webpackJsonp([114276838955818,60335399758886],{

/***/ 194:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(335);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(194);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  }
	}
	
	module.exports = _arrayWithoutHoles;

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

	function _iterableToArray(iter) {
	  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	}
	
	module.exports = _iterableToArray;

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance");
	}
	
	module.exports = _nonIterableSpread;

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	var arrayWithoutHoles = __webpack_require__(118);
	
	var iterableToArray = __webpack_require__(119);
	
	var nonIterableSpread = __webpack_require__(120);
	
	function _toConsumableArray(arr) {
	  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
	}
	
	module.exports = _toConsumableArray;

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(15));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _Fade = _interopRequireDefault(__webpack_require__(135));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    zIndex: -1,
	    position: 'fixed',
	    right: 0,
	    bottom: 0,
	    top: 0,
	    left: 0,
	    backgroundColor: 'rgba(0, 0, 0, 0.5)',
	    // Remove grey highlight
	    WebkitTapHighlightColor: 'transparent',
	    // Disable scroll capabilities.
	    touchAction: 'none'
	  },
	
	  /* Styles applied to the root element if `invisible={true}`. */
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	exports.styles = styles;
	
	function Backdrop(props) {
	  var classes = props.classes,
	      className = props.className,
	      invisible = props.invisible,
	      open = props.open,
	      transitionDuration = props.transitionDuration,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "invisible", "open", "transitionDuration"]);
	  return _react.default.createElement(_Fade.default, (0, _extends2.default)({
	    in: open,
	    timeout: transitionDuration
	  }, other), _react.default.createElement("div", {
	    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.invisible, invisible), className),
	    "aria-hidden": "true"
	  }));
	}
	
	Backdrop.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : {};
	Backdrop.defaultProps = {
	  invisible: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBackdrop'
	})(Backdrop);
	
	exports.default = _default;

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Backdrop.default;
	  }
	});
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(122));

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(15));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _colorManipulator = __webpack_require__(156);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(131));
	
	var _helpers = __webpack_require__(33);
	
	// @inheritedComponent ButtonBase
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.button, {
	      lineHeight: '1.4em',
	      // Improve readability for multiline button.
	      boxSizing: 'border-box',
	      minWidth: 64,
	      minHeight: 36,
	      padding: '8px 16px',
	      borderRadius: theme.shape.borderRadius,
	      color: theme.palette.text.primary,
	      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
	        duration: theme.transitions.duration.short
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        },
	        '&$disabled': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }),
	
	    /* Styles applied to the span element that wraps the children. */
	    label: {
	      width: '100%',
	      // assure the correct width for iOS Safari
	      display: 'inherit',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    },
	
	    /* Styles applied to the root element if `variant="text"`. */
	    text: {},
	
	    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
	    textPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
	    textSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
	    flat: {},
	
	    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
	    flatPrimary: {},
	
	    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
	    flatSecondary: {},
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
	    outlinedPrimary: {
	      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.5)),
	      '&:hover': {
	        border: "1px solid ".concat(theme.palette.primary.main)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
	    outlinedSecondary: {
	      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.5)),
	      '&:hover': {
	        border: "1px solid ".concat(theme.palette.secondary.main)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="[contained | fab]"`. */
	    contained: {
	      color: theme.palette.getContrastText(theme.palette.grey[300]),
	      backgroundColor: theme.palette.grey[300],
	      boxShadow: theme.shadows[2],
	      '&$focusVisible': {
	        boxShadow: theme.shadows[6]
	      },
	      '&:active': {
	        boxShadow: theme.shadows[8]
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled,
	        boxShadow: theme.shadows[0],
	        backgroundColor: theme.palette.action.disabledBackground
	      },
	      '&:hover': {
	        backgroundColor: theme.palette.grey.A100,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.grey[300]
	        },
	        '&$disabled': {
	          backgroundColor: theme.palette.action.disabledBackground
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="[contained | fab]"` and `color="primary"`. */
	    containedPrimary: {
	      color: theme.palette.primary.contrastText,
	      backgroundColor: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.primary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.primary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="[contained | fab]"` and `color="secondary"`. */
	    containedSecondary: {
	      color: theme.palette.secondary.contrastText,
	      backgroundColor: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.secondary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.secondary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
	    raised: {},
	    // legacy
	
	    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
	    raisedPrimary: {},
	    // legacy
	
	    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
	    raisedSecondary: {},
	    // legacy
	
	    /* Styles applied to the root element if `variant="[fab | extendedFab]"`. */
	    fab: {
	      borderRadius: '50%',
	      padding: 0,
	      minWidth: 0,
	      width: 56,
	      height: 56,
	      boxShadow: theme.shadows[6],
	      '&:active': {
	        boxShadow: theme.shadows[12]
	      }
	    },
	
	    /* Styles applied to the root element if `variant="extendedFab"`. */
	    extendedFab: {
	      borderRadius: 48 / 2,
	      padding: '0 16px',
	      width: 'auto',
	      minWidth: 48,
	      height: 48
	    },
	
	    /* Styles applied to the ButtonBase root element if the button is keyboard focused. */
	    focusVisible: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `size="mini"` & `variant="[fab | extendedFab]"`. */
	    mini: {
	      width: 40,
	      height: 40
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      padding: '7px 8px',
	      minWidth: 64,
	      minHeight: 32,
	      fontSize: theme.typography.pxToRem(13)
	    },
	
	    /* Styles applied to the root element if `size="large"`. */
	    sizeLarge: {
	      padding: '8px 24px',
	      minWidth: 112,
	      minHeight: 40,
	      fontSize: theme.typography.pxToRem(15)
	    },
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Button(props) {
	  var _classNames;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      disabled = props.disabled,
	      disableFocusRipple = props.disableFocusRipple,
	      fullWidth = props.fullWidth,
	      focusVisibleClassName = props.focusVisibleClassName,
	      mini = props.mini,
	      size = props.size,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled", "disableFocusRipple", "fullWidth", "focusVisibleClassName", "mini", "size", "variant"]);
	  var fab = variant === 'fab' || variant === 'extendedFab';
	  var contained = variant === 'contained' || variant === 'raised';
	  var text = variant === 'text' || variant === 'flat' || variant === 'outlined';
	  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.fab, fab), (0, _defineProperty2.default)(_classNames, classes.mini, fab && mini), (0, _defineProperty2.default)(_classNames, classes.extendedFab, variant === 'extendedFab'), (0, _defineProperty2.default)(_classNames, classes.text, text), (0, _defineProperty2.default)(_classNames, classes.textPrimary, text && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.textSecondary, text && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.flat, variant === 'text' || variant === 'flat'), (0, _defineProperty2.default)(_classNames, classes.flatPrimary, (variant === 'text' || variant === 'flat') && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.flatSecondary, (variant === 'text' || variant === 'flat') && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.contained, contained || fab), (0, _defineProperty2.default)(_classNames, classes.containedPrimary, (contained || fab) && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.containedSecondary, (contained || fab) && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.raised, contained || fab), (0, _defineProperty2.default)(_classNames, classes.raisedPrimary, (contained || fab) && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.raisedSecondary, (contained || fab) && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.outlined, variant === 'outlined'), (0, _defineProperty2.default)(_classNames, classes.outlinedPrimary, variant === 'outlined' && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.outlinedSecondary, variant === 'outlined' && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes["size".concat((0, _helpers.capitalize)(size))], size !== 'medium'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty2.default)(_classNames, classes.colorInherit, color === 'inherit'), _classNames), classNameProp);
	  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: className,
	    disabled: disabled,
	    focusRipple: !disableFocusRipple,
	    focusVisibleClassName: (0, _classnames.default)(classes.focusVisible, focusVisibleClassName)
	  }, other), _react.default.createElement("span", {
	    className: classes.label
	  }, children));
	}
	
	Button.propTypes =  false ? {
	  /**
	   * The content of the button.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * If `true`, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The URL to link to when the button is clicked.
	   * If defined, an `a` element will be used as the root node.
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * If `true`, and `variant` is `'fab'`, will use mini floating action button styling.
	   */
	  mini: _propTypes.default.bool,
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['text', 'flat', 'outlined', 'contained', 'raised', 'fab', 'extendedFab'])
	} : {};
	Button.defaultProps = {
	  color: 'default',
	  component: 'button',
	  disabled: false,
	  disableFocusRipple: false,
	  fullWidth: false,
	  mini: false,
	  size: 'medium',
	  type: 'button',
	  variant: 'text'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButton'
	})(Button);
	
	exports.default = _default;

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Button.default;
	  }
	});
	
	var _Button = _interopRequireDefault(__webpack_require__(124));

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(9));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(36));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(20));
	
	var _classnames = _interopRequireDefault(__webpack_require__(15));
	
	var _keycode = _interopRequireDefault(__webpack_require__(44));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(39));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _focusVisible = __webpack_require__(130);
	
	var _TouchRipple = _interopRequireDefault(__webpack_require__(128));
	
	var _createRippleHandler = _interopRequireDefault(__webpack_require__(129));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    position: 'relative',
	    // Remove grey highlight
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'transparent',
	    // Reset default value
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 'none',
	    border: 0,
	    margin: 0,
	    // Remove the margin in Safari
	    borderRadius: 0,
	    padding: 0,
	    // Remove the padding in Firefox
	    cursor: 'pointer',
	    userSelect: 'none',
	    verticalAlign: 'middle',
	    '-moz-appearance': 'none',
	    // Reset
	    '-webkit-appearance': 'none',
	    // Reset
	    textDecoration: 'none',
	    // So we take precedent over the style of a native <a /> element.
	    color: 'inherit',
	    '&::-moz-focus-inner': {
	      borderStyle: 'none' // Remove Firefox dotted outline.
	
	    },
	    '&$disabled': {
	      pointerEvents: 'none',
	      // Disable link interactions
	      cursor: 'default'
	    }
	  },
	
	  /* Styles applied to the root element if `disabled={true}`. */
	  disabled: {},
	
	  /* Styles applied to the root element if keyboard focused. */
	  focusVisible: {}
	};
	/* istanbul ignore if */
	
	exports.styles = styles;
	
	if (false) {
	  throw new Error('Material-UI: react@16.3.0 or greater is required.');
	}
	/**
	 * `ButtonBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating a button.
	 * It contains a load of style reset and some focus/ripple logic.
	 */
	
	
	var ButtonBase =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ButtonBase, _React$Component);
	
	  function ButtonBase() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, ButtonBase);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ButtonBase)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.ripple = null;
	    _this.keyDown = false;
	    _this.button = null;
	    _this.focusVisibleTimeout = null;
	    _this.focusVisibleCheckTime = 50;
	    _this.focusVisibleMaxCheckTimes = 5;
	    _this.handleMouseDown = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseDown', 'start', function () {
	      clearTimeout(_this.focusVisibleTimeout);
	
	      if (_this.state.focusVisible) {
	        _this.setState({
	          focusVisible: false
	        });
	      }
	    });
	    _this.handleMouseUp = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseUp', 'stop');
	    _this.handleMouseLeave = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseLeave', 'stop', function (event) {
	      if (_this.state.focusVisible) {
	        event.preventDefault();
	      }
	    });
	    _this.handleTouchStart = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchStart', 'start');
	    _this.handleTouchEnd = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchEnd', 'stop');
	    _this.handleTouchMove = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchMove', 'stop');
	    _this.handleBlur = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'Blur', 'stop', function () {
	      clearTimeout(_this.focusVisibleTimeout);
	
	      if (_this.state.focusVisible) {
	        _this.setState({
	          focusVisible: false
	        });
	      }
	    });
	    _this.state = {};
	
	    _this.onRippleRef = function (node) {
	      _this.ripple = node;
	    };
	
	    _this.onFocusVisibleHandler = function (event) {
	      _this.keyDown = false;
	
	      _this.setState({
	        focusVisible: true
	      });
	
	      if (_this.props.onFocusVisible) {
	        _this.props.onFocusVisible(event);
	      }
	    };
	
	    _this.handleKeyDown = function (event) {
	      var _this$props = _this.props,
	          component = _this$props.component,
	          focusRipple = _this$props.focusRipple,
	          onKeyDown = _this$props.onKeyDown,
	          onClick = _this$props.onClick;
	      var key = (0, _keycode.default)(event); // Check if key is already down to avoid repeats being counted as multiple activations
	
	      if (focusRipple && !_this.keyDown && _this.state.focusVisible && _this.ripple && key === 'space') {
	        _this.keyDown = true;
	        event.persist();
	
	        _this.ripple.stop(event, function () {
	          _this.ripple.start(event);
	        });
	      }
	
	      if (onKeyDown) {
	        onKeyDown(event);
	      } // Keyboard accessibility for non interactive elements
	
	
	      if (event.target === event.currentTarget && component && component !== 'button' && (key === 'space' || key === 'enter') && !(_this.button.tagName === 'A' && _this.button.href)) {
	        event.preventDefault();
	
	        if (onClick) {
	          onClick(event);
	        }
	      }
	    };
	
	    _this.handleKeyUp = function (event) {
	      if (_this.props.focusRipple && (0, _keycode.default)(event) === 'space' && _this.ripple && _this.state.focusVisible) {
	        _this.keyDown = false;
	        event.persist();
	
	        _this.ripple.stop(event, function () {
	          _this.ripple.pulsate(event);
	        });
	      }
	
	      if (_this.props.onKeyUp) {
	        _this.props.onKeyUp(event);
	      }
	    };
	
	    _this.handleFocus = function (event) {
	      if (_this.props.disabled) {
	        return;
	      } // Fix for https://github.com/facebook/react/issues/7769
	
	
	      if (!_this.button) {
	        _this.button = event.currentTarget;
	      }
	
	      event.persist();
	      (0, _focusVisible.detectFocusVisible)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), _this.button, function () {
	        _this.onFocusVisibleHandler(event);
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(ButtonBase, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.button = _reactDom.default.findDOMNode(this);
	      (0, _focusVisible.listenForFocusKeys)((0, _ownerWindow.default)(this.button));
	
	      if (this.props.action) {
	        this.props.action({
	          focusVisible: function focusVisible() {
	            _this2.setState({
	              focusVisible: true
	            });
	
	            _this2.button.focus();
	          }
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.focusRipple && !this.props.disableRipple && !prevState.focusVisible && this.state.focusVisible) {
	        this.ripple.pulsate();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.button = null;
	      clearTimeout(this.focusVisibleTimeout);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props2 = this.props,
	          action = _this$props2.action,
	          buttonRef = _this$props2.buttonRef,
	          centerRipple = _this$props2.centerRipple,
	          children = _this$props2.children,
	          classes = _this$props2.classes,
	          classNameProp = _this$props2.className,
	          component = _this$props2.component,
	          disabled = _this$props2.disabled,
	          disableRipple = _this$props2.disableRipple,
	          disableTouchRipple = _this$props2.disableTouchRipple,
	          focusRipple = _this$props2.focusRipple,
	          focusVisibleClassName = _this$props2.focusVisibleClassName,
	          onBlur = _this$props2.onBlur,
	          onFocus = _this$props2.onFocus,
	          onFocusVisible = _this$props2.onFocusVisible,
	          onKeyDown = _this$props2.onKeyDown,
	          onKeyUp = _this$props2.onKeyUp,
	          onMouseDown = _this$props2.onMouseDown,
	          onMouseLeave = _this$props2.onMouseLeave,
	          onMouseUp = _this$props2.onMouseUp,
	          onTouchEnd = _this$props2.onTouchEnd,
	          onTouchMove = _this$props2.onTouchMove,
	          onTouchStart = _this$props2.onTouchStart,
	          tabIndex = _this$props2.tabIndex,
	          TouchRippleProps = _this$props2.TouchRippleProps,
	          type = _this$props2.type,
	          other = (0, _objectWithoutProperties2.default)(_this$props2, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "type"]);
	      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.focusVisible, this.state.focusVisible), (0, _defineProperty2.default)(_classNames, focusVisibleClassName, this.state.focusVisible), _classNames), classNameProp);
	      var buttonProps = {};
	      var ComponentProp = component;
	
	      if (ComponentProp === 'button' && other.href) {
	        ComponentProp = 'a';
	      }
	
	      if (ComponentProp === 'button') {
	        buttonProps.type = type || 'button';
	        buttonProps.disabled = disabled;
	      } else {
	        buttonProps.role = 'button';
	      }
	
	      return _react.default.createElement(ComponentProp, (0, _extends2.default)({
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        onKeyUp: this.handleKeyUp,
	        onMouseDown: this.handleMouseDown,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseUp: this.handleMouseUp,
	        onTouchEnd: this.handleTouchEnd,
	        onTouchMove: this.handleTouchMove,
	        onTouchStart: this.handleTouchStart,
	        tabIndex: disabled ? '-1' : tabIndex,
	        className: className,
	        ref: buttonRef
	      }, buttonProps, other), children, !disableRipple && !disabled ? _react.default.createElement(_TouchRipple.default, (0, _extends2.default)({
	        innerRef: this.onRippleRef,
	        center: centerRipple
	      }, TouchRippleProps)) : null);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (typeof prevState.focusVisible === 'undefined') {
	        return {
	          focusVisible: false,
	          lastDisabled: nextProps.disabled
	        };
	      } // The blur won't fire when the disabled state is set on a focused input.
	      // We need to book keep the focused state manually.
	
	
	      if (!prevState.prevState && nextProps.disabled && prevState.focusVisible) {
	        return {
	          focusVisible: false,
	          lastDisabled: nextProps.disabled
	        };
	      }
	
	      return {
	        lastDisabled: nextProps.disabled
	      };
	    }
	  }]);
	  return ButtonBase;
	}(_react.default.Component);
	
	ButtonBase.propTypes =  false ? {
	  /**
	   * Callback fired when the component mounts.
	   * This is useful when you want to trigger an action programmatically.
	   * It currently only supports `focusVisible()` action.
	   *
	   * @param {object} actions This object contains all possible actions
	   * that can be triggered programmatically.
	   */
	  action: _propTypes.default.func,
	
	  /**
	   * Use that property to pass a ref callback to the native button component.
	   */
	  buttonRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * If `true`, the ripples will be centered.
	   * They won't start at the cursor interaction position.
	   */
	  centerRipple: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * If `true`, the base button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the touch ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the base button will have a keyboard focus ripple.
	   * `disableRipple` must also be `false`.
	   */
	  focusRipple: _propTypes.default.bool,
	
	  /**
	   * This property can help a person know which element has the keyboard focus.
	   * The class name will be applied when the element gain the focus through a keyboard interaction.
	   * It's a polyfill for the [CSS :focus-visible feature](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
	   * The rational for using this feature [is explain here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is focused with a keyboard.
	   * We trigger a `onFocus` callback too.
	   */
	  onFocusVisible: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchEnd: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchMove: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchStart: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Properties applied to the `TouchRipple` element.
	   */
	  TouchRippleProps: _propTypes.default.object,
	
	  /**
	   * Used to control the button's purpose.
	   * This property passes the value to the `type` attribute of the native button component.
	   * Valid property values include `button`, `submit`, and `reset`.
	   */
	  type: _propTypes.default.string
	} : {};
	ButtonBase.defaultProps = {
	  centerRipple: false,
	  component: 'button',
	  disableRipple: false,
	  disableTouchRipple: false,
	  focusRipple: false,
	  tabIndex: '0',
	  type: 'button'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButtonBase'
	})(ButtonBase);
	
	exports.default = _default;

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(9));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(15));
	
	var _Transition = _interopRequireDefault(__webpack_require__(45));
	
	/**
	 * @ignore - internal component.
	 */
	var Ripple =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Ripple, _React$Component);
	
	  function Ripple() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Ripple);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Ripple)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      visible: false,
	      leaving: false
	    };
	
	    _this.handleEnter = function () {
	      _this.setState({
	        visible: true
	      });
	    };
	
	    _this.handleExit = function () {
	      _this.setState({
	        leaving: true
	      });
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(Ripple, [{
	    key: "render",
	    value: function render() {
	      var _classNames, _classNames2;
	
	      var _this$props = this.props,
	          classes = _this$props.classes,
	          classNameProp = _this$props.className,
	          pulsate = _this$props.pulsate,
	          rippleX = _this$props.rippleX,
	          rippleY = _this$props.rippleY,
	          rippleSize = _this$props.rippleSize,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "pulsate", "rippleX", "rippleY", "rippleSize"]);
	      var _this$state = this.state,
	          visible = _this$state.visible,
	          leaving = _this$state.leaving;
	      var rippleClassName = (0, _classnames.default)(classes.ripple, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.rippleVisible, visible), (0, _defineProperty2.default)(_classNames, classes.ripplePulsate, pulsate), _classNames), classNameProp);
	      var rippleStyles = {
	        width: rippleSize,
	        height: rippleSize,
	        top: -(rippleSize / 2) + rippleY,
	        left: -(rippleSize / 2) + rippleX
	      };
	      var childClassName = (0, _classnames.default)(classes.child, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.childLeaving, leaving), (0, _defineProperty2.default)(_classNames2, classes.childPulsate, pulsate), _classNames2));
	      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        onEnter: this.handleEnter,
	        onExit: this.handleExit
	      }, other), _react.default.createElement("span", {
	        className: rippleClassName,
	        style: rippleStyles
	      }, _react.default.createElement("span", {
	        className: childClassName
	      })));
	    }
	  }]);
	  return Ripple;
	}(_react.default.Component);
	
	Ripple.propTypes =  false ? {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
	   */
	  pulsate: _propTypes.default.bool,
	
	  /**
	   * Diameter of the ripple.
	   */
	  rippleSize: _propTypes.default.number,
	
	  /**
	   * Horizontal position of the ripple center.
	   */
	  rippleX: _propTypes.default.number,
	
	  /**
	   * Vertical position of the ripple center.
	   */
	  rippleY: _propTypes.default.number
	} : {};
	Ripple.defaultProps = {
	  pulsate: false
	};
	var _default = Ripple;
	exports.default = _default;

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = exports.DELAY_RIPPLE = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(121));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(9));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(36));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(20));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(202));
	
	var _classnames = _interopRequireDefault(__webpack_require__(15));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _Ripple = _interopRequireDefault(__webpack_require__(127));
	
	var DURATION = 550;
	var DELAY_RIPPLE = 80;
	exports.DELAY_RIPPLE = DELAY_RIPPLE;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      position: 'absolute',
	      overflow: 'hidden',
	      borderRadius: 'inherit',
	      width: '100%',
	      height: '100%',
	      left: 0,
	      top: 0,
	      pointerEvents: 'none',
	      zIndex: 0
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripple` class. */
	    ripple: {
	      width: 50,
	      height: 50,
	      left: 0,
	      top: 0,
	      opacity: 0,
	      position: 'absolute'
	    },
	
	    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
	    rippleVisible: {
	      opacity: 0.3,
	      transform: 'scale(1)',
	      animation: "mui-ripple-enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
	    ripplePulsate: {
	      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
	    },
	
	    /* Styles applied to the internal `Ripple` components `child` class. */
	    child: {
	      opacity: 1,
	      display: 'block',
	      width: '100%',
	      height: '100%',
	      borderRadius: '50%',
	      backgroundColor: 'currentColor'
	    },
	
	    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
	    childLeaving: {
	      opacity: 0,
	      animation: "mui-ripple-exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
	    childPulsate: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      animation: "mui-ripple-pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
	    },
	    '@keyframes mui-ripple-enter': {
	      '0%': {
	        transform: 'scale(0)',
	        opacity: 0.1
	      },
	      '100%': {
	        transform: 'scale(1)',
	        opacity: 0.3
	      }
	    },
	    '@keyframes mui-ripple-exit': {
	      '0%': {
	        opacity: 1
	      },
	      '100%': {
	        opacity: 0
	      }
	    },
	    '@keyframes mui-ripple-pulsate': {
	      '0%': {
	        transform: 'scale(1)'
	      },
	      '50%': {
	        transform: 'scale(0.92)'
	      },
	      '100%': {
	        transform: 'scale(1)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	var TouchRipple =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  (0, _inherits2.default)(TouchRipple, _React$PureComponent);
	
	  function TouchRipple() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, TouchRipple);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TouchRipple)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.ignoringMouseDown = false;
	    _this.startTimer = null;
	    _this.startTimerCommit = null;
	    _this.state = {
	      // eslint-disable-next-line react/no-unused-state
	      nextKey: 0,
	      ripples: []
	    };
	
	    _this.pulsate = function () {
	      _this.start({}, {
	        pulsate: true
	      });
	    };
	
	    _this.start = function () {
	      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var cb = arguments.length > 2 ? arguments[2] : undefined;
	      var _options$pulsate = options.pulsate,
	          pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
	          _options$center = options.center,
	          center = _options$center === void 0 ? _this.props.center || options.pulsate : _options$center,
	          _options$fakeElement = options.fakeElement,
	          fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
	
	      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
	        _this.ignoringMouseDown = false;
	        return;
	      }
	
	      if (event.type === 'touchstart') {
	        _this.ignoringMouseDown = true;
	      }
	
	      var element = fakeElement ? null : _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	      var rect = element ? element.getBoundingClientRect() : {
	        width: 0,
	        height: 0,
	        left: 0,
	        top: 0
	      }; // Get the size of the ripple
	
	      var rippleX;
	      var rippleY;
	      var rippleSize;
	
	      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
	        rippleX = Math.round(rect.width / 2);
	        rippleY = Math.round(rect.height / 2);
	      } else {
	        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
	        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
	        rippleX = Math.round(clientX - rect.left);
	        rippleY = Math.round(clientY - rect.top);
	      }
	
	      if (center) {
	        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
	
	        if (rippleSize % 2 === 0) {
	          rippleSize += 1;
	        }
	      } else {
	        var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
	        var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
	        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
	      } // Touche devices
	
	
	      if (event.touches) {
	        // Prepare the ripple effect.
	        _this.startTimerCommit = function () {
	          _this.startCommit({
	            pulsate: pulsate,
	            rippleX: rippleX,
	            rippleY: rippleY,
	            rippleSize: rippleSize,
	            cb: cb
	          });
	        }; // Deplay the execution of the ripple effect.
	
	
	        _this.startTimer = setTimeout(function () {
	          if (_this.startTimerCommit) {
	            _this.startTimerCommit();
	
	            _this.startTimerCommit = null;
	          }
	        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
	      } else {
	        _this.startCommit({
	          pulsate: pulsate,
	          rippleX: rippleX,
	          rippleY: rippleY,
	          rippleSize: rippleSize,
	          cb: cb
	        });
	      }
	    };
	
	    _this.startCommit = function (params) {
	      var pulsate = params.pulsate,
	          rippleX = params.rippleX,
	          rippleY = params.rippleY,
	          rippleSize = params.rippleSize,
	          cb = params.cb;
	
	      _this.setState(function (state) {
	        return {
	          nextKey: state.nextKey + 1,
	          ripples: (0, _toConsumableArray2.default)(state.ripples).concat([_react.default.createElement(_Ripple.default, {
	            key: state.nextKey,
	            classes: _this.props.classes,
	            timeout: {
	              exit: DURATION,
	              enter: DURATION
	            },
	            pulsate: pulsate,
	            rippleX: rippleX,
	            rippleY: rippleY,
	            rippleSize: rippleSize
	          })])
	        };
	      }, cb);
	    };
	
	    _this.stop = function (event, cb) {
	      clearTimeout(_this.startTimer);
	      var ripples = _this.state.ripples; // The touch interaction occurs too quickly.
	      // We still want to show ripple effect.
	
	      if (event.type === 'touchend' && _this.startTimerCommit) {
	        event.persist();
	
	        _this.startTimerCommit();
	
	        _this.startTimerCommit = null;
	        _this.startTimer = setTimeout(function () {
	          _this.stop(event, cb);
	        }, 0);
	        return;
	      }
	
	      _this.startTimerCommit = null;
	
	      if (ripples && ripples.length) {
	        _this.setState({
	          ripples: ripples.slice(1)
	        }, cb);
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(TouchRipple, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.startTimer);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          center = _this$props.center,
	          classes = _this$props.classes,
	          className = _this$props.className,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["center", "classes", "className"]);
	      return _react.default.createElement(_TransitionGroup.default, (0, _extends2.default)({
	        component: "span",
	        enter: true,
	        exit: true,
	        className: (0, _classnames.default)(classes.root, className)
	      }, other), this.state.ripples);
	    }
	  }]);
	  return TouchRipple;
	}(_react.default.PureComponent);
	
	TouchRipple.propTypes =  false ? {
	  /**
	   * If `true`, the ripple starts at the center of the component
	   * rather than at the point of interaction.
	   */
	  center: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : {};
	TouchRipple.defaultProps = {
	  center: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiTouchRipple'
	})(TouchRipple);
	
	exports.default = _default;

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function createRippleHandler(instance, eventName, action, cb) {
	  return function handleEvent(event) {
	    if (cb) {
	      cb.call(instance, event);
	    }
	
	    var ignore = false; // Ignore events that have been `event.preventDefault()` marked.
	
	    if (event.defaultPrevented) {
	      ignore = true;
	    }
	
	    if (instance.props.disableTouchRipple && eventName !== 'Blur') {
	      ignore = true;
	    }
	
	    if (!ignore && instance.ripple) {
	      instance.ripple[action](event);
	    }
	
	    if (typeof instance.props["on".concat(eventName)] === 'function') {
	      instance.props["on".concat(eventName)](event);
	    }
	
	    return true;
	  };
	}
	
	var _default = createRippleHandler;
	exports.default = _default;

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.detectFocusVisible = detectFocusVisible;
	exports.listenForFocusKeys = listenForFocusKeys;
	
	var _keycode = _interopRequireDefault(__webpack_require__(44));
	
	var _warning = _interopRequireDefault(__webpack_require__(11));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(22));
	
	var internal = {
	  focusKeyPressed: false,
	  keyUpEventTimeout: -1
	};
	
	function detectFocusVisible(instance, element, callback) {
	  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	   false ? (0, _warning.default)(instance.focusVisibleCheckTime, 'Material-UI: missing instance.focusVisibleCheckTime.') : void 0;
	   false ? (0, _warning.default)(instance.focusVisibleMaxCheckTimes, 'Material-UI: missing instance.focusVisibleMaxCheckTimes.') : void 0;
	  instance.focusVisibleTimeout = setTimeout(function () {
	    var doc = (0, _ownerDocument.default)(element);
	
	    if (internal.focusKeyPressed && (doc.activeElement === element || element.contains(doc.activeElement))) {
	      callback();
	    } else if (attempt < instance.focusVisibleMaxCheckTimes) {
	      detectFocusVisible(instance, element, callback, attempt + 1);
	    }
	  }, instance.focusVisibleCheckTime);
	}
	
	var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right'];
	
	function isFocusKey(event) {
	  return FOCUS_KEYS.indexOf((0, _keycode.default)(event)) > -1;
	}
	
	var handleKeyUpEvent = function handleKeyUpEvent(event) {
	  if (isFocusKey(event)) {
	    internal.focusKeyPressed = true; // Let's consider that the user is using a keyboard during a window frame of 1s.
	
	    clearTimeout(internal.keyUpEventTimeout);
	    internal.keyUpEventTimeout = setTimeout(function () {
	      internal.focusKeyPressed = false;
	    }, 1e3);
	  }
	};
	
	function listenForFocusKeys(win) {
	  // The event listener will only be added once per window.
	  // Duplicate event listeners will be ignored by addEventListener.
	  // Also, this logic is client side only, we don't need a teardown.
	  win.addEventListener('keyup', handleKeyUpEvent);
	}

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonBase.default;
	  }
	});
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(126));

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isHorizontal = isHorizontal;
	exports.getAnchor = getAnchor;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(9));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(15));
	
	var _Modal = _interopRequireDefault(__webpack_require__(145));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _Slide = _interopRequireDefault(__webpack_require__(155));
	
	var _Paper = _interopRequireDefault(__webpack_require__(149));
	
	var _helpers = __webpack_require__(33);
	
	var _transitions = __webpack_require__(38);
	
	var oppositeDirection = {
	  left: 'right',
	  right: 'left',
	  top: 'down',
	  bottom: 'up'
	};
	
	function isHorizontal(props) {
	  return ['left', 'right'].indexOf(props.anchor) !== -1;
	}
	
	function getAnchor(props) {
	  return props.theme.direction === 'rtl' && isHorizontal(props) ? oppositeDirection[props.anchor] : props.anchor;
	}
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element if `variant="permanent or persistent"`. */
	    docked: {
	      flex: '0 0 auto'
	    },
	
	    /* Styles applied to the `Paper` component. */
	    paper: {
	      overflowY: 'auto',
	      display: 'flex',
	      flexDirection: 'column',
	      height: '100%',
	      flex: '1 0 auto',
	      zIndex: theme.zIndex.drawer,
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      // temporary style
	      position: 'fixed',
	      top: 0,
	      // We disable the focus ring for mouse, touch and keyboard users.
	      // At some point, it would be better to keep it for keyboard users.
	      // :focus-ring CSS pseudo-class will help.
	      outline: 'none'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="left"`. */
	    paperAnchorLeft: {
	      left: 0,
	      right: 'auto'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="right"`. */
	    paperAnchorRight: {
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="top"`. */
	    paperAnchorTop: {
	      top: 0,
	      left: 0,
	      bottom: 'auto',
	      right: 0,
	      height: 'auto',
	      maxHeight: '100%'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
	    paperAnchorBottom: {
	      top: 'auto',
	      left: 0,
	      bottom: 0,
	      right: 0,
	      height: 'auto',
	      maxHeight: '100%'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="left"` & `variant` is not "temporary". */
	    paperAnchorDockedLeft: {
	      borderRight: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="top"` & `variant` is not "temporary". */
	    paperAnchorDockedTop: {
	      borderBottom: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="right"` & `variant` is not "temporary". */
	    paperAnchorDockedRight: {
	      borderLeft: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="bottom"` & `variant` is not "temporary". */
	    paperAnchorDockedBottom: {
	      borderTop: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Modal` component. */
	    modal: {}
	  };
	};
	/**
	 * The properties of the [Modal](/api/modal) component are available
	 * when `variant="temporary"` is set.
	 */
	
	
	exports.styles = styles;
	
	var Drawer =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Drawer, _React$Component);
	
	  function Drawer() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Drawer);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Drawer)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.mounted = false;
	    return _this;
	  }
	
	  (0, _createClass2.default)(Drawer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          anchorProp = _this$props.anchor,
	          children = _this$props.children,
	          classes = _this$props.classes,
	          className = _this$props.className,
	          elevation = _this$props.elevation,
	          _this$props$ModalProp = _this$props.ModalProps;
	      _this$props$ModalProp = _this$props$ModalProp === void 0 ? {} : _this$props$ModalProp;
	      var BackdropPropsProp = _this$props$ModalProp.BackdropProps,
	          ModalProps = (0, _objectWithoutProperties2.default)(_this$props$ModalProp, ["BackdropProps"]),
	          onClose = _this$props.onClose,
	          open = _this$props.open,
	          PaperProps = _this$props.PaperProps,
	          SlideProps = _this$props.SlideProps,
	          theme = _this$props.theme,
	          transitionDuration = _this$props.transitionDuration,
	          variant = _this$props.variant,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["anchor", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "theme", "transitionDuration", "variant"]);
	      var anchor = getAnchor(this.props);
	
	      var drawer = _react.default.createElement(_Paper.default, (0, _extends2.default)({
	        elevation: variant === 'temporary' ? elevation : 0,
	        square: true,
	        className: (0, _classnames.default)(classes.paper, classes["paperAnchor".concat((0, _helpers.capitalize)(anchor))], (0, _defineProperty2.default)({}, classes["paperAnchorDocked".concat((0, _helpers.capitalize)(anchor))], variant !== 'temporary'))
	      }, PaperProps), children);
	
	      if (variant === 'permanent') {
	        return _react.default.createElement("div", (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.docked, className)
	        }, other), drawer);
	      }
	
	      var slidingDrawer = _react.default.createElement(_Slide.default, (0, _extends2.default)({
	        in: open,
	        direction: oppositeDirection[anchor],
	        timeout: transitionDuration,
	        appear: this.mounted
	      }, SlideProps), drawer);
	
	      if (variant === 'persistent') {
	        return _react.default.createElement("div", (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.docked, className)
	        }, other), slidingDrawer);
	      } // variant === temporary
	
	
	      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
	        BackdropProps: (0, _extends2.default)({}, BackdropPropsProp, {
	          transitionDuration: transitionDuration
	        }),
	        className: (0, _classnames.default)(classes.modal, className),
	        open: open,
	        onClose: onClose
	      }, other, ModalProps), slidingDrawer);
	    }
	  }]);
	  return Drawer;
	}(_react.default.Component);
	
	Drawer.propTypes =  false ? {
	  /**
	   * Side from which the drawer will appear.
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),
	
	  /**
	   * The contents of the drawer.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The elevation of the drawer.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * Properties applied to the [`Modal`](/api/modal) element.
	   */
	  ModalProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Properties applied to the [`Paper`](/api/paper) element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Properties applied to the [`Slide`](/api/slide) element.
	   */
	  SlideProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : {};
	Drawer.defaultProps = {
	  anchor: 'left',
	  elevation: 16,
	  open: false,
	  transitionDuration: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  },
	  variant: 'temporary' // Mobile first.
	
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDrawer',
	  flip: false,
	  withTheme: true
	})(Drawer);
	
	exports.default = _default;

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.default;
	  }
	});
	
	var _Drawer = _interopRequireDefault(__webpack_require__(132));

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(9));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _Transition = _interopRequireDefault(__webpack_require__(45));
	
	var _transitions = __webpack_require__(38);
	
	var _withTheme = _interopRequireDefault(__webpack_require__(69));
	
	var _utils = __webpack_require__(70);
	
	// @inheritedComponent Transition
	var styles = {
	  entering: {
	    opacity: 1
	  },
	  entered: {
	    opacity: 1
	  }
	};
	/**
	 * The Fade transition is used by the [Modal](/utils/modal) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Fade =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Fade, _React$Component);
	
	  function Fade() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Fade);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Fade)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _this.handleEnter = function (node) {
	      var theme = _this.props.theme;
	      (0, _utils.reflow)(node); // So the animation always start from the start.
	
	      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'enter'
	      });
	      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
	      node.style.transition = theme.transitions.create('opacity', transitionProps);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    };
	
	    _this.handleExit = function (node) {
	      var theme = _this.props.theme;
	      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'exit'
	      });
	      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
	      node.style.transition = theme.transitions.create('opacity', transitionProps);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(Fade, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          onEnter = _this$props.onEnter,
	          onExit = _this$props.onExit,
	          styleProp = _this$props.style,
	          theme = _this$props.theme,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "onEnter", "onExit", "style", "theme"]);
	      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
	      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        appear: true,
	        onEnter: this.handleEnter,
	        onExit: this.handleExit
	      }, other), function (state, childProps) {
	        return _react.default.cloneElement(children, (0, _extends2.default)({
	          style: (0, _extends2.default)({
	            opacity: 0,
	            willChange: 'opacity'
	          }, styles[state], style)
	        }, childProps));
	      });
	    }
	  }]);
	  return Fade;
	}(_react.default.Component);
	
	Fade.propTypes =  false ? {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : {};
	Fade.defaultProps = {
	  timeout: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  }
	};
	
	var _default = (0, _withTheme.default)()(Fade);
	
	exports.default = _default;

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Fade.default;
	  }
	});
	
	var _Fade = _interopRequireDefault(__webpack_require__(134));

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(9));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(36));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(20));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(15));
	
	var _warning = _interopRequireDefault(__webpack_require__(11));
	
	var _keycode = _interopRequireDefault(__webpack_require__(44));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(22));
	
	var _RootRef = _interopRequireDefault(__webpack_require__(153));
	
	var _Portal = _interopRequireDefault(__webpack_require__(151));
	
	var _helpers = __webpack_require__(33);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var _ModalManager = _interopRequireDefault(__webpack_require__(68));
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(123));
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom.default.findDOMNode(container) || defaultContainer;
	}
	
	function getHasTransition(props) {
	  return props.children ? props.children.props.hasOwnProperty('in') : false;
	}
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'fixed',
	      zIndex: theme.zIndex.modal,
	      right: 0,
	      bottom: 0,
	      top: 0,
	      left: 0
	    },
	
	    /* Styles applied to the root element if the `Modal` has exited. */
	    hidden: {
	      visibility: 'hidden'
	    }
	  };
	};
	/* istanbul ignore if */
	
	
	exports.styles = styles;
	
	if (false) {
	  throw new Error('Material-UI: react@16.3.0 or greater is required.');
	}
	/**
	 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
	 */
	
	
	var Modal =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Modal, _React$Component);
	
	  function Modal(props) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Modal);
	    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Modal).call(this));
	    _this.mountNode = null;
	    _this.modalRef = null;
	    _this.dialogRef = null;
	    _this.mounted = false;
	
	    _this.handleRendered = function () {
	      _this.autoFocus(); // Fix a bug on Chrome where the scroll isn't initially 0.
	
	
	      _this.modalRef.scrollTop = 0;
	
	      if (_this.props.onRendered) {
	        _this.props.onRendered();
	      }
	    };
	
	    _this.handleOpen = function () {
	      var doc = (0, _ownerDocument.default)(_this.mountNode);
	      var container = getContainer(_this.props.container, doc.body);
	
	      _this.props.manager.add((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), container);
	
	      doc.addEventListener('keydown', _this.handleDocumentKeyDown);
	      doc.addEventListener('focus', _this.enforceFocus, true);
	    };
	
	    _this.handleClose = function () {
	      _this.props.manager.remove((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	
	      var doc = (0, _ownerDocument.default)(_this.mountNode);
	      doc.removeEventListener('keydown', _this.handleDocumentKeyDown);
	      doc.removeEventListener('focus', _this.enforceFocus, true);
	
	      _this.restoreLastFocus();
	    };
	
	    _this.handleExited = function () {
	      _this.setState({
	        exited: true
	      });
	
	      _this.handleClose();
	    };
	
	    _this.handleBackdropClick = function (event) {
	      if (event.target !== event.currentTarget) {
	        return;
	      }
	
	      if (_this.props.onBackdropClick) {
	        _this.props.onBackdropClick(event);
	      }
	
	      if (!_this.props.disableBackdropClick && _this.props.onClose) {
	        _this.props.onClose(event, 'backdropClick');
	      }
	    };
	
	    _this.handleDocumentKeyDown = function (event) {
	      if (!_this.isTopModal() || (0, _keycode.default)(event) !== 'esc') {
	        return;
	      } // Ignore events that have been `event.preventDefault()` marked.
	
	
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      if (_this.props.onEscapeKeyDown) {
	        _this.props.onEscapeKeyDown(event);
	      }
	
	      if (!_this.props.disableEscapeKeyDown && _this.props.onClose) {
	        _this.props.onClose(event, 'escapeKeyDown');
	      }
	    };
	
	    _this.checkForFocus = function () {
	      _this.lastFocus = (0, _ownerDocument.default)(_this.mountNode).activeElement;
	    };
	
	    _this.enforceFocus = function () {
	      if (_this.props.disableEnforceFocus || !_this.mounted || !_this.isTopModal()) {
	        return;
	      }
	
	      var currentActiveElement = (0, _ownerDocument.default)(_this.mountNode).activeElement;
	
	      if (_this.dialogRef && !_this.dialogRef.contains(currentActiveElement)) {
	        _this.dialogRef.focus();
	      }
	    };
	
	    _this.state = {
	      exited: !props.open
	    };
	    return _this;
	  }
	
	  (0, _createClass2.default)(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	
	      if (this.props.open) {
	        this.handleOpen();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (!prevProps.open && this.props.open) {
	        this.checkForFocus();
	      }
	
	      if (prevProps.open && !this.props.open && !getHasTransition(this.props)) {
	        // Otherwise handleExited will call this.
	        this.handleClose();
	      } else if (!prevProps.open && this.props.open) {
	        this.handleOpen();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	
	      if (this.props.open || getHasTransition(this.props) && !this.state.exited) {
	        this.handleClose();
	      }
	    }
	  }, {
	    key: "autoFocus",
	    value: function autoFocus() {
	      if (this.props.disableAutoFocus) {
	        return;
	      }
	
	      var currentActiveElement = (0, _ownerDocument.default)(this.mountNode).activeElement;
	
	      if (this.dialogRef && !this.dialogRef.contains(currentActiveElement)) {
	        this.lastFocus = currentActiveElement;
	
	        if (!this.dialogRef.hasAttribute('tabIndex')) {
	           false ? (0, _warning.default)(false, ['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n')) : void 0;
	          this.dialogRef.setAttribute('tabIndex', -1);
	        }
	
	        this.dialogRef.focus();
	      }
	    }
	  }, {
	    key: "restoreLastFocus",
	    value: function restoreLastFocus() {
	      if (this.props.disableRestoreFocus) {
	        return;
	      }
	
	      if (this.lastFocus) {
	        // Not all elements in IE11 have a focus method.
	        // Because IE11 market share is low, we accept the restore focus being broken
	        // and we silent the issue.
	        if (this.lastFocus.focus) {
	          this.lastFocus.focus();
	        }
	
	        this.lastFocus = null;
	      }
	    }
	  }, {
	    key: "isTopModal",
	    value: function isTopModal() {
	      return this.props.manager.isTopModal(this);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          BackdropComponent = _this$props.BackdropComponent,
	          BackdropProps = _this$props.BackdropProps,
	          children = _this$props.children,
	          classes = _this$props.classes,
	          className = _this$props.className,
	          container = _this$props.container,
	          disableAutoFocus = _this$props.disableAutoFocus,
	          disableBackdropClick = _this$props.disableBackdropClick,
	          disableEnforceFocus = _this$props.disableEnforceFocus,
	          disableEscapeKeyDown = _this$props.disableEscapeKeyDown,
	          disablePortal = _this$props.disablePortal,
	          disableRestoreFocus = _this$props.disableRestoreFocus,
	          hideBackdrop = _this$props.hideBackdrop,
	          keepMounted = _this$props.keepMounted,
	          manager = _this$props.manager,
	          onBackdropClick = _this$props.onBackdropClick,
	          onClose = _this$props.onClose,
	          onEscapeKeyDown = _this$props.onEscapeKeyDown,
	          onRendered = _this$props.onRendered,
	          open = _this$props.open,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["BackdropComponent", "BackdropProps", "children", "classes", "className", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
	      var exited = this.state.exited;
	      var hasTransition = getHasTransition(this.props);
	      var childProps = {};
	
	      if (!keepMounted && !open && (!hasTransition || exited)) {
	        return null;
	      } // It's a Transition like component
	
	
	      if (hasTransition) {
	        childProps.onExited = (0, _helpers.createChainedFunction)(this.handleExited, children.props.onExited);
	      }
	
	      if (children.props.role === undefined) {
	        childProps.role = children.props.role || 'document';
	      }
	
	      if (children.props.tabIndex === undefined) {
	        childProps.tabIndex = children.props.tabIndex || '-1';
	      }
	
	      return _react.default.createElement(_Portal.default, {
	        ref: function ref(_ref2) {
	          _this2.mountNode = _ref2 ? _ref2.getMountNode() : _ref2;
	        },
	        container: container,
	        disablePortal: disablePortal,
	        onRendered: this.handleRendered
	      }, _react.default.createElement("div", (0, _extends2.default)({
	        ref: function ref(_ref) {
	          _this2.modalRef = _ref;
	        },
	        className: (0, _classnames.default)(classes.root, className, (0, _defineProperty2.default)({}, classes.hidden, exited))
	      }, other), hideBackdrop ? null : _react.default.createElement(BackdropComponent, (0, _extends2.default)({
	        open: open,
	        onClick: this.handleBackdropClick
	      }, BackdropProps)), _react.default.createElement(_RootRef.default, {
	        rootRef: function rootRef(ref) {
	          _this2.dialogRef = ref;
	        }
	      }, _react.default.cloneElement(children, childProps))));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if (nextProps.open) {
	        return {
	          exited: false
	        };
	      }
	
	      if (!getHasTransition(nextProps)) {
	        // Otherwise let handleExited take care of marking exited.
	        return {
	          exited: true
	        };
	      }
	
	      return null;
	    }
	  }]);
	  return Modal;
	}(_react.default.Component);
	
	Modal.propTypes =  false ? {
	  /**
	   * A backdrop component. This property enables custom backdrop rendering.
	   */
	  BackdropComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * Properties applied to the [`Backdrop`](/api/backdrop) element.
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   */
	  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	
	  /**
	   * If `true`, the modal will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, clicking the backdrop will not fire any callback.
	   */
	  disableBackdropClick: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not prevent focus from leaving the modal while open.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire any callback.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not restore focus to previously focused element once
	   * modal is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is not rendered.
	   */
	  hideBackdrop: _propTypes.default.bool,
	
	  /**
	   * Always keep the children in the DOM.
	   * This property can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Modal.
	   */
	  keepMounted: _propTypes.default.bool,
	
	  /**
	   * A modal manager used to track and manage the state of open
	   * Modals. This enables customizing how modals interact within a container.
	   */
	  manager: _propTypes.default.object,
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * The `reason` parameter can optionally be used to control the response to `onClose`.
	   *
	   * @param {object} event The event source of the callback
	   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableEscapeKeyDown` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes.default.func,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   * It signals that the `open={true}` property took effect.
	   */
	  onRendered: _propTypes.default.func,
	
	  /**
	   * If `true`, the modal is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : {};
	Modal.defaultProps = {
	  disableAutoFocus: false,
	  disableBackdropClick: false,
	  disableEnforceFocus: false,
	  disableEscapeKeyDown: false,
	  disablePortal: false,
	  disableRestoreFocus: false,
	  hideBackdrop: false,
	  keepMounted: false,
	  // Modals don't open on the server so this won't conflict with concurrent requests.
	  manager: new _ModalManager.default(),
	  BackdropComponent: _Backdrop.default
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiModal'
	})(Modal);
	
	exports.default = _default;

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(9));
	
	var _style = _interopRequireDefault(__webpack_require__(244));
	
	var _scrollbarSize = _interopRequireDefault(__webpack_require__(246));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(22));
	
	var _isOverflowing = _interopRequireDefault(__webpack_require__(146));
	
	var _manageAriaHidden = __webpack_require__(147);
	
	function findIndexOf(data, callback) {
	  var idx = -1;
	  data.some(function (item, index) {
	    if (callback(item)) {
	      idx = index;
	      return true;
	    }
	
	    return false;
	  });
	  return idx;
	}
	
	function getPaddingRight(node) {
	  return parseInt((0, _style.default)(node, 'paddingRight') || 0, 10);
	}
	
	function setContainerStyle(data, container) {
	  var style = {
	    overflow: 'hidden'
	  }; // We are only interested in the actual `style` here because we will override it.
	
	  data.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (data.overflowing) {
	    var scrollbarSize = (0, _scrollbarSize.default)(); // Use computed style, here to get the real padding to add our scrollbar width.
	
	    style.paddingRight = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
	
	    var fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');
	
	    for (var i = 0; i < fixedNodes.length; i += 1) {
	      var paddingRight = getPaddingRight(fixedNodes[i]);
	      data.prevPaddings.push(paddingRight);
	      fixedNodes[i].style.paddingRight = "".concat(paddingRight + scrollbarSize, "px");
	    }
	  }
	
	  Object.keys(style).forEach(function (key) {
	    container.style[key] = style[key];
	  });
	}
	
	function removeContainerStyle(data, container) {
	  Object.keys(data.style).forEach(function (key) {
	    container.style[key] = data.style[key];
	  });
	  var fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');
	
	  for (var i = 0; i < fixedNodes.length; i += 1) {
	    fixedNodes[i].style.paddingRight = "".concat(data.prevPaddings[i], "px");
	  }
	}
	/**
	 * @ignore - do not document.
	 *
	 * Proper state managment for containers and the modals in those containers.
	 * Simplified, but inspired by react-overlay's ModalManager class.
	 * Used by the Modal to ensure proper styling of containers.
	 */
	
	
	var ModalManager =
	/*#__PURE__*/
	function () {
	  function ModalManager() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck2.default)(this, ModalManager);
	    var _options$hideSiblingN = options.hideSiblingNodes,
	        hideSiblingNodes = _options$hideSiblingN === void 0 ? true : _options$hideSiblingN,
	        _options$handleContai = options.handleContainerOverflow,
	        handleContainerOverflow = _options$handleContai === void 0 ? true : _options$handleContai;
	    this.hideSiblingNodes = hideSiblingNodes;
	    this.handleContainerOverflow = handleContainerOverflow; // this.modals[modalIdx] = modal
	
	    this.modals = []; // this.containers[containerIdx] = container
	
	    this.containers = []; // this.data[containerIdx] = {
	    //   modals: [],
	    // }
	
	    this.data = [];
	  }
	
	  (0, _createClass2.default)(ModalManager, [{
	    key: "add",
	    value: function add(modal, container) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx !== -1) {
	        return modalIdx;
	      }
	
	      modalIdx = this.modals.length;
	      this.modals.push(modal);
	
	      if (this.hideSiblingNodes) {
	        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	      }
	
	      var containerIdx = this.containers.indexOf(container);
	
	      if (containerIdx !== -1) {
	        this.data[containerIdx].modals.push(modal);
	        return modalIdx;
	      }
	
	      var data = {
	        modals: [modal],
	        overflowing: (0, _isOverflowing.default)(container),
	        prevPaddings: []
	      };
	
	      if (this.handleContainerOverflow) {
	        setContainerStyle(data, container);
	      }
	
	      this.containers.push(container);
	      this.data.push(data);
	      return modalIdx;
	    }
	  }, {
	    key: "remove",
	    value: function remove(modal) {
	      var modalIdx = this.modals.indexOf(modal);
	
	      if (modalIdx === -1) {
	        return modalIdx;
	      }
	
	      var containerIdx = findIndexOf(this.data, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var data = this.data[containerIdx];
	      var container = this.containers[containerIdx];
	      data.modals.splice(data.modals.indexOf(modal), 1);
	      this.modals.splice(modalIdx, 1); // If that was the last modal in a container, clean up the container.
	
	      if (data.modals.length === 0) {
	        if (this.handleContainerOverflow) {
	          removeContainerStyle(data, container);
	        }
	
	        if (this.hideSiblingNodes) {
	          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	        }
	
	        this.containers.splice(containerIdx, 1);
	        this.data.splice(containerIdx, 1);
	      } else if (this.hideSiblingNodes) {
	        // Otherwise make sure the next top modal is visible to a screan reader.
	        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	      }
	
	      return modalIdx;
	    }
	  }, {
	    key: "isTopModal",
	    value: function isTopModal(modal) {
	      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	  return ModalManager;
	}();
	
	var _default = ModalManager;
	exports.default = _default;

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "ModalManager", {
	  enumerable: true,
	  get: function get() {
	    return _ModalManager.default;
	  }
	});
	
	var _Modal = _interopRequireDefault(__webpack_require__(144));
	
	var _ModalManager = _interopRequireDefault(__webpack_require__(68));

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isBody = isBody;
	exports.default = isOverflowing;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(102));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(22));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(39));
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	} // Do we have a vertical scroll bar?
	
	
	function isOverflowing(container) {
	  var doc = (0, _ownerDocument.default)(container);
	  var win = (0, _ownerWindow.default)(doc);
	  /* istanbul ignore next */
	
	  if (!(0, _isWindow.default)(doc) && !isBody(container)) {
	    return container.scrollHeight > container.clientHeight;
	  } // Takes in account potential non zero margin on the body.
	
	
	  var style = win.getComputedStyle(doc.body);
	  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
	  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);
	  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
	}

/***/ }),

/***/ 147:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	var BLACKLIST = ['template', 'script', 'style'];
	
	function isHidable(node) {
	  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
	}
	
	function siblings(container, mount, callback) {
	  mount = [].concat(mount); // eslint-disable-line no-param-reassign
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      callback(node);
	    }
	  });
	}
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(17));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(15));
	
	var _warning = _interopRequireDefault(__webpack_require__(11));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(18));
	
	var styles = function styles(theme) {
	  var elevations = {};
	  theme.shadows.forEach(function (shadow, index) {
	    elevations["elevation".concat(index)] = {
	      boxShadow: shadow
	    };
	  });
	  return (0, _extends2.default)({
	    /* Styles applied to the root element. */
	    root: {
	      backgroundColor: theme.palette.background.paper
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: theme.shape.borderRadius
	    }
	  }, elevations);
	};
	
	exports.styles = styles;
	
	function Paper(props) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      square = props.square,
	      elevation = props.elevation,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
	   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
	  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className
	  }, other));
	}
	
	Paper.propTypes =  false ? {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
	
	  /**
	   * Shadow depth, corresponds to `dp` in the spec.
	   * It's accepting values between 0 and 24 inclusive.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool
	} : {};
	Paper.defaultProps = {
	  component: 'div',
	  elevation: 2,
	  square: false
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPaper'
	})(Paper);
	
	exports.default = _default;

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	
	var _Paper = _interopRequireDefault(__webpack_require__(148));

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(9));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(20));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(22));
	
	var _exactProp = _interopRequireDefault(__webpack_require__(71));
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom.default.findDOMNode(container) || defaultContainer;
	}
	
	function getOwnerDocument(element) {
	  return (0, _ownerDocument.default)(_reactDom.default.findDOMNode(element));
	}
	/**
	 * Portals provide a first-class way to render children into a DOM node
	 * that exists outside the DOM hierarchy of the parent component.
	 */
	
	
	var Portal =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Portal, _React$Component);
	
	  function Portal() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Portal);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Portal)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _this.getMountNode = function () {
	      return _this.mountNode;
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(Portal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setMountNode(this.props.container); // Only rerender if needed
	
	      if (!this.props.disablePortal) {
	        this.forceUpdate(this.props.onRendered);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.container !== this.props.container || prevProps.disablePortal !== this.props.disablePortal) {
	        this.setMountNode(this.props.container); // Only rerender if needed
	
	        if (!this.props.disablePortal) {
	          this.forceUpdate(this.props.onRendered);
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mountNode = null;
	    }
	  }, {
	    key: "setMountNode",
	    value: function setMountNode(container) {
	      if (this.props.disablePortal) {
	        this.mountNode = _reactDom.default.findDOMNode(this).parentElement;
	        return;
	      }
	
	      this.mountNode = getContainer(container, getOwnerDocument(this).body);
	    }
	    /**
	     * @public
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          disablePortal = _this$props.disablePortal;
	
	      if (disablePortal) {
	        return children;
	      }
	
	      return this.mountNode ? _reactDom.default.createPortal(children, this.mountNode) : null;
	    }
	  }]);
	  return Portal;
	}(_react.default.Component);
	
	Portal.propTypes =  false ? {
	  /**
	   * The children to render into the `container`.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   */
	  onRendered: _propTypes.default.func
	} : {};
	Portal.defaultProps = {
	  disablePortal: false
	};
	Portal.propTypes =  false ? (0, _exactProp.default)(Portal.propTypes) : {};
	var _default = Portal;
	exports.default = _default;

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Portal.default;
	  }
	});
	
	var _Portal = _interopRequireDefault(__webpack_require__(150));

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(9));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(20));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _exactProp = _interopRequireDefault(__webpack_require__(71));
	
	function setRef(ref, value) {
	  if (typeof ref === 'function') {
	    ref(value);
	  } else if (ref) {
	    ref.current = value;
	  }
	}
	/**
	 * Helper component to allow attaching a ref to a
	 * wrapped element to access the underlying DOM element.
	 *
	 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
	 * For example:
	 * ```jsx
	 * import React from 'react';
	 * import RootRef from '@material-ui/core/RootRef';
	 *
	 * class MyComponent extends React.Component {
	 *   constructor() {
	 *     super();
	 *     this.domRef = React.createRef();
	 *   }
	 *
	 *   componentDidMount() {
	 *     console.log(this.domRef.current); // DOM node
	 *   }
	 *
	 *   render() {
	 *     return (
	 *       <RootRef rootRef={this.domRef}>
	 *         <SomeChildComponent />
	 *       </RootRef>
	 *     );
	 *   }
	 * }
	 * ```
	 */
	
	
	var RootRef =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(RootRef, _React$Component);
	
	  function RootRef() {
	    (0, _classCallCheck2.default)(this, RootRef);
	    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RootRef).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(RootRef, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      setRef(this.props.rootRef, _reactDom.default.findDOMNode(this));
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.rootRef !== this.props.rootRef) {
	        setRef(prevProps.rootRef, null);
	        setRef(this.props.rootRef, _reactDom.default.findDOMNode(this));
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      setRef(this.props.rootRef, null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return RootRef;
	}(_react.default.Component);
	
	RootRef.propTypes =  false ? {
	  /**
	   * The wrapped element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * Provide a way to access the DOM node of the wrapped element.
	   * You can provide a callback ref or a `React.createRef()` ref.
	   */
	  rootRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]).isRequired
	} : {};
	RootRef.propTypes =  false ? (0, _exactProp.default)(RootRef.propTypes) : {};
	var _default = RootRef;
	exports.default = _default;

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _RootRef.default;
	  }
	});
	
	var _RootRef = _interopRequireDefault(__webpack_require__(152));

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTranslateValue = setTranslateValue;
	exports.default = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(9));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));
	
	var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(12));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(20));
	
	var _reactEventListener = _interopRequireDefault(__webpack_require__(66));
	
	var _debounce = _interopRequireDefault(__webpack_require__(61));
	
	var _Transition = _interopRequireDefault(__webpack_require__(45));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(39));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(69));
	
	var _transitions = __webpack_require__(38);
	
	var _utils = __webpack_require__(70);
	
	// @inheritedComponent Transition
	// < 1kb payload overhead when lodash/debounce is > 3kb.
	var GUTTER = 24; // Translate the node so he can't be seen on the screen.
	// Later, we gonna translate back the node to his original location
	// with `translate3d(0, 0, 0)`.`
	
	function getTranslateValue(props, node) {
	  var direction = props.direction;
	  var rect = node.getBoundingClientRect();
	  var transform;
	
	  if (node.fakeTransform) {
	    transform = node.fakeTransform;
	  } else {
	    var computedStyle = (0, _ownerWindow.default)(node).getComputedStyle(node);
	    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
	  }
	
	  var offsetX = 0;
	  var offsetY = 0;
	
	  if (transform && transform !== 'none' && typeof transform === 'string') {
	    var transformValues = transform.split('(')[1].split(')')[0].split(',');
	    offsetX = parseInt(transformValues[4], 10);
	    offsetY = parseInt(transformValues[5], 10);
	  }
	
	  if (direction === 'left') {
	    return "translateX(100vw) translateX(-".concat(rect.left - offsetX, "px)");
	  }
	
	  if (direction === 'right') {
	    return "translateX(-".concat(rect.left + rect.width + GUTTER - offsetX, "px)");
	  }
	
	  if (direction === 'up') {
	    return "translateY(100vh) translateY(-".concat(rect.top - offsetY, "px)");
	  } // direction === 'down'
	
	
	  return "translateY(-".concat(rect.top + rect.height + GUTTER - offsetY, "px)");
	}
	
	function setTranslateValue(props, node) {
	  var transform = getTranslateValue(props, node);
	
	  if (transform) {
	    node.style.webkitTransform = transform;
	    node.style.transform = transform;
	  }
	}
	/**
	 * The Slide transition is used by the [Snackbar](/demos/snackbars) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	
	var Slide =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Slide, _React$Component);
	
	  function Slide() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Slide);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Slide)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.mounted = false;
	    _this.transition = null;
	    _this.handleResize = (0, _debounce.default)(function () {
	      // Skip configuration where the position is screen size invariant.
	      if (_this.props.in || _this.props.direction === 'down' || _this.props.direction === 'right') {
	        return;
	      }
	
	      if (_this.transitionRef) {
	        setTranslateValue(_this.props, _this.transitionRef);
	      }
	    }, 166);
	
	    _this.handleEnter = function (node) {
	      setTranslateValue(_this.props, node);
	      (0, _utils.reflow)(node);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    };
	
	    _this.handleEntering = function (node) {
	      var theme = _this.props.theme;
	      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'enter'
	      });
	      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
	        easing: theme.transitions.easing.easeOut
	      }));
	      node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
	        easing: theme.transitions.easing.easeOut
	      }));
	      node.style.webkitTransform = 'translate(0, 0)';
	      node.style.transform = 'translate(0, 0)';
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node);
	      }
	    };
	
	    _this.handleExit = function (node) {
	      var theme = _this.props.theme;
	      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
	        mode: 'exit'
	      });
	      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
	        easing: theme.transitions.easing.sharp
	      }));
	      node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
	        easing: theme.transitions.easing.sharp
	      }));
	      setTranslateValue(_this.props, node);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.handleExited = function (node) {
	      // No need for transitions when the component is hidden
	      node.style.webkitTransition = '';
	      node.style.transition = '';
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(Slide, [{
	    key: "componentDidMount",
	    // Corresponds to 10 frames at 60 Hz.
	    value: function componentDidMount() {
	      // state.mounted handle SSR, once the component is mounted, we need
	      // to properly hide it.
	      if (!this.props.in) {
	        // We need to set initial translate values of transition element
	        // otherwise component will be shown when in=false.
	        this.updatePosition();
	      }
	
	      this.mounted = true;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.direction !== this.props.direction && !this.props.in) {
	        // We need to update the position of the drawer when the direction change and
	        // when it's hidden.
	        this.updatePosition();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.handleResize.clear();
	    }
	  }, {
	    key: "updatePosition",
	    value: function updatePosition() {
	      if (this.transitionRef) {
	        this.transitionRef.style.visibility = 'inherit';
	        setTranslateValue(this.props, this.transitionRef);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          children = _this$props.children,
	          onEnter = _this$props.onEnter,
	          onEntering = _this$props.onEntering,
	          onExit = _this$props.onExit,
	          onExited = _this$props.onExited,
	          styleProp = _this$props.style,
	          theme = _this$props.theme,
	          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "onEnter", "onEntering", "onExit", "onExited", "style", "theme"]);
	      var style = {}; // We use this state to handle the server-side rendering.
	      // We don't know the width of the children ahead of time.
	      // We need to render it.
	
	      if (!this.props.in && !this.mounted) {
	        style.visibility = 'hidden';
	      }
	
	      style = (0, _extends2.default)({}, style, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
	      return _react.default.createElement(_reactEventListener.default, {
	        target: "window",
	        onResize: this.handleResize
	      }, _react.default.createElement(_Transition.default, (0, _extends2.default)({
	        onEnter: this.handleEnter,
	        onEntering: this.handleEntering,
	        onExit: this.handleExit,
	        onExited: this.handleExited,
	        appear: true,
	        style: style,
	        ref: function ref(_ref) {
	          _this2.transitionRef = _reactDom.default.findDOMNode(_ref);
	        }
	      }, other), children));
	    }
	  }]);
	  return Slide;
	}(_react.default.Component);
	
	Slide.propTypes =  false ? {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
	
	  /**
	   * Direction the child node will enter from.
	   */
	  direction: _propTypes.default.oneOf(['left', 'right', 'up', 'down']),
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  theme: _propTypes.default.object.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : {};
	Slide.defaultProps = {
	  direction: 'down',
	  timeout: {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  }
	};
	
	var _default = (0, _withTheme.default)()(Slide);
	
	exports.default = _default;

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	
	var _Slide = _interopRequireDefault(__webpack_require__(154));

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionProps = getTransitionProps;
	exports.reflow = void 0;
	
	var reflow = function reflow(node) {
	  return node.scrollTop;
	};
	
	exports.reflow = reflow;
	
	function getTransitionProps(props, options) {
	  var timeout = props.timeout,
	      _props$style = props.style,
	      style = _props$style === void 0 ? {} : _props$style;
	  return {
	    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
	    delay: style.transitionDelay
	  };
	}

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	var _default = ownerDocument;
	exports.default = _default;

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(22));
	
	function ownerWindow(node) {
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
	  var doc = (0, _ownerDocument.default)(node);
	  return doc.defaultView || doc.parentView || fallback;
	}
	
	var _default = ownerWindow;
	exports.default = _default;

/***/ }),

/***/ 61:
/***/ (function(module, exports) {

	/**
	 * Returns a function, that, as long as it continues to be invoked, will not
	 * be triggered. The function will be called after it stops being called for
	 * N milliseconds. If `immediate` is passed, trigger the function on the
	 * leading edge, instead of the trailing. The function also has a property 'clear' 
	 * that is a function which will clear the timer to prevent previously scheduled executions. 
	 *
	 * @source underscore.js
	 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
	 * @param {Function} function to wrap
	 * @param {Number} timeout in ms (`100`)
	 * @param {Boolean} whether to execute at the beginning (`false`)
	 * @api public
	 */
	
	module.exports = function debounce(func, wait, immediate){
	  var timeout, args, context, timestamp, result;
	  if (null == wait) wait = 100;
	
	  function later() {
	    var last = Date.now() - timestamp;
	
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	    }
	  };
	
	  var debounced = function(){
	    context = this;
	    args = arguments;
	    timestamp = Date.now();
	    var callNow = immediate && !timeout;
	    if (!timeout) timeout = setTimeout(later, wait);
	    if (callNow) {
	      result = func.apply(context, args);
	      context = args = null;
	    }
	
	    return result;
	  };
	
	  debounced.clear = function() {
	    if (timeout) {
	      clearTimeout(timeout);
	      timeout = null;
	    }
	  };
	  
	  debounced.flush = function() {
	    if (timeout) {
	      result = func.apply(context, args);
	      context = args = null;
	      
	      clearTimeout(timeout);
	      timeout = null;
	    }
	  };
	
	  return debounced;
	};


/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(435);
	var isArguments = __webpack_require__(434);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 434:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 435:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 44:
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var MenuIcon = function MenuIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z' })
	  );
	};
	
	module.exports = MenuIcon;


/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var AccessPointNetworkIcon = function AccessPointNetworkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.93,2.93C3.12,4.74 2,7.24 2,10C2,12.76 3.12,15.26 4.93,17.07L6.34,15.66C4.89,14.22 4,12.22 4,10C4,7.79 4.89,5.78 6.34,4.34L4.93,2.93M19.07,2.93L17.66,4.34C19.11,5.78 20,7.79 20,10C20,12.22 19.11,14.22 17.66,15.66L19.07,17.07C20.88,15.26 22,12.76 22,10C22,7.24 20.88,4.74 19.07,2.93M7.76,5.76C6.67,6.85 6,8.35 6,10C6,11.65 6.67,13.15 7.76,14.24L9.17,12.83C8.45,12.11 8,11.11 8,10C8,8.89 8.45,7.89 9.17,7.17L7.76,5.76M16.24,5.76L14.83,7.17C15.55,7.89 16,8.89 16,10C16,11.11 15.55,12.11 14.83,12.83L16.24,14.24C17.33,13.15 18,11.65 18,10C18,8.35 17.33,6.85 16.24,5.76M12,8C10.9,8 10,8.9 10,10C10,11.1 10.9,12 12,12C13.1,12 14,11.1 14,10C14,8.9 13.1,8 12,8M11,14V18H10C9.45,18 9,18.45 9,19H2V21H9C9,21.55 9.45,22 10,22H14C14.55,22 15,21.55 15,21H22V19H15C15,18.45 14.55,18 14,18H13V14H11Z' })
	  );
	};
	
	var AccessPointIcon = function AccessPointIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.93,4.93C3.12,6.74 2,9.24 2,12C2,14.76 3.12,17.26 4.93,19.07L6.34,17.66C4.89,16.22 4,14.22 4,12C4,9.79 4.89,7.78 6.34,6.34L4.93,4.93M19.07,4.93L17.66,6.34C19.11,7.78 20,9.79 20,12C20,14.22 19.11,16.22 17.66,17.66L19.07,19.07C20.88,17.26 22,14.76 22,12C22,9.24 20.88,6.74 19.07,4.93M7.76,7.76C6.67,8.85 6,10.35 6,12C6,13.65 6.67,15.15 7.76,16.24L9.17,14.83C8.45,14.11 8,13.11 8,12C8,10.89 8.45,9.89 9.17,9.17L7.76,7.76M16.24,7.76L14.83,9.17C15.55,9.89 16,10.89 16,12C16,13.11 15.55,14.11 14.83,14.83L16.24,16.24C17.33,15.15 18,13.65 18,12C18,10.35 17.33,8.85 16.24,7.76M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10Z' })
	  );
	};
	
	var AccountAlertIcon = function AccountAlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,4C12.21,4 14,5.79 14,8C14,10.21 12.21,12 10,12C7.79,12 6,10.21 6,8C6,5.79 7.79,4 10,4M10,14C14.42,14 18,15.79 18,18V20H2V18C2,15.79 5.58,14 10,14M20,12V7H22V12H20M20,16V14H22V16H20Z' })
	  );
	};
	
	var AccountBoxMultipleIcon = function AccountBoxMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,6H2V20C2,21.1 2.9,22 4,22H18V20H4V6M20,2C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H8C6.9,18 6,17.1 6,16V4C6,2.9 6.9,2 8,2H20M17,7C17,5.34 15.66,4 14,4C12.34,4 11,5.34 11,7C11,8.66 12.34,10 14,10C15.66,10 17,8.66 17,7M8,15V16H20V15C20,13 16,11.9 14,11.9C12,11.9 8,13 8,15Z' })
	  );
	};
	
	var AccountBoxOutlineIcon = function AccountBoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M16.5,16.25C16.5,14.75 13.5,14 12,14C10.5,14 7.5,14.75 7.5,16.25V17H16.5M12,12.25C13.24,12.25 14.25,11.24 14.25,10C14.25,8.76 13.24,7.75 12,7.75C10.76,7.75 9.75,8.76 9.75,10C9.75,11.24 10.76,12.25 12,12.25Z' })
	  );
	};
	
	var AccountBoxIcon = function AccountBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,17C6,15 10,13.9 12,13.9C14,13.9 18,15 18,17V18H6M15,9C15,10.66 13.66,12 12,12C10.34,12 9,10.66 9,9C9,7.34 10.34,6 12,6C13.66,6 15,7.34 15,9M3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5C3.89,3 3,3.9 3,5Z' })
	  );
	};
	
	var AccountCardDetailsIcon = function AccountCardDetailsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,3H22C23.05,3 24,3.95 24,5V19C24,20.05 23.05,21 22,21H2C0.95,21 0,20.05 0,19V5C0,3.95 0.95,3 2,3M14,6V7H22V6H14M14,8V9H21.5L22,9V8H14M14,10V11H21V10H14M8,13.91C6,13.91 2,15 2,17V18H14V17C14,15 10,13.91 8,13.91M8,6C6.34,6 5,7.34 5,9C5,10.66 6.34,12 8,12C9.66,12 11,10.66 11,9C11,7.34 9.66,6 8,6Z' })
	  );
	};
	
	var AccountCheckIcon = function AccountCheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,5C10.93,5 12.5,6.57 12.5,8.5C12.5,10.43 10.93,12 9,12C7.07,12 5.5,10.43 5.5,8.5C5.5,6.57 7.07,5 9,5M9,13.75C12.87,13.75 16,15.32 16,17.25V19H2V17.25C2,15.32 5.13,13.75 9,13.75M17,12.66L14.25,9.66L15.41,8.5L17,10.09L20.59,6.5L21.75,7.91L17,12.66Z' })
	  );
	};
	
	var AccountCircleIcon = function AccountCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5C13.66,5 15,6.34 15,8C15,9.66 13.66,11 12,11C10.34,11 9,9.66 9,8C9,6.34 10.34,5 12,5M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.47 17.5,2 12,2Z' })
	  );
	};
	
	var AccountConvertIcon = function AccountConvertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.5,21.5L8.85,20.16L12.66,23.97L12,24C5.71,24 0.56,19.16 0.05,13H1.55C1.91,16.76 4.25,19.94 7.5,21.5M16.5,2.5L15.15,3.84L11.34,0.03L12,0C18.29,0 23.44,4.84 23.95,11H22.45C22.09,7.24 19.75,4.07 16.5,2.5M6,17C6,15 10,13.9 12,13.9C14,13.9 18,15 18,17V18H6V17M15,9C15,10.66 13.66,12 12,12C10.34,12 9,10.66 9,9C9,7.34 10.34,6 12,6C13.66,6 15,7.34 15,9Z' })
	  );
	};
	
	var AccountEditIcon = function AccountEditIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.7,13.35L20.7,14.35L18.65,12.3L19.65,11.3C19.86,11.09 20.21,11.09 20.42,11.3L21.7,12.58C21.91,12.79 21.91,13.14 21.7,13.35M12,18.94L18.06,12.88L20.11,14.93L14.06,21H12V18.94M12,14C7.58,14 4,15.79 4,18V20H10V18.11L14,14.11C13.34,14.03 12.67,14 12,14M12,4C9.79,4 8,5.79 8,8C8,10.21 9.79,12 12,12C14.21,12 16,10.21 16,8C16,5.79 14.21,4 12,4Z' })
	  );
	};
	
	var AccountGroupIcon = function AccountGroupIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,6C10.34,6 9,7.34 9,9C9,10.66 10.34,12 12,12C13.66,12 15,10.66 15,9C15,7.34 13.66,6 12,6M6,8.17C4.62,8.17 3.5,9.29 3.5,10.67C3.5,12.05 4.62,13.17 6,13.17C6.88,13.17 7.65,12.71 8.09,12.03C7.42,11.18 7,10.15 7,9C7,8.8 7,8.6 7.04,8.4C6.72,8.25 6.37,8.17 6,8.17M18,8.17C17.63,8.17 17.28,8.25 16.96,8.4C17,8.6 17,8.8 17,9C17,10.15 16.58,11.18 15.91,12.03C16.35,12.71 17.12,13.17 18,13.17C19.38,13.17 20.5,12.05 20.5,10.67C20.5,9.29 19.38,8.17 18,8.17M12,14C10,14 6,15 6,17V19H18V17C18,15 14,14 12,14M4.67,14.97C3,15.26 1,16.04 1,17.33V19H4V17C4,16.22 4.29,15.53 4.67,14.97M19.33,14.97C19.71,15.53 20,16.22 20,17V19H23V17.33C23,16.04 21,15.26 19.33,14.97Z' })
	  );
	};
	
	var AccountHeartIcon = function AccountHeartIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,14C12.3,14 7,15.3 7,18V20H23V18C23,15.3 17.7,14 15,14M15,12C17.21,12 19,10.21 19,8C19,5.79 17.21,4 15,4C12.79,4 11,5.79 11,8C11,10.21 12.79,12 15,12M5,15L4.4,14.5C2.4,12.6 1,11.4 1,9.9C1,8.7 2,7.7 3.2,7.7C3.9,7.7 4.6,8 5,8.5C5.4,8 6.1,7.7 6.8,7.7C8,7.7 9,8.6 9,9.9C9,11.4 7.6,12.6 5.6,14.5L5,15Z' })
	  );
	};
	
	var AccountKeyIcon = function AccountKeyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,10V12H10V14H8V12H5.83C5.42,13.17 4.31,14 3,14C1.34,14 0,12.66 0,11C0,9.34 1.34,8 3,8C4.31,8 5.42,8.83 5.83,10H11M3,10C2.45,10 2,10.45 2,11C2,11.55 2.45,12 3,12C3.55,12 4,11.55 4,11C4,10.45 3.55,10 3,10M16,14C18.67,14 24,15.34 24,18V20H8V18C8,15.34 13.33,14 16,14M16,12C13.79,12 12,10.21 12,8C12,5.79 13.79,4 16,4C18.21,4 20,5.79 20,8C20,10.21 18.21,12 16,12Z' })
	  );
	};
	
	var AccountLocationIcon = function AccountLocationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,16H6V15.1C6,13.1 10,12 12,12C14,12 18,13.1 18,15.1M12,5.3C13.5,5.3 14.7,6.5 14.7,8C14.7,9.5 13.5,10.7 12,10.7C10.5,10.7 9.3,9.5 9.3,8C9.3,6.5 10.5,5.3 12,5.3M19,2H5C3.89,2 3,2.89 3,4V18C3,19.1 3.9,20 5,20H9L12,23L15,20H19C20.1,20 21,19.1 21,18V4C21,2.89 20.1,2 19,2Z' })
	  );
	};
	
	var AccountMinusIcon = function AccountMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M1,10V12H9V10M15,12C17.21,12 19,10.21 19,8C19,5.79 17.21,4 15,4C12.79,4 11,5.79 11,8C11,10.21 12.79,12 15,12Z' })
	  );
	};
	
	var AccountMultipleCheckIcon = function AccountMultipleCheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22.59,7.92L23.75,9.33L19,14.08L16.25,11.08L17.41,9.92L19,11.5L22.59,7.92M6,5C7.66,5 9,6.34 9,8C9,9.66 7.66,11 6,11C4.34,11 3,9.66 3,8C3,6.34 4.34,5 6,5M11,5C12.66,5 14,6.34 14,8C14,9.66 12.66,11 11,11C10.68,11 10.37,10.95 10.08,10.85C10.65,10.04 11,9.06 11,8C11,6.94 10.65,5.95 10.08,5.14C10.37,5.05 10.68,5 11,5M6,13C8,13 12,14 12,16V18H0V16C0,14 4,13 6,13M12.62,13.16C14.63,13.5 17,14.46 17,16V18H14V16C14,14.82 13.45,13.88 12.62,13.16Z' })
	  );
	};
	
	var AccountMultipleMinusIcon = function AccountMultipleMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,13C11,13 7,14 7,16V18H19V16C19,14 15,13 13,13M19.62,13.16C20.45,13.88 21,14.82 21,16V18H24V16C24,14.46 21.63,13.5 19.62,13.16M13,11C14.66,11 16,9.66 16,8C16,6.34 14.66,5 13,5C11.34,5 10,6.34 10,8C10,9.66 11.34,11 13,11M18,11C19.66,11 21,9.66 21,8C21,6.34 19.66,5 18,5C17.68,5 17.37,5.05 17.08,5.14C17.65,5.95 18,6.94 18,8C18,9.06 17.65,10.04 17.08,10.85C17.37,10.95 17.68,11 18,11M8,10H0V12H8V10Z' })
	  );
	};
	
	var AccountMultipleOutlineIcon = function AccountMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.5,6.5C17.6,6.5 18.5,7.4 18.5,8.5C18.5,9.6 17.6,10.5 16.5,10.5C15.4,10.5 14.5,9.6 14.5,8.5C14.5,7.4 15.4,6.5 16.5,6.5M16.5,12C18.43,12 20,10.43 20,8.5C20,6.57 18.43,5 16.5,5C14.57,5 13,6.57 13,8.5C13,10.43 14.57,12 16.5,12M7.5,6.5C8.6,6.5 9.5,7.4 9.5,8.5C9.5,9.6 8.6,10.5 7.5,10.5C6.4,10.5 5.5,9.6 5.5,8.5C5.5,7.4 6.4,6.5 7.5,6.5M7.5,12C9.43,12 11,10.43 11,8.5C11,6.57 9.43,5 7.5,5C5.57,5 4,6.57 4,8.5C4,10.43 5.57,12 7.5,12M21.5,17.5H14V16.25C14,15.79 13.8,15.39 13.5,15.03C14.36,14.73 15.44,14.5 16.5,14.5C18.94,14.5 21.5,15.71 21.5,16.25M12.5,17.5H2.5V16.25C2.5,15.71 5.06,14.5 7.5,14.5C9.94,14.5 12.5,15.71 12.5,16.25M16.5,13C15.3,13 13.43,13.34 12,14C10.57,13.33 8.7,13 7.5,13C5.33,13 1,14.08 1,16.25V19H23V16.25C23,14.08 18.67,13 16.5,13Z' })
	  );
	};
	
	var AccountMultiplePlusOutlineIcon = function AccountMultiplePlusOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.5,5C11.57,5 10,6.57 10,8.5C10,10.43 11.57,12 13.5,12C14.25,12 14.94,11.76 15.5,11.36C16.07,11.76 16.76,12 17.5,12C19.43,12 21,10.43 21,8.5C21,6.57 19.43,5 17.5,5C16.76,5 16.08,5.25 15.5,5.65C14.95,5.24 14.25,5 13.5,5M13.5,6.5C14.6,6.5 15.5,7.4 15.5,8.5C15.5,9.6 14.6,10.5 13.5,10.5C12.4,10.5 11.5,9.6 11.5,8.5C11.5,7.4 12.4,6.5 13.5,6.5M17.5,6.5C18.6,6.5 19.5,7.4 19.5,8.5C19.5,9.6 18.6,10.5 17.5,10.5C17.14,10.5 16.81,10.4 16.5,10.23C16.82,9.72 17,9.13 17,8.5C17,7.87 16.82,7.28 16.5,6.77C16.81,6.6 17.14,6.5 17.5,6.5M3,8V11H0V13H3V16H5V13H8V11H5V8H3M13.5,13C11.33,13 7,14.08 7,16.25V19H24V16.25C24,14.08 19.67,13 17.5,13C16.95,13 16.25,13.08 15.5,13.22C14.78,13.08 14.07,13 13.5,13M13.5,14.5C15.94,14.5 18.5,15.71 18.5,16.25V17.5H8.5V16.25C8.5,15.71 11.06,14.5 13.5,14.5M19.08,14.66C20.93,15 22.5,15.83 22.5,16.25V17.5H20V16.25C20,15.63 19.64,15.1 19.08,14.66Z' })
	  );
	};
	
	var AccountMultiplePlusIcon = function AccountMultiplePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,13C11,13 7,14 7,16V18H19V16C19,14 15,13 13,13M19.62,13.16C20.45,13.88 21,14.82 21,16V18H24V16C24,14.46 21.63,13.5 19.62,13.16M13,11C14.66,11 16,9.66 16,8C16,6.34 14.66,5 13,5C11.34,5 10,6.34 10,8C10,9.66 11.34,11 13,11M18,11C19.66,11 21,9.66 21,8C21,6.34 19.66,5 18,5C17.68,5 17.37,5.05 17.08,5.14C17.65,5.95 18,6.94 18,8C18,9.06 17.65,10.04 17.08,10.85C17.37,10.95 17.68,11 18,11M8,10H5V7H3V10H0V12H3V15H5V12H8V10Z' })
	  );
	};
	
	var AccountMultipleIcon = function AccountMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,13C15.71,13 15.38,13 15.03,13.05C16.19,13.89 17,15 17,16.5V19H23V16.5C23,14.17 18.33,13 16,13M8,13C5.67,13 1,14.17 1,16.5V19H15V16.5C15,14.17 10.33,13 8,13M8,11C9.66,11 11,9.66 11,8C11,6.34 9.66,5 8,5C6.34,5 5,6.34 5,8C5,9.66 6.34,11 8,11M16,11C17.66,11 19,9.66 19,8C19,6.34 17.66,5 16,5C14.34,5 13,6.34 13,8C13,9.66 14.34,11 16,11Z' })
	  );
	};
	
	var AccountNetworkIcon = function AccountNetworkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,16V18H14C14.55,18 15,18.45 15,19H22V21H15C15,21.55 14.55,22 14,22H10C9.45,22 9,21.55 9,21H2V19H9C9,18.45 9.45,18 10,18H11V16H5V14.5C5,12.57 8.13,11 12,11C15.87,11 19,12.57 19,14.5V16H13M12,2C13.93,2 15.5,3.57 15.5,5.5C15.5,7.43 13.93,9 12,9C10.07,9 8.5,7.43 8.5,5.5C8.5,3.57 10.07,2 12,2Z' })
	  );
	};
	
	var AccountOffIcon = function AccountOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,4C14.21,4 16,5.79 16,8C16,9.95 14.6,11.58 12.75,11.93L8.07,7.25C8.42,5.4 10.05,4 12,4M12.28,14L18.28,20L20,21.72L18.73,23L15.73,20H4V18C4,16.16 6.5,14.61 9.87,14.14L2.78,7.05L4.05,5.78L12.28,14M20,18V19.18L15.14,14.32C18,14.93 20,16.35 20,18Z' })
	  );
	};
	
	var AccountOutlineIcon = function AccountOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,13C9.33,13 4,14.33 4,17V20H20V17C20,14.33 14.67,13 12,13M12,4C9.79,4 8,5.79 8,8C8,10.21 9.79,12 12,12C14.21,12 16,10.21 16,8C16,5.79 14.21,4 12,4M12,14.9C14.97,14.9 18.1,16.36 18.1,17V18.1H5.9V17C5.9,16.36 9,14.9 12,14.9M12,5.9C13.16,5.9 14.1,6.84 14.1,8C14.1,9.16 13.16,10.1 12,10.1C10.84,10.1 9.9,9.16 9.9,8C9.9,6.84 10.84,5.9 12,5.9Z' })
	  );
	};
	
	var AccountPlusOutlineIcon = function AccountPlusOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,4C12.79,4 11,5.79 11,8C11,10.21 12.79,12 15,12C17.21,12 19,10.21 19,8C19,5.79 17.21,4 15,4M15,5.9C16.16,5.9 17.1,6.84 17.1,8C17.1,9.16 16.16,10.1 15,10.1C13.84,10.1 12.9,9.16 12.9,8C12.9,6.84 13.84,5.9 15,5.9M4,7V10H1V12H4V15H6V12H9V10H6V7H4M15,13C12.33,13 7,14.33 7,17V20H23V17C23,14.33 17.67,13 15,13M15,14.9C17.97,14.9 21.1,16.36 21.1,17V18.1H8.9V17C8.9,16.36 12,14.9 15,14.9Z' })
	  );
	};
	
	var AccountPlusIcon = function AccountPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M6,10V7H4V10H1V12H4V15H6V12H9V10M15,12C17.21,12 19,10.21 19,8C19,5.79 17.21,4 15,4C12.79,4 11,5.79 11,8C11,10.21 12.79,12 15,12Z' })
	  );
	};
	
	var AccountRemoveIcon = function AccountRemoveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,14C17.67,14 23,15.33 23,18V20H7V18C7,15.33 12.33,14 15,14M15,12C12.79,12 11,10.21 11,8C11,5.79 12.79,4 15,4C17.21,4 19,5.79 19,8C19,10.21 17.21,12 15,12M5,9.59L7.12,7.46L8.54,8.88L6.41,11L8.54,13.12L7.12,14.54L5,12.41L2.88,14.54L1.46,13.12L3.59,11L1.46,8.88L2.88,7.46L5,9.59Z' })
	  );
	};
	
	var AccountSearchOutlineIcon = function AccountSearchOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,13C9.65,13.59 9.36,14.24 9.19,14.93C6.5,15.16 3.9,16.42 3.9,17V18.1H9.2C9.37,18.78 9.65,19.42 10,20H2V17C2,14.34 7.33,13 10,13M10,4C12.21,4 14,5.79 14,8C14,8.91 13.69,9.75 13.18,10.43C12.32,10.75 11.55,11.26 10.91,11.9L10,12C7.79,12 6,10.21 6,8C6,5.79 7.79,4 10,4M10,5.9C8.84,5.9 7.9,6.84 7.9,8C7.9,9.16 8.84,10.1 10,10.1C11.16,10.1 12.1,9.16 12.1,8C12.1,6.84 11.16,5.9 10,5.9M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14C14.12,14 13,15.12 13,16.5C13,17.88 14.12,19 15.5,19C16.88,19 18,17.88 18,16.5C18,15.12 16.88,14 15.5,14Z' })
	  );
	};
	
	var AccountSearchIcon = function AccountSearchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14C14.12,14 13,15.12 13,16.5C13,17.88 14.12,19 15.5,19C16.88,19 18,17.88 18,16.5C18,15.12 16.88,14 15.5,14M10,4C12.21,4 14,5.79 14,8C14,8.91 13.69,9.75 13.18,10.43C12.32,10.75 11.55,11.26 10.91,11.9L10,12C7.79,12 6,10.21 6,8C6,5.79 7.79,4 10,4M2,20V18C2,15.88 5.31,14.14 9.5,14C9.18,14.78 9,15.62 9,16.5C9,17.79 9.38,19 10,20H2Z' })
	  );
	};
	
	var AccountSettingsVariantIcon = function AccountSettingsVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,4C6.79,4 5,5.79 5,8C5,10.21 6.79,12 9,12C11.21,12 13,10.21 13,8C13,5.79 11.21,4 9,4M9,14C6.33,14 1,15.33 1,18V20H12.08C12.03,19.67 12,19.34 12,19C12,17.5 12.5,16 13.41,14.8C11.88,14.28 10.18,14 9,14M18,14C17.87,14 17.76,14.09 17.74,14.21L17.55,15.53C17.25,15.66 16.96,15.82 16.7,16L15.46,15.5C15.35,15.5 15.22,15.5 15.15,15.63L14.15,17.36C14.09,17.47 14.11,17.6 14.21,17.68L15.27,18.5C15.25,18.67 15.24,18.83 15.24,19C15.24,19.17 15.25,19.33 15.27,19.5L14.21,20.32C14.12,20.4 14.09,20.53 14.15,20.64L15.15,22.37C15.21,22.5 15.34,22.5 15.46,22.5L16.7,22C16.96,22.18 17.24,22.35 17.55,22.47L17.74,23.79C17.76,23.91 17.86,24 18,24H20C20.11,24 20.22,23.91 20.24,23.79L20.43,22.47C20.73,22.34 21,22.18 21.27,22L22.5,22.5C22.63,22.5 22.76,22.5 22.83,22.37L23.83,20.64C23.89,20.53 23.86,20.4 23.77,20.32L22.7,19.5C22.72,19.33 22.74,19.17 22.74,19C22.74,18.83 22.73,18.67 22.7,18.5L23.76,17.68C23.85,17.6 23.88,17.47 23.82,17.36L22.82,15.63C22.76,15.5 22.63,15.5 22.5,15.5L21.27,16C21,15.82 20.73,15.65 20.42,15.53L20.23,14.21C20.22,14.09 20.11,14 20,14M19,17.5C19.83,17.5 20.5,18.17 20.5,19C20.5,19.83 19.83,20.5 19,20.5C18.16,20.5 17.5,19.83 17.5,19C17.5,18.17 18.17,17.5 19,17.5Z' })
	  );
	};
	
	var AccountSettingsIcon = function AccountSettingsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,4C14.21,4 16,5.79 16,8C16,10.21 14.21,12 12,12C9.79,12 8,10.21 8,8C8,5.79 9.79,4 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22Z' })
	  );
	};
	
	var AccountStarIcon = function AccountStarIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M15,12C17.21,12 19,10.21 19,8C19,5.79 17.21,4 15,4C12.79,4 11,5.79 11,8C11,10.21 12.79,12 15,12M5,13.28L7.45,14.77L6.8,11.96L9,10.08L6.11,9.83L5,7.19L3.87,9.83L1,10.08L3.18,11.96L2.5,14.77L5,13.28Z' })
	  );
	};
	
	var AccountSwitchIcon = function AccountSwitchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,9C18.33,9 23,10.17 23,12.5V15H17V12.5C17,11 16.19,9.89 15.04,9.05L16,9M8,9C10.33,9 15,10.17 15,12.5V15H1V12.5C1,10.17 5.67,9 8,9M8,7C6.34,7 5,5.66 5,4C5,2.34 6.34,1 8,1C9.66,1 11,2.34 11,4C11,5.66 9.66,7 8,7M16,7C14.34,7 13,5.66 13,4C13,2.34 14.34,1 16,1C17.66,1 19,2.34 19,4C19,5.66 17.66,7 16,7M9,16.75V19H15V16.75L18.25,20L15,23.25V21H9V23.25L5.75,20L9,16.75Z' })
	  );
	};
	
	var AccountIcon = function AccountIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,4C14.21,4 16,5.79 16,8C16,10.21 14.21,12 12,12C9.79,12 8,10.21 8,8C8,5.79 9.79,4 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z' })
	  );
	};
	
	var AccusoftIcon = function AccusoftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.5,15.61C17.33,15.37 9.53,5.4 9.27,5.08C9,4.75 9.08,4.65 9.13,4.59C9.22,4.5 9.36,4.5 9.93,4.5C10.26,4.5 13.59,4.5 13.94,4.47C14.66,4.47 14.78,4.53 14.85,4.56C14.93,4.58 15.13,4.75 15.26,4.92C15.33,5 22.32,13.36 22.39,13.45C22.46,13.54 22.59,13.69 22.67,13.84C22.76,14 22.77,14.18 22.64,14.25C22.56,14.3 18.7,15.89 18.59,15.93C18.5,16 18.27,16.06 18.11,16.04C18,16 17.77,15.92 17.5,15.61M21.47,15.42L21.75,15.47C21.75,15.47 22.68,15.65 22.77,15.67C22.87,15.69 22.96,15.76 22.95,15.79C22.94,15.87 22.9,15.91 22.83,15.95C22.77,16 18.58,18.58 18.5,18.62C18.43,18.66 18.33,18.72 18.11,18.75C17.7,18.83 16.91,18.61 16.66,18.56C16.41,18.5 6.15,16.23 6.06,16.2C5.97,16.17 5.91,16.16 5.9,16.08C5.89,15.94 6.11,15.88 6.28,15.81C6.46,15.75 11.28,14 11.45,13.93C11.62,13.86 11.84,13.84 11.95,13.83C12.06,13.82 12.73,13.93 13.03,13.97C13.34,14 14.2,14.15 14.2,14.15L16.16,16.7C16.5,17.09 16.72,17.25 17,17.28C17.15,17.29 17.31,17.25 17.42,17.2C17.5,17.16 21.47,15.42 21.47,15.42M10.25,9.18L11.96,11.37L12,11.45V11.5C11.96,11.54 8.93,14.32 8.91,14.35L5.72,15.5C5.72,15.5 5.63,15.55 5.58,15.58C5.53,15.61 5.47,15.67 5.5,15.82C5.5,15.87 5.5,16.59 5.5,16.79L1.56,18.04C1.37,18.1 1,18.23 0.95,18.19C0.88,18.14 0.97,18.03 1,17.97C1.06,17.91 9.08,10 9.39,9.7C9.84,9.24 10.25,9.18 10.25,9.18' })
	  );
	};
	
	var AdjustIcon = function AdjustIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M15,12C15,13.66 13.66,15 12,15C10.34,15 9,13.66 9,12C9,10.34 10.34,9 12,9C13.66,9 15,10.34 15,12Z' })
	  );
	};
	
	var AdobeIcon = function AdobeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.58,3H22V19.67L14.58,3M9.42,3H2V19.67L9.42,3M12,9.17L16.67,19.67H13.5L12.17,16.33H8.75L12,9.17Z' })
	  );
	};
	
	var AirConditionerIcon = function AirConditionerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.59,0.66C8.93,-1.15 11.47,1.06 12.04,4.5C12.47,4.5 12.89,4.62 13.27,4.84C13.79,4.24 14.25,3.42 14.07,2.5C13.65,0.35 16.06,-1.39 18.35,1.58C20.16,3.92 17.95,6.46 14.5,7.03C14.5,7.46 14.39,7.89 14.16,8.27C14.76,8.78 15.58,9.24 16.5,9.06C18.63,8.64 20.38,11.04 17.41,13.34C15.07,15.15 12.53,12.94 11.96,9.5C11.53,9.5 11.11,9.37 10.74,9.15C10.22,9.75 9.75,10.58 9.93,11.5C10.35,13.64 7.94,15.39 5.65,12.42C3.83,10.07 6.05,7.53 9.5,6.97C9.5,6.54 9.63,6.12 9.85,5.74C9.25,5.23 8.43,4.76 7.5,4.94C5.37,5.36 3.62,2.96 6.59,0.66M5,16H7C8.1,16 9,16.9 9,18V24H7V22H5V24H3V18C3,16.9 3.9,16 5,16M5,18V20H7V18H5M12.93,16H15L12.07,24H10L12.93,16M18,16H21V18H18V22H21V24H18C16.9,24 16,23.1 16,22V18C16,16.9 16.9,16 18,16Z' })
	  );
	};
	
	var AirballoonIcon = function AirballoonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,23C9.9,23 9,22.1 9,21V19H15V21C15,22.1 14.1,23 13,23H11M12,1C12.71,1 13.39,1.09 14.05,1.26C15.22,2.83 16,5.71 16,9C16,11.28 15.62,13.37 15,16C15,17.1 14.1,18 13,18H11C9.9,18 9,17.1 9,16C8.38,13.37 8,11.28 8,9C8,5.71 8.78,2.83 9.95,1.26C10.61,1.09 11.29,1 12,1M20,8C20,11.18 18.15,15.92 15.46,17.21C16.41,15.39 17,11.83 17,9C17,6.17 16.41,3.61 15.46,1.79C18.15,3.08 20,4.82 20,8M4,8C4,4.82 5.85,3.08 8.54,1.79C7.59,3.61 7,6.17 7,9C7,11.83 7.59,15.39 8.54,17.21C5.85,15.92 4,11.18 4,8Z' })
	  );
	};
	
	var AirplaneLandingIcon = function AirplaneLandingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.5,19H21.5V21H2.5V19M9.68,13.27L14.03,14.43L19.34,15.85C20.14,16.06 20.96,15.59 21.18,14.79C21.39,14 20.92,13.17 20.12,12.95L14.81,11.53L12.05,2.5L10.12,2V10.28L5.15,8.95L4.22,6.63L2.77,6.24V11.41L4.37,11.84L9.68,13.27Z' })
	  );
	};
	
	var AirplaneOffIcon = function AirplaneOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.15,5.27L8.13,10.26L2.15,14V16L10.15,13.5V19L8.15,20.5V22L11.65,21L15.15,22V20.5L13.15,19V15.27L18.87,21L20.15,19.73L4.42,4M13.15,9V3.5C13.15,2.67 12.48,2 11.65,2C10.82,2 10.15,2.67 10.15,3.5V7.18L17.97,15L21.15,16V14L13.15,9Z' })
	  );
	};
	
	var AirplaneTakeoffIcon = function AirplaneTakeoffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.5,19H21.5V21H2.5V19M22.07,9.64C21.86,8.84 21.03,8.36 20.23,8.58L14.92,10L8,3.57L6.09,4.08L10.23,11.25L5.26,12.58L3.29,11.04L1.84,11.43L3.66,14.59L4.43,15.92L6.03,15.5L11.34,14.07L15.69,12.91L21,11.5C21.81,11.26 22.28,10.44 22.07,9.64Z' })
	  );
	};
	
	var AirplaneIcon = function AirplaneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,16V14L13,9V3.5C13,2.67 12.33,2 11.5,2C10.67,2 10,2.67 10,3.5V9L2,14V16L10,13.5V19L8,20.5V22L11.5,21L15,22V20.5L13,19V13.5L21,16Z' })
	  );
	};
	
	var AirplayIcon = function AirplayIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,22H18L12,16M21,3H3C1.9,3 1,3.9 1,5V17C1,18.1 1.9,19 3,19H7V17H3V5H21V17H17V19H21C22.1,19 23,18.1 23,17V5C23,3.9 22.1,3 21,3Z' })
	  );
	};
	
	var AirportIcon = function AirportIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.97,5.92C14.83,5.41 14.3,5.1 13.79,5.24L10.39,6.15L5.95,2.03L4.72,2.36L7.38,6.95L4.19,7.8L2.93,6.82L2,7.07L3.66,9.95L14.28,7.11C14.8,6.96 15.1,6.43 14.97,5.92M21,10L20,12H15L14,10L15,9H17V7H18V9H20L21,10M22,20V22H2V20H15V13H20V20H22Z' })
	  );
	};
	
	var AlarmBellIcon = function AlarmBellIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,18.66V22H5V18.66C8.09,20.45 11.91,20.45 15,18.66M22,4C22,2.9 21.1,2 20,2C19.69,2 19.39,2.07 19.12,2.21C18.82,2.36 18.56,2.58 18.36,2.85C17.72,3.75 17.94,5 18.85,5.64C19.18,5.87 19.59,6 20,6C20.08,6 20.16,6 20.24,6C21.97,10.43 20.66,15.46 17,18.5C16.68,18.75 16.35,19 16,19.22V21H17V19.74C20.14,17.5 22,13.86 22,10C22,8.5 21.72,7 21.17,5.62C21.69,5.24 22,4.64 22,4M18,10C18,14.42 14.42,18 10,18C5.58,18 2,14.42 2,10C2,5.58 5.58,2 10,2C14.42,2 18,5.58 18,10Z' })
	  );
	};
	
	var AlarmCheckIcon = function AlarmCheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.54,14.53L8.41,12.4L7.35,13.46L10.53,16.64L16.53,10.64L15.47,9.58L10.54,14.53M12,20C8.13,20 5,16.87 5,13C5,9.13 8.13,6 12,6C15.87,6 19,9.13 19,13C19,16.87 15.87,20 12,20M12,4C7.03,4 3,8.03 3,13C3,17.97 7.03,22 12,22C16.97,22 21,17.97 21,13C21,8.03 16.97,4 12,4M7.88,3.39L6.6,1.86L2,5.71L3.29,7.24L7.88,3.39M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25L22,5.72Z' })
	  );
	};
	
	var AlarmLightIcon = function AlarmLightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,6.9L3.87,4.78L5.28,3.37L7.4,5.5L6,6.9M13,1V4H11V1H13M20.13,4.78L18,6.9L16.6,5.5L18.72,3.37L20.13,4.78M4.5,10.5V12.5H1.5V10.5H4.5M19.5,10.5H22.5V12.5H19.5V10.5M6,20H18C19.1,20 20,20.9 20,22H4C4,20.9 4.9,20 6,20M12,5C15.31,5 18,7.69 18,11V19H6V11C6,7.69 8.69,5 12,5Z' })
	  );
	};
	
	var AlarmMultipleIcon = function AlarmMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.29,3.25L5.16,6.72L4,5.34L8.14,1.87L9.29,3.25M22,5.35L20.84,6.73L16.7,3.25L17.86,1.87L22,5.35M13,4C17.42,4 21,7.58 21,12C21,16.42 17.42,20 13,20C8.58,20 5,16.42 5,12C5,7.58 8.58,4 13,4M13,6C9.69,6 7,8.69 7,12C7,15.31 9.69,18 13,18C16.31,18 19,15.31 19,12C19,8.69 16.31,6 13,6M12,7.5H13.5V12.03L16.72,13.5L16.1,14.86L12,13V7.5M1,14C1,11.5 2.13,9.3 3.91,7.83C3.33,9.1 3,10.5 3,12L3.06,13.13L3,14C3,16.28 4.27,18.26 6.14,19.28C7.44,20.5 9.07,21.39 10.89,21.78C10.28,21.92 9.65,22 9,22C4.58,22 1,18.42 1,14Z' })
	  );
	};
	
	var AlarmOffIcon = function AlarmOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,3.28L6.6,1.86L5.74,2.57L7.16,4M16.47,18.39C15.26,19.39 13.7,20 12,20C8.13,20 5,16.87 5,13C5,11.3 5.61,9.74 6.61,8.53M2.92,2.29L1.65,3.57L3,4.9L1.87,5.83L3.29,7.25L4.4,6.31L5.2,7.11C3.83,8.69 3,10.75 3,13C3,17.97 7.03,22 12,22C14.25,22 16.31,21.17 17.89,19.8L20.09,22L21.36,20.73L3.89,3.27L2.92,2.29M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25L22,5.72M12,6C15.87,6 19,9.13 19,13C19,13.84 18.84,14.65 18.57,15.4L20.09,16.92C20.67,15.73 21,14.41 21,13C21,8.03 16.97,4 12,4C10.59,4 9.27,4.33 8.08,4.91L9.6,6.43C10.35,6.16 11.16,6 12,6Z' })
	  );
	};
	
	var AlarmPlusIcon = function AlarmPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H11V12H8V14H11V17H13V14H16V12H13M12,20C8.13,20 5,16.87 5,13C5,9.13 8.13,6 12,6C15.87,6 19,9.13 19,13C19,16.87 15.87,20 12,20M12,4C7.03,4 3,8.03 3,13C3,17.97 7.03,22 12,22C16.97,22 21,17.97 21,13C21,8.03 16.97,4 12,4M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25M7.88,3.39L6.6,1.86L2,5.71L3.29,7.24L7.88,3.39Z' })
	  );
	};
	
	var AlarmSnoozeIcon = function AlarmSnoozeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.88,3.39L6.6,1.86L2,5.71L3.29,7.24L7.88,3.39M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25L22,5.72M12,4C7.03,4 3,8.03 3,13C3,17.97 7.03,22 12,22C16.97,22 21,17.97 21,13C21,8.03 16.97,4 12,4M12,20C8.13,20 5,16.87 5,13C5,9.13 8.13,6 12,6C15.87,6 19,9.13 19,13C19,16.87 15.87,20 12,20M9,11H12.63L9,15.2V17H15V15H11.37L15,10.8V9H9V11Z' })
	  );
	};
	
	var AlarmIcon = function AlarmIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C8.13,20 5,16.87 5,13C5,9.13 8.13,6 12,6C15.87,6 19,9.13 19,13C19,16.87 15.87,20 12,20M12,4C7.03,4 3,8.03 3,13C3,17.97 7.03,22 12,22C16.97,22 21,17.97 21,13C21,8.03 16.97,4 12,4M12.5,8H11V14L15.75,16.85L16.5,15.62L12.5,13.25V8M7.88,3.39L6.6,1.86L2,5.71L3.29,7.24L7.88,3.39M22,5.72L17.4,1.86L16.11,3.39L20.71,7.25L22,5.72Z' })
	  );
	};
	
	var AlbumIcon = function AlbumIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,11C11.45,11 11,11.45 11,12C11,12.55 11.45,13 12,13C12.55,13 13,12.55 13,12C13,11.45 12.55,11 12,11M12,16.5C9.5,16.5 7.5,14.5 7.5,12C7.5,9.5 9.5,7.5 12,7.5C14.5,7.5 16.5,9.5 16.5,12C16.5,14.5 14.5,16.5 12,16.5M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var AlertBoxIcon = function AlertBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M13,13V7H11V13H13M13,17V15H11V17H13Z' })
	  );
	};
	
	var AlertCircleOutlineIcon = function AlertCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20Z' })
	  );
	};
	
	var AlertCircleIcon = function AlertCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,13H11V7H13M13,17H11V15H13M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var AlertDecagramIcon = function AlertDecagramIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M13,17H11V15H13V17M13,13H11V7H13V13Z' })
	  );
	};
	
	var AlertOctagonIcon = function AlertOctagonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,13H11V7H13M12,17.3C11.28,17.3 10.7,16.72 10.7,16C10.7,15.28 11.28,14.7 12,14.7C12.72,14.7 13.3,15.28 13.3,16C13.3,16.72 12.72,17.3 12,17.3M15.73,3H8.27L3,8.27V15.73L8.27,21H15.73L21,15.73V8.27L15.73,3Z' })
	  );
	};
	
	var AlertOctagramIcon = function AlertOctagramIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.2,16.06L3.88,12L2.2,7.94L6.26,6.26L7.94,2.2L12,3.88L16.06,2.2L17.74,6.26L21.8,7.94L20.12,12L21.8,16.06L17.74,17.74L16.06,21.8L12,20.12L7.94,21.8L6.26,17.74L2.2,16.06M13,17V15H11V17H13M13,13V7H11V13H13Z' })
	  );
	};
	
	var AlertOutlineIcon = function AlertOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16' })
	  );
	};
	
	var AlertIcon = function AlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z' })
	  );
	};
	
	var AlienIcon = function AlienIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C16.97,3 21,6.58 21,11C21,15.42 15,21 12,21C9,21 3,15.42 3,11C3,6.58 7.03,3 12,3M10.31,10.93C9.29,9.29 7.47,8.58 6.25,9.34C5.03,10.1 4.87,12.05 5.89,13.69C6.92,15.33 8.74,16.04 9.96,15.28C11.18,14.5 11.33,12.57 10.31,10.93M13.69,10.93C12.67,12.57 12.82,14.5 14.04,15.28C15.26,16.04 17.08,15.33 18.11,13.69C19.13,12.05 18.97,10.1 17.75,9.34C16.53,8.58 14.71,9.29 13.69,10.93M12,17.75C10,17.75 9.5,17 9.5,17C9.5,17.03 10,19 12,19C14,19 14.5,17 14.5,17C14.5,17 14,17.75 12,17.75Z' })
	  );
	};
	
	var AllInclusiveIcon = function AllInclusiveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.6,6.62C17.16,6.62 15.8,7.18 14.83,8.15L7.8,14.39C7.16,15.03 6.31,15.38 5.4,15.38C3.53,15.38 2,13.87 2,12C2,10.13 3.53,8.62 5.4,8.62C6.31,8.62 7.16,8.97 7.84,9.65L8.97,10.65L10.5,9.31L9.22,8.2C8.2,7.18 6.84,6.62 5.4,6.62C2.42,6.62 0,9.04 0,12C0,14.96 2.42,17.38 5.4,17.38C6.84,17.38 8.2,16.82 9.17,15.85L16.2,9.61C16.84,8.97 17.69,8.62 18.6,8.62C20.47,8.62 22,10.13 22,12C22,13.87 20.47,15.38 18.6,15.38C17.7,15.38 16.84,15.03 16.16,14.35L15,13.34L13.5,14.68L14.78,15.8C15.8,16.81 17.15,17.37 18.6,17.37C21.58,17.37 24,14.96 24,12C24,9 21.58,6.62 18.6,6.62Z' })
	  );
	};
	
	var AlphaIcon = function AlphaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.08,17.8C17.62,17.93 17.21,18 16.85,18C15.65,18 14.84,17.12 14.43,15.35H14.38C13.39,17.26 12,18.21 10.25,18.21C8.94,18.21 7.89,17.72 7.1,16.73C6.31,15.74 5.92,14.5 5.92,13C5.92,11.25 6.37,9.85 7.26,8.76C8.15,7.67 9.36,7.12 10.89,7.12C11.71,7.12 12.45,7.35 13.09,7.8C13.73,8.26 14.22,8.9 14.56,9.73H14.6L15.31,7.33H17.87L15.73,12.65C15.97,13.89 16.22,14.74 16.5,15.19C16.74,15.64 17.08,15.87 17.5,15.87C17.74,15.87 17.93,15.83 18.1,15.76L18.08,17.8M13.82,12.56C13.61,11.43 13.27,10.55 12.81,9.95C12.36,9.34 11.81,9.04 11.18,9.04C10.36,9.04 9.7,9.41 9.21,10.14C8.72,10.88 8.5,11.79 8.5,12.86C8.5,13.84 8.69,14.65 9.12,15.31C9.54,15.97 10.11,16.29 10.82,16.29C11.42,16.29 11.97,16 12.46,15.45C12.96,14.88 13.37,14.05 13.7,12.96L13.82,12.56Z' })
	  );
	};
	
	var AlphabeticalIcon = function AlphabeticalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,11C7.1,11 8,11.9 8,13V17H4C2.9,17 2,16.1 2,15V13C2,11.9 2.9,11 4,11H6M4,13V15H6V13H4M20,13V15H22V17H20C18.9,17 18,16.1 18,15V13C18,11.9 18.9,11 20,11H22V13H20M12,7V11H14C15.1,11 16,11.9 16,13V15C16,16.1 15.1,17 14,17H12C10.9,17 10,16.1 10,15V7H12M12,15H14V13H12V15Z' })
	  );
	};
	
	var AltimeterIcon = function AltimeterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,3V5H17V3H7M9,7V9H15V7H9M2,7.96V16.04L6.03,12L2,7.96M22.03,7.96L18,12L22.03,16.04V7.96M7,11V13H17V11H7M9,15V17H15V15H9M7,19V21H17V19H7Z' })
	  );
	};
	
	var AmazonAlexaIcon = function AmazonAlexaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M10.43,21.87V19.91C10.43,19.22 10,18.57 9.35,18.3C6.91,17.26 5.17,14.83 5.17,12C5.17,8.26 8.22,5.17 12,5.17C15.78,5.17 18.83,8.26 18.83,12C18.83,16.43 15.39,20.61 10.43,21.87Z' })
	  );
	};
	
	var AmazonDriveIcon = function AmazonDriveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.94,11.12C5.23,11.12 5.5,11.16 5.76,11.23C5.77,9.09 7.5,7.35 9.65,7.35C11.27,7.35 12.67,8.35 13.24,9.77C13.83,9 14.74,8.53 15.76,8.53C17.5,8.53 18.94,9.95 18.94,11.71C18.94,11.95 18.91,12.2 18.86,12.43C19.1,12.34 19.37,12.29 19.65,12.29C20.95,12.29 22,13.35 22,14.65C22,15.95 20.95,17 19.65,17C18.35,17 6.36,17 4.94,17C3.32,17 2,15.68 2,14.06C2,12.43 3.32,11.12 4.94,11.12Z' })
	  );
	};
	
	var AmazonIcon = function AmazonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.93,17.09C15.75,17.25 15.5,17.26 15.3,17.15C14.41,16.41 14.25,16.07 13.76,15.36C12.29,16.86 11.25,17.31 9.34,17.31C7.09,17.31 5.33,15.92 5.33,13.14C5.33,10.96 6.5,9.5 8.19,8.76C9.65,8.12 11.68,8 13.23,7.83V7.5C13.23,6.84 13.28,6.09 12.9,5.54C12.58,5.05 11.95,4.84 11.4,4.84C10.38,4.84 9.47,5.37 9.25,6.45C9.2,6.69 9,6.93 8.78,6.94L6.18,6.66C5.96,6.61 5.72,6.44 5.78,6.1C6.38,2.95 9.23,2 11.78,2C13.08,2 14.78,2.35 15.81,3.33C17.11,4.55 17,6.18 17,7.95V12.12C17,13.37 17.5,13.93 18,14.6C18.17,14.85 18.21,15.14 18,15.31L15.94,17.09H15.93M13.23,10.56V10C11.29,10 9.24,10.39 9.24,12.67C9.24,13.83 9.85,14.62 10.87,14.62C11.63,14.62 12.3,14.15 12.73,13.4C13.25,12.47 13.23,11.6 13.23,10.56M20.16,19.54C18,21.14 14.82,22 12.1,22C8.29,22 4.85,20.59 2.25,18.24C2.05,18.06 2.23,17.81 2.5,17.95C5.28,19.58 8.75,20.56 12.33,20.56C14.74,20.56 17.4,20.06 19.84,19.03C20.21,18.87 20.5,19.27 20.16,19.54M21.07,18.5C20.79,18.14 19.22,18.33 18.5,18.42C18.31,18.44 18.28,18.26 18.47,18.12C19.71,17.24 21.76,17.5 22,17.79C22.24,18.09 21.93,20.14 20.76,21.11C20.58,21.27 20.41,21.18 20.5,21C20.76,20.33 21.35,18.86 21.07,18.5Z' })
	  );
	};
	
	var AmbulanceIcon = function AmbulanceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,18.5C18.83,18.5 19.5,17.83 19.5,17C19.5,16.17 18.83,15.5 18,15.5C17.17,15.5 16.5,16.17 16.5,17C16.5,17.83 17.17,18.5 18,18.5M19.5,9.5H17V12H21.46L19.5,9.5M6,18.5C6.83,18.5 7.5,17.83 7.5,17C7.5,16.17 6.83,15.5 6,15.5C5.17,15.5 4.5,16.17 4.5,17C4.5,17.83 5.17,18.5 6,18.5M20,8L23,12V17H21C21,18.66 19.66,20 18,20C16.34,20 15,18.66 15,17H9C9,18.66 7.66,20 6,20C4.34,20 3,18.66 3,17H1V6C1,4.89 1.89,4 3,4H17V8H20M8,6V9H5V11H8V14H10V11H13V9H10V6H8Z' })
	  );
	};
	
	var AmplifierIcon = function AmplifierIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,2H14C14.55,2 15,2.45 15,3H21V21H19C19,21.55 18.55,22 18,22C17.45,22 17,21.55 17,21H7C7,21.55 6.55,22 6,22C5.45,22 5,21.55 5,21H3V3H9C9,2.45 9.45,2 10,2M5,5V9H19V5H5M7,6C7.55,6 8,6.45 8,7C8,7.55 7.55,8 7,8C6.45,8 6,7.55 6,7C6,6.45 6.45,6 7,6M12,6H14V7H12V6M15,6H16V8H15V6M17,6H18V8H17V6M12,11C9.79,11 8,12.79 8,15C8,17.21 9.79,19 12,19C14.21,19 16,17.21 16,15C16,12.79 14.21,11 12,11M10,6C10.55,6 11,6.45 11,7C11,7.55 10.55,8 10,8C9.45,8 9,7.55 9,7C9,6.45 9.45,6 10,6Z' })
	  );
	};
	
	var AnchorIcon = function AnchorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C10.34,2 9,3.34 9,5C9,6.27 9.8,7.4 11,7.83V10H8V12H11V18.92C9.16,18.63 7.53,17.57 6.53,16H8V14H3V19H5V17.3C6.58,19.61 9.2,21 12,21C14.8,21 17.42,19.61 19,17.31V19H21V14H16V16H17.46C16.46,17.56 14.83,18.63 13,18.92V12H16V10H13V7.82C14.2,7.4 15,6.27 15,5C15,3.34 13.66,2 12,2M12,4C12.55,4 13,4.45 13,5C13,5.55 12.55,6 12,6C11.45,6 11,5.55 11,5C11,4.45 11.45,4 12,4Z' })
	  );
	};
	
	var AndroidDebugBridgeIcon = function AndroidDebugBridgeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,9C14.45,9 14,8.55 14,8C14,7.45 14.45,7 15,7C15.55,7 16,7.45 16,8C16,8.55 15.55,9 15,9M9,9C8.45,9 8,8.55 8,8C8,7.45 8.45,7 9,7C9.55,7 10,7.45 10,8C10,8.55 9.55,9 9,9M16.12,4.37L18.22,2.27L17.4,1.44L15.09,3.75C14.16,3.28 13.11,3 12,3C10.88,3 9.84,3.28 8.91,3.75L6.6,1.44L5.78,2.27L7.88,4.37C6.14,5.64 5,7.68 5,10V11H19V10C19,7.68 17.86,5.64 16.12,4.37M5,16C5,19.86 8.13,23 12,23C15.87,23 19,19.87 19,16V12H5V16Z' })
	  );
	};
	
	var AndroidHeadIcon = function AndroidHeadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,11.5C7.31,11.5 6.75,12.06 6.75,12.75C6.75,13.44 7.31,14 8,14C8.69,14 9.25,13.44 9.25,12.75C9.25,12.06 8.69,11.5 8,11.5M16,11.5C15.31,11.5 14.75,12.06 14.75,12.75C14.75,13.44 15.31,14 16,14C16.69,14 17.25,13.44 17.25,12.75C17.25,12.06 16.69,11.5 16,11.5M12,7C13.5,7 14.9,7.33 16.18,7.91L18.34,5.75C18.73,5.36 19.36,5.36 19.75,5.75C20.14,6.14 20.14,6.77 19.75,7.16L17.95,8.96C20.41,10.79 22,13.71 22,17H2C2,13.71 3.59,10.79 6.05,8.96L4.25,7.16C3.86,6.77 3.86,6.14 4.25,5.75C4.64,5.36 5.27,5.36 5.66,5.75L7.82,7.91C9.1,7.33 10.5,7 12,7Z' })
	  );
	};
	
	var AndroidStudioIcon = function AndroidStudioIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,2H13V4H13.5C14.33,4 15,4.67 15,5.5V9L14.56,9.44L16.2,12.28C17.31,11.19 18,9.68 18,8H20C20,10.42 18.93,12.59 17.23,14.06L20.37,19.5L20.5,21.72L18.63,20.5L15.56,15.17C14.5,15.7 13.28,16 12,16C10.72,16 9.5,15.7 8.44,15.17L5.37,20.5L3.5,21.72L3.63,19.5L9.44,9.44L9,9V5.5C9,4.67 9.67,4 10.5,4H11V2M9.44,13.43C10.22,13.8 11.09,14 12,14C12.91,14 13.78,13.8 14.56,13.43L13.1,10.9H13.09C12.47,11.5 11.53,11.5 10.91,10.9H10.9L9.44,13.43M12,6C11.45,6 11,6.45 11,7C11,7.55 11.45,8 12,8C12.55,8 13,7.55 13,7C13,6.45 12.55,6 12,6Z' })
	  );
	};
	
	var AndroidIcon = function AndroidIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,5H14V4H15M10,5H9V4H10M15.53,2.16L16.84,0.85C17.03,0.66 17.03,0.34 16.84,0.14C16.64,-0.05 16.32,-0.05 16.13,0.14L14.65,1.62C13.85,1.23 12.95,1 12,1C11.04,1 10.14,1.23 9.34,1.63L7.85,0.14C7.66,-0.05 7.34,-0.05 7.15,0.14C6.95,0.34 6.95,0.66 7.15,0.85L8.46,2.16C6.97,3.26 6,5 6,7H18C18,5 17,3.25 15.53,2.16M20.5,8C19.67,8 19,8.67 19,9.5V16.5C19,17.33 19.67,18 20.5,18C21.33,18 22,17.33 22,16.5V9.5C22,8.67 21.33,8 20.5,8M3.5,8C2.67,8 2,8.67 2,9.5V16.5C2,17.33 2.67,18 3.5,18C4.33,18 5,17.33 5,16.5V9.5C5,8.67 4.33,8 3.5,8M6,18C6,18.55 6.45,19 7,19H8V22.5C8,23.33 8.67,24 9.5,24C10.33,24 11,23.33 11,22.5V19H13V22.5C13,23.33 13.67,24 14.5,24C15.33,24 16,23.33 16,22.5V19H17C17.55,19 18,18.55 18,18V8H6V18Z' })
	  );
	};
	
	var AngleAcuteIcon = function AngleAcuteIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,19H4.09L14.18,4.43L15.82,5.57L11.28,12.13C12.89,12.96 14,14.62 14,16.54C14,16.7 14,16.85 13.97,17H20V19M7.91,17H11.96C12,16.85 12,16.7 12,16.54C12,15.28 11.24,14.22 10.14,13.78L7.91,17Z' })
	  );
	};
	
	var AngleObtuseIcon = function AngleObtuseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,19H9.31L4.07,5.36L5.93,4.64L8.96,12.5C9.5,12.29 10.09,12.17 10.71,12.17V12.17C13.38,12.17 15.56,14.34 15.58,17H21V19M10.69,17H13.58C13.56,15.42 12.3,14.17 10.71,14.17C10.34,14.17 10,14.24 9.67,14.36L10.69,17Z' })
	  );
	};
	
	var AngleRightIcon = function AngleRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,4H7V11H13V17H20V19H5V4M7,17H11V13H7V17Z' })
	  );
	};
	
	var AngularIcon = function AngularIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2.5L20.84,5.65L19.5,17.35L12,21.5L4.5,17.35L3.16,5.65L12,2.5M12,4.6L6.47,17H8.53L9.64,14.22H14.34L15.45,17H17.5L12,4.6M13.62,12.5H10.39L12,8.63L13.62,12.5Z' })
	  );
	};
	
	var AngularjsIcon = function AngularjsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2.5L20.84,5.65L19.5,17.35L12,21.5L4.5,17.35L3.16,5.65L12,2.5M12,4.5L5,7L6.08,16.22L12,19.5L17.92,16.22L19,7L12,4.5M12,5.72L16.58,16H14.87L13.94,13.72H10.04L9.12,16H7.41L12,5.72M13.34,12.3L12,9.07L10.66,12.3H13.34Z' })
	  );
	};
	
	var AnimationPlayIcon = function AnimationPlayIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H14V4H4V14H2V4C2,2.89 2.89,2 4,2M8,6H18V8H8V18H6V8C6,6.89 6.89,6 8,6M12,10H20C21.11,10 22,10.89 22,12V20C22,21.11 21.11,22 20,22H12C10.89,22 10,21.11 10,20V12C10,10.89 10.89,10 12,10M14,12V20L20,16L14,12Z' })
	  );
	};
	
	var AnimationIcon = function AnimationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2C2.89,2 2,2.89 2,4V14H4V4H14V2H4M8,6C6.89,6 6,6.89 6,8V18H8V8H18V6H8M12,10C10.89,10 10,10.89 10,12V20C10,21.11 10.89,22 12,22H20C21.11,22 22,21.11 22,20V12C22,10.89 21.11,10 20,10H12Z' })
	  );
	};
	
	var AnvilIcon = function AnvilIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,5V10C13.03,12.47 8.44,14.97 6,16V19H21V16C14.59,13.27 17.47,9 22,8V5H9M2,6C2.81,8.13 4.42,9.5 7,10V6H2Z' })
	  );
	};
	
	var AppleFinderIcon = function AppleFinderIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H11.89C12.46,2.91 13.13,1.88 13.93,1L15.04,2.11C14.61,2.7 14.23,3.34 13.89,4H20C21.1,4 22,4.9 22,6V19C22,20.1 21.1,21 20,21H14.93L15.26,22.23L13.43,22.95L12.93,21H4C2.9,21 2,20.1 2,19V6C2,4.9 2.9,4 4,4M4,6V19H12.54C12.5,18.67 12.44,18.34 12.4,18C12.27,18 12.13,18 12,18C9.25,18 6.78,17.5 5.13,16.76L6.04,15.12C7,15.64 9.17,16 12,16C12.08,16 12.16,16 12.24,16C12.21,15.33 12.22,14.66 12.27,14H9C9,14 9.4,9.97 11,6H4M20,19V6H13C12.1,8.22 11.58,10.46 11.3,12H14.17C14,13.28 13.97,14.62 14.06,15.93C15.87,15.8 17.25,15.5 17.96,15.12L18.87,16.76C17.69,17.3 16.1,17.7 14.29,17.89C14.35,18.27 14.41,18.64 14.5,19H20M6,8H8V11H6V8M16,8H18V11H16V8Z' })
	  );
	};
	
	var AppleIcloudIcon = function AppleIcloudIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,15.04C22,17.23 20.24,19 18.07,19H5.93C3.76,19 2,17.23 2,15.04C2,13.07 3.43,11.44 5.31,11.14C5.28,11 5.27,10.86 5.27,10.71C5.27,9.33 6.38,8.2 7.76,8.2C8.37,8.2 8.94,8.43 9.37,8.8C10.14,7.05 11.13,5.44 13.91,5.44C17.28,5.44 18.87,8.06 18.87,10.83C18.87,10.94 18.87,11.06 18.86,11.17C20.65,11.54 22,13.13 22,15.04Z' })
	  );
	};
	
	var AppleIosIcon = function AppleIosIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,9V7H16C14.9,7 14,7.9 14,9V11C14,12.1 14.9,13 16,13H18V15H14V17H18C19.1,17 20,16.1 20,15V13C20,11.9 19.1,11 18,11H16V9M11,15H9V9H11M11,7H9C7.9,7 7,7.9 7,9V15C7,16.1 7.9,17 9,17H11C12.1,17 13,16.1 13,15V9C13,7.9 12.1,7 11,7M4,17H6V11H4M4,9H6V7H4V9Z' })
	  );
	};
	
	var AppleKeyboardCapsIcon = function AppleKeyboardCapsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,14V8H17.17L12,2.83L6.83,8H9V14H15M12,0L22,10H17V16H7V10H2L12,0M7,18H17V24H7V18M15,20H9V22H15V20Z' })
	  );
	};
	
	var AppleKeyboardCommandIcon = function AppleKeyboardCommandIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2C8.21,2 10,3.79 10,6V8H14V6C14,3.79 15.79,2 18,2C20.21,2 22,3.79 22,6C22,8.21 20.21,10 18,10H16V14H18C20.21,14 22,15.79 22,18C22,20.21 20.21,22 18,22C15.79,22 14,20.21 14,18V16H10V18C10,20.21 8.21,22 6,22C3.79,22 2,20.21 2,18C2,15.79 3.79,14 6,14H8V10H6C3.79,10 2,8.21 2,6C2,3.79 3.79,2 6,2M16,18C16,19.1 16.9,20 18,20C19.1,20 20,19.1 20,18C20,16.9 19.1,16 18,16H16V18M14,10H10V14H14V10M6,16C4.9,16 4,16.9 4,18C4,19.1 4.9,20 6,20C7.1,20 8,19.1 8,18V16H6M8,6C8,4.9 7.1,4 6,4C4.9,4 4,4.9 4,6C4,7.1 4.9,8 6,8H8V6M18,8C19.1,8 20,7.1 20,6C20,4.9 19.1,4 18,4C16.9,4 16,4.9 16,6V8H18Z' })
	  );
	};
	
	var AppleKeyboardControlIcon = function AppleKeyboardControlIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.78,11.78L18.36,13.19L12,6.83L5.64,13.19L4.22,11.78L12,4L19.78,11.78Z' })
	  );
	};
	
	var AppleKeyboardOptionIcon = function AppleKeyboardOptionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4H9.11L16.15,18H21V20H14.88L7.84,6H3V4M14,4H21V6H14V4Z' })
	  );
	};
	
	var AppleKeyboardShiftIcon = function AppleKeyboardShiftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,18V12H17.17L12,6.83L6.83,12H9V18H15M12,4L22,14H17V20H7V14H2L12,4Z' })
	  );
	};
	
	var AppleSafariIcon = function AppleSafariIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,14.09 4.8,16 6.11,17.41L9.88,9.88L17.41,6.11C16,4.8 14.09,4 12,4M12,20C16.42,20 20,16.42 20,12C20,9.91 19.2,8 17.89,6.59L14.12,14.12L6.59,17.89C8,19.2 9.91,20 12,20M12,12L11.23,11.23L9.7,14.3L12.77,12.77L12,12M12,17.5H13V19H12V17.5M15.88,15.89L16.59,15.18L17.65,16.24L16.94,16.95L15.88,15.89M17.5,12V11H19V12H17.5M12,6.5H11V5H12V6.5M8.12,8.11L7.41,8.82L6.35,7.76L7.06,7.05L8.12,8.11M6.5,12V13H5V12H6.5Z' })
	  );
	};
	
	var AppleIcon = function AppleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z' })
	  );
	};
	
	var ApplicationIcon = function ApplicationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,4C20.11,4 21,4.9 21,6V18C21,19.1 20.1,20 19,20H5C3.89,20 3,19.1 3,18V6C3,4.9 3.9,4 5,4H19M19,18V8H5V18H19Z' })
	  );
	};
	
	var ApprovalIcon = function ApprovalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9L10,17Z' })
	  );
	};
	
	var AppsIcon = function AppsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,20H20V16H16M16,14H20V10H16M10,8H14V4H10M16,8H20V4H16M10,14H14V10H10M4,14H8V10H4M4,20H8V16H4M10,20H14V16H10M4,8H8V4H4V8Z' })
	  );
	};
	
	var ArchIcon = function ArchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C11.11,4.18 10.57,5.61 9.58,7.73C10.19,8.37 10.93,9.12 12.14,9.97C10.84,9.43 9.95,8.9 9.29,8.34C8,11 6.03,14.75 2,22C5.17,20.17 7.63,19.04 9.92,18.61C9.82,18.19 9.76,17.73 9.77,17.25V17.15C9.82,15.12 10.88,13.56 12.13,13.67C13.38,13.77 14.35,15.5 14.3,17.54C14.29,17.92 14.25,18.29 14.18,18.63C16.44,19.07 18.87,20.19 22,22C21.38,20.86 20.83,19.84 20.31,18.87C19.5,18.23 18.61,17.39 16.85,16.5C18.06,16.8 18.93,17.16 19.61,17.57C14.26,7.62 13.83,6.3 12,2Z' })
	  );
	};
	
	var ArchiveIcon = function ArchiveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3H21V7H3V3M4,8H20V21H4V8M9.5,11C9.22,11 9,11.22 9,11.5V13H15V11.5C15,11.22 14.78,11 14.5,11H9.5Z' })
	  );
	};
	
	var ArrangeBringForwardIcon = function ArrangeBringForwardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,2H16V16H2V2M22,8V22H8V18H10V20H20V10H18V8H22Z' })
	  );
	};
	
	var ArrangeBringToFrontIcon = function ArrangeBringToFrontIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,2H11V6H9V4H4V9H6V11H2V2M22,13V22H13V18H15V20H20V15H18V13H22M8,8H16V16H8V8Z' })
	  );
	};
	
	var ArrangeSendBackwardIcon = function ArrangeSendBackwardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,2H16V16H2V2M22,8V22H8V18H18V8H22M4,4V14H14V4H4Z' })
	  );
	};
	
	var ArrangeSendToBackIcon = function ArrangeSendToBackIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,2H11V11H2V2M9,4H4V9H9V4M22,13V22H13V13H22M15,20H20V15H15V20M16,8V11H13V8H16M11,16H8V13H11V16Z' })
	  );
	};
	
	var ArrowAllIcon = function ArrowAllIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,11H18L16.5,9.5L17.92,8.08L21.84,12L17.92,15.92L16.5,14.5L18,13H13V18L14.5,16.5L15.92,17.92L12,21.84L8.08,17.92L9.5,16.5L11,18V13H6L7.5,14.5L6.08,15.92L2.16,12L6.08,8.08L7.5,9.5L6,11H11V6L9.5,7.5L8.08,6.08L12,2.16L15.92,6.08L14.5,7.5L13,6V11Z' })
	  );
	};
	
	var ArrowBottomLeftIcon = function ArrowBottomLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z' })
	  );
	};
	
	var ArrowBottomRightIcon = function ArrowBottomRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,6.41L6.41,5L17,15.59V9H19V19H9V17H15.59L5,6.41Z' })
	  );
	};
	
	var ArrowCollapseAllIcon = function ArrowCollapseAllIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.5,3.09L20.91,4.5L16.41,9H20V11H13V4H15V7.59L19.5,3.09M20.91,19.5L19.5,20.91L15,16.41V20H13V13H20V15H16.41L20.91,19.5M4.5,3.09L9,7.59V4H11V11H4V9H7.59L3.09,4.5L4.5,3.09M3.09,19.5L7.59,15H4V13H11V20H9V16.41L4.5,20.91L3.09,19.5Z' })
	  );
	};
	
	var ArrowCollapseDownIcon = function ArrowCollapseDownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.92,12.08L12,20L4.08,12.08L5.5,10.67L11,16.17V2H13V16.17L18.5,10.66L19.92,12.08M12,20H2V22H22V20H12Z' })
	  );
	};
	
	var ArrowCollapseHorizontalIcon = function ArrowCollapseHorizontalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,20V4H15.03V20H13M10,20V4H12.03V20H10M5,8L9.03,12L5,16V13H2V11H5V8M20,16L16,12L20,8V11H23V13H20V16Z' })
	  );
	};
	
	var ArrowCollapseLeftIcon = function ArrowCollapseLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.92,19.92L4,12L11.92,4.08L13.33,5.5L7.83,11H22V13H7.83L13.34,18.5L11.92,19.92M4,12V2H2V22H4V12Z' })
	  );
	};
	
	var ArrowCollapseRightIcon = function ArrowCollapseRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.08,4.08L20,12L12.08,19.92L10.67,18.5L16.17,13H2V11H16.17L10.67,5.5L12.08,4.08M20,12V22H22V2H20V12Z' })
	  );
	};
	
	var ArrowCollapseUpIcon = function ArrowCollapseUpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.08,11.92L12,4L19.92,11.92L18.5,13.33L13,7.83V22H11V7.83L5.5,13.33L4.08,11.92M12,4H22V2H2V4H12Z' })
	  );
	};
	
	var ArrowCollapseVerticalIcon = function ArrowCollapseVerticalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,12H20V14H4V12M4,9H20V11H4V9M16,4L12,8L8,4H11V1H13V4H16M8,19L12,15L16,19H13V22H11V19H8Z' })
	  );
	};
	
	var ArrowCollapseIcon = function ArrowCollapseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.5,3.09L15,7.59V4H13V11H20V9H16.41L20.91,4.5L19.5,3.09M4,13V15H7.59L3.09,19.5L4.5,20.91L9,16.41V20H11V13H4Z' })
	  );
	};
	
	var ArrowDownBoldBoxOutlineIcon = function ArrowDownBoldBoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,17L7,12H10V8H14V12H17L12,17M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M5,5V19H19V5H5Z' })
	  );
	};
	
	var ArrowDownBoldBoxIcon = function ArrowDownBoldBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M12,17L17,12H14V8H10V12H7L12,17Z' })
	  );
	};
	
	var ArrowDownBoldCircleOutlineIcon = function ArrowDownBoldCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,17L7,12H10V8H14V12H17L12,17M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4Z' })
	  );
	};
	
	var ArrowDownBoldCircleIcon = function ArrowDownBoldCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,17L17,12H14V8H10V12H7L12,17Z' })
	  );
	};
	
	var ArrowDownBoldHexagonOutlineIcon = function ArrowDownBoldHexagonOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,17L7,12H10V8H14V12H17L12,17M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z' })
	  );
	};
	
	var ArrowDownBoldIcon = function ArrowDownBoldIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,4H15V12H19.84L12,19.84L4.16,12H9V4Z' })
	  );
	};
	
	var ArrowDownBoxIcon = function ArrowDownBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5M11,6V14.5L7.5,11L6.08,12.42L12,18.34L17.92,12.42L16.5,11L13,14.5V6H11Z' })
	  );
	};
	
	var ArrowDownDropCircleOutlineIcon = function ArrowDownDropCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4M7,10L12,15L17,10H7Z' })
	  );
	};
	
	var ArrowDownDropCircleIcon = function ArrowDownDropCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M7,10L12,15L17,10H7Z' })
	  );
	};
	
	var ArrowDownThickIcon = function ArrowDownThickIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,4H14V13L17.5,9.5L19.92,11.92L12,19.84L4.08,11.92L6.5,9.5L10,13V4Z' })
	  );
	};
	
	var ArrowDownIcon = function ArrowDownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z' })
	  );
	};
	
	var ArrowExpandAllIcon = function ArrowExpandAllIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.5,13.09L10.91,14.5L6.41,19H10V21H3V14H5V17.59L9.5,13.09M10.91,9.5L9.5,10.91L5,6.41V10H3V3H10V5H6.41L10.91,9.5M14.5,13.09L19,17.59V14H21V21H14V19H17.59L13.09,14.5L14.5,13.09M13.09,9.5L17.59,5H14V3H21V10H19V6.41L14.5,10.91L13.09,9.5Z' })
	  );
	};
	
	var ArrowExpandDownIcon = function ArrowExpandDownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,4V2H2V4H11V18.17L5.5,12.67L4.08,14.08L12,22L19.92,14.08L18.5,12.67L13,18.17V4H22Z' })
	  );
	};
	
	var ArrowExpandHorizontalIcon = function ArrowExpandHorizontalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,11H15V8L19,12L15,16V13H9V16L5,12L9,8V11M2,20V4H4V20H2M20,20V4H22V20H20Z' })
	  );
	};
	
	var ArrowExpandLeftIcon = function ArrowExpandLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,22H22V2H20V11H5.83L11.33,5.5L9.92,4.08L2,12L9.92,19.92L11.33,18.5L5.83,13H20V22Z' })
	  );
	};
	
	var ArrowExpandRightIcon = function ArrowExpandRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H2V22H4V13H18.17L12.67,18.5L14.08,19.92L22,12L14.08,4.08L12.67,5.5L18.17,11H4V2Z' })
	  );
	};
	
	var ArrowExpandUpIcon = function ArrowExpandUpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,20V22H22V20H13V5.83L18.5,11.33L19.92,9.92L12,2L4.08,9.92L5.5,11.33L11,5.83V20H2Z' })
	  );
	};
	
	var ArrowExpandVerticalIcon = function ArrowExpandVerticalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9V15H16L12,19L8,15H11V9H8L12,5L16,9H13M4,2H20V4H4V2M4,20H20V22H4V20Z' })
	  );
	};
	
	var ArrowExpandIcon = function ArrowExpandIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,21V19H6.41L10.91,14.5L9.5,13.09L5,17.59V14H3V21H10M14.5,10.91L19,6.41V10H21V3H14V5H17.59L13.09,9.5L14.5,10.91Z' })
	  );
	};
	
	var ArrowLeftBoldBoxOutlineIcon = function ArrowLeftBoldBoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,12L12,7V10H16V14H12V17L7,12M21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5M19,5H5V19H19V5Z' })
	  );
	};
	
	var ArrowLeftBoldBoxIcon = function ArrowLeftBoldBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5M7,12L12,17V14H16V10H12V7L7,12Z' })
	  );
	};
	
	var ArrowLeftBoldCircleOutlineIcon = function ArrowLeftBoldCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,12L12,7V10H16V14H12V17L7,12M22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12M20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12Z' })
	  );
	};
	
	var ArrowLeftBoldCircleIcon = function ArrowLeftBoldCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12M7,12L12,17V14H16V10H12V7L7,12Z' })
	  );
	};
	
	var ArrowLeftBoldHexagonOutlineIcon = function ArrowLeftBoldHexagonOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,12L12,7V10H16V14H12V17L7,12M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z' })
	  );
	};
	
	var ArrowLeftBoldIcon = function ArrowLeftBoldIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,9V15H12V19.84L4.16,12L12,4.16V9H20Z' })
	  );
	};
	
	var ArrowLeftBoxIcon = function ArrowLeftBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.89 3.9,3 5,3H19M18,11H9.5L13,7.5L11.58,6.08L5.66,12L11.58,17.92L13,16.5L9.5,13H18V11Z' })
	  );
	};
	
	var ArrowLeftDropCircleOutlineIcon = function ArrowLeftDropCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,12C22,6.48 17.52,2 12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12M20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12M14,7L9,12L14,17V7Z' })
	  );
	};
	
	var ArrowLeftDropCircleIcon = function ArrowLeftDropCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12M14,7L9,12L14,17V7Z' })
	  );
	};
	
	var ArrowLeftThickIcon = function ArrowLeftThickIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,10V14H11L14.5,17.5L12.08,19.92L4.16,12L12.08,4.08L14.5,6.5L11,10H20Z' })
	  );
	};
	
	var ArrowLeftIcon = function ArrowLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z' })
	  );
	};
	
	var ArrowRightBoldBoxOutlineIcon = function ArrowRightBoldBoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,12L12,17V14H8V10H12V7L17,12M3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19M5,19H19V5H5V19Z' })
	  );
	};
	
	var ArrowRightBoldBoxIcon = function ArrowRightBoldBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19M17,12L12,7V10H8V14H12V17L17,12Z' })
	  );
	};
	
	var ArrowRightBoldCircleOutlineIcon = function ArrowRightBoldCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,12L12,17V14H8V10H12V7L17,12M2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12M4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12Z' })
	  );
	};
	
	var ArrowRightBoldCircleIcon = function ArrowRightBoldCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12M17,12L12,7V10H8V14H12V17L17,12Z' })
	  );
	};
	
	var ArrowRightBoldHexagonOutlineIcon = function ArrowRightBoldHexagonOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,12L12,17V14H8V10H12V7L17,12M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z' })
	  );
	};
	
	var ArrowRightBoldIcon = function ArrowRightBoldIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z' })
	  );
	};
	
	var ArrowRightBoxIcon = function ArrowRightBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,21C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.11 20.1,21 19,21H5M6,13H14.5L11,16.5L12.42,17.92L18.34,12L12.42,6.08L11,7.5L14.5,11H6V13Z' })
	  );
	};
	
	var ArrowRightDropCircleOutlineIcon = function ArrowRightDropCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2C6.48,2 2,6.48 2,12M4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12M10,17L15,12L10,7V17Z' })
	  );
	};
	
	var ArrowRightDropCircleIcon = function ArrowRightDropCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12M10,17L15,12L10,7V17Z' })
	  );
	};
	
	var ArrowRightThickIcon = function ArrowRightThickIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,10V14H13L9.5,17.5L11.92,19.92L19.84,12L11.92,4.08L9.5,6.5L13,10H4Z' })
	  );
	};
	
	var ArrowRightIcon = function ArrowRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z' })
	  );
	};
	
	var ArrowSplitHorizontalIcon = function ArrowSplitHorizontalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,18H11V15H2V13H22V15H13V18H16L12,22L8,18M12,2L8,6H11V9H2V11H22V9H13V6H16L12,2Z' })
	  );
	};
	
	var ArrowSplitVerticalIcon = function ArrowSplitVerticalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,16V13H15V22H13V2H15V11H18V8L22,12L18,16M2,12L6,16V13H9V22H11V2H9V11H6V8L2,12Z' })
	  );
	};
	
	var ArrowTopLeftIcon = function ArrowTopLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,17.59L17.59,19L7,8.41V15H5V5H15V7H8.41L19,17.59Z' })
	  );
	};
	
	var ArrowTopRightIcon = function ArrowTopRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z' })
	  );
	};
	
	var ArrowUpBoldBoxOutlineIcon = function ArrowUpBoldBoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,7L17,12H14V16H10V12H7L12,7M19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21M19,19V5H5V19H19Z' })
	  );
	};
	
	var ArrowUpBoldBoxIcon = function ArrowUpBoldBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21M12,7L7,12H10V16H14V12H17L12,7Z' })
	  );
	};
	
	var ArrowUpBoldCircleOutlineIcon = function ArrowUpBoldCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,7L17,12H14V16H10V12H7L12,7M12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22M12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20Z' })
	  );
	};
	
	var ArrowUpBoldCircleIcon = function ArrowUpBoldCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22M12,7L7,12H10V16H14V12H17L12,7Z' })
	  );
	};
	
	var ArrowUpBoldHexagonOutlineIcon = function ArrowUpBoldHexagonOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,7L17,12H14V16H10V12H7L12,7M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z' })
	  );
	};
	
	var ArrowUpBoldIcon = function ArrowUpBoldIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,20H9V12H4.16L12,4.16L19.84,12H15V20Z' })
	  );
	};
	
	var ArrowUpBoxIcon = function ArrowUpBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.11,3 21,3.9 21,5V19M13,18V9.5L16.5,13L17.92,11.58L12,5.66L6.08,11.58L7.5,13L11,9.5V18H13Z' })
	  );
	};
	
	var ArrowUpDropCircleOutlineIcon = function ArrowUpDropCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M17,14L12,9L7,14H17Z' })
	  );
	};
	
	var ArrowUpDropCircleIcon = function ArrowUpDropCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22M17,14L12,9L7,14H17Z' })
	  );
	};
	
	var ArrowUpThickIcon = function ArrowUpThickIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,20H10V11L6.5,14.5L4.08,12.08L12,4.16L19.92,12.08L17.5,14.5L14,11V20Z' })
	  );
	};
	
	var ArrowUpIcon = function ArrowUpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z' })
	  );
	};
	
	var ArtistIcon = function ArtistIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,14C12,14 13.05,14.16 14.2,14.44C13.39,15.31 13,16.33 13,17.5C13,18.39 13.25,19.23 13.78,20H3V18C3,16.81 3.91,15.85 5.74,15.12C7.57,14.38 9.33,14 11,14M18.5,10H22V12H20V17.5C20,18.17 19.77,18.77 19.27,19.27C18.77,19.77 18.17,20 17.5,20C16.8,20 16.21,19.77 15.73,19.27C15.24,18.77 15,18.17 15,17.5C15,16.8 15.24,16.21 15.73,15.73C16.21,15.24 16.8,15 17.5,15C17.8,15 18.14,15.08 18.5,15.23V10M11,12C9.92,12 9,11.61 8.18,10.83C7.38,10.05 7,9.11 7,8C7,6.92 7.38,6 8.18,5.18C9,4.38 9.92,4 11,4C12.11,4 13.05,4.38 13.83,5.18C14.61,6 15,6.92 15,8C15,9.11 14.61,10.05 13.83,10.83C13.05,11.61 12.11,12 11,12Z' })
	  );
	};
	
	var AssistantIcon = function AssistantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,2H5C3.9,2 3,2.9 3,4V18C3,19.1 3.9,20 5,20H9L12,23L15,20H19C20.1,20 21,19.1 21,18V4C21,2.9 20.1,2 19,2M13.88,12.88L12,17L10.12,12.88L6,11L10.12,9.12L12,5L13.88,9.12L18,11' })
	  );
	};
	
	var AsteriskIcon = function AsteriskIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,2H14L13.21,9.91L19.66,5.27L21.66,8.73L14.42,12L21.66,15.27L19.66,18.73L13.21,14.09L14,22H10L10.79,14.09L4.34,18.73L2.34,15.27L9.58,12L2.34,8.73L4.34,5.27L10.79,9.91L10,2Z' })
	  );
	};
	
	var AtIcon = function AtIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,15C12.81,15 13.5,14.7 14.11,14.11C14.7,13.5 15,12.81 15,12C15,11.19 14.7,10.5 14.11,9.89C13.5,9.3 12.81,9 12,9C11.19,9 10.5,9.3 9.89,9.89C9.3,10.5 9,11.19 9,12C9,12.81 9.3,13.5 9.89,14.11C10.5,14.7 11.19,15 12,15M12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12V13.45C22,14.45 21.65,15.3 21,16C20.3,16.67 19.5,17 18.5,17C17.3,17 16.31,16.5 15.56,15.5C14.56,16.5 13.38,17 12,17C10.63,17 9.45,16.5 8.46,15.54C7.5,14.55 7,13.38 7,12C7,10.63 7.5,9.45 8.46,8.46C9.45,7.5 10.63,7 12,7C13.38,7 14.55,7.5 15.54,8.46C16.5,9.45 17,10.63 17,12V13.45C17,13.86 17.16,14.22 17.46,14.53C17.76,14.84 18.11,15 18.5,15C18.92,15 19.27,14.84 19.57,14.53C19.87,14.22 20,13.86 20,13.45V12C20,9.81 19.23,7.93 17.65,6.35C16.07,4.77 14.19,4 12,4C9.81,4 7.93,4.77 6.35,6.35C4.77,7.93 4,9.81 4,12C4,14.19 4.77,16.07 6.35,17.65C7.93,19.23 9.81,20 12,20H17V22H12C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,9.25 3,6.9 4.95,4.95C6.9,3 9.25,2 12,2Z' })
	  );
	};
	
	var AtlassianIcon = function AtlassianIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.93,11.24C7.74,11 7.38,10.94 7.13,11.13C7.06,11.19 7,11.26 6.96,11.34L2.06,21.15C1.91,21.44 2.03,21.79 2.32,21.94C2.4,22 2.5,22 2.59,22H9.41C9.63,22 9.84,21.88 9.94,21.68C11.41,18.63 10.5,14 7.93,11.24M11.53,2.31C9.05,6.14 8.76,11 10.77,15.09L14.06,21.68C14.17,21.88 14.37,22 14.59,22H21.41C21.74,22 22,21.74 22,21.41C22,21.32 22,21.23 21.94,21.15C21.94,21.15 12.76,2.77 12.5,2.31C12.39,2.04 12.06,1.92 11.78,2.06C11.67,2.11 11.58,2.2 11.53,2.31Z' })
	  );
	};
	
	var AtomIcon = function AtomIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,11C12.55,11 13,11.45 13,12C13,12.55 12.55,13 12,13C11.45,13 11,12.55 11,12C11,11.45 11.45,11 12,11M4.22,4.22C5.65,2.79 8.75,3.43 12,5.56C15.25,3.43 18.35,2.79 19.78,4.22C21.21,5.65 20.57,8.75 18.44,12C20.57,15.25 21.21,18.35 19.78,19.78C18.35,21.21 15.25,20.57 12,18.44C8.75,20.57 5.65,21.21 4.22,19.78C2.79,18.35 3.43,15.25 5.56,12C3.43,8.75 2.79,5.65 4.22,4.22M15.54,8.46C16.15,9.08 16.71,9.71 17.23,10.34C18.61,8.21 19.11,6.38 18.36,5.64C17.62,4.89 15.79,5.39 13.66,6.77C14.29,7.29 14.92,7.85 15.54,8.46M8.46,15.54C7.85,14.92 7.29,14.29 6.77,13.66C5.39,15.79 4.89,17.62 5.64,18.36C6.38,19.11 8.21,18.61 10.34,17.23C9.71,16.71 9.08,16.15 8.46,15.54M5.64,5.64C4.89,6.38 5.39,8.21 6.77,10.34C7.29,9.71 7.85,9.08 8.46,8.46C9.08,7.85 9.71,7.29 10.34,6.77C8.21,5.39 6.38,4.89 5.64,5.64M9.88,14.12C10.58,14.82 11.3,15.46 12,16.03C12.7,15.46 13.42,14.82 14.12,14.12C14.82,13.42 15.46,12.7 16.03,12C15.46,11.3 14.82,10.58 14.12,9.88C13.42,9.18 12.7,8.54 12,7.97C11.3,8.54 10.58,9.18 9.88,9.88C9.18,10.58 8.54,11.3 7.97,12C8.54,12.7 9.18,13.42 9.88,14.12M18.36,18.36C19.11,17.62 18.61,15.79 17.23,13.66C16.71,14.29 16.15,14.92 15.54,15.54C14.92,16.15 14.29,16.71 13.66,17.23C15.79,18.61 17.62,19.11 18.36,18.36Z' })
	  );
	};
	
	var AttachmentIcon = function AttachmentIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.5,18C4.46,18 2,15.54 2,12.5C2,9.46 4.46,7 7.5,7H18C20.21,7 22,8.79 22,11C22,13.21 20.21,15 18,15H9.5C8.12,15 7,13.88 7,12.5C7,11.12 8.12,10 9.5,10H17V11.5H9.5C8.95,11.5 8.5,11.95 8.5,12.5C8.5,13.05 8.95,13.5 9.5,13.5H18C19.38,13.5 20.5,12.38 20.5,11C20.5,9.62 19.38,8.5 18,8.5H7.5C5.29,8.5 3.5,10.29 3.5,12.5C3.5,14.71 5.29,16.5 7.5,16.5H17V18H7.5Z' })
	  );
	};
	
	var AudioVideoIcon = function AudioVideoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,7H4C2.9,7 2,7.9 2,9V15C2,16.1 2.9,17 4,17H5V18C5,18.6 5.4,19 6,19H8C8.6,19 9,18.6 9,18V17H15V18C15,18.6 15.4,19 16,19H18C18.6,19 19,18.6 19,18V17H20C21.1,17 22,16.1 22,15V9C22,7.9 21.1,7 20,7M14,12H4V10H14V12M18,13C16.9,13 16,12.1 16,11C16,9.9 16.9,9 18,9C19.1,9 20,9.9 20,11C20,12.1 19.1,13 18,13M6,15H4V14H6V15M10,15H8V14H10V15M14,15H12V14H14V15Z' })
	  );
	};
	
	var AudiobookIcon = function AudiobookIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,22H6C4.9,22 4,21.1 4,20V4C4,2.89 4.9,2 6,2H7V9L9.5,7.5L12,9V2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22M13,15C11.9,15 11,15.9 11,17C11,18.1 11.9,19 13,19C14.1,19 15,18.1 15,17V12H18V10H14V15.27C13.71,15.1 13.36,15 13,15Z' })
	  );
	};
	
	var AugmentedRealityIcon = function AugmentedRealityIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5M7.75,9H9.25L11,15H9.5L9.21,14H7.79L7.5,15H6L7.75,9M13,9H16.5C17.35,9 18,9.65 18,10.5V11.5C18,12.1 17.6,12.65 17.1,12.9L18,15H16.5L15.65,13H14.5V15H13V9M14.5,10.5V11.5H16.5V10.5H14.5M8.5,11.57L8.23,12.5H8.77L8.5,11.57Z' })
	  );
	};
	
	var AutoFixIcon = function AutoFixIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.5,5.6L5,7L6.4,4.5L5,2L7.5,3.4L10,2L8.6,4.5L10,7L7.5,5.6M19.5,15.4L22,14L20.6,16.5L22,19L19.5,17.6L17,19L18.4,16.5L17,14L19.5,15.4M22,2L20.6,4.5L22,7L19.5,5.6L17,7L18.4,4.5L17,2L19.5,3.4L22,2M13.34,12.78L15.78,10.34L13.66,8.22L11.22,10.66L13.34,12.78M14.37,7.29L16.71,9.63C17.1,10 17.1,10.65 16.71,11.04L5.04,22.71C4.65,23.1 4,23.1 3.63,22.71L1.29,20.37C0.9,20 0.9,19.35 1.29,18.96L12.96,7.29C13.35,6.9 14,6.9 14.37,7.29Z' })
	  );
	};
	
	var AutoUploadIcon = function AutoUploadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.35,12.65L6.5,9L7.65,12.65M5.5,7L2.3,16H4.2L4.9,14H8.1L8.8,16H10.7L7.5,7M11,20H22V18H11M14,16H19V11H22L16.5,5.5L11,11H14V16Z' })
	  );
	};
	
	var AutorenewIcon = function AutorenewIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,6V9L16,5L12,1V4C7.58,4 4,7.58 4,12C4,13.57 4.46,15.03 5.24,16.26L6.7,14.8C6.25,13.97 6,13 6,12C6,8.69 8.69,6 12,6M18.76,7.74L17.3,9.2C17.74,10.04 18,11 18,12C18,15.31 15.31,18 12,18V15L8,19L12,23V20C16.42,20 20,16.42 20,12C20,10.43 19.54,8.97 18.76,7.74Z' })
	  );
	};
	
	var AvTimerIcon = function AvTimerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,17C11,17.55 11.45,18 12,18C12.55,18 13,17.55 13,17C13,16.45 12.55,16 12,16C11.45,16 11,16.45 11,17M11,3V7H13V5.08C16.39,5.57 19,8.47 19,12C19,15.87 15.87,19 12,19C8.13,19 5,15.87 5,12C5,10.32 5.59,8.78 6.58,7.58L12,13L13.41,11.59L6.61,4.79V4.81C4.42,6.45 3,9.05 3,12C3,16.97 7.03,21 12,21C16.97,21 21,16.97 21,12C21,7.03 16.97,3 12,3M18,12C18,11.45 17.55,11 17,11C16.45,11 16,11.45 16,12C16,12.55 16.45,13 17,13C17.55,13 18,12.55 18,12M6,12C6,12.55 6.45,13 7,13C7.55,13 8,12.55 8,12C8,11.45 7.55,11 7,11C6.45,11 6,11.45 6,12Z' })
	  );
	};
	
	var AxeIcon = function AxeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2L22,8C22,12 20,14 16,15L13,10L9,6L12,2M4.11,19.84L2.12,18.33L9.19,9L11,10.81L4.11,19.84Z' })
	  );
	};
	
	var AzureIcon = function AzureIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.05,4.24L6.56,18.05L2,18L7.09,9.24L13.05,4.24M13.75,5.33L22,19.76H6.74L16.04,18.1L11.17,12.31L13.75,5.33Z' })
	  );
	};
	
	var BabyBuggyIcon = function BabyBuggyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,2V10H21C21,5.58 17.42,2 13,2M19.32,15.89C20.37,14.54 21,12.84 21,11H6.44L5.5,9H2V11H4.22C4.22,11 6.11,15.07 6.34,15.42C5.24,16 4.5,17.17 4.5,18.5C4.5,20.43 6.07,22 8,22C9.76,22 11.22,20.7 11.46,19H13.54C13.78,20.7 15.24,22 17,22C18.93,22 20.5,20.43 20.5,18.5C20.5,17.46 20.04,16.53 19.32,15.89M8,20C7.17,20 6.5,19.33 6.5,18.5C6.5,17.67 7.17,17 8,17C8.83,17 9.5,17.67 9.5,18.5C9.5,19.33 8.83,20 8,20M17,20C16.17,20 15.5,19.33 15.5,18.5C15.5,17.67 16.17,17 17,17C17.83,17 18.5,17.67 18.5,18.5C18.5,19.33 17.83,20 17,20Z' })
	  );
	};
	
	var BabyIcon = function BabyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.5,4C19.88,4 21,5.12 21,6.5C21,7.88 19.88,9 18.5,9C17.12,9 16,7.88 16,6.5C16,5.12 17.12,4 18.5,4M4.5,20C3.67,20 3,19.33 3,18.5C3,17.67 3.67,17 4.5,17H11.5C12.33,17 13,17.67 13,18.5C13,19.33 12.33,20 11.5,20H4.5M16.09,19L14.69,15H11L6.75,10.75C6.75,10.75 9,8.25 12.5,8.25C15.5,8.25 15.85,9.25 16.06,9.87L18.92,18C19.2,18.78 18.78,19.64 18,19.92C17.22,20.19 16.36,19.78 16.09,19Z' })
	  );
	};
	
	var BackburgerIcon = function BackburgerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,13L9,17L7.6,18.42L1.18,12L7.6,5.58L9,7L5,11H21V13H5M21,6V8H11V6H21M21,16V18H11V16H21Z' })
	  );
	};
	
	var BackspaceIcon = function BackspaceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,3H7C6.31,3 5.77,3.35 5.41,3.88L0,12L5.41,20.11C5.77,20.64 6.31,21 7,21H22C23.1,21 24,20.1 24,19V5C24,3.9 23.1,3 22,3M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12' })
	  );
	};
	
	var BackupRestoreIcon = function BackupRestoreIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.03,3 3,7.03 3,12H0L4,16L8,12H5C5,8.13 8.13,5 12,5C15.87,5 19,8.13 19,12C19,15.87 15.87,19 12,19C10.5,19 9.09,18.5 7.94,17.7L6.5,19.14C8.04,20.3 9.94,21 12,21C16.97,21 21,16.97 21,12C21,7.03 16.97,3 12,3M14,12C14,10.9 13.1,10 12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12Z' })
	  );
	};
	
	var BadmintonIcon = function BadmintonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.3,2C11.33,2.03 10.58,2.84 10.61,3.8C10.62,4.04 10.67,4.27 10.77,4.5L11.06,5.14V5.14C11.1,5.27 11.03,5.41 10.89,5.45C10.8,5.5 10.7,5.45 10.63,5.37L10.21,4.82C9.88,4.4 9.38,4.14 8.85,4.13C7.88,4.11 7.08,4.88 7.06,5.84C7.05,6.26 7.19,6.66 7.45,7L7.87,7.5H7.88C7.96,7.63 7.93,7.79 7.82,7.87C7.73,7.94 7.61,7.94 7.53,7.87L7,7.45C6.66,7.19 6.25,7.05 5.84,7.06C4.88,7.08 4.11,7.88 4.13,8.85C4.14,9.38 4.4,9.88 4.82,10.21L5.39,10.65C5.5,10.75 5.5,10.91 5.38,11C5.31,11.07 5.21,11.09 5.12,11.05H5.11L4.5,10.77C4.27,10.68 4.04,10.62 3.8,10.61C2.84,10.58 2.03,11.34 2,12.31C2,13.03 2.4,13.69 3.06,13.97L14.45,19.04L19.04,14.45L13.97,3.06C13.69,2.39 13,1.97 12.3,2M13.13,6.1C13.55,6.09 13.93,6.33 14.09,6.71L17.14,13.55L13.19,9.61L12.26,7.5C11.96,6.87 12.42,6.12 13.13,6.1M9.85,8.85C10.12,8.85 10.37,8.95 10.56,9.15L15.37,13.96C15.77,14.34 15.78,14.97 15.4,15.37C15,15.77 14.38,15.78 13.96,15.37L9.15,10.56C8.75,10.18 8.74,9.54 9.13,9.15C9.32,8.95 9.58,8.85 9.85,8.85M7.13,12.17C7.26,12.17 7.4,12.21 7.5,12.26L9.63,13.2L13.57,17.14L6.71,14.09C5.69,13.65 6.03,12.14 7.13,12.17M20.28,16.04L16.04,20.28L16.89,21.13C17.65,21.88 18.75,22.17 19.78,21.9C20.81,21.62 21.62,20.81 21.9,19.78C22.17,18.75 21.88,17.65 21.13,16.89L20.28,16.04Z' })
	  );
	};
	
	var BandcampIcon = function BandcampIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,6L15.5,18H2L8.5,6H22Z' })
	  );
	};
	
	var BankIcon = function BankIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.5,1L2,6V8H21V6M16,10V17H19V10M2,22H21V19H2M10,10V17H13V10M4,10V17H7V10H4Z' })
	  );
	};
	
	var BarcodeScanIcon = function BarcodeScanIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,6H6V18H4V6M7,6H8V18H7V6M9,6H12V18H9V6M13,6H14V18H13V6M16,6H18V18H16V6M19,6H20V18H19V6M2,4V8H0V4C0,2.9 0.9,2 2,2H6V4H2M22,2C23.1,2 24,2.9 24,4V8H22V4H18V2H22M2,16V20H6V22H2C0.9,22 0,21.1 0,20V16H2M22,20V16H24V20C24,21.1 23.1,22 22,22H18V20H22Z' })
	  );
	};
	
	var BarcodeIcon = function BarcodeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,6H4V18H2V6M5,6H6V18H5V6M7,6H10V18H7V6M11,6H12V18H11V6M14,6H16V18H14V6M17,6H20V18H17V6M21,6H22V18H21V6Z' })
	  );
	};
	
	var BarleyIcon = function BarleyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.33,18.33C6.5,17.17 6.5,15.83 6.5,14.5C8.17,15.5 9.83,16.5 10.67,17.67L11,18.23V15.95C9.5,15.05 8.08,14.13 7.33,13.08C6.5,11.92 6.5,10.58 6.5,9.25C8.17,10.25 9.83,11.25 10.67,12.42L11,13V10.7C9.5,9.8 8.08,8.88 7.33,7.83C6.5,6.67 6.5,5.33 6.5,4C8.17,5 9.83,6 10.67,7.17C10.77,7.31 10.86,7.46 10.94,7.62C10.77,7 10.66,6.42 10.65,5.82C10.64,4.31 11.3,2.76 11.96,1.21C12.65,2.69 13.34,4.18 13.35,5.69C13.36,6.32 13.25,6.96 13.07,7.59C13.15,7.45 13.23,7.31 13.33,7.17C14.17,6 15.83,5 17.5,4C17.5,5.33 17.5,6.67 16.67,7.83C15.92,8.88 14.5,9.8 13,10.7V13L13.33,12.42C14.17,11.25 15.83,10.25 17.5,9.25C17.5,10.58 17.5,11.92 16.67,13.08C15.92,14.13 14.5,15.05 13,15.95V18.23L13.33,17.67C14.17,16.5 15.83,15.5 17.5,14.5C17.5,15.83 17.5,17.17 16.67,18.33C15.92,19.38 14.5,20.3 13,21.2V23H11V21.2C9.5,20.3 8.08,19.38 7.33,18.33Z' })
	  );
	};
	
	var BarrelIcon = function BarrelIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,19H19V21H5V19H6V13H5V11H6V5H5V3H19V5H18V11H19V13H18V19M9,13C9,14.66 10.34,16 12,16C13.66,16 15,14.66 15,13C15,11 12,7.63 12,7.63C12,7.63 9,11 9,13Z' })
	  );
	};
	
	var BaseballBatIcon = function BaseballBatIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,2C19.72,2 19.5,2.11 19.29,2.29L9.79,11.79C9.75,11.83 9.72,11.87 7.23,15.35L4,18.59L3.71,18.29C3.5,18.1 3.26,18 3,18C2.44,18 2,18.44 2,19C2,19.26 2.1,19.5 2.29,19.71L4.29,21.71C4.68,22.11 5.31,22.12 5.71,21.74C6.11,21.35 6.12,20.72 5.71,20.29L5.41,20L8.64,16.77L12.21,14.21L21.71,4.71C22.1,4.32 22.1,3.68 21.71,3.29L20.71,2.29C20.5,2.1 20.26,2 20,2M18.5,13C17.12,13 16,14.12 16,15.5C16,16.88 17.12,18 18.5,18C19.88,18 21,16.88 21,15.5C21,14.12 19.88,13 18.5,13Z' })
	  );
	};
	
	var BaseballIcon = function BaseballIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C9.5,2 7.25,2.9 5.5,4.4C6,4.81 6.41,5.27 6.8,5.76L7.89,5.13L8.89,6.87L7.89,7.44C8.45,8.53 8.82,9.73 8.95,11H10V12L10,13H8.95C8.82,14.27 8.45,15.47 7.89,16.56L8.89,17.13L7.89,18.87L6.8,18.24C6.41,18.73 6,19.19 5.5,19.6C7.25,21.1 9.5,22 12,22C14.5,22 16.75,21.1 18.5,19.6C18,19.19 17.59,18.73 17.19,18.24L16.11,18.87L15.11,17.13L16.11,16.55C15.55,15.47 15.18,14.27 15.05,13H14V11H15.05C15.18,9.73 15.55,8.53 16.11,7.45L15.11,6.87L16.11,5.13L17.19,5.76C17.59,5.27 18,4.81 18.5,4.4C16.75,2.9 14.5,2 12,2M4.12,5.85C2.79,7.55 2,9.68 2,12C2,14.32 2.79,16.45 4.12,18.15C4.46,17.87 4.76,17.55 5.05,17.22L4.43,16.87L5.43,15.13L6.16,15.56C6.55,14.77 6.82,13.91 6.93,13H6V12L6,11H6.93C6.82,10.09 6.55,9.23 6.16,8.44L5.43,8.87L4.43,7.13L5.05,6.78C4.76,6.45 4.46,6.13 4.12,5.85M19.88,5.85C19.54,6.13 19.24,6.45 18.95,6.78L19.57,7.13L18.57,8.87L17.84,8.44C17.45,9.23 17.18,10.09 17.07,11H18V13H17.07C17.18,13.91 17.45,14.77 17.84,15.56L18.57,15.13L19.57,16.87L18.95,17.22C19.24,17.55 19.54,17.87 19.88,18.15C21.21,16.45 22,14.32 22,12C22,9.68 21.21,7.55 19.88,5.85Z' })
	  );
	};
	
	var BasecampIcon = function BasecampIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,16.25C2,16.25 4,3.75 12,3.75C20,3.75 22,16.25 22,16.25C22,16.25 20,20.25 12,20.25C4,20.25 2,16.25 2,16.25M3.35,15.65C3.35,15.65 4.3,19 12,19C17,19 20,17.8 20.65,15.85C21.3,13.9 15.65,7.6 14.65,7.6C13.65,7.6 11.2,12 10.45,12C8.45,12 8.9,10 7.15,10C5.4,10 3.35,15.65 3.35,15.65Z' })
	  );
	};
	
	var BasketFillIcon = function BasketFillIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,2H6V5H3V2M6,7H9V10H6V7M8,2H11V5H8V2M17,11L12,6H15V2H19V6H22L17,11M7.5,22C6.72,22 6.04,21.55 5.71,20.9V20.9L3.1,13.44L3,13C3,12.45 3.45,12 4,12H20C20.55,12 21,12.45 21,13L20.96,13.29L18.29,20.9C17.96,21.55 17.28,22 16.5,22H7.5M7.61,20H16.39L18.57,14H5.42L7.61,20Z' })
	  );
	};
	
	var BasketUnfillIcon = function BasketUnfillIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,10H6V7H3V10M5,5H8V2H5V5M8,10H11V7H8V10M17,1L12,6H15V10H19V6H22L17,1M7.5,22C6.72,22 6.04,21.55 5.71,20.9V20.9L3.1,13.44L3,13C3,12.45 3.45,12 4,12H20C20.55,12 21,12.45 21,13L20.96,13.29L18.29,20.9C17.96,21.55 17.28,22 16.5,22H7.5M7.61,20H16.39L18.57,14H5.42L7.61,20Z' })
	  );
	};
	
	var BasketIcon = function BasketIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.5,21C4.72,21 4.04,20.55 3.71,19.9V19.9L1.1,10.44L1,10C1,9.45 1.45,9 2,9H6.58L11.18,2.43C11.36,2.17 11.66,2 12,2C12.34,2 12.65,2.17 12.83,2.44L17.42,9H22C22.55,9 23,9.45 23,10L22.96,10.29L20.29,19.9C19.96,20.55 19.28,21 18.5,21H5.5M12,4.74L9,9H15L12,4.74M12,13C10.9,13 10,13.9 10,15C10,16.1 10.9,17 12,17C13.1,17 14,16.1 14,15C14,13.9 13.1,13 12,13Z' })
	  );
	};
	
	var BasketballIcon = function BasketballIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.34,14.63C2.94,14.41 3.56,14.3 4.22,14.3C5.56,14.3 6.73,14.72 7.73,15.56L4.59,18.7C3.53,17.5 2.78,16.13 2.34,14.63M15.56,9.8C17.53,11.27 19.66,11.63 21.94,10.88C21.97,11.09 22,11.47 22,12C22,13.03 21.75,14.18 21.28,15.45C20.81,16.71 20.23,17.73 19.55,18.5L13.22,12.19L15.56,9.8M8.77,16.64C9.83,18.17 10.05,19.84 9.42,21.66C8,21.25 6.73,20.61 5.67,19.73L8.77,16.64M12.19,13.22L18.5,19.55C16.33,21.45 13.78,22.25 10.88,21.94C11.09,21.28 11.2,20.56 11.2,19.78C11.2,19.16 11.06,18.43 10.78,17.6C10.5,16.77 10.17,16.09 9.8,15.56L12.19,13.22M8.81,14.5C7.88,13.67 6.8,13.15 5.58,12.91C4.36,12.68 3.19,12.75 2.06,13.13C2.03,12.91 2,12.53 2,12C2,10.97 2.25,9.82 2.72,8.55C3.19,7.29 3.77,6.27 4.45,5.5L11.11,12.19L8.81,14.5M15.56,7.73C14.22,6.08 13.91,4.28 14.63,2.34C15.25,2.5 15.96,2.8 16.76,3.26C17.55,3.71 18.2,4.16 18.7,4.59L15.56,7.73M21.66,9.38C21.06,9.59 20.44,9.7 19.78,9.7C18.69,9.7 17.64,9.38 16.64,8.72L19.73,5.67C20.61,6.77 21.25,8 21.66,9.38M12.19,11.11L5.5,4.45C7.67,2.55 10.22,1.75 13.13,2.06C12.91,2.72 12.8,3.44 12.8,4.22C12.8,4.94 12.96,5.75 13.29,6.66C13.62,7.56 14,8.28 14.5,8.81L12.19,11.11Z' })
	  );
	};
	
	var Battery10BluetoothIcon = function Battery10BluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V18H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z' })
	  );
	};
	
	var Battery10Icon = function Battery10Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,18H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z' })
	  );
	};
	
	var Battery20BluetoothIcon = function Battery20BluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V17H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z' })
	  );
	};
	
	var Battery20Icon = function Battery20Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,17H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z' })
	  );
	};
	
	var Battery30BluetoothIcon = function Battery30BluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V15H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z' })
	  );
	};
	
	var Battery30Icon = function Battery30Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,15H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z' })
	  );
	};
	
	var Battery40BluetoothIcon = function Battery40BluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V14H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z' })
	  );
	};
	
	var Battery40Icon = function Battery40Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,14H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z' })
	  );
	};
	
	var Battery50BluetoothIcon = function Battery50BluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V13H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z' })
	  );
	};
	
	var Battery50Icon = function Battery50Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,13H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z' })
	  );
	};
	
	var Battery60BluetoothIcon = function Battery60BluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V12H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z' })
	  );
	};
	
	var Battery60Icon = function Battery60Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,12H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z' })
	  );
	};
	
	var Battery70BluetoothIcon = function Battery70BluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V10H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z' })
	  );
	};
	
	var Battery70Icon = function Battery70Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,10H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z' })
	  );
	};
	
	var Battery80BluetoothIcon = function Battery80BluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V9H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z' })
	  );
	};
	
	var Battery80Icon = function Battery80Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,9H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z' })
	  );
	};
	
	var Battery90BluetoothIcon = function Battery90BluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M4,6H12V8H4V6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z' })
	  );
	};
	
	var Battery90Icon = function Battery90Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,8H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z' })
	  );
	};
	
	var BatteryAlertBluetoothIcon = function BatteryAlertBluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M7,9H9V14H7V9M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21M7,16H9V18H7V16Z' })
	  );
	};
	
	var BatteryAlertIcon = function BatteryAlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,14H11V9H13M13,18H11V16H13M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z' })
	  );
	};
	
	var BatteryBluetoothVariantIcon = function BatteryBluetoothVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,2V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4H15V2H9M11.83,8H12.33L15.18,10.85L13.04,13L15.17,15.14L12.33,18H11.83V14.21L9.54,16.5L8.83,15.79L11.62,13L8.83,10.21L9.54,9.5L11.83,11.79V8M12.83,9.91V11.79L13.77,10.85L12.83,9.91M12.83,14.21V16.08L13.77,15.14L12.83,14.21Z' })
	  );
	};
	
	var BatteryBluetoothIcon = function BatteryBluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4H11V2H5M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21Z' })
	  );
	};
	
	var BatteryCharging10Icon = function BatteryCharging10Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23.05,11H20.05V4L15.05,14H18.05V22M12,18H4L4.05,6H12.05M12.72,4H11.05V2H5.05V4H3.38C2.65,4 2.05,4.6 2.05,5.33V20.67C2.05,21.4 2.65,22 3.38,22H12.72C13.45,22 14.05,21.4 14.05,20.67V5.33C14.05,4.6 13.45,4 12.72,4Z' })
	  );
	};
	
	var BatteryCharging100Icon = function BatteryCharging100Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,11H20V4L15,14H18V22M12.67,4H11V2H5V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4Z' })
	  );
	};
	
	var BatteryCharging20Icon = function BatteryCharging20Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23.05,11H20.05V4L15.05,14H18.05V22M12.05,17H4.05V6H12.05M12.72,4H11.05V2H5.05V4H3.38C2.65,4 2.05,4.6 2.05,5.33V20.67C2.05,21.4 2.65,22 3.38,22H12.72C13.45,22 14.05,21.4 14.05,20.67V5.33C14.05,4.6 13.45,4 12.72,4Z' })
	  );
	};
	
	var BatteryCharging30Icon = function BatteryCharging30Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,15H4V6H12M12.67,4H11V2H5V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4M23,11H20V4L15,14H18V22L23,11Z' })
	  );
	};
	
	var BatteryCharging40Icon = function BatteryCharging40Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,11H20V4L15,14H18V22M12,13H4V6H12M12.67,4H11V2H5V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4Z' })
	  );
	};
	
	var BatteryCharging50Icon = function BatteryCharging50Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,11H20V4L15,14H18V22M12,13H4V6H12M12.67,4H11V2H5V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4Z' })
	  );
	};
	
	var BatteryCharging60Icon = function BatteryCharging60Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,11H4V6H12M12.67,4H11V2H5V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4M23,11H20V4L15,14H18V22L23,11Z' })
	  );
	};
	
	var BatteryCharging70Icon = function BatteryCharging70Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,10H4V6H12M12.67,4H11V2H5V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4M23,11H20V4L15,14H18V22L23,11Z' })
	  );
	};
	
	var BatteryCharging80Icon = function BatteryCharging80Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,11H20V4L15,14H18V22M12,9H4V6H12M12.67,4H11V2H5V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4Z' })
	  );
	};
	
	var BatteryCharging90Icon = function BatteryCharging90Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,11H20V4L15,14H18V22M12,8H4V6H12M12.67,4H11V2H5V4H3.33C2.6,4 2,4.6 2,5.33V20.67C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.67V5.33C14,4.6 13.4,4 12.67,4Z' })
	  );
	};
	
	var BatteryChargingOutlineIcon = function BatteryChargingOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23.05,11H20.05V4L15.05,14H18.05V22M12,20H4L4.05,6H12.05M12.72,4H11.05V2H5.05V4H3.38C2.65,4 2.05,4.6 2.05,5.33V20.67C2.05,21.4 2.65,22 3.38,22H12.72C13.45,22 14.05,21.4 14.05,20.67V5.33C14.05,4.6 13.45,4 12.72,4Z' })
	  );
	};
	
	var BatteryChargingWireless10Icon = function BatteryChargingWireless10Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,18.5H4V6H12V18.5Z' })
	  );
	};
	
	var BatteryChargingWireless20Icon = function BatteryChargingWireless20Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,17H4V6H12V17Z' })
	  );
	};
	
	var BatteryChargingWireless30Icon = function BatteryChargingWireless30Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,16H4V6H12V16Z' })
	  );
	};
	
	var BatteryChargingWireless40Icon = function BatteryChargingWireless40Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,14.5H4V6H12V14.5Z' })
	  );
	};
	
	var BatteryChargingWireless50Icon = function BatteryChargingWireless50Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,13H4V6H12V13Z' })
	  );
	};
	
	var BatteryChargingWireless60Icon = function BatteryChargingWireless60Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,11.6H4V6H12V11.6Z' })
	  );
	};
	
	var BatteryChargingWireless70Icon = function BatteryChargingWireless70Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,10H4V6H12V10Z' })
	  );
	};
	
	var BatteryChargingWireless80Icon = function BatteryChargingWireless80Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,9H4V6H12V9Z' })
	  );
	};
	
	var BatteryChargingWireless90Icon = function BatteryChargingWireless90Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,7.5H4V6H12V7.5Z' })
	  );
	};
	
	var BatteryChargingWirelessAlertIcon = function BatteryChargingWirelessAlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M9,18H7V16H9V18M9,14H7V9H9V14M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76Z' })
	  );
	};
	
	var BatteryChargingWirelessOutlineIcon = function BatteryChargingWirelessOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M12,20H4V6H12V20Z' })
	  );
	};
	
	var BatteryChargingWirelessIcon = function BatteryChargingWirelessIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,4H11V2H5V4H3C2.45,4 2,4.45 2,5V21C2,21.55 2.45,22 3,22H13C13.55,22 14,21.55 14,21V5C14,4.45 13.55,4 13,4M20.07,4.93L18.66,6.34C21.79,9.46 21.79,14.53 18.66,17.66L20.07,19.07C23.97,15.17 23.97,8.84 20.07,4.93M17.24,7.76L15.83,9.17C17.39,10.73 17.39,13.26 15.83,14.83L17.24,16.24C19.58,13.9 19.58,10.1 17.24,7.76Z' })
	  );
	};
	
	var BatteryChargingIcon = function BatteryChargingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.66C6,21.4 6.6,22 7.33,22H16.66C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4M11,20V14.5H9L13,7V12.5H15' })
	  );
	};
	
	var BatteryMinusIcon = function BatteryMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.67,4C17.4,4 18,4.6 18,5.33V20.67C18,21.4 17.4,22 16.67,22H7.33C6.6,22 6,21.4 6,20.67V5.33C6,4.6 6.6,4 7.33,4H9V2H15V4H16.67M8,12V14H16V12' })
	  );
	};
	
	var BatteryNegativeIcon = function BatteryNegativeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.67,4C12.4,4 13,4.6 13,5.33V20.67C13,21.4 12.4,22 11.67,22H2.33C1.6,22 1,21.4 1,20.67V5.33C1,4.6 1.6,4 2.33,4H4V2H10V4H11.67M15,12H23V14H15V12M3,13H11V6H3V13Z' })
	  );
	};
	
	var BatteryOutlineIcon = function BatteryOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,20H8V6H16M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z' })
	  );
	};
	
	var BatteryPlusIcon = function BatteryPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.67,4C17.4,4 18,4.6 18,5.33V20.67C18,21.4 17.4,22 16.67,22H7.33C6.6,22 6,21.4 6,20.67V5.33C6,4.6 6.6,4 7.33,4H9V2H15V4H16.67M16,14V12H13V9H11V12H8V14H11V17H13V14H16Z' })
	  );
	};
	
	var BatteryPositiveIcon = function BatteryPositiveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.67,4C12.4,4 13,4.6 13,5.33V20.67C13,21.4 12.4,22 11.67,22H2.33C1.6,22 1,21.4 1,20.67V5.33C1,4.6 1.6,4 2.33,4H4V2H10V4H11.67M23,14H20V17H18V14H15V12H18V9H20V12H23V14M3,13H11V6H3V13Z' })
	  );
	};
	
	var BatteryUnknownBluetoothIcon = function BatteryUnknownBluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,2V4H3.33C2.6,4 2,4.6 2,5.33V20.66C2,21.4 2.6,22 3.33,22H12.67C13.4,22 14,21.4 14,20.66V5.33C14,4.59 13.4,4 12.67,4H11V2H5M8,6C10.21,6 12,7.79 12,10C12,10.88 11.64,11.68 11.07,12.25L10.17,13.17C9.63,13.71 9.25,14.18 9.09,15H7.05C7.16,14.1 7.56,13.28 8.17,12.67L9.41,11.41C9.78,11.05 10,10.55 10,10C10,8.89 9.1,8 8,8C6.9,8 6,8.9 6,10H4C4,7.79 5.79,6 8,6M19,8V11.79L16.71,9.5L16,10.21L18.79,13L16,15.79L16.71,16.5L19,14.21V18H19.5L22.35,15.14L20.21,13L22.35,10.85L19.5,8H19M20,9.91L20.94,10.85L20,11.79V9.91M20,14.21L20.94,15.14L20,16.08V14.21M7,17H9V19H7V17Z' })
	  );
	};
	
	var BatteryUnknownIcon = function BatteryUnknownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.07,12.25L14.17,13.17C13.63,13.71 13.25,14.18 13.09,15H11.05C11.16,14.1 11.56,13.28 12.17,12.67L13.41,11.41C13.78,11.05 14,10.55 14,10C14,8.89 13.1,8 12,8C10.9,8 10,8.9 10,10H8C8,7.79 9.79,6 12,6C14.21,6 16,7.79 16,10C16,10.88 15.64,11.68 15.07,12.25M13,19H11V17H13M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.66C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.66V5.33C18,4.59 17.4,4 16.67,4Z' })
	  );
	};
	
	var BatteryIcon = function BatteryIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.67,4H15V2H9V4H7.33C6.6,4 6,4.6 6,5.33V20.67C6,21.4 6.6,22 7.33,22H16.67C17.4,22 18,21.4 18,20.67V5.33C18,4.6 17.4,4 16.67,4Z' })
	  );
	};
	
	var BeachIcon = function BeachIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,18.54C17.13,18.21 19.5,18 22,18V22H5C5,21.35 8.2,19.86 13,18.9V12.4C12.16,12.65 11.45,13.21 11,13.95C10.39,12.93 9.27,12.25 8,12.25C6.73,12.25 5.61,12.93 5,13.95C5.03,10.37 8.5,7.43 13,7.04V7C13,6.45 13.45,6 14,6C14.55,6 15,6.45 15,7V7.04C19.5,7.43 22.96,10.37 23,13.95C22.39,12.93 21.27,12.25 20,12.25C18.73,12.25 17.61,12.93 17,13.95C16.55,13.21 15.84,12.65 15,12.39V18.54M7,2C7,4.76 4.76,7 2,7V2H7Z' })
	  );
	};
	
	var BeakerIcon = function BeakerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3H21V5C19.9,5 19,5.9 19,7V19C19,20.1 18.1,21 17,21H7C5.9,21 5,20.1 5,19V7C5,5.9 4.1,5 3,5V3M7,5V7H12V8H7V9H10V10H7V11H10V12H7V13H12V14H7V15H10V16H7V19H17V5H7Z' })
	  );
	};
	
	var BeatsIcon = function BeatsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7C10.87,7 9.84,7.37 9,8V2.46C9.95,2.16 10.95,2 12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,8.3 4,5.07 7,3.34V12M12,9C13.66,9 15,10.34 15,12C15,13.66 13.66,15 12,15C10.34,15 9,13.66 9,12C9,10.34 10.34,9 12,9Z' })
	  );
	};
	
	var BedEmptyIcon = function BedEmptyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,7H5V14H3V5H1V20H3V17H21V20H23V11C23,8.79 21.21,7 19,7' })
	  );
	};
	
	var BeerIcon = function BeerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H19L17,22H6L4,2M6.2,4L7.8,20H8.8L7.43,6.34C8.5,6 9.89,5.89 11,7C12.56,8.56 15.33,7.69 16.5,7.23L16.8,4H6.2Z' })
	  );
	};
	
	var BehanceIcon = function BehanceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.58,12.27C19.54,11.65 19.33,11.18 18.96,10.86C18.59,10.54 18.13,10.38 17.58,10.38C17,10.38 16.5,10.55 16.19,10.89C15.86,11.23 15.65,11.69 15.57,12.27M21.92,12.04C22,12.45 22,13.04 22,13.81H15.5C15.55,14.71 15.85,15.33 16.44,15.69C16.79,15.92 17.22,16.03 17.73,16.03C18.26,16.03 18.69,15.89 19,15.62C19.2,15.47 19.36,15.27 19.5,15H21.88C21.82,15.54 21.53,16.07 21,16.62C20.22,17.5 19.1,17.92 17.66,17.92C16.47,17.92 15.43,17.55 14.5,16.82C13.62,16.09 13.16,14.9 13.16,13.25C13.16,11.7 13.57,10.5 14.39,9.7C15.21,8.87 16.27,8.46 17.58,8.46C18.35,8.46 19.05,8.6 19.67,8.88C20.29,9.16 20.81,9.59 21.21,10.2C21.58,10.73 21.81,11.34 21.92,12.04M9.58,14.07C9.58,13.42 9.31,12.97 8.79,12.73C8.5,12.6 8.08,12.53 7.54,12.5H4.87V15.84H7.5C8.04,15.84 8.46,15.77 8.76,15.62C9.31,15.35 9.58,14.83 9.58,14.07M4.87,10.46H7.5C8.04,10.46 8.5,10.36 8.82,10.15C9.16,9.95 9.32,9.58 9.32,9.06C9.32,8.5 9.1,8.1 8.66,7.91C8.27,7.78 7.78,7.72 7.19,7.72H4.87M11.72,12.42C12.04,12.92 12.2,13.53 12.2,14.24C12.2,15 12,15.64 11.65,16.23C11.41,16.62 11.12,16.94 10.77,17.21C10.37,17.5 9.9,17.72 9.36,17.83C8.82,17.94 8.24,18 7.61,18H2V5.55H8C9.53,5.58 10.6,6 11.23,6.88C11.61,7.41 11.8,8.04 11.8,8.78C11.8,9.54 11.61,10.15 11.23,10.61C11,10.87 10.7,11.11 10.28,11.32C10.91,11.55 11.39,11.92 11.72,12.42M20.06,7.32H15.05V6.07H20.06V7.32Z' })
	  );
	};
	
	var BellOffIcon = function BellOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,18.69L7.84,6.14L5.27,3.5L4,4.76L6.8,7.56V7.57C6.28,8.56 6,9.73 6,11V16L4,18V19H17.73L19.73,21L21,19.72L20,18.69M12,22C13.11,22 14,21.11 14,20H10C10,21.11 10.89,22 12,22M18,14.68V11C18,7.92 16.36,5.36 13.5,4.68V4C13.5,3.17 12.83,2.5 12,2.5C11.17,2.5 10.5,3.17 10.5,4V4.68C10.35,4.71 10.21,4.76 10.08,4.8C10,4.83 9.88,4.87 9.78,4.91L9.75,4.92C9.5,5 9.29,5.12 9.06,5.24L18,14.68Z' })
	  );
	};
	
	var BellOutlineIcon = function BellOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,17H7V10.5C7,8 9,6 11.5,6C14,6 16,8 16,10.5M18,16V10.5C18,7.43 15.86,4.86 13,4.18V3.5C13,2.67 12.33,2 11.5,2C10.67,2 10,2.67 10,3.5V4.18C7.13,4.86 5,7.43 5,10.5V16L3,18V19H20V18M11.5,22C12.6,22 13.5,21.1 13.5,20H9.5C9.5,21.1 10.4,22 11.5,22Z' })
	  );
	};
	
	var BellPlusIcon = function BellPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,21C10,22.11 10.9,23 12,23C13.1,23 14,22.1 14,21M18.88,16.82V11C18.88,7.75 16.63,5.03 13.59,4.31V3.59C13.59,2.71 12.88,2 12,2C11.12,2 10.41,2.71 10.41,3.59V4.31C7.37,5.03 5.12,7.75 5.12,11V16.82L3,18.94V20H21V18.94M16,13H13V16H11V13H8V11H11V8H13V11H16' })
	  );
	};
	
	var BellRingOutlineIcon = function BellRingOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,17V10.5C16,8 14,6 11.5,6C9,6 7,8 7,10.5V17H16M18,16L20,18V19H3V18L5,16V10.5C5,7.43 7.13,4.86 10,4.18V3.5C10,2.67 10.67,2 11.5,2C12.33,2 13,2.67 13,3.5V4.18C15.86,4.86 18,7.43 18,10.5V16M11.5,22C10.4,22 9.5,21.1 9.5,20H13.5C13.5,21.1 12.6,22 11.5,22M19.97,10C19.82,7.35 18.46,5 16.42,3.58L17.85,2.15C20.24,3.97 21.82,6.79 21.97,10H19.97M6.58,3.58C4.54,5 3.18,7.35 3,10H1C1.18,6.79 2.76,3.97 5.15,2.15L6.58,3.58Z' })
	  );
	};
	
	var BellRingIcon = function BellRingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.5,22C11.64,22 11.77,22 11.9,21.96C12.55,21.82 13.09,21.38 13.34,20.78C13.44,20.54 13.5,20.27 13.5,20H9.5C9.5,21.1 10.4,22 11.5,22M18,10.5C18,7.43 15.86,4.86 13,4.18V3.5C13,2.67 12.33,2 11.5,2C10.67,2 10,2.67 10,3.5V4.18C7.13,4.86 5,7.43 5,10.5V16L3,18V19H20V18L18,16M19.97,10H21.97C21.82,6.79 20.24,3.97 17.85,2.15L16.42,3.58C18.46,5 19.82,7.35 19.97,10M6.58,3.58L5.15,2.15C2.76,3.97 1.18,6.79 1,10H3C3.18,7.35 4.54,5 6.58,3.58Z' })
	  );
	};
	
	var BellSleepIcon = function BellSleepIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,9.8L11.2,13.2H14V15H9V13.2L11.8,9.8H9V8H14M18,16V10.5C18,7.43 15.86,4.86 13,4.18V3.5C13,2.67 12.33,2 11.5,2C10.67,2 10,2.67 10,3.5V4.18C7.13,4.86 5,7.43 5,10.5V16L3,18V19H20V18M11.5,22C12.6,22 13.5,21.1 13.5,20H9.5C9.5,21.1 10.4,22 11.5,22Z' })
	  );
	};
	
	var BellIcon = function BellIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,22C13.1,22 14,21.1 14,20H10C10,21.1 10.9,22 12,22M18,16V11C18,7.93 16.36,5.36 13.5,4.68V4C13.5,3.17 12.83,2.5 12,2.5C11.17,2.5 10.5,3.17 10.5,4V4.68C7.63,5.36 6,7.92 6,11V16L4,18V19H20V18L18,16Z' })
	  );
	};
	
	var BetaIcon = function BetaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.23,17.59V23.12H6.88V6.72C6.88,5.27 7.31,4.13 8.16,3.28C9,2.43 10.17,2 11.61,2C13,2 14.07,2.34 14.87,3C15.66,3.68 16.05,4.62 16.05,5.81C16.05,6.63 15.79,7.4 15.27,8.11C14.75,8.82 14.08,9.31 13.25,9.58V9.62C14.5,9.82 15.47,10.27 16.13,11C16.79,11.71 17.12,12.62 17.12,13.74C17.12,15.06 16.66,16.14 15.75,16.97C14.83,17.8 13.63,18.21 12.13,18.21C11.07,18.21 10.1,18 9.23,17.59M10.72,10.75V8.83C11.59,8.72 12.3,8.4 12.87,7.86C13.43,7.31 13.71,6.7 13.71,6C13.71,4.62 13,3.92 11.6,3.92C10.84,3.92 10.25,4.16 9.84,4.65C9.43,5.14 9.23,5.82 9.23,6.71V15.5C10.14,16.03 11.03,16.29 11.89,16.29C12.73,16.29 13.39,16.07 13.86,15.64C14.33,15.2 14.56,14.58 14.56,13.79C14.56,12 13.28,11 10.72,10.75Z' })
	  );
	};
	
	var BibleIcon = function BibleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.81,2H7V9L9.5,7.5L12,9V2H18C19.1,2 20,2.9 20,4V20C20,21.05 19.05,22 18,22H6C4.95,22 4,21.05 4,20V4C4,3 4.83,2.09 5.81,2M13,10V13H10V15H13V20H15V15H18V13H15V10H13Z' })
	  );
	};
	
	var BikeIcon = function BikeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,20.5C3.07,20.5 1.5,18.93 1.5,17C1.5,15.07 3.07,13.5 5,13.5C6.93,13.5 8.5,15.07 8.5,17C8.5,18.93 6.93,20.5 5,20.5M5,12C2.24,12 0,14.24 0,17C0,19.76 2.24,22 5,22C7.76,22 10,19.76 10,17C10,14.24 7.76,12 5,12M14.8,10H19V8.2H15.8L13.86,4.93C13.57,4.43 13,4.1 12.4,4.1C11.93,4.1 11.5,4.29 11.2,4.6L7.5,8.29C7.19,8.6 7,9 7,9.5C7,10.13 7.33,10.66 7.85,10.97L11.2,13V18H13V11.5L10.75,9.85L13.07,7.5M19,20.5C17.07,20.5 15.5,18.93 15.5,17C15.5,15.07 17.07,13.5 19,13.5C20.93,13.5 22.5,15.07 22.5,17C22.5,18.93 20.93,20.5 19,20.5M19,12C16.24,12 14,14.24 14,17C14,19.76 16.24,22 19,22C21.76,22 24,19.76 24,17C24,14.24 21.76,12 19,12M16,4.8C17,4.8 17.8,4 17.8,3C17.8,2 17,1.2 16,1.2C15,1.2 14.2,2 14.2,3C14.2,4 15,4.8 16,4.8Z' })
	  );
	};
	
	var BingIcon = function BingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3V19L8.72,21L18,15.82V11.73H18L9.77,8.95L11.38,12.84L13.94,14L8.7,16.92V4.27L5,3' })
	  );
	};
	
	var BinocularsIcon = function BinocularsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,6H13V13H11V6M9,20C9,20.55 8.55,21 8,21H5C4.45,21 4,20.55 4,20V15L6,6H10V13C10,13.55 9.55,14 9,14V20M10,5H7V3H10V5M15,20V14C14.45,14 14,13.55 14,13V6H18L20,15V20C20,20.55 19.55,21 19,21H16C15.45,21 15,20.55 15,20M14,5V3H17V5H14Z' })
	  );
	};
	
	var BioIcon = function BioIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,12H20C21.1,12 22,12.9 22,14V17C22,18.1 21.1,19 20,19H17C15.9,19 15,18.1 15,17V14C15,12.9 15.9,12 17,12M17,14V17H20V14H17M2,7H7C8.1,7 9,7.9 9,9V11C9,12.1 8.1,13 7,13C8.1,13 9,13.9 9,15V17C9,18.1 8.1,19 7,19H2V13L2,7M4,9V12H7V9H4M4,17H7V14H4V17M11,13H13V19H11V13M11,9H13V11H11V9Z' })
	  );
	};
	
	var BiohazardIcon = function BiohazardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,16.06C23,16.29 23,16.5 22.96,16.7C22.78,14.14 20.64,12.11 18,12.11C17.63,12.11 17.27,12.16 16.92,12.23C16.96,12.5 17,12.73 17,13C17,15.35 15.31,17.32 13.07,17.81C13.42,20.05 15.31,21.79 17.65,21.96C17.43,22 17.22,22 17,22C14.92,22 13.07,20.94 12,19.34C10.93,20.94 9.09,22 7,22C6.78,22 6.57,22 6.35,21.96C8.69,21.79 10.57,20.06 10.93,17.81C8.68,17.32 7,15.35 7,13C7,12.73 7.04,12.5 7.07,12.23C6.73,12.16 6.37,12.11 6,12.11C3.36,12.11 1.22,14.14 1.03,16.7C1,16.5 1,16.29 1,16.06C1,12.85 3.59,10.24 6.81,10.14C6.3,9.27 6,8.25 6,7.17C6,4.94 7.23,3 9.06,2C7.81,2.9 7,4.34 7,6C7,7.35 7.56,8.59 8.47,9.5C9.38,8.59 10.62,8.04 12,8.04C13.37,8.04 14.62,8.59 15.5,9.5C16.43,8.59 17,7.35 17,6C17,4.34 16.18,2.9 14.94,2C16.77,3 18,4.94 18,7.17C18,8.25 17.7,9.27 17.19,10.14C20.42,10.24 23,12.85 23,16.06M9.27,10.11C10.05,10.62 11,10.92 12,10.92C13,10.92 13.95,10.62 14.73,10.11C14,9.45 13.06,9.03 12,9.03C10.94,9.03 10,9.45 9.27,10.11M12,14.47C12.82,14.47 13.5,13.8 13.5,13C13.5,12.17 12.83,11.5 12,11.5C11.17,11.5 10.5,12.17 10.5,13C10.5,13.8 11.17,14.47 12,14.47M10.97,16.79C10.87,14.9 9.71,13.29 8.05,12.55C8.03,12.7 8,12.84 8,13C8,14.82 9.27,16.34 10.97,16.79M15.96,12.55C14.29,13.29 13.12,14.9 13,16.79C14.73,16.34 16,14.82 16,13C16,12.84 15.97,12.7 15.96,12.55Z' })
	  );
	};
	
	var BitbucketIcon = function BitbucketIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.43,2C21.79,2.07 22.03,2.42 22,2.82L21.12,8.7L19.27,21.4C19.2,21.75 18.95,22 18.63,22H5.37C5.05,22 4.8,21.75 4.73,21.4L2.88,8.7L2,2.82C1.97,2.42 2.21,2.07 2.57,2H21.43M14.08,15.26L15.1,8.7H8.9L9.92,15.26H14.08Z' })
	  );
	};
	
	var BitcoinIcon = function BitcoinIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.5,5H8V2H10V5H11.5V2H13.5V5C19,5 19,11 16,11.25C20,11 21,19 13.5,19V22H11.5V19H10V22H8V19H4.5L5,17H6C6.55,17 7,16.55 7,16V8C7,7.45 6.55,7 6,7H4.5V5M10,7V11C10,11 14.5,11.25 14.5,9C14.5,6.75 10,7 10,7M10,12.5V17C10,17 15.5,17 15.5,14.75C15.5,12.5 10,12.5 10,12.5Z' })
	  );
	};
	
	var BlackMesaIcon = function BlackMesaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,14.39 5.05,16.53 6.71,18H9V12H17L19.15,15.59C19.69,14.5 20,13.29 20,12C20,7.58 16.42,4 12,4Z' })
	  );
	};
	
	var BlackberryIcon = function BlackberryIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.45,10.28C6.4,10.28 7.5,11.05 7.5,12C7.5,12.95 6.4,13.72 5.45,13.72H2L2.69,10.28H5.45M6.14,4.76C7.09,4.76 8.21,5.53 8.21,6.5C8.21,7.43 7.09,8.21 6.14,8.21H2.69L3.38,4.76H6.14M13.03,4.76C14,4.76 15.1,5.53 15.1,6.5C15.1,7.43 14,8.21 13.03,8.21H9.41L10.1,4.76H13.03M12.34,10.28C13.3,10.28 14.41,11.05 14.41,12C14.41,12.95 13.3,13.72 12.34,13.72H8.72L9.41,10.28H12.34M10.97,15.79C11.92,15.79 13.03,16.57 13.03,17.5C13.03,18.47 11.92,19.24 10.97,19.24H7.5L8.21,15.79H10.97M18.55,13.72C19.5,13.72 20.62,14.5 20.62,15.45C20.62,16.4 19.5,17.17 18.55,17.17H15.1L15.79,13.72H18.55M19.93,8.21C20.88,8.21 22,9 22,9.93C22,10.88 20.88,11.66 19.93,11.66H16.5L17.17,8.21H19.93Z' })
	  );
	};
	
	var BlenderIcon = function BlenderIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,3C8,3.34 8.17,3.69 8.5,3.88L12,6H2.5C1.67,6 1,6.67 1,7.5C1,8.33 1.67,9 2.5,9H8.41L2,13C1.16,13.5 1,14.22 1,15C1,16 1.77,17 3,17C3.69,17 4.39,16.5 5,16L7,14.38C7.2,18.62 10.71,22 15,22C19.42,22 23,18.42 23,14C23,11.08 21.43,8.5 19.09,7.13C19.06,7.11 19.03,7.08 19,7.06C19,7.06 18.92,7 18.86,6.97C15.76,4.88 13.03,3.72 9.55,2.13C9.34,2.04 9.16,2 9,2C8.4,2 8,2.46 8,3M15,9C17.76,9 20,11.24 20,14C20,16.76 17.76,19 15,19C12.24,19 10,16.76 10,14C10,11.24 12.24,9 15,9M15,10.5C13.07,10.5 11.5,12.07 11.5,14C11.5,15.93 13.07,17.5 15,17.5C16.93,17.5 18.5,15.93 18.5,14C18.5,12.07 16.93,10.5 15,10.5Z' })
	  );
	};
	
	var BlindsIcon = function BlindsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,2H21C21.55,2 22,2.45 22,3V5C22,5.55 21.55,6 21,6H20V13C20,13.55 19.55,14 19,14H13V16.17C14.17,16.58 15,17.69 15,19C15,20.66 13.66,22 12,22C10.34,22 9,20.66 9,19C9,17.69 9.83,16.58 11,16.17V14H5C4.45,14 4,13.55 4,13V6H3C2.45,6 2,5.55 2,5V3C2,2.45 2.45,2 3,2M12,18C11.45,18 11,18.45 11,19C11,19.55 11.45,20 12,20C12.55,20 13,19.55 13,19C13,18.45 12.55,18 12,18Z' })
	  );
	};
	
	var BlockHelperIcon = function BlockHelperIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,0C18.63,0 24,5.37 24,12C24,18.63 18.63,24 12,24C5.37,24 0,18.63 0,12C0,5.37 5.37,0 12,0M12,2C6.48,2 2,6.48 2,12C2,14.4 2.85,16.6 4.26,18.33L18.33,4.26C16.6,2.85 14.4,2 12,2M12,22C17.52,22 22,17.52 22,12C22,9.6 21.15,7.4 19.74,5.67L5.67,19.74C7.4,21.15 9.6,22 12,22Z' })
	  );
	};
	
	var BloggerIcon = function BloggerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,13H9.95C9.4,13 8.95,13.45 8.95,14C8.95,14.55 9.4,15 9.95,15H14C14.55,15 15,14.55 15,14C15,13.45 14.55,13 14,13M9.95,10H12.55C13.1,10 13.55,9.55 13.55,9C13.55,8.45 13.1,8 12.55,8H9.95C9.4,8 8.95,8.45 8.95,9C8.95,9.55 9.4,10 9.95,10M16,9V10C16,10.55 16.45,11 17,11C17.55,11 18,11.45 18,12V15C18,16.66 16.66,18 15,18H9C7.34,18 6,16.66 6,15V8C6,6.34 7.34,5 9,5H13C14.66,5 16,6.34 16,8M20,2H4C2.89,2 2,2.89 2,4V20C2,21.1 2.9,22 4,22H20C21.1,22 22,21.1 22,20V4C22,2.89 21.1,2 20,2Z' })
	  );
	};
	
	var BluetoothAudioIcon = function BluetoothAudioIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.88,16.29L11,18.17V14.41M11,5.83L12.88,7.71L11,9.58M15.71,7.71L10,2H9V9.58L4.41,5L3,6.41L8.59,12L3,17.58L4.41,19L9,14.41V22H10L15.71,16.29L11.41,12M19.53,6.71L18.26,8C18.89,9.18 19.25,10.55 19.25,12C19.25,13.45 18.89,14.82 18.26,16L19.46,17.22C20.43,15.68 21,13.87 21,11.91C21,10 20.46,8.23 19.53,6.71M14.24,12L16.56,14.33C16.84,13.6 17,12.82 17,12C17,11.18 16.84,10.4 16.57,9.68L14.24,12Z' })
	  );
	};
	
	var BluetoothConnectIcon = function BluetoothConnectIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,10L17,12L19,14L21,12M14.88,16.29L13,18.17V14.41M13,5.83L14.88,7.71L13,9.58M17.71,7.71L12,2H11V9.58L6.41,5L5,6.41L10.59,12L5,17.58L6.41,19L11,14.41V22H12L17.71,16.29L13.41,12M7,12L5,10L3,12L5,14L7,12Z' })
	  );
	};
	
	var BluetoothOffIcon = function BluetoothOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,5.83L14.88,7.71L13.28,9.31L14.69,10.72L17.71,7.7L12,2H11V7.03L13,9.03M5.41,4L4,5.41L10.59,12L5,17.59L6.41,19L11,14.41V22H12L16.29,17.71L18.59,20L20,18.59M13,18.17V14.41L14.88,16.29' })
	  );
	};
	
	var BluetoothSettingsIcon = function BluetoothSettingsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.88,14.29L13,16.17V12.41L14.88,14.29M13,3.83L14.88,5.71L13,7.59M17.71,5.71L12,0H11V7.59L6.41,3L5,4.41L10.59,10L5,15.59L6.41,17L11,12.41V20H12L17.71,14.29L13.41,10L17.71,5.71M15,24H17V22H15M7,24H9V22H7M11,24H13V22H11V24Z' })
	  );
	};
	
	var BluetoothTransferIcon = function BluetoothTransferIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.71,7.71L10.41,12L14.71,16.29L9,22H8V14.41L3.41,19L2,17.59L7.59,12L2,6.41L3.41,5L8,9.59V2H9L14.71,7.71M10,5.83V9.59L11.88,7.71L10,5.83M11.88,16.29L10,14.41V18.17L11.88,16.29M22,8H20V11H18V8H16L19,4L22,8M22,16L19,20L16,16H18V13H20V16H22Z' })
	  );
	};
	
	var BluetoothIcon = function BluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.88,16.29L13,18.17V14.41M13,5.83L14.88,7.71L13,9.58M17.71,7.71L12,2H11V9.58L6.41,5L5,6.41L10.59,12L5,17.58L6.41,19L11,14.41V22H12L17.71,16.29L13.41,12L17.71,7.71Z' })
	  );
	};
	
	var BlurLinearIcon = function BlurLinearIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,17C13.55,17 14,16.55 14,16C14,15.45 13.55,15 13,15C12.45,15 12,15.45 12,16C12,16.55 12.45,17 13,17M13,13C13.55,13 14,12.55 14,12C14,11.45 13.55,11 13,11C12.45,11 12,11.45 12,12C12,12.55 12.45,13 13,13M13,9C13.55,9 14,8.55 14,8C14,7.45 13.55,7 13,7C12.45,7 12,7.45 12,8C12,8.55 12.45,9 13,9M17,12.5C17.28,12.5 17.5,12.28 17.5,12C17.5,11.72 17.28,11.5 17,11.5C16.72,11.5 16.5,11.72 16.5,12C16.5,12.28 16.72,12.5 17,12.5M17,8.5C17.28,8.5 17.5,8.28 17.5,8C17.5,7.72 17.28,7.5 17,7.5C16.72,7.5 16.5,7.72 16.5,8C16.5,8.28 16.72,8.5 17,8.5M3,3V5H21V3M17,16.5C17.28,16.5 17.5,16.28 17.5,16C17.5,15.72 17.28,15.5 17,15.5C16.72,15.5 16.5,15.72 16.5,16C16.5,16.28 16.72,16.5 17,16.5M9,17C9.55,17 10,16.55 10,16C10,15.45 9.55,15 9,15C8.45,15 8,15.45 8,16C8,16.55 8.45,17 9,17M5,13.5C5.83,13.5 6.5,12.83 6.5,12C6.5,11.17 5.83,10.5 5,10.5C4.17,10.5 3.5,11.17 3.5,12C3.5,12.83 4.17,13.5 5,13.5M5,9.5C5.83,9.5 6.5,8.83 6.5,8C6.5,7.17 5.83,6.5 5,6.5C4.17,6.5 3.5,7.17 3.5,8C3.5,8.83 4.17,9.5 5,9.5M3,21H21V19H3M9,9C9.55,9 10,8.55 10,8C10,7.45 9.55,7 9,7C8.45,7 8,7.45 8,8C8,8.55 8.45,9 9,9M9,13C9.55,13 10,12.55 10,12C10,11.45 9.55,11 9,11C8.45,11 8,11.45 8,12C8,12.55 8.45,13 9,13M5,17.5C5.83,17.5 6.5,16.83 6.5,16C6.5,15.17 5.83,14.5 5,14.5C4.17,14.5 3.5,15.17 3.5,16C3.5,16.83 4.17,17.5 5,17.5Z' })
	  );
	};
	
	var BlurOffIcon = function BlurOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,13.5C2.72,13.5 2.5,13.72 2.5,14C2.5,14.28 2.72,14.5 3,14.5C3.28,14.5 3.5,14.28 3.5,14C3.5,13.72 3.28,13.5 3,13.5M6,17C5.45,17 5,17.45 5,18C5,18.55 5.45,19 6,19C6.55,19 7,18.55 7,18C7,17.45 6.55,17 6,17M10,20.5C9.72,20.5 9.5,20.72 9.5,21C9.5,21.28 9.72,21.5 10,21.5C10.28,21.5 10.5,21.28 10.5,21C10.5,20.72 10.28,20.5 10,20.5M3,9.5C2.72,9.5 2.5,9.72 2.5,10C2.5,10.28 2.72,10.5 3,10.5C3.28,10.5 3.5,10.28 3.5,10C3.5,9.72 3.28,9.5 3,9.5M6,13C5.45,13 5,13.45 5,14C5,14.55 5.45,15 6,15C6.55,15 7,14.55 7,14C7,13.45 6.55,13 6,13M21,13.5C20.72,13.5 20.5,13.72 20.5,14C20.5,14.28 20.72,14.5 21,14.5C21.28,14.5 21.5,14.28 21.5,14C21.5,13.72 21.28,13.5 21,13.5M10,17C9.45,17 9,17.45 9,18C9,18.55 9.45,19 10,19C10.55,19 11,18.55 11,18C11,17.45 10.55,17 10,17M2.5,5.27L6.28,9.05L6,9C5.45,9 5,9.45 5,10C5,10.55 5.45,11 6,11C6.55,11 7,10.55 7,10C7,9.9 6.97,9.81 6.94,9.72L9.75,12.53C9.04,12.64 8.5,13.26 8.5,14C8.5,14.83 9.17,15.5 10,15.5C10.74,15.5 11.36,14.96 11.47,14.25L14.28,17.06C14.19,17.03 14.1,17 14,17C13.45,17 13,17.45 13,18C13,18.55 13.45,19 14,19C14.55,19 15,18.55 15,18C15,17.9 14.97,17.81 14.94,17.72L18.72,21.5L20,20.23L3.77,4L2.5,5.27M14,20.5C13.72,20.5 13.5,20.72 13.5,21C13.5,21.28 13.72,21.5 14,21.5C14.28,21.5 14.5,21.28 14.5,21C14.5,20.72 14.28,20.5 14,20.5M18,7C18.55,7 19,6.55 19,6C19,5.45 18.55,5 18,5C17.45,5 17,5.45 17,6C17,6.55 17.45,7 18,7M18,11C18.55,11 19,10.55 19,10C19,9.45 18.55,9 18,9C17.45,9 17,9.45 17,10C17,10.55 17.45,11 18,11M18,15C18.55,15 19,14.55 19,14C19,13.45 18.55,13 18,13C17.45,13 17,13.45 17,14C17,14.55 17.45,15 18,15M10,7C10.55,7 11,6.55 11,6C11,5.45 10.55,5 10,5C9.45,5 9,5.45 9,6C9,6.55 9.45,7 10,7M21,10.5C21.28,10.5 21.5,10.28 21.5,10C21.5,9.72 21.28,9.5 21,9.5C20.72,9.5 20.5,9.72 20.5,10C20.5,10.28 20.72,10.5 21,10.5M10,3.5C10.28,3.5 10.5,3.28 10.5,3C10.5,2.72 10.28,2.5 10,2.5C9.72,2.5 9.5,2.72 9.5,3C9.5,3.28 9.72,3.5 10,3.5M14,3.5C14.28,3.5 14.5,3.28 14.5,3C14.5,2.72 14.28,2.5 14,2.5C13.72,2.5 13.5,2.72 13.5,3C13.5,3.28 13.72,3.5 14,3.5M13.8,11.5H14C14.83,11.5 15.5,10.83 15.5,10C15.5,9.17 14.83,8.5 14,8.5C13.17,8.5 12.5,9.17 12.5,10V10.2C12.61,10.87 13.13,11.39 13.8,11.5M14,7C14.55,7 15,6.55 15,6C15,5.45 14.55,5 14,5C13.45,5 13,5.45 13,6C13,6.55 13.45,7 14,7Z' })
	  );
	};
	
	var BlurRadialIcon = function BlurRadialIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,13C13.45,13 13,13.45 13,14C13,14.55 13.45,15 14,15C14.55,15 15,14.55 15,14C15,13.45 14.55,13 14,13M14,16.5C13.72,16.5 13.5,16.72 13.5,17C13.5,17.28 13.72,17.5 14,17.5C14.28,17.5 14.5,17.28 14.5,17C14.5,16.72 14.28,16.5 14,16.5M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M17,9.5C16.72,9.5 16.5,9.72 16.5,10C16.5,10.28 16.72,10.5 17,10.5C17.28,10.5 17.5,10.28 17.5,10C17.5,9.72 17.28,9.5 17,9.5M17,13.5C16.72,13.5 16.5,13.72 16.5,14C16.5,14.28 16.72,14.5 17,14.5C17.28,14.5 17.5,14.28 17.5,14C17.5,13.72 17.28,13.5 17,13.5M14,7.5C14.28,7.5 14.5,7.28 14.5,7C14.5,6.72 14.28,6.5 14,6.5C13.72,6.5 13.5,6.72 13.5,7C13.5,7.28 13.72,7.5 14,7.5M14,9C13.45,9 13,9.45 13,10C13,10.55 13.45,11 14,11C14.55,11 15,10.55 15,10C15,9.45 14.55,9 14,9M10,7.5C10.28,7.5 10.5,7.28 10.5,7C10.5,6.72 10.28,6.5 10,6.5C9.72,6.5 9.5,6.72 9.5,7C9.5,7.28 9.72,7.5 10,7.5M7,13.5C6.72,13.5 6.5,13.72 6.5,14C6.5,14.28 6.72,14.5 7,14.5C7.28,14.5 7.5,14.28 7.5,14C7.5,13.72 7.28,13.5 7,13.5M10,16.5C9.72,16.5 9.5,16.72 9.5,17C9.5,17.28 9.72,17.5 10,17.5C10.28,17.5 10.5,17.28 10.5,17C10.5,16.72 10.28,16.5 10,16.5M7,9.5C6.72,9.5 6.5,9.72 6.5,10C6.5,10.28 6.72,10.5 7,10.5C7.28,10.5 7.5,10.28 7.5,10C7.5,9.72 7.28,9.5 7,9.5M10,13C9.45,13 9,13.45 9,14C9,14.55 9.45,15 10,15C10.55,15 11,14.55 11,14C11,13.45 10.55,13 10,13M10,9C9.45,9 9,9.45 9,10C9,10.55 9.45,11 10,11C10.55,11 11,10.55 11,10C11,9.45 10.55,9 10,9Z' })
	  );
	};
	
	var BlurIcon = function BlurIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,8.5C13.17,8.5 12.5,9.17 12.5,10C12.5,10.83 13.17,11.5 14,11.5C14.83,11.5 15.5,10.83 15.5,10C15.5,9.17 14.83,8.5 14,8.5M14,12.5C13.17,12.5 12.5,13.17 12.5,14C12.5,14.83 13.17,15.5 14,15.5C14.83,15.5 15.5,14.83 15.5,14C15.5,13.17 14.83,12.5 14,12.5M10,17C9.45,17 9,17.45 9,18C9,18.55 9.45,19 10,19C10.55,19 11,18.55 11,18C11,17.45 10.55,17 10,17M10,8.5C9.17,8.5 8.5,9.17 8.5,10C8.5,10.83 9.17,11.5 10,11.5C10.83,11.5 11.5,10.83 11.5,10C11.5,9.17 10.83,8.5 10,8.5M14,20.5C13.72,20.5 13.5,20.72 13.5,21C13.5,21.28 13.72,21.5 14,21.5C14.28,21.5 14.5,21.28 14.5,21C14.5,20.72 14.28,20.5 14,20.5M14,17C13.45,17 13,17.45 13,18C13,18.55 13.45,19 14,19C14.55,19 15,18.55 15,18C15,17.45 14.55,17 14,17M21,13.5C20.72,13.5 20.5,13.72 20.5,14C20.5,14.28 20.72,14.5 21,14.5C21.28,14.5 21.5,14.28 21.5,14C21.5,13.72 21.28,13.5 21,13.5M18,5C17.45,5 17,5.45 17,6C17,6.55 17.45,7 18,7C18.55,7 19,6.55 19,6C19,5.45 18.55,5 18,5M18,9C17.45,9 17,9.45 17,10C17,10.55 17.45,11 18,11C18.55,11 19,10.55 19,10C19,9.45 18.55,9 18,9M18,17C17.45,17 17,17.45 17,18C17,18.55 17.45,19 18,19C18.55,19 19,18.55 19,18C19,17.45 18.55,17 18,17M18,13C17.45,13 17,13.45 17,14C17,14.55 17.45,15 18,15C18.55,15 19,14.55 19,14C19,13.45 18.55,13 18,13M10,12.5C9.17,12.5 8.5,13.17 8.5,14C8.5,14.83 9.17,15.5 10,15.5C10.83,15.5 11.5,14.83 11.5,14C11.5,13.17 10.83,12.5 10,12.5M10,7C10.55,7 11,6.55 11,6C11,5.45 10.55,5 10,5C9.45,5 9,5.45 9,6C9,6.55 9.45,7 10,7M10,3.5C10.28,3.5 10.5,3.28 10.5,3C10.5,2.72 10.28,2.5 10,2.5C9.72,2.5 9.5,2.72 9.5,3C9.5,3.28 9.72,3.5 10,3.5M10,20.5C9.72,20.5 9.5,20.72 9.5,21C9.5,21.28 9.72,21.5 10,21.5C10.28,21.5 10.5,21.28 10.5,21C10.5,20.72 10.28,20.5 10,20.5M3,13.5C2.72,13.5 2.5,13.72 2.5,14C2.5,14.28 2.72,14.5 3,14.5C3.28,14.5 3.5,14.28 3.5,14C3.5,13.72 3.28,13.5 3,13.5M14,3.5C14.28,3.5 14.5,3.28 14.5,3C14.5,2.72 14.28,2.5 14,2.5C13.72,2.5 13.5,2.72 13.5,3C13.5,3.28 13.72,3.5 14,3.5M14,7C14.55,7 15,6.55 15,6C15,5.45 14.55,5 14,5C13.45,5 13,5.45 13,6C13,6.55 13.45,7 14,7M21,10.5C21.28,10.5 21.5,10.28 21.5,10C21.5,9.72 21.28,9.5 21,9.5C20.72,9.5 20.5,9.72 20.5,10C20.5,10.28 20.72,10.5 21,10.5M6,5C5.45,5 5,5.45 5,6C5,6.55 5.45,7 6,7C6.55,7 7,6.55 7,6C7,5.45 6.55,5 6,5M3,9.5C2.72,9.5 2.5,9.72 2.5,10C2.5,10.28 2.72,10.5 3,10.5C3.28,10.5 3.5,10.28 3.5,10C3.5,9.72 3.28,9.5 3,9.5M6,9C5.45,9 5,9.45 5,10C5,10.55 5.45,11 6,11C6.55,11 7,10.55 7,10C7,9.45 6.55,9 6,9M6,17C5.45,17 5,17.45 5,18C5,18.55 5.45,19 6,19C6.55,19 7,18.55 7,18C7,17.45 6.55,17 6,17M6,13C5.45,13 5,13.45 5,14C5,14.55 5.45,15 6,15C6.55,15 7,14.55 7,14C7,13.45 6.55,13 6,13Z' })
	  );
	};
	
	var BombOffIcon = function BombOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.5,2.75C12.7,2.75 11.25,4.2 11.25,6H10V7.29C9.31,7.5 8.67,7.81 8.08,8.2L17.79,17.91C18.58,16.76 19,15.39 19,14C19,10.83 16.89,8.15 14,7.29V6H12.75C12.75,5.03 13.53,4.25 14.5,4.25C15.47,4.25 16.25,5.03 16.25,6C16.25,7.24 17.26,8.25 18.5,8.25C19.74,8.25 20.74,7.24 20.74,6V5.25H19.25V6C19.25,6.42 18.91,6.75 18.5,6.75C18.08,6.75 17.75,6.42 17.75,6C17.75,4.2 16.29,2.75 14.5,2.75M3.41,6.36L2,7.77L5.55,11.32C5.2,12.14 5,13.04 5,14C5,17.86 8.13,21 12,21C12.92,21 13.83,20.81 14.68,20.45L18.23,24L19.64,22.59L3.41,6.36Z' })
	  );
	};
	
	var BombIcon = function BombIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.25,6C11.25,4.21 12.71,2.75 14.5,2.75C16.29,2.75 17.75,4.21 17.75,6C17.75,6.42 18.08,6.75 18.5,6.75C18.92,6.75 19.25,6.42 19.25,6V5.25H20.75V6C20.75,7.24 19.74,8.25 18.5,8.25C17.26,8.25 16.25,7.24 16.25,6C16.25,5.03 15.47,4.25 14.5,4.25C13.53,4.25 12.75,5.03 12.75,6H14V7.29C16.89,8.15 19,10.83 19,14C19,17.87 15.87,21 12,21C8.13,21 5,17.87 5,14C5,10.83 7.11,8.15 10,7.29V6H11.25M22,6H24V7H22V6M19,4V2H20V4H19M20.91,4.38L22.33,2.96L23.04,3.67L21.62,5.09L20.91,4.38Z' })
	  );
	};
	
	var BoneIcon = function BoneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,14C8,15.66 6.66,17 5,17C3.34,17 2,15.66 2,14C2,13.23 2.29,12.53 2.76,12C2.29,11.47 2,10.77 2,10C2,8.34 3.34,7 5,7C6.66,7 8,8.34 8,10C9.33,10.08 10.67,10.17 12,10.17C13.33,10.17 14.67,10.08 16,10C16,8.34 17.34,7 19,7C20.66,7 22,8.34 22,10C22,10.77 21.71,11.47 21.24,12C21.71,12.53 22,13.23 22,14C22,15.66 20.66,17 19,17C17.34,17 16,15.66 16,14C14.67,13.92 13.33,13.83 12,13.83C10.67,13.83 9.33,13.92 8,14Z' })
	  );
	};
	
	var BookMinusIcon = function BookMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,22H6C4.9,22 4,21.1 4,20V4C4,2.89 4.9,2 6,2H7V9L9.5,7.5L12,9V2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22M18,18V16H12V18H18Z' })
	  );
	};
	
	var BookMultipleVariantIcon = function BookMultipleVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,18H9C7.9,18 7,17.1 7,16V4C7,2.9 7.9,2 9,2H19C20.1,2 21,2.9 21,4V16C21,17.1 20.1,18 19,18M10,9L12,7.5L14,9V4H10V9M17,20V22H5C3.9,22 3,21.1 3,20V6H5V20H17Z' })
	  );
	};
	
	var BookMultipleIcon = function BookMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,18H9C7.9,18 7,17.1 7,16V4C7,2.9 7.9,2 9,2H10V7L12,5.5L14,7V2H19C20.1,2 21,2.9 21,4V16C21,17.1 20.1,18 19,18M17,20V22H5C3.9,22 3,21.1 3,20V6H5V20H17Z' })
	  );
	};
	
	var BookOpenPageVariantIcon = function BookOpenPageVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,2L14,6.5V17.5L19,13V2M6.5,5C4.55,5 2.45,5.4 1,6.5V21.16C1,21.41 1.25,21.66 1.5,21.66C1.6,21.66 1.65,21.59 1.75,21.59C3.1,20.94 5.05,20.5 6.5,20.5C8.45,20.5 10.55,20.9 12,22C13.35,21.15 15.8,20.5 17.5,20.5C19.15,20.5 20.85,20.81 22.25,21.56C22.35,21.61 22.4,21.59 22.5,21.59C22.75,21.59 23,21.34 23,21.09V6.5C22.4,6.05 21.75,5.75 21,5.5V7.5L21,13V19C19.9,18.65 18.7,18.5 17.5,18.5C15.8,18.5 13.35,19.15 12,20V13L12,8.5V6.5C10.55,5.4 8.45,5 6.5,5V5Z' })
	  );
	};
	
	var BookOpenVariantIcon = function BookOpenVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,5C19.89,4.65 18.67,4.5 17.5,4.5C15.55,4.5 13.45,4.9 12,6C10.55,4.9 8.45,4.5 6.5,4.5C4.55,4.5 2.45,4.9 1,6V20.65C1,20.9 1.25,21.15 1.5,21.15C1.6,21.15 1.65,21.1 1.75,21.1C3.1,20.45 5.05,20 6.5,20C8.45,20 10.55,20.4 12,21.5C13.35,20.65 15.8,20 17.5,20C19.15,20 20.85,20.3 22.25,21.05C22.35,21.1 22.4,21.1 22.5,21.1C22.75,21.1 23,20.85 23,20.6V6C22.4,5.55 21.75,5.25 21,5M21,18.5C19.9,18.15 18.7,18 17.5,18C15.8,18 13.35,18.65 12,19.5V8C13.35,7.15 15.8,6.5 17.5,6.5C18.7,6.5 19.9,6.65 21,7V18.5Z' })
	  );
	};
	
	var BookOpenIcon = function BookOpenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,12H20V13.5H13M13,9.5H20V11H13M13,14.5H20V16H13M21,4H3C1.9,4 1,4.9 1,6V19C1,20.1 1.9,21 3,21H21C22.1,21 23,20.1 23,19V6C23,4.9 22.1,4 21,4M21,19H12V6H21' })
	  );
	};
	
	var BookPlusIcon = function BookPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,22H6C4.9,22 4,21.1 4,20V4C4,2.89 4.9,2 6,2H7V9L9.5,7.5L12,9V2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22M14,20H16V18H18V16H16V14H14V16H12V18H14V20Z' })
	  );
	};
	
	var BookSecureIcon = function BookSecureIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,2H12V9L9.5,7.5L7,9V2H6C4.9,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V4C20,2.9 19.1,2 18,2M18,20H10V16H11V15C11,13.34 12.34,12 14,12C15.66,12 17,13.34 17,15V16H18V20M15,15V16H13V15C13,14.45 13.45,14 14,14C14.55,14 15,14.45 15,15Z' })
	  );
	};
	
	var BookUnsecureIcon = function BookUnsecureIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,2H12V9L9.5,7.5L7,9V2H6C4.9,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V4C20,2.9 19.1,2 18,2M18,20H10V16H11V14C11,12.34 12.34,11 14,11C15.66,11 17,12.34 17,14H15C15,13.45 14.55,13 14,13C13.45,13 13,13.45 13,14V16H18V20Z' })
	  );
	};
	
	var BookVariantIcon = function BookVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,4H11V12L8.5,10.5L6,12M18,2H6C4.9,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V4C20,2.9 19.1,2 18,2Z' })
	  );
	};
	
	var BookIcon = function BookIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,22C19.1,22 20,21.1 20,20V4C20,2.89 19.1,2 18,2H12V9L9.5,7.5L7,9V2H6C4.9,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18Z' })
	  );
	};
	
	var BookmarkCheckIcon = function BookmarkCheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,3C18.1,3 19,3.9 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M11,14L17.25,7.76L15.84,6.34L11,11.18L8.41,8.59L7,10L11,14Z' })
	  );
	};
	
	var BookmarkMusicIcon = function BookmarkMusicIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,3C18.1,3 19,3.9 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M11,11C9.9,11 9,11.9 9,13C9,14.1 9.9,15 11,15C12.1,15 13,14.1 13,13V8H16V6H12V11.27C11.71,11.1 11.36,11 11,11Z' })
	  );
	};
	
	var BookmarkOutlineIcon = function BookmarkOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,18L12,15.82L7,18V5H17M17,3H7C5.9,3 5,3.9 5,5V21L12,18L19,21V5C19,3.89 18.1,3 17,3Z' })
	  );
	};
	
	var BookmarkPlusOutlineIcon = function BookmarkPlusOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,18V5H7V18L12,15.82L17,18M17,3C18.1,3 19,3.9 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M11,7H13V9H15V11H13V13H11V11H9V9H11V7Z' })
	  );
	};
	
	var BookmarkPlusIcon = function BookmarkPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,3C18.1,3 19,3.9 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M11,7V9H9V11H11V13H13V11H15V9H13V7H11Z' })
	  );
	};
	
	var BookmarkRemoveIcon = function BookmarkRemoveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,3C18.1,3 19,3.9 19,5V21L12,18L5,21V5C5,3.89 5.9,3 7,3H17M8.17,8.58L10.59,11L8.17,13.41L9.59,14.83L12,12.41L14.41,14.83L15.83,13.41L13.41,11L15.83,8.58L14.41,7.17L12,9.58L9.59,7.17L8.17,8.58Z' })
	  );
	};
	
	var BookmarkIcon = function BookmarkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,3H7C5.9,3 5,3.9 5,5V21L12,18L19,21V5C19,3.89 18.1,3 17,3Z' })
	  );
	};
	
	var BoomboxIcon = function BoomboxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,5L5,7V8H3C2.45,8 2,8.45 2,9V17C2,17.55 2.45,18 3,18H21C21.55,18 22,17.55 22,17V9C22,8.45 21.55,8 21,8H19V7L17,5H7M7,7H17V8H7V7M11,9H13C13.28,9 13.5,9.22 13.5,9.5C13.5,9.78 13.28,10 13,10H11C10.72,10 10.5,9.78 10.5,9.5C10.5,9.22 10.72,9 11,9M7.5,10.5C9.16,10.5 10.5,11.84 10.5,13.5C10.5,15.16 9.16,16.5 7.5,16.5C5.84,16.5 4.5,15.16 4.5,13.5C4.5,11.84 5.84,10.5 7.5,10.5M16.5,10.5C18.16,10.5 19.5,11.84 19.5,13.5C19.5,15.16 18.16,16.5 16.5,16.5C14.84,16.5 13.5,15.16 13.5,13.5C13.5,11.84 14.84,10.5 16.5,10.5M7.5,12C6.67,12 6,12.67 6,13.5C6,14.33 6.67,15 7.5,15C8.33,15 9,14.33 9,13.5C9,12.67 8.33,12 7.5,12M16.5,12C15.67,12 15,12.67 15,13.5C15,14.33 15.67,15 16.5,15C17.33,15 18,14.33 18,13.5C18,12.67 17.33,12 16.5,12Z' })
	  );
	};
	
	var BootstrapIcon = function BootstrapIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5M7.5,6V18H12.5C14.75,18 16.5,16.75 16.5,14.5C16.5,12.5 14.77,11.5 13.25,11.5C14.77,11.5 16,10.27 16,8.75C16,7.23 14.27,6 12.75,6H7.5M10,11V8H11.5C12.33,8 13,8.67 13,9.5C13,10.33 12.33,11 11.5,11H10M10,13H12C12.83,13 13.5,13.67 13.5,14.5C13.5,15.33 12.83,16 12,16H10V13Z' })
	  );
	};
	
	var BorderAllVariantIcon = function BorderAllVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,21V3H21V21H3M5,5V19H19V5H5Z' })
	  );
	};
	
	var BorderAllIcon = function BorderAllIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,11H13V5H19M19,19H13V13H19M11,11H5V5H11M11,19H5V13H11M3,21H21V3H3V21Z' })
	  );
	};
	
	var BorderBottomVariantIcon = function BorderBottomVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,15H3V17H5M3,21H21V19H3M5,11H3V13H5M19,9H21V7H19M19,5H21V3H19M5,7H3V9H5M19,17H21V15H19M19,13H21V11H19M17,3H15V5H17M13,3H11V5H13M5,3H3V5H5M9,3H7V5H9' })
	  );
	};
	
	var BorderBottomIcon = function BorderBottomIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,15H3V17H5M3,21H21V19H3M5,11H3V13H5M19,9H21V7H19M19,5H21V3H19M5,7H3V9H5M19,17H21V15H19M19,13H21V11H19M17,3H15V5H17M13,3H11V5H13M17,11H15V13H17M13,7H11V9H13M5,3H3V5H5M13,11H11V13H13M9,3H7V5H9M13,15H11V17H13M9,11H7V13H9V11Z' })
	  );
	};
	
	var BorderColorIcon = function BorderColorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.71,4.04C21.1,3.65 21.1,3 20.71,2.63L18.37,0.29C18,-0.1 17.35,-0.1 16.96,0.29L15,2.25L18.75,6M17.75,7L14,3.25L4,13.25V17H7.75L17.75,7Z' })
	  );
	};
	
	var BorderHorizontalIcon = function BorderHorizontalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,21H21V19H19M15,21H17V19H15M11,17H13V15H11M19,9H21V7H19M19,5H21V3H19M3,13H21V11H3M11,21H13V19H11M19,17H21V15H19M13,3H11V5H13M13,7H11V9H13M17,3H15V5H17M9,3H7V5H9M5,3H3V5H5M7,21H9V19H7M3,17H5V15H3M5,7H3V9H5M3,21H5V19H3V21Z' })
	  );
	};
	
	var BorderInsideIcon = function BorderInsideIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,17H21V15H19M19,21H21V19H19M13,3H11V11H3V13H11V21H13V13H21V11H13M15,21H17V19H15M19,5H21V3H19M19,9H21V7H19M17,3H15V5H17M5,3H3V5H5M9,3H7V5H9M3,17H5V15H3M5,7H3V9H5M7,21H9V19H7M3,21H5V19H3V21Z' })
	  );
	};
	
	var BorderLeftVariantIcon = function BorderLeftVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,5H17V3H15M19,21H21V19H19M19,13H21V11H19M19,5H21V3H19M19,17H21V15H19M15,21H17V19H15M19,9H21V7H19M3,21H5V3H3M7,5H9V3H7M7,21H9V19H7M11,5H13V3H11M11,21H13V19H11V21Z' })
	  );
	};
	
	var BorderLeftIcon = function BorderLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,5H17V3H15M15,13H17V11H15M19,21H21V19H19M19,13H21V11H19M19,5H21V3H19M19,17H21V15H19M15,21H17V19H15M19,9H21V7H19M3,21H5V3H3M7,13H9V11H7M7,5H9V3H7M7,21H9V19H7M11,13H13V11H11M11,9H13V7H11M11,5H13V3H11M11,17H13V15H11M11,21H13V19H11V21Z' })
	  );
	};
	
	var BorderNoneVariantIcon = function BorderNoneVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,5H17V3H15M15,21H17V19H15M11,5H13V3H11M19,5H21V3H19M19,9H21V7H19M19,21H21V19H19M19,13H21V11H19M19,17H21V15H19M3,5H5V3H3M3,9H5V7H3M3,13H5V11H3M3,17H5V15H3M3,21H5V19H3M11,21H13V19H11M7,21H9V19H7M7,5H9V3H7V5Z' })
	  );
	};
	
	var BorderNoneIcon = function BorderNoneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,5H17V3H15M15,13H17V11H15M15,21H17V19H15M11,5H13V3H11M19,5H21V3H19M11,9H13V7H11M19,9H21V7H19M19,21H21V19H19M19,13H21V11H19M19,17H21V15H19M11,13H13V11H11M3,5H5V3H3M3,9H5V7H3M3,13H5V11H3M3,17H5V15H3M3,21H5V19H3M11,21H13V19H11M11,17H13V15H11M7,21H9V19H7M7,13H9V11H7M7,5H9V3H7V5Z' })
	  );
	};
	
	var BorderOutsideIcon = function BorderOutsideIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,11H7V13H9M13,15H11V17H13M19,19H5V5H19M3,21H21V3H3M17,11H15V13H17M13,11H11V13H13M13,7H11V9H13V7Z' })
	  );
	};
	
	var BorderRightVariantIcon = function BorderRightVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,5H13V3H11M15,5H17V3H15M15,21H17V19H15M19,21H21V3H19M3,9H5V7H3M3,17H5V15H3M3,13H5V11H3M11,21H13V19H11M3,21H5V19H3M7,5H9V3H7M3,5H5V3H3M7,21H9V19H7V21Z' })
	  );
	};
	
	var BorderRightIcon = function BorderRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,9H13V7H11M11,5H13V3H11M11,13H13V11H11M15,5H17V3H15M15,21H17V19H15M19,21H21V3H19M15,13H17V11H15M11,17H13V15H11M3,9H5V7H3M3,17H5V15H3M3,13H5V11H3M11,21H13V19H11M3,21H5V19H3M7,13H9V11H7M7,5H9V3H7M3,5H5V3H3M7,21H9V19H7V21Z' })
	  );
	};
	
	var BorderStyleIcon = function BorderStyleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,21H17V19H15M19,21H21V19H19M7,21H9V19H7M11,21H13V19H11M19,17H21V15H19M19,13H21V11H19M3,3V21H5V5H21V3M19,9H21V7H19' })
	  );
	};
	
	var BorderTopVariantIcon = function BorderTopVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,21H21V19H19M15,21H17V19H15M19,17H21V15H19M3,5H21V3H3M19,13H21V11H19M19,9H21V7H19M3,9H5V7H3M3,13H5V11H3M3,21H5V19H3M3,17H5V15H3M11,21H13V19H11M7,21H9V19H7V21Z' })
	  );
	};
	
	var BorderTopIcon = function BorderTopIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,13H17V11H15M19,21H21V19H19M11,9H13V7H11M15,21H17V19H15M19,17H21V15H19M3,5H21V3H3M19,13H21V11H19M19,9H21V7H19M11,17H13V15H11M3,9H5V7H3M3,13H5V11H3M3,21H5V19H3M3,17H5V15H3M11,21H13V19H11M11,13H13V11H11M7,13H9V11H7M7,21H9V19H7V21Z' })
	  );
	};
	
	var BorderVerticalIcon = function BorderVerticalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,13H17V11H15M15,21H17V19H15M15,5H17V3H15M19,9H21V7H19M19,5H21V3H19M19,13H21V11H19M19,21H21V19H19M11,21H13V3H11M19,17H21V15H19M7,5H9V3H7M3,17H5V15H3M3,21H5V19H3M3,13H5V11H3M7,13H9V11H7M7,21H9V19H7M3,5H5V3H3M3,9H5V7H3V9Z' })
	  );
	};
	
	var BottleWineIcon = function BottleWineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,22C9.45,22 9,21.55 9,21V11C9,9 10,7.25 11,7V2.5C11,2.22 11.22,2 11.5,2H12.5C12.78,2 13,2.22 13,2.5V7C14,7.25 15,9 15,11V21C15,21.55 14.55,22 14,22H10Z' })
	  );
	};
	
	var BowTieIcon = function BowTieIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,14L21,17V7L15,10V14M9,14L3,17V7L9,10V14M10,10H14V14H10V10Z' })
	  );
	};
	
	var BowlIcon = function BowlIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,15C22,18.87 18.87,22 15,22H9C5.13,22 2,18.87 2,15V12H15.58L20.3,4.44L22,5.5L17.94,12H22V15Z' })
	  );
	};
	
	var BowlingIcon = function BowlingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12.5,11C11.67,11 11,11.67 11,12.5C11,13.33 11.67,14 12.5,14C13.33,14 14,13.33 14,12.5C14,11.67 13.33,11 12.5,11M12,5C10.9,5 10,5.9 10,7C10,8.1 10.9,9 12,9C13.1,9 14,8.1 14,7C14,5.9 13.1,5 12,5M5.93,8.5C5.38,9.45 5.71,10.67 6.66,11.22C7.62,11.78 8.84,11.45 9.4,10.5C9.95,9.53 9.62,8.31 8.66,7.76C7.71,7.21 6.5,7.53 5.93,8.5Z' })
	  );
	};
	
	var BoxCutterIcon = function BoxCutterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.22,11.91C6.89,12.24 6.71,12.65 6.66,13.08L12.17,15.44L20.66,6.96C21.44,6.17 21.44,4.91 20.66,4.13L19.24,2.71C18.46,1.93 17.2,1.93 16.41,2.71L7.22,11.91M5,16V21.75L10.81,16.53L5.81,14.53L5,16M17.12,4.83C17.5,4.44 18.15,4.44 18.54,4.83C18.93,5.23 18.93,5.86 18.54,6.25C18.15,6.64 17.5,6.64 17.12,6.25C16.73,5.86 16.73,5.23 17.12,4.83Z' })
	  );
	};
	
	var BoxShadowIcon = function BoxShadowIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3H18V18H3V3M19,19H21V21H19V19M19,16H21V18H19V16M19,13H21V15H19V13M19,10H21V12H19V10M19,7H21V9H19V7M16,19H18V21H16V19M13,19H15V21H13V19M10,19H12V21H10V19M7,19H9V21H7V19Z' })
	  );
	};
	
	var BoxIcon = function BoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.39,14.04V14.04C15.39,12.62 14.24,11.47 12.82,11.47C11.41,11.47 10.26,12.62 10.26,14.04V14.04C10.26,15.45 11.41,16.6 12.82,16.6C14.24,16.6 15.39,15.45 15.39,14.04M17.1,14.04C17.1,16.4 15.18,18.31 12.82,18.31C11.19,18.31 9.77,17.39 9.05,16.04C8.33,17.39 6.91,18.31 5.28,18.31C2.94,18.31 1.04,16.43 1,14.11V14.11H1V7H1V7C1,6.56 1.39,6.18 1.86,6.18C2.33,6.18 2.7,6.56 2.71,7V7H2.71V10.62C3.43,10.08 4.32,9.76 5.28,9.76C6.91,9.76 8.33,10.68 9.05,12.03C9.77,10.68 11.19,9.76 12.82,9.76C15.18,9.76 17.1,11.68 17.1,14.04V14.04M7.84,14.04V14.04C7.84,12.62 6.69,11.47 5.28,11.47C3.86,11.47 2.71,12.62 2.71,14.04V14.04C2.71,15.45 3.86,16.6 5.28,16.6C6.69,16.6 7.84,15.45 7.84,14.04M22.84,16.96V16.96C22.95,17.12 23,17.3 23,17.47C23,17.73 22.88,18 22.66,18.15C22.5,18.26 22.33,18.32 22.15,18.32C21.9,18.32 21.65,18.21 21.5,18L19.59,15.47L17.7,18V18C17.53,18.21 17.28,18.32 17.03,18.32C16.85,18.32 16.67,18.26 16.5,18.15C16.29,18 16.17,17.72 16.17,17.46C16.17,17.29 16.23,17.11 16.33,16.96V16.96H16.33V16.96L18.5,14.04L16.33,11.11V11.11H16.33V11.11C16.22,10.96 16.17,10.79 16.17,10.61C16.17,10.35 16.29,10.1 16.5,9.93C16.89,9.65 17.41,9.72 17.7,10.09V10.09L19.59,12.61L21.5,10.09C21.76,9.72 22.29,9.65 22.66,9.93C22.89,10.1 23,10.36 23,10.63C23,10.8 22.95,10.97 22.84,11.11V11.11H22.84V11.11L20.66,14.04L22.84,16.96V16.96H22.84Z' })
	  );
	};
	
	var BridgeIcon = function BridgeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,14V10.91C6.28,10.58 5.61,10.18 5,9.71V14H7M5,18H3V16H1V14H3V7H5V8.43C6.8,10 9.27,11 12,11C14.73,11 17.2,10 19,8.43V7H21V14H23V16H21V18H19V16H5V18M17,10.91V14H19V9.71C18.39,10.18 17.72,10.58 17,10.91M16,14V11.32C15.36,11.55 14.69,11.72 14,11.84V14H16M13,14V11.96L12,12L11,11.96V14H13M10,14V11.84C9.31,11.72 8.64,11.55 8,11.32V14H10Z' })
	  );
	};
	
	var BriefcaseCheckIcon = function BriefcaseCheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,2H14C15.1,2 16,2.9 16,4V6H20C21.1,6 22,6.9 22,8V19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19V8C2,6.9 2.9,6 4,6H8V4C8,2.9 8.9,2 10,2M14,6V4H10V6H14M10.5,17.5L17.09,10.91L15.68,9.5L10.5,14.67L8.41,12.59L7,14L10.5,17.5Z' })
	  );
	};
	
	var BriefcaseDownloadIcon = function BriefcaseDownloadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,2H14C15.1,2 16,2.9 16,4V6H20C21.1,6 22,6.9 22,8V19C22,20.1 21.1,21 20,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14M12,19L17,14H14V10H10V14H7L12,19Z' })
	  );
	};
	
	var BriefcaseOutlineIcon = function BriefcaseOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,6C20.58,6 21.05,6.2 21.42,6.59C21.8,7 22,7.45 22,8V19C22,19.55 21.8,20 21.42,20.41C21.05,20.8 20.58,21 20,21H4C3.42,21 2.95,20.8 2.58,20.41C2.2,20 2,19.55 2,19V8C2,7.45 2.2,7 2.58,6.59C2.95,6.2 3.42,6 4,6H8V4C8,3.42 8.2,2.95 8.58,2.58C8.95,2.2 9.42,2 10,2H14C14.58,2 15.05,2.2 15.42,2.58C15.8,2.95 16,3.42 16,4V6H20M4,8V19H20V8H4M14,6V4H10V6H14Z' })
	  );
	};
	
	var BriefcaseUploadIcon = function BriefcaseUploadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,2H14C15.1,2 16,2.9 16,4V6H20C21.1,6 22,6.9 22,8V19C22,20.1 21.1,21 20,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14M12,9L7,14H10V18H14V14H17L12,9Z' })
	  );
	};
	
	var BriefcaseIcon = function BriefcaseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,2H14C15.1,2 16,2.9 16,4V6H20C21.1,6 22,6.9 22,8V19C22,20.1 21.1,21 20,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14Z' })
	  );
	};
	
	var Brightness1Icon = function Brightness1Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2Z' })
	  );
	};
	
	var Brightness2Icon = function Brightness2Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,2C8.18,2 6.47,2.5 5,3.35C8,5.08 10,8.3 10,12C10,15.7 8,18.92 5,20.65C6.47,21.5 8.18,22 10,22C15.52,22 20,17.52 20,12C20,6.48 15.52,2 10,2Z' })
	  );
	};
	
	var Brightness3Icon = function Brightness3Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,2C7.95,2 6.95,2.16 6,2.46C10.06,3.73 13,7.5 13,12C13,16.5 10.06,20.27 6,21.54C6.95,21.84 7.95,22 9,22C14.52,22 19,17.52 19,12C19,6.48 14.52,2 9,2Z' })
	  );
	};
	
	var Brightness4Icon = function Brightness4Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,18C11.11,18 10.26,17.8 9.5,17.45C11.56,16.5 13,14.42 13,12C13,9.58 11.56,7.5 9.5,6.55C10.26,6.2 11.11,6 12,6C15.31,6 18,8.69 18,12C18,15.31 15.31,18 12,18M20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31L23.31,12L20,8.69Z' })
	  );
	};
	
	var Brightness5Icon = function Brightness5Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,18C8.69,18 6,15.31 6,12C6,8.69 8.69,6 12,6C15.31,6 18,8.69 18,12C18,15.31 15.31,18 12,18M20,15.31L23.31,12L20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31Z' })
	  );
	};
	
	var Brightness6Icon = function Brightness6Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,18V6C15.31,6 18,8.69 18,12C18,15.31 15.31,18 12,18M20,15.31L23.31,12L20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31Z' })
	  );
	};
	
	var Brightness7Icon = function Brightness7Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,8C9.79,8 8,9.79 8,12C8,14.21 9.79,16 12,16C14.21,16 16,14.21 16,12C16,9.79 14.21,8 12,8M12,18C8.69,18 6,15.31 6,12C6,8.69 8.69,6 12,6C15.31,6 18,8.69 18,12C18,15.31 15.31,18 12,18M20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31L23.31,12L20,8.69Z' })
	  );
	};
	
	var BrightnessAutoIcon = function BrightnessAutoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.3,16L13.6,14H10.4L9.7,16H7.8L11,7H13L16.2,16H14.3M20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31L23.31,12L20,8.69M10.85,12.65H13.15L12,9L10.85,12.65Z' })
	  );
	};
	
	var BroomIcon = function BroomIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.36,2.72L20.78,4.14L15.06,9.85C16.13,11.39 16.28,13.24 15.38,14.44L9.06,8.12C10.26,7.22 12.11,7.37 13.65,8.44L19.36,2.72M5.93,17.57C3.92,15.56 2.69,13.16 2.35,10.92L7.23,8.83L14.67,16.27L12.58,21.15C10.34,20.81 7.94,19.58 5.93,17.57Z' })
	  );
	};
	
	var BrushIcon = function BrushIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.71,4.63L19.37,3.29C19,2.9 18.35,2.9 17.96,3.29L9,12.25L11.75,15L20.71,6.04C21.1,5.65 21.1,5 20.71,4.63M7,14C5.34,14 4,15.34 4,17C4,18.31 2.84,19 2,19C2.92,20.22 4.5,21 6,21C8.21,21 10,19.21 10,17C10,15.34 8.66,14 7,14Z' })
	  );
	};
	
	var BuddhismIcon = function BuddhismIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,2V3C9.27,3.2 7.69,3.9 6.4,4.94L5.64,4.18L4.22,5.6L5,6.35C3.9,7.68 3.21,9.3 3,11H2V13H3C3.21,14.68 3.9,16.26 5,17.56L4.22,18.32L5.64,19.74L6.39,19C7.71,20.07 9.3,20.77 11,21V22H13V21C14.69,20.77 16.29,20.07 17.6,19L18.36,19.74L19.78,18.32L19,17.57C20.1,16.27 20.79,14.68 21,13H22V11H21C20.79,9.3 20.1,7.69 19,6.36L19.78,5.6L18.36,4.18L17.61,4.94C16.29,3.87 14.69,3.2 13,3V2H11M11,5V8L10,8.5L7.81,6.35C8.72,5.67 9.81,5.17 11,5M13,5C14.16,5.18 15.26,5.64 16.2,6.35L14,8.5L13,8V5M6.4,7.76L8.5,10L8,11H5C5.16,9.84 5.7,8.7 6.39,7.75L6.4,7.76M17.6,7.76C18.33,8.71 18.81,9.82 19,11H16L15.5,10L17.61,7.76H17.6M12,10C13.12,10 14,10.88 14,12C14,13.12 13.12,14 12,14C10.88,14 10,13.12 10,12C10,10.88 10.88,10 12,10M5,13H8L8.57,14L6.39,16.15C5.67,15.24 5.19,14.16 5,13V13M16,13H19C18.81,14.15 18.33,15.24 17.61,16.16L15.5,14L16,13M10,15.5L11,16V19C9.83,18.8 8.73,18.31 7.8,17.57L10,15.5M14,15.5L16.19,17.57C15.28,18.25 14.19,18.83 13,19V16L14,15.5Z' })
	  );
	};
	
	var BufferIcon = function BufferIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.6,2.86C15.27,4.1 18,5.39 20.66,6.63C20.81,6.7 21,6.75 21,6.95C21,7.15 20.81,7.19 20.66,7.26C18,8.5 15.3,9.77 12.62,11C12.21,11.21 11.79,11.21 11.38,11C8.69,9.76 6,8.5 3.32,7.25C3.18,7.19 3,7.14 3,6.94C3,6.76 3.18,6.71 3.31,6.65C6,5.39 8.74,4.1 11.44,2.85C11.73,2.72 12.3,2.73 12.6,2.86M12,21.15C11.8,21.15 11.66,21.07 11.38,20.97C8.69,19.73 6,18.47 3.33,17.22C3.19,17.15 3,17.11 3,16.9C3,16.7 3.19,16.66 3.34,16.59C3.78,16.38 4.23,16.17 4.67,15.96C5.12,15.76 5.56,15.76 6,15.97C7.79,16.8 9.57,17.63 11.35,18.46C11.79,18.67 12.23,18.66 12.67,18.46C14.45,17.62 16.23,16.79 18,15.96C18.44,15.76 18.87,15.75 19.29,15.95C19.77,16.16 20.24,16.39 20.71,16.61C20.78,16.64 20.85,16.68 20.91,16.73C21.04,16.83 21.04,17 20.91,17.08C20.83,17.14 20.74,17.19 20.65,17.23C18,18.5 15.33,19.72 12.66,20.95C12.46,21.05 12.19,21.15 12,21.15M12,16.17C11.9,16.17 11.55,16.07 11.36,16C8.68,14.74 6,13.5 3.34,12.24C3.2,12.18 3,12.13 3,11.93C3,11.72 3.2,11.68 3.35,11.61C3.8,11.39 4.25,11.18 4.7,10.97C5.13,10.78 5.56,10.78 6,11C7.78,11.82 9.58,12.66 11.38,13.5C11.79,13.69 12.21,13.69 12.63,13.5C14.43,12.65 16.23,11.81 18.04,10.97C18.45,10.78 18.87,10.78 19.29,10.97C19.76,11.19 20.24,11.41 20.71,11.63C20.77,11.66 20.84,11.69 20.9,11.74C21.04,11.85 21.04,12 20.89,12.12C20.84,12.16 20.77,12.19 20.71,12.22C18,13.5 15.31,14.75 12.61,16C12.42,16.09 12.08,16.17 12,16.17Z' })
	  );
	};
	
	var BugIcon = function BugIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,12H10V10H14M14,16H10V14H14M20,8H17.19C16.74,7.22 16.12,6.55 15.37,6.04L17,4.41L15.59,3L13.42,5.17C12.96,5.06 12.5,5 12,5C11.5,5 11.04,5.06 10.59,5.17L8.41,3L7,4.41L8.62,6.04C7.88,6.55 7.26,7.22 6.81,8H4V10H6.09C6.04,10.33 6,10.66 6,11V12H4V14H6V15C6,15.34 6.04,15.67 6.09,16H4V18H6.81C7.85,19.79 9.78,21 12,21C14.22,21 16.15,19.79 17.19,18H20V16H17.91C17.96,15.67 18,15.34 18,15V14H20V12H18V11C18,10.66 17.96,10.33 17.91,10H20V8Z' })
	  );
	};
	
	var BulletinBoardIcon = function BulletinBoardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.04,2.5L9.53,5H14.53L12.04,2.5M4,7V20H20V7H4M12,0L17,5V5H20C21.1,5 22,5.9 22,7V20C22,21.1 21.1,22 20,22H4C2.9,22 2,21.1 2,20V7C2,5.9 2.9,5 4,5H7V5L12,0M7,18V14H12V18H7M14,17V10H18V17H14M6,12V9H11V12H6Z' })
	  );
	};
	
	var BullhornIcon = function BullhornIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,12V16C16,16.55 15.55,17 15,17C14.83,17 14.67,17 14.06,16.5C13.44,16 12.39,15 11.31,14.5C10.31,14.04 9.28,14 8.26,14L9.47,17.32L9.5,17.5C9.5,17.78 9.28,18 9,18H7C6.78,18 6.59,17.86 6.53,17.66L5.19,14H5C4.45,14 4,13.55 4,13C2.9,13 2,12.1 2,11C2,9.9 2.9,9 4,9C4,8.45 4.45,8 5,8H8C9.11,8 10.22,8 11.31,7.5C12.39,7 13.44,6 14.06,5.5C14.67,5 14.83,5 15,5C15.55,5 16,5.45 16,6V10C16.55,10 17,10.45 17,11C17,11.55 16.55,12 16,12M21,11C21,12.38 20.44,13.63 19.54,14.54L18.12,13.12C18.66,12.58 19,11.83 19,11C19,10.17 18.66,9.42 18.12,8.88L19.54,7.46C20.44,8.37 21,9.62 21,11Z' })
	  );
	};
	
	var BullseyeArrowIcon = function BullseyeArrowIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,10.84 21.79,9.69 21.39,8.61L19.79,10.21C19.93,10.8 20,11.4 20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C12.6,4 13.2,4.07 13.79,4.21L15.4,2.6C14.31,2.21 13.16,2 12,2M19,2L15,6V7.5L12.45,10.05C12.3,10 12.15,10 12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,11.85 14,11.7 13.95,11.55L16.5,9H18L22,5H19V2M12,6C8.69,6 6,8.69 6,12C6,15.31 8.69,18 12,18C15.31,18 18,15.31 18,12H16C16,14.21 14.21,16 12,16C9.79,16 8,14.21 8,12C8,9.79 9.79,8 12,8V6Z' })
	  );
	};
	
	var BullseyeIcon = function BullseyeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4M12,6C8.69,6 6,8.69 6,12C6,15.31 8.69,18 12,18C15.31,18 18,15.31 18,12C18,8.69 15.31,6 12,6M12,8C14.21,8 16,9.79 16,12C16,14.21 14.21,16 12,16C9.79,16 8,14.21 8,12C8,9.79 9.79,8 12,8M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10Z' })
	  );
	};
	
	var BusArticulatedEndIcon = function BusArticulatedEndIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.5,6L20,7.5L21.5,9L20,10.5L21.5,12L20,13.5L21.5,15H12.5C12.5,16.66 11.16,18 9.5,18C7.84,18 6.5,16.66 6.5,15H2.5V8C2.5,6.89 3.39,6 4.5,6H21.5M18.5,7.5H15V10H18.5V7.5M13.5,7.5H9.5V10H13.5V7.5M8,7.5H4V10H8V7.5M9.5,13.5C8.67,13.5 8,14.17 8,15C8,15.83 8.67,16.5 9.5,16.5C10.33,16.5 11,15.83 11,15C11,14.17 10.33,13.5 9.5,13.5Z' })
	  );
	};
	
	var BusArticulatedFrontIcon = function BusArticulatedFrontIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,6L2.5,7.5L1,9L2.5,10.5L1,12L2.5,13.5L1,15H3C3,16.66 4.34,18 6,18C7.66,18 9,16.66 9,15H15C15,16.66 16.34,18 18,18C19.66,18 21,16.66 21,15H23V8C23,6.89 22.11,6 21,6H1M4,7.5H6.5V10H4V7.5M8,7.5H12V10H8V7.5M13.5,7.5H17.5V10H13.5V7.5M19,7.5H21.5V13L19,11V7.5M6,13.5C6.83,13.5 7.5,14.17 7.5,15C7.5,15.83 6.83,16.5 6,16.5C5.17,16.5 4.5,15.83 4.5,15C4.5,14.17 5.17,13.5 6,13.5M18,13.5C18.83,13.5 19.5,14.17 19.5,15C19.5,15.83 18.83,16.5 18,16.5C17.17,16.5 16.5,15.83 16.5,15C16.5,14.17 17.17,13.5 18,13.5Z' })
	  );
	};
	
	var BusClockIcon = function BusClockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.5,4V8.25L19.36,9.94L18.61,11.16L15,9V4H16.5M16,13C17.36,13 18.54,12.5 19.5,11.53C20.5,10.56 21,9.39 21,8C21,6.64 20.5,5.46 19.5,4.5C18.54,3.5 17.36,3 16,3C14.61,3 13.44,3.5 12.47,4.5C11.5,5.46 11,6.64 11,8C11,9.39 11.5,10.56 12.47,11.53C13.44,12.5 14.61,13 16,13M13.5,19C13.94,19 14.3,18.84 14.58,18.54C14.86,18.24 15,17.89 15,17.5C15,17.08 14.86,16.73 14.58,16.43C14.3,16.13 13.94,16 13.5,16C13.06,16 12.7,16.13 12.42,16.43C12.14,16.73 12,17.08 12,17.5C12,17.89 12.14,18.24 12.42,18.54C12.7,18.84 13.06,19 13.5,19M3,13H11.11C9.7,11.64 9,10 9,8H3V13M4.5,19C4.94,19 5.3,18.84 5.58,18.54C5.86,18.24 6,17.89 6,17.5C6,17.08 5.86,16.73 5.58,16.43C5.3,16.13 4.94,16 4.5,16C4.06,16 3.7,16.13 3.42,16.43C3.14,16.73 3,17.08 3,17.5C3,17.89 3.14,18.24 3.42,18.54C3.7,18.84 4.06,19 4.5,19M16,1C17.92,1 19.58,1.67 20.95,3.05C22.33,4.42 23,6.08 23,8C23,9.77 22.44,11.29 21.28,12.59C20.13,13.88 18.7,14.66 17,14.91V18C17,18.84 16.67,19.58 16,20.2V22C16,22.27 15.89,22.5 15.7,22.71C15.5,22.91 15.28,23 15,23H14C13.73,23 13.5,22.91 13.29,22.71C13.09,22.5 13,22.27 13,22V21H5V22C5,22.27 4.91,22.5 4.71,22.71C4.5,22.91 4.27,23 4,23H3C2.72,23 2.5,22.91 2.3,22.71C2.11,22.5 2,22.27 2,22V20.2C1.33,19.58 1,18.84 1,18V8C1,6.42 1.67,5.35 3.05,4.8C4.42,4.26 6.41,4 9,4C9.13,4 9.33,4 9.61,4C9.89,4 10.09,4.03 10.22,4.03C11.63,2 13.55,1 16,1Z' })
	  );
	};
	
	var BusDoubleDeckerIcon = function BusDoubleDeckerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4C1.89,4 1,4.89 1,6V17H3C3,18.66 4.34,20 6,20C7.66,20 9,18.66 9,17H15C15,18.66 16.34,20 18,20C19.66,20 21,18.66 21,17H23V14C23,12.89 22.11,12 21,12H19V9.5H23V6C23,4.89 22.11,4 21,4H3M2.5,5.5H6.5V8H2.5V5.5M8,5.5H12V8H8V5.5M13.5,5.5H17.5V8H13.5V5.5M19,5.5H21.5V8H19V5.5M13.5,9.5H17.5V12H13.5V9.5M2.5,9.5H6.5V12H2.5V9.5M8,9.5H12V12H8V9.5M6,15.5C6.83,15.5 7.5,16.17 7.5,17C7.5,17.83 6.83,18.5 6,18.5C5.17,18.5 4.5,17.83 4.5,17C4.5,16.17 5.17,15.5 6,15.5M18,15.5C18.83,15.5 19.5,16.17 19.5,17C19.5,17.83 18.83,18.5 18,18.5C17.17,18.5 16.5,17.83 16.5,17C16.5,16.17 17.17,15.5 18,15.5Z' })
	  );
	};
	
	var BusSchoolIcon = function BusSchoolIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,6C1.89,6 1,6.89 1,8V15H3C3,16.66 4.34,18 6,18C7.66,18 9,16.66 9,15H15C15,16.66 16.34,18 18,18C19.66,18 21,16.66 21,15H23V12C23,10.89 22.11,10 21,10H19V8C19,6.89 18.11,6 17,6H3M13.5,7.5H17.5V10H13.5V7.5M2.5,7.5H6.5V10H2.5V7.5M8,7.5H12V10H8V7.5M6,13.5C6.83,13.5 7.5,14.17 7.5,15C7.5,15.83 6.83,16.5 6,16.5C5.17,16.5 4.5,15.83 4.5,15C4.5,14.17 5.17,13.5 6,13.5M18,13.5C18.83,13.5 19.5,14.17 19.5,15C19.5,15.83 18.83,16.5 18,16.5C17.17,16.5 16.5,15.83 16.5,15C16.5,14.17 17.17,13.5 18,13.5Z' })
	  );
	};
	
	var BusSideIcon = function BusSideIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,6C1.89,6 1,6.89 1,8V15H3C3,16.66 4.34,18 6,18C7.66,18 9,16.66 9,15H15C15,16.66 16.34,18 18,18C19.66,18 21,16.66 21,15H23V8C23,6.89 22.11,6 21,6H3M2.5,7.5H6.5V10H2.5V7.5M8,7.5H12V10H8V7.5M13.5,7.5H17.5V10H13.5V7.5M19,7.5H21.5V13L19,11V7.5M6,13.5C6.83,13.5 7.5,14.17 7.5,15C7.5,15.83 6.83,16.5 6,16.5C5.17,16.5 4.5,15.83 4.5,15C4.5,14.17 5.17,13.5 6,13.5M18,13.5C18.83,13.5 19.5,14.17 19.5,15C19.5,15.83 18.83,16.5 18,16.5C17.17,16.5 16.5,15.83 16.5,15C16.5,14.17 17.17,13.5 18,13.5Z' })
	  );
	};
	
	var BusIcon = function BusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,11H6V6H18M16.5,17C15.67,17 15,16.33 15,15.5C15,14.67 15.67,14 16.5,14C17.33,14 18,14.67 18,15.5C18,16.33 17.33,17 16.5,17M7.5,17C6.67,17 6,16.33 6,15.5C6,14.67 6.67,14 7.5,14C8.33,14 9,14.67 9,15.5C9,16.33 8.33,17 7.5,17M4,16C4,16.88 4.39,17.67 5,18.22V20C5,20.55 5.45,21 6,21H7C7.55,21 8,20.55 8,20V19H16V20C16,20.55 16.45,21 17,21H18C18.55,21 19,20.55 19,20V18.22C19.61,17.67 20,16.88 20,16V6C20,2.5 16.42,2 12,2C7.58,2 4,2.5 4,6V16Z' })
	  );
	};
	
	var CachedIcon = function CachedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,8L15,12H18C18,15.31 15.31,18 12,18C11,18 10.03,17.75 9.2,17.3L7.74,18.76C8.97,19.54 10.43,20 12,20C16.42,20 20,16.42 20,12H23M6,12C6,8.69 8.69,6 12,6C13,6 13.97,6.25 14.8,6.7L16.26,5.24C15.03,4.46 13.57,4 12,4C7.58,4 4,7.58 4,12H1L5,16L9,12' })
	  );
	};
	
	var CakeLayeredIcon = function CakeLayeredIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,21V17C21,15.89 20.1,15 19,15H18V12C18,10.89 17.1,10 16,10H13V8H11V10H8C6.89,10 6,10.89 6,12V15H5C3.89,15 3,15.89 3,17V21H1V23H23V21M12,7C13.1,7 14,6.1 14,5C14,4.62 13.9,4.27 13.71,3.97L12,1L10.28,3.97C10.1,4.27 10,4.62 10,5C10,6.1 10.9,7 12,7Z' })
	  );
	};
	
	var CakeVariantIcon = function CakeVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,6C13.11,6 14,5.1 14,4C14,3.62 13.9,3.27 13.71,2.97L12,0L10.29,2.97C10.1,3.27 10,3.62 10,4C10,5.1 10.9,6 12,6M16.6,16L15.53,14.92L14.45,16C13.15,17.29 10.87,17.3 9.56,16L8.5,14.92L7.4,16C6.75,16.64 5.88,17 4.96,17C4.23,17 3.56,16.77 3,16.39V21C3,21.55 3.45,22 4,22H20C20.55,22 21,21.55 21,21V16.39C20.44,16.77 19.77,17 19.04,17C18.12,17 17.25,16.64 16.6,16M18,9H13V7H11V9H6C4.34,9 3,10.34 3,12V13.54C3,14.62 3.88,15.5 4.96,15.5C5.5,15.5 6,15.3 6.34,14.93L8.5,12.8L10.61,14.93C11.35,15.67 12.64,15.67 13.38,14.93L15.5,12.8L17.65,14.93C18,15.3 18.5,15.5 19.03,15.5C20.11,15.5 21,14.62 21,13.54V12C21,10.34 19.66,9 18,9Z' })
	  );
	};
	
	var CakeIcon = function CakeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.5,0.5C12,0.75 13,2.4 13,3.5C13,4.6 12.33,5 11.5,5C10.67,5 10,4.85 10,3.75C10,2.65 11,2 11.5,0.5M18.5,9C21,9 23,11 23,13.5C23,15.06 22.21,16.43 21,17.24V23H12L3,23V17.24C1.79,16.43 1,15.06 1,13.5C1,11 3,9 5.5,9H10V6H13V9H18.5M12,16C13.38,16 14.5,14.88 14.5,13.5H16C16,14.88 17.12,16 18.5,16C19.88,16 21,14.88 21,13.5C21,12.12 19.88,11 18.5,11H5.5C4.12,11 3,12.12 3,13.5C3,14.88 4.12,16 5.5,16C6.88,16 8,14.88 8,13.5H9.5C9.5,14.88 10.62,16 12,16Z' })
	  );
	};
	
	var CalculatorIcon = function CalculatorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,2H17C18.1,2 19,2.9 19,4V20C19,21.1 18.1,22 17,22H7C5.9,22 5,21.1 5,20V4C5,2.9 5.9,2 7,2M7,4V8H17V4H7M7,10V12H9V10H7M11,10V12H13V10H11M15,10V12H17V10H15M7,14V16H9V14H7M11,14V16H13V14H11M15,14V16H17V14H15M7,18V20H9V18H7M11,18V20H13V18H11M15,18V20H17V18H15Z' })
	  );
	};
	
	var CalendarBlankIcon = function CalendarBlankIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3H18V1' })
	  );
	};
	
	var CalendarCheckIcon = function CalendarCheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M16.53,11.06L15.47,10L10.59,14.88L8.47,12.76L7.41,13.82L10.59,17L16.53,11.06Z' })
	  );
	};
	
	var CalendarClockIcon = function CalendarClockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,13H16.5V15.82L18.94,17.23L18.19,18.53L15,16.69V13M19,8H5V19H9.67C9.24,18.09 9,17.07 9,16C9,12.13 12.13,9 16,9C17.07,9 18.09,9.24 19,9.67V8M5,21C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1H18V3H19C20.1,3 21,3.9 21,5V11.1C22.24,12.36 23,14.09 23,16C23,19.87 19.87,23 16,23C14.09,23 12.36,22.24 11.1,21H5M16,11.15C13.32,11.15 11.15,13.32 11.15,16C11.15,18.68 13.32,20.85 16,20.85C18.68,20.85 20.85,18.68 20.85,16C20.85,13.32 18.68,11.15 16,11.15Z' })
	  );
	};
	
	var CalendarEditIcon = function CalendarEditIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H18V1H16V3H8V1H6V3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H10V19H5V8H19V9H21V5C21,3.9 20.1,3 19,3M21.7,13.35L20.7,14.35L18.65,12.35L19.65,11.35C19.85,11.14 20.19,11.13 20.42,11.35L21.7,12.63C21.89,12.83 21.89,13.15 21.7,13.35M12,18.94L18.07,12.88L20.12,14.88L14.06,21H12V18.94Z' })
	  );
	};
	
	var CalendarMultipleCheckIcon = function CalendarMultipleCheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,17V8H7V17H21M21,3C22.1,3 23,3.9 23,5V17C23,18.1 22.1,19 21,19H7C5.89,19 5,18.1 5,17V5C5,3.9 5.9,3 7,3H8V1H10V3H18V1H20V3H21M17.53,11.06L13.09,15.5L10.41,12.82L11.47,11.76L13.09,13.38L16.47,10L17.53,11.06M3,21H17V23H3C1.89,23 1,22.1 1,21V9H3V21Z' })
	  );
	};
	
	var CalendarMultipleIcon = function CalendarMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,17V8H7V17H21M21,3C22.1,3 23,3.9 23,5V17C23,18.1 22.1,19 21,19H7C5.89,19 5,18.1 5,17V5C5,3.9 5.9,3 7,3H8V1H10V3H18V1H20V3H21M3,21H17V23H3C1.89,23 1,22.1 1,21V9H3V21M19,15H15V11H19V15Z' })
	  );
	};
	
	var CalendarPlusIcon = function CalendarPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19V7H5V19H19M16,1H18V3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1M11,9H13V12H16V14H13V17H11V14H8V12H11V9Z' })
	  );
	};
	
	var CalendarQuestionIcon = function CalendarQuestionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,1V3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H18V1H16V3H8V1H6M5,8H19V19H5V8M12.19,9C11.32,9 10.62,9.2 10.08,9.59C9.56,10 9.3,10.57 9.31,11.36L9.32,11.39H11.25C11.26,11.09 11.35,10.86 11.53,10.7C11.71,10.55 11.93,10.47 12.19,10.47C12.5,10.47 12.76,10.57 12.94,10.75C13.12,10.94 13.2,11.2 13.2,11.5C13.2,11.82 13.13,12.09 12.97,12.32C12.83,12.55 12.62,12.75 12.36,12.91C11.85,13.25 11.5,13.55 11.31,13.82C11.11,14.08 11,14.5 11,15H13C13,14.69 13.04,14.44 13.13,14.26C13.22,14.08 13.39,13.9 13.64,13.74C14.09,13.5 14.46,13.21 14.75,12.81C15.04,12.41 15.19,12 15.19,11.5C15.19,10.74 14.92,10.13 14.38,9.68C13.85,9.23 13.12,9 12.19,9M11,16V18H13V16H11Z' })
	  );
	};
	
	var CalendarRangeIcon = function CalendarRangeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,10H7V12H9V10M13,10H11V12H13V10M17,10H15V12H17V10M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M19,19H5V8H19V19Z' })
	  );
	};
	
	var CalendarRemoveIcon = function CalendarRemoveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M9.31,17L11.75,14.56L14.19,17L15.25,15.94L12.81,13.5L15.25,11.06L14.19,10L11.75,12.44L9.31,10L8.25,11.06L10.69,13.5L8.25,15.94L9.31,17Z' })
	  );
	};
	
	var CalendarSearchIcon = function CalendarSearchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14C14.12,14 13,15.12 13,16.5C13,17.88 14.12,19 15.5,19C16.88,19 18,17.88 18,16.5C18,15.12 16.88,14 15.5,14M19,8H5V19H9.5C9.81,19.75 10.26,20.42 10.81,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1H18V3H19C20.1,3 21,3.9 21,5V13.03C20.5,12.22 19.8,11.54 19,11V8Z' })
	  );
	};
	
	var CalendarTextIcon = function CalendarTextIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,14H7V16H14M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M17,10H7V12H17V10Z' })
	  );
	};
	
	var CalendarTodayIcon = function CalendarTodayIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,10H12V15H7M19,19H5V8H19M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var CalendarIcon = function CalendarIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z' })
	  );
	};
	
	var CallMadeIcon = function CallMadeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,5V7H15.59L4,18.59L5.41,20L17,8.41V15H19V5' })
	  );
	};
	
	var CallMergeIcon = function CallMergeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,20.41L18.41,19L15,15.59L13.59,17M7.5,8H11V13.59L5.59,19L7,20.41L13,14.41V8H16.5L12,3.5' })
	  );
	};
	
	var CallMissedIcon = function CallMissedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.59,7L12,14.59L6.41,9H11V7H3V15H5V10.41L12,17.41L21,8.41' })
	  );
	};
	
	var CallReceivedIcon = function CallReceivedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,5.41L18.59,4L7,15.59V9H5V19H15V17H8.41' })
	  );
	};
	
	var CallSplitIcon = function CallSplitIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,4L16.29,6.29L13.41,9.17L14.83,10.59L17.71,7.71L20,10V4M10,4H4V10L6.29,7.71L11,12.41V20H13V11.59L7.71,6.29' })
	  );
	};
	
	var CamcorderBoxOffIcon = function CamcorderBoxOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,8H6.73L14,15.27V16H6M2.27,1L1,2.27L3,4.28C2.41,4.62 2,5.26 2,6V18C2,19.1 2.9,20 4,20H18.73L20.73,22L22,20.73M20,4H7.82L11.82,8H14V10.18L14.57,10.75L18,8V14.18L22,18.17C22,18.11 22,18.06 22,18V6C22,4.9 21.1,4 20,4Z' })
	  );
	};
	
	var CamcorderBoxIcon = function CamcorderBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,16L14,12.8V16H6V8H14V11.2L18,8M20,4H4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4Z' })
	  );
	};
	
	var CamcorderOffIcon = function CamcorderOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.27,2L2,3.27L4.73,6H4C3.45,6 3,6.45 3,7V17C3,17.55 3.45,18 4,18H16C16.2,18 16.39,17.92 16.54,17.82L19.73,21L21,19.73M21,6.5L17,10.5V7C17,6.45 16.55,6 16,6H9.82L21,17.18V6.5Z' })
	  );
	};
	
	var CamcorderIcon = function CamcorderIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,10.5V7C17,6.45 16.55,6 16,6H4C3.45,6 3,6.45 3,7V17C3,17.55 3.45,18 4,18H16C16.55,18 17,17.55 17,17V13.5L21,17.5V6.5L17,10.5Z' })
	  );
	};
	
	var CameraAccountIcon = function CameraAccountIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,5H7L9,3H15L17,5H20C21.1,5 22,5.9 22,7V19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19V7C2,5.9 2.9,5 4,5M16,17V16C16,14.67 13.33,14 12,14C10.67,14 8,14.67 8,16V17H16M12,9C10.9,9 10,9.9 10,11C10,12.1 10.9,13 12,13C13.1,13 14,12.1 14,11C14,9.9 13.1,9 12,9Z' })
	  );
	};
	
	var CameraBurstIcon = function CameraBurstIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,5H3V19H1V5M5,5H7V19H5V5M22,5H10C9.45,5 9,5.45 9,6V18C9,18.55 9.45,19 10,19H22C22.55,19 23,18.55 23,18V6C23,5.45 22.55,5 22,5M11,17L13.5,13.85L15.29,16L17.79,12.78L21,17H11Z' })
	  );
	};
	
	var CameraEnhanceIcon = function CameraEnhanceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,3L7.17,5H4C2.9,5 2,5.9 2,7V19C2,20.1 2.9,21 4,21H20C21.1,21 22,20.1 22,19V7C22,5.9 21.1,5 20,5H16.83L15,3M12,18C9.24,18 7,15.76 7,13C7,10.24 9.24,8 12,8C14.76,8 17,10.24 17,13C17,15.76 14.76,18 12,18M12,17L13.25,14.25L16,13L13.25,11.75L12,9L10.75,11.75L8,13L10.75,14.25' })
	  );
	};
	
	var CameraFrontVariantIcon = function CameraFrontVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,0H18C19.1,0 20,0.9 20,2V22C20,23.1 19.1,24 18,24H6C4.9,24 4,23.1 4,22V2C4,0.9 4.9,0 6,0M12,6C13.66,6 15,7.34 15,9C15,10.66 13.66,12 12,12C10.34,12 9,10.66 9,9C9,7.34 10.34,6 12,6M11,1V3H13V1H11M6,4V16.5C6,15.12 8.69,14 12,14C15.31,14 18,15.12 18,16.5V4H6M13,18H9V20H13V22L16,19L13,16V18Z' })
	  );
	};
	
	var CameraFrontIcon = function CameraFrontIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,2H17V12.5C17,10.83 13.67,10 12,10C10.33,10 7,10.83 7,12.5M17,0H7C5.9,0 5,0.9 5,2V16C5,17.1 5.9,18 7,18H17C18.1,18 19,17.1 19,16V2C19,0.9 18.1,0 17,0M12,8C13.1,8 14,7.1 14,6C14,4.9 13.1,4 12,4C10.9,4 10,4.9 10,6C10,7.1 10.9,8 12,8M14,20V22H19V20M10,20H5V22H10V24L13,21L10,18V20Z' })
	  );
	};
	
	var CameraGoproIcon = function CameraGoproIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,5H15C13.9,5 13,5.9 13,7V12C13,13.1 13.9,14 15,14H20C21.1,14 22,13.1 22,12V7C22,5.9 21.1,5 20,5M17.5,12.5C15.84,12.5 14.5,11.16 14.5,9.5C14.5,7.84 15.84,6.5 17.5,6.5C19.16,6.5 20.5,7.84 20.5,9.5C20.5,11.16 19.16,12.5 17.5,12.5M17.5,11C16.67,11 16,10.33 16,9.5C16,8.67 16.67,8 17.5,8C18.33,8 19,8.67 19,9.5C19,10.33 18.33,11 17.5,11M12,15V5H4C2.9,5 2,5.9 2,7V17C2,18.1 2.9,19 4,19H20C21.1,19 22,18.1 22,17V15H12M10,12H4V7H10V12Z' })
	  );
	};
	
	var CameraImageIcon = function CameraImageIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,5H7L9,3H15L17,5H20C21.1,5 22,5.9 22,7V19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19V7C2,5.9 2.9,5 4,5M13.09,9.45L11.05,12.18L12.6,14.25L11.73,14.91L9.27,11.64L6,16H18L13.09,9.45Z' })
	  );
	};
	
	var CameraIrisIcon = function CameraIrisIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.73,15L9.83,21.76C10.53,21.91 11.25,22 12,22C14.4,22 16.6,21.15 18.32,19.75L14.66,13.4M2.46,15C3.38,17.92 5.61,20.26 8.45,21.34L12.12,15M8.54,12L4.64,5.25C3,7 2,9.39 2,12C2,12.68 2.07,13.35 2.2,14H9.69M21.8,10H14.31L14.6,10.5L19.36,18.75C21,16.97 22,14.6 22,12C22,11.31 21.93,10.64 21.8,10M21.54,9C20.62,6.07 18.39,3.74 15.55,2.66L11.88,9M9.4,10.5L14.17,2.24C13.47,2.09 12.75,2 12,2C9.6,2 7.4,2.84 5.68,4.25L9.34,10.6L9.4,10.5Z' })
	  );
	};
	
	var CameraMeteringCenterIcon = function CameraMeteringCenterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H20C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4M4,6V18H20V6H4M12,10.5C12.83,10.5 13.5,11.17 13.5,12C13.5,12.83 12.83,13.5 12,13.5C11.17,13.5 10.5,12.83 10.5,12C10.5,11.17 11.17,10.5 12,10.5M12,7.5C14.14,7.5 15.93,9 16.39,11H14.83C14.42,9.83 13.31,9 12,9C10.69,9 9.58,9.83 9.17,11H7.61C8.07,9 9.86,7.5 12,7.5M12,16.5C9.86,16.5 8.07,15 7.61,13H9.17C9.58,14.17 10.69,15 12,15C13.31,15 14.42,14.17 14.83,13H16.39C15.93,15 14.14,16.5 12,16.5Z' })
	  );
	};
	
	var CameraMeteringMatrixIcon = function CameraMeteringMatrixIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H20C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4M4,6V18H20V6H4M5.5,7.5H11V9.17C10.15,9.47 9.47,10.15 9.17,11H5.5V7.5M18.5,7.5V11H14.83C14.53,10.15 13.85,9.47 13,9.17V7.5H18.5M18.5,16.5H13V14.83C13.85,14.53 14.53,13.85 14.83,13H18.5V16.5M5.5,16.5V13H9.17C9.47,13.85 10.15,14.53 11,14.83V16.5H5.5M12,10.5C12.83,10.5 13.5,11.17 13.5,12C13.5,12.83 12.83,13.5 12,13.5C11.17,13.5 10.5,12.83 10.5,12C10.5,11.17 11.17,10.5 12,10.5Z' })
	  );
	};
	
	var CameraMeteringPartialIcon = function CameraMeteringPartialIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H20C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4M4,6V18H20V6H4M12,7.5C14.14,7.5 15.93,9 16.39,11H14.83C14.42,9.83 13.31,9 12,9C10.69,9 9.58,9.83 9.17,11H7.61C8.07,9 9.86,7.5 12,7.5M12,16.5C9.86,16.5 8.07,15 7.61,13H9.17C9.58,14.17 10.69,15 12,15C13.31,15 14.42,14.17 14.83,13H16.39C15.93,15 14.14,16.5 12,16.5Z' })
	  );
	};
	
	var CameraMeteringSpotIcon = function CameraMeteringSpotIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H20C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4M4,6V18H20V6H4M12,10.5C12.83,10.5 13.5,11.17 13.5,12C13.5,12.83 12.83,13.5 12,13.5C11.17,13.5 10.5,12.83 10.5,12C10.5,11.17 11.17,10.5 12,10.5Z' })
	  );
	};
	
	var CameraOffIcon = function CameraOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1.2,4.47L2.5,3.2L20,20.72L18.73,22L16.73,20H4C2.9,20 2,19.1 2,18V6C2,5.78 2.04,5.57 2.1,5.37L1.2,4.47M7,4L9,2H15L17,4H20C21.1,4 22,4.9 22,6V18C22,18.6 21.74,19.13 21.32,19.5L16.33,14.5C16.76,13.77 17,12.91 17,12C17,9.24 14.76,7 12,7C11.09,7 10.23,7.24 9.5,7.67L5.82,4H7M7,12C7,14.76 9.24,17 12,17C12.5,17 13.03,16.92 13.5,16.77L11.72,15C10.29,14.85 9.15,13.71 9,12.28L7.23,10.5C7.08,10.97 7,11.5 7,12M12,9C13.66,9 15,10.34 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9Z' })
	  );
	};
	
	var CameraPartyModeIcon = function CameraPartyModeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,17C10.37,17 8.94,16.21 8,15H12C13.66,15 15,13.66 15,12C15,11.65 14.93,11.31 14.82,11H16.9C16.96,11.32 17,11.66 17,12C17,14.76 14.76,17 12,17M12,7C13.63,7 15.06,7.79 16,9H12C10.34,9 9,10.34 9,12C9,12.35 9.07,12.68 9.18,13H7.1C7.03,12.68 7,12.34 7,12C7,9.24 9.24,7 12,7M20,4H16.83L15,2H9L7.17,4H4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4Z' })
	  );
	};
	
	var CameraRearVariantIcon = function CameraRearVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,0H18C19.1,0 20,0.9 20,2V22C20,23.1 19.1,24 18,24H6C4.9,24 4,23.1 4,22V2C4,0.9 4.9,0 6,0M12,2C10.9,2 10,2.9 10,4C10,5.1 10.9,6 12,6C13.1,6 14,5.1 14,4C14,2.9 13.1,2 12,2M13,18H9V20H13V22L16,19L13,16V18Z' })
	  );
	};
	
	var CameraRearIcon = function CameraRearIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,6C10.89,6 10,5.1 10,4C10,2.9 10.9,2 12,2C13.09,2 14,2.9 14,4C14,5.1 13.1,6 12,6M17,0H7C5.9,0 5,0.9 5,2V16C5,17.1 5.9,18 7,18H17C18.1,18 19,17.1 19,16V2C19,0.9 18.1,0 17,0M14,20V22H19V20M10,20H5V22H10V24L13,21L10,18V20Z' })
	  );
	};
	
	var CameraSwitchIcon = function CameraSwitchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,15.5V13H9V15.5L5.5,12L9,8.5V11H15V8.5L18.5,12M20,4H16.83L15,2H9L7.17,4H4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4Z' })
	  );
	};
	
	var CameraTimerIcon = function CameraTimerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.94,6.35C4.55,5.96 4.55,5.32 4.94,4.93C5.33,4.54 5.96,4.54 6.35,4.93L13.07,10.31L13.42,10.59C14.2,11.37 14.2,12.64 13.42,13.42C12.64,14.2 11.37,14.2 10.59,13.42L10.31,13.07L4.94,6.35M12,20C16.42,20 20,16.42 20,12C20,9.79 19.1,7.79 17.66,6.34L19.07,4.93C20.88,6.74 22,9.24 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12H4C4,16.42 7.58,20 12,20M12,1C13.1,1 14,1.9 14,3C14,4.1 13.1,5 12,5C10.9,5 10,4.1 10,3C10,1.9 10.9,1 12,1Z' })
	  );
	};
	
	var CameraIcon = function CameraIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H7L9,2H15L17,4H20C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7M12,9C13.66,9 15,10.34 15,12C15,13.66 13.66,15 12,15C10.34,15 9,13.66 9,12C9,10.34 10.34,9 12,9Z' })
	  );
	};
	
	var CancelIcon = function CancelIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,13.85 4.63,15.55 5.68,16.91L16.91,5.68C15.55,4.63 13.85,4 12,4M12,20C16.42,20 20,16.42 20,12C20,10.15 19.37,8.45 18.32,7.09L7.09,18.32C8.45,19.37 10.15,20 12,20Z' })
	  );
	};
	
	var CandleIcon = function CandleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.5,2C10.84,2 9.5,5.34 9.5,7C9.5,8.66 10.84,10 12.5,10C14.16,10 15.5,8.66 15.5,7C15.5,5.34 14.16,2 12.5,2M12.5,6.5C13.05,6.5 13.5,6.95 13.5,7.5C13.5,8.05 13.05,8.5 12.5,8.5C11.95,8.5 11.5,8.05 11.5,7.5C11.5,6.95 11.95,6.5 12.5,6.5M10,11C9.45,11 9,11.45 9,12V20H7C6.45,20 6,19.55 6,19V18C6,17.45 5.55,17 5,17C4.45,17 4,17.45 4,18V19C4,20.66 5.34,22 7,22H19C19.55,22 20,21.55 20,21C20,20.45 19.55,20 19,20H16V12C16,11.45 15.55,11 15,11H10Z' })
	  );
	};
	
	var CandycaneIcon = function CandycaneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,10C10,11.1 9.1,12 8,12C6.9,12 6,11.1 6,10V8C6,7.37 6.1,6.77 6.27,6.2L10,9.93V10M12,2C12.74,2 13.44,2.13 14.09,2.38L11.97,6C11.14,6 10.44,6.5 10.15,7.25L7.24,4.34C8.34,2.92 10.06,2 12,2M17.76,6.31L14,10.07V8C14,7.62 13.9,7.27 13.72,6.97L15.83,3.38C16.74,4.13 17.42,5.15 17.76,6.31M18,13.09L14,17.09V12.9L18,8.9V13.09M18,20C18,21.1 17.1,22 16,22C14.9,22 14,21.1 14,20V19.91L18,15.91V20Z' })
	  );
	};
	
	var CannabisIcon = function CannabisIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.5,22V17.35C11,18.13 10,19.09 8.03,19.81C8.03,19.81 8.53,18.1 9.94,16.95C8.64,17.23 6.68,17.19 4,16C4,16 6.47,14.59 9.28,14.97C7.69,14 5.7,12.08 4.17,8.11C4.17,8.11 8.67,9.34 10.91,13.14C8.88,8.24 12,2 12,2C14.43,7.47 13.91,11.1 13.12,13.1C15.37,9.33 19.83,8.11 19.83,8.11C18.3,12.08 16.31,14 14.72,14.97C17.53,14.59 20,16 20,16C17.32,17.19 15.36,17.23 14.06,16.95C15.47,18.1 15.97,19.81 15.97,19.81C14,19.09 13,18.13 12.5,17.35V22H11.5Z' })
	  );
	};
	
	var CarBatteryIcon = function CarBatteryIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,3V6H1V20H23V6H20V3H14V6H10V3H4M3,8H21V18H3V8M15,10V12H13V14H15V16H17V14H19V12H17V10H15M5,12V14H11V12H5Z' })
	  );
	};
	
	var CarConnectedIcon = function CarConnectedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,14H19L17.5,9.5H6.5L5,14M17.5,19C18.33,19 19,18.33 19,17.5C19,16.67 18.33,16 17.5,16C16.67,16 16,16.67 16,17.5C16,18.33 16.67,19 17.5,19M6.5,19C7.33,19 8,18.33 8,17.5C8,16.67 7.33,16 6.5,16C5.67,16 5,16.67 5,17.5C5,18.33 5.67,19 6.5,19M18.92,9L21,15V23C21,23.55 20.55,24 20,24H19C18.45,24 18,23.55 18,23V22H6V23C6,23.55 5.55,24 5,24H4C3.45,24 3,23.55 3,23V15L5.08,9C5.28,8.42 5.85,8 6.5,8H17.5C18.15,8 18.72,8.42 18.92,9M12,0C14.12,0 16.15,0.86 17.65,2.35L16.23,3.77C15.11,2.65 13.58,2 12,2C10.42,2 8.89,2.65 7.77,3.77L6.36,2.35C7.85,0.86 9.88,0 12,0M12,4C13.06,4 14.07,4.44 14.82,5.18L13.4,6.6C13.03,6.23 12.53,6 12,6C11.5,6 10.97,6.23 10.6,6.6L9.18,5.18C9.93,4.44 10.94,4 12,4Z' })
	  );
	};
	
	var CarConvertibleIcon = function CarConvertibleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,6L15,6.75L17.5,10H13.5V8.5H12V10H3C1.89,10 1,10.89 1,12V15H3C3,16.66 4.34,18 6,18C7.66,18 9,16.66 9,15H15C15,16.66 16.34,18 18,18C19.66,18 21,16.66 21,15H23V12C23,10.89 22.11,10 21,10H19L16,6M6,13.5C6.83,13.5 7.5,14.17 7.5,15C7.5,15.83 6.83,16.5 6,16.5C5.17,16.5 4.5,15.83 4.5,15C4.5,14.17 5.17,13.5 6,13.5M18,13.5C18.83,13.5 19.5,14.17 19.5,15C19.5,15.83 18.83,16.5 18,16.5C17.17,16.5 16.5,15.83 16.5,15C16.5,14.17 17.17,13.5 18,13.5Z' })
	  );
	};
	
	var CarEstateIcon = function CarEstateIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,6H16L19,10H21C22.11,10 23,10.89 23,12V15H21C21,16.66 19.66,18 18,18C16.34,18 15,16.66 15,15H9C9,16.66 7.66,18 6,18C4.34,18 3,16.66 3,15H1V8C1,6.89 1.89,6 3,6M2.5,7.5V10H10.5V7.5H2.5M12,7.5V10H17.14L15.25,7.5H12M6,13.5C5.17,13.5 4.5,14.17 4.5,15C4.5,15.83 5.17,16.5 6,16.5C6.83,16.5 7.5,15.83 7.5,15C7.5,14.17 6.83,13.5 6,13.5M18,13.5C17.17,13.5 16.5,14.17 16.5,15C16.5,15.83 17.17,16.5 18,16.5C18.83,16.5 19.5,15.83 19.5,15C19.5,14.17 18.83,13.5 18,13.5Z' })
	  );
	};
	
	var CarHatchbackIcon = function CarHatchbackIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,6H6L1,12V15H3C3,16.66 4.34,18 6,18C7.66,18 9,16.66 9,15H15C15,16.66 16.34,18 18,18C19.66,18 21,16.66 21,15H23V12C23,10.89 22.11,10 21,10H19L16,6M6.5,7.5H10.5V10H4.5L6.5,7.5M12,7.5H15.5L17.46,10H12V7.5M6,13.5C6.83,13.5 7.5,14.17 7.5,15C7.5,15.83 6.83,16.5 6,16.5C5.17,16.5 4.5,15.83 4.5,15C4.5,14.17 5.17,13.5 6,13.5M18,13.5C18.83,13.5 19.5,14.17 19.5,15C19.5,15.83 18.83,16.5 18,16.5C17.17,16.5 16.5,15.83 16.5,15C16.5,14.17 17.17,13.5 18,13.5Z' })
	  );
	};
	
	var CarLimousineIcon = function CarLimousineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,6L2.5,7.5L1,9L2.5,10.5L1,12L2.5,13.5L1,15H15C15,16.66 16.34,18 18,18C19.66,18 21,16.66 21,15H23V12C23,10.89 22.11,10 21,10H19L16,6H1M4.62,7.5H10.5V10H4.12L3.12,9L4.62,7.5M12,7.5H15.5L17.46,10H12V7.5M18,13.5C18.83,13.5 19.5,14.17 19.5,15C19.5,15.83 18.83,16.5 18,16.5C17.17,16.5 16.5,15.83 16.5,15C16.5,14.17 17.17,13.5 18,13.5Z' })
	  );
	};
	
	var CarPickupIcon = function CarPickupIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,6H10.5V10H1V15H3C3,16.66 4.34,18 6,18C7.66,18 9,16.66 9,15H15C15,16.66 16.34,18 18,18C19.66,18 21,16.66 21,15H23V12C23,10.89 22.11,10 21,10H19L16,6M12,7.5H15.5L17.46,10H12V7.5M6,13.5C6.83,13.5 7.5,14.17 7.5,15C7.5,15.83 6.83,16.5 6,16.5C5.17,16.5 4.5,15.83 4.5,15C4.5,14.17 5.17,13.5 6,13.5M18,13.5C18.83,13.5 19.5,14.17 19.5,15C19.5,15.83 18.83,16.5 18,16.5C17.17,16.5 16.5,15.83 16.5,15C16.5,14.17 17.17,13.5 18,13.5Z' })
	  );
	};
	
	var CarSideIcon = function CarSideIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,6L19,10H21C22.11,10 23,10.89 23,12V15H21C21,16.66 19.66,18 18,18C16.34,18 15,16.66 15,15H9C9,16.66 7.66,18 6,18C4.34,18 3,16.66 3,15H1V12C1,10.89 1.89,10 3,10L6,6H16M10.5,7.5H6.75L4.86,10H10.5V7.5M12,7.5V10H17.14L15.25,7.5H12M6,13.5C5.17,13.5 4.5,14.17 4.5,15C4.5,15.83 5.17,16.5 6,16.5C6.83,16.5 7.5,15.83 7.5,15C7.5,14.17 6.83,13.5 6,13.5M18,13.5C17.17,13.5 16.5,14.17 16.5,15C16.5,15.83 17.17,16.5 18,16.5C18.83,16.5 19.5,15.83 19.5,15C19.5,14.17 18.83,13.5 18,13.5Z' })
	  );
	};
	
	var CarSportsIcon = function CarSportsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,8.5H7L4,11H3C1.89,11 1,11.89 1,13V16H3.17C3.6,17.2 4.73,18 6,18C7.27,18 8.4,17.2 8.82,16H15.17C15.6,17.2 16.73,18 18,18C19.27,18 20.4,17.2 20.82,16H23V15C23,13.89 21.97,13.53 21,13L12,8.5M5.25,12L7.5,10H11.5L15.5,12H5.25M6,13.5C6.83,13.5 7.5,14.17 7.5,15C7.5,15.83 6.83,16.5 6,16.5C5.17,16.5 4.5,15.83 4.5,15C4.5,14.17 5.17,13.5 6,13.5M18,13.5C18.83,13.5 19.5,14.17 19.5,15C19.5,15.83 18.83,16.5 18,16.5C17.17,16.5 16.5,15.83 16.5,15C16.5,14.17 17.17,13.5 18,13.5Z' })
	  );
	};
	
	var CarWashIcon = function CarWashIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,13L6.5,8.5H17.5L19,13M17.5,18C16.67,18 16,17.33 16,16.5C16,15.67 16.67,15 17.5,15C18.33,15 19,15.67 19,16.5C19,17.33 18.33,18 17.5,18M6.5,18C5.67,18 5,17.33 5,16.5C5,15.67 5.67,15 6.5,15C7.33,15 8,15.67 8,16.5C8,17.33 7.33,18 6.5,18M18.92,8C18.72,7.42 18.16,7 17.5,7H6.5C5.84,7 5.28,7.42 5.08,8L3,14V22C3,22.55 3.45,23 4,23H5C5.55,23 6,22.55 6,22V21H18V22C18,22.55 18.45,23 19,23H20C20.55,23 21,22.55 21,22V14M7,5C7.83,5 8.5,4.33 8.5,3.5C8.5,2.5 7,0.8 7,0.8C7,0.8 5.5,2.5 5.5,3.5C5.5,4.33 6.17,5 7,5M12,5C12.83,5 13.5,4.33 13.5,3.5C13.5,2.5 12,0.8 12,0.8C12,0.8 10.5,2.5 10.5,3.5C10.5,4.33 11.17,5 12,5M17,5C17.83,5 18.5,4.33 18.5,3.5C18.5,2.5 17,0.8 17,0.8C17,0.8 15.5,2.5 15.5,3.5C15.5,4.33 16.17,5 17,5Z' })
	  );
	};
	
	var CarIcon = function CarIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,11L6.5,6.5H17.5L19,11M17.5,16C16.67,16 16,15.33 16,14.5C16,13.67 16.67,13 17.5,13C18.33,13 19,13.67 19,14.5C19,15.33 18.33,16 17.5,16M6.5,16C5.67,16 5,15.33 5,14.5C5,13.67 5.67,13 6.5,13C7.33,13 8,13.67 8,14.5C8,15.33 7.33,16 6.5,16M18.92,6C18.72,5.42 18.16,5 17.5,5H6.5C5.84,5 5.28,5.42 5.08,6L3,12V20C3,20.55 3.45,21 4,21H5C5.55,21 6,20.55 6,20V19H18V20C18,20.55 18.45,21 19,21H20C20.55,21 21,20.55 21,20V12L18.92,6Z' })
	  );
	};
	
	var CaravanIcon = function CaravanIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,7C3.9,7 3,7.9 3,9V15C3,16.1 3.9,17 5,17H7C7,18.66 8.34,20 10,20C11.66,20 13,18.66 13,17H21V15H19V9C19,7.9 18.1,7 17,7H5M5,9H10V12H5V9M13,9H17V12H13V9M10,16C10.55,16 11,16.45 11,17C11,17.55 10.55,18 10,18C9.45,18 9,17.55 9,17C9,16.45 9.45,16 10,16Z' })
	  );
	};
	
	var CardsClubIcon = function CardsClubIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C14.3,2 16.3,4 16.3,6.2C16.21,8.77 14.34,9.83 14.04,10C15.04,9.5 16.5,9.5 16.5,9.5C19,9.5 21,11.3 21,13.8C21,16.3 19,18 16.5,18C16.5,18 15,18 13,17C13,17 12.7,19 15,22H9C11.3,19 11,17 11,17C9,18 7.5,18 7.5,18C5,18 3,16.3 3,13.8C3,11.3 5,9.5 7.5,9.5C7.5,9.5 8.96,9.5 9.96,10C9.66,9.83 7.79,8.77 7.7,6.2C7.7,4 9.7,2 12,2Z' })
	  );
	};
	
	var CardsDiamondIcon = function CardsDiamondIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,12L12,22L5,12L12,2' })
	  );
	};
	
	var CardsHeartIcon = function CardsHeartIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z' })
	  );
	};
	
	var CardsOutlineIcon = function CardsOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.19,2.25C10.93,2.25 10.67,2.31 10.42,2.4L3.06,5.45C2.04,5.87 1.55,7.04 1.97,8.05L6.93,20C7.24,20.77 7.97,21.23 8.74,21.25C9,21.25 9.27,21.22 9.53,21.1L16.9,18.05C17.65,17.74 18.11,17 18.13,16.25C18.14,16 18.09,15.71 18,15.45L13,3.5C12.71,2.73 11.97,2.26 11.19,2.25M14.67,2.25L18.12,10.6V4.25C18.12,3.15 17.22,2.25 16.12,2.25M20.13,3.79V12.82L22.56,6.96C22.97,5.94 22.5,4.78 21.47,4.36M11.19,4.22L16.17,16.24L8.78,19.3L3.8,7.29' })
	  );
	};
	
	var CardsPlayingOutlineIcon = function CardsPlayingOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.19,2.25C11.97,2.26 12.71,2.73 13,3.5L18,15.45C18.09,15.71 18.14,16 18.13,16.25C18.11,17 17.65,17.74 16.9,18.05L9.53,21.1C9.27,21.22 9,21.25 8.74,21.25C7.97,21.23 7.24,20.77 6.93,20L1.97,8.05C1.55,7.04 2.04,5.87 3.06,5.45L10.42,2.4C10.67,2.31 10.93,2.25 11.19,2.25M14.67,2.25H16.12C17.22,2.25 18.12,3.15 18.12,4.25V10.6L14.67,2.25M20.13,3.79L21.47,4.36C22.5,4.78 22.97,5.94 22.56,6.96L20.13,12.82V3.79M11.19,4.22L3.8,7.29L8.77,19.3L16.17,16.24L11.19,4.22M8.65,8.54L11.88,10.95L11.44,14.96L8.21,12.54L8.65,8.54Z' })
	  );
	};
	
	var CardsSpadeIcon = function CardsSpadeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C9,7 4,9 4,14C4,16 6,18 8,18C9,18 10,18 11,17C11,17 11.32,19 9,22H15C13,19 13,17 13,17C14,18 15,18 16,18C18,18 20,16 20,14C20,9 15,7 12,2Z' })
	  );
	};
	
	var CardsVariantIcon = function CardsVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,2H19C19.55,2 20,2.45 20,3V13C20,13.55 19.55,14 19,14H5C4.45,14 4,13.55 4,13V3C4,2.45 4.45,2 5,2M6,4V12H18V4H6M20,17C20,17.55 19.55,18 19,18H5C4.45,18 4,17.55 4,17V16H20V17M20,21C20,21.55 19.55,22 19,22H5C4.45,22 4,21.55 4,21V20H20V21Z' })
	  );
	};
	
	var CardsIcon = function CardsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.47,4.35L20.13,3.79V12.82L22.56,6.96C22.97,5.94 22.5,4.77 21.47,4.35M1.97,8.05L6.93,20C7.24,20.77 7.97,21.24 8.74,21.26C9,21.26 9.27,21.21 9.53,21.1L16.9,18.05C17.65,17.74 18.11,17 18.13,16.26C18.14,16 18.09,15.71 18,15.45L13,3.5C12.71,2.73 11.97,2.26 11.19,2.25C10.93,2.25 10.67,2.31 10.42,2.4L3.06,5.45C2.04,5.87 1.55,7.04 1.97,8.05M18.12,4.25C18.12,3.15 17.22,2.25 16.12,2.25H14.67L18.12,10.59' })
	  );
	};
	
	var CarrotIcon = function CarrotIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,10L15.8,11H13.5C13.22,11 13,11.22 13,11.5C13,11.78 13.22,12 13.5,12H15.6L14.6,17H12.5C12.22,17 12,17.22 12,17.5C12,17.78 12.22,18 12.5,18H14.4L14,20C14,21.1 13.1,22 12,22C10.9,22 10,21.1 10,20L9,15H10.5C10.78,15 11,14.78 11,14.5C11,14.22 10.78,14 10.5,14H8.8L8,10C8,8.8 8.93,7.77 10.29,7.29L8.9,5.28C8.59,4.82 8.7,4.2 9.16,3.89C9.61,3.57 10.23,3.69 10.55,4.14L11,4.8V3C11,2.45 11.45,2 12,2C12.55,2 13,2.45 13,3V5.28L14.5,3.54C14.83,3.12 15.47,3.07 15.89,3.43C16.31,3.78 16.36,4.41 16,4.84L13.87,7.35C15.14,7.85 16,8.85 16,10Z' })
	  );
	};
	
	var CartOffIcon = function CartOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22.73,22.73L1.27,1.27L0,2.54L4.39,6.93L6.6,11.59L5.25,14.04C5.09,14.32 5,14.65 5,15C5,16.1 5.9,17 7,17H14.46L15.84,18.38C15.34,18.74 15,19.33 15,20C15,21.1 15.9,22 17,22C17.67,22 18.26,21.67 18.62,21.16L21.46,24L22.73,22.73M7.42,15C7.28,15 7.17,14.89 7.17,14.75L7.2,14.63L8.1,13H10.46L12.46,15H7.42M15.55,13C16.3,13 16.96,12.59 17.3,11.97L20.88,5.5C20.96,5.34 21,5.17 21,5C21,4.45 20.55,4 20,4H6.54L15.55,13M7,18C5.9,18 5,18.9 5,20C5,21.1 5.9,22 7,22C8.1,22 9,21.1 9,20C9,18.9 8.1,18 7,18Z' })
	  );
	};
	
	var CartOutlineIcon = function CartOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,18C18.1,18 19,18.9 19,20C19,21.1 18.1,22 17,22C15.89,22 15,21.1 15,20C15,18.89 15.89,18 17,18M1,2H4.27L5.21,4H20C20.55,4 21,4.45 21,5C21,5.17 20.95,5.34 20.88,5.5L17.3,11.97C16.96,12.58 16.3,13 15.55,13H8.1L7.2,14.63L7.17,14.75C7.17,14.89 7.28,15 7.42,15H19V17H7C5.89,17 5,16.1 5,15C5,14.65 5.09,14.32 5.24,14.04L6.6,11.59L3,4H1V2M7,18C8.1,18 9,18.9 9,20C9,21.1 8.1,22 7,22C5.89,22 5,21.1 5,20C5,18.89 5.89,18 7,18M16,11L18.78,6H6.14L8.5,11H16Z' })
	  );
	};
	
	var CartPlusIcon = function CartPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,9H13V6H16V4H13V1H11V4H8V6H11M7,18C5.9,18 5,18.9 5,20C5,21.1 5.9,22 7,22C8.1,22 9,21.1 9,20C9,18.9 8.1,18 7,18M17,18C15.9,18 15,18.9 15,20C15,21.1 15.9,22 17,22C18.1,22 19,21.1 19,20C19,18.9 18.1,18 17,18M7.17,14.75L7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.59 17.3,11.97L21.16,4.96L19.42,4H19.41L18.31,6L15.55,11H8.53L8.4,10.73L6.16,6L5.21,4L4.27,2H1V4H3L6.6,11.59L5.25,14.04C5.09,14.32 5,14.65 5,15C5,16.1 5.9,17 7,17H19V15H7.42C7.29,15 7.17,14.89 7.17,14.75Z' })
	  );
	};
	
	var CartIcon = function CartIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,18C15.89,18 15,18.89 15,20C15,21.1 15.9,22 17,22C18.1,22 19,21.1 19,20C19,18.89 18.1,18 17,18M1,2V4H3L6.6,11.59L5.24,14.04C5.09,14.32 5,14.65 5,15C5,16.1 5.9,17 7,17H19V15H7.42C7.28,15 7.17,14.89 7.17,14.75C7.17,14.7 7.18,14.66 7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.58 17.3,11.97L20.88,5.5C20.95,5.34 21,5.17 21,5C21,4.45 20.55,4 20,4H5.21L4.27,2M7,18C5.89,18 5,18.89 5,20C5,21.1 5.9,22 7,22C8.1,22 9,21.1 9,20C9,18.89 8.1,18 7,18Z' })
	  );
	};
	
	var CaseSensitiveAltIcon = function CaseSensitiveAltIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,14C20,12.5 19.5,12 18,12H16V11C16,10 16,10 14,10V15.4L14,19H16L18,19C19.5,19 20,18.47 20,17V14M12,12C12,10.5 11.47,10 10,10H6C4.5,10 4,10.5 4,12V19H6V16H10V19H12V12M10,7H14V5H10V7M22,9V20C22,21.11 21.11,22 20,22H4C2.9,22 2,21.1 2,20V9C2,7.89 2.89,7 4,7H8V5L10,3H14L16,5V7H20C21.1,7 22,7.9 22,9H22M16,17H18V14H16V17M6,12H10V14H6V12Z' })
	  );
	};
	
	var Cash100Icon = function Cash100Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5H22V20H2V5M20,18V7H4V18H20M17,8C17,9.1 17.9,10 19,10V15C17.9,15 17,15.9 17,17H7C7,15.9 6.1,15 5,15V10C6.1,10 7,9.1 7,8H17M17,13V12C17,10.9 16.33,10 15.5,10C14.67,10 14,10.9 14,12V13C14,14.1 14.67,15 15.5,15C16.33,15 17,14.1 17,13M15.5,11C15.78,11 16,11.22 16,11.5V13.5C16,13.78 15.78,14 15.5,14C15.22,14 15,13.78 15,13.5V11.5C15,11.22 15.22,11 15.5,11M13,13V12C13,10.9 12.33,10 11.5,10C10.67,10 10,10.9 10,12V13C10,14.1 10.67,15 11.5,15C12.33,15 13,14.1 13,13M11.5,11C11.78,11 12,11.22 12,11.5V13.5C12,13.78 11.78,14 11.5,14C11.22,14 11,13.78 11,13.5V11.5C11,11.22 11.22,11 11.5,11M8,15H9V10H8L7,10.5V11.5L8,11V15Z' })
	  );
	};
	
	var CashMultipleIcon = function CashMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,6H23V18H5V6M14,9C15.66,9 17,10.34 17,12C17,13.66 15.66,15 14,15C12.34,15 11,13.66 11,12C11,10.34 12.34,9 14,9M9,8C9,9.1 8.1,10 7,10V14C8.1,14 9,14.9 9,16H19C19,14.9 19.9,14 21,14V10C19.9,10 19,9.1 19,8H9M1,10H3V20H19V22H1V10Z' })
	  );
	};
	
	var CashUsdIcon = function CashUsdIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,18H4V6H20M20,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4M11,17H13V16H14C14.55,16 15,15.55 15,15V12C15,11.45 14.55,11 14,11H11V10H15V8H13V7H11V8H10C9.45,8 9,8.45 9,9V12C9,12.55 9.45,13 10,13H13V14H9V16H11V17Z' })
	  );
	};
	
	var CashIcon = function CashIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,6H21V18H3V6M12,9C13.66,9 15,10.34 15,12C15,13.66 13.66,15 12,15C10.34,15 9,13.66 9,12C9,10.34 10.34,9 12,9M7,8C7,9.1 6.1,10 5,10V14C6.1,14 7,14.9 7,16H17C17,14.9 17.9,14 19,14V10C17.9,10 17,9.1 17,8H7Z' })
	  );
	};
	
	var CastConnectedIcon = function CastConnectedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,3H3C1.89,3 1,3.89 1,5V8H3V5H21V19H14V21H21C22.1,21 23,20.1 23,19V5C23,3.89 22.1,3 21,3M1,10V12C5.97,12 10,16.03 10,21H12C12,14.92 7.07,10 1,10M19,7H5V8.63C8.96,9.91 12.09,13.04 13.37,17H19M1,14V16C3.76,16 6,18.24 6,21H8C8,17.13 4.87,14 1,14M1,18V21H4C4,19.34 2.66,18 1,18Z' })
	  );
	};
	
	var CastOffIcon = function CastOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1.6,1.27L0.25,2.75L1.41,3.8C1.16,4.13 1,4.55 1,5V8H3V5.23L18.2,19H14V21H20.41L22.31,22.72L23.65,21.24M6.5,3L8.7,5H21V16.14L23,17.95V5C23,3.89 22.1,3 21,3M1,10V12C5.97,12 10,16.03 10,21H12C12,14.92 7.08,10 1,10M1,14V16C3.76,16 6,18.24 6,21H8C8,17.13 4.87,14 1,14M1,18V21H4C4,19.34 2.66,18 1,18Z' })
	  );
	};
	
	var CastIcon = function CastIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,10V12C5.97,12 10,16.03 10,21H12C12,14.92 7.07,10 1,10M1,14V16C3.76,16 6,18.24 6,21H8C8,17.13 4.87,14 1,14M1,18V21H4C4,19.34 2.66,18 1,18M21,3H3C1.89,3 1,3.89 1,5V8H3V5H21V19H14V21H21C22.1,21 23,20.1 23,19V5C23,3.89 22.1,3 21,3Z' })
	  );
	};
	
	var CastleIcon = function CastleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,13H4V15H6V13H8V15H10V13H12V15H14V10L17,7V1H19L23,3L19,5V7L22,10V22H11V19C11,17.9 10.1,17 9,17C7.9,17 7,17.9 7,19V22H2V13M18,10C17.45,10 17,10.54 17,11.2V13H19V11.2C19,10.54 18.55,10 18,10Z' })
	  );
	};
	
	var CatIcon = function CatIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,8L10.67,8.09C9.81,7.07 7.4,4.5 5,4.5C5,4.5 3.03,7.46 4.96,11.41C4.41,12.24 4.07,12.67 4,13.66L2.07,13.95L2.28,14.93L4.04,14.67L4.18,15.38L2.61,16.32L3.08,17.21L4.53,16.32C5.68,18.76 8.59,20 12,20C15.41,20 18.32,18.76 19.47,16.32L20.92,17.21L21.39,16.32L19.82,15.38L19.96,14.67L21.72,14.93L21.93,13.95L20,13.66C19.93,12.67 19.59,12.24 19.04,11.41C20.97,7.46 19,4.5 19,4.5C16.6,4.5 14.19,7.07 13.33,8.09L12,8M9,11C9.55,11 10,11.45 10,12C10,12.55 9.55,13 9,13C8.45,13 8,12.55 8,12C8,11.45 8.45,11 9,11M15,11C15.55,11 16,11.45 16,12C16,12.55 15.55,13 15,13C14.45,13 14,12.55 14,12C14,11.45 14.45,11 15,11M11,14H13L12.3,15.39C12.5,16.03 13.06,16.5 13.75,16.5C14.58,16.5 15.25,15.83 15.25,15H15.75C15.75,16.1 14.85,17 13.75,17C13,17 12.35,16.59 12,16V16H12C11.65,16.59 11,17 10.25,17C9.15,17 8.25,16.1 8.25,15H8.75C8.75,15.83 9.42,16.5 10.25,16.5C10.94,16.5 11.5,16.03 11.7,15.39L11,14Z' })
	  );
	};
	
	var CctvIcon = function CctvIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.15,4.94C17.77,4.91 17.37,5 17,5.2L8.35,10.2C7.39,10.76 7.07,12 7.62,12.94L9.12,15.53C9.67,16.5 10.89,16.82 11.85,16.27L13.65,15.23C13.92,15.69 14.32,16.06 14.81,16.27V18.04C14.81,19.13 15.7,20 16.81,20H22V18.04H16.81V16.27C17.72,15.87 18.31,14.97 18.31,14C18.31,13.54 18.19,13.11 17.97,12.73L20.5,11.27C21.47,10.71 21.8,9.5 21.24,8.53L19.74,5.94C19.4,5.34 18.79,5 18.15,4.94M6.22,13.17L2,13.87L2.75,15.17L4.75,18.63L5.5,19.93L8.22,16.63L6.22,13.17Z' })
	  );
	};
	
	var CeilingLightIcon = function CeilingLightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,9H11V4H13V9H16L20,17H4L8,9M14,18C14,19.1 13.1,20 12,20C10.9,20 10,19.1 10,18H14Z' })
	  );
	};
	
	var CellphoneAndroidIcon = function CellphoneAndroidIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.25,18H6.75V4H17.25M14,21H10V20H14M16,1H8C6.34,1 5,2.34 5,4V20C5,21.66 6.34,23 8,23H16C17.66,23 19,21.66 19,20V4C19,2.34 17.66,1 16,1Z' })
	  );
	};
	
	var CellphoneBasicIcon = function CellphoneBasicIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,2C14.45,2 14,2.45 14,3V6H10C8.89,6 8,6.89 8,8V20C8,21.11 8.89,22 10,22H15C16.11,22 17,21.11 17,20V8C17,7.26 16.6,6.62 16,6.28V3C16,2.45 15.55,2 15,2M10,8H15V13H10V8M10,15H11V16H10V15M12,15H13V16H12V15M14,15H15V16H14V15M10,17H11V18H10V17M12,17H13V18H12V17M14,17H15V18H14V17M10,19H11V20H10V19M12,19H13V20H12V19M14,19H15V20H14V19Z' })
	  );
	};
	
	var CellphoneDockIcon = function CellphoneDockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,15H8V5H16M16,1H8C6.89,1 6,1.89 6,3V17C6,18.1 6.9,19 8,19H16C17.1,19 18,18.1 18,17V3C18,1.89 17.1,1 16,1M8,23H16V21H8V23Z' })
	  );
	};
	
	var CellphoneEraseIcon = function CellphoneEraseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,8.2L10,7.2L6,11.2L2,7.2L1,8.2L5,12.2L1,16.2L2,17.2L6,13.2L10,17.2L11,16.2L7,12.2L11,8.2M17,1H7C5.9,1 5,1.9 5,3V6H7V4H17V20H7V18H5V21C5,22.1 5.9,23 7,23H17C18.1,23 19,22.1 19,21V3C19,1.9 18.1,1 17,1Z' })
	  );
	};
	
	var CellphoneIphoneIcon = function CellphoneIphoneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,18H7V4H16M11.5,22C10.67,22 10,21.33 10,20.5C10,19.67 10.67,19 11.5,19C12.33,19 13,19.67 13,20.5C13,21.33 12.33,22 11.5,22M15.5,1H7.5C6.12,1 5,2.12 5,3.5V20.5C5,21.88 6.12,23 7.5,23H15.5C16.88,23 18,21.88 18,20.5V3.5C18,2.12 16.88,1 15.5,1Z' })
	  );
	};
	
	var CellphoneKeyIcon = function CellphoneKeyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,1C5.9,1 5,1.9 5,3V7H7V4H17V20H7V17H5V21C5,22.1 5.9,23 7,23H17C18.1,23 19,22.1 19,21V3C19,1.9 18.1,1 17,1H7M6,9C4.34,9 3,10.34 3,12C3,13.66 4.34,15 6,15C7.31,15 8.42,14.17 8.83,13H11V15H13V13H14V11H8.83C8.42,9.83 7.31,9 6,9M6,11C6.55,11 7,11.45 7,12C7,12.55 6.55,13 6,13C5.45,13 5,12.55 5,12C5,11.45 5.45,11 6,11Z' })
	  );
	};
	
	var CellphoneLinkOffIcon = function CellphoneLinkOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,8H17C16.45,8 16,8.45 16,9V13.18L18,15.18V10H22V17H19.82L22.82,20H23C23.55,20 24,19.55 24,19V9C24,8.45 23.55,8 23,8M4,6.27L14.73,17H4V6.27M1.92,1.65L0.65,2.92L2.47,4.74C2.18,5.08 2,5.5 2,6V17H0V20H17.73L20.08,22.35L21.35,21.08L3.89,3.62L1.92,1.65M22,6V4H6.82L8.82,6H22Z' })
	  );
	};
	
	var CellphoneLinkIcon = function CellphoneLinkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,17H18V10H22M23,8H17C16.45,8 16,8.45 16,9V19C16,19.55 16.45,20 17,20H23C23.55,20 24,19.55 24,19V9C24,8.45 23.55,8 23,8M4,6H22V4H4C2.9,4 2,4.9 2,6V17H0V20H14V17H4V6Z' })
	  );
	};
	
	var CellphoneLockIcon = function CellphoneLockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,1H7C5.9,1 5,1.9 5,3V6H7V4H17V20H7V18H5V21C5,22.1 5.9,23 7,23H17C18.1,23 19,22.1 19,21V3C19,1.9 18.1,1 17,1M8.8,11V9.5C8.8,8.1 7.4,7 6,7C4.6,7 3.2,8.1 3.2,9.5V11C2.6,11 2,11.6 2,12.2V15.7C2,16.4 2.6,17 3.2,17H8.7C9.4,17 10,16.4 10,15.8V12.3C10,11.6 9.4,11 8.8,11M7.5,11H4.5V9.5C4.5,8.7 5.2,8.2 6,8.2C6.8,8.2 7.5,8.7 7.5,9.5V11Z' })
	  );
	};
	
	var CellphoneMessageIcon = function CellphoneMessageIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,17V7H4V17H11M11,3C12.1,3 13,3.9 13,5V19C13,20.1 12.1,21 11,21H4C2.89,21 2,20.1 2,19V5C2,3.9 2.9,3 4,3H11M16.5,3H21.5C22.33,3 23,3.67 23,4.5V7.5C23,8.33 22.33,9 21.5,9H18L15,12V9L15,4.5C15,3.67 15.67,3 16.5,3Z' })
	  );
	};
	
	var CellphoneOffIcon = function CellphoneOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.38,1.73L1.11,3L5,6.89V21C5,22.1 5.9,23 7,23H17C18.1,23 19,22.1 19,21V20.89L20.84,22.73L22.11,21.46M17,19H7V8.89L17,18.89V19M17,5V13.8L19,15.8V3C19,1.9 18.1,1 17,1H7C6.28,1 5.6,1.37 5.24,2L8.24,5H17Z' })
	  );
	};
	
	var CellphoneSettingsVariantIcon = function CellphoneSettingsVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.82,12.5C9.84,12.33 9.86,12.17 9.86,12C9.86,11.83 9.84,11.67 9.82,11.5L10.9,10.69C11,10.62 11,10.5 10.96,10.37L9.93,8.64C9.87,8.53 9.73,8.5 9.62,8.53L8.34,9.03C8.07,8.83 7.78,8.67 7.47,8.54L7.27,7.21C7.27,7.09 7.16,7 7.03,7H5C4.85,7 4.74,7.09 4.72,7.21L4.5,8.53C4.21,8.65 3.92,8.83 3.65,9L2.37,8.5C2.25,8.47 2.12,8.5 2.06,8.63L1.03,10.36C0.97,10.5 1,10.61 1.1,10.69L2.18,11.5C2.16,11.67 2.15,11.84 2.15,12C2.15,12.17 2.17,12.33 2.19,12.5L1.1,13.32C1,13.39 1,13.53 1.04,13.64L2.07,15.37C2.13,15.5 2.27,15.5 2.38,15.5L3.66,15C3.93,15.18 4.22,15.34 4.53,15.47L4.73,16.79C4.74,16.91 4.85,17 5,17H7.04C7.17,17 7.28,16.91 7.29,16.79L7.5,15.47C7.8,15.35 8.09,15.17 8.36,15L9.64,15.5C9.76,15.53 9.89,15.5 9.95,15.37L11,13.64C11.04,13.53 11,13.4 10.92,13.32L9.82,12.5M6,13.75C5,13.75 4.2,12.97 4.2,12C4.2,11.03 5,10.25 6,10.25C7,10.25 7.8,11.03 7.8,12C7.8,12.97 7,13.75 6,13.75M17,1H7C5.9,1 5,1.9 5,3V6H7V4H17V20H7V18H5V21C5,22.1 5.9,23 7,23H17C18.1,23 19,22.1 19,21V3C19,1.9 18.1,1 17,1Z' })
	  );
	};
	
	var CellphoneSettingsIcon = function CellphoneSettingsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,16H8V4H16M16,0H8C6.9,0 6,0.9 6,2V18C6,19.1 6.9,20 8,20H16C17.1,20 18,19.1 18,18V2C18,0.9 17.1,0 16,0M15,24H17V22H15M11,24H13V22H11M7,24H9V22H7V24Z' })
	  );
	};
	
	var CellphoneSoundIcon = function CellphoneSoundIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.1,8.7C20.9,10.5 20.9,13.3 19.1,15.2L20.1,16.2C22.6,13.9 22.6,10.1 20.1,7.7L19.1,8.7M18,9.8L17,10.8C17.5,11.5 17.5,12.4 17,13.1L18,14.1C19.2,12.9 19.2,11.1 18,9.8M14,1H4C2.9,1 2,1.9 2,3V21C2,22.1 2.9,23 4,23H14C15.1,23 16,22.1 16,21V3C16,1.9 15.1,1 14,1M14,20H4V4H14V20Z' })
	  );
	};
	
	var CellphoneTextIcon = function CellphoneTextIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,19V5H7V19H17M17,1C18.1,1 19,1.9 19,3V21C19,22.1 18.1,23 17,23H7C5.89,23 5,22.1 5,21V3C5,1.89 5.89,1 7,1H17M9,7H15V9H9V7M9,11H13V13H9V11Z' })
	  );
	};
	
	var CellphoneWirelessIcon = function CellphoneWirelessIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.07,4.93C21.88,6.74 23,9.24 23,12C23,14.76 21.88,17.26 20.07,19.07L18.66,17.66C20.11,16.22 21,14.22 21,12C21,9.79 20.11,7.78 18.66,6.34L20.07,4.93M17.24,7.76C18.33,8.85 19,10.35 19,12C19,13.65 18.33,15.15 17.24,16.24L15.83,14.83C16.55,14.11 17,13.11 17,12C17,10.89 16.55,9.89 15.83,9.17L17.24,7.76M13,10C14.1,10 15,10.9 15,12C15,13.1 14.1,14 13,14C11.9,14 11,13.1 11,12C11,10.9 11.9,10 13,10M11.5,1C12.88,1 14,2.12 14,3.5V8H12V4H3V19H12V16H14V20.5C14,21.88 12.88,23 11.5,23H3.5C2.12,23 1,21.88 1,20.5V3.5C1,2.12 2.12,1 3.5,1H11.5Z' })
	  );
	};
	
	var CellphoneIcon = function CellphoneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,19H7V5H17M17,1H7C5.89,1 5,1.89 5,3V21C5,22.1 5.9,23 7,23H17C18.1,23 19,22.1 19,21V3C19,1.89 18.1,1 17,1Z' })
	  );
	};
	
	var CertificateIcon = function CertificateIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,3C2.89,3 2,3.89 2,5V15C2,16.1 2.9,17 4,17H12V22L15,19L18,22V17H20C21.1,17 22,16.1 22,15V8L22,6V5C22,3.9 21.1,3 20,3H16V3H4M12,5L15,7L18,5V8.5L21,10L18,11.5V15L15,13L12,15V11.5L9,10L12,8.5V5M4,5H9V7H4V5M4,9H7V11H4V9M4,13H9V15H4V13Z' })
	  );
	};
	
	var ChairSchoolIcon = function ChairSchoolIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,5V7H17L13.53,12H16V14H14.46L18.17,22H15.97L15.04,20H6.38L5.35,22H3.1L7.23,14H7C6.55,14 6.17,13.7 6.04,13.3L2.87,3.84L3.82,3.5C4.34,3.34 4.91,3.63 5.08,4.15L7.72,12H12.1L15.57,7H12V5H22M9.5,14L7.42,18H14.11L12.26,14H9.5Z' })
	  );
	};
	
	var ChartArcIcon = function ChartArcIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.18,19.6L14.17,16.12C15.15,15.4 15.83,14.28 15.97,13H20C19.83,15.76 18.35,18.16 16.18,19.6M13,7.03V3C17.3,3.26 20.74,6.7 21,11H16.97C16.74,8.91 15.09,7.26 13,7.03M7,12.5C7,13.14 7.13,13.75 7.38,14.3L3.9,16.31C3.32,15.16 3,13.87 3,12.5C3,7.97 6.54,4.27 11,4V8.03C8.75,8.28 7,10.18 7,12.5M11.5,21C8.53,21 5.92,19.5 4.4,17.18L7.88,15.17C8.7,16.28 10,17 11.5,17C12.14,17 12.75,16.87 13.3,16.62L15.31,20.1C14.16,20.68 12.87,21 11.5,21Z' })
	  );
	};
	
	var ChartAreasplineIcon = function ChartAreasplineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.45,15.18L22,7.31V19L22,21H2V3H4V15.54L9.5,6L16,9.78L20.24,2.45L21.97,3.45L16.74,12.5L10.23,8.75L4.31,19H6.57L10.96,11.44L17.45,15.18Z' })
	  );
	};
	
	var ChartBarStackedIcon = function ChartBarStackedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,21H2V3H4V19H6V17H10V19H12V16H16V19H18V17H22V21M18,14H22V16H18V14M12,6H16V9H12V6M16,15H12V10H16V15M6,10H10V12H6V10M10,16H6V13H10V16Z' })
	  );
	};
	
	var ChartBarIcon = function ChartBarIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,21H2V3H4V19H6V10H10V19H12V6H16V19H18V14H22V21Z' })
	  );
	};
	
	var ChartBubbleIcon = function ChartBubbleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.2,11.2C8.97,11.2 10.4,12.63 10.4,14.4C10.4,16.17 8.97,17.6 7.2,17.6C5.43,17.6 4,16.17 4,14.4C4,12.63 5.43,11.2 7.2,11.2M14.8,16C15.9,16 16.8,16.9 16.8,18C16.8,19.1 15.9,20 14.8,20C13.7,20 12.8,19.1 12.8,18C12.8,16.9 13.7,16 14.8,16M15.2,4C17.85,4 20,6.15 20,8.8C20,11.45 17.85,13.6 15.2,13.6C12.55,13.6 10.4,11.45 10.4,8.8C10.4,6.15 12.55,4 15.2,4Z' })
	  );
	};
	
	var ChartDonutVariantIcon = function ChartDonutVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,2.05C18.05,2.55 22,6.82 22,12C22,13.45 21.68,14.83 21.12,16.07L18.5,14.54C18.82,13.75 19,12.9 19,12C19,8.47 16.39,5.57 13,5.08V2.05M12,19C14.21,19 16.17,18 17.45,16.38L20.05,17.91C18.23,20.39 15.3,22 12,22C6.47,22 2,17.5 2,12C2,6.81 5.94,2.55 11,2.05V5.08C7.61,5.57 5,8.47 5,12C5,15.87 8.13,19 12,19M12,6C15.31,6 18,8.69 18,12C18,14.97 15.84,17.44 13,17.92V14.83C14.17,14.42 15,13.31 15,12C15,10.34 13.66,9 12,9L11.45,9.05L9.91,6.38C10.56,6.13 11.26,6 12,6M6,12C6,10.14 6.85,8.5 8.18,7.38L9.72,10.05C9.27,10.57 9,11.26 9,12C9,13.31 9.83,14.42 11,14.83V17.92C8.16,17.44 6,14.97 6,12Z' })
	  );
	};
	
	var ChartDonutIcon = function ChartDonutIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,2.05V5.08C16.39,5.57 19,8.47 19,12C19,12.9 18.82,13.75 18.5,14.54L21.12,16.07C21.68,14.83 22,13.45 22,12C22,6.82 18.05,2.55 13,2.05M12,19C8.13,19 5,15.87 5,12C5,8.47 7.61,5.57 11,5.08V2.05C5.94,2.55 2,6.81 2,12C2,17.52 6.48,22 12,22C15.3,22 18.23,20.39 20.05,17.91L17.45,16.38C16.17,18 14.21,19 12,19Z' })
	  );
	};
	
	var ChartGanttIcon = function ChartGanttIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5H10V2H12V22H10V18H6V15H10V13H4V10H10V8H2V5M14,5H17V8H14V5M14,10H19V13H14V10M14,15H22V18H14V15Z' })
	  );
	};
	
	var ChartHistogramIcon = function ChartHistogramIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3H5V13H9V7H13V11H17V15H21V21H3V3Z' })
	  );
	};
	
	var ChartLineStackedIcon = function ChartLineStackedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.45,15.18L22,6.81V19L22,21H2V3H4V15.54L4,19H4.31L6,19H6.57L10.96,11.44L17.45,15.18M22,3L21.97,3.45L17,11L10,6L6,12V3H22Z' })
	  );
	};
	
	var ChartLineVariantIcon = function ChartLineVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.5,18.5L9.5,12.5L13.5,16.5L22,6.92L20.59,5.5L13.5,13.5L9.5,9.5L2,17L3.5,18.5Z' })
	  );
	};
	
	var ChartLineIcon = function ChartLineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,11.78L20.24,4.45L21.97,5.45L16.74,14.5L10.23,10.75L5.46,19H22V21H2V3H4V17.54L9.5,8L16,11.78Z' })
	  );
	};
	
	var ChartMultilineIcon = function ChartMultilineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,6.92L20.59,5.5L17.74,8.72C15.68,6.4 12.83,5 9.61,5C6.72,5 4.07,6.16 2,8L3.42,9.42C5.12,7.93 7.27,7 9.61,7C12.35,7 14.7,8.26 16.38,10.24L13.5,13.5L9.5,9.5L2,17L3.5,18.5L9.5,12.5L13.5,16.5L17.55,11.93C18.3,13.28 18.8,14.83 19,16.5H21C20.78,14.18 20.05,12.09 18.96,10.34L22,6.92Z' })
	  );
	};
	
	var ChartPieIcon = function ChartPieIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,11H13V3C17.42,3 21,6.58 21,11M19,13C19,15.78 17.58,18.23 15.43,19.67L11.58,13H19M11,21C8.22,21 5.77,19.58 4.33,17.43L10.82,13.68L14.56,20.17C13.5,20.7 12.28,21 11,21M3,13C3,8.58 6.58,5 11,5V12.42L3.83,16.56C3.3,15.5 3,14.28 3,13Z' })
	  );
	};
	
	var ChartScatterplotHexbinIcon = function ChartScatterplotHexbinIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,2H4V20H22V22H2V2M14,14.5L12,18H7.94L5.92,14.5L7.94,11H12L14,14.5M14.08,6.5L12.06,10H8L6,6.5L8,3H12.06L14.08,6.5M21.25,10.5L19.23,14H15.19L13.17,10.5L15.19,7H19.23L21.25,10.5Z' })
	  );
	};
	
	var ChartTimelineIcon = function ChartTimelineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,2H4V20H22V22H2V2M7,10H17V13H7V10M11,15H21V18H11V15M6,4H22V8H20V6H8V8H6V4Z' })
	  );
	};
	
	var CheckAllIcon = function CheckAllIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M0.41,13.41L6,19L7.41,17.58L1.83,12M22.24,5.58L11.66,16.17L7.5,12L6.07,13.41L11.66,19L23.66,7M18,7L16.59,5.58L10.24,11.93L11.66,13.34L18,7Z' })
	  );
	};
	
	var CheckCircleOutlineIcon = function CheckCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4M11,16.5L6.5,12L7.91,10.59L11,13.67L16.59,8.09L18,9.5L11,16.5Z' })
	  );
	};
	
	var CheckCircleIcon = function CheckCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z' })
	  );
	};
	
	var CheckOutlineIcon = function CheckOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.78,2.2L24,6.42L8.44,22L0,13.55L4.22,9.33L8.44,13.55L19.78,2.2M19.78,5L8.44,16.36L4.22,12.19L2.81,13.55L8.44,19.17L21.19,6.42L19.78,5Z' })
	  );
	};
	
	var CheckIcon = function CheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
	  );
	};
	
	var CheckboxBlankCircleOutlineIcon = function CheckboxBlankCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var CheckboxBlankCircleIcon = function CheckboxBlankCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var CheckboxBlankOutlineIcon = function CheckboxBlankOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z' })
	  );
	};
	
	var CheckboxBlankIcon = function CheckboxBlankIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z' })
	  );
	};
	
	var CheckboxIntermediateIcon = function CheckboxIntermediateIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M19,19H5V5H19V19M17,17H7V7H17V17Z' })
	  );
	};
	
	var CheckboxMarkedCircleOutlineIcon = function CheckboxMarkedCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z' })
	  );
	};
	
	var CheckboxMarkedCircleIcon = function CheckboxMarkedCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var CheckboxMarkedOutlineIcon = function CheckboxMarkedOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19H5V5H15V3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V11H19M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z' })
	  );
	};
	
	var CheckboxMarkedIcon = function CheckboxMarkedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z' })
	  );
	};
	
	var CheckboxMultipleBlankCircleOutlineIcon = function CheckboxMultipleBlankCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,2C9.58,2 6,5.58 6,10C6,14.42 9.58,18 14,18C18.42,18 22,14.42 22,10C22,5.58 18.42,2 14,2M14,4C17.32,4 20,6.69 20,10C20,13.32 17.32,16 14,16C10.69,16 8,13.31 8,10C8,6.69 10.69,4 14,4M4.93,5.82C3.08,7.34 2,9.61 2,12C2,16.42 5.58,20 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z' })
	  );
	};
	
	var CheckboxMultipleBlankCircleIcon = function CheckboxMultipleBlankCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,2C9.58,2 6,5.58 6,10C6,14.42 9.58,18 14,18C18.42,18 22,14.42 22,10C22,5.58 18.42,2 14,2M4.93,5.82C3.08,7.34 2,9.61 2,12C2,16.42 5.58,20 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z' })
	  );
	};
	
	var CheckboxMultipleBlankOutlineIcon = function CheckboxMultipleBlankOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,16V4H8V16H20M22,16C22,17.1 21.1,18 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H20C21.1,2 22,2.9 22,4V16M16,20V22H4C2.9,22 2,21.1 2,20V7H4V20H16Z' })
	  );
	};
	
	var CheckboxMultipleBlankIcon = function CheckboxMultipleBlankIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,16C22,17.1 21.1,18 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H20C21.1,2 22,2.9 22,4V16M16,20V22H4C2.9,22 2,21.1 2,20V7H4V20H16Z' })
	  );
	};
	
	var CheckboxMultipleMarkedCircleOutlineIcon = function CheckboxMultipleMarkedCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,2C9.58,2 6,5.58 6,10C6,14.42 9.58,18 14,18C18.42,18 22,14.42 22,10H20C20,13.32 17.32,16 14,16C10.69,16 8,13.31 8,10C8,6.69 10.69,4 14,4C14.43,4 14.86,4.05 15.27,4.14L16.88,2.54C15.96,2.18 15,2 14,2M20.59,3.58L14,10.17L11.62,7.79L10.21,9.21L14,13L22,5M4.93,5.82C3.08,7.34 2,9.61 2,12C2,16.42 5.58,20 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82Z' })
	  );
	};
	
	var CheckboxMultipleMarkedCircleIcon = function CheckboxMultipleMarkedCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,2C9.58,2 6,5.58 6,10C6,14.42 9.58,18 14,18C18.42,18 22,14.42 22,10C22,5.58 18.42,2 14,2M4.93,5.82C3.08,7.34 2,9.61 2,12C2,16.42 5.58,20 10,20C10.64,20 11.27,19.92 11.88,19.77C10.12,19.38 8.5,18.5 7.17,17.29C5.22,16.25 4,14.21 4,12C4,11.7 4.03,11.41 4.07,11.11C4.03,10.74 4,10.37 4,10C4,8.56 4.32,7.13 4.93,5.82M18.09,6.08L19.5,7.5L13,14L9.21,10.21L10.63,8.79L13,11.17' })
	  );
	};
	
	var CheckboxMultipleMarkedOutlineIcon = function CheckboxMultipleMarkedOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,16V10H22V16C22,17.1 21.1,18 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H16V4H8V16H20M10.91,7.08L14,10.17L20.59,3.58L22,5L14,13L9.5,8.5L10.91,7.08M16,20V22H4C2.9,22 2,21.1 2,20V7H4V20H16Z' })
	  );
	};
	
	var CheckboxMultipleMarkedIcon = function CheckboxMultipleMarkedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,16C22,17.1 21.1,18 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H20C21.1,2 22,2.9 22,4V16M16,20V22H4C2.9,22 2,21.1 2,20V7H4V20H16M13,14L20,7L18.59,5.59L13,11.17L9.91,8.09L8.5,9.5L13,14Z' })
	  );
	};
	
	var CheckerboardIcon = function CheckerboardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3H21V21H3V3M5,5V12H12V19H19V12H12V5H5Z' })
	  );
	};
	
	var ChemicalWeaponIcon = function ChemicalWeaponIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,7.83C9.83,7.42 9,6.3 9,5C9,3.34 10.34,2 12,2C13.66,2 15,3.34 15,5C15,6.31 14.16,7.42 13,7.83V10.64C12.68,10.55 12.35,10.5 12,10.5C11.65,10.5 11.32,10.55 11,10.64V7.83M18.3,21.1C17.16,20.45 16.62,19.18 16.84,17.96L14.4,16.55C14.88,16.09 15.24,15.5 15.4,14.82L17.84,16.23C18.78,15.42 20.16,15.26 21.29,15.91C22.73,16.74 23.22,18.57 22.39,20C21.56,21.44 19.73,21.93 18.3,21.1M2.7,15.9C3.83,15.25 5.21,15.42 6.15,16.22L8.6,14.81C8.76,15.5 9.11,16.08 9.6,16.54L7.15,17.95C7.38,19.17 6.83,20.45 5.7,21.1C4.26,21.93 2.43,21.44 1.6,20C0.77,18.57 1.26,16.73 2.7,15.9M14,14C14,15.1 13.1,16 12,16C10.89,16 10,15.1 10,14C10,12.9 10.9,12 12,12C13.11,12 14,12.9 14,14M17,14L16.97,14.57L15.5,13.71C15.4,12.64 14.83,11.71 14,11.12V9.41C15.77,10.19 17,11.95 17,14M14.97,18.03C14.14,18.64 13.11,19 12,19C10.89,19 9.86,18.64 9.03,18L10.5,17.17C10.96,17.38 11.47,17.5 12,17.5C12.53,17.5 13.03,17.38 13.5,17.17L14.97,18.03M7.03,14.56L7,14C7,11.95 8.23,10.19 10,9.42V11.13C9.17,11.71 8.6,12.64 8.5,13.7L7.03,14.56Z' })
	  );
	};
	
	var ChessBishopIcon = function ChessBishopIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,22H5V20H19V22M17.16,8.26C18.22,9.63 18.86,11.28 19,13C19,15.76 15.87,18 12,18C8.13,18 5,15.76 5,13C5,10.62 7.33,6.39 10.46,5.27C10.16,4.91 10,4.46 10,4C10,2.9 10.9,2 12,2C13.1,2 14,2.9 14,4C14,4.46 13.84,4.91 13.54,5.27C14.4,5.6 15.18,6.1 15.84,6.74L11.29,11.29L12.71,12.71L17.16,8.26Z' })
	  );
	};
	
	var ChessKingIcon = function ChessKingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,22H5V20H19V22M17,10C15.58,10 14.26,10.77 13.55,12H13V7H16V5H13V2H11V5H8V7H11V12H10.45C9.35,10.09 6.9,9.43 5,10.54C3.07,11.64 2.42,14.09 3.5,16C4.24,17.24 5.57,18 7,18H17C19.21,18 21,16.21 21,14C21,11.79 19.21,10 17,10Z' })
	  );
	};
	
	var ChessKnightIcon = function ChessKnightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,22H5V20H19V22M13,2V2C11.75,2 10.58,2.62 9.89,3.66L7,8L9,10L11.06,8.63C11.5,8.32 12.14,8.44 12.45,8.9C12.47,8.93 12.5,8.96 12.5,9V9C12.8,9.59 12.69,10.3 12.22,10.77L7.42,15.57C6.87,16.13 6.87,17.03 7.43,17.58C7.69,17.84 8.05,18 8.42,18H17V6C17,3.79 15.21,2 13,2Z' })
	  );
	};
	
	var ChessPawnIcon = function ChessPawnIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,22H5V20H19V22M16,18L13.2,7.74C14.72,7.07 15.41,5.31 14.74,3.79C14.08,2.27 12.31,1.58 10.79,2.25C9.27,2.91 8.58,4.68 9.25,6.2C9.55,6.89 10.1,7.44 10.79,7.74L8,18H16Z' })
	  );
	};
	
	var ChessQueenIcon = function ChessQueenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,3C19.1,3 20,3.9 20,5C20,5.81 19.5,6.5 18.83,6.82L17,13.15V18H7V13.15L5.17,6.82C4.5,6.5 4,5.81 4,5C4,3.9 4.9,3 6,3C7.1,3 8,3.9 8,5C8,5.5 7.82,5.95 7.5,6.3L10.3,9.35L10.83,5.62C10.33,5.26 10,4.67 10,4C10,2.9 10.9,2 12,2C13.1,2 14,2.9 14,4C14,4.67 13.67,5.26 13.17,5.62L13.7,9.35L16.47,6.29C16.18,5.94 16,5.5 16,5C16,3.9 16.9,3 18,3M5,20H19V22H5V20Z' })
	  );
	};
	
	var ChessRookIcon = function ChessRookIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,20H19V22H5V20M17,2V5H15V2H13V5H11V2H9V5H7V2H5V8H7V18H17V8H19V2H17Z' })
	  );
	};
	
	var ChevronDoubleDownIcon = function ChevronDoubleDownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.59,5.59L18,7L12,13L6,7L7.41,5.59L12,10.17L16.59,5.59M16.59,11.59L18,13L12,19L6,13L7.41,11.59L12,16.17L16.59,11.59Z' })
	  );
	};
	
	var ChevronDoubleLeftIcon = function ChevronDoubleLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.41,7.41L17,6L11,12L17,18L18.41,16.59L13.83,12L18.41,7.41M12.41,7.41L11,6L5,12L11,18L12.41,16.59L7.83,12L12.41,7.41Z' })
	  );
	};
	
	var ChevronDoubleRightIcon = function ChevronDoubleRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.59,7.41L7,6L13,12L7,18L5.59,16.59L10.17,12L5.59,7.41M11.59,7.41L13,6L19,12L13,18L11.59,16.59L16.17,12L11.59,7.41Z' })
	  );
	};
	
	var ChevronDoubleUpIcon = function ChevronDoubleUpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.41,18.41L6,17L12,11L18,17L16.59,18.41L12,13.83L7.41,18.41M7.41,12.41L6,11L12,5L18,11L16.59,12.41L12,7.83L7.41,12.41Z' })
	  );
	};
	
	var ChevronDownIcon = function ChevronDownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z' })
	  );
	};
	
	var ChevronLeftIcon = function ChevronLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z' })
	  );
	};
	
	var ChevronRightIcon = function ChevronRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z' })
	  );
	};
	
	var ChevronUpIcon = function ChevronUpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z' })
	  );
	};
	
	var ChiliHotIcon = function ChiliHotIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.75,9L18.95,8.24C19.58,8.58 20,9.24 20,10V21.75C20,21.75 12,20 12,11V10C12,9.27 12.39,8.63 12.97,8.28L14.43,9L16,8L17.75,9M14,2C15.53,2 16.8,3.15 17,4.64C18,4.93 18.81,5.67 19.22,6.63L17.75,7.5L16,6.5L14.43,7.5L12.76,6.67C13.15,5.72 13.95,5 14.94,4.66C14.8,4.28 14.43,4 14,4V2M10,10C10,18 13.63,19.84 16,21.75C16,21.75 8,20 8,11V10C8,9.27 8.39,8.63 8.97,8.28L10.3,8.94C10.11,9.25 10,9.61 10,10M10.43,7.5L8.76,6.67C9.15,5.72 9.95,5 10.94,4.66C10.8,4.28 10.43,4 10,4V2C10.77,2 11.47,2.29 12,2.76V4C12.43,4 12.8,4.28 12.94,4.66C11.95,5 11.15,5.72 10.43,7.5M6,10C6,18 9.63,19.84 12,21.75C12,21.75 4,20 4,11V10C4,9.27 4.39,8.63 4.97,8.28L6.3,8.94C6.11,9.25 6,9.61 6,10M6.43,7.5L4.76,6.67C5.15,5.72 5.95,5 6.94,4.66C6.8,4.28 6.43,4 6,4V2C6.77,2 7.47,2.29 8,2.76V4C8.43,4 8.8,4.28 8.94,4.66C7.95,5 7.15,5.72 6.43,7.5Z' })
	  );
	};
	
	var ChiliMediumIcon = function ChiliMediumIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.75,9L16.95,8.24C17.58,8.58 18,9.24 18,10V21.75C18,21.75 10,20 10,11V10C10,9.27 10.39,8.63 10.97,8.28L12.43,9L14,8L15.75,9M12,2C13.53,2 14.8,3.15 15,4.64C16,4.93 16.81,5.67 17.22,6.63L15.75,7.5L14,6.5L12.43,7.5L10.76,6.67C11.15,5.72 11.95,5 12.94,4.66C12.8,4.28 12.43,4 12,4V2M8,10C8,18 11.63,19.84 14,21.75C14,21.75 6,20 6,11V10C6,9.27 6.39,8.63 6.97,8.28L8.3,8.94C8.11,9.25 8,9.61 8,10M8.43,7.5L6.76,6.67C7.15,5.72 7.95,5 8.94,4.66C8.8,4.28 8.43,4 8,4V2C8.77,2 9.47,2.29 10,2.76V4C10.43,4 10.8,4.28 10.94,4.66C9.95,5 9.15,5.72 8.43,7.5Z' })
	  );
	};
	
	var ChiliMildIcon = function ChiliMildIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.75,9L14.95,8.24C15.58,8.58 16,9.24 16,10V21.75C16,21.75 8,20 8,11V10C8,9.27 8.39,8.63 8.97,8.28L10.43,9L12,8L13.75,9M10,2C11.53,2 12.8,3.15 13,4.64C14,4.93 14.81,5.67 15.22,6.63L13.75,7.5L12,6.5L10.43,7.5L8.76,6.67C9.15,5.72 9.95,5 10.94,4.66C10.8,4.28 10.43,4 10,4V2Z' })
	  );
	};
	
	var ChipIcon = function ChipIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,4H18V5H21V7H18V9H21V11H18V13H21V15H18V17H21V19H18V20H6V19H3V17H6V15H3V13H6V11H3V9H6V7H3V5H6V4M11,15V18H12V15H11M13,15V18H14V15H13M15,15V18H16V15H15Z' })
	  );
	};
	
	var ChristiantiyIcon = function ChristiantiyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.5,2H13.5V8H19V11H13.5V22H10.5V11H5V8H10.5V2Z' })
	  );
	};
	
	var ChurchIcon = function ChurchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,2H13V4H15V6H13V9.4L22,13V15L20,14.2V22H14V17C14,15.9 13.1,15 12,15C10.9,15 10,15.9 10,17V22H4V14.2L2,15V13L11,9.4V6H9V4H11V2M6,20H8V15L7,14L6,15V20M16,20H18V15L17,14L16,15V20Z' })
	  );
	};
	
	var CircleEditOutlineIcon = function CircleEditOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12H20C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4V2M18.78,3C18.61,3 18.43,3.07 18.3,3.2L17.08,4.41L19.58,6.91L20.8,5.7C21.06,5.44 21.06,5 20.8,4.75L19.25,3.2C19.12,3.07 18.95,3 18.78,3M16.37,5.12L9,12.5V15H11.5L18.87,7.62L16.37,5.12Z' })
	  );
	};
	
	var CircleOutlineIcon = function CircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var CircleIcon = function CircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var CiscoWebexIcon = function CiscoWebexIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C16.97,3 21,7.03 21,12C21,16.97 16.97,21 12,21C7.03,21 3,16.97 3,12C3,7.03 7.03,3 12,3M5.94,8.5C4,11.85 5.15,16.13 8.5,18.06C11.85,20 18.85,7.87 15.5,5.94C12.15,4 7.87,5.15 5.94,8.5Z' })
	  );
	};
	
	var CityIcon = function CityIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,15H17V13H19M19,19H17V17H19M13,7H11V5H13M13,11H11V9H13M13,15H11V13H13M13,19H11V17H13M7,11H5V9H7M7,15H5V13H7M7,19H5V17H7M15,11V5L12,2L9,5V7H3V21H21V11H15Z' })
	  );
	};
	
	var ClipboardAccountIcon = function ClipboardAccountIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,19H6V17.6C6,15.6 10,14.5 12,14.5C14,14.5 18,15.6 18,17.6M12,7C13.66,7 15,8.34 15,10C15,11.66 13.66,13 12,13C10.34,13 9,11.66 9,10C9,8.34 10.34,7 12,7M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var ClipboardAlertIcon = function ClipboardAlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5M13,14H11V8H13M13,18H11V16H13M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var ClipboardArrowDownIcon = function ClipboardArrowDownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,18L7,13H10V9H14V13H17M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var ClipboardArrowLeftIcon = function ClipboardArrowLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,15H12V18L7,13L12,8V11H16M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var ClipboardCheckOutlineIcon = function ClipboardCheckOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M7,7H17V5H19V19H5V5H7V7M7.5,13.5L9,12L11,14L15.5,9.5L17,11L11,17L7.5,13.5Z' })
	  );
	};
	
	var ClipboardCheckIcon = function ClipboardCheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var ClipboardFlowIcon = function ClipboardFlowIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M15,19L11,15H14V8H16V15H19L15,19M10,16H8V9H5L9,5L13,9H10V16' })
	  );
	};
	
	var ClipboardOutlineIcon = function ClipboardOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M7,7H17V5H19V19H5V5H7V7Z' })
	  );
	};
	
	var ClipboardPlusIcon = function ClipboardPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M13,12H16V14H13V17H11V14H8V12H11V9H13V12Z' })
	  );
	};
	
	var ClipboardPulseOutlineIcon = function ClipboardPulseOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M5,15H8.11L9.62,12.15L10.38,17.92L14.07,13.21L15.89,15H19V19H5V15M19,13.46H16.53L13.93,10.86L11.44,14.05L10.5,7.08L7.17,13.46H5V5H7V6H17V5H19V6L19,13.46Z' })
	  );
	};
	
	var ClipboardPulseIcon = function ClipboardPulseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M5,13.46H7.17L10.5,7.08L11.44,14.05L13.93,10.86L16.53,13.46H19V15H15.89L14.07,13.21L10.38,17.92L9.62,12.15L8.11,15H5V13.46Z' })
	  );
	};
	
	var ClipboardTextIcon = function ClipboardTextIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,9H7V7H17M17,13H7V11H17M14,17H7V15H14M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var ClipboardIcon = function ClipboardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M12,3C12.55,3 13,3.45 13,4C13,4.55 12.55,5 12,5C11.45,5 11,4.55 11,4C11,3.45 11.45,3 12,3' })
	  );
	};
	
	var ClippyIcon = function ClippyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,15.5C15,16.88 13.88,18 12.5,18C11.12,18 10,16.88 10,15.5V13.75C10,13.34 10.34,13 10.75,13C11.16,13 11.5,13.34 11.5,13.75V15.5C11.5,16.05 11.95,16.5 12.5,16.5C13.05,16.5 13.5,16.05 13.5,15.5V11.89C12.63,11.61 12,10.87 12,10C12,8.9 13,8 14.25,8C15.5,8 16.5,8.9 16.5,10C16.5,10.87 15.87,11.61 15,11.89V15.5M8.25,8C9.5,8 10.5,8.9 10.5,10C10.5,10.87 9.87,11.61 9,11.89V17.25C9,19.04 10.46,20.5 12.25,20.5C14.04,20.5 15.5,19.04 15.5,17.25V13.75C15.5,13.34 15.84,13 16.25,13C16.66,13 17,13.34 17,13.75V17.25C17,19.87 14.87,22 12.25,22C9.63,22 7.5,19.87 7.5,17.25V11.89C6.63,11.61 6,10.87 6,10C6,8.9 7,8 8.25,8M10.06,6.13L9.63,7.59C9.22,7.37 8.75,7.25 8.25,7.25C7.34,7.25 6.53,7.65 6.03,8.27L4.83,7.37C5.46,6.57 6.41,6 7.5,5.81V5.75C7.5,3.68 9.18,2 11.25,2C13.32,2 15,3.68 15,5.75V5.81C16.09,6 17.04,6.57 17.67,7.37L16.47,8.27C15.97,7.65 15.16,7.25 14.25,7.25C13.75,7.25 13.28,7.37 12.87,7.59L12.44,6.13C12.77,6 13.13,5.87 13.5,5.81V5.75C13.5,4.5 12.5,3.5 11.25,3.5C10,3.5 9,4.5 9,5.75V5.81C9.37,5.87 9.73,6 10.06,6.13M14.25,9.25C13.7,9.25 13.25,9.59 13.25,10C13.25,10.41 13.7,10.75 14.25,10.75C14.8,10.75 15.25,10.41 15.25,10C15.25,9.59 14.8,9.25 14.25,9.25M8.25,9.25C7.7,9.25 7.25,9.59 7.25,10C7.25,10.41 7.7,10.75 8.25,10.75C8.8,10.75 9.25,10.41 9.25,10C9.25,9.59 8.8,9.25 8.25,9.25Z' })
	  );
	};
	
	var ClockAlertOutlineIcon = function ClockAlertOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.47,2 2,6.5 2,12C2,17.52 6.48,22 12,22C14.25,22 16.33,21.24 18,20V17.28C16.53,18.94 14.39,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C15.36,4 18.23,6.07 19.41,9H21.54C20.27,4.94 16.5,2 12,2M11,7V13L16.25,16.15L17,14.92L12.5,12.25V7H11M20,11V18H22V11H20M20,20V22H22V20H20Z' })
	  );
	};
	
	var ClockAlertIcon = function ClockAlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C16.46,2 20.26,4.95 21.54,9H18V20C16.33,21.25 14.25,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M16.2,16.2L17,14.9L12.5,12.2V7H11V13L16.2,16.2M20,11H22V18H20V11M20,20H22V22H20V20Z' })
	  );
	};
	
	var ClockEndIcon = function ClockEndIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1C8.14,1 5,4.14 5,8C5,11.87 8.13,15 12,15C15.86,15 19,11.87 19,8C19,4.14 15.86,1 12,1M12,3.15C14.67,3.15 16.85,5.32 16.85,8C16.85,10.68 14.67,12.85 12,12.85C9.32,12.85 7.15,10.68 7.15,8C7.15,5.32 9.32,3.15 12,3.15M11,5V8.69L14.19,10.53L14.94,9.23L12.5,7.82V5M15,16V19H3V21H15V24L19,20M19,20V24H21V16H19' })
	  );
	};
	
	var ClockFastIcon = function ClockFastIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,4C19.42,4 23,7.58 23,12C23,16.42 19.42,20 15,20C10.58,20 7,16.42 7,12C7,7.58 10.58,4 15,4M15,6C11.69,6 9,8.69 9,12C9,15.31 11.69,18 15,18C18.31,18 21,15.31 21,12C21,8.69 18.31,6 15,6M14,8H15.5V11.78L17.83,14.11L16.77,15.17L14,12.4V8M2,18C1.45,18 1,17.55 1,17C1,16.45 1.45,16 2,16H5.83C6.14,16.71 6.54,17.38 7,18H2M3,13C2.45,13 2,12.55 2,12C2,11.45 2.45,11 3,11H5.05L5,12L5.05,13H3M4,8C3.45,8 3,7.55 3,7C3,6.45 3.45,6 4,6H7C6.54,6.62 6.14,7.29 5.83,8H4Z' })
	  );
	};
	
	var ClockInIcon = function ClockInIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.21,0.79L0.79,2.21L4.8,6.21L3,8H8V3L6.21,4.8M12,8C8.14,8 5,11.13 5,15C5,18.87 8.13,22 12,22C15.86,22 19,18.87 19,15C19,11.13 15.87,8 12,8M12,10.15C14.67,10.15 16.85,12.32 16.85,15C16.85,17.68 14.68,19.85 12,19.85C9.32,19.85 7.15,17.68 7.15,15C7.15,12.32 9.32,10.15 12,10.15M11,12V15.69L14.19,17.53L14.94,16.23L12.5,14.82V12' })
	  );
	};
	
	var ClockOutIcon = function ClockOutIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,1L19.8,2.79L15.79,6.79L17.21,8.21L21.21,4.21L23,6V1M12,8C8.14,8 5,11.13 5,15C5,18.87 8.13,22 12,22C15.86,22 19,18.87 19,15C19,11.13 15.87,8 12,8M12,10.15C14.67,10.15 16.85,12.32 16.85,15C16.85,17.68 14.68,19.85 12,19.85C9.32,19.85 7.15,17.68 7.15,15C7.15,12.32 9.32,10.15 12,10.15M11,12V15.69L14.19,17.53L14.94,16.23L12.5,14.82V12' })
	  );
	};
	
	var ClockOutlineIcon = function ClockOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.47,22 2,17.5 2,12C2,6.48 6.48,2 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z' })
	  );
	};
	
	var ClockStartIcon = function ClockStartIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1C8.14,1 5,4.14 5,8C5,11.87 8.13,15 12,15C15.86,15 19,11.87 19,8C19,4.14 15.86,1 12,1M12,3.15C14.67,3.15 16.85,5.32 16.85,8C16.85,10.68 14.67,12.85 12,12.85C9.32,12.85 7.15,10.68 7.15,8C7.15,5.32 9.32,3.15 12,3.15M11,5V8.69L14.19,10.53L14.94,9.23L12.5,7.82V5M4,16V24H6V21H18V24L22,20L18,16V19H6V16' })
	  );
	};
	
	var ClockIcon = function ClockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.9L16.2,16.2Z' })
	  );
	};
	
	var CloseBoxOutlineIcon = function CloseBoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M19,19H5V5H19V19M17,8.4L13.4,12L17,15.6L15.6,17L12,13.4L8.4,17L7,15.6L10.6,12L7,8.4L8.4,7L12,10.6L15.6,7L17,8.4Z' })
	  );
	};
	
	var CloseBoxIcon = function CloseBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H16.3H7.7H5C3.9,3 3,3.9 3,5V7.7V16.4V19C3,20.1 3.9,21 5,21H7.7H16.4H19C20.1,21 21,20.1 21,19V16.3V7.7V5C21,3.9 20.1,3 19,3M15.6,17L12,13.4L8.4,17L7,15.6L10.6,12L7,8.4L8.4,7L12,10.6L15.6,7L17,8.4L13.4,12L17,15.6L15.6,17Z' })
	  );
	};
	
	var CloseCircleOutlineIcon = function CloseCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2M14.59,8L12,10.59L9.41,8L8,9.41L10.59,12L8,14.59L9.41,16L12,13.41L14.59,16L16,14.59L13.41,12L16,9.41L14.59,8Z' })
	  );
	};
	
	var CloseCircleIcon = function CloseCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z' })
	  );
	};
	
	var CloseNetworkIcon = function CloseNetworkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.59,6L12,8.59L9.41,6L8,7.41L10.59,10L8,12.59L9.41,14L12,11.41L14.59,14L16,12.59L13.41,10L16,7.41L14.59,6M17,3C18.1,3 19,3.9 19,5V15C19,16.1 18.1,17 17,17H13V19H14C14.55,19 15,19.45 15,20H22V22H15C15,22.55 14.55,23 14,23H10C9.45,23 9,22.55 9,22H2V20H9C9,19.45 9.45,19 10,19H11V17H7C5.89,17 5,16.1 5,15V5C5,3.9 5.9,3 7,3H17Z' })
	  );
	};
	
	var CloseOctagonOutlineIcon = function CloseOctagonOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.27,3L3,8.27V15.73L8.27,21H15.73C17.5,19.24 21,15.73 21,15.73V8.27L15.73,3M9.1,5H14.9L19,9.1V14.9L14.9,19H9.1L5,14.9V9.1M9.12,7.71L7.71,9.12L10.59,12L7.71,14.88L9.12,16.29L12,13.41L14.88,16.29L16.29,14.88L13.41,12L16.29,9.12L14.88,7.71L12,10.59' })
	  );
	};
	
	var CloseOctagonIcon = function CloseOctagonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.27,3L3,8.27V15.73L8.27,21H15.73L21,15.73V8.27L15.73,3M8.41,7L12,10.59L15.59,7L17,8.41L13.41,12L17,15.59L15.59,17L12,13.41L8.41,17L7,15.59L10.59,12L7,8.41' })
	  );
	};
	
	var CloseOutlineIcon = function CloseOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,16.74L7.76,12L3,7.26L7.26,3L12,7.76L16.74,3L21,7.26L16.24,12L21,16.74L16.74,21L12,16.24L7.26,21L3,16.74M12,13.41L16.74,18.16L18.16,16.74L13.41,12L18.16,7.26L16.74,5.84L12,10.59L7.26,5.84L5.84,7.26L10.59,12L5.84,16.74L7.26,18.16L12,13.41Z' })
	  );
	};
	
	var CloseIcon = function CloseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z' })
	  );
	};
	
	var ClosedCaptionIcon = function ClosedCaptionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,11H16.5V10.5H14.5V13.5H16.5V13H18V14C18,14.55 17.55,15 17,15H14C13.45,15 13,14.55 13,14V10C13,9.45 13.45,9 14,9H17C17.55,9 18,9.45 18,10M11,11H9.5V10.5H7.5V13.5H9.5V13H11V14C11,14.55 10.55,15 10,15H7C6.45,15 6,14.55 6,14V10C6,9.45 6.45,9 7,9H10C10.55,9 11,9.45 11,10M19,4H5C3.89,4 3,4.89 3,6V18C3,19.1 3.9,20 5,20H19C20.1,20 21,19.1 21,18V6C21,4.89 20.1,4 19,4Z' })
	  );
	};
	
	var CloudBracesIcon = function CloudBracesIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,20C2.69,20 0,17.31 0,14C0,10.91 2.34,8.36 5.35,8.04C6.6,5.64 9.11,4 12,4C15.63,4 18.66,6.58 19.35,10C21.95,10.19 24,12.36 24,15C24,17.76 21.76,20 19,20H6M18.5,12H18C17.45,12 17,11.55 17,11V10C17,8.9 16.1,8 15,8H13.5V10H15V11C15,12.1 15.9,13 17,13C15.9,13 15,13.9 15,15V16H13.5V18H15C16.1,18 17,17.1 17,16V15C17,14.45 17.45,14 18,14H18.5V12M5.5,12V14H6C6.55,14 7,14.45 7,15V16C7,17.1 7.9,18 9,18H10.5V16H9V15C9,13.9 8.1,13 7,13C8.1,13 9,12.1 9,11V10H10.5V8H9C7.9,8 7,8.9 7,10V11C7,11.55 6.55,12 6,12H5.5Z' })
	  );
	};
	
	var CloudCheckIcon = function CloudCheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,17L6.5,13.5L7.91,12.08L10,14.17L15.18,9L16.59,10.41M19.35,10.03C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.03C2.34,8.36 0,10.9 0,14C0,17.31 2.69,20 6,20H19C21.76,20 24,17.76 24,15C24,12.36 21.95,10.22 19.35,10.03Z' })
	  );
	};
	
	var CloudCircleIcon = function CloudCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.5,16H8C6.34,16 5,14.66 5,13C5,11.34 6.34,10 8,10C8.05,10 8.09,10 8.14,10C8.58,8.28 10.13,7 12,7C14.21,7 16,8.79 16,11H16.5C17.88,11 19,12.12 19,13.5C19,14.88 17.88,16 16.5,16M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var CloudDownloadIcon = function CloudDownloadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,13L12,18L7,13H10V9H14V13M19.35,10.03C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.03C2.34,8.36 0,10.9 0,14C0,17.31 2.69,20 6,20H19C21.76,20 24,17.76 24,15C24,12.36 21.95,10.22 19.35,10.03Z' })
	  );
	};
	
	var CloudOffOutlineIcon = function CloudOffOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.73,10L15.73,18H6C3.79,18 2,16.21 2,14C2,11.79 3.79,10 6,10M3,5.27L5.75,8C2.56,8.15 0,10.77 0,14C0,17.31 2.69,20 6,20H17.73L19.73,22L21,20.73L4.27,4M19.35,10.03C18.67,6.59 15.64,4 12,4C10.5,4 9.15,4.43 8,5.17L9.45,6.63C10.21,6.23 11.08,6 12,6C15.04,6 17.5,8.46 17.5,11.5V12H19C20.66,12 22,13.34 22,15C22,16.13 21.36,17.11 20.44,17.62L21.89,19.07C23.16,18.16 24,16.68 24,15C24,12.36 21.95,10.22 19.35,10.03Z' })
	  );
	};
	
	var CloudOutlineIcon = function CloudOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,18H6C3.79,18 2,16.21 2,14C2,11.79 3.79,10 6,10H6.71C7.37,7.69 9.5,6 12,6C15.04,6 17.5,8.46 17.5,11.5V12H19C20.66,12 22,13.34 22,15C22,16.66 20.66,18 19,18M19.35,10.03C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.03C2.34,8.36 0,10.9 0,14C0,17.31 2.69,20 6,20H19C21.76,20 24,17.76 24,15C24,12.36 21.95,10.22 19.35,10.03Z' })
	  );
	};
	
	var CloudPrintOutlineIcon = function CloudPrintOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,16C20.66,16 22,14.66 22,13C22,11.34 20.66,10 19,10H17.5V9.5C17.5,6.46 15.04,4 12,4C9.5,4 7.37,5.69 6.71,8H6C3.79,8 2,9.79 2,12C2,14.21 3.79,16 6,16V11H18V16H19M19.36,8.04C21.95,8.22 24,10.36 24,13C24,15.76 21.76,18 19,18H18V22H6V18C2.69,18 0,15.31 0,12C0,8.91 2.34,6.36 5.35,6.04C6.6,3.64 9.11,2 12,2C15.64,2 18.67,4.6 19.36,8.04M8,13V20H16V13H8M9,18H15V19H9V18M15,17H9V16H15V17M9,14H15V15H9V14Z' })
	  );
	};
	
	var CloudPrintIcon = function CloudPrintIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C9.11,2 6.6,3.64 5.35,6.04C2.34,6.36 0,8.91 0,12C0,15.31 2.69,18 6,18V22H18V18H19C21.76,18 24,15.76 24,13C24,10.36 21.95,8.22 19.35,8.04C18.67,4.59 15.64,2 12,2M8,13H16V20H8V13M9,14V15H15V14H9M9,16V17H15V16H9M9,18V19H15V18H9Z' })
	  );
	};
	
	var CloudSearchOutlineIcon = function CloudSearchOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14C14.12,14 13,15.12 13,16.5C13,17.88 14.12,19 15.5,19C16.88,19 18,17.88 18,16.5C18,15.12 16.88,14 15.5,14M22,13C22,11.34 20.66,10 19,10H17.5V9.5C17.5,6.46 15.04,4 12,4C9.5,4 7.37,5.69 6.71,8H6C3.79,8 2,9.79 2,12C2,14.21 3.79,16 6,16H9V16.5C9,17 9.06,17.5 9.17,18H6C2.69,18 0,15.31 0,12C0,8.9 2.34,6.36 5.35,6.04C6.6,3.64 9.11,2 12,2C15.64,2 18.67,4.59 19.36,8.04C21.95,8.22 24,10.36 24,13C24,14.65 23.21,16.1 22,17V16.5C22,15.77 21.88,15.06 21.65,14.4C21.87,14 22,13.5 22,13Z' })
	  );
	};
	
	var CloudSearchIcon = function CloudSearchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14C14.12,14 13,15.12 13,16.5C13,17.88 14.12,19 15.5,19C16.88,19 18,17.88 18,16.5C18,15.12 16.88,14 15.5,14M19.35,8.03C21.95,8.22 24,10.36 24,13C24,14.64 23.21,16.1 22,17V16.5C22,12.91 19.09,10 15.5,10C11.91,10 9,12.91 9,16.5C9,17 9.06,17.5 9.17,18H6C2.69,18 0,15.31 0,12C0,8.9 2.34,6.36 5.35,6.03C6.6,3.64 9.11,2 12,2C15.64,2 18.67,4.59 19.35,8.03Z' })
	  );
	};
	
	var CloudSyncIcon = function CloudSyncIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,4C15.64,4 18.67,6.59 19.35,10.04C21.95,10.22 24,12.36 24,15C24,17.76 21.76,20 19,20H6C2.69,20 0,17.31 0,14C0,10.91 2.34,8.36 5.35,8.04C6.6,5.64 9.11,4 12,4M7.5,9.69C6.06,11.5 6.2,14.06 7.82,15.68C8.66,16.5 9.81,17 11,17V18.86L13.83,16.04L11,13.21V15C10.34,15 9.7,14.74 9.23,14.27C8.39,13.43 8.26,12.11 8.92,11.12L7.5,9.69M9.17,8.97L10.62,10.42L12,11.79V10C12.66,10 13.3,10.26 13.77,10.73C14.61,11.57 14.74,12.89 14.08,13.88L15.5,15.31C16.94,13.5 16.8,10.94 15.18,9.32C14.34,8.5 13.19,8 12,8V6.14L9.17,8.97Z' })
	  );
	};
	
	var CloudTagsIcon = function CloudTagsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,20C2.69,20 0,17.31 0,14C0,10.91 2.34,8.36 5.35,8.04C6.6,5.64 9.11,4 12,4C15.63,4 18.66,6.58 19.35,10C21.95,10.19 24,12.36 24,15C24,17.76 21.76,20 19,20H6M9.09,8.4L4.5,13L9.09,17.6L10.5,16.18L7.32,13L10.5,9.82L9.09,8.4M14.91,8.4L13.5,9.82L16.68,13L13.5,16.18L14.91,17.6L19.5,13L14.91,8.4Z' })
	  );
	};
	
	var CloudUploadIcon = function CloudUploadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,13V17H10V13H7L12,8L17,13M19.35,10.03C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.03C2.34,8.36 0,10.9 0,14C0,17.31 2.69,20 6,20H19C21.76,20 24,17.76 24,15C24,12.36 21.95,10.22 19.35,10.03Z' })
	  );
	};
	
	var CloudIcon = function CloudIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.35,10.03C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.03C2.34,8.36 0,10.9 0,14C0,17.31 2.69,20 6,20H19C21.76,20 24,17.76 24,15C24,12.36 21.95,10.22 19.35,10.03Z' })
	  );
	};
	
	var CloverIcon = function CloverIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,11.18C15.3,8.18 17,6.64 17,4.69C17,3.19 15.75,2 14.25,2C13.39,2 12.57,2.36 12,3C11.43,2.36 10.61,2 9.69,2C8.19,2 7,3.25 7,4.75C7,6.64 8.7,8.18 12,11.18M11.18,12C8.18,8.7 6.64,7 4.69,7C3.19,7 2,8.25 2,9.75C2,10.61 2.36,11.43 3,12C2.36,12.57 2,13.39 2,14.31C2,15.81 3.25,17 4.75,17C6.64,17 8.18,15.3 11.18,12M12.83,12C15.82,15.3 17.36,17 19.31,17C20.81,17 22,15.75 22,14.25C22,13.39 21.64,12.57 21,12C21.64,11.43 22,10.61 22,9.69C22,8.19 20.75,7 19.25,7C17.36,7 15.82,8.7 12.83,12M12,12.82C8.7,15.82 7,17.36 7,19.31C7,20.81 8.25,22 9.75,22C10.61,22 11.43,21.64 12,21C12.57,21.64 13.39,22 14.31,22C15.81,22 17,20.75 17,19.25C17,17.36 15.3,15.82 12,12.82Z' })
	  );
	};
	
	var CodeArrayIcon = function CodeArrayIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5M6,6V18H10V16H8V8H10V6H6M16,16H14V18H18V6H14V8H16V16Z' })
	  );
	};
	
	var CodeBracesIcon = function CodeBracesIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,3C6.9,3 6,3.9 6,5V9C6,10.1 5.1,11 4,11H3V13H4C5.1,13 6,13.9 6,15V19C6,20.1 6.9,21 8,21H10V19H8V14C8,12.9 7.1,12 6,12C7.1,12 8,11.1 8,10V5H10V3M16,3C17.1,3 18,3.9 18,5V9C18,10.1 18.9,11 20,11H21V13H20C18.9,13 18,13.9 18,15V19C18,20.1 17.1,21 16,21H14V19H16V14C16,12.9 16.9,12 18,12C16.9,12 16,11.1 16,10V5H14V3H16Z' })
	  );
	};
	
	var CodeBracketsIcon = function CodeBracketsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,4V6H18V18H15V20H20V4M4,4V20H9V18H6V6H9V4H4Z' })
	  );
	};
	
	var CodeEqualIcon = function CodeEqualIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,13H11V15H6M13,13H18V15H13M13,9H18V11H13M6,9H11V11H6M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5Z' })
	  );
	};
	
	var CodeGreaterThanOrEqualIcon = function CodeGreaterThanOrEqualIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,13H18V15H13M13,9H18V11H13M6.91,7.41L11.5,12L6.91,16.6L5.5,15.18L8.68,12L5.5,8.82M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5Z' })
	  );
	};
	
	var CodeGreaterThanIcon = function CodeGreaterThanIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.41,7.41L15,12L10.41,16.6L9,15.18L12.18,12L9,8.82M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5Z' })
	  );
	};
	
	var CodeLessThanOrEqualIcon = function CodeLessThanOrEqualIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,13H18V15H13M13,9H18V11H13M10.09,7.41L11.5,8.82L8.32,12L11.5,15.18L10.09,16.6L5.5,12M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5Z' })
	  );
	};
	
	var CodeLessThanIcon = function CodeLessThanIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.59,7.41L9,12L13.59,16.6L15,15.18L11.82,12L15,8.82M19,3C20.11,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19Z' })
	  );
	};
	
	var CodeNotEqualVariantIcon = function CodeNotEqualVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,6.5V9.33L8.33,12L11,14.67V17.5L5.5,12M13,6.43L18.57,12L13,17.57V14.74L15.74,12L13,9.26M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5Z' })
	  );
	};
	
	var CodeNotEqualIcon = function CodeNotEqualIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,15H8V17H6M11,13H18V15H11M11,9H18V11H11M6,7H8V13H6M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5Z' })
	  );
	};
	
	var CodeParenthesesIcon = function CodeParenthesesIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.62,3C19.13,5.27 20,8.55 20,12C20,15.44 19.13,18.72 17.62,21L16,19.96C17.26,18.07 18,15.13 18,12C18,8.87 17.26,5.92 16,4.03L17.62,3M6.38,3L8,4.04C6.74,5.92 6,8.87 6,12C6,15.13 6.74,18.08 8,19.96L6.38,21C4.87,18.73 4,15.45 4,12C4,8.55 4.87,5.27 6.38,3Z' })
	  );
	};
	
	var CodeStringIcon = function CodeStringIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5M12.5,11H11.5C10.67,11 10,10.33 10,9.5C10,8.67 10.67,8 11.5,8H12.5C13.33,8 14,8.67 14,9.5H16C16,7.57 14.43,6 12.5,6H11.5C9.57,6 8,7.57 8,9.5C8,11.43 9.57,13 11.5,13H12.5C13.33,13 14,13.67 14,14.5C14,15.33 13.33,16 12.5,16H11.5C10.67,16 10,15.33 10,14.5H8C8,16.43 9.57,18 11.5,18H12.5C14.43,18 16,16.43 16,14.5C16,12.57 14.43,11 12.5,11Z' })
	  );
	};
	
	var CodeTagsCheckIcon = function CodeTagsCheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.59,3.41L2,8L6.59,12.6L8,11.18L4.82,8L8,4.82L6.59,3.41M12.41,3.41L11,4.82L14.18,8L11,11.18L12.41,12.6L17,8L12.41,3.41M21.59,11.59L13.5,19.68L9.83,16L8.42,17.41L13.5,22.5L23,13L21.59,11.59Z' })
	  );
	};
	
	var CodeTagsIcon = function CodeTagsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.6,16.6L19.2,12L14.6,7.4L16,6L22,12L16,18L14.6,16.6M9.4,16.6L4.8,12L9.4,7.4L8,6L2,12L8,18L9.4,16.6Z' })
	  );
	};
	
	var CodepenIcon = function CodepenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.09,12L12,14.08V14.09L8.91,12L12,9.92V9.92L15.09,12M12,2C11.84,2 11.68,2.06 11.53,2.15L2.5,8.11C2.27,8.22 2.09,8.43 2,8.67V14.92C2,15.33 2,15.33 2.15,15.53L11.53,21.86C11.67,21.96 11.84,22 12,22C12.16,22 12.33,21.95 12.47,21.85L21.85,15.5C22,15.33 22,15.33 22,14.92V8.67C21.91,8.42 21.73,8.22 21.5,8.1L12.47,2.15C12.32,2.05 12.16,2 12,2M16.58,13L19.59,15.04L12.83,19.6V15.53L16.58,13M19.69,8.9L16.58,11L12.83,8.47V4.38L19.69,8.9M20.33,10.47V13.53L18.07,12L20.33,10.47M7.42,13L11.17,15.54V19.6L4.41,15.04L7.42,13M4.31,8.9L11.17,4.39V8.5L7.42,11L4.31,8.9M3.67,10.5L5.93,12L3.67,13.54V10.5Z' })
	  );
	};
	
	var CoffeeOutlineIcon = function CoffeeOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,21V19H20V21H2M20,8V5H18V8H20M20,3C21.1,3 22,3.9 22,5V8C22,9.1 21.1,10 20,10H18V13C18,15.21 16.21,17 14,17H8C5.79,17 4,15.21 4,13V3H20M16,5H6V13C6,14.1 6.9,15 8,15H14C15.1,15 16,14.1 16,13V5Z' })
	  );
	};
	
	var CoffeeToGoIcon = function CoffeeToGoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,19V17H17L15.26,15.24L16.67,13.83L20.84,18L16.67,22.17L15.26,20.76L17,19H3M17,8V5H15V8H17M17,3C18.11,3 19,3.9 19,5V8C19,9.11 18.11,10 17,10H15V11C15,13.21 13.21,15 11,15H7C4.79,15 3,13.21 3,11V3H17Z' })
	  );
	};
	
	var CoffeeIcon = function CoffeeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,21H20V19H2M20,8H18V5H20M20,3H4V13C4,15.21 5.79,17 8,17H14C16.21,17 18,15.21 18,13V10H20C21.1,10 22,9.1 22,8V5C22,3.89 21.1,3 20,3Z' })
	  );
	};
	
	var CogsIcon = function CogsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.9,18.45C17.25,18.45 18.35,17.35 18.35,16C18.35,14.65 17.25,13.55 15.9,13.55C14.54,13.55 13.45,14.65 13.45,16C13.45,17.35 14.54,18.45 15.9,18.45M21.1,16.68L22.58,17.84C22.71,17.95 22.75,18.13 22.66,18.29L21.26,20.71C21.17,20.86 21,20.92 20.83,20.86L19.09,20.16C18.73,20.44 18.33,20.67 17.91,20.85L17.64,22.7C17.62,22.87 17.47,23 17.3,23H14.5C14.32,23 14.18,22.87 14.15,22.7L13.89,20.85C13.46,20.67 13.07,20.44 12.71,20.16L10.96,20.86C10.81,20.92 10.62,20.86 10.54,20.71L9.14,18.29C9.05,18.13 9.09,17.95 9.22,17.84L10.7,16.68L10.65,16L10.7,15.31L9.22,14.16C9.09,14.05 9.05,13.86 9.14,13.71L10.54,11.29C10.62,11.13 10.81,11.07 10.96,11.13L12.71,11.84C13.07,11.56 13.46,11.32 13.89,11.15L14.15,9.29C14.18,9.13 14.32,9 14.5,9H17.3C17.47,9 17.62,9.13 17.64,9.29L17.91,11.15C18.33,11.32 18.73,11.56 19.09,11.84L20.83,11.13C21,11.07 21.17,11.13 21.26,11.29L22.66,13.71C22.75,13.86 22.71,14.05 22.58,14.16L21.1,15.31L21.15,16L21.1,16.68M6.69,8.07C7.56,8.07 8.26,7.37 8.26,6.5C8.26,5.63 7.56,4.92 6.69,4.92C5.82,4.92 5.11,5.63 5.11,6.5C5.11,7.37 5.82,8.07 6.69,8.07M10.03,6.94L11,7.68C11.07,7.75 11.09,7.87 11.03,7.97L10.13,9.53C10.08,9.63 9.96,9.67 9.86,9.63L8.74,9.18L8,9.62L7.81,10.81C7.79,10.92 7.7,11 7.59,11H5.79C5.67,11 5.58,10.92 5.56,10.81L5.4,9.62L4.64,9.18L3.5,9.63C3.41,9.67 3.3,9.63 3.24,9.53L2.34,7.97C2.28,7.87 2.31,7.75 2.39,7.68L3.34,6.94L3.31,6.5L3.34,6.06L2.39,5.32C2.31,5.25 2.28,5.13 2.34,5.03L3.24,3.47C3.3,3.37 3.41,3.33 3.5,3.37L4.63,3.82L5.4,3.38L5.56,2.19C5.58,2.08 5.67,2 5.79,2H7.59C7.7,2 7.79,2.08 7.81,2.19L8,3.38L8.74,3.82L9.86,3.37C9.96,3.33 10.08,3.37 10.13,3.47L11.03,5.03C11.09,5.13 11.07,5.25 11,5.32L10.03,6.06L10.06,6.5L10.03,6.94Z' })
	  );
	};
	
	var CoinIcon = function CoinIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4M11,17V16H9V14H13V13H10C9.45,13 9,12.55 9,12V9C9,8.45 9.45,8 10,8H11V7H13V8H15V10H11V11H14C14.55,11 15,11.45 15,12V15C15,15.55 14.55,16 14,16H13V17H11Z' })
	  );
	};
	
	var CoinsIcon = function CoinsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,4C19.42,4 23,7.58 23,12C23,16.42 19.42,20 15,20C10.58,20 7,16.42 7,12C7,7.58 10.58,4 15,4M15,18C18.31,18 21,15.31 21,12C21,8.69 18.31,6 15,6C11.69,6 9,8.69 9,12C9,15.31 11.69,18 15,18M3,12C3,14.61 4.67,16.83 7,17.65V19.74C3.55,18.85 1,15.73 1,12C1,8.27 3.55,5.15 7,4.26V6.35C4.67,7.17 3,9.39 3,12Z' })
	  );
	};
	
	var CollageIcon = function CollageIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3C3.89,3 3,3.89 3,5V19C3,20.11 3.89,21 5,21H11V3M13,3V11H21V5C21,3.89 20.11,3 19,3M13,13V21H19C20.11,21 21,20.11 21,19V13' })
	  );
	};
	
	var ColorHelperIcon = function ColorHelperIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M0,24H24V20H0V24Z' })
	  );
	};
	
	var CommentAccountOutlineIcon = function CommentAccountOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M16,14H8V13C8,11.67 10.67,11 12,11C13.33,11 16,11.67 16,13V14M12,6C13.1,6 14,6.9 14,8C14,9.1 13.1,10 12,10C10.9,10 10,9.1 10,8C10,6.9 10.9,6 12,6Z' })
	  );
	};
	
	var CommentAccountIcon = function CommentAccountIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M16,14V13C16,11.67 13.33,11 12,11C10.67,11 8,11.67 8,13V14H16M12,6C10.9,6 10,6.9 10,8C10,9.1 10.9,10 12,10C13.1,10 14,9.1 14,8C14,6.9 13.1,6 12,6Z' })
	  );
	};
	
	var CommentAlertOutlineIcon = function CommentAlertOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M13,10H11V6H13V10M13,14H11V12H13V14Z' })
	  );
	};
	
	var CommentAlertIcon = function CommentAlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M13,10V6H11V10H13M13,14V12H11V14H13Z' })
	  );
	};
	
	var CommentCheckOutlineIcon = function CommentCheckOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M16.5,8L11,13.5L7.5,10L8.91,8.59L11,10.67L15.09,6.59L16.5,8Z' })
	  );
	};
	
	var CommentCheckIcon = function CommentCheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,15L18,7L16.59,5.58L10,12.17L7.41,9.59L6,11L10,15Z' })
	  );
	};
	
	var CommentMultipleOutlineIcon = function CommentMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,23C11.45,23 11,22.55 11,22V19H7C5.9,19 5,18.1 5,17V7C5,5.89 5.9,5 7,5H21C22.1,5 23,5.9 23,7V17C23,18.1 22.1,19 21,19H16.9L13.2,22.71C13,22.9 12.75,23 12.5,23V23H12M13,17V20.08L16.08,17H21V7H7V17H13M3,15H1V3C1,1.9 1.9,1 3,1H19V3H3V15Z' })
	  );
	};
	
	var CommentMultipleIcon = function CommentMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,23C11.45,23 11,22.55 11,22V19H7C5.9,19 5,18.1 5,17V7C5,5.9 5.9,5 7,5H21C22.1,5 23,5.9 23,7V17C23,18.1 22.1,19 21,19H16.9L13.2,22.71C13,22.89 12.76,23 12.5,23H12M3,15H1V3C1,1.9 1.9,1 3,1H19V3H3V15Z' })
	  );
	};
	
	var CommentOutlineIcon = function CommentOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10Z' })
	  );
	};
	
	var CommentPlusOutlineIcon = function CommentPlusOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M11,6H13V9H16V11H13V14H11V11H8V9H11V6Z' })
	  );
	};
	
	var CommentProcessingOutlineIcon = function CommentProcessingOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M17,11H15V9H17V11M13,11H11V9H13V11M9,11H7V9H9V11Z' })
	  );
	};
	
	var CommentProcessingIcon = function CommentProcessingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M17,11V9H15V11H17M13,11V9H11V11H13M9,11V9H7V11H9Z' })
	  );
	};
	
	var CommentQuestionOutlineIcon = function CommentQuestionOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2C2.9,2 2,2.9 2,4V16C2,17.1 2.9,18 4,18H8V21C8,21.55 8.45,22 9,22H9.5V22C9.75,22 10,21.9 10.2,21.71L13.9,18H20C21.1,18 22,17.1 22,16V4C22,2.89 21.1,2 20,2H4M4,4H20V16H13.08L10,19.08V16H4V4M12.19,5.5C11.3,5.5 10.59,5.68 10.05,6.04C9.5,6.4 9.22,7 9.27,7.69C0.21,7.69 6.57,7.69 11.24,7.69C11.24,7.41 11.34,7.2 11.5,7.06C11.7,6.92 11.92,6.85 12.19,6.85C12.5,6.85 12.77,6.93 12.95,7.11C13.13,7.28 13.22,7.5 13.22,7.8C13.22,8.08 13.14,8.33 13,8.54C12.83,8.76 12.62,8.94 12.36,9.08C11.84,9.4 11.5,9.68 11.29,9.92C11.1,10.16 11,10.5 11,11H13C13,10.72 13.05,10.5 13.14,10.32C13.23,10.15 13.4,10 13.66,9.85C14.12,9.64 14.5,9.36 14.79,9C15.08,8.63 15.23,8.24 15.23,7.8C15.23,7.1 14.96,6.54 14.42,6.12C13.88,5.71 13.13,5.5 12.19,5.5M11,12V14H13V12H11Z' })
	  );
	};
	
	var CommentQuestionIcon = function CommentQuestionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2M12.19,5.5C11.3,5.5 10.59,5.68 10.05,6.04C9.5,6.4 9.22,7 9.27,7.69H11.24C11.24,7.41 11.34,7.2 11.5,7.06C11.7,6.92 11.92,6.85 12.19,6.85C12.5,6.85 12.77,6.93 12.95,7.11C13.13,7.28 13.22,7.5 13.22,7.8C13.22,8.08 13.14,8.33 13,8.54C12.83,8.76 12.62,8.94 12.36,9.08C11.84,9.4 11.5,9.68 11.29,9.92C11.1,10.16 11,10.5 11,11H13C13,10.72 13.05,10.5 13.14,10.32C13.23,10.15 13.4,10 13.66,9.85C14.12,9.64 14.5,9.36 14.79,9C15.08,8.63 15.23,8.24 15.23,7.8C15.23,7.1 14.96,6.54 14.42,6.12C13.88,5.71 13.13,5.5 12.19,5.5M11,12V14H13V12H11Z' })
	  );
	};
	
	var CommentRemoveOutlineIcon = function CommentRemoveOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M9.41,6L12,8.59L14.59,6L16,7.41L13.41,10L16,12.59L14.59,14L12,11.41L9.41,14L8,12.59L10.59,10L8,7.41L9.41,6Z' })
	  );
	};
	
	var CommentRemoveIcon = function CommentRemoveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M9.41,6L8,7.41L10.59,10L8,12.59L9.41,14L12,11.41L14.59,14L16,12.59L13.41,10L16,7.41L14.59,6L12,8.59L9.41,6Z' })
	  );
	};
	
	var CommentTextMultipleOutlineIcon = function CommentTextMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,23C11.45,23 11,22.55 11,22V19H7C5.9,19 5,18.1 5,17V7C5,5.9 5.9,5 7,5H21C22.1,5 23,5.9 23,7V17C23,18.1 22.1,19 21,19H16.9L13.2,22.71C13,22.89 12.76,23 12.5,23H12M13,17V20.08L16.08,17H21V7H7V17H13M3,15H1V3C1,1.9 1.9,1 3,1H19V3H3V15M9,9H19V11H9V9M9,13H17V15H9V13Z' })
	  );
	};
	
	var CommentTextMultipleIcon = function CommentTextMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,15H1V3C1,1.9 1.9,1 3,1H19V3H3V15M12,23C11.45,23 11,22.55 11,22V19H7C5.9,19 5,18.1 5,17V7C5,5.9 5.9,5 7,5H21C22.1,5 23,5.9 23,7V17C23,18.1 22.1,19 21,19H16.9L13.2,22.71C13,22.89 12.76,23 12.5,23H12M9,9V11H19V9H9M9,13V15H17V13H9Z' })
	  );
	};
	
	var CommentTextOutlineIcon = function CommentTextOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M10,16V19.08L13.08,16H20V4H4V16H10M6,7H18V9H6V7M6,11H15V13H6V11Z' })
	  );
	};
	
	var CommentTextIcon = function CommentTextIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9M5,5V7H19V5H5M5,9V11H13V9H5M5,13V15H15V13H5Z' })
	  );
	};
	
	var CommentIcon = function CommentIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,22C8.45,22 8,21.55 8,21V18H4C2.9,18 2,17.1 2,16V4C2,2.89 2.9,2 4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9Z' })
	  );
	};
	
	var CompareIcon = function CompareIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H14V5H19V18L14,12V21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M10,18H5L10,12M10,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H10V23H12V1H10V3Z' })
	  );
	};
	
	var CompassOutlineIcon = function CompassOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,17L10.2,10.2L17,7L13.8,13.8L7,17M12,11.1C11.5,11.1 11.1,11.5 11.1,12C11.1,12.5 11.5,12.9 12,12.9C12.5,12.9 12.9,12.5 12.9,12C12.9,11.5 12.5,11.1 12,11.1M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4Z' })
	  );
	};
	
	var CompassIcon = function CompassIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.19,14.19L6,18L9.81,9.81L18,6M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,10.9C11.39,10.9 10.9,11.39 10.9,12C10.9,12.61 11.39,13.1 12,13.1C12.61,13.1 13.1,12.61 13.1,12C13.1,11.39 12.61,10.9 12,10.9Z' })
	  );
	};
	
	var ConsoleLineIcon = function ConsoleLineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,19V16H21V19H13M8.5,13L2.47,7H6.71L11.67,11.95C12.25,12.54 12.25,13.5 11.67,14.07L6.74,19H2.5L8.5,13Z' })
	  );
	};
	
	var ConsoleNetworkIcon = function ConsoleNetworkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,2C18.1,2 19,2.9 19,4V14C19,15.1 18.1,16 17,16H13V18H14C14.55,18 15,18.45 15,19H22V21H15C15,21.55 14.55,22 14,22H10C9.45,22 9,21.55 9,21H2V19H9C9,18.45 9.45,18 10,18H11V16H7C5.9,16 5,15.1 5,14V4C5,2.9 5.9,2 7,2H17M7,6L11,10L7,14H9.85L13.13,10.72C13.5,10.33 13.5,9.7 13.13,9.3L9.83,6H7M17,12H14V14H17V12Z' })
	  );
	};
	
	var ConsoleIcon = function ConsoleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,19V7H4V19H20M20,3C21.1,3 22,3.9 22,5V19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19V5C2,3.89 2.9,3 4,3H20M13,17V15H18V17H13M9.58,13L5.57,9H8.4L11.7,12.3C12.09,12.69 12.09,13.33 11.7,13.72L8.42,17H5.59L9.58,13Z' })
	  );
	};
	
	var ContactMailIcon = function ContactMailIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,8V7L18,9L15,7V8L18,10M22,3H2C0.9,3 0,3.9 0,5V19C0,20.1 0.9,21 2,21H22C23.1,21 24,20.1 24,19V5C24,3.9 23.1,3 22,3M8,6C9.66,6 11,7.34 11,9C11,10.66 9.66,12 8,12C6.34,12 5,10.66 5,9C5,7.34 6.34,6 8,6M14,18H2V17C2,15 6,13.9 8,13.9C10,13.9 14,15 14,17M22,12H14V6H22' })
	  );
	};
	
	var ContactsIcon = function ContactsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,0H4V2H20V0M4,24H20V22H4V24M20,4H4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.9 21.1,4 20,4M12,6.75C13.24,6.75 14.25,7.76 14.25,9C14.25,10.24 13.24,11.25 12,11.25C10.76,11.25 9.75,10.24 9.75,9C9.75,7.76 10.76,6.75 12,6.75M17,17H7V15.5C7,13.83 10.33,13 12,13C13.67,13 17,13.83 17,15.5V17Z' })
	  );
	};
	
	var ContentCopyIcon = function ContentCopyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,21H8V7H19M19,5H8C6.9,5 6,5.9 6,7V21C6,22.1 6.9,23 8,23H19C20.1,23 21,22.1 21,21V7C21,5.9 20.1,5 19,5M16,1H4C2.9,1 2,1.9 2,3V17H4V3H16V1Z' })
	  );
	};
	
	var ContentCutIcon = function ContentCutIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3L13,9L15,11L22,4V3M12,12.5C11.72,12.5 11.5,12.28 11.5,12C11.5,11.72 11.72,11.5 12,11.5C12.28,11.5 12.5,11.72 12.5,12C12.5,12.28 12.28,12.5 12,12.5M6,20C4.9,20 4,19.1 4,18C4,16.89 4.9,16 6,16C7.1,16 8,16.9 8,18C8,19.11 7.1,20 6,20M6,8C4.9,8 4,7.1 4,6C4,4.89 4.9,4 6,4C7.1,4 8,4.9 8,6C8,7.11 7.1,8 6,8M9.64,7.64C9.87,7.14 10,6.59 10,6C10,3.79 8.21,2 6,2C3.79,2 2,3.79 2,6C2,8.21 3.79,10 6,10C6.59,10 7.14,9.87 7.64,9.64L10,12L7.64,14.36C7.14,14.13 6.59,14 6,14C3.79,14 2,15.79 2,18C2,20.21 3.79,22 6,22C8.21,22 10,20.21 10,18C10,17.41 9.87,16.86 9.64,16.36L12,14L19,21H22V20L9.64,7.64Z' })
	  );
	};
	
	var ContentDuplicateIcon = function ContentDuplicateIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,17H4C2.9,17 2,16.1 2,15V3C2,1.9 2.9,1 4,1H16V3H4V15H11V13L15,16L11,19V17M19,21V7H8V13H6V7C6,5.9 6.9,5 8,5H19C20.1,5 21,5.9 21,7V21C21,22.1 20.1,23 19,23H8C6.9,23 6,22.1 6,21V19H8V21H19Z' })
	  );
	};
	
	var ContentPasteIcon = function ContentPasteIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,20H5V4H7V7H17V4H19M12,2C12.55,2 13,2.45 13,3C13,3.55 12.55,4 12,4C11.45,4 11,3.55 11,3C11,2.45 11.45,2 12,2M19,2H14.82C14.4,0.84 13.3,0 12,0C10.7,0 9.6,0.84 9.18,2H5C3.9,2 3,2.9 3,4V20C3,21.1 3.9,22 5,22H19C20.1,22 21,21.1 21,20V4C21,2.9 20.1,2 19,2Z' })
	  );
	};
	
	var ContentSaveAllIcon = function ContentSaveAllIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,7V3H7V7H17M14,17C15.66,17 17,15.66 17,14C17,12.34 15.66,11 14,11C12.34,11 11,12.34 11,14C11,15.66 12.34,17 14,17M19,1L23,5V17C23,18.1 22.1,19 21,19H7C5.89,19 5,18.1 5,17V3C5,1.9 5.9,1 7,1H19M1,7H3V21H17V23H3C1.9,23 1,22.1 1,21V7Z' })
	  );
	};
	
	var ContentSaveOutlineIcon = function ContentSaveOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,5V9H5V19H9.35C8.5,18.27 8,17.19 8,16C8,13.79 9.79,12 12,12C14.21,12 16,13.79 16,16C16,17.19 15.5,18.27 14.65,19H19V7.83L16.17,5H15M5,7H13V5H5V7M17,3L21,7V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H17M12,14C10.9,14 10,14.9 10,16C10,17.1 10.9,18 12,18C13.1,18 14,17.1 14,16C14,14.9 13.1,14 12,14Z' })
	  );
	};
	
	var ContentSaveSettingsIcon = function ContentSaveSettingsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,8V4H5V8H15M12,18C13.66,18 15,16.66 15,15C15,13.34 13.66,12 12,12C10.34,12 9,13.34 9,15C9,16.66 10.34,18 12,18M17,2L21,6V18C21,19.1 20.1,20 19,20H5C3.89,20 3,19.1 3,18V4C3,2.9 3.9,2 5,2H17M11,22H13V24H11V22M7,22H9V24H7V22M15,22H17V24H15V22Z' })
	  );
	};
	
	var ContentSaveIcon = function ContentSaveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,9H5V5H15M12,19C10.34,19 9,17.66 9,16C9,14.34 10.34,13 12,13C13.66,13 15,14.34 15,16C15,17.66 13.66,19 12,19M17,3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V7L17,3Z' })
	  );
	};
	
	var ContrastBoxIcon = function ContrastBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,15.5H12V17H17M19,19H5L19,5M5.5,7.5H7.5V5.5H9V7.5H11V9H9V11H7.5V9H5.5M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z' })
	  );
	};
	
	var ContrastCircleIcon = function ContrastCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C9.79,20 7.79,19.1 6.34,17.66L17.66,6.34C19.1,7.79 20,9.79 20,12C20,16.42 16.42,20 12,20M6,8H8V6H9.5V8H11.5V9.5H9.5V11.5H8V9.5H6M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,16H17V14.5H12V16Z' })
	  );
	};
	
	var ContrastIcon = function ContrastIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.38,20.9C3.78,20.71 3.3,20.23 3.1,19.63L19.63,3.1C20.23,3.3 20.71,3.78 20.9,4.38L4.38,20.9M20,16V18H13V16H20M3,6H6V3H8V6H11V8H8V11H6V8H3V6Z' })
	  );
	};
	
	var CookieIcon = function CookieIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.03,3 3,7.03 3,12C3,16.97 7.03,21 12,21C16.97,21 21,16.97 21,12C21,11.5 20.96,11 20.87,10.5C20.6,10 20,10 20,10H18V9C18,8 17,8 17,8H15V7C15,6 14,6 14,6H13V4C13,3 12,3 12,3M9.5,6C10.33,6 11,6.67 11,7.5C11,8.33 10.33,9 9.5,9C8.67,9 8,8.33 8,7.5C8,6.67 8.67,6 9.5,6M6.5,10C7.33,10 8,10.67 8,11.5C8,12.33 7.33,13 6.5,13C5.67,13 5,12.33 5,11.5C5,10.67 5.67,10 6.5,10M11.5,11C12.33,11 13,11.67 13,12.5C13,13.33 12.33,14 11.5,14C10.67,14 10,13.33 10,12.5C10,11.67 10.67,11 11.5,11M16.5,13C17.33,13 18,13.67 18,14.5C18,15.33 17.33,16 16.5,16H16.5C15.67,16 15,15.33 15,14.5H15C15,13.67 15.67,13 16.5,13M11,16C11.83,16 12.5,16.67 12.5,17.5C12.5,18.33 11.83,19 11,19C10.17,19 9.5,18.33 9.5,17.5C9.5,16.67 10.17,16 11,16Z' })
	  );
	};
	
	var CopyrightIcon = function CopyrightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.08,10.86C10.13,10.53 10.24,10.24 10.38,10C10.5,9.74 10.72,9.53 10.97,9.37C11.21,9.22 11.5,9.15 11.88,9.14C12.11,9.15 12.32,9.19 12.5,9.27C12.71,9.36 12.89,9.5 13.03,9.63C13.17,9.78 13.28,9.96 13.37,10.16C13.46,10.36 13.5,10.58 13.5,10.8H15.3C15.28,10.33 15.19,9.9 15,9.5C14.85,9.12 14.62,8.78 14.32,8.5C14,8.22 13.66,8 13.24,7.84C12.82,7.68 12.36,7.61 11.85,7.61C11.2,7.61 10.63,7.72 10.15,7.95C9.67,8.18 9.27,8.5 8.95,8.87C8.63,9.26 8.39,9.71 8.24,10.23C8.09,10.75 8,11.29 8,11.87V12.14C8,12.72 8.08,13.26 8.23,13.78C8.38,14.3 8.62,14.75 8.94,15.13C9.26,15.5 9.66,15.82 10.14,16.04C10.62,16.26 11.19,16.38 11.84,16.38C12.31,16.38 12.75,16.3 13.16,16.15C13.57,16 13.93,15.79 14.24,15.5C14.55,15.25 14.8,14.94 15,14.58C15.16,14.22 15.27,13.84 15.28,13.43H13.5C13.5,13.64 13.43,13.83 13.34,14C13.25,14.19 13.13,14.34 13,14.47C12.83,14.6 12.66,14.7 12.46,14.77C12.27,14.84 12.07,14.86 11.86,14.87C11.5,14.86 11.2,14.79 10.97,14.64C10.72,14.5 10.5,14.27 10.38,14C10.24,13.77 10.13,13.47 10.08,13.14C10.03,12.81 10,12.47 10,12.14V11.87C10,11.5 10.03,11.19 10.08,10.86M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20Z' })
	  );
	};
	
	var CordovaIcon = function CordovaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.18,21.55H16.94L17.17,18.82H15.58L15.35,21.55H8.65L8.42,18.82H6.83L7.06,21.55H3.82L2,9.73L6.55,2.45H17.45L22,9.73L20.18,21.55M16.55,6.09H13.62L13.82,7.45H10.18L10.38,6.09H7.45L5.64,9.73L6.55,17H17.45L18.36,9.73L16.55,6.09M14.95,14.59C14.7,14.59 14.5,13.83 14.5,12.9C14.5,11.96 14.7,11.2 14.95,11.2C15.21,11.2 15.41,11.96 15.41,12.9C15.41,13.83 15.21,14.59 14.95,14.59M9.22,14.73C8.96,14.73 8.76,13.97 8.76,13.04C8.76,12.1 8.96,11.35 9.22,11.35C9.47,11.35 9.67,12.1 9.67,13.04C9.67,13.97 9.47,14.73 9.22,14.73Z' })
	  );
	};
	
	var CornIcon = function CornIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,12H8.82C9.62,12.5 10.35,13.07 11,13.68V12M7,11C7.27,5.88 9.37,2 12,2C14.66,2 16.77,5.94 17,11.12C18.5,10.43 20.17,10 22,10C16.25,12.57 18.25,22 12,22C6,22 7.93,12.57 2,10C3.82,10 5.5,10.4 7,11M11,11V9H8.24L8.03,11H11M11,8V6H9.05C8.8,6.6 8.6,7.27 8.43,8H11M11,5V3.3C10.45,3.63 9.95,4.22 9.5,5H11M12,3V5H13V6H12V8H14V9H12V11H15V12H12V14H14V15H12.23C13.42,16.45 14.15,18 14.32,19.23C15.31,17.56 15.96,14.84 16,11.76C15.94,7 14.13,3 12,3Z' })
	  );
	};
	
	var CounterIcon = function CounterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H20C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4M4,6V18H11V6H4M20,18V6H18.76C19,6.54 18.95,7.07 18.95,7.13C18.88,7.8 18.41,8.5 18.24,8.75L15.91,11.3L19.23,11.28L19.24,12.5L14.04,12.47L14,11.47C14,11.47 17.05,8.24 17.2,7.95C17.34,7.67 17.91,6 16.5,6C15.27,6.05 15.41,7.3 15.41,7.3L13.87,7.31C13.87,7.31 13.88,6.65 14.25,6H13V18H15.58L15.57,17.14L16.54,17.13C16.54,17.13 17.45,16.97 17.46,16.08C17.5,15.08 16.65,15.08 16.5,15.08C16.37,15.08 15.43,15.13 15.43,15.95H13.91C13.91,15.95 13.95,13.89 16.5,13.89C19.1,13.89 18.96,15.91 18.96,15.91C18.96,15.91 19,17.16 17.85,17.63L18.37,18H20M8.92,16H7.42V10.2L5.62,10.76V9.53L8.76,8.41H8.92V16Z' })
	  );
	};
	
	var CowIcon = function CowIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.5,18C10.78,18 11,18.22 11,18.5C11,18.78 10.78,19 10.5,19C10.22,19 10,18.78 10,18.5C10,18.22 10.22,18 10.5,18M13.5,18C13.78,18 14,18.22 14,18.5C14,18.78 13.78,19 13.5,19C13.22,19 13,18.78 13,18.5C13,18.22 13.22,18 13.5,18M10,11C10.55,11 11,11.45 11,12C11,12.55 10.55,13 10,13C9.45,13 9,12.55 9,12C9,11.45 9.45,11 10,11M14,11C14.55,11 15,11.45 15,12C15,12.55 14.55,13 14,13C13.45,13 13,12.55 13,12C13,11.45 13.45,11 14,11M18,18C18,20.21 15.31,22 12,22C8.69,22 6,20.21 6,18C6,17.1 6.45,16.27 7.2,15.6C6.45,14.6 6,13.35 6,12L6.12,10.78C5.58,10.93 4.93,10.93 4.4,10.78C3.38,10.5 1.84,9.35 2.07,8.55C2.3,7.75 4.21,7.6 5.23,7.9C5.82,8.07 6.45,8.5 6.82,8.96L7.39,8.15C6.79,7.05 7,4 10,3L9.91,3.14V3.14C9.63,3.58 8.91,4.97 9.67,6.47C10.39,6.17 11.17,6 12,6C12.83,6 13.61,6.17 14.33,6.47C15.09,4.97 14.37,3.58 14.09,3.14L14,3C17,4 17.21,7.05 16.61,8.15L17.18,8.96C17.55,8.5 18.18,8.07 18.77,7.9C19.79,7.6 21.7,7.75 21.93,8.55C22.16,9.35 20.62,10.5 19.6,10.78C19.07,10.93 18.42,10.93 17.88,10.78L18,12C18,13.35 17.55,14.6 16.8,15.6C17.55,16.27 18,17.1 18,18M12,16C9.79,16 8,16.9 8,18C8,19.1 9.79,20 12,20C14.21,20 16,19.1 16,18C16,16.9 14.21,16 12,16M12,14C13.12,14 14.17,14.21 15.07,14.56C15.65,13.87 16,13 16,12C16,9.79 14.21,8 12,8C9.79,8 8,9.79 8,12C8,13 8.35,13.87 8.93,14.56C9.83,14.21 10.88,14 12,14M14.09,3.14V3.14Z' })
	  );
	};
	
	var CraneIcon = function CraneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,6V5C20,4.45 19.55,4 19,4H9V3H6V4H5V6H6V15H5V13H3V15H2V17H3V21H5V17H10V21H12V19.92L12,17H13V15H12V13H10V15H9V6H17V10.62C16.53,10.79 16.19,11.23 16.19,11.76C16.19,12.2 16.43,12.6 16.8,12.82V14H17.42C17.76,14 18.03,14.28 18.03,14.62C18.03,14.96 17.76,15.24 17.42,15.24C17.2,15.24 17,15.12 16.89,14.93C16.71,14.64 16.34,14.54 16.05,14.71C15.75,14.87 15.65,15.25 15.82,15.55C16.15,16.11 16.76,16.47 17.42,16.47C18.43,16.47 19.26,15.64 19.26,14.62C19.26,13.84 18.76,13.14 18.03,12.88V12.82C18.41,12.6 18.65,12.2 18.65,11.76C18.65,11.3 18.38,10.91 18,10.7V6H20M8,13.66L7,14.66V13.24L8,12.24V13.66M8,10.71L7,11.71V10.29L8,9.29V10.71M7,8.71V7.29L8,6.29V7.71L7,8.71Z' })
	  );
	};
	
	var CreationIcon = function CreationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,1L17.74,3.75L15,5L17.74,6.26L19,9L20.25,6.26L23,5L20.25,3.75M9,4L6.5,9.5L1,12L6.5,14.5L9,20L11.5,14.5L17,12L11.5,9.5M19,15L17.74,17.74L15,19L17.74,20.25L19,23L20.25,20.25L23,19L20.25,17.74' })
	  );
	};
	
	var CreditCardMultipleIcon = function CreditCardMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,8V6H7V8H21M21,16V11H7V16H21M21,4C22.1,4 23,4.9 23,6V16C23,17.1 22.1,18 21,18H7C5.89,18 5,17.1 5,16V6C5,4.89 5.89,4 7,4H21M3,20H18V22H3C1.9,22 1,21.1 1,20V9H3V20Z' })
	  );
	};
	
	var CreditCardOffIcon = function CreditCardOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M0.93,4.2L2.21,2.93L20,20.72L18.73,22L16.73,20H4C2.89,20 2,19.1 2,18V6C2,5.78 2.04,5.57 2.11,5.38L0.93,4.2M20,8V6H7.82L5.82,4H20C21.1,4 22,4.9 22,6V18C22,18.6 21.74,19.13 21.32,19.5L19.82,18H20V12H13.82L9.82,8H20M4,8H4.73L4,7.27V8M4,12V18H14.73L8.73,12H4Z' })
	  );
	};
	
	var CreditCardPlusIcon = function CreditCardPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,18H24V20H21V23H19V20H16V18H19V15H21V18M19,8V6H3V8H19M19,12H3V18H14V20H3C1.89,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4H19C20.1,4 21,4.9 21,6V13H19V12Z' })
	  );
	};
	
	var CreditCardScanIcon = function CreditCardScanIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,4H6V2H2C0.9,2 0,2.9 0,4V8H2V4M22,2H18V4H22V8H24V4C24,2.9 23.1,2 22,2M2,16H0V20C0,21.1 0.9,22 2,22H6V20H2V16M22,20H18V22H22C23.1,22 24,21.1 24,20V16H22V20M4,8V16C4,17.1 4.9,18 6,18H18C19.1,18 20,17.1 20,16V8C20,6.9 19.1,6 18,6H6C4.9,6 4,6.9 4,8M6,16V12H18V16H6M18,8V10H6V8H18Z' })
	  );
	};
	
	var CreditCardSettingsIcon = function CreditCardSettingsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,8H4V6H20M20,18H4V12H20M20,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22Z' })
	  );
	};
	
	var CreditCardIcon = function CreditCardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,8H4V6H20M20,18H4V12H20M20,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4Z' })
	  );
	};
	
	var CropFreeIcon = function CropFreeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H15V5H19V9H21V5C21,3.89 20.1,3 19,3M19,19H15V21H19C20.1,21 21,20.1 21,19V15H19M5,15H3V19C3,20.1 3.9,21 5,21H9V19H5M3,5V9H5V5H9V3H5C3.9,3 3,3.9 3,5Z' })
	  );
	};
	
	var CropLandscapeIcon = function CropLandscapeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,17H5V7H19M19,5H5C3.9,5 3,5.9 3,7V17C3,18.1 3.9,19 5,19H19C20.1,19 21,18.1 21,17V7C21,5.89 20.1,5 19,5Z' })
	  );
	};
	
	var CropPortraitIcon = function CropPortraitIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,19H7V5H17M17,3H7C5.9,3 5,3.9 5,5V19C5,20.1 5.9,21 7,21H17C18.1,21 19,20.1 19,19V5C19,3.89 18.1,3 17,3Z' })
	  );
	};
	
	var CropRotateIcon = function CropRotateIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.47,21.5C4.2,19.93 1.86,16.76 1.5,13H0C0.5,19.16 5.66,24 11.95,24C12.18,24 12.39,24 12.61,23.97L8.8,20.15L7.47,21.5M12.05,0C11.82,0 11.61,0 11.39,0.04L15.2,3.85L16.53,2.5C19.8,4.07 22.14,7.24 22.5,11H24C23.5,4.84 18.34,0 12.05,0M16,14H18V8C18,6.89 17.1,6 16,6H10V8H16V14M8,16V4H6V6H4V8H6V16C6,17.1 6.9,18 8,18H16V20H18V18H20V16H8Z' })
	  );
	};
	
	var CropSquareIcon = function CropSquareIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,18H6V6H18M18,4H6C4.9,4 4,4.9 4,6V18C4,19.1 4.9,20 6,20H18C19.1,20 20,19.1 20,18V6C20,4.89 19.1,4 18,4Z' })
	  );
	};
	
	var CropIcon = function CropIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,17V1H5V5H1V7H5V17C5,18.1 5.9,19 7,19H17V23H19V19H23V17M17,15H19V7C19,5.89 18.1,5 17,5H9V7H17V15Z' })
	  );
	};
	
	var CrosshairsGpsIcon = function CrosshairsGpsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,8C14.21,8 16,9.79 16,12C16,14.21 14.21,16 12,16C9.79,16 8,14.21 8,12C8,9.79 9.79,8 12,8M3.05,13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,13M12,5C8.13,5 5,8.13 5,12C5,15.87 8.13,19 12,19C15.87,19 19,15.87 19,12C19,8.13 15.87,5 12,5Z' })
	  );
	};
	
	var CrosshairsIcon = function CrosshairsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.05,13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,13M12,5C8.13,5 5,8.13 5,12C5,15.87 8.13,19 12,19C15.87,19 19,15.87 19,12C19,8.13 15.87,5 12,5Z' })
	  );
	};
	
	var CrownIcon = function CrownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,16L3,5L8.5,12L12,5L15.5,12L21,5L19,16H5M19,19C19,19.55 18.55,20 18,20H6C5.45,20 5,19.55 5,19V18H19V19Z' })
	  );
	};
	
	var CryengineIcon = function CryengineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23.03,12.4M23.03,12.5V12.5C23,13 20.91,15.23 17.82,16.24C14.05,17.5 7.97,17.03 7.97,12.3C7.97,10.08 9.78,8.27 12,8.27C14.25,8.27 16.05,10.09 16.05,12.31C16.05,13.39 15.58,14.44 14.87,15.18C15.54,15.17 17.94,15 20.21,13.12C20.46,12.88 20.62,12.68 20.69,12.55C20.71,12.5 20.74,12.46 20.73,12.4C20.73,11.92 18.12,8.19 12.72,7.12C19.22,7.46 23,11.32 23.03,12.4V12.5H23.03M12,10C10.74,10 9.71,11.04 9.71,12.3C9.71,13.57 10.74,14.59 12,14.59C13.27,14.59 14.29,13.57 14.29,12.3C14.29,11.04 13.27,10 12,10M3.31,12.34C3.31,12.34 3.31,12.31 3.31,12.42V12.42C3.41,12.94 4.82,15.41 10.28,16.88C3.96,16.37 1.12,13.28 1.04,12.42H1.03C1.03,12.31 1.03,12.36 1.03,12.35C1.03,11.5 4.96,7.58 10.92,7.15C6.14,8.26 3.31,11.87 3.31,12.34V12.34Z' })
	  );
	};
	
	var CubeOutlineIcon = function CubeOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L6.04,7.5L12,10.85L17.96,7.5L12,4.15M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V9.21L13,12.58V19.29L19,15.91Z' })
	  );
	};
	
	var CubeSendIcon = function CubeSendIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,4L9,8.04V15.96L16,20L23,15.96V8.04M16,6.31L19.8,8.5L16,10.69L12.21,8.5M0,7V9H7V7M11,10.11L15,12.42V17.11L11,14.81M21,10.11V14.81L17,17.11V12.42M2,11V13H7V11M4,15V17H7V15' })
	  );
	};
	
	var CubeUnfoldedIcon = function CubeUnfoldedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,9V4H13V9H23V16H18V21H11V16H1V9H6M16,16H13V19H16V16M8,9H11V6H8V9M6,14V11H3V14H6M18,11V14H21V11H18M13,11V14H16V11H13M8,11V14H11V11H8Z' })
	  );
	};
	
	var CubeIcon = function CubeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L6.04,7.5L12,10.85L17.96,7.5L12,4.15Z' })
	  );
	};
	
	var CupOffIcon = function CupOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,4.27L2.28,3L21,21.72L19.73,23L18.27,21.54C17.93,21.83 17.5,22 17,22H7C5.97,22 5.13,21.23 5,20.23L3.53,6.8L1,4.27M18.32,8L18.77,4H5.82L3.82,2H21L19.29,17.47L9.82,8H18.32Z' })
	  );
	};
	
	var CupWaterIcon = function CupWaterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.32,8H5.67L5.23,4H18.77M12,19C10.34,19 9,17.66 9,16C9,14 12,10.6 12,10.6C12,10.6 15,14 15,16C15,17.66 13.66,19 12,19M3,2L5,20.23C5.13,21.23 5.97,22 7,22H17C18,22 18.87,21.23 19,20.23L21,2H3Z' })
	  );
	};
	
	var CupIcon = function CupIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.32,8H5.67L5.23,4H18.77M3,2L5,20.23C5.13,21.23 5.97,22 7,22H17C18,22 18.87,21.23 19,20.23L21,2H3Z' })
	  );
	};
	
	var CupcakeIcon = function CupcakeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1.5C13.38,1.5 14.5,2.62 14.5,4C14.5,5.38 13.38,6.5 12,6.5C10.62,6.5 9.5,5.38 9.5,4C9.5,2.62 10.62,1.5 12,1.5M15.87,5C18,5 20,7 20,9C22.7,9 22.7,13 20,13H4C1.3,13 1.3,9 4,9C4,7 6,5 8.13,5C8.57,6.73 10.14,8 12,8C13.86,8 15.43,6.73 15.87,5M5,15H8L9,22H7L5,15M10,15H14L13,22H11L10,15M16,15H19L17,22H15L16,15Z' })
	  );
	};
	
	var CurlingIcon = function CurlingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,3V5C12.5,5 13.9,5.05 14.72,5.41C15.26,5.65 15.73,6.21 16.25,7H5V9H19.62L18.89,7.55C17.86,5.5 16.96,4.22 15.53,3.59C14.1,2.95 12.5,3 10,3M6,11C3.78,11 2,12.78 2,15V18C2,20.22 3.78,22 6,22H18C20.22,22 22,20.22 22,18V15C22,12.78 20.22,11 18,11H6Z' })
	  );
	};
	
	var CurrencyBdtIcon = function CurrencyBdtIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.09,10.5V9H9.59V4.5C9.59,3.67 8.92,3 8.09,3C7.26,3 6.59,3.67 6.59,4.5C6.59,5.33 7.26,6 8.09,6V9H5.09V10.5H8.09V16.7C8.09,19.06 10,20.97 12.34,21C14.68,20.96 16.54,19.04 16.5,16.7C16.5,15.11 15.75,13.61 14.5,12.62C14.28,12.44 14.05,12.28 13.8,12.15C13.58,12.05 13.34,12 13.1,12C12.39,12 11.74,12.39 11.39,13C11.2,13.3 11.1,13.65 11.1,14C11.11,15.1 12,16 13.11,16C13.73,16 14.31,15.69 14.69,15.2C14.9,15.67 15,16.18 15,16.7C15.04,18.2 13.86,19.45 12.34,19.5C10.81,19.5 9.58,18.23 9.59,16.7V10.5H18.09Z' })
	  );
	};
	
	var CurrencyBtcIcon = function CurrencyBtcIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,4H8V2H10V4H12V2H14V4.03C16.25,4.28 18,6.18 18,8.5C18,9.8 17.45,11 16.56,11.8C17.73,12.61 18.5,13.97 18.5,15.5C18.5,18 16.5,20 14,20V22H12V20H10V22H8V20H6L6.5,18H8V6H6V4M10,13V18H14C15.38,18 16.5,16.88 16.5,15.5C16.5,14.12 15.38,13 14,13H10M10,6V11H13.5C14.88,11 16,9.88 16,8.5C16,7.12 14.88,6 13.5,6H13.5L10,6Z' })
	  );
	};
	
	var CurrencyChfIcon = function CurrencyChfIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,3H18V5H9V11H17V13H9V16H11V18H9V21H7V18H5V16H7V3Z' })
	  );
	};
	
	var CurrencyCnyIcon = function CurrencyCnyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,21V16H6V14H11V13.71L10.16,12H6V10H9.19L5.77,3H8L12,11.2L16,3H18.23L14.81,10H18V12H13.84L13,13.71V14H18V16H13V21H11Z' })
	  );
	};
	
	var CurrencyEthIcon = function CurrencyEthIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,5H18V7H6M7,11H17V13H7M5.5,17H18.5V19H5.5' })
	  );
	};
	
	var CurrencyEurIcon = function CurrencyEurIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.07,11L7,12L7.07,13H17.35L16.5,15H7.67C8.8,17.36 11.21,19 14,19C16.23,19 18.22,17.96 19.5,16.33V19.12C18,20.3 16.07,21 14,21C10.08,21 6.75,18.5 5.5,15H2L3,13H5.05L5,12L5.05,11H2L3,9H5.5C6.75,5.5 10.08,3 14,3C16.5,3 18.8,4.04 20.43,5.71L19.57,7.75C18.29,6.08 16.27,5 14,5C11.21,5 8.8,6.64 7.67,9H19.04L18.19,11H7.07Z' })
	  );
	};
	
	var CurrencyGbpIcon = function CurrencyGbpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.5,21V19.75C7.44,19.29 8.24,18.57 8.81,17.7C9.38,16.83 9.67,15.85 9.68,14.75L9.66,13.77L9.57,13H7V11H9.4C9.25,10.17 9.16,9.31 9.13,8.25C9.16,6.61 9.64,5.33 10.58,4.41C11.5,3.5 12.77,3 14.32,3C15.03,3 15.64,3.07 16.13,3.2C16.63,3.32 17,3.47 17.31,3.65L16.76,5.39C16.5,5.25 16.19,5.12 15.79,5C15.38,4.9 14.89,4.85 14.32,4.84C13.25,4.86 12.5,5.19 12,5.83C11.5,6.46 11.29,7.28 11.3,8.28L11.4,9.77L11.6,11H15.5V13H11.79C11.88,14 11.84,15 11.65,15.96C11.35,17.16 10.74,18.18 9.83,19H18V21H6.5Z' })
	  );
	};
	
	var CurrencyInrIcon = function CurrencyInrIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,3H18L17,5H13.74C14.22,5.58 14.58,6.26 14.79,7H18L17,9H15C14.75,11.57 12.74,13.63 10.2,13.96V14H9.5L15.5,21H13L7,14V12H9.5V12C11.26,12 12.72,10.7 12.96,9H7L8,7H12.66C12.1,5.82 10.9,5 9.5,5H7L8,3Z' })
	  );
	};
	
	var CurrencyJpyIcon = function CurrencyJpyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,21V16H6V14H11V13.71L10.16,12H6V10H9.19L5.77,3H8L12,11.2L16,3H18.23L14.81,10H18V12H13.84L13,13.71V14H18V16H13V21H11Z' })
	  );
	};
	
	var CurrencyKrwIcon = function CurrencyKrwIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,3H4L5.33,9H9.33L10.67,3H13.33L14.67,9H18.67L20,3H22L20.67,9H22V11H20.22L19.78,13H22V15H19.33L18,21H15.33L14,15H10L8.67,21H6L4.67,15H2V13H4.22L3.78,11H2V9H3.33L2,3M13.11,11H10.89L10.44,13H13.56L13.11,11M7.33,18L8,15H6.67L7.33,18M8.89,11H5.78L6.22,13H8.44L8.89,11M16.67,18L17.33,15H16L16.67,18M18.22,11H15.11L15.56,13H17.78L18.22,11M12,6L11.33,9H12.67L12,6Z' })
	  );
	};
	
	var CurrencyKztIcon = function CurrencyKztIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19V5H5V3M5,6H19V8H13V21H11V8H5V6Z' })
	  );
	};
	
	var CurrencyNgnIcon = function CurrencyNgnIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,9H6V3H8L11.42,9H16V3H18V9H20V11H18V13H20V15H18V21H16L12.57,15H8V21H6V15H4V13H6V11H4V9M8,9H9.13L8,7.03V9M8,11V13H11.42L10.28,11H8M16,17V15H14.85L16,17M12.56,11L13.71,13H16V11H12.56Z' })
	  );
	};
	
	var CurrencyRubIcon = function CurrencyRubIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,10H7V3H14.5C17,3 19,5 19,7.5C19,10 17,12 14.5,12H9V14H15V16H9V21H7V16H6V14H7V12H6V10M14.5,5H9V10H14.5C15.88,10 17,8.88 17,7.5C17,6.12 15.88,5 14.5,5Z' })
	  );
	};
	
	var CurrencySignIcon = function CurrencySignIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,12C22,9.86 21.29,7.78 20,6.07L22,4.07L19.94,1.94L17.94,3.94C14.4,1.36 9.59,1.38 6.07,4L4.07,2L1.94,4.06L3.94,6.06C1.36,9.6 1.38,14.41 4,17.93L2,19.93L4.12,22.05L6.12,20.05C9.65,22.65 14.45,22.65 18,20.05L20,22.05L22.1,19.93L20.1,17.93C21.35,16.21 22,14.13 22,12M12,19C8.13,19 5,15.87 5,12C5,8.13 8.13,5 12,5C15.87,5 19,8.13 19,12C19,15.87 15.87,19 12,19Z' })
	  );
	};
	
	var CurrencyTryIcon = function CurrencyTryIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,12C19,16.97 14.97,21 10,21H8V12.77L5,13.87V11.74L8,10.64V8.87L5,9.96V7.84L8,6.74V3H10V6L15,4.2V6.32L10,8.14V9.92L15,8.1V10.23L10,12.05V19C13.87,19 17,15.87 17,12H19Z' })
	  );
	};
	
	var CurrencyTwdIcon = function CurrencyTwdIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,11H21V13H15V19H21V21H15C13.9,21 13,20.1 13,19V13H10.35L5.73,21L4,20L8.04,13H3V11M5,3H19V5H5V3Z' })
	  );
	};
	
	var CurrencyUsdOffIcon = function CurrencyUsdOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4.27L4.28,3L21,19.72L19.73,21L16.06,17.33C15.44,18 14.54,18.55 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15H9C9,16.08 10.37,17 12,17C13.13,17 14.14,16.56 14.65,15.92L11.68,12.95C9.58,12.42 7,11.75 7,9C7,8.77 7,8.55 7.07,8.34L3,4.27M10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C11.63,7 11.28,7.05 10.95,7.13L9.4,5.58L10.5,5.18Z' })
	  );
	};
	
	var CurrencyUsdIcon = function CurrencyUsdIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z' })
	  );
	};
	
	var CurrentAcIcon = function CurrentAcIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.5,21C13.5,21 12.31,16.76 11.05,12.28C10.14,9.04 9,5 7.5,5C4.11,5 4,11.93 4,12H2C2,11.63 2.06,3 7.5,3C10.5,3 11.71,7.25 12.97,11.74C13.83,14.8 15,19 16.5,19C19.94,19 20.03,12.07 20.03,12H22.03C22.03,12.37 21.97,21 16.5,21Z' })
	  );
	};
	
	var CurrentDcIcon = function CurrentDcIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,9V11H22V9H2M2,13V15H6V13H2M10,13V15H14V13H10M18,13V15H22V13H18Z' })
	  );
	};
	
	var CursorDefaultOutlineIcon = function CursorDefaultOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.07,14.27C10.57,14.03 11.16,14.25 11.4,14.75L13.7,19.74L15.5,18.89L13.19,13.91C12.95,13.41 13.17,12.81 13.67,12.58L13.95,12.5L16.25,12.05L8,5.12V15.9L9.82,14.43L10.07,14.27M13.64,21.97C13.14,22.21 12.54,22 12.31,21.5L10.13,16.76L7.62,18.78C7.45,18.92 7.24,19 7,19C6.45,19 6,18.55 6,18V3C6,2.45 6.45,2 7,2C7.24,2 7.47,2.09 7.64,2.23L7.65,2.22L19.14,11.86C19.57,12.22 19.62,12.85 19.27,13.27C19.12,13.45 18.91,13.57 18.7,13.61L15.54,14.23L17.74,18.96C18,19.46 17.76,20.05 17.26,20.28L13.64,21.97Z' })
	  );
	};
	
	var CursorDefaultIcon = function CursorDefaultIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.64,21.97C13.14,22.21 12.54,22 12.31,21.5L10.13,16.76L7.62,18.78C7.45,18.92 7.24,19 7,19C6.45,19 6,18.55 6,18V3C6,2.45 6.45,2 7,2C7.24,2 7.47,2.09 7.64,2.23L7.65,2.22L19.14,11.86C19.57,12.22 19.62,12.85 19.27,13.27C19.12,13.45 18.91,13.57 18.7,13.61L15.54,14.23L17.74,18.96C18,19.46 17.76,20.05 17.26,20.28L13.64,21.97Z' })
	  );
	};
	
	var CursorMoveIcon = function CursorMoveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,6V11H18V7.75L22.25,12L18,16.25V13H13V18H16.25L12,22.25L7.75,18H11V13H6V16.25L1.75,12L6,7.75V11H11V6H7.75L12,1.75L16.25,6H13Z' })
	  );
	};
	
	var CursorPointerIcon = function CursorPointerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,2C11.1,2 12,2.9 12,4V8.5C12,8.5 14,8.25 14,9.25C14,9.25 16,9 16,10C16,10 18,9.75 18,10.75C18,10.75 20,10.5 20,11.5V15C20,16 17,21 17,22H9C9,22 7,15 4,13C4,13 3,7 8,12V4C8,2.9 8.9,2 10,2Z' })
	  );
	};
	
	var CursorTextIcon = function CursorTextIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,19C13,19.55 13.45,20 14,20H16V22H13.5C12.95,22 12,21.55 12,21C12,21.55 11.05,22 10.5,22H8V20H10C10.55,20 11,19.55 11,19V5C11,4.45 10.55,4 10,4H8V2H10.5C11.05,2 12,2.45 12,3C12,2.45 12.95,2 13.5,2H16V4H14C13.45,4 13,4.45 13,5V19Z' })
	  );
	};
	
	var DatabaseExportIcon = function DatabaseExportIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.22,19L17.05,16.17L14.93,14H22V21.07L19.88,19L17.05,21.83L14.22,19M11.39,19L12.39,18H12C7.58,18 4,16.21 4,14V17C4,19.21 7.58,21 12,21C12.47,21 12.93,21 13.38,20.94L11.39,19M17.29,12H20V9C20,10.2 19,11.27 17.29,12M4,9V12C4,14.21 7.58,16 12,16C12.67,16 13.34,15.96 14,15.87L11.07,13C7.09,12.74 4,11.05 4,9M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3Z' })
	  );
	};
	
	var DatabaseImportIcon = function DatabaseImportIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.05,14.22L19.88,17.05L22,14.93V22H14.93L17.05,19.88L14.22,17.05L17.05,14.22M12.33,18H12C7.58,18 4,16.21 4,14V17C4,19.21 7.58,21 12,21C12.39,21 12.77,21 13.14,21L14.22,19.92L12.33,18M17.54,11.89L19.29,13.64C19.73,13.21 20,12.62 20,12V9C20,10.13 19.06,11.16 17.54,11.88V11.89M4,9V12C4,14.21 7.58,16 12,16H12.45L16,12.47C14.7,12.83 13.35,13 12,13C7.58,13 4,11.21 4,9M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3Z' })
	  );
	};
	
	var DatabaseMinusIcon = function DatabaseMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,3C4.58,3 1,4.79 1,7C1,9.21 4.58,11 9,11C13.42,11 17,9.21 17,7C17,4.79 13.42,3 9,3M1,9V12C1,14.21 4.58,16 9,16C13.42,16 17,14.21 17,12V9C17,11.21 13.42,13 9,13C4.58,13 1,11.21 1,9M1,14V17C1,19.21 4.58,21 9,21C10.41,21 11.79,20.81 13,20.46V17.46C11.79,17.81 10.41,18 9,18C4.58,18 1,16.21 1,14M15,17V19H23V17' })
	  );
	};
	
	var DatabasePlusIcon = function DatabasePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,3C4.58,3 1,4.79 1,7C1,9.21 4.58,11 9,11C13.42,11 17,9.21 17,7C17,4.79 13.42,3 9,3M1,9V12C1,14.21 4.58,16 9,16C13.42,16 17,14.21 17,12V9C17,11.21 13.42,13 9,13C4.58,13 1,11.21 1,9M1,14V17C1,19.21 4.58,21 9,21C10.41,21 11.79,20.81 13,20.46V17.46C11.79,17.81 10.41,18 9,18C4.58,18 1,16.21 1,14M18,14V17H15V19H18V22H20V19H23V17H20V14' })
	  );
	};
	
	var DatabaseSearchIcon = function DatabaseSearchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.68,12.32C16.92,10.56 14.07,10.57 12.32,12.33C10.56,14.09 10.56,16.94 12.32,18.69C13.81,20.17 16.11,20.43 17.89,19.32L21,22.39L22.39,21L19.3,17.89C20.43,16.12 20.17,13.8 18.68,12.32M17.27,17.27C16.29,18.25 14.71,18.24 13.73,17.27C12.76,16.29 12.76,14.71 13.74,13.73C14.71,12.76 16.29,12.76 17.27,13.73C18.24,14.71 18.24,16.29 17.27,17.27M10.9,20.1C10.25,19.44 9.74,18.65 9.42,17.78C6.27,17.25 4,15.76 4,14V17C4,19.21 7.58,21 12,21V21C11.6,20.74 11.23,20.44 10.9,20.1M4,9V12C4,13.68 6.07,15.12 9,15.7C9,15.63 9,15.57 9,15.5C9,14.57 9.2,13.65 9.58,12.81C6.34,12.3 4,10.79 4,9M12,3C7.58,3 4,4.79 4,7C4,9 7,10.68 10.85,11H10.9C12.1,9.74 13.76,9 15.5,9C16.41,9 17.31,9.19 18.14,9.56C19.17,9.09 19.87,8.12 20,7C20,4.79 16.42,3 12,3Z' })
	  );
	};
	
	var DatabaseIcon = function DatabaseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M4,9V12C4,14.21 7.58,16 12,16C16.42,16 20,14.21 20,12V9C20,11.21 16.42,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C16.42,21 20,19.21 20,17V14C20,16.21 16.42,18 12,18C7.58,18 4,16.21 4,14Z' })
	  );
	};
	
	var DeathStarVariantIcon = function DeathStarVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.05,13H21.94C21.88,13.69 21.74,14.36 21.54,15H14V17H17V19H15V21H12.5V22C12.33,22 12.17,22 12,22C6.82,22 2.55,18.05 2.05,13M21.94,11H2.05C2.55,5.95 6.82,2 12,2C13.62,2 15.15,2.39 16.5,3.08V5H18.5V7H20V9H21.54C21.74,9.64 21.88,10.31 21.94,11M12,6.75C12,5.37 10.88,4.25 9.5,4.25C8.12,4.25 7,5.37 7,6.75C7,8.13 8.12,9.25 9.5,9.25C10.88,9.25 12,8.13 12,6.75Z' })
	  );
	};
	
	var DeathStarIcon = function DeathStarIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.05,13H21.95C21.45,18.05 17.19,22 12,22C6.82,22 2.55,18.05 2.05,13M21.95,11H2.05C2.55,5.95 6.82,2 12,2C17.18,2 21.45,5.95 21.95,11M12,6.75C12,5.37 10.88,4.25 9.5,4.25C8.12,4.25 7,5.37 7,6.75C7,8.13 8.12,9.25 9.5,9.25C10.88,9.25 12,8.13 12,6.75Z' })
	  );
	};
	
	var DebianIcon = function DebianIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.5,10.57L18.3,10.94C18.56,10.16 18.41,9.31 18.45,8.57L18.38,8.55C18.31,6.7 16.71,4.73 15.29,4.07C14.06,3.5 12.17,3.4 11.3,3.83C11.42,3.72 11.9,3.68 11.75,3.6C10.38,3.73 10.69,4.07 9.64,4.34C9.35,4.62 10.5,4.12 9.87,4.5C9.31,4.63 9.05,4.38 8.22,5.24C8.29,5.36 8.75,4.89 8.37,5.36C7.58,5.27 5.89,7.16 5.53,7.78L5.72,7.82C5.41,8.59 5,9.08 4.95,9.54C4.87,10.68 4.5,12.75 5.03,13.39L4.97,13.92L5.2,14.37L5.08,14.38C5.66,16.21 5.7,14.42 6.47,16.32C6.36,16.28 6.24,16.24 6.08,16C6.06,16.19 6.32,16.69 6.62,17.08L6.5,17.22C6.66,17.53 6.82,17.6 6.93,17.71C6.3,17.36 7.5,18.84 7.63,19.03L7.73,18.86C7.71,19.1 7.9,19.42 8.26,19.87L8.56,19.86C8.69,20.1 9.14,20.54 9.41,20.56L9.23,20.8C9.92,21 9.56,21.09 10.41,21.39L10.24,21.09C10.67,21.46 10.8,21.79 11.41,22.07C12.26,22.37 12.37,22.25 13.23,22.5C12.5,22.5 11.64,22.5 11.06,22.28C7.1,21.21 3.5,16.56 3.74,11.78C3.68,10.81 3.84,9.6 3.68,9.36C3.9,8.62 4.16,7.72 4.69,6.65C4.65,6.58 4.78,6.86 5.05,6.41C5.21,6.05 5.34,5.66 5.55,5.31L5.65,5.28C5.76,4.67 7.08,3.73 7.5,3.26V3.44C8.36,2.63 9.9,2.09 10.76,1.71C10.53,1.96 11.27,1.68 11.8,1.65L11.31,1.93C11.94,1.77 11.91,2 12.56,1.9C12.33,1.93 12.06,2 12.1,2.06C12.82,2.14 12.94,1.84 13.61,2.06L13.56,1.86C14.5,2.2 14.69,2.14 15.7,2.68C16.06,2.69 16.1,2.46 16.63,2.68C16.73,2.84 16.61,2.87 17.27,3.27C17.34,3.24 17.14,3.05 17,2.9C18.3,3.61 19.75,5.12 20.18,6.74C19.77,6 20.14,7.13 20,7.07C20.18,7.56 20.33,8.07 20.43,8.6C20.31,8.17 20.04,7.12 19.57,6.45C19.54,6.88 18.97,6.15 19.28,7.11C19.5,7.45 19.33,6.76 19.62,7.36C19.62,7.65 19.73,7.94 19.8,8.31C19.7,8.29 19.58,7.9 19.5,8C19.6,8.5 19.77,8.72 19.83,8.76C19.8,8.84 19.71,8.68 19.71,9C19.75,9.74 19.92,9.43 20,9.46C19.91,9.83 19.59,10.25 19.75,10.88L19.55,10.32C19.5,10.85 19.66,10.95 19.42,11.6C19.6,11 19.58,10.5 19.41,10.75C19.5,11.57 18.76,12.2 18.83,12.73L18.62,12.44C18.05,13.27 18.61,12.89 18.22,13.5C18.36,13.27 18.15,13.42 18.33,13.14C18.21,13.15 17.78,13.67 17.39,13.97C15.85,15.2 14,15.37 12.24,14.7H12.23C12.24,14.66 12.23,14.61 12.11,14.53C10.6,13.38 9.71,12.4 10,10.12C10.25,9.95 10.31,9 10.84,8.67C11.16,7.96 12.12,7.31 13.15,7.29C14.2,7.23 15.09,7.85 15.54,8.43C14.72,7.68 13.4,7.45 12.26,8C11.11,8.53 10.42,9.8 10.5,11.07C10.56,11 10.6,11.05 10.62,10.89C10.59,13.36 13.28,15.17 15.22,14.26L15.25,14.31C16.03,14.09 15.93,13.92 16.44,13.56C16.4,13.65 16.1,13.86 16.28,13.86C16.53,13.8 17.31,13.07 17.7,12.73C17.87,12.35 17.6,12.5 17.85,12.04L18.15,11.89C18.32,11.41 18.5,11.14 18.5,10.57' })
	  );
	};
	
	var DebugStepIntoIcon = function DebugStepIntoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,22C10.9,22 10,21.1 10,20C10,18.9 10.9,18 12,18C13.1,18 14,18.9 14,20C14,21.1 13.1,22 12,22M13,2V13L17.5,8.5L18.92,9.92L12,16.84L5.08,9.92L6.5,8.5L11,13V2H13Z' })
	  );
	};
	
	var DebugStepOutIcon = function DebugStepOutIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,22C10.9,22 10,21.1 10,20C10,18.9 10.9,18 12,18C13.1,18 14,18.9 14,20C14,21.1 13.1,22 12,22M13,16H11V6L6.5,10.5L5.08,9.08L12,2.16L18.92,9.08L17.5,10.5L13,6V16Z' })
	  );
	};
	
	var DebugStepOverIcon = function DebugStepOverIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,14C13.1,14 14,14.9 14,16C14,17.1 13.1,18 12,18C10.9,18 10,17.1 10,16C10,14.9 10.9,14 12,14M23.46,8.86L21.87,15.75L15,14.16L18.8,11.78C17.39,9.5 14.87,8 12,8C8.05,8 4.77,10.86 4.12,14.63L2.15,14.28C2.96,9.58 7.06,6 12,6C15.58,6 18.73,7.89 20.5,10.72L23.46,8.86Z' })
	  );
	};
	
	var DecagramOutlineIcon = function DecagramOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,12L20.56,14.78L20.9,18.46L17.29,19.28L15.4,22.46L12,21L8.6,22.47L6.71,19.29L3.1,18.47L3.44,14.78L1,12L3.44,9.21L3.1,5.53L6.71,4.72L8.6,1.54L12,3L15.4,1.54L17.29,4.72L20.9,5.54L20.56,9.22L23,12M20.33,12L18.5,9.89L18.74,7.1L16,6.5L14.58,4.07L12,5.18L9.42,4.07L8,6.5L5.26,7.09L5.5,9.88L3.67,12L5.5,14.1L5.26,16.9L8,17.5L9.42,19.93L12,18.81L14.58,19.92L16,17.5L18.74,16.89L18.5,14.1L20.33,12Z' })
	  );
	};
	
	var DecagramIcon = function DecagramIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12Z' })
	  );
	};
	
	var DecimalDecreaseIcon = function DecimalDecreaseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,17L15,20V18H21V16H15V14L12,17M9,5C10.66,5 12,6.34 12,8V11C12,12.66 10.66,14 9,14C7.34,14 6,12.66 6,11V8C6,6.34 7.34,5 9,5M9,7C8.45,7 8,7.45 8,8V11C8,11.55 8.45,12 9,12C9.55,12 10,11.55 10,11V8C10,7.45 9.55,7 9,7M4,12C4.55,12 5,12.45 5,13C5,13.55 4.55,14 4,14C3.45,14 3,13.55 3,13C3,12.45 3.45,12 4,12Z' })
	  );
	};
	
	var DecimalIncreaseIcon = function DecimalIncreaseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,17L19,20V18H13V16H19V14L22,17M9,5C10.66,5 12,6.34 12,8V11C12,12.66 10.66,14 9,14C7.34,14 6,12.66 6,11V8C6,6.34 7.34,5 9,5M9,7C8.45,7 8,7.45 8,8V11C8,11.55 8.45,12 9,12C9.55,12 10,11.55 10,11V8C10,7.45 9.55,7 9,7M16,5C17.66,5 19,6.34 19,8V11C19,12.66 17.66,14 16,14C14.34,14 13,12.66 13,11V8C13,6.34 14.34,5 16,5M16,7C15.45,7 15,7.45 15,8V11C15,11.55 15.45,12 16,12C16.55,12 17,11.55 17,11V8C17,7.45 16.55,7 16,7M4,12C4.55,12 5,12.45 5,13C5,13.55 4.55,14 4,14C3.45,14 3,13.55 3,13C3,12.45 3.45,12 4,12Z' })
	  );
	};
	
	var DeleteCircleIcon = function DeleteCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M17,7H14.5L13.5,6H10.5L9.5,7H7V9H17V7M9,18H15C15.55,18 16,17.55 16,17V10H8V17C8,17.55 8.45,18 9,18Z' })
	  );
	};
	
	var DeleteEmptyIcon = function DeleteEmptyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.37,8.91L19.37,10.64L7.24,3.64L8.24,1.91L11.28,3.66L12.64,3.29L16.97,5.79L17.34,7.16L20.37,8.91M6,19V7H11.07L18,11V19C18,20.1 17.1,21 16,21H8C6.9,21 6,20.1 6,19Z' })
	  );
	};
	
	var DeleteForeverIcon = function DeleteForeverIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,19C6,20.1 6.9,21 8,21H16C17.1,21 18,20.1 18,19V7H6V19M8.46,11.88L9.87,10.47L12,12.59L14.12,10.47L15.53,11.88L13.41,14L15.53,16.12L14.12,17.53L12,15.41L9.88,17.53L8.47,16.12L10.59,14L8.46,11.88M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z' })
	  );
	};
	
	var DeleteRestoreIcon = function DeleteRestoreIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,14H16L12,10L8,14H10V18H14V14M6,7H18V19C18,19.5 17.8,20 17.39,20.39C17,20.8 16.5,21 16,21H8C7.5,21 7,20.8 6.61,20.39C6.2,20 6,19.5 6,19V7M19,4V6H5V4H8.5L9.5,3H14.5L15.5,4H19Z' })
	  );
	};
	
	var DeleteSweepIcon = function DeleteSweepIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,16H19V18H15V16M15,8H22V10H15V8M15,12H21V14H15V12M3,18C3,19.1 3.9,20 5,20H11C12.1,20 13,19.1 13,18V8H3V18M14,5H11L10,4H6L5,5H2V7H14V5Z' })
	  );
	};
	
	var DeleteVariantIcon = function DeleteVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.03,3L18,20.31C17.83,21.27 17,22 16,22H8C7,22 6.17,21.27 6,20.31L2.97,3H21.03M5.36,5L8,20H16L18.64,5H5.36M9,18V14H13V18H9M13,13.18L9.82,10L13,6.82L16.18,10L13,13.18Z' })
	  );
	};
	
	var DeleteIcon = function DeleteIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19C6,20.1 6.9,21 8,21H16C17.1,21 18,20.1 18,19V7H6V19Z' })
	  );
	};
	
	var DeltaIcon = function DeltaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,7.77L18.39,18H5.61L12,7.77M12,4L2,20H22' })
	  );
	};
	
	var DeskLampIcon = function DeskLampIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.85,2L9.18,4.5L10.32,5.25L7.14,10C7.1,10 7.05,10 7,10C5.9,10 5,10.9 5,12C5,12.94 5.66,13.75 6.58,13.95L10.62,20H7V22H17V20H13L8.53,13.28C8.83,12.92 9,12.47 9,12C9,11.7 8.93,11.4 8.8,11.13L12,6.37C11.78,8.05 12.75,9.89 14.45,11L18.89,4.37C17.2,3.24 15.12,3.04 13.65,3.87L10.85,2M18.33,7L16.67,9.5C17.35,9.95 18.29,9.77 18.75,9.08C19.21,8.39 19,7.46 18.33,7Z' })
	  );
	};
	
	var DeskphoneIcon = function DeskphoneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M15,5V19H19V5H15M5,5V9H13V5H5M5,11V13H7V11H5M8,11V13H10V11H8M11,11V13H13V11H11M5,14V16H7V14H5M8,14V16H10V14H8M11,14V16H13V14H11M11,17V19H13V17H11M8,17V19H10V17H8M5,17V19H7V17H5Z' })
	  );
	};
	
	var DesktopClassicIcon = function DesktopClassicIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2C4.89,2 4,2.89 4,4V12C4,13.11 4.89,14 6,14H18C19.11,14 20,13.11 20,12V4C20,2.89 19.11,2 18,2H6M6,4H18V12H6V4M4,15C2.89,15 2,15.89 2,17V20C2,21.11 2.89,22 4,22H20C21.11,22 22,21.11 22,20V17C22,15.89 21.11,15 20,15H4M8,17H20V20H8V17M9,17.75V19.25H13V17.75H9M15,17.75V19.25H19V17.75H15Z' })
	  );
	};
	
	var DesktopMacIcon = function DesktopMacIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,14H3V4H21M21,2H3C1.89,2 1,2.89 1,4V16C1,17.1 1.9,18 3,18H10L8,21V22H16V21L14,18H21C22.1,18 23,17.1 23,16V4C23,2.89 22.1,2 21,2Z' })
	  );
	};
	
	var DesktopTowerIcon = function DesktopTowerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,2H16C17.1,2 18,2.9 18,4V20C18,21.1 17.1,22 16,22H8C6.9,22 6,21.1 6,20V4C6,2.9 6.9,2 8,2M8,4V6H16V4H8M16,8H8V10H16V8M16,18H14V20H16V18Z' })
	  );
	};
	
	var DetailsIcon = function DetailsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.38,6H17.63L12,16L6.38,6M3,4L12,20L21,4H3Z' })
	  );
	};
	
	var DeveloperBoardIcon = function DeveloperBoardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,9V7H20V5C20,3.9 19.1,3 18,3H4C2.9,3 2,3.9 2,5V19C2,20.1 2.9,21 4,21H18C19.1,21 20,20.1 20,19V17H22V15H20V13H22V11H20V9H22M18,19H4V5H18V19M6,13H11V17H6V13M12,7H16V10H12V7M6,7H11V12H6V7M12,11H16V17H12V11Z' })
	  );
	};
	
	var DeviantartIcon = function DeviantartIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,6H12L14,2H18V6L14.5,13H18V18H12L10,22H6V18L9.5,11H6V6Z' })
	  );
	};
	
	var DialpadIcon = function DialpadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,19C10.9,19 10,19.9 10,21C10,22.1 10.9,23 12,23C13.1,23 14,22.1 14,21C14,19.9 13.1,19 12,19M6,1C4.9,1 4,1.9 4,3C4,4.1 4.9,5 6,5C7.1,5 8,4.1 8,3C8,1.9 7.1,1 6,1M6,7C4.9,7 4,7.9 4,9C4,10.1 4.9,11 6,11C7.1,11 8,10.1 8,9C8,7.9 7.1,7 6,7M6,13C4.9,13 4,13.9 4,15C4,16.1 4.9,17 6,17C7.1,17 8,16.1 8,15C8,13.9 7.1,13 6,13M18,5C19.1,5 20,4.1 20,3C20,1.9 19.1,1 18,1C16.9,1 16,1.9 16,3C16,4.1 16.9,5 18,5M12,13C10.9,13 10,13.9 10,15C10,16.1 10.9,17 12,17C13.1,17 14,16.1 14,15C14,13.9 13.1,13 12,13M18,13C16.9,13 16,13.9 16,15C16,16.1 16.9,17 18,17C19.1,17 20,16.1 20,15C20,13.9 19.1,13 18,13M18,7C16.9,7 16,7.9 16,9C16,10.1 16.9,11 18,11C19.1,11 20,10.1 20,9C20,7.9 19.1,7 18,7M12,7C10.9,7 10,7.9 10,9C10,10.1 10.9,11 12,11C13.1,11 14,10.1 14,9C14,7.9 13.1,7 12,7M12,1C10.9,1 10,1.9 10,3C10,4.1 10.9,5 12,5C13.1,5 14,4.1 14,3C14,1.9 13.1,1 12,1Z' })
	  );
	};
	
	var DiamondIcon = function DiamondIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,9H19L14,16M10,9H14L12,17M5,9H8L10,16M15,4H17L19,7H16M11,4H13L14,7H10M7,4H9L8,7H5M6,2L2,8L12,22L22,8L18,2H6Z' })
	  );
	};
	
	var Dice1Icon = function Dice1Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10Z' })
	  );
	};
	
	var Dice2Icon = function Dice2Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M7,5C5.9,5 5,5.9 5,7C5,8.1 5.9,9 7,9C8.1,9 9,8.1 9,7C9,5.9 8.1,5 7,5M17,15C15.9,15 15,15.9 15,17C15,18.1 15.9,19 17,19C18.1,19 19,18.1 19,17C19,15.9 18.1,15 17,15Z' })
	  );
	};
	
	var Dice3Icon = function Dice3Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10M7,5C5.9,5 5,5.9 5,7C5,8.1 5.9,9 7,9C8.1,9 9,8.1 9,7C9,5.9 8.1,5 7,5M17,15C15.9,15 15,15.9 15,17C15,18.1 15.9,19 17,19C18.1,19 19,18.1 19,17C19,15.9 18.1,15 17,15Z' })
	  );
	};
	
	var Dice4Icon = function Dice4Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M7,5C5.9,5 5,5.9 5,7C5,8.1 5.9,9 7,9C8.1,9 9,8.1 9,7C9,5.9 8.1,5 7,5M17,15C15.9,15 15,15.9 15,17C15,18.1 15.9,19 17,19C18.1,19 19,18.1 19,17C19,15.9 18.1,15 17,15M17,5C15.9,5 15,5.9 15,7C15,8.1 15.9,9 17,9C18.1,9 19,8.1 19,7C19,5.9 18.1,5 17,5M7,15C5.9,15 5,15.9 5,17C5,18.1 5.9,19 7,19C8.1,19 9,18.1 9,17C9,15.9 8.1,15 7,15Z' })
	  );
	};
	
	var Dice5Icon = function Dice5Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M7,5C5.9,5 5,5.9 5,7C5,8.1 5.9,9 7,9C8.1,9 9,8.1 9,7C9,5.9 8.1,5 7,5M17,15C15.9,15 15,15.9 15,17C15,18.1 15.9,19 17,19C18.1,19 19,18.1 19,17C19,15.9 18.1,15 17,15M17,5C15.9,5 15,5.9 15,7C15,8.1 15.9,9 17,9C18.1,9 19,8.1 19,7C19,5.9 18.1,5 17,5M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10M7,15C5.9,15 5,15.9 5,17C5,18.1 5.9,19 7,19C8.1,19 9,18.1 9,17C9,15.9 8.1,15 7,15Z' })
	  );
	};
	
	var Dice6Icon = function Dice6Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M7,5C5.9,5 5,5.9 5,7C5,8.1 5.9,9 7,9C8.1,9 9,8.1 9,7C9,5.9 8.1,5 7,5M17,15C15.9,15 15,15.9 15,17C15,18.1 15.9,19 17,19C18.1,19 19,18.1 19,17C19,15.9 18.1,15 17,15M17,10C15.9,10 15,10.9 15,12C15,13.1 15.9,14 17,14C18.1,14 19,13.1 19,12C19,10.9 18.1,10 17,10M17,5C15.9,5 15,5.9 15,7C15,8.1 15.9,9 17,9C18.1,9 19,8.1 19,7C19,5.9 18.1,5 17,5M7,10C5.9,10 5,10.9 5,12C5,13.1 5.9,14 7,14C8.1,14 9,13.1 9,12C9,10.9 8.1,10 7,10M7,15C5.9,15 5,15.9 5,17C5,18.1 5.9,19 7,19C8.1,19 9,18.1 9,17C9,15.9 8.1,15 7,15Z' })
	  );
	};
	
	var DiceD10Icon = function DiceD10Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.5,10.8C22.1,11.5 22.1,12.5 21.5,13.2L13.2,21.5C12.5,22.2 11.5,22.2 10.8,21.5L2.5,13.2C1.8,12.5 1.8,11.5 2.5,10.8L10.8,2.5C11.5,1.8 12.5,1.8 13.2,2.5L21.5,10.8M20.3,12L12,3.7L3.7,12L12,20.3L20.3,12M10.38,15.79H8.88V10L7.08,10.55V9.32L10.22,8.2H10.38V15.79M13.93,8C15.35,8 16.5,9.15 16.5,10.57V13.21C16.5,14.63 15.35,15.78 13.93,15.78C12.5,15.78 11.36,14.63 11.36,13.21V10.57C11.36,9.15 12.51,8 13.93,8M13.92,9.44C13.33,9.44 12.86,9.91 12.86,10.5V13.27C12.86,13.86 13.33,14.33 13.92,14.33C14.5,14.33 15,13.85 15,13.27V10.5C15,9.91 14.5,9.44 13.92,9.44Z' })
	  );
	};
	
	var DiceD12Icon = function DiceD12Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2L1.5,9.64L5.5,22H18.5L22.5,9.64L12,2M17,20H7L3.85,10.4L12,4.47L20.15,10.4L17,20M17,15.75V17H11.66V15.91C11.66,15.91 15.23,12.45 15.23,11.4C15.23,10.12 14.18,10.25 14.18,10.25C13.5,10.3 13,10.87 13,11.55H11.44C11.5,10.09 12.72,8.94 14.27,9C16.74,9 16.77,10.85 16.77,11.3C16.77,13.07 13.58,15.77 13.58,15.77L17,15.75M10.5,17H8.89V10.89L7,11.47V10.19L10.31,9H10.5V17Z' })
	  );
	};
	
	var DiceD20Icon = function DiceD20Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15M14.93,8.27C16.35,8.27 17.5,9.42 17.5,10.84V13.5C17.5,14.9 16.35,16.05 14.93,16.05C13.5,16.05 12.36,14.9 12.36,13.5V10.84C12.36,9.42 13.51,8.27 14.93,8.27M14.92,9.71C14.34,9.71 13.86,10.18 13.86,10.77V13.53C13.86,14.12 14.34,14.6 14.92,14.6C15.5,14.6 16,14.12 16,13.53V10.77C16,10.18 15.5,9.71 14.92,9.71M11.45,14.76V15.96L6.31,15.93V14.91C6.31,14.91 9.74,11.58 9.75,10.57C9.75,9.33 8.73,9.46 8.73,9.46C8.73,9.46 7.75,9.5 7.64,10.71L6.14,10.76C6.14,10.76 6.18,8.26 8.83,8.26C11.2,8.26 11.23,10.04 11.23,10.5C11.23,12.18 8.15,14.77 8.15,14.77L11.45,14.76Z' })
	  );
	};
	
	var DiceD4Icon = function DiceD4Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.43,15.15H14.29V16.36H13.43V18H11.92V16.36H8.82L8.75,15.41L11.91,10.42H13.43V15.15M10.25,15.15H11.92V12.47L10.25,15.15M22,21H2C1.64,21 1.31,20.81 1.13,20.5C0.95,20.18 0.96,19.79 1.15,19.5L11.15,3C11.5,2.38 12.5,2.38 12.86,3L22.86,19.5C23.04,19.79 23.05,20.18 22.87,20.5C22.69,20.81 22.36,21 22,21M3.78,19H20.23L12,5.43L3.78,19Z' })
	  );
	};
	
	var DiceD6Icon = function DiceD6Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M5,5V19H19V5H5M13.39,9.53C10.89,9.5 10.86,11.53 10.86,11.53C10.86,11.53 11.41,10.87 12.53,10.87C13.19,10.87 14.5,11.45 14.55,13.41C14.61,15.47 12.77,16 12.77,16C12.77,16 9.27,16.86 9.3,12.66C9.33,7.94 13.39,8.33 13.39,8.33V9.53M11.95,12.1C11.21,12 10.83,12.78 10.83,12.78L10.85,13.5C10.85,14.27 11.39,14.83 12,14.83C12.61,14.83 13.05,14.27 13.05,13.5C13.05,12.73 12.56,12.1 11.95,12.1Z' })
	  );
	};
	
	var DiceD8Icon = function DiceD8Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,8.25C13.31,8.25 14.38,9.2 14.38,10.38C14.38,11.07 14,11.68 13.44,12.07C14.14,12.46 14.6,13.13 14.6,13.9C14.6,15.12 13.44,16.1 12,16.1C10.56,16.1 9.4,15.12 9.4,13.9C9.4,13.13 9.86,12.46 10.56,12.07C10,11.68 9.63,11.07 9.63,10.38C9.63,9.2 10.69,8.25 12,8.25M12,12.65C11.39,12.65 10.9,13.14 10.9,13.75C10.9,14.36 11.39,14.85 12,14.85C12.61,14.85 13.1,14.36 13.1,13.75C13.1,13.14 12.61,12.65 12,12.65M12,9.5C11.5,9.5 11.1,9.95 11.1,10.5C11.1,11.05 11.5,11.5 12,11.5C12.5,11.5 12.9,11.05 12.9,10.5C12.9,9.95 12.5,9.5 12,9.5M21.54,10.8C22.14,11.5 22.14,12.5 21.54,13.2L13.24,21.5C12.54,22.2 11.54,22.2 10.84,21.5L2.54,13.2C1.84,12.5 1.84,11.5 2.54,10.8L10.84,2.5C11.54,1.8 12.54,1.8 13.24,2.5L21.54,10.8M20.34,12L12.04,3.7L3.74,12L12.04,20.3L20.34,12Z' })
	  );
	};
	
	var DiceMultipleIcon = function DiceMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.78,3H11.22C10.55,3 10,3.55 10,4.22V8H16V14H19.78C20.45,14 21,13.45 21,12.78V4.22C21,3.55 20.45,3 19.78,3M12.44,6.67C11.76,6.67 11.21,6.12 11.21,5.44C11.21,4.76 11.76,4.21 12.44,4.21C13.12,4.21 13.67,4.76 13.67,5.44C13.67,6.12 13.12,6.67 12.44,6.67M18.56,12.78C17.88,12.79 17.33,12.24 17.32,11.56C17.31,10.88 17.86,10.33 18.54,10.32C19.22,10.31 19.77,10.86 19.78,11.56C19.77,12.23 19.23,12.77 18.56,12.78M18.56,6.67C17.88,6.68 17.33,6.13 17.32,5.45C17.31,4.77 17.86,4.22 18.54,4.21C19.22,4.2 19.77,4.75 19.78,5.44C19.78,6.12 19.24,6.66 18.56,6.67M4.22,10H12.78C13.45,10 14,10.55 14,11.22V19.78C14,20.45 13.45,21 12.78,21H4.22C3.55,21 3,20.45 3,19.78V11.22C3,10.55 3.55,10 4.22,10M8.5,14.28C7.83,14.28 7.28,14.83 7.28,15.5C7.28,16.17 7.83,16.72 8.5,16.72C9.17,16.72 9.72,16.17 9.72,15.5C9.72,14.83 9.17,14.28 8.5,14.28M5.44,11.22C4.77,11.22 4.22,11.77 4.22,12.44C4.22,13.11 4.77,13.66 5.44,13.66C6.11,13.66 6.66,13.11 6.66,12.44V12.44C6.66,11.77 6.11,11.22 5.44,11.22M11.55,17.33C10.88,17.33 10.33,17.88 10.33,18.55C10.33,19.22 10.88,19.77 11.55,19.77C12.22,19.77 12.77,19.22 12.77,18.55H12.77C12.77,17.88 12.23,17.34 11.56,17.33H11.55Z' })
	  );
	};
	
	var DictionaryIcon = function DictionaryIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.81,2C4.83,2.09 4,3 4,4V20C4,21.05 4.95,22 6,22H18C19.05,22 20,21.05 20,20V4C20,2.89 19.1,2 18,2H12V9L9.5,7.5L7,9V2H6C5.94,2 5.87,2 5.81,2M12,13H13C13.55,13 14,13.45 14,14V18H13V16H12V18H11V14C11,13.45 11.45,13 12,13M12,14V15H13V14H12M15,15H18V16L16,19H18V20H15V19L17,16H15V15Z' })
	  );
	};
	
	var DipSwitchIcon = function DipSwitchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4H7C7.55,4 8,4.45 8,5V19C8,19.55 7.55,20 7,20H3C2.45,20 2,19.55 2,19V5C2,4.45 2.45,4 3,4M10,4H14C14.55,4 15,4.45 15,5V19C15,19.55 14.55,20 14,20H10C9.45,20 9,19.55 9,19V5C9,4.45 9.45,4 10,4M17,4H21C21.55,4 22,4.45 22,5V19C22,19.55 21.55,20 21,20H17C16.45,20 16,19.55 16,19V5C16,4.45 16.45,4 17,4M4,18H6V13H4V18M11,11H13V6H11V11M18,18H20V13H18V18Z' })
	  );
	};
	
	var DirectionsForkIcon = function DirectionsForkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4V12.5L6,9.5L9,13C10,14 10,15 10,15V21H14V14C14,14 14,13 13.47,12C12.94,11 12,10 12,10L9,6.58L11.5,4M18,4L13.54,8.47L14,9C14,9 14.93,10 15.47,11C15.68,11.4 15.8,11.79 15.87,12.13L21,7' })
	  );
	};
	
	var DirectionsIcon = function DirectionsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,14.5V12H10V15H8V11C8,10.45 8.45,10 9,10H14V7.5L17.5,11M21.71,11.29L12.71,2.29H12.7C12.31,1.9 11.68,1.9 11.29,2.29L2.29,11.29C1.9,11.68 1.9,12.32 2.29,12.71L11.29,21.71C11.68,22.09 12.31,22.1 12.71,21.71L21.71,12.71C22.1,12.32 22.1,11.68 21.71,11.29Z' })
	  );
	};
	
	var DiscordIcon = function DiscordIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,24L16.75,19L17.38,21H4.5C3.12,21 2,19.88 2,18.5V3.5C2,2.12 3.12,1 4.5,1H19.5C20.88,1 22,2.12 22,3.5V24M12,6.8C9.32,6.8 7.44,7.95 7.44,7.95C8.47,7.03 10.27,6.5 10.27,6.5L10.1,6.33C8.41,6.36 6.88,7.53 6.88,7.53C5.16,11.12 5.27,14.22 5.27,14.22C6.67,16.03 8.75,15.9 8.75,15.9L9.46,15C8.21,14.73 7.42,13.62 7.42,13.62C7.42,13.62 9.3,14.9 12,14.9C14.7,14.9 16.58,13.62 16.58,13.62C16.58,13.62 15.79,14.73 14.54,15L15.25,15.9C15.25,15.9 17.33,16.03 18.73,14.22C18.73,14.22 18.84,11.12 17.12,7.53C17.12,7.53 15.59,6.36 13.9,6.33L13.73,6.5C13.73,6.5 15.53,7.03 16.56,7.95C16.56,7.95 14.68,6.8 12,6.8M9.93,10.59C10.58,10.59 11.11,11.16 11.1,11.86C11.1,12.55 10.58,13.13 9.93,13.13C9.29,13.13 8.77,12.55 8.77,11.86C8.77,11.16 9.28,10.59 9.93,10.59M14.1,10.59C14.75,10.59 15.27,11.16 15.27,11.86C15.27,12.55 14.75,13.13 14.1,13.13C13.46,13.13 12.94,12.55 12.94,11.86C12.94,11.16 13.45,10.59 14.1,10.59Z' })
	  );
	};
	
	var DiskAlertIcon = function DiskAlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,14C8.89,14 8,13.1 8,12C8,10.89 8.89,10 10,10C11.1,10 12,10.9 12,12C12,13.1 11.1,14 10,14M10,4C5.58,4 2,7.58 2,12C2,16.42 5.58,20 10,20C14.42,20 18,16.42 18,12C18,7.58 14.42,4 10,4M20,12H22V7H20M20,16H22V14H20V16Z' })
	  );
	};
	
	var DiskPlayerIcon = function DiskPlayerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.5,10.37C15.54,10.37 16.38,9.53 16.38,8.5C16.38,7.46 15.54,6.63 14.5,6.63C13.46,6.63 12.63,7.46 12.63,8.5C12.63,9.53 13.47,10.37 14.5,10.37M14.5,1C18.64,1 22,4.36 22,8.5C22,10.67 21.08,12.63 19.6,14H9.4C7.93,12.63 7,10.67 7,8.5C7,4.35 10.36,1 14.5,1M6,21V22H4V21H2V15H22V21H20V22H18V21H6M4,18V19H13V18H4M15,17V19H17V17H15M19,17C18.45,17 18,17.45 18,18C18,18.55 18.45,19 19,19C19.55,19 20,18.55 20,18C20,17.45 19.55,17 19,17Z' })
	  );
	};
	
	var DiskIcon = function DiskIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,14C10.89,14 10,13.1 10,12C10,10.89 10.89,10 12,10C13.11,10 14,10.89 14,12C14,13.1 13.1,14 12,14M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4Z' })
	  );
	};
	
	var DisqusOutlineIcon = function DisqusOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.9,14.5H10.8V9.5H11.9C13.5,9.5 14.6,10.4 14.6,12C14.6,13.6 13.5,14.5 11.9,14.5M11.9,7H8.1V17H11.8C15.3,17 17.4,14.9 17.4,12V12C17.4,9.1 15.4,7 11.9,7M12,20C10.1,20 8.3,19.3 6.9,18.1L6.2,17.5L4.5,17.7L5.2,16.1L4.9,15.3C4.4,14.2 4.2,13.1 4.2,11.9C4.2,7.5 7.8,3.9 12.1,3.9C16.4,3.9 19.9,7.6 19.9,12C19.9,16.4 16.3,20 12,20M12,2C6.5,2 2.1,6.5 2.1,12C2.1,13.5 2.4,14.9 3,16.2L1.4,20.3L5.7,19.7C7.4,21.2 9.7,22.1 12.1,22.1C17.6,22.1 22,17.6 22,12.1C22,6.6 17.5,2 12,2Z' })
	  );
	};
	
	var DisqusIcon = function DisqusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.08,22C9.63,22 7.39,21.11 5.66,19.63L1.41,20.21L3.05,16.15C2.5,14.88 2.16,13.5 2.16,12C2.16,6.5 6.6,2 12.08,2C17.56,2 22,6.5 22,12C22,17.5 17.56,22 12.08,22M17.5,11.97V11.94C17.5,9.06 15.46,7 11.95,7H8.16V17H11.9C15.43,17 17.5,14.86 17.5,11.97M12,14.54H10.89V9.46H12C13.62,9.46 14.7,10.39 14.7,12V12C14.7,13.63 13.62,14.54 12,14.54Z' })
	  );
	};
	
	var DivisionBoxIcon = function DivisionBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,13V11H7V13H17M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M12,7C11.45,7 11,7.45 11,8C11,8.55 11.45,9 12,9C12.55,9 13,8.55 13,8C13,7.45 12.55,7 12,7M12,15C11.45,15 11,15.45 11,16C11,16.55 11.45,17 12,17C12.55,17 13,16.55 13,16C13,15.45 12.55,15 12,15Z' })
	  );
	};
	
	var DivisionIcon = function DivisionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,13H5V11H19V13M12,5C13.1,5 14,5.9 14,7C14,8.1 13.1,9 12,9C10.9,9 10,8.1 10,7C10,5.9 10.9,5 12,5M12,15C13.1,15 14,15.9 14,17C14,18.1 13.1,19 12,19C10.9,19 10,18.1 10,17C10,15.9 10.9,15 12,15Z' })
	  );
	};
	
	var DnaIcon = function DnaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H6V4C6,5.44 6.68,6.61 7.88,7.78C8.74,8.61 9.89,9.41 11.09,10.2L9.26,11.39C8.27,10.72 7.31,10 6.5,9.21C5.07,7.82 4,6.1 4,4V2M18,2H20V4C20,6.1 18.93,7.82 17.5,9.21C16.09,10.59 14.29,11.73 12.54,12.84C10.79,13.96 9.09,15.05 7.88,16.22C6.68,17.39 6,18.56 6,20V22H4V20C4,17.9 5.07,16.18 6.5,14.79C7.91,13.41 9.71,12.27 11.46,11.16C13.21,10.04 14.91,8.95 16.12,7.78C17.32,6.61 18,5.44 18,4V2M14.74,12.61C15.73,13.28 16.69,14 17.5,14.79C18.93,16.18 20,17.9 20,20V22H18V20C18,18.56 17.32,17.39 16.12,16.22C15.26,15.39 14.11,14.59 12.91,13.8L14.74,12.61M7,3H17V4L16.94,4.5H7.06L7,4V3M7.68,6H16.32C16.08,6.34 15.8,6.69 15.42,7.06L14.91,7.5H9.07L8.58,7.06C8.2,6.69 7.92,6.34 7.68,6M9.09,16.5H14.93L15.42,16.94C15.8,17.31 16.08,17.66 16.32,18H7.68C7.92,17.66 8.2,17.31 8.58,16.94L9.09,16.5M7.06,19.5H16.94L17,20V21H7V20L7.06,19.5Z' })
	  );
	};
	
	var DnsIcon = function DnsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,9C5.9,9 5,8.1 5,7C5,5.9 5.9,5 7,5C8.1,5 9,5.9 9,7C9,8.1 8.1,9 7,9M20,3H4C3.45,3 3,3.45 3,4V10C3,10.55 3.45,11 4,11H20C20.55,11 21,10.55 21,10V4C21,3.45 20.55,3 20,3M7,19C5.9,19 5,18.1 5,17C5,15.9 5.9,15 7,15C8.1,15 9,15.9 9,17C9,18.1 8.1,19 7,19M20,13H4C3.45,13 3,13.45 3,14V20C3,20.55 3.45,21 4,21H20C20.55,21 21,20.55 21,20V14C21,13.45 20.55,13 20,13Z' })
	  );
	};
	
	var DoNotDisturbOffIcon = function DoNotDisturbOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,11V13H15.54L20.22,17.68C21.34,16.07 22,14.11 22,12C22,6.48 17.52,2 12,2C9.89,2 7.93,2.66 6.32,3.78L13.54,11H17M2.27,2.27L1,3.54L3.78,6.32C2.66,7.93 2,9.89 2,12C2,17.52 6.48,22 12,22C14.11,22 16.07,21.34 17.68,20.22L20.46,23L21.73,21.73L2.27,2.27M7,13V11H8.46L10.46,13H7Z' })
	  );
	};
	
	var DoNotDisturbIcon = function DoNotDisturbIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M17,13H7V11H17V13Z' })
	  );
	};
	
	var DockerIcon = function DockerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.2,9.76H4.44V11.94H2.2V9.76H2.2M4.95,9.76H7.2V11.94H4.95V9.76H4.95M4.95,6.96H7.2V9.14H4.95V6.96M7.71,9.76H9.95V11.94H7.71V9.76H7.71M7.71,6.96H9.95V9.14H7.71V6.96M10.46,9.76H12.71V11.94H10.46V9.76H10.46M10.46,6.96H12.71V9.14H10.46V6.96M13.22,9.76H15.46V11.94H13.22V9.76H13.22M10.46,4.16H12.71V6.34H10.46V4.16M5.33,15.09C5.68,15.09 5.96,15.36 5.96,15.7C5.96,16.03 5.68,16.31 5.33,16.31C5,16.31 4.71,16.03 4.71,15.7C4.71,15.36 5,15.09 5.33,15.09M22.69,10.89V10.89L23,11.06L22.84,11.37C22.2,12.58 20.87,12.95 19.57,12.89C17.62,17.6 13.37,19.84 8.23,19.84C5.57,19.84 3.13,18.87 1.74,16.58L1.72,16.54L1.5,16.14C1.05,15.13 0.89,14.03 1,12.92L1.03,12.59H15.8C16.33,12.59 16.87,12.5 17.36,12.34L18.12,12C17.81,11.6 17.64,11.09 17.6,10.59C17.53,9.91 17.67,9 18.15,8.5L18.39,8.22L18.67,8.44C19.38,9 19.97,9.77 20.08,10.65C20.93,10.41 21.94,10.46 22.69,10.89M5.34,16.85V16.85C6,16.85 6.5,16.33 6.5,15.7C6.5,15.06 6,14.54 5.33,14.54C4.68,14.54 4.15,15.06 4.15,15.7C4.15,16.34 4.68,16.85 5.34,16.85Z' })
	  );
	};
	
	var DolbyIcon = function DolbyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5V19H22V5H2M6,17H4V7H6C8.86,7.09 11.1,9.33 11,12C11.1,14.67 8.86,16.91 6,17M20,17H18C15.14,16.91 12.9,14.67 13,12C12.9,9.33 15.14,7.09 18,7H20V17Z' })
	  );
	};
	
	var DomainIcon = function DomainIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,15H16V17H18M18,11H16V13H18M20,19H12V17H14V15H12V13H14V11H12V9H20M10,7H8V5H10M10,11H8V9H10M10,15H8V13H10M10,19H8V17H10M6,7H4V5H6M6,11H4V9H6M6,15H4V13H6M6,19H4V17H6M12,7V3H2V21H22V7H12Z' })
	  );
	};
	
	var DonkeyIcon = function DonkeyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.34,10.35L21.27,10.28L21.18,10.19L18,7V6C18,5.72 17.78,5.5 17.5,5.5C17.36,5.5 17.22,5.56 17.13,5.66L13.46,9H7C6.32,9 5.69,9.35 5.32,9.92L2.62,12.59C2.29,13.04 2.39,13.66 2.84,14C3.18,14.24 3.65,14.25 4,14L5,13.07V19H8V15H13V19H16V13.83C16,13.3 16.21,12.79 16.59,12.42L18,11L20,12V12C20.15,12.08 20.32,12.13 20.5,12.13C21.1,12.11 21.59,11.61 21.58,11C21.57,10.76 21.5,10.53 21.34,10.35Z' })
	  );
	};
	
	var DoorClosedIcon = function DoorClosedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,11H18V13H16V11M12,3H19C20.11,3 21,3.89 21,5V19H22V21H2V19H10V5C10,3.89 10.89,3 12,3M12,5V19H19V5H12Z' })
	  );
	};
	
	var DoorOpenIcon = function DoorOpenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C10.89,3 10,3.89 10,5H3V19H2V21H22V19H21V5C21,3.89 20.11,3 19,3H12M12,5H19V19H12V5M5,11H7V13H5V11Z' })
	  );
	};
	
	var DoorIcon = function DoorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,3C6.89,3 6,3.89 6,5V21H18V5C18,3.89 17.11,3 16,3H8M8,5H16V19H8V5M13,11V13H15V11H13Z' })
	  );
	};
	
	var DoorbellVideoIcon = function DoorbellVideoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.97,2C6.86,2 6,2.88 6,4V19.92C6,21.03 6.86,21.91 7.97,21.91H15.94C17.04,21.91 17.93,21.03 17.93,19.92V4C17.93,2.88 17.04,2 15.94,2H7.97M11.95,5.5C12.78,5.5 13.45,6.15 13.45,6.97C13.45,7.8 12.78,8.47 11.95,8.47C11.13,8.47 10.46,7.8 10.46,6.97C10.46,6.15 11.13,5.5 11.95,5.5M7.97,9.96H15.94V19.92H7.97V9.96M12,13C10.9,13 10,13.87 10,14.97C10,16.07 10.9,16.97 12,16.97C13.1,16.97 14,16.07 14,14.97C14,13.87 13.1,13 12,13Z' })
	  );
	};
	
	var DotsHorizontalCircleIcon = function DotsHorizontalCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,10.5C11.17,10.5 10.5,11.17 10.5,12C10.5,12.83 11.17,13.5 12,13.5C12.83,13.5 13.5,12.83 13.5,12C13.5,11.17 12.83,10.5 12,10.5M6.5,10.5C5.67,10.5 5,11.17 5,12C5,12.83 5.67,13.5 6.5,13.5C7.33,13.5 8,12.83 8,12C8,11.17 7.33,10.5 6.5,10.5M17.5,10.5C16.67,10.5 16,11.17 16,12C16,12.83 16.67,13.5 17.5,13.5C18.33,13.5 19,12.83 19,12C19,11.17 18.33,10.5 17.5,10.5Z' })
	  );
	};
	
	var DotsHorizontalIcon = function DotsHorizontalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,12C16,10.9 16.9,10 18,10C19.1,10 20,10.9 20,12C20,13.1 19.1,14 18,14C16.9,14 16,13.1 16,12M10,12C10,10.9 10.9,10 12,10C13.1,10 14,10.9 14,12C14,13.1 13.1,14 12,14C10.9,14 10,13.1 10,12M4,12C4,10.9 4.9,10 6,10C7.1,10 8,10.9 8,12C8,13.1 7.1,14 6,14C4.9,14 4,13.1 4,12Z' })
	  );
	};
	
	var DotsVerticalCircleIcon = function DotsVerticalCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12M10.5,12C10.5,12.83 11.17,13.5 12,13.5C12.83,13.5 13.5,12.83 13.5,12C13.5,11.17 12.83,10.5 12,10.5C11.17,10.5 10.5,11.17 10.5,12M10.5,17.5C10.5,18.33 11.17,19 12,19C12.83,19 13.5,18.33 13.5,17.5C13.5,16.67 12.83,16 12,16C11.17,16 10.5,16.67 10.5,17.5M10.5,6.5C10.5,7.33 11.17,8 12,8C12.83,8 13.5,7.33 13.5,6.5C13.5,5.67 12.83,5 12,5C11.17,5 10.5,5.67 10.5,6.5Z' })
	  );
	};
	
	var DotsVerticalIcon = function DotsVerticalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,16C13.1,16 14,16.9 14,18C14,19.1 13.1,20 12,20C10.9,20 10,19.1 10,18C10,16.9 10.9,16 12,16M12,10C13.1,10 14,10.9 14,12C14,13.1 13.1,14 12,14C10.9,14 10,13.1 10,12C10,10.9 10.9,10 12,10M12,4C13.1,4 14,4.9 14,6C14,7.1 13.1,8 12,8C10.9,8 10,7.1 10,6C10,4.9 10.9,4 12,4Z' })
	  );
	};
	
	var DoubanIcon = function DoubanIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,6H4V4H20V6M20,18V20H4V18H7.33L6.26,14H5V8H19V14H17.74L16.67,18H20M7,12H17V10H7V12M9.4,18H14.6L15.67,14H8.33L9.4,18Z' })
	  );
	};
	
	var DownloadNetworkIcon = function DownloadNetworkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,3C18.1,3 19,3.9 19,5V15C19,16.1 18.1,17 17,17H13V19H14C14.55,19 15,19.45 15,20H22V22H15C15,22.55 14.55,23 14,23H10C9.45,23 9,22.55 9,22H2V20H9C9,19.45 9.45,19 10,19H11V17H7C5.89,17 5,16.1 5,15V5C5,3.9 5.9,3 7,3H17M12,14.5L16.5,10H13V6H11V10H7.5L12,14.5Z' })
	  );
	};
	
	var DownloadIcon = function DownloadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z' })
	  );
	};
	
	var DragHorizontalIcon = function DragHorizontalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,15V13H5V15H3M3,11V9H5V11H3M7,15V13H9V15H7M7,11V9H9V11H7M11,15V13H13V15H11M11,11V9H13V11H11M15,15V13H17V15H15M15,11V9H17V11H15M19,15V13H21V15H19M19,11V9H21V11H19Z' })
	  );
	};
	
	var DragVerticalIcon = function DragVerticalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,3H11V5H9V3M13,3H15V5H13V3M9,7H11V9H9V7M13,7H15V9H13V7M9,11H11V13H9V11M13,11H15V13H13V11M9,15H11V17H9V15M13,15H15V17H13V15M9,19H11V21H9V19M13,19H15V21H13V19Z' })
	  );
	};
	
	var DragIcon = function DragIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,19V17H9V19H7M11,19V17H13V19H11M15,19V17H17V19H15M7,15V13H9V15H7M11,15V13H13V15H11M15,15V13H17V15H15M7,11V9H9V11H7M11,11V9H13V11H11M15,11V9H17V11H15M7,7V5H9V7H7M11,7V5H13V7H11M15,7V5H17V7H15Z' })
	  );
	};
	
	var DrawingBoxIcon = function DrawingBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,18H12V12.21C11.34,12.82 10.47,13.2 9.5,13.2C7.46,13.2 5.8,11.54 5.8,9.5C5.8,7.46 7.46,5.8 9.5,5.8C11.54,5.8 13.2,7.46 13.2,9.5C13.2,10.47 12.82,11.34 12.21,12H18M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z' })
	  );
	};
	
	var DrawingIcon = function DrawingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.5,3C11.54,3 14,5.46 14,8.5C14,9.83 13.53,11.05 12.74,12H21V21H12V12.74C11.05,13.53 9.83,14 8.5,14C5.46,14 3,11.54 3,8.5C3,5.46 5.46,3 8.5,3Z' })
	  );
	};
	
	var DribbbleBoxIcon = function DribbbleBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M15.09,16.5C14.81,15.14 14.47,13.91 14.08,12.82L15.2,12.74H15.22V12.74C15.87,12.74 16.59,12.82 17.36,13C17.09,14.44 16.26,15.69 15.09,16.5M12,17.46C10.79,17.46 9.66,17.06 8.76,16.39C8.95,16.07 9.36,15.46 10,14.83C10.7,14.18 11.64,13.5 12.86,13.11C13.28,14.27 13.65,15.6 13.94,17.1C13.33,17.33 12.68,17.46 12,17.46M6.54,12V11.92L7.14,11.93V11.93C8.24,11.93 10.15,11.83 12.1,11.22L12.41,11.94C11.11,12.38 10.09,13.07 9.34,13.76C8.61,14.42 8.12,15.08 7.83,15.5C7.03,14.56 6.54,13.34 6.54,12M9.59,7.11C9.97,7.56 10.73,8.54 11.54,10.08C9.89,10.57 8.23,10.68 7.22,10.68H7.14V10.68H6.7C7.09,9.11 8.17,7.81 9.59,7.11M12,6.54C13.29,6.54 14.47,7 15.41,7.74C14.69,8.6 13.74,9.22 12.72,9.66C12,8.27 11.31,7.28 10.84,6.67C11.21,6.59 11.6,6.54 12,6.54M16.29,8.63C16.97,9.5 17.4,10.57 17.45,11.74C16.66,11.58 15.92,11.5 15.22,11.5V11.5C14.66,11.5 14.13,11.54 13.63,11.63L13.27,10.78C14.37,10.3 15.43,9.61 16.29,8.63M12,5C8.13,5 5,8.13 5,12C5,15.87 8.13,19 12,19C15.87,19 19,15.87 19,12C19,8.13 15.87,5 12,5Z' })
	  );
	};
	
	var DribbbleIcon = function DribbbleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.42,18.42C16,16.5 15.5,14.73 15,13.17C15.5,13.1 16,13.06 16.58,13.06H16.6V13.06H16.6C17.53,13.06 18.55,13.18 19.66,13.43C19.28,15.5 18.08,17.27 16.42,18.42M12,19.8C10.26,19.8 8.66,19.23 7.36,18.26C7.64,17.81 8.23,16.94 9.18,16.04C10.14,15.11 11.5,14.15 13.23,13.58C13.82,15.25 14.36,17.15 14.77,19.29C13.91,19.62 13,19.8 12,19.8M4.2,12C4.2,11.96 4.2,11.93 4.2,11.89C4.42,11.9 4.71,11.9 5.05,11.9H5.06C6.62,11.89 9.36,11.76 12.14,10.89C12.29,11.22 12.44,11.56 12.59,11.92C10.73,12.54 9.27,13.53 8.19,14.5C7.16,15.46 6.45,16.39 6.04,17C4.9,15.66 4.2,13.91 4.2,12M8.55,5C9.1,5.65 10.18,7.06 11.34,9.25C9,9.96 6.61,10.12 5.18,10.12C5.14,10.12 5.1,10.12 5.06,10.12H5.05C4.81,10.12 4.6,10.12 4.43,10.11C5,7.87 6.5,6 8.55,5M12,4.2C13.84,4.2 15.53,4.84 16.86,5.91C15.84,7.14 14.5,8 13.03,8.65C12,6.67 11,5.25 10.34,4.38C10.88,4.27 11.43,4.2 12,4.2M18.13,7.18C19.1,8.42 19.71,9.96 19.79,11.63C18.66,11.39 17.6,11.28 16.6,11.28V11.28H16.59C15.79,11.28 15.04,11.35 14.33,11.47C14.16,11.05 14,10.65 13.81,10.26C15.39,9.57 16.9,8.58 18.13,7.18M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var DroneIcon = function DroneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,11H21L20,9H13.75L16,12.5H14L10.75,9H4C3.45,9 2,8.55 2,8C2,7.45 3.5,5.5 5.5,5.5C7.5,5.5 7.67,6.5 9,7H21C21.55,7 22,7.45 22,8V9L22,11M10.75,6.5L14,3H16L13.75,6.5H10.75M18,11V9.5H19.75L19,11H18M3,19C2.45,19 2,18.55 2,18C2,17.45 2.45,17 3,17C5.21,17 7,18.79 7,21C7,21.55 6.55,22 6,22C5.45,22 5,21.55 5,21C5,19.9 4.1,19 3,19M11,21C11,21.55 10.55,22 10,22C9.45,22 9,21.55 9,21C9,17.69 6.31,15 3,15C2.45,15 2,14.55 2,14C2,13.45 2.45,13 3,13C7.42,13 11,16.58 11,21Z' })
	  );
	};
	
	var DropboxIcon = function DropboxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,14.56L16.35,18.16L18.2,16.95V18.3L12,22L5.82,18.3V16.95L7.68,18.16L12,14.56M7.68,2.5L12,6.09L16.32,2.5L22.5,6.5L18.23,9.94L22.5,13.36L16.32,17.39L12,13.78L7.68,17.39L1.5,13.36L5.77,9.94L1.5,6.5L7.68,2.5M12,13.68L18.13,9.94L12,6.19L5.87,9.94L12,13.68Z' })
	  );
	};
	
	var DrupalIcon = function DrupalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.47,14.65C20.47,15.29 20.25,16.36 19.83,17.1C19.4,17.85 19.08,18.06 18.44,18.06C17.7,17.95 16.31,15.82 15.36,15.72C14.18,15.72 11.73,18.17 9.71,18.17C8.54,18.17 8.11,17.95 7.79,17.74C7.15,17.31 6.94,16.67 6.94,15.82C6.94,14.22 8.43,12.84 10.24,12.84C12.59,12.84 14.18,15.18 15.36,15.08C16.31,15.08 18.23,13.16 19.19,13.16C20.15,12.95 20.47,14 20.47,14.65M16.63,5.28C15.57,4.64 14.61,4.32 13.54,3.68C12.91,3.25 12.05,2.3 11.31,1.44C11,2.83 10.78,3.36 10.24,3.79C9.18,4.53 8.64,4.85 7.69,5.28C6.94,5.7 3,8.05 3,13.16C3,18.27 7.37,22 12.05,22C16.85,22 21,18.5 21,13.27C21.21,8.05 17.27,5.7 16.63,5.28Z' })
	  );
	};
	
	var DuckIcon = function DuckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.5,5C7.67,5 7,5.67 7,6.5C7,7.33 7.67,8 8.5,8C9.33,8 10,7.33 10,6.5C10,5.67 9.33,5 8.5,5M10,2C12.76,2 15,4.24 15,7C15,8.7 14.15,10.2 12.86,11.1C14.44,11.25 16.22,11.61 18,12.5C21,14 22,12 22,12C22,12 21,21 15,21H9C9,21 4,21 4,16C4,13 7,12 6,10C2,10 2,6.5 2,6.5C3,7 4.24,7 5,6.65C5.19,4.05 7.36,2 10,2Z' })
	  );
	};
	
	var DumbbellIcon = function DumbbellIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.22,14.12L3.5,13.41C2.73,12.63 2.73,11.37 3.5,10.59C4.3,9.8 5.56,9.8 6.34,10.59L8.92,13.16L13.16,8.92L10.59,6.34C9.8,5.56 9.8,4.3 10.59,3.5C11.37,2.73 12.63,2.73 13.41,3.5L14.12,4.22L19.78,9.88L20.5,10.59C21.27,11.37 21.27,12.63 20.5,13.41C19.7,14.2 18.44,14.2 17.66,13.41L15.08,10.84L10.84,15.08L13.41,17.66C14.2,18.44 14.2,19.7 13.41,20.5C12.63,21.27 11.37,21.27 10.59,20.5L9.88,19.78L4.22,14.12M3.16,19.42L4.22,18.36L2.81,16.95C2.42,16.56 2.42,15.93 2.81,15.54C3.2,15.15 3.83,15.15 4.22,15.54L8.46,19.78C8.85,20.17 8.85,20.8 8.46,21.19C8.07,21.58 7.44,21.58 7.05,21.19L5.64,19.78L4.58,20.84L3.16,19.42M19.42,3.16L20.84,4.58L19.78,5.64L21.19,7.05C21.58,7.44 21.58,8.07 21.19,8.46C20.8,8.86 20.17,8.86 19.78,8.46L15.54,4.22C15.15,3.83 15.15,3.2 15.54,2.81C15.93,2.42 16.56,2.42 16.95,2.81L18.36,4.22L19.42,3.16Z' })
	  );
	};
	
	var EarHearingIcon = function EarHearingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,20C16.71,20 16.44,19.94 16.24,19.85C15.53,19.5 15.03,18.97 14.53,17.47C14,15.91 13.06,15.18 12.14,14.47C11.35,13.86 10.53,13.23 9.82,11.94C9.29,11 9,9.93 9,9C9,6.2 11.2,4 14,4C16.8,4 19,6.2 19,9H21C21,5.07 17.93,2 14,2C10.07,2 7,5.07 7,9C7,10.26 7.38,11.65 8.07,12.9C9,14.55 10.05,15.38 10.92,16.05C11.73,16.67 12.31,17.12 12.63,18.1C13.23,19.92 14,20.94 15.36,21.65C15.87,21.88 16.43,22 17,22C19.21,22 21,20.21 21,18H19C19,19.1 18.1,20 17,20M7.64,2.64L6.22,1.22C4.23,3.21 3,5.96 3,9C3,12.04 4.23,14.79 6.22,16.78L7.63,15.37C6,13.74 5,11.5 5,9C5,6.5 6,4.26 7.64,2.64M11.5,9C11.5,10.38 12.62,11.5 14,11.5C15.38,11.5 16.5,10.38 16.5,9C16.5,7.62 15.38,6.5 14,6.5C12.62,6.5 11.5,7.62 11.5,9Z' })
	  );
	};
	
	var EarthBoxOffIcon = function EarthBoxOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,4.27L21,6.27V19C21,20.1 20.1,21 19,21H6.27L4.27,23L3,21.72L21.72,3L23,4.27M5,3H19.18L17.18,5H15.78C15.67,6 14.83,6.79 13.8,6.79H11.8V8.79C11.8,9.35 11.35,9.79 10.8,9.79H8.8V11.79H10.38L8.55,13.62L5,10.29V17.18L3,19.18V5C3,3.89 3.89,3 5,3M11.8,19V17.79C11.17,17.79 10.6,17.5 10.23,17.04L8.27,19H11.8M15.8,12.79V15.79H16.8C17.69,15.79 18.74,16.38 19,17.18V8.27L15.33,11.94C15.61,12.12 15.8,12.43 15.8,12.79Z' })
	  );
	};
	
	var EarthBoxIcon = function EarthBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3H5M15.78,5H19V17.18C18.74,16.38 17.69,15.79 16.8,15.79H15.8V12.79C15.8,12.24 15.35,11.79 14.8,11.79H8.8V9.79H10.8C11.35,9.79 11.8,9.34 11.8,8.79V6.79H13.8C14.83,6.79 15.67,6 15.78,5M5,10.29L9.8,14.79V15.79C9.8,16.9 10.7,17.79 11.8,17.79V19H5V10.29Z' })
	  );
	};
	
	var EarthOffIcon = function EarthOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,5.27L20.5,6.75C21.46,8.28 22,10.07 22,12C22,17.52 17.52,22 12,22C10.08,22 8.28,21.46 6.75,20.5L5.27,22L4,20.72L20.72,4L22,5.27M17.9,17.39C19.2,15.97 20,14.08 20,12C20,10.63 19.66,9.34 19.05,8.22L14.83,12.44C14.94,12.6 15,12.79 15,13V16H16C16.89,16 17.64,16.59 17.9,17.39M11,19.93V18C10.5,18 10.07,17.83 9.73,17.54L8.22,19.05C9.07,19.5 10,19.8 11,19.93M15,4.59V5C15,6.1 14.1,7 13,7H11V9C11,9.55 10.55,10 10,10H8V12H10.18L8.09,14.09L4.21,10.21C4.08,10.78 4,11.38 4,12C4,13.74 4.56,15.36 5.5,16.67L4.08,18.1C2.77,16.41 2,14.3 2,12C2,6.48 6.48,2 12,2C14.3,2 16.41,2.77 18.1,4.08L16.67,5.5C16.16,5.14 15.6,4.83 15,4.59Z' })
	  );
	};
	
	var EarthIcon = function EarthIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.9,17.39C17.64,16.59 16.89,16 16,16H15V13C15,12.45 14.55,12 14,12H8V10H10C10.55,10 11,9.55 11,9V7H13C14.1,7 15,6.1 15,5V4.59C17.93,5.77 20,8.64 20,12C20,14.08 19.2,15.97 17.9,17.39M11,19.93C7.05,19.44 4,16.08 4,12C4,11.38 4.08,10.78 4.21,10.21L9,15V16C9,17.1 9.9,18 11,18M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var EdgeIcon = function EdgeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.74,10.81C3.83,-1.36 22.5,-1.36 21.2,13.56H8.61C8.61,17.85 14.42,19.21 19.54,16.31V20.53C13.25,23.88 5,21.43 5,14.09C5,8.58 9.97,6.81 9.97,6.81C9.97,6.81 8.58,8.58 8.54,10.05H15.7C15.7,2.93 5.9,5.57 2.74,10.81Z' })
	  );
	};
	
	var EjectIcon = function EjectIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,5L5.33,15H18.67M5,17H19V19H5V17Z' })
	  );
	};
	
	var ElephantIcon = function ElephantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.5,15.5C19.5,15.78 19.28,16 19,16C18.72,16 18.5,15.78 18.5,15.5V8.5C18.5,6.57 16.43,5 14.5,5H6C3.79,5 2,6.79 2,9V19H6V15H11V19H15V14.5C15,14.22 15.22,14 15.5,14C15.78,14 16,14.22 16,14.5V16C16,17.66 17.34,19 19,19C20.66,19 22,17.66 22,16V14H19.5V15.5Z' })
	  );
	};
	
	var ElevationDeclineIcon = function ElevationDeclineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,21H3V11.25L9.45,15L13.22,12.8L21,17.29V21M3,8.94V6.75L9.45,10.5L13.22,8.3L21,12.79V15L13.22,10.5L9.45,12.67L3,8.94Z' })
	  );
	};
	
	var ElevationRiseIcon = function ElevationRiseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,21V17.29L10.78,12.8L14.55,15L21,11.25V21H3M21,8.94L14.55,12.67L10.78,10.5L3,15V12.79L10.78,8.3L14.55,10.5L21,6.75V8.94Z' })
	  );
	};
	
	var ElevatorIcon = function ElevatorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,2L11,6H8V10H6V6H3L7,2M17,10L13,6H16V2H18V6H21L17,10M7,12H17C18.1,12 19,12.9 19,14V20C19,21.1 18.1,22 17,22H7C5.9,22 5,21.1 5,20V14C5,12.9 5.9,12 7,12M7,14V20H17V14H7Z' })
	  );
	};
	
	var EmailAlertIcon = function EmailAlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,9V7L10,11L4,7V9L10,13L16,9M16,5C17.1,5 18,5.9 18,7V16C18,17.1 17.1,18 16,18H4C2.89,18 2,17.1 2,16V7C2,5.9 2.9,5 4,5H16M20,12V7H22V12H20M20,16V14H22V16H20Z' })
	  );
	};
	
	var EmailOpenOutlineIcon = function EmailOpenOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,15.36L4,10.36V18H20V10.36L12,15.36M4,8L12,13L20,8V8L12,3L4,8V8M22,8V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V8C2,7.27 2.39,6.64 2.97,6.29L12,0.64L21.03,6.29C21.61,6.64 22,7.27 22,8Z' })
	  );
	};
	
	var EmailOpenIcon = function EmailOpenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,8L12,13L20,8V8L12,3L4,8V8M22,8V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V8C2,7.27 2.39,6.64 2.97,6.29L12,0.64L21.03,6.29C21.61,6.64 22,7.27 22,8Z' })
	  );
	};
	
	var EmailOutlineIcon = function EmailOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H20C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4M12,11L20,6H4L12,11M4,18H20V8.37L12,13.36L4,8.37V18Z' })
	  );
	};
	
	var EmailSearchOutlineIcon = function EmailSearchOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4H19C20.1,4 21,4.9 21,6V10.82C20.42,10.26 19.74,9.81 19,9.5V8.37L17.78,9.13C17.36,9.04 16.93,9 16.5,9C13.86,9 11.5,10.6 10.5,13.04L3,8.37V18H10.5C10.81,18.74 11.26,19.42 11.81,20H3C1.89,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4M3,6L11,11L19,6H3M16.5,11C19,11 21,13 21,15.5C21,16.38 20.75,17.21 20.31,17.9L23.39,21L22,22.39L18.88,19.32C18.19,19.75 17.37,20 16.5,20C14,20 12,18 12,15.5C12,13 14,11 16.5,11M16.5,13C15.12,13 14,14.12 14,15.5C14,16.88 15.12,18 16.5,18C17.88,18 19,16.88 19,15.5C19,14.12 17.88,13 16.5,13Z' })
	  );
	};
	
	var EmailSearchIcon = function EmailSearchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4H19C20.1,4 21,4.9 21,6V10.82C20,9.85 18.7,9.23 17.31,9.06L19,8V6L11,11L3,6V8L10.62,12.76C10.21,13.62 10,14.55 10,15.5C10,17.18 10.65,18.79 11.81,20H3C1.9,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4M16.5,11C19,11 21,13 21,15.5C21,16.38 20.75,17.21 20.31,17.9L23.39,21L22,22.39L18.88,19.32C18.19,19.75 17.37,20 16.5,20C14,20 12,18 12,15.5C12,13 14,11 16.5,11M16.5,13C15.12,13 14,14.12 14,15.5C14,16.88 15.12,18 16.5,18C17.88,18 19,16.88 19,15.5C19,14.12 17.88,13 16.5,13Z' })
	  );
	};
	
	var EmailSecureIcon = function EmailSecureIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.5,0C21.88,0 23,1.12 23,2.5V3C23.55,3 24,3.45 24,4V8C24,8.55 23.55,9 23,9H18C17.45,9 17,8.55 17,8V4C17,3.45 17.45,3 18,3V2.5C18,1.12 19.12,0 20.5,0M12,11L4,6V8L12,13L16.18,10.39C16.69,10.77 17.32,11 18,11H22V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4H15V8C15,8.36 15.06,8.7 15.18,9L12,11M20.5,1C19.67,1 19,1.67 19,2.5V3H22V2.5C22,1.67 21.33,1 20.5,1Z' })
	  );
	};
	
	var EmailVariantIcon = function EmailVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,13L2,6.76V6C2,4.89 2.89,4 4,4H20C21.1,4 22,4.9 22,6V6.75L12,13M22,18C22,19.1 21.1,20 20,20H4C2.89,20 2,19.1 2,18V9.11L4,10.36V18H20V10.36L22,9.11V18Z' })
	  );
	};
	
	var EmailIcon = function EmailIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4Z' })
	  );
	};
	
	var EmbyIcon = function EmbyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,2L6,7L7,8L2,13L7,18L8,17L13,22L18,17L17,16L22,11L17,6L16,7L11,2M10,8.5L16,12L10,15.5V8.5Z' })
	  );
	};
	
	var EmoticonCoolIcon = function EmoticonCoolIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,10C19,11.38 16.88,12.5 15.5,12.5C14.12,12.5 12.75,11.38 12.75,10H11.25C11.25,11.38 9.88,12.5 8.5,12.5C7.12,12.5 5,11.38 5,10H4.25C4.09,10.64 4,11.31 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,11.31 19.91,10.64 19.75,10H19M12,4C9.04,4 6.45,5.61 5.07,8H18.93C17.55,5.61 14.96,4 12,4M22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z' })
	  );
	};
	
	var EmoticonDeadIcon = function EmoticonDeadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.52,22 22,17.52 22,12C22,6.47 17.5,2 12,2M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M16.18,7.76L15.12,8.82L14.06,7.76L13,8.82L14.06,9.88L13,10.94L14.06,12L15.12,10.94L16.18,12L17.24,10.94L16.18,9.88L17.24,8.82L16.18,7.76M7.82,12L8.88,10.94L9.94,12L11,10.94L9.94,9.88L11,8.82L9.94,7.76L8.88,8.82L7.82,7.76L6.76,8.82L7.82,9.88L6.76,10.94L7.82,12M12,14C9.67,14 7.69,15.46 6.89,17.5H17.11C16.31,15.46 14.33,14 12,14Z' })
	  );
	};
	
	var EmoticonDevilIcon = function EmoticonDevilIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1.5,2.09C2.4,3 3.87,3.73 5.69,4.25C7.41,2.84 9.61,2 12,2C14.39,2 16.59,2.84 18.31,4.25C20.13,3.73 21.6,3 22.5,2.09C22.47,3.72 21.65,5.21 20.28,6.4C21.37,8 22,9.92 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,9.92 2.63,8 3.72,6.4C2.35,5.21 1.53,3.72 1.5,2.09M20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12M10.5,10C10.5,10.8 9.8,11.5 9,11.5C8.2,11.5 7.5,10.8 7.5,10V8.5L10.5,10M16.5,10C16.5,10.8 15.8,11.5 15,11.5C14.2,11.5 13.5,10.8 13.5,10L16.5,8.5V10M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z' })
	  );
	};
	
	var EmoticonExcitedIcon = function EmoticonExcitedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.52,22 22,17.52 22,12C22,6.47 17.5,2 12,2M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M13,9.94L14.06,11L15.12,9.94L16.18,11L17.24,9.94L15.12,7.82L13,9.94M8.88,9.94L9.94,11L11,9.94L8.88,7.82L6.76,9.94L7.82,11L8.88,9.94M12,17.5C14.33,17.5 16.31,16.04 17.11,14H6.89C7.69,16.04 9.67,17.5 12,17.5Z' })
	  );
	};
	
	var EmoticonHappyIcon = function EmoticonHappyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12M22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z' })
	  );
	};
	
	var EmoticonNeutralIcon = function EmoticonNeutralIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.5,11C7.67,11 7,10.33 7,9.5C7,8.67 7.67,8 8.5,8C9.33,8 10,8.67 10,9.5C10,10.33 9.33,11 8.5,11M15.5,11C14.67,11 14,10.33 14,9.5C14,8.67 14.67,8 15.5,8C16.33,8 17,8.67 17,9.5C17,10.33 16.33,11 15.5,11M12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.47,22 2,17.5 2,12C2,6.48 6.48,2 12,2M9,14H15C15.55,14 16,14.45 16,15C16,15.55 15.55,16 15,16H9C8.45,16 8,15.55 8,15C8,14.45 8.45,14 9,14Z' })
	  );
	};
	
	var EmoticonPoopIcon = function EmoticonPoopIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.36,2C11.15,2 10.87,2.12 10.57,2.32C10,2.7 8.85,3.9 8.4,5.1C8.06,6 8.05,6.82 8.19,7.43C7.63,7.53 7.22,7.71 7.06,7.78C6.55,8 5.47,8.96 5.37,10.45C5.34,10.97 5.41,11.5 5.57,12C4.91,12.19 4.53,12.43 4.5,12.44C4.18,12.56 3.65,12.93 3.5,13.13C3.15,13.53 2.92,14 2.79,14.5C2.5,15.59 2.6,16.83 3.13,17.83C3.42,18.39 3.82,19 4.26,19.43C5.7,20.91 8.18,21.47 10.14,21.79C12.53,22.19 15.03,22.05 17.26,21.13C20.61,19.74 21.5,17.5 21.64,16.89C21.93,15.5 21.57,14.19 21.42,13.87C21.2,13.41 20.84,12.94 20.25,12.64C19.85,12.39 19.5,12.26 19.24,12.2C19.5,11.25 19.13,10.5 18.62,9.94C17.85,9.12 17.06,9 17.06,9V9C17.32,8.5 17.42,7.9 17.28,7.32C17.12,6.61 16.73,6.16 16.22,5.86C15.7,5.55 15.06,5.4 14.4,5.28C14.08,5.22 12.75,5.03 12.2,4.27C11.75,3.65 11.74,2.53 11.62,2.2C11.57,2.07 11.5,2 11.36,2M16,9.61C16.07,9.61 16.13,9.62 16.19,9.62C17.62,9.78 18.64,11.16 18.47,12.69C18.3,14.22 17,15.34 15.57,15.18V15.18C14.14,15 13.12,13.65 13.29,12.11C13.45,10.66 14.64,9.56 16,9.61M8.62,9.61C9.95,9.65 11.06,10.78 11.16,12.21C11.28,13.75 10.21,15.08 8.78,15.19H8.77C7.34,15.3 6.08,14.14 5.96,12.6V12.6C5.85,11.06 6.92,9.73 8.35,9.62V9.62C8.44,9.61 8.53,9.61 8.62,9.61M8.64,11.31C8.6,11.31 8.57,11.31 8.53,11.32C7.97,11.39 7.57,11.9 7.64,12.45C7.7,13 8.21,13.39 8.77,13.32C9.33,13.25 9.73,12.74 9.67,12.19C9.61,11.67 9.15,11.3 8.64,11.31M15.94,11.33C15.42,11.35 15,11.75 14.96,12.28C14.92,12.83 15.35,13.31 15.91,13.34C16.5,13.38 16.96,12.95 17,12.4C17.04,11.84 16.61,11.36 16.05,11.33C16,11.33 16,11.33 15.94,11.33M8.71,16.15C9,16.14 9.26,16.23 9.5,16.28C10.68,16.5 11.7,16.53 12.19,16.53C12.68,16.53 13.69,16.5 14.86,16.28C15.27,16.2 15.74,16.03 16.11,16.28C16.59,16.6 16.24,17.75 15.5,18.53C15.04,19 13.97,19.91 12.19,19.91C10.41,19.91 9.33,19 8.88,18.53C8.14,17.75 7.79,16.6 8.26,16.28C8.4,16.19 8.55,16.15 8.71,16.15Z' })
	  );
	};
	
	var EmoticonSadIcon = function EmoticonSadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12M22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12M15.5,8C16.3,8 17,8.7 17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M12,14C13.75,14 15.29,14.72 16.19,15.81L14.77,17.23C14.32,16.5 13.25,16 12,16C10.75,16 9.68,16.5 9.23,17.23L7.81,15.81C8.71,14.72 10.25,14 12,14Z' })
	  );
	};
	
	var EmoticonTongueIcon = function EmoticonTongueIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,8C10.1,8 11,8.9 11,10C11,10.36 10.9,10.71 10.73,11C10.39,10.4 9.74,10 9,10C8.26,10 7.61,10.4 7.27,11C7.1,10.71 7,10.36 7,10C7,8.9 7.9,8 9,8M15,8C16.1,8 17,8.9 17,10C17,10.36 16.9,10.71 16.73,11C16.39,10.4 15.74,10 15,10C14.26,10 13.61,10.4 13.27,11C13.1,10.71 13,10.36 13,10C13,8.9 13.9,8 15,8M12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.47,22 2,17.5 2,12C2,6.48 6.48,2 12,2M9,13H15C15.55,13 16,13.45 16,14C16,14.55 15.55,15 15,15C15,17 14.1,18 13,18C11.9,18 11,17 11,15H9C8.45,15 8,14.55 8,14C8,13.45 8.45,13 9,13Z' })
	  );
	};
	
	var EmoticonIcon = function EmoticonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,17.5C14.33,17.5 16.3,16.04 17.11,14H6.89C7.69,16.04 9.67,17.5 12,17.5M8.5,11C9.33,11 10,10.33 10,9.5C10,8.67 9.33,8 8.5,8C7.67,8 7,8.67 7,9.5C7,10.33 7.67,11 8.5,11M15.5,11C16.33,11 17,10.33 17,9.5C17,8.67 16.33,8 15.5,8C14.67,8 14,8.67 14,9.5C14,10.33 14.67,11 15.5,11M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.47,2 2,6.5 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var EngineOutlineIcon = function EngineOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,10H16V18H11L9,16H7V11M7,4V6H10V8H7L5,10V13H3V10H1V18H3V15H5V18H8L10,20H18V16H20V19H23V9H20V12H18V8H12V6H15V4H7Z' })
	  );
	};
	
	var EngineIcon = function EngineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,4V6H10V8H7L5,10V13H3V10H1V18H3V15H5V18H8L10,20H18V16H20V19H23V9H20V12H18V8H12V6H15V4H7Z' })
	  );
	};
	
	var EqualBoxIcon = function EqualBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,16V14H7V16H17M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M17,10V8H7V10H17Z' })
	  );
	};
	
	var EqualIcon = function EqualIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,10H5V8H19V10M19,16H5V14H19V16Z' })
	  );
	};
	
	var EraserVariantIcon = function EraserVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.14,3C14.63,3 14.12,3.2 13.73,3.59L2.59,14.73C1.81,15.5 1.81,16.77 2.59,17.56L5.03,20H12.69L21.41,11.27C22.2,10.5 22.2,9.23 21.41,8.44L16.56,3.59C16.17,3.2 15.65,3 15.14,3M17,18L15,20H22V18' })
	  );
	};
	
	var EraserIcon = function EraserIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.24,3.56L21.19,8.5C21.97,9.29 21.97,10.55 21.19,11.34L12,20.53C10.44,22.09 7.91,22.09 6.34,20.53L2.81,17C2.03,16.21 2.03,14.95 2.81,14.16L13.41,3.56C14.2,2.78 15.46,2.78 16.24,3.56M4.22,15.58L7.76,19.11C8.54,19.9 9.8,19.9 10.59,19.11L14.12,15.58L9.17,10.63L4.22,15.58Z' })
	  );
	};
	
	var EscalatorIcon = function EscalatorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,8H18.95L6.95,20H4C2.9,20 2,19.1 2,18C2,16.9 2.9,16 4,16H5.29L7,14.29V10C7,9.45 7.45,9 8,9H9C9.55,9 10,9.45 10,10V11.29L17.29,4H20C21.1,4 22,4.9 22,6C22,7.1 21.1,8 20,8M8.5,5C9.33,5 10,5.67 10,6.5C10,7.33 9.33,8 8.5,8C7.67,8 7,7.33 7,6.5C7,5.67 7.67,5 8.5,5Z' })
	  );
	};
	
	var EthereumIcon = function EthereumIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1.75L5.75,12.25L12,16L18.25,12.25L12,1.75M5.75,13.5L12,22.25L18.25,13.5L12,17.25L5.75,13.5Z' })
	  );
	};
	
	var EthernetCableOffIcon = function EthernetCableOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,3H13V7H11V3M8,4H10V8H14V4H16V11H12.82L8,6.18V4M20,20.72L18.73,22L14,17.27V22H10V13.27L2,5.27L3.28,4L20,20.72Z' })
	  );
	};
	
	var EthernetCableIcon = function EthernetCableIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,3V7H13V3H11M8,4V11H16V4H14V8H10V4H8M10,12V22H14V12H10Z' })
	  );
	};
	
	var EthernetIcon = function EthernetIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,15H9V18H11V15H13V18H15V15H17V18H19V9H15V6H9V9H5V18H7V15M4.38,3H19.63C20.94,3 22,4.06 22,5.38V19.63C22,20.94 20.94,22 19.63,22H4.38C3.06,22 2,20.94 2,19.63V5.38C2,4.06 3.06,3 4.38,3Z' })
	  );
	};
	
	var EtsyIcon = function EtsyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.72,20.78C8.23,20.71 10.07,20.78 11.87,20.78C13.72,20.78 15.62,20.66 17.12,20.78C17.72,20.83 18.28,21.19 18.77,20.87C19.16,20.38 18.87,19.71 18.96,19.05C19.12,17.78 20.28,16.27 18.59,15.95C17.87,16.61 18.35,17.23 17.95,18.05C17.45,19.03 15.68,19.37 14,19.5C12.54,19.62 10,19.76 9.5,18.77C9.04,17.94 9.29,16.65 9.29,15.58C9.29,14.38 9.16,13.22 9.5,12.3C11.32,12.43 13.7,11.69 15,12.5C15.87,13 15.37,14.06 16.38,14.4C17.07,14.21 16.7,13.32 16.66,12.5C16.63,11.94 16.63,11.19 16.66,10.57C16.69,9.73 17,8.76 16.1,8.74C15.39,9.3 15.93,10.23 15.18,10.75C14.95,10.92 14.43,11 14.08,11C12.7,11.17 10.54,11.05 9.38,10.84C9.23,9.16 9.24,6.87 9.38,5.19C10,4.57 11.45,4.54 12.42,4.55C14.13,4.55 16.79,4.7 17.3,5.55C17.58,6 17.36,7 17.85,7.1C18.85,7.33 18.36,5.55 18.41,4.73C18.44,4.11 18.71,3.72 18.59,3.27C18.27,2.83 17.79,3.05 17.5,3.09C14.35,3.5 9.6,3.27 6.26,3.27C5.86,3.27 5.16,3.07 4.88,3.54C4.68,4.6 6.12,4.16 6.62,4.73C6.79,4.91 7.03,5.73 7.08,6.28C7.23,7.74 7.08,9.97 7.08,12.12C7.08,14.38 7.26,16.67 7.08,18.05C7,18.53 6.73,19.3 6.62,19.41C6,20.04 4.34,19.35 4.5,20.69C5.09,21.08 5.93,20.82 6.72,20.78Z' })
	  );
	};
	
	var EvStationIcon = function EvStationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.77,7.23L19.78,7.22L16.06,3.5L15,4.56L17.11,6.67C16.17,7.03 15.5,7.93 15.5,9C15.5,10.38 16.62,11.5 18,11.5C18.36,11.5 18.69,11.42 19,11.29V18.5C19,19.05 18.55,19.5 18,19.5C17.45,19.5 17,19.05 17,18.5V14C17,12.9 16.1,12 15,12H14V5C14,3.9 13.1,3 12,3H6C4.9,3 4,3.9 4,5V21H14V13.5H15.5V18.5C15.5,19.88 16.62,21 18,21C19.38,21 20.5,19.88 20.5,18.5V9C20.5,8.31 20.22,7.68 19.77,7.23M18,10C17.45,10 17,9.55 17,9C17,8.45 17.45,8 18,8C18.55,8 19,8.45 19,9C19,9.55 18.55,10 18,10M8,18V13.5H6L10,6V11H12L8,18Z' })
	  );
	};
	
	var EventbriteIcon = function EventbriteIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,6.23C22,4.88 21.14,3.68 19.86,3.23C18.91,2.92 5.34,2 4.89,2C4.04,2.09 3.27,2.5 2.74,3.19C2.26,3.75 2,4.46 2,5.19C2,9.7 2,14.2 2,18.71C2,19.77 2.47,20.77 3.33,21.39C3.88,21.81 4.54,22.03 5.23,22.03C5.71,22.03 18,21.03 18.83,20.97C19.65,20.92 20.42,20.58 21,20C21.62,19.45 22,18.67 22,17.84C22,15.88 22,8.15 22,6.23M17.61,7.5C17.56,7.63 17.5,7.77 17.45,7.91C17.32,8.29 16.94,8.53 16.54,8.5C15.44,8.5 11.95,8.5 11.31,8.45C11.13,8.45 11.06,8.5 11.03,8.69C10.9,9.38 10.74,10.07 10.58,10.8H14.46C14.57,10.79 14.67,10.79 14.78,10.8C15.36,10.93 15.5,11.11 15.47,11.7C15.43,12 15.33,12.31 15.18,12.59C15,12.86 14.71,13 14.39,13H14.13L10.3,13C10.17,13 10.09,13 10.06,13.16L9.59,15.44V15.54H9.86L14.93,15.54C15.32,15.5 15.69,15.74 15.81,16.11C15.96,16.81 15.63,17.5 15,17.85C14.84,17.9 14.68,17.92 14.5,17.93C13.82,17.93 8.32,18.07 7.93,18.07C7.6,18.08 7.27,18 7,17.8C6.69,17.57 6.55,17.18 6.63,16.8C6.73,16.14 8.29,8.5 8.57,7.33C8.64,6.5 9.36,5.92 10.19,6C11.19,6 16,6.1 16.75,6.14C17.5,6.18 17.85,6.64 17.61,7.5Z' })
	  );
	};
	
	var EvernoteIcon = function EvernoteIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.09,11.63C15.09,11.63 15.28,10.35 16,10.35C16.76,10.35 17.78,12.06 17.78,12.06C17.78,12.06 15.46,11.63 15.09,11.63M19,4.69C18.64,4.09 16.83,3.41 15.89,3.41C14.96,3.41 13.5,3.41 13.5,3.41C13.5,3.41 12.7,2 10.88,2C9.05,2 9.17,2.81 9.17,3.5V6.32L8.34,7.19H4.5C4.5,7.19 3.44,7.91 3.44,9.44C3.44,11 3.92,16.35 7.13,16.85C10.93,17.43 11.58,15.67 11.58,15.46C11.58,14.56 11.6,13.21 11.6,13.21C11.6,13.21 12.71,15.33 14.39,15.33C16.07,15.33 17.04,16.3 17.04,17.29C17.04,18.28 17.04,19.13 17.04,19.13C17.04,19.13 17,20.28 16,20.28C15,20.28 13.89,20.28 13.89,20.28C13.89,20.28 13.2,19.74 13.2,19C13.2,18.25 13.53,18.05 13.93,18.05C14.32,18.05 14.65,18.09 14.65,18.09V16.53C14.65,16.53 11.47,16.5 11.47,18.94C11.47,21.37 13.13,22 14.46,22C15.8,22 16.63,22 16.63,22C16.63,22 20.56,21.5 20.56,13.75C20.56,6 19.33,5.28 19,4.69M7.5,6.31H4.26L8.32,2.22V5.5L7.5,6.31Z' })
	  );
	};
	
	var ExclamationIcon = function ExclamationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,4.5H13V15.5H11V4.5M13,17.5V19.5H11V17.5H13Z' })
	  );
	};
	
	var ExitToAppIcon = function ExitToAppIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H5C3.89,3 3,3.89 3,5V9H5V5H19V19H5V15H3V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M10.08,15.58L11.5,17L16.5,12L11.5,7L10.08,8.41L12.67,11H3V13H12.67L10.08,15.58Z' })
	  );
	};
	
	var ExponentBoxIcon = function ExponentBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5M13.76,6H15.39L16.5,8.6L17.59,6H19.24C19.24,6 17.5,10.57 16.46,12.32C16.08,12.89 15.35,13.27 14.5,13.25V11.75C14.96,11.76 15.25,11.5 15.5,11.13C15.61,11 15.68,10.8 15.74,10.64L13.76,6M6.41,9.59L9.21,12.38L12,9.59L13.41,11L10.62,13.79L13.41,16.59L12,18L9.21,15.21L6.41,18L5,16.59L7.79,13.79L5,11L6.41,9.59Z' })
	  );
	};
	
	var ExponentIcon = function ExponentIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.38,3L17.77,8.75C17.55,9.68 17.27,10.32 17,10.7C16.67,11.18 16.44,11.25 16.19,11.25V12.75C16.94,12.75 17.74,12.35 18.24,11.56C19.87,8.94 22,3 22,3H20.38L18.69,7.05L17,3H15.38M3.42,8.59L2,10L6.79,14.79L2,19.59L3.41,21L8.21,16.21L13,21L14.41,19.59L9.62,14.79L14.41,10L13,8.59L8.21,13.38L3.41,8.59H3.42Z' })
	  );
	};
	
	var ExportIcon = function ExportIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,12L19,8V11H10V13H19V16M1,18V6C1,4.89 1.9,4 3,4H15C16.1,4 17,4.9 17,6V9H15V6H3V18H15V15H17V18C17,19.1 16.1,20 15,20H3C1.9,20 1,19.1 1,18Z' })
	  );
	};
	
	var EyeOffOutlineIcon = function EyeOffOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9C13.66,9 15,10.34 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z' })
	  );
	};
	
	var EyeOffIcon = function EyeOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.83,9L15,12.16C15,12.11 15,12.05 15,12C15,10.34 13.66,9 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12C9,13.66 10.34,15 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17C9.24,17 7,14.76 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7C14.76,7 17,9.24 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z' })
	  );
	};
	
	var EyeOutlineIcon = function EyeOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,9C13.66,9 15,10.34 15,12C15,13.66 13.66,15 12,15C10.34,15 9,13.66 9,12C9,10.34 10.34,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z' })
	  );
	};
	
	var EyePlusOutlineIcon = function EyePlusOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C12.36,19.5 12.72,19.5 13.08,19.45C13.03,19.13 13,18.82 13,18.5C13,18.14 13.04,17.78 13.1,17.42C12.74,17.46 12.37,17.5 12,17.5C8.24,17.5 4.83,15.36 3.18,12C4.83,8.64 8.24,6.5 12,6.5C15.76,6.5 19.17,8.64 20.82,12C20.7,12.24 20.56,12.45 20.43,12.68C21.09,12.84 21.72,13.11 22.29,13.5C22.56,13 22.8,12.5 23,12C21.27,7.61 17,4.5 12,4.5M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M18,14.5V17.5H15V19.5H18V22.5H20V19.5H23V17.5H20V14.5H18Z' })
	  );
	};
	
	var EyePlusIcon = function EyePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C12.36,19.5 12.72,19.5 13.08,19.45C13.03,19.13 13,18.82 13,18.5C13,17.94 13.08,17.38 13.24,16.84C12.83,16.94 12.42,17 12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7C14.76,7 17,9.24 17,12C17,12.29 16.97,12.59 16.92,12.88C17.58,12.63 18.29,12.5 19,12.5C20.17,12.5 21.31,12.84 22.29,13.5C22.56,13 22.8,12.5 23,12C21.27,7.61 17,4.5 12,4.5M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M18,14.5V17.5H15V19.5H18V22.5H20V19.5H23V17.5H20V14.5H18Z' })
	  );
	};
	
	var EyeSettingsOutlineIcon = function EyeSettingsOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,9C13.66,9 15,10.34 15,12C15,13.66 13.66,15 12,15C10.34,15 9,13.66 9,12C9,10.34 10.34,9 12,9M12,4.5C16.86,4.5 21.22,7.5 23,12C20.61,18.08 13.75,21.06 7.67,18.67C4.62,17.47 2.2,15.06 1,12C2.78,7.5 7.14,4.5 12,4.5M3.18,12C5.56,16.87 11.45,18.89 16.32,16.5C18.28,15.54 19.86,13.96 20.82,12C18.44,7.13 12.55,5.11 7.68,7.5C5.72,8.46 4.14,10.04 3.18,12M9,22H7V24H9V22M13,22H11V24H13V22M17,22H15V24H17V22Z' })
	  );
	};
	
	var EyeSettingsIcon = function EyeSettingsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17M12,4.5C7.14,4.5 2.78,7.5 1,12C3.39,18.08 10.25,21.06 16.33,18.67C19.38,17.47 21.8,15.06 23,12C21.22,7.5 16.86,4.5 12,4.5M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22Z' })
	  );
	};
	
	var EyeIcon = function EyeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z' })
	  );
	};
	
	var EyedropperVariantIcon = function EyedropperVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.92,19L5,17.08L13.06,9L15,10.94M20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L13.84,6.41L11.91,4.5L10.5,5.91L11.92,7.33L3,16.25V21H7.75L16.67,12.08L18.09,13.5L19.5,12.09L17.58,10.17L20.7,7.05C21.1,6.65 21.1,6 20.71,5.63Z' })
	  );
	};
	
	var EyedropperIcon = function EyedropperIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.35,11.72L17.22,13.85L15.81,12.43L8.1,20.14L3.5,22L2,20.5L3.86,15.9L11.57,8.19L10.15,6.78L12.28,4.65L19.35,11.72M16.76,3C17.93,1.83 19.83,1.83 21,3C22.17,4.17 22.17,6.07 21,7.24L19.08,9.16L14.84,4.92L16.76,3M5.56,17.03L4.5,19.5L6.97,18.44L14.4,11L13,9.6L5.56,17.03Z' })
	  );
	};
	
	var FaceProfileIcon = function FaceProfileIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,8.39C13.57,9.4 15.42,10 17.42,10C18.2,10 18.95,9.91 19.67,9.74C19.88,10.45 20,11.21 20,12C20,16.41 16.41,20 12,20C9,20 6.39,18.34 5,15.89L6.75,14V13C6.75,12.31 7.31,11.75 8,11.75C8.69,11.75 9.25,12.31 9.25,13V14H12M16,11.75C15.31,11.75 14.75,12.31 14.75,13C14.75,13.69 15.31,14.25 16,14.25C16.69,14.25 17.25,13.69 17.25,13C17.25,12.31 16.69,11.75 16,11.75Z' })
	  );
	};
	
	var FaceIcon = function FaceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,11.75C8.31,11.75 7.75,12.31 7.75,13C7.75,13.69 8.31,14.25 9,14.25C9.69,14.25 10.25,13.69 10.25,13C10.25,12.31 9.69,11.75 9,11.75M15,11.75C14.31,11.75 13.75,12.31 13.75,13C13.75,13.69 14.31,14.25 15,14.25C15.69,14.25 16.25,13.69 16.25,13C16.25,12.31 15.69,11.75 15,11.75M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,20C7.59,20 4,16.41 4,12C4,11.71 4,11.42 4.05,11.14C6.41,10.09 8.28,8.16 9.26,5.77C11.07,8.33 14.05,10 17.42,10C18.2,10 18.95,9.91 19.67,9.74C19.88,10.45 20,11.21 20,12C20,16.41 16.41,20 12,20Z' })
	  );
	};
	
	var FacebookBoxIcon = function FacebookBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M18,5H15.5C13.57,5 12,6.57 12,8.5V11H10V14H12V21H15V14H18V11H15V9C15,8.45 15.45,8 16,8H18V5Z' })
	  );
	};
	
	var FacebookMessengerIcon = function FacebookMessengerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.5,2 2,6.14 2,11.25C2,14.13 3.42,16.7 5.65,18.4L5.71,22L9.16,20.12L9.13,20.11C10.04,20.36 11,20.5 12,20.5C17.5,20.5 22,16.36 22,11.25C22,6.14 17.5,2 12,2M13.03,14.41L10.54,11.78L5.5,14.41L10.88,8.78L13.46,11.25L18.31,8.78L13.03,14.41Z' })
	  );
	};
	
	var FacebookIcon = function FacebookIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6C10,3.79 11.79,2 14,2H17Z' })
	  );
	};
	
	var FactoryIcon = function FactoryIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,18V20H8V18H4M4,14V16H14V14H4M10,18V20H14V18H10M16,14V16H20V14H16M16,18V20H20V18H16M2,22V8L7,12V8L12,12V8L17,12L18,2H21L22,12V22H2Z' })
	  );
	};
	
	var FanOffIcon = function FanOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.5,2C9.64,2 8.57,4.55 9.29,7.47L15,13.16C15.87,13.37 16.81,13.81 17.28,14.73C18.46,17.1 22.03,17 22.03,12.5C22.03,8.92 18.05,8.13 14.35,10.13C14.03,9.73 13.61,9.42 13.13,9.22C13.32,8.29 13.76,7.24 14.75,6.75C17.11,5.57 17,2 12.5,2M3.28,4L2,5.27L4.47,7.73C3.22,7.74 2,8.87 2,11.5C2,15.07 5.96,15.85 9.65,13.87C9.97,14.27 10.4,14.59 10.89,14.79C10.69,15.71 10.25,16.75 9.27,17.24C6.91,18.42 7,22 11.5,22C13.8,22 14.94,20.36 14.94,18.21L18.73,22L20,20.72L3.28,4Z' })
	  );
	};
	
	var FanIcon = function FanIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,11C11.45,11 11,11.45 11,12C11,12.55 11.45,13 12,13C12.55,13 13,12.55 13,12C13,11.45 12.55,11 12,11M12.5,2C17,2 17.11,5.57 14.75,6.75C13.76,7.24 13.32,8.29 13.13,9.22C13.61,9.42 14.03,9.73 14.35,10.13C18.05,8.13 22.03,8.92 22.03,12.5C22.03,17 18.46,17.1 17.28,14.73C16.78,13.74 15.72,13.3 14.79,13.11C14.59,13.59 14.28,14 13.88,14.34C15.87,18.03 15.08,22 11.5,22C7,22 6.91,18.42 9.27,17.24C10.25,16.75 10.69,15.71 10.89,14.79C10.4,14.59 9.97,14.27 9.65,13.87C5.96,15.85 2,15.07 2,11.5C2,7 5.56,6.89 6.74,9.26C7.24,10.25 8.29,10.68 9.22,10.87C9.41,10.39 9.73,9.97 10.14,9.65C8.15,5.96 8.94,2 12.5,2Z' })
	  );
	};
	
	var FastForwardOutlineIcon = function FastForwardOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,9.9L18,12L15,14.1V9.9M6,9.9L9,12L6,14.1V9.9M13,6V18L21.5,12L13,6M4,6V18L12.5,12L4,6Z' })
	  );
	};
	
	var FastForwardIcon = function FastForwardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,6V18L21.5,12M4,18L12.5,12L4,6V18Z' })
	  );
	};
	
	var FaxIcon = function FaxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,6H16V8H11V6M8,9V3H19V9C20.66,9 22,10.34 22,12V18H19V21H8V18H7V9H8M10,5V9H17V5H10M10,15V19H17V15H10M19,11C18.45,11 18,11.45 18,12C18,12.55 18.45,13 19,13C19.55,13 20,12.55 20,12C20,11.45 19.55,11 19,11M4,9H5C5.55,9 6,9.45 6,10V17C6,17.55 5.55,18 5,18H4C2.9,18 2,17.1 2,16V11C2,9.9 2.9,9 4,9Z' })
	  );
	};
	
	var FeatherIcon = function FeatherIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,2C22,2 14.36,1.63 8.34,9.88C3.72,16.21 2,22 2,22L3.94,21C5.38,18.5 6.13,17.47 7.54,16C10.07,16.74 12.71,16.65 15,14C13,13.44 11.4,13.57 9.04,13.81C11.69,12 13.5,11.6 16,12L17,10C15.2,9.66 14,9.63 12.22,10.04C14.19,8.65 15.56,7.87 18,8L19.21,6.07C17.65,5.96 16.71,6.13 14.92,6.57C16.53,5.11 18,4.45 20.14,4.32C20.14,4.32 21.19,2.43 22,2Z' })
	  );
	};
	
	var FedoraIcon = function FedoraIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12V19.73C2,21 3,22 4.27,22H12C17.53,22 22,17.5 22,12C22,6.48 17.52,2 12,2M14.94,4.37C15.33,4.37 15.61,4.42 15.97,4.5C16.5,4.65 16.94,5.08 16.94,5.59C16.94,6.2 16.5,6.65 15.83,6.65C15.5,6.65 15.4,6.59 14.94,6.59C13.57,6.59 12.46,7.69 12.46,9.06V11.21C12.46,11.41 12.62,11.56 12.81,11.56H14.44C15.04,11.56 15.53,12.05 15.53,12.65C15.53,13.27 15.04,13.75 14.42,13.75H12.46V16.23C12.46,18.83 10.36,20.93 7.77,20.93C7.37,20.93 7.09,20.88 6.73,20.79C6.2,20.65 5.76,20.21 5.76,19.71C5.76,19.1 6.21,18.65 6.87,18.65C7.19,18.65 7.3,18.71 7.77,18.71C9.13,18.71 10.24,17.61 10.24,16.24V14.09C10.24,13.89 10.09,13.74 9.89,13.74H8.27C7.66,13.74 7.17,13.25 7.17,12.65C7.17,12.03 7.66,11.55 8.28,11.55H10.24V9.06C10.24,6.47 12.34,4.37 14.94,4.37V4.37Z' })
	  );
	};
	
	var FerryIcon = function FerryIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,6H18V9.96L12,8L6,9.96M3.94,19H4C5.6,19 7,18.12 8,17C9,18.12 10.4,19 12,19C13.6,19 15,18.12 16,17C17,18.12 18.4,19 20,19H20.05L21.95,12.31C22.03,12.06 22,11.78 21.89,11.54C21.76,11.3 21.55,11.12 21.29,11.04L20,10.62V6C20,4.89 19.1,4 18,4H15V1H9V4H6C4.9,4 4,4.9 4,6V10.62L2.71,11.04C2.45,11.12 2.24,11.3 2.11,11.54C2,11.78 1.97,12.06 2.05,12.31M20,21C18.61,21 17.22,20.53 16,19.67C13.56,21.38 10.44,21.38 8,19.67C6.78,20.53 5.39,21 4,21H2V23H4C5.37,23 6.74,22.65 8,22C10.5,23.3 13.5,23.3 16,22C17.26,22.65 18.62,23 20,23H22V21H20Z' })
	  );
	};
	
	var FileAccountIcon = function FileAccountIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M14,20V19C14,17.67 11.33,17 10,17C8.67,17 6,17.67 6,19V20H14M10,12C8.9,12 8,12.9 8,14C8,15.1 8.9,16 10,16C11.1,16 12,15.1 12,14C12,12.9 11.1,12 10,12Z' })
	  );
	};
	
	var FileChartIcon = function FileChartIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M7,20H9V14H7V20M11,20H13V12H11V20M15,20H17V16H15V20Z' })
	  );
	};
	
	var FileCheckIcon = function FileCheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M10.45,18.46L15.2,13.71L14.03,12.3L10.45,15.88L8.86,14.3L7.7,15.46L10.45,18.46Z' })
	  );
	};
	
	var FileCloudIcon = function FileCloudIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15.68,15C15.34,13.3 13.82,12 12,12C10.55,12 9.3,12.82 8.68,14C7.17,14.18 6,15.45 6,17C6,18.66 7.34,20 9,20H15.5C16.88,20 18,18.88 18,17.5C18,16.18 16.97,15.11 15.68,15Z' })
	  );
	};
	
	var FileCompareIcon = function FileCompareIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,18H6V16H10V18M10,14H6V12H10V14M10,1V2H6C4.89,2 4,2.89 4,4V20C4,21.1 4.9,22 6,22H10V23H12V1H10M20,8V20C20,21.11 19.11,22 18,22H14V20H18V11H14V9H18.5L14,4.5V2L20,8M16,14H14V12H16V14M16,18H14V16H16V18Z' })
	  );
	};
	
	var FileDelimitedIcon = function FileDelimitedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M14,15V11H10V15H12.3C12.6,17 12,18 9.7,19.38L10.85,20.2C13,19 14,16 14,15Z' })
	  );
	};
	
	var FileDocumentBoxIcon = function FileDocumentBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,17H7V15H14M17,13H7V11H17M17,9H7V7H17M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z' })
	  );
	};
	
	var FileDocumentIcon = function FileDocumentIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15,18V16H6V18H15M18,14V12H6V14H18Z' })
	  );
	};
	
	var FileDownloadOutlineIcon = function FileDownloadOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.11 19.11,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M11,4H6V20H11L18,20V11H11V4M12,19L15.89,15.11H13.56V12H10.45V15.11H8.11L12,19Z' })
	  );
	};
	
	var FileDownloadIcon = function FileDownloadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,2H6C4.89,2 4,2.89 4,4V20C4,21.11 4.89,22 6,22H18C19.11,22 20,21.11 20,20V8L14,2M12,19L8.11,15.11H10.44V12H13.56V15.11H15.89L12,19M13,9V3.5L18.5,9H13Z' })
	  );
	};
	
	var FileExcelBoxIcon = function FileExcelBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.2,17H14.2L12,13.2L9.8,17H7.8L11,12L7.8,7H9.8L12,10.8L14.2,7H16.2L13,12M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z' })
	  );
	};
	
	var FileExcelIcon = function FileExcelIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M13,3.5V9H18.5L13,3.5M17,11H13V13H14L12,14.67L10,13H11V11H7V13H8L11,15.5L8,18H7V20H11V18H10L12,16.33L14,18H13V20H17V18H16L13,15.5L16,13H17V11Z' })
	  );
	};
	
	var FileExportIcon = function FileExportIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2C4.89,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V8L14,2M13,3.5L18.5,9H13M8.93,12.22H16V19.29L13.88,17.17L11.05,20L8.22,17.17L11.05,14.35' })
	  );
	};
	
	var FileFindIcon = function FileFindIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,13C9,14.66 10.34,16 12,16C13.66,16 15,14.66 15,13C15,11.34 13.66,10 12,10C10.34,10 9,11.34 9,13M20,19.59V8L14,2H6C4.9,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C18.45,22 18.85,21.85 19.19,21.6L14.76,17.17C13.96,17.69 13,18 12,18C9.24,18 7,15.76 7,13C7,10.24 9.24,8 12,8C14.76,8 17,10.24 17,13C17,14 16.69,14.96 16.17,15.75L20,19.59Z' })
	  );
	};
	
	var FileHiddenIcon = function FileHiddenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H14V11H11V7H13V9M18.5,9L16.38,6.88L17.63,5.63L20,8V10H18V11H15V9H18.5M13,3.5V2H12V4H13V6H11V4H9V2H8V4H6V5H4V4C4,2.89 4.89,2 6,2H14L16.36,4.36L15.11,5.61L13,3.5M20,20C20,21.1 19.1,22 18,22H16V20H18V19H20V20M18,15H20V18H18V15M12,22V20H15V22H12M8,22V20H11V22H8M6,22C4.89,22 4,21.1 4,20V18H6V20H7V22H6M4,14H6V17H4V14M4,10H6V13H4V10M18,11H20V14H18V11M4,6H6V9H4V6Z' })
	  );
	};
	
	var FileImageIcon = function FileImageIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M6,20H15L18,20V12L14,16L12,14L6,20M8,9C6.9,9 6,9.9 6,11C6,12.1 6.9,13 8,13C9.1,13 10,12.1 10,11C10,9.9 9.1,9 8,9Z' })
	  );
	};
	
	var FileImportIcon = function FileImportIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2C4.89,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V8L14,2M13,3.5L18.5,9H13M10.05,11.22L12.88,14.05L15,11.93V19H7.93L10.05,16.88L7.22,14.05' })
	  );
	};
	
	var FileLockIcon = function FileLockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2C4.89,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V8L14,2H6M13,3.5L18.5,9H13V3.5M12,11C13.66,11 15,12.34 15,14V15H16V19H8V15H9V14C9,12.36 10.34,11 12,11M12,13C11.45,13 11,13.45 11,14V15H13V14C13,13.47 12.55,13 12,13Z' })
	  );
	};
	
	var FileMultipleIcon = function FileMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,7H20.5L15,1.5V7M8,0H16L22,6V18C22,19.1 21.1,20 20,20H8C6.89,20 6,19.1 6,18V2C6,0.9 6.9,0 8,0M4,4V22H20V24H4C2.9,24 2,23.1 2,22V4H4Z' })
	  );
	};
	
	var FileMusicIcon = function FileMusicIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M9,16C7.9,16 7,16.9 7,18C7,19.1 7.9,20 9,20C10.1,20 11,19.1 11,18V13H14V11H10V16.27C9.71,16.1 9.36,16 9,16Z' })
	  );
	};
	
	var FileOutlineIcon = function FileOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M11,4H6V20H11L18,20V11H11V4Z' })
	  );
	};
	
	var FilePdfBoxIcon = function FilePdfBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.43,10.94C11.2,11.68 10.87,12.47 10.42,13.34C10.22,13.72 10,14.08 9.92,14.38L10.03,14.34V14.34C11.3,13.85 12.5,13.57 13.37,13.41C13.22,13.31 13.08,13.2 12.96,13.09C12.36,12.58 11.84,11.84 11.43,10.94M17.91,14.75C17.74,14.94 17.44,15.05 17,15.05C16.24,15.05 15,14.82 14,14.31C12.28,14.5 11,14.73 9.97,15.06C9.92,15.08 9.86,15.1 9.79,15.13C8.55,17.25 7.63,18.2 6.82,18.2C6.66,18.2 6.5,18.16 6.38,18.09L5.9,17.78L5.87,17.73C5.8,17.55 5.78,17.38 5.82,17.19C5.93,16.66 6.5,15.82 7.7,15.07C7.89,14.93 8.19,14.77 8.59,14.58C8.89,14.06 9.21,13.45 9.55,12.78C10.06,11.75 10.38,10.73 10.63,9.85V9.84C10.26,8.63 10.04,7.9 10.41,6.57C10.5,6.19 10.83,5.8 11.2,5.8H11.44C11.67,5.8 11.89,5.88 12.05,6.04C12.71,6.7 12.4,8.31 12.07,9.64C12.05,9.7 12.04,9.75 12.03,9.78C12.43,10.91 13,11.82 13.63,12.34C13.89,12.54 14.18,12.74 14.5,12.92C14.95,12.87 15.38,12.85 15.79,12.85C17.03,12.85 17.78,13.07 18.07,13.54C18.17,13.7 18.22,13.89 18.19,14.09C18.18,14.34 18.09,14.57 17.91,14.75M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M17.5,14.04C17.4,13.94 17,13.69 15.6,13.69C15.53,13.69 15.46,13.69 15.37,13.79C16.1,14.11 16.81,14.3 17.27,14.3C17.34,14.3 17.4,14.29 17.46,14.28H17.5C17.55,14.26 17.58,14.25 17.59,14.15C17.57,14.12 17.55,14.08 17.5,14.04M8.33,15.5C8.12,15.62 7.95,15.73 7.85,15.81C7.14,16.46 6.69,17.12 6.64,17.5C7.09,17.35 7.68,16.69 8.33,15.5M11.35,8.59L11.4,8.55C11.47,8.23 11.5,7.95 11.56,7.73L11.59,7.57C11.69,7 11.67,6.71 11.5,6.47L11.35,6.42C11.33,6.45 11.3,6.5 11.28,6.54C11.11,6.96 11.12,7.69 11.35,8.59Z' })
	  );
	};
	
	var FilePdfIcon = function FilePdfIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,9H19.5L14,3.5V9M7,2H15L21,8V20C21,21.1 20.1,22 19,22H7C5.89,22 5,21.1 5,20V4C5,2.9 5.9,2 7,2M11.93,12.44C12.34,13.34 12.86,14.08 13.46,14.59L13.87,14.91C13,15.07 11.8,15.35 10.53,15.84V15.84L10.42,15.88L10.92,14.84C11.37,13.97 11.7,13.18 11.93,12.44M18.41,16.25C18.59,16.07 18.68,15.84 18.69,15.59C18.72,15.39 18.67,15.2 18.57,15.04C18.28,14.57 17.53,14.35 16.29,14.35L15,14.42L14.13,13.84C13.5,13.32 12.93,12.41 12.53,11.28L12.57,11.14C12.9,9.81 13.21,8.2 12.55,7.54C12.39,7.38 12.17,7.3 11.94,7.3H11.7C11.33,7.3 11,7.69 10.91,8.07C10.54,9.4 10.76,10.13 11.13,11.34V11.35C10.88,12.23 10.56,13.25 10.05,14.28L9.09,16.08L8.2,16.57C7,17.32 6.43,18.16 6.32,18.69C6.28,18.88 6.3,19.05 6.37,19.23L6.4,19.28L6.88,19.59L7.32,19.7C8.13,19.7 9.05,18.75 10.29,16.63L10.47,16.56C11.5,16.23 12.78,16 14.5,15.81C15.53,16.32 16.74,16.55 17.5,16.55C17.94,16.55 18.24,16.44 18.41,16.25M18,15.54L18.09,15.65C18.08,15.75 18.05,15.76 18,15.78H17.96L17.77,15.8C17.31,15.8 16.6,15.61 15.87,15.29C15.96,15.19 16,15.19 16.1,15.19C17.5,15.19 17.9,15.44 18,15.54M8.83,17C8.18,18.19 7.59,18.85 7.14,19C7.19,18.62 7.64,17.96 8.35,17.31L8.83,17M11.85,10.09C11.62,9.19 11.61,8.46 11.78,8.04L11.85,7.92L12,7.97C12.17,8.21 12.19,8.53 12.09,9.07L12.06,9.23L11.9,10.05L11.85,10.09Z' })
	  );
	};
	
	var FilePercentIcon = function FilePercentIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,2L20,8V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2H14M7.37,20L15,12.35L13.65,11L6,18.65L7.37,20M13,9H18.5L13,3.5V9M7.5,11C6.67,11 6,11.67 6,12.5C6,13.33 6.67,14 7.5,14C8.33,14 9,13.33 9,12.5C9,11.67 8.33,11 7.5,11M13.5,17C12.67,17 12,17.67 12,18.5C12,19.33 12.67,20 13.5,20C14.33,20 15,19.33 15,18.5C15,17.67 14.33,17 13.5,17Z' })
	  );
	};
	
	var FilePlusIcon = function FilePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M11,15V12H9V15H6V17H9V20H11V17H14V15H11Z' })
	  );
	};
	
	var FilePowerpointBoxIcon = function FilePowerpointBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.8,13.4H12.3C13.8,13.4 14.46,13.12 15.1,12.58C15.74,12.03 16,11.25 16,10.23C16,9.26 15.75,8.5 15.1,7.88C14.45,7.29 13.83,7 12.3,7H8V17H9.8V13.4M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.89 3.9,3 5,3H19M9.8,12V8.4H12.1C12.76,8.4 13.27,8.65 13.6,9C13.93,9.35 14.1,9.72 14.1,10.24C14.1,10.8 13.92,11.19 13.6,11.5C13.28,11.81 12.9,12 12.22,12H9.8Z' })
	  );
	};
	
	var FilePowerpointIcon = function FilePowerpointIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M13,3.5V9H18.5L13,3.5M8,11V13H9V19H8V20H12V19H11V17H13C14.66,17 16,15.66 16,14C16,12.34 14.66,11 13,11H8M13,13C13.55,13 14,13.45 14,14C14,14.55 13.55,15 13,15H11V13H13Z' })
	  );
	};
	
	var FilePresentationBoxIcon = function FilePresentationBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,16H5V8H19M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z' })
	  );
	};
	
	var FileQuestionIcon = function FileQuestionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2C4.89,2 4,2.89 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V8L14,2H6M13,3.5L18.5,9H13V3.5M12,11C13.66,11 15,12.34 15,14C15,15.88 12.75,16.06 12.75,17.75H11.25C11.25,15.31 13.5,15.5 13.5,14C13.5,13.17 12.83,12.5 12,12.5C11.17,12.5 10.5,13.17 10.5,14H9C9,12.34 10.34,11 12,11M11.25,18.5H12.75V20H11.25V18.5Z' })
	  );
	};
	
	var FileRestoreIcon = function FileRestoreIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,2H6C4.9,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V8L14,2M12,18C9.95,18 8.19,16.76 7.42,15H9.13C9.76,15.9 10.81,16.5 12,16.5C13.93,16.5 15.5,14.93 15.5,13C15.5,11.07 13.93,9.5 12,9.5C10.65,9.5 9.5,10.28 8.9,11.4L10.5,13H6.5V9L7.8,10.3C8.69,8.92 10.23,8 12,8C14.76,8 17,10.24 17,13C17,15.76 14.76,18 12,18Z' })
	  );
	};
	
	var FileSendIcon = function FileSendIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,2H6C4.89,2 4,2.89 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V8L14,2M12.54,19.37V17.37H8.54V15.38H12.54V13.38L15.54,16.38L12.54,19.37M13,9V3.5L18.5,9H13Z' })
	  );
	};
	
	var FileTreeIcon = function FileTreeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3H9V7H3V3M15,10H21V14H15V10M15,17H21V21H15V17M13,13H7V18H13V20H7L5,20V9H7V11H13V13Z' })
	  );
	};
	
	var FileUndoIcon = function FileUndoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M12.16,14.31C10.6,14.31 9.19,14.89 8.11,15.83L6,13.72V19H11.28L9.15,16.88C9.97,16.2 11,15.78 12.16,15.78C14.23,15.78 16,17.13 16.61,19L18,18.54C17.19,16.09 14.88,14.31 12.16,14.31Z' })
	  );
	};
	
	var FileVideoIcon = function FileVideoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M17,19V13L14,15.2V13H7V19H14V16.8L17,19Z' })
	  );
	};
	
	var FileWordBoxIcon = function FileWordBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.5,17H14L12,9.5L10,17H8.5L6.1,7H7.8L9.34,14.5L11.3,7H12.7L14.67,14.5L16.2,7H17.9M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z' })
	  );
	};
	
	var FileWordIcon = function FileWordIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M13,3.5V9H18.5L13,3.5M7,13L8.5,20H10.5L12,17L13.5,20H15.5L17,13H18V11H14V13H15L14.1,17.2L13,15V15H11V15L9.9,17.2L9,13H10V11H6V13H7Z' })
	  );
	};
	
	var FileXmlIcon = function FileXmlIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H18.5L13,3.5V9M6,2H14L20,8V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M6.12,15.5L9.86,19.24L11.28,17.83L8.95,15.5L11.28,13.17L9.86,11.76L6.12,15.5M17.28,15.5L13.54,11.76L12.12,13.17L14.45,15.5L12.12,17.83L13.54,19.24L17.28,15.5Z' })
	  );
	};
	
	var FileIcon = function FileIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9V3.5L18.5,9M6,2C4.89,2 4,2.89 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V8L14,2H6Z' })
	  );
	};
	
	var FilmIcon = function FilmIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.5,3H5V1.8C5,1.36 5.36,1 5.8,1H10.2C10.64,1 11,1.36 11,1.8V3H12.5C13.33,3 14,3.67 14,4.5V5H22V20H14V20.5C14,21.33 13.33,22 12.5,22H3.5C2.67,22 2,21.33 2,20.5V4.5C2,3.67 2.67,3 3.5,3M18,7V9H20V7H18M14,7V9H16V7H14M10,7V9H12V7H10M14,16V18H16V16H14M18,16V18H20V16H18M10,16V18H12V16H10Z' })
	  );
	};
	
	var FilmstripOffIcon = function FilmstripOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,4.27L2.28,3L21,21.72L19.73,23L16,19.27V21H8V19H6V21H4V7.27L1,4.27M18,9V7H16V9H18M18,13V11H16V13H18M18,15H16.82L6.82,5H8V3H16V5H18V3H20V18.18L18,16.18V15M8,13V11.27L7.73,11H6V13H8M8,17V15H6V17H8M6,3V4.18L4.82,3H6Z' })
	  );
	};
	
	var FilmstripIcon = function FilmstripIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,9H16V7H18M18,13H16V11H18M18,17H16V15H18M8,9H6V7H8M8,13H6V11H8M8,17H6V15H8M18,3V5H16V3H8V5H6V3H4V21H6V19H8V21H16V19H18V21H20V3H18Z' })
	  );
	};
	
	var FilterOutlineIcon = function FilterOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,19.88C15.04,20.18 14.94,20.5 14.71,20.71C14.32,21.1 13.69,21.1 13.3,20.71L9.29,16.7C9.06,16.47 8.96,16.16 9,15.87V10.75L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L15,10.75V19.88M7.04,5L11,10.06V15.58L13,17.58V10.05L16.96,5H7.04Z' })
	  );
	};
	
	var FilterRemoveOutlineIcon = function FilterRemoveOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.73,20.83L17.58,18L14.73,15.17L16.15,13.76L19,16.57L21.8,13.76L23.22,15.17L20.41,18L23.22,20.83L21.8,22.24L19,19.4L16.15,22.24L14.73,20.83M13,19.88C13.04,20.18 12.94,20.5 12.71,20.71C12.32,21.1 11.69,21.1 11.3,20.71L7.29,16.7C7.06,16.47 6.96,16.16 7,15.87V10.75L2.21,4.62C1.87,4.19 1.95,3.56 2.38,3.22C2.57,3.08 2.78,3 3,3V3H17V3C17.22,3 17.43,3.08 17.62,3.22C18.05,3.56 18.13,4.19 17.79,4.62L13,10.75V19.88M5.04,5L9,10.06V15.58L11,17.58V10.05L14.96,5H5.04Z' })
	  );
	};
	
	var FilterRemoveIcon = function FilterRemoveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.76,20.83L17.6,18L14.76,15.17L16.17,13.76L19,16.57L21.83,13.76L23.24,15.17L20.43,18L23.24,20.83L21.83,22.24L19,19.4L16.17,22.24L14.76,20.83M12,12V19.88C12.04,20.18 11.94,20.5 11.71,20.71C11.32,21.1 10.69,21.1 10.3,20.71L8.29,18.7C8.06,18.47 7.96,18.16 8,17.87V12H7.97L2.21,4.62C1.87,4.19 1.95,3.56 2.38,3.22C2.57,3.08 2.78,3 3,3V3H17V3C17.22,3 17.43,3.08 17.62,3.22C18.05,3.56 18.13,4.19 17.79,4.62L12.03,12H12Z' })
	  );
	};
	
	var FilterVariantIcon = function FilterVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,13H18V11H6M3,6V8H21V6M10,18H14V16H10V18Z' })
	  );
	};
	
	var FilterIcon = function FilterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,12V19.88C14.04,20.18 13.94,20.5 13.71,20.71C13.32,21.1 12.69,21.1 12.3,20.71L10.29,18.7C10.06,18.47 9.96,18.16 10,17.87V12H9.97L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L14.03,12H14Z' })
	  );
	};
	
	var FinanceIcon = function FinanceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,13H7V23H3V13M10,14H14V23H10V14M17,9H21V23H17V9M17,1H21V5H20V3.06L11.97,11.09L8,7.12L3.4,11.72L2.34,10.66L8,5L11.97,8.97L18.94,2H17V1Z' })
	  );
	};
	
	var FindReplaceIcon = function FindReplaceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,6C12.38,6 13.63,6.56 14.54,7.46L12,10H18V4L15.95,6.05C14.68,4.78 12.93,4 11,4C7.47,4 4.57,6.61 4.08,10H6.1C6.56,7.72 8.58,6 11,6M16.64,15.14C17.3,14.24 17.76,13.17 17.92,12H15.9C15.44,14.28 13.42,16 11,16C9.62,16 8.37,15.44 7.46,14.54L10,12H4V18L6.05,15.95C7.32,17.22 9.07,18 11,18C12.55,18 14,17.5 15.14,16.64L20,21.5L21.5,20L16.64,15.14Z' })
	  );
	};
	
	var FingerprintIcon = function FingerprintIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.81,4.47C17.73,4.47 17.65,4.45 17.58,4.41C15.66,3.42 14,3 12,3C10.03,3 8.15,3.47 6.44,4.41C6.2,4.54 5.9,4.45 5.76,4.21C5.63,3.97 5.72,3.66 5.96,3.53C7.82,2.5 9.86,2 12,2C14.14,2 16,2.47 18.04,3.5C18.29,3.65 18.38,3.95 18.25,4.19C18.16,4.37 18,4.47 17.81,4.47M3.5,9.72C3.4,9.72 3.3,9.69 3.21,9.63C3,9.47 2.93,9.16 3.09,8.93C4.08,7.53 5.34,6.43 6.84,5.66C10,4.04 14,4.03 17.15,5.65C18.65,6.42 19.91,7.5 20.9,8.9C21.06,9.12 21,9.44 20.78,9.6C20.55,9.76 20.24,9.71 20.08,9.5C19.18,8.22 18.04,7.23 16.69,6.54C13.82,5.07 10.15,5.07 7.29,6.55C5.93,7.25 4.79,8.25 3.89,9.5C3.81,9.65 3.66,9.72 3.5,9.72M9.75,21.79C9.62,21.79 9.5,21.74 9.4,21.64C8.53,20.77 8.06,20.21 7.39,19C6.7,17.77 6.34,16.27 6.34,14.66C6.34,11.69 8.88,9.27 12,9.27C15.12,9.27 17.66,11.69 17.66,14.66C17.66,14.94 17.44,15.16 17.16,15.16C16.88,15.16 16.66,14.94 16.66,14.66C16.66,12.24 14.57,10.27 12,10.27C9.43,10.27 7.34,12.24 7.34,14.66C7.34,16.1 7.66,17.43 8.27,18.5C8.91,19.66 9.35,20.15 10.12,20.93C10.31,21.13 10.31,21.44 10.12,21.64C10,21.74 9.88,21.79 9.75,21.79M16.92,19.94C15.73,19.94 14.68,19.64 13.82,19.05C12.33,18.04 11.44,16.4 11.44,14.66C11.44,14.38 11.66,14.16 11.94,14.16C12.22,14.16 12.44,14.38 12.44,14.66C12.44,16.07 13.16,17.4 14.38,18.22C15.09,18.7 15.92,18.93 16.92,18.93C17.16,18.93 17.56,18.9 17.96,18.83C18.23,18.78 18.5,18.96 18.54,19.24C18.59,19.5 18.41,19.77 18.13,19.82C17.56,19.93 17.06,19.94 16.92,19.94M14.91,22C14.87,22 14.82,22 14.78,22C13.19,21.54 12.15,20.95 11.06,19.88C9.66,18.5 8.89,16.64 8.89,14.66C8.89,13.04 10.27,11.72 11.97,11.72C13.67,11.72 15.05,13.04 15.05,14.66C15.05,15.73 16,16.6 17.13,16.6C18.28,16.6 19.21,15.73 19.21,14.66C19.21,10.89 15.96,7.83 11.96,7.83C9.12,7.83 6.5,9.41 5.35,11.86C4.96,12.67 4.76,13.62 4.76,14.66C4.76,15.44 4.83,16.67 5.43,18.27C5.53,18.53 5.4,18.82 5.14,18.91C4.88,19 4.59,18.87 4.5,18.62C4,17.31 3.77,16 3.77,14.66C3.77,13.46 4,12.37 4.45,11.42C5.78,8.63 8.73,6.82 11.96,6.82C16.5,6.82 20.21,10.33 20.21,14.65C20.21,16.27 18.83,17.59 17.13,17.59C15.43,17.59 14.05,16.27 14.05,14.65C14.05,13.58 13.12,12.71 11.97,12.71C10.82,12.71 9.89,13.58 9.89,14.65C9.89,16.36 10.55,17.96 11.76,19.16C12.71,20.1 13.62,20.62 15.03,21C15.3,21.08 15.45,21.36 15.38,21.62C15.33,21.85 15.12,22 14.91,22Z' })
	  );
	};
	
	var FireTruckIcon = function FireTruckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.04,2C16.85,2 16.66,2.04 16.5,2.14L5.59,8.5H9.55L17.5,3.86C18,3.58 18.13,2.97 17.85,2.5C17.68,2.2 17.38,2 17.04,2M16,8V10H3C1.9,10 1,10.9 1,12H2V15H1V19H3C3,20.66 4.34,22 6,22C7.66,22 9,20.66 9,19H15C15,20.66 16.34,22 18,22C19.66,22 21,20.66 21,19H23V12.5L19.5,8H16M18,9.5H19L21.5,12.5V13.5H18V9.5M4,12H7V15H4V12M9,12H12V15H9V12M14,12H16V15H14V12M6,17.5C6.83,17.5 7.5,18.17 7.5,19C7.5,19.83 6.83,20.5 6,20.5C5.17,20.5 4.5,19.83 4.5,19C4.5,18.17 5.17,17.5 6,17.5M18,17.5C18.83,17.5 19.5,18.17 19.5,19C19.5,19.83 18.83,20.5 18,20.5C17.17,20.5 16.5,19.83 16.5,19C16.5,18.17 17.17,17.5 18,17.5Z' })
	  );
	};
	
	var FireIcon = function FireIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.71,19C9.93,19 8.5,17.59 8.5,15.86C8.5,14.24 9.53,13.1 11.3,12.74C13.07,12.38 14.9,11.53 15.92,10.16C16.31,11.45 16.5,12.81 16.5,14.2C16.5,16.84 14.36,19 11.71,19M13.5,0.67C13.5,0.67 14.24,3.32 14.24,5.47C14.24,7.53 12.89,9.2 10.83,9.2C8.76,9.2 7.2,7.53 7.2,5.47L7.23,5.1C5.21,7.5 4,10.61 4,14C4,18.42 7.58,22 12,22C16.42,22 20,18.42 20,14C20,8.6 17.41,3.8 13.5,0.67Z' })
	  );
	};
	
	var FirebaseIcon = function FirebaseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,18.69L12.7,22.74C12.2,23 11.7,23 11.2,22.74L4,18.69L17.05,5.54L17.4,5.44C17.7,5.44 17.87,5.57 17.9,5.84L20,18.69M9.35,5.74L4.8,13.29L6.7,1.34C6.73,1.07 6.9,0.94 7.2,0.94C7.4,0.94 7.53,1 7.6,1.19L9.75,5.14L9.35,5.74M13.85,7L4.3,16.59L11.55,4.29C11.65,4.09 11.8,4 12,4C12.2,4 12.33,4.09 12.4,4.29L13.85,7Z' })
	  );
	};
	
	var FirefoxIcon = function FirefoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,11.7C21,11.3 20.9,10.7 20.8,10.3C20.5,8.6 19.6,7.1 18.5,5.9C18.3,5.6 17.9,5.3 17.5,5C16.4,4.1 15.1,3.5 13.6,3.2C10.6,2.7 7.6,3.7 5.6,5.8C5.6,5.8 5.6,5.7 5.6,5.7C5.5,5.5 5.5,5.5 5.4,5.5C5.4,5.5 5.4,5.5 5.4,5.5C5.3,5.3 5.3,5.2 5.2,5.1C5.2,5.1 5.2,5.1 5.2,5.1C5.2,4.9 5.1,4.7 5.1,4.5C4.8,4.6 4.8,4.9 4.7,5.1C4.7,5.1 4.7,5.1 4.7,5.1C4.5,5.3 4.3,5.6 4.3,5.9C4.3,5.9 4.3,5.9 4.3,5.9C4.2,6.1 4,7 4.2,7.1C4.2,7.1 4.2,7.1 4.3,7.1C4.3,7.2 4.3,7.3 4.3,7.4C4.1,7.6 4,7.7 4,7.8C3.7,8.4 3.4,8.9 3.3,9.5C3.3,9.7 3.3,9.8 3.3,9.9C3.3,9.9 3.3,9.9 3.3,9.9C3.3,9.9 3.3,9.8 3.3,9.8C3.1,10 3.1,10.3 3,10.5C3.1,10.5 3.1,10.4 3.2,10.4C2.7,13 3.4,15.7 5,17.7C7.4,20.6 11.5,21.8 15.1,20.5C18.6,19.2 21,15.8 21,12C21,11.9 21,11.8 21,11.7M13.5,4.1C15,4.4 16.4,5.1 17.5,6.1C17.6,6.2 17.7,6.4 17.7,6.4C17.4,6.1 16.7,5.6 16.3,5.8C16.4,6.1 17.6,7.6 17.7,7.7C17.7,7.7 18,9 18.1,9.1C18.1,9.1 18.1,9.1 18.1,9.1C18.1,9.1 18.1,9.1 18.1,9.1C18.1,9.3 17.4,11.9 17.4,12.3C17.4,12.4 16.5,14.2 16.6,14.2C16.3,14.9 16,14.9 15.9,15C15.8,15 15.2,15.2 14.5,15.4C13.9,15.5 13.2,15.7 12.7,15.6C12.4,15.6 12,15.6 11.7,15.4C11.6,15.3 10.8,14.9 10.6,14.8C10.3,14.7 10.1,14.5 9.9,14.3C10.2,14.3 10.8,14.3 11,14.3C11.6,14.2 14.2,13.3 14.1,12.9C14.1,12.6 13.6,12.4 13.4,12.2C13.1,12.1 11.9,12.3 11.4,12.5C11.4,12.5 9.5,12 9,11.6C9,11.5 8.9,10.9 8.9,10.8C8.8,10.7 9.2,10.4 9.2,10.4C9.2,10.4 10.2,9.4 10.2,9.3C10.4,9.3 10.6,9.1 10.7,9C10.6,9 10.8,8.9 11.1,8.7C11.1,8.7 11.1,8.7 11.1,8.7C11.4,8.5 11.6,8.5 11.6,8.2C11.6,8.2 12.1,7.3 11.5,7.4C11.5,7.4 10.6,7.3 10.3,7.3C10,7.5 9.9,7.4 9.6,7.3C9.6,7.3 9.4,7.1 9.4,7C9.5,6.8 10.2,5.3 10.5,5.2C10.3,4.8 9.3,5.1 9.1,5.4C9.1,5.4 8.3,6 7.9,6.1C7.9,6.1 7.9,6.1 7.9,6.1C7.9,6 7.4,5.9 6.9,5.9C8.7,4.4 11.1,3.7 13.5,4.1Z' })
	  );
	};
	
	var FishIcon = function FishIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20L12.76,17C9.5,16.79 6.59,15.4 5.75,13.58C5.66,14.06 5.53,14.5 5.33,14.83C4.67,16 3.33,16 2,16C3.1,16 3.5,14.43 3.5,12.5C3.5,10.57 3.1,9 2,9C3.33,9 4.67,9 5.33,10.17C5.53,10.5 5.66,10.94 5.75,11.42C6.4,10 8.32,8.85 10.66,8.32L9,5C11,5 13,5 14.33,5.67C15.46,6.23 16.11,7.27 16.69,8.38C19.61,9.08 22,10.66 22,12.5C22,14.38 19.5,16 16.5,16.66C15.67,17.76 14.86,18.78 14.17,19.33C13.33,20 12.67,20 12,20M17,11C16.45,11 16,11.45 16,12C16,12.55 16.45,13 17,13C17.55,13 18,12.55 18,12C18,11.45 17.55,11 17,11Z' })
	  );
	};
	
	var FlagCheckeredIcon = function FlagCheckeredIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.4,6H20V16H13L12.6,14H7V21H5V4H14L14.4,6M14,14H16V12H18V10H16V8H14V10L13,8V6H11V8H9V6H7V8H9V10H7V12H9V10H11V12H13V10L14,12V14M11,10V8H13V10H11M14,10H16V12H14V10Z' })
	  );
	};
	
	var FlagOutlineIcon = function FlagOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.5,6H20V16H13L12.5,14H7V21H5V4H14L14.5,6M7,6V12H13L13.5,14H18V8H14L13.5,6H7Z' })
	  );
	};
	
	var FlagTriangleIcon = function FlagTriangleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,2H9V22H7V2M19,9L11,14.6V3.4L19,9Z' })
	  );
	};
	
	var FlagVariantOutlineIcon = function FlagVariantOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,3C6.55,3 7,3.45 7,4V4.88C8.06,4.44 9.5,4 11,4C14,4 14,6 16,6C19,6 20,4 20,4V12C20,12 19,14 16,14C13,14 13,12 11,12C8,12 7,14 7,14V21H5V4C5,3.45 5.45,3 6,3M7,7.25V11.5C7,11.5 9,10 11,10C13,10 14,12 16,12C18,12 18,11 18,11V7.5C18,7.5 17,8 16,8C14,8 13,6 11,6C9,6 7,7.25 7,7.25Z' })
	  );
	};
	
	var FlagVariantIcon = function FlagVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,3C6.55,3 7,3.45 7,4V4.88C8.06,4.44 9.5,4 11,4C14,4 14,6 16,6C19,6 20,4 20,4V12C20,12 19,14 16,14C13,14 13,12 11,12C8,12 7,14 7,14V21H5V4C5,3.45 5.45,3 6,3Z' })
	  );
	};
	
	var FlagIcon = function FlagIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.4,6L14,4H5V21H7V14H12.6L13,16H20V6H14.4Z' })
	  );
	};
	
	var FlashAutoIcon = function FlashAutoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.85,7.65L18,4L19.15,7.65M19,2H17L13.8,11H15.7L16.4,9H19.6L20.3,11H22.2M3,2V14H6V23L13,11H9L13,2H3Z' })
	  );
	};
	
	var FlashCircleIcon = function FlashCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.5,20L16.36,10.27H13V4L8,13.73H11.5V20M12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12C22,14.75 21,17.1 19.05,19.05C17.1,21 14.75,22 12,22C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,9.25 3,6.9 4.95,4.95C6.9,3 9.25,2 12,2Z' })
	  );
	};
	
	var FlashOffIcon = function FlashOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,10H13L17,2H7V4.18L15.46,12.64M3.27,3L2,4.27L7,9.27V13H10V22L13.58,15.86L17.73,20L19,18.73L3.27,3Z' })
	  );
	};
	
	var FlashOutlineIcon = function FlashOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,2H17L13.5,9H17L10,22V14H7V2M9,4V12H12V14.66L14,11H10.24L13.76,4H9Z' })
	  );
	};
	
	var FlashRedEyeIcon = function FlashRedEyeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,5C15.44,5 15,5.44 15,6C15,6.56 15.44,7 16,7C16.56,7 17,6.56 17,6C17,5.44 16.56,5 16,5M16,2C13.27,2 10.94,3.66 10,6C10.94,8.34 13.27,10 16,10C18.73,10 21.06,8.34 22,6C21.06,3.66 18.73,2 16,2M16,3.5C17.38,3.5 18.5,4.62 18.5,6C18.5,7.38 17.38,8.5 16,8.5C14.62,8.5 13.5,7.38 13.5,6C13.5,4.62 14.62,3.5 16,3.5M3,2V14H6V23L13,11H9L10.12,8.5C9.44,7.76 8.88,6.93 8.5,6C9.19,4.29 10.5,2.88 12.11,2H3Z' })
	  );
	};
	
	var FlashIcon = function FlashIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,2V13H10V22L17,10H13L17,2H7Z' })
	  );
	};
	
	var FlashlightOffIcon = function FlashlightOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L15,18.27V22H9V12.27L2,5.27M18,5L15,10H11.82L6.82,5H18M18,4H6V2H18V4M15,11V13.18L12.82,11H15Z' })
	  );
	};
	
	var FlashlightIcon = function FlashlightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,10L6,5H18L15,10H9M18,4H6V2H18V4M9,22V11H15V22H9M12,13C11.45,13 11,13.45 11,14C11,14.55 11.45,15 12,15C12.55,15 13,14.55 13,14C13,13.45 12.55,13 12,13Z' })
	  );
	};
	
	var FlaskEmptyOutlineIcon = function FlaskEmptyOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,19C5,19.55 5.45,20 6,20H18C18.55,20 19,19.55 19,19C19,18.79 18.93,18.59 18.82,18.43L13,8.35V4H11V8.35L5.18,18.43C5.07,18.59 5,18.79 5,19M6,22C4.34,22 3,20.66 3,19C3,18.4 3.18,17.84 3.5,17.37L9,7.81V6C8.45,6 8,5.55 8,5V4C8,2.9 8.9,2 10,2H14C15.1,2 16,2.9 16,4V5C16,5.55 15.55,6 15,6V7.81L20.5,17.37C20.82,17.84 21,18.4 21,19C21,20.66 19.66,22 18,22H6Z' })
	  );
	};
	
	var FlaskEmptyIcon = function FlaskEmptyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,22C4.34,22 3,20.66 3,19C3,18.4 3.18,17.84 3.5,17.37L9,7.81V6C8.45,6 8,5.55 8,5V4C8,2.9 8.9,2 10,2H14C15.1,2 16,2.9 16,4V5C16,5.55 15.55,6 15,6V7.81L20.5,17.37C20.82,17.84 21,18.4 21,19C21,20.66 19.66,22 18,22H6Z' })
	  );
	};
	
	var FlaskOutlineIcon = function FlaskOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,19C5,19.55 5.45,20 6,20H18C18.55,20 19,19.55 19,19C19,18.79 18.93,18.59 18.82,18.43L13,8.35V4H11V8.35L5.18,18.43C5.07,18.59 5,18.79 5,19M6,22C4.34,22 3,20.66 3,19C3,18.4 3.18,17.84 3.5,17.37L9,7.81V6C8.45,6 8,5.55 8,5V4C8,2.9 8.9,2 10,2H14C15.1,2 16,2.9 16,4V5C16,5.55 15.55,6 15,6V7.81L20.5,17.37C20.82,17.84 21,18.4 21,19C21,20.66 19.66,22 18,22H6M13,16L14.34,14.66L16.27,18H7.73L10.39,13.39L13,16M12.5,12C12.78,12 13,12.22 13,12.5C13,12.78 12.78,13 12.5,13C12.22,13 12,12.78 12,12.5C12,12.22 12.22,12 12.5,12Z' })
	  );
	};
	
	var FlaskIcon = function FlaskIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,22C4.34,22 3,20.66 3,19C3,18.4 3.18,17.84 3.5,17.37L9,7.81V6C8.45,6 8,5.55 8,5V4C8,2.9 8.9,2 10,2H14C15.1,2 16,2.9 16,4V5C16,5.55 15.55,6 15,6V7.81L20.5,17.37C20.82,17.84 21,18.4 21,19C21,20.66 19.66,22 18,22H6M5,19C5,19.55 5.45,20 6,20H18C18.55,20 19,19.55 19,19C19,18.79 18.93,18.59 18.82,18.43L16.53,14.47L14,17L8.93,11.93L5.18,18.43C5.07,18.59 5,18.79 5,19M13,10C12.45,10 12,10.45 12,11C12,11.55 12.45,12 13,12C13.55,12 14,11.55 14,11C14,10.45 13.55,10 13,10Z' })
	  );
	};
	
	var FlattrIcon = function FlattrIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,12C21,16.97 16.97,21 12,21H4.5L9.74,15.76L11.16,17.17L9.33,19H12C15.87,19 19,15.87 19,12V7L21,5V12M3,12C3,7.03 7.03,3 12,3H19.5L14.26,8.24L12.84,6.83L14.67,5H12C8.13,5 5,8.13 5,12V17L3,19V12Z' })
	  );
	};
	
	var FlipToBackIcon = function FlipToBackIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,17H17V15H15M15,5H17V3H15M5,7H3V19C3,20.1 3.9,21 5,21H17V19H5M19,17C20.1,17 21,16.1 21,15H19M19,9H21V7H19M19,13H21V11H19M9,17V15H7C7,16.1 7.9,17 9,17M13,3H11V5H13M19,3V5H21C21,3.89 20.1,3 19,3M13,15H11V17H13M9,3C7.89,3 7,3.89 7,5H9M9,11H7V13H9M9,7H7V9H9V7Z' })
	  );
	};
	
	var FlipToFrontIcon = function FlipToFrontIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,21H9V19H7M11,21H13V19H11M19,15H9V5H19M19,3H9C7.89,3 7,3.89 7,5V15C7,16.1 7.9,17 9,17H14L18,17H19C20.1,17 21,16.1 21,15V5C21,3.89 20.1,3 19,3M15,21H17V19H15M3,9H5V7H3M5,21V19H3C3,20.1 3.9,21 5,21M3,17H5V15H3M3,13H5V11H3V13Z' })
	  );
	};
	
	var FloorLampIcon = function FloorLampIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,2L17,9H7L9,2M11,10H13V20H16V22H8V20H11V10Z' })
	  );
	};
	
	var FloorPlanIcon = function FloorPlanIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,5V10H9V5H5V13H9V12H10V17H9V14H5V19H12V17H13V19H19V17H21V21H3V3H21V15H19V10H13V15H12V9H19V5H10Z' })
	  );
	};
	
	var FloppyIcon = function FloppyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.5,22L2,19.5V4C2,2.9 2.9,2 4,2H20C21.1,2 22,2.9 22,4V20C22,21.1 21.1,22 20,22H17V15C17,14.45 16.55,14 16,14H7C6.45,14 6,14.45 6,15V22H4.5M5,4V10C5,10.55 5.45,11 6,11H18C18.55,11 19,10.55 19,10V4H5M8,16H11V20H8V16M20,4V5H21V4H20Z' })
	  );
	};
	
	var FlowerIcon = function FlowerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,13C3,17.97 7.03,22 12,22C12,17 7.97,13 3,13M12,5.5C13.38,5.5 14.5,6.62 14.5,8C14.5,9.38 13.38,10.5 12,10.5C10.62,10.5 9.5,9.38 9.5,8C9.5,6.62 10.62,5.5 12,5.5M5.6,10.25C5.6,11.63 6.72,12.75 8.1,12.75C8.63,12.75 9.12,12.58 9.5,12.31C9.5,12.37 9.5,12.43 9.5,12.5C9.5,13.88 10.62,15 12,15C13.38,15 14.5,13.88 14.5,12.5C14.5,12.43 14.5,12.37 14.5,12.31C14.88,12.58 15.37,12.75 15.9,12.75C17.28,12.75 18.4,11.63 18.4,10.25C18.4,9.25 17.81,8.4 16.97,8C17.81,7.6 18.4,6.74 18.4,5.75C18.4,4.37 17.28,3.25 15.9,3.25C15.37,3.25 14.88,3.41 14.5,3.69C14.5,3.63 14.5,3.56 14.5,3.5C14.5,2.12 13.38,1 12,1C10.62,1 9.5,2.12 9.5,3.5C9.5,3.56 9.5,3.63 9.5,3.69C9.12,3.41 8.63,3.25 8.1,3.25C6.72,3.25 5.6,4.37 5.6,5.75C5.6,6.74 6.19,7.6 7.03,8C6.19,8.4 5.6,9.25 5.6,10.25M12,22C16.97,22 21,17.97 21,13C16,13 12,17 12,22Z' })
	  );
	};
	
	var FolderAccountIcon = function FolderAccountIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,17H11V16C11,14.67 13.67,14 15,14C16.33,14 19,14.67 19,16M15,9C16.1,9 17,9.9 17,11C17,12.1 16.1,13 15,13C13.9,13 13,12.1 13,11C13,9.89 13.9,9 15,9M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.89 21.1,6 20,6Z' })
	  );
	};
	
	var FolderDownloadIcon = function FolderDownloadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,6C21.1,6 22,6.9 22,8V18C22,19.1 21.1,20 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10L12,6H20M19.25,13H16V9H14V13H10.75L15,17.25' })
	  );
	};
	
	var FolderEditIcon = function FolderEditIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4C1.89,4 1,4.89 1,6V18C1,19.1 1.9,20 3,20H11V18.11L21,8.11V8C21,6.89 20.1,6 19,6H11L9,4H3M21.04,11.13C20.9,11.13 20.76,11.19 20.65,11.3L19.65,12.3L21.7,14.35L22.7,13.35C22.92,13.14 22.92,12.79 22.7,12.58L21.42,11.3C21.31,11.19 21.18,11.13 21.04,11.13M19.07,12.88L13,18.94V21H15.06L21.12,14.93L19.07,12.88Z' })
	  );
	};
	
	var FolderGoogleDriveIcon = function FolderGoogleDriveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.75,9H16.14L19,14H16.05L13.5,9.46M18.3,17H12.75L14.15,14.5H19.27L19.53,14.96M11.5,17L10.4,14.86L13.24,9.9L14.74,12.56L12.25,17M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.89 21.1,6 20,6Z' })
	  );
	};
	
	var FolderImageIcon = function FolderImageIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,17L9.5,11L13,15.5L15.5,12.5L19,17M20,6H12L10,4H4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.9 21.1,6 20,6Z' })
	  );
	};
	
	var FolderKeyNetworkIcon = function FolderKeyNetworkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,4C4.89,4 4,4.89 4,6V14C4,15.1 4.9,16 6,16H11V18H10C9.45,18 9,18.45 9,19H2V21H9C9,21.55 9.45,22 10,22H14C14.55,22 15,21.55 15,21H22V19H15C15,18.45 14.55,18 14,18H13V16H18C19.1,16 20,15.1 20,14V8C20,6.9 19.1,6 18,6H12L10,4H6M9,8C10.31,8 11.42,8.83 11.83,10H17V12H16V14H14V12H11.83C11.42,13.17 10.31,14 9,14C7.34,14 6,12.66 6,11C6,9.34 7.34,8 9,8M9,10C8.45,10 8,10.45 8,11C8,11.56 8.45,12 9,12C9.55,12 10,11.55 10,11C10,10.45 9.55,10 9,10Z' })
	  );
	};
	
	var FolderKeyIcon = function FolderKeyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.9 21.1,6 20,6H12L10,4M11,10C12.31,10 13.42,10.84 13.83,12H19V14H18V16H16V14H13.83C13.42,15.17 12.31,16 11,16C9.34,16 8,14.66 8,13C8,11.34 9.34,10 11,10M11,12C10.45,12 10,12.45 10,13C10,13.56 10.45,14 11,14C11.55,14 12,13.55 12,13C12,12.45 11.55,12 11,12Z' })
	  );
	};
	
	var FolderLockOpenIcon = function FolderLockOpenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,6C21.1,6 22,6.9 22,8V18C22,19.1 21.1,20 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10L12,6H20M19,17V13H18L16,13H14V11C14,10.45 14.45,10 15,10C15.55,10 16,10.45 16,11H18C18,9.34 16.66,8 15,8C13.34,8 12,9.34 12,11V13H11V17H19Z' })
	  );
	};
	
	var FolderLockIcon = function FolderLockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,6C21.1,6 22,6.9 22,8V18C22,19.1 21.1,20 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10L12,6H20M19,17V13H18V12C18,10.34 16.66,9 15,9C13.34,9 12,10.34 12,12V13H11V17H19M15,11C15.55,11 16,11.45 16,12V13H14V12C14,11.45 14.45,11 15,11Z' })
	  );
	};
	
	var FolderMoveIcon = function FolderMoveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,18V15H10V11H14V8L19,13M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.89 21.1,6 20,6Z' })
	  );
	};
	
	var FolderMultipleImageIcon = function FolderMultipleImageIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,15L11.5,9L15,13.5L17.5,10.5L21,15M22,4H14L12,2H6C4.9,2 4,2.9 4,4V16C4,17.1 4.9,18 6,18H22C23.1,18 24,17.1 24,16V6C24,4.9 23.1,4 22,4M2,6H0V11H0V20C0,21.1 0.9,22 2,22H20V20H2V6Z' })
	  );
	};
	
	var FolderMultipleOutlineIcon = function FolderMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,4C23.1,4 24,4.9 24,6V16C24,17.1 23.1,18 22,18H6C4.9,18 4,17.1 4,16V4C4,2.9 4.9,2 6,2H12L14,4H22M2,6V20H20V22H2C0.9,22 0,21.1 0,20V11H0V6H2M6,6V16H22V6H6Z' })
	  );
	};
	
	var FolderMultipleIcon = function FolderMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,4H14L12,2H6C4.9,2 4,2.9 4,4V16C4,17.1 4.9,18 6,18H22C23.1,18 24,17.1 24,16V6C24,4.9 23.1,4 22,4M2,6H0V11H0V20C0,21.1 0.9,22 2,22H20V20H2V6Z' })
	  );
	};
	
	var FolderNetworkIcon = function FolderNetworkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,14V4C3,2.9 3.9,2 5,2H11L13,4H19C20.1,4 21,4.9 21,6V14C21,15.1 20.1,16 19,16H13V18H14C14.55,18 15,18.45 15,19H22V21H15C15,21.55 14.55,22 14,22H10C9.45,22 9,21.55 9,21H2V19H9C9,18.45 9.45,18 10,18H11V16H5C3.9,16 3,15.1 3,14Z' })
	  );
	};
	
	var FolderOpenIcon = function FolderOpenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10L12,6H19C20.1,6 21,6.9 21,8H21L4,8V18L6.14,10H23.21L20.93,18.5C20.7,19.37 19.92,20 19,20Z' })
	  );
	};
	
	var FolderOutlineIcon = function FolderOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,18H4V8H20M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.89 21.1,6 20,6Z' })
	  );
	};
	
	var FolderPlusIcon = function FolderPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,4L12,6H20C21.1,6 22,6.9 22,8V18C22,19.1 21.1,20 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10M15,9V12H12V14H15V17H17V14H20V12H17V9H15Z' })
	  );
	};
	
	var FolderRemoveIcon = function FolderRemoveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,4L12,6H20C21.1,6 22,6.9 22,8V18C22,19.1 21.1,20 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4H10M12.46,10.88L14.59,13L12.46,15.12L13.88,16.54L16,14.41L18.12,16.54L19.54,15.12L17.41,13L19.54,10.88L18.12,9.46L16,11.59L13.88,9.46L12.46,10.88Z' })
	  );
	};
	
	var FolderSearchOutlineIcon = function FolderSearchOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.5,12C19,12 21,14 21,16.5C21,17.38 20.75,18.21 20.31,18.9L23.39,22L22,23.39L18.88,20.32C18.19,20.75 17.37,21 16.5,21C14,21 12,19 12,16.5C12,14 14,12 16.5,12M16.5,14C15.12,14 14,15.12 14,16.5C14,17.88 15.12,19 16.5,19C17.88,19 19,17.88 19,16.5C19,15.12 17.88,14 16.5,14M19,8H3V18H10.17C10.34,18.72 10.63,19.39 11,20H3C1.89,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4H9L11,6H19C20.1,6 21,6.9 21,8V11.81C20.42,11.26 19.75,10.81 19,10.5V8Z' })
	  );
	};
	
	var FolderSearchIcon = function FolderSearchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.5,12C19,12 21,14 21,16.5C21,17.38 20.75,18.21 20.31,18.9L23.39,22L22,23.39L18.88,20.32C18.19,20.75 17.37,21 16.5,21C14,21 12,19 12,16.5C12,14 14,12 16.5,12M16.5,14C15.12,14 14,15.12 14,16.5C14,17.88 15.12,19 16.5,19C17.88,19 19,17.88 19,16.5C19,15.12 17.88,14 16.5,14M9,4L11,6H19C20.1,6 21,6.9 21,8V11.81C19.83,10.69 18.25,10 16.5,10C12.91,10 10,12.91 10,16.5C10,17.79 10.37,19 11,20H3C1.89,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4H9Z' })
	  );
	};
	
	var FolderStarIcon = function FolderStarIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,6H12L10,4H4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.9 21.1,6 20,6M17.94,17L15,15.28L12.06,17L12.84,13.67L10.25,11.43L13.66,11.14L15,8L16.34,11.14L19.75,11.43L17.16,13.67L17.94,17Z' })
	  );
	};
	
	var FolderUploadIcon = function FolderUploadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,6C21.1,6 22,6.9 22,8V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4H10L12,6H20M10.75,13H14V17H16V13H19.25L15,8.75' })
	  );
	};
	
	var FolderIcon = function FolderIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z' })
	  );
	};
	
	var FontAwesomeIcon = function FontAwesomeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,3C7.38,3 8.5,4.12 8.5,5.5C8.5,6.53 7.88,7.41 7,7.79V8.66C8.11,8.36 9.72,8 11,8C12.15,8 12.89,8.22 13.54,8.42C14.13,8.6 14.65,8.75 15.5,8.75C17.13,8.75 18.4,8.18 18.54,8.11C18.68,8.04 18.84,8 19,8C19.55,8 20,8.45 20,9V17C20,17.38 19.79,17.72 19.45,17.89C19.38,17.93 17.71,18.75 15.5,18.75C14.39,18.75 13.45,18.55 12.54,18.35C11.69,18.17 10.89,18 10,18C8.85,18 7.67,18.39 7,18.66V22H5V7.79C4.12,7.41 3.5,6.53 3.5,5.5C3.5,4.12 4.62,3 6,3Z' })
	  );
	};
	
	var FoodAppleIcon = function FoodAppleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,10C22,13 17,22 15,22C13,22 13,21 12,21C11,21 11,22 9,22C7,22 2,13 4,10C6,7 9,7 11,8V5C5.38,8.07 4.11,3.78 4.11,3.78C4.11,3.78 6.77,0.19 11,5V3H13V8C15,7 18,7 20,10Z' })
	  );
	};
	
	var FoodCroissantIcon = function FoodCroissantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,19L19,17L22,15V19M15,15L19,9L22,13L18,16L15,15M5,17L2,19V15L5,17M9,15L6,16L2,13L5,9L9,15M14,6L18,8L13,15H11L6,8L10,6H14Z' })
	  );
	};
	
	var FoodForkDrinkIcon = function FoodForkDrinkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3C2.45,3 2,3.45 2,4V8L2,9.5C2,11.19 3.03,12.63 4.5,13.22V19.5C4.5,20.33 5.17,21 6,21C6.83,21 7.5,20.33 7.5,19.5V13.22C8.97,12.63 10,11.19 10,9.5V8L10,4C10,3.45 9.55,3 9,3C8.45,3 8,3.45 8,4V8C8,8.28 7.78,8.5 7.5,8.5C7.22,8.5 7,8.28 7,8V4C7,3.45 6.55,3 6,3C5.45,3 5,3.45 5,4V8C5,8.28 4.78,8.5 4.5,8.5C4.22,8.5 4,8.28 4,8V4C4,3.45 3.55,3 3,3M19.88,3C19.75,3 19.62,3.09 19.5,3.16L16,5.25V9H12V11H13L14,21H20L21,11H22V9H18V6.34L20.5,4.84C21,4.56 21.13,4 20.84,3.5C20.63,3.14 20.26,2.95 19.88,3Z' })
	  );
	};
	
	var FoodOffIcon = function FoodOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L21,21.72L19.73,23L17.73,21H15.5L15.21,18.5L12.97,16.24C12.86,16.68 12.47,17 12,17H3C2.45,17 2,16.55 2,16C2,15.45 2.45,15 3,15H8L9.5,16.5L11,15H11.73L10.73,14H2C2,12.34 3.34,11 5,11H7.73L2,5.27M14,8H16.23L15.1,3.46L16.84,3L18.09,8H22L20.74,18.92L14.54,12.72L14,8M13,18C13,19.66 11.66,21 10,21H5C3.34,21 2,19.66 2,18H13Z' })
	  );
	};
	
	var FoodVariantIcon = function FoodVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,18C22,20.21 20.21,22 18,22H15C12.79,22 11,20.21 11,18V16H17.79L20.55,11.23L22.11,12.13L19.87,16H22V18M9,22H2C2,19 2,16 2.33,12.83C2.6,10.3 3.08,7.66 3.6,5H3V3H4L7,3H8V5H7.4C7.92,7.66 8.4,10.3 8.67,12.83C9,16 9,19 9,22Z' })
	  );
	};
	
	var FoodIcon = function FoodIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.5,21L14,8H16.23L15.1,3.46L16.84,3L18.09,8H22L20.5,21H15.5M5,11H10C11.66,11 13,12.34 13,14H2C2,12.34 3.34,11 5,11M13,18C13,19.66 11.66,21 10,21H5C3.34,21 2,19.66 2,18H13M3,15H8L9.5,16.5L11,15H12C12.55,15 13,15.45 13,16C13,16.55 12.55,17 12,17H3C2.45,17 2,16.55 2,16C2,15.45 2.45,15 3,15Z' })
	  );
	};
	
	var FootballAustralianIcon = function FootballAustralianIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.5,7.5C9.17,5.87 11.29,4.69 13.37,4.18C18,3 21,6 19.82,10.63C19.31,12.71 18.13,14.83 16.5,16.5C14.83,18.13 12.71,19.31 10.63,19.82C6,21 3,18 4.18,13.37C4.69,11.29 5.87,9.17 7.5,7.5M10.62,11.26L10.26,11.62L12.38,13.74L12.74,13.38L10.62,11.26M11.62,10.26L11.26,10.62L13.38,12.74L13.74,12.38L11.62,10.26M9.62,12.26L9.26,12.62L11.38,14.74L11.74,14.38L9.62,12.26M12.63,9.28L12.28,9.63L14.4,11.75L14.75,11.4L12.63,9.28M8.63,13.28L8.28,13.63L10.4,15.75L10.75,15.4L8.63,13.28M13.63,8.28L13.28,8.63L15.4,10.75L15.75,10.4L13.63,8.28Z' })
	  );
	};
	
	var FootballHelmetIcon = function FootballHelmetIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.5,12C12.67,12 12,12.67 12,13.5C12,14.33 12.67,15 13.5,15C14.33,15 15,14.33 15,13.5C15,12.67 14.33,12 13.5,12M13.5,3C18.19,3 22,6.58 22,11C22,12.62 22,14 21.09,16C17,16 16,20 12.5,20C10.32,20 9.27,18.28 9.05,16H9L8.24,16L6.96,20.3C6.81,20.79 6.33,21.08 5.84,21H3C2.45,21 2,20.55 2,20C2,19.45 2.45,19 3,19V16C2.45,16 2,15.55 2,15C2,14.45 2.45,14 3,14H6.75L7.23,12.39C6.72,12.14 6.13,12 5.5,12H5.07L5,11C5,6.58 8.81,3 13.5,3M5,16V19H5.26L6.15,16H5Z' })
	  );
	};
	
	var FootballIcon = function FootballIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.5,7.5C9.17,5.87 11.29,4.69 13.37,4.18C15.46,3.67 17.5,3.83 18.6,4C19.71,4.15 19.87,4.31 20.03,5.41C20.18,6.5 20.33,8.55 19.82,10.63C19.31,12.71 18.13,14.83 16.5,16.5C14.83,18.13 12.71,19.31 10.63,19.82C8.55,20.33 6.5,20.18 5.41,20.03C4.31,19.87 4.15,19.71 4,18.6C3.83,17.5 3.67,15.46 4.18,13.37C4.69,11.29 5.87,9.17 7.5,7.5M7.3,15.79L8.21,16.7L9.42,15.5L10.63,16.7L11.54,15.79L10.34,14.58L12,12.91L13.21,14.12L14.12,13.21L12.91,12L14.58,10.34L15.79,11.54L16.7,10.63L15.5,9.42L16.7,8.21L15.79,7.3L14.58,8.5L13.37,7.3L12.46,8.21L13.66,9.42L12,11.09L10.79,9.88L9.88,10.79L11.09,12L9.42,13.66L8.21,12.46L7.3,13.37L8.5,14.58L7.3,15.79Z' })
	  );
	};
	
	var ForkliftIcon = function ForkliftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,4V11H4C2.89,11 2,11.89 2,13V17C2,18.66 3.34,20 5,20C6.66,20 8,18.66 8,17H10C10,18.66 11.34,20 13,20C14.66,20 16,18.66 16,17V13L12,4H6M17,5V19H22V17.5H18.5V5H17M7.5,5.5H11.2L14.5,13H7.5V5.5M5,15.5C5.83,15.5 6.5,16.17 6.5,17C6.5,17.83 5.83,18.5 5,18.5C4.17,18.5 3.5,17.83 3.5,17C3.5,16.17 4.17,15.5 5,15.5M13,15.5C13.83,15.5 14.5,16.17 14.5,17C14.5,17.83 13.83,18.5 13,18.5C12.17,18.5 11.5,17.83 11.5,17C11.5,16.17 12.17,15.5 13,15.5Z' })
	  );
	};
	
	var FormatAlignBottomIcon = function FormatAlignBottomIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9L15.5,6.5L16.92,7.92L12,12.84L7.08,7.92L8.5,6.5L11,9V3H13V9M3,15H21V17H3V15M3,19H13V21H3V19Z' })
	  );
	};
	
	var FormatAlignCenterIcon = function FormatAlignCenterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3H21V5H3V3M7,7H17V9H7V7M3,11H21V13H3V11M7,15H17V17H7V15M3,19H21V21H3V19Z' })
	  );
	};
	
	var FormatAlignJustifyIcon = function FormatAlignJustifyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3H21V5H3V3M3,7H21V9H3V7M3,11H21V13H3V11M3,15H21V17H3V15M3,19H21V21H3V19Z' })
	  );
	};
	
	var FormatAlignLeftIcon = function FormatAlignLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3H21V5H3V3M3,7H15V9H3V7M3,11H21V13H3V11M3,15H15V17H3V15M3,19H21V21H3V19Z' })
	  );
	};
	
	var FormatAlignMiddleIcon = function FormatAlignMiddleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,6L15,4L16.42,5.42L12,9.84L7.58,5.42L9,4L11,6V2H13V6M3,11H21V13H3V11M13,18V22H11V18L9,20L7.58,18.58L12,14.16L16.42,18.58L15,20L13,18Z' })
	  );
	};
	
	var FormatAlignRightIcon = function FormatAlignRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3H21V5H3V3M9,7H21V9H9V7M3,11H21V13H3V11M9,15H21V17H9V15M3,19H21V21H3V19Z' })
	  );
	};
	
	var FormatAlignTopIcon = function FormatAlignTopIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,15L15.5,17.5L16.92,16.08L12,11.16L7.08,16.08L8.5,17.5L11,15V21H13V15M3,3H21V5H3V3M3,7H13V9H3V7Z' })
	  );
	};
	
	var FormatAnnotationPlusIcon = function FormatAnnotationPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.5,7H10.5L16,21H13.6L12.5,18H6.3L5.2,21H3L8.5,7M7.1,16H11.9L9.5,9.7L7.1,16M22,5V7H19V10H17V7H14V5H17V2H19V5H22Z' })
	  );
	};
	
	var FormatBoldIcon = function FormatBoldIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.5,15.5H10V12.5H13.5C14.33,12.5 15,13.17 15,14C15,14.83 14.33,15.5 13.5,15.5M10,6.5H13C13.83,6.5 14.5,7.17 14.5,8C14.5,8.83 13.83,9.5 13,9.5H10M15.6,10.79C16.57,10.11 17.25,9 17.25,8C17.25,5.74 15.5,4 13.25,4H7V18H14.04C16.14,18 17.75,16.3 17.75,14.21C17.75,12.69 16.89,11.39 15.6,10.79Z' })
	  );
	};
	
	var FormatClearIcon = function FormatClearIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,5V5.18L8.82,8H11.22L10.5,9.68L12.6,11.78L14.21,8H20V5H6M3.27,5L2,6.27L8.97,13.24L6.5,19H9.5L11.07,15.34L16.73,21L18,19.73L3.55,5.27L3.27,5Z' })
	  );
	};
	
	var FormatColorFillIcon = function FormatColorFillIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,11.5C19,11.5 17,13.67 17,15C17,16.1 17.9,17 19,17C20.1,17 21,16.1 21,15C21,13.67 19,11.5 19,11.5M5.21,10L10,5.21L14.79,10M16.56,8.94L7.62,0L6.21,1.41L8.59,3.79L3.44,8.94C2.85,9.5 2.85,10.47 3.44,11.06L8.94,16.56C9.23,16.85 9.62,17 10,17C10.38,17 10.77,16.85 11.06,16.56L16.56,11.06C17.15,10.47 17.15,9.5 16.56,8.94Z' })
	  );
	};
	
	var FormatColorTextIcon = function FormatColorTextIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.62,12L12,5.67L14.37,12M11,3L5.5,17H7.75L8.87,14H15.12L16.25,17H18.5L13,3H11Z' })
	  );
	};
	
	var FormatColumnsIcon = function FormatColumnsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3H11V5H3V3M13,3H21V5H13V3M3,7H11V9H3V7M13,7H21V9H13V7M3,11H11V13H3V11M13,11H21V13H13V11M3,15H11V17H3V15M13,15H21V17H13V15M3,19H11V21H3V19M13,19H21V21H13V19Z' })
	  );
	};
	
	var FormatFloatCenterIcon = function FormatFloatCenterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,7H15V13H9V7M3,3H21V5H3V3M3,15H21V17H3V15M3,19H17V21H3V19Z' })
	  );
	};
	
	var FormatFloatLeftIcon = function FormatFloatLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,7H9V13H3V7M3,3H21V5H3V3M21,7V9H11V7H21M21,11V13H11V11H21M3,15H17V17H3V15M3,19H21V21H3V19Z' })
	  );
	};
	
	var FormatFloatNoneIcon = function FormatFloatNoneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,7H9V13H3V7M3,3H21V5H3V3M21,11V13H11V11H21M3,15H17V17H3V15M3,19H21V21H3V19Z' })
	  );
	};
	
	var FormatFloatRightIcon = function FormatFloatRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,7H21V13H15V7M3,3H21V5H3V3M13,7V9H3V7H13M9,11V13H3V11H9M3,15H17V17H3V15M3,19H21V21H3V19Z' })
	  );
	};
	
	var FormatFontIcon = function FormatFontIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,8H20V20H21V21H17V20H18V17H14L12.5,20H14V21H10V20H11L17,8M18,9L14.5,16H18V9M5,3H10C11.11,3 12,3.89 12,5V16H9V11H6V16H3V5C3,3.89 3.89,3 5,3M6,5V9H9V5H6Z' })
	  );
	};
	
	var FormatHeader1Icon = function FormatHeader1Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4H5V10H9V4H11V18H9V12H5V18H3V4M14,18V16H16V6.31L13.5,7.75V5.44L16,4H18V16H20V18H14Z' })
	  );
	};
	
	var FormatHeader2Icon = function FormatHeader2Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4H5V10H9V4H11V18H9V12H5V18H3V4M21,18H15C13.9,18 13,17.1 13,16C13,15.47 13.2,15 13.54,14.64L18.41,9.41C18.78,9.05 19,8.55 19,8C19,6.9 18.1,6 17,6C15.9,6 15,6.9 15,8H13C13,5.79 14.79,4 17,4C19.21,4 21,5.79 21,8C21,9.1 20.55,10.1 19.83,10.83L15,16H21V18Z' })
	  );
	};
	
	var FormatHeader3Icon = function FormatHeader3Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4H5V10H9V4H11V18H9V12H5V18H3V4M15,4H19C20.1,4 21,4.9 21,6V16C21,17.1 20.1,18 19,18H15C13.9,18 13,17.1 13,16V15H15V16H19V12H15V10H19V6H15V7H13V6C13,4.9 13.9,4 15,4Z' })
	  );
	};
	
	var FormatHeader4Icon = function FormatHeader4Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4H5V10H9V4H11V18H9V12H5V18H3V4M18,18V13H13V11L18,4H20V11H21V13H20V18H18M18,11V7.42L15.45,11H18Z' })
	  );
	};
	
	var FormatHeader5Icon = function FormatHeader5Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4H5V10H9V4H11V18H9V12H5V18H3V4M15,4H20V6H15V10H17C19.21,10 21,11.79 21,14C21,16.21 19.21,18 17,18H15C13.9,18 13,17.1 13,16V15H15V16H17C18.1,16 19,15.1 19,14C19,12.9 18.1,12 17,12H15C13.9,12 13,11.1 13,10V6C13,4.9 13.9,4 15,4Z' })
	  );
	};
	
	var FormatHeader6Icon = function FormatHeader6Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4H5V10H9V4H11V18H9V12H5V18H3V4M15,4H19C20.1,4 21,4.9 21,6V7H19V6H15V10H19C20.1,10 21,10.9 21,12V16C21,17.1 20.1,18 19,18H15C13.9,18 13,17.1 13,16V6C13,4.9 13.9,4 15,4M15,12V16H19V12H15Z' })
	  );
	};
	
	var FormatHeaderDecreaseIcon = function FormatHeaderDecreaseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H6V10H10V4H12V18H10V12H6V18H4V4M20.42,7.41L16.83,11L20.42,14.59L19,16L14,11L19,6L20.42,7.41Z' })
	  );
	};
	
	var FormatHeaderEqualIcon = function FormatHeaderEqualIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H6V10H10V4H12V18H10V12H6V18H4V4M14,10V8H21V10H14M14,12H21V14H14V12Z' })
	  );
	};
	
	var FormatHeaderIncreaseIcon = function FormatHeaderIncreaseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H6V10H10V4H12V18H10V12H6V18H4V4M14.59,7.41L18.17,11L14.59,14.59L16,16L21,11L16,6L14.59,7.41Z' })
	  );
	};
	
	var FormatHeaderPoundIcon = function FormatHeaderPoundIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4H5V10H9V4H11V18H9V12H5V18H3V4M13,8H15.31L15.63,5H17.63L17.31,8H19.31L19.63,5H21.63L21.31,8H23V10H21.1L20.9,12H23V14H20.69L20.37,17H18.37L18.69,14H16.69L16.37,17H14.37L14.69,14H13V12H14.9L15.1,10H13V8M17.1,10L16.9,12H18.9L19.1,10H17.1Z' })
	  );
	};
	
	var FormatHorizontalAlignCenterIcon = function FormatHorizontalAlignCenterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,16V13H23V11H19V8L15,12L19,16M5,8V11H1V13H5V16L9,12L5,8M11,20H13V4H11V20Z' })
	  );
	};
	
	var FormatHorizontalAlignLeftIcon = function FormatHorizontalAlignLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,16V13H21V11H11V8L7,12L11,16M3,20H5V4H3V20Z' })
	  );
	};
	
	var FormatHorizontalAlignRightIcon = function FormatHorizontalAlignRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,8V11H3V13H13V16L17,12L13,8M19,20H21V4H19V20Z' })
	  );
	};
	
	var FormatIndentDecreaseIcon = function FormatIndentDecreaseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,13H21V11H11M11,9H21V7H11M3,3V5H21V3M3,21H21V19H3M3,12L7,16V8M11,17H21V15H11V17Z' })
	  );
	};
	
	var FormatIndentIncreaseIcon = function FormatIndentIncreaseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,13H21V11H11M11,9H21V7H11M3,3V5H21V3M11,17H21V15H11M3,8V16L7,12M3,21H21V19H3V21Z' })
	  );
	};
	
	var FormatItalicIcon = function FormatItalicIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,4V7H12.21L8.79,15H6V18H14V15H11.79L15.21,7H18V4H10Z' })
	  );
	};
	
	var FormatLineSpacingIcon = function FormatLineSpacingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,13H22V11H10M10,19H22V17H10M10,7H22V5H10M6,7H8.5L5,3.5L1.5,7H4V17H1.5L5,20.5L8.5,17H6V7Z' })
	  );
	};
	
	var FormatLineStyleIcon = function FormatLineStyleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,16H8V14H3V16M9.5,16H14.5V14H9.5V16M16,16H21V14H16V16M3,20H5V18H3V20M7,20H9V18H7V20M11,20H13V18H11V20M15,20H17V18H15V20M19,20H21V18H19V20M3,12H11V10H3V12M13,12H21V10H13V12M3,4V8H21V4H3Z' })
	  );
	};
	
	var FormatLineWeightIcon = function FormatLineWeightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,17H21V15H3V17M3,20H21V19H3V20M3,13H21V10H3V13M3,4V8H21V4H3Z' })
	  );
	};
	
	var FormatListBulletedTypeIcon = function FormatListBulletedTypeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,9.5L7.5,14H2.5L5,9.5M3,4H7V8H3V4M5,20C6.1,20 7,19.1 7,18C7,16.9 6.1,16 5,16C3.9,16 3,16.9 3,18C3,19.1 3.9,20 5,20M9,5V7H21V5H9M9,19H21V17H9V19M9,13H21V11H9V13Z' })
	  );
	};
	
	var FormatListBulletedIcon = function FormatListBulletedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,5H21V7H7V5M7,13V11H21V13H7M4,4.5C4.83,4.5 5.5,5.17 5.5,6C5.5,6.83 4.83,7.5 4,7.5C3.17,7.5 2.5,6.83 2.5,6C2.5,5.17 3.17,4.5 4,4.5M4,10.5C4.83,10.5 5.5,11.17 5.5,12C5.5,12.83 4.83,13.5 4,13.5C3.17,13.5 2.5,12.83 2.5,12C2.5,11.17 3.17,10.5 4,10.5M7,19V17H21V19H7M4,16.5C4.83,16.5 5.5,17.17 5.5,18C5.5,18.83 4.83,19.5 4,19.5C3.17,19.5 2.5,18.83 2.5,18C2.5,17.17 3.17,16.5 4,16.5Z' })
	  );
	};
	
	var FormatListCheckboxIcon = function FormatListCheckboxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,19V17H8V19H21M21,13V11H8V13H21M8,7H21V5H8V7M4,5V7H6V5H4M3,5C3,4.45 3.45,4 4,4H6C6.55,4 7,4.45 7,5V7C7,7.55 6.55,8 6,8H4C3.45,8 3,7.55 3,7V5M4,11V13H6V11H4M3,11C3,10.45 3.45,10 4,10H6C6.55,10 7,10.45 7,11V13C7,13.55 6.55,14 6,14H4C3.45,14 3,13.55 3,13V11M4,17V19H6V17H4M3,17C3,16.45 3.45,16 4,16H6C6.55,16 7,16.45 7,17V19C7,19.55 6.55,20 6,20H4C3.45,20 3,19.55 3,19V17Z' })
	  );
	};
	
	var FormatListChecksIcon = function FormatListChecksIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,5H9V11H3V5M5,7V9H7V7H5M11,7H21V9H11V7M11,15H21V17H11V15M5,20L1.5,16.5L2.91,15.09L5,17.17L9.59,12.59L11,14L5,20Z' })
	  );
	};
	
	var FormatListNumbersIcon = function FormatListNumbersIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,13H21V11H7M7,19H21V17H7M7,7H21V5H7M2,11H3.8L2,13.1V14H5V13H3.2L5,10.9V10H2M3,8H4V4H2V5H3M2,17H4V17.5H3V18.5H4V19H2V20H5V16H2V17Z' })
	  );
	};
	
	var FormatPageBreakIcon = function FormatPageBreakIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,20H6V18H4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V18H18V20M14,2H6C4.9,2 4,2.9 4,4V12H6V4H14V8H18V12H20V8L14,2M11,16H8V14H11V16M16,16H13V14H16V16M3,14H6V16H3V14M21,16H18V14H21V16Z' })
	  );
	};
	
	var FormatPaintIcon = function FormatPaintIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,4V3C18,2.45 17.55,2 17,2H5C4.45,2 4,2.45 4,3V7C4,7.55 4.45,8 5,8H17C17.55,8 18,7.55 18,7V6H19V10H9V21C9,21.55 9.45,22 10,22H12C12.55,22 13,21.55 13,21V12H21V4H18Z' })
	  );
	};
	
	var FormatParagraphIcon = function FormatParagraphIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,4C15.21,4 17,5.79 17,8C17,10.21 15.21,12 13,12H11V18H9V4H13M13,10C14.1,10 15,9.1 15,8C15,6.9 14.1,6 13,6H11V10H13Z' })
	  );
	};
	
	var FormatPilcrowIcon = function FormatPilcrowIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,11C7.79,11 6,9.21 6,7C6,4.79 7.79,3 10,3H18V5H16V21H14V5H12V21H10V11Z' })
	  );
	};
	
	var FormatQuoteCloseIcon = function FormatQuoteCloseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,17H17L19,13V7H13V13H16M6,17H9L11,13V7H5V13H8L6,17Z' })
	  );
	};
	
	var FormatQuoteOpenIcon = function FormatQuoteOpenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,7L8,11H11V17H5V11L7,7H10M18,7L16,11H19V17H13V11L15,7H18Z' })
	  );
	};
	
	var FormatRotate90Icon = function FormatRotate90Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.34,6.41L0.86,12.9L7.35,19.38L13.84,12.9L7.34,6.41M3.69,12.9L7.35,9.24L11,12.9L7.34,16.56L3.69,12.9M19.36,6.64C17.61,4.88 15.3,4 13,4V0.76L8.76,5L13,9.24V6C14.79,6 16.58,6.68 17.95,8.05C20.68,10.78 20.68,15.22 17.95,17.95C16.58,19.32 14.79,20 13,20C12.03,20 11.06,19.79 10.16,19.39L8.67,20.88C10,21.62 11.5,22 13,22C15.3,22 17.61,21.12 19.36,19.36C22.88,15.85 22.88,10.15 19.36,6.64Z' })
	  );
	};
	
	var FormatSectionIcon = function FormatSectionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.67,4.42C14.7,3.84 13.58,3.54 12.45,3.56C10.87,3.56 9.66,4.34 9.66,5.56C9.66,6.96 11,7.47 13,8.14C15.5,8.95 17.4,9.97 17.4,12.38C17.36,13.69 16.69,14.89 15.6,15.61C16.25,16.22 16.61,17.08 16.6,17.97C16.6,20.79 14,21.97 11.5,21.97C10.04,22.03 8.59,21.64 7.35,20.87L8,19.34C9.04,20.05 10.27,20.43 11.53,20.44C13.25,20.44 14.53,19.66 14.53,18.24C14.53,17 13.75,16.31 11.25,15.45C8.5,14.5 6.6,13.5 6.6,11.21C6.67,9.89 7.43,8.69 8.6,8.07C7.97,7.5 7.61,6.67 7.6,5.81C7.6,3.45 9.77,2 12.53,2C13.82,2 15.09,2.29 16.23,2.89L15.67,4.42M11.35,13.42C12.41,13.75 13.44,14.18 14.41,14.71C15.06,14.22 15.43,13.45 15.41,12.64C15.41,11.64 14.77,10.76 13,10.14C11.89,9.77 10.78,9.31 9.72,8.77C8.97,9.22 8.5,10.03 8.5,10.91C8.5,11.88 9.23,12.68 11.35,13.42Z' })
	  );
	};
	
	var FormatSizeIcon = function FormatSizeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,12H6V19H9V12H12V9H3M9,4V7H14V19H17V7H22V4H9Z' })
	  );
	};
	
	var FormatStrikethroughVariantIcon = function FormatStrikethroughVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,12V14H18.61C19.61,16.14 19.56,22 12.38,22C4.05,22.05 4.37,15.5 4.37,15.5L8.34,15.55C8.37,18.92 11.5,18.92 12.12,18.88C12.76,18.83 15.15,18.84 15.34,16.5C15.42,15.41 14.32,14.58 13.12,14H1V12H23M19.41,7.89L15.43,7.86C15.43,7.86 15.6,5.09 12.15,5.08C8.7,5.06 9,7.28 9,7.56C9.04,7.84 9.34,9.22 12,9.88H5.71C5.71,9.88 2.22,3.15 10.74,2C19.45,0.8 19.43,7.91 19.41,7.89Z' })
	  );
	};
	
	var FormatStrikethroughIcon = function FormatStrikethroughIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,14H21V12H3M5,4V7H10V10H14V7H19V4M10,19H14V16H10V19Z' })
	  );
	};
	
	var FormatSubscriptIcon = function FormatSubscriptIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,7.41L11.41,12L16,16.59L14.59,18L10,13.41L5.41,18L4,16.59L8.59,12L4,7.41L5.41,6L10,10.59L14.59,6L16,7.41M21.85,21.03H16.97V20.03L17.86,19.23C18.62,18.58 19.18,18.04 19.56,17.6C19.93,17.16 20.12,16.75 20.13,16.36C20.14,16.08 20.05,15.85 19.86,15.66C19.68,15.5 19.39,15.38 19,15.38C18.69,15.38 18.42,15.44 18.16,15.56L17.5,15.94L17.05,14.77C17.32,14.56 17.64,14.38 18.03,14.24C18.42,14.1 18.85,14 19.32,14C20.1,14.04 20.7,14.25 21.1,14.66C21.5,15.07 21.72,15.59 21.72,16.23C21.71,16.79 21.53,17.31 21.18,17.78C20.84,18.25 20.42,18.7 19.91,19.14L19.27,19.66V19.68H21.85V21.03Z' })
	  );
	};
	
	var FormatSuperscriptIcon = function FormatSuperscriptIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,7.41L11.41,12L16,16.59L14.59,18L10,13.41L5.41,18L4,16.59L8.59,12L4,7.41L5.41,6L10,10.59L14.59,6L16,7.41M21.85,9H16.97V8L17.86,7.18C18.62,6.54 19.18,6 19.56,5.55C19.93,5.11 20.12,4.7 20.13,4.32C20.14,4.04 20.05,3.8 19.86,3.62C19.68,3.43 19.39,3.34 19,3.33C18.69,3.34 18.42,3.4 18.16,3.5L17.5,3.89L17.05,2.72C17.32,2.5 17.64,2.33 18.03,2.19C18.42,2.05 18.85,2 19.32,2C20.1,2 20.7,2.2 21.1,2.61C21.5,3 21.72,3.54 21.72,4.18C21.71,4.74 21.53,5.26 21.18,5.73C20.84,6.21 20.42,6.66 19.91,7.09L19.27,7.61V7.63H21.85V9Z' })
	  );
	};
	
	var FormatTextIcon = function FormatTextIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.5,4L19.66,8.35L18.7,8.61C18.25,7.74 17.79,6.87 17.26,6.43C16.73,6 16.11,6 15.5,6H13V16.5C13,17 13,17.5 13.33,17.75C13.67,18 14.33,18 15,18V19H9V18C9.67,18 10.33,18 10.67,17.75C11,17.5 11,17 11,16.5V6H8.5C7.89,6 7.27,6 6.74,6.43C6.21,6.87 5.75,7.74 5.3,8.61L4.34,8.35L5.5,4H18.5Z' })
	  );
	};
	
	var FormatTextdirectionLToRIcon = function FormatTextdirectionLToRIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,18L17,14V17H5V19H17V22M9,10V15H11V4H13V15H15V4H17V2H9C6.79,2 5,3.79 5,6C5,8.21 6.79,10 9,10Z' })
	  );
	};
	
	var FormatTextdirectionRToLIcon = function FormatTextdirectionRToLIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,17V14L4,18L8,22V19H20V17M10,10V15H12V4H14V15H16V4H18V2H10C7.79,2 6,3.79 6,6C6,8.21 7.79,10 10,10Z' })
	  );
	};
	
	var FormatTitleIcon = function FormatTitleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,4V7H10.5V19H13.5V7H19V4H5Z' })
	  );
	};
	
	var FormatUnderlineIcon = function FormatUnderlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,21H19V19H5V21M12,17C15.31,17 18,14.31 18,11V3H15.5V11C15.5,12.93 13.93,14.5 12,14.5C10.07,14.5 8.5,12.93 8.5,11V3H6V11C6,14.31 8.69,17 12,17Z' })
	  );
	};
	
	var FormatVerticalAlignBottomIcon = function FormatVerticalAlignBottomIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,13H13V3H11V13H8L12,17L16,13M4,19V21H20V19H4Z' })
	  );
	};
	
	var FormatVerticalAlignCenterIcon = function FormatVerticalAlignCenterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,19H11V23H13V19H16L12,15L8,19M16,5H13V1H11V5H8L12,9L16,5M4,11V13H20V11H4Z' })
	  );
	};
	
	var FormatVerticalAlignTopIcon = function FormatVerticalAlignTopIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,11H11V21H13V11H16L12,7L8,11M4,3V5H20V3H4Z' })
	  );
	};
	
	var FormatWrapInlineIcon = function FormatWrapInlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,7L13,17H3L8,7M3,3H21V5H3V3M21,15V17H14V15H21M3,19H21V21H3V19Z' })
	  );
	};
	
	var FormatWrapSquareIcon = function FormatWrapSquareIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,7L17,17H7L12,7M3,3H21V5H3V3M3,7H6V9H3V7M21,7V9H18V7H21M3,11H6V13H3V11M21,11V13H18V11H21M3,15H6V17H3V15M21,15V17H18V15H21M3,19H21V21H3V19Z' })
	  );
	};
	
	var FormatWrapTightIcon = function FormatWrapTightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,7L17,17H7L12,7M3,3H21V5H3V3M3,7H9V9H3V7M21,7V9H15V7H21M3,11H7V13H3V11M21,11V13H17V11H21M3,15H6V17H3V15M21,15V17H18V15H21M3,19H21V21H3V19Z' })
	  );
	};
	
	var FormatWrapTopBottomIcon = function FormatWrapTopBottomIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,7L17,17H7L12,7M3,3H21V5H3V3M3,19H21V21H3V19Z' })
	  );
	};
	
	var ForumOutlineIcon = function ForumOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2C2.9,2 2,2.9 2,4V17L6,13H15C16.1,13 17,12.1 17,11V4C17,2.9 16.1,2 15,2H4M4,4H15V11H6L4,13V4M19,6V8H20V18L18,16H8V15H6V16C6,17.1 6.9,18 8,18H18L22,22V8C22,6.9 21.1,6 20,6H19Z' })
	  );
	};
	
	var ForumIcon = function ForumIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,12V3C17,2.45 16.55,2 16,2H3C2.45,2 2,2.45 2,3V17L6,13H16C16.55,13 17,12.55 17,12M21,6H19V15H6V17C6,17.55 6.45,18 7,18H18L22,22V7C22,6.45 21.55,6 21,6Z' })
	  );
	};
	
	var ForwardIcon = function ForwardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,8V4L20,12L12,20V16H4V8H12Z' })
	  );
	};
	
	var FountainIcon = function FountainIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.5,2C4.47,2 2,4.46 2,7.5V7.5L2,8H4V7.5C4,5.57 5.57,4 7.5,4C9,4 10.26,4.93 10.76,6.24C10.37,6.08 9.95,6 9.5,6C8.11,6 6.9,6.82 6.34,8L8.08,9C8.29,8.42 8.85,8 9.5,8C10.33,8 11,8.67 11,9.5V11H13V9.5C13,8.67 13.67,8 14.5,8C15.16,8 15.71,8.42 15.92,9L17.66,8C17.1,6.82 15.9,6 14.5,6C14.05,6 13.63,6.08 13.24,6.24C13.74,4.93 15,4 16.5,4C18.43,4 20,5.57 20,7.5V8H22V7.5H22C22,4.46 19.54,2 16.5,2C14.64,2 13,2.93 12,4.34C11,2.93 9.36,2 7.5,2M6,12V14H7.42C7.92,15.15 8.85,16.07 10,16.57C10,17.38 10,18.19 10,19H2C2,19 2.82,20.23 3.41,21.11C3.78,21.67 4.4,22 5.07,22H18.93C19.6,22 20.22,21.67 20.59,21.11L22,19H14C14,18.19 14,17.38 14,16.57C15.15,16.07 16.08,15.15 16.58,14H18V12H6Z' })
	  );
	};
	
	var FoursquareIcon = function FoursquareIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,5L16.57,7.5C16.5,7.73 16.2,8 15.91,8C15.61,8 12,8 12,8C11.53,8 10.95,8.32 10.95,8.79V9.2C10.95,9.67 11.53,10 12,10C12,10 14.95,10 15.28,10C15.61,10 15.93,10.36 15.86,10.71C15.79,11.07 14.94,13.28 14.9,13.5C14.86,13.67 14.64,14 14.25,14C13.92,14 11.37,14 11.37,14C10.85,14 10.69,14.07 10.34,14.5C10,14.94 7.27,18.1 7.27,18.1C7.24,18.13 7,18.04 7,18V5C7,4.7 7.61,4 8,4C8,4 16.17,4 16.5,4C16.82,4 17.08,4.61 17,5M17,14.45C17.11,13.97 18.78,6.72 19.22,4.55M17.58,2C17.58,2 8.38,2 6.91,2C5.43,2 5,3.11 5,3.8C5,4.5 5,20.76 5,20.76C5,21.54 5.42,21.84 5.66,21.93C5.9,22.03 6.55,22.11 6.94,21.66C6.94,21.66 11.65,16.22 11.74,16.13C11.87,16 11.87,16 12,16C12.26,16 14.2,16 15.26,16C16.63,16 16.85,15 17,14.45C17.11,13.97 18.78,6.72 19.22,4.55C19.56,2.89 19.14,2 17.58,2Z' })
	  );
	};
	
	var FreebsdIcon = function FreebsdIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.69,2C3.54,1.95 6.08,3.16 6.13,3.19C4.84,4 3.74,5.09 2.91,6.38C2.09,4.81 1.34,2.91 2,2.25C2.17,2.08 2.4,2 2.69,2M20.84,2.13C21.25,2.08 21.58,2.14 21.78,2.34C22.85,3.42 19.88,8.15 19.38,8.66C18.87,9.16 17.57,8.7 16.5,7.63C15.43,6.55 14.97,5.26 15.47,4.75C15.88,4.34 19.09,2.3 20.84,2.13M12,2.56C13.29,2.56 14.53,2.82 15.66,3.28C15.17,3.6 14.81,3.85 14.69,3.97C13.7,4.96 14.14,6.83 15.72,8.41C16.7,9.38 17.84,9.97 18.78,9.97C19.46,9.97 19.92,9.68 20.16,9.44C20.33,9.27 20.6,8.88 20.91,8.41C21.42,9.59 21.69,10.88 21.69,12.25C21.69,17.61 17.36,21.97 12,21.97C6.64,21.97 2.31,17.61 2.31,12.25C2.31,6.89 6.64,2.56 12,2.56Z' })
	  );
	};
	
	var FridgeFilledBottomIcon = function FridgeFilledBottomIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,8V6H10V8H8M7,2H17C18.1,2 19,2.9 19,4V19C19,20.1 18.1,21 17,21V22H15V21H9V22H7V21C5.9,21 5,20.1 5,19V4C5,2.9 5.9,2 7,2M7,4V9H17V4H7M8,12V15H10V12H8Z' })
	  );
	};
	
	var FridgeFilledTopIcon = function FridgeFilledTopIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,2C5.9,2 5,2.9 5,4V19C5,20.1 5.9,21 7,21V22H9V21H15V22H17V21C18.1,21 19,20.1 19,19V4C19,2.9 18.1,2 17,2H7M8,6H10V8H8V6M7,11H17V19H7V11M8,12V15H10V12H8Z' })
	  );
	};
	
	var FridgeFilledIcon = function FridgeFilledIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,2H17C18.1,2 19,2.9 19,4V9H5V4C5,2.9 5.9,2 7,2M19,19C19,20.1 18.1,21 17,21V22H15V21H9V22H7V21C5.9,21 5,20.1 5,19V10H19V19M8,5V7H10V5H8M8,12V15H10V12H8Z' })
	  );
	};
	
	var FridgeIcon = function FridgeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,21V22H7V21C5.9,21 5,20.1 5,19V4C5,2.9 5.9,2 7,2H17C18.1,2 19,2.9 19,4V19C19,20.1 18.1,21 17,21V22H15V21H9M7,4V9H17V4H7M7,19H17V11H7V19M8,12H10V15H8V12M8,6H10V8H8V6Z' })
	  );
	};
	
	var FuelIcon = function FuelIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,2H6C6.28,2 6.53,2.11 6.71,2.29L8.79,4.38L9.59,3.59C10,3.2 10.5,3 11,3H17C17.5,3 18,3.2 18.41,3.59L19.41,4.59C19.8,5 20,5.5 20,6V19C20,20.1 19.1,21 18,21H8C6.9,21 6,20.1 6,19V13L6,12V8C6,7.5 6.2,7 6.59,6.59L7.38,5.79L5.59,4H3V2M11,5V7H17V5H11M11.41,11L9.41,9H8V10.41L10,12.41V15.59L8,17.59V19H9.41L11.41,17H14.59L16.59,19H18V17.59L16,15.59V12.41L18,10.41V9H16.59L14.59,11H11.41M12,13H14V15H12V13Z' })
	  );
	};
	
	var FullscreenExitIcon = function FullscreenExitIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,14H19V16H16V19H14V14M5,14H10V19H8V16H5V14M8,5H10V10H5V8H8V5M19,8V10H14V5H16V8H19Z' })
	  );
	};
	
	var FullscreenIcon = function FullscreenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z' })
	  );
	};
	
	var FunctionVariantIcon = function FunctionVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.42,5.29C11.32,5.19 10.35,6 10.25,7.11L10,10H12.82V12H9.82L9.38,17.07C9.18,19.27 7.24,20.9 5.04,20.7C3.79,20.59 2.66,19.9 2,18.83L3.5,17.33C3.83,18.38 4.96,18.97 6,18.63C6.78,18.39 7.33,17.7 7.4,16.89L7.82,12H4.82V10H8L8.27,6.93C8.46,4.73 10.39,3.1 12.6,3.28C13.86,3.39 15,4.09 15.66,5.17L14.16,6.67C13.91,5.9 13.23,5.36 12.42,5.29M22,13.65L20.59,12.24L17.76,15.07L14.93,12.24L13.5,13.65L16.35,16.5L13.5,19.31L14.93,20.72L17.76,17.89L20.59,20.72L22,19.31L19.17,16.5L22,13.65Z' })
	  );
	};
	
	var FunctionIcon = function FunctionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.6,5.29C14.5,5.19 13.53,6 13.43,7.11L13.18,10H16V12H13L12.56,17.07C12.37,19.27 10.43,20.9 8.23,20.7C6.92,20.59 5.82,19.86 5.17,18.83L6.67,17.33C6.91,18.07 7.57,18.64 8.4,18.71C9.5,18.81 10.47,18 10.57,16.89L11,12H8V10H11.17L11.44,6.93C11.63,4.73 13.57,3.1 15.77,3.3C17.08,3.41 18.18,4.14 18.83,5.17L17.33,6.67C17.09,5.93 16.43,5.36 15.6,5.29Z' })
	  );
	};
	
	var GamepadVariantIcon = function GamepadVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,6H17C20.31,6 23,8.69 23,12C23,15.31 20.31,18 17,18C15.22,18 13.63,17.23 12.53,16H11.47C10.37,17.23 8.78,18 7,18C3.69,18 1,15.31 1,12C1,8.69 3.69,6 7,6M6,9V11H4V13H6V15H8V13H10V11H8V9H6M15.5,12C14.67,12 14,12.67 14,13.5C14,14.33 14.67,15 15.5,15C16.33,15 17,14.33 17,13.5C17,12.67 16.33,12 15.5,12M18.5,9C17.67,9 17,9.67 17,10.5C17,11.33 17.67,12 18.5,12C19.33,12 20,11.33 20,10.5C20,9.67 19.33,9 18.5,9Z' })
	  );
	};
	
	var GamepadIcon = function GamepadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.5,9L13.5,12L16.5,15H22V9M9,16.5V22H15V16.5L12,13.5M7.5,9H2V15H7.5L10.5,12M15,7.5V2H9V7.5L12,10.5L15,7.5Z' })
	  );
	};
	
	var GarageAlertIcon = function GarageAlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,20H15V11H5V20H3V9L10,5L17,9V20M6,12H14V14H6V12M6,15H14V17H6V15M19,15V10H21V15H19M19,19V17H21V19H19Z' })
	  );
	};
	
	var GarageOpenIcon = function GarageOpenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,20H17V11H7V20H5V9L12,5L19,9V20M8,12H16V14H8V12Z' })
	  );
	};
	
	var GarageIcon = function GarageIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,20H17V11H7V20H5V9L12,5L19,9V20M8,12H16V14H8V12M8,15H16V17H8V15M16,18V20H8V18H16Z' })
	  );
	};
	
	var GasCylinderIcon = function GasCylinderIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,9V14L16,20C16,21.1 15.1,22 14,22H10C8.9,22 8,21.1 8,20V14L8,9C8,7.14 9.27,5.57 11,5.13V4H9V2H15V4H13V5.13C14.73,5.57 16,7.14 16,9Z' })
	  );
	};
	
	var GasStationIcon = function GasStationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,10C17.45,10 17,9.55 17,9C17,8.45 17.45,8 18,8C18.55,8 19,8.45 19,9C19,9.55 18.55,10 18,10M12,10H6V5H12M19.77,7.23L19.78,7.22L16.06,3.5L15,4.56L17.11,6.67C16.17,7 15.5,7.93 15.5,9C15.5,10.38 16.62,11.5 18,11.5C18.36,11.5 18.69,11.42 19,11.29V18.5C19,19.05 18.55,19.5 18,19.5C17.45,19.5 17,19.05 17,18.5V14C17,12.89 16.1,12 15,12H14V5C14,3.89 13.1,3 12,3H6C4.89,3 4,3.89 4,5V21H14V13.5H15.5V18.5C15.5,19.88 16.62,21 18,21C19.38,21 20.5,19.88 20.5,18.5V9C20.5,8.31 20.22,7.68 19.77,7.23Z' })
	  );
	};
	
	var GateAndIcon = function GateAndIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,4V20H14C18.42,20 22,16.42 22,12C22,7.58 18.42,4 14,4H2M4,6H14C17.31,6 20,8.69 20,12C20,15.31 17.31,18 14,18H4V6Z' })
	  );
	};
	
	var GateNandIcon = function GateNandIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,4V20H10C13.43,20 16.5,17.84 17.6,14.6C18,14.8 18.5,15 19,15C20.66,15 22,13.66 22,12C22,10.34 20.66,9 19,9C18.5,9 18.03,9.15 17.6,9.4C16.5,6.16 13.43,4 10,4H2M4,6H10C13.31,6 16,8.69 16,12C16,15.31 13.31,18 10,18H4V6M19,11C19.5,11 20,11.5 20,12C20,12.5 19.5,13 19,13C18.45,13 18,12.55 18,12C18,11.5 18.5,11 19,11Z' })
	  );
	};
	
	var GateNorIcon = function GateNorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,4C5,10 5,14 2,20H5C9.4,20 13,17.7 16.6,13.7C17.15,14.5 18.04,15 19,15C20.66,15 22,13.66 22,12C22,10.34 20.66,9 19,9C18.04,9 17.15,9.5 16.6,10.3C13,6.3 9.4,4 5,4H2M5,6C8.8,6 12,8.1 15.3,12C12,15.9 8.8,18 5,18C6.5,14 6.5,10 5,6M19,11C19.5,11 20,11.5 20,12C20,12.5 19.5,13 19,13C18.45,13 18,12.55 18,12C18,11.5 18.5,11 19,11Z' })
	  );
	};
	
	var GateNotIcon = function GateNotIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,4V20L16.2,13C16.62,14.19 17.74,15 19,15C20.66,15 22,13.66 22,12C22,10.34 20.66,9 19,9C17.74,9 16.62,9.81 16.2,11L2,4M4,7.3L13.7,12L4,16.7V7.3M19,11C19.5,11 20,11.5 20,12C20,12.5 19.5,13 19,13C18.45,13 18,12.55 18,12C18,11.5 18.5,11 19,11Z' })
	  );
	};
	
	var GateOrIcon = function GateOrIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,4C5,10 5,14 2,20H8C13,20 19,16 22,12C19,8 13,4 8,4H2M5,6H8C11.5,6 16.3,9 19.3,12C16.3,15 11.5,18 8,18H5C6.4,13.9 6.4,10.1 5,6Z' })
	  );
	};
	
	var GateXnorIcon = function GateXnorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,4C5,10 5,14 2,20H4C7,14 7,10 4.1,4H2M6,4C9,10 9,14 6,20H9C12.2,20 14.8,16.8 16.7,14C17.28,14.65 18.12,15 19,15C20.66,15 22,13.66 22,12C22,10.34 20.66,9 19,9C18.12,9 17.28,9.35 16.7,10C14.7,7.2 12.2,4 9,4H6M9,6C12,6 14,10 15.5,12C14,14 12,18 9,18C10.6,14 10.6,10 9,6M19,11C19.5,11 20,11.5 20,12C20,12.5 19.5,13 19,13C18.45,13 18,12.55 18,12C18,11.5 18.5,11 19,11Z' })
	  );
	};
	
	var GateXorIcon = function GateXorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,4C5,10 5,14 2,20H4C7,14 7,10 4.1,4H2M6,4C9,10 9,14 6,20H9C14,20 18,17 22,12C18,7 14,4 9,4H6M9,6C12.8,6 16,8.1 19.3,12C15.9,15.9 12.8,18 9,18C10.5,14 10.5,10 9,6Z' })
	  );
	};
	
	var GateIcon = function GateIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,5V10H7V6H5V10H3V8H1V20H3V18H5V20H7V18H9V20H11V18H13V20H15V18H17V20H19V18H21V20H23V8H21V10H19V6H17V10H15V5H13V10H11V5H9M3,12H5V16H3V12M7,12H9V16H7V12M11,12H13V16H11V12M15,12H17V16H15V12M19,12H21V16H19V12Z' })
	  );
	};
	
	var GaugeEmptyIcon = function GaugeEmptyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,14.4 5,16.5 6.7,18C8.1,16.7 10,16 12,16C14,16 15.8,16.7 17.3,18C19,16.5 20,14.4 20,12C20,7.58 16.42,4 12,4M14,6C14.55,6 15,6.45 15,7C15,7.55 14.55,8 14,8C13.45,8 13,7.55 13,7C13,6.45 13.45,6 14,6M10,6C10.55,6 11,6.45 11,7C11,7.55 10.55,8 10,8C9.45,8 9,7.55 9,7C9,6.45 9.45,6 10,6M6.91,8.94C7.04,8.94 7.16,8.97 7.3,9L10.5,10.32L10.77,10.43C11.33,10 12.09,9.88 12.75,10.15C13.77,10.56 14.27,11.73 13.85,12.75C13.44,13.77 12.27,14.27 11.25,13.85C10.59,13.59 10.12,13 10,12.28L9.77,12.18L6.55,10.88L6.53,10.87C6,10.66 5.77,10.08 5.97,9.56C6.13,9.18 6.5,8.93 6.91,8.94V8.94M17,9C17.55,9 18,9.45 18,10C18,10.55 17.55,11 17,11C16.45,11 16,10.55 16,10C16,9.45 16.45,9 17,9Z' })
	  );
	};
	
	var GaugeFullIcon = function GaugeFullIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,4C16.42,4 20,7.58 20,12C20,14.4 19,16.5 17.3,18C15.9,16.7 14,16 12,16C10,16 8.2,16.7 6.7,18C5,16.5 4,14.4 4,12C4,7.58 7.58,4 12,4M10,6C9.45,6 9,6.45 9,7C9,7.55 9.45,8 10,8C10.55,8 11,7.55 11,7C11,6.45 10.55,6 10,6M14,6C13.45,6 13,6.45 13,7C13,7.55 13.45,8 14,8C14.55,8 15,7.55 15,7C15,6.45 14.55,6 14,6M17.09,8.94C16.96,8.94 16.84,8.97 16.7,9L13.5,10.32L13.23,10.43C12.67,10 11.91,9.88 11.25,10.15C10.23,10.56 9.73,11.73 10.15,12.75C10.56,13.77 11.73,14.27 12.75,13.85C13.41,13.59 13.88,13 14,12.28L14.23,12.18L17.45,10.88L17.47,10.87C18,10.66 18.23,10.08 18.03,9.56C17.87,9.18 17.5,8.93 17.09,8.94M7,9C6.45,9 6,9.45 6,10C6,10.55 6.45,11 7,11C7.55,11 8,10.55 8,10C8,9.45 7.55,9 7,9Z' })
	  );
	};
	
	var GaugeLowIcon = function GaugeLowIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,14.4 5,16.5 6.7,18C8.1,16.7 10,16 12,16C14,16 15.8,16.7 17.3,18C19,16.5 20,14.4 20,12C20,7.58 16.42,4 12,4M10,5.89C10.38,5.9 10.74,6.15 10.9,6.54L12.19,9.77L12.29,10C13,10.13 13.59,10.6 13.86,11.26C14.27,12.29 13.77,13.45 12.74,13.86C11.71,14.27 10.55,13.77 10.14,12.74C9.88,12.08 10,11.32 10.43,10.76L10.33,10.5L9.04,7.29L9.03,7.26C8.83,6.75 9.08,6.17 9.59,5.96C9.72,5.91 9.85,5.89 10,5.89V5.89M14,6C14.55,6 15,6.45 15,7C15,7.55 14.55,8 14,8C13.45,8 13,7.55 13,7C13,6.45 13.45,6 14,6M17,9C17.55,9 18,9.45 18,10C18,10.55 17.55,11 17,11C16.45,11 16,10.55 16,10C16,9.45 16.45,9 17,9M7,9C7.55,9 8,9.45 8,10C8,10.55 7.55,11 7,11C6.45,11 6,10.55 6,10C6,9.45 6.45,9 7,9Z' })
	  );
	};
	
	var GaugeIcon = function GaugeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,4C16.42,4 20,7.58 20,12C20,14.4 19,16.5 17.3,18C15.9,16.7 14,16 12,16C10,16 8.2,16.7 6.7,18C5,16.5 4,14.4 4,12C4,7.58 7.58,4 12,4M14,5.89C13.62,5.9 13.26,6.15 13.1,6.54L11.81,9.77L11.71,10C11,10.13 10.41,10.6 10.14,11.26C9.73,12.29 10.23,13.45 11.26,13.86C12.29,14.27 13.45,13.77 13.86,12.74C14.12,12.08 14,11.32 13.57,10.76L13.67,10.5L14.96,7.29L14.97,7.26C15.17,6.75 14.92,6.17 14.41,5.96C14.28,5.91 14.15,5.89 14,5.89M10,6C9.45,6 9,6.45 9,7C9,7.55 9.45,8 10,8C10.55,8 11,7.55 11,7C11,6.45 10.55,6 10,6M7,9C6.45,9 6,9.45 6,10C6,10.55 6.45,11 7,11C7.55,11 8,10.55 8,10C8,9.45 7.55,9 7,9M17,9C16.45,9 16,9.45 16,10C16,10.55 16.45,11 17,11C17.55,11 18,10.55 18,10C18,9.45 17.55,9 17,9Z' })
	  );
	};
	
	var GavelIcon = function GavelIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.3,20.28L11.9,10.68L10.5,9.26L9.78,9.97C9.39,10.36 8.76,10.36 8.37,9.97L7.66,9.26C7.27,8.87 7.27,8.24 7.66,7.85L13.32,2.19C13.71,1.8 14.34,1.8 14.73,2.19L15.44,2.9C15.83,3.29 15.83,3.92 15.44,4.31L14.73,5L16.15,6.43C16.54,6.04 17.17,6.04 17.56,6.43C17.95,6.82 17.95,7.46 17.56,7.85L18.97,9.26L19.68,8.55C20.07,8.16 20.71,8.16 21.1,8.55L21.8,9.26C22.19,9.65 22.19,10.29 21.8,10.68L16.15,16.33C15.76,16.72 15.12,16.72 14.73,16.33L14.03,15.63C13.63,15.24 13.63,14.6 14.03,14.21L14.73,13.5L13.32,12.09L3.71,21.7C3.32,22.09 2.69,22.09 2.3,21.7C1.91,21.31 1.91,20.67 2.3,20.28M20,19C21.1,19 22,19.9 22,21V22H12V21C12,19.9 12.9,19 14,19H20Z' })
	  );
	};
	
	var GenderFemaleIcon = function GenderFemaleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,4C15.31,4 18,6.69 18,10C18,12.97 15.84,15.44 13,15.92V18H15V20H13V22H11V20H9V18H11V15.92C8.16,15.44 6,12.97 6,10C6,6.69 8.69,4 12,4M12,6C9.79,6 8,7.79 8,10C8,12.21 9.79,14 12,14C14.21,14 16,12.21 16,10C16,7.79 14.21,6 12,6Z' })
	  );
	};
	
	var GenderMaleFemaleIcon = function GenderMaleFemaleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.58,4H14V2H21V9H19V5.41L15.17,9.24C15.69,10.03 16,11 16,12C16,14.42 14.28,16.44 12,16.9V19H14V21H12V23H10V21H8V19H10V16.9C7.72,16.44 6,14.42 6,12C6,9.24 8.24,7 11,7C12,7 12.96,7.3 13.75,7.83L17.58,4M11,9C9.34,9 8,10.34 8,12C8,13.66 9.34,15 11,15C12.66,15 14,13.66 14,12C14,10.34 12.66,9 11,9Z' })
	  );
	};
	
	var GenderMaleIcon = function GenderMaleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,9C10.29,9 11.5,9.41 12.47,10.11L17.58,5H13V3H21V11H19V6.41L13.89,11.5C14.59,12.5 15,13.7 15,15C15,18.31 12.31,21 9,21C5.69,21 3,18.31 3,15C3,11.69 5.69,9 9,9M9,11C6.79,11 5,12.79 5,15C5,17.21 6.79,19 9,19C11.21,19 13,17.21 13,15C13,12.79 11.21,11 9,11Z' })
	  );
	};
	
	var GenderTransgenderIcon = function GenderTransgenderIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.58,3H15V1H23V9H21V4.41L16.17,9.24C16.69,10.03 17,11 17,12C17,14.42 15.28,16.44 13,16.9V19H15V21H13V23H11V21H9V19H11V16.9C8.72,16.44 7,14.42 7,12C7,11 7.3,10.04 7.82,9.26L6.64,8.07L5.24,9.46L3.83,8.04L5.23,6.65L3,4.42V8H1V1H8V3H4.41L6.64,5.24L8.08,3.81L9.5,5.23L8.06,6.66L9.23,7.84C10,7.31 11,7 12,7C13,7 13.96,7.3 14.75,7.83L19.58,3M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9Z' })
	  );
	};
	
	var GentooIcon = function GentooIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.28,2C9.93,2 9.57,2.03 9.23,2.1C5.61,2.76 3.06,5.89 2.85,7.96C2.74,8.97 3.29,9.73 3.59,10.06C4.4,10.97 6.03,11.66 7.07,12.23C5.56,13.5 4.87,14.14 4.19,14.86C3.17,15.93 2.45,17.1 2.45,17.95C2.45,18.22 2.4,19.09 2.76,19.77C2.89,20.03 3.27,20.89 4.41,21.53C5.14,21.94 6.17,22.09 7.19,21.95C10.33,21.5 14.54,18.83 17.55,16.35C19.46,14.77 20.86,13.23 21.26,12.5C21.59,11.87 21.63,10.78 21.44,10.09C20.9,8.14 16.53,4.15 12.96,2.55C12.14,2.18 11.2,2 10.28,2M11.34,4.91C11.59,4.91 11.81,4.94 12,5C13.15,5.3 15.08,6.68 14.91,7.94C14.68,9.6 13.23,10.27 11.56,10.03C10.58,9.9 8.63,8.8 8.78,6.89C8.89,5.4 10.3,4.9 11.34,4.91M11.32,6.65C11.05,6.65 10.84,6.71 10.74,6.87C10.27,7.59 10.5,8.09 10.92,8.42C11.07,8.04 12.71,8.45 12.75,8.79C14.17,7.72 12.36,6.66 11.32,6.65Z' })
	  );
	};
	
	var GestureDoubleTapIcon = function GestureDoubleTapIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,9C10,8.45 10.45,8 11,8C11.55,8 12,8.45 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M11,5C13.21,5 15,6.79 15,9C15,10.5 14.2,11.77 13,12.46V11.24C13.61,10.69 14,9.89 14,9C14,7.34 12.66,6 11,6C9.34,6 8,7.34 8,9C8,9.89 8.39,10.69 9,11.24V12.46C7.8,11.77 7,10.5 7,9C7,6.79 8.79,5 11,5M11,3C14.31,3 17,5.69 17,9C17,10.7 16.29,12.23 15.16,13.33L14.16,12.88C15.28,11.96 16,10.56 16,9C16,6.24 13.76,4 11,4C8.24,4 6,6.24 6,9C6,11.05 7.23,12.81 9,13.58V14.66C6.67,13.83 5,11.61 5,9C5,5.69 7.69,3 11,3Z' })
	  );
	};
	
	var GestureSwipeDownIcon = function GestureSwipeDownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,9C10,8.45 10.45,8 11,8C11.55,8 12,8.45 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M1,9L4,12L7,9H5V3H3V9H1Z' })
	  );
	};
	
	var GestureSwipeLeftIcon = function GestureSwipeLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,9C10,8.45 10.45,8 11,8C11.55,8 12,8.45 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M3,4L6,7V5H12V3H6V1L3,4Z' })
	  );
	};
	
	var GestureSwipeRightIcon = function GestureSwipeRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,9C10,8.45 10.45,8 11,8C11.55,8 12,8.45 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M12,4L9,1V3H3V5H9V7L12,4Z' })
	  );
	};
	
	var GestureSwipeUpIcon = function GestureSwipeUpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,9C10,8.45 10.45,8 11,8C11.55,8 12,8.45 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M7,6L4,3L1,6H3V12H5V6H7Z' })
	  );
	};
	
	var GestureTapIcon = function GestureTapIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,9C10,8.45 10.45,8 11,8C11.55,8 12,8.45 12,9V13.47L13.21,13.6L18.15,15.79C18.68,16.03 19,16.56 19,17.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9M11,5C13.21,5 15,6.79 15,9C15,10.5 14.2,11.77 13,12.46V11.24C13.61,10.69 14,9.89 14,9C14,7.34 12.66,6 11,6C9.34,6 8,7.34 8,9C8,9.89 8.39,10.69 9,11.24V12.46C7.8,11.77 7,10.5 7,9C7,6.79 8.79,5 11,5Z' })
	  );
	};
	
	var GestureTwoDoubleTapIcon = function GestureTwoDoubleTapIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,15.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9C10,8.45 10.45,8 11,8C11.55,8 12,8.45 12,9V7C12,6.45 12.45,6 13,6C13.55,6 14,6.45 14,7V12L18.15,13.84C18.66,14.07 19,14.58 19,15.14M13,3C15.21,3 17,4.79 17,7C17,8.5 16.2,9.77 15,10.46V9.24C15.61,8.69 16,7.89 16,7C16,5.34 14.66,4 13,4C11.65,4 10.5,4.9 10.13,6.13C8.9,6.5 8,7.65 8,9C8,9.89 8.39,10.69 9,11.24V12.46C7.8,11.77 7,10.5 7,9C7,7.38 7.97,6 9.35,5.35C10,3.97 11.38,3 13,3M13,1C16.31,1 19,3.69 19,7C19,9.06 17.96,10.88 16.38,11.96L15.26,11.46C16.89,10.64 18,8.95 18,7C18,4.24 15.76,2 13,2C11.11,2 9.46,3.05 8.61,4.61C7.05,5.46 6,7.11 6,9C6,11.05 7.23,12.81 9,13.58V14.66C6.67,13.83 5,11.61 5,9C5,6.83 6.15,4.93 7.88,3.88C8.93,2.15 10.83,1 13,1Z' })
	  );
	};
	
	var GestureTwoTapIcon = function GestureTwoTapIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,15.14V21.5C18.97,22.32 18.32,22.97 17.5,23H11C10.62,23 10.26,22.85 10,22.57L5.1,18.37L5.84,17.6C6.03,17.39 6.3,17.28 6.58,17.28H6.8L10,19V9C10,8.45 10.45,8 11,8C11.55,8 12,8.45 12,9V7C12,6.45 12.45,6 13,6C13.55,6 14,6.45 14,7V12L18.15,13.84C18.66,14.07 19,14.58 19,15.14M15,10.45V9.24L15,9.23C15.23,9.03 15.42,8.79 15.57,8.54C15.84,8.09 16,7.56 16,7C16,5.34 14.66,4 13,4C12.21,4 11.5,4.31 10.95,4.81L10.81,4.95C10.68,5.09 10.56,5.24 10.46,5.4C10.36,5.56 10.27,5.74 10.2,5.92C10.17,6 10.15,6.06 10.13,6.13C8.9,6.5 8,7.65 8,9C8,9.7 8.24,10.34 8.64,10.85C8.74,11 8.87,11.11 9,11.23V11.24L9,12.46V12.46C7.8,11.77 7,10.5 7,9C7,7.38 7.97,6 9.35,5.35C10,3.97 11.38,3 13,3C15.21,3 17,4.79 17,7C17,8.5 16.2,9.77 15,10.46V10.45Z' })
	  );
	};
	
	var GestureIcon = function GestureIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.59,6.89C5.29,6.18 6,5.54 6.3,5.67C6.8,5.87 6.3,6.7 6,7.19C5.75,7.61 3.14,11.08 3.14,13.5C3.14,14.78 3.62,15.84 4.5,16.5C5.23,17.04 6.22,17.21 7.12,16.94C8.19,16.63 9.07,15.54 10.18,14.17C11.39,12.68 13,10.73 14.26,10.73C15.89,10.73 15.91,11.74 16,12.5C12.24,13.16 10.64,16.19 10.64,17.89C10.64,19.59 12.08,21 13.85,21C15.5,21 18.14,19.65 18.54,14.88H21V12.38H18.53C18.38,10.73 17.44,8.18 14.5,8.18C12.25,8.18 10.32,10.09 9.56,11C9,11.75 7.5,13.5 7.27,13.74C7,14.04 6.59,14.58 6.16,14.58C5.71,14.58 5.44,13.75 5.8,12.66C6.15,11.57 7.2,9.8 7.65,9.14C8.43,8 8.95,7.22 8.95,5.86C8.95,3.69 7.31,3 6.44,3C5.12,3 3.97,4 3.72,4.25C3.36,4.61 3.06,4.91 2.84,5.18L4.59,6.89M13.88,18.55C13.57,18.55 13.14,18.29 13.14,17.83C13.14,17.23 13.87,15.63 16,15.07C15.71,17.76 14.58,18.55 13.88,18.55Z' })
	  );
	};
	
	var GhostIcon = function GhostIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C7.03,2 3,6.03 3,11V22L6,19L9,22L12,19L15,22L18,19L21,22V11C21,6.03 16.97,2 12,2M9,8C10.1,8 11,8.9 11,10C11,11.1 10.1,12 9,12C7.9,12 7,11.1 7,10C7,8.9 7.9,8 9,8M15,8C16.1,8 17,8.9 17,10C17,11.1 16.1,12 15,12C13.9,12 13,11.1 13,10C13,8.9 13.9,8 15,8Z' })
	  );
	};
	
	var GiftIcon = function GiftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,12V20C22,21.1 21.1,22 20,22H4C2.9,22 2,21.1 2,20V12C1.45,12 1,11.55 1,11V8C1,6.9 1.9,6 3,6H6.17C6.06,5.69 6,5.35 6,5C6,3.34 7.34,2 9,2C10,2 10.88,2.5 11.43,3.24V3.23L12,4L12.57,3.23V3.24C13.12,2.5 14,2 15,2C16.66,2 18,3.34 18,5C18,5.35 17.94,5.69 17.83,6H21C22.1,6 23,6.9 23,8V11C23,11.55 22.55,12 22,12M4,20H11V12H4V20M20,20V12H13V20H20M9,4C8.45,4 8,4.45 8,5C8,5.55 8.45,6 9,6C9.55,6 10,5.55 10,5C10,4.45 9.55,4 9,4M15,4C14.45,4 14,4.45 14,5C14,5.55 14.45,6 15,6C15.55,6 16,5.55 16,5C16,4.45 15.55,4 15,4M3,8V10H11V8H3M13,8V10H21V8H13Z' })
	  );
	};
	
	var GitIcon = function GitIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.6,10.59L8.38,4.8L10.07,6.5C9.83,7.35 10.22,8.28 11,8.73V14.27C10.4,14.61 10,15.26 10,16C10,17.1 10.9,18 12,18C13.1,18 14,17.1 14,16C14,15.26 13.6,14.61 13,14.27V9.41L15.07,11.5C15,11.65 15,11.82 15,12C15,13.1 15.9,14 17,14C18.1,14 19,13.1 19,12C19,10.9 18.1,10 17,10C16.82,10 16.65,10 16.5,10.07L13.93,7.5C14.19,6.57 13.71,5.55 12.78,5.16C12.35,5 11.9,4.96 11.5,5.07L9.8,3.38L10.59,2.6C11.37,1.81 12.63,1.81 13.41,2.6L21.4,10.59C22.19,11.37 22.19,12.63 21.4,13.41L13.41,21.4C12.63,22.19 11.37,22.19 10.59,21.4L2.6,13.41C1.81,12.63 1.81,11.37 2.6,10.59Z' })
	  );
	};
	
	var GithubBoxIcon = function GithubBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H14.56C14.24,20.93 14.23,20.32 14.23,20.11L14.24,17.64C14.24,16.8 13.95,16.25 13.63,15.97C15.64,15.75 17.74,15 17.74,11.53C17.74,10.55 17.39,9.74 16.82,9.11C16.91,8.89 17.22,7.97 16.73,6.73C16.73,6.73 15.97,6.5 14.25,7.66C13.53,7.46 12.77,7.36 12,7.35C11.24,7.36 10.46,7.46 9.75,7.66C8.03,6.5 7.27,6.73 7.27,6.73C6.78,7.97 7.09,8.89 7.18,9.11C6.61,9.74 6.26,10.55 6.26,11.53C6.26,15 8.36,15.75 10.36,16C10.1,16.2 9.87,16.6 9.79,17.18C9.27,17.41 7.97,17.81 7.17,16.43C7.17,16.43 6.69,15.57 5.79,15.5C5.79,15.5 4.91,15.5 5.73,16.05C5.73,16.05 6.32,16.33 6.73,17.37C6.73,17.37 7.25,19.12 9.76,18.58L9.77,20.11C9.77,20.32 9.75,20.93 9.43,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3Z' })
	  );
	};
	
	var GithubCircleIcon = function GithubCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,16.42 4.87,20.17 8.84,21.5C9.34,21.58 9.5,21.27 9.5,21C9.5,20.77 9.5,20.14 9.5,19.31C6.73,19.91 6.14,17.97 6.14,17.97C5.68,16.81 5.03,16.5 5.03,16.5C4.12,15.88 5.1,15.9 5.1,15.9C6.1,15.97 6.63,16.93 6.63,16.93C7.5,18.45 8.97,18 9.54,17.76C9.63,17.11 9.89,16.67 10.17,16.42C7.95,16.17 5.62,15.31 5.62,11.5C5.62,10.39 6,9.5 6.65,8.79C6.55,8.54 6.2,7.5 6.75,6.15C6.75,6.15 7.59,5.88 9.5,7.17C10.29,6.95 11.15,6.84 12,6.84C12.85,6.84 13.71,6.95 14.5,7.17C16.41,5.88 17.25,6.15 17.25,6.15C17.8,7.5 17.45,8.54 17.35,8.79C18,9.5 18.38,10.39 18.38,11.5C18.38,15.32 16.04,16.16 13.81,16.41C14.17,16.72 14.5,17.33 14.5,18.26C14.5,19.6 14.5,20.68 14.5,21C14.5,21.27 14.66,21.59 15.17,21.5C19.14,20.16 22,16.42 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var GithubFaceIcon = function GithubFaceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.38,8.53C20.54,8.13 21.06,6.54 20.21,4.39C20.21,4.39 18.9,4 15.91,6C14.66,5.67 13.33,5.62 12,5.62C10.68,5.62 9.34,5.67 8.09,6C5.1,3.97 3.79,4.39 3.79,4.39C2.94,6.54 3.46,8.13 3.63,8.53C2.61,9.62 2,11 2,12.72C2,19.16 6.16,20.61 12,20.61C17.79,20.61 22,19.16 22,12.72C22,11 21.39,9.62 20.38,8.53M12,19.38C7.88,19.38 4.53,19.19 4.53,15.19C4.53,14.24 5,13.34 5.8,12.61C7.14,11.38 9.43,12.03 12,12.03C14.59,12.03 16.85,11.38 18.2,12.61C19,13.34 19.5,14.23 19.5,15.19C19.5,19.18 16.13,19.38 12,19.38M8.86,13.12C8.04,13.12 7.36,14.12 7.36,15.34C7.36,16.57 8.04,17.58 8.86,17.58C9.69,17.58 10.36,16.58 10.36,15.34C10.36,14.11 9.69,13.12 8.86,13.12M15.14,13.12C14.31,13.12 13.64,14.11 13.64,15.34C13.64,16.58 14.31,17.58 15.14,17.58C15.96,17.58 16.64,16.58 16.64,15.34C16.64,14.11 16,13.12 15.14,13.12Z' })
	  );
	};
	
	var GlassCocktailIcon = function GlassCocktailIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.5,7L5.5,5H18.5L16.5,7M11,13V19H6V21H18V19H13V13L21,5V3H3V5L11,13Z' })
	  );
	};
	
	var GlassFluteIcon = function GlassFluteIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,2H16C15.67,5 15.33,8 14.75,9.83C14.17,11.67 13.33,12.33 12.92,14.08C12.5,15.83 12.5,18.67 13.08,20C13.67,21.33 14.83,21.17 15.42,21.25C16,21.33 16,21.67 16,22H8C8,21.67 8,21.33 8.58,21.25C9.17,21.17 10.33,21.33 10.92,20C11.5,18.67 11.5,15.83 11.08,14.08C10.67,12.33 9.83,11.67 9.25,9.83C8.67,8 8.33,5 8,2M10,4C10.07,5.03 10.15,6.07 10.24,7H13.76C13.85,6.07 13.93,5.03 14,4H10Z' })
	  );
	};
	
	var GlassMugIcon = function GlassMugIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,4V7H18V4H10M8,2H20L21,2V3L20,4V20L21,21V22H20L8,22H7V21L8,20V18.6L4.2,16.83C3.5,16.5 3,15.82 3,15V8C3,6.9 3.9,6 5,6H8V4L7,3V2H8M5,15L8,16.39V8H5V15Z' })
	  );
	};
	
	var GlassStangeIcon = function GlassStangeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,2H16V22H8V2M10,4V7H14V4H10Z' })
	  );
	};
	
	var GlassTulipIcon = function GlassTulipIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,2H16C15.67,2.67 15.33,3.33 15.58,5C15.83,6.67 16.67,9.33 16.25,10.74C15.83,12.14 14.17,12.28 13.33,13.86C12.5,15.44 12.5,18.47 13.08,19.9C13.67,21.33 14.83,21.17 15.42,21.25C16,21.33 16,21.67 16,22H8C8,21.67 8,21.33 8.58,21.25C9.17,21.17 10.33,21.33 10.92,19.9C11.5,18.47 11.5,15.44 10.67,13.86C9.83,12.28 8.17,12.14 7.75,10.74C7.33,9.33 8.17,6.67 8.42,5C8.67,3.33 8.33,2.67 8,2M10,4C10,5.19 9.83,6.17 9.64,7H14.27C14.13,6.17 14,5.19 14,4H10Z' })
	  );
	};
	
	var GlassWineIcon = function GlassWineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.5,21.27L14.66,21.18C13.9,21.11 13.25,20.6 13,19.87C12.47,17.91 12.47,15.83 13,13.87C15.32,13.4 17,11.37 17,9C17,7 15,2 15,2H9C9,2 7,7 7,9C7,11.38 8.67,13.42 11,13.9C11.53,15.86 11.53,17.94 11,19.9C10.76,20.62 10.12,21.13 9.37,21.21L8.5,21.3C8.5,21.3 8,21.28 8,22H16C16,21.28 15.5,21.27 15.5,21.27M9.44,7L10.44,4H13.56L14.56,7H9.44Z' })
	  );
	};
	
	var GlassdoorIcon = function GlassdoorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,2C6.34,2 5,3.34 5,5V16.5H8V5H19C19,3.34 17.66,2 16,2H8M16,7.5V19H5C5,20.66 6.34,22 8,22H16C17.66,22 19,20.66 19,19V7.5H16Z' })
	  );
	};
	
	var GlassesIcon = function GlassesIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,10C2.76,10 2.55,10.09 2.41,10.25C2.27,10.4 2.21,10.62 2.24,10.86L2.74,13.85C2.82,14.5 3.4,15 4,15H7C7.64,15 8.36,14.44 8.5,13.82L9.56,10.63C9.6,10.5 9.57,10.31 9.5,10.19C9.39,10.07 9.22,10 9,10H3M7,17H4C2.38,17 0.96,15.74 0.76,14.14L0.26,11.15C0.15,10.3 0.39,9.5 0.91,8.92C1.43,8.34 2.19,8 3,8H9C9.83,8 10.58,8.35 11.06,8.96C11.17,9.11 11.27,9.27 11.35,9.45C11.78,9.36 12.22,9.36 12.64,9.45C12.72,9.27 12.82,9.11 12.94,8.96C13.41,8.35 14.16,8 15,8H21C21.81,8 22.57,8.34 23.09,8.92C23.6,9.5 23.84,10.3 23.74,11.11L23.23,14.18C23.04,15.74 21.61,17 20,17H17C15.44,17 13.92,15.81 13.54,14.3L12.64,11.59C12.26,11.31 11.73,11.31 11.35,11.59L10.43,14.37C10.07,15.82 8.56,17 7,17M15,10C14.78,10 14.61,10.07 14.5,10.19C14.42,10.31 14.4,10.5 14.45,10.7L15.46,13.75C15.64,14.44 16.36,15 17,15H20C20.59,15 21.18,14.5 21.25,13.89L21.76,10.82C21.79,10.62 21.73,10.4 21.59,10.25C21.45,10.09 21.24,10 21,10H15Z' })
	  );
	};
	
	var GlobeModelIcon = function GlobeModelIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.36,2.64L15.95,4.06C17.26,5.37 18,7.14 18,9C18,12.87 14.87,16 11,16C9.15,16 7.37,15.26 6.06,13.95L4.64,15.36C6.08,16.8 7.97,17.71 10,17.93V20H6V22H16V20H12V17.94C16.55,17.43 20,13.58 20,9C20,6.62 19.05,4.33 17.36,2.64M11,3.5C7.96,3.5 5.5,5.96 5.5,9C5.5,12.04 7.96,14.5 11,14.5C14.04,14.5 16.5,12.04 16.5,9C16.5,5.96 14.04,3.5 11,3.5M11,5.5C12.94,5.5 14.5,7.07 14.5,9C14.5,10.93 12.93,12.5 11,12.5C9.07,12.5 7.5,10.93 7.5,9C7.5,7.07 9.07,5.5 11,5.5Z' })
	  );
	};
	
	var GmailIcon = function GmailIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,18H18V9.25L12,13L6,9.25V18H4V6H5.2L12,10.25L18.8,6H20M20,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4Z' })
	  );
	};
	
	var GnomeIcon = function GnomeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.42,2C14.26,2 13.5,7.93 15.82,7.93C18.16,7.93 22.58,2 18.42,2M12,2.73C11.92,2.73 11.85,2.73 11.78,2.74C9.44,3.04 10.26,7.12 11.5,7.19C12.72,7.27 14.04,2.73 12,2.73M7.93,4.34C7.81,4.34 7.67,4.37 7.53,4.43C5.65,5.21 7.24,8.41 8.3,8.2C9.27,8 9.39,4.3 7.93,4.34M4.93,6.85C4.77,6.84 4.59,6.9 4.41,7.03C2.9,8.07 4.91,10.58 5.8,10.19C6.57,9.85 6.08,6.89 4.93,6.85M13.29,8.77C10.1,8.8 6.03,10.42 5.32,13.59C4.53,17.11 8.56,22 12.76,22C14.83,22 17.21,20.13 17.66,17.77C18,15.97 13.65,16.69 13.81,17.88C14,19.31 12.76,20 11.55,19.1C7.69,16.16 17.93,14.7 17.25,10.69C17.03,9.39 15.34,8.76 13.29,8.77Z' })
	  );
	};
	
	var GolfIcon = function GolfIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.5,18C20.33,18 21,18.67 21,19.5C21,20.33 20.33,21 19.5,21C18.67,21 18,20.33 18,19.5C18,18.67 18.67,18 19.5,18M17,5.92L11,9V18.03C13.84,18.19 16,19 16,20C16,21.1 13.31,22 10,22C6.69,22 4,21.1 4,20C4,19.26 5.21,18.62 7,18.27V20H9V2L17,5.92Z' })
	  );
	};
	
	var GondolaIcon = function GondolaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,10H13V7.59L22.12,6.07L21.88,4.59L16.41,5.5C16.46,5.35 16.5,5.18 16.5,5C16.5,4.17 15.83,3.5 15,3.5C14.17,3.5 13.5,4.17 13.5,5C13.5,5.35 13.63,5.68 13.84,5.93L13,6.07V5H11V6.41L10.41,6.5C10.46,6.35 10.5,6.18 10.5,6C10.5,5.17 9.83,4.5 9,4.5C8.17,4.5 7.5,5.17 7.5,6C7.5,6.36 7.63,6.68 7.83,6.93L1.88,7.93L2.12,9.41L11,7.93V10H6C4.89,10 4,10.9 4,12V18C4,19.1 4.9,20 6,20H18C19.1,20 20,19.1 20,18V12C20,10.9 19.1,10 18,10M6,12H8.25V16H6V12M9.75,16V12H14.25V16H9.75M18,16H15.75V12H18V16Z' })
	  );
	};
	
	var GoogleAlloIcon = function GoogleAlloIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,12V21C22,21.5 21.76,21.82 21.3,21.96C20.85,22.1 20.5,21.97 20.2,21.56L18.66,19.45C16.78,21.14 14.56,22 12,22C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,9.25 3,6.9 4.95,4.95C6.9,3 9.25,2 12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12Z' })
	  );
	};
	
	var GoogleAnalyticsIcon = function GoogleAnalyticsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H17L15,21V9L15,5C15,3.9 15.9,3 17,3H19M5,21C3.9,21 3,20.1 3,19V17C3,15.9 3.9,15 5,15H9V11C9,9.9 9.9,9 11,9H14.5V21H5Z' })
	  );
	};
	
	var GoogleAssistantIcon = function GoogleAssistantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,3C11.31,3 14,5.69 14,9C14,12.31 11.31,15 8,15C4.69,15 2,12.31 2,9C2,5.69 4.69,3 8,3M21,8C21.55,8 22,8.45 22,9C22,9.55 21.55,10 21,10C20.45,10 20,9.55 20,9C20,8.45 20.45,8 21,8M17.5,10C18.88,10 20,11.12 20,12.5C20,13.88 18.88,15 17.5,15C16.12,15 15,13.88 15,12.5C15,11.12 16.12,10 17.5,10M17.5,16C19.16,16 20.5,17.34 20.5,19C20.5,20.66 19.16,22 17.5,22C15.84,22 14.5,20.66 14.5,19C14.5,17.34 15.84,16 17.5,16Z' })
	  );
	};
	
	var GoogleCardboardIcon = function GoogleCardboardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.74,6H3.2C2.55,6 2,6.57 2,7.27V17.73C2,18.43 2.55,19 3.23,19H8C8.54,19 9,18.68 9.16,18.21L10.55,14.74C10.79,14.16 11.35,13.75 12,13.75C12.65,13.75 13.21,14.16 13.45,14.74L14.84,18.21C15.03,18.68 15.46,19 15.95,19H20.74C21.45,19 22,18.43 22,17.73V7.27C22,6.57 21.45,6 20.74,6M7.22,14.58C6,14.58 5,13.55 5,12.29C5,11 6,10 7.22,10C8.44,10 9.43,11 9.43,12.29C9.43,13.55 8.44,14.58 7.22,14.58M16.78,14.58C15.56,14.58 14.57,13.55 14.57,12.29C14.57,11.03 15.56,10 16.78,10C18,10 19,11.03 19,12.29C19,13.55 18,14.58 16.78,14.58Z' })
	  );
	};
	
	var GoogleChromeIcon = function GoogleChromeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20L15.46,14H15.45C15.79,13.4 16,12.73 16,12C16,10.8 15.46,9.73 14.62,9H19.41C19.79,9.93 20,10.94 20,12C20,16.42 16.42,20 12,20M4,12C4,10.54 4.39,9.18 5.07,8L8.54,14H8.55C9.24,15.19 10.5,16 12,16C12.45,16 12.88,15.91 13.29,15.77L10.89,19.91C7,19.37 4,16.04 4,12M15,12C15,13.66 13.66,15 12,15C10.34,15 9,13.66 9,12C9,10.34 10.34,9 12,9C13.66,9 15,10.34 15,12M12,4C14.96,4 17.54,5.61 18.92,8H12C10.06,8 8.45,9.38 8.08,11.21L5.7,7.08C7.16,5.21 9.44,4 12,4M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var GoogleCirclesCommunitiesIcon = function GoogleCirclesCommunitiesIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,12C13.89,12 13,12.89 13,14C13,15.1 13.9,16 15,16C16.1,16 17,15.1 17,14C17,12.89 16.1,12 15,12M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M14,9C14,7.89 13.1,7 12,7C10.89,7 10,7.89 10,9C10,10.1 10.9,11 12,11C13.1,11 14,10.1 14,9M9,12C7.9,12 7,12.9 7,14C7,15.1 7.9,16 9,16C10.1,16 11,15.1 11,14C11,12.89 10.1,12 9,12Z' })
	  );
	};
	
	var GoogleCirclesExtendedIcon = function GoogleCirclesExtendedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,19C16.89,19 16,18.1 16,17C16,15.89 16.89,15 18,15C19.1,15 20,15.9 20,17C20,18.1 19.1,19 18,19M18,13C15.79,13 14,14.79 14,17C14,19.21 15.79,21 18,21C20.21,21 22,19.21 22,17C22,14.79 20.21,13 18,13M12,11.1C10.95,11.1 10.1,11.95 10.1,13C10.1,14.05 10.95,14.9 12,14.9C13.05,14.9 13.9,14.05 13.9,13C13.9,11.95 13.05,11.1 12,11.1M6,19C4.89,19 4,18.1 4,17C4,15.89 4.89,15 6,15C7.1,15 8,15.9 8,17C8,18.1 7.1,19 6,19M6,13C3.79,13 2,14.79 2,17C2,19.21 3.79,21 6,21C8.21,21 10,19.21 10,17C10,14.79 8.21,13 6,13M12,4C13.1,4 14,4.9 14,6C14,7.1 13.1,8 12,8C10.89,8 10,7.1 10,6C10,4.89 10.89,4 12,4M12,10C14.21,10 16,8.21 16,6C16,3.79 14.21,2 12,2C9.79,2 8,3.79 8,6C8,8.21 9.79,10 12,10Z' })
	  );
	};
	
	var GoogleCirclesGroupIcon = function GoogleCirclesGroupIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,10C3.9,10 3,10.9 3,12C3,13.11 3.9,14 5,14C6.11,14 7,13.11 7,12C7,10.9 6.1,10 5,10M5,16C2.79,16 1,14.21 1,12C1,9.79 2.79,8 5,8C7.21,8 9,9.79 9,12C9,14.21 7.21,16 5,16M10.5,11H14V8L18,12L14,16V13H10.5V11M5,6C4.55,6 4.11,6.05 3.69,6.14C5.63,3.05 9.08,1 13,1C19.08,1 24,5.92 24,12C24,18.08 19.08,23 13,23C9.08,23 5.63,20.95 3.69,17.86C4.11,17.95 4.55,18 5,18C5.8,18 6.56,17.84 7.25,17.56C8.71,19.07 10.74,20 13,20C17.42,20 21,16.42 21,12C21,7.58 17.42,4 13,4C10.74,4 8.71,4.93 7.25,6.44C6.56,6.16 5.8,6 5,6Z' })
	  );
	};
	
	var GoogleCirclesIcon = function GoogleCirclesIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.66,15H17C18,15 19,14.8 19.87,14.46C19.17,18.73 15.47,22 11,22C6,22 2,17.97 2,13C2,8.53 5.27,4.83 9.54,4.13C9.2,5 9,6 9,7V7.34C6.68,8.16 5,10.38 5,13C5,16.31 7.69,19 11,19C13.62,19 15.84,17.32 16.66,15M17,10C18.66,10 20,8.66 20,7C20,5.34 18.66,4 17,4C15.34,4 14,5.34 14,7C14,8.66 15.34,10 17,10M17,1C20.31,1 23,3.69 23,7C23,10.31 20.31,13 17,13C13.69,13 11,10.31 11,7C11,3.68 13.69,1 17,1Z' })
	  );
	};
	
	var GoogleControllerOffIcon = function GoogleControllerOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L12.73,16H7.97L5,19C4.67,19.3 4.23,19.5 3.75,19.5C2.78,19.5 2,18.72 2,17.75V17.5L3,10.12C3.1,9.09 3.53,8.17 4.19,7.46L2,5.27M5,10V11H7V13H8V11.27L6.73,10H5M16.5,6C18.86,6 20.79,7.81 21,10.12L22,17.5V17.75C22,18.41 21.64,19 21.1,19.28L7.82,6H16.5M16.5,8C16.09,8 15.75,8.34 15.75,8.75C15.75,9.16 16.09,9.5 16.5,9.5C16.91,9.5 17.25,9.16 17.25,8.75C17.25,8.34 16.91,8 16.5,8M14.75,9.75C14.34,9.75 14,10.09 14,10.5C14,10.91 14.34,11.25 14.75,11.25C15.16,11.25 15.5,10.91 15.5,10.5C15.5,10.09 15.16,9.75 14.75,9.75M18.25,9.75C17.84,9.75 17.5,10.09 17.5,10.5C17.5,10.91 17.84,11.25 18.25,11.25C18.66,11.25 19,10.91 19,10.5C19,10.09 18.66,9.75 18.25,9.75M16.5,11.5C16.09,11.5 15.75,11.84 15.75,12.25C15.75,12.66 16.09,13 16.5,13C16.91,13 17.25,12.66 17.25,12.25C17.25,11.84 16.91,11.5 16.5,11.5Z' })
	  );
	};
	
	var GoogleControllerIcon = function GoogleControllerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.97,16L5,19C4.67,19.3 4.23,19.5 3.75,19.5C2.78,19.5 2,18.72 2,17.75V17.5L3,10.12C3.21,7.81 5.14,6 7.5,6H16.5C18.86,6 20.79,7.81 21,10.12L22,17.5V17.75C22,18.72 21.22,19.5 20.25,19.5C19.77,19.5 19.33,19.3 19,19L16.03,16H7.97M7,8V10H5V11H7V13H8V11H10V10H8V8H7M16.5,8C16.09,8 15.75,8.34 15.75,8.75C15.75,9.16 16.09,9.5 16.5,9.5C16.91,9.5 17.25,9.16 17.25,8.75C17.25,8.34 16.91,8 16.5,8M14.75,9.75C14.34,9.75 14,10.09 14,10.5C14,10.91 14.34,11.25 14.75,11.25C15.16,11.25 15.5,10.91 15.5,10.5C15.5,10.09 15.16,9.75 14.75,9.75M18.25,9.75C17.84,9.75 17.5,10.09 17.5,10.5C17.5,10.91 17.84,11.25 18.25,11.25C18.66,11.25 19,10.91 19,10.5C19,10.09 18.66,9.75 18.25,9.75M16.5,11.5C16.09,11.5 15.75,11.84 15.75,12.25C15.75,12.66 16.09,13 16.5,13C16.91,13 17.25,12.66 17.25,12.25C17.25,11.84 16.91,11.5 16.5,11.5Z' })
	  );
	};
	
	var GoogleDriveIcon = function GoogleDriveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.71,3.5L1.15,15L4.58,21L11.13,9.5M9.73,15L6.3,21H19.42L22.85,15M22.28,14L15.42,2H8.58L8.57,2L15.43,14H22.28Z' })
	  );
	};
	
	var GoogleEarthIcon = function GoogleEarthIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,12.14C11.09,10.77 10.14,9.78 9.14,9.19C8.14,8.59 7.27,8.38 6.5,8.55C5.77,8.73 5.14,9.14 4.64,9.8C4.2,10.39 4,11.06 4,11.81V12C4,12.78 4.11,13.58 4.36,14.39C4.45,14.64 4.5,14.64 4.55,14.39C4.67,13.77 4.96,13.31 5.41,13.03C5.87,12.75 6.47,12.76 7.22,13.05C7.97,13.35 8.7,14 9.42,14.95C10.7,16.67 12.2,17.72 13.92,18.09C16.14,18.41 17.81,17.7 18.94,16C19.25,15.39 19.5,14.86 19.64,14.39C19.73,14.08 19.69,14.05 19.5,14.3C19.03,14.92 18.4,15.33 17.6,15.5C16.8,15.7 15.89,15.5 14.86,15C13.83,14.43 12.88,13.5 12,12.14M16.97,8.16C15.41,5.81 13.72,4.5 11.91,4.17C10.47,3.95 8.91,4.45 7.22,5.67C7,5.83 6.9,5.91 6.91,5.93C6.93,5.95 7.06,5.89 7.31,5.77C9.81,4.55 12.22,5.83 14.53,9.61C15.03,10.45 15.55,11.11 16.1,11.58C16.65,12.05 17.16,12.33 17.65,12.42C18.13,12.5 18.57,12.5 18.96,12.38C19.35,12.25 19.7,12.05 20,11.77C20,11.17 19.91,10.5 19.69,9.8C19.19,9.92 18.74,9.88 18.35,9.68C17.96,9.5 17.5,8.97 16.97,8.16M12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12C22,14.75 21,17.1 19.05,19.05C17.1,21 14.75,22 12,22C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,9.25 3,6.9 4.95,4.95C6.9,3 9.25,2 12,2Z' })
	  );
	};
	
	var GoogleFitIcon = function GoogleFitIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.5,5C17.9,8.74 17.1,10.94 13,17.74C17.25,13.87 20,11.2 20,8.5C20,6.5 18.5,5 16.5,5M16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3Z' })
	  );
	};
	
	var GoogleGlassIcon = function GoogleGlassIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,11V13.5H18.87C18.26,17 15.5,19.5 12,19.5C7.86,19.5 4.5,16.14 4.5,12C4.5,7.86 7.86,4.5 12,4.5C14.09,4.5 15.9,5.39 17.16,6.84L18.93,5.06C17.24,3.18 14.83,2 12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.5,22 21.5,17.5 21.5,12V11H13Z' })
	  );
	};
	
	var GoogleHangoutsIcon = function GoogleHangoutsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,11L14,13H12.5L13.5,11H12V8H15M11,11L10,13H8.5L9.5,11H8V8H11M11.5,2C6.81,2 3,5.81 3,10.5C3,15.19 6.81,19 11.5,19H12V22.5C16.86,20.15 20,15 20,10.5C20,5.8 16.19,2 11.5,2Z' })
	  );
	};
	
	var GoogleHomeIcon = function GoogleHomeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.06,7.78C7.5,7.78 7.17,7.73 7.08,7.64L6.66,13.73C7.19,14.05 7.88,14.3 8.72,14.5C9.56,14.71 10.78,14.77 12.38,14.67C13.97,14.58 15.63,14.23 17.34,13.64L16.55,4.22C15.67,5.09 14.38,5.91 12.66,6.66C11.13,7.31 9.81,7.69 8.72,7.78H8.06M7.97,5.34C7.28,5.94 7,6.34 7.13,6.56C7.22,6.78 7.7,6.84 8.58,6.75C9.67,6.66 10.91,6.31 12.28,5.72C13.22,5.31 14.03,4.88 14.72,4.41C15.41,3.94 15.88,3.55 16.13,3.23C16.38,2.92 16.47,2.7 16.41,2.58C16.34,2.42 16.03,2.34 15.47,2.34C14.34,2.34 12.94,2.7 11.25,3.42C9.81,4.05 8.72,4.69 7.97,5.34M17.34,2.2C17.41,2.33 17.44,2.47 17.44,2.63L18.61,17C18.61,18.73 18,20.09 16.83,21.07C15.64,22.05 14.03,22.55 12,22.55C10,22.55 8.4,22.04 7.2,21C6,20 5.39,18.64 5.39,16.92L6.09,6.47C6.09,6.22 6.2,5.94 6.42,5.63C6.64,5.31 6.84,5.06 7.03,4.88L7.36,4.59C8.33,3.78 9.5,3.08 10.88,2.5C11.81,2.08 12.73,1.77 13.62,1.57C14.5,1.37 15.3,1.3 16,1.38C16.71,1.46 17.16,1.73 17.34,2.2Z' })
	  );
	};
	
	var GoogleKeepIcon = function GoogleKeepIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H20C21.1,2 22,2.9 22,4V17.33L17.33,22H4C2.9,22 2,21.1 2,20V4C2,2.9 2.9,2 4,2M17,17V20.25L20.25,17H17M10,19H14V18H15V13C16.21,12.09 17,10.64 17,9C17,6.24 14.76,4 12,4C9.24,4 7,6.24 7,9C7,10.64 7.79,12.09 9,13V18H10V19M14,17H10V16H14V17M14,15H10V14H14V15M12,5C14.21,5 16,6.79 16,9C16,10.5 15.2,11.77 14,12.46V13H10V12.46C8.8,11.77 8,10.5 8,9C8,6.79 9.79,5 12,5Z' })
	  );
	};
	
	var GoogleMapsIcon = function GoogleMapsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.5,4.5C15.5,5.06 15.7,5.54 16.08,5.93C16.45,6.32 16.92,6.5 17.5,6.5C18.05,6.5 18.5,6.32 18.91,5.93C19.3,5.54 19.5,5.06 19.5,4.5C19.5,3.97 19.3,3.5 18.89,3.09C18.5,2.69 18,2.5 17.5,2.5C16.95,2.5 16.5,2.69 16.1,3.09C15.71,3.5 15.5,3.97 15.5,4.5M22,4.5C22,5.5 21.61,6.69 20.86,8.06C20.11,9.44 19.36,10.56 18.61,11.44L17.5,12.75C17.14,12.38 16.72,11.89 16.22,11.3C15.72,10.7 15.05,9.67 14.23,8.2C13.4,6.73 13,5.5 13,4.5C13,3.25 13.42,2.19 14.3,1.31C15.17,0.44 16.23,0 17.5,0C18.73,0 19.8,0.44 20.67,1.31C21.55,2.19 22,3.25 22,4.5M21,11.58V19C21,19.5 20.8,20 20.39,20.39C20,20.8 19.5,21 19,21H5C4.5,21 4,20.8 3.61,20.39C3.2,20 3,19.5 3,19V5C3,4.5 3.2,4 3.61,3.61C4,3.2 4.5,3 5,3H11.2C11.08,3.63 11,4.13 11,4.5C11,5.69 11.44,7.09 12.28,8.7C13.13,10.3 13.84,11.5 14.41,12.21C15,12.95 15.53,13.58 16.03,14.11L17.5,15.7L19,14.11C20.27,12.5 20.94,11.64 21,11.58M9,14.5V15.89H11.25C11,17 10.25,17.53 9,17.53C8.31,17.53 7.73,17.28 7.27,16.78C6.8,16.28 6.56,15.69 6.56,15C6.56,14.31 6.8,13.72 7.27,13.22C7.73,12.72 8.31,12.47 9,12.47C9.66,12.47 10.19,12.67 10.59,13.08L11.67,12.05C10.92,11.36 10.05,11 9.05,11H9C7.91,11 6.97,11.41 6.19,12.19C5.41,12.97 5,13.91 5,15C5,16.09 5.41,17.03 6.19,17.81C6.97,18.59 7.91,19 9,19C10.16,19 11.09,18.63 11.79,17.91C12.5,17.19 12.84,16.25 12.84,15.09C12.84,14.81 12.83,14.61 12.8,14.5H9Z' })
	  );
	};
	
	var GoogleNearbyIcon = function GoogleNearbyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.36,10.46L13.54,2.64C12.69,1.79 11.31,1.79 10.46,2.64L2.64,10.46C1.79,11.31 1.79,12.69 2.64,13.54L10.46,21.36C11.31,22.21 12.69,22.21 13.54,21.36L21.36,13.54C22.21,12.69 22.21,11.31 21.36,10.46M12,19L5,12L12,5L19,12L12,19M16.5,12L12,16.5L7.5,12L12,7.5L16.5,12Z' })
	  );
	};
	
	var GooglePagesIcon = function GooglePagesIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H13V8L17,7L16,11H21V5C21,3.89 20.1,3 19,3M17,17L13,16V21H19C20.1,21 21,20.1 21,19V13H16M8,13H3V19C3,20.1 3.9,21 5,21H11V16L7,17M3,5V11H8L7,7L11,8V3H5C3.89,3 3,3.89 3,5Z' })
	  );
	};
	
	var GooglePhotosIcon = function GooglePhotosIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,13C10.55,13 11,13.18 11.41,13.57C11.8,13.96 12,14.44 12,15V22C12,22.17 11.91,22.27 11.72,22.27C11.66,22.27 11.58,22.22 11.5,22.13L7,17.67V13H10M12.5,1.88L17,6.33V11H14C13.45,11 13,10.82 12.59,10.43C12.2,10.04 12,9.56 12,9V2C12,1.83 12.09,1.73 12.28,1.73C12.34,1.73 12.42,1.78 12.5,1.88M22,12C22.17,12 22.27,12.09 22.27,12.28C22.27,12.34 22.22,12.42 22.13,12.5L17.67,17H13V14C13,13.45 13.18,13 13.57,12.59C13.96,12.2 14.44,12 15,12H22M6.33,7H11V10C11,10.55 10.82,11 10.43,11.41C10.04,11.8 9.56,12 9,12H2C1.83,12 1.73,11.91 1.73,11.72C1.73,11.66 1.78,11.58 1.88,11.5L6.33,7Z' })
	  );
	};
	
	var GooglePhysicalWebIcon = function GooglePhysicalWebIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1.5C16.97,1.5 21,5.53 21,10.5C21,13.11 19.89,15.47 18.11,17.11L17.05,16.05C18.55,14.68 19.5,12.7 19.5,10.5C19.5,6.36 16.14,3 12,3C7.86,3 4.5,6.36 4.5,10.5C4.5,12.7 5.45,14.68 6.95,16.05L5.89,17.11C4.11,15.47 3,13.11 3,10.5C3,5.53 7.03,1.5 12,1.5M12,4.5C15.31,4.5 18,7.19 18,10.5C18,12.28 17.22,13.89 16,15L14.92,13.92C15.89,13.1 16.5,11.87 16.5,10.5C16.5,8 14.5,6 12,6C9.5,6 7.5,8 7.5,10.5C7.5,11.87 8.11,13.1 9.08,13.92L8,15C6.78,13.89 6,12.28 6,10.5C6,7.19 8.69,4.5 12,4.5M8.11,17.65L11.29,14.46C11.68,14.07 12.32,14.07 12.71,14.46L15.89,17.65C16.28,18.04 16.28,18.67 15.89,19.06L12.71,22.24C12.32,22.63 11.68,22.63 11.29,22.24L8.11,19.06C7.72,18.67 7.72,18.04 8.11,17.65Z' })
	  );
	};
	
	var GooglePlayIcon = function GooglePlayIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z' })
	  );
	};
	
	var GooglePlusBoxIcon = function GooglePlusBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M19.5,12H18V10.5H17V12H15.5V13H17V14.5H18V13H19.5V12M9.65,11.36V12.9H12.22C12.09,13.54 11.45,14.83 9.65,14.83C8.11,14.83 6.89,13.54 6.89,12C6.89,10.46 8.11,9.17 9.65,9.17C10.55,9.17 11.13,9.56 11.45,9.88L12.67,8.72C11.9,7.95 10.87,7.5 9.65,7.5C7.14,7.5 5.15,9.5 5.15,12C5.15,14.5 7.14,16.5 9.65,16.5C12.22,16.5 13.96,14.7 13.96,12.13C13.96,11.81 13.96,11.61 13.89,11.36H9.65Z' })
	  );
	};
	
	var GooglePlusIcon = function GooglePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,11H21V9H19V11H17V13H19V15H21V13H23M8,11V13.4H12C11.8,14.4 10.8,16.4 8,16.4C5.6,16.4 3.7,14.4 3.7,12C3.7,9.6 5.6,7.6 8,7.6C9.4,7.6 10.3,8.2 10.8,8.7L12.7,6.9C11.5,5.7 9.9,5 8,5C4.1,5 1,8.1 1,12C1,15.9 4.1,19 8,19C12,19 14.7,16.2 14.7,12.2C14.7,11.7 14.7,11.4 14.6,11H8Z' })
	  );
	};
	
	var GoogleTranslateIcon = function GoogleTranslateIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,5H10.88L10,2H4C2.9,2 2,2.9 2,4V17C2,18.1 2.9,19 4,19H11L12,22H20C21.1,22 22,21.1 22,20V7C22,5.9 21.1,5 20,5M7.17,14.59C4.91,14.59 3.08,12.76 3.08,10.5C3.08,8.24 4.91,6.41 7.17,6.41C8.21,6.41 9.16,6.78 9.91,7.5L10,7.54L8.75,8.72L8.69,8.67C8.4,8.4 7.91,8.08 7.17,8.08C5.86,8.08 4.79,9.17 4.79,10.5C4.79,11.83 5.86,12.92 7.17,12.92C8.54,12.92 9.13,12.05 9.29,11.46H7.08V9.91H11.03L11.04,10C11.08,10.19 11.09,10.38 11.09,10.59C11.09,12.94 9.5,14.59 7.17,14.59M13.2,12.88C13.53,13.5 13.94,14.06 14.39,14.58L13.85,15.11L13.2,12.88M13.97,12.12H13L12.67,11.08H16.66C16.66,11.08 16.32,12.39 15.1,13.82C14.58,13.2 14.21,12.59 13.97,12.12M21,20C21,20.55 20.55,21 20,21H13L15,19L14.19,16.23L15.11,15.31L17.79,18L18.5,17.27L15.81,14.59C16.71,13.56 17.41,12.34 17.73,11.08H19V10.04H15.36V9H14.32V10.04H12.36L11.18,6H20C20.55,6 21,6.45 21,7V20Z' })
	  );
	};
	
	var GoogleWalletIcon = function GoogleWalletIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.44,2.56H20.24C20.24,2.56 23.12,11.36 20.24,21.5H15.5C15.5,21.5 15.12,16.8 13.28,12.8C13.28,12.8 12.5,16.08 11.6,18H6.72C6.72,18 5.76,13.44 2.5,9.5H7.28C7.28,9.5 8.16,10.4 8.88,11.6C8.88,11.6 9.5,9.12 9.5,6H14.32C14.32,6 15.92,8.32 16.64,9.76C16.64,9.76 16.4,6.24 15.44,2.56Z' })
	  );
	};
	
	var GoogleIcon = function GoogleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.35,11.1H12.18V13.83H18.69C18.36,17.64 15.19,19.27 12.19,19.27C8.36,19.27 5,16.25 5,12C5,7.9 8.2,4.73 12.2,4.73C15.29,4.73 17.1,6.7 17.1,6.7L19,4.72C19,4.72 16.56,2 12.1,2C6.42,2 2.03,6.8 2.03,12C2.03,17.05 6.16,22 12.25,22C17.6,22 21.5,18.33 21.5,12.91C21.5,11.76 21.35,11.1 21.35,11.1V11.1Z' })
	  );
	};
	
	var GpuIcon = function GpuIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,7V8.5H3V17H4.5V7C3.7,7 2.8,7 2,7M6,7V7L6,16H7V17H14V16H22V7H6M17.5,9C18.88,9 20,10.12 20,11.5C20,12.88 18.88,14 17.5,14C16.12,14 15,12.88 15,11.5C15,10.12 16.12,9 17.5,9Z' })
	  );
	};
	
	var GradientIcon = function GradientIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,9H13V11H11V9M9,11H11V13H9V11M13,11H15V13H13V11M15,9H17V11H15V9M7,9H9V11H7V9M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M9,18H7V16H9V18M13,18H11V16H13V18M17,18H15V16H17V18M19,11H17V13H19V15H17V13H15V15H13V13H11V15H9V13H7V15H5V13H7V11H5V5H19V11Z' })
	  );
	};
	
	var GraphqlIcon = function GraphqlIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,5.37L11.56,5.31L6,14.9C6.24,15.11 6.4,15.38 6.47,15.68H17.53C17.6,15.38 17.76,15.11 18,14.9L12.44,5.31L12,5.37M6.6,16.53L10.88,19.06C11.17,18.79 11.57,18.63 12,18.63C12.43,18.63 12.83,18.79 13.12,19.06L17.4,16.53H6.6M12,22C11.07,22 10.32,21.25 10.32,20.32L10.41,19.76L6.11,17.21C5.8,17.57 5.35,17.79 4.84,17.79C3.91,17.79 3.16,17.04 3.16,16.11C3.16,15.32 3.69,14.66 4.42,14.47V9.36C3.59,9.25 2.95,8.54 2.95,7.68C2.95,6.75 3.7,6 4.63,6C5.18,6 5.66,6.26 5.97,6.66L10.38,4.13L10.32,3.68C10.32,2.75 11.07,2 12,2C12.93,2 13.68,2.75 13.68,3.68L13.62,4.13L18.03,6.66C18.34,6.26 18.82,6 19.37,6C20.3,6 21.05,6.75 21.05,7.68C21.05,8.54 20.41,9.25 19.58,9.36V14.47C20.31,14.66 20.84,15.32 20.84,16.11C20.84,17.04 20.09,17.79 19.16,17.79C18.65,17.79 18.2,17.57 17.89,17.21L13.59,19.76L13.68,20.32C13.68,21.25 12.93,22 12,22M10.8,4.86L6.3,7.44L6.32,7.68C6.32,8.39 5.88,9 5.26,9.25L5.29,14.5L10.8,4.86M13.2,4.86L18.71,14.5L18.74,9.25C18.12,9 17.68,8.39 17.68,7.68L17.7,7.44L13.2,4.86Z' })
	  );
	};
	
	var GreasePencilIcon = function GreasePencilIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.62,1.5C18.11,1.5 17.6,1.69 17.21,2.09L10.75,8.55L14.95,12.74L21.41,6.29C22.2,5.5 22.2,4.24 21.41,3.46L20.04,2.09C19.65,1.69 19.14,1.5 18.62,1.5M9.8,9.5L3.23,16.07L3.93,16.77C3.4,17.24 2.89,17.78 2.38,18.29C1.6,19.08 1.6,20.34 2.38,21.12C3.16,21.9 4.42,21.9 5.21,21.12C5.72,20.63 6.25,20.08 6.73,19.58L7.43,20.27L14,13.7' })
	  );
	};
	
	var GreaterThanOrEqualIcon = function GreaterThanOrEqualIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.5,2.27L20,10.14L6.5,18L5.5,16.27L16.03,10.14L5.5,4L6.5,2.27M20,20V22H5V20H20Z' })
	  );
	};
	
	var GreaterThanIcon = function GreaterThanIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.5,4.14L4.5,5.86L15,12L4.5,18.14L5.5,19.86L19,12L5.5,4.14Z' })
	  );
	};
	
	var GridLargeIcon = function GridLargeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H20C21.1,2 22,2.9 22,4V20C22,21.1 21.1,22 20,22H4C2.92,22 2,21.1 2,20V4C2,2.9 2.9,2 4,2M4,4V11H11V4H4M4,20H11V13H4V20M20,20V13H13V20H20M20,4H13V11H20V4Z' })
	  );
	};
	
	var GridOffIcon = function GridOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M0,2.77L1.28,1.5L22.5,22.72L21.23,24L19.23,22H4C2.92,22 2,21.1 2,20V4.77L0,2.77M10,4V7.68L8,5.68V4H6.32L4.32,2H20C21.1,2 22,2.9 22,4V19.7L20,17.7V16H18.32L16.32,14H20V10H16V13.68L14,11.68V10H12.32L10.32,8H14V4H10M16,4V8H20V4H16M16,20H17.23L16,18.77V20M4,8H5.23L4,6.77V8M10,14H11.23L10,12.77V14M14,20V16.77L13.23,16H10V20H14M8,20V16H4V20H8M8,14V10.77L7.23,10H4V14H8Z' })
	  );
	};
	
	var GridIcon = function GridIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,4V8H14V4H10M16,4V8H20V4H16M16,10V14H20V10H16M16,16V20H20V16H16M14,20V16H10V20H14M8,20V16H4V20H8M8,14V10H4V14H8M8,8V4H4V8H8M10,14H14V10H10V14M4,2H20C21.1,2 22,2.9 22,4V20C22,21.1 21.1,22 20,22H4C2.92,22 2,21.1 2,20V4C2,2.9 2.9,2 4,2Z' })
	  );
	};
	
	var GroupIcon = function GroupIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,1V5H2V19H1V23H5V22H19V23H23V19H22V5H23V1H19V2H5V1M5,4H19V5H20V19H19V20H5V19H4V5H5M6,6V14H9V18H18V9H14V6M8,8H12V12H8M14,11H16V16H11V14H14' })
	  );
	};
	
	var GuitarAcousticIcon = function GuitarAcousticIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.59,3H22V5H20.41L16.17,9.24C15.8,8.68 15.32,8.2 14.76,7.83L19.59,3M12,8C14.21,8 16,9.79 16,12C16,13.82 14.77,15.42 13,15.87V16C13,18.76 10.76,21 8,21C5.24,21 3,18.76 3,16C3,13.24 5.24,11 8,11H8.13C8.58,9.24 10.17,8 12,8M12,10.5C11.17,10.5 10.5,11.17 10.5,12C10.5,12.83 11.17,13.5 12,13.5C12.83,13.5 13.5,12.83 13.5,12C13.5,11.17 12.83,10.5 12,10.5M6.94,14.24L6.23,14.94L9.06,17.77L9.77,17.06L6.94,14.24Z' })
	  );
	};
	
	var GuitarElectricIcon = function GuitarElectricIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.59,3H22V5H20.41L15.12,10.29L13.71,8.9L19.59,3M12,9C12.26,9 12.5,9.1 12.71,9.3L14.71,11.3C14.89,11.5 15,11.73 15,12L14.9,12.4L10.9,20.4C10.71,20.75 10.36,20.93 10,20.93C9.65,20.93 9.29,20.75 9.11,20.4L7.25,16.7L3.55,14.9C3.18,14.7 3,14.35 3,14C3,13.65 3.18,13.3 3.55,13.1L11.55,9.1C11.69,9 11.84,9 12,9M9.35,11.82L8.65,12.5L11.5,15.35L12.18,14.65L9.35,11.82M7.94,13.23L7.23,13.94L10.06,16.77L10.77,16.06L7.94,13.23Z' })
	  );
	};
	
	var GuitarPickOutlineIcon = function GuitarPickOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,4.1C18.1,3.3 17,2.8 15.8,2.5C15.5,2.4 13.6,2 12.2,2C12.2,2 12.1,2 12,2C12,2 11.9,2 11.8,2C10.4,2 8.4,2.4 8.1,2.5C7,2.8 5.9,3.3 5,4.1C3,5.9 3,8.7 4,11C5,13.5 6.1,15.7 7.6,17.9C8.8,19.6 10.1,22 12,22C13.9,22 15.2,19.6 16.5,17.9C18,15.8 19.1,13.5 20.1,11C21,8.7 21,5.9 19,4.1M18.2,10.2C17.1,12.9 16.1,14.9 14.8,16.7C14.6,16.9 14.5,17.2 14.3,17.4C13.8,18.2 12.6,20 12,20C12,20 12,20 12,20C11.3,20 10.2,18.3 9.6,17.4C9.4,17.2 9.3,16.9 9.1,16.7C7.9,14.9 6.8,12.9 5.7,10.2C5.5,9.5 4.7,7 6.3,5.5C6.8,5 7.6,4.7 8.6,4.4C9,4.4 10.7,4 11.8,4C11.8,4 12.1,4 12.1,4C13.2,4 14.9,4.3 15.3,4.4C16.3,4.7 17.1,5 17.6,5.5C19.3,7 18.5,9.5 18.2,10.2Z' })
	  );
	};
	
	var GuitarPickIcon = function GuitarPickIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,4.1C18.1,3.3 17,2.8 15.8,2.5C15.5,2.4 13.6,2 12.2,2C12.2,2 12.1,2 12,2C12,2 11.9,2 11.8,2C10.4,2 8.4,2.4 8.1,2.5C7,2.8 5.9,3.3 5,4.1C3,5.9 3,8.7 4,11C5,13.5 6.1,15.7 7.6,17.9C8.8,19.6 10.1,22 12,22C13.9,22 15.2,19.6 16.5,17.9C18,15.8 19.1,13.5 20.1,11C21,8.7 21,5.9 19,4.1Z' })
	  );
	};
	
	var GuyFawkesMaskIcon = function GuyFawkesMaskIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,13C21,17.97 16.97,22 12,22C7.03,22 3,17.97 3,13L3.03,4.43C5.68,2.88 8.76,2 12.05,2C15.3,2 18.36,2.87 21,4.38V13M13,19.93C16.39,19.44 19,16.5 19,13V5.59C16.9,4.57 14.54,4 12.05,4C9.5,4 7.08,4.6 4.94,5.66L5,13C5,16.5 7.63,19.44 11,19.93V18H13V19.93M11,16H8L6,13L9,14H10L11,13H13L14,14H15L18,13L16,16H13L12,15L11,16M6,9.03C6.64,8.4 7.5,8.05 8.5,8.05C9.45,8.05 10.34,8.4 11,9.03C10.34,9.65 9.45,10 8.5,10C7.5,10 6.64,9.65 6,9.03M13,9.03C13.64,8.4 14.5,8.05 15.5,8.05C16.45,8.05 17.34,8.4 18,9.03C17.34,9.65 16.45,10 15.5,10C14.5,10 13.64,9.65 13,9.03Z' })
	  );
	};
	
	var HackernewsIcon = function HackernewsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,2H22V22H2V2M11.25,17.5H12.75V13.06L16,7H14.5L12,11.66L9.5,7H8L11.25,13.06V17.5Z' })
	  );
	};
	
	var HamburgerIcon = function HamburgerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,16H22V18C22,19.11 21.11,20 20,20H4C2.89,20 2,19.11 2,18V16M6,4H18C20.22,4 22,5.78 22,8V10H2V8C2,5.78 3.78,4 6,4M4,11H15L17,13L19,11H20C21.11,11 22,11.89 22,13C22,14.11 21.11,15 20,15H4C2.89,15 2,14.11 2,13C2,11.89 2.89,11 4,11Z' })
	  );
	};
	
	var HammerIcon = function HammerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,5L19,8L18.5,8.5C19.5,9.5 20,10 20.5,9.5L22,11C22,12 20.5,13.5 19.5,13.5L18,12C18.5,11.5 18,11 17,10L16,11L13,8C14.5,6 13,4 9,5C10,4 11,3 12,3C12.5,3 14,3 16,5M2,20L4,22L14,12L12,10L2,20Z' })
	  );
	};
	
	var HandPointingRightIcon = function HandPointingRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,9C21.55,9 22,9.45 22,10C22,10.55 21.55,11 21,11H16.53L16.4,12.21L14.2,17.15C14,17.65 13.47,18 12.86,18H8.5C7.7,18 7,17.27 7,16.5V10C7,9.61 7.16,9.26 7.43,9L11.63,4.1L12.4,4.84C12.6,5.03 12.72,5.29 12.72,5.58L12.69,5.8L11,9H21M2,18V10H5V18H2Z' })
	  );
	};
	
	var HangerIcon = function HangerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.76,16.34H20.75C21.5,16.77 22,17.58 22,18.5C22,19.88 20.88,21 19.5,21H4.5C3.12,21 2,19.88 2,18.5C2,17.58 2.5,16.77 3.25,16.34H3.24L11,11.86C11,11.86 11,11 12,10C13,10 14,9.1 14,8C14,6.9 13.1,6 12,6C10.9,6 10,6.9 10,8H8C8,5.79 9.79,4 12,4C14.21,4 16,5.79 16,8C16,9.86 14.73,11.42 13,11.87L20.76,16.34M4.5,19V19H19.5V19C19.67,19 19.84,18.91 19.93,18.75C20.07,18.5 20,18.21 19.75,18.07L12,13.59L4.25,18.07C4,18.21 3.93,18.5 4.07,18.75C4.16,18.91 4.33,19 4.5,19Z' })
	  );
	};
	
	var HardHatIcon = function HardHatIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.87,12.15L9,6.46C10.95,5.84 13.05,5.84 15,6.46L14.13,12.15C14.06,12.64 13.63,13 13.13,13H10.86C10.37,13 9.94,12.64 9.87,12.15M22,16V16C22,15.21 21.53,14.5 20.8,14.17C20.32,11.86 18.96,9.83 17,8.5L15.24,13.34C15.1,13.74 14.72,14 14.3,14H9.7C9.28,14 8.9,13.74 8.76,13.34L7,8.5C5.04,9.83 3.68,11.86 3.2,14.16C2.47,14.5 2,15.2 2,16L8.45,17.84C8.81,17.94 9.18,18 9.55,18H14.43C14.8,18 15.17,17.94 15.53,17.84L22,16Z' })
	  );
	};
	
	var HarddiskIcon = function HarddiskIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M12,4C8.69,4 6,6.69 6,10C6,13.31 8.69,16 12.1,16L11.22,13.77C10.95,13.29 11.11,12.68 11.59,12.4L12.45,11.9C12.93,11.63 13.54,11.79 13.82,12.27L15.74,14.69C17.12,13.59 18,11.9 18,10C18,6.69 15.31,4 12,4M12,9C12.55,9 13,9.45 13,10C13,10.55 12.55,11 12,11C11.45,11 11,10.55 11,10C11,9.45 11.45,9 12,9M7,18C6.45,18 6,18.45 6,19C6,19.55 6.45,20 7,20C7.55,20 8,19.55 8,19C8,18.45 7.55,18 7,18M12.09,13.27L14.58,19.58L17.17,18.08L12.95,12.77L12.09,13.27Z' })
	  );
	};
	
	var HeadphonesBluetoothIcon = function HeadphonesBluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,6C4.69,6 2,8.69 2,12V16.8C2,17.46 2.54,18 3.2,18H6V14H4V12C4,9.79 5.79,8 8,8C10.21,8 12,9.79 12,12V14H10V18H12.8C13.46,18 14,17.46 14,16.8V12C14,8.69 11.31,6 8,6M19,7V10.79L16.71,8.5L16,9.21L18.79,12L16,14.79L16.71,15.5L19,13.21V17H19.5L22.35,14.14L20.21,12L22.35,9.85L19.5,7H19M20,8.91L20.94,9.85L20,10.79V8.91M20,13.21L20.94,14.14L20,15.08V13.21Z' })
	  );
	};
	
	var HeadphonesBoxIcon = function HeadphonesBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.2,18C6.54,18 6,17.46 6,16.8V13.2L6,12C6,8.69 8.69,6 12,6C15.31,6 18,8.69 18,12V13.2L18,16.8C18,17.46 17.46,18 16.8,18H14V14H16V12C16,9.79 14.21,8 12,8C9.79,8 8,9.79 8,12V14H10V18M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z' })
	  );
	};
	
	var HeadphonesOffIcon = function HeadphonesOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1C7.03,1 3,5.03 3,10V17C3,17.62 3.19,18.19 3.5,18.67L9,13.18V12H5V10C5,6.13 8.13,3 12,3C14,3 15.77,3.82 17.04,5.14L18.45,3.72C16.82,2.04 14.53,1 12,1M21.22,3.5L3.5,21.22L4.77,22.5L7.27,20H9V18.27L15,12.27V20H18C19.66,20 21,18.66 21,17V10C21,8.89 20.8,7.82 20.43,6.84L22.5,4.77L21.22,3.5M18.83,8.44C18.94,8.94 19,9.46 19,10V12H15.27L18.83,8.44Z' })
	  );
	};
	
	var HeadphonesSettingsIcon = function HeadphonesSettingsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1C16.97,1 21,5.03 21,10V17C21,18.66 19.66,20 18,20H15V12H19V10C19,6.13 15.87,3 12,3C8.13,3 5,6.13 5,10V12H9V20H6C4.34,20 3,18.66 3,17V10C3,5.03 7.03,1 12,1M15,24V22H17V24H15M11,24V22H13V24H11M7,24V22H9V24H7Z' })
	  );
	};
	
	var HeadphonesIcon = function HeadphonesIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1C7,1 3,5 3,10V17C3,18.66 4.34,20 6,20H9V12H5V10C5,6.13 8.13,3 12,3C15.87,3 19,6.13 19,10V12H15V20H18C19.66,20 21,18.66 21,17V10C21,5 16.97,1 12,1Z' })
	  );
	};
	
	var HeadsetDockIcon = function HeadsetDockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,18H9V6.13C7.27,6.57 6,8.14 6,10V11H8V17H6C4.9,17 4,16.1 4,15V10C4,6.69 6.69,4 10,4H11C14.31,4 17,6.69 17,10V12H18V9H20V12C20,13.1 19.1,14 18,14H17V15C17,16.1 16.1,17 15,17H13V11H15V10C15,8.14 13.73,6.57 12,6.13V18H22V20H2V18Z' })
	  );
	};
	
	var HeadsetOffIcon = function HeadsetOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22.5,4.77L20.43,6.84C20.8,7.82 21,8.89 21,10V20C21,21.66 19.66,23 18,23H12V21H19V20H15V12.27L9,18.27V20H7.27L4.77,22.5L3.5,21.22L21.22,3.5L22.5,4.77M12,1C14.53,1 16.82,2.04 18.45,3.72L17.04,5.14C15.77,3.82 14,3 12,3C8.13,3 5,6.13 5,10V12H9V13.18L3.5,18.67C3.19,18.19 3,17.62 3,17V10C3,5.03 7.03,1 12,1M19,12V10C19,9.46 18.94,8.94 18.83,8.44L15.27,12H19Z' })
	  );
	};
	
	var HeadsetIcon = function HeadsetIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1C7,1 3,5 3,10V17C3,18.66 4.34,20 6,20H9V12H5V10C5,6.13 8.13,3 12,3C15.87,3 19,6.13 19,10V12H15V20H19V21H12V23H18C19.66,23 21,21.66 21,20V10C21,5 16.97,1 12,1Z' })
	  );
	};
	
	var HeartBoxOutlineIcon = function HeartBoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,17L11.28,16.34C8.7,14 7,12.46 7,10.57C7,9.03 8.21,7.82 9.75,7.82C10.62,7.82 11.45,8.23 12,8.87C12.55,8.23 13.38,7.82 14.25,7.82C15.79,7.82 17,9.03 17,10.57C17,12.46 15.3,14 12.72,16.34L12,17M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M5,5V19H19V5H5Z' })
	  );
	};
	
	var HeartBoxIcon = function HeartBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M12,17L12.72,16.34C15.3,14 17,12.46 17,10.57C17,9.03 15.79,7.82 14.25,7.82C13.38,7.82 12.55,8.23 12,8.87C11.45,8.23 10.62,7.82 9.75,7.82C8.21,7.82 7,9.03 7,10.57C7,12.46 8.7,14 11.28,16.34L12,17Z' })
	  );
	};
	
	var HeartBrokenIcon = function HeartBrokenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C8.17,3 8.82,3.12 9.44,3.33L13,9.35L9,14.35L12,21.35V21.35M16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35L11,14.35L15.5,9.35L12.85,4.27C13.87,3.47 15.17,3 16.5,3Z' })
	  );
	};
	
	var HeartCircleOutlineIcon = function HeartCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4M9.75,7.82C8.21,7.82 7,9.03 7,10.57C7,12.46 8.7,14 11.28,16.34L12,17L12.72,16.34C15.3,14 17,12.46 17,10.57C17,9.03 15.79,7.82 14.25,7.82C13.38,7.82 12.55,8.23 12,8.87C11.45,8.23 10.62,7.82 9.75,7.82Z' })
	  );
	};
	
	var HeartCircleIcon = function HeartCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.47,2 2,6.5 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M9.75,7.82C10.62,7.82 11.45,8.23 12,8.87C12.55,8.23 13.38,7.82 14.25,7.82C15.79,7.82 17,9.03 17,10.57C17,12.46 15.3,14 12.72,16.34L12,17L11.28,16.34C8.7,14 7,12.46 7,10.57C7,9.03 8.21,7.82 9.75,7.82Z' })
	  );
	};
	
	var HeartHalfFullIcon = function HeartHalfFullIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.5,5C15,5 13.58,5.91 13,7.2V17.74C17.25,13.87 20,11.2 20,8.5C20,6.5 18.5,5 16.5,5M16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3Z' })
	  );
	};
	
	var HeartHalfOutlineIcon = function HeartHalfOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,8.5C4,11.2 6.75,13.87 11,17.74V7.2C10.42,5.91 9,5 7.5,5C5.5,5 4,6.5 4,8.5M13,7.2V17.74L13,20.44L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C10,3 13,5 13,7.2Z' })
	  );
	};
	
	var HeartHalfIcon = function HeartHalfIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,7.2V17.74L13,20.44L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C10,3 13,5 13,7.2Z' })
	  );
	};
	
	var HeartOffIcon = function HeartOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,4.27L2.28,3L20,20.72L18.73,22L15.18,18.44L13.45,20.03L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,7.55 2.23,6.67 2.63,5.9L1,4.27M7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,11.07 20.42,13.32 17.79,15.97L5.27,3.45C5.95,3.16 6.7,3 7.5,3Z' })
	  );
	};
	
	var HeartOutlineIcon = function HeartOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.1,18.55L12,18.65L11.89,18.55C7.14,14.24 4,11.39 4,8.5C4,6.5 5.5,5 7.5,5C9.04,5 10.54,6 11.07,7.36H12.93C13.46,6 14.96,5 16.5,5C18.5,5 20,6.5 20,8.5C20,11.39 16.86,14.24 12.1,18.55M16.5,3C14.76,3 13.09,3.81 12,5.08C10.91,3.81 9.24,3 7.5,3C4.42,3 2,5.41 2,8.5C2,12.27 5.4,15.36 10.55,20.03L12,21.35L13.45,20.03C18.6,15.36 22,12.27 22,8.5C22,5.41 19.58,3 16.5,3Z' })
	  );
	};
	
	var HeartPulseIcon = function HeartPulseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.5,4C4.46,4 2,6.46 2,9.5C2,10 2.09,10.5 2.22,11H6.3L7.57,7.63C7.87,6.83 9.05,6.75 9.43,7.63L11.5,13L12.09,11.58C12.22,11.25 12.57,11 13,11H21.78C21.91,10.5 22,10 22,9.5C22,6.46 19.54,4 16.5,4C14.64,4 13,4.93 12,6.34C11,4.93 9.36,4 7.5,4V4M3,12.5C2.45,12.5 2,12.95 2,13.5C2,14.05 2.45,14.5 3,14.5H5.44L11,20C12,20.9 12,20.9 13,20L18.56,14.5H21C21.55,14.5 22,14.05 22,13.5C22,12.95 21.55,12.5 21,12.5H13.4L12.47,14.8C12.07,15.81 10.92,15.67 10.55,14.83L8.5,9.5L7.54,11.83C7.39,12.21 7.05,12.5 6.6,12.5H3Z' })
	  );
	};
	
	var HeartIcon = function HeartIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z' })
	  );
	};
	
	var HelpBoxIcon = function HelpBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,18H13V16H11V18M12,6C9.79,6 8,7.79 8,10H10C10,8.9 10.9,8 12,8C13.1,8 14,8.9 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10C16,7.79 14.21,6 12,6M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3Z' })
	  );
	};
	
	var HelpCircleOutlineIcon = function HelpCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,18H13V16H11V18M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6C9.79,6 8,7.79 8,10H10C10,8.9 10.9,8 12,8C13.1,8 14,8.9 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10C16,7.79 14.21,6 12,6Z' })
	  );
	};
	
	var HelpCircleIcon = function HelpCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7C10.9,7 10,7.9 10,9H8C8,6.79 9.79,5 12,5C14.21,5 16,6.79 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.47 17.5,2 12,2Z' })
	  );
	};
	
	var HelpNetworkIcon = function HelpNetworkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,3C18.1,3 19,3.9 19,5V15C19,16.1 18.1,17 17,17H13V19H14C14.55,19 15,19.45 15,20H22V22H15C15,22.55 14.55,23 14,23H10C9.45,23 9,22.55 9,22H2V20H9C9,19.45 9.45,19 10,19H11V17H7C5.89,17 5,16.1 5,15V5C5,3.9 5.9,3 7,3H17M12.19,5C11.32,5 10.62,5.2 10.08,5.59C9.56,6 9.3,6.57 9.31,7.36L9.32,7.39H11.25C11.26,7.09 11.35,6.86 11.53,6.7C11.71,6.55 11.93,6.47 12.19,6.47C12.5,6.47 12.76,6.57 12.94,6.75C13.12,6.94 13.2,7.2 13.2,7.5C13.2,7.82 13.13,8.09 12.97,8.32C12.83,8.55 12.62,8.75 12.36,8.91C11.85,9.25 11.5,9.55 11.31,9.82C11.11,10.08 11,10.5 11,11H13C13,10.69 13.04,10.44 13.13,10.26C13.22,10.07 13.39,9.9 13.64,9.74C14.09,9.5 14.46,9.21 14.75,8.81C15.04,8.41 15.19,8 15.19,7.5C15.19,6.74 14.92,6.13 14.38,5.68C13.85,5.23 13.12,5 12.19,5M11,12V14H13V12H11Z' })
	  );
	};
	
	var HelpIcon = function HelpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,19H13V22H10V19M12,2C17.35,2.22 19.68,7.62 16.5,11.67C15.67,12.67 14.33,13.33 13.67,14.17C13,15 13,16 13,17H10C10,15.33 10,13.92 10.67,12.92C11.33,11.92 12.67,11.33 13.5,10.67C15.92,8.43 15.32,5.26 12,5C10.34,5 9,6.34 9,8H6C6,4.69 8.69,2 12,2Z' })
	  );
	};
	
	var HexagonMultipleIcon = function HexagonMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.25,2C10.44,2 10.61,2.11 10.69,2.26L12.91,6.22L13,6.5L12.91,6.78L10.69,10.74C10.61,10.89 10.44,11 10.25,11H5.75C5.56,11 5.39,10.89 5.31,10.74L3.09,6.78L3,6.5L3.09,6.22L5.31,2.26C5.39,2.11 5.56,2 5.75,2H10.25M10.25,13C10.44,13 10.61,13.11 10.69,13.26L12.91,17.22L13,17.5L12.91,17.78L10.69,21.74C10.61,21.89 10.44,22 10.25,22H5.75C5.56,22 5.39,21.89 5.31,21.74L3.09,17.78L3,17.5L3.09,17.22L5.31,13.26C5.39,13.11 5.56,13 5.75,13H10.25M19.5,7.5C19.69,7.5 19.86,7.61 19.94,7.76L22.16,11.72L22.25,12L22.16,12.28L19.94,16.24C19.86,16.39 19.69,16.5 19.5,16.5H15C14.81,16.5 14.64,16.39 14.56,16.24L12.34,12.28L12.25,12L12.34,11.72L14.56,7.76C14.64,7.61 14.81,7.5 15,7.5H19.5Z' })
	  );
	};
	
	var HexagonOutlineIcon = function HexagonOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z' })
	  );
	};
	
	var HexagonIcon = function HexagonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5Z' })
	  );
	};
	
	var HighDefinitionBoxIcon = function HighDefinitionBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M11,15H9.5V13H7.5V15H6V9H7.5V11.5H9.5V9H11V15M13,9H17C17.55,9 18,9.45 18,10V14C18,14.55 17.55,15 17,15H13V9M14.5,13.5H16.5V10.5H14.5V13.5Z' })
	  );
	};
	
	var HighDefinitionIcon = function HighDefinitionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,7H7V11H9V7H11V17H9V13H7V17H5V7M13,7H16C17.66,7 19,8.34 19,10V14C19,15.66 17.66,17 16,17H13V7M16,15C16.55,15 17,14.55 17,14V10C17,9.45 16.55,9 16,9H15V15H16Z' })
	  );
	};
	
	var HighwayIcon = function HighwayIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,2L8,8H11V2H10M13,2V8H16L14,2H13M2,9V10H4V11H6V10H18L18.06,11H20V10H22V9H2M7,11L3.34,22H11V11H7M13,11V22H20.66L17,11H13Z' })
	  );
	};
	
	var HinduismIcon = function HinduismIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,2L13.5,3.5L15,5L16.5,3.5L15,2M11,3C10,9 17,10 20,6L18,4.5C17,6 13,8 11,3M9,7C7,7 4.5,8.5 4.5,8.5L6,11C7,10 9,9.5 10,10C12,11 9,13 7,12V15.5C10,14 12,16 11,17.5C8,22 3,16 3,13C1,19 6,22 9,22C12,22 14,20 12.5,15H14C12.5,19.5 18,24 21,18C22,16 22,9.5 17,9.5C13,9.5 14,15 10.5,13.5C14,10 12,7 9,7M19,12C22,15 15,21 15,15C15,13 17,10.5 19,12Z' })
	  );
	};
	
	var HistoryIcon = function HistoryIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.5,8H12V13L16.28,15.54L17,14.33L13.5,12.25V8M13,3C8.03,3 4,7.03 4,12H1L4.96,16.03L9,12H6C6,8.13 9.13,5 13,5C16.87,5 20,8.13 20,12C20,15.87 16.87,19 13,19C11.07,19 9.32,18.21 8.06,16.94L6.64,18.36C8.27,20 10.5,21 13,21C17.97,21 22,16.97 22,12C22,7.03 17.97,3 13,3' })
	  );
	};
	
	var HockeyPuckIcon = function HockeyPuckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,5C6.5,5 2,6.57 2,8.5C2,10.43 6.5,12 12,12C17.5,12 22,10.43 22,8.5C22,6.57 17.5,5 12,5M2,11.76V16.5C2,18.43 6.5,20 12,20C17.5,20 22,18.43 22,16.5V11.76C21.33,12.22 20.58,12.57 19.73,12.86C17.62,13.6 14.95,14 12,14C9.05,14 6.38,13.6 4.27,12.86C3.42,12.57 2.67,12.22 2,11.76Z' })
	  );
	};
	
	var HockeySticksIcon = function HockeySticksIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.58,3L5.05,4.61L9.04,10.87L10.82,8.08L7.58,3M16.43,3L7.5,17H2V21H8.5L18.96,4.61L16.43,3M14.97,14.59L13.19,17.38L15.5,21H22V17H16.5L14.97,14.59Z' })
	  );
	};
	
	var HololensIcon = function HololensIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,8C12,8 22,8 22,11C22,11 22.09,14.36 21.75,14.25C21,11 12,11 12,11C12,11 3,11 2.25,14.25C1.91,14.36 2,11 2,11C2,8 12,8 12,8M12,12C20,12 20.75,14.25 20.75,14.25C19.75,17.25 19,18 15,18C12,18 13,16.5 12,16.5C11,16.5 12,18 9,18C5,18 4.25,17.25 3.25,14.25C3.25,14.25 4,12 12,12Z' })
	  );
	};
	
	var HomeAccountIcon = function HomeAccountIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3L2,12H5V20H19V12H22L12,3M12,8.75C13.24,8.75 14.25,9.76 14.25,11C14.25,12.24 13.24,13.25 12,13.25C10.76,13.25 9.75,12.24 9.75,11C9.75,9.76 10.76,8.75 12,8.75M12,15C13.5,15 16.5,15.75 16.5,17.25V18H7.5V17.25C7.5,15.75 10.5,15 12,15Z' })
	  );
	};
	
	var HomeAlertIcon = function HomeAlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3L2,12H5V20H19V12H22L12,3M13,18H11V16H13V18M13,14H11V9H13V14Z' })
	  );
	};
	
	var HomeAssistantIcon = function HomeAssistantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.8,13H20V21H13V17.67L15.79,14.88L16.5,15C17.66,15 18.6,14.06 18.6,12.9C18.6,11.74 17.66,10.8 16.5,10.8C15.34,10.8 14.4,11.74 14.4,12.9L14.5,13.61L13,15.13V9.65C13.66,9.29 14.1,8.6 14.1,7.8C14.1,6.64 13.16,5.7 12,5.7C10.84,5.7 9.9,6.64 9.9,7.8C9.9,8.6 10.34,9.29 11,9.65V15.13L9.5,13.61L9.6,12.9C9.6,11.74 8.66,10.8 7.5,10.8C6.34,10.8 5.4,11.74 5.4,12.9C5.4,14.06 6.34,15 7.5,15L8.21,14.88L11,17.67V21H4V13H2.25C1.83,13 1.42,13 1.42,12.79C1.43,12.57 1.85,12.15 2.28,11.72L11,3C11.33,2.67 11.67,2.33 12,2.33C12.33,2.33 12.67,2.67 13,3L17,7V6H19V9L21.78,11.78C22.18,12.18 22.59,12.59 22.6,12.8C22.6,13 22.2,13 21.8,13M7.5,12C8,12 8.4,12.4 8.4,12.9C8.4,13.4 8,13.8 7.5,13.8C7,13.8 6.6,13.4 6.6,12.9C6.6,12.4 7,12 7.5,12M16.5,12C17,12 17.4,12.4 17.4,12.9C17.4,13.4 17,13.8 16.5,13.8C16,13.8 15.6,13.4 15.6,12.9C15.6,12.4 16,12 16.5,12M12,6.9C12.5,6.9 12.9,7.3 12.9,7.8C12.9,8.3 12.5,8.7 12,8.7C11.5,8.7 11.1,8.3 11.1,7.8C11.1,7.3 11.5,6.9 12,6.9Z' })
	  );
	};
	
	var HomeAutomationIcon = function HomeAutomationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3L2,12H5V20H19V12H22L12,3M12,8.5C14.34,8.5 16.46,9.43 18,10.94L16.8,12.12C15.58,10.91 13.88,10.17 12,10.17C10.12,10.17 8.42,10.91 7.2,12.12L6,10.94C7.54,9.43 9.66,8.5 12,8.5M12,11.83C13.4,11.83 14.67,12.39 15.6,13.3L14.4,14.47C13.79,13.87 12.94,13.5 12,13.5C11.06,13.5 10.21,13.87 9.6,14.47L8.4,13.3C9.33,12.39 10.6,11.83 12,11.83M12,15.17C12.94,15.17 13.7,15.91 13.7,16.83C13.7,17.75 12.94,18.5 12,18.5C11.06,18.5 10.3,17.75 10.3,16.83C10.3,15.91 11.06,15.17 12,15.17Z' })
	  );
	};
	
	var HomeCircleIcon = function HomeCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.07,4.93C17.22,3 14.66,1.96 12,2C9.34,1.96 6.79,3 4.94,4.93C3,6.78 1.96,9.34 2,12C1.96,14.66 3,17.21 4.93,19.06C6.78,21 9.34,22.04 12,22C14.66,22.04 17.21,21 19.06,19.07C21,17.22 22.04,14.66 22,12C22.04,9.34 21,6.78 19.07,4.93M17,12V18H13.5V13H10.5V18H7V12H5L12,5L19.5,12H17Z' })
	  );
	};
	
	var HomeCurrencyUsdIcon = function HomeCurrencyUsdIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3L22,12H19V20H5V12H2L12,3M9.22,8.93C8.75,9.4 8.5,10.03 8.5,10.75C8.5,12.43 10.54,13.07 11.76,13.46C13.26,13.93 13.47,14.21 13.5,14.25C13.5,15 12.15,15 12,15V15C11.37,15 11.03,14.88 10.86,14.78C10.67,14.67 10.5,14.5 10.5,14H8.5C8.5,15.43 9.24,16.16 9.85,16.5C10.18,16.7 10.57,16.84 11,16.92V18H13V16.91C14.53,16.61 15.5,15.62 15.5,14.25C15.5,12.67 13.88,12.03 12.36,11.55C10.8,11.06 10.53,10.77 10.5,10.75C10.5,10.5 10.57,10.41 10.64,10.34C10.85,10.13 11.36,10 12,10V10C12.68,10 13.5,10.13 13.5,10.75H15.5C15.5,9.34 14.56,8.37 13,8.09V7H11V8.08C10.26,8.21 9.65,8.5 9.22,8.93Z' })
	  );
	};
	
	var HomeHeartIcon = function HomeHeartIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,12L12,3L22,12H19V20H5V12H2M12,18L12.72,17.34C15.3,15 17,13.46 17,11.57C17,10.03 15.79,8.82 14.25,8.82C13.38,8.82 12.55,9.23 12,9.87C11.45,9.23 10.62,8.82 9.75,8.82C8.21,8.82 7,10.03 7,11.57C7,13.46 8.7,15 11.28,17.34L12,18Z' })
	  );
	};
	
	var HomeLockOpenIcon = function HomeLockOpenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3L2,12H5V20H19V12H22L12,3M12,8C13.66,8 15,9.34 15,11H13C13,10.45 12.55,10 12,10C11.45,10 11,10.45 11,11V13H16V17H8V13H9V11C9,9.34 10.34,8 12,8Z' })
	  );
	};
	
	var HomeLockIcon = function HomeLockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3L2,12H5V20H19V12H22L12,3M12,9C13.66,9 15,10.34 15,12V13H16V17H8V13H9V12C9,10.34 10.34,9 12,9M12,11C11.45,11 11,11.45 11,12V13H13V12C13,11.5 12.6,11 12,11Z' })
	  );
	};
	
	var HomeMapMarkerIcon = function HomeMapMarkerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3L2,12H5V20H19V12H22L12,3M12,7.7C14.1,7.7 15.8,9.4 15.8,11.5C15.8,14.5 12,18 12,18C12,18 8.2,14.5 8.2,11.5C8.2,9.4 9.9,7.7 12,7.7M12,10C11.17,10 10.5,10.67 10.5,11.5C10.5,12.33 11.17,13 12,13C12.83,13 13.5,12.33 13.5,11.5C13.5,10.67 12.83,10 12,10Z' })
	  );
	};
	
	var HomeMinusIcon = function HomeMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3L2,12H5V20H19V12H22L12,3M16,13V15H8V13H16Z' })
	  );
	};
	
	var HomeModernIcon = function HomeModernIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,21V8C6,6.9 6.9,6 8,6L16,3V6C17.1,6 18,6.9 18,8V21H12V16H8V21H6M14,19H16V16H14V19M8,13H10V9H8V13M12,13H16V9H12V13Z' })
	  );
	};
	
	var HomeOutlineIcon = function HomeOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,19V13H11L13,13H15V19H18V10.91L12,4.91L6,10.91V19H9M12,2.09L21.91,12H20V21H13V15H11V21H4V12H2.09L12,2.09Z' })
	  );
	};
	
	var HomePlusIcon = function HomePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3L2,12H5V20H19V12H22L12,3M11,10H13V13H16V15H13V18H11V15H8V13H11V10Z' })
	  );
	};
	
	var HomeVariantIcon = function HomeVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,20H5V12H2L12,3L22,12H19V20H12V14H8V20M14,14V17H17V14H14Z' })
	  );
	};
	
	var HomeIcon = function HomeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z' })
	  );
	};
	
	var HookOffIcon = function HookOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9.86V11.18L15,13.18V9.86C17.14,9.31 18.43,7.13 17.87,5C17.32,2.85 15.14,1.56 13,2.11C10.86,2.67 9.57,4.85 10.13,7C10.5,8.4 11.59,9.5 13,9.86M14,4C15.1,4 16,4.9 16,6C16,7.1 15.1,8 14,8C12.9,8 12,7.1 12,6C12,4.9 12.9,4 14,4M18.73,22L14.86,18.13C14.21,20.81 11.5,22.46 8.83,21.82C6.6,21.28 5,19.29 5,17V12L10,17H7C7,18.66 8.34,20 10,20C11.66,20 13,18.66 13,17V16.27L2,5.27L3.28,4L13,13.72L15,15.72L20,20.72L18.73,22Z' })
	  );
	};
	
	var HookIcon = function HookIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,6C18,7.82 16.76,9.41 15,9.86V17C15,19.76 12.76,22 10,22C7.24,22 5,19.76 5,17V12L10,17H7C7,18.66 8.34,20 10,20C11.66,20 13,18.66 13,17V9.86C11.23,9.4 10,7.8 10,5.97C10,3.76 11.8,2 14,2C16.22,2 18,3.79 18,6M14,8C15.1,8 16,7.1 16,6C16,4.9 15.1,4 14,4C12.9,4 12,4.9 12,6C12,7.1 12.9,8 14,8Z' })
	  );
	};
	
	var HopsIcon = function HopsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,12C21,12 12.5,10 12.5,2C12.5,2 21,2 21,12M3,12C3,2 11.5,2 11.5,2C11.5,10 3,12 3,12M12,6.5C12,6.5 13,8.66 15,10.5C14.76,14.16 12,16 12,16C12,16 9.24,14.16 9,10.5C11,8.66 12,6.5 12,6.5M20.75,13.25C20.75,13.25 20,17 18,19C18,19 15.53,17.36 14.33,14.81C15.05,13.58 15.5,12.12 15.75,11.13C17.13,12.18 18.75,13 20.75,13.25M15.5,18.25C14.5,20.25 12,21.75 12,21.75C12,21.75 9.5,20.25 8.5,18.25C8.5,18.25 9.59,17.34 10.35,15.8C10.82,16.35 11.36,16.79 12,17C12.64,16.79 13.18,16.35 13.65,15.8C14.41,17.34 15.5,18.25 15.5,18.25M3.25,13.25C5.25,13 6.87,12.18 8.25,11.13C8.5,12.12 8.95,13.58 9.67,14.81C8.47,17.36 6,19 6,19C4,17 3.25,13.25 3.25,13.25Z' })
	  );
	};
	
	var HospitalBuildingIcon = function HospitalBuildingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,22V7C2,6.45 2.45,6 3,6H7V2H17V6H21C21.55,6 22,6.45 22,7V22H14V17H10V22H2M9,4V10H11V8H13V10H15V4H13V6H11V4H9M4,20H8V17H4V20M4,15H8V12H4V15M16,20H20V17H16V20M16,15H20V12H16V15M10,15H14V12H10V15Z' })
	  );
	};
	
	var HospitalMarkerIcon = function HospitalMarkerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C15.86,2 19,5.13 19,9C19,14.25 12,22 12,22C12,22 5,14.25 5,9C5,5.13 8.13,2 12,2M9,6V12H11V10H13V12H15V6H13V8H11V6H9Z' })
	  );
	};
	
	var HospitalIcon = function HospitalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,14H14V18H10V14H6V10H10V6H14V10H18M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z' })
	  );
	};
	
	var HotTubIcon = function HotTubIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,4C8.1,4 9,4.9 9,6C9,7.1 8.1,8 7,8C5.9,8 5,7.1 5,6C5,4.9 5.9,4 7,4M11.15,12H22V20C22,21.1 21.1,22 20,22H4C2.9,22 2,21.1 2,20V12H5V11.25C5,10 6,9 7.25,9H7.28C7.62,9 7.95,9.09 8.24,9.23C8.5,9.35 8.74,9.5 8.93,9.73L10.33,11.28C10.56,11.54 10.84,11.78 11.15,12M7,20V14H5V20H7M11,20V14H9V20H11M15,20V14H13V20H15M19,20V14H17V20H19M18.65,5.86C19.68,6.86 20.16,8.21 19.95,9.57L19.89,10H18L18.09,9.41C18.24,8.62 18,7.83 17.42,7.21L17.35,7.15C16.32,6.14 15.85,4.79 16.05,3.43L16.11,3H18L17.91,3.59C17.76,4.38 18,5.17 18.58,5.79L18.65,5.86M14.65,5.86C15.68,6.86 16.16,8.21 15.95,9.57L15.89,10H14L14.09,9.41C14.24,8.62 14,7.83 13.42,7.21L13.35,7.15C12.32,6.14 11.85,4.79 12.05,3.43L12.11,3H14L13.91,3.59C13.76,4.38 14,5.17 14.58,5.79L14.65,5.86Z' })
	  );
	};
	
	var HotelIcon = function HotelIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,7H11V14H3V5H1V20H3V17H21V20H23V11C23,8.79 21.21,7 19,7M7,13C8.66,13 10,11.66 10,10C10,8.34 8.66,7 7,7C5.34,7 4,8.34 4,10C4,11.66 5.34,13 7,13Z' })
	  );
	};
	
	var HouzzBoxIcon = function HouzzBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M13.5,18.71H18V11.09L9,8.5V5.29H6V18.71H10.5V14.5H13.5V18.71Z' })
	  );
	};
	
	var HouzzIcon = function HouzzIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,20.95H20V10.78L8,7.34V3.05H4V20.95H10V15.31H14V20.95Z' })
	  );
	};
	
	var HuluIcon = function HuluIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.5,12.8V22H14.7V13.9C14.7,13.2 14.1,12.6 13.4,12.6H10.5C9.8,12.6 9.2,13.2 9.2,13.9V22H4.5V2H9.3V8.4C9.6,8.3 9.9,8.2 10.2,8.2H15C17.5,8.2 19.5,10.3 19.5,12.8Z' })
	  );
	};
	
	var HumanChildIcon = function HumanChildIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C13.66,2 15,3.34 15,5C15,6.66 13.66,8 12,8C10.34,8 9,6.66 9,5C9,3.34 10.34,2 12,2M11,22H8V16H6V9H18V16H16V22H13V18H11V22Z' })
	  );
	};
	
	var HumanFemaleIcon = function HumanFemaleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.9,6 10,5.1 10,4C10,2.9 10.9,2 12,2M10.5,22V16H7.5L10.09,8.41C10.34,7.59 11.1,7 12,7C12.9,7 13.66,7.59 13.91,8.41L16.5,16H13.5V22H10.5Z' })
	  );
	};
	
	var HumanGreetingIcon = function HumanGreetingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1.5,4V5.5C1.5,9.65 3.71,13.28 7,15.3V20H22V18C22,15.34 16.67,14 14,14C14,14 13.83,14 13.75,14C9,14 5,10 5,5.5V4M14,4C11.79,4 10,5.79 10,8C10,10.21 11.79,12 14,12C16.21,12 18,10.21 18,8C18,5.79 16.21,4 14,4Z' })
	  );
	};
	
	var HumanHandsdownIcon = function HumanHandsdownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1C10.89,1 10,1.9 10,3C10,4.11 10.89,5 12,5C13.11,5 14,4.11 14,3C14,1.9 13.1,1 12,1M10,6C9.73,6 9.5,6.11 9.31,6.28H9.3L4,11.59L5.42,13L9,9.41V22H11V15H13V22H15V9.41L18.58,13L20,11.59L14.7,6.28C14.5,6.11 14.27,6 14,6' })
	  );
	};
	
	var HumanHandsupIcon = function HumanHandsupIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,1C5,3.7 6.56,6.16 9,7.32V22H11V15H13V22H15V7.31C17.44,6.16 19,3.7 19,1H17C17,3.76 14.76,6 12,6C9.24,6 7,3.76 7,1M12,1C10.89,1 10,1.89 10,3C10,4.11 10.89,5 12,5C13.11,5 14,4.11 14,3C14,1.89 13.11,1 12,1Z' })
	  );
	};
	
	var HumanMaleFemaleIcon = function HumanMaleFemaleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.5,2C8.6,2 9.5,2.9 9.5,4C9.5,5.1 8.6,6 7.5,6C6.4,6 5.5,5.1 5.5,4C5.5,2.9 6.4,2 7.5,2M6,7H9C10.1,7 11,7.9 11,9V14.5H9.5V22H5.5V14.5H4V9C4,7.9 4.9,7 6,7M16.5,2C17.6,2 18.5,2.9 18.5,4C18.5,5.1 17.6,6 16.5,6C15.4,6 14.5,5.1 14.5,4C14.5,2.9 15.4,2 16.5,2M15,22V16H12L14.59,8.41C14.84,7.59 15.6,7 16.5,7C17.4,7 18.16,7.59 18.41,8.41L21,16H18V22H15Z' })
	  );
	};
	
	var HumanMaleIcon = function HumanMaleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.9,6 10,5.1 10,4C10,2.9 10.9,2 12,2M10.5,7H13.5C14.6,7 15.5,7.9 15.5,9V14.5H14V22H10V14.5H8.5V9C8.5,7.9 9.4,7 10.5,7Z' })
	  );
	};
	
	var HumanPregnantIcon = function HumanPregnantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,4C9,2.89 9.89,2 11,2C12.11,2 13,2.89 13,4C13,5.11 12.11,6 11,6C9.89,6 9,5.11 9,4M16,13C16,11.66 15.17,10.5 14,10C14,8.34 12.66,7 11,7C9.34,7 8,8.34 8,10V17H10V22H13V17H16V13Z' })
	  );
	};
	
	var HumanIcon = function HumanIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,9H15V22H13V16H11V22H9V9H3V7H21M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.89,6 10,5.1 10,4C10,2.89 10.89,2 12,2Z' })
	  );
	};
	
	var HumbleBundleIcon = function HumbleBundleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.91,18.12C14.09,18.12 18.43,2.13 18.43,2.13H15.53C15.53,2.13 14.34,5.89 13.55,10.07H11.05C11.11,9.21 11.15,8.34 11.13,7.5C11,0.59 7,1.87 5.18,3.45C3.47,4.95 2.03,7.8 2,10C2.27,10 3.35,10 3.35,10C3.35,10 4.25,5.88 7.07,5.88C9.89,5.88 5.54,21.87 5.54,21.87H8.45C8.45,21.87 9.95,17.59 10.7,12.81L13.09,12.8C12.95,14.04 12.91,15.4 12.93,16.67C13.04,23.56 17.06,22.08 18.86,20.5C20.67,18.92 22,15.58 22,14H20.61C20.62,14.12 19.73,18.12 16.91,18.12V18.12Z' })
	  );
	};
	
	var IceCreamIcon = function IceCreamIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C14.21,2 16,3.79 16,6.05C17.14,6.28 18,7.29 18,8.5C18,9.88 16.88,11 15.5,11H8.5C7.12,11 6,9.88 6,8.5C6,7.29 6.86,6.28 8,6C8,3.79 9.79,2 12,2M9,12H15L13,22H11L9,12Z' })
	  );
	};
	
	var ImageAlbumIcon = function ImageAlbumIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,19L9,15.14L11.14,17.72L14.14,13.86L18,19H6M6,4H11V12L8.5,10.5L6,12M18,2H6C4.9,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V4C20,2.9 19.1,2 18,2Z' })
	  );
	};
	
	var ImageAreaCloseIcon = function ImageAreaCloseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,23L8,19H16L12,23M20,3C21.1,3 22,3.9 22,5V15C22,16.1 21.1,17 20,17H4C2.9,17 2,16.1 2,15V5C2,3.9 2.9,3 4,3H20M5,14H19L14.5,8L11,12.5L8.5,9.5L5,14Z' })
	  );
	};
	
	var ImageAreaIcon = function ImageAreaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,5C21.1,5 22,5.9 22,7V17C22,18.1 21.1,19 20,19H4C2.89,19 2,18.1 2,17V7C2,5.89 2.89,5 4,5H20M5,16H19L14.5,10L11,14.5L8.5,11.5L5,16Z' })
	  );
	};
	
	var ImageBrokenVariantIcon = function ImageBrokenVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,5V11.59L18,8.58L14,12.59L10,8.59L6,12.59L3,9.58V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5M18,11.42L21,14.43V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V12.42L6,15.41L10,11.41L14,15.41' })
	  );
	};
	
	var ImageBrokenIcon = function ImageBrokenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3C20.1,3 21,3.9 21,5V11H19V13H19L17,13V15H15V17H13V19H11V21H5C3.89,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M21,15V19C21,20.1 20.1,21 19,21H19L15,21V19H17V17H19V15H21M19,8.5C19,8.22 18.78,8 18.5,8H5.5C5.22,8 5,8.22 5,8.5V15.5C5,15.78 5.22,16 5.5,16H11V15H13V13H15V11H17V9H19V8.5Z' })
	  );
	};
	
	var ImageFilterBlackWhiteIcon = function ImageFilterBlackWhiteIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19L12,11V19H5L12,11V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var ImageFilterCenterFocusWeakIcon = function ImageFilterCenterFocusWeakIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,15H3V19C3,20.1 3.9,21 5,21H9V19H5M5,5H9V3H5C3.9,3 3,3.9 3,5V9H5M19,3H15V5H19V9H21V5C21,3.9 20.1,3 19,3M19,19H15V21H19C20.1,21 21,20.1 21,19V15H19M12,8C9.79,8 8,9.79 8,12C8,14.21 9.79,16 12,16C14.21,16 16,14.21 16,12C16,9.79 14.21,8 12,8M12,14C10.9,14 10,13.1 10,12C10,10.9 10.9,10 12,10C13.1,10 14,10.9 14,12C14,13.1 13.1,14 12,14Z' })
	  );
	};
	
	var ImageFilterCenterFocusIcon = function ImageFilterCenterFocusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M19,19H15V21H19C20.1,21 21,20.1 21,19V15H19M19,3H15V5H19V9H21V5C21,3.9 20.1,3 19,3M5,5H9V3H5C3.9,3 3,3.9 3,5V9H5M5,15H3V19C3,20.1 3.9,21 5,21H9V19H5V15Z' })
	  );
	};
	
	var ImageFilterDramaIcon = function ImageFilterDramaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,18H6C3.79,18 2,16.21 2,14C2,11.79 3.79,10 6,10C8.21,10 10,11.79 10,14H12C12,11.24 10.14,8.92 7.6,8.22C8.61,6.88 10.2,6 12,6C15.03,6 17.5,8.47 17.5,11.5V12H19C20.66,12 22,13.34 22,15C22,16.66 20.66,18 19,18M19.35,10.04C18.67,6.59 15.64,4 12,4C9.11,4 6.61,5.64 5.36,8.04C2.35,8.36 0,10.9 0,14C0,17.31 2.69,20 6,20H19C21.76,20 24,17.76 24,15C24,12.36 21.95,10.22 19.35,10.04Z' })
	  );
	};
	
	var ImageFilterFramesIcon = function ImageFilterFramesIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,8H6V18H18M20,20H4V6H8.5L12.04,2.5L15.5,6H20M20,4H16L12,0L8,4H4C2.9,4 2,4.9 2,6V20C2,21.1 2.9,22 4,22H20C21.1,22 22,21.1 22,20V6C22,4.9 21.1,4 20,4Z' })
	  );
	};
	
	var ImageFilterHdrIcon = function ImageFilterHdrIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,6L10.25,11L13.1,14.8L11.5,16C9.81,13.75 7,10 7,10L1,18H23L14,6Z' })
	  );
	};
	
	var ImageFilterNoneIcon = function ImageFilterNoneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z' })
	  );
	};
	
	var ImageFilterTiltShiftIcon = function ImageFilterTiltShiftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.68,19.74C7.16,20.95 9,21.75 11,21.95V19.93C9.54,19.75 8.21,19.17 7.1,18.31M13,19.93V21.95C15,21.75 16.84,20.95 18.32,19.74L16.89,18.31C15.79,19.17 14.46,19.75 13,19.93M18.31,16.9L19.74,18.33C20.95,16.85 21.75,15 21.95,13H19.93C19.75,14.46 19.17,15.79 18.31,16.9M15,12C15,10.34 13.66,9 12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12M4.07,13H2.05C2.25,15 3.05,16.84 4.26,18.32L5.69,16.89C4.83,15.79 4.25,14.46 4.07,13M5.69,7.1L4.26,5.68C3.05,7.16 2.25,9 2.05,11H4.07C4.25,9.54 4.83,8.21 5.69,7.1M19.93,11H21.95C21.75,9 20.95,7.16 19.74,5.68L18.31,7.1C19.17,8.21 19.75,9.54 19.93,11M18.32,4.26C16.84,3.05 15,2.25 13,2.05V4.07C14.46,4.25 15.79,4.83 16.9,5.69M11,4.07V2.05C9,2.25 7.16,3.05 5.68,4.26L7.1,5.69C8.21,4.83 9.54,4.25 11,4.07Z' })
	  );
	};
	
	var ImageFilterVintageIcon = function ImageFilterVintageIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,16C9.79,16 8,14.21 8,12C8,9.79 9.79,8 12,8C14.21,8 16,9.79 16,12C16,14.21 14.21,16 12,16M18.7,12.4C18.42,12.24 18.13,12.11 17.84,12C18.13,11.89 18.42,11.76 18.7,11.6C20.62,10.5 21.69,8.5 21.7,6.41C19.91,5.38 17.63,5.3 15.7,6.41C15.42,6.57 15.16,6.76 14.92,6.95C14.97,6.64 15,6.32 15,6C15,3.78 13.79,1.85 12,0.81C10.21,1.85 9,3.78 9,6C9,6.32 9.03,6.64 9.08,6.95C8.84,6.75 8.58,6.56 8.3,6.4C6.38,5.29 4.1,5.37 2.3,6.4C2.3,8.47 3.37,10.5 5.3,11.59C5.58,11.75 5.87,11.88 6.16,12C5.87,12.1 5.58,12.23 5.3,12.39C3.38,13.5 2.31,15.5 2.3,17.58C4.09,18.61 6.37,18.69 8.3,17.58C8.58,17.42 8.84,17.23 9.08,17.04C9.03,17.36 9,17.68 9,18C9,20.22 10.21,22.15 12,23.19C13.79,22.15 15,20.22 15,18C15,17.68 14.97,17.36 14.92,17.05C15.16,17.25 15.42,17.43 15.7,17.59C17.62,18.7 19.9,18.62 21.7,17.59C21.69,15.5 20.62,13.5 18.7,12.4Z' })
	  );
	};
	
	var ImageFilterIcon = function ImageFilterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3M15.96,10.29L13.21,13.83L11.25,11.47L8.5,15H19.5L15.96,10.29Z' })
	  );
	};
	
	var ImageMultipleIcon = function ImageMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,16V4C22,2.9 21.1,2 20,2H8C6.9,2 6,2.9 6,4V16C6,17.1 6.9,18 8,18H20C21.1,18 22,17.1 22,16M11,12L13.03,14.71L16,11L20,16H8M2,6V20C2,21.1 2.9,22 4,22H18V20H4V6' })
	  );
	};
	
	var ImageOffIcon = function ImageOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.28,3L1,4.27L3,6.27V19C3,20.1 3.9,21 5,21H17.73L19.73,23L21,21.72L2.28,3M4.83,3L21,19.17V5C21,3.89 20.1,3 19,3H4.83M8.5,13.5L11,16.5L12,15.25L14.73,18H5L8.5,13.5Z' })
	  );
	};
	
	var ImageOutlineIcon = function ImageOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M13.96,12.29L11.21,15.83L9.25,13.47L6.5,17H17.5L13.96,12.29Z' })
	  );
	};
	
	var ImagePlusIcon = function ImagePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H14.09C14.03,20.67 14,20.34 14,20C14,19.32 14.12,18.64 14.35,18H5L8.5,13.5L11,16.5L14.5,12L16.73,14.97C17.7,14.34 18.84,14 20,14C20.34,14 20.67,14.03 21,14.09V5C21,3.89 20.1,3 19,3H5M19,16V19H16V21H19V24H21V21H24V19H21V16H19Z' })
	  );
	};
	
	var ImageSearchOutlineIcon = function ImageSearchOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.5,9C16.2,9 16.79,8.76 17.27,8.27C17.76,7.79 18,7.2 18,6.5C18,5.83 17.76,5.23 17.27,4.73C16.79,4.23 16.2,4 15.5,4C14.83,4 14.23,4.23 13.73,4.73C13.23,5.23 13,5.83 13,6.5C13,7.2 13.23,7.79 13.73,8.27C14.23,8.76 14.83,9 15.5,9M19.31,8.91L22.41,12L21,13.41L17.86,10.31C17.08,10.78 16.28,11 15.47,11C14.22,11 13.16,10.58 12.3,9.7C11.45,8.83 11,7.77 11,6.5C11,5.27 11.45,4.2 12.33,3.33C13.2,2.45 14.27,2 15.5,2C16.77,2 17.83,2.45 18.7,3.33C19.58,4.2 20,5.27 20,6.5C20,7.33 19.78,8.13 19.31,8.91M16.5,18H5.5L8.25,14.5L10.22,16.83L12.94,13.31L16.5,18M18,13L20,15V20C20,20.55 19.81,21 19.41,21.4C19,21.79 18.53,22 18,22H4C3.45,22 3,21.79 2.6,21.4C2.21,21 2,20.55 2,20V6C2,5.47 2.21,5 2.6,4.59C3,4.19 3.45,4 4,4H9.5C9.2,4.64 9.03,5.31 9,6H4V20H18V13Z' })
	  );
	};
	
	var ImageSearchIcon = function ImageSearchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.5,2C18,2 20,4 20,6.5C20,7.38 19.75,8.21 19.31,8.9L22.39,12L21,13.39L17.88,10.32C17.19,10.75 16.37,11 15.5,11C13,11 11,9 11,6.5C11,4 13,2 15.5,2M15.5,4C14.12,4 13,5.12 13,6.5C13,7.88 14.12,9 15.5,9C16.88,9 18,7.88 18,6.5C18,5.12 16.88,4 15.5,4M7.5,14.5L4,19H18L13.5,13L10,17.5L7.5,14.5M20,20C20,21.1 19.1,22 18,22H4C2.9,22 2,21.1 2,20V6C2,4.9 2.9,4 4,4H9.5C9.18,4.77 9,5.61 9,6.5C9,10.09 11.91,13 15.5,13C16.18,13 16.84,12.89 17.46,12.7L20,15.24V20Z' })
	  );
	};
	
	var ImageIcon = function ImageIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19Z' })
	  );
	};
	
	var ImportIcon = function ImportIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,12L10,8V11H2V13H10V16M20,18V6C20,4.89 19.1,4 18,4H6C4.9,4 4,4.9 4,6V9H6V6H18V18H6V15H4V18C4,19.1 4.9,20 6,20H18C19.1,20 20,19.1 20,18Z' })
	  );
	};
	
	var InboxArrowDownIcon = function InboxArrowDownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,10H14V7H10V10H8L12,14M19,15H15C15,16.66 13.66,18 12,18C10.34,18 9,16.66 9,15H5V5H19M19,3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var InboxArrowUpIcon = function InboxArrowUpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,14H10V11H8L12,7L16,11H14V14M16,11M5,15V5H19V15H15C15,16.66 13.66,18 12,18C10.34,18 9,16.66 9,15H5M19,3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3' })
	  );
	};
	
	var InboxMultipleIcon = function InboxMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,8V5H5V8H9C9,9.66 10.34,11 12,11C13.66,11 15,9.66 15,8H19M19,3C20.1,3 21,3.9 21,5V12C21,13.1 20.1,14 19,14H5C3.9,14 3,13.1 3,12V5C3,3.9 3.9,3 5,3H19M3,15H9C9,16.66 10.34,18 12,18C13.66,18 15,16.66 15,15H21V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V15Z' })
	  );
	};
	
	var InboxIcon = function InboxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,15H15C15,16.66 13.66,18 12,18C10.34,18 9,16.66 9,15H5V5H19M19,3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var IncognitoIcon = function IncognitoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C9.31,3 7.41,4.22 7.41,4.22L6,9H18L16.59,4.22C16.59,4.22 14.69,3 12,3M12,11C9.27,11 5.39,11.54 5.13,11.59C4.09,11.87 3.25,12.15 2.59,12.41C1.58,12.75 1,13 1,13H23C23,13 22.42,12.75 21.41,12.41C20.75,12.15 19.89,11.87 18.84,11.59C18.84,11.59 14.82,11 12,11M7.5,14C5.57,14 4,15.57 4,17.5C4,19.43 5.57,21 7.5,21C9.43,21 11,19.43 11,17.5C11,17.34 11,17.18 10.97,17.03C11.29,16.96 11.63,16.9 12,16.91C12.37,16.91 12.71,16.96 13.03,17.03C13,17.18 13,17.34 13,17.5C13,19.43 14.57,21 16.5,21C18.43,21 20,19.43 20,17.5C20,15.57 18.43,14 16.5,14C15.03,14 13.77,14.9 13.25,16.19C12.93,16.09 12.55,16 12,16C11.45,16 11.07,16.09 10.75,16.19C10.23,14.9 8.97,14 7.5,14M7.5,15C8.88,15 10,16.12 10,17.5C10,18.88 8.88,20 7.5,20C6.12,20 5,18.88 5,17.5C5,16.12 6.12,15 7.5,15M16.5,15C17.88,15 19,16.12 19,17.5C19,18.88 17.88,20 16.5,20C15.12,20 14,18.88 14,17.5C14,16.12 15.12,15 16.5,15Z' })
	  );
	};
	
	var InfinityIcon = function InfinityIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.6,6.62C21.58,6.62 24,9 24,12C24,14.96 21.58,17.37 18.6,17.37C17.15,17.37 15.8,16.81 14.78,15.8L12,13.34L9.17,15.85C8.2,16.82 6.84,17.38 5.4,17.38C2.42,17.38 0,14.96 0,12C0,9.04 2.42,6.62 5.4,6.62C6.84,6.62 8.2,7.18 9.22,8.2L12,10.66L14.83,8.15C15.8,7.18 17.16,6.62 18.6,6.62M7.8,14.39L10.5,12L7.84,9.65C7.16,8.97 6.31,8.62 5.4,8.62C3.53,8.62 2,10.13 2,12C2,13.87 3.53,15.38 5.4,15.38C6.31,15.38 7.16,15.03 7.8,14.39M16.2,9.61L13.5,12L16.16,14.35C16.84,15.03 17.7,15.38 18.6,15.38C20.47,15.38 22,13.87 22,12C22,10.13 20.47,8.62 18.6,8.62C17.69,8.62 16.84,8.97 16.2,9.61Z' })
	  );
	};
	
	var InformationOutlineIcon = function InformationOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M11,17H13V11H11V17Z' })
	  );
	};
	
	var InformationVariantIcon = function InformationVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.5,4C12.67,4 12,4.67 12,5.5C12,6.33 12.67,7 13.5,7C14.33,7 15,6.33 15,5.5C15,4.67 14.33,4 13.5,4M13.14,8.77C11.95,8.87 8.7,11.46 8.7,11.46C8.5,11.61 8.56,11.6 8.72,11.88C8.88,12.15 8.86,12.17 9.05,12.04C9.25,11.91 9.58,11.7 10.13,11.36C12.25,10 10.47,13.14 9.56,18.43C9.2,21.05 11.56,19.7 12.17,19.3C12.77,18.91 14.38,17.8 14.54,17.69C14.76,17.54 14.6,17.42 14.43,17.17C14.31,17 14.19,17.12 14.19,17.12C13.54,17.55 12.35,18.45 12.19,17.88C12,17.31 13.22,13.4 13.89,10.71C14,10.07 14.3,8.67 13.14,8.77Z' })
	  );
	};
	
	var InformationIcon = function InformationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9H11V7H13M13,17H11V11H13M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var InstagramIcon = function InstagramIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2C22,19.4 19.4,22 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8C2,4.6 4.6,2 7.8,2M7.6,4C5.61,4 4,5.61 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4C18.39,20 20,18.39 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5C17.94,5.5 18.5,6.06 18.5,6.75C18.5,7.44 17.94,8 17.25,8C16.56,8 16,7.44 16,6.75C16,6.06 16.56,5.5 17.25,5.5M12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9Z' })
	  );
	};
	
	var InstapaperIcon = function InstapaperIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,5C10,4.45 9.55,4 9,4H8V2H16V4H15C14.45,4 14,4.45 14,5V19C14,19.55 14.45,20 15,20H16V22H8V20H9C9.55,20 10,19.55 10,19V5Z' })
	  );
	};
	
	var InternetExplorerIcon = function InternetExplorerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,3L14,3.06C16.8,1.79 19.23,1.64 20.5,2.92C21.5,3.93 21.58,5.67 20.92,7.72C21.61,9 22,10.45 22,12L21.95,13H9.08C9.45,15.28 11.06,17 13,17C14.31,17 15.47,16.21 16.2,15H21.5C20.25,18.5 16.92,21 13,21C11.72,21 10.5,20.73 9.41,20.25C6.5,21.68 3.89,21.9 2.57,20.56C1,18.96 1.68,15.57 4,12C4.93,10.54 6.14,9.06 7.57,7.65L8.38,6.88C7.21,7.57 5.71,8.62 4.19,10.17C5.03,6.08 8.66,3 13,3M13,7C11.21,7 9.69,8.47 9.18,10.5H16.82C16.31,8.47 14.79,7 13,7M20.06,4.06C19.4,3.39 18.22,3.35 16.74,3.81C18.22,4.5 19.5,5.56 20.41,6.89C20.73,5.65 20.64,4.65 20.06,4.06M3.89,20C4.72,20.84 6.4,20.69 8.44,19.76C6.59,18.67 5.17,16.94 4.47,14.88C3.27,17.15 3,19.07 3.89,20Z' })
	  );
	};
	
	var InvertColorsIcon = function InvertColorsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,19.58V19.58C10.4,19.58 8.89,18.96 7.76,17.83C6.62,16.69 6,15.19 6,13.58C6,12 6.62,10.47 7.76,9.34L12,5.1M17.66,7.93L12,2.27V2.27L6.34,7.93C3.22,11.05 3.22,16.12 6.34,19.24C7.9,20.8 9.95,21.58 12,21.58C14.05,21.58 16.1,20.8 17.66,19.24C20.78,16.12 20.78,11.05 17.66,7.93Z' })
	  );
	};
	
	var IslamIcon = function IslamIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.3,2C12.2,2 12.1,2 12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C15,22 16.7,21 18.5,19.5C13,21 8,17 8,12C8,7 13,3 18.5,4.5C16.86,2.86 14.62,1.96 12.3,2M16.8,6.2L15.3,9.7L11.6,10L14.5,12.5L13.6,16L16.8,14L20,16L19,12.5L22,10L18.3,9.7L16.8,6.2Z' })
	  );
	};
	
	var ItunesIcon = function ItunesIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.85,17.07C7.03,17.17 3.5,17.67 4.06,20.26C4.69,23.3 9.87,22.59 9.83,19C9.81,16.57 9.83,9.2 9.83,9.2C9.83,9.2 9.76,8.53 10.43,8.39L18.19,6.79C18.19,6.79 18.83,6.65 18.83,7.29C18.83,7.89 18.83,14.2 18.83,14.2C18.83,14.2 18.9,14.83 18.12,15C17.34,15.12 13.91,15.4 14.19,18C14.5,21.07 20,20.65 20,17.07V2.61C20,2.61 20.04,1.62 18.9,1.87L9.5,3.78C9.5,3.78 8.66,3.96 8.66,4.77C8.66,5.5 8.66,16.11 8.66,16.11C8.66,16.11 8.66,16.96 7.85,17.07Z' })
	  );
	};
	
	var JeepneyIcon = function JeepneyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,13V7H20V4H4V7H5V13H2C2,13.93 2.5,14.71 3.5,14.93V20C3.5,20.55 3.95,21 4.5,21H5.5C6.05,21 6.5,20.55 6.5,20V19H17.5V20C17.5,20.55 17.95,21 18.5,21H19.5C20.05,21 20.5,20.55 20.5,20V14.93C21.5,14.7 22,13.93 22,13H19M8,15C7.17,15 6.5,14.33 6.5,13.5C6.5,12.67 7.17,12 8,12C8.83,12 9.5,12.67 9.5,13.5C9.5,14.33 8.83,15 8,15M16,15C15.17,15 14.5,14.33 14.5,13.5C14.5,12.67 15.17,12 16,12C16.83,12 17.5,12.67 17.5,13.5C17.5,14.33 16.83,15 16,15M17.5,10.5C15.92,10.18 14.03,10 12,10C9.97,10 8,10.18 6.5,10.5V7H17.5V10.5Z' })
	  );
	};
	
	var JiraIcon = function JiraIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.53,2C11.53,4.4 13.5,6.35 15.88,6.35H17.66V8.05C17.66,10.45 19.6,12.39 22,12.4V2.84C22,2.38 21.62,2 21.16,2H11.53M6.77,6.8C6.78,9.19 8.72,11.13 11.11,11.14H12.91V12.86C12.92,15.25 14.86,17.19 17.25,17.2V7.63C17.24,7.17 16.88,6.81 16.42,6.8H6.77M2,11.6C2,14 3.95,15.94 6.35,15.94H8.13V17.66C8.14,20.05 10.08,22 12.47,22V12.43C12.47,11.97 12.09,11.59 11.63,11.59L2,11.6Z' })
	  );
	};
	
	var JqueryIcon = function JqueryIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22.88,10.41C20.77,12.18 17.61,11.9 15.84,9.79C14.06,7.67 14.34,4.5 16.45,2.75L16.96,2.37C15.27,4.19 15.16,7.03 16.8,9C18.43,10.94 21.25,11.32 23.34,9.97L22.88,10.41M21.1,14.5C17.93,17.17 13.2,16.76 10.54,13.58C7.87,10.41 8.29,5.68 11.46,3L12.38,2.36C9.96,5.09 9.84,9.26 12.26,12.14C14.68,15 18.8,15.63 21.91,13.72L21.1,14.5M19.97,19.38C15.53,23.11 8.9,22.53 5.17,18.08C1.45,13.64 2.03,7 6.47,3.29L7.58,2.5C4.07,6.3 3.85,12.23 7.28,16.32C10.71,20.4 16.59,21.22 20.96,18.43L19.97,19.38Z' })
	  );
	};
	
	var JsfiddleIcon = function JsfiddleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.45,17.5C17.45,17.5 18.3,17.15 19,16.5C19.67,15.8 20,15 20,14C20,13.05 19.66,12.22 18.96,11.53C18.26,10.84 17.41,10.5 16.41,10.5C15.47,10.5 14.64,10.83 13.92,11.5L9.14,15.56C8.7,16 8.17,16.22 7.55,16.22C6.92,16.22 6.39,16 5.95,15.56C5.5,15.13 5.3,14.61 5.3,14C5.3,13.42 5.5,12.91 5.95,12.47C6.39,12.03 6.92,11.81 7.55,11.81C8.14,11.81 8.69,12.03 9.19,12.47L9.94,13.13L10.92,12.23L10.08,11.53C9.39,10.84 8.55,10.5 7.55,10.5C6.58,10.5 5.74,10.84 5.04,11.53C4.34,12.22 4,13.05 4,14C4,15 4.34,15.8 5.04,16.5C5.74,17.15 6.59,17.5 7.59,17.5C8.53,17.5 9.36,17.16 10.08,16.5L14.86,12.42C15.27,12 15.8,11.81 16.45,11.81C17.08,11.81 17.61,12.03 18.05,12.47C18.5,12.91 18.7,13.42 18.7,14C18.7,14.61 18.5,15.13 18.05,15.56C17.61,16 17.08,16.22 16.45,16.22C15.89,16.22 15.34,16 14.81,15.5L14.06,14.86L13.08,15.75L13.92,16.45C14.61,17.14 15.45,17.5 16.45,17.5M19.36,10.03C20.64,10.13 21.73,10.65 22.64,11.6C23.55,12.55 24,13.69 24,15C24,16.38 23.5,17.55 22.5,18.54C21.54,19.5 20.36,20 19,20H6C4.34,20 2.93,19.43 1.76,18.26C0.59,17.09 0,15.67 0,14C0,12.55 0.5,11.23 1.57,10.05C2.62,8.88 3.88,8.22 5.34,8.06C6,6.84 6.92,5.86 8.11,5.11C9.3,4.36 10.59,4 12,4C13.69,4 15.26,4.58 16.71,5.77C18.16,6.95 19.05,8.38 19.36,10.03Z' })
	  );
	};
	
	var JsonIcon = function JsonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H7V5H5V10C5,11.1 4.1,12 3,12C4.1,12 5,12.9 5,14V19H7V21H5C3.93,20.73 3,20.1 3,19V15C3,13.9 2.1,13 1,13H0V11H1C2.1,11 3,10.1 3,9V5C3,3.9 3.9,3 5,3M19,3C20.1,3 21,3.9 21,5V9C21,10.1 21.9,11 23,11H24V13H23C21.9,13 21,13.9 21,15V19C21,20.1 20.1,21 19,21H17V19H19V14C19,12.9 19.9,12 21,12C19.9,12 19,11.1 19,10V5H17V3H19M12,15C12.55,15 13,15.45 13,16C13,16.55 12.55,17 12,17C11.45,17 11,16.55 11,16C11,15.45 11.45,15 12,15M8,15C8.55,15 9,15.45 9,16C9,16.55 8.55,17 8,17C7.45,17 7,16.55 7,16C7,15.45 7.45,15 8,15M16,15C16.55,15 17,15.45 17,16C17,16.55 16.55,17 16,17C15.45,17 15,16.55 15,16C15,15.45 15.45,15 16,15Z' })
	  );
	};
	
	var JudaismIcon = function JudaismIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2L9.1,7H3.3L6.3,12L3.3,17H9.1L12,22L14.9,17H20.7L17.7,12L20.7,7H14.9L12,2M12,5L13.2,7H10.8L12,5M8.2,8.5L7.1,10.5L5.9,8.5H8.2M10,8.5H14L16,12L14,15.5H10L8,12L10,8.5M18,8.5L16.8,10.5L15.7,8.5H18M7.1,13.5L8.2,15.5H6L7.1,13.5M16.9,13.5L18.1,15.5H15.8L16.9,13.5M13.3,17L12,19L10.8,17H13.3Z' })
	  );
	};
	
	var KarateIcon = function KarateIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,1.27C18.04,0.72 16.82,1.04 16.27,2C15.71,2.95 16.04,4.18 17,4.73C17.95,5.28 19.17,4.96 19.73,4C20.28,3.04 19.95,1.82 19,1.27M21.27,9.34L18.7,13.79L16.96,12.79L18.69,9.79L17.14,8.5L14,13.92V22H12V13.39L2.47,7.89L3.47,6.16L11.27,10.66L13.67,6.5L7.28,4.17L8,2.29L14.73,4.74L15,4.84C15.39,5 15.76,5.15 16.12,5.35L16.96,5.84C17.31,6.04 17.65,6.28 17.96,6.54L18.19,6.74L21.27,9.34Z' })
	  );
	};
	
	var KegIcon = function KegIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,22V20H6V16H5V14H6V11H5V7H11V3H10V2H11L13,2H14V3H13V7H19V11H18V14H19V16H18V20H19V22H5M17,9C17,8.45 16.55,8 16,8H14C13.45,8 13,8.45 13,9C13,9.55 13.45,10 14,10H16C16.55,10 17,9.55 17,9Z' })
	  );
	};
	
	var KettleIcon = function KettleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.5,3C7.81,3 4,5.69 4,9V9C4,10.19 4.5,11.34 5.44,12.33C4.53,13.5 4,14.96 4,16.5C4,17.64 4,18.83 4,20C4,21.11 4.89,22 6,22H19C20.11,22 21,21.11 21,20C21,18.85 21,17.61 21,16.5C21,15.28 20.66,14.07 20,13L22,11L19,8L16.9,10.1C15.58,9.38 14.05,9 12.5,9C10.65,9 8.95,9.53 7.55,10.41C7.19,9.97 7,9.5 7,9C7,7.21 9.46,5.75 12.5,5.75V5.75C13.93,5.75 15.3,6.08 16.33,6.67L18.35,4.65C16.77,3.59 14.68,3 12.5,3M12.5,11C12.84,11 13.17,11.04 13.5,11.09C10.39,11.57 8,14.25 8,17.5V20H6V17.5C6,13.91 8.91,11 12.5,11Z' })
	  );
	};
	
	var KeyChangeIcon = function KeyChangeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.5,2C8.46,2 10.13,3.25 10.74,5H22V8H18V11H15V8H10.74C10.13,9.75 8.46,11 6.5,11C4,11 2,9 2,6.5C2,4 4,2 6.5,2M6.5,5C5.67,5 5,5.67 5,6.5C5,7.33 5.67,8 6.5,8C7.33,8 8,7.33 8,6.5C8,5.67 7.33,5 6.5,5M6.5,13C8.46,13 10.13,14.25 10.74,16H22V19H20V22H18V19H16V22H13V19H10.74C10.13,20.75 8.46,22 6.5,22C4,22 2,20 2,17.5C2,15 4,13 6.5,13M6.5,16C5.67,16 5,16.67 5,17.5C5,18.33 5.67,19 6.5,19C7.33,19 8,18.33 8,17.5C8,16.67 7.33,16 6.5,16Z' })
	  );
	};
	
	var KeyMinusIcon = function KeyMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.5,3C8.46,3 10.13,4.25 10.74,6H22V9H18V12H15V9H10.74C10.13,10.75 8.46,12 6.5,12C4,12 2,10 2,7.5C2,5 4,3 6.5,3M6.5,6C5.67,6 5,6.67 5,7.5C5,8.33 5.67,9 6.5,9C7.33,9 8,8.33 8,7.5C8,6.67 7.33,6 6.5,6M8,17H16V19H8V17Z' })
	  );
	};
	
	var KeyPlusIcon = function KeyPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.5,3C8.46,3 10.13,4.25 10.74,6H22V9H18V12H15V9H10.74C10.13,10.75 8.46,12 6.5,12C4,12 2,10 2,7.5C2,5 4,3 6.5,3M6.5,6C5.67,6 5,6.67 5,7.5C5,8.33 5.67,9 6.5,9C7.33,9 8,8.33 8,7.5C8,6.67 7.33,6 6.5,6M8,17H11V14H13V17H16V19H13V22H11V19H8V17Z' })
	  );
	};
	
	var KeyRemoveIcon = function KeyRemoveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.5,3C8.46,3 10.13,4.25 10.74,6H22V9H18V12H15V9H10.74C10.13,10.75 8.46,12 6.5,12C4,12 2,10 2,7.5C2,5 4,3 6.5,3M6.5,6C5.67,6 5,6.67 5,7.5C5,8.33 5.67,9 6.5,9C7.33,9 8,8.33 8,7.5C8,6.67 7.33,6 6.5,6M14.59,14L16,15.41L13.41,18L16,20.59L14.59,22L12,19.41L9.41,22L8,20.59L10.59,18L8,15.41L9.41,14L12,16.59L14.59,14Z' })
	  );
	};
	
	var KeyVariantIcon = function KeyVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,18V22H18V19H15V16H12L9.74,13.74C9.19,13.91 8.61,14 8,14C4.69,14 2,11.31 2,8C2,4.69 4.69,2 8,2C11.31,2 14,4.69 14,8C14,8.61 13.91,9.19 13.74,9.74L22,18M7,5C5.9,5 5,5.9 5,7C5,8.1 5.9,9 7,9C8.1,9 9,8.1 9,7C9,5.9 8.1,5 7,5Z' })
	  );
	};
	
	var KeyIcon = function KeyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,14C5.9,14 5,13.1 5,12C5,10.9 5.9,10 7,10C8.1,10 9,10.9 9,12C9,13.1 8.1,14 7,14M12.65,10C11.83,7.67 9.61,6 7,6C3.69,6 1,8.69 1,12C1,15.31 3.69,18 7,18C9.61,18 11.83,16.33 12.65,14H17V18H21V14H23V10H12.65Z' })
	  );
	};
	
	var KeyboardBackspaceIcon = function KeyboardBackspaceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,11H6.83L10.41,7.41L9,6L3,12L9,18L10.41,16.58L6.83,13H21V11Z' })
	  );
	};
	
	var KeyboardCapsIcon = function KeyboardCapsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,18H18V16H6M12,8.41L16.59,13L18,11.58L12,5.58L6,11.58L7.41,13L12,8.41Z' })
	  );
	};
	
	var KeyboardCloseIcon = function KeyboardCloseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,23L16,19H8M19,8H17V6H19M19,11H17V9H19M16,8H14V6H16M16,11H14V9H16M16,15H8V13H16M7,8H5V6H7M7,11H5V9H7M8,9H10V11H8M8,6H10V8H8M11,9H13V11H11M11,6H13V8H11M20,3H4C2.89,3 2,3.89 2,5V15C2,16.1 2.9,17 4,17H20C21.1,17 22,16.1 22,15V5C22,3.89 21.1,3 20,3Z' })
	  );
	};
	
	var KeyboardOffIcon = function KeyboardOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,4.27L2.28,3L20,20.72L18.73,22L15.73,19H4C2.89,19 2,18.1 2,17V7C2,6.5 2.18,6.07 2.46,5.73L1,4.27M19,10V8H17V10H19M19,13V11H17V13H19M16,10V8H14V10H16M16,13V11H14V12.18L11.82,10H13V8H11V9.18L9.82,8L6.82,5H20C21.1,5 22,5.9 22,7V17C22,17.86 21.46,18.59 20.7,18.87L14.82,13H16M8,15V17H13.73L11.73,15H8M5,10H6.73L5,8.27V10M7,13V11H5V13H7M8,13H9.73L8,11.27V13Z' })
	  );
	};
	
	var KeyboardOutlineIcon = function KeyboardOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,5C2.9,5 2,5.9 2,7V17C2,18.1 2.9,19 4,19H20C21.1,19 22,18.1 22,17V7C22,5.9 21.1,5 20,5H4M4,7H20V17H4V7M5,8V10H7V8H5M8,8V10H10V8H8M11,8V10H13V8H11M14,8V10H16V8H14M17,8V10H19V8H17M5,11V13H7V11H5M8,11V13H10V11H8M11,11V13H13V11H11M14,11V13H16V11H14M17,11V13H19V11H17M8,14V16H16V14H8Z' })
	  );
	};
	
	var KeyboardReturnIcon = function KeyboardReturnIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,7V11H5.83L9.41,7.41L8,6L2,12L8,18L9.41,16.58L5.83,13H21V7H19Z' })
	  );
	};
	
	var KeyboardTabIcon = function KeyboardTabIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,18H22V6H20M11.59,7.41L15.17,11H1V13H15.17L11.59,16.58L13,18L19,12L13,6L11.59,7.41Z' })
	  );
	};
	
	var KeyboardVariantIcon = function KeyboardVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,16H18V18H6V16M6,13V15H2V13H6M7,15V13H10V15H7M11,15V13H13V15H11M14,15V13H17V15H14M18,15V13H22V15H18M2,10H5V12H2V10M19,12V10H22V12H19M18,12H16V10H18V12M8,12H6V10H8V12M12,12H9V10H12V12M15,12H13V10H15V12M2,9V7H4V9H2M5,9V7H7V9H5M8,9V7H10V9H8M11,9V7H13V9H11M14,9V7H16V9H14M17,9V7H22V9H17Z' })
	  );
	};
	
	var KeyboardIcon = function KeyboardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,10H17V8H19M19,13H17V11H19M16,10H14V8H16M16,13H14V11H16M16,17H8V15H16M7,10H5V8H7M7,13H5V11H7M8,11H10V13H8M8,8H10V10H8M11,11H13V13H11M11,8H13V10H11M20,5H4C2.89,5 2,5.89 2,7V17C2,18.1 2.9,19 4,19H20C21.1,19 22,18.1 22,17V7C22,5.89 21.1,5 20,5Z' })
	  );
	};
	
	var KickstarterIcon = function KickstarterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.21,9.13L13.5,4.35C14.13,3.45 14.94,3 15.93,3C16.73,3 17.43,3.29 18,3.86C18.61,4.43 18.9,5.11 18.9,5.91C18.9,6.5 18.75,7 18.43,7.47L15.46,11.8L19.1,16.41C19.46,16.87 19.64,17.41 19.64,18C19.64,18.84 19.36,19.54 18.78,20.12C18.21,20.71 17.5,21 16.7,21C15.81,21 15.13,20.71 14.66,20.13L10.21,14.57V17.63C10.21,18.5 10.05,19.19 9.75,19.67C9.2,20.56 8.39,21 7.33,21C6.37,21 5.63,20.68 5.1,20.03C4.6,19.43 4.36,18.63 4.36,17.65V6.27C4.36,5.34 4.61,4.57 5.11,3.96C5.64,3.32 6.37,3 7.3,3C8.18,3 8.92,3.32 9.5,3.96C9.83,4.32 10.04,4.68 10.13,5.04C10.18,5.27 10.21,5.69 10.21,6.3V9.13Z' })
	  );
	};
	
	var KodiIcon = function KodiIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.03,1C11.82,1 11.6,1.11 11.41,1.31C10.56,2.16 9.72,3 8.88,3.84C8.66,4.06 8.6,4.18 8.38,4.38C8.09,4.62 7.96,4.91 7.97,5.28C8,6.57 8,7.84 8,9.13C8,10.46 8,11.82 8,13.16C8,13.26 8,13.34 8.03,13.44C8.11,13.75 8.31,13.82 8.53,13.59C9.73,12.39 10.8,11.3 12,10.09C13.36,8.73 14.73,7.37 16.09,6C16.5,5.6 16.5,5.15 16.09,4.75C14.94,3.6 13.77,2.47 12.63,1.31C12.43,1.11 12.24,1 12.03,1M18.66,7.66C18.45,7.66 18.25,7.75 18.06,7.94C16.91,9.1 15.75,10.24 14.59,11.41C14.2,11.8 14.2,12.23 14.59,12.63C15.74,13.78 16.88,14.94 18.03,16.09C18.43,16.5 18.85,16.5 19.25,16.09C20.36,15 21.5,13.87 22.59,12.75C22.76,12.58 22.93,12.42 23,12.19V11.88C22.93,11.64 22.76,11.5 22.59,11.31C21.47,10.19 20.37,9.06 19.25,7.94C19.06,7.75 18.86,7.66 18.66,7.66M4.78,8.09C4.65,8.04 4.58,8.14 4.5,8.22C3.35,9.39 2.34,10.43 1.19,11.59C0.93,11.86 0.93,12.24 1.19,12.5C1.81,13.13 2.44,13.75 3.06,14.38C3.6,14.92 4,15.33 4.56,15.88C4.72,16.03 4.86,16 4.94,15.81C5,15.71 5,15.58 5,15.47C5,14.29 5,13.37 5,12.19C5,11 5,9.81 5,8.63C5,8.55 5,8.45 4.97,8.38C4.95,8.25 4.9,8.14 4.78,8.09M12.09,14.25C11.89,14.25 11.66,14.34 11.47,14.53C10.32,15.69 9.18,16.87 8.03,18.03C7.63,18.43 7.63,18.85 8.03,19.25C9.14,20.37 10.26,21.47 11.38,22.59C11.54,22.76 11.71,22.93 11.94,23H12.22C12.44,22.94 12.62,22.79 12.78,22.63C13.9,21.5 15.03,20.38 16.16,19.25C16.55,18.85 16.5,18.4 16.13,18C14.97,16.84 13.84,15.69 12.69,14.53C12.5,14.34 12.3,14.25 12.09,14.25Z' })
	  );
	};
	
	var LabelOutlineIcon = function LabelOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,17H5V7H16L19.55,12M17.63,5.84C17.27,5.33 16.67,5 16,5H5C3.9,5 3,5.9 3,7V17C3,18.1 3.9,19 5,19H16C16.67,19 17.27,18.66 17.63,18.15L22,12L17.63,5.84Z' })
	  );
	};
	
	var LabelIcon = function LabelIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.63,5.84C17.27,5.33 16.67,5 16,5H5C3.9,5 3,5.9 3,7V17C3,18.1 3.9,19 5,19H16C16.67,19 17.27,18.66 17.63,18.15L22,12L17.63,5.84Z' })
	  );
	};
	
	var LadybugIcon = function LadybugIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,5C12.74,5 13.47,5.1 14.15,5.29L15.78,2.46C16.06,2 16.67,1.82 17.15,2.1C17.63,2.37 17.79,3 17.5,3.46L16,6.07C17.22,6.78 18.23,7.79 18.93,9H5.07C5.77,7.79 6.78,6.78 8,6.07L6.5,3.46C6.21,3 6.37,2.37 6.85,2.1C7.33,1.82 7.94,2 8.22,2.46L9.85,5.29C10.53,5.1 11.26,5 12,5M20,13C20,17.17 16.82,20.59 12.75,20.97V10.5H19.6C19.86,11.29 20,12.13 20,13M4,13C4,12.13 4.14,11.29 4.4,10.5H11.25V20.97C7.18,20.59 4,17.17 4,13Z' })
	  );
	};
	
	var LambdaIcon = function LambdaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,20L10.16,7.91L9.34,6H8V4H10C10.42,4 10.78,4.26 10.93,4.63L16.66,18H18V20H16C15.57,20 15.21,19.73 15.07,19.36L11.33,10.65L8.12,20H6Z' })
	  );
	};
	
	var LampIcon = function LampIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,2H16L20,14H4L8,2M11,15H13V20H18V22H6V20H11V15Z' })
	  );
	};
	
	var LanConnectIcon = function LanConnectIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,1C2.89,1 2,1.89 2,3V7C2,8.11 2.89,9 4,9H1V11H13V9H10C11.11,9 12,8.11 12,7V3C12,1.89 11.11,1 10,1H4M4,3H10V7H4V3M3,13V18L3,20H10V18H5V13H3M14,13C12.89,13 12,13.89 12,15V19C12,20.11 12.89,21 14,21H11V23H23V21H20C21.11,21 22,20.11 22,19V15C22,13.89 21.11,13 20,13H14M14,15H20V19H14V15Z' })
	  );
	};
	
	var LanDisconnectIcon = function LanDisconnectIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,1C2.89,1 2,1.89 2,3V7C2,8.11 2.89,9 4,9H1V11H13V9H10C11.11,9 12,8.11 12,7V3C12,1.89 11.11,1 10,1H4M4,3H10V7H4V3M14,13C12.89,13 12,13.89 12,15V19C12,20.11 12.89,21 14,21H11V23H23V21H20C21.11,21 22,20.11 22,19V15C22,13.89 21.11,13 20,13H14M3.88,13.46L2.46,14.88L4.59,17L2.46,19.12L3.88,20.54L6,18.41L8.12,20.54L9.54,19.12L7.41,17L9.54,14.88L8.12,13.46L6,15.59L3.88,13.46M14,15H20V19H14V15Z' })
	  );
	};
	
	var LanPendingIcon = function LanPendingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,1C2.89,1 2,1.89 2,3V7C2,8.11 2.89,9 4,9H1V11H13V9H10C11.11,9 12,8.11 12,7V3C12,1.89 11.11,1 10,1H4M4,3H10V7H4V3M3,12V14H5V12H3M14,13C12.89,13 12,13.89 12,15V19C12,20.11 12.89,21 14,21H11V23H23V21H20C21.11,21 22,20.11 22,19V15C22,13.89 21.11,13 20,13H14M3,15V17H5V15H3M14,15H20V19H14V15M3,18V20H5V18H3M6,18V20H8V18H6M9,18V20H11V18H9Z' })
	  );
	};
	
	var LanIcon = function LanIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,2C8.89,2 8,2.89 8,4V7C8,8.11 8.89,9 10,9H11V11H2V13H6V15H5C3.89,15 3,15.89 3,17V20C3,21.11 3.89,22 5,22H9C10.11,22 11,21.11 11,20V17C11,15.89 10.11,15 9,15H8V13H16V15H15C13.89,15 13,15.89 13,17V20C13,21.11 13.89,22 15,22H19C20.11,22 21,21.11 21,20V17C21,15.89 20.11,15 19,15H18V13H22V11H13V9H14C15.11,9 16,8.11 16,7V4C16,2.89 15.11,2 14,2H10M10,4H14V7H10V4M5,17H9V20H5V17M15,17H19V20H15V17Z' })
	  );
	};
	
	var LanguageCIcon = function LanguageCIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.45,15.97L15.87,18.41C15.61,18.55 15.19,18.68 14.63,18.8C14.06,18.93 13.39,19 12.62,19C10.41,18.96 8.75,18.3 7.64,17.04C6.5,15.77 5.96,14.16 5.96,12.21C6,9.9 6.68,8.13 8,6.89C9.28,5.64 10.92,5 12.9,5C13.65,5 14.3,5.07 14.84,5.19C15.38,5.31 15.78,5.44 16.04,5.59L15.44,8.08L14.4,7.74C14,7.64 13.53,7.59 13,7.59C11.85,7.58 10.89,7.95 10.14,8.69C9.38,9.42 9,10.54 8.96,12.03C8.97,13.39 9.33,14.45 10.04,15.23C10.75,16 11.74,16.4 13.03,16.41L14.36,16.29C14.79,16.21 15.15,16.1 15.45,15.97Z' })
	  );
	};
	
	var LanguageCppIcon = function LanguageCppIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.5,15.97L10.91,18.41C10.65,18.55 10.23,18.68 9.67,18.8C9.1,18.93 8.43,19 7.66,19C5.45,18.96 3.79,18.3 2.68,17.04C1.56,15.77 1,14.16 1,12.21C1.05,9.9 1.72,8.13 3,6.89C4.32,5.64 5.96,5 7.94,5C8.69,5 9.34,5.07 9.88,5.19C10.42,5.31 10.82,5.44 11.08,5.59L10.5,8.08L9.44,7.74C9.04,7.64 8.58,7.59 8.05,7.59C6.89,7.58 5.93,7.95 5.18,8.69C4.42,9.42 4.03,10.54 4,12.03C4,13.39 4.37,14.45 5.08,15.23C5.79,16 6.79,16.4 8.07,16.41L9.4,16.29C9.83,16.21 10.19,16.1 10.5,15.97M11,11H13V9H15V11H17V13H15V15H13V13H11V11M18,11H20V9H22V11H24V13H22V15H20V13H18V11Z' })
	  );
	};
	
	var LanguageCsharpIcon = function LanguageCsharpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.5,15.97L11.91,18.41C11.65,18.55 11.23,18.68 10.67,18.8C10.1,18.93 9.43,19 8.66,19C6.45,18.96 4.79,18.3 3.68,17.04C2.56,15.77 2,14.16 2,12.21C2.05,9.9 2.72,8.13 4,6.89C5.32,5.64 6.96,5 8.94,5C9.69,5 10.34,5.07 10.88,5.19C11.42,5.31 11.82,5.44 12.08,5.59L11.5,8.08L10.44,7.74C10.04,7.64 9.58,7.59 9.05,7.59C7.89,7.58 6.93,7.95 6.18,8.69C5.42,9.42 5.03,10.54 5,12.03C5,13.39 5.37,14.45 6.08,15.23C6.79,16 7.79,16.4 9.07,16.41L10.4,16.29C10.83,16.21 11.19,16.1 11.5,15.97M13.89,19L14.5,15H13L13.34,13H14.84L15.16,11H13.66L14,9H15.5L16.11,5H18.11L17.5,9H18.5L19.11,5H21.11L20.5,9H22L21.66,11H20.16L19.84,13H21.34L21,15H19.5L18.89,19H16.89L17.5,15H16.5L15.89,19H13.89M16.84,13H17.84L18.16,11H17.16L16.84,13Z' })
	  );
	};
	
	var LanguageCss3Icon = function LanguageCss3Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3L4.35,6.34H17.94L17.5,8.5H3.92L3.26,11.83H16.85L16.09,15.64L10.61,17.45L5.86,15.64L6.19,14H2.85L2.06,18L9.91,21L18.96,18L20.16,11.97L20.4,10.76L21.94,3H5Z' })
	  );
	};
	
	var LanguageGoIcon = function LanguageGoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.64,10.33L2.62,10.27L2.84,10L2.96,9.92H6.8L6.83,10L6.65,10.26L6.54,10.32L2.64,10.33M1.03,11.31L1,11.26L1.22,10.97L1.34,10.91H6.24L6.29,11L6.21,11.24L6.11,11.31H1.03M3.63,12.3L3.59,12.24L3.75,11.96L3.85,11.9H6L6.07,11.97L6.05,12.22L5.97,12.3H3.63M14.78,10.14L13,10.61C12.81,10.65 12.8,10.66 12.66,10.5C12.5,10.32 12.39,10.21 12.16,10.1C11.5,9.76 10.83,9.86 10.22,10.25C9.5,10.73 9.11,11.42 9.12,12.3C9.13,13.16 9.72,13.87 10.57,14C11.3,14.09 11.91,13.83 12.4,13.28L12.69,12.89H10.62C10.4,12.89 10.35,12.75 10.42,12.57L10.97,11.39C11,11.33 11.08,11.22 11.24,11.22H14.68C14.83,10.72 15.09,10.26 15.43,9.81C16.21,8.78 17.16,8.24 18.43,8C19.5,7.82 20.56,7.93 21.5,8.57C22.34,9.15 22.87,9.93 23,10.96C23.19,12.41 22.76,13.59 21.76,14.61C21.05,15.33 20.18,15.78 19.19,16L18.33,16.08C17.35,16.06 16.46,15.78 15.71,15.13C15.19,14.68 14.83,14.14 14.65,13.5C14.5,13.74 14.38,13.97 14.21,14.2C13.44,15.22 12.43,15.85 11.15,16C10.1,16.16 9.12,15.95 8.26,15.31C7.47,14.71 7,13.91 6.9,12.92C6.76,11.75 7.1,10.7 7.81,9.78C8.57,8.78 9.58,8.15 10.82,7.92C11.82,7.74 12.79,7.86 13.66,8.44C14.23,8.82 14.63,9.34 14.9,9.96C14.94,10.05 14.9,10.11 14.78,10.14M20.89,11.74L20.86,11.38C20.67,10.32 19.69,9.72 18.67,9.95C17.66,10.17 17,10.8 16.79,11.81C16.6,12.65 17,13.5 17.77,13.84C18.36,14.1 18.96,14.06 19.53,13.78C20.37,13.35 20.84,12.66 20.89,11.74Z' })
	  );
	};
	
	var LanguageHtml5Icon = function LanguageHtml5Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,17.56L16.07,16.43L16.62,10.33H9.38L9.2,8.3H16.8L17,6.31H7L7.56,12.32H14.45L14.22,14.9L12,15.5L9.78,14.9L9.64,13.24H7.64L7.93,16.43L12,17.56M4.07,3H19.93L18.5,19.2L12,21L5.5,19.2L4.07,3Z' })
	  );
	};
	
	var LanguageJavascriptIcon = function LanguageJavascriptIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3H21V21H3V3M7.73,18.04C8.13,18.89 8.92,19.59 10.27,19.59C11.77,19.59 12.8,18.79 12.8,17.04V11.26H11.1V17C11.1,17.86 10.75,18.08 10.2,18.08C9.62,18.08 9.38,17.68 9.11,17.21L7.73,18.04M13.71,17.86C14.21,18.84 15.22,19.59 16.8,19.59C18.4,19.59 19.6,18.76 19.6,17.23C19.6,15.82 18.79,15.19 17.35,14.57L16.93,14.39C16.2,14.08 15.89,13.87 15.89,13.37C15.89,12.96 16.2,12.64 16.7,12.64C17.18,12.64 17.5,12.85 17.79,13.37L19.1,12.5C18.55,11.54 17.77,11.17 16.7,11.17C15.19,11.17 14.22,12.13 14.22,13.4C14.22,14.78 15.03,15.43 16.25,15.95L16.67,16.13C17.45,16.47 17.91,16.68 17.91,17.26C17.91,17.74 17.46,18.09 16.76,18.09C15.93,18.09 15.45,17.66 15.09,17.06L13.71,17.86Z' })
	  );
	};
	
	var LanguageLuaIcon = function LanguageLuaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.5,5C5.81,5 2,8.81 2,13.5C2,18.19 5.81,22 10.5,22C15.19,22 19,18.19 19,13.5C19,8.81 15.19,5 10.5,5M13.5,13C12.12,13 11,11.88 11,10.5C11,9.12 12.12,8 13.5,8C14.88,8 16,9.12 16,10.5C16,11.88 14.88,13 13.5,13M19.5,2C18.12,2 17,3.12 17,4.5C17,5.88 18.12,7 19.5,7C20.88,7 22,5.88 22,4.5C22,3.12 20.88,2 19.5,2' })
	  );
	};
	
	var LanguagePhpIcon = function LanguagePhpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,18.08C5.37,18.08 0,15.36 0,12C0,8.64 5.37,5.92 12,5.92C18.63,5.92 24,8.64 24,12C24,15.36 18.63,18.08 12,18.08M6.81,10.13C7.35,10.13 7.72,10.23 7.9,10.44C8.08,10.64 8.12,11 8.03,11.47C7.93,12 7.74,12.34 7.45,12.56C7.17,12.78 6.74,12.89 6.16,12.89H5.29L5.82,10.13H6.81M3.31,15.68H4.75L5.09,13.93H6.32C6.86,13.93 7.3,13.87 7.65,13.76C8,13.64 8.32,13.45 8.61,13.18C8.85,12.96 9.04,12.72 9.19,12.45C9.34,12.19 9.45,11.89 9.5,11.57C9.66,10.79 9.55,10.18 9.17,9.75C8.78,9.31 8.18,9.1 7.35,9.1H4.59L3.31,15.68M10.56,7.35L9.28,13.93H10.7L11.44,10.16H12.58C12.94,10.16 13.18,10.22 13.29,10.34C13.4,10.46 13.42,10.68 13.36,11L12.79,13.93H14.24L14.83,10.86C14.96,10.24 14.86,9.79 14.56,9.5C14.26,9.23 13.71,9.1 12.91,9.1H11.64L12,7.35H10.56M18,10.13C18.55,10.13 18.91,10.23 19.09,10.44C19.27,10.64 19.31,11 19.22,11.47C19.12,12 18.93,12.34 18.65,12.56C18.36,12.78 17.93,12.89 17.35,12.89H16.5L17,10.13H18M14.5,15.68H15.94L16.28,13.93H17.5C18.05,13.93 18.5,13.87 18.85,13.76C19.2,13.64 19.5,13.45 19.8,13.18C20.04,12.96 20.24,12.72 20.38,12.45C20.53,12.19 20.64,11.89 20.7,11.57C20.85,10.79 20.74,10.18 20.36,9.75C20,9.31 19.37,9.1 18.54,9.1H15.79L14.5,15.68Z' })
	  );
	};
	
	var LanguagePythonTextIcon = function LanguagePythonTextIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.69C8.92,1.07 11.1,7 11.28,10.27C11.46,13.53 8.29,17.64 4.31,14.92V20.3L2,18.77V5.69M4.22,7.4V12.78C7.84,14.95 9.08,13.17 9.08,10.09C9.08,5.74 6.57,5.59 4.22,7.4M15.08,4.15C15.08,4.15 14.9,7.64 15.08,11.07C15.44,14.5 19.69,11.84 19.69,11.84V4.92L22,5.2V14.44C22,20.6 15.85,20.3 15.85,20.3L15.08,18C20.46,18 19.78,14.43 19.78,14.43C13.27,16.97 12.77,12.61 12.77,12.61V5.69L15.08,4.15Z' })
	  );
	};
	
	var LanguagePythonIcon = function LanguagePythonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.14,7.5C20.72,7.5 22,8.78 22,10.36V14.14C22,15.72 20.72,17 19.14,17H12C12,17.39 12.32,17.96 12.71,17.96H17V19.64C17,21.22 15.72,22.5 14.14,22.5H9.86C8.28,22.5 7,21.22 7,19.64V15.89C7,14.31 8.28,13.04 9.86,13.04H15.11C16.69,13.04 17.96,11.76 17.96,10.18V7.5H19.14M14.86,19.29C14.46,19.29 14.14,19.59 14.14,20.18C14.14,20.77 14.46,20.89 14.86,20.89C15.25,20.89 15.57,20.57 15.57,20.18C15.57,19.59 15.25,19.29 14.86,19.29M4.86,17.5C3.28,17.5 2,16.22 2,14.64V10.86C2,9.28 3.28,8 4.86,8H12C12,7.61 11.68,7.04 11.29,7.04H7V5.36C7,3.78 8.28,2.5 9.86,2.5H14.14C15.72,2.5 17,3.78 17,5.36V9.11C17,10.69 15.72,11.96 14.14,11.96H8.89C7.31,11.96 6.04,13.24 6.04,14.82V17.5H4.86M9.14,5.71C9.54,5.71 9.86,5.41 9.86,4.82C9.86,4.23 9.54,4.11 9.14,4.11C8.75,4.11 8.43,4.23 8.43,4.82C8.43,5.41 8.75,5.71 9.14,5.71Z' })
	  );
	};
	
	var LanguageRIcon = function LanguageRIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,4.29C6.5,4.29 2,7.29 2,11C2,14.28 5.56,17 10.24,17.58V19.71H13.65V17.59C14.5,17.5 15.29,17.34 16.04,17.11L17.42,19.71H21.28L18.96,15.8C20.83,14.58 22,12.87 22,11C22,7.29 17.5,4.29 12,4.29V4.29M13.53,6.91C17.73,6.91 20.83,8.31 20.83,11.5C20.83,13.21 19.91,14.41 18.41,15.15C18.32,15.1 18.24,15.05 18.19,15C17.83,14.84 17.23,14.66 17.23,14.66C17.23,14.66 20.21,14.44 20.21,11.47C20.21,8.5 17.09,8.45 17.09,8.45H10.24V15.61C7.69,14.87 5.93,13.3 5.93,11.5C5.93,8.96 9.33,6.91 13.53,6.91M13.68,10.89H15.75C15.75,10.89 16.7,10.84 16.7,11.83C16.7,12.8 15.75,12.8 15.75,12.8H13.68V10.89M13.65,15.3H14.57C14.75,15.3 14.84,15.35 15,15.5C15.13,15.6 15.27,15.79 15.39,15.96C14.84,16.03 14.26,16.06 13.65,16.06V15.3Z' })
	  );
	};
	
	var LanguageSwiftIcon = function LanguageSwiftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.09,19.72C14.73,21.08 11.5,21.22 8.23,19.82C5.59,18.7 3.4,16.74 2,14.5C2.67,15.05 3.46,15.5 4.3,15.9C7.67,17.47 11.03,17.36 13.4,15.9C10.03,13.31 7.16,9.94 5.03,7.19C4.58,6.74 4.25,6.18 3.91,5.68C12.19,11.73 11.83,13.27 6.32,4.67C11.21,9.61 15.75,12.41 15.75,12.41C15.91,12.5 16,12.57 16.11,12.63C16.21,12.38 16.3,12.12 16.37,11.85C17.16,9 16.26,5.73 14.29,3.04C18.84,5.79 21.54,10.95 20.41,15.28C20.38,15.39 20.35,15.5 20.36,15.67C22.6,18.5 22,21.45 21.71,20.89C20.5,18.5 18.23,19.24 17.09,19.72V19.72Z' })
	  );
	};
	
	var LanguageTypescriptIcon = function LanguageTypescriptIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3H21V21H3V3M13.71,17.86C14.21,18.84 15.22,19.59 16.8,19.59C18.4,19.59 19.6,18.76 19.6,17.23C19.6,15.82 18.79,15.19 17.35,14.57L16.93,14.39C16.2,14.08 15.89,13.87 15.89,13.37C15.89,12.96 16.2,12.64 16.7,12.64C17.18,12.64 17.5,12.85 17.79,13.37L19.1,12.5C18.55,11.54 17.77,11.17 16.7,11.17C15.19,11.17 14.22,12.13 14.22,13.4C14.22,14.78 15.03,15.43 16.25,15.95L16.67,16.13C17.45,16.47 17.91,16.68 17.91,17.26C17.91,17.74 17.46,18.09 16.76,18.09C15.93,18.09 15.45,17.66 15.09,17.06L13.71,17.86M13,11.25H8V12.75H9.5V20H11.25V12.75H13V11.25Z' })
	  );
	};
	
	var LaptopChromebookIcon = function LaptopChromebookIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,15H4V5H20M14,18H10V17H14M22,18V3H2V18H0V20H24V18H22Z' })
	  );
	};
	
	var LaptopMacIcon = function LaptopMacIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,19C11.45,19 11,18.55 11,18C11,17.45 11.45,17 12,17C12.55,17 13,17.45 13,18C13,18.55 12.55,19 12,19M4,5H20V16H4M20,18C21.1,18 22,17.1 22,16V5C22,3.89 21.1,3 20,3H4C2.89,3 2,3.89 2,5V16C2,17.1 2.9,18 4,18H0C0,19.1 0.9,20 2,20H22C23.1,20 24,19.1 24,18H20Z' })
	  );
	};
	
	var LaptopOffIcon = function LaptopOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,4.27L2.28,3L20,20.72L18.73,22L16.73,20H0V18H4C2.89,18 2,17.1 2,16V6C2,5.78 2.04,5.57 2.1,5.37L1,4.27M4,16H12.73L4,7.27V16M20,16V6H7.82L5.82,4H20C21.1,4 22,4.9 22,6V16C22,17.1 21.1,18 20,18H24V20H21.82L17.82,16H20Z' })
	  );
	};
	
	var LaptopWindowsIcon = function LaptopWindowsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4H21C21.55,4 22,4.45 22,5V16C22,16.55 21.55,17 21,17H22L24,20V21H0V20L2,17H3C2.45,17 2,16.55 2,16V5C2,4.45 2.45,4 3,4M4,6V15H20V6H4Z' })
	  );
	};
	
	var LaptopIcon = function LaptopIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,6H20V16H4M20,18C21.1,18 22,17.1 22,16V6C22,4.89 21.1,4 20,4H4C2.89,4 2,4.89 2,6V16C2,17.1 2.9,18 4,18H0V20H24V18H20Z' })
	  );
	};
	
	var LastfmIcon = function LastfmIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,17.93C15.92,17.92 14.81,16.9 14.04,15.09L13.82,14.6L11.92,10.23C11.29,8.69 9.72,7.64 7.96,7.64C5.57,7.64 3.63,9.59 3.63,12C3.63,14.41 5.57,16.36 7.96,16.36C9.62,16.36 11.08,15.41 11.8,14L12.57,15.81C11.5,17.15 9.82,18 7.96,18C4.67,18 2,15.32 2,12C2,8.69 4.67,6 7.96,6C10.44,6 12.45,7.34 13.47,9.7C13.54,9.89 14.54,12.24 15.42,14.24C15.96,15.5 16.42,16.31 17.91,16.36C19.38,16.41 20.39,15.5 20.39,14.37C20.39,13.26 19.62,13 18.32,12.56C16,11.79 14.79,11 14.79,9.15C14.79,7.33 16,6.12 18,6.12C19.31,6.12 20.24,6.7 20.89,7.86L19.62,8.5C19.14,7.84 18.61,7.57 17.94,7.57C17,7.57 16.33,8.23 16.33,9.1C16.33,10.34 17.43,10.53 18.97,11.03C21.04,11.71 22,12.5 22,14.42C22,16.45 20.27,17.93 18,17.93Z' })
	  );
	};
	
	var LastpassIcon = function LastpassIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,12C14,10.9 14.9,10 16,10C17.1,10 18,10.9 18,12C18,13.1 17.1,14 16,14C14.9,14 14,13.1 14,12M8,12C8,10.9 8.9,10 10,10C11.1,10 12,10.9 12,12C12,13.1 11.1,14 10,14C8.9,14 8,13.1 8,12M2,12C2,10.9 2.9,10 4,10C5.1,10 6,10.9 6,12C6,13.1 5.1,14 4,14C2.9,14 2,13.1 2,12M22,5H20V19H22V5Z' })
	  );
	};
	
	var LaunchIcon = function LaunchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V12H19V19Z' })
	  );
	};
	
	var LavaLampIcon = function LavaLampIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,3L8,16H16L14,3H10M11.5,5.75C11.91,5.75 12.25,6.09 12.25,6.5C12.25,6.91 11.91,7.25 11.5,7.25C11.09,7.25 10.75,6.91 10.75,6.5C10.75,6.09 11.09,5.75 11.5,5.75M12.5,8.5C13.05,8.5 13.5,8.95 13.5,9.5C13.5,10.05 13.05,10.5 12.5,10.5C11.95,10.5 11.5,10.05 11.5,9.5C11.5,8.95 11.95,8.5 12.5,8.5M11.5,12C12.33,12 13,12.67 13,13.5C13,14.33 12.33,15 11.5,15C10.67,15 10,14.33 10,13.5C10,12.67 10.67,12 11.5,12M8,17L10,19L8,21H16L14,19L16,17H8Z' })
	  );
	};
	
	var LayersOffIcon = function LayersOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.27,1L2,2.27L6.22,6.5L3,9L4.63,10.27L12,16L14.1,14.37L15.53,15.8L12,18.54L4.63,12.81L3,14.07L12,21.07L16.95,17.22L20.73,21L22,19.73L3.27,1M19.36,10.27L21,9L12,2L9.09,4.27L16.96,12.15L19.36,10.27M19.81,15L21,14.07L19.57,12.64L18.38,13.56L19.81,15Z' })
	  );
	};
	
	var LayersIcon = function LayersIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,16L19.36,10.27L21,9L12,2L3,9L4.63,10.27M12,18.54L4.62,12.81L3,14.07L12,21.07L21,14.07L19.37,12.8L12,18.54Z' })
	  );
	};
	
	var LeadPencilIcon = function LeadPencilIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.84,2.73C16.45,2.73 16.07,2.88 15.77,3.17L13.65,5.29L18.95,10.6L21.07,8.5C21.67,7.89 21.67,6.94 21.07,6.36L17.9,3.17C17.6,2.88 17.22,2.73 16.84,2.73M12.94,6L4.84,14.11L7.4,14.39L7.58,16.68L9.86,16.85L10.15,19.41L18.25,11.3M4.25,15.04L2.5,21.73L9.2,19.94L8.96,17.78L6.65,17.61L6.47,15.29' })
	  );
	};
	
	var LeafIcon = function LeafIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,8C8,10 5.9,16.17 3.82,21.34L5.71,22L6.66,19.7C7.14,19.87 7.64,20 8,20C19,20 22,3 22,3C21,5 14,5.25 9,6.25C4,7.25 2,11.5 2,13.5C2,15.5 3.75,17.25 3.75,17.25C7,8 17,8 17,8Z' })
	  );
	};
	
	var LedOffIcon = function LedOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,6C9.79,6 8,7.79 8,10V16H6V18H9V23H11V18H13V23H15V18H18V16H16V10C16,7.79 14.21,6 12,6Z' })
	  );
	};
	
	var LedOnIcon = function LedOnIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,0V4H13V0H11M18.3,2.29L15.24,5.29L16.64,6.71L19.7,3.71L18.3,2.29M5.71,2.29L4.29,3.71L7.29,6.71L8.71,5.29L5.71,2.29M12,6C9.79,6 8,7.79 8,10V16H6V18H9V23H11V18H13V23H15V18H18V16H16V10C16,7.79 14.21,6 12,6M2,9V11H6V9H2M18,9V11H22V9H18Z' })
	  );
	};
	
	var LedOutlineIcon = function LedOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,6C9.79,6 8,7.79 8,10V16H6V18H9V23H11V18H13V23H15V18H18V16H16V10C16,7.79 14.21,6 12,6M12,8C13.1,8 14,8.9 14,10V15H10V10C10,8.9 10.9,8 12,8Z' })
	  );
	};
	
	var LedStripIcon = function LedStripIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.81,8.46L14.83,20.5L15.54,19.78L16.95,21.19L18.36,19.78L16.95,18.36L18.36,16.95L19.78,18.36L21.19,16.95L19.78,15.54L20.5,14.83L8.46,2.81L2.81,8.46M5.64,8.46L8.46,5.64L17.66,14.83L14.83,17.66L5.64,8.46M7.05,8.46L8.46,9.88L9.88,8.46L8.46,7.05L7.05,8.46M9.17,10.59L10.59,12L12,10.59L10.59,9.17L9.17,10.59M11.29,12.71L12.71,14.12L14.12,12.71L12.71,11.29L11.29,12.71M13.41,14.83L14.83,16.24L16.24,14.83L14.83,13.41L13.41,14.83Z' })
	  );
	};
	
	var LedVariantOffIcon = function LedVariantOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C10.05,3 8.43,4.4 8.08,6.25L16.82,15H18V13H16V7C16,4.79 14.21,3 12,3M3.28,4L2,5.27L8,11.27V13H6V15H9V21H11V15H11.73L13,16.27V21H15V18.27L18.73,22L20,20.72L15,15.72L8,8.72L3.28,4Z' })
	  );
	};
	
	var LedVariantOnIcon = function LedVariantOnIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C9.79,3 8,4.79 8,7V13H6V15H9V21H11V15H13V21H15V15H18V13H16V7C16,4.79 14.21,3 12,3Z' })
	  );
	};
	
	var LedVariantOutlineIcon = function LedVariantOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C9.79,3 8,4.79 8,7V13H6V15H9V21H11V15H13V21H15V15H18V13H16V7C16,4.79 14.21,3 12,3M12,5C13.1,5 14,5.9 14,7V12H10V7C10,5.9 10.9,5 12,5Z' })
	  );
	};
	
	var LessThanOrEqualIcon = function LessThanOrEqualIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.5,2.27L5,10.14L18.5,18L19.5,16.27L8.97,10.14L19.5,4L18.5,2.27M5,20V22H20V20H5Z' })
	  );
	};
	
	var LessThanIcon = function LessThanIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.5,4.14L19.5,5.86L8.97,12L19.5,18.14L18.5,19.86L5,12L18.5,4.14Z' })
	  );
	};
	
	var LibraryBooksIcon = function LibraryBooksIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,7H9V5H19M15,15H9V13H15M19,11H9V9H19M20,2H8C6.9,2 6,2.9 6,4V16C6,17.1 6.9,18 8,18H20C21.1,18 22,17.1 22,16V4C22,2.9 21.1,2 20,2M4,6H2V20C2,21.1 2.9,22 4,22H18V20H4V6Z' })
	  );
	};
	
	var LibraryMusicIcon = function LibraryMusicIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,6H2V20C2,21.1 2.9,22 4,22H18V20H4M18,7H15V12.5C15,13.88 13.88,15 12.5,15C11.12,15 10,13.88 10,12.5C10,11.12 11.12,10 12.5,10C13.07,10 13.58,10.19 14,10.5V5H18M20,2H8C6.9,2 6,2.9 6,4V16C6,17.1 6.9,18 8,18H20C21.1,18 22,17.1 22,16V4C22,2.9 21.1,2 20,2Z' })
	  );
	};
	
	var LibraryPlusIcon = function LibraryPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,11H15V15H13V11H9V9H13V5H15V9H19M20,2H8C6.9,2 6,2.9 6,4V16C6,17.1 6.9,18 8,18H20C21.1,18 22,17.1 22,16V4C22,2.9 21.1,2 20,2M4,6H2V20C2,21.1 2.9,22 4,22H18V20H4V6Z' })
	  );
	};
	
	var LibraryIcon = function LibraryIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,8C13.66,8 15,6.66 15,5C15,3.34 13.66,2 12,2C10.34,2 9,3.34 9,5C9,6.66 10.34,8 12,8M12,11.54C9.64,9.35 6.5,8 3,8V19C6.5,19 9.64,20.35 12,22.54C14.36,20.35 17.5,19 21,19V8C17.5,8 14.36,9.35 12,11.54Z' })
	  );
	};
	
	var LifebuoyIcon = function LifebuoyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.79,15.41C20.74,13.24 20.74,10.75 19.79,8.59L17.05,9.83C17.65,11.21 17.65,12.78 17.06,14.17L19.79,15.41M15.42,4.21C13.25,3.26 10.76,3.26 8.59,4.21L9.83,6.94C11.22,6.35 12.79,6.35 14.18,6.95L15.42,4.21M4.21,8.58C3.26,10.76 3.26,13.24 4.21,15.42L6.95,14.17C6.35,12.79 6.35,11.21 6.95,9.82L4.21,8.58M8.59,19.79C10.76,20.74 13.25,20.74 15.42,19.78L14.18,17.05C12.8,17.65 11.22,17.65 9.84,17.06L8.59,19.79M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,8C9.79,8 8,9.79 8,12C8,14.21 9.79,16 12,16C14.21,16 16,14.21 16,12C16,9.79 14.21,8 12,8Z' })
	  );
	};
	
	var LightSwitchIcon = function LightSwitchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,1C5.9,1 5,1.9 5,3V21C5,22.1 5.9,23 7,23H17C18.1,23 19,22.1 19,21V3C19,1.9 18.1,1 17,1H7M7,3H17V21H7V3M9,6V18H15V6H9M10,7H14V11H10V7M10,13H14V17H10V13Z' })
	  );
	};
	
	var LightbulbOnOutlineIcon = function LightbulbOnOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,11H23V13H20V11M1,11H4V13H1V11M13,1V4H11V1H13M4.92,3.5L7.05,5.64L5.63,7.05L3.5,4.93L4.92,3.5M16.95,5.63L19.07,3.5L20.5,4.93L18.37,7.05L16.95,5.63M12,6C15.31,6 18,8.69 18,12C18,14.22 16.79,16.16 15,17.2V19C15,19.55 14.55,20 14,20H10C9.45,20 9,19.55 9,19V17.2C7.21,16.16 6,14.22 6,12C6,8.69 8.69,6 12,6M14,21V22C14,22.55 13.55,23 13,23H11C10.45,23 10,22.55 10,22V21H14M11,18H13V15.87C14.73,15.43 16,13.86 16,12C16,9.79 14.21,8 12,8C9.79,8 8,9.79 8,12C8,13.86 9.27,15.43 11,15.87V18Z' })
	  );
	};
	
	var LightbulbOnIcon = function LightbulbOnIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,6C15.31,6 18,8.69 18,12C18,14.22 16.79,16.16 15,17.2V19C15,19.55 14.55,20 14,20H10C9.45,20 9,19.55 9,19V17.2C7.21,16.16 6,14.22 6,12C6,8.69 8.69,6 12,6M14,21V22C14,22.55 13.55,23 13,23H11C10.45,23 10,22.55 10,22V21H14M20,11H23V13H20V11M1,11H4V13H1V11M13,1V4H11V1H13M4.92,3.5L7.05,5.64L5.63,7.05L3.5,4.93L4.92,3.5M16.95,5.63L19.07,3.5L20.5,4.93L18.37,7.05L16.95,5.63Z' })
	  );
	};
	
	var LightbulbOutlineIcon = function LightbulbOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C15.87,2 19,5.13 19,9C19,11.38 17.81,13.47 16,14.74V17C16,17.55 15.55,18 15,18H9C8.45,18 8,17.55 8,17V14.74C6.19,13.47 5,11.38 5,9C5,5.13 8.13,2 12,2M9,21V20H15V21C15,21.55 14.55,22 14,22H10C9.45,22 9,21.55 9,21M12,4C9.24,4 7,6.24 7,9C7,11.05 8.23,12.81 10,13.58V16H14V13.58C15.77,12.81 17,11.05 17,9C17,6.24 14.76,4 12,4Z' })
	  );
	};
	
	var LightbulbIcon = function LightbulbIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C8.13,2 5,5.13 5,9C5,11.38 6.19,13.47 8,14.74V17C8,17.55 8.45,18 9,18H15C15.55,18 16,17.55 16,17V14.74C17.81,13.47 19,11.38 19,9C19,5.13 15.87,2 12,2M9,21C9,21.55 9.45,22 10,22H14C14.55,22 15,21.55 15,21V20H9V21Z' })
	  );
	};
	
	var LinkOffIcon = function LinkOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L14.73,18H13V16.27L9.73,13H8V11.27L5.5,8.76C4.5,9.5 3.9,10.68 3.9,12C3.9,14.26 5.74,16.1 8,16.1H11V18H8C4.69,18 2,15.31 2,12C2,10.16 2.83,8.5 4.14,7.41L2,5.27M16,6C19.31,6 22,8.69 22,12C22,14.21 20.8,16.15 19,17.19L17.6,15.77C19.07,15.15 20.1,13.7 20.1,12C20.1,9.73 18.26,7.9 16,7.9H13V6H16M8,6H11V7.9H9.72L7.82,6H8M16,11V13H14.82L12.82,11H16Z' })
	  );
	};
	
	var LinkVariantOffIcon = function LinkVariantOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L13.9,17.17L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L12.5,15.76L10.88,14.15C10.87,14.39 10.77,14.64 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C8.12,13.77 7.63,12.37 7.72,11L2,5.27M12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.79,8.97L9.38,7.55L12.71,4.22M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.2,10.54 16.61,12.5 16.06,14.23L14.28,12.46C14.23,11.78 13.94,11.11 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z' })
	  );
	};
	
	var LinkVariantIcon = function LinkVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.59,13.41C11,13.8 11,14.44 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C7.22,12.88 7.22,9.71 9.17,7.76V7.76L12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.59,9.17C9.41,10.34 9.41,12.24 10.59,13.41M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.78,11.12 16.78,14.29 14.83,16.24V16.24L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L13.41,14.83C14.59,13.66 14.59,11.76 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z' })
	  );
	};
	
	var LinkIcon = function LinkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,6H13V7.9H16C18.26,7.9 20.1,9.73 20.1,12C20.1,14.26 18.26,16.1 16,16.1H13V18H16C19.31,18 22,15.31 22,12C22,8.68 19.31,6 16,6M3.9,12C3.9,9.73 5.74,7.9 8,7.9H11V6H8C4.69,6 2,8.69 2,12C2,15.31 4.69,18 8,18H11V16.1H8C5.74,16.1 3.9,14.26 3.9,12M8,13H16V11H8V13Z' })
	  );
	};
	
	var LinkedinBoxIcon = function LinkedinBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M18.5,18.5V13.2C18.5,11.4 17.04,9.94 15.24,9.94C14.39,9.94 13.4,10.46 12.92,11.24V10.13H10.13V18.5H12.92V13.57C12.92,12.8 13.54,12.17 14.31,12.17C15.08,12.17 15.71,12.8 15.71,13.57V18.5H18.5M6.88,8.56C7.81,8.56 8.56,7.81 8.56,6.88C8.56,5.95 7.81,5.19 6.88,5.19C5.95,5.19 5.19,5.95 5.19,6.88C5.19,7.81 5.95,8.56 6.88,8.56M8.27,18.5V10.13H5.5V18.5H8.27Z' })
	  );
	};
	
	var LinkedinIcon = function LinkedinIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,21H17V14.25C17,13.19 15.81,12.31 14.75,12.31C13.69,12.31 13,13.19 13,14.25V21H9V9H13V11C13.66,9.93 15.36,9.24 16.5,9.24C19,9.24 21,11.28 21,13.75V21M7,21H3V9H7V21M5,3C6.1,3 7,3.9 7,5C7,6.1 6.1,7 5,7C3.9,7 3,6.1 3,5C3,3.9 3.9,3 5,3Z' })
	  );
	};
	
	var LinuxMintIcon = function LinuxMintIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,3.23V6.8H3.5C4.59,6.8 4.78,7.53 4.78,8.55V14.86C4.78,18.12 7.65,20.77 11.18,20.77H19.9C21,20.77 22,20.07 22,19V9.2C22,5.93 19.13,3.28 15.6,3.28H11.93V3.27L2,3.23V3.23M6.62,5.46H8.37V14.45C8.37,15.65 9.19,16.59 10.16,16.59L16.13,16.61C17.38,16.61 18.35,15.75 18.35,14.73L18.34,9.96C18.34,9.65 18.24,9.41 18,9.19C17.79,8.96 17.56,8.86 17.25,8.86C16.94,8.86 16.71,8.96 16.5,9.19C16.27,9.41 16.16,9.65 16.16,9.96V14.05H14.31V9.96C14.31,9.65 14.21,9.41 14,9.19C13.77,8.96 13.54,8.86 13.22,8.86C12.92,8.86 12.68,8.96 12.46,9.19C12.24,9.41 12.14,9.65 12.14,9.96V14.05H10.29V9.96C10.29,9.15 10.58,8.44 11.15,7.86C11.72,7.29 12.43,7 13.22,7C14,7 14.68,7.28 15.24,7.82C15.79,7.28 16.47,7 17.25,7C18.05,7 18.76,7.29 19.32,7.86C19.89,8.44 20.19,9.15 20.19,9.96L20.2,15.06C20.11,15.91 19.75,16.67 19.13,17.31V17.31C18.4,18.04 17.5,18.42 16.5,18.42H9.83C9,18.34 8.29,17.95 7.69,17.36C7,16.65 6.62,15.79 6.62,14.79V5.46H6.62Z' })
	  );
	};
	
	var LinuxIcon = function LinuxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.62,8.35C14.2,8.63 12.87,9.39 12.67,9.54C12.28,9.85 11.92,9.83 11.53,9.53C11.33,9.37 10,8.61 9.58,8.34C9.1,8.03 9.13,7.64 9.66,7.42C11.3,6.73 12.94,6.78 14.57,7.45C15.06,7.66 15.08,8.05 14.62,8.35M21.84,15.63C20.91,13.54 19.64,11.64 18,9.97C17.47,9.42 17.14,8.8 16.94,8.09C16.84,7.76 16.77,7.42 16.7,7.08C16.5,6.2 16.41,5.3 16,4.47C15.27,2.89 14,2.07 12.16,2C10.35,2.05 9,2.81 8.21,4.4C8,4.83 7.85,5.28 7.75,5.74C7.58,6.5 7.43,7.29 7.25,8.06C7.1,8.71 6.8,9.27 6.29,9.77C4.68,11.34 3.39,13.14 2.41,15.12C2.27,15.41 2.13,15.7 2.04,16C1.85,16.66 2.33,17.12 3.03,16.96C3.47,16.87 3.91,16.78 4.33,16.65C4.74,16.5 4.9,16.6 5,17C5.65,19.15 7.07,20.66 9.24,21.5C13.36,23.06 18.17,20.84 19.21,16.92C19.28,16.65 19.38,16.55 19.68,16.65C20.14,16.79 20.61,16.89 21.08,17C21.57,17.09 21.93,16.84 22,16.36C22.03,16.1 21.94,15.87 21.84,15.63' })
	  );
	};
	
	var LoadingIcon = function LoadingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,4V2C6.48,2 2,6.48 2,12H4C4,7.58 7.58,4 12,4Z' })
	  );
	};
	
	var LockAlertIcon = function LockAlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1C9.24,1 7,3.24 7,6V8H6C4.9,8 4,8.9 4,10V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V10C20,8.9 19.1,8 18,8H17V6C17,3.24 14.76,1 12,1M12,2.9C13.71,2.9 15.1,4.29 15.1,6V8H8.9V6C8.9,4.29 10.29,2.9 12,2.9M11,11H13V15H11V11M11,17H13V19H11V17Z' })
	  );
	};
	
	var LockClockIcon = function LockClockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.5,2C6,2 4,4 4,6.5V7C2.89,7 2,7.89 2,9V18C2,19.11 2.89,20 4,20H8.72C10.18,21.29 12.06,22 14,22C18.42,22 22,18.42 22,14C22,9.58 18.42,6 14,6C13.66,6 13.32,6.03 13,6.08C12.76,3.77 10.82,2 8.5,2M8.5,4C9.88,4 11,5.12 11,6.5V7H6V6.5C6,5.12 7.12,4 8.5,4M14,8C17.31,8 20,10.69 20,14C20,17.31 17.31,20 14,20C10.69,20 8,17.31 8,14C8,10.69 10.69,8 14,8M13,10V15L16.64,17.19L17.42,15.9L14.5,14.15V10H13Z' })
	  );
	};
	
	var LockOpenOutlineIcon = function LockOpenOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,20V10H6V20H18M18,8C19.1,8 20,8.9 20,10V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V10C4,8.9 4.9,8 6,8H15V6C15,4.34 13.66,3 12,3C10.34,3 9,4.34 9,6H7C7,3.24 9.24,1 12,1C14.76,1 17,3.24 17,6V8H18M12,17C10.9,17 10,16.1 10,15C10,13.9 10.9,13 12,13C13.1,13 14,13.9 14,15C14,16.1 13.1,17 12,17Z' })
	  );
	};
	
	var LockOpenIcon = function LockOpenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,8C19.1,8 20,8.9 20,10V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V10C4,8.9 4.9,8 6,8H15V6C15,4.34 13.66,3 12,3C10.34,3 9,4.34 9,6H7C7,3.24 9.24,1 12,1C14.76,1 17,3.24 17,6V8H18M12,17C13.1,17 14,16.1 14,15C14,13.9 13.1,13 12,13C10.9,13 10,13.9 10,15C10,16.1 10.9,17 12,17Z' })
	  );
	};
	
	var LockOutlineIcon = function LockOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,17C10.89,17 10,16.1 10,15C10,13.89 10.89,13 12,13C13.1,13 14,13.9 14,15C14,16.1 13.1,17 12,17M18,20V10H6V20H18M18,8C19.1,8 20,8.9 20,10V20C20,21.1 19.1,22 18,22H6C4.89,22 4,21.1 4,20V10C4,8.89 4.89,8 6,8H7V6C7,3.24 9.24,1 12,1C14.76,1 17,3.24 17,6V8H18M12,3C10.34,3 9,4.34 9,6V8H15V6C15,4.34 13.66,3 12,3Z' })
	  );
	};
	
	var LockPatternIcon = function LockPatternIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,3C9.21,3 11,4.79 11,7C11,8.86 9.73,10.43 8,10.87V13.13C8.37,13.22 8.72,13.37 9.04,13.56L13.56,9.04C13.2,8.44 13,7.75 13,7C13,4.79 14.79,3 17,3C19.21,3 21,4.79 21,7C21,9.21 19.21,11 17,11C16.26,11 15.57,10.8 15,10.45L10.45,15C10.8,15.57 11,16.26 11,17C11,19.21 9.21,21 7,21C4.79,21 3,19.21 3,17C3,15.14 4.27,13.57 6,13.13V10.87C4.27,10.43 3,8.86 3,7C3,4.79 4.79,3 7,3M17,13C19.21,13 21,14.79 21,17C21,19.21 19.21,21 17,21C14.79,21 13,19.21 13,17C13,14.79 14.79,13 17,13M17,15C15.9,15 15,15.9 15,17C15,18.1 15.9,19 17,19C18.1,19 19,18.1 19,17C19,15.9 18.1,15 17,15Z' })
	  );
	};
	
	var LockPlusIcon = function LockPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,8H17V6C17,3.24 14.76,1 12,1C9.24,1 7,3.24 7,6V8H6C4.9,8 4,8.9 4,10V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V10C20,8.9 19.1,8 18,8M8.9,6C8.9,4.29 10.29,2.9 12,2.9C13.71,2.9 15.1,4.29 15.1,6V8H8.9V6M16,16H13V19H11V16H8V14H11V11H13V14H16V16Z' })
	  );
	};
	
	var LockQuestionIcon = function LockQuestionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1C9.24,1 7,3.24 7,6V8H6C4.9,8 4,8.9 4,10V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V10C20,8.9 19.1,8 18,8H17V6C17,3.24 14.76,1 12,1M12,2.9C13.71,2.9 15.1,4.29 15.1,6V8H8.9V6C8.9,4.29 10.29,2.9 12,2.9M12.19,10.5C13.13,10.5 13.88,10.71 14.42,11.12C14.96,11.54 15.23,12.1 15.23,12.8C15.23,13.24 15.08,13.63 14.79,14C14.5,14.36 14.12,14.64 13.66,14.85C13.4,15 13.23,15.15 13.14,15.32C13.05,15.5 13,15.72 13,16H11C11,15.5 11.1,15.16 11.29,14.92C11.5,14.68 11.84,14.4 12.36,14.08C12.62,13.94 12.83,13.76 13,13.54C13.14,13.33 13.22,13.08 13.22,12.8C13.22,12.5 13.13,12.28 12.95,12.11C12.77,11.93 12.5,11.85 12.19,11.85C11.92,11.85 11.7,11.92 11.5,12.06C11.34,12.2 11.24,12.41 11.24,12.69H9.27C9.22,12 9.5,11.4 10.05,11.04C10.59,10.68 11.3,10.5 12.19,10.5M11,17H13V19H11V17Z' })
	  );
	};
	
	var LockResetIcon = function LockResetIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.63,2C18.16,2 22.64,6.5 22.64,12C22.64,17.5 18.16,22 12.63,22C9.12,22 6.05,20.18 4.26,17.43L5.84,16.18C7.25,18.47 9.76,20 12.64,20C17.06,20 20.64,16.42 20.64,12C20.64,7.58 17.06,4 12.64,4C8.56,4 5.2,7.06 4.71,11H7.47L3.73,14.73L0,11H2.69C3.19,5.95 7.45,2 12.63,2M15.59,10.24C16.09,10.25 16.5,10.65 16.5,11.16V15.77C16.5,16.27 16.09,16.69 15.58,16.69H10.05C9.54,16.69 9.13,16.27 9.13,15.77V11.16C9.13,10.65 9.54,10.25 10.04,10.24V9.23C10.04,7.7 11.29,6.46 12.81,6.46C14.34,6.46 15.59,7.7 15.59,9.23V10.24M12.81,7.86C12.06,7.86 11.44,8.47 11.44,9.23V10.24H14.19V9.23C14.19,8.47 13.57,7.86 12.81,7.86Z' })
	  );
	};
	
	var LockSmartIcon = function LockSmartIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C8.69,2 6,4.69 6,8V16C6,19.31 8.69,22 12,22C15.31,22 18,19.31 18,16V8C18,4.69 15.31,2 12,2M8,6H10V8H8V6M11,6H13V8H11V6M14,6H16V8H14V6M8,9H10V11H8V9M11,9H13V11H11V9M14,9H16V11H14V9M8,12H10V14H8V12M11,12H13V14H11V12M14,12H16V14H14V12M12,16C13.1,16 14,16.9 14,18C14,19.1 13.1,20 12,20C10.9,20 10,19.1 10,18C10,16.9 10.9,16 12,16Z' })
	  );
	};
	
	var LockIcon = function LockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,17C13.1,17 14,16.1 14,15C14,13.89 13.1,13 12,13C10.9,13 10,13.9 10,15C10,16.1 10.9,17 12,17M18,8C19.1,8 20,8.9 20,10V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V10C4,8.89 4.9,8 6,8H7V6C7,3.24 9.24,1 12,1C14.76,1 17,3.24 17,6V8H18M12,3C10.34,3 9,4.34 9,6V8H15V6C15,4.34 13.66,3 12,3Z' })
	  );
	};
	
	var LockerMultipleIcon = function LockerMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,2H21C22.1,2 23,2.9 23,4V20C23,21.1 22.1,22 21,22H3C1.9,22 1,21.1 1,20V4C1,2.9 1.9,2 3,2M13,4V20H21V4H13M3,4V20H11V4H3M5,13H7V17H5V13M5,6H9V7.5H5V6M5,9H9V10.5H5V9M15,13H17V17H15V13M15,6H19V7.5H15V6M15,9H19V10.5H15V9Z' })
	  );
	};
	
	var LockerIcon = function LockerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,2H16C17.1,2 18,2.9 18,4V20C18,21.1 17.1,22 16,22H8C6.9,22 6,21.1 6,20V4C6,2.9 6.9,2 8,2M8,4V20H16V4H8M10,13H12V17H10V13M10,6H14V7.5H10V6M10,9H14V10.5H10V9Z' })
	  );
	};
	
	var LoginVariantIcon = function LoginVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3H5C3.89,3 3,3.89 3,5V9H5V5H19V19H5V15H3V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M10.08,15.58L11.5,17L16.5,12L11.5,7L10.08,8.41L12.67,11H3V13H12.67L10.08,15.58Z' })
	  );
	};
	
	var LoginIcon = function LoginIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,17.25V14H3V10H10V6.75L15.25,12L10,17.25M8,2H17C18.1,2 19,2.9 19,4V20C19,21.1 18.1,22 17,22H8C6.9,22 6,21.1 6,20V16H8V20H17V4H8V8H6V4C6,2.9 6.9,2 8,2Z' })
	  );
	};
	
	var LogoutVariantIcon = function LogoutVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.08,15.59L16.67,13H7V11H16.67L14.08,8.41L15.5,7L20.5,12L15.5,17L14.08,15.59M19,3C20.1,3 21,3.9 21,5V9.67L19,7.67V5H5V19H19V16.33L21,14.33V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19Z' })
	  );
	};
	
	var LogoutIcon = function LogoutIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,17.25V14H10V10H17V6.75L22.25,12L17,17.25M13,2C14.1,2 15,2.9 15,4V8H13V4H4V20H13V16H15V20C15,21.1 14.1,22 13,22H4C2.9,22 2,21.1 2,20V4C2,2.9 2.9,2 4,2H13Z' })
	  );
	};
	
	var LooksIcon = function LooksIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,6C5.92,6 1,10.92 1,17H3C3,12.04 7.04,8 12,8C16.96,8 21,12.04 21,17H23C23,10.92 18.08,6 12,6M12,10C8.14,10 5,13.14 5,17H7C7,14.24 9.24,12 12,12C14.76,12 17,14.24 17,17H19C19,13.14 15.86,10 12,10Z' })
	  );
	};
	
	var LoopIcon = function LoopIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,14V21H2V19H5.57C4,17.3 3,15 3,12.5C3,7.25 7.25,3 12.5,3C17.75,3 22,7.25 22,12.5C22,17.75 17.75,22 12.5,22H12V20H12.5C16.64,20 20,16.64 20,12.5C20,8.36 16.64,5 12.5,5C8.36,5 5,8.36 5,12.5C5,14.47 5.76,16.26 7,17.6V14H9Z' })
	  );
	};
	
	var LoupeIcon = function LoupeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22H20C21.1,22 22,21.1 22,20V12C22,6.48 17.52,2 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z' })
	  );
	};
	
	var LumxIcon = function LumxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.35,1.75L20.13,9.53L13.77,15.89L12.35,14.47L17.3,9.53L10.94,3.16L12.35,1.75M15.89,9.53L14.47,10.94L10.23,6.7L5.28,11.65L3.87,10.23L10.23,3.87L15.89,9.53M10.23,8.11L11.65,9.53L6.7,14.47L13.06,20.84L11.65,22.25L3.87,14.47L10.23,8.11M8.11,14.47L9.53,13.06L13.77,17.3L18.72,12.35L20.13,13.77L13.77,20.13L8.11,14.47Z' })
	  );
	};
	
	var MagnetOnIcon = function MagnetOnIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,7V13C3,17.97 7.03,22 12,22C16.97,22 21,17.97 21,13V7H17V13C17,15.76 14.76,18 12,18C9.24,18 7,15.76 7,13V7M17,5H21V2H17M3,5H7V2H3M13,1.5L9,9H11V14.5L15,7H13V1.5Z' })
	  );
	};
	
	var MagnetIcon = function MagnetIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,7V13C3,17.97 7.03,22 12,22C16.97,22 21,17.97 21,13V7H17V13C17,15.76 14.76,18 12,18C9.24,18 7,15.76 7,13V7M17,5H21V2H17M3,5H7V2H3' })
	  );
	};
	
	var MagnifyCloseIcon = function MagnifyCloseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,2C12.87,2 16,5.13 16,9C16,10.5 15.5,12 14.61,13.19L15.41,14H16L22,20L20,22L14,16V15.41L13.19,14.61C12,15.5 10.5,16 9,16C5.13,16 2,12.87 2,9C2,5.13 5.13,2 9,2M11.12,5.46L9,7.59L6.88,5.46L5.46,6.88L7.59,9L5.46,11.12L6.88,12.54L9,10.41L11.12,12.54L12.54,11.12L10.41,9L12.54,6.88L11.12,5.46Z' })
	  );
	};
	
	var MagnifyMinusOutlineIcon = function MagnifyMinusOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.5,14H14.71L14.43,13.73C15.41,12.59 16,11.11 16,9.5C16,5.91 13.09,3 9.5,3C5.91,3 3,5.91 3,9.5C3,13.09 5.91,16 9.5,16C11.11,16 12.59,15.41 13.73,14.43L14,14.71V15.5L19,20.5L20.5,19L15.5,14M9.5,14C7,14 5,12 5,9.5C5,7 7,5 9.5,5C12,5 14,7 14,9.5C14,12 12,14 9.5,14M7,9H12V10H7V9Z' })
	  );
	};
	
	var MagnifyMinusIcon = function MagnifyMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,2C12.87,2 16,5.13 16,9C16,10.57 15.5,12 14.61,13.19L15.41,14H16L22,20L20,22L14,16V15.41L13.19,14.61C12,15.5 10.57,16 9,16C5.13,16 2,12.87 2,9C2,5.13 5.13,2 9,2M5,8V10H13V8H5Z' })
	  );
	};
	
	var MagnifyPlusOutlineIcon = function MagnifyPlusOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.5,14L20.5,19L19,20.5L14,15.5V14.71L13.73,14.43C12.59,15.41 11.11,16 9.5,16C5.91,16 3,13.09 3,9.5C3,5.91 5.91,3 9.5,3C13.09,3 16,5.91 16,9.5C16,11.11 15.41,12.59 14.43,13.73L14.71,14H15.5M9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14M12,10H10V12H9V10H7V9H9V7H10V9H12V10Z' })
	  );
	};
	
	var MagnifyPlusIcon = function MagnifyPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,2C12.87,2 16,5.13 16,9C16,10.57 15.5,12 14.61,13.19L15.41,14H16L22,20L20,22L14,16V15.41L13.19,14.61C12,15.5 10.57,16 9,16C5.13,16 2,12.87 2,9C2,5.13 5.13,2 9,2M8,5V8H5V10H8V13H10V10H13V8H10V5H8Z' })
	  );
	};
	
	var MagnifyIcon = function MagnifyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.5,3C13.09,3 16,5.91 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16C5.91,16 3,13.09 3,9.5C3,5.91 5.91,3 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z' })
	  );
	};
	
	var MailRuIcon = function MailRuIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.45,11.91C15.34,9.7 13.7,8.37 11.72,8.37H11.64C9.35,8.37 8.09,10.17 8.09,12.21C8.09,14.5 9.62,15.95 11.63,15.95C13.88,15.95 15.35,14.3 15.46,12.36M11.65,6.39C13.18,6.39 14.62,7.07 15.67,8.13V8.13C15.67,7.62 16,7.24 16.5,7.24H16.61C17.35,7.24 17.5,7.94 17.5,8.16V16.06C17.46,16.58 18.04,16.84 18.37,16.5C19.64,15.21 21.15,9.81 17.58,6.69C14.25,3.77 9.78,4.25 7.4,5.89C4.88,7.63 3.26,11.5 4.83,15.11C6.54,19.06 11.44,20.24 14.35,19.06C15.83,18.47 16.5,20.46 15,21.11C12.66,22.1 6.23,22 3.22,16.79C1.19,13.27 1.29,7.08 6.68,3.87C10.81,1.42 16.24,2.1 19.5,5.5C22.95,9.1 22.75,15.8 19.4,18.41C17.89,19.59 15.64,18.44 15.66,16.71L15.64,16.15C14.59,17.2 13.18,17.81 11.65,17.81C8.63,17.81 6,15.15 6,12.13C6,9.08 8.63,6.39 11.65,6.39Z' })
	  );
	};
	
	var MailboxIcon = function MailboxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,6H10V12H8V4H14V0H6V6H4C2.9,6 2,6.9 2,8V20C2,21.1 2.9,22 4,22H20C21.1,22 22,21.1 22,20V8C22,6.9 21.1,6 20,6Z' })
	  );
	};
	
	var MapMarkerCircleIcon = function MapMarkerCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,12.5C11.17,12.5 10.5,11.83 10.5,11C10.5,10.17 11.17,9.5 12,9.5C12.83,9.5 13.5,10.17 13.5,11C13.5,11.83 12.83,12.5 12,12.5M12,7.2C9.9,7.2 8.2,8.9 8.2,11C8.2,14 12,17.5 12,17.5C12,17.5 15.8,14 15.8,11C15.8,8.9 14.1,7.2 12,7.2Z' })
	  );
	};
	
	var MapMarkerDistanceIcon = function MapMarkerDistanceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.5,8.11C5.61,8.11 4.89,7.39 4.89,6.5C4.89,5.61 5.61,4.89 6.5,4.89C7.39,4.89 8.11,5.61 8.11,6.5V6.5C8.11,7.39 7.39,8.11 6.5,8.11M6.5,2C4,2 2,4 2,6.5C2,9.87 6.5,14.86 6.5,14.86C6.5,14.86 11,9.87 11,6.5C11,4 9,2 6.5,2M17.5,8.11C16.61,8.11 15.89,7.39 15.89,6.5C15.89,5.61 16.61,4.89 17.5,4.89C18.39,4.89 19.11,5.61 19.11,6.5C19.11,7.39 18.39,8.11 17.5,8.11M17.5,2C15,2 13,4 13,6.5C13,9.87 17.5,14.86 17.5,14.86C17.5,14.86 22,9.87 22,6.5C22,4 20,2 17.5,2M17.5,16C16.23,16 15.1,16.8 14.68,18H9.32C8.77,16.44 7.05,15.62 5.5,16.17C3.93,16.72 3.11,18.44 3.66,20C4.22,21.56 5.93,22.38 7.5,21.83C8.35,21.53 9,20.85 9.32,20H14.69C15.24,21.56 16.96,22.38 18.5,21.83C20.08,21.28 20.9,19.56 20.35,18C19.92,16.8 18.78,16 17.5,16V16M17.5,20.5C16.67,20.5 16,19.83 16,19C16,18.17 16.67,17.5 17.5,17.5C18.33,17.5 19,18.17 19,19C19,19.83 18.33,20.5 17.5,20.5Z' })
	  );
	};
	
	var MapMarkerMinusIcon = function MapMarkerMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,11.5C10.38,11.5 11.5,10.38 11.5,9C11.5,7.62 10.38,6.5 9,6.5C7.62,6.5 6.5,7.62 6.5,9C6.5,10.38 7.62,11.5 9,11.5M9,2C12.86,2 16,5.13 16,9C16,14.25 9,22 9,22C9,22 2,14.25 2,9C2,5.13 5.13,2 9,2M15,17H23V19H15V17Z' })
	  );
	};
	
	var MapMarkerMultipleIcon = function MapMarkerMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,11.5C15.38,11.5 16.5,10.38 16.5,9C16.5,7.62 15.38,6.5 14,6.5C12.62,6.5 11.5,7.62 11.5,9C11.5,10.38 12.62,11.5 14,11.5M14,2C17.86,2 21,5.13 21,9C21,14.25 14,22 14,22C14,22 7,14.25 7,9C7,5.13 10.13,2 14,2M5,9C5,13.5 10.08,19.66 11,20.81L10,22C10,22 3,14.25 3,9C3,5.83 5.11,3.15 8,2.29C6.16,3.94 5,6.33 5,9Z' })
	  );
	};
	
	var MapMarkerOffIcon = function MapMarkerOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.37,16.1L11.75,11.47L11.64,11.36L3.27,3L2,4.27L5.18,7.45C5.06,7.95 5,8.46 5,9C5,14.25 12,22 12,22C12,22 13.67,20.15 15.37,17.65L18.73,21L20,19.72M12,6.5C13.38,6.5 14.5,7.62 14.5,9C14.5,9.73 14.17,10.39 13.67,10.85L17.3,14.5C18.28,12.62 19,10.68 19,9C19,5.13 15.87,2 12,2C10,2 8.24,2.82 6.96,4.14L10.15,7.33C10.61,6.82 11.26,6.5 12,6.5Z' })
	  );
	};
	
	var MapMarkerOutlineIcon = function MapMarkerOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,6.5C13.38,6.5 14.5,7.62 14.5,9C14.5,10.38 13.38,11.5 12,11.5C10.62,11.5 9.5,10.38 9.5,9C9.5,7.62 10.62,6.5 12,6.5M12,2C15.87,2 19,5.13 19,9C19,14.25 12,22 12,22C12,22 5,14.25 5,9C5,5.13 8.13,2 12,2M12,4C9.24,4 7,6.24 7,9C7,10 7,12 12,18.71C17,12 17,10 17,9C17,6.24 14.76,4 12,4Z' })
	  );
	};
	
	var MapMarkerPlusIcon = function MapMarkerPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,11.5C10.38,11.5 11.5,10.38 11.5,9C11.5,7.62 10.38,6.5 9,6.5C7.62,6.5 6.5,7.62 6.5,9C6.5,10.38 7.62,11.5 9,11.5M9,2C12.86,2 16,5.13 16,9C16,14.25 9,22 9,22C9,22 2,14.25 2,9C2,5.13 5.13,2 9,2M15,17H18V14H20V17H23V19H20V22H18V19H15V17Z' })
	  );
	};
	
	var MapMarkerRadiusIcon = function MapMarkerRadiusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C15.31,2 18,4.66 18,7.95C18,12.41 12,19 12,19C12,19 6,12.41 6,7.95C6,4.66 8.69,2 12,2M12,6C10.9,6 10,6.9 10,8C10,9.1 10.9,10 12,10C13.1,10 14,9.1 14,8C14,6.9 13.1,6 12,6M20,19C20,21.21 16.42,23 12,23C7.58,23 4,21.21 4,19C4,17.71 5.22,16.56 7.11,15.83L7.75,16.74C6.67,17.19 6,17.81 6,18.5C6,19.88 8.69,21 12,21C15.31,21 18,19.88 18,18.5C18,17.81 17.33,17.19 16.25,16.74L16.89,15.83C18.78,16.56 20,17.71 20,19Z' })
	  );
	};
	
	var MapMarkerIcon = function MapMarkerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,11.5C10.62,11.5 9.5,10.38 9.5,9C9.5,7.62 10.62,6.5 12,6.5C13.38,6.5 14.5,7.62 14.5,9C14.5,10.38 13.38,11.5 12,11.5M12,2C8.13,2 5,5.13 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9C19,5.13 15.87,2 12,2Z' })
	  );
	};
	
	var MapMinusIcon = function MapMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,3L3.36,4.9C3.16,4.97 3,5.15 3,5.38V20.5C3,20.78 3.22,21 3.5,21C3.55,21 3.6,21 3.66,20.97L9,18.9L13,20.3V18.3L9,16.9V5L15,7.1V16H21V3.5C21,3.22 20.78,3 20.5,3H20.34L15,5.1L9,3M15,18V20H23V18H15Z' })
	  );
	};
	
	var MapOutlineIcon = function MapOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.5,3L20.34,3.03L15,5.1L9,3L3.36,4.9C3.15,4.97 3,5.15 3,5.38V20.5C3,20.78 3.22,21 3.5,21L3.66,20.97L9,18.9L15,21L20.64,19.1C20.85,19.03 21,18.85 21,18.62V3.5C21,3.22 20.78,3 20.5,3M10,5.47L14,6.87V18.53L10,17.13V5.47M5,6.46L8,5.45V17.15L5,18.31V6.46M19,17.54L16,18.55V6.86L19,5.7V17.54Z' })
	  );
	};
	
	var MapPlusIcon = function MapPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,3L3.36,4.9C3.16,4.97 3,5.15 3,5.38V20.5C3,20.78 3.22,21 3.5,21C3.55,21 3.6,21 3.66,20.97L9,18.9L13.16,20.36C13.06,19.92 13,19.46 13,19C13,18.77 13,18.54 13.04,18.3L9,16.9V5L15,7.1V14.56C16.07,13.6 17.47,13 19,13C19.7,13 20.37,13.13 21,13.36V3.5C21,3.22 20.78,3 20.5,3H20.34L15,5.1L9,3M18,15V18H15V20H18V23H20V20H23V18H20V15H18Z' })
	  );
	};
	
	var MapSearchOutlineIcon = function MapSearchOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.2 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14C14.12,14 13,15.12 13,16.5C13,17.88 14.12,19 15.5,19C16.88,19 18,17.88 18,16.5C18,15.12 16.88,14 15.5,14M19.5,2C19.78,2 20,2.22 20,2.5V11.81C19.42,11.26 18.75,10.81 18,10.5V4.7L15,5.86V10C14.3,10.07 13.62,10.24 13,10.5V5.87L9,4.47V16.13H9V16.5C9,17.14 9.09,17.76 9.26,18.34L8,17.9L2.66,19.97L2.5,20C2.22,20 2,19.78 2,19.5V4.38C2,4.15 2.15,3.97 2.36,3.9L8,2L14,4.1L19.34,2.03L19.5,2M4,5.46V17.31L7,16.15V4.45L4,5.46Z' })
	  );
	};
	
	var MapSearchIcon = function MapSearchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14C14.12,14 13,15.12 13,16.5C13,17.88 14.12,19 15.5,19C16.88,19 18,17.88 18,16.5C18,15.12 16.88,14 15.5,14M14,6.11L8,4V15.89L9,16.24V16.5C9,17.14 9.09,17.76 9.26,18.34L8,17.9L2.66,19.97L2.5,20C2.22,20 2,19.78 2,19.5V4.38C2,4.15 2.15,3.97 2.36,3.9L8,2L14,4.1L19.34,2H19.5C19.78,2 20,2.22 20,2.5V11.81C18.83,10.69 17.25,10 15.5,10C15,10 14.5,10.06 14,10.17V6.11Z' })
	  );
	};
	
	var MapIcon = function MapIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,19L9,16.89V5L15,7.11M20.5,3C20.44,3 20.39,3 20.34,3L15,5.1L9,3L3.36,4.9C3.15,4.97 3,5.15 3,5.38V20.5C3,20.78 3.22,21 3.5,21C3.55,21 3.61,21 3.66,20.97L9,18.9L15,21L20.64,19.1C20.85,19 21,18.85 21,18.62V3.5C21,3.22 20.78,3 20.5,3Z' })
	  );
	};
	
	var MarginIcon = function MarginIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,4V9L18.5,7.5L5.5,20.5L3.5,18.5L16.5,5.5L15,4H20M17,20C15.34,20 14,18.66 14,17V15C14,13.34 15.34,12 17,12C18.66,12 20,13.34 20,15V17C20,18.66 18.66,20 17,20M17,14C16.45,14 16,14.45 16,15V17C16,17.55 16.45,18 17,18C17.55,18 18,17.55 18,17V15C18,14.45 17.55,14 17,14M7,12C5.34,12 4,10.66 4,9V7C4,5.34 5.34,4 7,4C8.66,4 10,5.34 10,7V9C10,10.66 8.66,12 7,12M7,6C6.45,6 6,6.45 6,7V9C6,9.55 6.45,10 7,10C7.55,10 8,9.55 8,9V7C8,6.45 7.55,6 7,6Z' })
	  );
	};
	
	var MarkdownIcon = function MarkdownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,16V8H4L7,11L10,8H12V16H10V10.83L7,13.83L4,10.83V16H2M16,8H19V12H21.5L17.5,16.5L13.5,12H16V8Z' })
	  );
	};
	
	var MarkerCheckIcon = function MarkerCheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,16L5,11L6.41,9.58L10,13.17L17.59,5.58L19,7M19,1H5C3.89,1 3,1.89 3,3V15.93C3,16.62 3.35,17.23 3.88,17.59L12,23L20.11,17.59C20.64,17.23 21,16.62 21,15.93V3C21,1.89 20.1,1 19,1Z' })
	  );
	};
	
	var MarkerIcon = function MarkerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.5,1.15C17.97,1.15 17.46,1.34 17.07,1.73L11.26,7.55L16.91,13.2L22.73,7.39C23.5,6.61 23.5,5.35 22.73,4.56L19.89,1.73C19.5,1.34 19,1.15 18.5,1.15M10.3,8.5L4.34,14.46C3.56,15.24 3.56,16.5 4.36,17.31C3.14,18.54 1.9,19.77 0.67,21H6.33L7.19,20.14C7.97,20.9 9.22,20.89 10,20.12L15.95,14.16' })
	  );
	};
	
	var MaterialDesignIcon = function MaterialDesignIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,12C21,9.97 20.33,8.09 19,6.38V17.63C20.33,15.97 21,14.09 21,12M17.63,19H6.38C7.06,19.55 7.95,20 9.05,20.41C10.14,20.8 11.13,21 12,21C12.88,21 13.86,20.8 14.95,20.41C16.05,20 16.94,19.55 17.63,19M11,17L7,9V17H11M17,9L13,17H17V9M12,14.53L15.75,7H8.25L12,14.53M17.63,5C15.97,3.67 14.09,3 12,3C9.91,3 8.03,3.67 6.38,5H17.63M5,17.63V6.38C3.67,8.09 3,9.97 3,12C3,14.09 3.67,15.97 5,17.63M23,12C23,15.03 21.94,17.63 19.78,19.78C17.63,21.94 15.03,23 12,23C8.97,23 6.38,21.94 4.22,19.78C2.06,17.63 1,15.03 1,12C1,8.97 2.06,6.38 4.22,4.22C6.38,2.06 8.97,1 12,1C15.03,1 17.63,2.06 19.78,4.22C21.94,6.38 23,8.97 23,12Z' })
	  );
	};
	
	var MaterialUiIcon = function MaterialUiIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,16.61V15.37L14,11.91V7.23L9,10.12L4,7.23V13L3,13.58L2,13V5L3.07,4.38L9,7.81L12.93,5.54L14.93,4.38L16,5V13.06L10.92,16L14.97,18.33L20,15.43V11L21,10.42L22,11V16.58L14.97,20.64L8,16.61M22,9.75L21,10.33L20,9.75V8.58L21,8L22,8.58V9.75Z' })
	  );
	};
	
	var MathCompassIcon = function MathCompassIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,4.2V3C13,2.4 12.6,2 12,2V4.2C9.8,4.6 9,5.7 9,7C9,7.8 9.3,8.5 9.8,9L4,19.9V22L6.2,20L11.6,10C11.7,10 11.9,10 12,10C13.7,10 15,8.7 15,7C15,5.7 14.2,4.6 13,4.2M12.9,7.5C12.7,7.8 12.4,8 12,8C11.4,8 11,7.6 11,7C11,6.8 11.1,6.7 11.1,6.5C11.3,6.2 11.6,6 12,6C12.6,6 13,6.4 13,7C13,7.2 12.9,7.3 12.9,7.5M20,19.9V22H20L17.8,20L13.4,11.8C14.1,11.6 14.7,11.3 15.2,10.9L20,19.9Z' })
	  );
	};
	
	var MatrixIcon = function MatrixIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,2H6V4H4V20H6V22H2V2M20,4H18V2H22V22H18V20H20V4M9,5H10V10H11V11H8V10H9V6L8,6.5V5.5L9,5M15,13H16V18H17V19H14V18H15V14L14,14.5V13.5L15,13M9,13C10.1,13 11,14.34 11,16C11,17.66 10.1,19 9,19C7.9,19 7,17.66 7,16C7,14.34 7.9,13 9,13M9,14C8.45,14 8,14.9 8,16C8,17.1 8.45,18 9,18C9.55,18 10,17.1 10,16C10,14.9 9.55,14 9,14M15,5C16.1,5 17,6.34 17,8C17,9.66 16.1,11 15,11C13.9,11 13,9.66 13,8C13,6.34 13.9,5 15,5M15,6C14.45,6 14,6.9 14,8C14,9.1 14.45,10 15,10C15.55,10 16,9.1 16,8C16,6.9 15.55,6 15,6Z' })
	  );
	};
	
	var MaxcdnIcon = function MaxcdnIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.6,6.69C19.73,5.61 18.38,5 16.9,5H2.95L4.62,8.57L2.39,19H6.05L8.28,8.57H11.4L9.17,19H12.83L15.06,8.57H16.9C17.3,8.57 17.63,8.7 17.82,8.94C18,9.17 18.07,9.5 18,9.9L16.04,19H19.69L21.5,10.65C21.78,9.21 21.46,7.76 20.6,6.69Z' })
	  );
	};
	
	var MedalIcon = function MedalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,2H4V4L9.81,8.36C6.14,9.57 4.14,13.53 5.35,17.2C6.56,20.87 10.5,22.87 14.19,21.66C17.86,20.45 19.86,16.5 18.65,12.82C17.95,10.71 16.3,9.05 14.19,8.36L20,4V2M14.94,19.5L12,17.78L9.06,19.5L9.84,16.17L7.25,13.93L10.66,13.64L12,10.5L13.34,13.64L16.75,13.93L14.16,16.17L14.94,19.5Z' })
	  );
	};
	
	var MedicalBagIcon = function MedicalBagIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,3L8,5V7H5C3.85,7 3.12,8 3,9L2,19C1.88,20 2.54,21 4,21H20C21.46,21 22.12,20 22,19L21,9C20.88,8 20.06,7 19,7H16V5L14,3H10M10,5H14V7H10V5M11,10H13V13H16V15H13V18H11V15H8V13H11V10Z' })
	  );
	};
	
	var MediumIcon = function MediumIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.37,7.3C4.4,7.05 4.3,6.81 4.12,6.65L2.25,4.4V4.06H8.05L12.53,13.89L16.47,4.06H22V4.4L20.4,5.93C20.27,6.03 20.2,6.21 20.23,6.38V17.62C20.2,17.79 20.27,17.97 20.4,18.07L21.96,19.6V19.94H14.12V19.6L15.73,18.03C15.89,17.88 15.89,17.83 15.89,17.59V8.5L11.4,19.9H10.8L5.57,8.5V16.14C5.5,16.46 5.63,16.78 5.86,17L7.96,19.57V19.9H2V19.57L4.1,17C4.33,16.78 4.43,16.46 4.37,16.14V7.3Z' })
	  );
	};
	
	var MemoryIcon = function MemoryIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,17H7V7H17M21,11V9H19V7C19,5.89 18.1,5 17,5H15V3H13V5H11V3H9V5H7C5.89,5 5,5.89 5,7V9H3V11H5V13H3V15H5V17C5,18.1 5.9,19 7,19H9V21H11V19H13V21H15V19H17C18.1,19 19,18.1 19,17V15H21V13H19V11M13,13H11V11H13M15,9H9V15H15V9Z' })
	  );
	};
	
	var MenuDownOutlineIcon = function MenuDownOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,9V10.5L12,16.5L6,10.5V9H18M12,13.67L14.67,11H9.33L12,13.67Z' })
	  );
	};
	
	var MenuDownIcon = function MenuDownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,10L12,15L17,10H7Z' })
	  );
	};
	
	var MenuLeftIcon = function MenuLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,7L9,12L14,17V7Z' })
	  );
	};
	
	var MenuRightIcon = function MenuRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,17L15,12L10,7V17Z' })
	  );
	};
	
	var MenuUpOutlineIcon = function MenuUpOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,16V14.5L12,8.5L6,14.5V16H18M12,11.33L14.67,14H9.33L12,11.33Z' })
	  );
	};
	
	var MenuUpIcon = function MenuUpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,15L12,10L17,15H7Z' })
	  );
	};
	
	var MenuIcon = function MenuIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z' })
	  );
	};
	
	var MessageAlertIcon = function MessageAlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,10H11V6H13M13,14H11V12H13M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.89 21.1,2 20,2Z' })
	  );
	};
	
	var MessageBulletedOffIcon = function MessageBulletedOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1.27,1.73L0,3L2,5V22L6,18H15L20.73,23.73L22,22.46L1.27,1.73M8,14H6V12H8V14M6,11V9L8,11H6M20,2H4.08L10,7.92V6H18V8H10.08L11.08,9H18V11H13.08L20.07,18C21.14,17.95 22,17.08 22,16V4C22,2.9 21.1,2 20,2Z' })
	  );
	};
	
	var MessageBulletedIcon = function MessageBulletedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.9 21.1,2 20,2M8,14H6V12H8V14M8,11H6V9H8V11M8,8H6V6H8V8M15,14H10V12H15V14M18,11H10V9H18V11M18,8H10V6H18V8Z' })
	  );
	};
	
	var MessageDrawIcon = function MessageDrawIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,14H10.5L12.5,12H18M6,14V11.5L12.88,4.64C13.07,4.45 13.39,4.45 13.59,4.64L15.35,6.41C15.55,6.61 15.55,6.92 15.35,7.12L8.47,14M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.89 21.1,2 20,2Z' })
	  );
	};
	
	var MessageImageIcon = function MessageImageIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,14L8.5,9.5L11,12.5L14.5,8L19,14M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.89 21.1,2 20,2Z' })
	  );
	};
	
	var MessageOutlineIcon = function MessageOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.9 21.1,2 20,2M20,16H6L4,18V4H20' })
	  );
	};
	
	var MessagePlusIcon = function MessagePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,2C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H6L2,22V4C2,2.89 2.9,2 4,2H20M11,6V9H8V11H11V14H13V11H16V9H13V6H11Z' })
	  );
	};
	
	var MessageProcessingIcon = function MessageProcessingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,11H15V9H17M13,11H11V9H13M9,11H7V9H9M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.89 21.1,2 20,2Z' })
	  );
	};
	
	var MessageReplyTextIcon = function MessageReplyTextIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,8H6V6H18V8M18,11H6V9H18V11M18,14H6V12H18V14M22,4C22,2.9 21.1,2 20,2H4C2.9,2 2,2.9 2,4V16C2,17.1 2.9,18 4,18H18L22,22V4Z' })
	  );
	};
	
	var MessageReplyIcon = function MessageReplyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,4C22,2.89 21.1,2 20,2H4C2.9,2 2,2.9 2,4V16C2,17.1 2.9,18 4,18H18L22,22V4Z' })
	  );
	};
	
	var MessageSettingsVariantIcon = function MessageSettingsVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.5,10C13.5,10.83 12.83,11.5 12,11.5C11.16,11.5 10.5,10.83 10.5,10C10.5,9.17 11.17,8.5 12,8.5C12.83,8.5 13.5,9.17 13.5,10M22,4V16C22,17.1 21.1,18 20,18H6L2,22V4C2,2.9 2.9,2 4,2H20C21.1,2 22,2.9 22,4M16.77,11.32L15.7,10.5C15.71,10.33 15.71,10.16 15.7,10C15.72,9.84 15.72,9.67 15.7,9.5L16.76,8.68C16.85,8.6 16.88,8.47 16.82,8.36L15.82,6.63C15.76,6.5 15.63,6.47 15.5,6.5L14.27,7C14,6.8 13.73,6.63 13.42,6.5L13.23,5.19C13.21,5.08 13.11,5 13,5H11C10.88,5 10.77,5.09 10.75,5.21L10.56,6.53C10.26,6.65 9.97,6.81 9.7,7L8.46,6.5C8.34,6.46 8.21,6.5 8.15,6.61L7.15,8.34C7.09,8.45 7.11,8.58 7.21,8.66L8.27,9.5C8.23,9.82 8.23,10.16 8.27,10.5L7.21,11.32C7.12,11.4 7.09,11.53 7.15,11.64L8.15,13.37C8.21,13.5 8.34,13.53 8.46,13.5L9.7,13C9.96,13.2 10.24,13.37 10.55,13.5L10.74,14.81C10.77,14.93 10.88,15 11,15H13C13.12,15 13.23,14.91 13.25,14.79L13.44,13.47C13.74,13.34 14,13.18 14.28,13L15.53,13.5C15.65,13.5 15.78,13.5 15.84,13.37L16.84,11.64C16.9,11.53 16.87,11.4 16.77,11.32Z' })
	  );
	};
	
	var MessageSettingsIcon = function MessageSettingsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.9 21.1,2 20,2M11,24H13V22H11V24M7,24H9V22H7V24M15,24H17V22H15V24Z' })
	  );
	};
	
	var MessageTextOutlineIcon = function MessageTextOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,2C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H6L2,22V4C2,2.89 2.9,2 4,2H20M4,4V17.17L5.17,16H20V4H4M6,7H18V9H6V7M6,11H15V13H6V11Z' })
	  );
	};
	
	var MessageTextIcon = function MessageTextIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.9 21.1,2 20,2M6,9H18V11H6M14,14H6V12H14M18,8H6V6H18' })
	  );
	};
	
	var MessageVideoIcon = function MessageVideoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,14L14,10.8V14H6V6H14V9.2L18,6M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.89 21.1,2 20,2Z' })
	  );
	};
	
	var MessageIcon = function MessageIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,2H4C2.9,2 2,2.9 2,4V22L6,18H20C21.1,18 22,17.1 22,16V4C22,2.89 21.1,2 20,2Z' })
	  );
	};
	
	var MeteorIcon = function MeteorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.8,3L19.67,18.82C19.67,18.82 20,19.27 19.58,19.71C19.17,20.15 18.63,19.77 18.63,19.77L2.8,3M7.81,4.59L20.91,16.64C20.91,16.64 21.23,17.08 20.82,17.5C20.4,17.97 19.86,17.59 19.86,17.59L7.81,4.59M4.29,8L17.39,20.03C17.39,20.03 17.71,20.47 17.3,20.91C16.88,21.36 16.34,21 16.34,21L4.29,8M12.05,5.96L21.2,14.37C21.2,14.37 21.42,14.68 21.13,15C20.85,15.3 20.47,15.03 20.47,15.03L12.05,5.96M5.45,11.91L14.6,20.33C14.6,20.33 14.82,20.64 14.54,20.95C14.25,21.26 13.87,21 13.87,21L5.45,11.91M16.38,7.92L20.55,11.74C20.55,11.74 20.66,11.88 20.5,12.03C20.38,12.17 20.19,12.05 20.19,12.05L16.38,7.92M7.56,16.1L11.74,19.91C11.74,19.91 11.85,20.06 11.7,20.2C11.56,20.35 11.37,20.22 11.37,20.22L7.56,16.1Z' })
	  );
	};
	
	var MetronomeTickIcon = function MetronomeTickIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1.75L8.57,2.67L4.07,19.5C4.06,19.5 4,19.84 4,20C4,21.11 4.89,22 6,22H18C19.11,22 20,21.11 20,20C20,19.84 19.94,19.5 19.93,19.5L15.43,2.67L12,1.75M10.29,4H13.71L17.2,17H13V12H11V17H6.8L10.29,4M11,5V9H10V11H14V9H13V5H11Z' })
	  );
	};
	
	var MetronomeIcon = function MetronomeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1.75L8.57,2.67L4.06,19.53C4.03,19.68 4,19.84 4,20C4,21.11 4.89,22 6,22H18C19.11,22 20,21.11 20,20C20,19.84 19.97,19.68 19.94,19.53L18.58,14.42L17,16L17.2,17H13.41L16.25,14.16L14.84,12.75L10.59,17H6.8L10.29,4H13.71L15.17,9.43L16.8,7.79L15.43,2.67L12,1.75M11.25,5V14.75L12.75,13.25V5H11.25M19.79,7.8L16.96,10.63L16.25,9.92L14.84,11.34L17.66,14.16L19.08,12.75L18.37,12.04L21.2,9.21L19.79,7.8Z' })
	  );
	};
	
	var MicroSdIcon = function MicroSdIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,2C6.9,2 6,2.9 6,4V11L4,13V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V4C20,2.9 19.1,2 18,2H8M9,4H11V8H9V4M12,4H14V8H12V4M15,4H17V8H15V4Z' })
	  );
	};
	
	var MicrophoneMinusIcon = function MicrophoneMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,2C10.66,2 12,3.34 12,5V11C12,12.66 10.66,14 9,14C7.34,14 6,12.66 6,11V5C6,3.34 7.34,2 9,2M16,11C16,14.5 13.44,17.43 10,17.93V21H8V17.93C4.56,17.43 2,14.5 2,11H4C4,13.76 6.24,16 9,16C11.76,16 14,13.76 14,11H16M15,5H23V7H15V5Z' })
	  );
	};
	
	var MicrophoneOffIcon = function MicrophoneOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,11C19,12.19 18.66,13.3 18.1,14.28L16.87,13.05C17.14,12.43 17.3,11.74 17.3,11H19M15,11.16L9,5.18V5C9,3.34 10.34,2 12,2C13.66,2 15,3.34 15,5V11L15,11.16M4.27,3L21,19.73L19.73,21L15.54,16.81C14.77,17.27 13.91,17.58 13,17.72V21H11V17.72C7.72,17.23 5,14.41 5,11H6.7C6.7,14 9.24,16.1 12,16.1C12.81,16.1 13.6,15.91 14.31,15.58L12.65,13.92L12,14C10.34,14 9,12.66 9,11V10.28L3,4.27L4.27,3Z' })
	  );
	};
	
	var MicrophoneOutlineIcon = function MicrophoneOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.3,11C17.3,14 14.76,16.1 12,16.1C9.24,16.1 6.7,14 6.7,11H5C5,14.41 7.72,17.23 11,17.72V21H13V17.72C16.28,17.23 19,14.41 19,11M10.8,4.9C10.8,4.24 11.34,3.7 12,3.7C12.66,3.7 13.2,4.24 13.2,4.9L13.19,11.1C13.19,11.76 12.66,12.3 12,12.3C11.34,12.3 10.8,11.76 10.8,11.1M12,14C13.66,14 15,12.66 15,11V5C15,3.34 13.66,2 12,2C10.34,2 9,3.34 9,5V11C9,12.66 10.34,14 12,14Z' })
	  );
	};
	
	var MicrophonePlusIcon = function MicrophonePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,2C10.66,2 12,3.34 12,5V11C12,12.66 10.66,14 9,14C7.34,14 6,12.66 6,11V5C6,3.34 7.34,2 9,2M16,11C16,14.5 13.44,17.43 10,17.93V21H8V17.93C4.56,17.43 2,14.5 2,11H4C4,13.76 6.24,16 9,16C11.76,16 14,13.76 14,11H16M15,5H18V2H20V5H23V7H20V10H18V7H15V5Z' })
	  );
	};
	
	var MicrophoneSettingsIcon = function MicrophoneSettingsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,10H17.3C17.3,13 14.76,15.1 12,15.1C9.24,15.1 6.7,13 6.7,10H5C5,13.41 7.72,16.23 11,16.72V20H13V16.72C16.28,16.23 19,13.41 19,10M15,24H17V22H15M11,24H13V22H11M12,13C13.66,13 15,11.66 15,10V4C15,2.34 13.66,1 12,1C10.34,1 9,2.34 9,4V10C9,11.66 10.34,13 12,13M7,24H9V22H7V24Z' })
	  );
	};
	
	var MicrophoneVariantOffIcon = function MicrophoneVariantOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L16,19.26C15.86,21.35 14.12,23 12,23C9.79,23 8,21.21 8,19V18H7L6.16,9.82C5.82,9.47 5.53,9.06 5.33,8.6L2,5.27M9,3C11.21,3 13,4.79 13,7H8.82L6.08,4.26C6.81,3.5 7.85,3 9,3M11.84,9.82L11.82,10L9.82,8H12.87C12.69,8.7 12.33,9.32 11.84,9.82M11,18H10V19C10,20.1 10.9,21 12,21C13.1,21 14,20.1 14,19V17.27L11.35,14.62L11,18M18,10H20L19,11L20,12H18C16.9,12 16,12.9 16,14V14.18L14.3,12.5C14.9,11 16.33,10 18,10M8,12C8,12.55 8.45,13 9,13C9.21,13 9.4,12.94 9.56,12.83L8.17,11.44C8.06,11.6 8,11.79 8,12Z' })
	  );
	};
	
	var MicrophoneVariantIcon = function MicrophoneVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,3C11.21,3 13,4.79 13,7H5C5,4.79 6.79,3 9,3M11.84,9.82L11,18H10V19C10,20.1 10.9,21 12,21C13.1,21 14,20.1 14,19V14C14,11.79 15.79,10 18,10H20L19,11L20,12H18C16.9,12 16,12.9 16,14V19C16,21.21 14.21,23 12,23C9.79,23 8,21.21 8,19V18H7L6.16,9.82C5.67,9.32 5.31,8.7 5.13,8H12.87C12.69,8.7 12.33,9.32 11.84,9.82M9,11C8.45,11 8,11.45 8,12C8,12.55 8.45,13 9,13C9.55,13 10,12.55 10,12C10,11.45 9.55,11 9,11Z' })
	  );
	};
	
	var MicrophoneIcon = function MicrophoneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C13.66,2 15,3.34 15,5V11C15,12.66 13.66,14 12,14C10.34,14 9,12.66 9,11V5C9,3.34 10.34,2 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7C7,13.76 9.24,16 12,16C14.76,16 17,13.76 17,11H19Z' })
	  );
	};
	
	var MicroscopeIcon = function MicroscopeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.46,6.28L11.05,9C8.47,9.26 6.5,11.41 6.5,14C6.5,16.76 8.74,19 11.5,19C13.55,19 15.31,17.77 16.08,16H13.5V14H21.5V16H19.25C18.84,17.57 17.97,18.96 16.79,20H19.5V22H3.5V20H6.21C4.55,18.53 3.5,16.39 3.5,14C3.5,10.37 5.96,7.2 9.46,6.28M12.74,2.07L13.5,3.37L14.36,2.87L17.86,8.93L14.39,10.93L10.89,4.87L11.76,4.37L11,3.07L12.74,2.07Z' })
	  );
	};
	
	var MicrosoftDynamicsIcon = function MicrosoftDynamicsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2L17.25,8.5L13.5,11.5L6,8V2M6,9L9.5,11.25L6,22L18,9V15L6,22V9Z' })
	  );
	};
	
	var MicrosoftIcon = function MicrosoftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,3H11V12H2V3M11,22H2V13H11V22M21,3V12H12V3H21M21,22H12V13H21V22Z' })
	  );
	};
	
	var MidiPortIcon = function MidiPortIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M20.18,12C20.18,8.18 17.55,4.96 14,4.07V6H10V4.07C6.45,4.96 3.82,8.18 3.82,12C3.82,16.52 7.48,20.18 12,20.18C16.52,20.18 20.18,16.52 20.18,12M7,10.64C7.75,10.64 8.36,11.25 8.36,12C8.36,12.75 7.75,13.36 7,13.36C6.25,13.36 5.64,12.75 5.64,12C5.64,11.25 6.25,10.64 7,10.64M17,10.64C17.75,10.64 18.36,11.25 18.36,12C18.36,12.75 17.75,13.36 17,13.36C16.25,13.36 15.64,12.75 15.64,12C15.64,11.25 16.25,10.64 17,10.64M8.36,14.27C9.12,14.27 9.73,14.88 9.73,15.64C9.73,16.39 9.12,17 8.36,17C7.61,17 7,16.39 7,15.64C7,14.88 7.61,14.27 8.36,14.27M15.64,14.27C16.39,14.27 17,14.88 17,15.64C17,16.39 16.39,17 15.64,17C14.88,17 14.27,16.39 14.27,15.64C14.27,14.88 14.88,14.27 15.64,14.27M12,15.64C12.75,15.64 13.36,16.25 13.36,17C13.36,17.75 12.75,18.36 12,18.36C11.25,18.36 10.64,17.75 10.64,17C10.64,16.25 11.25,15.64 12,15.64Z' })
	  );
	};
	
	var MidiIcon = function MidiIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,7H12V15H10V7M13,7H19C19.55,7 20,7.45 20,8V14C20,14.55 19.55,15 19,15H13V10H15V13H18V9H13V7M21,7H23V15H21V7M1,7H3L8,7C8.55,7 9,7.45 9,8V15H7V9H6V15H4V9H3V15H1V7M1,16H23V19H1V16Z' })
	  );
	};
	
	var MinecraftIcon = function MinecraftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H20C21.1,2 22,2.9 22,4V20C22,21.1 21.1,22 20,22H4C2.9,22 2,21.1 2,20V4C2,2.9 2.9,2 4,2M6,6V10H10V12H8V18H10V16H14V18H16V12H14V10H18V6H14V10H10V6H6Z' })
	  );
	};
	
	var MinusBoxOutlineIcon = function MinusBoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19V5H5V19H19M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.89 3.9,3 5,3H19M17,11V13H7V11H17Z' })
	  );
	};
	
	var MinusBoxIcon = function MinusBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,13H7V11H17M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z' })
	  );
	};
	
	var MinusCircleOutlineIcon = function MinusCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M7,13H17V11H7' })
	  );
	};
	
	var MinusCircleIcon = function MinusCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,13H7V11H17M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var MinusNetworkIcon = function MinusNetworkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,11V9H8V11H16M17,3C18.1,3 19,3.9 19,5V15C19,16.1 18.1,17 17,17H13V19H14C14.55,19 15,19.45 15,20H22V22H15C15,22.55 14.55,23 14,23H10C9.45,23 9,22.55 9,22H2V20H9C9,19.45 9.45,19 10,19H11V17H7C5.89,17 5,16.1 5,15V5C5,3.9 5.9,3 7,3H17Z' })
	  );
	};
	
	var MinusIcon = function MinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,13H5V11H19V13Z' })
	  );
	};
	
	var MixcloudIcon = function MixcloudIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.11,18.5C20.97,18.5 20.83,18.44 20.71,18.36C20.37,18.13 20.28,17.68 20.5,17.34C21.18,16.34 21.54,15.16 21.54,13.93C21.54,12.71 21.18,11.53 20.5,10.5C20.28,10.18 20.37,9.73 20.71,9.5C21.04,9.28 21.5,9.37 21.72,9.7C22.56,10.95 23,12.41 23,13.93C23,15.45 22.56,16.91 21.72,18.16C21.58,18.37 21.35,18.5 21.11,18.5M19,17.29C18.88,17.29 18.74,17.25 18.61,17.17C18.28,16.94 18.19,16.5 18.42,16.15C18.86,15.5 19.1,14.73 19.1,13.93C19.1,13.14 18.86,12.37 18.42,11.71C18.19,11.37 18.28,10.92 18.61,10.69C18.95,10.47 19.4,10.55 19.63,10.89C20.24,11.79 20.56,12.84 20.56,13.93C20.56,15 20.24,16.07 19.63,16.97C19.5,17.18 19.25,17.29 19,17.29M14.9,15.73C15.89,15.73 16.7,14.92 16.7,13.93C16.7,13.17 16.22,12.5 15.55,12.25C15.5,12.55 15.43,12.85 15.34,13.14C15.23,13.44 14.95,13.64 14.64,13.64C14.57,13.64 14.5,13.62 14.41,13.6C14.03,13.47 13.82,13.06 13.95,12.67C14.09,12.24 14.17,11.78 14.17,11.32C14.17,8.93 12.22,7 9.82,7C8.1,7 6.56,8 5.87,9.5C6.54,9.7 7.16,10.04 7.66,10.54C7.95,10.83 7.95,11.29 7.66,11.58C7.38,11.86 6.91,11.86 6.63,11.58C6.17,11.12 5.56,10.86 4.9,10.86C3.56,10.86 2.46,11.96 2.46,13.3C2.46,14.64 3.56,15.73 4.9,15.73H14.9M15.6,10.75C17.06,11.07 18.17,12.37 18.17,13.93C18.17,15.73 16.7,17.19 14.9,17.19H4.9C2.75,17.19 1,15.45 1,13.3C1,11.34 2.45,9.73 4.33,9.45C5.12,7.12 7.33,5.5 9.82,5.5C12.83,5.5 15.31,7.82 15.6,10.75Z' })
	  );
	};
	
	var MixedRealityIcon = function MixedRealityIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M8.25,15H9.75L10.75,11.57V15H12.25V9H10L9,12.43L8,9H5.75V15H7.25V11.57L8.25,15M13.5,9V15H15V13H16.15L17,15H18.5L17.6,12.9C18.1,12.65 18.5,12.1 18.5,11.5V10.5C18.5,9.65 17.85,9 17,9H13.5M15,10.5H17V11.5H15V10.5Z' })
	  );
	};
	
	var MixerIcon = function MixerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.68,3.96L11.41,11.65C11.55,11.84 11.55,12.1 11.41,12.29L5.65,20L5.5,20.18C4.76,21 3.47,21.07 2.64,20.31C1.85,19.59 1.79,18.37 2.43,17.5L6.56,11.97L2.46,6.47C1.83,5.62 1.88,4.39 2.67,3.67L2.82,3.54C3.73,2.87 5,3.05 5.68,3.96M18.32,3.96C19,3.05 20.27,2.87 21.18,3.54L21.33,3.67C22.12,4.39 22.17,5.61 21.54,6.47L17.44,11.97L21.57,17.5C22.21,18.36 22.15,19.59 21.36,20.31C20.53,21.07 19.24,21 18.5,20.18L18.35,20L12.59,12.29C12.45,12.1 12.45,11.84 12.59,11.65L18.32,3.96Z' })
	  );
	};
	
	var MonitorCellphoneStarIcon = function MonitorCellphoneStarIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,11H18C17.45,11 17,11.45 17,12V21C17,21.55 17.45,22 18,22H23C23.55,22 24,21.55 24,21V12C24,11.45 23.55,11 23,11M23,20H18V13H23V20M20,2H2C0.89,2 0,2.89 0,4V16C0,17.1 0.9,18 2,18H9V20H7V22H15V20H13V18H15V16H2V4H20V9H22V4C22,2.89 21.1,2 20,2M11.97,9L11,6L10.03,9H7L9.47,10.76L8.53,13.67L11,11.87L13.47,13.67L12.53,10.76L15,9H11.97Z' })
	  );
	};
	
	var MonitorCellphoneIcon = function MonitorCellphoneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,11H18C17.45,11 17,11.45 17,12V21C17,21.55 17.45,22 18,22H23C23.55,22 24,21.55 24,21V12C24,11.45 23.55,11 23,11M23,20H18V13H23V20M20,2H2C0.89,2 0,2.89 0,4V16C0,17.1 0.9,18 2,18H9V20H7V22H15V20H13V18H15V16H2V4H20V9H22V4C22,2.89 21.1,2 20,2Z' })
	  );
	};
	
	var MonitorMultipleIcon = function MonitorMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,17V7H6V17H22M22,5C23.1,5 24,5.9 24,7V17C24,18.11 23.1,19 22,19H16V21H18V23H10V21H12V19H6C4.89,19 4,18.11 4,17V7C4,5.9 4.9,5 6,5H22M2,3V15H0V3C0,1.9 0.9,1 2,1H20V3H2Z' })
	  );
	};
	
	var MonitorIcon = function MonitorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,16H3V4H21M21,2H3C1.89,2 1,2.89 1,4V16C1,17.1 1.9,18 3,18H10V20H8V22H16V20H14V18H21C22.1,18 23,17.1 23,16V4C23,2.89 22.1,2 21,2Z' })
	  );
	};
	
	var MoreIcon = function MoreIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,13.5C18.17,13.5 17.5,12.83 17.5,12C17.5,11.17 18.17,10.5 19,10.5C19.83,10.5 20.5,11.17 20.5,12C20.5,12.83 19.83,13.5 19,13.5M14,13.5C13.17,13.5 12.5,12.83 12.5,12C12.5,11.17 13.17,10.5 14,10.5C14.83,10.5 15.5,11.17 15.5,12C15.5,12.83 14.83,13.5 14,13.5M9,13.5C8.17,13.5 7.5,12.83 7.5,12C7.5,11.17 8.17,10.5 9,10.5C9.83,10.5 10.5,11.17 10.5,12C10.5,12.83 9.83,13.5 9,13.5M22,3H7C6.31,3 5.77,3.35 5.41,3.88L0,12L5.41,20.11C5.77,20.64 6.37,21 7.06,21H22C23.1,21 24,20.1 24,19V5C24,3.89 23.1,3 22,3Z' })
	  );
	};
	
	var MotorbikeIcon = function MotorbikeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.36,4.27H18.55V2.13H16.36V1.07H18.22C17.89,0.43 17.13,0 16.36,0C15.16,0 14.18,0.96 14.18,2.13C14.18,3.31 15.16,4.27 16.36,4.27M10.04,9.39L13,6.93L17.45,9.6H10.25M19.53,12.05L21.05,10.56C21.93,9.71 21.93,8.43 21.05,7.57L19.2,9.39L13.96,4.27C13.64,3.73 13,3.41 12.33,3.41C11.78,3.41 11.35,3.63 11,3.95L7,7.89C6.65,8.21 6.44,8.64 6.44,9.17V9.71H5.13C4.04,9.71 3.16,10.67 3.16,11.84V12.27C3.5,12.16 3.93,12.16 4.25,12.16C7.09,12.16 9.5,14.4 9.5,17.28C9.5,17.6 9.5,18.03 9.38,18.35H14.5C14.4,18.03 14.4,17.6 14.4,17.28C14.4,14.29 16.69,12.05 19.53,12.05M4.36,19.73C2.84,19.73 1.64,18.56 1.64,17.07C1.64,15.57 2.84,14.4 4.36,14.4C5.89,14.4 7.09,15.57 7.09,17.07C7.09,18.56 5.89,19.73 4.36,19.73M4.36,12.8C1.96,12.8 0,14.72 0,17.07C0,19.41 1.96,21.33 4.36,21.33C6.76,21.33 8.73,19.41 8.73,17.07C8.73,14.72 6.76,12.8 4.36,12.8M19.64,19.73C18.11,19.73 16.91,18.56 16.91,17.07C16.91,15.57 18.11,14.4 19.64,14.4C21.16,14.4 22.36,15.57 22.36,17.07C22.36,18.56 21.16,19.73 19.64,19.73M19.64,12.8C17.24,12.8 15.27,14.72 15.27,17.07C15.27,19.41 17.24,21.33 19.64,21.33C22.04,21.33 24,19.41 24,17.07C24,14.72 22.04,12.8 19.64,12.8Z' })
	  );
	};
	
	var MouseBluetoothIcon = function MouseBluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,7H20.5L23.35,9.85L21.21,12L23.35,14.14L20.5,17H20V13.21L17.71,15.5L17,14.79L19.79,12L17,9.21L17.71,8.5L20,10.79V7M21,8.91V10.79L21.94,9.85L21,8.91M21,13.21V15.08L21.94,14.14L21,13.21M15,9V10H9V2.07C12.39,2.56 15,5.47 15,9M1,10V9C1,5.47 3.61,2.56 7,2.07V10H1M15,15C15,18.87 11.87,22 8,22C4.13,22 1,18.87 1,15V12H15V15Z' })
	  );
	};
	
	var MouseOffIcon = function MouseOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L17.5,20.79C16.08,22.16 14.14,23 12,23C7.58,23 4,19.42 4,15V11H7.73L5.73,9H4C4,8.46 4.05,7.93 4.15,7.42L2,5.27M11,1.07V9H10.82L5.79,3.96C7.05,2.4 8.9,1.33 11,1.07M20,11V15C20,15.95 19.83,16.86 19.53,17.71L12.82,11H20M13,1.07C16.94,1.56 20,4.92 20,9H13V1.07Z' })
	  );
	};
	
	var MouseVariantOffIcon = function MouseVariantOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L17.29,20.56C16.42,22 14.82,23 13,23C10.24,23 8,20.76 8,18V16.9C5.72,16.44 4,14.42 4,12V9H5.73L2,5.27M14,7H10V2.1C12.28,2.56 14,4.58 14,7M8,2.1V6.18L5.38,3.55C6.07,2.83 7,2.31 8,2.1M14,12V12.17L10.82,9H14V12M10,16.9V18C10,19.66 11.34,21 13,21C14.28,21 15.37,20.2 15.8,19.07L12.4,15.67C11.74,16.28 10.92,16.71 10,16.9M16,13C16,10.79 17.79,9 20,9H22L21,10L22,11H20C18.9,11 18,11.9 18,13V16.18L16,14.18V13Z' })
	  );
	};
	
	var MouseVariantIcon = function MouseVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,7H10V2.1C12.28,2.56 14,4.58 14,7M4,7C4,4.58 5.72,2.56 8,2.1V7H4M14,12C14,14.42 12.28,16.44 10,16.9V18C10,19.66 11.34,21 13,21C14.66,21 16,19.66 16,18V13C16,10.79 17.79,9 20,9H22L21,10L22,11H20C18.9,11 18,11.9 18,13H18V18C18,20.76 15.76,23 13,23C10.24,23 8,20.76 8,18V16.9C5.72,16.44 4,14.42 4,12V9H14V12Z' })
	  );
	};
	
	var MouseIcon = function MouseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,1.07C7.05,1.56 4,4.92 4,9H11M4,15C4,19.42 7.58,23 12,23C16.42,23 20,19.42 20,15V11H4M13,1.07V9H20C20,4.92 16.94,1.56 13,1.07Z' })
	  );
	};
	
	var MoveResizeVariantIcon = function MoveResizeVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1.88,0.46L0.46,1.88L5.59,7H2V9H9V2H7V5.59M11,7V9H21V15H23V9C23,7.9 22.1,7 21,7M7,11V21C7,22.1 7.9,23 9,23H15V21H9V11M15.88,14.46L14.46,15.88L19.6,21H17V23H23V17H21V19.59' })
	  );
	};
	
	var MoveResizeIcon = function MoveResizeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,1V2H10V5H9V6H12V5H11V2H12V1M9,7C7.89,7 7,7.89 7,9V21C7,22.11 7.89,23 9,23H21C22.11,23 23,22.11 23,21V9C23,7.89 22.11,7 21,7M1,9V12H2V11H5V12H6V9H5V10H2V9M9,9H21V21H9M14,10V11H15V16H11V15H10V18H11V17H15V19H14V20H17V19H16V17H19V18H20V15H19V16H16V11H17V10' })
	  );
	};
	
	var MovieRollIcon = function MovieRollIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C10.62,4 9.5,5.12 9.5,6.5C9.5,7.88 10.62,9 12,9C13.38,9 14.5,7.88 14.5,6.5C14.5,5.12 13.38,4 12,4M4.4,9.53C3.97,10.84 4.69,12.25 6,12.68C7.32,13.1 8.73,12.39 9.15,11.07C9.58,9.76 8.86,8.35 7.55,7.92C6.24,7.5 4.82,8.21 4.4,9.53M19.61,9.5C19.18,8.21 17.77,7.5 16.46,7.92C15.14,8.34 14.42,9.75 14.85,11.07C15.28,12.38 16.69,13.1 18,12.67C19.31,12.25 20.03,10.83 19.61,9.5M7.31,18.46C8.42,19.28 10,19.03 10.8,17.91C11.61,16.79 11.36,15.23 10.24,14.42C9.13,13.61 7.56,13.86 6.75,14.97C5.94,16.09 6.19,17.65 7.31,18.46M16.7,18.46C17.82,17.65 18.07,16.09 17.26,14.97C16.45,13.85 14.88,13.6 13.77,14.42C12.65,15.23 12.4,16.79 13.21,17.91C14,19.03 15.59,19.27 16.7,18.46M12,10.5C11.17,10.5 10.5,11.17 10.5,12C10.5,12.83 11.17,13.5 12,13.5C12.83,13.5 13.5,12.83 13.5,12C13.5,11.17 12.83,10.5 12,10.5Z' })
	  );
	};
	
	var MovieIcon = function MovieIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,4L20,8H17L15,4H13L15,8H12L10,4H8L10,8H7L5,4H4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V4H18Z' })
	  );
	};
	
	var MuffinIcon = function MuffinIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,5C16,5 15,2 12,2C9,2 8,5 8,5C6,5 4,7 4,9C1.3,9 1.3,13 4,13H20C22.7,13 22.7,9 20,9C20,7 18,5 16,5M5,15L7,22H9L8,15H5M10,15L11,22H13L14,15H10M16,15L15,22H17L19,15H16Z' })
	  );
	};
	
	var MultiplicationBoxIcon = function MultiplicationBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M11,17H13V13.73L15.83,15.36L16.83,13.63L14,12L16.83,10.36L15.83,8.63L13,10.27V7H11V10.27L8.17,8.63L7.17,10.36L10,12L7.17,13.63L8.17,15.36L11,13.73V17Z' })
	  );
	};
	
	var MultiplicationIcon = function MultiplicationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,3H13V10.27L19.29,6.64L20.29,8.37L14,12L20.3,15.64L19.3,17.37L13,13.72V21H11V13.73L4.69,17.36L3.69,15.63L10,12L3.72,8.36L4.72,6.63L11,10.26V3Z' })
	  );
	};
	
	var MushroomOutlineIcon = function MushroomOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,12H20C20,8.27 17.44,5.13 14,4.25C13.86,5.24 13,6 12,6C11,6 10.14,5.24 10,4.25C6.56,5.13 4,8.27 4,12M12,2C17.52,2 22,6.48 22,12C22,13.1 21.1,14 20,14H4C2.9,14 2,13.1 2,12C2,6.48 6.48,2 12,2M13.5,17H10.5L9.92,19L9.65,20H14.35L14.08,19L13.5,17M15,15L16,18.5L16.27,19.45L16.35,20C16.35,21.1 15.45,22 14.35,22H9.65L9.17,21.94C8.1,21.66 7.45,20.57 7.73,19.5L8,18.5L9,15H15M16,7C17.1,7 18,7.9 18,9C18,10.1 17.1,11 16,11C14.9,11 14,10.1 14,9C14,7.9 14.9,7 16,7M8,7C9.1,7 10,7.9 10,9C10,10.1 9.1,11 8,11C6.9,11 6,10.1 6,9C6,7.9 6.9,7 8,7Z' })
	  );
	};
	
	var MushroomIcon = function MushroomIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,13.1 21.1,14 20,14H4C2.9,14 2,13.1 2,12C2,6.48 6.48,2 12,2M12,8C13.1,8 14,7.1 14,6C14,4.9 13.1,4 12,4C10.9,4 10,4.9 10,6C10,7.1 10.9,8 12,8M17,12C18.1,12 19,11.1 19,10C19,8.9 18.1,8 17,8C15.9,8 15,8.9 15,10C15,11.1 15.9,12 17,12M7,12C8.1,12 9,11.1 9,10C9,8.9 8.1,8 7,8C5.9,8 5,8.9 5,10C5,11.1 5.9,12 7,12M15,15L16.27,19.45L16.35,20C16.35,21.1 15.45,22 14.35,22H9.65C8.55,22 7.65,21.1 7.65,20L7.73,19.45L9,15H15Z' })
	  );
	};
	
	var MusicBoxOutlineIcon = function MusicBoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,9H13V14.5C13,15.88 11.88,17 10.5,17C9.12,17 8,15.88 8,14.5C8,13.12 9.12,12 10.5,12C11.07,12 11.58,12.19 12,12.5V7H16V9M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M5,5V19H19V5H5Z' })
	  );
	};
	
	var MusicBoxIcon = function MusicBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,9H13V14.5C13,15.88 11.88,17 10.5,17C9.12,17 8,15.88 8,14.5C8,13.12 9.12,12 10.5,12C11.07,12 11.58,12.19 12,12.5V7H16M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var MusicCircleIcon = function MusicCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,9V7H12V12.5C11.58,12.19 11.07,12 10.5,12C9.12,12 8,13.12 8,14.5C8,15.88 9.12,17 10.5,17C11.88,17 13,15.88 13,14.5V9H16M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2Z' })
	  );
	};
	
	var MusicNoteBluetoothOffIcon = function MusicNoteBluetoothOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,3V8.68L13,11.68V6H17V3H10M3.28,4.5L2,5.77L8.26,12.03C5.89,12.15 4,14.1 4,16.5C4,19 6,21 8.5,21C10.9,21 12.85,19.11 12.97,16.74L17.68,21.45L18.96,20.18L13,14.22L10,11.22L3.28,4.5M20,7V10.79L17.71,8.5L17,9.21L19.79,12L17,14.79L17.71,15.5L20,13.21V17H20.5L23.35,14.15L21.21,12L23.36,9.85L20.5,7H20M21,8.91L21.94,9.85L21,10.79V8.91M21,13.21L21.94,14.15L21,15.09V13.21Z' })
	  );
	};
	
	var MusicNoteBluetoothIcon = function MusicNoteBluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,3V12.26C9.5,12.09 9,12 8.5,12C6,12 4,14 4,16.5C4,19 6,21 8.5,21C11,21 13,19 13,16.5V6H17V3H10M20,7V10.79L17.71,8.5L17,9.21L19.79,12L17,14.79L17.71,15.5L20,13.21V17H20.5L23.35,14.15L21.21,12L23.36,9.85L20.5,7H20M21,8.91L21.94,9.85L21,10.79V8.91M21,13.21L21.94,14.15L21,15.09V13.21Z' })
	  );
	};
	
	var MusicNoteEighthIcon = function MusicNoteEighthIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3V12.26C11.5,12.09 11,12 10.5,12C8.54,12 6.9,13.26 6.28,15H3V18H6.28C6.9,19.74 8.54,21 10.5,21C12.46,21 14.1,19.74 14.72,18H19V15H15V6H19V3H12Z' })
	  );
	};
	
	var MusicNoteHalfIcon = function MusicNoteHalfIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3V12.26C11.5,12.09 11,12 10.5,12C8.54,12 6.9,13.26 6.28,15H3V18H6.28C6.9,19.74 8.54,21 10.5,21C12.46,21 14.1,19.74 14.72,18H19V15H15V9L15,6V3H12M10.5,14.5C11.6,14.5 12.5,15.4 12.5,16.5C12.5,17.6 11.6,18.5 10.5,18.5C9.4,18.5 8.5,17.6 8.5,16.5C8.5,15.4 9.4,14.5 10.5,14.5Z' })
	  );
	};
	
	var MusicNoteOffIcon = function MusicNoteOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3V8.68L15,11.68V6H19V3H12M5.28,4.5L4,5.77L10.26,12.03C7.89,12.15 6,14.1 6,16.5C6,19 8,21 10.5,21C12.9,21 14.85,19.11 14.97,16.74L19.68,21.45L20.96,20.18L15,14.22L12,11.22L5.28,4.5Z' })
	  );
	};
	
	var MusicNoteQuarterIcon = function MusicNoteQuarterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3H15V15H19V18H14.72C14.1,19.74 12.46,21 10.5,21C8.54,21 6.9,19.74 6.28,18H3V15H6.28C6.9,13.26 8.54,12 10.5,12C11,12 11.5,12.09 12,12.26V3Z' })
	  );
	};
	
	var MusicNoteSixteenthIcon = function MusicNoteSixteenthIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3V12.26C11.5,12.09 11,12 10.5,12C8.54,12 6.9,13.26 6.28,15H3V18H6.28C6.9,19.74 8.54,21 10.5,21C12.46,21 14.1,19.74 14.72,18H19V15H15V10H19V7H15V6H19V3H12Z' })
	  );
	};
	
	var MusicNoteWholeIcon = function MusicNoteWholeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.5,12C8.6,12 6.9,13.2 6.26,15H3V18H6.26C6.9,19.8 8.6,21 10.5,21C12.4,21 14.1,19.8 14.74,18H19V15H14.74C14.1,13.2 12.4,12 10.5,12M10.5,14.5C11.6,14.5 12.5,15.4 12.5,16.5C12.5,17.6 11.6,18.5 10.5,18.5C9.4,18.5 8.5,17.6 8.5,16.5C8.5,15.4 9.4,14.5 10.5,14.5Z' })
	  );
	};
	
	var MusicNoteIcon = function MusicNoteIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3V12.26C11.5,12.09 11,12 10.5,12C8,12 6,14 6,16.5C6,19 8,21 10.5,21C13,21 15,19 15,16.5V6H19V3H12Z' })
	  );
	};
	
	var MusicOffIcon = function MusicOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L9,12.27V17.5C9,19.43 7.43,21 5.5,21C3.57,21 2,19.43 2,17.5C2,15.57 3.57,14 5.5,14C6.04,14 6.55,14.12 7,14.34V10.27L2,5.27M21,3V15.5C21,16.5 20.57,17.42 19.88,18.06L14.94,13.12C15.58,12.43 16.5,12 17.5,12C18.04,12 18.55,12.12 19,12.34V6.47L10.17,8.35L7.66,5.84L21,3Z' })
	  );
	};
	
	var MusicIcon = function MusicIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,3V15.5C21,17.43 19.43,19 17.5,19C15.57,19 14,17.43 14,15.5C14,13.57 15.57,12 17.5,12C18.04,12 18.55,12.12 19,12.34V6.47L9,8.6V17.5C9,19.43 7.43,21 5.5,21C3.57,21 2,19.43 2,17.5C2,15.57 3.57,14 5.5,14C6.04,14 6.55,14.12 7,14.34V6L21,3Z' })
	  );
	};
	
	var NasIcon = function NasIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,5C2.89,5 2,5.89 2,7V17C2,18.11 2.89,19 4,19H20C21.11,19 22,18.11 22,17V7C22,5.89 21.11,5 20,5H4M4.5,7C5.05,7 5.5,7.45 5.5,8C5.5,8.55 5.05,9 4.5,9C3.95,9 3.5,8.55 3.5,8C3.5,7.45 3.95,7 4.5,7M7,7H20V17H7V7M8,8V16H11V8H8M12,8V16H15V8H12M16,8V16H19V8H16M9,9H10V10H9V9M13,9H14V10H13V9M17,9H18V10H17V9Z' })
	  );
	};
	
	var NativescriptIcon = function NativescriptIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.5,3H16.5C19,3 21,5 21,7.5V16.5C21,19 19,21 16.5,21H7.5C5,21 3,19 3,16.5V7.5C3,5 5,3 7.5,3M6,13.5V16.5C6,17.33 6.67,18 7.5,18H9V10.5L15,18H16.5C17.33,18 18,17.33 18,16.5V13.5C18,12.67 18.67,12 19.5,12C18.67,12 18,11.33 18,10.5V7.5C18,6.67 17.33,6 16.5,6H15V13.5L9,6H7.5C6.67,6 6,6.67 6,7.5V10.5C6,11.33 5.33,12 4.5,12C5.33,12 6,12.67 6,13.5Z' })
	  );
	};
	
	var NaturePeopleIcon = function NaturePeopleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.5,11C5.33,11 6,10.33 6,9.5C6,8.67 5.33,8 4.5,8C3.67,8 3,8.67 3,9.5C3,10.33 3.67,11 4.5,11M22.17,9.17C22.17,5.3 19.04,2.17 15.17,2.17C11.3,2.17 8.17,5.3 8.17,9.17C8.17,12.64 10.69,15.5 14,16.06V20H6V17H7V13C7,12.45 6.55,12 6,12H3C2.45,12 2,12.45 2,13V17H3V22H19V20H16V16.12C19.47,15.71 22.17,12.76 22.17,9.17Z' })
	  );
	};
	
	var NatureIcon = function NatureIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,16.12C16.47,15.71 19.17,12.76 19.17,9.17C19.17,5.3 16.04,2.17 12.17,2.17C8.3,2.17 5.17,5.3 5.17,9.17C5.17,12.64 7.69,15.5 11,16.06V20H5V22H19V20H13V16.12Z' })
	  );
	};
	
	var NavigationIcon = function NavigationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2L4.5,20.29L5.21,21L12,18L18.79,21L19.5,20.29L12,2Z' })
	  );
	};
	
	var NearMeIcon = function NearMeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,3L3,10.53V11.5L9.84,14.16L12.5,21H13.46L21,3Z' })
	  );
	};
	
	var NeedleIcon = function NeedleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.15,15.18L9.73,13.77L11.15,12.35L12.56,13.77L13.97,12.35L12.56,10.94L13.97,9.53L15.39,10.94L16.8,9.53L13.97,6.7L6.9,13.77L9.73,16.6L11.15,15.18M3.08,19L6.2,15.89L4.08,13.77L13.97,3.87L16.1,6L17.5,4.58L16.1,3.16L17.5,1.75L21.75,6L20.34,7.4L18.92,6L17.5,7.4L19.63,9.53L9.73,19.42L7.61,17.3L3.08,21.84V19Z' })
	  );
	};
	
	var NetflixIcon = function NetflixIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.5,2H10.5L13.44,10.83L13.5,2H17.5V22C16.25,21.78 14.87,21.64 13.41,21.58L10.5,13L10.43,21.59C9.03,21.65 7.7,21.79 6.5,22V2Z' })
	  );
	};
	
	var NetworkStrength1AlertIcon = function NetworkStrength1AlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,1L1,21H17V19H11V13.83L19,5.83V7H21M19,9V17H21V9M19,19V21H21V19' })
	  );
	};
	
	var NetworkStrength1Icon = function NetworkStrength1Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,21H21V1M19,5.83V19H11V13.83' })
	  );
	};
	
	var NetworkStrength2AlertIcon = function NetworkStrength2AlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,1L1,21H17V19H13V11.83L19,5.83V7H21M19,9V17H21V9M19,19V21H21V19' })
	  );
	};
	
	var NetworkStrength2Icon = function NetworkStrength2Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,21H21V1M19,5.83V19H13V11.83' })
	  );
	};
	
	var NetworkStrength3AlertIcon = function NetworkStrength3AlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,1L1,21H17V19H16V8.83L19,5.83V7H21M19,9V17H21V9M19,19V21H21V19' })
	  );
	};
	
	var NetworkStrength3Icon = function NetworkStrength3Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,21H21V1M19,5.83V19H16V8.83' })
	  );
	};
	
	var NetworkStrength4AlertIcon = function NetworkStrength4AlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,17H21V9H19M19,21H21V19H19M1,21H17V7H21V1' })
	  );
	};
	
	var NetworkStrength4Icon = function NetworkStrength4Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,21H21V1' })
	  );
	};
	
	var NetworkStrengthOffOutlineIcon = function NetworkStrengthOffOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,1L12.4,9.6L13.85,11.05L19,5.83V16.19L21,18.19M4.77,4.5L3.5,5.77L9.86,12.13L1,21H18.73L20.73,23L22,21.73M11.33,13.6L16.73,19H6' })
	  );
	};
	
	var NetworkStrengthOffIcon = function NetworkStrengthOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,1L12.4,9.6L21,18.19M4.77,4.5L3.5,5.77L9.86,12.13L1,21H18.73L20.73,23L22,21.73' })
	  );
	};
	
	var NetworkStrengthOutlineIcon = function NetworkStrengthOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,21H21V1M19,5.83V19H6' })
	  );
	};
	
	var NetworkIcon = function NetworkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,3C18.1,3 19,3.9 19,5V15C19,16.1 18.1,17 17,17H13V19H14C14.55,19 15,19.45 15,20H22V22H15C15,22.55 14.55,23 14,23H10C9.45,23 9,22.55 9,22H2V20H9C9,19.45 9.45,19 10,19H11V17H7C5.89,17 5,16.1 5,15V5C5,3.9 5.9,3 7,3H17Z' })
	  );
	};
	
	var NewBoxIcon = function NewBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,4C21.11,4 22,4.89 22,6V18C22,19.11 21.11,20 20,20H4C2.89,20 2,19.11 2,18V6C2,4.89 2.89,4 4,4H20M8.5,15V9H7.25V12.5L4.75,9H3.5V15H4.75V11.5L7.3,15H8.5M13.5,10.26V9H9.5V15H13.5V13.75H11V12.64H13.5V11.38H11V10.26H13.5M20.5,14V9H19.25V13.5H18.13V10H16.88V13.5H15.75V9H14.5V14C14.5,14.55 14.95,15 15.5,15H19.5C20.05,15 20.5,14.55 20.5,14Z' })
	  );
	};
	
	var NewspaperIcon = function NewspaperIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,11H4V8H20M20,15H13V13H20M20,19H13V17H20M11,19H4V13H11M20.33,4.67L18.67,3L17,4.67L15.33,3L13.67,4.67L12,3L10.33,4.67L8.67,3L7,4.67L5.33,3L3.67,4.67L2,3V19C2,20.1 2.9,21 4,21H20C21.1,21 22,20.1 22,19V3L20.33,4.67Z' })
	  );
	};
	
	var NfcTapIcon = function NfcTapIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,10C13.1,10 14,10.9 14,12C14,13.1 13.1,14 12,14C10.9,14 10,13.1 10,12C10,10.9 10.9,10 12,10M4,4H11C12.1,4 13,4.9 13,6V9H11V6H4V11H6V9L9,12L6,15V13H4C2.9,13 2,12.1 2,11V6C2,4.9 2.9,4 4,4M20,20H13C11.9,20 11,19.1 11,18V15H13V18H20V13H18V15L15,12L18,9V11H20C21.1,11 22,11.9 22,13V18C22,19.1 21.1,20 20,20Z' })
	  );
	};
	
	var NfcVariantIcon = function NfcVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,6H13C11.9,6 11,6.9 11,8V10.28C10.41,10.62 10,11.26 10,12C10,13.1 10.9,14 12,14C13.11,14 14,13.1 14,12C14,11.26 13.6,10.62 13,10.28V8H16V16H8V8H10V6H8L6,6V18H18M20,20H4V4H20M20,2H4C2.9,2 2,2.9 2,4V20C2,21.1 2.9,22 4,22H20C21.11,22 22,21.1 22,20V4C22,2.89 21.11,2 20,2Z' })
	  );
	};
	
	var NfcIcon = function NfcIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.59,7.66C10.59,7.66 11.19,7.39 11.57,7.82C11.95,8.26 12.92,9.94 12.92,11.62C12.92,13.3 12.5,15.09 12.05,15.68C11.62,16.28 11.19,16.28 10.86,16.06C10.54,15.85 5.5,12 5.23,11.89C4.95,11.78 4.85,12.05 5.12,13.5C5.39,15 4.95,15.41 4.57,15.47C4.2,15.5 3.06,15.2 3,12.16C2.95,9.13 3.76,8.64 4.14,8.64C4.85,8.64 10.27,13.5 10.64,13.46C10.97,13.41 11.13,11.35 10.5,9.72C9.78,7.96 10.59,7.66 10.59,7.66M19.3,4.63C21.12,8.24 21,11.66 21,12C21,12.34 21.12,15.76 19.3,19.37C19.3,19.37 18.83,19.92 18.12,19.59C17.42,19.26 17.66,18.4 17.66,18.4C17.66,18.4 19.14,15.55 19.1,12.05V12C19.14,8.5 17.66,5.6 17.66,5.6C17.66,5.6 17.42,4.74 18.12,4.41C18.83,4.08 19.3,4.63 19.3,4.63M15.77,6.25C17.26,8.96 17.16,11.66 17.14,12C17.16,12.34 17.26,14.92 15.77,17.85C15.77,17.85 15.3,18.4 14.59,18.07C13.89,17.74 14.13,16.88 14.13,16.88C14.13,16.88 15.09,15.5 15.24,12.05V12C15.14,8.53 14.13,7.23 14.13,7.23C14.13,7.23 13.89,6.36 14.59,6.04C15.3,5.71 15.77,6.25 15.77,6.25Z' })
	  );
	};
	
	var NinjaIcon = function NinjaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.75,13C7.74,12.65 7.9,12.31 8.17,12.08C8.92,12.24 9.62,12.55 10.25,13C10.25,13.68 9.69,14.24 9,14.24C8.31,14.24 7.76,13.69 7.75,13M13.75,13C14.38,12.56 15.08,12.25 15.83,12.09C16.1,12.32 16.26,12.66 16.25,13C16.25,13.7 15.69,14.26 15,14.26C14.31,14.26 13.75,13.7 13.75,13V13M12,9C9.23,8.96 6.5,9.65 4.07,11L4,12C4,13.23 4.29,14.44 4.84,15.54C7.21,15.18 9.6,15 12,15C14.4,15 16.79,15.18 19.16,15.54C19.71,14.44 20,13.23 20,12L19.93,11C17.5,9.65 14.77,8.96 12,9M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2Z' })
	  );
	};
	
	var NintendoSwitchIcon = function NintendoSwitchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.04,20.4H7.12C6.19,20.4 5.3,20 4.64,19.36C4,18.7 3.6,17.81 3.6,16.88V7.12C3.6,6.19 4,5.3 4.64,4.64C5.3,4 6.19,3.62 7.12,3.62H10.04V20.4M7.12,2C4.29,2 2,4.29 2,7.12V16.88C2,19.71 4.29,22 7.12,22H11.65V2H7.12M5.11,8C5.11,9.04 5.95,9.88 7,9.88C8.03,9.88 8.87,9.04 8.87,8C8.87,6.96 8.03,6.12 7,6.12C5.95,6.12 5.11,6.96 5.11,8M17.61,11C18.72,11 19.62,11.89 19.62,13C19.62,14.12 18.72,15 17.61,15C16.5,15 15.58,14.12 15.58,13C15.58,11.89 16.5,11 17.61,11M16.88,22C19.71,22 22,19.71 22,16.88V7.12C22,4.29 19.71,2 16.88,2H13.65V22H16.88Z' })
	  );
	};
	
	var NodejsIcon = function NodejsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1.85C11.73,1.85 11.45,1.92 11.22,2.05L3.78,6.35C3.3,6.63 3,7.15 3,7.71V16.29C3,16.85 3.3,17.37 3.78,17.65L5.73,18.77C6.68,19.23 7,19.24 7.44,19.24C8.84,19.24 9.65,18.39 9.65,16.91V8.44C9.65,8.32 9.55,8.22 9.43,8.22H8.5C8.37,8.22 8.27,8.32 8.27,8.44V16.91C8.27,17.57 7.59,18.22 6.5,17.67L4.45,16.5C4.38,16.45 4.34,16.37 4.34,16.29V7.71C4.34,7.62 4.38,7.54 4.45,7.5L11.89,3.21C11.95,3.17 12.05,3.17 12.11,3.21L19.55,7.5C19.62,7.54 19.66,7.62 19.66,7.71V16.29C19.66,16.37 19.62,16.45 19.55,16.5L12.11,20.79C12.05,20.83 11.95,20.83 11.88,20.79L10,19.65C9.92,19.62 9.84,19.61 9.79,19.64C9.26,19.94 9.16,20 8.67,20.15C8.55,20.19 8.36,20.26 8.74,20.47L11.22,21.94C11.46,22.08 11.72,22.15 12,22.15C12.28,22.15 12.54,22.08 12.78,21.94L20.22,17.65C20.7,17.37 21,16.85 21,16.29V7.71C21,7.15 20.7,6.63 20.22,6.35L12.78,2.05C12.55,1.92 12.28,1.85 12,1.85M14,8C11.88,8 10.61,8.89 10.61,10.39C10.61,12 11.87,12.47 13.91,12.67C16.34,12.91 16.53,13.27 16.53,13.75C16.53,14.58 15.86,14.93 14.3,14.93C12.32,14.93 11.9,14.44 11.75,13.46C11.73,13.36 11.64,13.28 11.53,13.28H10.57C10.45,13.28 10.36,13.37 10.36,13.5C10.36,14.74 11.04,16.24 14.3,16.24C16.65,16.24 18,15.31 18,13.69C18,12.08 16.92,11.66 14.63,11.35C12.32,11.05 12.09,10.89 12.09,10.35C12.09,9.9 12.29,9.3 14,9.3C15.5,9.3 16.09,9.63 16.32,10.66C16.34,10.76 16.43,10.83 16.53,10.83H17.5C17.55,10.83 17.61,10.81 17.65,10.76C17.69,10.72 17.72,10.66 17.7,10.6C17.56,8.82 16.38,8 14,8Z' })
	  );
	};
	
	var NotEqualVariantIcon = function NotEqualVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.08,4.61L15.92,5.4L14.8,8H19V10H13.95L12.23,14H19V16H11.38L9.92,19.4L8.08,18.61L9.2,16H5V14H10.06L11.77,10H5V8H12.63L14.08,4.61Z' })
	  );
	};
	
	var NotEqualIcon = function NotEqualIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,10H9V8H21V10M21,16H9V14H21V16M4,5H6V16H4V5M6,18V20H4V18H6Z' })
	  );
	};
	
	var NoteMultipleOutlineIcon = function NoteMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,6V22H21V24H3C1.9,24 1,23.1 1,22V6H3M16,9H21.5L16,3.5V9M7,2H17L23,8V18C23,19.1 22.1,20 21,20H7C5.89,20 5,19.1 5,18V4C5,2.9 5.9,2 7,2M7,4V18H21V11H14V4H7Z' })
	  );
	};
	
	var NoteMultipleIcon = function NoteMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,9H21.5L16,3.5V9M7,2H17L23,8V18C23,19.1 22.1,20 21,20H7C5.89,20 5,19.1 5,18V4C5,2.9 5.9,2 7,2M3,6V22H21V24H3C1.9,24 1,23.1 1,22V6H3Z' })
	  );
	};
	
	var NoteOutlineIcon = function NoteOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,10H19.5L14,4.5V10M5,3H15L21,9V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3M5,5V19H19V12H12V5H5Z' })
	  );
	};
	
	var NotePlusOutlineIcon = function NotePlusOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,10H20.5L15,4.5V10M4,3H16L22,9V19C22,20.1 21.1,21 20,21H4C2.89,21 2,20.1 2,19V5C2,3.89 2.89,3 4,3M4,5V19H20V12H13V5H4M8,17V15H6V13H8V11H10V13H12V15H10V17H8Z' })
	  );
	};
	
	var NotePlusIcon = function NotePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,10H19.5L14,4.5V10M5,3H15L21,9V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3M9,18H11V15H14V13H11V10H9V13H6V15H9V18Z' })
	  );
	};
	
	var NoteTextIcon = function NoteTextIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,10H19.5L14,4.5V10M5,3H15L21,9V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3M5,12V14H19V12H5M5,16V18H14V16H5Z' })
	  );
	};
	
	var NoteIcon = function NoteIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,10V4.5L19.5,10M5,3C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V9L15,3H5Z' })
	  );
	};
	
	var NotebookIcon = function NotebookIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,7V5H5V4C5,2.89 5.9,2 7,2H13V9L15.5,7.5L18,9V2H19C20.05,2 21,2.95 21,4V20C21,21.05 20.05,22 19,22H7C5.95,22 5,21.05 5,20V19H3V17H5V13H3V11H5V7H3M7,11H5V13H7V11M7,7V5H5V7H7M7,19V17H5V19H7Z' })
	  );
	};
	
	var NotificationClearAllIcon = function NotificationClearAllIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,13H19V11H5M3,17H17V15H3M7,7V9H21V7' })
	  );
	};
	
	var NpmVariantOutlineIcon = function NpmVariantOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3V21H21V3H3M6,6H18V18H15V9H12V18H6V6Z' })
	  );
	};
	
	var NpmVariantIcon = function NpmVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,4H4V20H12V8H16V20H20V4' })
	  );
	};
	
	var NpmIcon = function NpmIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,10V14H6V11H7V14H8V10H4M9,10V15H11V14H13V10H9M12,11V13H11V11H12M14,10V14H16V11H17V14H18V11H19V14H20V10H14M3,9H21V15H12V16H8V15H3V9Z' })
	  );
	};
	
	var NukeIcon = function NukeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.04,12H10V11H5.5C3.57,11 2,9.43 2,7.5C2,5.57 3.57,4 5.5,4C6.53,4 7.45,4.44 8.09,5.15C8.5,3.35 10.08,2 12,2C13.92,2 15.5,3.35 15.91,5.15C16.55,4.44 17.47,4 18.5,4C20.43,4 22,5.57 22,7.5C22,9.43 20.43,11 18.5,11H14.04V12M10,16.9V15.76H5V13.76H19V15.76H14.04V16.92L20,19.08C20.58,19.29 21,19.84 21,20.5C21,21.33 20.33,22 19.5,22H4.5C3.67,22 3,21.33 3,20.5C3,19.84 3.42,19.29 4,19.08L10,16.9Z' })
	  );
	};
	
	var NullIcon = function NullIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C13.85,2 15.55,2.78 16.9,4.1L18.6,1.93L20.18,3.16L18.2,5.68C19.33,7.41 20,9.6 20,12C20,17.5 16.42,22 12,22C10.15,22 8.45,21.22 7.1,19.9L5.4,22.07L3.82,20.84L5.8,18.32C4.67,16.59 4,14.4 4,12C4,6.5 7.58,2 12,2M12,4C8.69,4 6,7.58 6,12C6,13.73 6.41,15.33 7.11,16.64L15.67,5.67C14.66,4.62 13.38,4 12,4M12,20C15.31,20 18,16.42 18,12C18,10.27 17.59,8.67 16.89,7.36L8.33,18.33C9.34,19.38 10.62,20 12,20Z' })
	  );
	};
	
	var Numeric0BoxMultipleOutlineIcon = function Numeric0BoxMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,17V3H7V17H21M21,1C22.1,1 23,1.9 23,3V17C23,18.1 22.1,19 21,19H7C5.9,19 5,18.1 5,17V3C5,1.9 5.9,1 7,1H21M3,5V21H19V23H3C1.9,23 1,22.1 1,21V5H3M13,5H15C16.1,5 17,5.9 17,7V13C17,14.1 16.1,15 15,15H13C11.9,15 11,14.1 11,13V7C11,5.9 11.9,5 13,5M13,7V13H15V7H13Z' })
	  );
	};
	
	var Numeric0BoxOutlineIcon = function Numeric0BoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19V5H5V19H19M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M11,7H13C14.1,7 15,7.9 15,9V15C15,16.1 14.1,17 13,17H11C9.9,17 9,16.1 9,15V9C9,7.9 9.9,7 11,7M11,9V15H13V9H11Z' })
	  );
	};
	
	var Numeric0BoxIcon = function Numeric0BoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M11,7C9.9,7 9,7.9 9,9V15C9,16.1 9.9,17 11,17H13C14.1,17 15,16.1 15,15V9C15,7.9 14.1,7 13,7H11M11,9H13V15H11V9Z' })
	  );
	};
	
	var Numeric1BoxMultipleOutlineIcon = function Numeric1BoxMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M14,15H16V5H12V7H14M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z' })
	  );
	};
	
	var Numeric1BoxOutlineIcon = function Numeric1BoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M12,17H14V7H10V9H12' })
	  );
	};
	
	var Numeric1BoxIcon = function Numeric1BoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,17H12V9H10V7H14M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var Numeric2BoxMultipleOutlineIcon = function Numeric2BoxMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,13H13V11H15C16.1,11 17,10.1 17,9V7C17,5.89 16.1,5 15,5H11V7H15V9H13C11.9,9 11,9.9 11,11V15H17M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z' })
	  );
	};
	
	var Numeric2BoxOutlineIcon = function Numeric2BoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,15H11V13H13C14.1,13 15,12.1 15,11V9C15,7.89 14.1,7 13,7H9V9H13V11H11C9.9,11 9,11.9 9,13V17H15M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var Numeric2BoxIcon = function Numeric2BoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,11C15,12.11 14.1,13 13,13H11V15H15V17H9V13C9,11.89 9.9,11 11,11H13V9H9V7H13C14.1,7 15,7.9 15,9M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var Numeric3BoxMultipleOutlineIcon = function Numeric3BoxMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,13V11.5C17,10.67 16.33,10 15.5,10C16.33,10 17,9.33 17,8.5V7C17,5.89 16.1,5 15,5H11V7H15V9H13V11H15V13H11V15H15C16.1,15 17,14.1 17,13M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1Z' })
	  );
	};
	
	var Numeric3BoxOutlineIcon = function Numeric3BoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,15V13.5C15,12.67 14.33,12 13.5,12C14.33,12 15,11.33 15,10.5V9C15,7.89 14.1,7 13,7H9V9H13V11H11V13H13V15H9V17H13C14.1,17 15,16.1 15,15M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var Numeric3BoxIcon = function Numeric3BoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,10.5C15,11.33 14.33,12 13.5,12C14.34,12 15,12.67 15,13.5V15C15,16.11 14.11,17 13,17H9V15H13V13H11V11H13V9H9V7H13C14.11,7 15,7.89 15,9M19,3H5C3.91,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.11,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var Numeric4BoxMultipleOutlineIcon = function Numeric4BoxMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M15,15H17V5H15V9H13V5H11V11H15M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z' })
	  );
	};
	
	var Numeric4BoxOutlineIcon = function Numeric4BoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M13,17H15V7H13V11H11V7H9V13H13' })
	  );
	};
	
	var Numeric4BoxIcon = function Numeric4BoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,17H13V13H9V7H11V11H13V7H15M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var Numeric5BoxMultipleOutlineIcon = function Numeric5BoxMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,13V11C17,9.89 16.1,9 15,9H13V7H17V5H11V11H15V13H11V15H15C16.1,15 17,14.1 17,13M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1Z' })
	  );
	};
	
	var Numeric5BoxOutlineIcon = function Numeric5BoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,15V13C15,11.89 14.1,11 13,11H11V9H15V7H9V13H13V15H9V17H13C14.1,17 15,16.1 15,15M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var Numeric5BoxIcon = function Numeric5BoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,9H11V11H13C14.1,11 15,11.9 15,13V15C15,16.11 14.1,17 13,17H9V15H13V13H9V7H15M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var Numeric6BoxMultipleOutlineIcon = function Numeric6BoxMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,11H15V13H13M13,15H15C16.1,15 17,14.1 17,13V11C17,9.89 16.1,9 15,9H13V7H17V5H13C11.9,5 11,5.9 11,7V13C11,14.11 11.9,15 13,15M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z' })
	  );
	};
	
	var Numeric6BoxOutlineIcon = function Numeric6BoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,13H13V15H11M11,17H13C14.1,17 15,16.1 15,15V13C15,11.89 14.1,11 13,11H11V9H15V7H11C9.9,7 9,7.9 9,9V15C9,16.11 9.9,17 11,17M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var Numeric6BoxIcon = function Numeric6BoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,9H11V11H13C14.1,11 15,11.9 15,13V15C15,16.11 14.1,17 13,17H11C9.9,17 9,16.1 9,15V9C9,7.89 9.9,7 11,7H15M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M11,15H13V13H11V15Z' })
	  );
	};
	
	var Numeric7BoxMultipleOutlineIcon = function Numeric7BoxMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,15L17,7V5H11V7H15L11,15M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z' })
	  );
	};
	
	var Numeric7BoxOutlineIcon = function Numeric7BoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,17L15,9V7H9V9H13L9,17M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var Numeric7BoxIcon = function Numeric7BoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M11,17L15,9V7H9V9H13L9,17H11Z' })
	  );
	};
	
	var Numeric8BoxMultipleOutlineIcon = function Numeric8BoxMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,11H15V13H13M13,7H15V9H13M13,15H15C16.1,15 17,14.1 17,13V11.5C17,10.67 16.33,10 15.5,10C16.33,10 17,9.33 17,8.5V7C17,5.89 16.1,5 15,5H13C11.9,5 11,5.9 11,7V8.5C11,9.33 11.67,10 12.5,10C11.67,10 11,10.67 11,11.5V13C11,14.11 11.9,15 13,15M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z' })
	  );
	};
	
	var Numeric8BoxOutlineIcon = function Numeric8BoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,13H13V15H11M11,9H13V11H11M11,17H13C14.1,17 15,16.1 15,15V13.5C15,12.67 14.33,12 13.5,12C14.33,12 15,11.33 15,10.5V9C15,7.89 14.1,7 13,7H11C9.9,7 9,7.9 9,9V10.5C9,11.33 9.67,12 10.5,12C9.67,12 9,12.67 9,13.5V15C9,16.11 9.9,17 11,17M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var Numeric8BoxIcon = function Numeric8BoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M11,17H13C14.1,17 15,16.1 15,15V13.5C15,12.67 14.33,12 13.5,12C14.33,12 15,11.33 15,10.5V9C15,7.89 14.1,7 13,7H11C9.9,7 9,7.9 9,9V10.5C9,11.33 9.67,12 10.5,12C9.67,12 9,12.67 9,13.5V15C9,16.11 9.9,17 11,17M11,13H13V15H11V13M11,9H13V11H11V9Z' })
	  );
	};
	
	var Numeric9BoxMultipleOutlineIcon = function Numeric9BoxMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,9H13V7H15M15,5H13C11.9,5 11,5.9 11,7V9C11,10.11 11.9,11 13,11H15V13H11V15H15C16.1,15 17,14.1 17,13V7C17,5.89 16.1,5 15,5M21,17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z' })
	  );
	};
	
	var Numeric9BoxOutlineIcon = function Numeric9BoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,11H11V9H13M13,7H11C9.9,7 9,7.9 9,9V11C9,12.11 9.9,13 11,13H13V15H9V17H13C14.1,17 15,16.1 15,15V9C15,7.89 14.1,7 13,7M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3Z' })
	  );
	};
	
	var Numeric9BoxIcon = function Numeric9BoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M13,11H11V9H13V11M13,7H11C9.9,7 9,7.9 9,9V11C9,12.11 9.9,13 11,13H13V15H9V17H13C14.1,17 15,16.1 15,15V9C15,7.89 14.1,7 13,7Z' })
	  );
	};
	
	var Numeric9PlusBoxMultipleOutlineIcon = function Numeric9PlusBoxMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,9H19V7H17V9H15V11H17V13H19V11H21V17H7V3H21M21,1H7C5.9,1 5,1.9 5,3V17C5,18.1 5.9,19 7,19H21C22.1,19 23,18.1 23,17V3C23,1.9 22.1,1 21,1M11,9V8H12V9M14,12V8C14,6.89 13.1,6 12,6H11C9.9,6 9,6.9 9,8V9C9,10.11 9.9,11 11,11H12V12H9V14H12C13.1,14 14,13.1 14,12M3,5H1V21C1,22.1 1.9,23 3,23H19V21H3V5Z' })
	  );
	};
	
	var Numeric9PlusBoxOutlineIcon = function Numeric9PlusBoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,11H17V9H15V11H13V13H15V15H17V13H19V19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M9,11V10H10V11M12,14V10C12,8.89 11.1,8 10,8H9C7.9,8 7,8.9 7,10V11C7,12.11 7.9,13 9,13H10V14H7V16H10C11.1,16 12,15.1 12,14Z' })
	  );
	};
	
	var Numeric9PlusBoxIcon = function Numeric9PlusBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5M19,11H17V9H15V11H13V13H15V15H17V13H19V11M10,7H8C6.9,7 6,7.9 6,9V11C6,12.11 6.9,13 8,13H10V15H6V17H10C11.1,17 12,16.1 12,15V9C12,7.89 11.1,7 10,7M8,9H10V11H8V9Z' })
	  );
	};
	
	var NumericIcon = function NumericIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,17V9H2V7H6V17H4M22,15C22,16.11 21.1,17 20,17H16V15H20V13H18V11H20V9H16V7H20C21.1,7 22,7.9 22,9V10.5C22,11.33 21.33,12 20.5,12C21.33,12 22,12.67 22,13.5V15M14,15V17H8V13C8,11.89 8.9,11 10,11H12V9H8V7H12C13.1,7 14,7.9 14,9V11C14,12.11 13.1,13 12,13H10V15H14Z' })
	  );
	};
	
	var NutIcon = function NutIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7Z' })
	  );
	};
	
	var NutritionIcon = function NutritionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,18C22,20.21 20.21,22 18,22H14C11.79,22 10,20.21 10,18V16H22V18M4,3H14C15.1,3 16,3.9 16,5V14H8V19H4C2.9,19 2,18.1 2,17V5C2,3.9 2.9,3 4,3M4,6V8H6V6H4M14,8V6H8V8H14M4,10V12H6V10H4M8,10V12H14V10H8M4,14V16H6V14H4Z' })
	  );
	};
	
	var OarIcon = function OarIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.23,15.21C18.77,13.75 14.97,10.2 12.77,11.27L4.5,3L3,4.5L11.28,12.79C10.3,15 13.88,18.62 15.35,20.08C17.11,21.84 18.26,20.92 19.61,19.57C21.1,18.08 21.61,16.61 20.23,15.21Z' })
	  );
	};
	
	var OctagonOutlineIcon = function OctagonOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.27,3L3,8.27V15.73L8.27,21H15.73C17.5,19.24 21,15.73 21,15.73V8.27L15.73,3M9.1,5H14.9L19,9.1V14.9L14.9,19H9.1L5,14.9V9.1' })
	  );
	};
	
	var OctagonIcon = function OctagonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.73,3H8.27L3,8.27V15.73L8.27,21H15.73L21,15.73V8.27' })
	  );
	};
	
	var OctagramOutlineIcon = function OctagramOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.2,16.06L3.88,12L2.2,7.94L6.26,6.26L7.94,2.2L12,3.88L16.06,2.2L17.74,6.26L21.8,7.94L20.12,12L21.8,16.06L17.74,17.74L16.06,21.8L12,20.12L7.94,21.8L6.26,17.74L2.2,16.06M4.81,9L6.05,12L4.81,15L7.79,16.21L9,19.19L12,17.95L15,19.19L16.21,16.21L19.19,15L17.95,12L19.19,9L16.21,7.79L15,4.81L12,6.05L9,4.81L7.79,7.79L4.81,9Z' })
	  );
	};
	
	var OctagramIcon = function OctagramIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.2,16.06L3.88,12L2.2,7.94L6.26,6.26L7.94,2.2L12,3.88L16.06,2.2L17.74,6.26L21.8,7.94L20.12,12L21.8,16.06L17.74,17.74L16.06,21.8L12,20.12L7.94,21.8L6.26,17.74L2.2,16.06Z' })
	  );
	};
	
	var OdnoklassnikiIcon = function OdnoklassnikiIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.83,12.74C17.55,12.17 16.76,11.69 15.71,12.5C14.28,13.64 12,13.64 12,13.64C12,13.64 9.72,13.64 8.29,12.5C7.24,11.69 6.45,12.17 6.17,12.74C5.67,13.74 6.23,14.23 7.5,15.04C8.59,15.74 10.08,16 11.04,16.1L10.24,16.9C9.1,18.03 8,19.12 7.25,19.88C6.8,20.34 6.8,21.07 7.25,21.5L7.39,21.66C7.84,22.11 8.58,22.11 9.03,21.66L12,18.68C13.15,19.81 14.24,20.9 15,21.66C15.45,22.11 16.18,22.11 16.64,21.66L16.77,21.5C17.23,21.07 17.23,20.34 16.77,19.88L13.79,16.9L13,16.09C13.95,16 15.42,15.73 16.5,15.04C17.77,14.23 18.33,13.74 17.83,12.74M12,4.57C13.38,4.57 14.5,5.69 14.5,7.06C14.5,8.44 13.38,9.55 12,9.55C10.62,9.55 9.5,8.44 9.5,7.06C9.5,5.69 10.62,4.57 12,4.57M12,12.12C14.8,12.12 17.06,9.86 17.06,7.06C17.06,4.27 14.8,2 12,2C9.2,2 6.94,4.27 6.94,7.06C6.94,9.86 9.2,12.12 12,12.12Z' })
	  );
	};
	
	var OfficeBuildingIcon = function OfficeBuildingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3V21H11V17.5H13V21H19V3H5M7,5H9V7H7V5M11,5H13V7H11V5M15,5H17V7H15V5M7,9H9V11H7V9M11,9H13V11H11V9M15,9H17V11H15V9M7,13H9V15H7V13M11,13H13V15H11V13M15,13H17V15H15V13M7,17H9V19H7V17M15,17H17V19H15V17Z' })
	  );
	};
	
	var OfficeIcon = function OfficeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,18L7,16.75V7L14,5V19.5L3.5,18.25L14,22L20,20.75V3.5L13.95,2L3,5.75V18Z' })
	  );
	};
	
	var OilTemperatureIcon = function OilTemperatureIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.5,1C10.67,1 10,1.67 10,2.5V14.5C9.37,14.97 9,15.71 9,16.5C9,17.88 10.12,19 11.5,19C12.88,19 14,17.88 14,16.5C14,15.71 13.63,15 13,14.5V13H17V11H13V9H17V7H13V5H17V3H13V2.5C13,1.67 12.33,1 11.5,1M0,15V17C0.67,17 0.79,17.21 1.29,17.71C1.79,18.21 2.67,19 4,19C5.33,19 6.21,18.21 6.71,17.71C6.82,17.59 6.91,17.5 7,17.41V15.16C6.21,15.42 5.65,15.93 5.29,16.29C4.79,16.79 4.67,17 4,17C3.33,17 3.21,16.79 2.71,16.29C2.21,15.79 1.33,15 0,15M16,15V17C16.67,17 16.79,17.21 17.29,17.71C17.79,18.21 18.67,19 20,19C21.33,19 22.21,18.21 22.71,17.71C23.21,17.21 23.33,17 24,17V15C22.67,15 21.79,15.79 21.29,16.29C20.79,16.79 20.67,17 20,17C19.33,17 19.21,16.79 18.71,16.29C18.21,15.79 17.33,15 16,15M8,20C6.67,20 5.79,20.79 5.29,21.29C4.79,21.79 4.67,22 4,22C3.33,22 3.21,21.79 2.71,21.29C2.35,20.93 1.79,20.42 1,20.16V22.41C1.09,22.5 1.18,22.59 1.29,22.71C1.79,23.21 2.67,24 4,24C5.33,24 6.21,23.21 6.71,22.71C7.21,22.21 7.33,22 8,22C8.67,22 8.79,22.21 9.29,22.71C9.73,23.14 10.44,23.8 11.5,23.96C11.66,24 11.83,24 12,24C13.33,24 14.21,23.21 14.71,22.71C15.21,22.21 15.33,22 16,22C16.67,22 16.79,22.21 17.29,22.71C17.79,23.21 18.67,24 20,24C21.33,24 22.21,23.21 22.71,22.71C22.82,22.59 22.91,22.5 23,22.41V20.16C22.21,20.42 21.65,20.93 21.29,21.29C20.79,21.79 20.67,22 20,22C19.33,22 19.21,21.79 18.71,21.29C18.21,20.79 17.33,20 16,20C14.67,20 13.79,20.79 13.29,21.29C12.79,21.79 12.67,22 12,22C11.78,22 11.63,21.97 11.5,21.92C11.22,21.82 11.05,21.63 10.71,21.29C10.21,20.79 9.33,20 8,20Z' })
	  );
	};
	
	var OilIcon = function OilIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,12.5C22,12.5 24,14.67 24,16C24,17.1 23.1,18 22,18C20.9,18 20,17.1 20,16C20,14.67 22,12.5 22,12.5M6,6H10C10.55,6 11,6.45 11,7C11,7.55 10.55,8 10,8H9V10H11C11.74,10 12.39,10.4 12.73,11L19.24,7.24L22.5,9.13C23,9.4 23.14,10 22.87,10.5C22.59,10.97 22,11.14 21.5,10.86L19.4,9.65L15.75,15.97C15.41,16.58 14.75,17 14,17H5C3.9,17 3,16.1 3,15V12C3,10.9 3.9,10 5,10H7V8H6C5.45,8 5,7.55 5,7C5,6.45 5.45,6 6,6M5,12V15H14L16.06,11.43L12.6,13.43L11.69,12H5M0.38,9.21L2.09,7.5C2.5,7.11 3.11,7.11 3.5,7.5C3.89,7.89 3.89,8.5 3.5,8.91L1.79,10.62C1.4,11 0.77,11 0.38,10.62C0,10.23 0,9.6 0.38,9.21Z' })
	  );
	};
	
	var OmegaIcon = function OmegaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.15,19H13.39V16.87C15.5,15.25 16.59,13.24 16.59,10.84C16.59,9.34 16.16,8.16 15.32,7.29C14.47,6.42 13.37,6 12.03,6C10.68,6 9.57,6.42 8.71,7.3C7.84,8.17 7.41,9.37 7.41,10.88C7.41,13.26 8.5,15.26 10.61,16.87V19H4.85V16.87H8.41C6.04,15.32 4.85,13.23 4.85,10.6C4.85,8.5 5.5,6.86 6.81,5.66C8.12,4.45 9.84,3.85 11.97,3.85C14.15,3.85 15.89,4.45 17.19,5.64C18.5,6.83 19.15,8.5 19.15,10.58C19.15,13.21 17.95,15.31 15.55,16.87H19.15V19Z' })
	  );
	};
	
	var OnedriveIcon = function OnedriveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.08,13.64C21.17,13.81 22,14.75 22,15.89C22,16.78 21.5,17.55 20.75,17.92L20.58,18H9.18L9.16,18V18C7.71,18 6.54,16.81 6.54,15.36C6.54,13.9 7.72,12.72 9.18,12.72L9.4,12.73L9.39,12.53C9.39,10.71 10.87,9.23 12.69,9.23C13.97,9.23 15.08,9.96 15.63,11C16.08,10.73 16.62,10.55 17.21,10.55C18.8,10.55 20.09,11.84 20.09,13.43L20.08,13.64M8.82,12.16C7.21,12.34 5.96,13.7 5.96,15.36C5.96,16.04 6.17,16.66 6.5,17.18H4.73C3.22,17.18 2,15.96 2,14.45C2,13 3.12,11.83 4.53,11.73L4.46,11.06C4.46,9.36 5.84,8 7.54,8C8.17,8 8.77,8.18 9.26,8.5C9.95,7.11 11.4,6.15 13.07,6.15C15.27,6.15 17.08,7.83 17.3,9.97H17.21C16.73,9.97 16.27,10.07 15.84,10.25C15.12,9.25 13.96,8.64 12.69,8.64C10.67,8.64 9,10.19 8.82,12.16Z' })
	  );
	};
	
	var OnenoteIcon = function OnenoteIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1.96,4.8L14,3.08V5H20L21,5C21.55,5 22,5.45 22,6V10C22,10.55 21.55,11 21,11H20V19H14V21L1.96,19.21V4.8M11,16.75V8.25L9,8.5V12.75L7,8.75L5,9V16L6.5,16.25V10.75L9,16.5L11,16.75M14,14H18V13H14V14M14,11H18V10H14V11M14,8H18V7H14V8M14,16V17H18V16H14Z' })
	  );
	};
	
	var OnepasswordIcon = function OnepasswordIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1C5.92,1 1,5.92 1,12C1,18.08 5.92,23 12,23C18.08,23 23,18.08 23,12C23,5.92 18.08,1 12,1M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M13,13.5C13,14.13 13.4,14.7 14,14.91V18H10V11.91C10.78,11.64 11.19,10.8 10.93,10C10.78,9.58 10.44,9.24 10,9.09V6H14V12.09C13.4,12.3 13,12.87 13,13.5Z' })
	  );
	};
	
	var OpacityIcon = function OpacityIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.66,8L12,2.35L6.34,8C4.78,9.56 4,11.64 4,13.64C4,15.64 4.78,17.75 6.34,19.31C7.9,20.87 9.95,21.66 12,21.66C14.05,21.66 16.1,20.87 17.66,19.31C19.22,17.75 20,15.64 20,13.64C20,11.64 19.22,9.56 17.66,8M6,14C6,12 6.62,10.73 7.76,9.6L12,5.27L16.24,9.65C17.38,10.77 18,12 18,14H6Z' })
	  );
	};
	
	var OpenInAppIcon = function OpenInAppIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,10L8,14H11V20H13V14H16M19,4H5C3.89,4 3,4.9 3,6V18C3,19.1 3.9,20 5,20H9V18H5V8H19V18H15V20H19C20.1,20 21,19.1 21,18V6C21,4.9 20.1,4 19,4Z' })
	  );
	};
	
	var OpenInNewIcon = function OpenInNewIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V12H19V19Z' })
	  );
	};
	
	var OpenidIcon = function OpenidIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,2L11,3.5V19.94C7,19.5 4,17.46 4,15C4,12.75 6.5,10.85 10,10.22V8.19C4.86,8.88 1,11.66 1,15C1,18.56 5.36,21.5 11,21.94C11.03,21.94 11.06,21.94 11.09,21.94L14,20.5V2M15,8.19V10.22C16.15,10.43 17.18,10.77 18.06,11.22L16.5,12L23,13.5L22.5,9L20.5,10C19,9.12 17.12,8.47 15,8.19Z' })
	  );
	};
	
	var OperaIcon = function OperaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.04,17.07C8.04,15.9 7.4,14.16 7.35,12.21V11.79C7.4,9.84 8.04,8.1 9.04,6.93C9.86,5.95 10.93,5.37 12.1,5.37C14.72,5.37 16.84,8.34 16.84,12C16.84,15.66 14.72,18.63 12.1,18.63C10.93,18.63 10.33,18.5 9.04,17.07M12.03,3H12C7.03,3 3,7.03 3,12C3,16.83 6.8,20.77 11.57,21H12C14.3,21 16.4,20.13 18,18.71C19.84,17.06 21,14.67 21,12C21,9.33 19.84,6.94 18,5.29C16.41,3.87 14.32,3 12.03,3Z' })
	  );
	};
	
	var OrbitIcon = function OrbitIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.11,1.75C9.3,1.25 10.62,1 12,1C18.08,1 23,5.92 23,12C23,18.08 18.08,23 12,23C5.92,23 1,18.08 1,12C1,10.62 1.25,9.3 1.72,8.08C2.24,8.61 2.83,8.96 3.45,9.18C3.16,10.07 3,11 3,12C3,16.97 7.03,21 12,21C16.97,21 21,16.97 21,12C21,7.03 16.97,3 12,3C11,3 10.07,3.16 9.18,3.45C8.96,2.83 8.61,2.24 8.11,1.75M4.93,2.93C6.03,2.93 6.93,3.82 6.93,4.93C6.93,6.03 6.03,6.93 4.93,6.93C3.82,6.93 2.93,6.03 2.93,4.93C2.93,3.82 3.82,2.93 4.93,2.93M12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7Z' })
	  );
	};
	
	var OrnamentVariantIcon = function OrnamentVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1C13.66,1 15,2.34 15,4V5C15.55,5 16,5.45 16,6V7.07C18.39,8.45 20,11.04 20,14C20,18.42 16.42,22 12,22C7.58,22 4,18.42 4,14C4,11.04 5.61,8.45 8,7.07V6C8,5.45 8.45,5 9,5V4C9,2.34 10.34,1 12,1M12,3C11.45,3 11,3.45 11,4V5H13V4C13,3.45 12.55,3 12,3M12,8C10.22,8 8.63,8.77 7.53,10H16.47C15.37,8.77 13.78,8 12,8M12,20C13.78,20 15.37,19.23 16.47,18H7.53C8.63,19.23 10.22,20 12,20M12,12C10.9,12 10,12.9 10,14C10,15.1 10.9,16 12,16C13.1,16 14,15.1 14,14C14,12.9 13.1,12 12,12M18,14C18,13.31 17.88,12.65 17.67,12C16.72,12.19 16,13 16,14C16,15 16.72,15.81 17.67,15.97C17.88,15.35 18,14.69 18,14M6,14C6,14.69 6.12,15.35 6.33,15.97C7.28,15.81 8,15 8,14C8,13 7.28,12.19 6.33,12C6.12,12.65 6,13.31 6,14Z' })
	  );
	};
	
	var OrnamentIcon = function OrnamentIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1C13.66,1 15,2.34 15,4V5C15.55,5 16,5.45 16,6V7.07C18.39,8.45 20,11.04 20,14C20,18.42 16.42,22 12,22C7.58,22 4,18.42 4,14C4,11.04 5.61,8.45 8,7.07V6C8,5.45 8.45,5 9,5V4C9,2.34 10.34,1 12,1M12,3C11.45,3 11,3.45 11,4V5H13V4C13,3.45 12.55,3 12,3M12,8C10.22,8 8.63,8.77 7.53,10H16.47C15.37,8.77 13.78,8 12,8M6.34,16H7.59L6,14.43C6.05,15 6.17,15.5 6.34,16M12.59,16L8.59,12H6.41L10.41,16H12.59M17.66,12H16.41L18,13.57C17.95,13 17.83,12.5 17.66,12M11.41,12L15.41,16H17.59L13.59,12H11.41M12,20C13.78,20 15.37,19.23 16.47,18H7.53C8.63,19.23 10.22,20 12,20Z' })
	  );
	};
	
	var OwlIcon = function OwlIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,16C12.56,16.84 13.31,17.53 14.2,18L12,20.2L9.8,18C10.69,17.53 11.45,16.84 12,16M17,11.2C15.9,11.2 15,12.1 15,13.2C15,14.3 15.9,15.2 17,15.2C18.1,15.2 19,14.3 19,13.2C19,12.09 18.1,11.2 17,11.2M7,11.2C5.9,11.2 5,12.1 5,13.2C5,14.3 5.9,15.2 7,15.2C8.1,15.2 9,14.3 9,13.2C9,12.09 8.1,11.2 7,11.2M17,8.7C19.21,8.7 21,10.49 21,12.7C21,14.91 19.21,16.7 17,16.7C14.79,16.7 13,14.91 13,12.7C13,10.49 14.79,8.7 17,8.7M7,8.7C9.21,8.7 11,10.49 11,12.7C11,14.91 9.21,16.7 7,16.7C4.79,16.7 3,14.91 3,12.7C3,10.49 4.79,8.7 7,8.7M2.24,1C4,4.7 2.73,7.46 1.55,10.2C1.19,11 1,11.83 1,12.7C1,16.01 3.69,18.7 7,18.7C7.21,18.69 7.42,18.68 7.63,18.65L10.59,21.61L12,23L13.41,21.61L16.37,18.65C16.58,18.68 16.79,18.69 17,18.7C20.31,18.7 23,16.01 23,12.7C23,11.83 22.81,11 22.45,10.2C21.27,7.46 20,4.7 21.76,1C19.12,3.06 15.36,4.69 12,4.7C8.64,4.69 4.88,3.06 2.24,1Z' })
	  );
	};
	
	var PackageDownIcon = function PackageDownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.12,5L5.93,4H17.93L18.87,5M12,17.5L6.5,12H10V10H14V12H17.5L12,17.5M20.54,5.23L19.15,3.55C18.88,3.21 18.47,3 18,3H6C5.53,3 5.12,3.21 4.84,3.55L3.46,5.23C3.17,5.57 3,6 3,6.5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V6.5C21,6 20.83,5.57 20.54,5.23Z' })
	  );
	};
	
	var PackageUpIcon = function PackageUpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.54,5.23C20.83,5.57 21,6 21,6.5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V6.5C3,6 3.17,5.57 3.46,5.23L4.84,3.55C5.12,3.21 5.53,3 6,3H18C18.47,3 18.88,3.21 19.15,3.55L20.54,5.23M5.12,5H18.87L17.93,4H5.93L5.12,5M12,9.5L6.5,15H10V17H14V15H17.5L12,9.5Z' })
	  );
	};
	
	var PackageVariantClosedIcon = function PackageVariantClosedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L10.11,5.22L16,8.61L17.96,7.5L12,4.15M6.04,7.5L12,10.85L13.96,9.75L8.08,6.35L6.04,7.5M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V9.21L13,12.58V19.29L19,15.91Z' })
	  );
	};
	
	var PackageVariantIcon = function PackageVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,10.96C1.5,10.68 1.35,10.07 1.63,9.59L3.13,7C3.24,6.8 3.41,6.66 3.6,6.58L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.66,6.72 20.82,6.88 20.91,7.08L22.36,9.6C22.64,10.08 22.47,10.69 22,10.96L21,11.54V16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V10.96C2.7,11.13 2.32,11.14 2,10.96M12,4.15V4.15L12,10.85V10.85L17.96,7.5L12,4.15M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V12.69L14,15.59C13.67,15.77 13.3,15.76 13,15.6V19.29L19,15.91M13.85,13.36L20.13,9.73L19.55,8.72L13.27,12.35L13.85,13.36Z' })
	  );
	};
	
	var PackageIcon = function PackageIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.12,5H18.87L17.93,4H5.93L5.12,5M20.54,5.23C20.83,5.57 21,6 21,6.5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V6.5C3,6 3.17,5.57 3.46,5.23L4.84,3.55C5.12,3.21 5.53,3 6,3H18C18.47,3 18.88,3.21 19.15,3.55L20.54,5.23M6,18H12V15H6V18Z' })
	  );
	};
	
	var PageFirstIcon = function PageFirstIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.41,16.59L13.82,12L18.41,7.41L17,6L11,12L17,18L18.41,16.59M6,6H8V18H6V6Z' })
	  );
	};
	
	var PageLastIcon = function PageLastIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.59,7.41L10.18,12L5.59,16.59L7,18L13,12L7,6L5.59,7.41M16,6H18V18H16V6Z' })
	  );
	};
	
	var PageLayoutBodyIcon = function PageLayoutBodyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M6,8V16H18V8H6Z' })
	  );
	};
	
	var PageLayoutFooterIcon = function PageLayoutFooterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M6,16V20H18V16H6Z' })
	  );
	};
	
	var PageLayoutHeaderIcon = function PageLayoutHeaderIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M6,4V8H18V4H6Z' })
	  );
	};
	
	var PageLayoutSidebarLeftIcon = function PageLayoutSidebarLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M6,8V16H10V8H6Z' })
	  );
	};
	
	var PageLayoutSidebarRightIcon = function PageLayoutSidebarRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M14,8V16H18V8H14Z' })
	  );
	};
	
	var PaletteAdvancedIcon = function PaletteAdvancedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,22H10V20H22V22M2,22V20H9V22H2M18,18V10H22V18H18M18,3H22V9H18V3M2,18V3H16V18H2M9,14.56C10.66,14.56 12,13.22 12,11.56C12,9.56 9,6.19 9,6.19C9,6.19 6,9.56 6,11.56C6,13.22 7.34,14.56 9,14.56Z' })
	  );
	};
	
	var PaletteSwatchIcon = function PaletteSwatchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.53,19.65L3.87,20.21V11.18L1.44,17.04C1.03,18.06 1.5,19.23 2.53,19.65M22.03,15.95L17.07,4C16.76,3.23 16.03,2.77 15.26,2.75C15,2.75 14.73,2.79 14.47,2.9L7.1,5.95C6.35,6.26 5.89,7 5.87,7.75C5.86,8 5.91,8.29 6,8.55L11,20.5C11.29,21.28 12.03,21.74 12.81,21.75C13.07,21.75 13.33,21.7 13.58,21.6L20.94,18.55C21.96,18.13 22.45,16.96 22.03,15.95M7.88,8.75C7.33,8.75 6.88,8.3 6.88,7.75C6.88,7.2 7.33,6.75 7.88,6.75C8.43,6.75 8.88,7.2 8.88,7.75C8.88,8.3 8.43,8.75 7.88,8.75M5.88,19.75C5.88,20.85 6.78,21.75 7.88,21.75H9.33L5.88,13.41V19.75Z' })
	  );
	};
	
	var PaletteIcon = function PaletteIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.5,12C16.67,12 16,11.33 16,10.5C16,9.67 16.67,9 17.5,9C18.33,9 19,9.67 19,10.5C19,11.33 18.33,12 17.5,12M14.5,8C13.67,8 13,7.33 13,6.5C13,5.67 13.67,5 14.5,5C15.33,5 16,5.67 16,6.5C16,7.33 15.33,8 14.5,8M9.5,8C8.67,8 8,7.33 8,6.5C8,5.67 8.67,5 9.5,5C10.33,5 11,5.67 11,6.5C11,7.33 10.33,8 9.5,8M6.5,12C5.67,12 5,11.33 5,10.5C5,9.67 5.67,9 6.5,9C7.33,9 8,9.67 8,10.5C8,11.33 7.33,12 6.5,12M12,3C7.03,3 3,7.03 3,12C3,16.97 7.03,21 12,21C12.83,21 13.5,20.33 13.5,19.5C13.5,19.11 13.35,18.76 13.11,18.5C12.88,18.23 12.73,17.88 12.73,17.5C12.73,16.67 13.4,16 14.23,16H16C18.76,16 21,13.76 21,11C21,6.58 16.97,3 12,3Z' })
	  );
	};
	
	var PandaIcon = function PandaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C13.74,3 15.36,3.5 16.74,4.35C17.38,3.53 18.38,3 19.5,3C21.43,3 23,4.57 23,6.5C23,8 22.05,9.28 20.72,9.78C20.9,10.5 21,11.23 21,12C21,16.97 16.97,21 12,21C7.03,21 3,16.97 3,12C3,11.23 3.1,10.5 3.28,9.78C1.95,9.28 1,8 1,6.5C1,4.57 2.57,3 4.5,3C5.62,3 6.62,3.53 7.26,4.35C8.64,3.5 10.26,3 12,3M12,5C8.13,5 5,8.13 5,12C5,15.87 8.13,19 12,19C15.87,19 19,15.87 19,12C19,8.13 15.87,5 12,5M16.19,10.3C16.55,11.63 16.08,12.91 15.15,13.16C14.21,13.42 13.17,12.54 12.81,11.2C12.45,9.87 12.92,8.59 13.85,8.34C14.79,8.09 15.83,8.96 16.19,10.3M7.81,10.3C8.17,8.96 9.21,8.09 10.15,8.34C11.08,8.59 11.55,9.87 11.19,11.2C10.83,12.54 9.79,13.42 8.85,13.16C7.92,12.91 7.45,11.63 7.81,10.3M12,14C12.6,14 13.13,14.19 13.5,14.5L12.5,15.5C12.5,15.92 12.84,16.25 13.25,16.25C13.66,16.25 14,15.91 14,15.5C14,15.22 14.22,15 14.5,15C14.78,15 15,15.22 15,15.5C15,16.47 14.22,17.25 13.25,17.25C12.76,17.25 12.32,17.05 12,16.72C11.68,17.05 11.24,17.25 10.75,17.25C9.78,17.25 9,16.47 9,15.5C9,15.22 9.22,15 9.5,15C9.78,15 10,15.22 10,15.5C10,15.91 10.34,16.25 10.75,16.25C11.16,16.25 11.5,15.91 11.5,15.5L10.5,14.5C10.87,14.19 11.4,14 12,14Z' })
	  );
	};
	
	var PandoraIcon = function PandoraIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,20C10,20.55 9.55,21 9,21H4V3H13.71C17.44,3 20.46,6.02 20.46,9.75C20.46,13.5 17.44,16.5 13.71,16.5H10V20Z' })
	  );
	};
	
	var PanoramaFisheyeIcon = function PanoramaFisheyeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2Z' })
	  );
	};
	
	var PanoramaHorizontalIcon = function PanoramaHorizontalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.43,4C21.33,4 21.23,4 21.12,4.06C18.18,5.16 15.09,5.7 12,5.7C8.91,5.7 5.82,5.15 2.88,4.06C2.77,4 2.66,4 2.57,4C2.23,4 2,4.23 2,4.63V19.38C2,19.77 2.23,20 2.57,20C2.67,20 2.77,20 2.88,19.94C5.82,18.84 8.91,18.3 12,18.3C15.09,18.3 18.18,18.85 21.12,19.94C21.23,20 21.33,20 21.43,20C21.76,20 22,19.77 22,19.37V4.63C22,4.23 21.76,4 21.43,4M20,6.54V17.45C17.4,16.68 14.72,16.29 12,16.29C9.28,16.29 6.6,16.68 4,17.45V6.54C6.6,7.31 9.28,7.7 12,7.7C14.72,7.71 17.4,7.32 20,6.54Z' })
	  );
	};
	
	var PanoramaVerticalIcon = function PanoramaVerticalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.54,20C7.31,17.4 7.7,14.72 7.7,12C7.7,9.28 7.31,6.6 6.54,4H17.45C16.68,6.6 16.29,9.28 16.29,12C16.29,14.72 16.68,17.4 17.45,20M19.94,21.12C18.84,18.18 18.3,15.09 18.3,12C18.3,8.91 18.85,5.82 19.94,2.88C20,2.77 20,2.66 20,2.57C20,2.23 19.77,2 19.37,2H4.63C4.23,2 4,2.23 4,2.57C4,2.67 4,2.77 4.06,2.88C5.16,5.82 5.71,8.91 5.71,12C5.71,15.09 5.16,18.18 4.07,21.12C4,21.23 4,21.34 4,21.43C4,21.76 4.23,22 4.63,22H19.38C19.77,22 20,21.76 20,21.43C20,21.33 20,21.23 19.94,21.12Z' })
	  );
	};
	
	var PanoramaWideAngleIcon = function PanoramaWideAngleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,4C9.27,4 6.78,4.24 4.05,4.72L3.12,4.88L2.87,5.78C2.29,7.85 2,9.93 2,12C2,14.07 2.29,16.15 2.87,18.22L3.12,19.11L4.05,19.27C6.78,19.76 9.27,20 12,20C14.73,20 17.22,19.76 19.95,19.28L20.88,19.12L21.13,18.23C21.71,16.15 22,14.07 22,12C22,9.93 21.71,7.85 21.13,5.78L20.88,4.89L19.95,4.73C17.22,4.24 14.73,4 12,4M12,6C14.45,6 16.71,6.2 19.29,6.64C19.76,8.42 20,10.22 20,12C20,13.78 19.76,15.58 19.29,17.36C16.71,17.8 14.45,18 12,18C9.55,18 7.29,17.8 4.71,17.36C4.24,15.58 4,13.78 4,12C4,10.22 4.24,8.42 4.71,6.64C7.29,6.2 9.55,6 12,6Z' })
	  );
	};
	
	var PanoramaIcon = function PanoramaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.5,12.5L11,15.5L14.5,11L19,17H5M23,18V6C23,4.9 22.1,4 21,4H3C1.9,4 1,4.9 1,6V18C1,19.1 1.9,20 3,20H21C22.1,20 23,19.1 23,18Z' })
	  );
	};
	
	var PaperCutVerticalIcon = function PaperCutVerticalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.43,3.23L12,4L12.57,3.23V3.24C13.12,2.5 14,2 15,2C16.66,2 18,3.34 18,5C18,5.35 17.94,5.69 17.83,6H20C21.1,6 22,6.9 22,8V20C22,21.1 21.1,22 20,22H4C2.9,22 2,21.1 2,20V8C2,6.9 2.9,6 4,6H6.17C6.06,5.69 6,5.35 6,5C6,3.34 7.34,2 9,2C10,2 10.88,2.5 11.43,3.24V3.23M4,8V20H11C11,19.45 11.45,19 12,19C12.55,19 13,19.45 13,20H20V8H15L14.9,8L17,10.92L15.4,12.1L12.42,8H11.58L8.6,12.1L7,10.92L9.1,8H9L4,8M9,4C8.45,4 8,4.45 8,5C8,5.55 8.45,6 9,6C9.55,6 10,5.55 10,5C10,4.45 9.55,4 9,4M15,4C14.45,4 14,4.45 14,5C14,5.55 14.45,6 15,6C15.55,6 16,5.55 16,5C16,4.45 15.55,4 15,4M12,16C12.55,16 13,16.45 13,17C13,17.55 12.55,18 12,18C11.45,18 11,17.55 11,17C11,16.45 11.45,16 12,16M12,13C12.55,13 13,13.45 13,14C13,14.55 12.55,15 12,15C11.45,15 11,14.55 11,14C11,13.45 11.45,13 12,13M12,10C12.55,10 13,10.45 13,11C13,11.55 12.55,12 12,12C11.45,12 11,11.55 11,11C11,10.45 11.45,10 12,10Z' })
	  );
	};
	
	var PaperclipIcon = function PaperclipIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.5,6V17.5C16.5,19.71 14.71,21.5 12.5,21.5C10.29,21.5 8.5,19.71 8.5,17.5V5C8.5,3.62 9.62,2.5 11,2.5C12.38,2.5 13.5,3.62 13.5,5V15.5C13.5,16.05 13.05,16.5 12.5,16.5C11.95,16.5 11.5,16.05 11.5,15.5V6H10V15.5C10,16.88 11.12,18 12.5,18C13.88,18 15,16.88 15,15.5V5C15,2.79 13.21,1 11,1C8.79,1 7,2.79 7,5V17.5C7,20.54 9.46,23 12.5,23C15.54,23 18,20.54 18,17.5V6H16.5Z' })
	  );
	};
	
	var ParkingIcon = function ParkingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.2,11H10V7H13.2C14.3,7 15.2,7.9 15.2,9C15.2,10.1 14.3,11 13.2,11M13,3H6V21H10V15H13C16.31,15 19,12.31 19,9C19,5.68 16.31,3 13,3Z' })
	  );
	};
	
	var PassportIcon = function PassportIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2C4.9,2 4,2.9 4,4V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V4C20,2.9 19.1,2 18,2H6M12,5C14.76,5 17,7.24 17,10C17,12.76 14.76,15 12,15C9.24,15 7,12.76 7,10C7,7.24 9.24,5 12,5M12,6C11.59,6.62 11.25,7.29 11.04,8H12.96C12.75,7.29 12.42,6.62 12,6M10.7,6.22C9.78,6.53 9,7.17 8.54,8H10C10.18,7.38 10.4,6.78 10.7,6.22M13.29,6.22C13.59,6.78 13.82,7.38 14,8H15.46C15,7.17 14.21,6.54 13.29,6.22M8.13,9C8.05,9.32 8,9.65 8,10C8,10.35 8.05,10.68 8.13,11H9.82C9.78,10.67 9.75,10.34 9.75,10C9.75,9.66 9.78,9.33 9.82,9H8.13M10.83,9C10.78,9.32 10.75,9.66 10.75,10C10.75,10.34 10.78,10.67 10.83,11H13.17C13.21,10.67 13.25,10.34 13.25,10C13.25,9.66 13.21,9.32 13.17,9H10.83M14.18,9C14.22,9.33 14.25,9.66 14.25,10C14.25,10.34 14.22,10.67 14.18,11H15.87C15.95,10.68 16,10.35 16,10C16,9.65 15.95,9.32 15.87,9H14.18M8.54,12C9,12.83 9.78,13.46 10.7,13.78C10.4,13.22 10.18,12.63 10,12H8.54M11.04,12C11.25,12.72 11.59,13.38 12,14C12.42,13.38 12.75,12.72 12.96,12H11.04M14,12C13.82,12.63 13.59,13.22 13.29,13.78C14.21,13.46 15,12.83 15.46,12H14M7,17H17V19H7V17Z' })
	  );
	};
	
	var PatreonIcon = function PatreonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.73,3C18.45,3 21.47,6.03 21.47,9.76C21.47,13.47 18.45,16.5 14.73,16.5C11,16.5 7.97,13.47 7.97,9.76C7.97,6.03 11,3 14.73,3M2.7,21V3H6V21H2.7Z' })
	  );
	};
	
	var PauseCircleOutlineIcon = function PauseCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,16V8H15V16H13M9,16V8H11V16H9M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4Z' })
	  );
	};
	
	var PauseCircleIcon = function PauseCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,16H13V8H15M11,16H9V8H11M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var PauseOctagonOutlineIcon = function PauseOctagonOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,16H13V8H15V16M11,16H9V8H11V16M15.73,3L21,8.27V15.73L15.73,21H8.27L3,15.73V8.27L8.27,3H15.73M14.9,5H9.1L5,9.1V14.9L9.1,19H14.9L19,14.9V9.1L14.9,5Z' })
	  );
	};
	
	var PauseOctagonIcon = function PauseOctagonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.73,3L21,8.27V15.73L15.73,21H8.27L3,15.73V8.27L8.27,3H15.73M15,16V8H13V16H15M11,16V8H9V16H11Z' })
	  );
	};
	
	var PauseIcon = function PauseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,19H18V5H14M6,19H10V5H6V19Z' })
	  );
	};
	
	var PawOffIcon = function PawOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,4.27L3.28,3L21.5,21.22L20.23,22.5L18.23,20.5C18.09,20.6 17.94,20.68 17.79,20.75C16,21.57 13.88,19.87 11.89,19.87C9.9,19.87 7.76,21.64 6,20.75C5,20.26 4.31,18.96 4.44,17.88C4.62,16.39 6.41,15.59 7.47,14.5C8.21,13.77 8.84,12.69 9.55,11.82L2,4.27M8.35,3C9.53,2.83 10.78,4.12 11.14,5.9C11.32,6.75 11.26,7.56 11,8.19L7.03,4.2C7.29,3.55 7.75,3.1 8.35,3M15.5,3C16.69,3.19 17.35,4.77 17,6.54C16.62,8.32 15.37,9.61 14.19,9.43C13,9.25 12.35,7.67 12.72,5.9C13.08,4.12 14.33,2.83 15.5,3M3,7.6C4.14,7.11 5.69,8 6.5,9.55C7.26,11.13 7,12.79 5.87,13.28C4.74,13.77 3.2,12.89 2.41,11.32C1.62,9.75 1.9,8.08 3,7.6M21,7.6C22.1,8.08 22.38,9.75 21.59,11.32C20.8,12.89 19.26,13.77 18.13,13.28C17,12.79 16.74,11.13 17.5,9.55C18.31,8 19.86,7.11 21,7.6Z' })
	  );
	};
	
	var PawIcon = function PawIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.35,3C9.53,2.83 10.78,4.12 11.14,5.9C11.5,7.67 10.85,9.25 9.67,9.43C8.5,9.61 7.24,8.32 6.87,6.54C6.5,4.77 7.17,3.19 8.35,3M15.5,3C16.69,3.19 17.35,4.77 17,6.54C16.62,8.32 15.37,9.61 14.19,9.43C13,9.25 12.35,7.67 12.72,5.9C13.08,4.12 14.33,2.83 15.5,3M3,7.6C4.14,7.11 5.69,8 6.5,9.55C7.26,11.13 7,12.79 5.87,13.28C4.74,13.77 3.2,12.89 2.41,11.32C1.62,9.75 1.9,8.08 3,7.6M21,7.6C22.1,8.08 22.38,9.75 21.59,11.32C20.8,12.89 19.26,13.77 18.13,13.28C17,12.79 16.74,11.13 17.5,9.55C18.31,8 19.86,7.11 21,7.6M19.33,18.38C19.37,19.32 18.65,20.36 17.79,20.75C16,21.57 13.88,19.87 11.89,19.87C9.9,19.87 7.76,21.64 6,20.75C5,20.26 4.31,18.96 4.44,17.88C4.62,16.39 6.41,15.59 7.47,14.5C8.88,13.09 9.88,10.44 11.89,10.44C13.89,10.44 14.95,13.05 16.3,14.5C17.41,15.72 19.26,16.75 19.33,18.38Z' })
	  );
	};
	
	var PaypalIcon = function PaypalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.32,21.97C8.21,21.92 8.08,21.76 8.06,21.65C8.03,21.5 8,21.76 8.66,17.56C9.26,13.76 9.25,13.82 9.33,13.71C9.46,13.54 9.44,13.54 10.94,13.53C12.26,13.5 12.54,13.5 13.13,13.41C16.38,12.96 18.39,11.05 19.09,7.75C19.13,7.53 19.17,7.34 19.18,7.34C19.18,7.33 19.25,7.38 19.33,7.44C20.36,8.22 20.71,9.66 20.32,11.58C19.86,13.87 18.64,15.39 16.74,16.04C15.93,16.32 15.25,16.43 14.05,16.46C13.25,16.5 13.23,16.5 13,16.65C12.83,16.82 12.84,16.79 12.45,19.2C12.18,20.9 12.08,21.45 12.04,21.55C11.97,21.71 11.83,21.85 11.67,21.93L11.56,22H10C8.71,22 8.38,22 8.32,21.97V21.97M3.82,19.74C3.63,19.64 3.5,19.47 3.5,19.27C3.5,19 6.11,2.68 6.18,2.5C6.27,2.32 6.5,2.13 6.68,2.06L6.83,2H10.36C14.27,2 14.12,2 15,2.2C17.62,2.75 18.82,4.5 18.37,7.13C17.87,10.06 16.39,11.8 13.87,12.43C13,12.64 12.39,12.7 10.73,12.7C9.42,12.7 9.32,12.71 9.06,12.85C8.8,13 8.59,13.27 8.5,13.6C8.46,13.67 8.23,15.07 7.97,16.7C7.71,18.33 7.5,19.69 7.5,19.72L7.47,19.78H5.69C4.11,19.78 3.89,19.78 3.82,19.74V19.74Z' })
	  );
	};
	
	var PeaceIcon = function PeaceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M11,14.41V19.93C9.58,19.75 8.23,19.19 7.1,18.31L11,14.41M13,14.41L16.9,18.31C15.77,19.19 14.42,19.75 13,19.93V14.41M4,12C4,7.97 7,4.57 11,4.07V11.59L5.69,16.9C4.59,15.5 4,13.78 4,12M18.31,16.9L13,11.59V4.07C17,4.57 20,7.97 20,12C20,13.78 19.41,15.5 18.31,16.9Z' })
	  );
	};
	
	var PenIcon = function PenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.71,7.04C20.37,7.38 20.04,7.71 20.03,8.04C20,8.36 20.34,8.69 20.66,9C21.14,9.5 21.61,9.95 21.59,10.44C21.57,10.93 21.06,11.44 20.55,11.94L16.42,16.08L15,14.66L19.25,10.42L18.29,9.46L16.87,10.87L13.12,7.12L16.96,3.29C17.35,2.9 18,2.9 18.37,3.29L20.71,5.63C21.1,6 21.1,6.65 20.71,7.04M3,17.25L12.56,7.68L16.31,11.43L6.75,21H3V17.25Z' })
	  );
	};
	
	var PencilBoxOutlineIcon = function PencilBoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19V5H5V19H19M19,3C20.1,3 21,3.9 21,5V19C21,20.11 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M16.7,9.35L15.7,10.35L13.65,8.3L14.65,7.3C14.86,7.08 15.21,7.08 15.42,7.3L16.7,8.58C16.92,8.79 16.92,9.14 16.7,9.35M7,14.94L13.06,8.88L15.12,10.94L9.06,17H7V14.94Z' })
	  );
	};
	
	var PencilBoxIcon = function PencilBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3C20.1,3 21,3.9 21,5V19C21,20.11 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M16.7,9.35C16.92,9.14 16.92,8.79 16.7,8.58L15.42,7.3C15.21,7.08 14.86,7.08 14.65,7.3L13.65,8.3L15.7,10.35L16.7,9.35M7,14.94V17H9.06L15.12,10.94L13.06,8.88L7,14.94Z' })
	  );
	};
	
	var PencilCircleOutlineIcon = function PencilCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,14.94L13.06,8.88L15.12,10.94L9.06,17H7V14.94M12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20M16.7,9.35L15.7,10.35L13.65,8.3L14.65,7.3C14.86,7.08 15.21,7.08 15.42,7.3L16.7,8.58C16.92,8.79 16.92,9.14 16.7,9.35M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2' })
	  );
	};
	
	var PencilCircleIcon = function PencilCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2M15.1,7.07C15.24,7.07 15.38,7.12 15.5,7.23L16.77,8.5C17,8.72 17,9.07 16.77,9.28L15.77,10.28L13.72,8.23L14.72,7.23C14.82,7.12 14.96,7.07 15.1,7.07M13.13,8.81L15.19,10.87L9.13,16.93H7.07V14.87L13.13,8.81Z' })
	  );
	};
	
	var PencilLockIcon = function PencilLockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.5,2C4.12,2 3,3.12 3,4.5V5C2.45,5 2,5.45 2,6V10C2,10.55 2.45,11 3,11H8C8.55,11 9,10.55 9,10V6C9,5.45 8.55,5 8,5V4.5C8,3.12 6.88,2 5.5,2M5.5,3C6.33,3 7,3.67 7,4.5V5H4V4.5C4,3.67 4.67,3 5.5,3M19.66,3C19.4,3 19.16,3.09 18.97,3.28L17.13,5.13L20.88,8.88L22.72,7.03C23.11,6.64 23.11,6 22.72,5.63L20.38,3.28C20.18,3.09 19.91,3 19.66,3M16.06,6.19L5,17.25V21H8.75L19.81,9.94L16.06,6.19Z' })
	  );
	};
	
	var PencilOffIcon = function PencilOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.66,2C18.4,2 18.16,2.09 17.97,2.28L16.13,4.13L19.88,7.88L21.72,6.03C22.11,5.64 22.11,5 21.72,4.63L19.38,2.28C19.18,2.09 18.91,2 18.66,2M3.28,4L2,5.28L8.5,11.75L4,16.25V20H7.75L12.25,15.5L18.72,22L20,20.72L13.5,14.25L9.75,10.5L3.28,4M15.06,5.19L11.03,9.22L14.78,12.97L18.81,8.94L15.06,5.19Z' })
	  );
	};
	
	var PencilIcon = function PencilIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z' })
	  );
	};
	
	var PentagonOutlineIcon = function PentagonOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,5L19.6,10.5L16.7,19.4H7.3L4.4,10.5L12,5M12,2.5L2,9.8L5.8,21.5H18.1L22,9.8L12,2.5Z' })
	  );
	};
	
	var PentagonIcon = function PentagonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2.5L2,9.8L5.8,21.5H18.2L22,9.8L12,2.5Z' })
	  );
	};
	
	var PercentIcon = function PercentIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.5,3.5L3.5,18.5L5.5,20.5L20.5,5.5M7,4C5.34,4 4,5.34 4,7C4,8.66 5.34,10 7,10C8.66,10 10,8.66 10,7C10,5.34 8.66,4 7,4M17,14C15.34,14 14,15.34 14,17C14,18.66 15.34,20 17,20C18.66,20 20,18.66 20,17C20,15.34 18.66,14 17,14Z' })
	  );
	};
	
	var PeriodicTableCo2Icon = function PeriodicTableCo2Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,7C3.9,7 3,7.9 3,9V15C3,16.1 3.9,17 5,17H8V15H5V9H8V7H5M11,7C9.9,7 9,7.9 9,9V15C9,16.1 9.9,17 11,17H13C14.1,17 15,16.1 15,15V9C15,7.9 14.1,7 13,7H11M11,9H13V15H11V9M16,10.5V12H19V13.5H17.5C16.67,13.5 16,14.17 16,15V18H20.5V16.5H17.5V15H19C19.83,15 20.5,14.33 20.5,13.5V12C20.5,11.17 19.83,10.5 19,10.5H16Z' })
	  );
	};
	
	var PeriodicTableIcon = function PeriodicTableIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,4V6H4V4H2M20,4V6H22V4H20M2,7V9H4V7H2M5,7V9H7V7H5M14,7V9H16V7H14M17,7V9H19V7H17M20,7V9H22V7H20M2,10V12H4V10H2M5,10V12H7V10H5M8,10V12H10V10H8M11,10V12H13V10H11M14,10V12H16V10H14M17,10V12H19V10H17M20,10V12H22V10H20M2,13V15H4V13H2M5,13V15H7V13H5M8,13V15H10V13H8M11,13V15H13V13H11M14,13V15H16V13H14M17,13V15H19V13H17M20,13V15H22V13H20M5,17V19H7V17H5M8,17V19H10V17H8M11,17V19H13V17H11M14,17V19H16V17H14M17,17V19H19V17H17Z' })
	  );
	};
	
	var PeriscopeIcon = function PeriscopeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,7C12,8.1 11.1,9 10,9C8.9,9 8,8.1 8,7C7.37,7.84 7,8.87 7,10C7,12.76 9.24,15 12,15C14.76,15 17,12.76 17,10C17,7.24 14.76,5 12,5C11.57,5 11.16,5.05 10.77,5.15C11.5,5.45 12,6.17 12,7M12,2C16.42,2 20,5.58 20,10C20,11.05 19.8,12.04 19.43,12.96C17.89,17.38 13.63,22 12,22C10.37,22 6.11,17.38 4.57,12.96C4.2,12.04 4,11.05 4,10C4,5.58 7.58,2 12,2Z' })
	  );
	};
	
	var PharmacyIcon = function PharmacyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,14H13V17H11V14H8V12H11V9H13V12H16M21,5H18.35L19.5,1.85L17.15,1L15.69,5H3V7L5,13L3,19V21H21V19L19,13L21,7V5Z' })
	  );
	};
	
	var PhoneBluetoothIcon = function PhoneBluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4C8.5,3.45 8.05,3 7.5,3H4C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5M18,7.21L18.94,8.14L18,9.08M18,2.91L18.94,3.85L18,4.79M14.71,9.5L17,7.21V11H17.5L20.35,8.14L18.21,6L20.35,3.85L17.5,1H17V4.79L14.71,2.5L14,3.21L16.79,6L14,8.79L14.71,9.5Z' })
	  );
	};
	
	var PhoneClassicIcon = function PhoneClassicIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.46,3 3.34,4.78 0.29,7.67C0.11,7.85 0,8.1 0,8.38C0,8.66 0.11,8.91 0.29,9.09L2.77,11.57C2.95,11.75 3.2,11.86 3.5,11.86C3.75,11.86 4,11.75 4.18,11.58C4.97,10.84 5.87,10.22 6.84,9.73C7.17,9.57 7.4,9.23 7.4,8.83V5.73C8.85,5.25 10.39,5 12,5C13.59,5 15.14,5.25 16.59,5.72V8.82C16.59,9.21 16.82,9.56 17.15,9.72C18.13,10.21 19,10.84 19.82,11.57C20,11.75 20.25,11.85 20.5,11.85C20.8,11.85 21.05,11.74 21.23,11.56L23.71,9.08C23.89,8.9 24,8.65 24,8.37C24,8.09 23.88,7.85 23.7,7.67C20.65,4.78 16.53,3 12,3M9,7V10C9,10 3,15 3,18V22H21V18C21,15 15,10 15,10V7H13V9H11V7H9M12,12C14.21,12 16,13.79 16,16C16,18.21 14.21,20 12,20C9.79,20 8,18.21 8,16C8,13.79 9.79,12 12,12M12,13.5C10.62,13.5 9.5,14.62 9.5,16C9.5,17.38 10.62,18.5 12,18.5C13.38,18.5 14.5,17.38 14.5,16C14.5,14.62 13.38,13.5 12,13.5Z' })
	  );
	};
	
	var PhoneForwardIcon = function PhoneForwardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4C8.5,3.45 8.05,3 7.5,3H4C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5M18,11L23,6L18,1V4H14V8H18V11Z' })
	  );
	};
	
	var PhoneHangupIcon = function PhoneHangupIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,9C10.4,9 8.85,9.25 7.4,9.72V12.82C7.4,13.22 7.17,13.56 6.84,13.72C5.86,14.21 4.97,14.84 4.17,15.57C4,15.75 3.75,15.86 3.5,15.86C3.2,15.86 2.95,15.74 2.77,15.56L0.29,13.08C0.11,12.9 0,12.65 0,12.38C0,12.1 0.11,11.85 0.29,11.67C3.34,8.77 7.46,7 12,7C16.54,7 20.66,8.77 23.71,11.67C23.89,11.85 24,12.1 24,12.38C24,12.65 23.89,12.9 23.71,13.08L21.23,15.56C21.05,15.74 20.8,15.86 20.5,15.86C20.25,15.86 20,15.75 19.82,15.57C19.03,14.84 18.14,14.21 17.16,13.72C16.83,13.56 16.6,13.22 16.6,12.82V9.72C15.15,9.25 13.6,9 12,9Z' })
	  );
	};
	
	var PhoneInTalkIcon = function PhoneInTalkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,12H17C17,9.24 14.76,7 12,7V9C13.66,9 15,10.34 15,12M19,12H21C21,7 16.97,3 12,3V5C15.86,5 19,8.13 19,12M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4C8.5,3.45 8.05,3 7.5,3H4C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5Z' })
	  );
	};
	
	var PhoneIncomingIcon = function PhoneIncomingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,3C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.17L13.21,17.37C10.38,15.93 8.06,13.62 6.62,10.78L8.82,8.57C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4C8.5,3.45 8.05,3 7.5,3H4M19,11V9.5H15.5L21,4L20,3L14.5,8.5V5H13V11H19Z' })
	  );
	};
	
	var PhoneLockedIcon = function PhoneLockedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.2,4H15.8V3.5C15.8,2.56 16.56,1.8 17.5,1.8C18.44,1.8 19.2,2.56 19.2,3.5M20,4V3.5C20,2.12 18.88,1 17.5,1C16.12,1 15,2.12 15,3.5V4C14.45,4 14,4.45 14,5V9C14,9.55 14.45,10 15,10H20C20.55,10 21,9.55 21,9V5C21,4.45 20.55,4 20,4M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4C8.5,3.45 8.05,3 7.5,3H4C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5Z' })
	  );
	};
	
	var PhoneLogIcon = function PhoneLogIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,15.5C20.55,15.5 21,15.95 21,16.5V20C21,20.55 20.55,21 20,21C10.61,21 3,13.39 3,4C3,3.45 3.45,3 4,3H7.5C8.05,3 8.5,3.45 8.5,4C8.5,5.24 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.58L6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5M12,3H14V5H12M15,3H21V5H15M12,6H14V8H12M15,6H21V8H15M12,9H14V11H12M15,9H21V11H15' })
	  );
	};
	
	var PhoneMinusIcon = function PhoneMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,3C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5C18.76,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.07,13.62 6.62,10.79L8.82,8.58C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.24 8.5,4C8.5,3.45 8.05,3 7.5,3M13,6V8H21V6' })
	  );
	};
	
	var PhoneMissedIcon = function PhoneMissedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23.71,16.67C20.66,13.77 16.54,12 12,12C7.46,12 3.34,13.77 0.29,16.67C0.11,16.85 0,17.1 0,17.38C0,17.65 0.11,17.9 0.29,18.08L2.77,20.56C2.95,20.74 3.2,20.86 3.5,20.86C3.75,20.86 4,20.75 4.18,20.57C4.97,19.83 5.86,19.21 6.84,18.72C7.17,18.56 7.4,18.22 7.4,17.82V14.72C8.85,14.25 10.39,14 12,14C13.6,14 15.15,14.25 16.6,14.72V17.82C16.6,18.22 16.83,18.56 17.16,18.72C18.14,19.21 19.03,19.83 19.82,20.57C20,20.75 20.25,20.86 20.5,20.86C20.8,20.86 21.05,20.74 21.23,20.56L23.71,18.08C23.89,17.9 24,17.65 24,17.38C24,17.1 23.89,16.85 23.71,16.67M6.5,5.5L12,11L19,4L18,3L12,9L7.5,4.5H11V3H5V9H6.5V5.5Z' })
	  );
	};
	
	var PhoneOutgoingIcon = function PhoneOutgoingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,3C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.17L13.21,17.37C10.38,15.93 8.06,13.62 6.62,10.78L8.82,8.57C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4C8.5,3.45 8.05,3 7.5,3H4M15,3V4.5H18.5L13,10L14,11L19.5,5.5V9H21V3H15Z' })
	  );
	};
	
	var PhonePausedIcon = function PhonePausedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,10H21V3H19M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4C8.5,3.45 8.05,3 7.5,3H4C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5M17,3H15V10H17V3Z' })
	  );
	};
	
	var PhonePlusIcon = function PhonePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,3C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5C18.76,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.07,13.62 6.62,10.79L8.82,8.58C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.24 8.5,4C8.5,3.45 8.05,3 7.5,3M16,3V6H13V8H16V11H18V8H21V6H18V3' })
	  );
	};
	
	var PhoneReturnIcon = function PhoneReturnIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,6V11H19.5V7.5H13.87L16.3,9.93L15.24,11L11,6.75L15.24,2.5L16.3,3.57L13.87,6H21M8.82,8.58C9.08,8.32 9.17,7.93 9.06,7.58C8.69,6.42 8.5,5.22 8.5,4C8.5,3.45 8.05,3 7.5,3H4C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5C18.79,15.5 17.58,15.31 16.43,14.93C16.08,14.82 15.69,14.91 15.43,15.17L13.23,17.37C10.39,15.92 8.09,13.62 6.64,10.78L8.82,8.58Z' })
	  );
	};
	
	var PhoneRotateLandscapeIcon = function PhoneRotateLandscapeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,1H3C1.9,1 1,1.9 1,3V16C1,17.1 1.9,18 3,18H9C10.1,18 11,17.1 11,16V3C11,1.9 10.1,1 9,1M9,15H3V3H9V15M21,13H13V15H21V21H9V20H6V21C6,22.1 6.9,23 8,23H21C22.1,23 23,22.1 23,21V15C23,13.9 22.1,13 21,13M23,10L19,8L20.91,7.09C19.74,4.31 17,2.5 14,2.5V1C18.97,1 23,5.03 23,10Z' })
	  );
	};
	
	var PhoneRotatePortraitIcon = function PhoneRotatePortraitIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,1H3C1.9,1 1,1.9 1,3V16C1,17.1 1.9,18 3,18H4V15H3V3H9V11H11V3C11,1.9 10.1,1 9,1M23,21V15C23,13.9 22.1,13 21,13H8C6.9,13 6,13.9 6,15V21C6,22.1 6.9,23 8,23H21C22.1,23 23,22.1 23,21M9,21V15H21V21H9M23,10H21.5C21.5,7 19.69,4.27 16.92,3.09L16,5L14,1C18.97,1 23,5.03 23,10Z' })
	  );
	};
	
	var PhoneSettingsIcon = function PhoneSettingsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,11H21V9H19M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4C8.5,3.45 8.05,3 7.5,3H4C3.45,3 3,3.45 3,4C3,13.39 10.61,21 20,21C20.55,21 21,20.55 21,20V16.5C21,15.95 20.55,15.5 20,15.5M17,9H15V11H17M13,9H11V11H13V9Z' })
	  );
	};
	
	var PhoneVoipIcon = function PhoneVoipIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,17V19H14C14.55,19 15,19.45 15,20H22V22H15C15,22.55 14.55,23 14,23H10C9.45,23 9,22.55 9,22H2V20H9C9,19.45 9.45,19 10,19H11V17H13M23.7,7.67C23.88,7.85 24,8.09 24,8.37C24,8.65 23.89,8.9 23.71,9.08L21.23,11.56C21.05,11.74 20.8,11.85 20.5,11.85C20.25,11.85 20,11.75 19.82,11.57C19,10.84 18.13,10.21 17.15,9.72C16.82,9.56 16.59,9.21 16.59,8.82V5.72C15.14,5.25 13.59,5 12,5C10.4,5 8.85,5.25 7.4,5.73V8.83C7.4,9.23 7.17,9.57 6.84,9.73C5.87,10.22 4.97,10.84 4.18,11.58C4,11.75 3.75,11.86 3.5,11.86C3.2,11.86 2.95,11.75 2.77,11.57L0.29,9.09C0.11,8.91 0,8.66 0,8.38C0,8.1 0.11,7.85 0.29,7.67C3.34,4.78 7.46,3 12,3C16.53,3 20.65,4.78 23.7,7.67M11,10V15H10V10H11M12,10H15V13H13V15H12V10M14,12V11H13V12H14Z' })
	  );
	};
	
	var PhoneIcon = function PhoneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5C20.55,15.5 21,15.95 21,16.5V20C21,20.55 20.55,21 20,21C10.61,21 3,13.39 3,4C3,3.45 3.45,3 4,3H7.5C8.05,3 8.5,3.45 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z' })
	  );
	};
	
	var PiBoxIcon = function PiBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M6,7H17V9H15V14C15,14.55 15.45,15 16,15C16.55,15 17,14.55 17,14H19C19,15.66 17.66,17 16,17C14.34,17 13,15.66 13,14V9H10V17H8V9H6' })
	  );
	};
	
	var PiIcon = function PiIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,5V7H6V19H8V7H14V16C14,17.66 15.34,19 17,19C18.66,19 20,17.66 20,16H18C18,16.55 17.55,17 17,17C16.45,17 16,16.55 16,16V7H18V5' })
	  );
	};
	
	var PianoIcon = function PianoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,3H20C21.1,3 22,3.9 22,5V19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19V5C2,3.9 2.9,3 4,3M4,5V19H8V13H6.75V5H4M9,19H15V13H13.75V5H10.25V13H9V19M16,19H20V5H17.25V13H16V19Z' })
	  );
	};
	
	var PickaxeIcon = function PickaxeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.79,10.62L3.5,21.9L2.1,20.5L13.38,9.21L14.79,10.62M19.27,7.73L19.86,7.14L19.07,6.35L19.71,5.71L18.29,4.29L17.65,4.93L16.86,4.14L16.27,4.73C14.53,3.31 12.57,2.17 10.47,1.37L9.64,3.16C11.39,4.08 13,5.19 14.5,6.5L14,7L17,10L17.5,9.5C18.81,11 19.92,12.61 20.84,14.36L22.63,13.53C21.83,11.43 20.69,9.47 19.27,7.73Z' })
	  );
	};
	
	var PierCraneIcon = function PierCraneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,20C18.61,20 17.22,19.53 16,18.67C13.56,20.38 10.44,20.38 8,18.67C6.78,19.53 5.39,20 4,20H2V22H4C5.37,22 6.74,21.65 8,21C10.5,22.3 13.5,22.3 16,21C17.26,21.65 18.62,22 20,22H22V20H20M20,4V3C20,2.45 19.55,2 19,2H9V1H6V2H5V4H6V13H5V11H3V13H2V15H3V19H4C4.33,19 4.67,18.97 5,18.92V15H10V18.65C10.65,18.85 11.33,18.95 12,18.95V18.92L12,15H13V13H12V11H10V13H9V4H17V8.62C16.53,8.79 16.19,9.23 16.19,9.76C16.19,10.2 16.43,10.6 16.8,10.82V12H17.42C17.76,12 18.03,12.28 18.03,12.62C18.03,12.96 17.76,13.24 17.42,13.24C17.2,13.24 17,13.12 16.88,12.93C16.71,12.64 16.34,12.54 16.05,12.71C15.75,12.87 15.65,13.25 15.82,13.55C16.15,14.11 16.76,14.47 17.42,14.47C18.43,14.47 19.26,13.64 19.26,12.62C19.26,11.84 18.76,11.14 18.03,10.88V10.82C18.41,10.6 18.65,10.2 18.65,9.76C18.65,9.3 18.38,8.91 18,8.7V4H20M8,11.66L7,12.66V11.24L8,10.24V11.66M8,8.71L7,9.71V8.29L8,7.29V8.71M7,6.71V5.29L8,4.29V5.71L7,6.71Z' })
	  );
	};
	
	var PierIcon = function PierIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,18C18.6,18 17.2,17.5 16,16.7C13.6,18.4 10.4,18.4 8,16.7C6.8,17.5 5.4,18 4,18H2V20H4C5.4,20 6.7,19.6 8,19C10.5,20.3 13.5,20.3 16,19C17.3,19.6 18.6,20 20,20H22V18H20M20,13H19V16.9C18.3,16.8 17.6,16.6 17,16.2V13H12V17C11.3,17 10.7,16.9 10,16.7V13H5V16.9C4.7,17 4.3,17 4,17H3V13H2V11H3V9H5V11H10V9H12V11H17V9H19V11H20V13Z' })
	  );
	};
	
	var PigIcon = function PigIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.5,9C8.67,9 8,9.67 8,10.5C8,11.33 8.67,12 9.5,12C10.33,12 11,11.33 11,10.5C11,9.67 10.33,9 9.5,9M14.5,9C13.67,9 13,9.67 13,10.5C13,11.33 13.67,12 14.5,12C15.33,12 16,11.33 16,10.5C16,9.67 15.33,9 14.5,9M12,4L12.68,4.03C13.62,3.24 14.82,2.59 15.72,2.35C17.59,1.85 20.88,2.23 21.31,3.83C21.62,5 20.6,6.45 19.03,7.38C20.26,8.92 21,10.87 21,13C21,17.97 16.97,22 12,22C7.03,22 3,17.97 3,13C3,10.87 3.74,8.92 4.97,7.38C3.4,6.45 2.38,5 2.69,3.83C3.12,2.23 6.41,1.85 8.28,2.35C9.18,2.59 10.38,3.24 11.32,4.03L12,4M10,16C10.55,16 11,16.45 11,17C11,17.55 10.55,18 10,18C9.45,18 9,17.55 9,17C9,16.45 9.45,16 10,16M14,16C14.55,16 15,16.45 15,17C15,17.55 14.55,18 14,18C13.45,18 13,17.55 13,17C13,16.45 13.45,16 14,16M12,13C9.24,13 7,15.34 7,17C7,18.66 9.24,20 12,20C14.76,20 17,18.66 17,17C17,15.34 14.76,13 12,13M7.76,4.28C7.31,4.16 4.59,4.35 4.59,4.35C4.59,4.35 6.8,6.1 7.24,6.22C7.69,6.34 9.77,6.43 9.91,5.9C10.06,5.36 8.2,4.4 7.76,4.28M16.24,4.28C15.8,4.4 13.94,5.36 14.09,5.9C14.23,6.43 16.31,6.34 16.76,6.22C17.2,6.1 19.41,4.35 19.41,4.35C19.41,4.35 16.69,4.16 16.24,4.28Z' })
	  );
	};
	
	var PillIcon = function PillIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.22,11.29L11.29,4.22C13.64,1.88 17.43,1.88 19.78,4.22C22.12,6.56 22.12,10.36 19.78,12.71L12.71,19.78C10.36,22.12 6.56,22.12 4.22,19.78C1.88,17.43 1.88,13.64 4.22,11.29M5.64,12.71C4.59,13.75 4.24,15.24 4.6,16.57L10.59,10.59L14.83,14.83L18.36,11.29C19.93,9.73 19.93,7.2 18.36,5.64C16.8,4.07 14.27,4.07 12.71,5.64L5.64,12.71Z' })
	  );
	};
	
	var PillarIcon = function PillarIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,5H18C18.55,5 19,5.45 19,6C19,6.55 18.55,7 18,7H6C5.45,7 5,6.55 5,6C5,5.45 5.45,5 6,5M21,2V4H3V2H21M15,8H17V22H15V8M7,8H9V22H7V8M11,8H13V22H11V8Z' })
	  );
	};
	
	var PinOffOutlineIcon = function PinOffOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,6.2V4H7V2H17V4H16V12L18,14V16H17.8L14,12.2V4H10V8.2L8,6.2M20,20.7L18.7,22L12.8,16.1V22H11.2V16H6V14L8,12V11.3L2,5.3L3.3,4L20,20.7M8.8,14H10.6L9.7,13.1L8.8,14Z' })
	  );
	};
	
	var PinOffIcon = function PinOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L12.8,16.07V22H11.2V16H6V14L8,12V11.27L2,5.27M16,12L18,14V16H17.82L8,6.18V4H7V2H17V4H16V12Z' })
	  );
	};
	
	var PinOutlineIcon = function PinOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12M8.8,14L10,12.8V4H14V12.8L15.2,14H8.8Z' })
	  );
	};
	
	var PinIcon = function PinIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z' })
	  );
	};
	
	var PineTreeBoxIcon = function PineTreeBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H20C21.1,2 22,2.9 22,4V20C22,21.1 21.1,22 20,22H4C2.9,22 2,21.1 2,20V4C2,2.9 2.9,2 4,2M11,19H13V17H18L14,13H17L13,9H16L12,5L8,9H11L7,13H10L6,17H11V19Z' })
	  );
	};
	
	var PineTreeIcon = function PineTreeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,21V18H3L8,13H5L10,8H7L12,3L17,8H14L19,13H16L21,18H14V21H10Z' })
	  );
	};
	
	var PinterestBoxIcon = function PinterestBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H9.29C9.69,20.33 10.19,19.38 10.39,18.64L11.05,16.34C11.36,16.95 12.28,17.45 13.22,17.45C16.17,17.45 18.22,14.78 18.22,11.45C18.22,8.28 15.64,5.89 12.3,5.89C8.14,5.89 5.97,8.67 5.97,11.72C5.97,13.14 6.69,14.89 7.91,15.45C8.08,15.56 8.19,15.5 8.19,15.34L8.47,14.28C8.5,14.14 8.5,14.06 8.41,14C7.97,13.45 7.69,12.61 7.69,11.78C7.69,9.64 9.3,7.61 12.03,7.61C14.42,7.61 16.08,9.19 16.08,11.5C16.08,14.11 14.75,15.95 13.03,15.95C12.05,15.95 11.39,15.11 11.55,14.17C11.83,13.03 12.39,11.83 12.39,11C12.39,10.22 12,9.61 11.16,9.61C10.22,9.61 9.39,10.61 9.39,11.95C9.39,12.83 9.66,13.39 9.66,13.39L8.55,18.17C8.39,19 8.47,20.25 8.55,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3Z' })
	  );
	};
	
	var PinterestIcon = function PinterestIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.04,21.54C10,21.83 10.97,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2C6.48,2 2,6.48 2,12C2,16.25 4.67,19.9 8.44,21.34C8.35,20.56 8.26,19.27 8.44,18.38L9.59,13.44C9.59,13.44 9.3,12.86 9.3,11.94C9.3,10.56 10.16,9.53 11.14,9.53C12,9.53 12.4,10.16 12.4,10.97C12.4,11.83 11.83,13.06 11.54,14.24C11.37,15.22 12.06,16.08 13.06,16.08C14.84,16.08 16.22,14.18 16.22,11.5C16.22,9.1 14.5,7.46 12.03,7.46C9.21,7.46 7.55,9.56 7.55,11.77C7.55,12.63 7.83,13.5 8.29,14.07C8.38,14.13 8.38,14.21 8.35,14.36L8.06,15.45C8.06,15.62 7.95,15.68 7.78,15.56C6.5,15 5.76,13.18 5.76,11.71C5.76,8.55 8,5.68 12.32,5.68C15.76,5.68 18.44,8.15 18.44,11.43C18.44,14.87 16.31,17.63 13.26,17.63C12.29,17.63 11.34,17.11 11,16.5L10.33,18.87C10.1,19.73 9.47,20.88 9.04,21.57V21.54Z' })
	  );
	};
	
	var PipeDisconnectedIcon = function PipeDisconnectedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,9V11H8V9H10V8H4V10H2V2H4V4H12C13.1,4 14,4.9 14,6V9H16M10,15V18C10,19.1 10.9,20 12,20H20V22H22V14H20V16H14V15H16V13H8V15H10Z' })
	  );
	};
	
	var PipeLeakIcon = function PipeLeakIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5V13H4V11H10L12,9L10,7H4V5H2M20,5V7H12L14,9L12,11H20V13H22V5H20M12,13C12,13 10,15.17 10,16.5C10,17.6 10.9,18.5 12,18.5C13.1,18.5 14,17.6 14,16.5C14,15.17 12,13 12,13Z' })
	  );
	};
	
	var PipeIcon = function PipeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,14H20V16H14V13H16V11H14V6C14,4.9 13.1,4 12,4H4V2H2V10H4V8H10V11H8V13H10V18C10,19.1 10.9,20 12,20H20V22H22' })
	  );
	};
	
	var PistolIcon = function PistolIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,5H23V9H22V10H16C15.45,10 15,10.45 15,11V12C15,13.1 14.1,14 13,14H9.62C9.24,14 8.89,14.22 8.72,14.56L6.27,19.45C6.1,19.79 5.76,20 5.38,20H2C2,20 -1,20 3,14C3,14 6,10 2,10V5H3L3.5,4H6.5L7,5M14,12V11C14,10.45 13.55,10 13,10H12C12,10 11,11 12,12C10.9,12 10,11.1 10,10C9.45,10 9,10.45 9,11V12C9,12.55 9.45,13 10,13H13C13.55,13 14,12.55 14,12Z' })
	  );
	};
	
	var PistonIcon = function PistonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,16.18C13.5,16.35 13.9,16.63 14.23,17H15V21H14.21C13.89,21.35 13.5,21.63 13,21.8C11.85,22.22 10.58,21.87 9.78,21H9V17H9.77C10.1,16.63 10.5,16.35 11,16.18V12H13V16.18M12,20C12.55,20 13,19.55 13,19C13,18.45 12.55,18 12,18C11.45,18 11,18.45 11,19C11,19.55 11.45,20 12,20M17,4H15V5H17V11H7V5H9V4H7V2H17V4M12,9C12.55,9 13,8.55 13,8C13,7.45 12.55,7 12,7C11.45,7 11,7.45 11,8C11,8.55 11.45,9 12,9Z' })
	  );
	};
	
	var PizzaIcon = function PizzaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,15C10.9,15 10,14.1 10,13C10,11.89 10.9,11 12,11C13.1,11 14,11.9 14,13C14,14.1 13.1,15 12,15M7,7C7,5.89 7.89,5 9,5C10.1,5 11,5.9 11,7C11,8.1 10.1,9 9,9C7.89,9 7,8.1 7,7M12,2C8.43,2 5.23,3.54 3,6L12,22L21,6C18.78,3.54 15.57,2 12,2Z' })
	  );
	};
	
	var PlaneShieldIcon = function PlaneShieldIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,5.68C12.5,5.68 12.95,6.11 12.95,6.63V10.11L18,13.26V14.53L12.95,12.95V16.42L14.21,17.37V18.32L12,17.68L9.79,18.32V17.37L11.05,16.42V12.95L6,14.53V13.26L11.05,10.11V6.63C11.05,6.11 11.5,5.68 12,5.68Z' })
	  );
	};
	
	var PlayBoxOutlineIcon = function PlayBoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19H5V5H19M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M10,8V16L15,12L10,8Z' })
	  );
	};
	
	var PlayCircleOutlineIcon = function PlayCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M10,16.5L16,12L10,7.5V16.5Z' })
	  );
	};
	
	var PlayCircleIcon = function PlayCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,16.5V7.5L16,12M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var PlayNetworkIcon = function PlayNetworkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,20C15,19.45 14.55,19 14,19H13V17H17C18.1,17 19,16.1 19,15V5C19,3.9 18.1,3 17,3H7C5.9,3 5,3.9 5,5V15C5,16.1 5.9,17 7,17H11V19H10C9.45,19 9,19.45 9,20H2V22H9C9,22.55 9.45,23 10,23H14C14.55,23 15,22.55 15,22H22V20H15M10,14V6L15,10L10,14Z' })
	  );
	};
	
	var PlayPauseIcon = function PlayPauseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,5V19L11,12M13,19H16V5H13M18,5V19H21V5' })
	  );
	};
	
	var PlayProtectedContentIcon = function PlayProtectedContentIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5V18H11V16H4V7H17V11H19V5H2M9,9V14L12.5,11.5L9,9M21.04,11.67L16.09,16.62L13.96,14.5L12.55,15.91L16.09,19.45L22.45,13.09L21.04,11.67Z' })
	  );
	};
	
	var PlaySpeedIcon = function PlaySpeedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,2.05V4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03V2.05M5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37L5.67,19.74M7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74M5.69,7.1L4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1M4.06,13H2.06C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13M10,16.5L16,12L10,7.5V16.5Z' })
	  );
	};
	
	var PlayIcon = function PlayIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,5.14V19.14L19,12.14L8,5.14Z' })
	  );
	};
	
	var PlaylistCheckIcon = function PlaylistCheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,10H2V12H14V10M14,6H2V8H14V6M2,16H10V14H2V16M21.5,11.5L23,13L16,20L11.5,15.5L13,14L16,17L21.5,11.5Z' })
	  );
	};
	
	var PlaylistEditIcon = function PlaylistEditIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,6V8H14V6H2M2,10V12H14V10H2M20.04,10.13C19.9,10.13 19.76,10.19 19.65,10.3L18.65,11.3L20.7,13.35L21.7,12.35C21.92,12.14 21.92,11.79 21.7,11.58L20.42,10.3C20.31,10.19 20.18,10.13 20.04,10.13M18.07,11.88L12,17.94V20H14.06L20.12,13.93L18.07,11.88M2,14V16H10V14H2Z' })
	  );
	};
	
	var PlaylistMinusIcon = function PlaylistMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,16H10V14H2M12,14V16H22V14M14,6H2V8H14M14,10H2V12H14V10Z' })
	  );
	};
	
	var PlaylistPlayIcon = function PlaylistPlayIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,9H2V11H19V9M19,5H2V7H19V5M2,15H15V13H2V15M17,13V19L22,16L17,13Z' })
	  );
	};
	
	var PlaylistPlusIcon = function PlaylistPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,16H10V14H2M18,14V10H16V14H12V16H16V20H18V16H22V14M14,6H2V8H14M14,10H2V12H14V10Z' })
	  );
	};
	
	var PlaylistRemoveIcon = function PlaylistRemoveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,6V8H14V6H2M2,10V12H11V10H2M14.17,10.76L12.76,12.17L15.59,15L12.76,17.83L14.17,19.24L17,16.41L19.83,19.24L21.24,17.83L18.41,15L21.24,12.17L19.83,10.76L17,13.59L14.17,10.76M2,14V16H11V14H2Z' })
	  );
	};
	
	var PlaystationIcon = function PlaystationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.5,4.27C10.88,4.53 12.9,5.14 14,5.5C16.75,6.45 17.69,7.63 17.69,10.29C17.69,12.89 16.09,13.87 14.05,12.89V8.05C14.05,7.5 13.95,6.97 13.41,6.82C13,6.69 12.76,7.07 12.76,7.63V19.73L9.5,18.69V4.27M13.37,17.62L18.62,15.75C19.22,15.54 19.31,15.24 18.83,15.08C18.34,14.92 17.47,14.97 16.87,15.18L13.37,16.41V14.45L13.58,14.38C13.58,14.38 14.59,14 16,13.87C17.43,13.71 19.17,13.89 20.53,14.4C22.07,14.89 22.25,15.61 21.86,16.1C21.46,16.6 20.5,16.95 20.5,16.95L13.37,19.5V17.62M3.5,17.42C1.93,17 1.66,16.05 2.38,15.5C3.05,15 4.18,14.65 4.18,14.65L8.86,13V14.88L5.5,16.09C4.9,16.3 4.81,16.6 5.29,16.76C5.77,16.92 6.65,16.88 7.24,16.66L8.86,16.08V17.77L8.54,17.83C6.92,18.09 5.2,18 3.5,17.42Z' })
	  );
	};
	
	var PlexIcon = function PlexIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2C2.89,2 2,2.89 2,4V20C2,21.11 2.89,22 4,22H20C21.11,22 22,21.11 22,20V4C22,2.89 21.11,2 20,2H4M8.56,6H12.06L15.5,12L12.06,18H8.56L12,12L8.56,6Z' })
	  );
	};
	
	var PlusBoxOutlineIcon = function PlusBoxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19V5H5V19H19M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.89 3.9,3 5,3H19M11,7H13V11H17V13H13V17H11V13H7V11H11V7Z' })
	  );
	};
	
	var PlusBoxIcon = function PlusBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,13H13V17H11V13H7V11H11V7H13V11H17M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z' })
	  );
	};
	
	var PlusCircleMultipleOutlineIcon = function PlusCircleMultipleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,8H14V11H11V13H14V16H16V13H19V11H16M2,12C2,9.21 3.64,6.8 6,5.68V3.5C2.5,4.76 0,8.09 0,12C0,15.91 2.5,19.24 6,20.5V18.32C3.64,17.2 2,14.79 2,12M15,3C10.04,3 6,7.04 6,12C6,16.96 10.04,21 15,21C19.96,21 24,16.96 24,12C24,7.04 19.96,3 15,3M15,19C11.14,19 8,15.86 8,12C8,8.14 11.14,5 15,5C18.86,5 22,8.14 22,12C22,15.86 18.86,19 15,19Z' })
	  );
	};
	
	var PlusCircleOutlineIcon = function PlusCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z' })
	  );
	};
	
	var PlusCircleIcon = function PlusCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var PlusMinusBoxIcon = function PlusMinusBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5M11,6H13V9H16V11H13V14H11V11H8V9H11V6M8,16H16V18H8V16Z' })
	  );
	};
	
	var PlusMinusIcon = function PlusMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,4V9H6V11H11V16H13V11H18V9H13V4H11M6,18V20H18V18H6Z' })
	  );
	};
	
	var PlusNetworkIcon = function PlusNetworkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,11V9H13V6H11V9H8V11H11V14H13V11H16M17,3C18.1,3 19,3.9 19,5V15C19,16.1 18.1,17 17,17H13V19H14C14.55,19 15,19.45 15,20H22V22H15C15,22.55 14.55,23 14,23H10C9.45,23 9,22.55 9,22H2V20H9C9,19.45 9.45,19 10,19H11V17H7C5.89,17 5,16.1 5,15V5C5,3.9 5.9,3 7,3H17Z' })
	  );
	};
	
	var PlusOneIcon = function PlusOneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,8V12H14V14H10V18H8V14H4V12H8V8H10M14.5,6.08L19,5V18H17V7.4L14.5,7.9V6.08Z' })
	  );
	};
	
	var PlusOutlineIcon = function PlusOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,9H9V4H15V9H20V15H15V20H9V15H4V9M11,13V18H13V13H18V11H13V6H11V11H6V13H11Z' })
	  );
	};
	
	var PlusIcon = function PlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z' })
	  );
	};
	
	var PocketIcon = function PocketIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.9,4.26C21.64,3.55 20.96,3.07 20.2,3.07H20.19L18.46,3.07H3.81C3.07,3.07 2.39,3.54 2.12,4.24C2.04,4.45 2,4.66 2,4.88V10.92L2.07,12.12C2.36,14.85 3.78,17.23 5.97,18.9C6,18.93 6.05,18.96 6.09,19H6.11C7.29,19.86 8.6,20.44 10,20.73C10.68,20.86 11.35,20.93 12,20.93C12.63,20.93 13.25,20.87 13.85,20.76C13.93,20.75 14,20.73 14.07,20.72C14.09,20.71 14.11,20.7 14.14,20.69C15.5,20.4 16.76,19.83 17.89,19H17.91C17.95,18.96 18,18.93 18.03,18.9C20.22,17.23 21.64,14.85 21.93,12.12L22,10.92V4.88C22,4.68 21.97,4.47 21.9,4.26M17.67,10.55L12.96,15.06C12.7,15.32 12.35,15.44 12,15.44C11.67,15.44 11.33,15.32 11.06,15.06L6.36,10.55C5.81,10.03 5.79,9.16 6.32,8.61C6.84,8.06 7.71,8.05 8.26,8.57L12,12.17L15.77,8.57C16.31,8.05 17.18,8.07 17.71,8.61C18.23,9.16 18.21,10.03 17.67,10.55Z' })
	  );
	};
	
	var PodcastIcon = function PodcastIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,18.25V21.5H7V18.25C7,16.87 9.24,15.75 12,15.75C14.76,15.75 17,16.87 17,18.25M12,5.5C15.59,5.5 18.5,8.41 18.5,12C18.5,13.25 18.15,14.42 17.54,15.41L16,14.04C16.32,13.43 16.5,12.73 16.5,12C16.5,9.5 14.5,7.5 12,7.5C9.5,7.5 7.5,9.5 7.5,12C7.5,12.73 7.68,13.43 8,14.04L6.46,15.41C5.85,14.42 5.5,13.25 5.5,12C5.5,8.41 8.41,5.5 12,5.5M12,1.5C17.8,1.5 22.5,6.2 22.5,12C22.5,14.28 21.77,16.39 20.54,18.11L19.04,16.76C19.96,15.4 20.5,13.76 20.5,12C20.5,7.31 16.69,3.5 12,3.5C7.31,3.5 3.5,7.31 3.5,12C3.5,13.76 4.04,15.4 4.96,16.76L3.46,18.11C2.23,16.39 1.5,14.28 1.5,12C1.5,6.2 6.2,1.5 12,1.5M12,9.5C13.38,9.5 14.5,10.62 14.5,12C14.5,13.38 13.38,14.5 12,14.5C10.62,14.5 9.5,13.38 9.5,12C9.5,10.62 10.62,9.5 12,9.5Z' })
	  );
	};
	
	var PokeballIcon = function PokeballIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.92,4 4.55,7.05 4.06,11H8.13C8.57,9.27 10.14,8 12,8C13.86,8 15.43,9.27 15.87,11H19.94C19.45,7.05 16.08,4 12,4M12,20C16.08,20 19.45,16.95 19.94,13H15.87C15.43,14.73 13.86,16 12,16C10.14,16 8.57,14.73 8.13,13H4.06C4.55,16.95 7.92,20 12,20M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10Z' })
	  );
	};
	
	var PokerChipIcon = function PokerChipIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,12C23,18.08 18.08,23 12,23C5.92,23 1,18.08 1,12C1,5.92 5.92,1 12,1C18.08,1 23,5.92 23,12M13,4.06C15.13,4.33 17.07,5.45 18.37,7.16L20.11,6.16C18.45,3.82 15.86,2.3 13,2V4.06M3.89,6.16L5.63,7.16C6.93,5.45 8.87,4.33 11,4.06V2C8.14,2.3 5.55,3.82 3.89,6.16M2.89,16.1L4.62,15.1C3.79,13.12 3.79,10.88 4.62,8.9L2.89,7.9C1.7,10.5 1.7,13.5 2.89,16.1M11,19.94C8.87,19.67 6.93,18.55 5.63,16.84L3.89,17.84C5.55,20.18 8.14,21.7 11,22V19.94M20.11,17.84L18.37,16.84C17.07,18.55 15.13,19.67 13,19.94V21.94C15.85,21.65 18.44,20.16 20.11,17.84M21.11,16.1C22.3,13.5 22.3,10.5 21.11,7.9L19.38,8.9C20.21,10.88 20.21,13.12 19.38,15.1L21.11,16.1M15,12L12,7L9,12L12,17L15,12Z' })
	  );
	};
	
	var PolaroidIcon = function PolaroidIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,3H18C19.1,3 20,3.9 20,5V19C20,20.1 19.1,21 18,21H6C4.9,21 4,20.1 4,19V5C4,3.9 4.9,3 6,3M6,5V17H18V5H6Z' })
	  );
	};
	
	var PollBoxIcon = function PollBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,17H15V13H17M13,17H11V7H13M9,17H7V10H9M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z' })
	  );
	};
	
	var PollIcon = function PollIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,22V8H7V22H3M10,22V2H14V22H10M17,22V14H21V22H17Z' })
	  );
	};
	
	var PolymerIcon = function PolymerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,4H15L7.1,16.63L4.5,12L9,4H5L0.5,12L5,20H9L16.89,7.37L19.5,12L15,20H19L23.5,12L19,4Z' })
	  );
	};
	
	var PoolIcon = function PoolIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,15C3.67,14.25 5.33,13.5 7,13.17V5C7,3.34 8.34,2 10,2C11.31,2 12.42,2.83 12.83,4H10C9.45,4 9,4.45 9,5V6H14V5C14,3.34 15.34,2 17,2C18.31,2 19.42,2.83 19.83,4H17C16.45,4 16,4.45 16,5V14.94C18,14.62 20,13 22,13V15C19.78,15 17.56,17 15.33,17C13.11,17 10.89,15 8.67,15C6.44,15 4.22,16 2,17V15M14,8H9V10H14V8M14,12H9V13C10.67,13.16 12.33,14.31 14,14.79V12M2,19C4.22,18 6.44,17 8.67,17C10.89,17 13.11,19 15.33,19C17.56,19 19.78,17 22,17V19C19.78,19 17.56,21 15.33,21C13.11,21 10.89,19 8.67,19C6.44,19 4.22,20 2,21V19Z' })
	  );
	};
	
	var PopcornIcon = function PopcornIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,22H4.75C4.75,22 4,22 3.81,20.65L2.04,3.81L2,3.5C2,2.67 2.9,2 4,2C5.1,2 6,2.67 6,3.5C6,2.67 6.9,2 8,2C9.1,2 10,2.67 10,3.5C10,2.67 10.9,2 12,2C13.09,2 14,2.66 14,3.5V3.5C14,2.67 14.9,2 16,2C17.1,2 18,2.67 18,3.5C18,2.67 18.9,2 20,2C21.1,2 22,2.67 22,3.5L21.96,3.81L20.19,20.65C20,22 19.25,22 19.25,22H17L16.5,22H13.75L10.25,22H7.5L7,22M17.85,4.93C17.55,4.39 16.84,4 16,4C15.19,4 14.36,4.36 14,4.87L13.78,20H16.66L17.85,4.93M10,4.87C9.64,4.36 8.81,4 8,4C7.16,4 6.45,4.39 6.15,4.93L7.34,20H10.22L10,4.87Z' })
	  );
	};
	
	var PotMixIcon = function PotMixIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19C19,20.1 18.1,21 17,21H7C5.9,21 5,20.1 5,19V13H3V10H14L18,3.07L19.73,4.07L16.31,10H21V13H19V19Z' })
	  );
	};
	
	var PotIcon = function PotIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19C19,20.1 18.1,21 17,21H7C5.9,21 5,20.1 5,19V13H3V10H21V13H19V19M6,6H8V8H6V6M11,6H13V8H11V6M16,6H18V8H16V6M18,3H20V5H18V3M13,3H15V5H13V3M8,3H10V5H8V3Z' })
	  );
	};
	
	var PoundBoxIcon = function PoundBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5M7,18H9L9.35,16H13.35L13,18H15L15.35,16H17.35L17.71,14H15.71L16.41,10H18.41L18.76,8H16.76L17.12,6H15.12L14.76,8H10.76L11.12,6H9.12L8.76,8H6.76L6.41,10H8.41L7.71,14H5.71L5.35,16H7.35L7,18M10.41,10H14.41L13.71,14H9.71L10.41,10Z' })
	  );
	};
	
	var PoundIcon = function PoundIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.41,21L6.12,17H2.12L2.47,15H6.47L7.53,9H3.53L3.88,7H7.88L8.59,3H10.59L9.88,7H15.88L16.59,3H18.59L17.88,7H21.88L21.53,9H17.53L16.47,15H20.47L20.12,17H16.12L15.41,21H13.41L14.12,17H8.12L7.41,21H5.41M9.53,9L8.47,15H14.47L15.53,9H9.53Z' })
	  );
	};
	
	var PowerCycleIcon = function PowerCycleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.03,3 3,7.03 3,12C3,16.97 7.03,21 12,21C16.97,21 21,16.97 21,12C21,7.03 16.97,3 12,3M12,19C8.13,19 5,15.87 5,12C5,8.13 8.13,5 12,5C15.87,5 19,8.13 19,12C19,15.87 15.87,19 12,19M13,17H11V7H13V17Z' })
	  );
	};
	
	var PowerOffIcon = function PowerOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.03,3 3,7.03 3,12C3,16.97 7.03,21 12,21C16.97,21 21,16.97 21,12C21,7.03 16.97,3 12,3M12,19C8.13,19 5,15.87 5,12C5,8.13 8.13,5 12,5C15.87,5 19,8.13 19,12C19,15.87 15.87,19 12,19Z' })
	  );
	};
	
	var PowerOnIcon = function PowerOnIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,3H13V21H11V3Z' })
	  );
	};
	
	var PowerPlugOffIcon = function PowerPlugOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,3V6.18C11.1,9.23 14.1,12.3 17.2,15.3C17.4,15 17.8,14.8 18,14.4V8.8C18,7.68 16.7,7.16 16,6.84V3H14V7H10V3H8M3.28,4C2.85,4.42 2.43,4.85 2,5.27L6,9.27V14.5C7.17,15.65 8.33,16.83 9.5,18V21H14.5V18C14.72,17.73 14.95,18.33 15.17,18.44C16.37,19.64 17.47,20.84 18.67,22.04C19.17,21.64 19.57,21.14 19.97,20.74C14.37,15.14 8.77,9.64 3.27,4.04L3.28,4Z' })
	  );
	};
	
	var PowerPlugIcon = function PowerPlugIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,7V3H14V7H10V3H8V7H8C7,7 6,8 6,9V14.5L9.5,18V21H14.5V18L18,14.5V9C18,8 17,7 16,7Z' })
	  );
	};
	
	var PowerSettingsIcon = function PowerSettingsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,24H17V22H15M16.56,4.44L15.11,5.89C16.84,6.94 18,8.83 18,11C18,14.31 15.31,17 12,17C8.69,17 6,14.31 6,11C6,8.83 7.16,6.94 8.88,5.88L7.44,4.44C5.36,5.88 4,8.28 4,11C4,15.42 7.58,19 12,19C16.42,19 20,15.42 20,11C20,8.28 18.64,5.88 16.56,4.44M13,2H11V12H13M11,24H13V22H11M7,24H9V22H7V24Z' })
	  );
	};
	
	var PowerSleepIcon = function PowerSleepIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.73,18C15.4,21.69 9.71,22 6,18.64C2.33,15.31 2.04,9.62 5.37,5.93C6.9,4.25 9,3.2 11.27,3C7.96,6.7 8.27,12.39 12,15.71C13.63,17.19 15.78,18 18,18C18.25,18 18.5,18 18.73,18Z' })
	  );
	};
	
	var PowerSocketAuIcon = function PowerSocketAuIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.22,2C2.99,2 2,2.99 2,4.22V19.78C2,21 3,22 4.22,22H19.78C21.01,22 22,21.01 22,19.78V4.22C22,3 21,2 19.78,2H4.22M12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4M8.27,7.54L6.27,11L8,12L10,8.54L8.27,7.54M15.73,7.54L14,8.54L16,12L17.73,11L15.73,7.54M11,14V18H13V14H11Z' })
	  );
	};
	
	var PowerSocketEuIcon = function PowerSocketEuIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.5,10.5C8.33,10.5 9,11.17 9,12C9,12.83 8.33,13.5 7.5,13.5C6.66,13.5 6,12.83 6,12C6,11.17 6.67,10.5 7.5,10.5M16.5,10.5C17.33,10.5 18,11.17 18,12C18,12.83 17.33,13.5 16.5,13.5C15.67,13.5 15,12.83 15,12C15,11.17 15.67,10.5 16.5,10.5M4.22,2H19.78C21,2 22,3 22,4.22V19.78C22,21.01 21.01,22 19.78,22H4.22C3,22 2,21 2,19.78V4.22C2,2.99 2.99,2 4.22,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4Z' })
	  );
	};
	
	var PowerSocketUkIcon = function PowerSocketUkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.5,13.75H18V16H14.5V13.75M6,13.75H9.5V16H6V13.75M11,6H13V10H11V6M4.22,2C2.99,2 2,2.99 2,4.22V19.78C2,21 3,22 4.22,22H19.78C21.01,22 22,21.01 22,19.78V4.22C22,3 21,2 19.78,2H4.22M12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4Z' })
	  );
	};
	
	var PowerSocketUsIcon = function PowerSocketUsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,7H10V12H8V7M4.22,2H19.78C21,2 22,3 22,4.22V19.78C22,21.01 21.01,22 19.78,22H4.22C3,22 2,21 2,19.78V4.22C2,2.99 2.99,2 4.22,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4M14,7.5H16V11.5H14V7.5M10.5,16.25C10.5,15.42 11.17,14.75 12,14.75C12.83,14.75 13.5,15.42 13.5,16.25V17H10.5V16.25Z' })
	  );
	};
	
	var PowerSocketIcon = function PowerSocketIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,15H17V11H15M7,15H9V11H7M11,13H13V9H11M8.83,7H15.2L19,10.8V17H5V10.8M8,5L3,10V19H21V10L16,5H8Z' })
	  );
	};
	
	var PowerStandbyIcon = function PowerStandbyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,3H11V13H13V3M17.83,5.17L16.41,6.59C18.05,7.91 19,9.9 19,12C19,15.87 15.87,19 12,19C8.14,19 5,15.88 5,12C5,9.91 5.95,7.91 7.58,6.58L6.17,5.17C2.38,8.39 1.92,14.07 5.14,17.86C8.36,21.64 14.04,22.1 17.83,18.88C19.85,17.17 21,14.65 21,12C21,9.37 19.84,6.87 17.83,5.17Z' })
	  );
	};
	
	var PowerIcon = function PowerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.56,5.44L15.11,6.89C16.84,7.94 18,9.83 18,12C18,15.31 15.31,18 12,18C8.69,18 6,15.31 6,12C6,9.83 7.16,7.94 8.88,6.88L7.44,5.44C5.36,6.88 4,9.28 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,9.28 18.64,6.88 16.56,5.44M13,3H11V13H13' })
	  );
	};
	
	var PrescriptionIcon = function PrescriptionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4V10L4,14H6V10H8L13.41,15.41L9.83,19L11.24,20.41L14.83,16.83L18.41,20.41L19.82,19L16.24,15.41L19.82,11.83L18.41,10.41L14.83,14L10.83,10H11C12.66,10 14,8.66 14,7C14,5.34 12.66,4 11,4H4M6,6H11C11.55,6 12,6.45 12,7C12,7.55 11.55,8 11,8H6V6Z' })
	  );
	};
	
	var PresentationPlayIcon = function PresentationPlayIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,3H10C10,1.9 10.9,1 12,1C13.1,1 14,1.9 14,3H22V5H21V16H15.25L17,22H15L13.25,16H10.75L9,22H7L8.75,16H3V5H2V3M5,5V14H19V5H5M11.85,11.85C11.76,11.94 11.64,12 11.5,12C11.22,12 11,11.78 11,11.5V7.5C11,7.22 11.22,7 11.5,7C11.64,7 11.76,7.06 11.85,7.15L13.25,8.54C13.57,8.86 13.89,9.18 13.89,9.5C13.89,9.82 13.57,10.14 13.25,10.46L11.85,11.85Z' })
	  );
	};
	
	var PresentationIcon = function PresentationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,3H10C10,1.9 10.9,1 12,1C13.1,1 14,1.9 14,3H22V5H21V16H15.25L17,22H15L13.25,16H10.75L9,22H7L8.75,16H3V5H2V3M5,5V14H19V5H5Z' })
	  );
	};
	
	var Printer3dIcon = function Printer3dIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,6C19.55,6 20,5.55 20,5C20,4.45 19.55,4 19,4C18.45,4 18,4.45 18,5C18,5.55 18.45,6 19,6M19,2C20.66,2 22,3.34 22,5V11H18V7H6V11H2V5C2,3.34 3.34,2 5,2H19M18,18.25C18,18.63 17.79,18.96 17.47,19.13L12.57,21.82C12.4,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L6.53,19.13C6.21,18.96 6,18.63 6,18.25V13C6,12.62 6.21,12.29 6.53,12.12L11.43,9.68C11.59,9.56 11.79,9.5 12,9.5C12.21,9.5 12.4,9.56 12.57,9.68L17.47,12.12C17.79,12.29 18,12.62 18,13V18.25M12,11.65L9.04,13L12,14.6L14.96,13L12,11.65M8,17.66L11,19.29V16.33L8,14.71V17.66M16,17.66V14.71L13,16.33V19.29L16,17.66Z' })
	  );
	};
	
	var PrinterAlertIcon = function PrinterAlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,4V8H6V4H14M15,13C15.55,13 16,12.55 16,12C16,11.45 15.55,11 15,11C14.45,11 14,11.45 14,12C14,12.55 14.45,13 15,13M13,19V15H7V19H13M15,9C16.66,9 18,10.34 18,12V17H15V21H5V17H2V12C2,10.34 3.34,9 5,9H15M22,7V12H20V7H22M22,14V16H20V14H22Z' })
	  );
	};
	
	var PrinterSettingsIcon = function PrinterSettingsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,2V6H6V2H18M19,11C19.55,11 20,10.55 20,10C20,9.45 19.55,9 19,9C18.45,9 18,9.45 18,10C18,10.55 18.45,11 19,11M16,18V13H8V18H16M19,7C20.66,7 22,8.34 22,10V16H18V20H6V16H2V10C2,8.34 3.34,7 5,7H19M15,24V22H17V24H15M11,24V22H13V24H11M7,24V22H9V24H7Z' })
	  );
	};
	
	var PrinterIcon = function PrinterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,3H6V7H18M19,12C18.45,12 18,11.55 18,11C18,10.45 18.45,10 19,10C19.55,10 20,10.45 20,11C20,11.55 19.55,12 19,12M16,19H8V14H16M19,8H5C3.34,8 2,9.34 2,11V17H6V21H18V17H22V11C22,9.34 20.66,8 19,8Z' })
	  );
	};
	
	var PriorityHighIcon = function PriorityHighIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,19H22V17H14V19M14,13.5H22V11.5H14V13.5M14,8H22V6H14V8M2,12.5C2,8.92 4.92,6 8.5,6H9V4L12,7L9,10V8H8.5C6,8 4,10 4,12.5C4,15 6,17 8.5,17H12V19H8.5C4.92,19 2,16.08 2,12.5Z' })
	  );
	};
	
	var PriorityLowIcon = function PriorityLowIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,5H22V7H14V5M14,10.5H22V12.5H14V10.5M14,16H22V18H14V16M2,11.5C2,15.08 4.92,18 8.5,18H9V20L12,17L9,14V16H8.5C6,16 4,14 4,11.5C4,9 6,7 8.5,7H12V5H8.5C4.92,5 2,7.92 2,11.5Z' })
	  );
	};
	
	var ProfessionalHexagonIcon = function ProfessionalHexagonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M5,9V15H6.25V13H7C8.1,13 9,12.1 9,11C9,9.9 8.1,9 7,9H5M6.25,12V10H6.75C7.3,10 7.75,10.45 7.75,11C7.75,11.55 7.3,12 6.75,12H6.25M9.75,9V15H11V13H11.75L12.41,15H13.73L12.94,12.61C13.43,12.25 13.75,11.66 13.75,11C13.75,9.9 12.85,9 11.75,9H9.75M11,12V10H11.5C12.05,10 12.5,10.45 12.5,11C12.5,11.55 12.05,12 11.5,12H11M17,9C15.62,9 14.5,10.34 14.5,12C14.5,13.66 15.62,15 17,15C18.38,15 19.5,13.66 19.5,12C19.5,10.34 18.38,9 17,9M17,10.25C17.76,10.25 18.38,11.03 18.38,12C18.38,12.97 17.76,13.75 17,13.75C16.24,13.75 15.63,12.97 15.63,12C15.63,11.03 16.24,10.25 17,10.25Z' })
	  );
	};
	
	var ProgressCheckIcon = function ProgressCheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,2.03V2.05L13,4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03M11,2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06M4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M15.5,8.5L10.62,13.38L8.5,11.26L7.44,12.32L10.62,15.5L16.56,9.56L15.5,8.5M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.1,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37Z' })
	  );
	};
	
	var ProgressClockIcon = function ProgressClockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,2.03V2.05L13,4.05C17.39,4.59 20.5,8.58 19.96,12.97C19.5,16.61 16.64,19.5 13,19.93V21.93C18.5,21.38 22.5,16.5 21.95,11C21.5,6.25 17.73,2.5 13,2.03M11,2.06C9.05,2.25 7.19,3 5.67,4.26L7.1,5.74C8.22,4.84 9.57,4.26 11,4.06V2.06M4.26,5.67C3,7.19 2.25,9.04 2.05,11H4.05C4.24,9.58 4.8,8.23 5.69,7.1L4.26,5.67M2.06,13C2.26,14.96 3.03,16.81 4.27,18.33L5.69,16.9C4.81,15.77 4.24,14.42 4.06,13H2.06M7.1,18.37L5.67,19.74C7.18,21 9.04,21.79 11,22V20C9.58,19.82 8.23,19.25 7.1,18.37M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z' })
	  );
	};
	
	var ProgressDownloadIcon = function ProgressDownloadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,2.03C17.73,2.5 21.5,6.25 21.95,11C22.5,16.5 18.5,21.38 13,21.93V19.93C16.64,19.5 19.5,16.61 19.96,12.97C20.5,8.58 17.39,4.59 13,4.05V2.05L13,2.03M11,2.06V4.06C9.57,4.26 8.22,4.84 7.1,5.74L5.67,4.26C7.19,3 9.05,2.25 11,2.06M4.26,5.67L5.69,7.1C4.8,8.23 4.24,9.58 4.05,11H2.05C2.25,9.04 3,7.19 4.26,5.67M2.06,13H4.06C4.24,14.42 4.81,15.77 5.69,16.9L4.27,18.33C3.03,16.81 2.26,14.96 2.06,13M7.1,18.37C8.23,19.25 9.58,19.82 11,20V22C9.04,21.79 7.18,21 5.67,19.74L7.1,18.37M12,16.5L7.5,12H11V8H13V12H16.5L12,16.5Z' })
	  );
	};
	
	var ProgressUploadIcon = function ProgressUploadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,2.03C17.73,2.5 21.5,6.25 21.95,11C22.5,16.5 18.5,21.38 13,21.93V19.93C16.64,19.5 19.5,16.61 19.96,12.97C20.5,8.58 17.39,4.59 13,4.05V2.05L13,2.03M11,2.06V4.06C9.57,4.26 8.22,4.84 7.1,5.74L5.67,4.26C7.19,3 9.05,2.25 11,2.06M4.26,5.67L5.69,7.1C4.8,8.23 4.24,9.58 4.05,11H2.05C2.25,9.04 3,7.19 4.26,5.67M2.06,13H4.06C4.24,14.42 4.81,15.77 5.69,16.9L4.27,18.33C3.03,16.81 2.26,14.96 2.06,13M7.1,18.37C8.23,19.25 9.58,19.82 11,20V22C9.04,21.79 7.18,21 5.67,19.74L7.1,18.37M12,7.5L7.5,12H11V16H13V12H16.5L12,7.5Z' })
	  );
	};
	
	var ProjectorScreenIcon = function ProjectorScreenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2C3.45,2 3,2.45 3,3V4C3,4.55 3.45,5 4,5H5V14H11V16.59L6.79,20.79L8.21,22.21L11,19.41V22H13V19.41L15.79,22.21L17.21,20.79L13,16.59V14H19V5H20C20.55,5 21,4.55 21,4V3C21,2.45 20.55,2 20,2H4Z' })
	  );
	};
	
	var ProjectorIcon = function ProjectorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,6C14.87,6 13.77,6.35 12.84,7H4C2.89,7 2,7.89 2,9V15C2,16.11 2.89,17 4,17H5V18C5,18.55 5.45,19 6,19H8C8.55,19 9,18.55 9,18V17H15V18C15,18.55 15.45,19 16,19H18C18.55,19 19,18.55 19,18V17H20C21.11,17 22,16.11 22,15V9C22,7.89 21.11,7 20,7H19.15C18.23,6.35 17.13,6 16,6M16,7.5C17.93,7.5 19.5,9.07 19.5,11C19.5,12.93 17.93,14.5 16,14.5C14.07,14.5 12.5,12.93 12.5,11C12.5,9.07 14.07,7.5 16,7.5M4,9H8V10H4V9M16,9C14.9,9 14,9.9 14,11C14,12.1 14.9,13 16,13C17.1,13 18,12.1 18,11C18,9.9 17.1,9 16,9M4,11H8V12H4V11M4,13H8V14H4V13Z' })
	  );
	};
	
	var PublishIcon = function PublishIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,4V6H19V4H5M5,14H9V20H15V14H19L12,7L5,14Z' })
	  );
	};
	
	var PulseIcon = function PulseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,13H5.79L10.1,4.79L11.28,13.75L14.5,9.66L17.83,13H21V15H17L14.67,12.67L9.92,18.73L8.94,11.31L7,15H3V13Z' })
	  );
	};
	
	var PuzzleIcon = function PuzzleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.5,11H19V7C19,5.89 18.1,5 17,5H13V3.5C13,2.12 11.88,1 10.5,1C9.12,1 8,2.12 8,3.5V5H4C2.9,5 2,5.9 2,7V10.8H3.5C5,10.8 6.2,12 6.2,13.5C6.2,15 5,16.2 3.5,16.2H2V20C2,21.1 2.9,22 4,22H7.8V20.5C7.8,19 9,17.8 10.5,17.8C12,17.8 13.2,19 13.2,20.5V22H17C18.1,22 19,21.1 19,20V16H20.5C21.88,16 23,14.88 23,13.5C23,12.12 21.88,11 20.5,11Z' })
	  );
	};
	
	var QiIcon = function QiIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.09,6.56V14.64C12.09,14.72 12,14.79 11.94,14.79C9.62,14.79 7.75,12.91 7.75,10.6C7.75,8.28 9.62,6.4 11.94,6.4C12,6.4 12.09,6.47 12.09,6.56M12.09,17.86V20.29C12.06,21.69 13.12,22.87 14.5,23C14.66,23 14.78,22.89 14.79,22.73V4.47C14.78,4.3 14.68,4.15 14.5,4.09C10.92,2.67 6.86,4.44 5.44,8.03C4,11.63 5.79,15.69 9.38,17.11C10.16,17.42 11,17.58 11.81,17.6C11.95,17.59 12.07,17.71 12.08,17.87M16.19,5.5V15.72C16.19,16 16.19,16.2 16.46,16V16C19.42,13.5 19.81,9.09 17.33,6.13C17.07,5.81 16.77,5.5 16.46,5.26C16.19,5.05 16.19,5.26 16.19,5.53M14.79,2.43C14.79,1.66 15.42,1.03 16.19,1.03C16.96,1.03 17.59,1.66 17.59,2.43C17.59,3.2 16.96,3.83 16.19,3.83V3.83C15.42,3.83 14.79,3.2 14.79,2.43' })
	  );
	};
	
	var QqchatIcon = function QqchatIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.18,13.54C3.76,12.16 4.57,11.14 5.17,10.92C5.16,10.12 5.31,9.62 5.56,9.22C5.56,9.19 5.5,8.86 5.72,8.45C5.87,4.85 8.21,2 12,2C15.79,2 18.13,4.85 18.28,8.45C18.5,8.86 18.44,9.19 18.44,9.22C18.69,9.62 18.84,10.12 18.83,10.92C19.43,11.14 20.24,12.16 20.82,13.55C21.57,15.31 21.69,17 21.09,17.3C20.68,17.5 20.03,17 19.42,16.12C19.18,17.1 18.58,18 17.73,18.71C18.63,19.04 19.21,19.58 19.21,20.19C19.21,21.19 17.63,22 15.69,22C13.93,22 12.5,21.34 12.21,20.5H11.79C11.5,21.34 10.07,22 8.31,22C6.37,22 4.79,21.19 4.79,20.19C4.79,19.58 5.37,19.04 6.27,18.71C5.42,18 4.82,17.1 4.58,16.12C3.97,17 3.32,17.5 2.91,17.3C2.31,17 2.43,15.31 3.18,13.54Z' })
	  );
	};
	
	var QrcodeEditIcon = function QrcodeEditIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,5H7V7H5V5M1,1H11V11H1V1M3,3V9H9V3H3M5,17H7V19H5V17M1,13H11V23H1V13M3,15V21H9V15H3M13,13H17V15H19V13H23V15H19V17H23V23H19V21H15V23H13V21H15V19H13V13M21,21V19H19V21H21M19,17H17V15H15V19H19V17M22.7,3.35L21.7,4.35L19.65,2.35L20.65,1.35C20.85,1.14 21.19,1.13 21.42,1.35L22.7,2.58C22.91,2.78 22.92,3.12 22.7,3.35M13,8.94L19.07,2.88L21.12,4.93L15.06,11H13V8.94Z' })
	  );
	};
	
	var QrcodeScanIcon = function QrcodeScanIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H10V10H4V4M20,4V10H14V4H20M14,15H16V13H14V11H16V13H18V11H20V13H18V15H20V18H18V20H16V18H13V20H11V16H14V15M16,15V18H18V15H16M4,20V14H10V20H4M6,6V8H8V6H6M16,6V8H18V6H16M6,16V18H8V16H6M4,11H6V13H4V11M9,11H13V15H11V13H9V11M11,6H13V10H11V6M2,2V6H0V2C0,0.9 0.9,0 2,0H6V2H2M22,0C23.1,0 24,0.9 24,2V6H22V2H18V0H22M2,18V22H6V24H2C0.9,24 0,23.1 0,22V18H2M22,22V18H24V22C24,23.1 23.1,24 22,24H18V22H22Z' })
	  );
	};
	
	var QrcodeIcon = function QrcodeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,11H5V13H3V11M11,5H13V9H11V5M9,11H13V15H11V13H9V11M15,11H17V13H19V11H21V13H19V15H21V19H19V21H17V19H13V21H11V17H15V15H17V13H15V11M19,19V15H17V19H19M15,3H21V9H15V3M17,5V7H19V5H17M3,3H9V9H3V3M5,5V7H7V5H5M3,15H9V21H3V15M5,17V19H7V17H5Z' })
	  );
	};
	
	var QuadcopterIcon = function QuadcopterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.5,1C8,1 10,3 10,5.5C10,6.38 9.75,7.2 9.31,7.9L9.41,8H14.59L14.69,7.9C14.25,7.2 14,6.38 14,5.5C14,3 16,1 18.5,1C21,1 23,3 23,5.5C23,8 21,10 18.5,10C17.62,10 16.8,9.75 16.1,9.31L15,10.41V13.59L16.1,14.69C16.8,14.25 17.62,14 18.5,14C21,14 23,16 23,18.5C23,21 21,23 18.5,23C16,23 14,21 14,18.5C14,17.62 14.25,16.8 14.69,16.1L14.59,16H9.41L9.31,16.1C9.75,16.8 10,17.62 10,18.5C10,21 8,23 5.5,23C3,23 1,21 1,18.5C1,16 3,14 5.5,14C6.38,14 7.2,14.25 7.9,14.69L9,13.59V10.41L7.9,9.31C7.2,9.75 6.38,10 5.5,10C3,10 1,8 1,5.5C1,3 3,1 5.5,1M5.5,3C4.12,3 3,4.12 3,5.5C3,6.88 4.12,8 5.5,8C6.88,8 8,6.88 8,5.5C8,4.12 6.88,3 5.5,3M5.5,16C4.12,16 3,17.12 3,18.5C3,19.88 4.12,21 5.5,21C6.88,21 8,19.88 8,18.5C8,17.12 6.88,16 5.5,16M18.5,3C17.12,3 16,4.12 16,5.5C16,6.88 17.12,8 18.5,8C19.88,8 21,6.88 21,5.5C21,4.12 19.88,3 18.5,3M18.5,16C17.12,16 16,17.12 16,18.5C16,19.88 17.12,21 18.5,21C19.88,21 21,19.88 21,18.5C21,17.12 19.88,16 18.5,16M3.91,17.25L5.04,17.91C5.17,17.81 5.33,17.75 5.5,17.75C5.91,17.75 6.25,18.09 6.25,18.5L6.24,18.6L7.37,19.25L7.09,19.75L5.96,19.09C5.83,19.19 5.67,19.25 5.5,19.25C5.09,19.25 4.75,18.91 4.75,18.5L4.76,18.4L3.63,17.75L3.91,17.25M3.63,6.25L4.76,5.6L4.75,5.5C4.75,5.09 5.09,4.75 5.5,4.75C5.67,4.75 5.83,4.81 5.96,4.91L7.09,4.25L7.37,4.75L6.24,5.4L6.25,5.5C6.25,5.91 5.91,6.25 5.5,6.25C5.33,6.25 5.17,6.19 5.04,6.09L3.91,6.75L3.63,6.25M16.91,4.25L18.04,4.91C18.17,4.81 18.33,4.75 18.5,4.75C18.91,4.75 19.25,5.09 19.25,5.5L19.24,5.6L20.37,6.25L20.09,6.75L18.96,6.09C18.83,6.19 18.67,6.25 18.5,6.25C18.09,6.25 17.75,5.91 17.75,5.5L17.76,5.4L16.63,4.75L16.91,4.25M16.63,19.25L17.75,18.5C17.75,18.09 18.09,17.75 18.5,17.75C18.67,17.75 18.83,17.81 18.96,17.91L20.09,17.25L20.37,17.75L19.25,18.5C19.25,18.91 18.91,19.25 18.5,19.25C18.33,19.25 18.17,19.19 18.04,19.09L16.91,19.75L16.63,19.25Z' })
	  );
	};
	
	var QualityHighIcon = function QualityHighIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.5,13.5H16.5V10.5H14.5M18,14C18,14.55 17.55,15 17,15H16.25V16.5H14.75V15H14C13.45,15 13,14.55 13,14V10C13,9.45 13.45,9 14,9H17C17.55,9 18,9.45 18,10M11,15H9.5V13H7.5V15H6V9H7.5V11.5H9.5V9H11M19,4H5C3.89,4 3,4.89 3,6V18C3,19.1 3.9,20 5,20H19C20.1,20 21,19.1 21,18V6C21,4.89 20.1,4 19,4Z' })
	  );
	};
	
	var QuicktimeIcon = function QuicktimeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C16.97,3 21,7.03 21,12C21,13.76 20.5,15.4 19.62,16.79L21,18.17V20C21,20.55 20.55,21 20,21H18.18L16.79,19.62C15.41,20.5 13.76,21 12,21C7.03,21 3,16.97 3,12C3,7.03 7.03,3 12,3M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C12.65,17 13.26,16.88 13.83,16.65L10.95,13.77C10.17,13 10.17,11.72 10.95,10.94C11.73,10.16 13,10.16 13.78,10.94L16.66,13.82C16.88,13.26 17,12.64 17,12C17,9.24 14.76,7 12,7Z' })
	  );
	};
	
	var RabbitIcon = function RabbitIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.05,21L15.32,16.26C15.32,14.53 14.25,13.42 12.95,13.42C12.05,13.42 11.27,13.92 10.87,14.66C11.2,14.47 11.59,14.37 12,14.37C13.3,14.37 14.36,15.43 14.36,16.73C14.36,18.04 13.31,19.11 12,19.11H15.3V21H6.79C6.55,21 6.3,20.91 6.12,20.72C5.75,20.35 5.75,19.75 6.12,19.38V19.38L6.62,18.88C6.28,18.73 6,18.5 5.72,18.26C5.5,18.76 5,19.11 4.42,19.11C3.64,19.11 3,18.47 3,17.68C3,16.9 3.64,16.26 4.42,16.26L4.89,16.34V14.37C4.89,11.75 7,9.63 9.63,9.63H9.65C11.77,9.64 13.42,10.47 13.42,9.16C13.42,8.23 13.62,7.86 13.96,7.34C13.23,7 12.4,6.79 11.53,6.79C11,6.79 10.58,6.37 10.58,5.84C10.58,5.41 10.86,5.05 11.25,4.93L10.58,4.89C10.06,4.89 9.63,4.47 9.63,3.95C9.63,3.42 10.06,3 10.58,3H11.53C13.63,3 15.47,4.15 16.46,5.85L16.74,5.84C17.45,5.84 18.11,6.07 18.65,6.45L19.1,6.83C21.27,8.78 21,10.1 21,10.11C21,11.39 19.94,12.44 18.65,12.44L18.16,12.39V12.47C18.16,13.58 17.68,14.57 16.93,15.27L20.24,21H18.05M18.16,7.74C17.63,7.74 17.21,8.16 17.21,8.68C17.21,9.21 17.63,9.63 18.16,9.63C18.68,9.63 19.11,9.21 19.11,8.68C19.11,8.16 18.68,7.74 18.16,7.74Z' })
	  );
	};
	
	var RadarIcon = function RadarIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.07,4.93L17.66,6.34C19.1,7.79 20,9.79 20,12C20,16.42 16.42,20 12,20C7.58,20 4,16.42 4,12C4,7.92 7.05,4.56 11,4.07V6.09C8.16,6.57 6,9.03 6,12C6,15.31 8.69,18 12,18C15.31,18 18,15.31 18,12C18,10.34 17.33,8.84 16.24,7.76L14.83,9.17C15.55,9.9 16,10.9 16,12C16,14.21 14.21,16 12,16C9.79,16 8,14.21 8,12C8,10.14 9.28,8.59 11,8.14V10.28C10.4,10.63 10,11.26 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,11.26 13.6,10.62 13,10.28V2H12C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,9.24 20.88,6.74 19.07,4.93Z' })
	  );
	};
	
	var RadiatorIcon = function RadiatorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.95,3L6.53,5.19L7.95,7.4H7.94L5.95,10.5L4.22,9.6L5.64,7.39L4.22,5.19L6.22,2.09L7.95,3M13.95,2.89L12.53,5.1L13.95,7.3L13.94,7.31L11.95,10.4L10.22,9.5L11.64,7.3L10.22,5.1L12.22,2L13.95,2.89M20,2.89L18.56,5.1L20,7.3V7.31L18,10.4L16.25,9.5L17.67,7.3L16.25,5.1L18.25,2L20,2.89M2,22V14C2,12.9 2.9,12 4,12H20C21.1,12 22,12.9 22,14V22H20V20H4V22H2M6,14C5.45,14 5,14.45 5,15V17C5,17.55 5.45,18 6,18C6.55,18 7,17.55 7,17V15C7,14.45 6.55,14 6,14M10,14C9.45,14 9,14.45 9,15V17C9,17.55 9.45,18 10,18C10.55,18 11,17.55 11,17V15C11,14.45 10.55,14 10,14M14,14C13.45,14 13,14.45 13,15V17C13,17.55 13.45,18 14,18C14.55,18 15,17.55 15,17V15C15,14.45 14.55,14 14,14M18,14C17.45,14 17,14.45 17,15V17C17,17.55 17.45,18 18,18C18.55,18 19,17.55 19,17V15C19,14.45 18.55,14 18,14Z' })
	  );
	};
	
	var RadioHandheldIcon = function RadioHandheldIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,2C8.45,2 8,2.45 8,3C8,8.67 8,14.33 8,20C8,21.11 8.89,22 10,22H15C16.11,22 17,21.11 17,20V9C17,7.89 16.11,7 15,7H10V3C10,2.45 9.55,2 9,2M10,9H15V13H10V9Z' })
	  );
	};
	
	var RadioTowerIcon = function RadioTowerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,10C13.1,10 14,10.9 14,12C14,12.5 13.82,12.94 13.53,13.29L16.7,22H14.57L12,14.93L9.43,22H7.3L10.47,13.29C10.18,12.94 10,12.5 10,12C10,10.9 10.9,10 12,10M12,8C9.79,8 8,9.79 8,12C8,12.5 8.1,13 8.28,13.46L7.4,15.86C6.53,14.81 6,13.47 6,12C6,8.69 8.69,6 12,6C15.31,6 18,8.69 18,12C18,13.47 17.47,14.81 16.6,15.86L15.72,13.46C15.9,13 16,12.5 16,12C16,9.79 14.21,8 12,8M12,4C7.58,4 4,7.58 4,12C4,14.36 5,16.5 6.64,17.94L5.92,19.94C3.54,18.11 2,15.23 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12C22,15.23 20.46,18.11 18.08,19.94L17.36,17.94C19,16.5 20,14.36 20,12C20,7.58 16.42,4 12,4Z' })
	  );
	};
	
	var RadioIcon = function RadioIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,6C21.1,6 22,6.9 22,8V20C22,21.1 21.1,22 20,22H4C2.9,22 2,21.1 2,20V8C2,7.15 2.53,6.42 3.28,6.13L15.71,1L16.47,2.83L8.83,6H20M20,8H4V12H16V10H18V12H20V8M7,14C5.34,14 4,15.34 4,17C4,18.66 5.34,20 7,20C8.66,20 10,18.66 10,17C10,15.34 8.66,14 7,14Z' })
	  );
	};
	
	var RadioactiveIcon = function RadioactiveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,10C13.1,10 14,10.9 14,12C14,13.1 13.1,14 12,14C10.9,14 10,13.1 10,12C10,10.9 10.9,10 12,10M12,22C10.05,22 8.22,21.44 6.69,20.47L10,15.47C10.6,15.81 11.28,16 12,16C12.72,16 13.4,15.81 14,15.47L17.31,20.47C15.78,21.44 13.95,22 12,22M2,12C2,7.86 4.5,4.3 8.11,2.78L10.34,8.36C8.96,9 8,10.38 8,12H2M16,12C16,10.38 15.04,9 13.66,8.36L15.89,2.78C19.5,4.3 22,7.86 22,12H16Z' })
	  );
	};
	
	var RadioboxBlankIcon = function RadioboxBlankIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var RadioboxMarkedIcon = function RadioboxMarkedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7Z' })
	  );
	};
	
	var RaspberrypiIcon = function RaspberrypiIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,8H22V10H20V8M4,5H20C21.1,5 22,5.9 22,7H19V9H5V13H8V16H19V17H22C22,18.1 21.1,19 20,19H16V20H14V19H11V20H7V19H4C2.9,19 2,18.1 2,17V7C2,5.9 2.9,5 4,5M19,15H9V10H19V11H22V13H19V15M13,12V14H15V12H13M5,6V8H6V6H5M7,6V8H8V6H7M9,6V8H10V6H9M11,6V8H12V6H11M13,6V8H14V6H13M15,6V8H16V6H15M20,14H22V16H20V14Z' })
	  );
	};
	
	var RayEndArrowIcon = function RayEndArrowIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,12L5,16V13H17.17C17.58,14.17 18.69,15 20,15C21.66,15 23,13.66 23,12C23,10.34 21.66,9 20,9C18.69,9 17.58,9.83 17.17,11H5V8L1,12Z' })
	  );
	};
	
	var RayEndIcon = function RayEndIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,9C18.69,9 17.58,9.83 17.17,11H2V13H17.17C17.58,14.17 18.69,15 20,15C21.66,15 23,13.66 23,12C23,10.34 21.66,9 20,9Z' })
	  );
	};
	
	var RayStartArrowIcon = function RayStartArrowIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,12L19,16V13H6.83C6.42,14.17 5.31,15 4,15C2.34,15 1,13.66 1,12C1,10.34 2.34,9 4,9C5.31,9 6.42,9.83 6.83,11H19V8L23,12Z' })
	  );
	};
	
	var RayStartEndIcon = function RayStartEndIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,9C5.31,9 6.42,9.83 6.83,11H17.17C17.58,9.83 18.69,9 20,9C21.66,9 23,10.34 23,12C23,13.66 21.66,15 20,15C18.69,15 17.58,14.17 17.17,13H6.83C6.42,14.17 5.31,15 4,15C2.34,15 1,13.66 1,12C1,10.34 2.34,9 4,9Z' })
	  );
	};
	
	var RayStartIcon = function RayStartIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,9C5.31,9 6.42,9.83 6.83,11H22V13H6.83C6.42,14.17 5.31,15 4,15C2.34,15 1,13.66 1,12C1,10.34 2.34,9 4,9Z' })
	  );
	};
	
	var RayVertexIcon = function RayVertexIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,11H9.17C9.58,9.83 10.69,9 12,9C13.31,9 14.42,9.83 14.83,11H22V13H14.83C14.42,14.17 13.31,15 12,15C10.69,15 9.58,14.17 9.17,13H2V11Z' })
	  );
	};
	
	var ReactIcon = function ReactIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,10.11C13.03,10.11 13.87,10.95 13.87,12C13.87,13 13.03,13.85 12,13.85C10.97,13.85 10.13,13 10.13,12C10.13,10.95 10.97,10.11 12,10.11M7.37,20C8,20.38 9.38,19.8 10.97,18.3C10.45,17.71 9.94,17.07 9.46,16.4C8.64,16.32 7.83,16.2 7.06,16.04C6.55,18.18 6.74,19.65 7.37,20M8.08,14.26L7.79,13.75C7.68,14.04 7.57,14.33 7.5,14.61C7.77,14.67 8.07,14.72 8.38,14.77C8.28,14.6 8.18,14.43 8.08,14.26M14.62,13.5L15.43,12L14.62,10.5C14.32,9.97 14,9.5 13.71,9.03C13.17,9 12.6,9 12,9C11.4,9 10.83,9 10.29,9.03C10,9.5 9.68,9.97 9.38,10.5L8.57,12L9.38,13.5C9.68,14.03 10,14.5 10.29,14.97C10.83,15 11.4,15 12,15C12.6,15 13.17,15 13.71,14.97C14,14.5 14.32,14.03 14.62,13.5M12,6.78C11.81,7 11.61,7.23 11.41,7.5C11.61,7.5 11.8,7.5 12,7.5C12.2,7.5 12.39,7.5 12.59,7.5C12.39,7.23 12.19,7 12,6.78M12,17.22C12.19,17 12.39,16.77 12.59,16.5C12.39,16.5 12.2,16.5 12,16.5C11.8,16.5 11.61,16.5 11.41,16.5C11.61,16.77 11.81,17 12,17.22M16.62,4C16,3.62 14.62,4.2 13.03,5.7C13.55,6.29 14.06,6.93 14.54,7.6C15.36,7.68 16.17,7.8 16.94,7.96C17.45,5.82 17.26,4.35 16.62,4M15.92,9.74L16.21,10.25C16.32,9.96 16.43,9.67 16.5,9.39C16.23,9.33 15.93,9.28 15.62,9.23C15.72,9.4 15.82,9.57 15.92,9.74M17.37,2.69C18.84,3.53 19,5.74 18.38,8.32C20.92,9.07 22.75,10.31 22.75,12C22.75,13.69 20.92,14.93 18.38,15.68C19,18.26 18.84,20.47 17.37,21.31C15.91,22.15 13.92,21.19 12,19.36C10.08,21.19 8.09,22.15 6.62,21.31C5.16,20.47 5,18.26 5.62,15.68C3.08,14.93 1.25,13.69 1.25,12C1.25,10.31 3.08,9.07 5.62,8.32C5,5.74 5.16,3.53 6.62,2.69C8.09,1.85 10.08,2.81 12,4.64C13.92,2.81 15.91,1.85 17.37,2.69M17.08,12C17.42,12.75 17.72,13.5 17.97,14.26C20.07,13.63 21.25,12.73 21.25,12C21.25,11.27 20.07,10.37 17.97,9.74C17.72,10.5 17.42,11.25 17.08,12M6.92,12C6.58,11.25 6.28,10.5 6.03,9.74C3.93,10.37 2.75,11.27 2.75,12C2.75,12.73 3.93,13.63 6.03,14.26C6.28,13.5 6.58,12.75 6.92,12M15.92,14.26C15.82,14.43 15.72,14.6 15.62,14.77C15.93,14.72 16.23,14.67 16.5,14.61C16.43,14.33 16.32,14.04 16.21,13.75L15.92,14.26M13.03,18.3C14.62,19.8 16,20.38 16.62,20C17.26,19.65 17.45,18.18 16.94,16.04C16.17,16.2 15.36,16.32 14.54,16.4C14.06,17.07 13.55,17.71 13.03,18.3M8.08,9.74C8.18,9.57 8.28,9.4 8.38,9.23C8.07,9.28 7.77,9.33 7.5,9.39C7.57,9.67 7.68,9.96 7.79,10.25L8.08,9.74M10.97,5.7C9.38,4.2 8,3.62 7.37,4C6.74,4.35 6.55,5.82 7.06,7.96C7.83,7.8 8.64,7.68 9.46,7.6C9.94,6.93 10.45,6.29 10.97,5.7Z' })
	  );
	};
	
	var ReadIcon = function ReadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.59,11.59L23,13L13.5,22.5L8.42,17.41L9.83,16L13.5,19.68L21.59,11.59M4,16V3H6L9,3C11.21,3 13,4.79 13,7C13,8.54 12.13,9.88 10.85,10.55L14,16H12L9.11,11H6V16H4M6,9H9C10.1,9 11,8.1 11,7C11,5.9 10.1,5 9,5H6V9Z' })
	  );
	};
	
	var ReceiptIcon = function ReceiptIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,22L4.5,20.5L6,22L7.5,20.5L9,22L10.5,20.5L12,22L13.5,20.5L15,22L16.5,20.5L18,22L19.5,20.5L21,22V2L19.5,3.5L18,2L16.5,3.5L15,2L13.5,3.5L12,2L10.5,3.5L9,2L7.5,3.5L6,2L4.5,3.5L3,2M18,9H6V7H18M18,13H6V11H18M18,17H6V15H18V17Z' })
	  );
	};
	
	var RecordPlayerIcon = function RecordPlayerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,17.5C5,17.78 4.78,18 4.5,18H3.5C3.22,18 3,17.78 3,17.5V17H2C1.45,17 1,16.55 1,16V13C1,12.45 1.45,12 2,12H19V10H7L6,11V9C6,8.45 6.45,8 7,8H19V7H21V8C21.55,8 22,8.45 22,9V10H21V12H22C22.55,12 23,12.45 23,13V16C23,16.55 22.55,17 22,17H21V17.5C21,17.78 20.78,18 20.5,18H19.5C19.22,18 19,17.78 19,17.5V17H5V17.5M3,14V15H5V14H3M6,14V15H8V14H6M20.5,13.5C19.95,13.5 19.5,13.95 19.5,14.5C19.5,15.05 19.95,15.5 20.5,15.5C21.05,15.5 21.5,15.05 21.5,14.5C21.5,13.95 21.05,13.5 20.5,13.5Z' })
	  );
	};
	
	var RecordRecIcon = function RecordRecIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.5,5C8.36,5 5,8.36 5,12.5C5,16.64 8.36,20 12.5,20C16.64,20 20,16.64 20,12.5C20,8.36 16.64,5 12.5,5M7,10H9C9.55,10 10,10.45 10,11V12C10,12.5 9.62,12.9 9.14,12.97L10.31,15H9.15L8,13V15H7M12,10H14V11H12V12H14V13H12V14H14V15H12C11.45,15 11,14.55 11,14V11C11,10.45 11.45,10 12,10M16,10H18V11H16V14H18V15H16C15.45,15 15,14.55 15,14V11C15,10.45 15.45,10 16,10M8,11V12H9V11' })
	  );
	};
	
	var RecordIcon = function RecordIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,12C19,15.86 15.86,19 12,19C8.14,19 5,15.86 5,12C5,8.14 8.14,5 12,5C15.86,5 19,8.14 19,12Z' })
	  );
	};
	
	var RecycleIcon = function RecycleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.82,15.42L19.32,19.75C18.83,20.61 17.92,21.06 17,21H15V23L12.5,18.5L15,14V16H17.82L15.6,12.15L19.93,9.65L21.73,12.77C22.25,13.54 22.32,14.57 21.82,15.42M9.21,3.06H14.21C15.19,3.06 16.04,3.63 16.45,4.45L17.45,6.19L19.18,5.19L16.54,9.6L11.39,9.69L13.12,8.69L11.71,6.24L9.5,10.09L5.16,7.59L6.96,4.47C7.37,3.64 8.22,3.06 9.21,3.06M5.05,19.76L2.55,15.43C2.06,14.58 2.13,13.56 2.64,12.79L3.64,11.06L1.91,10.06L7.05,10.14L9.7,14.56L7.97,13.56L6.56,16H11V21H7.4C6.47,21.07 5.55,20.61 5.05,19.76Z' })
	  );
	};
	
	var RedditIcon = function RedditIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,11.5C22,10.1 20.9,9 19.5,9C18.9,9 18.3,9.2 17.9,9.6C16.4,8.7 14.6,8.1 12.5,8L13.6,4L17,5C17,6.1 17.9,7 19,7C20.1,7 21,6.1 21,5C21,3.9 20.1,3 19,3C18.3,3 17.6,3.4 17.3,4L13.3,3C13,2.9 12.8,3.1 12.7,3.4L11.5,8C9.5,8.1 7.6,8.7 6.1,9.6C5.7,9.2 5.1,9 4.5,9C3.1,9 2,10.1 2,11.5C2,12.4 2.4,13.1 3.1,13.6L3,14.5C3,18.1 7,21 12,21C17,21 21,18.1 21,14.5L20.9,13.6C21.6,13.1 22,12.4 22,11.5M9,11.8C9.7,11.8 10.2,12.4 10.2,13C10.2,13.6 9.7,14.2 9,14.2C8.3,14.2 7.8,13.7 7.8,13C7.8,12.3 8.3,11.8 9,11.8M15.8,17.2C14,18.3 10,18.3 8.2,17.2C8,17 7.9,16.7 8.1,16.5C8.3,16.3 8.6,16.2 8.8,16.4C10,17.3 14,17.3 15.2,16.4C15.4,16.2 15.7,16.3 15.9,16.5C16.1,16.7 16,17 15.8,17.2M15,14.2C14.3,14.2 13.8,13.6 13.8,13C13.8,12.3 14.4,11.8 15,11.8C15.7,11.8 16.2,12.4 16.2,13C16.2,13.7 15.7,14.2 15,14.2Z' })
	  );
	};
	
	var RedoVariantIcon = function RedoVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.5,7C6.91,7 4,9.91 4,13.5C4,17.09 6.91,20 10.5,20H14V18H10.5C8,18 6,16 6,13.5C6,11 8,9 10.5,9H16.17L13.09,12.09L14.5,13.5L20,8L14.5,2.5L13.08,3.91L16.17,7H10.5M18,18H16V20H18V18Z' })
	  );
	};
	
	var RedoIcon = function RedoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.4,10.6C16.55,9 14.15,8 11.5,8C6.85,8 2.92,11.03 1.54,15.22L3.9,16C4.95,12.81 7.95,10.5 11.5,10.5C13.45,10.5 15.23,11.22 16.62,12.38L13,16H22V7L18.4,10.6Z' })
	  );
	};
	
	var RefreshIcon = function RefreshIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.65,6.35C16.2,4.9 14.21,4 12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18C8.69,18 6,15.31 6,12C6,8.69 8.69,6 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z' })
	  );
	};
	
	var RegexIcon = function RegexIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,16.92C15.67,16.97 15.34,17 15,17C14.66,17 14.33,16.97 14,16.92V13.41L11.5,15.89C11,15.5 10.5,15 10.11,14.5L12.59,12H9.08C9.03,11.67 9,11.34 9,11C9,10.66 9.03,10.33 9.08,10H12.59L10.11,7.5C10.3,7.25 10.5,7 10.76,6.76V6.76C11,6.5 11.25,6.3 11.5,6.11L14,8.59V5.08C14.33,5.03 14.66,5 15,5C15.34,5 15.67,5.03 16,5.08V8.59L18.5,6.11C19,6.5 19.5,7 19.89,7.5L17.41,10H20.92C20.97,10.33 21,10.66 21,11C21,11.34 20.97,11.67 20.92,12H17.41L19.89,14.5C19.7,14.75 19.5,15 19.24,15.24V15.24C19,15.5 18.75,15.7 18.5,15.89L16,13.41V16.92H16V16.92M5,19C5,17.9 5.9,17 7,17C8.1,17 9,17.9 9,19C9,20.1 8.1,21 7,21C5.9,21 5,20.1 5,19H5Z' })
	  );
	};
	
	var RelativeScaleIcon = function RelativeScaleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,18H4V6H20M20,4H4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4M12,10H10V12H12M8,10H6V12H8M16,14H14V16H16M16,10H14V12H16V10Z' })
	  );
	};
	
	var ReloadIcon = function ReloadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,12H22.32L17.37,16.95L12.42,12H16.97C17,10.46 16.42,8.93 15.24,7.75C12.9,5.41 9.1,5.41 6.76,7.75C4.42,10.09 4.42,13.9 6.76,16.24C8.6,18.08 11.36,18.47 13.58,17.41L15.05,18.88C12,20.69 8,20.29 5.34,17.65C2.22,14.53 2.23,9.47 5.35,6.35C8.5,3.22 13.53,3.21 16.66,6.34C18.22,7.9 19,9.95 19,12Z' })
	  );
	};
	
	var ReminderIcon = function ReminderIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.25,3C7.9,3 8.5,3.21 9,3.56V3C9,1.9 9.9,1 11,1C12.1,1 13,1.9 13,3V3.57C13.5,3.22 14.1,3 14.75,3C16.41,3 17.75,4.34 17.75,6C17.75,7.58 16.54,8.87 15,9H13V10H14.24L14.72,10.13L19.31,12.42C20.13,12.73 20.53,13.34 20.53,14.25L20.5,14.39V14.53L19.5,21.28C19.44,21.75 19.22,22.16 18.84,22.5C18.47,22.84 18.05,23 17.58,23H10C9.45,23 9,22.81 8.58,22.41L2,15.84L3.05,14.77C3.33,14.5 3.69,14.34 4.13,14.34H4.45L9,15.33V10L9,9H7V9C5.46,8.86 4.25,7.57 4.25,6C4.25,4.34 5.59,3 7.25,3M9,6C9,5.03 8.22,4.25 7.25,4.25C6.28,4.25 5.5,5.03 5.5,6C5.5,6.88 6.15,7.61 7,7.73V7.75H9V6M15,7.75V7.74C15.85,7.62 16.5,6.89 16.5,6C16.5,5.04 15.72,4.26 14.75,4.26C13.78,4.26 13,5.04 13,6V7.75H15Z' })
	  );
	};
	
	var RemoteDesktopIcon = function RemoteDesktopIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,2C1.9,2 1,2.9 1,4V16C1,17.11 1.9,18 3,18H10V20H8V22H16V20H14V18H21C22.1,18 23,17.1 23,16V4C23,2.9 22.1,2 21,2M3,4H21V16H3M15,5L11.5,8.5L15,12L16.4,10.6L14.3,8.5L16.4,6.4M9,8L7.6,9.4L9.7,11.5L7.6,13.6L9,15L12.5,11.5' })
	  );
	};
	
	var RemoteIcon = function RemoteIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,0C8.96,0 6.21,1.23 4.22,3.22L5.63,4.63C7.26,3 9.5,2 12,2C14.5,2 16.74,3 18.36,4.64L19.77,3.23C17.79,1.23 15.04,0 12,0M7.05,6.05L8.46,7.46C9.37,6.56 10.62,6 12,6C13.38,6 14.63,6.56 15.54,7.46L16.95,6.05C15.68,4.78 13.93,4 12,4C10.07,4 8.32,4.78 7.05,6.05M12,15C10.9,15 10,14.1 10,13C10,11.9 10.9,11 12,11C13.1,11 14,11.9 14,13C14,14.1 13.1,15 12,15M15,9H9C8.45,9 8,9.45 8,10V22C8,22.55 8.45,23 9,23H15C15.55,23 16,22.55 16,22V10C16,9.45 15.55,9 15,9Z' })
	  );
	};
	
	var RenameBoxIcon = function RenameBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,17H10.5L12.5,15H18M6,17V14.5L13.88,6.65C14.07,6.45 14.39,6.45 14.59,6.65L16.35,8.41C16.55,8.61 16.55,8.92 16.35,9.12L8.47,17M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z' })
	  );
	};
	
	var ReorderHorizontalIcon = function ReorderHorizontalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,15H21V13H3V15M3,19H21V17H3V19M3,11H21V9H3V11M3,5V7H21V5H3Z' })
	  );
	};
	
	var ReorderVerticalIcon = function ReorderVerticalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,3V21H11V3H9M5,3V21H7V3H5M13,3V21H15V3H13M19,3H17V21H19V3Z' })
	  );
	};
	
	var RepeatOffIcon = function RepeatOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L15.73,19H7V22L3,18L7,14V17H13.73L7,10.27V11H5V8.27L2,5.27M17,13H19V17.18L17,15.18V13M17,5V2L21,6L17,10V7H8.82L6.82,5H17Z' })
	  );
	};
	
	var RepeatOnceIcon = function RepeatOnceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,15V9H12L10,10V11H11.5V15M17,17H7V14L3,18L7,22V19H19V13H17M7,7H17V10L21,6L17,2V5H5V11H7V7Z' })
	  );
	};
	
	var RepeatIcon = function RepeatIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,17H7V14L3,18L7,22V19H19V13H17M7,7H17V10L21,6L17,2V5H5V11H7V7Z' })
	  );
	};
	
	var ReplayIcon = function ReplayIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,5V1L7,6L12,11V7C15.31,7 18,9.69 18,13C18,16.31 15.31,19 12,19C8.69,19 6,16.31 6,13H4C4,17.42 7.58,21 12,21C16.42,21 20,17.42 20,13C20,8.58 16.42,5 12,5Z' })
	  );
	};
	
	var ReplyAllIcon = function ReplyAllIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,9V5L6,12L13,19V14.9C18,14.9 21.5,16.5 24,20C23,15 20,10 13,9M7,8V5L0,12L7,19V16L3,12L7,8Z' })
	  );
	};
	
	var ReplyIcon = function ReplyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,9V5L3,12L10,19V14.9C15,14.9 18.5,16.5 21,20C20,15 17,10 10,9Z' })
	  );
	};
	
	var ReproductionIcon = function ReproductionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.72,13.15L13.62,12.26C13.6,11 14.31,9.44 15.62,8.14C17.57,6.18 20.11,5.55 21.28,6.72C22.45,7.89 21.82,10.43 19.86,12.38C18.56,13.69 17,14.4 15.74,14.38L14.85,15.28C14.5,15.61 14,15.66 13.6,15.41C12.76,15.71 12,16.08 11.56,16.8C11.03,17.68 11.03,19.1 10.47,19.95C9.91,20.81 8.79,21.1 7.61,21.1C6.43,21.1 5,21 3.95,19.5L6.43,19.92C7,20 8.5,19.39 9.05,18.54C9.61,17.68 9.61,16.27 10.14,15.38C10.61,14.6 11.5,14.23 12.43,13.91C12.42,13.64 12.5,13.36 12.72,13.15M7,2C9.76,2 12,4.24 12,7C12,9.76 9.76,12 7,12C4.24,12 2,9.76 2,7C2,4.24 4.24,2 7,2M7,4C5.34,4 4,5.34 4,7C4,8.66 5.34,10 7,10C8.66,10 10,8.66 10,7C10,5.34 8.66,4 7,4Z' })
	  );
	};
	
	var ResizeBottomRightIcon = function ResizeBottomRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,22H20V20H22V22M22,18H20V16H22V18M18,22H16V20H18V22M18,18H16V16H18V18M14,22H12V20H14V22M22,14H20V12H22V14Z' })
	  );
	};
	
	var ResponsiveIcon = function ResponsiveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,6V16H9V12C9,10.9 9.9,10 11,10H16C17.1,10 18,10.9 18,12V16H20V6H4M0,20V18H4C2.9,18 2,17.1 2,16V6C2,4.9 2.9,4 4,4H20C21.1,4 22,4.9 22,6V16C22,17.1 21.1,18 20,18H24V20H18V20C18,21.11 17.1,22 16,22H11C9.9,22 9,21.1 9,20H9L0,20M11.5,20C11.22,20 11,20.22 11,20.5C11,20.78 11.22,21 11.5,21C11.78,21 12,20.78 12,20.5C12,20.22 11.78,20 11.5,20M15.5,20C15.22,20 15,20.22 15,20.5C15,20.78 15.22,21 15.5,21C15.78,21 16,20.78 16,20.5C16,20.22 15.78,20 15.5,20M13,20V21H14V20H13M11,12V19H16V12H11Z' })
	  );
	};
	
	var RestartIcon = function RestartIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,4C13.05,4 15.09,4.77 16.65,6.33C19.78,9.46 19.77,14.5 16.64,17.64C14.81,19.5 12.3,20.24 9.91,19.92L10.44,17.96C12.15,18.12 13.93,17.54 15.24,16.23C17.58,13.89 17.58,10.09 15.24,7.75C14.06,6.57 12.53,6 11,6V10.58L6.04,5.63L11,0.68V4M5.34,17.65C2.7,15 2.3,11 4.11,7.94L5.59,9.41C4.5,11.64 4.91,14.39 6.75,16.23C7.27,16.75 7.87,17.16 8.5,17.45L8,19.4C7,19 6.12,18.43 5.34,17.65Z' })
	  );
	};
	
	var RestoreClockIcon = function RestoreClockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,3C8.03,3 4,7.03 4,12H1L4.89,15.89L4.96,16.03L9,12H6C6,8.13 9.13,5 13,5C16.87,5 20,8.13 20,12C20,15.87 16.87,19 13,19C11.07,19 9.32,18.21 8.06,16.94L6.64,18.36C8.27,20 10.5,21 13,21C17.97,21 22,16.97 22,12C22,7.03 17.97,3 13,3M12,8V13L16.28,15.54L17,14.33L13.5,12.25V8H12Z' })
	  );
	};
	
	var RestoreIcon = function RestoreIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,3C8.03,3 4,7.03 4,12H1L4.89,15.89L4.96,16.03L9,12H6C6,8.13 9.13,5 13,5C16.87,5 20,8.13 20,12C20,15.87 16.87,19 13,19C11.07,19 9.32,18.21 8.06,16.94L6.64,18.36C8.27,20 10.5,21 13,21C17.97,21 22,16.97 22,12C22,7.03 17.97,3 13,3Z' })
	  );
	};
	
	var RewindOutlineIcon = function RewindOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,9.9L7,12L10,14.1V9.9M19,9.9L16,12L19,14.1V9.9M12,6V18L3.5,12L12,6M21,6V18L12.5,12L21,6Z' })
	  );
	};
	
	var RewindIcon = function RewindIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.5,12L20,18V6M11,18V6L2.5,12L11,18Z' })
	  );
	};
	
	var RhombusOutlineIcon = function RhombusOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.5,10.8L13.2,2.5C12.5,1.8 11.5,1.8 10.8,2.5L2.5,10.8C1.8,11.5 1.8,12.5 2.5,13.2L10.8,21.5C11.5,22.2 12.5,22.2 13.2,21.5L21.5,13.2C22.1,12.5 22.1,11.5 21.5,10.8M20.3,12L12,20.3L3.7,12L12,3.7L20.3,12Z' })
	  );
	};
	
	var RhombusIcon = function RhombusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.5,10.8L13.2,2.5C12.5,1.8 11.5,1.8 10.8,2.5L2.5,10.8C1.8,11.5 1.8,12.5 2.5,13.2L10.8,21.5C11.5,22.2 12.5,22.2 13.2,21.5L21.5,13.2C22.1,12.5 22.1,11.5 21.5,10.8Z' })
	  );
	};
	
	var RibbonIcon = function RibbonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.41,19.31L16.59,22.5L18,21.07L14.83,17.9M15.54,11.53H15.53L12,15.07L8.47,11.53H8.46V11.53C7.56,10.63 7,9.38 7,8C7,5.24 9.24,3 12,3C14.76,3 17,5.24 17,8C17,9.38 16.44,10.63 15.54,11.53M16.9,13C18.2,11.73 19,9.96 19,8C19,4.13 15.87,1 12,1C8.13,1 5,4.13 5,8C5,9.96 5.81,11.73 7.1,13V13L10.59,16.5L6,21.07L7.41,22.5L16.9,13Z' })
	  );
	};
	
	var RiceIcon = function RiceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,11H19.7C19.4,9.9 18.9,8.8 18.2,8L21.6,2.6L19.9,1.5L16.7,6.6C16.3,6.3 16,6.1 15.5,5.9L16.4,2.3L14.5,1.8L13.7,5.2C13.1,5.1 12.6,5 12,5C8.3,5 5.2,7.6 4.3,11H2C2,15.1 4.5,18.6 8,20.2V22H16V20.2C19.5,18.6 22,15.1 22,11M12,7C14.6,7 16.8,8.7 17.6,11H6.4C7.2,8.7 9.4,7 12,7Z' })
	  );
	};
	
	var RingIcon = function RingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,10L8,4.4L9.6,2H14.4L16,4.4L12,10M15.5,6.8L14.3,8.5C16.5,9.4 18,11.5 18,14C18,17.31 15.31,20 12,20C8.69,20 6,17.31 6,14C6,11.5 7.5,9.4 9.7,8.5L8.5,6.8C5.8,8.1 4,10.8 4,14C4,18.42 7.58,22 12,22C16.42,22 20,18.42 20,14C20,10.8 18.2,8.1 15.5,6.8Z' })
	  );
	};
	
	var RoadVariantIcon = function RoadVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.1,4.8C18,4.3 17.6,4 17.1,4H13L13.2,7H10.8L11,4H6.8C6.3,4 5.9,4.4 5.8,4.8L3.1,18.8C3,19.4 3.5,20 4.1,20H10L10.3,15H13.7L14,20H19.8C20.4,20 20.9,19.4 20.8,18.8L18.1,4.8M10.4,13L10.6,9H13.2L13.4,13H10.4Z' })
	  );
	};
	
	var RoadIcon = function RoadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,16H13V20H11M11,10H13V14H11M11,4H13V8H11M4,22H20V2H4V22Z' })
	  );
	};
	
	var RobotVacuumVariantIcon = function RobotVacuumVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3C3.9,3 3,3.9 3,5V7H5V5H19V7H21V5C21,3.9 20.1,3 19,3H5M8,7V9H16V7H8M3,9V12C3,16.97 7.03,21 12,21C16.97,21 21,16.97 21,12V9H19V12C19,15.87 15.87,19 12,19C8.13,19 5,15.87 5,12V9H3M12,12C10.62,12 9.5,13.12 9.5,14.5C9.5,15.88 10.62,17 12,17C13.38,17 14.5,15.88 14.5,14.5C14.5,13.12 13.38,12 12,12Z' })
	  );
	};
	
	var RobotVacuumIcon = function RobotVacuumIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C14.65,2 17.19,3.06 19.07,4.93L17.65,6.35C16.15,4.85 14.12,4 12,4C9.88,4 7.84,4.84 6.35,6.35L4.93,4.93C6.81,3.06 9.35,2 12,2M3.66,6.5L5.11,7.94C4.39,9.17 4,10.57 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,10.57 19.61,9.17 18.88,7.94L20.34,6.5C21.42,8.12 22,10.04 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,10.04 2.58,8.12 3.66,6.5M12,6C15.31,6 18,8.69 18,12C18,13.59 17.37,15.12 16.24,16.24L14.83,14.83C14.08,15.58 13.06,16 12,16C10.94,16 9.92,15.58 9.17,14.83L7.76,16.24C6.63,15.12 6,13.59 6,12C6,8.69 8.69,6 12,6M12,8C11.45,8 11,8.45 11,9C11,9.55 11.45,10 12,10C12.55,10 13,9.55 13,9C13,8.45 12.55,8 12,8Z' })
	  );
	};
	
	var RobotIcon = function RobotIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C13.1,2 14,2.9 14,4C14,4.74 13.6,5.39 13,5.73V7H14C17.87,7 21,10.13 21,14H22C22.55,14 23,14.45 23,15V18C23,18.55 22.55,19 22,19H21V20C21,21.1 20.1,22 19,22H5C3.9,22 3,21.1 3,20V19H2C1.45,19 1,18.55 1,18V15C1,14.45 1.45,14 2,14H3C3,10.13 6.13,7 10,7H11V5.73C10.4,5.39 10,4.74 10,4C10,2.9 10.9,2 12,2M7.5,13C6.12,13 5,14.12 5,15.5C5,16.88 6.12,18 7.5,18C8.88,18 10,16.88 10,15.5C10,14.12 8.88,13 7.5,13M16.5,13C15.12,13 14,14.12 14,15.5C14,16.88 15.12,18 16.5,18C17.88,18 19,16.88 19,15.5C19,14.12 17.88,13 16.5,13Z' })
	  );
	};
	
	var RocketIcon = function RocketIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.81,14.12L5.64,11.29L8.17,10.79C11.39,6.41 17.55,4.22 19.78,4.22C19.78,6.45 17.59,12.61 13.21,15.83L12.71,18.36L9.88,21.19L9.17,17.66C7.76,17.66 7.76,17.66 7.05,16.95C6.34,16.24 6.34,16.24 6.34,14.83L2.81,14.12M5.64,16.95L7.05,18.36L4.39,21.03H2.97V19.61L5.64,16.95M4.22,15.54L5.46,15.71L3,18.16V16.74L4.22,15.54M8.29,18.54L8.46,19.78L7.26,21H5.84L8.29,18.54M13,9.5C12.17,9.5 11.5,10.17 11.5,11C11.5,11.83 12.17,12.5 13,12.5C13.83,12.5 14.5,11.83 14.5,11C14.5,10.17 13.83,9.5 13,9.5Z' })
	  );
	};
	
	var RoomServiceIcon = function RoomServiceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,17H22V19H2V17M13.84,7.79C13.94,7.54 14,7.27 14,7C14,5.9 13.1,5 12,5C10.9,5 10,5.9 10,7C10,7.27 10.06,7.54 10.16,7.79C6.2,8.61 3.27,11.97 3,16H21C20.73,11.97 17.8,8.61 13.84,7.79Z' })
	  );
	};
	
	var Rotate3dIcon = function Rotate3dIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,5C16.97,5 21,7.69 21,11C21,12.68 19.96,14.2 18.29,15.29C19.36,14.42 20,13.32 20,12.13C20,9.29 16.42,7 12,7V10L8,6L12,2V5M12,19C7.03,19 3,16.31 3,13C3,11.32 4.04,9.8 5.71,8.71C4.64,9.58 4,10.68 4,11.88C4,14.71 7.58,17 12,17V14L16,18L12,22V19Z' })
	  );
	};
	
	var RotateLeftVariantIcon = function RotateLeftVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H7C8.1,2 9,2.9 9,4V20C9,21.1 8.1,22 7,22H4C2.9,22 2,21.1 2,20V4C2,2.9 2.9,2 4,2M20,15C21.1,15 22,15.9 22,17V20C22,21.1 21.1,22 20,22H11V15H20M14,4C18.42,4 22,7.58 22,12L21.94,13H19.92L20,12C20,8.69 17.31,6 14,6V9L10,5L14,1V4Z' })
	  );
	};
	
	var RotateLeftIcon = function RotateLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,4.07V1L8.45,5.55L13,10V6.09C15.84,6.57 18,9.03 18,12C18,14.97 15.84,17.43 13,17.91V19.93C16.95,19.44 20,16.08 20,12C20,7.92 16.95,4.56 13,4.07M7.1,18.32C8.26,19.22 9.61,19.76 11,19.93V17.9C10.13,17.75 9.29,17.41 8.54,16.87L7.1,18.32M6.09,13H4.07C4.24,14.39 4.79,15.73 5.69,16.89L7.1,15.47C6.58,14.72 6.23,13.88 6.09,13M7.11,8.53L5.7,7.11C4.8,8.27 4.24,9.61 4.07,11H6.09C6.23,10.13 6.58,9.28 7.11,8.53Z' })
	  );
	};
	
	var RotateRightVariantIcon = function RotateRightVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,4V1L14,5L10,9V6C6.69,6 4,8.69 4,12L4.08,13H2.06L2,12C2,7.58 5.58,4 10,4M17,2H20C21.1,2 22,2.9 22,4V20C22,21.1 21.1,22 20,22H17C15.9,22 15,21.1 15,20V4C15,2.9 15.9,2 17,2M4,15H13V22H4C2.9,22 2,21.1 2,20V17C2,15.9 2.9,15 4,15Z' })
	  );
	};
	
	var RotateRightIcon = function RotateRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.89,15.5L18.31,16.89C19.21,15.73 19.76,14.39 19.93,13H17.91C17.77,13.87 17.43,14.72 16.89,15.5M13,17.9V19.92C14.39,19.75 15.74,19.21 16.9,18.31L15.46,16.87C14.71,17.41 13.87,17.76 13,17.9M19.93,11C19.76,9.61 19.21,8.27 18.31,7.11L16.89,8.53C17.43,9.28 17.77,10.13 17.91,11M15.55,5.55L11,1V4.07C7.06,4.56 4,7.92 4,12C4,16.08 7.05,19.44 11,19.93V17.91C8.16,17.43 6,14.97 6,12C6,9.03 8.16,6.57 11,6.09V10L15.55,5.55Z' })
	  );
	};
	
	var RoundedCornerIcon = function RoundedCornerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19H21V21H19V19M19,17H21V15H19V17M3,13H5V11H3V13M3,17H5V15H3V17M3,9H5V7H3V9M3,5H5V3H3V5M7,5H9V3H7V5M15,21H17V19H15V21M11,21H13V19H11V21M15,21H17V19H15V21M7,21H9V19H7V21M3,21H5V19H3V21M21,8C21,5.24 18.76,3 16,3H11V5H16C17.66,5 19,6.34 19,8V13H21V8Z' })
	  );
	};
	
	var RouterWirelessIcon = function RouterWirelessIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,13H20C20.55,13 21,13.45 21,14V18C21,18.55 20.55,19 20,19H4C3.45,19 3,18.55 3,18V14C3,13.45 3.45,13 4,13M9,17H10V15H9V17M5,15V17H7V15H5M19,6.93L17.6,8.34C16.15,6.89 14.15,6 11.93,6C9.72,6 7.72,6.89 6.27,8.34L4.87,6.93C6.68,5.12 9.18,4 11.93,4C14.69,4 17.19,5.12 19,6.93M16.17,9.76L14.77,11.17C14.04,10.45 13.04,10 11.93,10C10.82,10 9.82,10.45 9.1,11.17L7.7,9.76C8.78,8.67 10.28,8 11.93,8C13.58,8 15.08,8.67 16.17,9.76Z' })
	  );
	};
	
	var RoutesIcon = function RoutesIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,10H5L3,8L5,6H11V3L12,2L13,3V4H19L21,6L19,8H13V10H19L21,12L19,14H13V20C14.1,20 15,20.9 15,22H9C9,20.9 9.9,20 11,20V10Z' })
	  );
	};
	
	var RowingIcon = function RowingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.5,14.5L4,19L5.5,20.5L9,17H11L8.5,14.5M15,1C13.9,1 13,1.9 13,3C13,4.1 13.9,5 15,5C16.1,5 17,4.1 17,3C17,1.9 16.1,1 15,1M21,21L18,24L15,21V19.5L7.91,12.41C7.6,12.46 7.3,12.5 7,12.5V10.32C8.66,10.35 10.61,9.45 11.67,8.28L13.07,6.73C13.26,6.5 13.5,6.35 13.76,6.23C14.05,6.09 14.38,6 14.72,6H14.75C16,6 17,7 17,8.26V14C17,14.85 16.65,15.62 16.08,16.17L12.5,12.59V10.32C11.87,10.84 11.07,11.34 10.21,11.71L16.5,18H18L21,21Z' })
	  );
	};
	
	var RssBoxIcon = function RssBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M7.5,15C6.67,15 6,15.67 6,16.5C6,17.33 6.67,18 7.5,18C8.33,18 9,17.33 9,16.5C9,15.67 8.33,15 7.5,15M6,10V12C9.31,12 12,14.69 12,18H14C14,13.58 10.42,10 6,10M6,6V8C11.52,8 16,12.48 16,18H18C18,11.37 12.63,6 6,6Z' })
	  );
	};
	
	var RssIcon = function RssIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.18,15.64C7.38,15.64 8.36,16.62 8.36,17.82C8.36,19 7.38,20 6.18,20C5,20 4,19 4,17.82C4,16.62 4.98,15.64 6.18,15.64M4,4.44C12.59,4.44 19.56,11.41 19.56,20H16.73C16.73,12.97 11.03,7.27 4,7.27V4.44M4,10.1C9.47,10.1 13.9,14.53 13.9,20H11.07C11.07,16.1 7.9,12.93 4,12.93V10.1Z' })
	  );
	};
	
	var RulerIcon = function RulerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1.39,18.36L3.16,16.6L4.58,18L5.64,16.95L4.22,15.54L5.64,14.12L8.11,16.6L9.17,15.54L6.7,13.06L8.11,11.65L9.53,13.06L10.59,12L9.17,10.59L10.59,9.17L13.06,11.65L14.12,10.59L11.65,8.11L13.06,6.7L14.47,8.11L15.54,7.05L14.12,5.64L15.54,4.22L18,6.7L19.07,5.64L16.6,3.16L18.36,1.39L22.61,5.64L5.64,22.61L1.39,18.36Z' })
	  );
	};
	
	var RunFastIcon = function RunFastIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.5,5.5C17.6,5.5 18.5,4.6 18.5,3.5C18.5,2.4 17.6,1.5 16.5,1.5C15.4,1.5 14.5,2.4 14.5,3.5C14.5,4.6 15.4,5.5 16.5,5.5M12.9,19.4L13.9,15L16,17V23H18V15.5L15.9,13.5L16.5,10.5C17.89,12.09 19.89,13 22,13V11C20.24,11.03 18.6,10.11 17.7,8.6L16.7,7C16.34,6.4 15.7,6 15,6C14.7,6 14.5,6.1 14.2,6.1L9,8.3V13H11V9.6L12.8,8.9L11.2,17L6.3,16L5.9,18L12.9,19.4M4,9C3.45,9 3,8.55 3,8C3,7.45 3.45,7 4,7H7V9H4M5,5C4.45,5 4,4.55 4,4C4,3.45 4.45,3 5,3H10V5H5M3,13C2.45,13 2,12.55 2,12C2,11.45 2.45,11 3,11H7V13H3Z' })
	  );
	};
	
	var RunIcon = function RunIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.5,5.5C14.59,5.5 15.5,4.58 15.5,3.5C15.5,2.38 14.59,1.5 13.5,1.5C12.39,1.5 11.5,2.38 11.5,3.5C11.5,4.58 12.39,5.5 13.5,5.5M9.89,19.38L10.89,15L13,17V23H15V15.5L12.89,13.5L13.5,10.5C14.79,12 16.79,13 19,13V11C17.09,11 15.5,10 14.69,8.58L13.69,7C13.29,6.38 12.69,6 12,6C11.69,6 11.5,6.08 11.19,6.08L6,8.28V13H8V9.58L9.79,8.88L8.19,17L3.29,16L2.89,18L9.89,19.38Z' })
	  );
	};
	
	var SaleIcon = function SaleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.65,2.85L19.26,6.71L22.77,8.5L21,12L22.78,15.5L19.24,17.29L18.63,21.15L14.74,20.54L11.97,23.3L9.19,20.5L5.33,21.14L4.71,17.25L1.22,15.47L3,11.97L1.23,8.5L4.74,6.69L5.35,2.86L9.22,3.5L12,0.69L14.77,3.46L18.65,2.85M9.5,7C8.67,7 8,7.67 8,8.5C8,9.33 8.67,10 9.5,10C10.33,10 11,9.33 11,8.5C11,7.67 10.33,7 9.5,7M14.5,14C13.67,14 13,14.67 13,15.5C13,16.33 13.67,17 14.5,17C15.33,17 16,16.33 16,15.5C16,14.67 15.33,14 14.5,14M8.41,17L17,8.41L15.59,7L7,15.59L8.41,17Z' })
	  );
	};
	
	var SalesforceIcon = function SalesforceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.38,6.37C17.68,6.37 17.07,6.58 16.47,6.78C15.77,5.57 14.46,4.77 13.05,4.77C11.95,4.77 10.95,5.27 10.24,5.97C9.44,4.97 8.23,4.26 6.83,4.26C4.5,4.26 2.5,6.17 2.5,8.5C2.5,9.09 2.71,9.69 2.91,10.29C1.8,10.9 1,12.1 1,13.5C1,15.5 2.61,17.22 4.62,17.22C4.92,17.22 5.22,17.22 5.42,17.12C5.82,18.63 7.33,19.74 9.14,19.74C10.84,19.74 12.25,18.73 12.75,17.32C13.26,17.53 13.76,17.73 14.26,17.73C15.57,17.73 16.77,17 17.37,15.92C17.68,16 18,16 18.28,16C20.89,16 23,13.91 23,11.2C23.1,8.5 21,6.37 18.38,6.37Z' })
	  );
	};
	
	var SassIcon = function SassIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M10,15.33C10.16,15.87 10.14,16.37 10,16.83C10,16.88 9.96,16.93 9.94,17C9.92,17 9.9,17.07 9.87,17.12C9.76,17.36 9.6,17.59 9.41,17.79C8.83,18.43 8,18.67 7.67,18.47C7.29,18.25 7.5,17.35 8.16,16.64C8.88,15.88 9.92,15.38 9.92,15.38V15.38L10,15.33M18.27,6.28C17.82,4.5 14.87,3.92 12.09,4.91C10.43,5.5 8.63,6.42 7.34,7.63C5.81,9.07 5.56,10.32 5.66,10.84C6,12.68 8.54,13.89 9.58,14.78V14.79C9.28,14.94 7.04,16.07 6.5,17.23C5.96,18.45 6.6,19.33 7,19.45C8.34,19.81 9.69,19.16 10.41,18.07C11.11,17.03 11.06,15.68 10.75,15C11.17,14.9 11.66,14.85 12.28,14.92C14.04,15.13 14.38,16.22 14.31,16.68C14.25,17.14 13.88,17.39 13.76,17.47C13.64,17.54 13.6,17.57 13.61,17.63C13.62,17.71 13.68,17.71 13.78,17.69C13.93,17.66 14.71,17.32 14.74,16.47C14.78,15.39 13.75,14.19 11.93,14.22C11.18,14.24 10.71,14.31 10.37,14.44L10.29,14.35C9.16,13.15 7.08,12.3 7.17,10.68C7.2,10.09 7.4,8.55 11.17,6.67C14.25,5.13 16.72,5.55 17.15,6.5C17.76,7.83 15.83,10.32 12.63,10.68C11.41,10.82 10.76,10.34 10.6,10.17C10.43,10 10.41,9.97 10.35,10C10.24,10.07 10.31,10.23 10.35,10.33C10.44,10.58 10.84,11 11.5,11.24C12.09,11.43 13.53,11.54 15.26,10.87C17.2,10.12 18.72,8.03 18.27,6.28Z' })
	  );
	};
	
	var SatelliteUplinkIcon = function SatelliteUplinkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.86,2L11.34,3.93C15.75,4.78 19.2,8.23 20.05,12.65L22,12.13C20.95,7.03 16.96,3.04 11.86,2M10.82,5.86L10.3,7.81C13.34,8.27 15.72,10.65 16.18,13.68L18.12,13.16C17.46,9.44 14.55,6.5 10.82,5.86M3.72,9.69C3.25,10.73 3,11.86 3,13C3,14.95 3.71,16.82 5,18.28V22H8V20.41C8.95,20.8 9.97,21 11,21C12.14,21 13.27,20.75 14.3,20.28L3.72,9.69M9.79,9.76L9.26,11.72C10.92,11.72 12.26,13.06 12.26,14.72L14.23,14.2C14,11.86 12.13,10 9.79,9.76Z' })
	  );
	};
	
	var SatelliteVariantIcon = function SatelliteVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.62,1L17.28,6.67L15.16,8.79L13.04,6.67L11.62,8.09L13.95,10.41L12.79,11.58L13.24,12.04C14.17,11.61 15.31,11.77 16.07,12.54L12.54,16.07C11.77,15.31 11.61,14.17 12.04,13.24L11.58,12.79L10.41,13.95L8.09,11.62L6.67,13.04L8.79,15.16L6.67,17.28L1,11.62L3.14,9.5L5.26,11.62L6.67,10.21L3.84,7.38C3.06,6.6 3.06,5.33 3.84,4.55L4.55,3.84C5.33,3.06 6.6,3.06 7.38,3.84L10.21,6.67L11.62,5.26L9.5,3.14L11.62,1M18,14C18,16.21 16.21,18 14,18V16C15.1,16 16,15.1 16,14H18M22,14C22,18.42 18.42,22 14,22V20C17.31,20 20,17.31 20,14H22Z' })
	  );
	};
	
	var SatelliteIcon = function SatelliteIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,18L8.5,13.5L11,16.5L14.5,12L19,18M5,12V10C7.76,10 10,7.76 10,5H12C12,8.87 8.87,12 5,12M5,5H8C8,6.66 6.66,8 5,8M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z' })
	  );
	};
	
	var SausageIcon = function SausageIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.5,3H9.5L7.96,5.32C9.16,5.87 10,7.09 10,8.5C10,11.54 12.46,14 15.5,14C16.91,14 18.13,14.84 18.68,16.04L21,14.5V20.5L18.68,18.96C18.13,20.16 16.91,21 15.5,21C8.6,21 3,15.4 3,8.5C3,7.09 3.84,5.87 5.04,5.32L3.5,3Z' })
	  );
	};
	
	var SaxophoneIcon = function SaxophoneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2C3.45,2 3,2.45 3,3C3,3.55 3.45,4 4,4C5.66,4 7,5.34 7,7V8.66L7,15.5C7,19.1 9.9,22 13.5,22C17.1,22 20,19.1 20,15.5V13C20.55,13 21,12.55 21,12C21,11.45 20.55,11 20,11H14C13.45,11 13,11.45 13,12C13,12.55 13.45,13 14,13V15C14,15.55 13.55,16 13,16C12.45,16 12,15.55 12,15V11C12.55,11 13,10.55 13,10C13,9.45 12.55,9 12,9V8C12.55,8 13,7.55 13,7C13,6.45 12.55,6 12,6V5.5C12,3.57 10.43,2 8.5,2H4Z' })
	  );
	};
	
	var ScaleBalanceIcon = function ScaleBalanceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C10.73,3 9.6,3.8 9.18,5H3V7H4.95L2,14C1.53,16 3,17 5.5,17C8,17 9.56,16 9,14L6.05,7H9.17C9.5,7.85 10.15,8.5 11,8.83V20H2V22H22V20H13V8.82C13.85,8.5 14.5,7.85 14.82,7H17.95L15,14C14.53,16 16,17 18.5,17C21,17 22.56,16 22,14L19.05,7H21V5H14.83C14.4,3.8 13.27,3 12,3M12,5C12.55,5 13,5.45 13,6C13,6.55 12.55,7 12,7C11.45,7 11,6.55 11,6C11,5.45 11.45,5 12,5M5.5,10.25L7,14H4L5.5,10.25M18.5,10.25L20,14H17L18.5,10.25Z' })
	  );
	};
	
	var ScaleBathroomIcon = function ScaleBathroomIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,2H19C20.1,2 21,2.9 21,4V20C21,21.1 20.1,22 19,22H5C3.9,22 3,21.1 3,20V4C3,2.9 3.9,2 5,2M12,4C9.79,4 8,5.79 8,8H11.26L10.85,5.23L12.9,8H16C16,5.79 14.21,4 12,4M5,10V20H19V10H5Z' })
	  );
	};
	
	var ScaleIcon = function ScaleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.46,15.06L7.05,16.47L5.68,15.1C4.82,16.21 4.24,17.54 4.06,19H6V21H2V20C2,15.16 5.44,11.13 10,10.2V8.2L2,5V3H22V5L14,8.2V10.2C18.56,11.13 22,15.16 22,20V21H18V19H19.94C19.76,17.54 19.18,16.21 18.32,15.1L16.95,16.47L15.54,15.06L16.91,13.68C15.8,12.82 14.46,12.24 13,12.06V14H11V12.06C9.54,12.24 8.2,12.82 7.09,13.68L8.46,15.06M12,18C13.1,18 14,18.9 14,20C14,21.1 13.1,22 12,22C11.68,22 11.38,21.93 11.12,21.79L7.27,20L11.12,18.21C11.38,18.07 11.68,18 12,18Z' })
	  );
	};
	
	var ScannerOffIcon = function ScannerOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L16.73,20H5C3.9,20 3,19.1 3,18V12.5C3,11.7 3.5,10.9 4.2,10.7L6.57,9.84L2,5.27M6.4,12H8.73L8.11,11.38L6.4,12M5,15V17H13.73L11.73,15H5M19.8,5L20.5,6.9L11.85,10.03L10.3,8.47L19.8,5M19,12C20.1,12 21,12.9 21,14V18C21,18.34 20.91,18.66 20.76,18.94L19,17.18V15H16.82L13.82,12H19Z' })
	  );
	};
	
	var ScannerIcon = function ScannerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.2,10.7L19.8,5L20.5,6.9L6.4,12H19C20.1,12 21,12.9 21,14V18C21,19.1 20.1,20 19,20H5C3.9,20 3,19.1 3,18V12.5C3,11.7 3.5,10.9 4.2,10.7M17,17H19V15H17V17M5,17H15V15H5V17Z' })
	  );
	};
	
	var SchoolIcon = function SchoolIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z' })
	  );
	};
	
	var ScreenRotationLockIcon = function ScreenRotationLockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.8,2.5C16.8,1.56 17.56,0.8 18.5,0.8C19.44,0.8 20.2,1.56 20.2,2.5V3H16.8V2.5M16,9H21C21.55,9 22,8.55 22,8V4C22,3.45 21.55,3 21,3V2.5C21,1.12 19.88,0 18.5,0C17.12,0 16,1.12 16,2.5V3C15.45,3 15,3.45 15,4V8C15,8.55 15.45,9 16,9M8.47,20.5C5.2,18.94 2.86,15.76 2.5,12H1C1.5,18.16 6.66,23 12.95,23L13.61,22.97L9.8,19.15L8.47,20.5M23.25,12.77L20.68,10.2L19.27,11.61L21.5,13.83L15.83,19.5L4.5,8.17L10.17,2.5L12.27,4.61L13.68,3.2L11.23,0.75C10.64,0.16 9.69,0.16 9.11,0.75L2.75,7.11C2.16,7.7 2.16,8.65 2.75,9.23L14.77,21.25C15.36,21.84 16.31,21.84 16.89,21.25L23.25,14.89C23.84,14.3 23.84,13.35 23.25,12.77Z' })
	  );
	};
	
	var ScreenRotationIcon = function ScreenRotationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.5,21.5C4.25,19.94 1.91,16.76 1.55,13H0.05C0.56,19.16 5.71,24 12,24L12.66,23.97L8.85,20.16M14.83,21.19L2.81,9.17L9.17,2.81L21.19,14.83M10.23,1.75C9.64,1.16 8.69,1.16 8.11,1.75L1.75,8.11C1.16,8.7 1.16,9.65 1.75,10.23L13.77,22.25C14.36,22.84 15.31,22.84 15.89,22.25L22.25,15.89C22.84,15.3 22.84,14.35 22.25,13.77L10.23,1.75M16.5,2.5C19.75,4.07 22.09,7.24 22.45,11H23.95C23.44,4.84 18.29,0 12,0L11.34,0.03L15.15,3.84L16.5,2.5Z' })
	  );
	};
	
	var ScrewdriverIcon = function ScrewdriverIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,1.83C17.5,1.83 17,2 16.59,2.41C13.72,5.28 8,11 8,11L9.5,12.5L6,16H4L2,20L4,22L8,20V18L11.5,14.5L13,16C13,16 18.72,10.28 21.59,7.41C22.21,6.5 22.37,5.37 21.59,4.59L19.41,2.41C19,2 18.5,1.83 18,1.83M18,4L20,6L13,13L11,11L18,4Z' })
	  );
	};
	
	var ScriptIcon = function ScriptIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,20C15.1,20 16,19.1 16,18V5H9C8.45,5 8,5.45 8,6V16H5V5C5,3.34 6.34,2 8,2H19C20.66,2 22,3.34 22,5V6H18V18L18,19C18,20.66 16.66,22 15,22H5C3.34,22 2,20.66 2,19V18H12C12,19.1 12.9,20 14,20Z' })
	  );
	};
	
	var SdIcon = function SdIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,8H16V4H18M15,8H13V4H15M12,8H10V4H12M18,2H10L4,8V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V4C20,2.9 19.1,2 18,2Z' })
	  );
	};
	
	var SealIcon = function SealIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.39,19.37L16.38,18L15,22L11.92,16L9,22L7.62,18L3.61,19.37L6.53,13.37C5.57,12.17 5,10.65 5,9C5,5.13 8.13,2 12,2C15.87,2 19,5.13 19,9C19,10.65 18.43,12.17 17.47,13.37L20.39,19.37M7,9L9.69,10.34L9.5,13.34L12,11.68L14.5,13.33L14.33,10.34L17,9L14.32,7.65L14.5,4.67L12,6.31L9.5,4.65L9.67,7.66L7,9Z' })
	  );
	};
	
	var SearchWebIcon = function SearchWebIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.5,14L20.5,19L19,20.5L14,15.5V14.71L13.73,14.43C12.59,15.41 11.11,16 9.5,16C5.91,16 3,13.09 3,9.5C3,5.91 5.91,3 9.5,3C13.09,3 16,5.91 16,9.5C16,11.11 15.41,12.59 14.43,13.73L14.71,14H15.5M9.5,4.5L8.95,4.53C8.71,5.05 8.34,5.93 8.07,7H10.93C10.66,5.93 10.29,5.05 10.05,4.53C9.87,4.5 9.69,4.5 9.5,4.5M13.83,7C13.24,5.97 12.29,5.17 11.15,4.78C11.39,5.31 11.7,6.08 11.93,7H13.83M5.17,7H7.07C7.3,6.08 7.61,5.31 7.85,4.78C6.71,5.17 5.76,5.97 5.17,7M4.5,9.5C4.5,10 4.58,10.53 4.73,11H6.87L6.75,9.5L6.87,8H4.73C4.58,8.47 4.5,9 4.5,9.5M14.27,11C14.42,10.53 14.5,10 14.5,9.5C14.5,9 14.42,8.47 14.27,8H12.13C12.21,8.5 12.25,9 12.25,9.5C12.25,10 12.21,10.5 12.13,11H14.27M7.87,8L7.75,9.5L7.87,11H11.13C11.21,10.5 11.25,10 11.25,9.5C11.25,9 11.21,8.5 11.13,8H7.87M9.5,14.5C9.68,14.5 9.86,14.5 10.03,14.47C10.28,13.95 10.66,13.07 10.93,12H8.07C8.34,13.07 8.72,13.95 8.97,14.47L9.5,14.5M13.83,12H11.93C11.7,12.92 11.39,13.69 11.15,14.22C12.29,13.83 13.24,13.03 13.83,12M5.17,12C5.76,13.03 6.71,13.83 7.85,14.22C7.61,13.69 7.3,12.92 7.07,12H5.17Z' })
	  );
	};
	
	var SeatFlatAngledIcon = function SeatFlatAngledIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22.25,14.29L21.56,16.18L9.2,11.71L11.28,6.05L19.84,9.14C21.94,9.9 23,12.2 22.25,14.29M1.5,12.14L8,14.5V19H16V17.37L20.5,19L21.21,17.11L2.19,10.25M7.3,10.2C8.79,9.5 9.42,7.69 8.71,6.2C8,4.71 6.2,4.08 4.7,4.8C3.21,5.5 2.58,7.3 3.3,8.8C4,10.29 5.8,10.92 7.3,10.2Z' })
	  );
	};
	
	var SeatFlatIcon = function SeatFlatIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,11V13H9V7H18C20.21,7 22,8.79 22,11M2,14V16H8V18H16V16H22V14M7.14,12.1C8.3,10.91 8.28,9 7.1,7.86C5.91,6.7 4,6.72 2.86,7.9C1.7,9.09 1.72,11 2.9,12.14C4.09,13.3 6,13.28 7.14,12.1Z' })
	  );
	};
	
	var SeatIndividualSuiteIcon = function SeatIndividualSuiteIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,13C8.66,13 10,11.66 10,10C10,8.34 8.66,7 7,7C5.34,7 4,8.34 4,10C4,11.66 5.34,13 7,13M19,7H11V14H3V7H1V17H23V11C23,8.79 21.21,7 19,7Z' })
	  );
	};
	
	var SeatLegroomExtraIcon = function SeatLegroomExtraIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,12V3H2V12C2,14.76 4.24,17 7,17H13V15H7C5.34,15 4,13.66 4,12M22.83,17.24C22.45,16.5 21.54,16.27 20.8,16.61L19.71,17.11L16.3,10.13C15.96,9.45 15.27,9 14.5,9H11V3H5V11C5,12.66 6.34,14 8,14H15L18.41,21L22.13,19.3C22.9,18.94 23.23,18 22.83,17.24Z' })
	  );
	};
	
	var SeatLegroomNormalIcon = function SeatLegroomNormalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,12V3H3V12C3,14.76 5.24,17 8,17H14V15H8C6.34,15 5,13.66 5,12M20.5,18H19V11C19,9.9 18.1,9 17,9H12V3H6V11C6,12.66 7.34,14 9,14H16V21H20.5C21.33,21 22,20.33 22,19.5C22,18.67 21.33,18 20.5,18Z' })
	  );
	};
	
	var SeatLegroomReducedIcon = function SeatLegroomReducedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.97,19.2C20.15,20.16 19.42,21 18.5,21H14V18L15,14H9C7.34,14 6,12.66 6,11V3H12V9H17C18.1,9 19,9.9 19,11L17,18H18.44C19.17,18 19.83,18.5 19.97,19.2M5,12V3H3V12C3,14.76 5.24,17 8,17H12V15H8C6.34,15 5,13.66 5,12Z' })
	  );
	};
	
	var SeatReclineExtraIcon = function SeatReclineExtraIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.35,5.64C4.45,5 4.23,3.76 4.86,2.85C5.5,1.95 6.74,1.73 7.65,2.36C8.55,3 8.77,4.24 8.14,5.15C7.5,6.05 6.26,6.27 5.35,5.64M16,19H8.93C7.45,19 6.19,17.92 5.97,16.46L4,7H2L4,16.76C4.37,19.2 6.47,21 8.94,21H16M16.23,15H11.35L10.32,10.9C11.9,11.79 13.6,12.44 15.47,12.12V10C13.84,10.3 12.03,9.72 10.78,8.74L9.14,7.47C8.91,7.29 8.65,7.17 8.38,7.09C8.06,7 7.72,6.97 7.39,7.03H7.37C6.14,7.25 5.32,8.42 5.53,9.64L6.88,15.56C7.16,17 8.39,18 9.83,18H16.68L20.5,21L22,19.5' })
	  );
	};
	
	var SeatReclineNormalIcon = function SeatReclineNormalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.59,5.41C6.81,4.63 6.81,3.36 7.59,2.58C8.37,1.8 9.64,1.8 10.42,2.58C11.2,3.36 11.2,4.63 10.42,5.41C9.63,6.2 8.37,6.2 7.59,5.41M6,16V7H4V16C4,18.76 6.24,21 9,21H15V19H9C7.34,19 6,17.66 6,16M20,20.07L14.93,15H11.5V11.32C12.9,12.47 15.1,13.5 17,13.5V11.32C15.34,11.34 13.39,10.45 12.33,9.28L10.93,7.73C10.74,7.5 10.5,7.35 10.24,7.23C9.95,7.09 9.62,7 9.28,7H9.25C8,7 7,8 7,9.25V15C7,16.66 8.34,18 10,18H15.07L18.57,21.5' })
	  );
	};
	
	var SecurityAccountIcon = function SecurityAccountIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,5C13.66,5 15,6.34 15,8C15,9.66 13.66,11 12,11C10.34,11 9,9.66 9,8C9,6.34 10.34,5 12,5M17.13,17C15.92,18.85 14.11,20.24 12,20.92C9.89,20.24 8.08,18.85 6.87,17C6.53,16.5 6.24,16 6,15.47C6,13.82 8.71,12.47 12,12.47C15.29,12.47 18,13.79 18,15.47C17.76,16 17.47,16.5 17.13,17Z' })
	  );
	};
	
	var SecurityCloseIcon = function SecurityCloseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M17,15.59L15.59,17L12,13.41L8.41,17L7,15.59L10.59,12L7,8.41L8.41,7L12,10.59L15.59,7L17,8.41L13.41,12L17,15.59Z' })
	  );
	};
	
	var SecurityHomeIcon = function SecurityHomeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,13H13V16H16V11H18L12,6L6,11H8V16H11V13M12,1L21,5V11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1Z' })
	  );
	};
	
	var SecurityLockIcon = function SecurityLockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.1 14.8,9.5V11C15.4,11 16,11.6 16,12.3V15.8C16,16.4 15.4,17 14.7,17H9.2C8.6,17 8,16.4 8,15.7V12.2C8,11.6 8.6,11 9.2,11V9.5C9.2,8.1 10.6,7 12,7M12,8.2C11.2,8.2 10.5,8.7 10.5,9.5V11H13.5V9.5C13.5,8.7 12.8,8.2 12,8.2Z' })
	  );
	};
	
	var SecurityNetworkIcon = function SecurityNetworkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,18H14C14.55,18 15,18.45 15,19H22V21H15C15,21.55 14.55,22 14,22H10C9.45,22 9,21.55 9,21H2V19H9C9,18.45 9.45,18 10,18H11V16.34C8.07,15.13 6,12 6,8.67V4.67L12,2L18,4.67V8.67C18,12 15.93,15.13 13,16.34V18M12,4L8,5.69V9H12V4M12,9V15C13.91,14.53 16,12.06 16,10V9H12Z' })
	  );
	};
	
	var SecurityOffIcon = function SecurityOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,4.27L2.28,3L20.5,21.22L19.23,22.5L17,20.25C15.57,21.57 13.87,22.54 12,23C6.84,21.74 3,16.55 3,11V6.27L1,4.27M12,1L21,5V11C21,13.28 20.35,15.5 19.23,17.41L5.65,3.82L12,1Z' })
	  );
	};
	
	var SecurityIcon = function SecurityIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,12H19C18.47,16.11 15.72,19.78 12,20.92V12H5V6.3L12,3.19M12,1L3,5V11C3,16.55 6.84,21.73 12,23C17.16,21.73 21,16.55 21,11V5L12,1Z' })
	  );
	};
	
	var SelectAllIcon = function SelectAllIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,9H15V15H9M7,17H17V7H7M15,5H17V3H15M15,21H17V19H15M19,17H21V15H19M19,9H21V7H19M19,21C20.1,21 21,20.1 21,19H19M19,13H21V11H19M11,21H13V19H11M9,3H7V5H9M3,17H5V15H3M5,21V19H3C3,20.1 3.9,21 5,21M19,3V5H21C21,3.9 20.1,3 19,3M13,3H11V5H13M3,9H5V7H3M7,21H9V19H7M3,13H5V11H3M3,5H5V3C3.9,3 3,3.9 3,5Z' })
	  );
	};
	
	var SelectInverseIcon = function SelectInverseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H7V5H9V3H11V5H13V3H15V5H17V3H19V5H21V7H19V9H21V11H19V13H21V15H19V17H21V19H19V21H17V19H15V21H13V19H11V21H9V19H7V21H5V19H3V17H5V15H3V13H5V11H3V9H5V7H3V5H5V3Z' })
	  );
	};
	
	var SelectOffIcon = function SelectOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,4.27L2.28,3L21,21.72L19.73,23L17,20.27V21H15V19H15.73L5,8.27V9H3V7H3.73L1,4.27M20,3C20.55,3 21,3.45 21,4V5H19V3H20M15,5V3H17V5H15M11,5V3H13V5H11M7,5V3H9V5H7M11,21V19H13V21H11M7,21V19H9V21H7M4,21C3.45,21 3,20.55 3,20V19H5V21H4M3,15H5V17H3V15M21,15V17H19V15H21M3,11H5V13H3V11M21,11V13H19V11H21M21,7V9H19V7H21Z' })
	  );
	};
	
	var SelectIcon = function SelectIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,3H5V5H3V4C3,3.45 3.45,3 4,3M20,3C20.55,3 21,3.45 21,4V5H19V3H20M15,5V3H17V5H15M11,5V3H13V5H11M7,5V3H9V5H7M21,20C21,20.55 20.55,21 20,21H19V19H21V20M15,21V19H17V21H15M11,21V19H13V21H11M7,21V19H9V21H7M4,21C3.45,21 3,20.55 3,20V19H5V21H4M3,15H5V17H3V15M21,15V17H19V15H21M3,11H5V13H3V11M21,11V13H19V11H21M3,7H5V9H3V7M21,7V9H19V7H21Z' })
	  );
	};
	
	var SelectionOffIcon = function SelectionOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M0.5,3.77L1.78,2.5L21.5,22.22L20.23,23.5L18.73,22H17V20.27L3.73,7H2V5.27L0.5,3.77M4,2H7V4H5.82L3.83,2H4M22,4V7H20V4H17V2H20C21.1,2 22,2.9 22,4M20,17H22V20L22,20.17L20,18.18V17M2,20V17H4V20H7V22H4C2.9,22 2,21.1 2,20M10,2H14V4H10V2M10,20H14V22H10V20M20,10H22V14H20V10M2,10H4V14H2V10Z' })
	  );
	};
	
	var SelectionIcon = function SelectionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,4C2,2.89 2.9,2 4,2H7V4H4V7H2V4M22,4V7H20V4H17V2H20C21.1,2 22,2.9 22,4M20,20V17H22V20C22,21.11 21.1,22 20,22H17V20H20M2,20V17H4V20H7V22H4C2.9,22 2,21.1 2,20M10,2H14V4H10V2M10,20H14V22H10V20M20,10H22V14H20V10M2,10H4V14H2V10Z' })
	  );
	};
	
	var SendSecureIcon = function SendSecureIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,18V17.5C23,16.12 21.88,15 20.5,15C19.12,15 18,16.12 18,17.5V18C17.45,18 17,18.45 17,19V23C17,23.55 17.45,24 18,24H23C23.55,24 24,23.55 24,23V19C24,18.45 23.55,18 23,18M22,18H19V17.5C19,16.67 19.67,16 20.5,16C21.33,16 22,16.67 22,17.5V18M23,12L2,21V14L17,12L2,10V3L23,12Z' })
	  );
	};
	
	var SendIcon = function SendIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,21L23,12L2,3V10L17,12L2,14V21Z' })
	  );
	};
	
	var SerialPortIcon = function SerialPortIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,3H17V5H19V8H16V14H8V8H5V5H7V3M17,9H19V14H17V9M11,15H13V22H11V15M5,9H7V14H5V9Z' })
	  );
	};
	
	var ServerMinusIcon = function ServerMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H20C20.55,4 21,4.45 21,5V9C21,9.55 20.55,10 20,10H4C3.45,10 3,9.55 3,9V5C3,4.45 3.45,4 4,4M9,8H10V6H9V8M5,6V8H7V6H5M8,16H16V18H8V16Z' })
	  );
	};
	
	var ServerNetworkOffIcon = function ServerNetworkOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,18H14C14.55,18 15,18.45 15,19H15.73L13,16.27V18M22,19V20.18L20.82,19H22M21,21.72L19.73,23L17.73,21H15C15,21.55 14.55,22 14,22H10C9.45,22 9,21.55 9,21H2V19H9C9,18.45 9.45,18 10,18H11V16H4C3.45,16 3,15.55 3,15V11C3,10.45 3.45,10 4,10H6.73L4.73,8H4C3.45,8 3,7.55 3,7V6.27L1,4.27L2.28,3L21,21.72M4,2H20C20.55,2 21,2.45 21,3V7C21,7.55 20.55,8 20,8H9.82L7,5.18V4H5.82L3.84,2C3.89,2 3.94,2 4,2M20,10C20.55,10 21,10.45 21,11V15C21,15.55 20.55,16 20,16H17.82L11.82,10H20M9,6H10V4H9V6M9,14H10V13.27L9,12.27V14M5,12V14H7V12H5Z' })
	  );
	};
	
	var ServerNetworkIcon = function ServerNetworkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,18H14C14.55,18 15,18.45 15,19H22V21H15C15,21.55 14.55,22 14,22H10C9.45,22 9,21.55 9,21H2V19H9C9,18.45 9.45,18 10,18H11V16H4C3.45,16 3,15.55 3,15V11C3,10.45 3.45,10 4,10H20C20.55,10 21,10.45 21,11V15C21,15.55 20.55,16 20,16H13V18M4,2H20C20.55,2 21,2.45 21,3V7C21,7.55 20.55,8 20,8H4C3.45,8 3,7.55 3,7V3C3,2.45 3.45,2 4,2M9,6H10V4H9V6M9,14H10V12H9V14M5,4V6H7V4H5M5,12V14H7V12H5Z' })
	  );
	};
	
	var ServerOffIcon = function ServerOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,1H20C20.55,1 21,1.45 21,2V6C21,6.55 20.55,7 20,7H8.82L6.82,5H7V3H5V3.18L3.21,1.39C3.39,1.15 3.68,1 4,1M22,22.72L20.73,24L19.73,23H4C3.45,23 3,22.55 3,22V18C3,17.45 3.45,17 4,17H13.73L11.73,15H4C3.45,15 3,14.55 3,14V10C3,9.45 3.45,9 4,9H5.73L3.68,6.95C3.38,6.85 3.15,6.62 3.05,6.32L1,4.27L2.28,3L22,22.72M20,9C20.55,9 21,9.45 21,10V14C21,14.55 20.55,15 20,15H16.82L10.82,9H20M20,17C20.55,17 21,17.45 21,18V19.18L18.82,17H20M9,5H10V3H9V5M9,13H9.73L9,12.27V13M9,21H10V19H9V21M5,11V13H7V11H5M5,19V21H7V19H5Z' })
	  );
	};
	
	var ServerPlusIcon = function ServerPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H20C20.55,4 21,4.45 21,5V9C21,9.55 20.55,10 20,10H4C3.45,10 3,9.55 3,9V5C3,4.45 3.45,4 4,4M9,8H10V6H9V8M5,6V8H7V6H5M8,16H11V13H13V16H16V18H13V21H11V18H8V16Z' })
	  );
	};
	
	var ServerRemoveIcon = function ServerRemoveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H20C20.55,4 21,4.45 21,5V9C21,9.55 20.55,10 20,10H4C3.45,10 3,9.55 3,9V5C3,4.45 3.45,4 4,4M9,8H10V6H9V8M5,6V8H7V6H5M10.59,17L8,14.41L9.41,13L12,15.59L14.59,13L16,14.41L13.41,17L16,19.59L14.59,21L12,18.41L9.41,21L8,19.59L10.59,17Z' })
	  );
	};
	
	var ServerSecurityIcon = function ServerSecurityIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,1H19C19.55,1 20,1.45 20,2V6C20,6.55 19.55,7 19,7H3C2.45,7 2,6.55 2,6V2C2,1.45 2.45,1 3,1M3,9H19C19.55,9 20,9.45 20,10V10.67L17.5,9.56L11,12.44V15H3C2.45,15 2,14.55 2,14V10C2,9.45 2.45,9 3,9M3,17H11C11.06,19.25 12,21.4 13.46,23H3C2.45,23 2,22.55 2,22V18C2,17.45 2.45,17 3,17M8,5H9V3H8V5M8,13H9V11H8V13M8,21H9V19H8V21M4,3V5H6V3H4M4,11V13H6V11H4M4,19V21H6V19H4M17.5,12L22,14V17C22,19.78 20.08,22.37 17.5,23C14.92,22.37 13,19.78 13,17V14L17.5,12M17.5,13.94L15,15.06V17.72C15,19.26 16.07,20.7 17.5,21.06V13.94Z' })
	  );
	};
	
	var ServerIcon = function ServerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,1H20C20.55,1 21,1.45 21,2V6C21,6.55 20.55,7 20,7H4C3.45,7 3,6.55 3,6V2C3,1.45 3.45,1 4,1M4,9H20C20.55,9 21,9.45 21,10V14C21,14.55 20.55,15 20,15H4C3.45,15 3,14.55 3,14V10C3,9.45 3.45,9 4,9M4,17H20C20.55,17 21,17.45 21,18V22C21,22.55 20.55,23 20,23H4C3.45,23 3,22.55 3,22V18C3,17.45 3.45,17 4,17M9,5H10V3H9V5M9,13H10V11H9V13M9,21H10V19H9V21M5,3V5H7V3H5M5,11V13H7V11H5M5,19V21H7V19H5Z' })
	  );
	};
	
	var SetAllIcon = function SetAllIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5C18.87,5 22,8.13 22,12C22,15.87 18.87,19 15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19C5.13,19 2,15.87 2,12C2,8.13 5.13,5 9,5M8.5,12C8.5,13.87 9.29,15.56 10.56,16.75L11.56,16.29C10.31,15.29 9.5,13.74 9.5,12C9.5,10.26 10.31,8.71 11.56,7.71L10.56,7.25C9.29,8.44 8.5,10.13 8.5,12M15.5,12C15.5,10.13 14.71,8.44 13.44,7.25L12.44,7.71C13.69,8.71 14.5,10.26 14.5,12C14.5,13.74 13.69,15.29 12.44,16.29L13.44,16.75C14.71,15.56 15.5,13.87 15.5,12Z' })
	  );
	};
	
	var SetCenterRightIcon = function SetCenterRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19C5.13,19 2,15.87 2,12C2,8.13 5.13,5 9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5C18.87,5 22,8.13 22,12C22,15.87 18.87,19 15,19M9,17L10,16.89C8.72,15.59 8,13.83 8,12C8,10.17 8.72,8.41 10,7.1L9,7C6.24,7 4,9.24 4,12C4,14.76 6.24,17 9,17M15.5,12C15.5,10.13 14.71,8.44 13.44,7.25L12.44,7.71C13.69,8.71 14.5,10.26 14.5,12C14.5,13.74 13.69,15.29 12.44,16.29L13.44,16.75C14.71,15.56 15.5,13.87 15.5,12Z' })
	  );
	};
	
	var SetCenterIcon = function SetCenterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,5C5.13,5 2,8.13 2,12C2,15.87 5.13,19 9,19C10.04,19 11.06,18.76 12,18.32C12.94,18.76 13.96,19 15,19C18.87,19 22,15.87 22,12C22,8.13 18.87,5 15,5C13.96,5 12.94,5.24 12,5.68C11.06,5.24 10.04,5 9,5M9,7C9.34,7 9.67,7.03 10,7.1C8.72,8.41 8,10.17 8,12C8,13.83 8.72,15.59 10,16.89C9.67,16.96 9.34,17 9,17C6.24,17 4,14.76 4,12C4,9.24 6.24,7 9,7M15,7C17.76,7 20,9.24 20,12C20,14.76 17.76,17 15,17C14.66,17 14.33,16.97 14,16.9C15.28,15.59 16,13.83 16,12C16,10.17 15.28,8.41 14,7.11C14.33,7.04 14.66,7 15,7Z' })
	  );
	};
	
	var SetLeftCenterIcon = function SetLeftCenterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5C18.87,5 22,8.13 22,12C22,15.87 18.87,19 15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19C5.13,19 2,15.87 2,12C2,8.13 5.13,5 9,5M15,7L14,7.11C15.28,8.41 16,10.17 16,12C16,13.83 15.28,15.59 14,16.9L15,17C17.76,17 20,14.76 20,12C20,9.24 17.76,7 15,7M8.5,12C8.5,13.87 9.29,15.56 10.56,16.75L11.56,16.29C10.31,15.29 9.5,13.74 9.5,12C9.5,10.26 10.31,8.71 11.56,7.71L10.56,7.25C9.29,8.44 8.5,10.13 8.5,12Z' })
	  );
	};
	
	var SetLeftRightIcon = function SetLeftRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5C18.87,5 22,8.13 22,12C22,15.87 18.87,19 15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19C5.13,19 2,15.87 2,12C2,8.13 5.13,5 9,5M9,12C9,14.22 10.21,16.16 12,17.2C13.79,16.16 15,14.22 15,12C15,9.78 13.79,7.84 12,6.8C10.21,7.84 9,9.78 9,12Z' })
	  );
	};
	
	var SetLeftIcon = function SetLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,5C5.13,5 2,8.13 2,12C2,15.87 5.13,19 9,19C10.04,19 11.06,18.76 12,18.32C12.94,18.76 13.96,19 15,19C18.87,19 22,15.87 22,12C22,8.13 18.87,5 15,5C13.96,5 12.94,5.24 12,5.68C11.06,5.24 10.04,5 9,5M15,7C17.76,7 20,9.24 20,12C20,14.76 17.76,17 15,17C14.66,17 14.33,16.97 14,16.9C15.28,15.59 16,13.83 16,12C16,10.17 15.28,8.41 14,7.11C14.33,7.04 14.66,7 15,7M12,8C13.26,8.95 14,10.43 14,12C14,13.57 13.26,15.05 12,16C10.74,15.05 10,13.57 10,12C10,10.43 10.74,8.95 12,8Z' })
	  );
	};
	
	var SetNoneIcon = function SetNoneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,5C5.13,5 2,8.13 2,12C2,15.87 5.13,19 9,19C10.04,19 11.06,18.76 12,18.32C12.94,18.76 13.96,19 15,19C18.87,19 22,15.87 22,12C22,8.13 18.87,5 15,5C13.96,5 12.94,5.24 12,5.68C11.06,5.24 10.04,5 9,5M9,7C9.34,7 9.67,7.03 10,7.1C8.72,8.41 8,10.17 8,12C8,13.83 8.72,15.59 10,16.89C9.67,16.96 9.34,17 9,17C6.24,17 4,14.76 4,12C4,9.24 6.24,7 9,7M15,7C17.76,7 20,9.24 20,12C20,14.76 17.76,17 15,17C14.66,17 14.33,16.97 14,16.9C15.28,15.59 16,13.83 16,12C16,10.17 15.28,8.41 14,7.11C14.33,7.04 14.66,7 15,7M12,8C13.26,8.95 14,10.43 14,12C14,13.57 13.26,15.05 12,16C10.74,15.05 10,13.57 10,12C10,10.43 10.74,8.95 12,8Z' })
	  );
	};
	
	var SetRightIcon = function SetRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,19C13.96,19 12.94,18.76 12,18.32C11.06,18.76 10.04,19 9,19C5.13,19 2,15.87 2,12C2,8.13 5.13,5 9,5C10.04,5 11.06,5.24 12,5.68C12.94,5.24 13.96,5 15,5C18.87,5 22,8.13 22,12C22,15.87 18.87,19 15,19M9,17L10,16.89C8.72,15.59 8,13.83 8,12C8,10.17 8.72,8.41 10,7.1L9,7C6.24,7 4,9.24 4,12C4,14.76 6.24,17 9,17M12,16C13.26,15.05 14,13.57 14,12C14,10.43 13.26,8.95 12,8C10.74,8.95 10,10.43 10,12C10,13.57 10.74,15.05 12,16Z' })
	  );
	};
	
	var SetTopBoxIcon = function SetTopBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,15.5C5,15.78 4.78,16 4.5,16H3.5C3.22,16 3,15.78 3,15.5V15H2C1.45,15 1,14.55 1,14V11C1,10.45 1.45,10 2,10H22C22.55,10 23,10.45 23,11V14C23,14.55 22.55,15 22,15H21V15.5C21,15.78 20.78,16 20.5,16H19.5C19.22,16 19,15.78 19,15.5V15H5V15.5M3,12V13H5V12H3M6,12V13H8V12H6M20.5,11.5C19.95,11.5 19.5,11.95 19.5,12.5C19.5,13.05 19.95,13.5 20.5,13.5C21.05,13.5 21.5,13.05 21.5,12.5C21.5,11.95 21.05,11.5 20.5,11.5Z' })
	  );
	};
	
	var SettingsBoxIcon = function SettingsBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.25,12C17.25,12.23 17.23,12.46 17.2,12.68L18.68,13.84C18.81,13.95 18.85,14.13 18.76,14.29L17.36,16.71C17.27,16.86 17.09,16.92 16.93,16.86L15.19,16.16C14.83,16.44 14.43,16.67 14,16.85L13.75,18.7C13.72,18.87 13.57,19 13.4,19H10.6C10.43,19 10.28,18.87 10.25,18.7L10,16.85C9.56,16.67 9.17,16.44 8.81,16.16L7.07,16.86C6.91,16.92 6.73,16.86 6.64,16.71L5.24,14.29C5.15,14.13 5.19,13.95 5.32,13.84L6.8,12.68C6.77,12.46 6.75,12.23 6.75,12C6.75,11.77 6.77,11.54 6.8,11.32L5.32,10.16C5.19,10.05 5.15,9.86 5.24,9.71L6.64,7.29C6.73,7.13 6.91,7.07 7.07,7.13L8.81,7.84C9.17,7.56 9.56,7.32 10,7.15L10.25,5.29C10.28,5.13 10.43,5 10.6,5H13.4C13.57,5 13.72,5.13 13.75,5.29L14,7.15C14.43,7.32 14.83,7.56 15.19,7.84L16.93,7.13C17.09,7.07 17.27,7.13 17.36,7.29L18.76,9.71C18.85,9.86 18.81,10.05 18.68,10.16L17.2,11.32C17.23,11.54 17.25,11.77 17.25,12M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3M12,10C10.89,10 10,10.89 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.89 13.1,10 12,10Z' })
	  );
	};
	
	var SettingsOutlineIcon = function SettingsOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.43,12.97L21.54,14.63C21.73,14.78 21.78,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.03 19.05,18.95L16.56,17.94C16.04,18.34 15.5,18.67 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.78,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,12.97M6.5,12C6.5,12.58 6.59,13.13 6.75,13.66L4.68,15.36L5.43,16.66L7.95,15.72C8.69,16.53 9.68,17.12 10.8,17.37L11.24,20H12.74L13.18,17.37C14.3,17.13 15.3,16.54 16.05,15.73L18.56,16.67L19.31,15.37L17.24,13.67C17.41,13.14 17.5,12.58 17.5,12C17.5,11.43 17.41,10.87 17.25,10.35L19.31,8.66L18.56,7.36L16.06,8.29C15.31,7.47 14.31,6.88 13.19,6.63L12.75,4H11.25L10.81,6.63C9.69,6.88 8.69,7.47 7.94,8.29L5.44,7.35L4.69,8.65L6.75,10.35C6.59,10.87 6.5,11.43 6.5,12M12,8.5C13.93,8.5 15.5,10.07 15.5,12C15.5,13.93 13.93,15.5 12,15.5C10.07,15.5 8.5,13.93 8.5,12C8.5,10.07 10.07,8.5 12,8.5M12,10.5C11.17,10.5 10.5,11.17 10.5,12C10.5,12.83 11.17,13.5 12,13.5C12.83,13.5 13.5,12.83 13.5,12C13.5,11.17 12.83,10.5 12,10.5Z' })
	  );
	};
	
	var SettingsIcon = function SettingsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,15.5C10.07,15.5 8.5,13.93 8.5,12C8.5,10.07 10.07,8.5 12,8.5C13.93,8.5 15.5,10.07 15.5,12C15.5,13.93 13.93,15.5 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z' })
	  );
	};
	
	var ShapeCirclePlusIcon = function ShapeCirclePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,19C14.31,19 17,16.31 17,13H19C19,17.42 15.42,21 11,21C6.58,21 3,17.42 3,13C3,8.58 6.58,5 11,5V7C7.69,7 5,9.69 5,13C5,16.31 7.69,19 11,19M19,5H22V7H19V10H17V7H14V5H17V2H19V5Z' })
	  );
	};
	
	var ShapeOutlineIcon = function ShapeOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,13.5V21.5H3V13.5H11M9,15.5H5V19.5H9V15.5M12,2L17.5,11H6.5L12,2M12,5.86L10.08,9H13.92L12,5.86M17.5,13C20,13 22,15 22,17.5C22,20 20,22 17.5,22C15,22 13,20 13,17.5C13,15 15,13 17.5,13M17.5,15C16.12,15 15,16.12 15,17.5C15,18.88 16.12,20 17.5,20C18.88,20 20,18.88 20,17.5C20,16.12 18.88,15 17.5,15Z' })
	  );
	};
	
	var ShapePlusIcon = function ShapePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,2H11V11H2V2M17.5,2C20,2 22,4 22,6.5C22,9 20,11 17.5,11C15,11 13,9 13,6.5C13,4 15,2 17.5,2M6.5,14L11,22H2L6.5,14M19,17H22V19H19V22H17V19H14V17H17V14H19V17Z' })
	  );
	};
	
	var ShapePolygonPlusIcon = function ShapePolygonPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,15.7V13H19V17L10,21L3,14L7,5H11V7H8.3L5.4,13.6L10.4,18.6L17,15.7M22,5V7H19V10H17V7H14V5H17V2H19V5H22Z' })
	  );
	};
	
	var ShapeRectanglePlusIcon = function ShapeRectanglePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,6H22V8H19V11H17V8H14V6H17V3H19V6M17,17V14H19V19H3V6H11V8H5V17H17Z' })
	  );
	};
	
	var ShapeSquarePlusIcon = function ShapeSquarePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,5H22V7H19V10H17V7H14V5H17V2H19V5M17,19V13H19V21H3V5H11V7H5V19H17Z' })
	  );
	};
	
	var ShapeIcon = function ShapeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,13.5V21.5H3V13.5H11M12,2L17.5,11H6.5L12,2M17.5,13C20,13 22,15 22,17.5C22,20 20,22 17.5,22C15,22 13,20 13,17.5C13,15 15,13 17.5,13Z' })
	  );
	};
	
	var ShareOutlineIcon = function ShareOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,4V8C7,9 4,14 3,19C5.5,15.5 9,13.9 14,13.9V18L21,11L14,4M16,8.83L18.17,11L16,13.17V11.9H14C11.93,11.9 10.07,12.28 8.34,12.85C9.74,11.46 11.54,10.37 14.28,10L16,9.73V8.83Z' })
	  );
	};
	
	var ShareVariantIcon = function ShareVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,16.08C17.24,16.08 16.56,16.38 16.04,16.85L8.91,12.7C8.96,12.47 9,12.24 9,12C9,11.76 8.96,11.53 8.91,11.3L15.96,7.19C16.5,7.69 17.21,8 18,8C19.66,8 21,6.66 21,5C21,3.34 19.66,2 18,2C16.34,2 15,3.34 15,5C15,5.24 15.04,5.47 15.09,5.7L8.04,9.81C7.5,9.31 6.79,9 6,9C4.34,9 3,10.34 3,12C3,13.66 4.34,15 6,15C6.79,15 7.5,14.69 8.04,14.19L15.16,18.34C15.11,18.55 15.08,18.77 15.08,19C15.08,20.61 16.39,21.91 18,21.91C19.61,21.91 20.92,20.61 20.92,19C20.92,17.39 19.61,16.08 18,16.08Z' })
	  );
	};
	
	var ShareIcon = function ShareIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,11L14,4V8C7,9 4,14 3,19C5.5,15.5 9,13.9 14,13.9V18L21,11Z' })
	  );
	};
	
	var ShieldHalfFullIcon = function ShieldHalfFullIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18V21Z' })
	  );
	};
	
	var ShieldOutlineIcon = function ShieldOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1L21,5V11M12,21C15.75,20 19,15.54 19,11.22V6.3L12,3.18L5,6.3V11.22C5,15.54 8.25,20 12,21Z' })
	  );
	};
	
	var ShieldIcon = function ShieldIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1Z' })
	  );
	};
	
	var ShipWheelIcon = function ShipWheelIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,11L4.05,11.1C4.3,8.83 5.5,6.85 7.25,5.56L6.13,3.84C5.86,3.36 6,2.75 6.5,2.47C7,2.2 7.59,2.36 7.87,2.84L8.8,4.66C9.78,4.24 10.86,4 12,4C13.14,4 14.22,4.24 15.2,4.66L16.13,2.84C16.41,2.36 17,2.2 17.5,2.47C18,2.75 18.14,3.36 17.87,3.84L16.75,5.56C18.5,6.85 19.7,8.83 19.95,11.1L22,11C22.55,11 23,11.45 23,12C23,12.55 22.55,13 22,13L19.95,12.9C19.7,15.17 18.5,17.15 16.75,18.44L17.87,20.16C18.14,20.64 18,21.25 17.5,21.53C17,21.8 16.41,21.64 16.13,21.16L15.2,19.34C14.22,19.76 13.14,20 12,20C10.86,20 9.78,19.76 8.8,19.34L7.87,21.16C7.59,21.64 7,21.8 6.5,21.53C6,21.25 5.86,20.64 6.13,20.16L7.25,18.44C5.5,17.15 4.3,15.17 4.05,12.9L2,13C1.45,13 1,12.55 1,12C1,11.45 1.45,11 2,11M9.07,11.35C9.2,10.74 9.53,10.2 10,9.79L8.34,7.25C7.11,8.19 6.27,9.6 6.05,11.2L9.07,11.35M12,9C12.32,9 12.62,9.05 12.9,9.14L14.28,6.45C13.58,6.16 12.81,6 12,6C11.19,6 10.42,6.16 9.72,6.45L11.1,9.14C11.38,9.05 11.68,9 12,9M14.93,11.35L17.95,11.2C17.73,9.6 16.89,8.19 15.66,7.25L14,9.79C14.47,10.2 14.8,10.74 14.93,11.35M14.93,12.65C14.8,13.26 14.47,13.8 14,14.21L15.66,16.75C16.89,15.81 17.73,14.4 17.95,12.8L14.93,12.65M12,15C11.68,15 11.38,14.95 11.09,14.86L9.72,17.55C10.42,17.84 11.19,18 12,18C12.81,18 13.58,17.84 14.28,17.55L12.91,14.86C12.62,14.95 12.32,15 12,15M9.07,12.65L6.05,12.8C6.27,14.4 7.11,15.81 8.34,16.75L10,14.21C9.53,13.8 9.2,13.26 9.07,12.65Z' })
	  );
	};
	
	var ShoppingMusicIcon = function ShoppingMusicIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C10.34,3 9,4.34 9,6H15C15,4.34 13.66,3 12,3M19,6C20.1,6 21,6.9 21,8V20C21,21.1 20.1,22 19,22H5C3.89,22 3,21.1 3,20V8C3,6.89 3.89,6 5,6H7C7,3.24 9.24,1 12,1C14.76,1 17,3.24 17,6H19M9,19L16.5,14L9,10V19Z' })
	  );
	};
	
	var ShoppingIcon = function ShoppingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,13C9.24,13 7,10.76 7,8H9C9,9.66 10.34,11 12,11C13.66,11 15,9.66 15,8H17C17,10.76 14.76,13 12,13M12,3C13.66,3 15,4.34 15,6H9C9,4.34 10.34,3 12,3M19,6H17C17,3.24 14.76,1 12,1C9.24,1 7,3.24 7,6H5C3.89,6 3,6.89 3,8V20C3,21.1 3.9,22 5,22H19C20.1,22 21,21.1 21,20V8C21,6.89 20.1,6 19,6Z' })
	  );
	};
	
	var ShovelOffIcon = function ShovelOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.1,1.81L12.27,4.65C11.5,5.43 11.5,6.69 12.27,7.47L13.68,8.89L13,9.62L14.44,11.06L15.17,10.33L16.56,11.72C17.34,12.5 18.61,12.5 19.39,11.72L22.22,8.88L15.1,1.81M17.93,10.28L13.7,6.06L15.11,4.65L19.34,8.88L17.93,10.28M20.7,20.24L19.29,21.65L11.5,13.88L10.5,14.88L13.33,17.69L12,19.09C7,24 3.5,20.5 3.5,20.5C3.5,20.5 -0.06,17 4.89,12L6.31,10.6L9.13,13.43L10.13,12.43L2.35,4.68L3.77,3.26L20.7,20.24Z' })
	  );
	};
	
	var ShovelIcon = function ShovelIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.1,1.81L12.27,4.64C11.5,5.42 11.5,6.69 12.27,7.47L13.68,8.88L9.13,13.43L6.31,10.6L4.89,12C-0.06,17 3.5,20.5 3.5,20.5C3.5,20.5 7,24 12,19.09L13.41,17.68L10.61,14.88L15.15,10.34L16.54,11.73C17.32,12.5 18.59,12.5 19.37,11.73L22.2,8.9L15.1,1.81M17.93,10.28L16.55,8.9L15.11,7.46L13.71,6.06L15.12,4.65L19.35,8.88L17.93,10.28Z' })
	  );
	};
	
	var ShowerHeadIcon = function ShowerHeadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,20C20.55,20 21,20.45 21,21C21,21.55 20.55,22 20,22C19.45,22 19,21.55 19,21C19,20.45 19.45,20 20,20M16,20C16.55,20 17,20.45 17,21C17,21.55 16.55,22 16,22C15.45,22 15,21.55 15,21C15,20.45 15.45,20 16,20M12,20C12.55,20 13,20.45 13,21C13,21.55 12.55,22 12,22C11.45,22 11,21.55 11,21C11,20.45 11.45,20 12,20M8,20C8.55,20 9,20.45 9,21C9,21.55 8.55,22 8,22C7.45,22 7,21.55 7,21C7,20.45 7.45,20 8,20M4,20C4.55,20 5,20.45 5,21C5,21.55 4.55,22 4,22C3.45,22 3,21.55 3,21C3,20.45 3.45,20 4,20M6,17C6.55,17 7,17.45 7,18C7,18.55 6.55,19 6,19H6C5.45,19 5,18.55 5,18C5,17.45 5.45,17 6,17H6M10,17C10.55,17 11,17.45 11,18C11,18.55 10.55,19 10,19C9.45,19 9,18.55 9,18C9,17.45 9.45,17 10,17M14,17C14.55,17 15,17.45 15,18C15,18.55 14.55,19 14,19C13.45,19 13,18.55 13,18C13,17.45 13.45,17 14,17M18,17C18.55,17 19,17.45 19,18C19,18.55 18.55,19 18,19C17.45,19 17,18.55 17,18C17,17.45 17.45,17 18,17M8,14C8.55,14 9,14.45 9,15C9,15.55 8.55,16 8,16C7.45,16 7,15.55 7,15C7,14.45 7.45,14 8,14M12,14C12.55,14 13,14.45 13,15C13,15.55 12.55,16 12,16C11.45,16 11,15.55 11,15C11,14.45 11.45,14 12,14M16,14C16.55,14 17,14.45 17,15C17,15.55 16.55,16 16,16C15.45,16 15,15.55 15,15C15,14.45 15.45,14 16,14M19,12H5V10H19V12M17.92,9H6.08C6.5,6.5 8.5,4.5 11,4.08V2H13V4.08C15.5,4.5 17.5,6.5 17.92,9Z' })
	  );
	};
	
	var ShowerIcon = function ShowerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,14V15C21,16.91 19.93,18.57 18.35,19.41L19,22H17L16.5,20C16.33,20 16.17,20 16,20H8C7.83,20 7.67,20 7.5,20L7,22H5L5.65,19.41C4.07,18.57 3,16.91 3,15V14H2V12H20V5C20,4.45 19.55,4 19,4C18.5,4 18.12,4.34 18,4.79C18.63,5.33 19,6.13 19,7H13C13,5.34 14.34,4 16,4C16.06,4 16.11,4 16.17,4C16.58,2.84 17.69,2 19,2C20.66,2 22,3.34 22,5V14H21V14M19,14H5V15C5,16.66 6.34,18 8,18H16C17.66,18 19,16.66 19,15V14Z' })
	  );
	};
	
	var ShredderIcon = function ShredderIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,3V7H8V5H16V7H18V3H6M5,8C3.34,8 2,9.34 2,11V17H5V14H19V17H22V11C22,9.34 20.66,8 19,8H5M18,10C18.55,10 19,10.45 19,11C19,11.55 18.55,12 18,12C17.45,12 17,11.55 17,11C17,10.45 17.45,10 18,10M7,16V21H9V16H7M11,16V20H13V16H11M15,16V21H17V16H15Z' })
	  );
	};
	
	var ShuffleDisabledIcon = function ShuffleDisabledIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,4.5V7H5V9H16V11.5L19.5,8M16,12.5V15H5V17H16V19.5L19.5,16' })
	  );
	};
	
	var ShuffleVariantIcon = function ShuffleVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,3L22.25,7.5L17,12L22.25,16.5L17,21V18H14.26L11.44,15.18L13.56,13.06L15.5,15H17V12L17,9H15.5L6.5,18H2V15H5.26L14.26,6H17V3M2,6H6.5L9.32,8.82L7.2,10.94L5.26,9H2V6Z' })
	  );
	};
	
	var ShuffleIcon = function ShuffleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.83,13.41L13.42,14.82L16.55,17.95L14.5,20H20V14.5L17.96,16.54L14.83,13.41M14.5,4L16.54,6.04L4,18.59L5.41,20L17.96,7.46L20,9.5V4M10.59,9.17L5.41,4L4,5.41L9.17,10.58L10.59,9.17Z' })
	  );
	};
	
	var SigmaLowerIcon = function SigmaLowerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,12C19,16.42 15.64,20 11.5,20C7.36,20 4,16.42 4,12C4,7.58 7.36,4 11.5,4H20V6H16.46C18,7.47 19,9.61 19,12M11.5,6C8.46,6 6,8.69 6,12C6,15.31 8.46,18 11.5,18C14.54,18 17,15.31 17,12C17,8.69 14.54,6 11.5,6Z' })
	  );
	};
	
	var SigmaIcon = function SigmaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,4H18V9H17L16,6H10.06L13.65,11.13L9.54,17H16L17,15H18V20H5L10.6,12L5,4Z' })
	  );
	};
	
	var SignCautionIcon = function SignCautionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,3H22V13H18V21H16V13H8V21H6V13H2V3M18.97,11L20,9.97V7.15L16.15,11H18.97M13.32,11L19.32,5H16.5L10.5,11H13.32M7.66,11L13.66,5H10.83L4.83,11H7.66M5.18,5L4,6.18V9L8,5H5.18Z' })
	  );
	};
	
	var SignDirectionIcon = function SignDirectionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,12H3.5L6,9.5L3.5,7H11V3L12,2L13,3V7H18L20.5,9.5L18,12H13V20C14.1,20 15,20.9 15,22H9C9,20.9 9.9,20 11,20V12Z' })
	  );
	};
	
	var SignTextIcon = function SignTextIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,3L12,2L13,3V5H20C20.55,5 21,5.45 21,6V16C21,16.55 20.55,17 20,17H13V20C14.1,20 15,20.9 15,22H9C9,20.9 9.9,20 11,20V17H4C3.45,17 3,16.55 3,16V6C3,5.45 3.45,5 4,5H11V3M6,8V10H18V8H6M6,12V14H13V12H6Z' })
	  );
	};
	
	var Signal2gIcon = function Signal2gIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,19.5H2V13.5C2,11.84 3.34,10.5 5,10.5H8V7.5H2V4.5H8C9.66,4.5 11,5.84 11,7.5V10.5C11,12.16 9.66,13.5 8,13.5H5V16.5H11M22,10.5H17.5V13.5H19V16.5H16V7.5H22V4.5H16C14.34,4.5 13,5.84 13,7.5V16.5C13,18.16 14.34,19.5 16,19.5H19C20.66,19.5 22,18.16 22,16.5' })
	  );
	};
	
	var Signal3gIcon = function Signal3gIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,16.5V14.25C11,13 10,12 8.75,12C10,12 11,11 11,9.75V7.5C11,5.84 9.66,4.5 8,4.5H2V7.5H8V10.5H5V13.5H8V16.5H2V19.5H8C9.66,19.5 11,18.16 11,16.5M22,16.5V10.5H17.5V13.5H19V16.5H16V7.5H22V4.5H16C14.34,4.5 13,5.84 13,7.5V16.5C13,18.16 14.34,19.5 16,19.5H19C20.66,19.5 22,18.16 22,16.5Z' })
	  );
	};
	
	var Signal4gIcon = function Signal4gIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,16.5V10.5H17.5V13.5H19V16.5H16V7.5H22V4.5H16C14.34,4.5 13,5.84 13,7.5V16.5C13,18.16 14.34,19.5 16,19.5H19C20.66,19.5 22,18.16 22,16.5M8,19.5H11V4.5H8V10.5H5V4.5H2V13.5H8V19.5Z' })
	  );
	};
	
	var SignalCellular1Icon = function SignalCellular1Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.5,5.5V18.5H17.5V5.5H19.5M12.5,10.5V18.5H10.5V10.5H12.5M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z' })
	  );
	};
	
	var SignalCellular2Icon = function SignalCellular2Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.5,5.5V18.5H17.5V5.5H19.5M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z' })
	  );
	};
	
	var SignalCellular3Icon = function SignalCellular3Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z' })
	  );
	};
	
	var SignalCellularOutlineIcon = function SignalCellularOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.5,5.5V18.5H17.5V5.5H19.5M12.5,10.5V18.5H10.5V10.5H12.5M5.5,15.5V18.5H3.5V15.5H5.5M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z' })
	  );
	};
	
	var SignalHspaPlusIcon = function SignalHspaPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,8V11H22V14H19V17H16V14H13V11H16V8H19M5,10.5H8V4.5H11V19.5H8V13.5H5V19.5H2V4.5H5V10.5Z' })
	  );
	};
	
	var SignalHspaIcon = function SignalHspaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.5,10.5H13.5V4.5H16.5V19.5H13.5V13.5H10.5V19.5H7.5V4.5H10.5V10.5Z' })
	  );
	};
	
	var SignalOffIcon = function SignalOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,3V16.18L21,19.18V3H18M4.28,5L3,6.27L10.73,14H8V21H11V14.27L13,16.27V21H16V19.27L19.73,23L21,21.72L4.28,5M13,9V11.18L16,14.18V9H13M3,18V21H6V18H3Z' })
	  );
	};
	
	var SignalVariantIcon = function SignalVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,6V4H4.1C12.9,4 20,11.1 20,19.9V20H18V19.9C18,12.2 11.8,6 4,6M4,10V8C10.63,8 16,13.37 16,20H14C14,14.48 9.52,10 4,10M4,14V12C8.42,12 12,15.58 12,20H10C10,16.69 7.31,14 4,14M4,16C6.21,16 8,17.79 8,20H4V16Z' })
	  );
	};
	
	var SignalIcon = function SignalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,21H6V18H3M8,21H11V14H8M13,21H16V9H13M18,21H21V3H18V21Z' })
	  );
	};
	
	var SilverwareForkIcon = function SilverwareForkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.12,21.29L3.71,19.88L13.36,10.22L13.16,10C12.38,9.23 12.38,7.97 13.16,7.19L17.5,2.82L18.43,3.74L15.19,7L16.15,7.94L19.39,4.69L20.31,5.61L17.06,8.85L18,9.81L21.26,6.56L22.18,7.5L17.81,11.84C17.03,12.62 15.77,12.62 15,11.84L14.78,11.64L5.12,21.29Z' })
	  );
	};
	
	var SilverwareSpoonIcon = function SilverwareSpoonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.88,11.53L5.12,21.29L3.71,19.88L13.47,10.12C12.76,8.59 13.26,6.44 14.85,4.85C16.76,2.93 19.5,2.57 20.96,4.03C22.43,5.5 22.07,8.24 20.15,10.15C18.56,11.74 16.41,12.24 14.88,11.53Z' })
	  );
	};
	
	var SilverwareVariantIcon = function SilverwareVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.1,13.34L3.91,9.16C2.35,7.59 2.35,5.06 3.91,3.5L10.93,10.5L8.1,13.34M13.41,13L20.29,19.88L18.88,21.29L12,14.41L5.12,21.29L3.71,19.88L13.36,10.22L13.16,10C12.38,9.23 12.38,7.97 13.16,7.19L17.5,2.82L18.43,3.74L15.19,7L16.15,7.94L19.39,4.69L20.31,5.61L17.06,8.85L18,9.81L21.26,6.56L22.18,7.5L17.81,11.84C17.03,12.62 15.77,12.62 15,11.84L14.78,11.64L13.41,13Z' })
	  );
	};
	
	var SilverwareIcon = function SilverwareIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.1,13.34L3.91,9.16C2.35,7.59 2.35,5.06 3.91,3.5L10.93,10.5L8.1,13.34M14.88,11.53L13.41,13L20.29,19.88L18.88,21.29L12,14.41L5.12,21.29L3.71,19.88L13.47,10.12C12.76,8.59 13.26,6.44 14.85,4.85C16.76,2.93 19.5,2.57 20.96,4.03C22.43,5.5 22.07,8.24 20.15,10.15C18.56,11.74 16.41,12.24 14.88,11.53Z' })
	  );
	};
	
	var SimAlertIcon = function SimAlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,13H11V8H13M13,17H11V15H13M18,2H10L4,8V20C4,21.1 4.9,22 6,22H18C19.1,22 20,21.1 20,20V4C20,2.9 19.1,2 18,2Z' })
	  );
	};
	
	var SimOffIcon = function SimOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,5C19,3.9 18.1,3 17,3H10L7.66,5.34L19,16.68V5M3.65,3.88L2.38,5.15L5,7.77V19C5,20.1 5.9,21 7,21H17C17.36,21 17.68,20.9 17.97,20.74L19.85,22.62L21.12,21.35L3.65,3.88Z' })
	  );
	};
	
	var SimIcon = function SimIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,4C20,2.9 19.1,2 18,2H10L4,8V20C4,21.1 4.9,22 6,22H18C19.11,22 20,21.1 20,20V4M9,19H7V17H9V19M17,19H15V17H17V19M9,15H7V11H9V15M13,19H11V15H13V19M13,13H11V11H13V13M17,15H15V11H17V15Z' })
	  );
	};
	
	var SitemapIcon = function SitemapIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,2V8H11V11H5C3.89,11 3,11.89 3,13V16H1V22H7V16H5V13H11V16H9V22H15V16H13V13H19V16H17V22H23V16H21V13C21,11.89 20.11,11 19,11H13V8H15V2H9Z' })
	  );
	};
	
	var SkipBackwardIcon = function SkipBackwardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,5V19L13,12M6,5V19H4V5M13,5V19L6,12' })
	  );
	};
	
	var SkipForwardIcon = function SkipForwardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,5V19L11,12M18,5V19H20V5M11,5V19L18,12' })
	  );
	};
	
	var SkipNextCircleOutlineIcon = function SkipNextCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4M8,8V16L13,12M14,8V16H16V8' })
	  );
	};
	
	var SkipNextCircleIcon = function SkipNextCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M8,8L13,12L8,16M14,8H16V16H14' })
	  );
	};
	
	var SkipNextIcon = function SkipNextIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,18H18V6H16M6,18L14.5,12L6,6V18Z' })
	  );
	};
	
	var SkipPreviousCircleOutlineIcon = function SkipPreviousCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.59,4 4,7.59 4,12C4,16.41 7.59,20 12,20C16.41,20 20,16.41 20,12C20,7.59 16.41,4 12,4M16,8V16L11,12M10,8V16H8V8' })
	  );
	};
	
	var SkipPreviousCircleIcon = function SkipPreviousCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M8,8H10V16H8M16,8V16L11,12' })
	  );
	};
	
	var SkipPreviousIcon = function SkipPreviousIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,18V6H8V18H6M9.5,12L18,6V18L9.5,12Z' })
	  );
	};
	
	var SkullIcon = function SkullIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C7.03,2 3,6.03 3,11C3,14.03 4.53,16.82 7,18.47V22H9V19H11V22H13V19H15V22H17V18.46C19.47,16.81 21,14 21,11C21,6.03 16.97,2 12,2M8,11C9.1,11 10,11.9 10,13C10,14.1 9.1,15 8,15C6.9,15 6,14.1 6,13C6,11.9 6.9,11 8,11M16,11C17.1,11 18,11.9 18,13C18,14.1 17.1,15 16,15C14.9,15 14,14.1 14,13C14,11.9 14.9,11 16,11M12,14L13.5,17H10.5L12,14Z' })
	  );
	};
	
	var SkypeBusinessIcon = function SkypeBusinessIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.03,16.53C9.37,16.53 8.18,15.22 8.18,14.24C8.18,13.74 8.55,13.38 9.06,13.38C10.2,13.38 9.91,15 12.03,15C13.12,15 13.73,14.43 13.73,13.82C13.73,13.46 13.55,13.06 12.83,12.88L10.46,12.29C8.55,11.81 8.2,10.78 8.2,9.81C8.2,7.79 10.1,7.03 11.88,7.03C13.5,7.03 15.46,7.94 15.46,9.15C15.46,9.67 15,9.97 14.5,9.97C13.5,9.97 13.7,8.62 11.74,8.62C10.77,8.62 10.23,9.06 10.23,9.69C10.23,10.32 11,10.5 11.66,10.68L13.42,11.07C15.34,11.5 15.83,12.62 15.83,13.67C15.83,15.31 14.57,16.53 12.03,16.53M18,6C20.07,8.04 20.85,10.89 20.36,13.55C20.77,14.27 21,15.11 21,16C21,18.76 18.76,21 16,21C15.11,21 14.27,20.77 13.55,20.36C10.89,20.85 8.04,20.07 6,18C3.93,15.96 3.15,13.11 3.64,10.45C3.23,9.73 3,8.89 3,8C3,5.24 5.24,3 8,3C8.89,3 9.73,3.23 10.45,3.64C13.11,3.15 15.96,3.93 18,6M8,5C6.34,5 5,6.34 5,8C5,8.79 5.3,9.5 5.8,10.04C5.1,12.28 5.63,14.82 7.4,16.6C9.18,18.37 11.72,18.9 13.96,18.2C14.5,18.7 15.21,19 16,19C17.66,19 19,17.66 19,16C19,15.21 18.7,14.5 18.2,13.96C18.9,11.72 18.37,9.18 16.6,7.4C14.82,5.63 12.28,5.1 10.04,5.8C9.5,5.3 8.79,5 8,5Z' })
	  );
	};
	
	var SkypeIcon = function SkypeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,6C20.07,8.04 20.85,10.89 20.36,13.55C20.77,14.27 21,15.11 21,16C21,18.76 18.76,21 16,21C15.11,21 14.27,20.77 13.55,20.36C10.89,20.85 8.04,20.07 6,18C3.93,15.96 3.15,13.11 3.64,10.45C3.23,9.73 3,8.89 3,8C3,5.24 5.24,3 8,3C8.89,3 9.73,3.23 10.45,3.64C13.11,3.15 15.96,3.93 18,6M12.04,17.16C14.91,17.16 16.34,15.78 16.34,13.92C16.34,12.73 15.78,11.46 13.61,10.97L11.62,10.53C10.86,10.36 10,10.13 10,9.42C10,8.7 10.6,8.2 11.7,8.2C13.93,8.2 13.72,9.73 14.83,9.73C15.41,9.73 15.91,9.39 15.91,8.8C15.91,7.43 13.72,6.4 11.86,6.4C9.85,6.4 7.7,7.26 7.7,9.54C7.7,10.64 8.09,11.81 10.25,12.35L12.94,13.03C13.75,13.23 13.95,13.68 13.95,14.1C13.95,14.78 13.27,15.45 12.04,15.45C9.63,15.45 9.96,13.6 8.67,13.6C8.09,13.6 7.67,14 7.67,14.57C7.67,15.68 9,17.16 12.04,17.16Z' })
	  );
	};
	
	var SlackIcon = function SlackIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.23,11.16L12.91,10.27L13.77,12.84L11.09,13.73L10.23,11.16M17.69,13.71C18.23,13.53 18.5,12.94 18.34,12.4C18.16,11.86 17.57,11.56 17.03,11.75L15.73,12.18L14.87,9.61L16.17,9.17C16.71,9 17,8.4 16.82,7.86C16.64,7.32 16.05,7 15.5,7.21L14.21,7.64L13.76,6.3C13.58,5.76 13,5.46 12.45,5.65C11.91,5.83 11.62,6.42 11.8,6.96L12.25,8.3L9.57,9.19L9.12,7.85C8.94,7.31 8.36,7 7.81,7.2C7.27,7.38 7,7.97 7.16,8.5L7.61,9.85L6.31,10.29C5.77,10.47 5.5,11.06 5.66,11.6C5.8,12 6.19,12.3 6.61,12.31L6.97,12.25L8.27,11.82L9.13,14.39L7.83,14.83C7.29,15 7,15.6 7.18,16.14C7.32,16.56 7.71,16.84 8.13,16.85L8.5,16.79L9.79,16.36L10.24,17.7C10.38,18.13 10.77,18.4 11.19,18.41L11.55,18.35C12.09,18.17 12.38,17.59 12.2,17.04L11.75,15.7L14.43,14.81L14.88,16.15C15,16.57 15.41,16.84 15.83,16.85L16.19,16.8C16.73,16.62 17,16.03 16.84,15.5L16.39,14.15L17.69,13.71M21.17,9.25C23.23,16.12 21.62,19.1 14.75,21.17C7.88,23.23 4.9,21.62 2.83,14.75C0.77,7.88 2.38,4.9 9.25,2.83C16.12,0.77 19.1,2.38 21.17,9.25Z' })
	  );
	};
	
	var SlackwareIcon = function SlackwareIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.47,17.19C7.37,17.95 7.08,18.21 6.19,18.21C5.27,18.21 4.87,17.79 4.81,16.87L4.61,13.65C4.61,12.91 4.87,12.55 5.86,12.55C7.21,12.55 7.04,13.54 7.64,14.5C8.33,15.62 10,16.35 12.31,16.35C15.17,16.35 17,15.14 17,13.57C17,12.23 15.89,11.39 13.85,11.16L11.5,10.89C7.21,10.42 5.1,9.19 5.1,6.62C5.1,4.07 8.06,2 12.21,2C13.5,2 14.81,2.29 16.29,2.76C16.29,2.26 16.58,2.1 17.3,2.1C18.46,2.1 18.55,2.39 18.62,3.08L18.85,5.88C18.85,6.5 18.39,6.83 17.63,6.83C16.35,6.83 16.55,5.88 15.86,5.07C15.17,4.26 13.79,3.73 12.08,3.73C9.44,3.73 7.7,4.89 7.7,6.5C7.7,7.8 8.92,8.56 11.38,8.82L13.95,9.08C17.7,9.5 19.61,10.92 19.61,13.33C19.61,16.17 16.71,18.08 12.21,18.08C10.56,18.08 9.08,17.77 7.47,17.19M1,16H2V21H23V22H1V16Z' })
	  );
	};
	
	var SleepOffIcon = function SleepOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L12.73,16H9V14L9.79,13.06L2,5.27M23,12H17V10L20.39,6H17V4H23V6L19.62,10H23V12M9.82,8H15V10L13.54,11.72L9.82,8M7,20H1V18L4.39,14H1V12H7V14L3.62,18H7V20Z' })
	  );
	};
	
	var SleepIcon = function SleepIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,12H17V10L20.39,6H17V4H23V6L19.62,10H23V12M15,16H9V14L12.39,10H9V8H15V10L11.62,14H15V16M7,20H1V18L4.39,14H1V12H7V14L3.62,18H7V20Z' })
	  );
	};
	
	var SmokeDetectorIcon = function SmokeDetectorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,18C15.31,18 18,15.31 18,12C18,8.68 15.31,6 12,6C8.68,6 6,8.68 6,12C6,15.31 8.69,18 12,18M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M8,12C8,9.79 9.79,8 12,8C14.21,8 16,9.79 16,12C16,14.21 14.21,16 12,16C9.79,16 8,14.21 8,12Z' })
	  );
	};
	
	var SmokingOffIcon = function SmokingOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,6L9,13H2V16H12L19,23L20.25,21.75L3.25,4.75L2,6M20.5,13H22V16H20.5V13M18,13H19.5V16H18V13M18.85,4.88C19.47,4.27 19.85,3.43 19.85,2.5H18.35C18.35,3.5 17.5,4.35 16.5,4.35V5.85C18.74,5.85 20.5,7.68 20.5,9.92V12H22V9.92C22,7.69 20.72,5.77 18.85,4.88M14.5,8.7H16.03C17.08,8.7 18,9.44 18,10.75V12H19.5V10.41C19.5,8.61 17.9,7.25 16.03,7.25H14.5C13.5,7.25 12.65,6.27 12.65,5.25C12.65,4.23 13.5,3.5 14.5,3.5V2C12.65,2 11.15,3.5 11.15,5.35C11.15,7.2 12.65,8.7 14.5,8.7M17,15.93V13H14.07L17,15.93Z' })
	  );
	};
	
	var SmokingIcon = function SmokingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,16H17V19H2V16M20.5,16H22V19H20.5V16M18,16H19.5V19H18V16M18.85,7.73C19.47,7.12 19.85,6.28 19.85,5.35C19.85,3.5 18.35,2 16.5,2V3.5C17.5,3.5 18.35,4.33 18.35,5.35C18.35,6.37 17.5,7.2 16.5,7.2V8.7C18.74,8.7 20.5,10.53 20.5,12.77V15H22V12.76C22,10.54 20.72,8.62 18.85,7.73M16.03,10.2H14.5C13.5,10.2 12.65,9.22 12.65,8.2C12.65,7.18 13.5,6.45 14.5,6.45V4.95C12.65,4.95 11.15,6.45 11.15,8.3C11.15,10.15 12.65,11.65 14.5,11.65H16.03C17.08,11.65 18,12.39 18,13.7V15H19.5V13.36C19.5,11.55 17.9,10.2 16.03,10.2Z' })
	  );
	};
	
	var SnapchatIcon = function SnapchatIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20.45C10.81,20.45 10.1,19.94 9.47,19.5C9,19.18 8.58,18.87 8.08,18.79C6.93,18.73 6.59,18.79 5.97,18.9C5.86,18.9 5.73,18.87 5.68,18.69C5.5,17.94 5.45,17.73 5.32,17.71C4,17.5 3.19,17.2 3.03,16.83C3,16.6 3.07,16.5 3.18,16.5C4.25,16.31 5.2,15.75 6,14.81C6.63,14.09 6.93,13.39 6.96,13.32C7.12,13 7.15,12.72 7.06,12.5C6.89,12.09 6.31,11.91 5.68,11.7C5.34,11.57 4.79,11.29 4.86,10.9C4.92,10.62 5.29,10.42 5.81,10.46C6.16,10.62 6.46,10.7 6.73,10.7C7.06,10.7 7.21,10.58 7.25,10.54C7.14,8.78 7.05,7.25 7.44,6.38C8.61,3.76 11.08,3.55 12,3.55C12.92,3.55 15.39,3.76 16.56,6.38C16.95,7.25 16.86,8.78 16.75,10.54C16.79,10.58 16.94,10.7 17.27,10.7C17.54,10.7 17.84,10.62 18.19,10.46C18.71,10.42 19.08,10.62 19.14,10.9C19.21,11.29 18.66,11.57 18.32,11.7C17.69,11.91 17.11,12.09 16.94,12.5C16.85,12.72 16.88,13 17.04,13.32C17.07,13.39 17.37,14.09 18,14.81C18.8,15.75 19.75,16.31 20.82,16.5C20.93,16.5 21,16.6 20.97,16.83C20.81,17.2 20,17.5 18.68,17.71C18.55,17.73 18.5,17.94 18.32,18.69C18.27,18.87 18.14,18.9 18.03,18.9C17.41,18.79 17.07,18.73 15.92,18.79C15.42,18.87 15,19.18 14.53,19.5C13.9,19.94 13.19,20.45 12,20.45Z' })
	  );
	};
	
	var SnowflakeIcon = function SnowflakeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.79,13.95L18.46,14.57L16.46,13.44V10.56L18.46,9.43L20.79,10.05L21.31,8.12L19.54,7.65L20,5.88L18.07,5.36L17.45,7.69L15.45,8.82L13,7.38V5.12L14.71,3.41L13.29,2L12,3.29L10.71,2L9.29,3.41L11,5.12V7.38L8.5,8.82L6.5,7.69L5.92,5.36L4,5.88L4.47,7.65L2.7,8.12L3.22,10.05L5.55,9.43L7.55,10.56V13.45L5.55,14.58L3.22,13.96L2.7,15.89L4.47,16.36L4,18.12L5.93,18.64L6.55,16.31L8.55,15.18L11,16.62V18.88L9.29,20.59L10.71,22L12,20.71L13.29,22L14.7,20.59L13,18.88V16.62L15.5,15.17L17.5,16.3L18.12,18.63L20,18.12L19.53,16.35L21.3,15.88L20.79,13.95M9.5,10.56L12,9.11L14.5,10.56V13.44L12,14.89L9.5,13.44V10.56Z' })
	  );
	};
	
	var SnowmanIcon = function SnowmanIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,17C17,19.76 14.76,22 12,22C9.24,22 7,19.76 7,17C7,15.5 7.65,14.17 8.69,13.25C8.26,12.61 8,11.83 8,11C8,10.86 8,10.73 8,10.59L5.04,8.87L4.83,8.71L2.29,9.39L2.03,8.43L4.24,7.84L2.26,6.69L2.76,5.82L4.74,6.97L4.15,4.75L5.11,4.5L5.8,7.04L6.04,7.14L8.73,8.69C9.11,8.15 9.62,7.71 10.22,7.42C9.5,6.87 9,6 9,5C9,3.34 10.34,2 12,2C13.66,2 15,3.34 15,5C15,6 14.5,6.87 13.78,7.42C14.38,7.71 14.89,8.15 15.27,8.69L17.96,7.14L18.2,7.04L18.89,4.5L19.85,4.75L19.26,6.97L21.24,5.82L21.74,6.69L19.76,7.84L21.97,8.43L21.71,9.39L19.17,8.71L18.96,8.87L16,10.59V11C16,11.83 15.74,12.61 15.31,13.25C16.35,14.17 17,15.5 17,17Z' })
	  );
	};
	
	var SoccerFieldIcon = function SoccerFieldIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4C2.89,4 2,4.89 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.89 21.1,4 20,4H4M4,6H11V8.13C9.24,8.59 8,10.18 8,12C8,13.82 9.24,15.41 11,15.87V18H4V16H7V8H4V6M13,6H20V8H17V16H20V18H13V15.87C14.76,15.41 16,13.82 16,12C16,10.18 14.76,8.59 13,8.13V6M4,10H5V14H4V10M19,10H20V14H19V10M13,10.27C13.62,10.63 14,11.29 14,12C14,12.71 13.62,13.37 13,13.73V10.27M11,10.27V13.73C10.38,13.37 10,12.71 10,12C10,11.29 10.38,10.63 11,10.27Z' })
	  );
	};
	
	var SoccerIcon = function SoccerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,3C13.76,3 15.4,3.53 16.78,4.41L16.5,5H13L12,5L10.28,4.16L10.63,3.13C11.08,3.05 11.53,3 12,3M9.53,3.38L9.19,4.41L6.63,5.69L5.38,5.94C6.5,4.73 7.92,3.84 9.53,3.38M13,6H16L18.69,9.59L17.44,12.16L14.81,12.78L11.53,8.94L13,6M6.16,6.66L7,10L5.78,13.06L3.22,13.94C3.08,13.31 3,12.67 3,12C3,10.1 3.59,8.36 4.59,6.91L6.16,6.66M20.56,9.22C20.85,10.09 21,11.03 21,12C21,13.44 20.63,14.79 20.03,16H19L18.16,12.66L19.66,9.66L20.56,9.22M8,10H11L13.81,13.28L12,16L8.84,16.78L6.53,13.69L8,10M12,17L15,19L14.13,20.72C13.44,20.88 12.73,21 12,21C10.25,21 8.63,20.5 7.25,19.63L8.41,17.91L12,17M19,17H19.5C18.5,18.5 17,19.67 15.31,20.34L16,19L19,17Z' })
	  );
	};
	
	var SofaIcon = function SofaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,6H9C10.1,6 11,6.9 11,8V12H5V8C5,6.9 5.9,6 7,6M15,6H17C18.1,6 19,6.9 19,8V12H13V8C13,6.9 13.9,6 15,6M1,9H2C2.55,9 3,9.45 3,10V12C3,13.1 3.9,14 5,14H19C20.1,14 21,13.1 21,12V11L21,10C21,9.45 21.45,9 22,9H23C23.55,9 24,9.45 24,10V19H21V17H3V19H0V10C0,9.45 0.45,9 1,9Z' })
	  );
	};
	
	var SolidIcon = function SolidIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M0,0H24V24H0' })
	  );
	};
	
	var SortAlphabeticalIcon = function SortAlphabeticalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.25,5L12.5,1.75L15.75,5H9.25M15.75,19L12.5,22.25L9.25,19H15.75M8.89,14.3H6L5.28,17H2.91L6,7H9L12.13,17H9.67L8.89,14.3M6.33,12.68H8.56L7.93,10.56L7.67,9.59L7.42,8.63H7.39L7.17,9.6L6.93,10.58L6.33,12.68M13.05,17V15.74L17.8,8.97V8.91H13.5V7H20.73V8.34L16.09,15V15.08H20.8V17H13.05Z' })
	  );
	};
	
	var SortAscendingIcon = function SortAscendingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,11V13H18V11H10M10,5V7H14V5H10M10,17V19H22V17H10M6,7H8.5L5,3.5L1.5,7H4V20H6V7Z' })
	  );
	};
	
	var SortDescendingIcon = function SortDescendingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,13V11H18V13H10M10,19V17H14V19H10M10,7V5H22V7H10M6,17H8.5L5,20.5L1.5,17H4V4H6V17Z' })
	  );
	};
	
	var SortNumericIcon = function SortNumericIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.78,7C9.08,7.04 10,7.53 10.57,8.46C11.13,9.4 11.41,10.56 11.39,11.95C11.4,13.5 11.09,14.73 10.5,15.62C9.88,16.5 8.95,16.97 7.71,17C6.45,16.96 5.54,16.5 4.96,15.56C4.38,14.63 4.09,13.45 4.09,12C4.09,10.55 4.39,9.36 5,8.44C5.59,7.5 6.5,7.04 7.78,7M7.75,8.63C7.31,8.63 6.96,8.9 6.7,9.46C6.44,10 6.32,10.87 6.32,12C6.31,13.15 6.44,14 6.69,14.54C6.95,15.1 7.31,15.37 7.77,15.37C8.69,15.37 9.16,14.24 9.17,12C9.17,9.77 8.7,8.65 7.75,8.63M13.33,17V15.22L13.76,15.24L14.3,15.22L15.34,15.03C15.68,14.92 16,14.78 16.26,14.58C16.59,14.35 16.86,14.08 17.07,13.76C17.29,13.45 17.44,13.12 17.53,12.78L17.5,12.77C17.05,13.19 16.38,13.4 15.47,13.41C14.62,13.4 13.91,13.15 13.34,12.65C12.77,12.15 12.5,11.43 12.46,10.5C12.47,9.5 12.81,8.69 13.47,8.03C14.14,7.37 15,7.03 16.12,7C17.37,7.04 18.29,7.45 18.88,8.24C19.47,9 19.76,10 19.76,11.19C19.75,12.15 19.61,13 19.32,13.76C19.03,14.5 18.64,15.13 18.12,15.64C17.66,16.06 17.11,16.38 16.47,16.61C15.83,16.83 15.12,16.96 14.34,17H13.33M16.06,8.63C15.65,8.64 15.32,8.8 15.06,9.11C14.81,9.42 14.68,9.84 14.68,10.36C14.68,10.8 14.8,11.16 15.03,11.46C15.27,11.77 15.63,11.92 16.11,11.93C16.43,11.93 16.7,11.86 16.92,11.74C17.14,11.61 17.3,11.46 17.41,11.28C17.5,11.17 17.53,10.97 17.53,10.71C17.54,10.16 17.43,9.69 17.2,9.28C16.97,8.87 16.59,8.65 16.06,8.63M9.25,5L12.5,1.75L15.75,5H9.25M15.75,19L12.5,22.25L9.25,19H15.75Z' })
	  );
	};
	
	var SortVariantIcon = function SortVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,13H15V11H3M3,6V8H21V6M3,18H9V16H3V18Z' })
	  );
	};
	
	var SortIcon = function SortIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,13V11H18V13H10M10,19V17H14V19H10M10,7V5H22V7H10M6,17H8.5L5,20.5L1.5,17H4V7H1.5L5,3.5L8.5,7H6V17Z' })
	  );
	};
	
	var SoundcloudIcon = function SoundcloudIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.56,8.87V17H20.32V17C22.17,16.87 23,15.73 23,14.33C23,12.85 21.88,11.66 20.38,11.66C20,11.66 19.68,11.74 19.35,11.88C19.11,9.54 17.12,7.71 14.67,7.71C13.5,7.71 12.39,8.15 11.56,8.87M10.68,9.89C10.38,9.71 10.06,9.57 9.71,9.5V17H11.1V9.34C10.95,9.5 10.81,9.7 10.68,9.89M8.33,9.35V17H9.25V9.38C9.06,9.35 8.87,9.34 8.67,9.34C8.55,9.34 8.44,9.34 8.33,9.35M6.5,10V17H7.41V9.54C7.08,9.65 6.77,9.81 6.5,10M4.83,12.5C4.77,12.5 4.71,12.44 4.64,12.41V17H5.56V10.86C5.19,11.34 4.94,11.91 4.83,12.5M2.79,12.22V16.91C3,16.97 3.24,17 3.5,17H3.72V12.14C3.64,12.13 3.56,12.12 3.5,12.12C3.24,12.12 3,12.16 2.79,12.22M1,14.56C1,15.31 1.34,15.97 1.87,16.42V12.71C1.34,13.15 1,13.82 1,14.56Z' })
	  );
	};
	
	var SourceBranchIcon = function SourceBranchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,14C9.64,14 8.54,15.35 8.18,16.24C9.25,16.7 10,17.76 10,19C10,20.66 8.66,22 7,22C5.34,22 4,20.66 4,19C4,17.69 4.83,16.58 6,16.17V7.83C4.83,7.42 4,6.31 4,5C4,3.34 5.34,2 7,2C8.66,2 10,3.34 10,5C10,6.31 9.17,7.42 8,7.83V13.12C8.88,12.47 10.16,12 12,12C14.67,12 15.56,10.66 15.85,9.77C14.77,9.32 14,8.25 14,7C14,5.34 15.34,4 17,4C18.66,4 20,5.34 20,7C20,8.34 19.12,9.5 17.91,9.86C17.65,11.29 16.68,14 13,14M7,18C6.45,18 6,18.45 6,19C6,19.55 6.45,20 7,20C7.55,20 8,19.55 8,19C8,18.45 7.55,18 7,18M7,4C6.45,4 6,4.45 6,5C6,5.55 6.45,6 7,6C7.55,6 8,5.55 8,5C8,4.45 7.55,4 7,4M17,6C16.45,6 16,6.45 16,7C16,7.55 16.45,8 17,8C17.55,8 18,7.55 18,7C18,6.45 17.55,6 17,6Z' })
	  );
	};
	
	var SourceCommitEndLocalIcon = function SourceCommitEndLocalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M11,5V3H13V5H11Z' })
	  );
	};
	
	var SourceCommitEndIcon = function SourceCommitEndIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,12C17,14.76 14.76,17 12,17C9.24,17 7,14.76 7,12C7,9.58 8.72,7.56 11,7.1V3H13V7.1C15.28,7.56 17,9.58 17,12M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9Z' })
	  );
	};
	
	var SourceCommitLocalIcon = function SourceCommitLocalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M11,5V3H13V5H11M11,21V19H13V21H11Z' })
	  );
	};
	
	var SourceCommitNextLocalIcon = function SourceCommitNextLocalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,12C17,14.76 14.76,17 12,17C9.24,17 7,14.76 7,12C7,9.58 8.72,7.56 11,7.1V3H13V7.1C15.28,7.56 17,9.58 17,12M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M11,21V19H13V21H11Z' })
	  );
	};
	
	var SourceCommitStartNextLocalIcon = function SourceCommitStartNextLocalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M11,21V19H13V21H11Z' })
	  );
	};
	
	var SourceCommitStartIcon = function SourceCommitStartIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,7C14.76,7 17,9.24 17,12C17,14.42 15.28,16.44 13,16.9V21H11V16.9C8.72,16.44 7,14.42 7,12C7,9.24 9.24,7 12,7M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9Z' })
	  );
	};
	
	var SourceCommitIcon = function SourceCommitIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,12C17,14.42 15.28,16.44 13,16.9V21H11V16.9C8.72,16.44 7,14.42 7,12C7,9.58 8.72,7.56 11,7.1V3H13V7.1C15.28,7.56 17,9.58 17,12M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9Z' })
	  );
	};
	
	var SourceForkIcon = function SourceForkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2C7.66,2 9,3.34 9,5C9,6.28 8.19,7.38 7.06,7.81C7.15,8.27 7.39,8.83 8,9.63C9,10.92 11,12.83 12,14.17C13,12.83 15,10.92 16,9.63C16.61,8.83 16.85,8.27 16.94,7.81C15.81,7.38 15,6.28 15,5C15,3.34 16.34,2 18,2C19.66,2 21,3.34 21,5C21,6.32 20.14,7.45 18.95,7.85C18.87,8.37 18.64,9 18,9.83C17,11.17 15,13.08 14,14.38C13.39,15.17 13.15,15.73 13.06,16.19C14.19,16.62 15,17.72 15,19C15,20.66 13.66,22 12,22C10.34,22 9,20.66 9,19C9,17.72 9.81,16.62 10.94,16.19C10.85,15.73 10.61,15.17 10,14.38C9,13.08 7,11.17 6,9.83C5.36,9 5.13,8.37 5.05,7.85C3.86,7.45 3,6.32 3,5C3,3.34 4.34,2 6,2M6,4C5.45,4 5,4.45 5,5C5,5.55 5.45,6 6,6C6.55,6 7,5.55 7,5C7,4.45 6.55,4 6,4M18,4C17.45,4 17,4.45 17,5C17,5.55 17.45,6 18,6C18.55,6 19,5.55 19,5C19,4.45 18.55,4 18,4M12,18C11.45,18 11,18.45 11,19C11,19.55 11.45,20 12,20C12.55,20 13,19.55 13,19C13,18.45 12.55,18 12,18Z' })
	  );
	};
	
	var SourceMergeIcon = function SourceMergeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,3C8.66,3 10,4.34 10,6C10,7.29 9.19,8.39 8.04,8.81C8.58,13.81 13.08,14.77 15.19,14.96C15.61,13.81 16.71,13 18,13C19.66,13 21,14.34 21,16C21,17.66 19.66,19 18,19C16.69,19 15.57,18.16 15.16,17C10.91,16.8 9.44,15.19 8,13.39V15.17C9.17,15.58 10,16.69 10,18C10,19.66 8.66,21 7,21C5.34,21 4,19.66 4,18C4,16.69 4.83,15.58 6,15.17V8.83C4.83,8.42 4,7.31 4,6C4,4.34 5.34,3 7,3M7,5C6.45,5 6,5.45 6,6C6,6.55 6.45,7 7,7C7.55,7 8,6.55 8,6C8,5.45 7.55,5 7,5M7,17C6.45,17 6,17.45 6,18C6,18.55 6.45,19 7,19C7.55,19 8,18.55 8,18C8,17.45 7.55,17 7,17M18,15C17.45,15 17,15.45 17,16C17,16.55 17.45,17 18,17C18.55,17 19,16.55 19,16C19,15.45 18.55,15 18,15Z' })
	  );
	};
	
	var SourcePullIcon = function SourcePullIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,3C7.66,3 9,4.34 9,6C9,7.31 8.17,8.42 7,8.83V15.17C8.17,15.58 9,16.69 9,18C9,19.66 7.66,21 6,21C4.34,21 3,19.66 3,18C3,16.69 3.83,15.58 5,15.17V8.83C3.83,8.42 3,7.31 3,6C3,4.34 4.34,3 6,3M6,5C5.45,5 5,5.45 5,6C5,6.55 5.45,7 6,7C6.55,7 7,6.55 7,6C7,5.45 6.55,5 6,5M6,17C5.45,17 5,17.45 5,18C5,18.55 5.45,19 6,19C6.55,19 7,18.55 7,18C7,17.45 6.55,17 6,17M21,18C21,19.66 19.66,21 18,21C16.34,21 15,19.66 15,18C15,16.69 15.83,15.58 17,15.17V7H15V10.25L10.75,6L15,1.75V5H17C18.1,5 19,5.9 19,7V15.17C20.17,15.58 21,16.69 21,18M18,17C17.45,17 17,17.45 17,18C17,18.55 17.45,19 18,19C18.55,19 19,18.55 19,18C19,17.45 18.55,17 18,17Z' })
	  );
	};
	
	var SoySauceIcon = function SoySauceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.9,7.5C13.9,6.8 14.1,6.3 14.2,6H14.8L15.7,3.5H16.5V2H7.5V3.5H8.3L9.2,6H9.8C10,6.3 10.1,6.8 10.1,7.5C10.1,8.8 6,13.7 6,17.6V19.6C6,21 8.7,21.9 12,21.9C15.3,21.9 18,21 18,19.6V17.6C18,13.7 13.9,8.8 13.9,7.5M12,15C10.9,15 10,14.1 10,13C10,11.9 10.9,11 12,11C13.1,11 14,11.9 14,13C14,14.1 13.1,15 12,15Z' })
	  );
	};
	
	var SpeakerBluetoothIcon = function SpeakerBluetoothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,3C2.9,3 2,3.9 2,5V19C2,20.1 2.9,21 4,21H12C13.1,21 14,20.1 14,19V5C14,3.9 13.1,3 12,3H4M8,5C9.1,5 10,5.9 10,7C10,8.1 9.1,9 8,9C6.9,9 6,8.1 6,7C6,5.9 6.9,5 8,5M19,7V10.79L16.71,8.5L16,9.21L18.79,12L16,14.79L16.71,15.5L19,13.21V17H19.5L22.35,14.14L20.21,12L22.35,9.85L19.5,7H19M20,8.91L20.94,9.85L20,10.79V8.91M8,11C10.21,11 12,12.79 12,15C12,17.21 10.21,19 8,19C5.79,19 4,17.21 4,15C4,12.79 5.79,11 8,11M8,13C6.9,13 6,13.9 6,15C6,16.1 6.9,17 8,17C9.1,17 10,16.1 10,15C10,13.9 9.1,13 8,13M20,13.21L20.94,14.14L20,15.08V13.21Z' })
	  );
	};
	
	var SpeakerOffIcon = function SpeakerOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L21,21.72L19.73,23L18.27,21.54C17.93,21.83 17.5,22 17,22H7C5.89,22 5,21.1 5,20V8.27L2,5.27M12,18C10.34,18 9,16.66 9,15C9,14.24 9.28,13.54 9.75,13L8.33,11.6C7.5,12.5 7,13.69 7,15C7,17.76 9.24,20 12,20C13.31,20 14.5,19.5 15.4,18.67L14,17.25C13.45,17.72 12.76,18 12,18M17,15C17,12.24 14.76,10 12,10H11.82L5.12,3.3C5.41,2.54 6.14,2 7,2H17C18.1,2 19,2.9 19,4V17.18L17,15.17V15M12,4C10.89,4 10,4.89 10,6C10,7.1 10.9,8 12,8C13.1,8 14,7.1 14,6C14,4.89 13.1,4 12,4Z' })
	  );
	};
	
	var SpeakerWirelessIcon = function SpeakerWirelessIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.07,19.07L18.66,17.66C20.11,16.22 21,14.21 21,12C21,9.78 20.11,7.78 18.66,6.34L20.07,4.93C21.88,6.74 23,9.24 23,12C23,14.76 21.88,17.26 20.07,19.07M17.24,16.24L15.83,14.83C16.55,14.11 17,13.11 17,12C17,10.89 16.55,9.89 15.83,9.17L17.24,7.76C18.33,8.85 19,10.35 19,12C19,13.65 18.33,15.15 17.24,16.24M4,3H12C13.1,3 14,3.9 14,5V19C14,20.1 13.1,21 12,21H4C2.9,21 2,20.1 2,19V5C2,3.9 2.9,3 4,3M8,5C6.9,5 6,5.9 6,7C6,8.1 6.9,9 8,9C9.1,9 10,8.1 10,7C10,5.9 9.1,5 8,5M8,11C5.79,11 4,12.79 4,15C4,17.21 5.79,19 8,19C10.21,19 12,17.21 12,15C12,12.79 10.21,11 8,11M8,13C9.1,13 10,13.9 10,15C10,16.1 9.1,17 8,17C6.9,17 6,16.1 6,15C6,13.9 6.9,13 8,13Z' })
	  );
	};
	
	var SpeakerIcon = function SpeakerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,12C10.34,12 9,13.34 9,15C9,16.66 10.34,18 12,18C13.66,18 15,16.66 15,15C15,13.34 13.66,12 12,12M12,20C9.24,20 7,17.76 7,15C7,12.24 9.24,10 12,10C14.76,10 17,12.24 17,15C17,17.76 14.76,20 12,20M12,4C13.1,4 14,4.9 14,6C14,7.1 13.1,8 12,8C10.89,8 10,7.1 10,6C10,4.89 10.89,4 12,4M17,2H7C5.89,2 5,2.89 5,4V20C5,21.1 5.9,22 7,22H17C18.1,22 19,21.1 19,20V4C19,2.89 18.1,2 17,2Z' })
	  );
	};
	
	var SpeedometerIcon = function SpeedometerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,16C10.34,16 9,14.66 9,13C9,11.88 9.61,10.9 10.5,10.39L20.21,4.77L14.68,14.35C14.18,15.33 13.17,16 12,16M12,3C13.81,3 15.5,3.5 16.97,4.32L14.87,5.53C14,5.19 13,5 12,5C7.58,5 4,8.58 4,13C4,15.21 4.89,17.21 6.34,18.65H6.35C6.74,19.04 6.74,19.67 6.35,20.06C5.96,20.45 5.32,20.45 4.93,20.07V20.07C3.12,18.26 2,15.76 2,13C2,7.48 6.48,3 12,3M22,13C22,15.76 20.88,18.26 19.07,20.07V20.07C18.68,20.45 18.05,20.45 17.66,20.06C17.27,19.67 17.27,19.04 17.66,18.65V18.65C19.11,17.2 20,15.21 20,13C20,12 19.81,11 19.46,10.1L20.67,8C21.5,9.5 22,11.18 22,13Z' })
	  );
	};
	
	var SpellcheckIcon = function SpellcheckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.59,11.59L13.5,19.68L9.83,16L8.42,17.41L13.5,22.5L23,13M6.43,11L8.5,5.5L10.57,11M12.45,16H14.54L9.43,3H7.57L2.46,16H4.55L5.67,13H11.31L12.45,16Z' })
	  );
	};
	
	var SpotifyIcon = function SpotifyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.9,10.9C14.7,9 9.35,8.8 6.3,9.75C5.8,9.9 5.3,9.6 5.15,9.15C5,8.65 5.3,8.15 5.75,8C9.3,6.95 15.15,7.15 18.85,9.35C19.3,9.6 19.45,10.2 19.2,10.65C18.95,11 18.35,11.15 17.9,10.9M17.8,13.7C17.55,14.05 17.1,14.2 16.75,13.95C14.05,12.3 9.95,11.8 6.8,12.8C6.4,12.9 5.95,12.7 5.85,12.3C5.75,11.9 5.95,11.45 6.35,11.35C10,10.25 14.5,10.8 17.6,12.7C17.9,12.85 18.05,13.35 17.8,13.7M16.6,16.45C16.4,16.75 16.05,16.85 15.75,16.65C13.4,15.2 10.45,14.9 6.95,15.7C6.6,15.8 6.3,15.55 6.2,15.25C6.1,14.9 6.35,14.6 6.65,14.5C10.45,13.65 13.75,14 16.35,15.6C16.7,15.75 16.75,16.15 16.6,16.45M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var SpotlightBeamIcon = function SpotlightBeamIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,16.5L9.91,15.59L15.13,20.8L14.21,21.71L9,16.5M15.5,10L16.41,9.09L21.63,14.3L20.71,15.21L15.5,10M6.72,2.72L10.15,6.15L6.15,10.15L2.72,6.72C1.94,5.94 1.94,4.67 2.72,3.89L3.89,2.72C4.67,1.94 5.94,1.94 6.72,2.72M14.57,7.5L15.28,8.21L8.21,15.28L7.5,14.57L6.64,11.07L11.07,6.64L14.57,7.5Z' })
	  );
	};
	
	var SpotlightIcon = function SpotlightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,6L7.09,8.55C6.4,9.5 6,10.71 6,12C6,13.29 6.4,14.5 7.09,15.45L2,18V6M6,3H18L15.45,7.09C14.5,6.4 13.29,6 12,6C10.71,6 9.5,6.4 8.55,7.09L6,3M22,6V18L16.91,15.45C17.6,14.5 18,13.29 18,12C18,10.71 17.6,9.5 16.91,8.55L22,6M18,21H6L8.55,16.91C9.5,17.6 10.71,18 12,18C13.29,18 14.5,17.6 15.45,16.91L18,21M12,8C14.21,8 16,9.79 16,12C16,14.21 14.21,16 12,16C9.79,16 8,14.21 8,12C8,9.79 9.79,8 12,8M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10Z' })
	  );
	};
	
	var SprayIcon = function SprayIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,4H12V6H10V4M7,3H9V5H7V3M7,6H9V8H7V6M6,8V10H4V8H6M6,5V7H4V5H6M6,2V4H4V2H6M13,22C11.9,22 11,21.1 11,20V10C11,8.9 11.9,8 13,8V7H14V4H17V7H18V8C19.1,8 20,8.9 20,10V20C20,21.1 19.1,22 18,22H13M13,10V20H18V10H13Z' })
	  );
	};
	
	var SquareEditOutlineIcon = function SquareEditOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V12H19V19H5V5H12V3H5M17.78,4C17.61,4 17.43,4.07 17.3,4.2L16.08,5.41L18.58,7.91L19.8,6.7C20.06,6.44 20.06,6 19.8,5.75L18.25,4.2C18.12,4.07 17.95,4 17.78,4M15.37,6.12L8,13.5V16H10.5L17.87,8.62L15.37,6.12Z' })
	  );
	};
	
	var SquareIncCashIcon = function SquareIncCashIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.5,0H18.5C21.54,0 24,2.46 24,5.5V18.5C24,21.54 21.54,24 18.5,24H5.5C2.46,24 0,21.54 0,18.5V5.5C0,2.46 2.46,0 5.5,0M15.39,15.18C15.39,16.76 14.5,17.81 12.85,17.95V12.61C14.55,13.13 15.39,13.66 15.39,15.18M11.65,6V10.88C10.34,10.5 9.03,9.93 9.03,8.43C9.03,6.94 10.18,6.12 11.65,6M15.5,7.6L16.5,6.8C15.62,5.66 14.4,4.92 12.85,4.77V3.8H11.65V3.8L11.65,4.75C9.5,4.89 7.68,6.17 7.68,8.5C7.68,11 9.74,11.78 11.65,12.29V17.96C10.54,17.84 9.29,17.31 8.43,16.03L7.3,16.78C8.2,18.12 9.76,19 11.65,19.14V20.2H12.07L12.85,20.2V19.16C15.35,19 16.7,17.34 16.7,15.14C16.7,12.58 14.81,11.76 12.85,11.19V6.05C14,6.22 14.85,6.76 15.5,7.6Z' })
	  );
	};
	
	var SquareIncIcon = function SquareIncIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,3H18C19.66,3 21,4.34 21,6V18C21,19.66 19.66,21 18,21H6C4.34,21 3,19.66 3,18V6C3,4.34 4.34,3 6,3M7,6C6.45,6 6,6.45 6,7V17C6,17.55 6.45,18 7,18H17C17.55,18 18,17.55 18,17V7C18,6.45 17.55,6 17,6H7M9.5,9H14.5C14.78,9 15,9.22 15,9.5V14.5C15,14.78 14.78,15 14.5,15H9.5C9.22,15 9,14.78 9,14.5V9.5C9,9.22 9.22,9 9.5,9Z' })
	  );
	};
	
	var SquareOutlineIcon = function SquareOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3H21V21H3V3M5,5V19H19V5H5Z' })
	  );
	};
	
	var SquareRootBoxIcon = function SquareRootBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5M11.24,6H19V8H12.76L10,18H8L6.25,12H5V10H7.75L9,14.28L11.24,6V6M14,10.59L15.79,12.38L17.59,10.59L19,12L17.21,13.79L19,15.59L17.59,17L15.79,15.21L14,17L12.59,15.59L14.38,13.79L12.59,12L14,10.59Z' })
	  );
	};
	
	var SquareRootIcon = function SquareRootIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11.76,16.83L14.59,14L11.76,11.17L13.17,9.76L16,12.59L18.83,9.76L20.24,11.17L17.41,14L20.24,16.83L18.83,18.24L16,15.41L13.17,18.24L11.76,16.83M2,11H5V11H5L7.29,16.4L10,6H22V8H11.55L8.68,19H6.22L3.68,13H2V11Z' })
	  );
	};
	
	var SquareIcon = function SquareIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3V21H21V3' })
	  );
	};
	
	var SshIcon = function SshIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.5,9C3.9,9 3.5,9.5 3.5,10V11.75C3.5,12.25 3.9,12.75 4.5,12.75H7V13.5H3.5V15H7.5C8.1,15 8.5,14.5 8.5,14V12.25C8.5,11.75 8.1,11.25 7.5,11.25H5V10.5H8.5V9H4.5M10.5,9C9.9,9 9.5,9.5 9.5,10V11.75C9.5,12.25 9.9,12.75 10.5,12.75H13V13.5H9.5V15H13.5C14.1,15 14.5,14.5 14.5,14V12.25C14.5,11.75 14.1,11.25 13.5,11.25H11V10.5H14.5V9H10.5M15.5,9V15H17V12.5H19V15H20.5V9H19V11H17V9H15.5Z' })
	  );
	};
	
	var StackExchangeIcon = function StackExchangeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,14.04V11H20V14.04H4M4,10V7H20V10H4M17.46,2C18.86,2 20,3.18 20,4.63V6H4V4.63C4,3.18 5.14,2 6.54,2H17.46M4,15H20V16.35C20,17.81 18.86,19 17.46,19H16.5L13,22V19H6.54C5.14,19 4,17.81 4,16.35V15Z' })
	  );
	};
	
	var StackOverflowIcon = function StackOverflowIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.36,20.2V14.82H19.15V22H3V14.82H4.8V20.2H17.36M6.77,14.32L7.14,12.56L15.93,14.41L15.56,16.17L6.77,14.32M7.93,10.11L8.69,8.5L16.83,12.28L16.07,13.9L7.93,10.11M10.19,6.12L11.34,4.74L18.24,10.5L17.09,11.87L10.19,6.12M14.64,1.87L20,9.08L18.56,10.15L13.2,2.94L14.64,1.87M6.59,18.41V16.61H15.57V18.41H6.59Z' })
	  );
	};
	
	var StadiumIcon = function StadiumIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H7L10,5L7,7V8.33C8.47,8.12 10.18,8 12,8C13.82,8 15.53,8.12 17,8.33V3H19L22,5L19,7V8.71C20.85,9.17 22,9.8 22,10.5C22,11.88 17.5,13 12,13C6.5,13 2,11.88 2,10.5C2,9.8 3.15,9.17 5,8.71V3M12,9.5C8.69,9.5 7,9.67 7,10.5C7,11.33 8.69,11.5 12,11.5C15.31,11.5 17,11.33 17,10.5C17,9.67 15.31,9.5 12,9.5M12,14.75C15.81,14.75 19.2,14.08 21.4,13.05L20,21H15V19C15,17.9 14.1,17 13,17H11C9.9,17 9,17.9 9,19V21H4L2.6,13.05C4.8,14.08 8.19,14.75 12,14.75Z' })
	  );
	};
	
	var StairsIcon = function StairsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,5V9H11V13H7V17H3V20H10V16H14V12H18V8H22V5H15Z' })
	  );
	};
	
	var StandardDefinitionIcon = function StandardDefinitionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,7H16C17.66,7 19,8.34 19,10V14C19,15.66 17.66,17 16,17H13V7M16,15C16.55,15 17,14.55 17,14V10C17,9.45 16.55,9 16,9H15V15H16M7,7H11V9H7V11H9C10.1,11 11,11.9 11,13V15C11,16.1 10.1,17 9,17H5V15H9V13H7C5.9,13 5,12.1 5,11V9C5,7.9 5.9,7 7,7Z' })
	  );
	};
	
	var StarCircleOutlineIcon = function StarCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.58,17.25L9.5,13.36L6.5,10.78L10.45,10.41L12,6.8L13.55,10.45L17.5,10.78L14.5,13.36L15.42,17.25L12,15.19L8.58,17.25M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4Z' })
	  );
	};
	
	var StarCircleIcon = function StarCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.23,18L12,15.45L7.77,18L8.89,13.19L5.16,9.96L10.08,9.54L12,5L13.92,9.53L18.84,9.95L15.11,13.18L16.23,18M12,2C6.47,2 2,6.5 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var StarFaceIcon = function StarFaceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2.5L8.42,8.06L2,9.74L6.2,14.88L5.82,21.5L12,19.09L18.18,21.5L17.8,14.88L22,9.74L15.58,8.06L12,2.5M9.38,10.5C10,10.5 10.5,11 10.5,11.63C10.5,12.25 10,12.75 9.38,12.75C8.75,12.75 8.25,12.25 8.25,11.63C8.25,11 8.75,10.5 9.38,10.5M14.63,10.5C15.25,10.5 15.75,11 15.75,11.63C15.75,12.25 15.25,12.75 14.63,12.75C14,12.75 13.5,12.25 13.5,11.63C13.5,11 14,10.5 14.63,10.5M9,15H15C14.5,16.21 13.31,17 12,17C10.69,17 9.5,16.21 9,15Z' })
	  );
	};
	
	var StarHalfIcon = function StarHalfIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,15.4V6.1L13.71,10.13L18.09,10.5L14.77,13.39L15.76,17.67M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z' })
	  );
	};
	
	var StarOffIcon = function StarOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L17.05,20.31L12,17.27L5.82,21L7.45,13.97L2,9.24L5.66,8.93L2,5.27M12,2L14.81,8.62L22,9.24L16.54,13.97L16.77,14.95L9.56,7.74L12,2Z' })
	  );
	};
	
	var StarOutlineIcon = function StarOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z' })
	  );
	};
	
	var StarIcon = function StarIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z' })
	  );
	};
	
	var SteamBoxIcon = function SteamBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V15L6.19,16.31C6.45,17.6 7.6,18.58 8.97,18.58C10.53,18.58 11.8,17.31 11.8,15.75V15.62L15.2,13.19H15.28C17.36,13.19 19.05,11.5 19.05,9.42C19.05,7.34 17.36,5.65 15.28,5.65C13.2,5.65 11.5,7.34 11.5,9.42V9.47L9.13,12.93L8.97,12.92C8.38,12.92 7.83,13.1 7.38,13.41L3,11.6V5C3,3.9 3.9,3 5,3H19M8.28,17.17C9.08,17.5 10,17.13 10.33,16.33C10.66,15.53 10.28,14.62 9.5,14.29L8.22,13.76C8.71,13.58 9.26,13.57 9.78,13.79C10.31,14 10.72,14.41 10.93,14.94C11.15,15.46 11.15,16.04 10.93,16.56C10.5,17.64 9.23,18.16 8.15,17.71C7.65,17.5 7.27,17.12 7.06,16.67L8.28,17.17M17.8,9.42C17.8,10.81 16.67,11.94 15.28,11.94C13.9,11.94 12.77,10.81 12.77,9.42C12.77,8.03 13.89,6.91 15.28,6.91C16.67,6.91 17.8,8.04 17.8,9.42M13.4,9.42C13.4,10.46 14.24,11.31 15.29,11.31C16.33,11.31 17.17,10.46 17.17,9.42C17.17,8.38 16.33,7.53 15.29,7.53C14.24,7.53 13.4,8.38 13.4,9.42Z' })
	  );
	};
	
	var SteamIcon = function SteamIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C7.4,22 3.55,18.92 2.36,14.73L6.19,16.31C6.45,17.6 7.6,18.58 8.97,18.58C10.53,18.58 11.8,17.31 11.8,15.75V15.62L15.2,13.19H15.28C17.36,13.19 19.05,11.5 19.05,9.42C19.05,7.34 17.36,5.65 15.28,5.65C13.2,5.65 11.5,7.34 11.5,9.42V9.47L9.13,12.93L8.97,12.92C8.38,12.92 7.83,13.1 7.38,13.41L2,11.2C2.43,6.05 6.73,2 12,2M8.28,17.17C9.08,17.5 10,17.13 10.33,16.33C10.66,15.53 10.28,14.62 9.5,14.29L8.22,13.76C8.71,13.58 9.26,13.57 9.78,13.79C10.31,14 10.72,14.41 10.93,14.94C11.15,15.46 11.15,16.04 10.93,16.56C10.5,17.64 9.23,18.16 8.15,17.71C7.65,17.5 7.27,17.12 7.06,16.67L8.28,17.17M17.8,9.42C17.8,10.81 16.67,11.94 15.28,11.94C13.9,11.94 12.77,10.81 12.77,9.42C12.77,8.04 13.9,6.91 15.28,6.91C16.67,6.91 17.8,8.04 17.8,9.42M13.4,9.42C13.4,10.46 14.24,11.31 15.29,11.31C16.33,11.31 17.17,10.46 17.17,9.42C17.17,8.38 16.33,7.53 15.29,7.53C14.24,7.53 13.4,8.38 13.4,9.42Z' })
	  );
	};
	
	var SteeringOffIcon = function SteeringOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L17.25,20.5C15.7,21.5 13.95,22 12,22C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,10.05 2.5,8.3 3.5,6.75L2,5.27M13,19.92C14,19.8 14.93,19.5 15.78,19.05L13.5,16.78C13.34,16.84 13.16,16.88 13,16.92V19.92M4.08,11H7L7.37,10.63L4.96,8.23C4.5,9.08 4.21,10 4.08,11M19.92,13H16.92C16.8,13.54 16.6,14.05 16.33,14.5L9.91,8.09L10,8H14L17,11H19.92C19.67,9.05 18.79,7.38 17.27,6C15.76,4.66 14,4 12,4C10.26,4 8.71,4.5 7.34,5.5L5.91,4.09C7.66,2.71 9.69,2 12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12C22,14.31 21.29,16.34 19.91,18.09L18.5,16.67C19.28,15.59 19.76,14.36 19.92,13M11,19.92V16.92C10,16.7 9.16,16.24 8.46,15.54C7.76,14.84 7.3,14 7.08,13H4.08C4.3,14.77 5.05,16.3 6.35,17.6C7.65,18.9 9.2,19.67 11,19.92Z' })
	  );
	};
	
	var SteeringIcon = function SteeringIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,19.92C14.8,19.7 16.35,18.95 17.65,17.65C18.95,16.35 19.7,14.8 19.92,13H16.92C16.7,14 16.24,14.84 15.54,15.54C14.84,16.24 14,16.7 13,16.92V19.92M10,8H14L17,11H19.92C19.67,9.05 18.79,7.38 17.27,6C15.76,4.66 14,4 12,4C10,4 8.24,4.66 6.73,6C5.21,7.38 4.33,9.05 4.08,11H7L10,8M11,19.92V16.92C10,16.7 9.16,16.24 8.46,15.54C7.76,14.84 7.3,14 7.08,13H4.08C4.3,14.77 5.05,16.3 6.35,17.6C7.65,18.9 9.2,19.67 11,19.92M12,2C14.75,2 17.1,3 19.05,4.95C21,6.9 22,9.25 22,12C22,14.75 21,17.1 19.05,19.05C17.1,21 14.75,22 12,22C9.25,22 6.9,21 4.95,19.05C3,17.1 2,14.75 2,12C2,9.25 3,6.9 4.95,4.95C6.9,3 9.25,2 12,2Z' })
	  );
	};
	
	var StepBackward2Icon = function StepBackward2Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,5H14V19H17V5M12,5L1,12L12,19V5M22,5H19V19H22V5Z' })
	  );
	};
	
	var StepBackwardIcon = function StepBackwardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,5V19H16V5M14,5V19L3,12' })
	  );
	};
	
	var StepForward2Icon = function StepForward2Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,5H10V19H7V5M12,5L23,12L12,19V5M2,5H5V19H2V5Z' })
	  );
	};
	
	var StepForwardIcon = function StepForwardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,5V19H8V5M10,5V19L21,12' })
	  );
	};
	
	var StethoscopeIcon = function StethoscopeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,8C19.56,8 20,8.43 20,9C20,9.55 19.55,10 19,10C18.43,10 18,9.55 18,9C18,8.43 18.43,8 19,8M2,2V11C2,13.96 4.19,16.5 7.14,16.91C7.76,19.92 10.42,22 13.5,22C17.09,22 20,19.09 20,15.5V11.81C21.16,11.39 22,10.29 22,9C22,7.34 20.66,6 19,6C17.34,6 16,7.34 16,9C16,10.29 16.84,11.4 18,11.81V15.41C18,17.91 16,19.91 13.5,19.91C11.5,19.91 9.82,18.7 9.22,16.9C12,16.3 14,13.8 14,11V2H10V5H12V11C12,13.21 10.21,15 8,15C5.79,15 4,13.21 4,11V5H6V2H2Z' })
	  );
	};
	
	var StickerEmojiIcon = function StickerEmojiIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.5,2C3.56,2 2,3.56 2,5.5V18.5C2,20.44 3.56,22 5.5,22H16L22,16V5.5C22,3.56 20.44,2 18.5,2H5.5M5.75,4H18.25C19.22,4 20,4.78 20,5.75V15H18.5C16.56,15 15,16.56 15,18.5V20H5.75C4.78,20 4,19.22 4,18.25V5.75C4,4.78 4.78,4 5.75,4M14.44,6.77C14.28,6.77 14.12,6.79 13.97,6.83C13.03,7.09 12.5,8.05 12.74,9C12.79,9.15 12.86,9.3 12.95,9.44L16.18,8.56C16.18,8.39 16.16,8.22 16.12,8.05C15.91,7.3 15.22,6.77 14.44,6.77M8.17,8.5C8,8.5 7.85,8.5 7.7,8.55C6.77,8.81 6.22,9.77 6.47,10.7C6.5,10.86 6.59,11 6.68,11.16L9.91,10.28C9.91,10.11 9.89,9.94 9.85,9.78C9.64,9 8.95,8.5 8.17,8.5M16.72,11.26L7.59,13.77C8.91,15.3 11,15.94 12.95,15.41C14.9,14.87 16.36,13.25 16.72,11.26Z' })
	  );
	};
	
	var StickerIcon = function StickerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.12,18.46L18.3,12.28C16.94,12.59 15.31,13.2 14.07,14.46C13.04,15.5 12.39,16.83 12.12,18.46M20.75,10H21.05C21.44,10 21.79,10.27 21.93,10.64C22.07,11 22,11.43 21.7,11.71L11.7,21.71C11.5,21.9 11.26,22 11,22L10.64,21.93C10.27,21.79 10,21.44 10,21.05C9.84,17.66 10.73,14.96 12.66,13.03C15.5,10.2 19.62,10 20.75,10M12,2C16.5,2 20.34,5 21.58,9.11L20,9H19.42C18.24,6.07 15.36,4 12,4C7.58,4 4,7.58 4,12C4,15.36 6.07,18.24 9,19.42C8.97,20.13 9,20.85 9.11,21.57C5,20.33 2,16.5 2,12C2,6.47 6.5,2 12,2Z' })
	  );
	};
	
	var StockingIcon = function StockingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,2C18.1,2 19,2.9 19,4V7C19,8.1 18.1,9 17,9V17C17,17.85 16.5,18.57 15.74,18.86L9.5,21.77C8.5,22.24 7.29,21.81 6.83,20.81L6,19C5.5,18 5.95,16.8 6.95,16.34L10,14.91V9C8.9,9 8,8.1 8,7V4C8,2.9 8.9,2 10,2H17M10,4V7H17V4H10Z' })
	  );
	};
	
	var StopCircleOutlineIcon = function StopCircleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4M9,9V15H15V9' })
	  );
	};
	
	var StopCircleIcon = function StopCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M9,9H15V15H9' })
	  );
	};
	
	var StopIcon = function StopIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,18H6V6H18V18Z' })
	  );
	};
	
	var Store24HourIcon = function Store24HourIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,12H15V10H13V7H14V9H15V7H16M11,10H9V11H11V12H8V9H10V8H8V7H11M19,7V4H5V7H2V20H10V16H14V20H22V7H19Z' })
	  );
	};
	
	var StoreIcon = function StoreIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,18H6V14H12M21,14V12L20,7H4L3,12V14H4V20H14V14H18V20H20V14M20,4H4V6H20V4Z' })
	  );
	};
	
	var StoveIcon = function StoveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,14H8L11,17H9L6,14M4,4H5V3C5,2.45 5.45,2 6,2H10C10.55,2 11,2.45 11,3V4H13V3C13,2.45 13.45,2 14,2H18C18.55,2 19,2.45 19,3V4H20C21.1,4 22,4.9 22,6V19C22,20.1 21.1,21 20,21V22H17V21H7V22H4V21C2.9,21 2,20.1 2,19V6C2,4.9 2.9,4 4,4M18,7C18.55,7 19,7.45 19,8C19,8.55 18.55,9 18,9C17.45,9 17,8.55 17,8C17,7.45 17.45,7 18,7M14,7C14.55,7 15,7.45 15,8C15,8.55 14.55,9 14,9C13.45,9 13,8.55 13,8C13,7.45 13.45,7 14,7M20,6H4V10H20V6M4,19H20V12H4V19M6,7C6.55,7 7,7.45 7,8C7,8.55 6.55,9 6,9C5.45,9 5,8.55 5,8C5,7.45 5.45,7 6,7M13,14H15L18,17H16L13,14Z' })
	  );
	};
	
	var SubdirectoryArrowLeftIcon = function SubdirectoryArrowLeftIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,9L12.42,10.42L8.83,14H18V4H20V16H8.83L12.42,19.58L11,21L5,15L11,9Z' })
	  );
	};
	
	var SubdirectoryArrowRightIcon = function SubdirectoryArrowRightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,15L13,21L11.58,19.58L15.17,16H4V4H6V14H15.17L11.58,10.42L13,9L19,15Z' })
	  );
	};
	
	var SubwayVariantIcon = function SubwayVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,11H13V6H18M16.5,17C15.67,17 15,16.33 15,15.5C15,14.67 15.67,14 16.5,14C17.33,14 18,14.67 18,15.5C18,16.33 17.33,17 16.5,17M11,11H6V6H11M7.5,17C6.67,17 6,16.33 6,15.5C6,14.67 6.67,14 7.5,14C8.33,14 9,14.67 9,15.5C9,16.33 8.33,17 7.5,17M12,2C7.58,2 4,2.5 4,6V15.5C4,17.43 5.57,19 7.5,19L6,20.5V21H18V20.5L16.5,19C18.43,19 20,17.43 20,15.5V6C20,2.5 16.42,2 12,2Z' })
	  );
	};
	
	var SubwayIcon = function SubwayIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.5,15C9.05,15 9.5,15.45 9.5,16C9.5,16.55 9.05,17 8.5,17C7.95,17 7.5,16.55 7.5,16C7.5,15.45 7.95,15 8.5,15M7,9H17V14H7V9M15.5,15C16.05,15 16.5,15.45 16.5,16C16.5,16.55 16.05,17 15.5,17C14.95,17 14.5,16.55 14.5,16C14.5,15.45 14.95,15 15.5,15M18,15.88V9C18,6.38 15.32,6 12,6C9,6 6,6.37 6,9V15.88C6,17.33 7.17,18.5 8.62,18.5L7.5,19.62V20H9.17L10.67,18.5H13.5L15,20H16.5V19.62L15.37,18.5C16.82,18.5 18,17.33 18,15.88M17.8,2.8C20.47,3.84 22,6.05 22,8.86V22H2V8.86C2,6.05 3.53,3.84 6.2,2.8C8,2.09 10.14,2 12,2C13.86,2 16,2.09 17.8,2.8Z' })
	  );
	};
	
	var SummitIcon = function SummitIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,3H17L22,5L17,7V10.17L22,21H2L8,13L11.5,17.7L15,10.17V3Z' })
	  );
	};
	
	var SunglassesIcon = function SunglassesIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,17H4C2.38,17 0.96,15.74 0.76,14.14L0.26,11.15C0.15,10.3 0.39,9.5 0.91,8.92C1.43,8.34 2.19,8 3,8H9C9.83,8 10.58,8.35 11.06,8.96C11.17,9.11 11.27,9.27 11.35,9.45C11.78,9.36 12.22,9.36 12.64,9.45C12.72,9.27 12.82,9.11 12.94,8.96C13.41,8.35 14.16,8 15,8H21C21.81,8 22.57,8.34 23.09,8.92C23.6,9.5 23.84,10.3 23.74,11.11L23.23,14.18C23.04,15.74 21.61,17 20,17H17C15.44,17 13.92,15.81 13.54,14.3L12.64,11.59C12.26,11.31 11.73,11.31 11.35,11.59L10.43,14.37C10.07,15.82 8.56,17 7,17Z' })
	  );
	};
	
	var SurroundSound20Icon = function SurroundSound20Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,7H19C20.1,7 21,7.9 21,9V15C21,16.1 20.1,17 19,17H17C15.9,17 15,16.1 15,15V9C15,7.9 15.9,7 17,7M17,9V15H19V9H17M9,17H3V15L7,9H3V7H7C8.1,7 9,7.9 9,9C9,9.42 8.87,9.81 8.65,10.13L5.41,15H9V17M12,17C11.45,17 11,16.55 11,16C11,15.45 11.45,15 12,15C12.55,15 13,15.45 13,16C13,16.55 12.55,17 12,17Z' })
	  );
	};
	
	var SurroundSound31Icon = function SurroundSound31Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,17C12.45,17 12,16.55 12,16C12,15.45 12.45,15 13,15C13.55,15 14,15.45 14,16C14,16.55 13.55,17 13,17M19,7V15H20V17H16V15H17V9H16L17,7H19M4,7H8C9.1,7 10,7.9 10,9V15C10,16.1 9.1,17 8,17H4V15H8V13H5V11H8V9H4V7Z' })
	  );
	};
	
	var SurroundSound51Icon = function SurroundSound51Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,17C12.45,17 12,16.55 12,16C12,15.45 12.45,15 13,15C13.55,15 14,15.45 14,16C14,16.55 13.55,17 13,17M19,7V15H20V17H16V15H17V9H16L17,7H19M6,13C4.9,13 4,12.1 4,11V7H10V9H6V11H8C9.1,11 10,11.9 10,13V15C10,16.1 9.1,17 8,17H4V15H8V13H6Z' })
	  );
	};
	
	var SurroundSound71Icon = function SurroundSound71Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,17C11.45,17 11,16.55 11,16C11,15.45 11.45,15 12,15C12.55,15 13,15.45 13,16C13,16.55 12.55,17 12,17M18,7V15H19V17H15V15H16V9H15L16,7H18M11,7L8,17H6L8.4,9H5V7H11Z' })
	  );
	};
	
	var SurroundSoundIcon = function SurroundSoundIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,4H4C2.9,4 2,4.9 2,6V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V6C22,4.9 21.1,4 20,4M7.76,16.24L6.35,17.65C4.78,16.1 4,14.05 4,12C4,9.95 4.78,7.9 6.34,6.34L7.75,7.75C6.59,8.93 6,10.46 6,12C6,13.54 6.59,15.07 7.76,16.24M12,16C9.79,16 8,14.21 8,12C8,9.79 9.79,8 12,8C14.21,8 16,9.79 16,12C16,14.21 14.21,16 12,16M17.66,17.66L16.25,16.25C17.41,15.07 18,13.54 18,12C18,10.46 17.41,8.93 16.24,7.76L17.65,6.35C19.22,7.9 20,9.95 20,12C20,14.05 19.22,16.1 17.66,17.66M12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10Z' })
	  );
	};
	
	var SvgIcon = function SvgIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.13,10.71H8.87L6.22,8.06C5.21,8.06 4.39,7.24 4.39,6.22C4.39,5.21 5.21,4.39 6.22,4.39C7.24,4.39 8.06,5.21 8.06,6.22L10.71,8.87V5.13C10,4.41 10,3.25 10.71,2.54C11.42,1.82 12.58,1.82 13.29,2.54C14,3.25 14,4.41 13.29,5.13V8.87L15.95,6.22C15.95,5.21 16.76,4.39 17.78,4.39C18.79,4.39 19.61,5.21 19.61,6.22C19.61,7.24 18.79,8.06 17.78,8.06L15.13,10.71H18.87C19.59,10 20.75,10 21.46,10.71C22.18,11.42 22.18,12.58 21.46,13.29C20.75,14 19.59,14 18.87,13.29H15.13L17.78,15.95C18.79,15.95 19.61,16.76 19.61,17.78C19.61,18.79 18.79,19.61 17.78,19.61C16.76,19.61 15.95,18.79 15.95,17.78L13.29,15.13V18.87C14,19.59 14,20.75 13.29,21.46C12.58,22.18 11.42,22.18 10.71,21.46C10,20.75 10,19.59 10.71,18.87V15.13L8.06,17.78C8.06,18.79 7.24,19.61 6.22,19.61C5.21,19.61 4.39,18.79 4.39,17.78C4.39,16.76 5.21,15.95 6.22,15.95L8.87,13.29H5.13C4.41,14 3.25,14 2.54,13.29C1.82,12.58 1.82,11.42 2.54,10.71C3.25,10 4.41,10 5.13,10.71Z' })
	  );
	};
	
	var SwapHorizontalVariantIcon = function SwapHorizontalVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,6L8,10V7H16C17.1,7 18,7.9 18,9C18,10.1 17.1,11 16,11H8C5.79,11 4,12.79 4,15C4,17.21 5.79,19 8,19H16V22L20,18L16,14V17H8C6.9,17 6,16.1 6,15C6,13.9 6.9,13 8,13H16C18.21,13 20,11.21 20,9C20,6.79 18.21,5 16,5H8V2L4,6Z' })
	  );
	};
	
	var SwapHorizontalIcon = function SwapHorizontalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,9L17,5V8H10V10H17V13M7,11L3,15L7,19V16H14V14H7V11Z' })
	  );
	};
	
	var SwapVerticalVariantIcon = function SwapVerticalVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,4L14,8H17V16C17,17.1 16.1,18 15,18C13.9,18 13,17.1 13,16V8C13,5.79 11.21,4 9,4C6.79,4 5,5.79 5,8V16H2L6,20L10,16H7V8C7,6.9 7.9,6 9,6C10.1,6 11,6.9 11,8V16C11,18.21 12.79,20 15,20C17.21,20 19,18.21 19,16V8H22L18,4Z' })
	  );
	};
	
	var SwapVerticalIcon = function SwapVerticalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,3L5,7H8V14H10V7H13M16,17V10H14V17H11L15,21L19,17H16Z' })
	  );
	};
	
	var SwimIcon = function SwimIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,18C4.22,17 6.44,16 8.67,16C10.89,16 13.11,18 15.33,18C17.56,18 19.78,16 22,16V19C19.78,19 17.56,21 15.33,21C13.11,21 10.89,19 8.67,19C6.44,19 4.22,20 2,21V18M8.67,13C7.89,13 7.12,13.12 6.35,13.32L11.27,9.88L10.23,8.64C10.09,8.47 10,8.24 10,8C10,7.66 10.17,7.35 10.44,7.17L16.16,3.17L17.31,4.8L12.47,8.19L17.7,14.42C16.91,14.75 16.12,15 15.33,15C13.11,15 10.89,13 8.67,13M18,7C19.1,7 20,7.9 20,9C20,10.1 19.1,11 18,11C16.9,11 16,10.1 16,9C16,7.9 16.9,7 18,7Z' })
	  );
	};
	
	var SwitchIcon = function SwitchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,18H14C14.55,18 15,18.45 15,19H22V21H15C15,21.55 14.55,22 14,22H10C9.45,22 9,21.55 9,21H2V19H9C9,18.45 9.45,18 10,18H11V16H8C7.45,16 7,15.55 7,15V3C7,2.45 7.45,2 8,2H16C16.55,2 17,2.45 17,3V15C17,15.55 16.55,16 16,16H13V18M13,6H14V4H13V6M9,4V6H11V4H9M9,8V10H11V8H9M9,12V14H11V12H9Z' })
	  );
	};
	
	var SwordCrossIcon = function SwordCrossIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.2,2.44L18.1,14.34L20.22,12.22L21.63,13.63L19.16,16.1L22.34,19.28C22.73,19.67 22.73,20.3 22.34,20.69L21.63,21.4C21.24,21.79 20.61,21.79 20.22,21.4L17,18.23L14.56,20.7L13.15,19.29L15.27,17.17L3.37,5.27V2.44H6.2M15.89,10L20.63,5.26V2.44H17.8L13.06,7.18L15.89,10M10.94,15L8.11,12.13L5.9,14.34L3.78,12.22L2.37,13.63L4.84,16.1L1.66,19.29C1.27,19.68 1.27,20.31 1.66,20.7L2.37,21.41C2.76,21.8 3.39,21.8 3.78,21.41L7,18.23L9.44,20.7L10.85,19.29L8.73,17.17L10.94,15Z' })
	  );
	};
	
	var SwordIcon = function SwordIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.92,5H5L14,14L15,13.06M19.96,19.12L19.12,19.96C18.73,20.35 18.1,20.35 17.71,19.96L14.59,16.84L11.91,19.5L10.5,18.09L11.92,16.67L3,7.75V3H7.75L16.67,11.92L18.09,10.5L19.5,11.91L16.83,14.58L19.95,17.7C20.35,18.1 20.35,18.73 19.96,19.12Z' })
	  );
	};
	
	var SyncAlertIcon = function SyncAlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,13H13V7H11M21,4H15V10L17.24,7.76C18.32,8.85 19,10.34 19,12C19,14.61 17.33,16.83 15,17.65V19.74C18.45,18.85 21,15.73 21,12C21,9.79 20.09,7.8 18.64,6.36M11,17H13V15H11M3,12C3,14.21 3.91,16.2 5.36,17.64L3,20H9V14L6.76,16.24C5.68,15.15 5,13.66 5,12C5,9.39 6.67,7.17 9,6.35V4.26C5.55,5.15 3,8.27 3,12Z' })
	  );
	};
	
	var SyncOffIcon = function SyncOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,4H14V10L16.24,7.76C17.32,8.85 18,10.34 18,12C18,13 17.75,13.94 17.32,14.77L18.78,16.23C19.55,15 20,13.56 20,12C20,9.79 19.09,7.8 17.64,6.36L20,4M2.86,5.41L5.22,7.77C4.45,9 4,10.44 4,12C4,14.21 4.91,16.2 6.36,17.64L4,20H10V14L7.76,16.24C6.68,15.15 6,13.66 6,12C6,11 6.25,10.06 6.68,9.23L14.76,17.31C14.5,17.44 14.26,17.56 14,17.65V19.74C14.79,19.53 15.54,19.2 16.22,18.78L18.58,21.14L19.85,19.87L4.14,4.14L2.86,5.41M10,6.35V4.26C9.2,4.47 8.45,4.8 7.77,5.22L9.23,6.68C9.5,6.56 9.73,6.44 10,6.35Z' })
	  );
	};
	
	var SyncIcon = function SyncIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,18C8.69,18 6,15.31 6,12C6,11 6.25,10.03 6.7,9.2L5.24,7.74C4.46,8.97 4,10.43 4,12C4,16.42 7.58,20 12,20V23L16,19L12,15M12,4V1L8,5L12,9V6C15.31,6 18,8.69 18,12C18,13 17.75,13.97 17.3,14.8L18.76,16.26C19.54,15.03 20,13.57 20,12C20,7.58 16.42,4 12,4Z' })
	  );
	};
	
	var TabPlusIcon = function TabPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3C1.9,3 1,3.9 1,5V19C1,20.1 1.9,21 3,21H21C22.1,21 23,20.1 23,19V5C23,3.9 22.1,3 21,3H3M3,5H13V9H21V19H3V5M10,10V13H7V15H10V18H12V15H15V13H12V10H10Z' })
	  );
	};
	
	var TabUnselectedIcon = function TabUnselectedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,9H3V7H1V9M1,13H3V11H1V13M1,5H3V3C1.9,3 1,3.9 1,5M9,21H11V19H9V21M1,17H3V15H1V17M3,21V19H1C1,20.1 1.9,21 3,21M21,3H13V9H23V5C23,3.9 22.1,3 21,3M21,17H23V15H21V17M9,5H11V3H9V5M5,21H7V19H5V21M5,5H7V3H5V5M21,21C22.1,21 23,20.1 23,19H21V21M21,13H23V11H21V13M13,21H15V19H13V21M17,21H19V19H17V21Z' })
	  );
	};
	
	var TabIcon = function TabIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,3H3C1.9,3 1,3.9 1,5V19C1,20.1 1.9,21 3,21H21C22.1,21 23,20.1 23,19V5C23,3.9 22.1,3 21,3M21,19H3V5H13V9H21V19Z' })
	  );
	};
	
	var TableColumnPlusAfterIcon = function TableColumnPlusAfterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,2C12.1,2 13,2.9 13,4V20C13,21.1 12.1,22 11,22H2V2H11M4,10V14H11V10H4M4,16V20H11V16H4M4,4V8H11V4H4M15,11H18V8H20V11H23V13H20V16H18V13H15V11Z' })
	  );
	};
	
	var TableColumnPlusBeforeIcon = function TableColumnPlusBeforeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,2C11.9,2 11,2.9 11,4V20C11,21.1 11.9,22 13,22H22V2H13M20,10V14H13V10H20M20,16V20H13V16H20M20,4V8H13V4H20M9,11H6V8H4V11H1V13H4V16H6V13H9V11Z' })
	  );
	};
	
	var TableColumnRemoveIcon = function TableColumnRemoveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H11C12.1,2 13,2.9 13,4V20C13,21.1 12.1,22 11,22H4C2.9,22 2,21.1 2,20V4C2,2.9 2.9,2 4,2M4,10V14H11V10H4M4,16V20H11V16H4M4,4V8H11V4H4M17.59,12L15,9.41L16.41,8L19,10.59L21.59,8L23,9.41L20.41,12L23,14.59L21.59,16L19,13.41L16.41,16L15,14.59L17.59,12Z' })
	  );
	};
	
	var TableColumnWidthIcon = function TableColumnWidthIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,8H19C20.1,8 21,8.9 21,10V20C21,21.1 20.1,22 19,22H5C3.9,22 3,21.1 3,20V10C3,8.9 3.9,8 5,8M5,12V15H11V12H5M13,12V15H19V12H13M5,17V20H11V17H5M13,17V20H19V17H13M11,2H21V6H19V4H13V6H11V2Z' })
	  );
	};
	
	var TableColumnIcon = function TableColumnIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,2H16C17.1,2 18,2.9 18,4V20C18,21.1 17.1,22 16,22H8C6.9,22 6,21.1 6,20V4C6,2.9 6.9,2 8,2M8,10V14H16V10H8M8,16V20H16V16H8M8,4V8H16V4H8Z' })
	  );
	};
	
	var TableEditIcon = function TableEditIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.7,13.35L20.7,14.35L18.65,12.3L19.65,11.3C19.86,11.08 20.21,11.08 20.42,11.3L21.7,12.58C21.92,12.79 21.92,13.14 21.7,13.35M12,18.94L18.07,12.88L20.12,14.93L14.06,21H12V18.94M4,2H18C19.1,2 20,2.9 20,4V8.17L16.17,12H12V16.17L10.17,18H4C2.9,18 2,17.1 2,16V4C2,2.9 2.9,2 4,2M4,6V10H10V6H4M12,6V10H18V6H12M4,12V16H10V12H4Z' })
	  );
	};
	
	var TableLargeIcon = function TableLargeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,3H20C21.1,3 22,3.9 22,5V20C22,21.1 21.1,22 20,22H4C2.9,22 2,21.1 2,20V5C2,3.9 2.9,3 4,3M4,7V10H8V7H4M10,7V10H14V7H10M20,10V7H16V10H20M4,12V15H8V12H4M4,20H8V17H4V20M10,12V15H14V12H10M10,20H14V17H10V20M20,20V17H16V20H20M20,12H16V15H20V12Z' })
	  );
	};
	
	var TableMergeCellsIcon = function TableMergeCellsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,10H3V6C3,4.9 3.9,4 5,4H11V6H5V10M19,18H13V20H19C20.1,20 21,19.1 21,18V14H19V18M5,18V14H3V18C3,19.1 3.9,20 5,20H11V18H5M19,4H13V6H19V10H21V6C21,4.9 20.1,4 19,4M8,13V15L11,12L8,9V11H3V13H8M16,11V9L13,12L16,15V13H21V11H16Z' })
	  );
	};
	
	var TableOfContentsIcon = function TableOfContentsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,9H17V7H3V9M3,13H17V11H3V13M3,17H17V15H3V17M19,17H21V15H19V17M19,7V9H21V7H19M19,13H21V11H19V13Z' })
	  );
	};
	
	var TableRowHeightIcon = function TableRowHeightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,5H15C16.1,5 17,5.9 17,7V17C17,18.1 16.1,19 15,19H3C1.9,19 1,18.1 1,17V7C1,5.9 1.9,5 3,5M3,9V12H8V9H3M10,9V12H15V9H10M3,14V17H8V14H3M10,14V17H15V14H10M23,14V7H19V9H21V12H19V14H23Z' })
	  );
	};
	
	var TableRowPlusAfterIcon = function TableRowPlusAfterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,10C22,11.1 21.1,12 20,12H4C2.9,12 2,11.1 2,10V3H4V5H8V3H10V5H14V3H16V5H20V3H22V10M4,10H8V7H4V10M10,10H14V7H10V10M20,10V7H16V10H20M11,14H13V17H16V19H13V22H11V19H8V17H11V14Z' })
	  );
	};
	
	var TableRowPlusBeforeIcon = function TableRowPlusBeforeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,14C22,12.9 21.1,12 20,12H4C2.9,12 2,12.9 2,14V21H4V19H8V21H10V19H14V21H16V19H20V21H22V14M4,14H8V17H4V14M10,14H14V17H10V14M20,14V17H16V14H20M11,10H13V7H16V5H13V2H11V5H8V7H11V10Z' })
	  );
	};
	
	var TableRowRemoveIcon = function TableRowRemoveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.41,13L12,15.59L14.59,13L16,14.41L13.41,17L16,19.59L14.59,21L12,18.41L9.41,21L8,19.59L10.59,17L8,14.41L9.41,13M22,9C22,10.1 21.1,11 20,11H4C2.9,11 2,10.1 2,9V6C2,4.9 2.9,4 4,4H20C21.1,4 22,4.9 22,6V9M4,9H8V6H4V9M10,9H14V6H10V9M16,9H20V6H16V9Z' })
	  );
	};
	
	var TableRowIcon = function TableRowIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,14C22,15.1 21.1,16 20,16H4C2.9,16 2,15.1 2,14V10C2,8.9 2.9,8 4,8H20C21.1,8 22,8.9 22,10V14M4,14H8V10H4V14M10,14H14V10H10V14M16,14H20V10H16V14Z' })
	  );
	};
	
	var TableSearchIcon = function TableSearchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.3,17.89C20.62,15.79 20,13 17.89,11.68C15.79,10.36 13,11 11.68,13.09C10.36,15.2 11,18 13.09,19.3C14.56,20.22 16.42,20.22 17.89,19.3L21,22.39L22.39,21L19.3,17.89M17.3,17.27C16.32,18.25 14.74,18.24 13.76,17.27C12.79,16.29 12.79,14.71 13.77,13.73C14.74,12.76 16.32,12.76 17.3,13.73C18.26,14.72 18.25,16.3 17.27,17.27H17.3M19,4H5C3.9,4 3,4.9 3,6V18C3,19.1 3.9,20 5,20H10.81C10.25,19.42 9.8,18.74 9.5,18H5V14H9.18C9.34,13.29 9.61,12.61 10,12H5V8H11V10.81C11.58,10.25 12.26,9.8 13,9.5V8H19V10C19.4,10.25 19.77,10.55 20.1,10.88C20.44,11.22 20.74,11.59 21,12V6C21,4.9 20.1,4 19,4Z' })
	  );
	};
	
	var TableSettingsIcon = function TableSettingsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22M5,4H19C20.1,4 21,4.9 21,6V18C21,19.1 20.1,20 19,20H5C3.9,20 3,19.1 3,18V6C3,4.9 3.9,4 5,4M5,8V12H11V8H5M13,8V12H19V8H13M5,14V18H11V14H5M13,14V18H19V14H13Z' })
	  );
	};
	
	var TableIcon = function TableIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,4H19C20.1,4 21,4.9 21,6V18C21,19.1 20.1,20 19,20H5C3.9,20 3,19.1 3,18V6C3,4.9 3.9,4 5,4M5,8V12H11V8H5M13,8V12H19V8H13M5,14V18H11V14H5M13,14V18H19V14H13Z' })
	  );
	};
	
	var TabletAndroidIcon = function TabletAndroidIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.25,19H4.75V3H19.25M14,22H10V21H14M18,0H6C4.34,0 3,1.34 3,3V21C3,22.66 4.34,24 6,24H18C19.66,24 21,22.66 21,21V3C21,1.34 19.66,0 18,0Z' })
	  );
	};
	
	var TabletCellphoneIcon = function TabletCellphoneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4H20C21.1,4 22,4.9 22,6V8H18V6H5V18H14V20H3C1.9,20 1,19.1 1,18V6C1,4.9 1.9,4 3,4M17,10H23C23.55,10 24,10.45 24,11V21C24,21.55 23.55,22 23,22H17C16.45,22 16,21.55 16,21V11C16,10.45 16.45,10 17,10M18,12V19H22V12H18Z' })
	  );
	};
	
	var TabletIpadIcon = function TabletIpadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,19H4V3H19M11.5,23C10.67,23 10,22.33 10,21.5C10,20.67 10.67,20 11.5,20C12.33,20 13,20.67 13,21.5C13,22.33 12.33,23 11.5,23M18.5,0H4.5C3.12,0 2,1.12 2,2.5V21.5C2,22.88 3.12,24 4.5,24H18.5C19.88,24 21,22.88 21,21.5V2.5C21,1.12 19.88,0 18.5,0Z' })
	  );
	};
	
	var TabletIcon = function TabletIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,18H5V6H19M21,4H3C1.89,4 1,4.89 1,6V18C1,19.1 1.9,20 3,20H21C22.1,20 23,19.1 23,18V6C23,4.89 22.1,4 21,4Z' })
	  );
	};
	
	var TacoIcon = function TacoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,18H5C2.79,18 1,16.21 1,14C1,9.58 4.58,6 9,6C10.06,6 11.07,6.21 12,6.58C12.93,6.21 13.94,6 15,6C19.42,6 23,9.58 23,14C23,16.21 21.21,18 19,18M3,14C3,15.1 3.9,16 5,16C6.1,16 7,15.1 7,14C7,11.63 8.03,9.5 9.67,8.04L9,8C5.69,8 3,10.69 3,14M19,16C20.1,16 21,15.1 21,14C21,10.69 18.31,8 15,8C11.69,8 9,10.69 9,14C9,14.73 8.81,15.41 8.46,16H19Z' })
	  );
	};
	
	var TagFacesIcon = function TagFacesIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,18C11.68,18 9,15.31 9,12C9,8.68 11.68,6 15,6C18.31,6 21,8.69 21,12C21,15.31 18.31,18 15,18M4,13C3.45,13 3,12.55 3,12C3,11.45 3.45,11 4,11C4.55,11 5,11.45 5,12C5,12.55 4.55,13 4,13M22,3H7.63C6.97,3 6.38,3.32 6,3.81L0,12L6,20.18C6.38,20.68 6.97,21 7.63,21H22C23.1,21 24,20.1 24,19V5C24,3.89 23.1,3 22,3M13,11C13.55,11 14,10.55 14,10C14,9.45 13.55,9 13,9C12.45,9 12,9.45 12,10C12,10.55 12.45,11 13,11M15,16C16.86,16 18.35,14.72 18.8,13H11.2C11.65,14.72 13.14,16 15,16M17,11C17.55,11 18,10.55 18,10C18,9.45 17.55,9 17,9C16.45,9 16,9.45 16,10C16,10.55 16.45,11 17,11Z' })
	  );
	};
	
	var TagHeartIcon = function TagHeartIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.41,11.58L12.41,2.58C12.05,2.22 11.55,2 11,2H4C2.9,2 2,2.9 2,4V11C2,11.55 2.22,12.05 2.59,12.42L11.59,21.42C11.95,21.78 12.45,22 13,22C13.55,22 14.05,21.78 14.41,21.41L21.41,14.41C21.78,14.05 22,13.55 22,13C22,12.45 21.77,11.94 21.41,11.58M5.5,7C4.67,7 4,6.33 4,5.5C4,4.67 4.67,4 5.5,4C6.33,4 7,4.67 7,5.5C7,6.33 6.33,7 5.5,7M17.27,15.27L13,19.54L8.73,15.27C8.28,14.81 8,14.19 8,13.5C8,12.12 9.12,11 10.5,11C11.19,11 11.82,11.28 12.27,11.74L13,12.46L13.73,11.73C14.18,11.28 14.81,11 15.5,11C16.88,11 18,12.12 18,13.5C18,14.19 17.72,14.82 17.27,15.27Z' })
	  );
	};
	
	var TagMinusIcon = function TagMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.41,11.58L12.41,2.58C12.04,2.21 11.53,2 11,2H4C2.9,2 2,2.9 2,4V11C2,11.53 2.21,12.04 2.59,12.41L3,12.81C3.9,12.27 4.94,12 6,12C9.31,12 12,14.69 12,18C12,19.06 11.72,20.09 11.18,21L11.58,21.4C11.95,21.78 12.47,22 13,22C13.53,22 14.04,21.79 14.41,21.41L21.41,14.41C21.79,14.04 22,13.53 22,13C22,12.47 21.79,11.96 21.41,11.58M5.5,7C4.67,7 4,6.33 4,5.5C4,4.67 4.67,4 5.5,4C6.33,4 7,4.67 7,5.5C7,6.33 6.33,7 5.5,7M10,19H2V17H10V19Z' })
	  );
	};
	
	var TagMultipleIcon = function TagMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.5,9C6.33,9 7,8.33 7,7.5C7,6.67 6.33,6 5.5,6C4.67,6 4,6.67 4,7.5C4,8.33 4.67,9 5.5,9M17.41,11.58C17.77,11.94 18,12.44 18,13C18,13.55 17.78,14.05 17.41,14.41L12.41,19.41C12.05,19.77 11.55,20 11,20C10.45,20 9.95,19.78 9.58,19.41L2.59,12.42C2.22,12.05 2,11.55 2,11V6C2,4.89 2.89,4 4,4H9C9.55,4 10.05,4.22 10.41,4.58L17.41,11.58M13.54,5.71L14.54,4.71L21.41,11.58C21.78,11.94 22,12.45 22,13C22,13.55 21.78,14.05 21.42,14.41L16.04,19.79L15.04,18.79L20.75,13L13.54,5.71Z' })
	  );
	};
	
	var TagOutlineIcon = function TagOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.5,7C6.33,7 7,6.33 7,5.5C7,4.67 6.33,4 5.5,4C4.67,4 4,4.67 4,5.5C4,6.33 4.67,7 5.5,7M21.41,11.58C21.77,11.94 22,12.44 22,13C22,13.55 21.78,14.05 21.41,14.41L14.41,21.41C14.05,21.77 13.55,22 13,22C12.45,22 11.95,21.77 11.58,21.41L2.59,12.41C2.22,12.05 2,11.55 2,11V4C2,2.89 2.89,2 4,2H11C11.55,2 12.05,2.22 12.41,2.58L21.41,11.58M13,20L20,13L11.5,4.5L4.5,11.5L13,20Z' })
	  );
	};
	
	var TagPlusIcon = function TagPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.41,11.58L12.41,2.58C12.04,2.21 11.53,2 11,2H4C2.9,2 2,2.9 2,4V11C2,11.53 2.21,12.04 2.59,12.41L3,12.81C3.9,12.27 4.94,12 6,12C9.31,12 12,14.69 12,18C12,19.06 11.72,20.09 11.18,21L11.58,21.4C11.95,21.78 12.47,22 13,22C13.53,22 14.04,21.79 14.41,21.41L21.41,14.41C21.79,14.04 22,13.53 22,13C22,12.47 21.79,11.96 21.41,11.58M5.5,7C4.67,7 4,6.33 4,5.5C4,4.67 4.67,4 5.5,4C6.33,4 7,4.67 7,5.5C7,6.33 6.33,7 5.5,7M10,19H7V22H5V19H2V17H5V14H7V17H10V19Z' })
	  );
	};
	
	var TagRemoveIcon = function TagRemoveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.41,11.58L12.41,2.58C12.04,2.21 11.53,2 11,2H4C2.9,2 2,2.9 2,4V11C2,11.53 2.21,12.04 2.59,12.41L3,12.81C3.9,12.27 4.94,12 6,12C9.31,12 12,14.69 12,18C12,19.06 11.72,20.09 11.18,21L11.58,21.4C11.95,21.78 12.47,22 13,22C13.53,22 14.04,21.79 14.41,21.41L21.41,14.41C21.79,14.04 22,13.53 22,13C22,12.47 21.79,11.96 21.41,11.58M5.5,7C4.67,7 4,6.33 4,5.5C4,4.67 4.67,4 5.5,4C6.33,4 7,4.67 7,5.5C7,6.33 6.33,7 5.5,7M8.12,21.54L6,19.41L3.88,21.54L2.46,20.12L4.59,18L2.46,15.88L3.87,14.47L6,16.59L8.12,14.47L9.53,15.88L7.41,18L9.53,20.12L8.12,21.54Z' })
	  );
	};
	
	var TagTextOutlineIcon = function TagTextOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.5,7C6.33,7 7,6.33 7,5.5C7,4.67 6.33,4 5.5,4C4.67,4 4,4.67 4,5.5C4,6.33 4.67,7 5.5,7M21.41,11.58C21.77,11.94 22,12.44 22,13C22,13.55 21.78,14.05 21.41,14.41L14.41,21.41C14.05,21.77 13.55,22 13,22C12.45,22 11.95,21.77 11.58,21.41L2.59,12.41C2.22,12.05 2,11.55 2,11V4C2,2.89 2.89,2 4,2H11C11.55,2 12.05,2.22 12.41,2.58L21.41,11.58M13,20L20,13L11.5,4.5L4.5,11.5L13,20M10.09,8.91L11.5,7.5L17,13L15.59,14.41L10.09,8.91M7.59,11.41L9,10L13,14L11.59,15.41L7.59,11.41Z' })
	  );
	};
	
	var TagIcon = function TagIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.5,7C4.67,7 4,6.33 4,5.5C4,4.67 4.67,4 5.5,4C6.33,4 7,4.67 7,5.5C7,6.33 6.33,7 5.5,7M21.41,11.58L12.41,2.58C12.05,2.22 11.55,2 11,2H4C2.89,2 2,2.89 2,4V11C2,11.55 2.22,12.05 2.59,12.41L11.58,21.41C11.95,21.77 12.45,22 13,22C13.55,22 14.05,21.77 14.41,21.41L21.41,14.41C21.78,14.05 22,13.55 22,13C22,12.44 21.77,11.94 21.41,11.58Z' })
	  );
	};
	
	var TargetIcon = function TargetIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,2V4.07C7.38,4.53 4.53,7.38 4.07,11H2V13H4.07C4.53,16.62 7.38,19.47 11,19.93V22H13V19.93C16.62,19.47 19.47,16.62 19.93,13H22V11H19.93C19.47,7.38 16.62,4.53 13,4.07V2M11,6.08V8H13V6.09C15.5,6.5 17.5,8.5 17.92,11H16V13H17.91C17.5,15.5 15.5,17.5 13,17.92V16H11V17.91C8.5,17.5 6.5,15.5 6.08,13H8V11H6.09C6.5,8.5 8.5,6.5 11,6.08M12,11C11.45,11 11,11.45 11,12C11,12.55 11.45,13 12,13C12.55,13 13,12.55 13,12C13,11.45 12.55,11 12,11Z' })
	  );
	};
	
	var TaxiIcon = function TaxiIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,11L6.5,6.5H17.5L19,11M17.5,16C16.67,16 16,15.33 16,14.5C16,13.67 16.67,13 17.5,13C18.33,13 19,13.67 19,14.5C19,15.33 18.33,16 17.5,16M6.5,16C5.67,16 5,15.33 5,14.5C5,13.67 5.67,13 6.5,13C7.33,13 8,13.67 8,14.5C8,15.33 7.33,16 6.5,16M18.92,6C18.72,5.42 18.16,5 17.5,5H15V3H9V5H6.5C5.84,5 5.28,5.42 5.08,6L3,12V20C3,20.55 3.45,21 4,21H5C5.55,21 6,20.55 6,20V19H18V20C18,20.55 18.45,21 19,21H20C20.55,21 21,20.55 21,20V12L18.92,6Z' })
	  );
	};
	
	var TeachIcon = function TeachIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,17C21.1,17 22,16.1 22,15V4C22,2.9 21.1,2 20,2H9.46C9.81,2.61 10,3.3 10,4H20V15H11V17M15,7V9H9V22H7V16H5V22H3V14H1.5V9C1.5,7.9 2.4,7 3.5,7H15M8,4C8,5.1 7.1,6 6,6C4.9,6 4,5.1 4,4C4,2.9 4.9,2 6,2C7.1,2 8,2.9 8,4Z' })
	  );
	};
	
	var TeamviewerIcon = function TeamviewerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,3C20.1,3 21,3.9 21,5V19C21,20.11 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19M12,5C8.13,5 5,8.13 5,12C5,15.87 8.13,19 12,19C15.87,19 19,15.87 19,12C19,8.13 15.87,5 12,5M7,12L10,9V11H14V9L17,12L14,15V13H10V15L7,12Z' })
	  );
	};
	
	var TelegramIcon = function TelegramIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.78,18.65L10.06,14.42L17.74,7.5C18.08,7.19 17.67,7.04 17.22,7.31L7.74,13.3L3.64,12C2.76,11.75 2.75,11.14 3.84,10.7L19.81,4.54C20.54,4.21 21.24,4.72 20.96,5.84L18.24,18.65C18.05,19.56 17.5,19.78 16.74,19.36L12.6,16.3L10.61,18.23C10.38,18.46 10.19,18.65 9.78,18.65Z' })
	  );
	};
	
	var TelevisionBoxIcon = function TelevisionBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M16,16L19,8H16.5L15,12.5L13.5,8H5V10H8V16H10V10H11.77L14,16H16Z' })
	  );
	};
	
	var TelevisionClassicOffIcon = function TelevisionClassicOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L21,21.72L19.73,23L17.73,21H4C2.89,21 2,20.11 2,19V9C2,8 2.76,7.14 3.75,7L2,5.27M8.16,3L12,6.84L15.84,3L17.25,4.41L14.66,7H20C21.11,7 22,7.89 22,9V19C22,19.34 21.92,19.66 21.77,19.94L17,15.18V9H10.82L8.82,7H9.34L6.75,4.41L8.16,3M4,9V19H15.73L5.73,9H4M19.5,9C18.95,9 18.5,9.45 18.5,10C18.5,10.55 18.95,11 19.5,11C20.05,11 20.5,10.55 20.5,10C20.5,9.45 20.05,9 19.5,9M19.5,12C18.95,12 18.5,12.45 18.5,13C18.5,13.55 18.95,14 19.5,14C20.05,14 20.5,13.55 20.5,13C20.5,12.45 20.05,12 19.5,12Z' })
	  );
	};
	
	var TelevisionClassicIcon = function TelevisionClassicIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.16,3L6.75,4.41L9.34,7H4C2.89,7 2,7.89 2,9V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V9C22,7.89 21.11,7 20,7H14.66L17.25,4.41L15.84,3L12,6.84L8.16,3M4,9H17V19H4V9M19.5,9C20.05,9 20.5,9.45 20.5,10C20.5,10.55 20.05,11 19.5,11C18.95,11 18.5,10.55 18.5,10C18.5,9.45 18.95,9 19.5,9M19.5,12C20.05,12 20.5,12.45 20.5,13C20.5,13.55 20.05,14 19.5,14C18.95,14 18.5,13.55 18.5,13C18.5,12.45 18.95,12 19.5,12Z' })
	  );
	};
	
	var TelevisionGuideIcon = function TelevisionGuideIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,17V5H3V17H21M21,3C22.1,3 23,3.9 23,5V17C23,18.1 22.1,19 21,19H16V21H8V19H3C1.9,19 1,18.1 1,17V5C1,3.9 1.9,3 3,3H21M5,7H11V11H5V7M5,13H11V15H5V13M13,7H19V9H13V7M13,11H19V15H13V11Z' })
	  );
	};
	
	var TelevisionOffIcon = function TelevisionOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M0.5,2.77L1.78,1.5L21,20.72L19.73,22L16.73,19H16V21H8V19H3C1.9,19 1,18.1 1,17V5C1,4.5 1.17,4.07 1.46,3.73L0.5,2.77M21,17V5H7.82L5.82,3H21C22.1,3 23,3.9 23,5V17C23,17.85 22.45,18.59 21.7,18.87L19.82,17H21M3,17H14.73L3,5.27V17Z' })
	  );
	};
	
	var TelevisionIcon = function TelevisionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,17H3V5H21M21,3H3C1.9,3 1,3.9 1,5V17C1,18.1 1.9,19 3,19H8V21H16V19H21C22.1,19 23,18.1 23,17V5C23,3.9 22.1,3 21,3Z' })
	  );
	};
	
	var TemperatureCelsiusIcon = function TemperatureCelsiusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.5,5C18.05,5 19.5,5.47 20.69,6.28L19.53,9.17C18.73,8.44 17.67,8 16.5,8C14,8 12,10 12,12.5C12,15 14,17 16.5,17C17.53,17 18.47,16.66 19.23,16.08L20.37,18.93C19.24,19.61 17.92,20 16.5,20C12.36,20 9,16.64 9,12.5C9,8.36 12.36,5 16.5,5M6,3C7.66,3 9,4.34 9,6C9,7.66 7.66,9 6,9C4.34,9 3,7.66 3,6C3,4.34 4.34,3 6,3M6,5C5.45,5 5,5.45 5,6C5,6.55 5.45,7 6,7C6.55,7 7,6.55 7,6C7,5.45 6.55,5 6,5Z' })
	  );
	};
	
	var TemperatureFahrenheitIcon = function TemperatureFahrenheitIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,20V5H20V8H14V11H19V14H14V20H11M6,3C7.66,3 9,4.34 9,6C9,7.66 7.66,9 6,9C4.34,9 3,7.66 3,6C3,4.34 4.34,3 6,3M6,5C5.45,5 5,5.45 5,6C5,6.55 5.45,7 6,7C6.55,7 7,6.55 7,6C7,5.45 6.55,5 6,5Z' })
	  );
	};
	
	var TemperatureKelvinIcon = function TemperatureKelvinIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,5H10V11L15,5H19L13.88,10.78L19,20H15.38L11.76,13.17L10,15.15V20H7V5Z' })
	  );
	};
	
	var TennisIcon = function TennisIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C14.5,2 16.75,2.9 18.5,4.4C16.36,6.23 15,8.96 15,12C15,15.04 16.36,17.77 18.5,19.6C16.75,21.1 14.5,22 12,22C9.5,22 7.25,21.1 5.5,19.6C7.64,17.77 9,15.04 9,12C9,8.96 7.64,6.23 5.5,4.4C7.25,2.9 9.5,2 12,2M22,12C22,14.32 21.21,16.45 19.88,18.15C18.12,16.68 17,14.47 17,12C17,9.53 18.12,7.32 19.88,5.85C21.21,7.55 22,9.68 22,12M2,12C2,9.68 2.79,7.55 4.12,5.85C5.88,7.32 7,9.53 7,12C7,14.47 5.88,16.68 4.12,18.15C2.79,16.45 2,14.32 2,12Z' })
	  );
	};
	
	var TentIcon = function TentIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,6C4,7.19 4.39,8.27 5,9C3.34,9 2,7.66 2,6C2,4.34 3.34,3 5,3C4.39,3.73 4,4.81 4,6M2,21V19H4.76L12,4.78L19.24,19H22V21H2M12,9.19L7,19H17L12,9.19Z' })
	  );
	};
	
	var TerrainIcon = function TerrainIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,6L10.25,11L13.1,14.8L11.5,16C9.81,13.75 7,10 7,10L1,18H23L14,6Z' })
	  );
	};
	
	var TestTubeEmptyIcon = function TestTubeEmptyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,2H17V4H16V18C16,20.21 14.21,22 12,22C9.79,22 8,20.21 8,18V4H7V2M14,4H10V18C10,19.1 10.9,20 12,20C13.1,20 14,19.1 14,18V4Z' })
	  );
	};
	
	var TestTubeOffIcon = function TestTubeOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L15.84,19.11C15.36,20.77 13.82,22 12,22C9.79,22 8,20.21 8,18V11.27L2,5.27M7,2H17V4H16V14.18L13.63,11.81C13.86,11.63 14,11.35 14,11C14,10.4 13.6,10 13,10C12.65,10 12.37,10.14 12.19,10.37L8,6.18V4H7V2M11,16C11.5,16 11.88,15.71 12,15.24L10.76,14C10.29,14.12 10,14.5 10,15C10,15.6 10.4,16 11,16M14,7V4H10V7H14Z' })
	  );
	};
	
	var TestTubeIcon = function TestTubeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,2V4H8V18C8,20.21 9.79,22 12,22C14.21,22 16,20.21 16,18V4H17V2H7M11,16C10.4,16 10,15.6 10,15C10,14.4 10.4,14 11,14C11.6,14 12,14.4 12,15C12,15.6 11.6,16 11,16M13,12C12.4,12 12,11.6 12,11C12,10.4 12.4,10 13,10C13.6,10 14,10.4 14,11C14,11.6 13.6,12 13,12M14,7H10V4H14V7Z' })
	  );
	};
	
	var TextShadowIcon = function TextShadowIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3H16V6H11V18H8V6H3V3M12,7H14V9H12V7M15,7H17V9H15V7M18,7H20V9H18V7M12,10H14V12H12V10M12,13H14V15H12V13M12,16H14V18H12V16M12,19H14V21H12V19Z' })
	  );
	};
	
	var TextShortIcon = function TextShortIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,9H20V11H4V9M4,13H14V15H4V13Z' })
	  );
	};
	
	var TextSubjectIcon = function TextSubjectIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,5H20V7H4V5M4,9H20V11H4V9M4,13H20V15H4V13M4,17H14V19H4V17Z' })
	  );
	};
	
	var TextToSpeechOffIcon = function TextToSpeechOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L13.38,16.65C12.55,18.35 10.93,19.59 9,19.92V22H7V19.92C4.16,19.44 2,16.97 2,14H4C4,16.21 5.79,18 8,18C9.82,18 11.36,16.78 11.84,15.11L10,13.27V14C10,15.1 9.1,16 8,16C6.9,16 6,15.1 6,14V9.27L2,5.27M21.41,9.41L17.17,13.66L18.18,10H14C12.9,10 12,9.1 12,8V4C12,2.9 12.9,2 14,2H20C21.1,2 22,2.9 22,4V8C22,8.55 21.78,9.05 21.41,9.41Z' })
	  );
	};
	
	var TextToSpeechIcon = function TextToSpeechIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,7C9.1,7 10,7.9 10,9V14C10,15.1 9.1,16 8,16C6.9,16 6,15.1 6,14V9C6,7.9 6.9,7 8,7M14,14C14,16.97 11.84,19.44 9,19.92V22H7V19.92C4.16,19.44 2,16.97 2,14H4C4,16.21 5.79,18 8,18C10.21,18 12,16.21 12,14H14M21.41,9.41L17.17,13.66L18.18,10H14C12.9,10 12,9.1 12,8V4C12,2.9 12.9,2 14,2H20C21.1,2 22,2.9 22,4V8C22,8.55 21.78,9.05 21.41,9.41Z' })
	  );
	};
	
	var TextIcon = function TextIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,6V8H3V6H21M3,18H12V16H3V18M3,13H21V11H3V13Z' })
	  );
	};
	
	var TextboxPasswordIcon = function TextboxPasswordIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,7H22V17H17V19C17,19.55 17.45,20 18,20H20V22H17.5C16.95,22 16,21.55 16,21C16,21.55 15.05,22 14.5,22H12V20H14C14.55,20 15,19.55 15,19V5C15,4.45 14.55,4 14,4H12V2H14.5C15.05,2 16,2.45 16,3C16,2.45 16.95,2 17.5,2H20V4H18C17.45,4 17,4.45 17,5V7M2,7H13V9H4V15H13V17H2V7M20,15V9H17V15H20M8.5,12C8.5,11.17 7.83,10.5 7,10.5C6.17,10.5 5.5,11.17 5.5,12C5.5,12.83 6.17,13.5 7,13.5C7.83,13.5 8.5,12.83 8.5,12M13,10.89C12.39,10.33 11.44,10.38 10.88,11C10.32,11.6 10.37,12.55 11,13.11C11.55,13.63 12.43,13.63 13,13.11V10.89Z' })
	  );
	};
	
	var TextboxIcon = function TextboxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,7H22V17H17V19C17,19.55 17.45,20 18,20H20V22H17.5C16.95,22 16,21.55 16,21C16,21.55 15.05,22 14.5,22H12V20H14C14.55,20 15,19.55 15,19V5C15,4.45 14.55,4 14,4H12V2H14.5C15.05,2 16,2.45 16,3C16,2.45 16.95,2 17.5,2H20V4H18C17.45,4 17,4.45 17,5V7M2,7H13V9H4V15H13V17H2V7M20,15V9H17V15H20Z' })
	  );
	};
	
	var TextureIcon = function TextureIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.29,21H12.12L21,12.12V9.29M19,21C19.55,21 20.05,20.78 20.41,20.41C20.78,20.05 21,19.55 21,19V17L17,21M5,3C3.9,3 3,3.9 3,5V7L7,3M11.88,3L3,11.88V14.71L14.71,3M19.5,3.08L3.08,19.5C3.17,19.85 3.35,20.16 3.59,20.41C3.84,20.65 4.15,20.83 4.5,20.92L20.93,4.5C20.74,3.8 20.2,3.26 19.5,3.08Z' })
	  );
	};
	
	var TheaterIcon = function TheaterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,15H6C7.1,15 8,15.9 8,17V19H9V17C9,15.9 9.9,15 11,15H13C14.1,15 15,15.9 15,17V19H16V17C16,15.9 16.9,15 18,15H20C21.1,15 22,15.9 22,17V19H23V22H1V19H2V17C2,15.9 2.9,15 4,15M11,7L15,10L11,13V7M4,2H20C21.1,2 22,2.9 22,4V13.54C21.41,13.19 20.73,13 20,13V4H4V13C3.27,13 2.59,13.19 2,13.54V4C2,2.9 2.9,2 4,2Z' })
	  );
	};
	
	var ThemeLightDarkIcon = function ThemeLightDarkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7.5,2C5.71,3.15 4.5,5.18 4.5,7.5C4.5,9.82 5.71,11.85 7.53,13C4.46,13 2,10.54 2,7.5C2,4.46 4.46,2 7.5,2M19.07,3.5L20.5,4.93L4.93,20.5L3.5,19.07L19.07,3.5M12.89,5.93L11.41,5L9.97,6L10.39,4.3L9,3.24L10.75,3.12L11.33,1.47L12,3.1L13.73,3.13L12.38,4.26L12.89,5.93M9.59,9.54L8.43,8.81L7.31,9.59L7.65,8.27L6.56,7.44L7.92,7.35L8.37,6.06L8.88,7.33L10.24,7.36L9.19,8.23L9.59,9.54M19,13.5C19,16.54 16.54,19 13.5,19C12.28,19 11.15,18.6 10.24,17.93L17.93,10.24C18.6,11.15 19,12.28 19,13.5M14.6,20.08L17.37,18.93L17.13,22.28L14.6,20.08M18.93,17.38L20.08,14.61L22.28,17.15L18.93,17.38M20.08,12.42L18.94,9.64L22.28,9.88L20.08,12.42M9.63,18.93L12.4,20.08L9.87,22.27L9.63,18.93Z' })
	  );
	};
	
	var ThermometerLinesIcon = function ThermometerLinesIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,3H21V5H17V3M17,7H21V9H17V7M17,11H21V13H17.75L17,12.1V11M21,15V17H19C19,16.31 18.9,15.63 18.71,15H21M17,17C17,19.76 14.76,22 12,22C9.24,22 7,19.76 7,17C7,15.36 7.79,13.91 9,13V5C9,3.34 10.34,2 12,2C13.66,2 15,3.34 15,5V13C16.21,13.91 17,15.36 17,17M11,8V14.17C9.83,14.58 9,15.69 9,17C9,18.66 10.34,20 12,20C13.66,20 15,18.66 15,17C15,15.69 14.17,14.58 13,14.17V8H11M7,3V5H3V3H7M7,7V9H3V7H7M7,11V12.1L6.25,13H3V11H7M3,15H5.29C5.1,15.63 5,16.31 5,17H3V15Z' })
	  );
	};
	
	var ThermometerIcon = function ThermometerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,17C17,19.76 14.76,22 12,22C9.24,22 7,19.76 7,17C7,15.36 7.79,13.91 9,13V5C9,3.34 10.34,2 12,2C13.66,2 15,3.34 15,5V13C16.21,13.91 17,15.36 17,17M11,8V14.17C9.83,14.58 9,15.69 9,17C9,18.66 10.34,20 12,20C13.66,20 15,18.66 15,17C15,15.69 14.17,14.58 13,14.17V8H11Z' })
	  );
	};
	
	var ThermostatBoxIcon = function ThermostatBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3H5M12,5C13.57,5 15,5.5 16.19,6.4L14,8.56C13.43,8.21 12.74,8 12,8C9.79,8 8,9.79 8,12C8,13.1 8.45,14.1 9.17,14.83L7.05,16.95C5.78,15.68 5,13.93 5,12C5,8.13 8.13,5 12,5M17.6,7.81C18.5,9 19,10.43 19,12C19,13.93 18.22,15.68 16.95,16.95L14.83,14.83C15.55,14.1 16,13.1 16,12C16,11.26 15.79,10.57 15.43,10L17.6,7.81Z' })
	  );
	};
	
	var ThermostatIcon = function ThermostatIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.95,16.95L14.83,14.83C15.55,14.1 16,13.1 16,12C16,11.26 15.79,10.57 15.43,10L17.6,7.81C18.5,9 19,10.43 19,12C19,13.93 18.22,15.68 16.95,16.95M12,5C13.57,5 15,5.5 16.19,6.4L14,8.56C13.43,8.21 12.74,8 12,8C9.79,8 8,9.79 8,12C8,13.1 8.45,14.1 9.17,14.83L7.05,16.95C5.78,15.68 5,13.93 5,12C5,8.13 8.13,5 12,5M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.47 17.5,2 12,2Z' })
	  );
	};
	
	var ThoughtBubbleOutlineIcon = function ThoughtBubbleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.5,19C4.33,19 5,19.67 5,20.5C5,21.33 4.33,22 3.5,22C2.67,22 2,21.33 2,20.5C2,19.67 2.67,19 3.5,19M8.5,16C9.88,16 11,17.12 11,18.5C11,19.88 9.88,21 8.5,21C7.12,21 6,19.88 6,18.5C6,17.12 7.12,16 8.5,16M14.5,15C13.31,15 12.23,14.5 11.5,13.65C10.77,14.5 9.69,15 8.5,15C6.54,15 4.91,13.59 4.57,11.74C3.07,11.16 2,9.7 2,8C2,5.79 3.79,4 6,4L6.77,4.07C7.5,3.41 8.45,3 9.5,3C10.69,3 11.77,3.5 12.5,4.35C13.23,3.5 14.31,3 15.5,3C17.46,3 19.09,4.41 19.43,6.26C20.93,6.84 22,8.3 22,10C22,12.21 20.21,14 18,14L17.23,13.93C16.5,14.59 15.55,15 14.5,15M6,6C4.9,6 4,6.9 4,8C4,9.1 4.9,10 6,10C6.33,10 6.64,9.92 6.92,9.78C6.66,10.12 6.5,10.54 6.5,11C6.5,12.1 7.4,13 8.5,13C9.1,13 9.64,12.73 10,12.31V12.31L11.47,10.63L13,12.34V12.34C13.38,12.74 13.91,13 14.5,13C15.5,13 16.33,12.26 16.5,11.3C16.84,11.73 17.39,12 18,12C19.1,12 20,11.1 20,10C20,8.9 19.1,8 18,8C17.67,8 17.36,8.08 17.08,8.22C17.34,7.88 17.5,7.46 17.5,7C17.5,5.9 16.6,5 15.5,5C14.91,5 14.38,5.26 14,5.66L12.47,7.37L11,5.69V5.69C10.64,5.27 10.1,5 9.5,5C8.5,5 7.67,5.74 7.5,6.7C7.16,6.27 6.61,6 6,6M8.5,17.5C7.95,17.5 7.5,17.95 7.5,18.5C7.5,19.05 7.95,19.5 8.5,19.5C9.05,19.5 9.5,19.05 9.5,18.5C9.5,17.95 9.05,17.5 8.5,17.5Z' })
	  );
	};
	
	var ThoughtBubbleIcon = function ThoughtBubbleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.5,19C4.33,19 5,19.67 5,20.5C5,21.33 4.33,22 3.5,22C2.67,22 2,21.33 2,20.5C2,19.67 2.67,19 3.5,19M8.5,16C9.88,16 11,17.12 11,18.5C11,19.88 9.88,21 8.5,21C7.12,21 6,19.88 6,18.5C6,17.12 7.12,16 8.5,16M14.5,15C13.31,15 12.23,14.5 11.5,13.65C10.77,14.5 9.69,15 8.5,15C6.54,15 4.91,13.59 4.57,11.74C3.07,11.16 2,9.7 2,8C2,5.79 3.79,4 6,4C6.26,4 6.5,4.03 6.77,4.07C7.5,3.41 8.45,3 9.5,3C10.69,3 11.77,3.5 12.5,4.35C13.23,3.5 14.31,3 15.5,3C17.46,3 19.09,4.41 19.43,6.26C20.93,6.84 22,8.3 22,10C22,12.21 20.21,14 18,14L17.23,13.93C16.5,14.59 15.55,15 14.5,15Z' })
	  );
	};
	
	var ThumbDownOutlineIcon = function ThumbDownOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,15V3H23V15H19M15,3C16.1,3 17,3.9 17,5V15C17,15.55 16.78,16.05 16.41,16.41L9.83,23L8.77,21.94C8.5,21.67 8.33,21.3 8.33,20.88L8.36,20.57L9.31,16H3C1.89,16 1,15.1 1,14V12C1,11.74 1.05,11.5 1.14,11.27L4.16,4.22C4.46,3.5 5.17,3 6,3H15M15,5H5.97L3,12V14H11.78L10.65,19.32L15,14.97V5Z' })
	  );
	};
	
	var ThumbDownIcon = function ThumbDownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,15H23V3H19M15,3H6C5.17,3 4.46,3.5 4.16,4.22L1.14,11.27C1.05,11.5 1,11.74 1,12V14C1,15.1 1.9,16 3,16H9.31L8.36,20.57C8.34,20.67 8.33,20.77 8.33,20.88C8.33,21.3 8.5,21.67 8.77,21.94L9.83,23L16.41,16.41C16.78,16.05 17,15.55 17,15V5C17,3.89 16.1,3 15,3Z' })
	  );
	};
	
	var ThumbUpOutlineIcon = function ThumbUpOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,9V21H1V9H5M9,21C7.9,21 7,20.1 7,19V9C7,8.45 7.22,7.95 7.59,7.59L14.17,1L15.23,2.06C15.5,2.33 15.67,2.7 15.67,3.11L15.64,3.43L14.69,8H21C22.11,8 23,8.9 23,10V12C23,12.26 22.95,12.5 22.86,12.73L19.84,19.78C19.54,20.5 18.83,21 18,21H9M9,19H18.03L21,12V10H12.21L13.34,4.68L9,9.03V19Z' })
	  );
	};
	
	var ThumbUpIcon = function ThumbUpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,10C23,8.89 22.1,8 21,8H14.68L15.64,3.43C15.66,3.33 15.67,3.22 15.67,3.11C15.67,2.7 15.5,2.32 15.23,2.05L14.17,1L7.59,7.58C7.22,7.95 7,8.45 7,9V19C7,20.1 7.9,21 9,21H18C18.83,21 19.54,20.5 19.84,19.78L22.86,12.73C22.95,12.5 23,12.26 23,12V10M1,21H5V9H1V21Z' })
	  );
	};
	
	var ThumbsUpDownIcon = function ThumbsUpDownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22.5,10H15.75C15.13,10 14.6,10.38 14.37,10.91L12.11,16.2C12.04,16.37 12,16.56 12,16.75V18C12,18.55 12.45,19 13,19H18.18L17.5,22.18V22.42C17.5,22.73 17.63,23 17.83,23.22L18.62,24L23.56,19.06C23.83,18.79 24,18.41 24,18V11.5C24,10.67 23.33,10 22.5,10M12,6C12,5.45 11.55,5 11,5H5.82L6.5,1.82V1.59C6.5,1.28 6.37,1 6.17,0.79L5.38,0L0.44,4.94C0.17,5.21 0,5.59 0,6V12.5C0,13.33 0.67,14 1.5,14H8.25C8.87,14 9.4,13.62 9.63,13.09L11.89,7.8C11.96,7.63 12,7.44 12,7.25V6Z' })
	  );
	};
	
	var TicketAccountIcon = function TicketAccountIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,12C20,13.1 20.9,14 22,14V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V14C3.11,14 4,13.1 4,12C4,10.9 3.1,10 2,10V6C2,4.89 2.9,4 4,4H20C21.1,4 22,4.9 22,6V10C20.9,10 20,10.9 20,12M16.5,16.25C16.5,14.75 13.5,14 12,14C10.5,14 7.5,14.75 7.5,16.25V17H16.5V16.25M12,12.25C13.24,12.25 14.25,11.24 14.25,10C14.25,8.76 13.24,7.75 12,7.75C10.76,7.75 9.75,8.76 9.75,10C9.75,11.24 10.76,12.25 12,12.25Z' })
	  );
	};
	
	var TicketConfirmationIcon = function TicketConfirmationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,8.5H11V6.5H13V8.5M13,13H11V11H13V13M13,17.5H11V15.5H13V17.5M22,10V6C22,4.89 21.1,4 20,4H4C2.9,4 2,4.9 2,6V10C3.11,10 4,10.9 4,12C4,13.1 3.1,14 2,14V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V14C20.9,14 20,13.1 20,12C20,10.9 20.9,10 22,10Z' })
	  );
	};
	
	var TicketOutlineIcon = function TicketOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4C2.9,4 2,4.9 2,6V10C3.1,10 4,10.9 4,12C4,13.1 3.1,14 2,14V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V14C20.9,14 20,13.1 20,12C20,10.9 20.9,10 22,10V6C22,4.9 21.1,4 20,4H4M4,6H20V8.54C18.76,9.25 18,10.57 18,12C18,13.43 18.76,14.75 20,15.46V18H4V15.46C5.24,14.75 6,13.43 6,12C6,10.57 5.24,9.25 4,8.54V6Z' })
	  );
	};
	
	var TicketPercentIcon = function TicketPercentIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4C2.9,4 2,4.9 2,6V10C3.11,10 4,10.9 4,12C4,13.1 3.1,14 2,14V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V14C20.9,14 20,13.1 20,12C20,10.89 20.9,10 22,10V6C22,4.89 21.1,4 20,4H4M15.5,7L17,8.5L8.5,17L7,15.5L15.5,7M8.81,7.04C9.79,7.04 10.58,7.83 10.58,8.81C10.58,9.79 9.79,10.58 8.81,10.58C7.83,10.58 7.04,9.79 7.04,8.81C7.04,7.83 7.83,7.04 8.81,7.04M15.19,13.42C16.17,13.42 16.96,14.21 16.96,15.19C16.96,16.17 16.17,16.96 15.19,16.96C14.21,16.96 13.42,16.17 13.42,15.19C13.42,14.21 14.21,13.42 15.19,13.42Z' })
	  );
	};
	
	var TicketIcon = function TicketIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.58,16.8L12,14.5L8.42,16.8L9.5,12.68L6.21,10L10.46,9.74L12,5.8L13.54,9.74L17.79,10L14.5,12.68M20,12C20,10.89 20.9,10 22,10V6C22,4.89 21.1,4 20,4H4C2.9,4 2,4.9 2,6V10C3.11,10 4,10.9 4,12C4,13.1 3.1,14 2,14V18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V14C20.9,14 20,13.1 20,12Z' })
	  );
	};
	
	var TieIcon = function TieIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2L10,6L7,17L12,22L17,17L14,6L18,2Z' })
	  );
	};
	
	var TildeIcon = function TildeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,15C2,15 2,9 8,9C12,9 12.5,12.5 15.5,12.5C19.5,12.5 19.5,9 19.5,9H22C22,9 22,15 16,15C12,15 10.5,11.5 8.5,11.5C4.5,11.5 4.5,15 4.5,15H2' })
	  );
	};
	
	var TimelapseIcon = function TimelapseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M16.24,7.76C15.07,6.58 13.53,6 12,6V12L7.76,16.24C10.1,18.58 13.9,18.58 16.24,16.24C18.59,13.9 18.59,10.1 16.24,7.76Z' })
	  );
	};
	
	var Timer10Icon = function Timer10Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.9,13.22C12.9,13.82 12.86,14.33 12.78,14.75C12.7,15.17 12.58,15.5 12.42,15.77C12.26,16.03 12.06,16.22 11.83,16.34C11.6,16.46 11.32,16.5 11,16.5C10.71,16.5 10.43,16.46 10.19,16.34C9.95,16.22 9.75,16.03 9.59,15.77C9.43,15.5 9.3,15.17 9.21,14.75C9.12,14.33 9.08,13.82 9.08,13.22V10.72C9.08,10.12 9.12,9.61 9.21,9.2C9.3,8.79 9.42,8.46 9.59,8.2C9.75,7.95 9.95,7.77 10.19,7.65C10.43,7.54 10.7,7.5 11,7.5C11.31,7.5 11.58,7.54 11.81,7.65C12.05,7.76 12.25,7.94 12.41,8.2C12.57,8.45 12.7,8.78 12.78,9.19C12.86,9.6 12.91,10.11 12.91,10.71V13.22M13.82,7.05C13.5,6.65 13.07,6.35 12.59,6.17C12.12,6 11.58,5.9 11,5.9C10.42,5.9 9.89,6 9.41,6.17C8.93,6.35 8.5,6.64 8.18,7.05C7.84,7.46 7.58,8 7.39,8.64C7.21,9.29 7.11,10.09 7.11,11.03V12.95C7.11,13.89 7.2,14.69 7.39,15.34C7.58,16 7.84,16.53 8.19,16.94C8.53,17.35 8.94,17.65 9.42,17.83C9.9,18 10.43,18.11 11,18.11C11.6,18.11 12.13,18 12.6,17.83C13.08,17.65 13.5,17.35 13.82,16.94C14.16,16.53 14.42,16 14.6,15.34C14.78,14.69 14.88,13.89 14.88,12.95V11.03C14.88,10.09 14.79,9.29 14.6,8.64C14.42,8 14.16,7.45 13.82,7.05M23.78,14.37C23.64,14.09 23.43,13.84 23.15,13.63C22.87,13.42 22.54,13.24 22.14,13.1C21.74,12.96 21.29,12.83 20.79,12.72C20.44,12.65 20.15,12.57 19.92,12.5C19.69,12.41 19.5,12.33 19.37,12.24C19.23,12.15 19.14,12.05 19.09,11.94C19.04,11.83 19,11.7 19,11.55C19,11.41 19.04,11.27 19.1,11.14C19.16,11 19.25,10.89 19.37,10.8C19.5,10.7 19.64,10.62 19.82,10.56C20,10.5 20.22,10.47 20.46,10.47C20.71,10.47 20.93,10.5 21.12,10.58C21.31,10.65 21.47,10.75 21.6,10.87C21.73,11 21.82,11.13 21.89,11.29C21.95,11.45 22,11.61 22,11.78H23.94C23.94,11.39 23.86,11.03 23.7,10.69C23.54,10.35 23.31,10.06 23,9.81C22.71,9.56 22.35,9.37 21.92,9.22C21.5,9.07 21,9 20.46,9C19.95,9 19.5,9.07 19.07,9.21C18.66,9.35 18.3,9.54 18,9.78C17.72,10 17.5,10.3 17.34,10.62C17.18,10.94 17.11,11.27 17.11,11.63C17.11,12 17.19,12.32 17.34,12.59C17.5,12.87 17.7,13.11 18,13.32C18.25,13.53 18.58,13.7 18.96,13.85C19.34,14 19.77,14.11 20.23,14.21C20.62,14.29 20.94,14.38 21.18,14.47C21.42,14.56 21.61,14.66 21.75,14.76C21.88,14.86 21.97,15 22,15.1C22.07,15.22 22.09,15.35 22.09,15.5C22.09,15.81 21.96,16.06 21.69,16.26C21.42,16.46 21.03,16.55 20.5,16.55C20.3,16.55 20.09,16.53 19.88,16.47C19.67,16.42 19.5,16.34 19.32,16.23C19.15,16.12 19,15.97 18.91,15.79C18.8,15.61 18.74,15.38 18.73,15.12H16.84C16.84,15.5 16.92,15.83 17.08,16.17C17.24,16.5 17.47,16.82 17.78,17.1C18.09,17.37 18.47,17.59 18.93,17.76C19.39,17.93 19.91,18 20.5,18C21.04,18 21.5,17.95 21.95,17.82C22.38,17.69 22.75,17.5 23.06,17.28C23.37,17.05 23.6,16.77 23.77,16.45C23.94,16.13 24,15.78 24,15.39C24,15 23.93,14.65 23.78,14.37M0,7.72V9.4L3,8.4V18H5V6H4.75L0,7.72Z' })
	  );
	};
	
	var Timer3Icon = function Timer3Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.87,14.37C20.73,14.09 20.5,13.84 20.24,13.63C19.96,13.42 19.63,13.24 19.23,13.1C18.83,12.96 18.38,12.83 17.88,12.72C17.53,12.65 17.24,12.57 17,12.5C16.78,12.41 16.6,12.33 16.46,12.24C16.32,12.15 16.23,12.05 16.18,11.94C16.13,11.83 16.1,11.7 16.1,11.55C16.1,11.4 16.13,11.27 16.19,11.14C16.25,11 16.34,10.89 16.46,10.8C16.58,10.7 16.73,10.62 16.91,10.56C17.09,10.5 17.31,10.47 17.55,10.47C17.8,10.47 18,10.5 18.21,10.58C18.4,10.65 18.56,10.75 18.69,10.87C18.82,11 18.91,11.13 19,11.29C19.04,11.45 19.08,11.61 19.08,11.78H21.03C21.03,11.39 20.95,11.03 20.79,10.69C20.63,10.35 20.4,10.06 20.1,9.81C19.8,9.56 19.44,9.37 19,9.22C18.58,9.07 18.09,9 17.55,9C17.04,9 16.57,9.07 16.16,9.21C15.75,9.35 15.39,9.54 15.1,9.78C14.81,10 14.59,10.3 14.43,10.62C14.27,10.94 14.2,11.27 14.2,11.63C14.2,12 14.28,12.31 14.43,12.59C14.58,12.87 14.8,13.11 15.07,13.32C15.34,13.53 15.67,13.7 16.05,13.85C16.43,14 16.86,14.11 17.32,14.21C17.71,14.29 18.03,14.38 18.27,14.47C18.5,14.56 18.7,14.66 18.84,14.76C18.97,14.86 19.06,15 19.11,15.1C19.16,15.22 19.18,15.35 19.18,15.5C19.18,15.81 19.05,16.06 18.78,16.26C18.5,16.46 18.12,16.55 17.61,16.55C17.39,16.55 17.18,16.53 16.97,16.47C16.76,16.42 16.57,16.34 16.41,16.23C16.24,16.12 16.11,15.97 16,15.79C15.89,15.61 15.83,15.38 15.82,15.12H13.93C13.93,15.5 14,15.83 14.17,16.17C14.33,16.5 14.56,16.82 14.87,17.1C15.18,17.37 15.56,17.59 16,17.76C16.5,17.93 17,18 17.6,18C18.13,18 18.61,17.95 19.04,17.82C19.47,17.69 19.84,17.5 20.15,17.28C20.46,17.05 20.69,16.77 20.86,16.45C21.03,16.13 21.11,15.78 21.11,15.39C21.09,15 21,14.65 20.87,14.37M11.61,12.97C11.45,12.73 11.25,12.5 11,12.32C10.74,12.13 10.43,11.97 10.06,11.84C10.36,11.7 10.63,11.54 10.86,11.34C11.09,11.14 11.28,10.93 11.43,10.7C11.58,10.47 11.7,10.24 11.77,10C11.85,9.75 11.88,9.5 11.88,9.26C11.88,8.71 11.79,8.22 11.6,7.8C11.42,7.38 11.16,7.03 10.82,6.74C10.5,6.46 10.09,6.24 9.62,6.1C9.17,5.97 8.65,5.9 8.09,5.9C7.54,5.9 7.03,6 6.57,6.14C6.1,6.31 5.7,6.54 5.37,6.83C5.04,7.12 4.77,7.46 4.59,7.86C4.39,8.25 4.3,8.69 4.3,9.15H6.28C6.28,8.89 6.33,8.66 6.42,8.46C6.5,8.26 6.64,8.08 6.8,7.94C6.97,7.8 7.16,7.69 7.38,7.61C7.6,7.53 7.84,7.5 8.11,7.5C8.72,7.5 9.17,7.65 9.47,7.96C9.77,8.27 9.91,8.71 9.91,9.28C9.91,9.55 9.87,9.8 9.79,10C9.71,10.24 9.58,10.43 9.41,10.59C9.24,10.75 9.03,10.87 8.78,10.96C8.53,11.05 8.23,11.09 7.89,11.09H6.72V12.66H7.9C8.24,12.66 8.54,12.7 8.81,12.77C9.08,12.85 9.31,12.96 9.5,13.12C9.69,13.28 9.84,13.5 9.94,13.73C10.04,13.97 10.1,14.27 10.1,14.6C10.1,15.22 9.92,15.69 9.57,16C9.22,16.35 8.73,16.5 8.12,16.5C7.83,16.5 7.56,16.47 7.32,16.38C7.08,16.3 6.88,16.18 6.71,16C6.54,15.86 6.41,15.68 6.32,15.46C6.23,15.24 6.18,15 6.18,14.74H4.19C4.19,15.29 4.3,15.77 4.5,16.19C4.72,16.61 5,16.96 5.37,17.24C5.73,17.5 6.14,17.73 6.61,17.87C7.08,18 7.57,18.08 8.09,18.08C8.66,18.08 9.18,18 9.67,17.85C10.16,17.7 10.58,17.47 10.93,17.17C11.29,16.87 11.57,16.5 11.77,16.07C11.97,15.64 12.07,15.14 12.07,14.59C12.07,14.3 12.03,14 11.96,13.73C11.88,13.5 11.77,13.22 11.61,12.97Z' })
	  );
	};
	
	var TimerOffIcon = function TimerOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C8.13,20 5,16.87 5,13C5,11.72 5.35,10.5 5.95,9.5L15.5,19.04C14.5,19.65 13.28,20 12,20M3,4L1.75,5.27L4.5,8.03C3.55,9.45 3,11.16 3,13C3,17.97 7.03,22 12,22C13.84,22 15.55,21.45 17,20.5L19.5,23L20.75,21.73L13.04,14L3,4M11,9.44L13,11.44V8H11M15,1H9V3H15M19.04,4.55L17.62,5.97C16.07,4.74 14.12,4 12,4C10.17,4 8.47,4.55 7.05,5.5L8.5,6.94C9.53,6.35 10.73,6 12,6C15.87,6 19,9.13 19,13C19,14.27 18.65,15.47 18.06,16.5L19.5,17.94C20.45,16.53 21,14.83 21,13C21,10.88 20.26,8.93 19.03,7.39L20.45,5.97L19.04,4.55Z' })
	  );
	};
	
	var TimerSandEmptyIcon = function TimerSandEmptyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2V8H6V8L10,12L6,16V16H6V22H18V16H18V16L14,12L18,8V8H18V2H6M16,16.5V20H8V16.5L12,12.5L16,16.5M12,11.5L8,7.5V4H16V7.5L12,11.5Z' })
	  );
	};
	
	var TimerSandFullIcon = function TimerSandFullIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2V8H6V8L10,12L6,16V16H6V22H18V16H18V16L14,12L18,8V8H18V2H6Z' })
	  );
	};
	
	var TimerSandIcon = function TimerSandIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2H18V8H18V8L14,12L18,16V16H18V22H6V16H6V16L10,12L6,8V8H6V2M16,16.5L12,12.5L8,16.5V20H16V16.5M12,11.5L16,7.5V4H8V7.5L12,11.5M10,6H14V6.75L12,8.75L10,6.75V6Z' })
	  );
	};
	
	var TimerIcon = function TimerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C8.13,20 5,16.87 5,13C5,9.13 8.13,6 12,6C15.87,6 19,9.13 19,13C19,16.87 15.87,20 12,20M19.03,7.39L20.45,5.97C20,5.46 19.55,5 19.04,4.56L17.62,6C16.07,4.74 14.12,4 12,4C7.03,4 3,8.03 3,13C3,17.97 7.03,22 12,22C17,22 21,17.97 21,13C21,10.88 20.26,8.93 19.03,7.39M11,14H13V8H11M15,1H9V3H15V1Z' })
	  );
	};
	
	var TimetableIcon = function TimetableIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,12H15.5V14.82L17.94,16.23L17.19,17.53L14,15.69V12M4,2H18C19.1,2 20,2.9 20,4V10.1C21.24,11.36 22,13.09 22,15C22,18.87 18.87,22 15,22C13.09,22 11.36,21.24 10.1,20H4C2.9,20 2,19.1 2,18V4C2,2.9 2.9,2 4,2M4,15V18H8.67C8.24,17.09 8,16.07 8,15H4M4,8H10V5H4V8M18,8V5H12V8H18M4,13H8.29C8.63,11.85 9.26,10.82 10.1,10H4V13M15,10.15C12.32,10.15 10.15,12.32 10.15,15C10.15,17.68 12.32,19.85 15,19.85C17.68,19.85 19.85,17.68 19.85,15C19.85,12.32 17.68,10.15 15,10.15Z' })
	  );
	};
	
	var ToggleSwitchOffIcon = function ToggleSwitchOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,7C9.76,7 12,9.24 12,12C12,14.76 9.76,17 7,17C4.24,17 2,14.76 2,12C2,9.24 4.24,7 7,7M20,14H14V10H20C21.1,10 22,10.9 22,12C22,13.1 21.1,14 20,14M7,9C5.34,9 4,10.34 4,12C4,13.66 5.34,15 7,15C8.66,15 10,13.66 10,12C10,10.34 8.66,9 7,9Z' })
	  );
	};
	
	var ToggleSwitchIcon = function ToggleSwitchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,7C19.76,7 22,9.24 22,12C22,14.76 19.76,17 17,17C14.24,17 12,14.76 12,12C12,9.24 14.24,7 17,7M4,14C2.9,14 2,13.1 2,12C2,10.9 2.9,10 4,10H10V14H4Z' })
	  );
	};
	
	var ToiletIcon = function ToiletIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,22H17V19.5C19.41,17.87 21,15.12 21,12V4C21,2.9 20.1,2 19,2H15C13.89,2 13,2.9 13,4V12H3C3,15.09 5,18 9,19.5V22M5.29,14H18.71C18.14,15.91 16.77,17.5 15,18.33V20H11V18.33C9,18 5.86,15.91 5.29,14M15,4H19V12H15V4M16,5V8H18V5H16Z' })
	  );
	};
	
	var ToolboxOutlineIcon = function ToolboxOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,18V14H17V15H15V14H9V15H7V14H4V18H20M6.33,8L4.59,12H7V11H9V12H15V11H17V12H19.41L17.67,8H6.33M9,5V6H15V5H9M21.84,12.61C21.94,12.83 22,13.09 22,13.41V18C22,18.53 21.79,19 21.4,19.41C21,19.81 20.55,20 20,20H4C3.45,20 3,19.81 2.6,19.41C2.21,19 2,18.53 2,18V13.41C2,13.09 2.06,12.83 2.16,12.61L4.5,7.22C4.84,6.41 5.45,6 6.33,6H7V5C7,4.45 7.18,4 7.57,3.59C7.96,3.2 8.44,3 9,3H15C15.56,3 16.04,3.2 16.43,3.59C16.82,4 17,4.45 17,5V6H17.67C18.55,6 19.16,6.41 19.5,7.22L21.84,12.61Z' })
	  );
	};
	
	var ToolboxIcon = function ToolboxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,5V6H15V5H9M22,18C22,18.53 21.79,19 21.4,19.41C21,19.81 20.55,20 20,20H4C3.45,20 3,19.81 2.6,19.41C2.21,19 2,18.53 2,18V14H7V15H9V14H15V15H17V14H22V18M4.5,7.22C4.84,6.41 5.45,6 6.33,6H7V5C7,4.45 7.18,4 7.57,3.59C7.96,3.2 8.44,3 9,3H15C15.56,3 16.04,3.2 16.43,3.59C16.82,4 17,4.45 17,5V6H17.67C18.55,6 19.16,6.41 19.5,7.22L21.58,12H17V11H15V12H9V11H7V12H2.42L4.5,7.22Z' })
	  );
	};
	
	var TooltipEditIcon = function TooltipEditIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H16L12,22L8,18H4C2.9,18 2,17.1 2,16V4C2,2.9 2.9,2 4,2M18,14V12H12.5L10.5,14H18M6,14H8.5L15.35,7.12C15.55,6.93 15.55,6.61 15.35,6.41L13.59,4.65C13.39,4.45 13.07,4.45 12.88,4.65L6,11.53V14Z' })
	  );
	};
	
	var TooltipImageIcon = function TooltipImageIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H16L12,22L8,18H4C2.9,18 2,17.1 2,16V4C2,2.9 2.9,2 4,2M19,15V7L15,11L13,9L7,15H19M7,5C5.9,5 5,5.9 5,7C5,8.1 5.9,9 7,9C8.1,9 9,8.1 9,7C9,5.9 8.1,5 7,5Z' })
	  );
	};
	
	var TooltipOutlinePlusIcon = function TooltipOutlinePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H16L12,22L8,18H4C2.9,18 2,17.1 2,16V4C2,2.9 2.9,2 4,2M4,4V16H8.83L12,19.17L15.17,16H20V4H4M11,6H13V9H16V11H13V14H11V11H8V9H11V6Z' })
	  );
	};
	
	var TooltipOutlineIcon = function TooltipOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H16L12,22L8,18H4C2.9,18 2,17.1 2,16V4C2,2.9 2.9,2 4,2M4,4V16H8.83L12,19.17L15.17,16H20V4H4Z' })
	  );
	};
	
	var TooltipTextIcon = function TooltipTextIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H16L12,22L8,18H4C2.9,18 2,17.1 2,16V4C2,2.9 2.9,2 4,2M5,5V7H19V5H5M5,9V11H15V9H5M5,13V15H17V13H5Z' })
	  );
	};
	
	var TooltipIcon = function TooltipIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H20C21.1,2 22,2.9 22,4V16C22,17.1 21.1,18 20,18H16L12,22L8,18H4C2.9,18 2,17.1 2,16V4C2,2.9 2.9,2 4,2Z' })
	  );
	};
	
	var ToothOutlineIcon = function ToothOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,2C4,2 2,5 2,8C2,10.11 3,13 4,14C5,15 6,22 8,22C12.54,22 10,15 12,15C14,15 11.46,22 16,22C18,22 19,15 20,14C21,13 22,10.11 22,8C22,5 20,2 17,2C14,2 14,3 12,3C10,3 10,2 7,2M7,4C9,4 10,5 12,5C14,5 15,4 17,4C18.67,4 20,6 20,8C20,9.75 19.14,12.11 18.19,13.06C17.33,13.92 16.06,19.94 15.5,19.94C15.29,19.94 15,18.88 15,17.59C15,15.55 14.43,13 12,13C9.57,13 9,15.55 9,17.59C9,18.88 8.71,19.94 8.5,19.94C7.94,19.94 6.67,13.92 5.81,13.06C4.86,12.11 4,9.75 4,8C4,6 5.33,4 7,4Z' })
	  );
	};
	
	var ToothIcon = function ToothIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,2C4,2 2,5 2,8C2,10.11 3,13 4,14C5,15 6,22 8,22C12.54,22 10,15 12,15C14,15 11.46,22 16,22C18,22 19,15 20,14C21,13 22,10.11 22,8C22,5 20,2 17,2C14,2 14,3 12,3C10,3 10,2 7,2Z' })
	  );
	};
	
	var TorIcon = function TorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,14C11,14 9,15 9,16C9,18 12,18 12,18V17C11.45,17 11,16.55 11,16C11,15.45 11.45,15 12,15V14M12,19C12,19 8,18.5 8,16.5C8,13.5 11,12.75 12,12.75V11.5C11,11.5 7,13 7,16C7,20 12,20 12,20V19M10.07,7.03L11.26,7.56C11.69,5.12 12.84,3.5 12.84,3.5C12.41,4.53 12.13,5.38 11.95,6.05C13.16,3.55 15.61,2 15.61,2C14.43,3.18 13.56,4.46 12.97,5.53C14.55,3.85 16.74,2.75 16.74,2.75C14.05,4.47 12.84,7.2 12.54,7.96L13.09,8.04C13.09,8.56 13.09,9.04 13.34,9.42C14.1,11.31 18,11.47 18,16C18,20.53 13.97,22 11.83,22C9.69,22 5,21.03 5,16C5,10.97 9.95,10.93 10.83,8.92C10.95,8.54 10.07,7.03 10.07,7.03Z' })
	  );
	};
	
	var TournamentIcon = function TournamentIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,2V4H7V8H2V10H7C8.11,10 9,9.11 9,8V7H14V17H9V16C9,14.89 8.11,14 7,14H2V16H7V20H2V22H7C8.11,22 9,21.11 9,20V19H14C15.11,19 16,18.11 16,17V13H22V11H16V7C16,5.89 15.11,5 14,5H9V4C9,2.89 8.11,2 7,2H2Z' })
	  );
	};
	
	var TowerBeachIcon = function TowerBeachIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,4V8H18V10H17.64L21,23H18.93L18.37,20.83L12,17.15L5.63,20.83L5.07,23H3L6.36,10H6V8H7V4H6V3L18,1V4H17M7.28,14.43L6.33,18.12L10,16L7.28,14.43M15.57,10H8.43L7.8,12.42L12,14.85L16.2,12.42L15.57,10M17.67,18.12L16.72,14.43L14,16L17.67,18.12Z' })
	  );
	};
	
	var TowerFireIcon = function TowerFireIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,4V8H18V10H17.64L21,23H18.93L18.37,20.83L12,17.15L5.63,20.83L5.07,23H3L6.36,10H6V8H7V4H6V3L12,1L18,3V4H17M7.28,14.43L6.33,18.12L10,16L7.28,14.43M15.57,10H8.43L7.8,12.42L12,14.85L16.2,12.42L15.57,10M17.67,18.12L16.72,14.43L14,16L17.67,18.12Z' })
	  );
	};
	
	var TowingIcon = function TowingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,10H20.39L17.06,6H15V10M17.5,18.5C17.89,18.5 18.24,18.37 18.54,18.07C18.84,17.77 19,17.42 19,17C19,16.61 18.84,16.26 18.54,15.96C18.24,15.66 17.89,15.5 17.5,15.5C17.08,15.5 16.73,15.66 16.43,15.96C16.13,16.26 16,16.61 16,17C16,17.42 16.13,17.77 16.43,18.07C16.73,18.37 17.08,18.5 17.5,18.5M6,18.5C6.44,18.5 6.8,18.37 7.08,18.07C7.36,17.77 7.5,17.42 7.5,17C7.5,16.61 7.36,16.26 7.08,15.96C6.8,15.66 6.44,15.5 6,15.5C5.56,15.5 5.2,15.66 4.92,15.96C4.64,16.26 4.5,16.61 4.5,17C4.5,17.42 4.64,17.77 4.92,18.07C5.2,18.37 5.56,18.5 6,18.5M18,4L23,10V17H20.5C20.5,17.83 20.19,18.53 19.59,19.13C19,19.72 18.3,20 17.5,20C16.67,20 15.97,19.72 15.38,19.13C14.78,18.53 14.5,17.83 14.5,17H9C9,17.83 8.7,18.53 8.11,19.13C7.5,19.72 6.81,20 6,20C5.19,20 4.5,19.72 3.89,19.13C3.3,18.53 3,17.83 3,17H1V13H9.19L3,8.11V11H1V5H2L13,11.06V4H18Z' })
	  );
	};
	
	var TrackLightIcon = function TrackLightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,1V3H9V6.4L4.11,4.38L1.43,10.84L6.97,13.14L11.94,16.82L13.79,17.59L17.62,8.35L15.77,7.58L11,6.87V3H14V1H6M21.81,6.29L19.5,7.25L20.26,9.1L22.57,8.14L21.81,6.29M19.78,13.57L19,15.42L21.79,16.57L22.55,14.72L19.78,13.57M16.19,18.93L14.34,19.69L15.3,22L17.15,21.23L16.19,18.93Z' })
	  );
	};
	
	var TrackpadLockIcon = function TrackpadLockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,1C1.89,1 1,1.89 1,3V17C1,18.11 1.89,19 3,19H14V17H12V13H16.68C17.5,12.35 18.47,12 19.5,12C20,12 20.5,12.09 21,12.26V3C21,1.89 20.11,1 19,1H3M3,3H19V11H3V3M3,13H10V17H3V13M19.5,14C18.12,14 17,15.12 17,16.5V17C16.45,17 16,17.45 16,18V22C16,22.55 16.45,23 17,23H22C22.55,23 23,22.55 23,22V18C23,17.45 22.55,17 22,17V16.5C22,15.12 20.88,14 19.5,14M19.5,15C20.33,15 21,15.67 21,16.5V17H18V16.5C18,15.67 18.67,15 19.5,15Z' })
	  );
	};
	
	var TrackpadIcon = function TrackpadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,3H20C21.1,3 22,3.9 22,5V19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19V5C2,3.9 2.9,3 4,3M4,5V13H20V5H4M4,19H11V15H4V19M20,19V15H13V19H20Z' })
	  );
	};
	
	var TractorIcon = function TractorIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,4V11.26C3.2,11.9 2,13.6 2,15.5C2,18 4,20 6.5,20C8.79,20 10.71,18.28 10.97,16H15.17C15.06,16.32 15,16.66 15,17C15,18.66 16.34,20 18,20C19.66,20 21,18.66 21,17C21,16.66 20.94,16.32 20.82,16H22V13C22,11.89 21.11,11 20,11H15.04L13.65,4H5M7,6H12L13,11V14H10.74C10.16,12.38 8.71,11.23 7,11.03V6M6.5,13.25C7.74,13.25 8.75,14.26 8.75,15.5C8.75,16.74 7.74,17.75 6.5,17.75C5.26,17.75 4.25,16.74 4.25,15.5C4.25,14.26 5.26,13.25 6.5,13.25M18,15.5C18.83,15.5 19.5,16.17 19.5,17C19.5,17.83 18.83,18.5 18,18.5C17.17,18.5 16.5,17.83 16.5,17C16.5,16.17 17.17,15.5 18,15.5Z' })
	  );
	};
	
	var TrafficLightIcon = function TrafficLightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,9C10.9,9 10,8.1 10,7C10,5.89 10.9,5 12,5C13.11,5 14,5.89 14,7C14,8.1 13.1,9 12,9M12,14C10.9,14 10,13.1 10,12C10,10.89 10.9,10 12,10C13.11,10 14,10.89 14,12C14,13.1 13.1,14 12,14M12,19C10.9,19 10,18.1 10,17C10,15.89 10.9,15 12,15C13.11,15 14,15.89 14,17C14,18.1 13.1,19 12,19M20,10H17V8.86C18.72,8.41 20,6.86 20,5H17V4C17,3.45 16.55,3 16,3H8C7.45,3 7,3.45 7,4V5H4C4,6.86 5.28,8.41 7,8.86V10H4C4,11.86 5.28,13.41 7,13.86V15H4C4,16.86 5.28,18.41 7,18.86V20C7,20.55 7.45,21 8,21H16C16.55,21 17,20.55 17,20V18.86C18.72,18.41 20,16.86 20,15H17V13.86C18.72,13.41 20,11.86 20,10Z' })
	  );
	};
	
	var TrainVariantIcon = function TrainVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,10H6V5H18M12,17C10.89,17 10,16.1 10,15C10,13.89 10.89,13 12,13C13.1,13 14,13.9 14,15C14,16.1 13.1,17 12,17M4,15.5C4,17.43 5.57,19 7.5,19L6,20.5V21H18V20.5L16.5,19C18.43,19 20,17.43 20,15.5V5C20,1.5 16.42,1 12,1C7.58,1 4,1.5 4,5V15.5Z' })
	  );
	};
	
	var TrainIcon = function TrainIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C8,2 4,2.5 4,6V15.5C4,17.43 5.57,19 7.5,19L6,20.5V21H8.23L10.23,19H14L16,21H18V20.5L16.5,19C18.43,19 20,17.43 20,15.5V6C20,2.5 16.42,2 12,2M7.5,17C6.67,17 6,16.33 6,15.5C6,14.67 6.67,14 7.5,14C8.33,14 9,14.67 9,15.5C9,16.33 8.33,17 7.5,17M11,10H6V6H11V10M13,10V6H18V10H13M16.5,17C15.67,17 15,16.33 15,15.5C15,14.67 15.67,14 16.5,14C17.33,14 18,14.67 18,15.5C18,16.33 17.33,17 16.5,17Z' })
	  );
	};
	
	var TramIcon = function TramIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,16.94V8.5C19,5.71 16.39,5.1 13,5L13.75,3.5H17V2H7V3.5H11.75L11,5C7.86,5.11 5,5.73 5,8.5V16.94C5,18.39 6.19,19.6 7.59,19.91L6,21.5V22H8.23L10.23,20H14L16,22H18V21.5L16.5,20H16.42C18.11,20 19,18.63 19,16.94M12,18.5C11.17,18.5 10.5,17.83 10.5,17C10.5,16.17 11.17,15.5 12,15.5C12.83,15.5 13.5,16.17 13.5,17C13.5,17.83 12.83,18.5 12,18.5M17,14H7V9H17V14Z' })
	  );
	};
	
	var TranscribeCloseIcon = function TranscribeCloseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,23L8,19H16L12,23M20,3C21.1,3 22,3.9 22,5V15C22,16.1 21.1,17 20,17H4C2.9,17 2,16.1 2,15V5C2,3.9 2.9,3 4,3H20M18,15V13H12.5L10.5,15H18M6,15H8.5L15.35,8.12C15.55,7.93 15.55,7.61 15.35,7.42L13.59,5.65C13.39,5.45 13.07,5.45 12.88,5.65L6,12.53V15Z' })
	  );
	};
	
	var TranscribeIcon = function TranscribeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,5C21.1,5 22,5.9 22,7V17C22,18.1 21.1,19 20,19H4C2.89,19 2,18.1 2,17V7C2,5.89 2.89,5 4,5H20M18,17V15H12.5L10.5,17H18M6,17H8.5L15.35,10.12C15.55,9.93 15.55,9.61 15.35,9.41L13.59,7.65C13.39,7.45 13.07,7.45 12.88,7.65L6,14.53V17Z' })
	  );
	};
	
	var TransferIcon = function TransferIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,8H5V16H3V8M7,8H9V16H7V8M11,8H13V16H11V8M15,19.25V4.75L22.25,12L15,19.25Z' })
	  );
	};
	
	var TransitTransferIcon = function TransitTransferIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.5,15.5H22V17H16.5V18.75L14,16.25L16.5,13.75V15.5M19.5,19.75V18L22,20.5L19.5,23V21.25H14V19.75H19.5M9.5,5.5C8.4,5.5 7.5,4.6 7.5,3.5C7.5,2.4 8.4,1.5 9.5,1.5C10.6,1.5 11.5,2.4 11.5,3.5C11.5,4.6 10.6,5.5 9.5,5.5M5.75,8.9L4,9.65V13H2V8.3L7.25,6.15C7.5,6.05 7.75,6 8,6C8.7,6 9.35,6.35 9.7,6.95L10.65,8.55C11.55,10 13.15,11 15,11V13C12.8,13 10.85,12 9.55,10.4L8.95,13.4L11,15.45V23H9V17L6.85,15L5.1,23H3L5.75,8.9Z' })
	  );
	};
	
	var TransitionMaskedIcon = function TransitionMaskedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,2C16.94,2 18.59,2.7 19.95,4.05C21.3,5.41 22,7.06 22,9C22,10.56 21.5,11.96 20.58,13.2C19.64,14.43 18.44,15.27 16.97,15.7L17,15.38V15C17,12.81 16.23,10.93 14.65,9.35C13.07,7.77 11.19,7 9,7H8.63L8.3,7.03C8.73,5.56 9.57,4.36 10.8,3.42C12.04,2.5 13.44,2 15,2M9,8C12.87,8 16,11.13 16,15C16,18.87 12.87,22 9,22C5.13,22 2,18.87 2,15C2,11.13 5.13,8 9,8M9,10C6.24,10 4,12.24 4,15C4,17.76 6.24,20 9,20C11.76,20 14,17.76 14,15C14,12.24 11.76,10 9,10Z' })
	  );
	};
	
	var TransitionIcon = function TransitionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,2C18.87,2 22,5.13 22,9C22,11.71 20.46,14.05 18.22,15.22C17.55,16.5 16.5,17.55 15.22,18.22C14.05,20.46 11.71,22 9,22C5.13,22 2,18.87 2,15C2,12.29 3.54,9.95 5.78,8.78C6.45,7.5 7.5,6.45 8.78,5.78C9.95,3.54 12.29,2 15,2M12,19C8.13,19 5,15.87 5,12C4.37,12.84 4,13.87 4,15C4,17.76 6.24,20 9,20C10.13,20 11.16,19.63 12,19M15,16C11.13,16 8,12.87 8,9H8C7.37,9.84 7,10.87 7,12C7,14.76 9.24,17 12,17C13.13,17 14.16,16.63 15,16V16M15,4C13.87,4 12.84,4.37 12,5V5C15.87,5 19,8.13 19,12H19C19.63,11.16 20,10.13 20,9C20,6.24 17.76,4 15,4M10,9C10,11.76 12.24,14 15,14C15.6,14 16.17,13.9 16.7,13.7C16.9,13.17 17,12.6 17,12C17,9.24 14.76,7 12,7C11.4,7 10.83,7.1 10.3,7.3C10.1,7.83 10,8.4 10,9Z' })
	  );
	};
	
	var TranslateIcon = function TranslateIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.87,15.07L10.33,12.56L10.36,12.53C12.1,10.59 13.34,8.36 14.07,6H17V4H10V2H8V4H1V6H12.17C11.5,7.92 10.44,9.75 9,11.35C8.07,10.32 7.3,9.19 6.69,8H4.69C5.42,9.63 6.42,11.17 7.67,12.56L2.58,17.58L4,19L9,14L12.11,17.11L12.87,15.07M18.5,10H16.5L12,22H14L15.12,19H19.87L21,22H23L18.5,10M15.88,17L17.5,12.67L19.12,17H15.88Z' })
	  );
	};
	
	var TreasureChestIcon = function TreasureChestIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,4H19C20.66,4 22,5.34 22,7V11H15V10H9V11H2V7C2,5.34 3.34,4 5,4M11,11H13V13H11V11M2,12H9V13L11,15H13L15,13V12H22V20H2V12Z' })
	  );
	};
	
	var TreeIcon = function TreeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,21V16.74C10.53,16.91 10.03,17 9.5,17C7,17 5,15 5,12.5C5,11.23 5.5,10.09 6.36,9.27C6.13,8.73 6,8.13 6,7.5C6,5 8,3 10.5,3C12.06,3 13.44,3.8 14.25,5C14.33,5 14.41,5 14.5,5C17.54,5 20,7.46 20,10.5C20,13.54 17.54,16 14.5,16C14,16 13.5,15.93 13,15.79V21H11Z' })
	  );
	};
	
	var TrelloIcon = function TrelloIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.5,2H4.5C3.12,2 2,3.12 2,4.5V19.5C2,20.88 3.12,22 4.5,22H19.5C20.88,22 22,20.88 22,19.5V4.5C22,3.12 20.88,2 19.5,2M10.7,17.2C10.7,17.86 10.16,18.4 9.5,18.4H5.8C5.14,18.4 4.6,17.86 4.6,17.2V5.8C4.6,5.14 5.14,4.6 5.8,4.6H9.5C10.16,4.6 10.7,5.14 10.7,5.8V17.2M19.4,12.2C19.4,12.86 18.86,13.4 18.2,13.4H14.5C13.84,13.4 13.3,12.86 13.3,12.2V5.8C13.3,5.14 13.84,4.6 14.5,4.6H18.2C18.86,4.6 19.4,5.14 19.4,5.8V12.2Z' })
	  );
	};
	
	var TrendingDownIcon = function TrendingDownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,18L18.29,15.71L13.41,10.83L9.41,14.83L2,7.41L3.41,6L9.41,12L13.41,8L19.71,14.29L22,12V18H16Z' })
	  );
	};
	
	var TrendingNeutralIcon = function TrendingNeutralIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,12L18,8V11H3V13H18V16L22,12Z' })
	  );
	};
	
	var TrendingUpIcon = function TrendingUpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,12L13.41,16L19.71,9.71L22,12V6H16Z' })
	  );
	};
	
	var TriangleOutlineIcon = function TriangleOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2L1,21H23M12,6L19.53,19H4.47' })
	  );
	};
	
	var TriangleIcon = function TriangleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,21H23L12,2' })
	  );
	};
	
	var TrophyAwardIcon = function TrophyAwardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15.2,10.7L16.6,16L12,12.2L7.4,16L8.8,10.8L4.6,7.3L10,7L12,2L14,7L19.4,7.3L15.2,10.7M14,19.1H13V16L12,15L11,16V19.1H10C8.9,19.1 8,20 8,21.1V22.1H16V21.1C16,20 15.1,19.1 14,19.1Z' })
	  );
	};
	
	var TrophyOutlineIcon = function TrophyOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,2V11C2,12 3,13 4,13H6.2C6.6,15 7.9,16.7 11,17V19.1C8.8,19.3 8,20.4 8,21.7V22H16V21.7C16,20.4 15.2,19.3 13,19.1V17C16.1,16.7 17.4,15 17.8,13H20C21,13 22,12 22,11V2H18C17.1,2 16,3 16,4H8C8,3 6.9,2 6,2H2M4,4H6V6L6,11H4V4M18,4H20V11H18V6L18,4M8,6H16V11.5C16,13.43 15.42,15 12,15C8.59,15 8,13.43 8,11.5V6Z' })
	  );
	};
	
	var TrophyVariantOutlineIcon = function TrophyVariantOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,2V4H2V11C2,12 3,13 4,13H7.2C7.6,14.9 8.6,16.6 11,16.9V19C8,19.2 8,20.3 8,21.6V22H16V21.7C16,20.4 16,19.3 13,19.1V17C15.5,16.7 16.5,15 16.8,13.1H20C21,13.1 22,12.1 22,11.1V4H17V2H7M9,4H15V12C15,13.66 13.66,15 12,15C10,15 9,13.66 9,12V4M4,6H7V8L7,11H4V6M17,6H20V11H17V6Z' })
	  );
	};
	
	var TrophyVariantIcon = function TrophyVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.2,4H20H17V2H7V4H4.5H3.8H2V11C2,12 3,13 4,13H7.2C7.6,14.9 8.6,16.6 11,16.9V19C8,19.2 8,20.3 8,21.6V22H16V21.7C16,20.4 16,19.3 13,19.1V17C15.5,16.7 16.5,15 16.8,13.1H20C21,13.1 22,12.1 22,11.1V4H20.2M4,11V6H7V8V11C5.6,11 4.4,11 4,11M20,11C19.6,11 18.4,11 17,11V6H18H20V11Z' })
	  );
	};
	
	var TrophyIcon = function TrophyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.2,2H19.5H18C17.1,2 16,3 16,4H8C8,3 6.9,2 6,2H4.5H3.8H2V11C2,12 3,13 4,13H6.2C6.6,15 7.9,16.7 11,17V19.1C8.8,19.3 8,20.4 8,21.7V22H16V21.7C16,20.4 15.2,19.3 13,19.1V17C16.1,16.7 17.4,15 17.8,13H20C21,13 22,12 22,11V2H20.2M4,11V4H6V6V11C5.1,11 4.3,11 4,11M20,11C19.7,11 18.9,11 18,11V6V4H20V11Z' })
	  );
	};
	
	var TruckDeliveryIcon = function TruckDeliveryIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4C1.9,4 1,4.9 1,6V17H3C3,18.66 4.34,20 6,20C7.66,20 9,18.66 9,17H15C15,18.66 16.34,20 18,20C19.66,20 21,18.66 21,17H23V12L20,8H17V4M10,6L14,10L10,14V11H4V9H10M17,9.5H19.5L21.47,12H17M6,15.5C6.83,15.5 7.5,16.17 7.5,17C7.5,17.83 6.83,18.5 6,18.5C5.17,18.5 4.5,17.83 4.5,17C4.5,16.17 5.17,15.5 6,15.5M18,15.5C18.83,15.5 19.5,16.17 19.5,17C19.5,17.83 18.83,18.5 18,18.5C17.17,18.5 16.5,17.83 16.5,17C16.5,16.17 17.17,15.5 18,15.5Z' })
	  );
	};
	
	var TruckFastIcon = function TruckFastIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,13.5L2.25,12H7.5L6.9,10.5H2L1.25,9H9.05L8.45,7.5H1.11L0.25,6H4C4,4.9 4.9,4 6,4H18V8H21L24,12V17H22C22,18.66 20.66,20 19,20C17.34,20 16,18.66 16,17H12C12,18.66 10.66,20 9,20C7.34,20 6,18.66 6,17H4V13.5H3M19,18.5C19.83,18.5 20.5,17.83 20.5,17C20.5,16.17 19.83,15.5 19,15.5C18.17,15.5 17.5,16.17 17.5,17C17.5,17.83 18.17,18.5 19,18.5M20.5,9.5H18V12H22.46L20.5,9.5M9,18.5C9.83,18.5 10.5,17.83 10.5,17C10.5,16.17 9.83,15.5 9,15.5C8.17,15.5 7.5,16.17 7.5,17C7.5,17.83 8.17,18.5 9,18.5Z' })
	  );
	};
	
	var TruckTrailerIcon = function TruckTrailerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,15V17H10C10,18.66 8.66,20 7,20C5.34,20 4,18.66 4,17H2V6C2,4.9 2.9,4 4,4H17C18.1,4 19,4.9 19,6V15H22M7,16C6.45,16 6,16.45 6,17C6,17.55 6.45,18 7,18C7.55,18 8,17.55 8,17C8,16.45 7.55,16 7,16Z' })
	  );
	};
	
	var TruckIcon = function TruckIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,18.5C17.17,18.5 16.5,17.83 16.5,17C16.5,16.17 17.17,15.5 18,15.5C18.83,15.5 19.5,16.17 19.5,17C19.5,17.83 18.83,18.5 18,18.5M19.5,9.5L21.46,12H17V9.5M6,18.5C5.17,18.5 4.5,17.83 4.5,17C4.5,16.17 5.17,15.5 6,15.5C6.83,15.5 7.5,16.17 7.5,17C7.5,17.83 6.83,18.5 6,18.5M20,8H17V4H3C1.89,4 1,4.89 1,6V17H3C3,18.66 4.34,20 6,20C7.66,20 9,18.66 9,17H15C15,18.66 16.34,20 18,20C19.66,20 21,18.66 21,17H23V12L20,8Z' })
	  );
	};
	
	var TshirtCrewIcon = function TshirtCrewIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,21H8C7.45,21 7,20.55 7,20V12.07L5.7,13.12C5.31,13.5 4.68,13.5 4.29,13.12L1.46,10.29C1.07,9.9 1.07,9.27 1.46,8.88L7.34,3H9C9,4.1 10.34,5 12,5C13.66,5 15,4.1 15,3H16.66L22.54,8.88C22.93,9.27 22.93,9.9 22.54,10.29L19.71,13.12C19.32,13.5 18.69,13.5 18.3,13.12L17,12.07V20C17,20.55 16.55,21 16,21M20.42,9.58L16.11,5.28C15.8,5.63 15.43,5.94 15,6.2C14.16,6.7 13.13,7 12,7C10.3,7 8.79,6.32 7.89,5.28L3.58,9.58L5,11L8,9H9V19H15V9H16L19,11L20.42,9.58Z' })
	  );
	};
	
	var TshirtVIcon = function TshirtVIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,21H8C7.45,21 7,20.55 7,20V12.07L5.7,13.12C5.31,13.5 4.68,13.5 4.29,13.12L1.46,10.29C1.07,9.9 1.07,9.27 1.46,8.88L7.34,3H9C9,4.1 10,6 12,7.25C14,6 15,4.1 15,3H16.66L22.54,8.88C22.93,9.27 22.93,9.9 22.54,10.29L19.71,13.12C19.32,13.5 18.69,13.5 18.3,13.12L17,12.07V20C17,20.55 16.55,21 16,21M20.42,9.58L16.11,5.28C15,7 14,8.25 12,9.25C10,8.25 9,7 7.89,5.28L3.58,9.58L5,11L8,9H9V19H15V9H16L19,11L20.42,9.58Z' })
	  );
	};
	
	var TumbleDryerIcon = function TumbleDryerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M7,4C6.45,4 6,4.45 6,5C6,5.55 6.45,6 7,6C7.55,6 8,5.55 8,5C8,4.45 7.55,4 7,4M10,4C9.45,4 9,4.45 9,5C9,5.55 9.45,6 10,6C10.55,6 11,5.55 11,5C11,4.45 10.55,4 10,4M12,8C8.69,8 6,10.69 6,14C6,17.31 8.69,20 12,20C15.31,20 18,17.31 18,14C18,10.69 15.31,8 12,8M8.11,10.5H10C9.76,11.88 10,12.67 10.58,13.29C11.68,14.36 12.16,15.71 11.89,17.5H10C10.24,16.12 10,15.33 9.42,14.71C8.32,13.64 7.85,12.29 8.11,10.5M12.11,10.5H14C13.76,11.88 14,12.67 14.58,13.29C15.68,14.36 16.16,15.71 15.89,17.5H14C14.24,16.12 14,15.33 13.42,14.71C12.32,13.64 11.85,12.29 12.11,10.5Z' })
	  );
	};
	
	var TumblrBoxIcon = function TumblrBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,11H13V14.9C13,15.63 13.14,16 14.1,16H16V19C16,19 14.97,19.1 13.9,19.1C11.25,19.1 10,17.5 10,15.7V11H8V8.2C10.41,8 10.62,6.16 10.8,5H13V8H16M20,2H4C2.89,2 2,2.89 2,4V20C2,21.1 2.9,22 4,22H20C21.1,22 22,21.1 22,20V4C22,2.89 21.1,2 20,2Z' })
	  );
	};
	
	var TumblrReblogIcon = function TumblrReblogIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.75,17L8,12.75V16H18V11.5L20,9.5V16C20,17.1 19.1,18 18,18H8V21.25L3.75,17M20.25,7L16,11.25V8H6V12.5L4,14.5V8C4,6.9 4.9,6 6,6H16V2.75L20.25,7Z' })
	  );
	};
	
	var TumblrIcon = function TumblrIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,11H13V15.5C13,16.44 13.28,17 14.5,17H17V21C17,21 15.54,21.05 14.17,21.05C10.8,21.05 9.5,19 9.5,16.75V11H7V7C10.07,6.74 10.27,4.5 10.5,3H13V7H17' })
	  );
	};
	
	var TuneVerticalIcon = function TuneVerticalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3V12H3V14H5V21H7V14H9V12H7V3M11,3V8H9V10H11V21H13V10H15V8H13V3M17,3V14H15V16H17V21H19V16H21V14H19V3' })
	  );
	};
	
	var TuneIcon = function TuneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,17V19H9V17H3M3,5V7H13V5H3M13,21V19H21V17H13V15H11V21H13M7,9V11H3V13H7V15H9V9H7M21,13V11H11V13H21M15,9H17V7H21V5H17V3H15V9Z' })
	  );
	};
	
	var TwitchIcon = function TwitchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,2H22V14L17,19H13L10,22H7V19H2V6L4,2M20,13V4H6V16H9V19L12,16H17L20,13M15,7H17V12H15V7M12,7V12H10V7H12Z' })
	  );
	};
	
	var TwitterBoxIcon = function TwitterBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M17.71,9.33C18.19,8.93 18.75,8.45 19,7.92C18.59,8.13 18.1,8.26 17.56,8.33C18.06,7.97 18.47,7.5 18.68,6.86C18.16,7.14 17.63,7.38 16.97,7.5C15.42,5.63 11.71,7.15 12.37,9.95C9.76,9.79 8.17,8.61 6.85,7.16C6.1,8.38 6.75,10.23 7.64,10.74C7.18,10.71 6.83,10.57 6.5,10.41C6.54,11.95 7.39,12.69 8.58,13.09C8.22,13.16 7.82,13.18 7.44,13.12C7.81,14.19 8.58,14.86 9.9,15C9,15.76 7.34,16.29 6,16.08C7.15,16.81 8.46,17.39 10.28,17.31C14.69,17.11 17.64,13.95 17.71,9.33Z' })
	  );
	};
	
	var TwitterCircleIcon = function TwitterCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.71,9.33C18.19,8.93 18.75,8.45 19,7.92C18.59,8.13 18.1,8.26 17.56,8.33C18.06,7.97 18.47,7.5 18.68,6.86C18.16,7.14 17.63,7.38 16.97,7.5C15.42,5.63 11.71,7.15 12.37,9.95C9.76,9.79 8.17,8.61 6.85,7.16C6.1,8.38 6.75,10.23 7.64,10.74C7.18,10.71 6.83,10.57 6.5,10.41C6.54,11.95 7.39,12.69 8.58,13.09C8.22,13.16 7.82,13.18 7.44,13.12C7.81,14.19 8.58,14.86 9.9,15C9,15.76 7.34,16.29 6,16.08C7.15,16.81 8.46,17.39 10.28,17.31C14.69,17.11 17.64,13.95 17.71,9.33M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2Z' })
	  );
	};
	
	var TwitterRetweetIcon = function TwitterRetweetIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,5.75L10.25,10H7V16H13.5L15.5,18H7C5.9,18 5,17.1 5,16V10H1.75L6,5.75M18,18.25L13.75,14H17V8H10.5L8.5,6H17C18.1,6 19,6.9 19,8V14H22.25L18,18.25Z' })
	  );
	};
	
	var TwitterIcon = function TwitterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z' })
	  );
	};
	
	var TwoFactorAuthenticationIcon = function TwoFactorAuthenticationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,7V9H6V11H4C2.9,11 2,11.9 2,13V17H8V15H4V13H6C7.1,13 8,12.1 8,11V9C8,7.89 7.1,7 6,7H2M9,7V17H11V13H14V11H11V9H15V7H9M18,7C16.9,7 16,7.9 16,9V17H18V14H20V17H22V9C22,7.9 21.1,7 20,7H18M18,9H20V12H18V9Z' })
	  );
	};
	
	var UberIcon = function UberIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.64,22 2.27,17.79 2,12.5H9V14.5C9,14.78 9.22,15 9.5,15H14.5C14.78,15 15,14.78 15,14.5V9.5C15,9.22 14.78,9 14.5,9H9.5C9.22,9 9,9.22 9,9.5V11.5H2C2.27,6.21 6.64,2 12,2Z' })
	  );
	};
	
	var UbuntuIcon = function UbuntuIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2C17.52,2 22,6.48 22,12M14.34,7.74C14.92,8.07 15.65,7.87 16,7.3C16.31,6.73 16.12,6 15.54,5.66C14.97,5.33 14.23,5.5 13.9,6.1C13.57,6.67 13.77,7.41 14.34,7.74M11.88,15.5C11.35,15.5 10.85,15.39 10.41,15.18L9.57,16.68C10.27,17 11.05,17.22 11.88,17.22C12.37,17.22 12.83,17.15 13.28,17.03C13.36,16.54 13.64,16.1 14.1,15.84C14.56,15.57 15.08,15.55 15.54,15.72C16.43,14.85 17,13.66 17.09,12.33L15.38,12.31C15.22,14.1 13.72,15.5 11.88,15.5M11.88,8.5C13.72,8.5 15.22,9.89 15.38,11.69L17.09,11.66C17,10.34 16.43,9.15 15.54,8.28C15.08,8.45 14.55,8.42 14.1,8.16C13.64,7.9 13.36,7.45 13.28,6.97C12.83,6.85 12.37,6.78 11.88,6.78C11.05,6.78 10.27,6.97 9.57,7.32L10.41,8.82C10.85,8.61 11.35,8.5 11.88,8.5M8.37,12C8.37,10.81 8.96,9.76 9.86,9.13L9,7.65C7.94,8.36 7.15,9.43 6.83,10.69C7.21,11 7.45,11.47 7.45,12C7.45,12.53 7.21,13 6.83,13.31C7.15,14.56 7.94,15.64 9,16.34L9.86,14.87C8.96,14.24 8.37,13.19 8.37,12M14.34,16.26C13.77,16.59 13.57,17.32 13.9,17.9C14.23,18.47 14.97,18.67 15.54,18.34C16.12,18 16.31,17.27 16,16.7C15.65,16.12 14.92,15.93 14.34,16.26M5.76,10.8C5.1,10.8 4.56,11.34 4.56,12C4.56,12.66 5.1,13.2 5.76,13.2C6.43,13.2 6.96,12.66 6.96,12C6.96,11.34 6.43,10.8 5.76,10.8Z' })
	  );
	};
	
	var UltraHighDefinitionIcon = function UltraHighDefinitionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,7H11V11H13V7H15V17H13V13H11V17H9V7M17,7H20C21.66,7 23,8.34 23,10V14C23,15.66 21.66,17 20,17H17V7M20,15C20.55,15 21,14.55 21,14V10C21,9.45 20.55,9 20,9H19V15H20M7,14C7,15.66 5.66,17 4,17C2.34,17 1,15.66 1,14V7H3V14C3,14.55 3.45,15 4,15C4.55,15 5,14.55 5,14V7H7V14Z' })
	  );
	};
	
	var UmbracoIcon = function UmbracoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.6,8.6L7.17,8.38C6.5,11.67 6.46,14.24 7.61,15.5C8.6,16.61 11.89,16.61 11.89,16.61C11.89,16.61 15.29,16.61 16.28,15.5C17.43,14.24 17.38,11.67 16.72,8.38L15.29,8.6C15.29,8.6 16.54,13.88 14.69,14.69C13.81,15.07 11.89,15.07 11.89,15.07C11.89,15.07 10.08,15.07 9.2,14.69C7.35,13.88 8.6,8.6 8.6,8.6M12,3C16.97,3 21,7.03 21,12C21,16.97 16.97,21 12,21C7.03,21 3,16.97 3,12C3,7.03 7.03,3 12,3Z' })
	  );
	};
	
	var UmbrellaClosedIcon = function UmbrellaClosedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1.53L17.5,15H13V19C13,20.66 11.66,22 10,22C8.34,22 7,20.66 7,19V18H9V19C9,19.55 9.45,20 10,20C10.55,20 11,19.55 11,19V15H6.5L12,1.53Z' })
	  );
	};
	
	var UmbrellaOutlineIcon = function UmbrellaOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,4C8.9,4 6.18,6.03 5.3,9H18.7C17.82,6.04 15.09,4 12,4M12,2C16.97,2 21,6.03 21,11H13V19C13,20.66 11.66,22 10,22C8.34,22 7,20.66 7,19V18H9V19C9,19.55 9.45,20 10,20C10.55,20 11,19.55 11,19V11H3C3,6.03 7.03,2 12,2Z' })
	  );
	};
	
	var UmbrellaIcon = function UmbrellaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C16.97,2 21,6.03 21,11H13V19C13,20.66 11.66,22 10,22C8.34,22 7,20.66 7,19V18H9V19C9,19.55 9.45,20 10,20C10.55,20 11,19.55 11,19V11H3C3,6.03 7.03,2 12,2Z' })
	  );
	};
	
	var UndoVariantIcon = function UndoVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.5,7C17.09,7 20,9.91 20,13.5C20,17.09 17.09,20 13.5,20H10V18H13.5C16,18 18,16 18,13.5C18,11 16,9 13.5,9H7.83L10.91,12.09L9.5,13.5L4,8L9.5,2.5L10.92,3.91L7.83,7H13.5M6,18H8V20H6V18Z' })
	  );
	};
	
	var UndoIcon = function UndoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.5,8C9.85,8 7.45,9 5.6,10.6L2,7V16H11L7.38,12.38C8.77,11.22 10.54,10.5 12.5,10.5C16.04,10.5 19.05,12.81 20.1,16L22.47,15.22C21.08,11.03 17.15,8 12.5,8Z' })
	  );
	};
	
	var UnfoldLessHorizontalIcon = function UnfoldLessHorizontalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.59,5.41L15.17,4L12,7.17L8.83,4L7.41,5.41L12,10M7.41,18.59L8.83,20L12,16.83L15.17,20L16.58,18.59L12,14L7.41,18.59Z' })
	  );
	};
	
	var UnfoldLessVerticalIcon = function UnfoldLessVerticalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5.41,7.41L10,12L5.41,16.59L4,15.17L7.17,12L4,8.83L5.41,7.41M18.59,16.59L14,12L18.59,7.42L20,8.83L16.83,12L20,15.17L18.59,16.59Z' })
	  );
	};
	
	var UnfoldMoreHorizontalIcon = function UnfoldMoreHorizontalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z' })
	  );
	};
	
	var UnfoldMoreVerticalIcon = function UnfoldMoreVerticalIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.17,12L15,8.83L16.41,7.41L21,12L16.41,16.58L15,15.17L18.17,12M5.83,12L9,15.17L7.59,16.59L3,12L7.59,7.42L9,8.83L5.83,12Z' })
	  );
	};
	
	var UngroupIcon = function UngroupIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,2H6V3H13V2H17V6H16V9H18V8H22V12H21V18H22V22H18V21H12V22H8V18H9V16H6V17H2V13H3V6H2V2M18,12V11H16V13H17V17H13V16H11V18H12V19H18V18H19V12H18M13,6V5H6V6H5V13H6V14H9V12H8V8H12V9H14V6H13M12,12H11V14H13V13H14V11H12V12Z' })
	  );
	};
	
	var UnityIcon = function UnityIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.11,17H6.5L1.59,12L6.5,7H9.11L10.42,4.74L17.21,3L19.08,9.74L17.77,12L19.08,14.26L17.21,21L10.42,19.26L9.11,17M9.25,16.75L14.38,18.13L11.42,13H5.5L9.25,16.75M16.12,17.13L17.5,12L16.12,6.87L13.15,12L16.12,17.13M9.25,7.25L5.5,11H11.42L14.38,5.87L9.25,7.25Z' })
	  );
	};
	
	var UnrealIcon = function UnrealIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2C6.48,2 2,6.48 2,12M5.24,18.76C3.43,16.95 2.44,14.55 2.44,12C2.44,9.45 3.43,7.05 5.24,5.24C7.05,3.43 9.45,2.44 12,2.44C14.55,2.44 16.95,3.43 18.76,5.24C20.57,7.05 21.56,9.45 21.56,12C21.56,14.55 20.57,16.95 18.76,18.76C16.95,20.57 14.55,21.56 12,21.56C9.45,21.56 7.05,20.57 5.24,18.76M6.35,9.5C4.34,11.79 4.73,13.68 4.73,13.68C4.73,13.68 5.28,12.38 6.61,11C7.25,10.37 7.72,10.15 8.04,10.15C8.4,10.15 8.57,10.41 8.57,10.65V15.29C8.57,15.75 8.27,15.85 8,15.84C7.77,15.84 7.55,15.76 7.55,15.76C8.92,17.73 12.19,18 12.19,18L13.63,16.5H13.67L15,17.63C17.39,16.21 18.55,13.58 18.55,13.58C17.5,14.7 16.79,14.97 16.39,14.96C16.03,14.96 15.88,14.75 15.88,14.75C15.87,14.65 15.82,8.9 15.89,8.9C16.31,8.13 17.63,6.56 17.63,6.56C15.16,7.05 13.81,8.66 13.81,8.66C13.41,8.35 12.59,8.4 12.59,8.4C12.97,8.61 13.35,9.21 13.35,9.72V14.65C13.35,14.65 12.5,15.38 11.88,15.38C11.5,15.38 11.27,15.17 11.14,15C11.05,14.88 11,14.79 11,14.79V8.69C10.93,8.75 10.82,8.8 10.71,8.8C10.57,8.79 10.43,8.73 10.34,8.53C10.26,8.38 10.22,8.15 10.22,7.83C10.22,6.7 11.5,5.96 11.5,5.96C9.87,6.39 8.36,7.22 6.35,9.5' })
	  );
	};
	
	var UntappdIcon = function UntappdIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.41,4C14.41,4 14.94,4.39 14.97,4.71C14.97,4.81 14.73,4.85 14.68,4.93C14.62,5 14.7,5.15 14.65,5.21C14.59,5.26 14.5,5.26 14.41,5.41C14.33,5.56 12.07,10.09 11.73,10.63C11.59,11.03 11.47,12.46 11.37,12.66C11.26,12.85 6.34,19.84 6.16,20.05C5.67,20.63 4.31,20.3 3.28,19.56C2.3,18.86 1.74,17.7 2.11,17.16C2.27,16.93 7.15,9.92 7.29,9.75C7.44,9.58 8.75,9 9.07,8.71C9.47,8.22 12.96,4.54 13.07,4.42C13.18,4.3 13.15,4.2 13.18,4.13C13.22,4.06 13.38,4.08 13.43,4C13.5,3.93 13.39,3.71 13.5,3.68C13.59,3.64 13.96,3.67 14.41,4M10.85,4.44L11.74,5.37L10.26,6.94L9.46,5.37C9.38,5.22 9.28,5.22 9.22,5.17C9.17,5.11 9.24,4.97 9.19,4.89C9.13,4.81 8.9,4.83 8.9,4.73C8.9,4.62 9.05,4.28 9.5,3.96C9.5,3.96 10.06,3.6 10.37,3.68C10.47,3.71 10.43,3.95 10.5,4C10.54,4.1 10.7,4.08 10.73,4.15C10.77,4.21 10.73,4.32 10.85,4.44M21.92,17.15C22.29,17.81 21.53,19 20.5,19.7C19.5,20.39 18.21,20.54 17.83,20C17.66,19.78 12.67,12.82 12.56,12.62C12.45,12.43 12.32,11 12.18,10.59L12.15,10.55C12.45,10 13.07,8.77 13.73,7.47C14.3,8.06 14.75,8.56 14.88,8.72C15.21,9 16.53,9.58 16.68,9.75C16.82,9.92 21.78,16.91 21.92,17.15Z' })
	  );
	};
	
	var UpdateIcon = function UpdateIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,10.12H14.22L16.96,7.3C14.23,4.6 9.81,4.5 7.08,7.2C4.35,9.91 4.35,14.28 7.08,17C9.81,19.7 14.23,19.7 16.96,17C18.32,15.65 19,14.08 19,12.1H21C21,14.08 20.12,16.65 18.36,18.39C14.85,21.87 9.15,21.87 5.64,18.39C2.14,14.92 2.11,9.28 5.62,5.81C9.13,2.34 14.76,2.34 18.27,5.81L21,3V10.12M12.5,8V12.25L16,14.33L15.28,15.54L11,13V8H12.5Z' })
	  );
	};
	
	var UploadMultipleIcon = function UploadMultipleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,14V8H5L12,1L19,8H15V14H9M5,18V16H19V18H5M19,20H5V22H19V20Z' })
	  );
	};
	
	var UploadNetworkIcon = function UploadNetworkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,3C18.1,3 19,3.9 19,5V15C19,16.1 18.1,17 17,17H13V19H14C14.55,19 15,19.45 15,20H22V22H15C15,22.55 14.55,23 14,23H10C9.45,23 9,22.55 9,22H2V20H9C9,19.45 9.45,19 10,19H11V17H7C5.89,17 5,16.1 5,15V5C5,3.9 5.9,3 7,3H17M12,5.5L7.5,10H11V14H13V10H16.5L12,5.5Z' })
	  );
	};
	
	var UploadIcon = function UploadIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z' })
	  );
	};
	
	var UsbIcon = function UsbIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,7V11H16V13H13V5H15L12,1L9,5H11V13H8V10.93C8.7,10.56 9.2,9.85 9.2,9C9.2,7.78 8.21,6.8 7,6.8C5.78,6.8 4.8,7.78 4.8,9C4.8,9.85 5.3,10.56 6,10.93V13C6,14.1 6.9,15 8,15H11V18.05C10.29,18.41 9.8,19.15 9.8,20C9.8,21.22 10.78,22.2 12,22.2C13.22,22.2 14.2,21.22 14.2,20C14.2,19.15 13.71,18.41 13,18.05V15H16C17.1,15 18,14.1 18,13V11H19V7H15Z' })
	  );
	};
	
	var VanPassengerIcon = function VanPassengerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,7C1.89,7 1,7.89 1,9V17H3C3,18.66 4.34,20 6,20C7.66,20 9,18.66 9,17H15C15,18.66 16.34,20 18,20C19.66,20 21,18.66 21,17H23V13C23,11.89 22.11,11 21,11L18,7H3M3,8.5H7V11H3V8.5M9,8.5H13V11H9V8.5M15,8.5H17.5L19.46,11H15V8.5M6,15.5C6.83,15.5 7.5,16.17 7.5,17C7.5,17.83 6.83,18.5 6,18.5C5.17,18.5 4.5,17.83 4.5,17C4.5,16.17 5.17,15.5 6,15.5M18,15.5C18.83,15.5 19.5,16.17 19.5,17C19.5,17.83 18.83,18.5 18,18.5C17.17,18.5 16.5,17.83 16.5,17C16.5,16.17 17.17,15.5 18,15.5Z' })
	  );
	};
	
	var VanUtilityIcon = function VanUtilityIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,7C1.89,7 1,7.89 1,9V17H3C3,18.66 4.34,20 6,20C7.66,20 9,18.66 9,17H15C15,18.66 16.34,20 18,20C19.66,20 21,18.66 21,17H23V13C23,11.89 22.11,11 21,11L18,7H3M15,8.5H17.5L19.46,11H15V8.5M6,15.5C6.83,15.5 7.5,16.17 7.5,17C7.5,17.83 6.83,18.5 6,18.5C5.17,18.5 4.5,17.83 4.5,17C4.5,16.17 5.17,15.5 6,15.5M18,15.5C18.83,15.5 19.5,16.17 19.5,17C19.5,17.83 18.83,18.5 18,18.5C17.17,18.5 16.5,17.83 16.5,17C16.5,16.17 17.17,15.5 18,15.5Z' })
	  );
	};
	
	var VanishIcon = function VanishIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,13V11H21V13H16M14.83,7.76L17.66,4.93L19.07,6.34L16.24,9.17L14.83,7.76M11,16H13V21H11V16M11,3H13V8H11V3M4.93,17.66L7.76,14.83L9.17,16.24L6.34,19.07L4.93,17.66M4.93,6.34L6.34,4.93L9.17,7.76L7.76,9.17L4.93,6.34M8,13H3V11H8V13M19.07,17.66L17.66,19.07L14.83,16.24L16.24,14.83L19.07,17.66Z' })
	  );
	};
	
	var VectorArrangeAboveIcon = function VectorArrangeAboveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,1C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16C6.67,16 10.33,16 14,16C15.11,16 16,15.11 16,14C16,10.33 16,6.67 16,3C16,1.89 15.11,1 14,1H3M3,3H14V14H3V3M18,7V9H20V20H9V18H7V20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7H18Z' })
	  );
	};
	
	var VectorArrangeBelowIcon = function VectorArrangeBelowIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,22C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7C16.33,7 12.67,7 9,7C7.89,7 7,7.89 7,9C7,12.67 7,16.33 7,20C7,21.11 7.89,22 9,22H20M20,20H9V9H20V20M5,16V14H3V3H14V5H16V3C16,1.89 15.11,1 14,1H3C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16H5Z' })
	  );
	};
	
	var VectorCircleVariantIcon = function VectorCircleVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,9H19.97C18.7,5.41 15.31,3 11.5,3C6.53,3 2.5,7.03 2.5,12C2.5,17 6.53,21 11.5,21C15.31,21 18.7,18.6 20,15H22M20,11V13H18V11M17.82,15C16.66,17.44 14.2,19 11.5,19C7.64,19 4.5,15.87 4.5,12C4.5,8.14 7.64,5 11.5,5C14.2,5 16.66,6.57 17.81,9H16V15' })
	  );
	};
	
	var VectorCircleIcon = function VectorCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,2V4.06C6.72,4.92 4.92,6.72 4.05,9H2V15H4.06C4.92,17.28 6.72,19.09 9,19.95V22H15V19.94C17.28,19.08 19.09,17.28 19.95,15H22V9H19.94C19.08,6.72 17.28,4.92 15,4.05V2M11,4H13V6H11M9,6.25V8H15V6.25C16.18,6.86 17.14,7.82 17.75,9H16V15H17.75C17.14,16.18 16.18,17.14 15,17.75V16H9V17.75C7.82,17.14 6.86,16.18 6.25,15H8V9H6.25C6.86,7.82 7.82,6.86 9,6.25M4,11H6V13H4M18,11H20V13H18M11,18H13V20H11' })
	  );
	};
	
	var VectorCombineIcon = function VectorCombineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,1C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16C4.33,16 7,16 7,16C7,16 7,18.67 7,20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7C18.67,7 16,7 16,7C16,7 16,4.33 16,3C16,1.89 15.11,1 14,1H3M3,3H14C14,4.33 14,7 14,7H9C7.89,7 7,7.89 7,9V14C7,14 4.33,14 3,14V3M9,9H14V14H9V9M16,9C16,9 18.67,9 20,9V20H9C9,18.67 9,16 9,16H14C15.11,16 16,15.11 16,14V9Z' })
	  );
	};
	
	var VectorCurveIcon = function VectorCurveIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.5,2C19.33,2 20,2.67 20,3.5C20,4.33 19.33,5 18.5,5C18.27,5 18.05,4.95 17.85,4.85L14.16,8.55L14.5,9C16.69,7.74 19.26,7 22,7L23,7.03V9.04L22,9C19.42,9 17,9.75 15,11.04C15,13.23 13.23,15 11.04,15C9.75,17 9,19.42 9,22L9.04,23H7.03L7,22C7,19.26 7.74,16.69 9,14.5L8.55,14.16L4.85,17.85C4.95,18.05 5,18.27 5,18.5C5,19.33 4.33,20 3.5,20C2.67,20 2,19.33 2,18.5C2,17.67 2.67,17 3.5,17C3.73,17 3.95,17.05 4.15,17.15L7.84,13.45C7.31,12.78 7,11.92 7,11C7,8.79 8.79,7 11,7C11.92,7 12.78,7.31 13.45,7.84L17.15,4.15C17.05,3.95 17,3.73 17,3.5C17,2.67 17.67,2 18.5,2M11,9C9.9,9 9,9.9 9,11C9,12.1 9.9,13 11,13C12.1,13 13,12.1 13,11C13,9.9 12.1,9 11,9Z' })
	  );
	};
	
	var VectorDifferenceAbIcon = function VectorDifferenceAbIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,1C1.89,1 1,1.89 1,3V5H3V3H5V1H3M7,1V3H10V1H7M12,1V3H14V5H16V3C16,1.89 15.11,1 14,1H12M1,7V10H3V7H1M14,7C14,7 14,11.67 14,14C11.67,14 7,14 7,14C7,14 7,18 7,20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7C18,7 14,7 14,7M16,9H20V20H9V16H14C15.11,16 16,15.11 16,14V9M1,12V14C1,15.11 1.89,16 3,16H5V14H3V12H1Z' })
	  );
	};
	
	var VectorDifferenceBaIcon = function VectorDifferenceBaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,22C21.11,22 22,21.11 22,20V18H20V20H18V22H20M16,22V20H13V22H16M11,22V20H9V18H7V20C7,21.11 7.89,22 9,22H11M22,16V13H20V16H22M9,16C9,16 9,11.33 9,9C11.33,9 16,9 16,9C16,9 16,5 16,3C16,1.89 15.11,1 14,1H3C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16C5,16 9,16 9,16M7,14H3V3H14V7H9C7.89,7 7,7.89 7,9V14M22,11V9C22,7.89 21.11,7 20,7H18V9H20V11H22Z' })
	  );
	};
	
	var VectorDifferenceIcon = function VectorDifferenceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,1C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16H5V14H3V3H14V5H16V3C16,1.89 15.11,1 14,1H3M9,7C7.89,7 7,7.89 7,9V11H9V9H11V7H9M13,7V9H14V10H16V7H13M18,7V9H20V20H9V18H7V20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7H18M14,12V14H12V16H14C15.11,16 16,15.11 16,14V12H14M7,13V16H10V14H9V13H7Z' })
	  );
	};
	
	var VectorEllipseIcon = function VectorEllipseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M23,9V15H20.35C19.38,17.12 17.43,18.78 15,19.54V22H9V19.54C5.5,18.45 3,15.5 3,12C3,7.58 7.03,4 12,4C15.78,4 19,6.07 20.35,9H23M17,15V9H18.06C16.85,7.21 14.59,6 12,6C8.13,6 5,8.69 5,12C5,14.39 6.64,16.46 9,17.42V16H15V17.42C16.29,16.9 17.35,16.05 18.06,15H17M19,13H21V11H19V13M11,20H13V18H11V20Z' })
	  );
	};
	
	var VectorIntersectionIcon = function VectorIntersectionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.14,1C1.96,1 1,1.96 1,3.14V5H3V3H5V1H3.14M7,1V3H10V1H7M12,1V3H14V5H16V3.14C16,1.96 15.04,1 13.86,1H12M1,7V10H3V7H1M9,7C7.89,7 7,7.89 7,9C7,11.33 7,16 7,16C7,16 11.57,16 13.86,16C15.04,16 16,15.04 16,13.86C16,11.57 16,7 16,7C16,7 11.33,7 9,7M18,7V9H20V11H22V9C22,7.89 21.11,7 20,7H18M9,9H14V14H9V9M1,12V13.86C1,15.04 1.96,16 3.14,16H5V14H3V12H1M20,13V16H22V13H20M7,18V20C7,21.11 7.89,22 9,22H11V20H9V18H7M20,18V20H18V22H20C21.11,22 22,21.11 22,20V18H20M13,20V22H16V20H13Z' })
	  );
	};
	
	var VectorLineIcon = function VectorLineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,3V7.59L7.59,15H3V21H9V16.42L16.42,9H21V3M17,5H19V7H17M5,17H7V19H5' })
	  );
	};
	
	var VectorPointIcon = function VectorPointIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20L7,22L12,11L17,22L12,20M8,2H16V5H22V7H16V10H8V7H2V5H8V2M10,4V8H14V4H10Z' })
	  );
	};
	
	var VectorPolygonIcon = function VectorPolygonIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,2V8H4.28L5.57,16H4V22H10V20.06L15,20.05V22H21V16H19.17L20,9H22V3H16V6.53L14.8,8H9.59L8,5.82V2M4,4H6V6H4M18,5H20V7H18M6.31,8H7.11L9,10.59V14H15V10.91L16.57,9H18L17.16,16H15V18.06H10V16H7.6M11,10H13V12H11M6,18H8V20H6M17,18H19V20H17' })
	  );
	};
	
	var VectorPolylineIcon = function VectorPolylineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,2V8H17.08L14.95,13H14.26L12,9.97V5H6V11H6.91L4.88,16H2V22H8V16H7.04L9.07,11H10.27L12,13.32V19H18V13H17.12L19.25,8H22V2M18,4H20V6H18M8,7H10V9H8M14,15H16V17H14M4,18H6V20H4' })
	  );
	};
	
	var VectorRadiusIcon = function VectorRadiusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,4H4V2H10V4C15.52,4 20,8.48 20,14H22V20H20V22H18V20H16V14H18C18,9.58 14.42,6 10,6V8H4V6H2V4M18,16V18H20V16H18M6,4V6H8V4H6Z' })
	  );
	};
	
	var VectorRectangleIcon = function VectorRectangleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,4H8V6H16V4H22V10H20V14H22V20H16V18H8V20H2V14H4V10H2V4M16,10V8H8V10H6V14H8V16H16V14H18V10H16M4,6V8H6V6H4M18,6V8H20V6H18M4,16V18H6V16H4M18,16V18H20V16H18Z' })
	  );
	};
	
	var VectorSelectionIcon = function VectorSelectionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,1H5V3H3V5H1V3C1,1.9 1.9,1 3,1M14,1C15.1,1 16,1.9 16,3V5H14V3H12V1H14M20,7C21.1,7 22,7.9 22,9V11H20V9H18V7H20M22,20C22,21.1 21.1,22 20,22H18V20H20V18H22V20M20,13H22V16H20V13M13,9V7H16V10H14V9H13M13,22V20H16V22H13M9,22C7.9,22 7,21.1 7,20V18H9V20H11V22H9M7,16V13H9V14H10V16H7M7,3V1H10V3H7M3,16C1.9,16 1,15.1 1,14V12H3V14H5V16H3M1,7H3V10H1V7M9,7H11V9H9V11H7V9C7,7.9 7.9,7 9,7M16,14C16,15.1 15.1,16 14,16H12V14H14V12H16V14Z' })
	  );
	};
	
	var VectorSquareIcon = function VectorSquareIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,2H8V4H16V2H22V8H20V16H22V22H16V20H8V22H2V16H4V8H2V2M16,8V6H8V8H6V16H8V18H16V16H18V8H16M4,4V6H6V4H4M18,4V6H20V4H18M4,18V20H6V18H4M18,18V20H20V18H18Z' })
	  );
	};
	
	var VectorTriangleIcon = function VectorTriangleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,3V9H9.73L5.79,16H2V22H8V20H16V22H22V16H18.21L14.27,9H15V3M11,5H13V7H11M12,9.04L16,16.15V18H8V16.15M4,18H6V20H4M18,18H20V20H18' })
	  );
	};
	
	var VectorUnionIcon = function VectorUnionIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,1C1.89,1 1,1.89 1,3V14C1,15.11 1.89,16 3,16H7V20C7,21.11 7.89,22 9,22H20C21.11,22 22,21.11 22,20V9C22,7.89 21.11,7 20,7H16V3C16,1.89 15.11,1 14,1H3M3,3H14V9H20V20H9V14H3V3Z' })
	  );
	};
	
	var VenmoIcon = function VenmoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19.5,3C20.14,4.08 20.44,5.19 20.44,6.6C20.44,11.08 16.61,16.91 13.5,21H6.41L3.56,4L9.77,3.39L11.28,15.5C12.69,13.21 14.42,9.61 14.42,7.16C14.42,5.81 14.19,4.9 13.83,4.15L19.5,3Z' })
	  );
	};
	
	var VerifiedIcon = function VerifiedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1Z' })
	  );
	};
	
	var VibrateIcon = function VibrateIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,19H8V5H16M16.5,3H7.5C6.67,3 6,3.67 6,4.5V19.5C6,20.33 6.67,21 7.5,21H16.5C17.33,21 18,20.33 18,19.5V4.5C18,3.67 17.33,3 16.5,3M19,17H21V7H19M22,9V15H24V9M3,17H5V7H3M0,15H2V9H0V15Z' })
	  );
	};
	
	var Video3dIcon = function Video3dIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,7H9C10.1,7 11,7.9 11,9V15C11,16.1 10.1,17 9,17H5V15H9V13H6V11H9V9H5V7M13,7H16C17.66,7 19,8.34 19,10V14C19,15.66 17.66,17 16,17H13V7M16,15C16.55,15 17,14.55 17,14V10C17,9.45 16.55,9 16,9H15V15H16Z' })
	  );
	};
	
	var Video4kBoxIcon = function Video4kBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M18.09,15L16.08,12L18.09,9H16.36L14.39,12V9H12.89V15H14.39V12L16.36,15H18.09M11.86,13.5V12H10.88V9H9.38V12H7.88V9H6.38V13.5H9.38V15H10.88V13.5H11.86Z' })
	  );
	};
	
	var VideoAccountIcon = function VideoAccountIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,10.5L21,6.5V17.5L17,13.5V17C17,17.55 16.55,18 16,18H4C3.45,18 3,17.55 3,17V7C3,6.45 3.45,6 4,6H16C16.55,6 17,6.45 17,7V10.5M14,16V15C14,13.67 11.33,13 10,13C8.67,13 6,13.67 6,15V16H14M10,8C8.9,8 8,8.9 8,10C8,11.1 8.9,12 10,12C11.1,12 12,11.1 12,10C12,8.9 11.1,8 10,8Z' })
	  );
	};
	
	var VideoImageIcon = function VideoImageIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,10.5L21,6.5V17.5L17,13.5V17C17,17.55 16.55,18 16,18H4C3.45,18 3,17.55 3,17V7C3,6.45 3.45,6 4,6H16C16.55,6 17,6.45 17,7V10.5M10.91,9.55L9.2,11.82L10.5,13.55L9.77,14.09L7.73,11.36L5,15H15L10.91,9.55Z' })
	  );
	};
	
	var VideoInputAntennaIcon = function VideoInputAntennaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,5C8.13,5 5,8.13 5,12H7C7,9.24 9.24,7 12,7C14.76,7 17,9.24 17,12H19C19,8.13 15.87,5 12,5M13,14.29C13.88,13.9 14.5,13.03 14.5,12C14.5,10.62 13.38,9.5 12,9.5C10.62,9.5 9.5,10.62 9.5,12C9.5,13 10.12,13.9 11,14.29V17.59L7.59,21L9,22.41L12,19.41L15,22.41L16.41,21L13,17.59V14.29M12,1C5.92,1 1,5.92 1,12H3C3,7.03 7.03,3 12,3C16.97,3 21,7.03 21,12H23C23,5.92 18.08,1 12,1Z' })
	  );
	};
	
	var VideoInputComponentIcon = function VideoInputComponentIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,2C5,1.45 4.55,1 4,1C3.45,1 3,1.45 3,2V6H1V12H7V6H5V2M9,16C9,17.3 9.84,18.4 11,18.82V23H13V18.82C14.16,18.41 15,17.31 15,16V14H9V16M1,16C1,17.3 1.84,18.4 3,18.82V23H5V18.82C6.16,18.4 7,17.3 7,16V14H1V16M21,6V2C21,1.45 20.55,1 20,1C19.45,1 19,1.45 19,2V6H17V12H23V6H21M13,2C13,1.45 12.55,1 12,1C11.45,1 11,1.45 11,2V6H9V12H15V6H13V2M17,16C17,17.3 17.84,18.4 19,18.82V23H21V18.82C22.16,18.41 23,17.31 23,16V14H17V16Z' })
	  );
	};
	
	var VideoInputHdmiIcon = function VideoInputHdmiIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,7V4C18,2.9 17.1,2 16,2H8C6.9,2 6,2.9 6,4V7H5V13L8,19V22H16V19L19,13V7H18M8,4H16V7H14V5H13V7H11V5H10V7H8V4Z' })
	  );
	};
	
	var VideoInputSvideoIcon = function VideoInputSvideoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,11.5C8,10.67 7.33,10 6.5,10C5.67,10 5,10.67 5,11.5C5,12.33 5.67,13 6.5,13C7.33,13 8,12.33 8,11.5M15,6.5C15,5.67 14.33,5 13.5,5H10.5C9.67,5 9,5.67 9,6.5C9,7.33 9.67,8 10.5,8H13.5C14.33,8 15,7.33 15,6.5M8.5,15C7.67,15 7,15.67 7,16.5C7,17.33 7.67,18 8.5,18C9.33,18 10,17.33 10,16.5C10,15.67 9.33,15 8.5,15M12,1C5.92,1 1,5.92 1,12C1,18.08 5.92,23 12,23C18.08,23 23,18.08 23,12C23,5.92 18.08,1 12,1M12,21C7.04,21 3,16.96 3,12C3,7.04 7.04,3 12,3C16.96,3 21,7.04 21,12C21,16.96 16.96,21 12,21M17.5,10C16.67,10 16,10.67 16,11.5C16,12.33 16.67,13 17.5,13C18.33,13 19,12.33 19,11.5C19,10.67 18.33,10 17.5,10M15.5,15C14.67,15 14,15.67 14,16.5C14,17.33 14.67,18 15.5,18C16.33,18 17,17.33 17,16.5C17,15.67 16.33,15 15.5,15Z' })
	  );
	};
	
	var VideoMinusIcon = function VideoMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,10.5V7C17,6.45 16.55,6 16,6H4C3.45,6 3,6.45 3,7V17C3,17.55 3.45,18 4,18H16C16.55,18 17,17.55 17,17V13.5L21,17.5V6.5L17,10.5M14,13H6V11H14V13Z' })
	  );
	};
	
	var VideoOffIcon = function VideoOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.27,2L2,3.27L4.73,6H4C3.45,6 3,6.45 3,7V17C3,17.55 3.45,18 4,18H16C16.2,18 16.39,17.92 16.54,17.82L19.73,21L21,19.73M21,6.5L17,10.5V7C17,6.45 16.55,6 16,6H9.82L21,17.18V6.5Z' })
	  );
	};
	
	var VideoPlusIcon = function VideoPlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,10.5V7C17,6.45 16.55,6 16,6H4C3.45,6 3,6.45 3,7V17C3,17.55 3.45,18 4,18H16C16.55,18 17,17.55 17,17V13.5L21,17.5V6.5L17,10.5M14,13H11V16H9V13H6V11H9V8H11V11H14V13Z' })
	  );
	};
	
	var VideoStabilizationIcon = function VideoStabilizationIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H20C21.1,4 22,4.9 22,6V18C22,19.1 21.1,20 20,20H4C2.9,20 2,19.1 2,18V6C2,4.9 2.9,4 4,4M4,6V18H20V6H4M7.24,6.58L18.83,9.69L16.76,17.42L5.17,14.31L7.24,6.58Z' })
	  );
	};
	
	var VideoSwitchIcon = function VideoSwitchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,15.5V13H7V15.5L3.5,12L7,8.5V11H13V8.5L16.5,12M18,9.5V6C18,5.45 17.55,5 17,5H3C2.45,5 2,5.45 2,6V18C2,18.55 2.45,19 3,19H17C17.55,19 18,18.55 18,18V14.5L22,18.5V5.5L18,9.5Z' })
	  );
	};
	
	var VideoIcon = function VideoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,10.5V7C17,6.45 16.55,6 16,6H4C3.45,6 3,6.45 3,7V17C3,17.55 3.45,18 4,18H16C16.55,18 17,17.55 17,17V13.5L21,17.5V6.5L17,10.5Z' })
	  );
	};
	
	var ViewAgendaIcon = function ViewAgendaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,3H3C2.45,3 2,3.45 2,4V10C2,10.55 2.45,11 3,11H20C20.55,11 21,10.55 21,10V4C21,3.45 20.55,3 20,3M20,13H3C2.45,13 2,13.45 2,14V20C2,20.55 2.45,21 3,21H20C20.55,21 21,20.55 21,20V14C21,13.45 20.55,13 20,13Z' })
	  );
	};
	
	var ViewArrayIcon = function ViewArrayIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,18H17V5H8M18,5V18H21V5M4,18H7V5H4V18Z' })
	  );
	};
	
	var ViewCarouselIcon = function ViewCarouselIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,6V17H22V6M2,17H6V6H2M7,19H17V4H7V19Z' })
	  );
	};
	
	var ViewColumnIcon = function ViewColumnIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,5V18H21V5M4,18H9V5H4M10,18H15V5H10V18Z' })
	  );
	};
	
	var ViewDashboardVariantIcon = function ViewDashboardVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5V19H8V5H2M9,5V10H15V5H9M16,5V14H22V5H16M9,11V19H15V11H9M16,15V19H22V15H16Z' })
	  );
	};
	
	var ViewDashboardIcon = function ViewDashboardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,3V9H21V3M13,21H21V11H13M3,21H11V15H3M3,13H11V3H3V13Z' })
	  );
	};
	
	var ViewDayIcon = function ViewDayIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,3V6H21V3M20,8H3C2.45,8 2,8.45 2,9V15C2,15.55 2.45,16 3,16H20C20.55,16 21,15.55 21,15V9C21,8.45 20.55,8 20,8M2,21H21V18H2V21Z' })
	  );
	};
	
	var ViewGridIcon = function ViewGridIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,11H11V3H3M3,21H11V13H3M13,21H21V13H13M13,3V11H21V3' })
	  );
	};
	
	var ViewHeadlineIcon = function ViewHeadlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,5V7H21V5M4,11H21V9H4M4,19H21V17H4M4,15H21V13H4V15Z' })
	  );
	};
	
	var ViewListIcon = function ViewListIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,5V9H21V5M9,19H21V15H9M9,14H21V10H9M4,9H8V5H4M4,19H8V15H4M4,14H8V10H4V14Z' })
	  );
	};
	
	var ViewModuleIcon = function ViewModuleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16,5V11H21V5M10,11H15V5H10M16,18H21V12H16M10,18H15V12H10M4,18H9V12H4M4,11H9V5H4V11Z' })
	  );
	};
	
	var ViewParallelIcon = function ViewParallelIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,21V3H8V21H4M10,21V3H14V21H10M16,21V3H20V21H16Z' })
	  );
	};
	
	var ViewQuiltIcon = function ViewQuiltIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,5V11H21V5M16,18H21V12H16M4,18H9V5H4M10,18H15V12H10V18Z' })
	  );
	};
	
	var ViewSequentialIcon = function ViewSequentialIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,4H21V8H3V4M3,10H21V14H3V10M3,16H21V20H3V16Z' })
	  );
	};
	
	var ViewStreamIcon = function ViewStreamIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,5V11H21V5M4,18H21V12H4V18Z' })
	  );
	};
	
	var ViewWeekIcon = function ViewWeekIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13,5H10C9.45,5 9,5.45 9,6V18C9,18.55 9.45,19 10,19H13C13.55,19 14,18.55 14,18V6C14,5.45 13.55,5 13,5M20,5H17C16.45,5 16,5.45 16,6V18C16,18.55 16.45,19 17,19H20C20.55,19 21,18.55 21,18V6C21,5.45 20.55,5 20,5M6,5H3C2.45,5 2,5.45 2,6V18C2,18.55 2.45,19 3,19H6C6.55,19 7,18.55 7,18V6C7,5.45 6.55,5 6,5Z' })
	  );
	};
	
	var VimeoIcon = function VimeoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22,7.42C21.91,9.37 20.55,12.04 17.92,15.44C15.2,19 12.9,20.75 11,20.75C9.85,20.75 8.86,19.67 8.05,17.5C7.5,15.54 7,13.56 6.44,11.58C5.84,9.42 5.2,8.34 4.5,8.34C4.36,8.34 3.84,8.66 2.94,9.29L2,8.07C3,7.2 3.96,6.33 4.92,5.46C6.24,4.32 7.23,3.72 7.88,3.66C9.44,3.5 10.4,4.58 10.76,6.86C11.15,9.33 11.42,10.86 11.57,11.46C12,13.5 12.5,14.5 13.05,14.5C13.47,14.5 14.1,13.86 14.94,12.53C15.78,11.21 16.23,10.2 16.29,9.5C16.41,8.36 15.96,7.79 14.94,7.79C14.46,7.79 13.97,7.9 13.46,8.12C14.44,4.89 16.32,3.32 19.09,3.41C21.15,3.47 22.12,4.81 22,7.42Z' })
	  );
	};
	
	var ViolinIcon = function ViolinIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,2C10.45,2 10,2.45 10,3V5L10,9C10,9.28 10.22,9.5 10.5,9.5H12C12.28,9.5 12.5,9.72 12.5,10C12.5,10.28 12.28,10.5 12,10.5H10.5C9.73,10.5 9,9.77 9,9V5.16C7.27,5.6 6,7.13 6,9V10.5C7.38,10.5 8.5,11.62 8.5,13C8.5,14.38 7.38,15.5 6,15.5V17C6,19.77 8.23,22 11,22H13C15.77,22 18,19.77 18,17V15.5C16.62,15.5 15.5,14.38 15.5,13C15.5,11.62 16.62,10.5 18,10.5V9C18,6.78 16.22,5 14,5V3C14,2.45 13.55,2 13,2H11M10.75,16.5H13.25L12.75,20H11.25L10.75,16.5Z' })
	  );
	};
	
	var VirtualRealityIcon = function VirtualRealityIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5M6,9H7.5L8.5,12.43L9.5,9H11L9.25,15H7.75L6,9M13,9H16.5C17.35,9 18,9.65 18,10.5V11.5C18,12.1 17.6,12.65 17.1,12.9L18,15H16.5L15.65,13H14.5V15H13V9M14.5,10.5V11.5H16.5V10.5H14.5Z' })
	  );
	};
	
	var VisualstudioIcon = function VisualstudioIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,8.5L12.25,12.32L17,16V8.5M4.7,18.4L2,16.7V7.7L5,6.7L9.3,10.03L18,2L22,4.5V20L17,22L9.34,14.66L4.7,18.4M5,14L6.86,12.28L5,10.5V14Z' })
	  );
	};
	
	var VkBoxIcon = function VkBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,3C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3H5M5.5,8.5H7C7.36,8.5 7.5,8.66 7.64,9.07C8.36,11.17 9.57,13 10.07,13C10.26,13 10.35,12.92 10.35,12.45V10.28C10.29,9.28 9.76,9.19 9.76,8.84C9.76,8.67 9.9,8.5 10.14,8.5H12.45C12.77,8.5 12.87,8.67 12.87,9.04V11.96C12.87,12.27 13,12.38 13.1,12.38C13.29,12.38 13.45,12.27 13.79,11.93C14.85,10.74 15.6,8.92 15.6,8.92C15.7,8.7 15.87,8.5 16.24,8.5H17.71C18.16,8.5 18.26,8.73 18.16,9.04C17.97,9.9 16.18,12.43 16.18,12.43C16,12.68 15.96,12.8 16.18,13.09C16.33,13.3 16.85,13.74 17.19,14.15C17.83,14.86 18.3,15.46 18.44,15.87C18.56,16.29 18.35,16.5 17.93,16.5H16.45C15.89,16.5 15.73,16.05 14.73,15.05C13.85,14.21 13.5,14.1 13.26,14.1C12.96,14.1 12.87,14.18 12.87,14.61V15.93C12.87,16.29 12.76,16.5 11.82,16.5C10.26,16.5 8.54,15.55 7.33,13.8C5.5,11.24 5,9.31 5,8.92C5,8.7 5.08,8.5 5.5,8.5Z' })
	  );
	};
	
	var VkCircleIcon = function VkCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M5.5,8.5H7C7.36,8.5 7.5,8.66 7.64,9.07C8.36,11.17 9.57,13 10.07,13C10.26,13 10.35,12.92 10.35,12.45V10.28C10.29,9.28 9.76,9.19 9.76,8.84C9.76,8.67 9.9,8.5 10.14,8.5H12.45C12.77,8.5 12.87,8.67 12.87,9.04V11.96C12.87,12.27 13,12.38 13.1,12.38C13.29,12.38 13.45,12.27 13.79,11.93C14.85,10.74 15.6,8.92 15.6,8.92C15.7,8.7 15.87,8.5 16.24,8.5H17.71C18.16,8.5 18.26,8.73 18.16,9.04C17.97,9.9 16.18,12.43 16.18,12.43C16,12.68 15.96,12.8 16.18,13.09C16.33,13.3 16.85,13.74 17.19,14.15C17.83,14.86 18.3,15.46 18.44,15.87C18.56,16.29 18.35,16.5 17.93,16.5H16.45C15.89,16.5 15.73,16.05 14.73,15.05C13.85,14.21 13.5,14.1 13.26,14.1C12.96,14.1 12.87,14.18 12.87,14.61V15.93C12.87,16.29 12.76,16.5 11.82,16.5C10.26,16.5 8.54,15.55 7.33,13.8C5.5,11.24 5,9.31 5,8.92C5,8.7 5.08,8.5 5.5,8.5Z' })
	  );
	};
	
	var VkIcon = function VkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20.8,7.74C20.93,7.32 20.8,7 20.18,7H18.16C17.64,7 17.41,7.27 17.28,7.57C17.28,7.57 16.25,10.08 14.79,11.72C14.31,12.19 14.1,12.34 13.84,12.34C13.71,12.34 13.5,12.19 13.5,11.76V7.74C13.5,7.23 13.38,7 12.95,7H9.76C9.44,7 9.25,7.24 9.25,7.47C9.25,7.95 10,8.07 10.05,9.44V12.42C10.05,13.08 9.93,13.2 9.68,13.2C9,13.2 7.32,10.67 6.33,7.79C6.13,7.23 5.94,7 5.42,7H3.39C2.82,7 2.7,7.27 2.7,7.57C2.7,8.11 3.39,10.77 5.9,14.29C7.57,16.7 9.93,18 12.08,18C13.37,18 13.53,17.71 13.53,17.21V15.39C13.53,14.82 13.65,14.7 14.06,14.7C14.36,14.7 14.87,14.85 16.07,16C17.45,17.38 17.67,18 18.45,18H20.47C21.05,18 21.34,17.71 21.18,17.14C21,16.57 20.34,15.74 19.47,14.76C19,14.21 18.29,13.61 18.07,13.3C17.77,12.92 17.86,12.75 18.07,12.4C18.07,12.4 20.54,8.93 20.8,7.74Z' })
	  );
	};
	
	var VlcIcon = function VlcIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,1C11.58,1 11.19,1.23 11,1.75L9.88,4.88C10.36,5.4 11.28,5.5 12,5.5C12.72,5.5 13.64,5.4 14.13,4.88L13,1.75C12.82,1.25 12.42,1 12,1M8.44,8.91L7,12.91C8.07,14.27 10.26,14.5 12,14.5C13.74,14.5 15.93,14.27 17,12.91L15.56,8.91C14.76,9.83 13.24,10 12,10C10.76,10 9.24,9.83 8.44,8.91M5.44,15C4.62,15 3.76,15.65 3.53,16.44L2.06,21.56C1.84,22.35 2.3,23 3.13,23H20.88C21.7,23 22.16,22.35 21.94,21.56L20.47,16.44C20.24,15.65 19.38,15 18.56,15H17.75L18.09,15.97C18.21,16.29 18.29,16.69 18.09,16.97C16.84,18.7 14.14,19 12,19C9.86,19 7.16,18.7 5.91,16.97C5.71,16.69 5.79,16.29 5.91,15.97L6.25,15H5.44Z' })
	  );
	};
	
	var VoiceIcon = function VoiceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,5C11.21,5 13,6.79 13,9C13,11.21 11.21,13 9,13C6.79,13 5,11.21 5,9C5,6.79 6.79,5 9,5M9,15C11.67,15 17,16.34 17,19V21H1V19C1,16.34 6.33,15 9,15M16.76,5.36C18.78,7.56 18.78,10.61 16.76,12.63L15.08,10.94C15.92,9.76 15.92,8.23 15.08,7.05L16.76,5.36M20.07,2C24,6.05 23.97,12.11 20.07,16L18.44,14.37C21.21,11.19 21.21,6.65 18.44,3.63L20.07,2Z' })
	  );
	};
	
	var VoicemailIcon = function VoicemailIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.5,15C16.57,15 15,13.43 15,11.5C15,9.57 16.57,8 18.5,8C20.43,8 22,9.57 22,11.5C22,13.43 20.43,15 18.5,15M5.5,15C3.57,15 2,13.43 2,11.5C2,9.57 3.57,8 5.5,8C7.43,8 9,9.57 9,11.5C9,13.43 7.43,15 5.5,15M18.5,6C15.46,6 13,8.46 13,11.5C13,12.83 13.47,14.05 14.26,15H9.74C10.53,14.05 11,12.83 11,11.5C11,8.46 8.54,6 5.5,6C2.46,6 0,8.46 0,11.5C0,14.54 2.46,17 5.5,17H18.5C21.54,17 24,14.54 24,11.5C24,8.46 21.54,6 18.5,6Z' })
	  );
	};
	
	var VolleyballIcon = function VolleyballIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M13.6,20.35C15.96,18.04 17.69,15.08 18.5,11.76C17.84,11.62 17.18,11.54 16.5,11.5C15.56,15.11 13.41,18.22 10.5,20.37C11,20.45 11.5,20.5 12,20.5C12.55,20.5 13.08,20.45 13.6,20.35M9.23,20.04C12.23,18.07 14.5,15.05 15.46,11.5C14.71,11.55 13.97,11.65 13.27,11.81C12.18,14.89 9.97,17.44 7.13,18.97C7.77,19.42 8.5,19.78 9.23,20.04M20.5,12.37C20.16,12.23 19.81,12.11 19.46,12C18.76,14.9 17.39,17.53 15.54,19.73C18.36,18.44 20.35,15.64 20.5,12.37M3.56,11.04C3.5,11.35 3.5,11.68 3.5,12C3.5,14.5 4.57,16.73 6.27,18.28C6.86,18 7.41,17.66 7.94,17.29C6.08,15.54 4.58,13.41 3.56,11.04M5.33,6.74C4.73,7.5 4.26,8.35 3.95,9.28C4.92,12.13 6.58,14.66 8.74,16.67C9.25,16.24 9.72,15.77 10.15,15.26C7.74,13.03 6,10.08 5.33,6.74M8.04,4.5C7.36,4.85 6.73,5.3 6.18,5.82C6.71,9.21 8.37,12.23 10.77,14.47C11.17,13.91 11.5,13.32 11.82,12.7C9.68,10.56 8.28,7.69 8.04,4.5M19.96,9.03C18.7,8.68 17.37,8.5 16,8.5C14.1,8.5 12.28,8.85 10.61,9.5C10.96,10.1 11.35,10.67 11.8,11.2C13.12,10.75 14.53,10.5 16,10.5C17.57,10.5 19.08,10.78 20.47,11.29C20.4,10.5 20.23,9.74 19.96,9.03M17.54,5.57C17.03,5.5 16.5,5.5 16,5.5C13.69,5.5 11.47,5.94 9.44,6.73C9.62,7.38 9.86,8 10.14,8.61C11.96,7.89 13.93,7.5 16,7.5C17.18,7.5 18.32,7.63 19.42,7.87C18.93,7 18.29,6.21 17.54,5.57M16,4.5C14.79,3.87 13.44,3.5 12,3.5C10.95,3.5 9.94,3.7 9,4.05C9.04,4.63 9.11,5.2 9.21,5.75C11.31,4.95 13.6,4.5 16,4.5Z' })
	  );
	};
	
	var VolumeHighIcon = function VolumeHighIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,3.23V5.29C16.89,6.15 19,8.83 19,12C19,15.17 16.89,17.84 14,18.7V20.77C18,19.86 21,16.28 21,12C21,7.72 18,4.14 14,3.23M16.5,12C16.5,10.23 15.5,8.71 14,7.97V16C15.5,15.29 16.5,13.76 16.5,12M3,9V15H7L12,20V4L7,9H3Z' })
	  );
	};
	
	var VolumeLowIcon = function VolumeLowIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M7,9V15H11L16,20V4L11,9H7Z' })
	  );
	};
	
	var VolumeMediumIcon = function VolumeMediumIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,9V15H9L14,20V4L9,9M18.5,12C18.5,10.23 17.5,8.71 16,7.97V16C17.5,15.29 18.5,13.76 18.5,12Z' })
	  );
	};
	
	var VolumeMinusIcon = function VolumeMinusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,9H7L12,4V20L7,15H3V9M14,11H22V13H14V11Z' })
	  );
	};
	
	var VolumeMuteIcon = function VolumeMuteIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,9H7L12,4V20L7,15H3V9M16.59,12L14,9.41L15.41,8L18,10.59L20.59,8L22,9.41L19.41,12L22,14.59L20.59,16L18,13.41L15.41,16L14,14.59L16.59,12Z' })
	  );
	};
	
	var VolumeOffIcon = function VolumeOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,4L9.91,6.09L12,8.18M4.27,3L3,4.27L7.73,9H3V15H7L12,20V13.27L16.25,17.53C15.58,18.04 14.83,18.46 14,18.7V20.77C15.38,20.45 16.63,19.82 17.68,18.96L19.73,21L21,19.73L12,10.73M19,12C19,12.94 18.8,13.82 18.46,14.64L19.97,16.15C20.62,14.91 21,13.5 21,12C21,7.72 18,4.14 14,3.23V5.29C16.89,6.15 19,8.83 19,12M16.5,12C16.5,10.23 15.5,8.71 14,7.97V10.18L16.45,12.63C16.5,12.43 16.5,12.21 16.5,12Z' })
	  );
	};
	
	var VolumePlusIcon = function VolumePlusIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,9H7L12,4V20L7,15H3V9M14,11H17V8H19V11H22V13H19V16H17V13H14V11Z' })
	  );
	};
	
	var VpnIcon = function VpnIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,5H15L12,8L9,5M10.5,14.66C10.2,15 10,15.5 10,16C10,17.1 10.9,18 12,18C13.1,18 14,17.1 14,16C14,15.45 13.78,14.95 13.41,14.59L14.83,13.17C15.55,13.9 16,14.9 16,16C16,18.21 14.21,20 12,20C9.79,20 8,18.21 8,16C8,14.93 8.42,13.96 9.1,13.25L9.09,13.24L16.17,6.17V6.17C16.89,5.45 17.89,5 19,5C21.21,5 23,6.79 23,9C23,11.21 21.21,13 19,13C17.9,13 16.9,12.55 16.17,11.83L17.59,10.41C17.95,10.78 18.45,11 19,11C20.1,11 21,10.1 21,9C21,7.9 20.1,7 19,7C18.45,7 17.95,7.22 17.59,7.59L10.5,14.66M6.41,7.59C6.05,7.22 5.55,7 5,7C3.9,7 3,7.9 3,9C3,10.1 3.9,11 5,11C5.55,11 6.05,10.78 6.41,10.41L7.83,11.83C7.1,12.55 6.1,13 5,13C2.79,13 1,11.21 1,9C1,6.79 2.79,5 5,5C6.11,5 7.11,5.45 7.83,6.17V6.17L10.59,8.93L9.17,10.35L6.41,7.59Z' })
	  );
	};
	
	var VuejsIcon = function VuejsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,3H5.5L12,15L18.5,3H22L12,21L2,3M6.5,3H9.5L12,7.58L14.5,3H17.5L12,13.08L6.5,3Z' })
	  );
	};
	
	var WalkIcon = function WalkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.12,10H19V8.2H15.38L13.38,4.87C13.08,4.37 12.54,4.03 11.92,4.03C11.74,4.03 11.58,4.06 11.42,4.11L6,5.8V11H7.8V7.33L9.91,6.67L6,22H7.8L10.67,13.89L13,17V22H14.8V15.59L12.31,11.05L13.04,8.18M14,3.8C15,3.8 15.8,3 15.8,2C15.8,1 15,0.2 14,0.2C13,0.2 12.2,1 12.2,2C12.2,3 13,3.8 14,3.8Z' })
	  );
	};
	
	var WallSconceFlatIcon = function WallSconceFlatIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M5,5V11H19V5H5M5.27,13.32L3.5,15.09L4.91,16.5L6.68,14.73L5.27,13.32M18.73,13.32L17.32,14.73L19.09,16.5L20.5,15.09L18.73,13.32M11,16V19H13V16H11Z' })
	  );
	};
	
	var WallSconceVariantIcon = function WallSconceVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,4.5V7.5H13V4.5H11M4.91,7L3.5,8.41L5.27,10.18L6.68,8.77L4.91,7M19.09,7L17.32,8.77L18.73,10.18L20.5,8.41L19.09,7M4,11.5C4,14.36 5.5,17 8,18.43C10.5,19.86 13.5,19.86 16,18.43C18.5,17 20,14.36 20,11.5H12L4,11.5Z' })
	  );
	};
	
	var WallSconceIcon = function WallSconceIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M11,4L7,13H19L15,4H11M4,14V22H6V19H14V14H12V17H6V14H4Z' })
	  );
	};
	
	var WallIcon = function WallIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,16H12V21H3V16M2,10H8V15H2V10M9,10H15V15H9V10M16,10H22V15H16V10M13,16H21V21H13V16M3,4H11V9H3V4M12,4H21V9H12V4Z' })
	  );
	};
	
	var WalletGiftcardIcon = function WalletGiftcardIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,14H4V8H9.08L7,10.83L8.62,12L11,8.76L12,7.4L13,8.76L15.38,12L17,10.83L14.92,8H20M20,19H4V17H20M9,4C9.55,4 10,4.45 10,5C10,5.55 9.55,6 9,6C8.45,6 8,5.55 8,5C8,4.45 8.45,4 9,4M15,4C15.55,4 16,4.45 16,5C16,5.55 15.55,6 15,6C14.45,6 14,5.55 14,5C14,4.45 14.45,4 15,4M20,6H17.82C17.93,5.69 18,5.35 18,5C18,3.34 16.66,2 15,2C13.95,2 13.04,2.54 12.5,3.35L12,4L11.5,3.34C10.96,2.54 10.05,2 9,2C7.34,2 6,3.34 6,5C6,5.35 6.07,5.69 6.18,6H4C2.89,6 2,6.89 2,8V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V8C22,6.89 21.11,6 20,6Z' })
	  );
	};
	
	var WalletMembershipIcon = function WalletMembershipIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,10H4V4H20M20,15H4V13H20M20,2H4C2.89,2 2,2.89 2,4V15C2,16.11 2.89,17 4,17H8V22L12,20L16,22V17H20C21.11,17 22,16.11 22,15V4C22,2.89 21.11,2 20,2Z' })
	  );
	};
	
	var WalletTravelIcon = function WalletTravelIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,14H4V8H7V10H9V8H15V10H17V8H20M20,19H4V17H20M9,4H15V6H9M20,6H17V4C17,2.89 16.11,2 15,2H9C7.89,2 7,2.89 7,4V6H4C2.89,6 2,6.89 2,8V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V8C22,6.89 21.11,6 20,6Z' })
	  );
	};
	
	var WalletIcon = function WalletIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,18V19C21,20.1 20.1,21 19,21H5C3.89,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3H19C20.1,3 21,3.9 21,5V6H12C10.89,6 10,6.9 10,8V16C10,17.1 10.9,18 12,18M12,16H22V8H12M16,13.5C15.17,13.5 14.5,12.83 14.5,12C14.5,11.17 15.17,10.5 16,10.5C16.83,10.5 17.5,11.17 17.5,12C17.5,12.83 16.83,13.5 16,13.5Z' })
	  );
	};
	
	var WanIcon = function WanIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C7.58,2 4,5.58 4,10C4,14.03 7,17.42 11,17.93V19H10C9.45,19 9,19.45 9,20H2V22H9C9,22.55 9.45,23 10,23H14C14.55,23 15,22.55 15,22H22V20H15C15,19.45 14.55,19 14,19H13V17.93C17,17.43 20,14.03 20,10C20,5.58 16.42,2 12,2M12,4C12,4 12.74,5.28 13.26,7H10.74C11.26,5.28 12,4 12,4M9.77,4.43C9.5,4.93 9.09,5.84 8.74,7H6.81C7.5,5.84 8.5,4.93 9.77,4.43M14.23,4.44C15.5,4.94 16.5,5.84 17.19,7H15.26C14.91,5.84 14.5,4.93 14.23,4.44M6.09,9H8.32C8.28,9.33 8.25,9.66 8.25,10C8.25,10.34 8.28,10.67 8.32,11H6.09C6.03,10.67 6,10.34 6,10C6,9.66 6.03,9.33 6.09,9M10.32,9H13.68C13.72,9.33 13.75,9.66 13.75,10C13.75,10.34 13.72,10.67 13.68,11H10.32C10.28,10.67 10.25,10.34 10.25,10C10.25,9.66 10.28,9.33 10.32,9M15.68,9H17.91C17.97,9.33 18,9.66 18,10C18,10.34 17.97,10.67 17.91,11H15.68C15.72,10.67 15.75,10.34 15.75,10C15.75,9.66 15.72,9.33 15.68,9M6.81,13H8.74C9.09,14.16 9.5,15.07 9.77,15.56C8.5,15.06 7.5,14.16 6.81,13M10.74,13H13.26C12.74,14.72 12,16 12,16C12,16 11.26,14.72 10.74,13M15.26,13H17.19C16.5,14.16 15.5,15.07 14.23,15.57C14.5,15.07 14.91,14.16 15.26,13Z' })
	  );
	};
	
	var WashingMachineIcon = function WashingMachineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.83,11.17C16.39,12.73 16.39,15.27 14.83,16.83C13.27,18.39 10.73,18.39 9.17,16.83L14.83,11.17M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2M7,4C6.45,4 6,4.45 6,5C6,5.55 6.45,6 7,6C7.55,6 8,5.55 8,5C8,4.45 7.55,4 7,4M10,4C9.45,4 9,4.45 9,5C9,5.55 9.45,6 10,6C10.55,6 11,5.55 11,5C11,4.45 10.55,4 10,4M12,8C8.69,8 6,10.69 6,14C6,17.31 8.69,20 12,20C15.31,20 18,17.31 18,14C18,10.69 15.31,8 12,8Z' })
	  );
	};
	
	var WatchExportVariantIcon = function WatchExportVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,11H19L16.5,8.5L17.92,7.08L22.84,12L17.92,16.92L16.5,15.5L19,13H14V11M8,0H16L16.83,5H17C17.28,5 17.54,5.06 17.78,5.16L15.94,7H7V17H15.94L17.78,18.84C17.54,18.94 17.28,19 17,19H16.83L16,24H8L7.17,19H7C5.9,19 5,18.1 5,17V7C5,5.89 5.9,5 7,5H7.17L8,0Z' })
	  );
	};
	
	var WatchExportIcon = function WatchExportIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,11H19L16.5,8.5L17.92,7.08L22.84,12L17.92,16.92L16.5,15.5L19,13H14V11M12,18C8.69,18 6,15.31 6,12C6,8.69 8.69,6 12,6C13.4,6 14.69,6.5 15.71,7.29L17.13,5.87L16.95,5.73L16,0H8L7.05,5.73C5.19,7.19 4,9.46 4,12C4,14.55 5.19,16.81 7.05,18.27L8,24H16L16.95,18.27L17.13,18.13L15.71,16.71C14.69,17.5 13.4,18 12,18Z' })
	  );
	};
	
	var WatchImportVariantIcon = function WatchImportVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M1,11H6L3.5,8.5L4.92,7.08L9.84,12L4.92,16.92L3.5,15.5L6,13H1V11M8,0H16L16.83,5H17C18.1,5 19,5.9 19,7V17C19,18.11 18.1,19 17,19H16.83L16,24H8L7.17,19H7C6.46,19 6,18.79 5.62,18.44L7.06,17H17V7H7.06L5.62,5.56C6,5.21 6.46,5 7,5H7.17L8,0Z' })
	  );
	};
	
	var WatchImportIcon = function WatchImportIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,11H7L4.5,8.5L5.92,7.08L10.84,12L5.92,16.92L4.5,15.5L7,13H2V11M12,18C15.31,18 18,15.31 18,12C18,8.69 15.31,6 12,6C10.6,6 9.31,6.5 8.29,7.29L6.87,5.87L7.05,5.73L8,0H16L16.95,5.73C18.81,7.19 20,9.45 20,12C20,14.54 18.81,16.81 16.95,18.27L16,24H8L7.05,18.27L6.87,18.13L8.29,16.71C9.31,17.5 10.6,18 12,18Z' })
	  );
	};
	
	var WatchVariantIcon = function WatchVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8,0L7.17,5H7C5.9,5 5,5.9 5,7V17C5,18.11 5.9,19 7,19H7.17L8,24H16L16.83,19H17C18.1,19 19,18.1 19,17V7C19,5.89 18.1,5 17,5H16.83L16,0H8M7,7H17V17H7V7Z' })
	  );
	};
	
	var WatchVibrateIcon = function WatchVibrateIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,17V7H5V17H3M19,17V7H21V17H19M22,9H24V15H22V9M0,15V9H2V15H0M17.96,11.97C17.96,13.87 17.07,15.57 15.68,16.67L14.97,20.95H9L8.27,16.67C6.88,15.57 6,13.87 6,11.97C6,10.07 6.88,8.37 8.27,7.28L9,3H14.97L15.68,7.28C17.07,8.37 17.96,10.07 17.96,11.97M7.5,11.97C7.5,14.45 9.5,16.46 11.97,16.46C14.46,16.46 16.46,14.46 16.46,11.97C16.46,9.5 14.45,7.5 11.97,7.5C9.5,7.5 7.5,9.5 7.5,11.97Z' })
	  );
	};
	
	var WatchIcon = function WatchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,12C6,8.69 8.69,6 12,6C15.31,6 18,8.69 18,12C18,15.31 15.31,18 12,18C8.69,18 6,15.31 6,12M20,12C20,9.45 18.81,7.19 16.95,5.73L16,0H8L7.05,5.73C5.19,7.19 4,9.45 4,12C4,14.54 5.19,16.81 7.05,18.27L8,24H16L16.95,18.27C18.81,16.81 20,14.54 20,12Z' })
	  );
	};
	
	var WaterOffIcon = function WaterOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.12,17.12L12.5,12.5L5.27,5.27L4,6.55L7.32,9.87C6.55,11.32 6,12.79 6,14C6,17.31 8.69,20 12,20C13.5,20 14.9,19.43 15.96,18.5L18.59,21.13L19.86,19.86L17.12,17.12M18,14C18,10 12,3.2 12,3.2C12,3.2 10.67,4.71 9.27,6.72L17.86,15.31C17.95,14.89 18,14.45 18,14Z' })
	  );
	};
	
	var WaterPercentIcon = function WaterPercentIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3.25C12,3.25 6,10 6,14C6,17.32 8.69,20 12,20C15.31,20 18,17.31 18,14C18,10 12,3.25 12,3.25M14.47,9.97L15.53,11.03L9.53,17.03L8.47,15.97M9.75,10C10.44,10 11,10.56 11,11.25C11,11.94 10.44,12.5 9.75,12.5C9.06,12.5 8.5,11.94 8.5,11.25C8.5,10.56 9.06,10 9.75,10M14.25,14.5C14.94,14.5 15.5,15.06 15.5,15.75C15.5,16.44 14.94,17 14.25,17C13.56,17 13,16.44 13,15.75C13,15.06 13.56,14.5 14.25,14.5Z' })
	  );
	};
	
	var WaterPumpIcon = function WaterPumpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M19,14.5C19,14.5 21,16.67 21,18C21,19.1 20.1,20 19,20C17.9,20 17,19.1 17,18C17,16.67 19,14.5 19,14.5M5,18V9C3.9,9 3,8.1 3,7C3,5.9 3.9,5 5,5V4C5,2.9 5.9,2 7,2H9C10.1,2 11,2.9 11,4V5H19C20.1,5 21,5.9 21,7V9L21,11C21.55,11 22,11.45 22,12C22,12.55 21.55,13 21,13H17C16.45,13 16,12.55 16,12C16,11.45 16.45,11 17,11V9H11V18H12C13.1,18 14,18.9 14,20V22H2V20C2,18.9 2.9,18 4,18H5Z' })
	  );
	};
	
	var WaterIcon = function WaterIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,20C8.69,20 6,17.31 6,14C6,10 12,3.25 12,3.25C12,3.25 18,10 18,14C18,17.31 15.31,20 12,20Z' })
	  );
	};
	
	var WatermarkIcon = function WatermarkIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,3H3C1.9,3 1,3.9 1,5V19C1,20.1 1.9,21 3,21H21C22.1,21 23,20.1 23,19V5C23,3.9 22.1,3 21,3M21,19H12V13H21V19Z' })
	  );
	};
	
	var WavesIcon = function WavesIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,18C4.22,17 6.44,16 8.67,16C10.89,16 13.11,18 15.33,18C17.56,18 19.78,16 22,16V19C19.78,19 17.56,21 15.33,21C13.11,21 10.89,19 8.67,19C6.44,19 4.22,20 2,21V18M2,12C4.22,11 6.44,10 8.67,10C10.89,10 13.11,12 15.33,12C17.56,12 19.78,10 22,10V13C19.78,13 17.56,15 15.33,15C13.11,15 10.89,13 8.67,13C6.44,13 4.22,14 2,15V12M2,6C4.22,5 6.44,4 8.67,4C10.89,4 13.11,6 15.33,6C17.56,6 19.78,4 22,4V7C19.78,7 17.56,9 15.33,9C13.11,9 10.89,7 8.67,7C6.44,7 4.22,8 2,9V6Z' })
	  );
	};
	
	var WeatherCloudyIcon = function WeatherCloudyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,19C3.24,19 1,16.76 1,14C1,11.24 3.24,9 6,9C7,6.65 9.3,5 12,5C15.43,5 18.24,7.66 18.5,11.03L19,11C21.21,11 23,12.79 23,15C23,17.21 21.21,19 19,19H6M19,13H17V12C17,9.24 14.76,7 12,7C9.5,7 7.45,8.82 7.06,11.19C6.73,11.07 6.37,11 6,11C4.34,11 3,12.34 3,14C3,15.66 4.34,17 6,17H19C20.1,17 21,16.1 21,15C21,13.9 20.1,13 19,13Z' })
	  );
	};
	
	var WeatherFogIcon = function WeatherFogIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,15H13C13.55,15 14,15.45 14,16C14,16.55 13.55,17 13,17H3C2.45,17 2,16.55 2,16C2,15.45 2.45,15 3,15M16,15H21C21.55,15 22,15.45 22,16C22,16.55 21.55,17 21,17H16C15.45,17 15,16.55 15,16C15,15.45 15.45,15 16,15M1,12C1,9.24 3.24,7 6,7C7,4.65 9.3,3 12,3C15.43,3 18.24,5.66 18.5,9.03L19,9C21.19,9 22.97,10.76 23,13H21C21,11.9 20.1,11 19,11H17V10C17,7.24 14.76,5 12,5C9.5,5 7.45,6.82 7.06,9.19C6.73,9.07 6.37,9 6,9C4.34,9 3,10.34 3,12C3,12.35 3.06,12.69 3.17,13H1.1L1,12M3,19H5C5.55,19 6,19.45 6,20C6,20.55 5.55,21 5,21H3C2.45,21 2,20.55 2,20C2,19.45 2.45,19 3,19M8,19H21C21.55,19 22,19.45 22,20C22,20.55 21.55,21 21,21H8C7.45,21 7,20.55 7,20C7,19.45 7.45,19 8,19Z' })
	  );
	};
	
	var WeatherHailIcon = function WeatherHailIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,14C6.55,14 7,14.45 7,15C7,15.55 6.55,16 6,16C3.24,16 1,13.76 1,11C1,8.24 3.24,6 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8C21.21,8 23,9.79 23,12C23,14.21 21.21,16 19,16H18C17.45,16 17,15.55 17,15C17,14.45 17.45,14 18,14H19C20.1,14 21,13.1 21,12C21,10.9 20.1,10 19,10H17V9C17,6.24 14.76,4 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8C4.34,8 3,9.34 3,11C3,12.66 4.34,14 6,14M10,18C11.1,18 12,18.9 12,20C12,21.1 11.1,22 10,22C8.9,22 8,21.1 8,20C8,18.9 8.9,18 10,18M14.5,16C15.33,16 16,16.67 16,17.5C16,18.33 15.33,19 14.5,19C13.67,19 13,18.33 13,17.5C13,16.67 13.67,16 14.5,16M10.5,12C11.33,12 12,12.67 12,13.5C12,14.33 11.33,15 10.5,15C9.67,15 9,14.33 9,13.5C9,12.67 9.67,12 10.5,12Z' })
	  );
	};
	
	var WeatherHurricaneIcon = function WeatherHurricaneIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M15,6.79C16.86,7.86 18,9.85 18,12C18,22 6,22 6,22C7.25,21.06 8.38,19.95 9.34,18.71C9.38,18.66 9.41,18.61 9.44,18.55C9.69,18.06 9.5,17.46 9,17.21C7.14,16.14 6,14.15 6,12C6,2 18,2 18,2C16.75,2.94 15.62,4.05 14.66,5.29C14.62,5.34 14.59,5.39 14.56,5.45C14.31,5.94 14.5,6.54 15,6.79M12,14C13.1,14 14,13.1 14,12C14,10.9 13.1,10 12,10C10.9,10 10,10.9 10,12C10,13.1 10.9,14 12,14Z' })
	  );
	};
	
	var WeatherLightningRainyIcon = function WeatherLightningRainyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.5,13.59C5,13.87 5.14,14.5 4.87,14.96C4.59,15.44 4,15.6 3.5,15.33V15.33C2,14.47 1,12.85 1,11C1,8.24 3.24,6 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8C21.21,8 23,9.79 23,12C23,14.21 21.21,16 19,16C18.45,16 18,15.55 18,15C18,14.45 18.45,14 19,14C20.1,14 21,13.1 21,12C21,10.9 20.1,10 19,10H17V9C17,6.24 14.76,4 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8C4.34,8 3,9.34 3,11C3,12.11 3.6,13.08 4.5,13.6V13.59M9.5,11H12.5L10.5,15H12.5L8.75,22L9.5,17H7L9.5,11M17.5,18.67C17.5,19.96 16.5,21 15.25,21C14,21 13,19.96 13,18.67C13,17.12 15.25,14.5 15.25,14.5C15.25,14.5 17.5,17.12 17.5,18.67Z' })
	  );
	};
	
	var WeatherLightningIcon = function WeatherLightningIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,16C3.24,16 1,13.76 1,11C1,8.24 3.24,6 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8C21.21,8 23,9.79 23,12C23,14.21 21.21,16 19,16H18C17.45,16 17,15.55 17,15C17,14.45 17.45,14 18,14H19C20.1,14 21,13.1 21,12C21,10.9 20.1,10 19,10H17V9C17,6.24 14.76,4 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8C4.34,8 3,9.34 3,11C3,12.66 4.34,14 6,14H7C7.55,14 8,14.45 8,15C8,15.55 7.55,16 7,16H6M12,11H15L13,15H15L11.25,22L12,17H9.5L12,11Z' })
	  );
	};
	
	var WeatherNightIcon = function WeatherNightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.75,4.09L15.22,6.03L16.13,9.09L13.5,7.28L10.87,9.09L11.78,6.03L9.25,4.09L12.44,4L13.5,1L14.56,4L17.75,4.09M21.25,11L19.61,12.25L20.2,14.23L18.5,13.06L16.8,14.23L17.39,12.25L15.75,11L17.81,10.95L18.5,9L19.19,10.95L21.25,11M18.97,15.95C19.8,15.87 20.69,17.05 20.16,17.8C19.84,18.25 19.5,18.67 19.08,19.07C15.17,23 8.84,23 4.94,19.07C1.03,15.17 1.03,8.83 4.94,4.93C5.34,4.53 5.76,4.17 6.21,3.85C6.96,3.32 8.14,4.21 8.06,5.04C7.79,7.9 8.75,10.87 10.95,13.06C13.14,15.26 16.1,16.22 18.97,15.95M17.33,17.97C14.5,17.81 11.7,16.64 9.53,14.5C7.36,12.31 6.2,9.5 6.04,6.68C3.23,9.82 3.34,14.64 6.35,17.66C9.37,20.67 14.19,20.78 17.33,17.97Z' })
	  );
	};
	
	var WeatherPartlycloudyIcon = function WeatherPartlycloudyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.74,5.47C15.1,6.5 16.35,9.03 15.92,11.46C17.19,12.56 18,14.19 18,16V16.17C18.31,16.06 18.65,16 19,16C20.66,16 22,17.34 22,19C22,20.66 20.66,22 19,22H6C3.79,22 2,20.21 2,18C2,15.79 3.79,14 6,14H6.27C5,12.45 4.6,10.24 5.5,8.26C6.72,5.5 9.97,4.24 12.74,5.47M11.93,7.3C10.16,6.5 8.09,7.31 7.31,9.07C6.85,10.09 6.93,11.22 7.41,12.13C8.5,10.83 10.16,10 12,10C12.7,10 13.38,10.12 14,10.34C13.94,9.06 13.18,7.86 11.93,7.3M13.55,3.64C13,3.4 12.45,3.23 11.88,3.12L14.37,1.82L15.27,4.71C14.76,4.29 14.19,3.93 13.55,3.64M6.09,4.44C5.6,4.79 5.17,5.19 4.8,5.63L4.91,2.82L7.87,3.5C7.25,3.71 6.65,4.03 6.09,4.44M18,9.71C17.91,9.12 17.78,8.55 17.59,8L19.97,9.5L17.92,11.73C18.03,11.08 18.05,10.4 18,9.71M3.04,11.3C3.11,11.9 3.24,12.47 3.43,13L1.06,11.5L3.1,9.28C3,9.93 2.97,10.61 3.04,11.3M19,18H16V16C16,13.79 14.21,12 12,12C9.79,12 8,13.79 8,16H6C4.9,16 4,16.9 4,18C4,19.1 4.9,20 6,20H19C19.55,20 20,19.55 20,19C20,18.45 19.55,18 19,18Z' })
	  );
	};
	
	var WeatherPouringIcon = function WeatherPouringIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9,12C9.53,12.14 9.85,12.69 9.71,13.22L8.41,18.05C8.27,18.59 7.72,18.9 7.19,18.76C6.65,18.62 6.34,18.07 6.5,17.54L7.78,12.71C7.92,12.17 8.47,11.86 9,12M13,12C13.53,12.14 13.85,12.69 13.71,13.22L11.64,20.95C11.5,21.5 10.95,21.8 10.41,21.66C9.88,21.5 9.56,20.97 9.7,20.43L11.78,12.71C11.92,12.17 12.47,11.86 13,12M17,12C17.53,12.14 17.85,12.69 17.71,13.22L16.41,18.05C16.27,18.59 15.72,18.9 15.19,18.76C14.65,18.62 14.34,18.07 14.5,17.54L15.78,12.71C15.92,12.17 16.47,11.86 17,12M17,10V9C17,6.24 14.76,4 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8C4.34,8 3,9.34 3,11C3,12.11 3.6,13.08 4.5,13.6V13.59C5,13.87 5.14,14.5 4.87,14.96C4.59,15.43 4,15.6 3.5,15.32V15.33C2,14.47 1,12.85 1,11C1,8.24 3.24,6 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8C21.21,8 23,9.79 23,12C23,13.5 22.2,14.77 21,15.46V15.46C20.5,15.73 19.91,15.57 19.63,15.09C19.36,14.61 19.5,14 20,13.72V13.73C20.6,13.39 21,12.74 21,12C21,10.9 20.1,10 19,10H17Z' })
	  );
	};
	
	var WeatherRainyIcon = function WeatherRainyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,14C6.55,14 7,14.45 7,15C7,15.55 6.55,16 6,16C3.24,16 1,13.76 1,11C1,8.24 3.24,6 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8C21.21,8 23,9.79 23,12C23,14.21 21.21,16 19,16H18C17.45,16 17,15.55 17,15C17,14.45 17.45,14 18,14H19C20.1,14 21,13.1 21,12C21,10.9 20.1,10 19,10H17V9C17,6.24 14.76,4 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8C4.34,8 3,9.34 3,11C3,12.66 4.34,14 6,14M14.83,15.67C16.39,17.23 16.39,19.5 14.83,21.08C14.05,21.86 13,22 12,22C11,22 9.95,21.86 9.17,21.08C7.61,19.5 7.61,17.23 9.17,15.67L12,11L14.83,15.67M13.41,16.69L12,14.25L10.59,16.69C9.8,17.5 9.8,18.7 10.59,19.5C11,19.93 11.5,20 12,20C12.5,20 13,19.93 13.41,19.5C14.2,18.7 14.2,17.5 13.41,16.69Z' })
	  );
	};
	
	var WeatherSnowyRainyIcon = function WeatherSnowyRainyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.5,18.67C18.5,19.96 17.5,21 16.25,21C15,21 14,19.96 14,18.67C14,17.12 16.25,14.5 16.25,14.5C16.25,14.5 18.5,17.12 18.5,18.67M4,17.36C3.86,16.82 4.18,16.25 4.73,16.11L7,15.5L5.33,13.86C4.93,13.46 4.93,12.81 5.33,12.4C5.73,12 6.4,12 6.79,12.4L8.45,14.05L9.04,11.8C9.18,11.24 9.75,10.92 10.29,11.07C10.85,11.21 11.17,11.78 11,12.33L10.42,14.58L12.67,14C13.22,13.83 13.79,14.15 13.93,14.71C14.08,15.25 13.76,15.82 13.2,15.96L10.95,16.55L12.6,18.21C13,18.6 13,19.27 12.6,19.67C12.2,20.07 11.54,20.07 11.15,19.67L9.5,18L8.89,20.27C8.75,20.83 8.18,21.14 7.64,21C7.08,20.86 6.77,20.29 6.91,19.74L7.5,17.5L5.26,18.09C4.71,18.23 4.14,17.92 4,17.36M1,11C1,8.24 3.24,6 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8C21.21,8 23,9.79 23,12C23,14.21 21.21,16 19,16C18.45,16 18,15.55 18,15C18,14.45 18.45,14 19,14C20.1,14 21,13.1 21,12C21,10.9 20.1,10 19,10H17V9C17,6.24 14.76,4 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8C4.34,8 3,9.34 3,11C3,11.85 3.35,12.61 3.91,13.16C4.27,13.55 4.26,14.16 3.88,14.54C3.5,14.93 2.85,14.93 2.47,14.54C1.56,13.63 1,12.38 1,11Z' })
	  );
	};
	
	var WeatherSnowyIcon = function WeatherSnowyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,14C6.55,14 7,14.45 7,15C7,15.55 6.55,16 6,16C3.24,16 1,13.76 1,11C1,8.24 3.24,6 6,6C7,3.65 9.3,2 12,2C15.43,2 18.24,4.66 18.5,8.03L19,8C21.21,8 23,9.79 23,12C23,14.21 21.21,16 19,16H18C17.45,16 17,15.55 17,15C17,14.45 17.45,14 18,14H19C20.1,14 21,13.1 21,12C21,10.9 20.1,10 19,10H17V9C17,6.24 14.76,4 12,4C9.5,4 7.45,5.82 7.06,8.19C6.73,8.07 6.37,8 6,8C4.34,8 3,9.34 3,11C3,12.66 4.34,14 6,14M7.88,18.07L10.07,17.5L8.46,15.88C8.07,15.5 8.07,14.86 8.46,14.46C8.85,14.07 9.5,14.07 9.88,14.46L11.5,16.07L12.07,13.88C12.21,13.34 12.76,13.03 13.29,13.17C13.83,13.31 14.14,13.86 14,14.4L13.41,16.59L15.6,16C16.14,15.86 16.69,16.17 16.83,16.71C16.97,17.24 16.66,17.79 16.12,17.93L13.93,18.5L15.54,20.12C15.93,20.5 15.93,21.15 15.54,21.54C15.15,21.93 14.5,21.93 14.12,21.54L12.5,19.93L11.93,22.12C11.79,22.66 11.24,22.97 10.71,22.83C10.17,22.69 9.86,22.14 10,21.6L10.59,19.41L8.4,20C7.86,20.14 7.31,19.83 7.17,19.29C7.03,18.76 7.34,18.21 7.88,18.07Z' })
	  );
	};
	
	var WeatherSunnyIcon = function WeatherSunnyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M3.36,17L5.12,13.23C5.26,14 5.53,14.78 5.95,15.5C6.37,16.24 6.91,16.86 7.5,17.37L3.36,17M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7M20.64,17L16.5,17.36C17.09,16.85 17.62,16.22 18.04,15.5C18.46,14.77 18.73,14 18.87,13.21L20.64,17M12,22L9.59,18.56C10.33,18.83 11.14,19 12,19C12.82,19 13.63,18.83 14.37,18.56L12,22Z' })
	  );
	};
	
	var WeatherSunsetDownIcon = function WeatherSunsetDownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,12H7C7,9.24 9.24,7 12,7C14.76,7 17,9.24 17,12H21C21.55,12 22,12.45 22,13C22,13.55 21.55,14 21,14H3C2.45,14 2,13.55 2,13C2,12.45 2.45,12 3,12M15,12C15,10.34 13.66,9 12,9C10.34,9 9,10.34 9,12H15M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7M12.71,20.71L15.82,17.6C16.21,17.21 16.21,16.57 15.82,16.18C15.43,15.79 14.8,15.79 14.41,16.18L12,18.59L9.59,16.18C9.2,15.79 8.57,15.79 8.18,16.18C7.79,16.57 7.79,17.21 8.18,17.6L11.29,20.71C11.5,20.9 11.74,21 12,21C12.26,21 12.5,20.9 12.71,20.71Z' })
	  );
	};
	
	var WeatherSunsetUpIcon = function WeatherSunsetUpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,12H7C7,9.24 9.24,7 12,7C14.76,7 17,9.24 17,12H21C21.55,12 22,12.45 22,13C22,13.55 21.55,14 21,14H3C2.45,14 2,13.55 2,13C2,12.45 2.45,12 3,12M15,12C15,10.34 13.66,9 12,9C10.34,9 9,10.34 9,12H15M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7M12.71,16.3L15.82,19.41C16.21,19.8 16.21,20.43 15.82,20.82C15.43,21.21 14.8,21.21 14.41,20.82L12,18.41L9.59,20.82C9.2,21.21 8.57,21.21 8.18,20.82C7.79,20.43 7.79,19.8 8.18,19.41L11.29,16.3C11.5,16.1 11.74,16 12,16C12.26,16 12.5,16.1 12.71,16.3Z' })
	  );
	};
	
	var WeatherSunsetIcon = function WeatherSunsetIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,12H7C7,9.24 9.24,7 12,7C14.76,7 17,9.24 17,12H21C21.55,12 22,12.45 22,13C22,13.55 21.55,14 21,14H3C2.45,14 2,13.55 2,13C2,12.45 2.45,12 3,12M5,16H19C19.55,16 20,16.45 20,17C20,17.55 19.55,18 19,18H5C4.45,18 4,17.55 4,17C4,16.45 4.45,16 5,16M17,20C17.55,20 18,20.45 18,21C18,21.55 17.55,22 17,22H7C6.45,22 6,21.55 6,21C6,20.45 6.45,20 7,20H17M15,12C15,10.34 13.66,9 12,9C10.34,9 9,10.34 9,12H15M12,2L14.39,5.42C13.65,5.15 12.84,5 12,5C11.16,5 10.35,5.15 9.61,5.42L12,2M3.34,7L7.5,6.65C6.9,7.16 6.36,7.78 5.94,8.5C5.5,9.24 5.25,10 5.11,10.79L3.34,7M20.65,7L18.88,10.79C18.74,10 18.47,9.23 18.05,8.5C17.63,7.78 17.1,7.15 16.5,6.64L20.65,7Z' })
	  );
	};
	
	var WeatherWindyVariantIcon = function WeatherWindyVariantIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,6L6.69,6.06C7.32,3.72 9.46,2 12,2C15.04,2 17.5,4.46 17.5,7.5L17.42,8.45C17.88,8.16 18.42,8 19,8C20.66,8 22,9.34 22,11C22,12.66 20.66,14 19,14H6C3.79,14 2,12.21 2,10C2,7.79 3.79,6 6,6M6,8C4.9,8 4,8.9 4,10C4,11.1 4.9,12 6,12H19C19.55,12 20,11.55 20,11C20,10.45 19.55,10 19,10H15.5V7.5C15.5,5.57 13.93,4 12,4C10.07,4 8.5,5.57 8.5,7.5V8H6M18,18H4C3.45,18 3,17.55 3,17C3,16.45 3.45,16 4,16H18C19.66,16 21,17.34 21,19C21,20.66 19.66,22 18,22C17.17,22 16.42,21.66 15.88,21.12C15.5,20.73 15.5,20.1 15.88,19.71C16.27,19.32 16.9,19.32 17.29,19.71C17.47,19.89 17.72,20 18,20C18.55,20 19,19.55 19,19C19,18.45 18.55,18 18,18Z' })
	  );
	};
	
	var WeatherWindyIcon = function WeatherWindyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,10C3.45,10 3,9.55 3,9C3,8.45 3.45,8 4,8H12C13.1,8 14,7.1 14,6C14,4.9 13.1,4 12,4C11.45,4 10.95,4.22 10.59,4.59C10.2,5 9.56,5 9.17,4.59C8.78,4.2 8.78,3.56 9.17,3.17C9.9,2.45 10.9,2 12,2C14.21,2 16,3.79 16,6C16,8.21 14.21,10 12,10H4M19,12C19.55,12 20,11.55 20,11C20,10.45 19.55,10 19,10C18.72,10 18.47,10.11 18.29,10.29C17.9,10.68 17.27,10.68 16.88,10.29C16.5,9.9 16.5,9.27 16.88,8.88C17.42,8.34 18.17,8 19,8C20.66,8 22,9.34 22,11C22,12.66 20.66,14 19,14H5C4.45,14 4,13.55 4,13C4,12.45 4.45,12 5,12H19M18,18H4C3.45,18 3,17.55 3,17C3,16.45 3.45,16 4,16H18C19.66,16 21,17.34 21,19C21,20.66 19.66,22 18,22C17.17,22 16.42,21.66 15.88,21.12C15.5,20.73 15.5,20.1 15.88,19.71C16.27,19.32 16.9,19.32 17.29,19.71C17.47,19.89 17.72,20 18,20C18.55,20 19,19.55 19,19C19,18.45 18.55,18 18,18Z' })
	  );
	};
	
	var WebIcon = function WebIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z' })
	  );
	};
	
	var WebcamIcon = function WebcamIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C15.87,2 19,5.13 19,9C19,12.87 15.87,16 12,16C8.13,16 5,12.87 5,9C5,5.13 8.13,2 12,2M12,4C9.24,4 7,6.24 7,9C7,11.76 9.24,14 12,14C14.76,14 17,11.76 17,9C17,6.24 14.76,4 12,4M12,6C13.66,6 15,7.34 15,9C15,10.66 13.66,12 12,12C10.34,12 9,10.66 9,9C9,7.34 10.34,6 12,6M6,22C4.9,22 4,21.1 4,20C4,19.62 4.1,19.27 4.29,18.97L6.11,15.81C7.69,17.17 9.75,18 12,18C14.25,18 16.31,17.17 17.89,15.81L19.71,18.97C19.9,19.27 20,19.62 20,20C20,21.1 19.1,22 18,22H6Z' })
	  );
	};
	
	var WebhookIcon = function WebhookIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.46,19C9,21.07 6.15,21.59 4.09,20.15C2.04,18.71 1.56,15.84 3,13.75C3.87,12.5 5.21,11.83 6.58,11.77L6.63,13.2C5.72,13.27 4.84,13.74 4.27,14.56C3.27,16 3.58,17.94 4.95,18.91C6.33,19.87 8.26,19.5 9.26,18.07C9.57,17.62 9.75,17.13 9.82,16.63V15.62L15.4,15.58L15.47,15.47C16,14.55 17.15,14.23 18.05,14.75C18.95,15.27 19.26,16.43 18.73,17.35C18.2,18.26 17.04,18.58 16.14,18.06C15.73,17.83 15.44,17.46 15.31,17.04L11.24,17.06C11.13,17.73 10.87,18.38 10.46,19M17.74,11.86C20.27,12.17 22.07,14.44 21.76,16.93C21.45,19.43 19.15,21.2 16.62,20.89C15.13,20.71 13.9,19.86 13.19,18.68L14.43,17.96C14.92,18.73 15.75,19.28 16.75,19.41C18.5,19.62 20.05,18.43 20.26,16.76C20.47,15.09 19.23,13.56 17.5,13.35C16.96,13.29 16.44,13.36 15.97,13.53L15.12,13.97L12.54,9.2H12.32C11.26,9.16 10.44,8.29 10.47,7.25C10.5,6.21 11.4,5.4 12.45,5.44C13.5,5.5 14.33,6.35 14.3,7.39C14.28,7.83 14.11,8.23 13.84,8.54L15.74,12.05C16.36,11.85 17.04,11.78 17.74,11.86M8.25,9.14C7.25,6.79 8.31,4.1 10.62,3.12C12.94,2.14 15.62,3.25 16.62,5.6C17.21,6.97 17.09,8.47 16.42,9.67L15.18,8.95C15.6,8.14 15.67,7.15 15.27,6.22C14.59,4.62 12.78,3.85 11.23,4.5C9.67,5.16 8.97,7 9.65,8.6C9.93,9.26 10.4,9.77 10.97,10.11L11.36,10.32L8.29,15.31C8.32,15.36 8.36,15.42 8.39,15.5C8.88,16.41 8.54,17.56 7.62,18.05C6.71,18.54 5.56,18.18 5.06,17.24C4.57,16.31 4.91,15.16 5.83,14.67C6.22,14.46 6.65,14.41 7.06,14.5L9.37,10.73C8.9,10.3 8.5,9.76 8.25,9.14Z' })
	  );
	};
	
	var WebpackIcon = function WebpackIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15M12,6.23L16.9,9.06L12,11.89L7.1,9.06L12,6.23M17,14.89L13,17.2V13.62L17,11.31V14.89M11,17.2L7,14.89V11.31L11,13.62V17.2Z' })
	  );
	};
	
	var WechatIcon = function WechatIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M9.5,4C5.36,4 2,6.69 2,10C2,11.89 3.08,13.56 4.78,14.66L4,17L6.5,15.5C7.39,15.81 8.37,16 9.41,16C9.15,15.37 9,14.7 9,14C9,10.69 12.13,8 16,8C16.19,8 16.38,8 16.56,8.03C15.54,5.69 12.78,4 9.5,4M6.5,6.5C7.05,6.5 7.5,6.95 7.5,7.5C7.5,8.05 7.05,8.5 6.5,8.5C5.95,8.5 5.5,8.05 5.5,7.5C5.5,6.95 5.95,6.5 6.5,6.5M11.5,6.5C12.05,6.5 12.5,6.95 12.5,7.5C12.5,8.05 12.05,8.5 11.5,8.5C10.95,8.5 10.5,8.05 10.5,7.5C10.5,6.95 10.95,6.5 11.5,6.5M16,9C12.69,9 10,11.24 10,14C10,16.76 12.69,19 16,19C16.67,19 17.31,18.92 17.91,18.75L20,20L19.38,18.13C20.95,17.22 22,15.71 22,14C22,11.24 19.31,9 16,9M14,11.5C14.55,11.5 15,11.95 15,12.5C15,13.05 14.55,13.5 14,13.5C13.45,13.5 13,13.05 13,12.5C13,11.95 13.45,11.5 14,11.5M18,11.5C18.55,11.5 19,11.95 19,12.5C19,13.05 18.55,13.5 18,13.5C17.45,13.5 17,13.05 17,12.5C17,11.95 17.45,11.5 18,11.5Z' })
	  );
	};
	
	var WeightKilogramIcon = function WeightKilogramIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C14.21,3 16,4.79 16,7C16,7.73 15.81,8.41 15.46,9H18C18.95,9 19.75,9.67 19.95,10.56C21.96,18.57 22,18.78 22,19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19C2,18.78 2.04,18.57 4.05,10.56C4.25,9.67 5.05,9 6,9H8.54C8.19,8.41 8,7.73 8,7C8,4.79 9.79,3 12,3M12,5C10.9,5 10,5.9 10,7C10,8.1 10.9,9 12,9C13.1,9 14,8.1 14,7C14,5.9 13.1,5 12,5M6,11V19H8V16.5L9,17.5V19H11V17L9,15L11,13V11H9V12.5L8,13.5V11H6M15,11C13.89,11 13,11.89 13,13V17C13,18.11 13.89,19 15,19H18V14H16V17H15V13H18V11H15Z' })
	  );
	};
	
	var WeightPoundIcon = function WeightPoundIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C14.21,3 16,4.79 16,7C16,7.73 15.81,8.41 15.46,9H18C18.95,9 19.75,9.67 19.95,10.56C21.96,18.57 22,18.78 22,19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19C2,18.78 2.04,18.57 4.05,10.56C4.25,9.67 5.05,9 6,9H8.54C8.19,8.41 8,7.73 8,7C8,4.79 9.79,3 12,3M12,5C10.9,5 10,5.9 10,7C10,8.1 10.9,9 12,9C13.1,9 14,8.1 14,7C14,5.9 13.1,5 12,5M6,11V19H11V17H8V11H6M13,11V19H16C17.11,19 18,18.11 18,17V16.5C18,15.93 17.75,15.38 17.32,15C17.75,14.62 18,14.07 18,13.5V13C18,11.89 17.11,11 16,11H13M15,13H16V14H15V13M15,16H16V17H15V16Z' })
	  );
	};
	
	var WeightIcon = function WeightIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C14.21,3 16,4.79 16,7C16,7.73 15.81,8.41 15.46,9H18C18.95,9 19.75,9.67 19.95,10.56C21.96,18.57 22,18.78 22,19C22,20.1 21.1,21 20,21H4C2.9,21 2,20.1 2,19C2,18.78 2.04,18.57 4.05,10.56C4.25,9.67 5.05,9 6,9H8.54C8.19,8.41 8,7.73 8,7C8,4.79 9.79,3 12,3M12,5C10.9,5 10,5.9 10,7C10,8.1 10.9,9 12,9C13.1,9 14,8.1 14,7C14,5.9 13.1,5 12,5Z' })
	  );
	};
	
	var WhatsappIcon = function WhatsappIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M16.75,13.96C17,14.09 17.16,14.16 17.21,14.26C17.27,14.37 17.25,14.87 17,15.44C16.8,16 15.76,16.54 15.3,16.56C14.84,16.58 14.83,16.92 12.34,15.83C9.85,14.74 8.35,12.08 8.23,11.91C8.11,11.74 7.27,10.53 7.31,9.3C7.36,8.08 8,7.5 8.26,7.26C8.5,7 8.77,6.97 8.94,7H9.41C9.56,7 9.77,6.94 9.96,7.45L10.65,9.32C10.71,9.45 10.75,9.6 10.66,9.76L10.39,10.17L10,10.59C9.88,10.71 9.74,10.84 9.88,11.09C10,11.35 10.5,12.18 11.2,12.87C12.11,13.75 12.91,14.04 13.15,14.17C13.39,14.31 13.54,14.29 13.69,14.13L14.5,13.19C14.69,12.94 14.85,13 15.08,13.08L16.75,13.96M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C10.03,22 8.2,21.43 6.65,20.45L2,22L3.55,17.35C2.57,15.8 2,13.97 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,13.72 4.54,15.31 5.46,16.61L4.5,19.5L7.39,18.54C8.69,19.46 10.28,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4Z' })
	  );
	};
	
	var WheelchairAccessibilityIcon = function WheelchairAccessibilityIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.4,11.2L14.3,11.4L16.6,8.8C16.8,8.5 16.9,8 16.8,7.5C16.7,7.2 16.6,6.9 16.3,6.7L10.9,3.5C10.5,3.2 9.9,3.3 9.5,3.6L6.8,6.1C6.3,6.6 6.2,7.3 6.7,7.8C7.1,8.3 7.9,8.3 8.4,7.9L10.4,6.1L12.3,7.2L8.1,11.5C8,11.6 8,11.7 7.9,11.7C7.4,11.9 6.9,12.1 6.5,12.4L8,13.9C8.5,13.7 9,13.5 9.5,13.5C11.4,13.5 13,15.1 13,17C13,17.6 12.9,18.1 12.6,18.5L14.1,20C14.7,19.1 15,18.1 15,17C15,15.8 14.6,14.6 13.9,13.7L17.2,13.4L17,18.2C16.9,18.9 17.4,19.4 18.1,19.5H18.2C18.8,19.5 19.3,19 19.4,18.4L19.6,12.5C19.6,12.2 19.5,11.8 19.3,11.6C19,11.3 18.7,11.2 18.4,11.2M18,5.5C19.1,5.5 20,4.6 20,3.5C20,2.4 19.1,1.5 18,1.5C16.9,1.5 16,2.4 16,3.5C16,4.6 16.9,5.5 18,5.5M12.5,21.6C11.6,22.2 10.6,22.5 9.5,22.5C6.5,22.5 4,20 4,17C4,15.9 4.3,14.9 4.9,14L6.4,15.5C6.2,16 6,16.5 6,17C6,18.9 7.6,20.5 9.5,20.5C10.1,20.5 10.6,20.4 11,20.1L12.5,21.6Z' })
	  );
	};
	
	var WhistleIcon = function WhistleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.5,9C4.91,9 2,11.91 2,15.5C2,19.09 4.91,22 8.5,22C12.09,22 15,19.09 15,15.5V13.91L22,12V9H11V11H9V9H8.5M11,2V7H9V2H11M6.35,7.28C5.68,7.44 5.04,7.68 4.43,8L2.14,4.88L3.76,3.7L6.35,7.28M17.86,4.88L16.32,7H13.85L16.24,3.7L17.86,4.88Z' })
	  );
	};
	
	var WhiteBalanceAutoIcon = function WhiteBalanceAutoIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.3,16L9.6,14H6.4L5.7,16H3.8L7,7H9L12.2,16M22,7L20.8,13.29L19.3,7H17.7L16.21,13.29L15,7H14.24C12.77,5.17 10.5,4 8,4C3.58,4 0,7.58 0,12C0,16.42 3.58,20 8,20C11.13,20 13.84,18.19 15.15,15.57L15.25,16H17L18.5,9.9L20,16H21.75L23.8,7M6.85,12.65H9.15L8,9L6.85,12.65Z' })
	  );
	};
	
	var WhiteBalanceIncandescentIcon = function WhiteBalanceIncandescentIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.24,18.15L19.04,19.95L20.45,18.53L18.66,16.74M20,12.5H23V10.5H20M15,6.31V1.5H9V6.31C7.21,7.35 6,9.28 6,11.5C6,14.81 8.69,17.5 12,17.5C15.31,17.5 18,14.81 18,11.5C18,9.28 16.79,7.35 15,6.31M4,10.5H1V12.5H4M11,22.45C11.32,22.45 13,22.45 13,22.45V19.5H11M3.55,18.53L4.96,19.95L6.76,18.15L5.34,16.74L3.55,18.53Z' })
	  );
	};
	
	var WhiteBalanceIridescentIcon = function WhiteBalanceIridescentIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.96,19.95L6.76,18.15L5.34,16.74L3.55,18.53M3.55,4.46L5.34,6.26L6.76,4.84L4.96,3.05M20.45,18.53L18.66,16.74L17.24,18.15L19.04,19.95M13,22.45V19.5H11V22.45C11.32,22.45 13,22.45 13,22.45M19.04,3.05L17.24,4.84L18.66,6.26L20.45,4.46M11,3.5H13V0.55H11M5,14.5H19V8.5H5V14.5Z' })
	  );
	};
	
	var WhiteBalanceSunnyIcon = function WhiteBalanceSunnyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.55,18.54L4.96,19.95L6.76,18.16L5.34,16.74M11,22.45C11.32,22.45 13,22.45 13,22.45V19.5H11M12,5.5C8.69,5.5 6,8.19 6,11.5C6,14.81 8.69,17.5 12,17.5C15.31,17.5 18,14.81 18,11.5C18,8.18 15.31,5.5 12,5.5M20,12.5H23V10.5H20M17.24,18.16L19.04,19.95L20.45,18.54L18.66,16.74M20.45,4.46L19.04,3.05L17.24,4.84L18.66,6.26M13,0.55H11V3.5H13M4,10.5H1V12.5H4M6.76,4.84L4.96,3.05L3.55,4.46L5.34,6.26L6.76,4.84Z' })
	  );
	};
	
	var WidgetsIcon = function WidgetsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,3H11V7.34L16.66,1.69L22.31,7.34L16.66,13H21V21H13V13H16.66L11,7.34V11H3V3M3,13H11V21H3V13Z' })
	  );
	};
	
	var WifiOffIcon = function WifiOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.28,3L1,4.27L2.47,5.74C2.04,6 1.61,6.29 1.2,6.6L3,9C3.53,8.6 4.08,8.25 4.66,7.93L6.89,10.16C6.15,10.5 5.44,10.91 4.8,11.4L6.6,13.8C7.38,13.22 8.26,12.77 9.2,12.47L11.75,15C10.5,15.07 9.34,15.5 8.4,16.2L12,21L14.46,17.73L17.74,21L19,19.72M12,3C9.85,3 7.8,3.38 5.9,4.07L8.29,6.47C9.5,6.16 10.72,6 12,6C15.38,6 18.5,7.11 21,9L22.8,6.6C19.79,4.34 16.06,3 12,3M12,9C11.62,9 11.25,9 10.88,9.05L14.07,12.25C15.29,12.53 16.43,13.07 17.4,13.8L19.2,11.4C17.2,9.89 14.7,9 12,9Z' })
	  );
	};
	
	var WifiStrength1AlertIcon = function WifiStrength1AlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C14.45,18.45 16.68,15.68 19,12.78V9.59L15.61,13.81C14.5,13.28 13.25,13 12,13C10.75,13 9.5,13.28 8.39,13.8L3.27,7.44C5.91,5.85 8.93,5 12,5C15.07,5 18.09,5.86 20.71,7.45L20.27,8H22.84C23.09,7.7 23.41,7.29 23.65,7C20.32,4.41 16.22,3 12,3M21,10V18H23V10M21,20V22H23V20' })
	  );
	};
	
	var WifiStrength1LockIcon = function WifiStrength1LockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C16.22,3 20.32,4.41 23.65,7L21.54,9.62L20.5,9.5C19.93,9.5 19.37,9.6 18.83,9.79L20.71,7.45C18.08,5.86 15.07,5 12,5C8.92,5 5.91,5.85 3.27,7.44L8.39,13.8C9.5,13.28 10.75,13 12,13C13.23,13 14.44,13.28 15.55,13.79L15.5,14.5V17.14L12,21.5L0.38,7C3.7,4.42 7.79,3 12,3M23,16C23.5,16 24,16.5 24,17V21C24,21.5 23.5,22 23,22H18C17.5,22 17,21.5 17,21V17C17,16.5 17.5,16 18,16V14.5C18,13.1 19.1,12 20.5,12C21.9,12 23,13.1 23,14.5V16M22,16V14.5C22,13.7 21.3,13 20.5,13C19.7,13 19,13.7 19,14.5V16H22Z' })
	  );
	};
	
	var WifiStrength1Icon = function WifiStrength1Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3M12,5C15.07,5 18.09,5.86 20.71,7.45L15.61,13.81C14.5,13.28 13.25,13 12,13C10.75,13 9.5,13.28 8.39,13.8L3.27,7.44C5.91,5.85 8.93,5 12,5Z' })
	  );
	};
	
	var WifiStrength2AlertIcon = function WifiStrength2AlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C14.45,18.45 16.68,15.68 19,12.78V9.59L17.5,11.43C16.26,10.74 14.37,10 12,10C9.62,10 7.74,10.75 6.5,11.43L3.27,7.44C5.91,5.85 8.93,5 12,5C15.07,5 18.09,5.86 20.71,7.45L20.27,8H22.84C23.09,7.7 23.41,7.29 23.65,7C20.32,4.41 16.22,3 12,3M21,10V18H23V10M21,20V22H23V20' })
	  );
	};
	
	var WifiStrength2LockIcon = function WifiStrength2LockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.79,3 3.7,4.42 0.38,7C4.42,12.06 7.89,16.37 12,21.5C13.23,19.97 14.29,18.66 15.5,17.14V14.5C15.5,13.24 16,12 16.84,11.1C15.62,10.53 14,10 12,10C9.62,10 7.74,10.75 6.5,11.43L3.27,7.44C5.91,5.85 8.92,5 12,5C15.07,5 18.08,5.86 20.71,7.45L18.83,9.79C19.37,9.6 19.93,9.5 20.5,9.5C20.85,9.5 21.2,9.54 21.54,9.62C22.2,8.8 23.03,7.76 23.65,7C20.32,4.41 16.22,3 12,3M20.5,12C19.1,12 18,13.1 18,14.5V16C17.5,16 17,16.5 17,17V21C17,21.5 17.5,22 18,22H23C23.5,22 24,21.5 24,21V17C24,16.5 23.5,16 23,16V14.5C23,13.1 21.9,12 20.5,12M20.5,13C21.3,13 22,13.7 22,14.5V16H19V14.5C19,13.7 19.7,13 20.5,13Z' })
	  );
	};
	
	var WifiStrength2Icon = function WifiStrength2Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3M12,5C15.07,5 18.09,5.86 20.71,7.45L17.5,11.43C16.26,10.74 14.37,10 12,10C9.62,10 7.74,10.75 6.5,11.43L3.27,7.44C5.91,5.85 8.93,5 12,5Z' })
	  );
	};
	
	var WifiStrength3AlertIcon = function WifiStrength3AlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C14.45,18.45 16.68,15.68 19,12.78V9.59L18.77,9.88C17.26,9 14.88,8 12,8C9,8 6.68,9 5.21,9.84L3.27,7.44C5.91,5.85 8.93,5 12,5C15.07,5 18.09,5.86 20.71,7.45L20.27,8H22.84C23.09,7.7 23.41,7.29 23.65,7C20.32,4.41 16.22,3 12,3M21,10V18H23V10M21,20V22H23V20' })
	  );
	};
	
	var WifiStrength3LockIcon = function WifiStrength3LockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.79,3 3.7,4.42 0.38,7C4.42,12.06 7.89,16.37 12,21.5C13.23,19.97 14.29,18.66 15.5,17.14V14.5C15.5,12.44 16.77,10.59 18.69,9.84C17.19,8.96 14.84,8 12,8C9,8 6.68,9 5.2,9.84L3.27,7.44C5.91,5.85 8.92,5 12,5C15.07,5 18.08,5.86 20.71,7.45L18.84,9.79C19.37,9.6 19.93,9.5 20.5,9.5C20.85,9.5 21.2,9.54 21.54,9.62C22.2,8.8 23.03,7.76 23.65,7C20.32,4.41 16.22,3 12,3M20.5,12C19.1,12 18,13.1 18,14.5V16C17.5,16 17,16.5 17,17V21C17,21.5 17.5,22 18,22H23C23.5,22 24,21.5 24,21V17C24,16.5 23.5,16 23,16V14.5C23,13.1 21.9,12 20.5,12M20.5,13C21.3,13 22,13.7 22,14.5V16H19V14.5C19,13.7 19.7,13 20.5,13Z' })
	  );
	};
	
	var WifiStrength3Icon = function WifiStrength3Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3M12,5C15.07,5 18.09,5.86 20.71,7.45L18.77,9.88C17.26,9 14.88,8 12,8C9,8 6.68,9 5.21,9.84L3.27,7.44C5.91,5.85 8.93,5 12,5Z' })
	  );
	};
	
	var WifiStrength4AlertIcon = function WifiStrength4AlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C14.45,18.45 16.68,15.68 19,12.78V8H22.84C23.09,7.7 23.41,7.29 23.65,7C20.32,4.41 16.22,3 12,3M21,10V18H23V10M21,20V22H23V20' })
	  );
	};
	
	var WifiStrength4LockIcon = function WifiStrength4LockIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.79,3 3.7,4.42 0.38,7C4.42,12.06 7.89,16.37 12,21.5C13.23,19.97 14.29,18.66 15.5,17.14V14.5C15.5,11.74 17.74,9.5 20.5,9.5C20.85,9.5 21.2,9.54 21.54,9.62C22.2,8.8 23.03,7.76 23.65,7C20.32,4.41 16.22,3 12,3M20.5,12C19.1,12 18,13.1 18,14.5V16C17.5,16 17,16.5 17,17V21C17,21.5 17.5,22 18,22H23C23.5,22 24,21.5 24,21V17C24,16.5 23.5,16 23,16V14.5C23,13.1 21.9,12 20.5,12M20.5,13C21.3,13 22,13.7 22,14.5V16H19V14.5C19,13.7 19.7,13 20.5,13Z' })
	  );
	};
	
	var WifiStrength4Icon = function WifiStrength4Icon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3Z' })
	  );
	};
	
	var WifiStrengthAlertOutlineIcon = function WifiStrengthAlertOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.79,3 3.7,4.41 0.38,7H0.36C4.24,11.83 8.13,16.66 12,21.5C14.34,18.59 16.67,15.68 19,12.78V9.59L12,18.3L3.27,7.44C5.9,5.85 8.92,5 12,5C15.07,5 18.09,5.86 20.71,7.45L20.27,8H22.84C23.11,7.67 23.37,7.33 23.64,7H23.65C20.32,4.41 16.22,3 12,3M21,10V18H23V10M21,20V22H23V20' })
	  );
	};
	
	var WifiStrengthLockOutlineIcon = function WifiStrengthLockOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.79,3 3.7,4.42 0.38,7C4.61,12.3 8.16,16.7 12,21.5C13.21,20 14.29,18.65 15.5,17.14V14.5C15.5,14.3 15.5,14.09 15.54,13.89L12,18.3L3.27,7.44C5.91,5.85 8.92,5 12,5C15.07,5 18.08,5.86 20.71,7.45L18.83,9.79C19.37,9.6 19.93,9.5 20.5,9.5C20.85,9.5 21.2,9.54 21.55,9.62C22.21,8.79 23,7.77 23.65,7C20.32,4.41 16.22,3 12,3M20.5,12C19.1,12 18,13.1 18,14.5V16C17.5,16 17,16.5 17,17V21C17,21.5 17.5,22 18,22H23C23.5,22 24,21.5 24,21V17C24,16.5 23.5,16 23,16V14.5C23,13.1 21.9,12 20.5,12M20.5,13C21.3,13 22,13.7 22,14.5V16H19V14.5C19,13.7 19.7,13 20.5,13Z' })
	  );
	};
	
	var WifiStrengthOffOutlineIcon = function WifiStrengthOffOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.27,1.44L2,2.72L4.05,4.77C2.75,5.37 1.5,6.11 0.38,7C4.2,11.8 8.14,16.67 12,21.5L15.91,16.63L19.23,19.95L20.5,18.68C14.87,13.04 3.27,1.44 3.27,1.44M12,3C10.6,3 9.21,3.17 7.86,3.5L9.56,5.19C10.37,5.07 11.18,5 12,5C15.07,5 18.09,5.86 20.71,7.45L16.76,12.38L18.18,13.8C20.08,11.43 22,9 23.65,7C20.32,4.41 16.22,3 12,3M5.57,6.29L14.5,15.21L12,18.3L3.27,7.44C4,7 4.78,6.61 5.57,6.29Z' })
	  );
	};
	
	var WifiStrengthOffIcon = function WifiStrengthOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.27,1.44L2,2.72L4.05,4.77C2.75,5.37 1.5,6.11 0.38,7C4.41,12.06 12,21.5 12,21.5L15.91,16.63L19.23,19.95L20.5,18.68M12,3C10.6,3 9.21,3.17 7.86,3.5L18.18,13.81C20,11.5 22.05,9 23.65,7C20.32,4.41 16.22,3 12,3Z' })
	  );
	};
	
	var WifiStrengthOutlineIcon = function WifiStrengthOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,3C7.79,3 3.7,4.41 0.38,7H0.36C4.24,11.83 8.13,16.66 12,21.5C15.89,16.66 19.77,11.83 23.64,7H23.65C20.32,4.41 16.22,3 12,3M12,5C15.07,5 18.09,5.86 20.71,7.45L12,18.3L3.27,7.44C5.9,5.85 8.92,5 12,5Z' })
	  );
	};
	
	var WifiIcon = function WifiIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,21L15.6,16.2C14.6,15.45 13.35,15 12,15C10.65,15 9.4,15.45 8.4,16.2L12,21M12,3C7.95,3 4.21,4.34 1.2,6.6L3,9C5.5,7.12 8.62,6 12,6C15.38,6 18.5,7.12 21,9L22.8,6.6C19.79,4.34 16.05,3 12,3M12,9C9.3,9 6.81,9.89 4.8,11.4L6.6,13.8C8.1,12.67 9.97,12 12,12C14.03,12 15.9,12.67 17.4,13.8L19.2,11.4C17.19,9.89 14.7,9 12,9Z' })
	  );
	};
	
	var WiiIcon = function WiiIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.84,16.94H15.97V10.79H17.84V16.94M18,8.58C18,9.19 17.5,9.69 16.9,9.69C16.29,9.69 15.79,9.19 15.79,8.58C15.79,7.96 16.29,7.46 16.9,7.46C17.5,7.46 18,7.96 18,8.58M21.82,16.94H19.94V10.79H21.82V16.94M22,8.58C22,9.19 21.5,9.69 20.88,9.69C20.27,9.69 19.77,9.19 19.77,8.58C19.77,7.96 20.27,7.46 20.88,7.46C21.5,7.46 22,7.96 22,8.58M12.9,8.05H14.9L12.78,15.5C12.78,15.5 12.5,17.04 11.28,17.04C10.07,17.04 9.79,15.5 9.79,15.5L8.45,10.64L7.11,15.5C7.11,15.5 6.82,17.04 5.61,17.04C4.4,17.04 4.12,15.5 4.12,15.5L2,8.05H4L5.72,14.67L7.11,9.3C7.43,7.95 8.45,7.97 8.45,7.97C8.45,7.97 9.47,7.95 9.79,9.3L11.17,14.67L12.9,8.05Z' })
	  );
	};
	
	var WiiuIcon = function WiiuIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,15.96C2,18.19 3.54,19.5 5.79,19.5H18.57C20.47,19.5 22,18.2 22,16.32V6.97C22,5.83 21.15,4.6 20.11,4.6H17.15V12.3C17.15,18.14 6.97,18.09 6.97,12.41V4.5H4.72C3.26,4.5 2,5.41 2,6.85V15.96M9.34,11.23C9.34,15.74 14.66,15.09 14.66,11.94V4.5H9.34V11.23Z' })
	  );
	};
	
	var WikipediaIcon = function WikipediaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14.97,18.95L12.41,12.92C11.39,14.91 10.27,17 9.31,18.95C9.3,18.96 8.84,18.95 8.84,18.95C7.37,15.5 5.85,12.1 4.37,8.68C4.03,7.84 2.83,6.5 2,6.5C2,6.4 2,6.18 2,6.05H7.06V6.5C6.46,6.5 5.44,6.9 5.7,7.55C6.42,9.09 8.94,15.06 9.63,16.58C10.1,15.64 11.43,13.16 12,12.11C11.55,11.23 10.13,7.93 9.71,7.11C9.39,6.57 8.58,6.5 7.96,6.5C7.96,6.35 7.97,6.25 7.96,6.06L12.42,6.07V6.47C11.81,6.5 11.24,6.71 11.5,7.29C12.1,8.53 12.45,9.42 13,10.57C13.17,10.23 14.07,8.38 14.5,7.41C14.76,6.76 14.37,6.5 13.29,6.5C13.3,6.38 13.3,6.17 13.3,6.07C14.69,6.06 16.78,6.06 17.15,6.05V6.47C16.44,6.5 15.71,6.88 15.33,7.46L13.5,11.3C13.68,11.81 15.46,15.76 15.65,16.2L19.5,7.37C19.2,6.65 18.34,6.5 18,6.5C18,6.37 18,6.2 18,6.05L22,6.08V6.1L22,6.5C21.12,6.5 20.57,7 20.25,7.75C19.45,9.54 17,15.24 15.4,18.95C15.4,18.95 14.97,18.95 14.97,18.95Z' })
	  );
	};
	
	var WindowCloseIcon = function WindowCloseIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z' })
	  );
	};
	
	var WindowClosedIcon = function WindowClosedIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,11H10V9H14V11H18V4H6V11M18,13H6V20H18V13M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2Z' })
	  );
	};
	
	var WindowMaximizeIcon = function WindowMaximizeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,4H20V20H4V4M6,8V18H18V8H6Z' })
	  );
	};
	
	var WindowMinimizeIcon = function WindowMinimizeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M20,14H4V10H20' })
	  );
	};
	
	var WindowOpenIcon = function WindowOpenIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,8H10V6H14V8H18V4H6V8M18,10H6V15H18V10M6,20H18V17H6V20M6,2H18C19.1,2 20,2.9 20,4V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V4C4,2.9 4.9,2 6,2Z' })
	  );
	};
	
	var WindowRestoreIcon = function WindowRestoreIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4,8H8V4H20V16H16V20H4V8M16,8V14H18V6H10V8H16M6,12V18H14V12H6Z' })
	  );
	};
	
	var WindowsIcon = function WindowsIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3,12V6.75L9,5.43V11.91L3,12M20,3V11.75L10,11.9V5.21L20,3M3,13L9,13.09V19.9L3,18.75V13M20,13.25V22L10,20.09V13.1L20,13.25Z' })
	  );
	};
	
	var WordpressIcon = function WordpressIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M3.42,12C3.42,10.76 3.69,9.58 4.16,8.5L8.26,19.72C5.39,18.33 3.42,15.4 3.42,12M17.79,11.57C17.79,12.3 17.5,13.15 17.14,14.34L16.28,17.2L13.18,8L14.16,7.9C14.63,7.84 14.57,7.16 14.11,7.19C14.11,7.19 12.72,7.3 11.82,7.3L9.56,7.19C9.1,7.16 9.05,7.87 9.5,7.9L10.41,8L11.75,11.64L9.87,17.27L6.74,8L7.73,7.9C8.19,7.84 8.13,7.16 7.67,7.19C7.67,7.19 6.28,7.3 5.38,7.3L4.83,7.29C6.37,4.96 9,3.42 12,3.42C14.23,3.42 16.27,4.28 17.79,5.67H17.68C16.84,5.67 16.24,6.4 16.24,7.19C16.24,7.9 16.65,8.5 17.08,9.2C17.41,9.77 17.79,10.5 17.79,11.57M12.15,12.75L14.79,19.97L14.85,20.09C13.96,20.41 13,20.58 12,20.58C11.16,20.58 10.35,20.46 9.58,20.23L12.15,12.75M19.53,7.88C20.2,9.11 20.58,10.5 20.58,12C20.58,15.16 18.86,17.93 16.31,19.41L18.93,11.84C19.42,10.62 19.59,9.64 19.59,8.77L19.53,7.88M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,21.54C17.26,21.54 21.54,17.26 21.54,12C21.54,6.74 17.26,2.46 12,2.46C6.74,2.46 2.46,6.74 2.46,12C2.46,17.26 6.74,21.54 12,21.54Z' })
	  );
	};
	
	var WorkerIcon = function WorkerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,15C7.58,15 4,16.79 4,19V21H20V19C20,16.79 16.42,15 12,15M8,9C8,11.21 9.79,13 12,13C14.21,13 16,11.21 16,9M11.5,2C11.2,2 11,2.21 11,2.5V5.5H10V3C10,3 7.75,3.86 7.75,6.75C7.75,6.75 7,6.89 7,8H17C16.95,6.89 16.25,6.75 16.25,6.75C16.25,3.86 14,3 14,3V5.5H13V2.5C13,2.21 12.81,2 12.5,2H11.5Z' })
	  );
	};
	
	var WrapIcon = function WrapIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,5H3V7H21V5M3,19H10V17H3V19M3,13H18C19,13 20,13.43 20,15C20,16.57 19,17 18,17H16V15L12,18L16,21V19H18C20.95,19 22,17.73 22,15C22,12.28 21,11 18,11H3V13Z' })
	  );
	};
	
	var WrenchIcon = function WrenchIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22.7,19L13.6,9.9C14.5,7.6 14,4.9 12.1,3C10.1,1 7.1,0.6 4.7,1.7L9,6L6,9L1.6,4.7C0.4,7.1 0.9,10.1 2.9,12.1C4.8,14 7.5,14.5 9.8,13.6L18.9,22.7C19.3,23.1 19.9,23.1 20.3,22.7L22.6,20.4C23.1,20 23.1,19.3 22.7,19Z' })
	  );
	};
	
	var WunderlistIcon = function WunderlistIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17,17.5L12,15L7,17.5V5H5V19H19V5H17V17.5M12,12.42L14.25,13.77L13.65,11.22L15.64,9.5L13,9.27L12,6.86L11,9.27L8.36,9.5L10.35,11.22L9.75,13.77L12,12.42M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3Z' })
	  );
	};
	
	var XamarinOutlineIcon = function XamarinOutlineIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,12L12.03,11.9L14.58,7.1L14.75,7H16.34L16.5,7.1V7.3L14,12L16.5,16.7V16.9L16.34,17H14.75L14.58,16.9L12.03,12.1L12,12V12.1L9.42,16.9L9.25,17H7.66L7.5,16.9V16.7L10,12L7.5,7.3V7.1L7.66,7H9.25L9.42,7.1L12,11.9V12M22.75,11.07C22.91,11.35 23,11.67 23,12C23,12.33 22.91,12.65 22.75,12.93L18.08,21C17.72,21.62 17.06,22 16.35,22H7.65C6.94,22 6.28,21.62 5.92,21L1.25,12.93C1.09,12.65 1,12.33 1,12C1,11.67 1.09,11.35 1.25,11.07L5.92,3C6.28,2.38 6.94,2 7.65,2H16.35C17.06,2 17.72,2.38 18.08,3L22.75,11.07M20.8,11.25L16.97,4.8C16.68,4.3 16.14,4 15.56,4H8.44C7.86,4 7.32,4.3 7.03,4.8L3.2,11.25C3.07,11.5 3,11.74 3,12C3,12.26 3.07,12.5 3.2,12.75L7.03,19.2C7.32,19.7 7.86,20 8.44,20H15.56C16.14,20 16.68,19.7 16.97,19.2L20.8,12.75C20.93,12.5 21,12.26 21,12C21,11.74 20.93,11.5 20.8,11.25Z' })
	  );
	};
	
	var XamarinIcon = function XamarinIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M22.75,11.07C22.91,11.35 23,11.67 23,12C23,12.33 22.91,12.65 22.75,12.93L18.08,21C17.72,21.62 17.06,22 16.35,22H7.65C6.94,22 6.28,21.62 5.92,21L1.25,12.93C1.09,12.65 1,12.33 1,12C1,11.67 1.09,11.35 1.25,11.07L5.92,3C6.28,2.38 6.94,2 7.65,2H16.35C17.06,2 17.72,2.38 18.08,3L22.75,11.07M12,12V11.9L9.42,7.1L9.25,7H7.66L7.5,7.1V7.3L10,12L7.5,16.7V16.9L7.66,17H9.25L9.42,16.9L12,12.1V12L12.03,12.1L14.58,16.9L14.75,17H16.34L16.5,16.9V16.7L14,12L16.5,7.3V7.1L16.34,7H14.75L14.58,7.1L12.03,11.9L12,12Z' })
	  );
	};
	
	var XamlIcon = function XamlIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18.93,12L15.46,18H8.54L5.07,12L8.54,6H15.46L18.93,12M23.77,12L19.73,19L18,18L21.46,12L18,6L19.73,5L23.77,12M0.23,12L4.27,5L6,6L2.54,12L6,18L4.27,19L0.23,12Z' })
	  );
	};
	
	var XboxControllerBatteryAlertIcon = function XboxControllerBatteryAlertIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,19V7H15V19H21M21.67,5C22.4,5 23,5.6 23,6.33V19.67C23,20.4 22.4,21 21.67,21H14.33C13.6,21 13,20.4 13,19.67V16.75H7.75C5.75,16.75 5,19 3,20C1,20 -0.5,17 3.5,8.5H3.75L4.19,7.67C4.19,7.67 7,6 8.33,7.23H13V6.33C13,5.6 13.6,5 14.33,5H16V3H20V5H21.67M11,8C10.45,8 10,8.45 10,9C10,9.55 10.45,10 11,10C11.55,10 12,9.55 12,9C12,8.45 11.55,8 11,8M17,9H19V14H17V9M17,15H19V17H17V15Z' })
	  );
	};
	
	var XboxControllerBatteryEmptyIcon = function XboxControllerBatteryEmptyIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,19V7H15V19H21M21.67,5C22.4,5 23,5.6 23,6.33V19.67C23,20.4 22.4,21 21.67,21H14.33C13.6,21 13,20.4 13,19.67V16.75H7.75C5.75,16.75 5,19 3,20C1,20 -0.5,17 3.5,8.5H3.75L4.19,7.67C4.19,7.67 7,6 8.33,7.23H13V6.33C13,5.6 13.6,5 14.33,5H16V3H20V5H21.67M11,8C10.45,8 10,8.45 10,9C10,9.55 10.45,10 11,10C11.55,10 12,9.55 12,9C12,8.45 11.55,8 11,8Z' })
	  );
	};
	
	var XboxControllerBatteryFullIcon = function XboxControllerBatteryFullIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.67,5C22.4,5 23,5.6 23,6.33V19.67C23,20.4 22.4,21 21.67,21H14.33C13.6,21 13,20.4 13,19.67V16.75H7.75C5.75,16.75 5,19 3,20C1,20 -0.5,17 3.5,8.5H3.75L4.19,7.67C4.19,7.67 7,6 8.33,7.23H13V6.33C13,5.6 13.6,5 14.33,5H16V3H20V5H21.67M11,8C10.45,8 10,8.45 10,9C10,9.55 10.45,10 11,10C11.55,10 12,9.55 12,9C12,8.45 11.55,8 11,8Z' })
	  );
	};
	
	var XboxControllerBatteryLowIcon = function XboxControllerBatteryLowIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,16V7H15V16H21M21.67,5C22.4,5 23,5.6 23,6.33V19.67C23,20.4 22.4,21 21.67,21H14.33C13.6,21 13,20.4 13,19.67V16.75H7.75C5.75,16.75 5,19 3,20C1,20 -0.5,17 3.5,8.5H3.75L4.19,7.67C4.19,7.67 7,6 8.33,7.23H13V6.33C13,5.6 13.6,5 14.33,5H16V3H20V5H21.67M11,8C10.45,8 10,8.45 10,9C10,9.55 10.45,10 11,10C11.55,10 12,9.55 12,9C12,8.45 11.55,8 11,8Z' })
	  );
	};
	
	var XboxControllerBatteryMediumIcon = function XboxControllerBatteryMediumIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21,12V7H15V12H21M21.67,5C22.4,5 23,5.6 23,6.33V19.67C23,20.4 22.4,21 21.67,21H14.33C13.6,21 13,20.4 13,19.67V16.75H7.75C5.75,16.75 5,19 3,20C1,20 -0.5,17 3.5,8.5H3.75L4.19,7.67C4.19,7.67 7,6 8.33,7.23H13V6.33C13,5.6 13.6,5 14.33,5H16V3H20V5H21.67M11,8C10.45,8 10,8.45 10,9C10,9.55 10.45,10 11,10C11.55,10 12,9.55 12,9C12,8.45 11.55,8 11,8Z' })
	  );
	};
	
	var XboxControllerBatteryUnknownIcon = function XboxControllerBatteryUnknownIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M21.67,5C22.4,5 23,5.6 23,6.33V19.67C23,20.4 22.4,21 21.67,21H14.33C13.6,21 13,20.4 13,19.67V16.75H7.75C5.75,16.75 5,19 3,20C1,20 -0.5,17 3.5,8.5H3.75L4.19,7.67C4.19,7.67 7,6 8.33,7.23H13V6.33C13,5.6 13.6,5 14.33,5H16V3H20V5H21.67M11,8C10.45,8 10,8.45 10,9C10,9.55 10.45,10 11,10C11.55,10 12,9.55 12,9C12,8.45 11.55,8 11,8M18.19,8C17.32,8 16.62,8.2 16.08,8.59C15.56,9 15.3,9.57 15.31,10.36L15.32,10.39H17.25C17.26,10.09 17.35,9.86 17.53,9.7C17.71,9.55 17.93,9.47 18.19,9.47C18.5,9.47 18.76,9.57 18.94,9.75C19.12,9.94 19.2,10.2 19.2,10.5C19.2,10.82 19.13,11.09 18.97,11.32C18.83,11.55 18.62,11.75 18.36,11.91C17.85,12.25 17.5,12.55 17.31,12.82C17.11,13.08 17,13.5 17,14H19C19,13.69 19.04,13.44 19.13,13.26C19.22,13.08 19.39,12.9 19.64,12.74C20.09,12.5 20.46,12.21 20.75,11.81C21.04,11.41 21.19,11 21.19,10.5C21.19,9.74 20.92,9.13 20.38,8.68C19.85,8.23 19.12,8 18.19,8M17,15V17H19V15H17Z' })
	  );
	};
	
	var XboxControllerOffIcon = function XboxControllerOffIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2,5.27L3.28,4L20,20.72L18.73,22L12.5,15.75H8.75C6.75,15.75 6,18 4,19C2,19 0.5,16.04 4.42,7.69L2,5.27M9.33,6.23H14.67C16,5 18.81,6.67 18.81,6.67L19.25,7.5H19.5C23,15 22.28,18.2 20.69,18.87L7.62,5.8C8.25,5.73 8.87,5.81 9.33,6.23M12,7C11.45,7 11,7.45 11,8C11,8.55 11.45,9 12,9C12.55,9 13,8.55 13,8C13,7.45 12.55,7 12,7Z' })
	  );
	};
	
	var XboxControllerIcon = function XboxControllerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M8.75,15.75C6.75,15.75 6,18 4,19C2,19 0.5,16 4.5,7.5H4.75L5.19,6.67C5.19,6.67 8,5 9.33,6.23H14.67C16,5 18.81,6.67 18.81,6.67L19.25,7.5H19.5C23.5,16 22,19 20,19C18,18 17.25,15.75 15.25,15.75H8.75M12,7C11.45,7 11,7.45 11,8C11,8.55 11.45,9 12,9C12.55,9 13,8.55 13,8C13,7.45 12.55,7 12,7Z' })
	  );
	};
	
	var XboxIcon = function XboxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6.43,3.72C6.5,3.66 6.57,3.6 6.62,3.56C8.18,2.55 10,2 12,2C13.88,2 15.64,2.5 17.14,3.42C17.25,3.5 17.54,3.69 17.7,3.88C16.25,2.28 12,5.7 12,5.7C10.5,4.57 9.17,3.8 8.16,3.5C7.31,3.29 6.73,3.5 6.46,3.7M19.34,5.21C19.29,5.16 19.24,5.11 19.2,5.06C18.84,4.66 18.38,4.56 18,4.59C17.61,4.71 15.9,5.32 13.8,7.31C13.8,7.31 16.17,9.61 17.62,11.96C19.07,14.31 19.93,16.16 19.4,18.73C21,16.95 22,14.59 22,12C22,9.38 21,7 19.34,5.21M15.73,12.96C15.08,12.24 14.13,11.21 12.86,9.95C12.59,9.68 12.3,9.4 12,9.1C12,9.1 11.53,9.56 10.93,10.17C10.16,10.94 9.17,11.95 8.61,12.54C7.63,13.59 4.81,16.89 4.65,18.74C4.65,18.74 4,17.28 5.4,13.89C6.3,11.68 9,8.36 10.15,7.28C10.15,7.28 9.12,6.14 7.82,5.35L7.77,5.32C7.14,4.95 6.46,4.66 5.8,4.62C5.13,4.67 4.71,5.16 4.71,5.16C3.03,6.95 2,9.35 2,12C2,17.52 6.48,22 12,22C14.93,22 17.57,20.74 19.4,18.73C19.4,18.73 19.19,17.4 17.84,15.5C17.53,15.07 16.37,13.69 15.73,12.96Z' })
	  );
	};
	
	var XdaIcon = function XdaIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M-0.05,16.79L3.19,12.97L-0.05,9.15L1.5,7.86L4.5,11.41L7.5,7.86L9.05,9.15L5.81,12.97L9.05,16.79L7.5,18.07L4.5,14.5L1.5,18.07L-0.05,16.79M24,17C24,17.55 23.55,18 23,18H20C18.9,18 18,17.1 18,16V14C18,12.9 18.9,12 20,12H22V10H18V8H23C23.55,8 24,8.45 24,9M22,14H20V16H22V14M16,17C16,17.55 15.55,18 15,18H12C10.9,18 10,17.1 10,16V10C10,8.9 10.9,8 12,8H14V5H16V17M14,16V10H12V16H14Z' })
	  );
	};
	
	var XingBoxIcon = function XingBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M4.8,3C3.8,3 3,3.8 3,4.8V19.2C3,20.2 3.8,21 4.8,21H19.2C20.2,21 21,20.2 21,19.2V4.8C21,3.8 20.2,3 19.2,3M16.07,5H18.11C18.23,5 18.33,5.04 18.37,5.13C18.43,5.22 18.43,5.33 18.37,5.44L13.9,13.36L16.75,18.56C16.81,18.67 16.81,18.78 16.75,18.87C16.7,18.95 16.61,19 16.5,19H14.47C14.16,19 14,18.79 13.91,18.61L11.04,13.35C11.18,13.1 15.53,5.39 15.53,5.39C15.64,5.19 15.77,5 16.07,5M7.09,7.76H9.1C9.41,7.76 9.57,7.96 9.67,8.15L11.06,10.57C10.97,10.71 8.88,14.42 8.88,14.42C8.77,14.61 8.63,14.81 8.32,14.81H6.3C6.18,14.81 6.09,14.76 6.04,14.67C6,14.59 6,14.47 6.04,14.36L8.18,10.57L6.82,8.2C6.77,8.09 6.75,8 6.81,7.89C6.86,7.81 6.96,7.76 7.09,7.76Z' })
	  );
	};
	
	var XingCircleIcon = function XingCircleIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M15.85,6H17.74C17.86,6 17.94,6.04 18,6.12C18.04,6.2 18.04,6.3 18,6.41L13.84,13.76L16.5,18.59C16.53,18.69 16.53,18.8 16.5,18.88C16.43,18.96 16.35,19 16.24,19H14.36C14.07,19 13.93,18.81 13.84,18.64L11.17,13.76C11.31,13.5 15.35,6.36 15.35,6.36C15.45,6.18 15.57,6 15.85,6M7.5,8.57H9.39C9.67,8.57 9.81,8.75 9.9,8.92L11.19,11.17C11.12,11.3 9.17,14.75 9.17,14.75C9.07,14.92 8.94,15.11 8.66,15.11H6.78C6.67,15.11 6.59,15.06 6.54,15C6.5,14.9 6.5,14.8 6.54,14.69L8.53,11.17L7.27,9C7.21,8.87 7.2,8.77 7.25,8.69C7.3,8.61 7.39,8.57 7.5,8.57Z' })
	  );
	};
	
	var XingIcon = function XingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M17.67,2C17.24,2 17.05,2.27 16.9,2.55C16.9,2.55 10.68,13.57 10.5,13.93L14.58,21.45C14.72,21.71 14.94,22 15.38,22H18.26C18.44,22 18.57,21.93 18.64,21.82C18.72,21.69 18.72,21.53 18.64,21.37L14.57,13.92L20.96,2.63C21.04,2.47 21.04,2.31 20.97,2.18C20.89,2.07 20.76,2 20.58,2M5.55,5.95C5.38,5.95 5.23,6 5.16,6.13C5.08,6.26 5.09,6.41 5.18,6.57L7.12,9.97L4.06,15.37C4,15.53 4,15.69 4.06,15.82C4.13,15.94 4.26,16 4.43,16H7.32C7.75,16 7.96,15.72 8.11,15.45C8.11,15.45 11.1,10.16 11.22,9.95L9.24,6.5C9.1,6.24 8.88,5.95 8.43,5.95' })
	  );
	};
	
	var XmlIcon = function XmlIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12.89,3L14.85,3.4L11.11,21L9.15,20.6L12.89,3M19.59,12L16,8.41V5.58L22.42,12L16,18.41V15.58L19.59,12M1.58,12L8,5.58V8.41L4.41,12L8,15.58V18.41L1.58,12Z' })
	  );
	};
	
	var XmppIcon = function XmppIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,15.4C9.75,13.09 8,9.54 8,6C2,4 8,6 2,4C2,9.65 6.33,14.11 10.55,16.66C9.38,17.5 8.15,18 7,18C7,19 7,18 7,19C8.2,19 10.03,18.46 12,17.46C13.97,18.46 15.8,19 17,19C17,18 17,19 17,18C15.85,18 14.62,17.5 13.45,16.66C17.66,14.11 22,9.65 22,4C16,6 22,4 16,6C16,9.54 14.25,13.09 12,15.4Z' })
	  );
	};
	
	var YammerIcon = function YammerIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M13.54,5.93L9.18,17.11C9.16,17.19 8.26,19.65 5.23,19.65C4.68,19.65 4.23,19.2 4.23,18.65C4.23,18.09 4.68,17.65 5.23,17.65C6.79,17.65 7.26,16.53 7.31,16.41L7.68,15.4L3.82,5.94C3.62,5.43 3.86,4.84 4.37,4.64C4.88,4.43 5.47,4.67 5.68,5.19L8.75,12.72L11.68,5.2C11.88,4.68 12.46,4.43 13,4.63C13.5,4.83 13.75,5.41 13.54,5.93M18.5,6.38C18.32,6.38 18.13,6.45 18,6.57C18,6.57 13.8,9.56 14,9.88C14.19,10.2 18.83,8.03 18.84,8C19.15,7.9 19.38,7.59 19.38,7.23C19.38,6.76 19,6.38 18.5,6.38M19.27,16.84C19.17,16.67 19,16.54 18.83,16.46C18.83,16.46 14.17,14.29 14,14.61C13.81,14.94 18,17.92 18,17.92C18.25,18.14 18.63,18.18 18.94,18C19.35,17.77 19.5,17.25 19.27,16.84M20.97,11.42C20.79,11.32 20.6,11.29 20.4,11.32C20.4,11.32 15.29,11.85 15.3,12.22C15.31,12.59 20.41,13 20.42,13C20.76,13.05 21.11,12.9 21.29,12.58C21.5,12.17 21.38,11.65 20.97,11.42Z' })
	  );
	};
	
	var YeastIcon = function YeastIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M18,14C20.21,14 22,15.79 22,18C22,20.21 20.21,22 18,22C15.79,22 14,20.21 14,18L14.09,17.15C14.05,16.45 13.92,15.84 13.55,15.5C13.35,15.3 13.07,15.19 12.75,15.13C11.79,15.68 10.68,16 9.5,16C5.91,16 3,13.09 3,9.5C3,5.91 5.91,3 9.5,3C13.09,3 16,5.91 16,9.5C16,10.68 15.68,11.79 15.13,12.75C15.19,13.07 15.3,13.35 15.5,13.55C15.84,13.92 16.45,14.05 17.15,14.09L18,14M7.5,10C8.33,10 9,10.67 9,11.5C9,12.33 8.33,13 7.5,13C6.67,13 6,12.33 6,11.5C6,10.67 6.67,10 7.5,10M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z' })
	  );
	};
	
	var YelpIcon = function YelpIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10.59,2C11.23,2 11.5,2.27 11.58,2.97L11.79,6.14L12.03,10.29C12.05,10.64 12,11 11.86,11.32C11.64,11.77 11.14,11.89 10.73,11.58C10.5,11.39 10.31,11.14 10.15,10.87L6.42,4.55C6.06,3.94 6.17,3.54 6.77,3.16C7.5,2.68 9.73,2 10.59,2M14.83,14.85L15.09,14.91L18.95,16.31C19.61,16.55 19.79,16.92 19.5,17.57C19.06,18.7 18.34,19.66 17.42,20.45C16.96,20.85 16.5,20.78 16.21,20.28L13.94,16.32C13.55,15.61 14.03,14.8 14.83,14.85M4.5,14C4.5,13.26 4.5,12.55 4.75,11.87C4.97,11.2 5.33,11 6,11.27L9.63,12.81C10.09,13 10.35,13.32 10.33,13.84C10.3,14.36 9.97,14.58 9.53,14.73L5.85,15.94C5.15,16.17 4.79,15.96 4.64,15.25C4.55,14.83 4.47,14.4 4.5,14M11.97,21C11.95,21.81 11.6,22.12 10.81,22C9.77,21.8 8.81,21.4 7.96,20.76C7.54,20.44 7.45,19.95 7.76,19.53L10.47,15.97C10.7,15.67 11.03,15.6 11.39,15.74C11.77,15.88 11.97,16.18 11.97,16.59V21M14.45,13.32C13.73,13.33 13.23,12.5 13.64,11.91C14.47,10.67 15.35,9.46 16.23,8.26C16.5,7.85 16.94,7.82 17.31,8.16C18.24,9 18.91,10 19.29,11.22C19.43,11.67 19.25,12.08 18.83,12.2L15.09,13.17L14.45,13.32Z' })
	  );
	};
	
	var YinYangIcon = function YinYangIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C9.79,20 8,18.21 8,16C8,13.79 9.79,12 12,12C14.21,12 16,10.21 16,8C16,5.79 14.21,4 12,4M12,6.5C12.83,6.5 13.5,7.17 13.5,8C13.5,8.83 12.83,9.5 12,9.5C11.17,9.5 10.5,8.83 10.5,8C10.5,7.17 11.17,6.5 12,6.5M12,14.5C11.17,14.5 10.5,15.17 10.5,16C10.5,16.83 11.17,17.5 12,17.5C12.83,17.5 13.5,16.83 13.5,16C13.5,15.17 12.83,14.5 12,14.5Z' })
	  );
	};
	
	var YoutubeCreatorStudioIcon = function YoutubeCreatorStudioIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,15L15,12L10,9V15M19.45,13L21.56,14.63C21.78,14.78 21.81,15 21.66,15.28L19.64,18.75C19.5,18.97 19.31,19.03 19.03,18.94L16.55,17.95C15.89,18.42 15.33,18.75 14.86,18.94L14.5,21.56C14.42,21.84 14.27,22 14,22H10C9.73,22 9.58,21.84 9.5,21.56L9.14,18.94C8.55,18.69 8,18.36 7.45,17.95L4.97,18.94C4.69,19.03 4.5,18.97 4.36,18.75L2.34,15.28C2.19,15 2.22,14.78 2.44,14.63L4.55,13C4.5,12.77 4.5,12.44 4.5,12C4.5,11.56 4.5,11.23 4.55,11L2.44,9.38C2.22,9.22 2.19,9 2.34,8.72L4.36,5.25C4.5,5.03 4.69,4.97 4.97,5.06L7.45,6.05C8.11,5.58 8.67,5.25 9.14,5.06L9.5,2.44C9.58,2.16 9.73,2 10,2H14C14.27,2 14.42,2.16 14.5,2.44L14.86,5.06C15.45,5.31 16,5.64 16.55,6.05L19.03,5.06C19.31,4.97 19.5,5.03 19.64,5.25L21.66,8.72C21.81,9 21.78,9.22 21.56,9.38L19.45,11C19.5,11.23 19.5,11.56 19.5,12C19.5,12.44 19.5,12.77 19.45,13Z' })
	  );
	};
	
	var YoutubeGamingIcon = function YoutubeGamingIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M6,3.54C5.81,3.54 5.63,3.62 5.46,3.71L0.55,6.5C0.21,6.7 0,7.06 0,7.45V13.68C0,14.07 0.21,14.43 0.55,14.63L11.46,20.83C11.63,20.92 11.81,21 12,21C12.19,21 12.37,20.92 12.54,20.83L23.45,14.63C23.79,14.44 24,14.08 24,13.69V7.45C24,7.06 23.79,6.7 23.45,6.5L18.54,3.71C18.37,3.62 18.19,3.54 18,3.54C17.81,3.54 17.63,3.62 17.46,3.71L12.54,6.5C12.21,6.7 11.8,6.7 11.46,6.5L6.54,3.71C6.37,3.62 6.19,3.54 6,3.54M18.14,4.09L23.46,7.09L18.14,10.23V4.09Z' })
	  );
	};
	
	var YoutubeTvIcon = function YoutubeTvIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M2.5,4.5H21.5C22.34,4.5 23,5.15 23,6V17.5C23,18.35 22.34,19 21.5,19H2.5C1.65,19 1,18.35 1,17.5V6C1,5.15 1.65,4.5 2.5,4.5M9.71,8.5V15L15.42,11.7L9.71,8.5M17.25,21H6.65C6.35,21 6.15,20.8 6.15,20.5C6.15,20.2 6.35,20 6.65,20H17.35C17.65,20 17.85,20.2 17.85,20.5C17.85,20.8 17.55,21 17.25,21Z' })
	  );
	};
	
	var YoutubeIcon = function YoutubeIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z' })
	  );
	};
	
	var ZipBoxIcon = function ZipBoxIcon(_ref) {
	  var _ref$color = _ref.color,
	      color = _ref$color === undefined ? 'currentColor' : _ref$color,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 24 : _ref$size,
	      children = _ref.children,
	      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);
	
	  var className = 'mdi-icon ' + (props.className || '');
	
	  return React.createElement(
	    'svg',
	    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
	    React.createElement('path', { d: 'M14,17H12V15H10V13H12V15H14M14,9H12V11H14V13H12V11H10V9H12V7H10V5H12V7H14M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z' })
	  );
	};
	
	exports.AccessPointNetworkIcon = AccessPointNetworkIcon;
	exports.AccessPointIcon = AccessPointIcon;
	exports.AccountAlertIcon = AccountAlertIcon;
	exports.AccountBoxMultipleIcon = AccountBoxMultipleIcon;
	exports.AccountBoxOutlineIcon = AccountBoxOutlineIcon;
	exports.AccountBoxIcon = AccountBoxIcon;
	exports.AccountCardDetailsIcon = AccountCardDetailsIcon;
	exports.AccountCheckIcon = AccountCheckIcon;
	exports.AccountCircleIcon = AccountCircleIcon;
	exports.AccountConvertIcon = AccountConvertIcon;
	exports.AccountEditIcon = AccountEditIcon;
	exports.AccountGroupIcon = AccountGroupIcon;
	exports.AccountHeartIcon = AccountHeartIcon;
	exports.AccountKeyIcon = AccountKeyIcon;
	exports.AccountLocationIcon = AccountLocationIcon;
	exports.AccountMinusIcon = AccountMinusIcon;
	exports.AccountMultipleCheckIcon = AccountMultipleCheckIcon;
	exports.AccountMultipleMinusIcon = AccountMultipleMinusIcon;
	exports.AccountMultipleOutlineIcon = AccountMultipleOutlineIcon;
	exports.AccountMultiplePlusOutlineIcon = AccountMultiplePlusOutlineIcon;
	exports.AccountMultiplePlusIcon = AccountMultiplePlusIcon;
	exports.AccountMultipleIcon = AccountMultipleIcon;
	exports.AccountNetworkIcon = AccountNetworkIcon;
	exports.AccountOffIcon = AccountOffIcon;
	exports.AccountOutlineIcon = AccountOutlineIcon;
	exports.AccountPlusOutlineIcon = AccountPlusOutlineIcon;
	exports.AccountPlusIcon = AccountPlusIcon;
	exports.AccountRemoveIcon = AccountRemoveIcon;
	exports.AccountSearchOutlineIcon = AccountSearchOutlineIcon;
	exports.AccountSearchIcon = AccountSearchIcon;
	exports.AccountSettingsVariantIcon = AccountSettingsVariantIcon;
	exports.AccountSettingsIcon = AccountSettingsIcon;
	exports.AccountStarIcon = AccountStarIcon;
	exports.AccountSwitchIcon = AccountSwitchIcon;
	exports.AccountIcon = AccountIcon;
	exports.AccusoftIcon = AccusoftIcon;
	exports.AdjustIcon = AdjustIcon;
	exports.AdobeIcon = AdobeIcon;
	exports.AirConditionerIcon = AirConditionerIcon;
	exports.AirballoonIcon = AirballoonIcon;
	exports.AirplaneLandingIcon = AirplaneLandingIcon;
	exports.AirplaneOffIcon = AirplaneOffIcon;
	exports.AirplaneTakeoffIcon = AirplaneTakeoffIcon;
	exports.AirplaneIcon = AirplaneIcon;
	exports.AirplayIcon = AirplayIcon;
	exports.AirportIcon = AirportIcon;
	exports.AlarmBellIcon = AlarmBellIcon;
	exports.AlarmCheckIcon = AlarmCheckIcon;
	exports.AlarmLightIcon = AlarmLightIcon;
	exports.AlarmMultipleIcon = AlarmMultipleIcon;
	exports.AlarmOffIcon = AlarmOffIcon;
	exports.AlarmPlusIcon = AlarmPlusIcon;
	exports.AlarmSnoozeIcon = AlarmSnoozeIcon;
	exports.AlarmIcon = AlarmIcon;
	exports.AlbumIcon = AlbumIcon;
	exports.AlertBoxIcon = AlertBoxIcon;
	exports.AlertCircleOutlineIcon = AlertCircleOutlineIcon;
	exports.AlertCircleIcon = AlertCircleIcon;
	exports.AlertDecagramIcon = AlertDecagramIcon;
	exports.AlertOctagonIcon = AlertOctagonIcon;
	exports.AlertOctagramIcon = AlertOctagramIcon;
	exports.AlertOutlineIcon = AlertOutlineIcon;
	exports.AlertIcon = AlertIcon;
	exports.AlienIcon = AlienIcon;
	exports.AllInclusiveIcon = AllInclusiveIcon;
	exports.AlphaIcon = AlphaIcon;
	exports.AlphabeticalIcon = AlphabeticalIcon;
	exports.AltimeterIcon = AltimeterIcon;
	exports.AmazonAlexaIcon = AmazonAlexaIcon;
	exports.AmazonDriveIcon = AmazonDriveIcon;
	exports.AmazonIcon = AmazonIcon;
	exports.AmbulanceIcon = AmbulanceIcon;
	exports.AmplifierIcon = AmplifierIcon;
	exports.AnchorIcon = AnchorIcon;
	exports.AndroidDebugBridgeIcon = AndroidDebugBridgeIcon;
	exports.AndroidHeadIcon = AndroidHeadIcon;
	exports.AndroidStudioIcon = AndroidStudioIcon;
	exports.AndroidIcon = AndroidIcon;
	exports.AngleAcuteIcon = AngleAcuteIcon;
	exports.AngleObtuseIcon = AngleObtuseIcon;
	exports.AngleRightIcon = AngleRightIcon;
	exports.AngularIcon = AngularIcon;
	exports.AngularjsIcon = AngularjsIcon;
	exports.AnimationPlayIcon = AnimationPlayIcon;
	exports.AnimationIcon = AnimationIcon;
	exports.AnvilIcon = AnvilIcon;
	exports.AppleFinderIcon = AppleFinderIcon;
	exports.AppleIcloudIcon = AppleIcloudIcon;
	exports.AppleIosIcon = AppleIosIcon;
	exports.AppleKeyboardCapsIcon = AppleKeyboardCapsIcon;
	exports.AppleKeyboardCommandIcon = AppleKeyboardCommandIcon;
	exports.AppleKeyboardControlIcon = AppleKeyboardControlIcon;
	exports.AppleKeyboardOptionIcon = AppleKeyboardOptionIcon;
	exports.AppleKeyboardShiftIcon = AppleKeyboardShiftIcon;
	exports.AppleSafariIcon = AppleSafariIcon;
	exports.AppleIcon = AppleIcon;
	exports.ApplicationIcon = ApplicationIcon;
	exports.ApprovalIcon = ApprovalIcon;
	exports.AppsIcon = AppsIcon;
	exports.ArchIcon = ArchIcon;
	exports.ArchiveIcon = ArchiveIcon;
	exports.ArrangeBringForwardIcon = ArrangeBringForwardIcon;
	exports.ArrangeBringToFrontIcon = ArrangeBringToFrontIcon;
	exports.ArrangeSendBackwardIcon = ArrangeSendBackwardIcon;
	exports.ArrangeSendToBackIcon = ArrangeSendToBackIcon;
	exports.ArrowAllIcon = ArrowAllIcon;
	exports.ArrowBottomLeftIcon = ArrowBottomLeftIcon;
	exports.ArrowBottomRightIcon = ArrowBottomRightIcon;
	exports.ArrowCollapseAllIcon = ArrowCollapseAllIcon;
	exports.ArrowCollapseDownIcon = ArrowCollapseDownIcon;
	exports.ArrowCollapseHorizontalIcon = ArrowCollapseHorizontalIcon;
	exports.ArrowCollapseLeftIcon = ArrowCollapseLeftIcon;
	exports.ArrowCollapseRightIcon = ArrowCollapseRightIcon;
	exports.ArrowCollapseUpIcon = ArrowCollapseUpIcon;
	exports.ArrowCollapseVerticalIcon = ArrowCollapseVerticalIcon;
	exports.ArrowCollapseIcon = ArrowCollapseIcon;
	exports.ArrowDownBoldBoxOutlineIcon = ArrowDownBoldBoxOutlineIcon;
	exports.ArrowDownBoldBoxIcon = ArrowDownBoldBoxIcon;
	exports.ArrowDownBoldCircleOutlineIcon = ArrowDownBoldCircleOutlineIcon;
	exports.ArrowDownBoldCircleIcon = ArrowDownBoldCircleIcon;
	exports.ArrowDownBoldHexagonOutlineIcon = ArrowDownBoldHexagonOutlineIcon;
	exports.ArrowDownBoldIcon = ArrowDownBoldIcon;
	exports.ArrowDownBoxIcon = ArrowDownBoxIcon;
	exports.ArrowDownDropCircleOutlineIcon = ArrowDownDropCircleOutlineIcon;
	exports.ArrowDownDropCircleIcon = ArrowDownDropCircleIcon;
	exports.ArrowDownThickIcon = ArrowDownThickIcon;
	exports.ArrowDownIcon = ArrowDownIcon;
	exports.ArrowExpandAllIcon = ArrowExpandAllIcon;
	exports.ArrowExpandDownIcon = ArrowExpandDownIcon;
	exports.ArrowExpandHorizontalIcon = ArrowExpandHorizontalIcon;
	exports.ArrowExpandLeftIcon = ArrowExpandLeftIcon;
	exports.ArrowExpandRightIcon = ArrowExpandRightIcon;
	exports.ArrowExpandUpIcon = ArrowExpandUpIcon;
	exports.ArrowExpandVerticalIcon = ArrowExpandVerticalIcon;
	exports.ArrowExpandIcon = ArrowExpandIcon;
	exports.ArrowLeftBoldBoxOutlineIcon = ArrowLeftBoldBoxOutlineIcon;
	exports.ArrowLeftBoldBoxIcon = ArrowLeftBoldBoxIcon;
	exports.ArrowLeftBoldCircleOutlineIcon = ArrowLeftBoldCircleOutlineIcon;
	exports.ArrowLeftBoldCircleIcon = ArrowLeftBoldCircleIcon;
	exports.ArrowLeftBoldHexagonOutlineIcon = ArrowLeftBoldHexagonOutlineIcon;
	exports.ArrowLeftBoldIcon = ArrowLeftBoldIcon;
	exports.ArrowLeftBoxIcon = ArrowLeftBoxIcon;
	exports.ArrowLeftDropCircleOutlineIcon = ArrowLeftDropCircleOutlineIcon;
	exports.ArrowLeftDropCircleIcon = ArrowLeftDropCircleIcon;
	exports.ArrowLeftThickIcon = ArrowLeftThickIcon;
	exports.ArrowLeftIcon = ArrowLeftIcon;
	exports.ArrowRightBoldBoxOutlineIcon = ArrowRightBoldBoxOutlineIcon;
	exports.ArrowRightBoldBoxIcon = ArrowRightBoldBoxIcon;
	exports.ArrowRightBoldCircleOutlineIcon = ArrowRightBoldCircleOutlineIcon;
	exports.ArrowRightBoldCircleIcon = ArrowRightBoldCircleIcon;
	exports.ArrowRightBoldHexagonOutlineIcon = ArrowRightBoldHexagonOutlineIcon;
	exports.ArrowRightBoldIcon = ArrowRightBoldIcon;
	exports.ArrowRightBoxIcon = ArrowRightBoxIcon;
	exports.ArrowRightDropCircleOutlineIcon = ArrowRightDropCircleOutlineIcon;
	exports.ArrowRightDropCircleIcon = ArrowRightDropCircleIcon;
	exports.ArrowRightThickIcon = ArrowRightThickIcon;
	exports.ArrowRightIcon = ArrowRightIcon;
	exports.ArrowSplitHorizontalIcon = ArrowSplitHorizontalIcon;
	exports.ArrowSplitVerticalIcon = ArrowSplitVerticalIcon;
	exports.ArrowTopLeftIcon = ArrowTopLeftIcon;
	exports.ArrowTopRightIcon = ArrowTopRightIcon;
	exports.ArrowUpBoldBoxOutlineIcon = ArrowUpBoldBoxOutlineIcon;
	exports.ArrowUpBoldBoxIcon = ArrowUpBoldBoxIcon;
	exports.ArrowUpBoldCircleOutlineIcon = ArrowUpBoldCircleOutlineIcon;
	exports.ArrowUpBoldCircleIcon = ArrowUpBoldCircleIcon;
	exports.ArrowUpBoldHexagonOutlineIcon = ArrowUpBoldHexagonOutlineIcon;
	exports.ArrowUpBoldIcon = ArrowUpBoldIcon;
	exports.ArrowUpBoxIcon = ArrowUpBoxIcon;
	exports.ArrowUpDropCircleOutlineIcon = ArrowUpDropCircleOutlineIcon;
	exports.ArrowUpDropCircleIcon = ArrowUpDropCircleIcon;
	exports.ArrowUpThickIcon = ArrowUpThickIcon;
	exports.ArrowUpIcon = ArrowUpIcon;
	exports.ArtistIcon = ArtistIcon;
	exports.AssistantIcon = AssistantIcon;
	exports.AsteriskIcon = AsteriskIcon;
	exports.AtIcon = AtIcon;
	exports.AtlassianIcon = AtlassianIcon;
	exports.AtomIcon = AtomIcon;
	exports.AttachmentIcon = AttachmentIcon;
	exports.AudioVideoIcon = AudioVideoIcon;
	exports.AudiobookIcon = AudiobookIcon;
	exports.AugmentedRealityIcon = AugmentedRealityIcon;
	exports.AutoFixIcon = AutoFixIcon;
	exports.AutoUploadIcon = AutoUploadIcon;
	exports.AutorenewIcon = AutorenewIcon;
	exports.AvTimerIcon = AvTimerIcon;
	exports.AxeIcon = AxeIcon;
	exports.AzureIcon = AzureIcon;
	exports.BabyBuggyIcon = BabyBuggyIcon;
	exports.BabyIcon = BabyIcon;
	exports.BackburgerIcon = BackburgerIcon;
	exports.BackspaceIcon = BackspaceIcon;
	exports.BackupRestoreIcon = BackupRestoreIcon;
	exports.BadmintonIcon = BadmintonIcon;
	exports.BandcampIcon = BandcampIcon;
	exports.BankIcon = BankIcon;
	exports.BarcodeScanIcon = BarcodeScanIcon;
	exports.BarcodeIcon = BarcodeIcon;
	exports.BarleyIcon = BarleyIcon;
	exports.BarrelIcon = BarrelIcon;
	exports.BaseballBatIcon = BaseballBatIcon;
	exports.BaseballIcon = BaseballIcon;
	exports.BasecampIcon = BasecampIcon;
	exports.BasketFillIcon = BasketFillIcon;
	exports.BasketUnfillIcon = BasketUnfillIcon;
	exports.BasketIcon = BasketIcon;
	exports.BasketballIcon = BasketballIcon;
	exports.Battery10BluetoothIcon = Battery10BluetoothIcon;
	exports.Battery10Icon = Battery10Icon;
	exports.Battery20BluetoothIcon = Battery20BluetoothIcon;
	exports.Battery20Icon = Battery20Icon;
	exports.Battery30BluetoothIcon = Battery30BluetoothIcon;
	exports.Battery30Icon = Battery30Icon;
	exports.Battery40BluetoothIcon = Battery40BluetoothIcon;
	exports.Battery40Icon = Battery40Icon;
	exports.Battery50BluetoothIcon = Battery50BluetoothIcon;
	exports.Battery50Icon = Battery50Icon;
	exports.Battery60BluetoothIcon = Battery60BluetoothIcon;
	exports.Battery60Icon = Battery60Icon;
	exports.Battery70BluetoothIcon = Battery70BluetoothIcon;
	exports.Battery70Icon = Battery70Icon;
	exports.Battery80BluetoothIcon = Battery80BluetoothIcon;
	exports.Battery80Icon = Battery80Icon;
	exports.Battery90BluetoothIcon = Battery90BluetoothIcon;
	exports.Battery90Icon = Battery90Icon;
	exports.BatteryAlertBluetoothIcon = BatteryAlertBluetoothIcon;
	exports.BatteryAlertIcon = BatteryAlertIcon;
	exports.BatteryBluetoothVariantIcon = BatteryBluetoothVariantIcon;
	exports.BatteryBluetoothIcon = BatteryBluetoothIcon;
	exports.BatteryCharging10Icon = BatteryCharging10Icon;
	exports.BatteryCharging100Icon = BatteryCharging100Icon;
	exports.BatteryCharging20Icon = BatteryCharging20Icon;
	exports.BatteryCharging30Icon = BatteryCharging30Icon;
	exports.BatteryCharging40Icon = BatteryCharging40Icon;
	exports.BatteryCharging50Icon = BatteryCharging50Icon;
	exports.BatteryCharging60Icon = BatteryCharging60Icon;
	exports.BatteryCharging70Icon = BatteryCharging70Icon;
	exports.BatteryCharging80Icon = BatteryCharging80Icon;
	exports.BatteryCharging90Icon = BatteryCharging90Icon;
	exports.BatteryChargingOutlineIcon = BatteryChargingOutlineIcon;
	exports.BatteryChargingWireless10Icon = BatteryChargingWireless10Icon;
	exports.BatteryChargingWireless20Icon = BatteryChargingWireless20Icon;
	exports.BatteryChargingWireless30Icon = BatteryChargingWireless30Icon;
	exports.BatteryChargingWireless40Icon = BatteryChargingWireless40Icon;
	exports.BatteryChargingWireless50Icon = BatteryChargingWireless50Icon;
	exports.BatteryChargingWireless60Icon = BatteryChargingWireless60Icon;
	exports.BatteryChargingWireless70Icon = BatteryChargingWireless70Icon;
	exports.BatteryChargingWireless80Icon = BatteryChargingWireless80Icon;
	exports.BatteryChargingWireless90Icon = BatteryChargingWireless90Icon;
	exports.BatteryChargingWirelessAlertIcon = BatteryChargingWirelessAlertIcon;
	exports.BatteryChargingWirelessOutlineIcon = BatteryChargingWirelessOutlineIcon;
	exports.BatteryChargingWirelessIcon = BatteryChargingWirelessIcon;
	exports.BatteryChargingIcon = BatteryChargingIcon;
	exports.BatteryMinusIcon = BatteryMinusIcon;
	exports.BatteryNegativeIcon = BatteryNegativeIcon;
	exports.BatteryOutlineIcon = BatteryOutlineIcon;
	exports.BatteryPlusIcon = BatteryPlusIcon;
	exports.BatteryPositiveIcon = BatteryPositiveIcon;
	exports.BatteryUnknownBluetoothIcon = BatteryUnknownBluetoothIcon;
	exports.BatteryUnknownIcon = BatteryUnknownIcon;
	exports.BatteryIcon = BatteryIcon;
	exports.BeachIcon = BeachIcon;
	exports.BeakerIcon = BeakerIcon;
	exports.BeatsIcon = BeatsIcon;
	exports.BedEmptyIcon = BedEmptyIcon;
	exports.BeerIcon = BeerIcon;
	exports.BehanceIcon = BehanceIcon;
	exports.BellOffIcon = BellOffIcon;
	exports.BellOutlineIcon = BellOutlineIcon;
	exports.BellPlusIcon = BellPlusIcon;
	exports.BellRingOutlineIcon = BellRingOutlineIcon;
	exports.BellRingIcon = BellRingIcon;
	exports.BellSleepIcon = BellSleepIcon;
	exports.BellIcon = BellIcon;
	exports.BetaIcon = BetaIcon;
	exports.BibleIcon = BibleIcon;
	exports.BikeIcon = BikeIcon;
	exports.BingIcon = BingIcon;
	exports.BinocularsIcon = BinocularsIcon;
	exports.BioIcon = BioIcon;
	exports.BiohazardIcon = BiohazardIcon;
	exports.BitbucketIcon = BitbucketIcon;
	exports.BitcoinIcon = BitcoinIcon;
	exports.BlackMesaIcon = BlackMesaIcon;
	exports.BlackberryIcon = BlackberryIcon;
	exports.BlenderIcon = BlenderIcon;
	exports.BlindsIcon = BlindsIcon;
	exports.BlockHelperIcon = BlockHelperIcon;
	exports.BloggerIcon = BloggerIcon;
	exports.BluetoothAudioIcon = BluetoothAudioIcon;
	exports.BluetoothConnectIcon = BluetoothConnectIcon;
	exports.BluetoothOffIcon = BluetoothOffIcon;
	exports.BluetoothSettingsIcon = BluetoothSettingsIcon;
	exports.BluetoothTransferIcon = BluetoothTransferIcon;
	exports.BluetoothIcon = BluetoothIcon;
	exports.BlurLinearIcon = BlurLinearIcon;
	exports.BlurOffIcon = BlurOffIcon;
	exports.BlurRadialIcon = BlurRadialIcon;
	exports.BlurIcon = BlurIcon;
	exports.BombOffIcon = BombOffIcon;
	exports.BombIcon = BombIcon;
	exports.BoneIcon = BoneIcon;
	exports.BookMinusIcon = BookMinusIcon;
	exports.BookMultipleVariantIcon = BookMultipleVariantIcon;
	exports.BookMultipleIcon = BookMultipleIcon;
	exports.BookOpenPageVariantIcon = BookOpenPageVariantIcon;
	exports.BookOpenVariantIcon = BookOpenVariantIcon;
	exports.BookOpenIcon = BookOpenIcon;
	exports.BookPlusIcon = BookPlusIcon;
	exports.BookSecureIcon = BookSecureIcon;
	exports.BookUnsecureIcon = BookUnsecureIcon;
	exports.BookVariantIcon = BookVariantIcon;
	exports.BookIcon = BookIcon;
	exports.BookmarkCheckIcon = BookmarkCheckIcon;
	exports.BookmarkMusicIcon = BookmarkMusicIcon;
	exports.BookmarkOutlineIcon = BookmarkOutlineIcon;
	exports.BookmarkPlusOutlineIcon = BookmarkPlusOutlineIcon;
	exports.BookmarkPlusIcon = BookmarkPlusIcon;
	exports.BookmarkRemoveIcon = BookmarkRemoveIcon;
	exports.BookmarkIcon = BookmarkIcon;
	exports.BoomboxIcon = BoomboxIcon;
	exports.BootstrapIcon = BootstrapIcon;
	exports.BorderAllVariantIcon = BorderAllVariantIcon;
	exports.BorderAllIcon = BorderAllIcon;
	exports.BorderBottomVariantIcon = BorderBottomVariantIcon;
	exports.BorderBottomIcon = BorderBottomIcon;
	exports.BorderColorIcon = BorderColorIcon;
	exports.BorderHorizontalIcon = BorderHorizontalIcon;
	exports.BorderInsideIcon = BorderInsideIcon;
	exports.BorderLeftVariantIcon = BorderLeftVariantIcon;
	exports.BorderLeftIcon = BorderLeftIcon;
	exports.BorderNoneVariantIcon = BorderNoneVariantIcon;
	exports.BorderNoneIcon = BorderNoneIcon;
	exports.BorderOutsideIcon = BorderOutsideIcon;
	exports.BorderRightVariantIcon = BorderRightVariantIcon;
	exports.BorderRightIcon = BorderRightIcon;
	exports.BorderStyleIcon = BorderStyleIcon;
	exports.BorderTopVariantIcon = BorderTopVariantIcon;
	exports.BorderTopIcon = BorderTopIcon;
	exports.BorderVerticalIcon = BorderVerticalIcon;
	exports.BottleWineIcon = BottleWineIcon;
	exports.BowTieIcon = BowTieIcon;
	exports.BowlIcon = BowlIcon;
	exports.BowlingIcon = BowlingIcon;
	exports.BoxCutterIcon = BoxCutterIcon;
	exports.BoxShadowIcon = BoxShadowIcon;
	exports.BoxIcon = BoxIcon;
	exports.BridgeIcon = BridgeIcon;
	exports.BriefcaseCheckIcon = BriefcaseCheckIcon;
	exports.BriefcaseDownloadIcon = BriefcaseDownloadIcon;
	exports.BriefcaseOutlineIcon = BriefcaseOutlineIcon;
	exports.BriefcaseUploadIcon = BriefcaseUploadIcon;
	exports.BriefcaseIcon = BriefcaseIcon;
	exports.Brightness1Icon = Brightness1Icon;
	exports.Brightness2Icon = Brightness2Icon;
	exports.Brightness3Icon = Brightness3Icon;
	exports.Brightness4Icon = Brightness4Icon;
	exports.Brightness5Icon = Brightness5Icon;
	exports.Brightness6Icon = Brightness6Icon;
	exports.Brightness7Icon = Brightness7Icon;
	exports.BrightnessAutoIcon = BrightnessAutoIcon;
	exports.BroomIcon = BroomIcon;
	exports.BrushIcon = BrushIcon;
	exports.BuddhismIcon = BuddhismIcon;
	exports.BufferIcon = BufferIcon;
	exports.BugIcon = BugIcon;
	exports.BulletinBoardIcon = BulletinBoardIcon;
	exports.BullhornIcon = BullhornIcon;
	exports.BullseyeArrowIcon = BullseyeArrowIcon;
	exports.BullseyeIcon = BullseyeIcon;
	exports.BusArticulatedEndIcon = BusArticulatedEndIcon;
	exports.BusArticulatedFrontIcon = BusArticulatedFrontIcon;
	exports.BusClockIcon = BusClockIcon;
	exports.BusDoubleDeckerIcon = BusDoubleDeckerIcon;
	exports.BusSchoolIcon = BusSchoolIcon;
	exports.BusSideIcon = BusSideIcon;
	exports.BusIcon = BusIcon;
	exports.CachedIcon = CachedIcon;
	exports.CakeLayeredIcon = CakeLayeredIcon;
	exports.CakeVariantIcon = CakeVariantIcon;
	exports.CakeIcon = CakeIcon;
	exports.CalculatorIcon = CalculatorIcon;
	exports.CalendarBlankIcon = CalendarBlankIcon;
	exports.CalendarCheckIcon = CalendarCheckIcon;
	exports.CalendarClockIcon = CalendarClockIcon;
	exports.CalendarEditIcon = CalendarEditIcon;
	exports.CalendarMultipleCheckIcon = CalendarMultipleCheckIcon;
	exports.CalendarMultipleIcon = CalendarMultipleIcon;
	exports.CalendarPlusIcon = CalendarPlusIcon;
	exports.CalendarQuestionIcon = CalendarQuestionIcon;
	exports.CalendarRangeIcon = CalendarRangeIcon;
	exports.CalendarRemoveIcon = CalendarRemoveIcon;
	exports.CalendarSearchIcon = CalendarSearchIcon;
	exports.CalendarTextIcon = CalendarTextIcon;
	exports.CalendarTodayIcon = CalendarTodayIcon;
	exports.CalendarIcon = CalendarIcon;
	exports.CallMadeIcon = CallMadeIcon;
	exports.CallMergeIcon = CallMergeIcon;
	exports.CallMissedIcon = CallMissedIcon;
	exports.CallReceivedIcon = CallReceivedIcon;
	exports.CallSplitIcon = CallSplitIcon;
	exports.CamcorderBoxOffIcon = CamcorderBoxOffIcon;
	exports.CamcorderBoxIcon = CamcorderBoxIcon;
	exports.CamcorderOffIcon = CamcorderOffIcon;
	exports.CamcorderIcon = CamcorderIcon;
	exports.CameraAccountIcon = CameraAccountIcon;
	exports.CameraBurstIcon = CameraBurstIcon;
	exports.CameraEnhanceIcon = CameraEnhanceIcon;
	exports.CameraFrontVariantIcon = CameraFrontVariantIcon;
	exports.CameraFrontIcon = CameraFrontIcon;
	exports.CameraGoproIcon = CameraGoproIcon;
	exports.CameraImageIcon = CameraImageIcon;
	exports.CameraIrisIcon = CameraIrisIcon;
	exports.CameraMeteringCenterIcon = CameraMeteringCenterIcon;
	exports.CameraMeteringMatrixIcon = CameraMeteringMatrixIcon;
	exports.CameraMeteringPartialIcon = CameraMeteringPartialIcon;
	exports.CameraMeteringSpotIcon = CameraMeteringSpotIcon;
	exports.CameraOffIcon = CameraOffIcon;
	exports.CameraPartyModeIcon = CameraPartyModeIcon;
	exports.CameraRearVariantIcon = CameraRearVariantIcon;
	exports.CameraRearIcon = CameraRearIcon;
	exports.CameraSwitchIcon = CameraSwitchIcon;
	exports.CameraTimerIcon = CameraTimerIcon;
	exports.CameraIcon = CameraIcon;
	exports.CancelIcon = CancelIcon;
	exports.CandleIcon = CandleIcon;
	exports.CandycaneIcon = CandycaneIcon;
	exports.CannabisIcon = CannabisIcon;
	exports.CarBatteryIcon = CarBatteryIcon;
	exports.CarConnectedIcon = CarConnectedIcon;
	exports.CarConvertibleIcon = CarConvertibleIcon;
	exports.CarEstateIcon = CarEstateIcon;
	exports.CarHatchbackIcon = CarHatchbackIcon;
	exports.CarLimousineIcon = CarLimousineIcon;
	exports.CarPickupIcon = CarPickupIcon;
	exports.CarSideIcon = CarSideIcon;
	exports.CarSportsIcon = CarSportsIcon;
	exports.CarWashIcon = CarWashIcon;
	exports.CarIcon = CarIcon;
	exports.CaravanIcon = CaravanIcon;
	exports.CardsClubIcon = CardsClubIcon;
	exports.CardsDiamondIcon = CardsDiamondIcon;
	exports.CardsHeartIcon = CardsHeartIcon;
	exports.CardsOutlineIcon = CardsOutlineIcon;
	exports.CardsPlayingOutlineIcon = CardsPlayingOutlineIcon;
	exports.CardsSpadeIcon = CardsSpadeIcon;
	exports.CardsVariantIcon = CardsVariantIcon;
	exports.CardsIcon = CardsIcon;
	exports.CarrotIcon = CarrotIcon;
	exports.CartOffIcon = CartOffIcon;
	exports.CartOutlineIcon = CartOutlineIcon;
	exports.CartPlusIcon = CartPlusIcon;
	exports.CartIcon = CartIcon;
	exports.CaseSensitiveAltIcon = CaseSensitiveAltIcon;
	exports.Cash100Icon = Cash100Icon;
	exports.CashMultipleIcon = CashMultipleIcon;
	exports.CashUsdIcon = CashUsdIcon;
	exports.CashIcon = CashIcon;
	exports.CastConnectedIcon = CastConnectedIcon;
	exports.CastOffIcon = CastOffIcon;
	exports.CastIcon = CastIcon;
	exports.CastleIcon = CastleIcon;
	exports.CatIcon = CatIcon;
	exports.CctvIcon = CctvIcon;
	exports.CeilingLightIcon = CeilingLightIcon;
	exports.CellphoneAndroidIcon = CellphoneAndroidIcon;
	exports.CellphoneBasicIcon = CellphoneBasicIcon;
	exports.CellphoneDockIcon = CellphoneDockIcon;
	exports.CellphoneEraseIcon = CellphoneEraseIcon;
	exports.CellphoneIphoneIcon = CellphoneIphoneIcon;
	exports.CellphoneKeyIcon = CellphoneKeyIcon;
	exports.CellphoneLinkOffIcon = CellphoneLinkOffIcon;
	exports.CellphoneLinkIcon = CellphoneLinkIcon;
	exports.CellphoneLockIcon = CellphoneLockIcon;
	exports.CellphoneMessageIcon = CellphoneMessageIcon;
	exports.CellphoneOffIcon = CellphoneOffIcon;
	exports.CellphoneSettingsVariantIcon = CellphoneSettingsVariantIcon;
	exports.CellphoneSettingsIcon = CellphoneSettingsIcon;
	exports.CellphoneSoundIcon = CellphoneSoundIcon;
	exports.CellphoneTextIcon = CellphoneTextIcon;
	exports.CellphoneWirelessIcon = CellphoneWirelessIcon;
	exports.CellphoneIcon = CellphoneIcon;
	exports.CertificateIcon = CertificateIcon;
	exports.ChairSchoolIcon = ChairSchoolIcon;
	exports.ChartArcIcon = ChartArcIcon;
	exports.ChartAreasplineIcon = ChartAreasplineIcon;
	exports.ChartBarStackedIcon = ChartBarStackedIcon;
	exports.ChartBarIcon = ChartBarIcon;
	exports.ChartBubbleIcon = ChartBubbleIcon;
	exports.ChartDonutVariantIcon = ChartDonutVariantIcon;
	exports.ChartDonutIcon = ChartDonutIcon;
	exports.ChartGanttIcon = ChartGanttIcon;
	exports.ChartHistogramIcon = ChartHistogramIcon;
	exports.ChartLineStackedIcon = ChartLineStackedIcon;
	exports.ChartLineVariantIcon = ChartLineVariantIcon;
	exports.ChartLineIcon = ChartLineIcon;
	exports.ChartMultilineIcon = ChartMultilineIcon;
	exports.ChartPieIcon = ChartPieIcon;
	exports.ChartScatterplotHexbinIcon = ChartScatterplotHexbinIcon;
	exports.ChartTimelineIcon = ChartTimelineIcon;
	exports.CheckAllIcon = CheckAllIcon;
	exports.CheckCircleOutlineIcon = CheckCircleOutlineIcon;
	exports.CheckCircleIcon = CheckCircleIcon;
	exports.CheckOutlineIcon = CheckOutlineIcon;
	exports.CheckIcon = CheckIcon;
	exports.CheckboxBlankCircleOutlineIcon = CheckboxBlankCircleOutlineIcon;
	exports.CheckboxBlankCircleIcon = CheckboxBlankCircleIcon;
	exports.CheckboxBlankOutlineIcon = CheckboxBlankOutlineIcon;
	exports.CheckboxBlankIcon = CheckboxBlankIcon;
	exports.CheckboxIntermediateIcon = CheckboxIntermediateIcon;
	exports.CheckboxMarkedCircleOutlineIcon = CheckboxMarkedCircleOutlineIcon;
	exports.CheckboxMarkedCircleIcon = CheckboxMarkedCircleIcon;
	exports.CheckboxMarkedOutlineIcon = CheckboxMarkedOutlineIcon;
	exports.CheckboxMarkedIcon = CheckboxMarkedIcon;
	exports.CheckboxMultipleBlankCircleOutlineIcon = CheckboxMultipleBlankCircleOutlineIcon;
	exports.CheckboxMultipleBlankCircleIcon = CheckboxMultipleBlankCircleIcon;
	exports.CheckboxMultipleBlankOutlineIcon = CheckboxMultipleBlankOutlineIcon;
	exports.CheckboxMultipleBlankIcon = CheckboxMultipleBlankIcon;
	exports.CheckboxMultipleMarkedCircleOutlineIcon = CheckboxMultipleMarkedCircleOutlineIcon;
	exports.CheckboxMultipleMarkedCircleIcon = CheckboxMultipleMarkedCircleIcon;
	exports.CheckboxMultipleMarkedOutlineIcon = CheckboxMultipleMarkedOutlineIcon;
	exports.CheckboxMultipleMarkedIcon = CheckboxMultipleMarkedIcon;
	exports.CheckerboardIcon = CheckerboardIcon;
	exports.ChemicalWeaponIcon = ChemicalWeaponIcon;
	exports.ChessBishopIcon = ChessBishopIcon;
	exports.ChessKingIcon = ChessKingIcon;
	exports.ChessKnightIcon = ChessKnightIcon;
	exports.ChessPawnIcon = ChessPawnIcon;
	exports.ChessQueenIcon = ChessQueenIcon;
	exports.ChessRookIcon = ChessRookIcon;
	exports.ChevronDoubleDownIcon = ChevronDoubleDownIcon;
	exports.ChevronDoubleLeftIcon = ChevronDoubleLeftIcon;
	exports.ChevronDoubleRightIcon = ChevronDoubleRightIcon;
	exports.ChevronDoubleUpIcon = ChevronDoubleUpIcon;
	exports.ChevronDownIcon = ChevronDownIcon;
	exports.ChevronLeftIcon = ChevronLeftIcon;
	exports.ChevronRightIcon = ChevronRightIcon;
	exports.ChevronUpIcon = ChevronUpIcon;
	exports.ChiliHotIcon = ChiliHotIcon;
	exports.ChiliMediumIcon = ChiliMediumIcon;
	exports.ChiliMildIcon = ChiliMildIcon;
	exports.ChipIcon = ChipIcon;
	exports.ChristiantiyIcon = ChristiantiyIcon;
	exports.ChurchIcon = ChurchIcon;
	exports.CircleEditOutlineIcon = CircleEditOutlineIcon;
	exports.CircleOutlineIcon = CircleOutlineIcon;
	exports.CircleIcon = CircleIcon;
	exports.CiscoWebexIcon = CiscoWebexIcon;
	exports.CityIcon = CityIcon;
	exports.ClipboardAccountIcon = ClipboardAccountIcon;
	exports.ClipboardAlertIcon = ClipboardAlertIcon;
	exports.ClipboardArrowDownIcon = ClipboardArrowDownIcon;
	exports.ClipboardArrowLeftIcon = ClipboardArrowLeftIcon;
	exports.ClipboardCheckOutlineIcon = ClipboardCheckOutlineIcon;
	exports.ClipboardCheckIcon = ClipboardCheckIcon;
	exports.ClipboardFlowIcon = ClipboardFlowIcon;
	exports.ClipboardOutlineIcon = ClipboardOutlineIcon;
	exports.ClipboardPlusIcon = ClipboardPlusIcon;
	exports.ClipboardPulseOutlineIcon = ClipboardPulseOutlineIcon;
	exports.ClipboardPulseIcon = ClipboardPulseIcon;
	exports.ClipboardTextIcon = ClipboardTextIcon;
	exports.ClipboardIcon = ClipboardIcon;
	exports.ClippyIcon = ClippyIcon;
	exports.ClockAlertOutlineIcon = ClockAlertOutlineIcon;
	exports.ClockAlertIcon = ClockAlertIcon;
	exports.ClockEndIcon = ClockEndIcon;
	exports.ClockFastIcon = ClockFastIcon;
	exports.ClockInIcon = ClockInIcon;
	exports.ClockOutIcon = ClockOutIcon;
	exports.ClockOutlineIcon = ClockOutlineIcon;
	exports.ClockStartIcon = ClockStartIcon;
	exports.ClockIcon = ClockIcon;
	exports.CloseBoxOutlineIcon = CloseBoxOutlineIcon;
	exports.CloseBoxIcon = CloseBoxIcon;
	exports.CloseCircleOutlineIcon = CloseCircleOutlineIcon;
	exports.CloseCircleIcon = CloseCircleIcon;
	exports.CloseNetworkIcon = CloseNetworkIcon;
	exports.CloseOctagonOutlineIcon = CloseOctagonOutlineIcon;
	exports.CloseOctagonIcon = CloseOctagonIcon;
	exports.CloseOutlineIcon = CloseOutlineIcon;
	exports.CloseIcon = CloseIcon;
	exports.ClosedCaptionIcon = ClosedCaptionIcon;
	exports.CloudBracesIcon = CloudBracesIcon;
	exports.CloudCheckIcon = CloudCheckIcon;
	exports.CloudCircleIcon = CloudCircleIcon;
	exports.CloudDownloadIcon = CloudDownloadIcon;
	exports.CloudOffOutlineIcon = CloudOffOutlineIcon;
	exports.CloudOutlineIcon = CloudOutlineIcon;
	exports.CloudPrintOutlineIcon = CloudPrintOutlineIcon;
	exports.CloudPrintIcon = CloudPrintIcon;
	exports.CloudSearchOutlineIcon = CloudSearchOutlineIcon;
	exports.CloudSearchIcon = CloudSearchIcon;
	exports.CloudSyncIcon = CloudSyncIcon;
	exports.CloudTagsIcon = CloudTagsIcon;
	exports.CloudUploadIcon = CloudUploadIcon;
	exports.CloudIcon = CloudIcon;
	exports.CloverIcon = CloverIcon;
	exports.CodeArrayIcon = CodeArrayIcon;
	exports.CodeBracesIcon = CodeBracesIcon;
	exports.CodeBracketsIcon = CodeBracketsIcon;
	exports.CodeEqualIcon = CodeEqualIcon;
	exports.CodeGreaterThanOrEqualIcon = CodeGreaterThanOrEqualIcon;
	exports.CodeGreaterThanIcon = CodeGreaterThanIcon;
	exports.CodeLessThanOrEqualIcon = CodeLessThanOrEqualIcon;
	exports.CodeLessThanIcon = CodeLessThanIcon;
	exports.CodeNotEqualVariantIcon = CodeNotEqualVariantIcon;
	exports.CodeNotEqualIcon = CodeNotEqualIcon;
	exports.CodeParenthesesIcon = CodeParenthesesIcon;
	exports.CodeStringIcon = CodeStringIcon;
	exports.CodeTagsCheckIcon = CodeTagsCheckIcon;
	exports.CodeTagsIcon = CodeTagsIcon;
	exports.CodepenIcon = CodepenIcon;
	exports.CoffeeOutlineIcon = CoffeeOutlineIcon;
	exports.CoffeeToGoIcon = CoffeeToGoIcon;
	exports.CoffeeIcon = CoffeeIcon;
	exports.CogsIcon = CogsIcon;
	exports.CoinIcon = CoinIcon;
	exports.CoinsIcon = CoinsIcon;
	exports.CollageIcon = CollageIcon;
	exports.ColorHelperIcon = ColorHelperIcon;
	exports.CommentAccountOutlineIcon = CommentAccountOutlineIcon;
	exports.CommentAccountIcon = CommentAccountIcon;
	exports.CommentAlertOutlineIcon = CommentAlertOutlineIcon;
	exports.CommentAlertIcon = CommentAlertIcon;
	exports.CommentCheckOutlineIcon = CommentCheckOutlineIcon;
	exports.CommentCheckIcon = CommentCheckIcon;
	exports.CommentMultipleOutlineIcon = CommentMultipleOutlineIcon;
	exports.CommentMultipleIcon = CommentMultipleIcon;
	exports.CommentOutlineIcon = CommentOutlineIcon;
	exports.CommentPlusOutlineIcon = CommentPlusOutlineIcon;
	exports.CommentProcessingOutlineIcon = CommentProcessingOutlineIcon;
	exports.CommentProcessingIcon = CommentProcessingIcon;
	exports.CommentQuestionOutlineIcon = CommentQuestionOutlineIcon;
	exports.CommentQuestionIcon = CommentQuestionIcon;
	exports.CommentRemoveOutlineIcon = CommentRemoveOutlineIcon;
	exports.CommentRemoveIcon = CommentRemoveIcon;
	exports.CommentTextMultipleOutlineIcon = CommentTextMultipleOutlineIcon;
	exports.CommentTextMultipleIcon = CommentTextMultipleIcon;
	exports.CommentTextOutlineIcon = CommentTextOutlineIcon;
	exports.CommentTextIcon = CommentTextIcon;
	exports.CommentIcon = CommentIcon;
	exports.CompareIcon = CompareIcon;
	exports.CompassOutlineIcon = CompassOutlineIcon;
	exports.CompassIcon = CompassIcon;
	exports.ConsoleLineIcon = ConsoleLineIcon;
	exports.ConsoleNetworkIcon = ConsoleNetworkIcon;
	exports.ConsoleIcon = ConsoleIcon;
	exports.ContactMailIcon = ContactMailIcon;
	exports.ContactsIcon = ContactsIcon;
	exports.ContentCopyIcon = ContentCopyIcon;
	exports.ContentCutIcon = ContentCutIcon;
	exports.ContentDuplicateIcon = ContentDuplicateIcon;
	exports.ContentPasteIcon = ContentPasteIcon;
	exports.ContentSaveAllIcon = ContentSaveAllIcon;
	exports.ContentSaveOutlineIcon = ContentSaveOutlineIcon;
	exports.ContentSaveSettingsIcon = ContentSaveSettingsIcon;
	exports.ContentSaveIcon = ContentSaveIcon;
	exports.ContrastBoxIcon = ContrastBoxIcon;
	exports.ContrastCircleIcon = ContrastCircleIcon;
	exports.ContrastIcon = ContrastIcon;
	exports.CookieIcon = CookieIcon;
	exports.CopyrightIcon = CopyrightIcon;
	exports.CordovaIcon = CordovaIcon;
	exports.CornIcon = CornIcon;
	exports.CounterIcon = CounterIcon;
	exports.CowIcon = CowIcon;
	exports.CraneIcon = CraneIcon;
	exports.CreationIcon = CreationIcon;
	exports.CreditCardMultipleIcon = CreditCardMultipleIcon;
	exports.CreditCardOffIcon = CreditCardOffIcon;
	exports.CreditCardPlusIcon = CreditCardPlusIcon;
	exports.CreditCardScanIcon = CreditCardScanIcon;
	exports.CreditCardSettingsIcon = CreditCardSettingsIcon;
	exports.CreditCardIcon = CreditCardIcon;
	exports.CropFreeIcon = CropFreeIcon;
	exports.CropLandscapeIcon = CropLandscapeIcon;
	exports.CropPortraitIcon = CropPortraitIcon;
	exports.CropRotateIcon = CropRotateIcon;
	exports.CropSquareIcon = CropSquareIcon;
	exports.CropIcon = CropIcon;
	exports.CrosshairsGpsIcon = CrosshairsGpsIcon;
	exports.CrosshairsIcon = CrosshairsIcon;
	exports.CrownIcon = CrownIcon;
	exports.CryengineIcon = CryengineIcon;
	exports.CubeOutlineIcon = CubeOutlineIcon;
	exports.CubeSendIcon = CubeSendIcon;
	exports.CubeUnfoldedIcon = CubeUnfoldedIcon;
	exports.CubeIcon = CubeIcon;
	exports.CupOffIcon = CupOffIcon;
	exports.CupWaterIcon = CupWaterIcon;
	exports.CupIcon = CupIcon;
	exports.CupcakeIcon = CupcakeIcon;
	exports.CurlingIcon = CurlingIcon;
	exports.CurrencyBdtIcon = CurrencyBdtIcon;
	exports.CurrencyBtcIcon = CurrencyBtcIcon;
	exports.CurrencyChfIcon = CurrencyChfIcon;
	exports.CurrencyCnyIcon = CurrencyCnyIcon;
	exports.CurrencyEthIcon = CurrencyEthIcon;
	exports.CurrencyEurIcon = CurrencyEurIcon;
	exports.CurrencyGbpIcon = CurrencyGbpIcon;
	exports.CurrencyInrIcon = CurrencyInrIcon;
	exports.CurrencyJpyIcon = CurrencyJpyIcon;
	exports.CurrencyKrwIcon = CurrencyKrwIcon;
	exports.CurrencyKztIcon = CurrencyKztIcon;
	exports.CurrencyNgnIcon = CurrencyNgnIcon;
	exports.CurrencyRubIcon = CurrencyRubIcon;
	exports.CurrencySignIcon = CurrencySignIcon;
	exports.CurrencyTryIcon = CurrencyTryIcon;
	exports.CurrencyTwdIcon = CurrencyTwdIcon;
	exports.CurrencyUsdOffIcon = CurrencyUsdOffIcon;
	exports.CurrencyUsdIcon = CurrencyUsdIcon;
	exports.CurrentAcIcon = CurrentAcIcon;
	exports.CurrentDcIcon = CurrentDcIcon;
	exports.CursorDefaultOutlineIcon = CursorDefaultOutlineIcon;
	exports.CursorDefaultIcon = CursorDefaultIcon;
	exports.CursorMoveIcon = CursorMoveIcon;
	exports.CursorPointerIcon = CursorPointerIcon;
	exports.CursorTextIcon = CursorTextIcon;
	exports.DatabaseExportIcon = DatabaseExportIcon;
	exports.DatabaseImportIcon = DatabaseImportIcon;
	exports.DatabaseMinusIcon = DatabaseMinusIcon;
	exports.DatabasePlusIcon = DatabasePlusIcon;
	exports.DatabaseSearchIcon = DatabaseSearchIcon;
	exports.DatabaseIcon = DatabaseIcon;
	exports.DeathStarVariantIcon = DeathStarVariantIcon;
	exports.DeathStarIcon = DeathStarIcon;
	exports.DebianIcon = DebianIcon;
	exports.DebugStepIntoIcon = DebugStepIntoIcon;
	exports.DebugStepOutIcon = DebugStepOutIcon;
	exports.DebugStepOverIcon = DebugStepOverIcon;
	exports.DecagramOutlineIcon = DecagramOutlineIcon;
	exports.DecagramIcon = DecagramIcon;
	exports.DecimalDecreaseIcon = DecimalDecreaseIcon;
	exports.DecimalIncreaseIcon = DecimalIncreaseIcon;
	exports.DeleteCircleIcon = DeleteCircleIcon;
	exports.DeleteEmptyIcon = DeleteEmptyIcon;
	exports.DeleteForeverIcon = DeleteForeverIcon;
	exports.DeleteRestoreIcon = DeleteRestoreIcon;
	exports.DeleteSweepIcon = DeleteSweepIcon;
	exports.DeleteVariantIcon = DeleteVariantIcon;
	exports.DeleteIcon = DeleteIcon;
	exports.DeltaIcon = DeltaIcon;
	exports.DeskLampIcon = DeskLampIcon;
	exports.DeskphoneIcon = DeskphoneIcon;
	exports.DesktopClassicIcon = DesktopClassicIcon;
	exports.DesktopMacIcon = DesktopMacIcon;
	exports.DesktopTowerIcon = DesktopTowerIcon;
	exports.DetailsIcon = DetailsIcon;
	exports.DeveloperBoardIcon = DeveloperBoardIcon;
	exports.DeviantartIcon = DeviantartIcon;
	exports.DialpadIcon = DialpadIcon;
	exports.DiamondIcon = DiamondIcon;
	exports.Dice1Icon = Dice1Icon;
	exports.Dice2Icon = Dice2Icon;
	exports.Dice3Icon = Dice3Icon;
	exports.Dice4Icon = Dice4Icon;
	exports.Dice5Icon = Dice5Icon;
	exports.Dice6Icon = Dice6Icon;
	exports.DiceD10Icon = DiceD10Icon;
	exports.DiceD12Icon = DiceD12Icon;
	exports.DiceD20Icon = DiceD20Icon;
	exports.DiceD4Icon = DiceD4Icon;
	exports.DiceD6Icon = DiceD6Icon;
	exports.DiceD8Icon = DiceD8Icon;
	exports.DiceMultipleIcon = DiceMultipleIcon;
	exports.DictionaryIcon = DictionaryIcon;
	exports.DipSwitchIcon = DipSwitchIcon;
	exports.DirectionsForkIcon = DirectionsForkIcon;
	exports.DirectionsIcon = DirectionsIcon;
	exports.DiscordIcon = DiscordIcon;
	exports.DiskAlertIcon = DiskAlertIcon;
	exports.DiskPlayerIcon = DiskPlayerIcon;
	exports.DiskIcon = DiskIcon;
	exports.DisqusOutlineIcon = DisqusOutlineIcon;
	exports.DisqusIcon = DisqusIcon;
	exports.DivisionBoxIcon = DivisionBoxIcon;
	exports.DivisionIcon = DivisionIcon;
	exports.DnaIcon = DnaIcon;
	exports.DnsIcon = DnsIcon;
	exports.DoNotDisturbOffIcon = DoNotDisturbOffIcon;
	exports.DoNotDisturbIcon = DoNotDisturbIcon;
	exports.DockerIcon = DockerIcon;
	exports.DolbyIcon = DolbyIcon;
	exports.DomainIcon = DomainIcon;
	exports.DonkeyIcon = DonkeyIcon;
	exports.DoorClosedIcon = DoorClosedIcon;
	exports.DoorOpenIcon = DoorOpenIcon;
	exports.DoorIcon = DoorIcon;
	exports.DoorbellVideoIcon = DoorbellVideoIcon;
	exports.DotsHorizontalCircleIcon = DotsHorizontalCircleIcon;
	exports.DotsHorizontalIcon = DotsHorizontalIcon;
	exports.DotsVerticalCircleIcon = DotsVerticalCircleIcon;
	exports.DotsVerticalIcon = DotsVerticalIcon;
	exports.DoubanIcon = DoubanIcon;
	exports.DownloadNetworkIcon = DownloadNetworkIcon;
	exports.DownloadIcon = DownloadIcon;
	exports.DragHorizontalIcon = DragHorizontalIcon;
	exports.DragVerticalIcon = DragVerticalIcon;
	exports.DragIcon = DragIcon;
	exports.DrawingBoxIcon = DrawingBoxIcon;
	exports.DrawingIcon = DrawingIcon;
	exports.DribbbleBoxIcon = DribbbleBoxIcon;
	exports.DribbbleIcon = DribbbleIcon;
	exports.DroneIcon = DroneIcon;
	exports.DropboxIcon = DropboxIcon;
	exports.DrupalIcon = DrupalIcon;
	exports.DuckIcon = DuckIcon;
	exports.DumbbellIcon = DumbbellIcon;
	exports.EarHearingIcon = EarHearingIcon;
	exports.EarthBoxOffIcon = EarthBoxOffIcon;
	exports.EarthBoxIcon = EarthBoxIcon;
	exports.EarthOffIcon = EarthOffIcon;
	exports.EarthIcon = EarthIcon;
	exports.EdgeIcon = EdgeIcon;
	exports.EjectIcon = EjectIcon;
	exports.ElephantIcon = ElephantIcon;
	exports.ElevationDeclineIcon = ElevationDeclineIcon;
	exports.ElevationRiseIcon = ElevationRiseIcon;
	exports.ElevatorIcon = ElevatorIcon;
	exports.EmailAlertIcon = EmailAlertIcon;
	exports.EmailOpenOutlineIcon = EmailOpenOutlineIcon;
	exports.EmailOpenIcon = EmailOpenIcon;
	exports.EmailOutlineIcon = EmailOutlineIcon;
	exports.EmailSearchOutlineIcon = EmailSearchOutlineIcon;
	exports.EmailSearchIcon = EmailSearchIcon;
	exports.EmailSecureIcon = EmailSecureIcon;
	exports.EmailVariantIcon = EmailVariantIcon;
	exports.EmailIcon = EmailIcon;
	exports.EmbyIcon = EmbyIcon;
	exports.EmoticonCoolIcon = EmoticonCoolIcon;
	exports.EmoticonDeadIcon = EmoticonDeadIcon;
	exports.EmoticonDevilIcon = EmoticonDevilIcon;
	exports.EmoticonExcitedIcon = EmoticonExcitedIcon;
	exports.EmoticonHappyIcon = EmoticonHappyIcon;
	exports.EmoticonNeutralIcon = EmoticonNeutralIcon;
	exports.EmoticonPoopIcon = EmoticonPoopIcon;
	exports.EmoticonSadIcon = EmoticonSadIcon;
	exports.EmoticonTongueIcon = EmoticonTongueIcon;
	exports.EmoticonIcon = EmoticonIcon;
	exports.EngineOutlineIcon = EngineOutlineIcon;
	exports.EngineIcon = EngineIcon;
	exports.EqualBoxIcon = EqualBoxIcon;
	exports.EqualIcon = EqualIcon;
	exports.EraserVariantIcon = EraserVariantIcon;
	exports.EraserIcon = EraserIcon;
	exports.EscalatorIcon = EscalatorIcon;
	exports.EthereumIcon = EthereumIcon;
	exports.EthernetCableOffIcon = EthernetCableOffIcon;
	exports.EthernetCableIcon = EthernetCableIcon;
	exports.EthernetIcon = EthernetIcon;
	exports.EtsyIcon = EtsyIcon;
	exports.EvStationIcon = EvStationIcon;
	exports.EventbriteIcon = EventbriteIcon;
	exports.EvernoteIcon = EvernoteIcon;
	exports.ExclamationIcon = ExclamationIcon;
	exports.ExitToAppIcon = ExitToAppIcon;
	exports.ExponentBoxIcon = ExponentBoxIcon;
	exports.ExponentIcon = ExponentIcon;
	exports.ExportIcon = ExportIcon;
	exports.EyeOffOutlineIcon = EyeOffOutlineIcon;
	exports.EyeOffIcon = EyeOffIcon;
	exports.EyeOutlineIcon = EyeOutlineIcon;
	exports.EyePlusOutlineIcon = EyePlusOutlineIcon;
	exports.EyePlusIcon = EyePlusIcon;
	exports.EyeSettingsOutlineIcon = EyeSettingsOutlineIcon;
	exports.EyeSettingsIcon = EyeSettingsIcon;
	exports.EyeIcon = EyeIcon;
	exports.EyedropperVariantIcon = EyedropperVariantIcon;
	exports.EyedropperIcon = EyedropperIcon;
	exports.FaceProfileIcon = FaceProfileIcon;
	exports.FaceIcon = FaceIcon;
	exports.FacebookBoxIcon = FacebookBoxIcon;
	exports.FacebookMessengerIcon = FacebookMessengerIcon;
	exports.FacebookIcon = FacebookIcon;
	exports.FactoryIcon = FactoryIcon;
	exports.FanOffIcon = FanOffIcon;
	exports.FanIcon = FanIcon;
	exports.FastForwardOutlineIcon = FastForwardOutlineIcon;
	exports.FastForwardIcon = FastForwardIcon;
	exports.FaxIcon = FaxIcon;
	exports.FeatherIcon = FeatherIcon;
	exports.FedoraIcon = FedoraIcon;
	exports.FerryIcon = FerryIcon;
	exports.FileAccountIcon = FileAccountIcon;
	exports.FileChartIcon = FileChartIcon;
	exports.FileCheckIcon = FileCheckIcon;
	exports.FileCloudIcon = FileCloudIcon;
	exports.FileCompareIcon = FileCompareIcon;
	exports.FileDelimitedIcon = FileDelimitedIcon;
	exports.FileDocumentBoxIcon = FileDocumentBoxIcon;
	exports.FileDocumentIcon = FileDocumentIcon;
	exports.FileDownloadOutlineIcon = FileDownloadOutlineIcon;
	exports.FileDownloadIcon = FileDownloadIcon;
	exports.FileExcelBoxIcon = FileExcelBoxIcon;
	exports.FileExcelIcon = FileExcelIcon;
	exports.FileExportIcon = FileExportIcon;
	exports.FileFindIcon = FileFindIcon;
	exports.FileHiddenIcon = FileHiddenIcon;
	exports.FileImageIcon = FileImageIcon;
	exports.FileImportIcon = FileImportIcon;
	exports.FileLockIcon = FileLockIcon;
	exports.FileMultipleIcon = FileMultipleIcon;
	exports.FileMusicIcon = FileMusicIcon;
	exports.FileOutlineIcon = FileOutlineIcon;
	exports.FilePdfBoxIcon = FilePdfBoxIcon;
	exports.FilePdfIcon = FilePdfIcon;
	exports.FilePercentIcon = FilePercentIcon;
	exports.FilePlusIcon = FilePlusIcon;
	exports.FilePowerpointBoxIcon = FilePowerpointBoxIcon;
	exports.FilePowerpointIcon = FilePowerpointIcon;
	exports.FilePresentationBoxIcon = FilePresentationBoxIcon;
	exports.FileQuestionIcon = FileQuestionIcon;
	exports.FileRestoreIcon = FileRestoreIcon;
	exports.FileSendIcon = FileSendIcon;
	exports.FileTreeIcon = FileTreeIcon;
	exports.FileUndoIcon = FileUndoIcon;
	exports.FileVideoIcon = FileVideoIcon;
	exports.FileWordBoxIcon = FileWordBoxIcon;
	exports.FileWordIcon = FileWordIcon;
	exports.FileXmlIcon = FileXmlIcon;
	exports.FileIcon = FileIcon;
	exports.FilmIcon = FilmIcon;
	exports.FilmstripOffIcon = FilmstripOffIcon;
	exports.FilmstripIcon = FilmstripIcon;
	exports.FilterOutlineIcon = FilterOutlineIcon;
	exports.FilterRemoveOutlineIcon = FilterRemoveOutlineIcon;
	exports.FilterRemoveIcon = FilterRemoveIcon;
	exports.FilterVariantIcon = FilterVariantIcon;
	exports.FilterIcon = FilterIcon;
	exports.FinanceIcon = FinanceIcon;
	exports.FindReplaceIcon = FindReplaceIcon;
	exports.FingerprintIcon = FingerprintIcon;
	exports.FireTruckIcon = FireTruckIcon;
	exports.FireIcon = FireIcon;
	exports.FirebaseIcon = FirebaseIcon;
	exports.FirefoxIcon = FirefoxIcon;
	exports.FishIcon = FishIcon;
	exports.FlagCheckeredIcon = FlagCheckeredIcon;
	exports.FlagOutlineIcon = FlagOutlineIcon;
	exports.FlagTriangleIcon = FlagTriangleIcon;
	exports.FlagVariantOutlineIcon = FlagVariantOutlineIcon;
	exports.FlagVariantIcon = FlagVariantIcon;
	exports.FlagIcon = FlagIcon;
	exports.FlashAutoIcon = FlashAutoIcon;
	exports.FlashCircleIcon = FlashCircleIcon;
	exports.FlashOffIcon = FlashOffIcon;
	exports.FlashOutlineIcon = FlashOutlineIcon;
	exports.FlashRedEyeIcon = FlashRedEyeIcon;
	exports.FlashIcon = FlashIcon;
	exports.FlashlightOffIcon = FlashlightOffIcon;
	exports.FlashlightIcon = FlashlightIcon;
	exports.FlaskEmptyOutlineIcon = FlaskEmptyOutlineIcon;
	exports.FlaskEmptyIcon = FlaskEmptyIcon;
	exports.FlaskOutlineIcon = FlaskOutlineIcon;
	exports.FlaskIcon = FlaskIcon;
	exports.FlattrIcon = FlattrIcon;
	exports.FlipToBackIcon = FlipToBackIcon;
	exports.FlipToFrontIcon = FlipToFrontIcon;
	exports.FloorLampIcon = FloorLampIcon;
	exports.FloorPlanIcon = FloorPlanIcon;
	exports.FloppyIcon = FloppyIcon;
	exports.FlowerIcon = FlowerIcon;
	exports.FolderAccountIcon = FolderAccountIcon;
	exports.FolderDownloadIcon = FolderDownloadIcon;
	exports.FolderEditIcon = FolderEditIcon;
	exports.FolderGoogleDriveIcon = FolderGoogleDriveIcon;
	exports.FolderImageIcon = FolderImageIcon;
	exports.FolderKeyNetworkIcon = FolderKeyNetworkIcon;
	exports.FolderKeyIcon = FolderKeyIcon;
	exports.FolderLockOpenIcon = FolderLockOpenIcon;
	exports.FolderLockIcon = FolderLockIcon;
	exports.FolderMoveIcon = FolderMoveIcon;
	exports.FolderMultipleImageIcon = FolderMultipleImageIcon;
	exports.FolderMultipleOutlineIcon = FolderMultipleOutlineIcon;
	exports.FolderMultipleIcon = FolderMultipleIcon;
	exports.FolderNetworkIcon = FolderNetworkIcon;
	exports.FolderOpenIcon = FolderOpenIcon;
	exports.FolderOutlineIcon = FolderOutlineIcon;
	exports.FolderPlusIcon = FolderPlusIcon;
	exports.FolderRemoveIcon = FolderRemoveIcon;
	exports.FolderSearchOutlineIcon = FolderSearchOutlineIcon;
	exports.FolderSearchIcon = FolderSearchIcon;
	exports.FolderStarIcon = FolderStarIcon;
	exports.FolderUploadIcon = FolderUploadIcon;
	exports.FolderIcon = FolderIcon;
	exports.FontAwesomeIcon = FontAwesomeIcon;
	exports.FoodAppleIcon = FoodAppleIcon;
	exports.FoodCroissantIcon = FoodCroissantIcon;
	exports.FoodForkDrinkIcon = FoodForkDrinkIcon;
	exports.FoodOffIcon = FoodOffIcon;
	exports.FoodVariantIcon = FoodVariantIcon;
	exports.FoodIcon = FoodIcon;
	exports.FootballAustralianIcon = FootballAustralianIcon;
	exports.FootballHelmetIcon = FootballHelmetIcon;
	exports.FootballIcon = FootballIcon;
	exports.ForkliftIcon = ForkliftIcon;
	exports.FormatAlignBottomIcon = FormatAlignBottomIcon;
	exports.FormatAlignCenterIcon = FormatAlignCenterIcon;
	exports.FormatAlignJustifyIcon = FormatAlignJustifyIcon;
	exports.FormatAlignLeftIcon = FormatAlignLeftIcon;
	exports.FormatAlignMiddleIcon = FormatAlignMiddleIcon;
	exports.FormatAlignRightIcon = FormatAlignRightIcon;
	exports.FormatAlignTopIcon = FormatAlignTopIcon;
	exports.FormatAnnotationPlusIcon = FormatAnnotationPlusIcon;
	exports.FormatBoldIcon = FormatBoldIcon;
	exports.FormatClearIcon = FormatClearIcon;
	exports.FormatColorFillIcon = FormatColorFillIcon;
	exports.FormatColorTextIcon = FormatColorTextIcon;
	exports.FormatColumnsIcon = FormatColumnsIcon;
	exports.FormatFloatCenterIcon = FormatFloatCenterIcon;
	exports.FormatFloatLeftIcon = FormatFloatLeftIcon;
	exports.FormatFloatNoneIcon = FormatFloatNoneIcon;
	exports.FormatFloatRightIcon = FormatFloatRightIcon;
	exports.FormatFontIcon = FormatFontIcon;
	exports.FormatHeader1Icon = FormatHeader1Icon;
	exports.FormatHeader2Icon = FormatHeader2Icon;
	exports.FormatHeader3Icon = FormatHeader3Icon;
	exports.FormatHeader4Icon = FormatHeader4Icon;
	exports.FormatHeader5Icon = FormatHeader5Icon;
	exports.FormatHeader6Icon = FormatHeader6Icon;
	exports.FormatHeaderDecreaseIcon = FormatHeaderDecreaseIcon;
	exports.FormatHeaderEqualIcon = FormatHeaderEqualIcon;
	exports.FormatHeaderIncreaseIcon = FormatHeaderIncreaseIcon;
	exports.FormatHeaderPoundIcon = FormatHeaderPoundIcon;
	exports.FormatHorizontalAlignCenterIcon = FormatHorizontalAlignCenterIcon;
	exports.FormatHorizontalAlignLeftIcon = FormatHorizontalAlignLeftIcon;
	exports.FormatHorizontalAlignRightIcon = FormatHorizontalAlignRightIcon;
	exports.FormatIndentDecreaseIcon = FormatIndentDecreaseIcon;
	exports.FormatIndentIncreaseIcon = FormatIndentIncreaseIcon;
	exports.FormatItalicIcon = FormatItalicIcon;
	exports.FormatLineSpacingIcon = FormatLineSpacingIcon;
	exports.FormatLineStyleIcon = FormatLineStyleIcon;
	exports.FormatLineWeightIcon = FormatLineWeightIcon;
	exports.FormatListBulletedTypeIcon = FormatListBulletedTypeIcon;
	exports.FormatListBulletedIcon = FormatListBulletedIcon;
	exports.FormatListCheckboxIcon = FormatListCheckboxIcon;
	exports.FormatListChecksIcon = FormatListChecksIcon;
	exports.FormatListNumbersIcon = FormatListNumbersIcon;
	exports.FormatPageBreakIcon = FormatPageBreakIcon;
	exports.FormatPaintIcon = FormatPaintIcon;
	exports.FormatParagraphIcon = FormatParagraphIcon;
	exports.FormatPilcrowIcon = FormatPilcrowIcon;
	exports.FormatQuoteCloseIcon = FormatQuoteCloseIcon;
	exports.FormatQuoteOpenIcon = FormatQuoteOpenIcon;
	exports.FormatRotate90Icon = FormatRotate90Icon;
	exports.FormatSectionIcon = FormatSectionIcon;
	exports.FormatSizeIcon = FormatSizeIcon;
	exports.FormatStrikethroughVariantIcon = FormatStrikethroughVariantIcon;
	exports.FormatStrikethroughIcon = FormatStrikethroughIcon;
	exports.FormatSubscriptIcon = FormatSubscriptIcon;
	exports.FormatSuperscriptIcon = FormatSuperscriptIcon;
	exports.FormatTextIcon = FormatTextIcon;
	exports.FormatTextdirectionLToRIcon = FormatTextdirectionLToRIcon;
	exports.FormatTextdirectionRToLIcon = FormatTextdirectionRToLIcon;
	exports.FormatTitleIcon = FormatTitleIcon;
	exports.FormatUnderlineIcon = FormatUnderlineIcon;
	exports.FormatVerticalAlignBottomIcon = FormatVerticalAlignBottomIcon;
	exports.FormatVerticalAlignCenterIcon = FormatVerticalAlignCenterIcon;
	exports.FormatVerticalAlignTopIcon = FormatVerticalAlignTopIcon;
	exports.FormatWrapInlineIcon = FormatWrapInlineIcon;
	exports.FormatWrapSquareIcon = FormatWrapSquareIcon;
	exports.FormatWrapTightIcon = FormatWrapTightIcon;
	exports.FormatWrapTopBottomIcon = FormatWrapTopBottomIcon;
	exports.ForumOutlineIcon = ForumOutlineIcon;
	exports.ForumIcon = ForumIcon;
	exports.ForwardIcon = ForwardIcon;
	exports.FountainIcon = FountainIcon;
	exports.FoursquareIcon = FoursquareIcon;
	exports.FreebsdIcon = FreebsdIcon;
	exports.FridgeFilledBottomIcon = FridgeFilledBottomIcon;
	exports.FridgeFilledTopIcon = FridgeFilledTopIcon;
	exports.FridgeFilledIcon = FridgeFilledIcon;
	exports.FridgeIcon = FridgeIcon;
	exports.FuelIcon = FuelIcon;
	exports.FullscreenExitIcon = FullscreenExitIcon;
	exports.FullscreenIcon = FullscreenIcon;
	exports.FunctionVariantIcon = FunctionVariantIcon;
	exports.FunctionIcon = FunctionIcon;
	exports.GamepadVariantIcon = GamepadVariantIcon;
	exports.GamepadIcon = GamepadIcon;
	exports.GarageAlertIcon = GarageAlertIcon;
	exports.GarageOpenIcon = GarageOpenIcon;
	exports.GarageIcon = GarageIcon;
	exports.GasCylinderIcon = GasCylinderIcon;
	exports.GasStationIcon = GasStationIcon;
	exports.GateAndIcon = GateAndIcon;
	exports.GateNandIcon = GateNandIcon;
	exports.GateNorIcon = GateNorIcon;
	exports.GateNotIcon = GateNotIcon;
	exports.GateOrIcon = GateOrIcon;
	exports.GateXnorIcon = GateXnorIcon;
	exports.GateXorIcon = GateXorIcon;
	exports.GateIcon = GateIcon;
	exports.GaugeEmptyIcon = GaugeEmptyIcon;
	exports.GaugeFullIcon = GaugeFullIcon;
	exports.GaugeLowIcon = GaugeLowIcon;
	exports.GaugeIcon = GaugeIcon;
	exports.GavelIcon = GavelIcon;
	exports.GenderFemaleIcon = GenderFemaleIcon;
	exports.GenderMaleFemaleIcon = GenderMaleFemaleIcon;
	exports.GenderMaleIcon = GenderMaleIcon;
	exports.GenderTransgenderIcon = GenderTransgenderIcon;
	exports.GentooIcon = GentooIcon;
	exports.GestureDoubleTapIcon = GestureDoubleTapIcon;
	exports.GestureSwipeDownIcon = GestureSwipeDownIcon;
	exports.GestureSwipeLeftIcon = GestureSwipeLeftIcon;
	exports.GestureSwipeRightIcon = GestureSwipeRightIcon;
	exports.GestureSwipeUpIcon = GestureSwipeUpIcon;
	exports.GestureTapIcon = GestureTapIcon;
	exports.GestureTwoDoubleTapIcon = GestureTwoDoubleTapIcon;
	exports.GestureTwoTapIcon = GestureTwoTapIcon;
	exports.GestureIcon = GestureIcon;
	exports.GhostIcon = GhostIcon;
	exports.GiftIcon = GiftIcon;
	exports.GitIcon = GitIcon;
	exports.GithubBoxIcon = GithubBoxIcon;
	exports.GithubCircleIcon = GithubCircleIcon;
	exports.GithubFaceIcon = GithubFaceIcon;
	exports.GlassCocktailIcon = GlassCocktailIcon;
	exports.GlassFluteIcon = GlassFluteIcon;
	exports.GlassMugIcon = GlassMugIcon;
	exports.GlassStangeIcon = GlassStangeIcon;
	exports.GlassTulipIcon = GlassTulipIcon;
	exports.GlassWineIcon = GlassWineIcon;
	exports.GlassdoorIcon = GlassdoorIcon;
	exports.GlassesIcon = GlassesIcon;
	exports.GlobeModelIcon = GlobeModelIcon;
	exports.GmailIcon = GmailIcon;
	exports.GnomeIcon = GnomeIcon;
	exports.GolfIcon = GolfIcon;
	exports.GondolaIcon = GondolaIcon;
	exports.GoogleAlloIcon = GoogleAlloIcon;
	exports.GoogleAnalyticsIcon = GoogleAnalyticsIcon;
	exports.GoogleAssistantIcon = GoogleAssistantIcon;
	exports.GoogleCardboardIcon = GoogleCardboardIcon;
	exports.GoogleChromeIcon = GoogleChromeIcon;
	exports.GoogleCirclesCommunitiesIcon = GoogleCirclesCommunitiesIcon;
	exports.GoogleCirclesExtendedIcon = GoogleCirclesExtendedIcon;
	exports.GoogleCirclesGroupIcon = GoogleCirclesGroupIcon;
	exports.GoogleCirclesIcon = GoogleCirclesIcon;
	exports.GoogleControllerOffIcon = GoogleControllerOffIcon;
	exports.GoogleControllerIcon = GoogleControllerIcon;
	exports.GoogleDriveIcon = GoogleDriveIcon;
	exports.GoogleEarthIcon = GoogleEarthIcon;
	exports.GoogleFitIcon = GoogleFitIcon;
	exports.GoogleGlassIcon = GoogleGlassIcon;
	exports.GoogleHangoutsIcon = GoogleHangoutsIcon;
	exports.GoogleHomeIcon = GoogleHomeIcon;
	exports.GoogleKeepIcon = GoogleKeepIcon;
	exports.GoogleMapsIcon = GoogleMapsIcon;
	exports.GoogleNearbyIcon = GoogleNearbyIcon;
	exports.GooglePagesIcon = GooglePagesIcon;
	exports.GooglePhotosIcon = GooglePhotosIcon;
	exports.GooglePhysicalWebIcon = GooglePhysicalWebIcon;
	exports.GooglePlayIcon = GooglePlayIcon;
	exports.GooglePlusBoxIcon = GooglePlusBoxIcon;
	exports.GooglePlusIcon = GooglePlusIcon;
	exports.GoogleTranslateIcon = GoogleTranslateIcon;
	exports.GoogleWalletIcon = GoogleWalletIcon;
	exports.GoogleIcon = GoogleIcon;
	exports.GpuIcon = GpuIcon;
	exports.GradientIcon = GradientIcon;
	exports.GraphqlIcon = GraphqlIcon;
	exports.GreasePencilIcon = GreasePencilIcon;
	exports.GreaterThanOrEqualIcon = GreaterThanOrEqualIcon;
	exports.GreaterThanIcon = GreaterThanIcon;
	exports.GridLargeIcon = GridLargeIcon;
	exports.GridOffIcon = GridOffIcon;
	exports.GridIcon = GridIcon;
	exports.GroupIcon = GroupIcon;
	exports.GuitarAcousticIcon = GuitarAcousticIcon;
	exports.GuitarElectricIcon = GuitarElectricIcon;
	exports.GuitarPickOutlineIcon = GuitarPickOutlineIcon;
	exports.GuitarPickIcon = GuitarPickIcon;
	exports.GuyFawkesMaskIcon = GuyFawkesMaskIcon;
	exports.HackernewsIcon = HackernewsIcon;
	exports.HamburgerIcon = HamburgerIcon;
	exports.HammerIcon = HammerIcon;
	exports.HandPointingRightIcon = HandPointingRightIcon;
	exports.HangerIcon = HangerIcon;
	exports.HardHatIcon = HardHatIcon;
	exports.HarddiskIcon = HarddiskIcon;
	exports.HeadphonesBluetoothIcon = HeadphonesBluetoothIcon;
	exports.HeadphonesBoxIcon = HeadphonesBoxIcon;
	exports.HeadphonesOffIcon = HeadphonesOffIcon;
	exports.HeadphonesSettingsIcon = HeadphonesSettingsIcon;
	exports.HeadphonesIcon = HeadphonesIcon;
	exports.HeadsetDockIcon = HeadsetDockIcon;
	exports.HeadsetOffIcon = HeadsetOffIcon;
	exports.HeadsetIcon = HeadsetIcon;
	exports.HeartBoxOutlineIcon = HeartBoxOutlineIcon;
	exports.HeartBoxIcon = HeartBoxIcon;
	exports.HeartBrokenIcon = HeartBrokenIcon;
	exports.HeartCircleOutlineIcon = HeartCircleOutlineIcon;
	exports.HeartCircleIcon = HeartCircleIcon;
	exports.HeartHalfFullIcon = HeartHalfFullIcon;
	exports.HeartHalfOutlineIcon = HeartHalfOutlineIcon;
	exports.HeartHalfIcon = HeartHalfIcon;
	exports.HeartOffIcon = HeartOffIcon;
	exports.HeartOutlineIcon = HeartOutlineIcon;
	exports.HeartPulseIcon = HeartPulseIcon;
	exports.HeartIcon = HeartIcon;
	exports.HelpBoxIcon = HelpBoxIcon;
	exports.HelpCircleOutlineIcon = HelpCircleOutlineIcon;
	exports.HelpCircleIcon = HelpCircleIcon;
	exports.HelpNetworkIcon = HelpNetworkIcon;
	exports.HelpIcon = HelpIcon;
	exports.HexagonMultipleIcon = HexagonMultipleIcon;
	exports.HexagonOutlineIcon = HexagonOutlineIcon;
	exports.HexagonIcon = HexagonIcon;
	exports.HighDefinitionBoxIcon = HighDefinitionBoxIcon;
	exports.HighDefinitionIcon = HighDefinitionIcon;
	exports.HighwayIcon = HighwayIcon;
	exports.HinduismIcon = HinduismIcon;
	exports.HistoryIcon = HistoryIcon;
	exports.HockeyPuckIcon = HockeyPuckIcon;
	exports.HockeySticksIcon = HockeySticksIcon;
	exports.HololensIcon = HololensIcon;
	exports.HomeAccountIcon = HomeAccountIcon;
	exports.HomeAlertIcon = HomeAlertIcon;
	exports.HomeAssistantIcon = HomeAssistantIcon;
	exports.HomeAutomationIcon = HomeAutomationIcon;
	exports.HomeCircleIcon = HomeCircleIcon;
	exports.HomeCurrencyUsdIcon = HomeCurrencyUsdIcon;
	exports.HomeHeartIcon = HomeHeartIcon;
	exports.HomeLockOpenIcon = HomeLockOpenIcon;
	exports.HomeLockIcon = HomeLockIcon;
	exports.HomeMapMarkerIcon = HomeMapMarkerIcon;
	exports.HomeMinusIcon = HomeMinusIcon;
	exports.HomeModernIcon = HomeModernIcon;
	exports.HomeOutlineIcon = HomeOutlineIcon;
	exports.HomePlusIcon = HomePlusIcon;
	exports.HomeVariantIcon = HomeVariantIcon;
	exports.HomeIcon = HomeIcon;
	exports.HookOffIcon = HookOffIcon;
	exports.HookIcon = HookIcon;
	exports.HopsIcon = HopsIcon;
	exports.HospitalBuildingIcon = HospitalBuildingIcon;
	exports.HospitalMarkerIcon = HospitalMarkerIcon;
	exports.HospitalIcon = HospitalIcon;
	exports.HotTubIcon = HotTubIcon;
	exports.HotelIcon = HotelIcon;
	exports.HouzzBoxIcon = HouzzBoxIcon;
	exports.HouzzIcon = HouzzIcon;
	exports.HuluIcon = HuluIcon;
	exports.HumanChildIcon = HumanChildIcon;
	exports.HumanFemaleIcon = HumanFemaleIcon;
	exports.HumanGreetingIcon = HumanGreetingIcon;
	exports.HumanHandsdownIcon = HumanHandsdownIcon;
	exports.HumanHandsupIcon = HumanHandsupIcon;
	exports.HumanMaleFemaleIcon = HumanMaleFemaleIcon;
	exports.HumanMaleIcon = HumanMaleIcon;
	exports.HumanPregnantIcon = HumanPregnantIcon;
	exports.HumanIcon = HumanIcon;
	exports.HumbleBundleIcon = HumbleBundleIcon;
	exports.IceCreamIcon = IceCreamIcon;
	exports.ImageAlbumIcon = ImageAlbumIcon;
	exports.ImageAreaCloseIcon = ImageAreaCloseIcon;
	exports.ImageAreaIcon = ImageAreaIcon;
	exports.ImageBrokenVariantIcon = ImageBrokenVariantIcon;
	exports.ImageBrokenIcon = ImageBrokenIcon;
	exports.ImageFilterBlackWhiteIcon = ImageFilterBlackWhiteIcon;
	exports.ImageFilterCenterFocusWeakIcon = ImageFilterCenterFocusWeakIcon;
	exports.ImageFilterCenterFocusIcon = ImageFilterCenterFocusIcon;
	exports.ImageFilterDramaIcon = ImageFilterDramaIcon;
	exports.ImageFilterFramesIcon = ImageFilterFramesIcon;
	exports.ImageFilterHdrIcon = ImageFilterHdrIcon;
	exports.ImageFilterNoneIcon = ImageFilterNoneIcon;
	exports.ImageFilterTiltShiftIcon = ImageFilterTiltShiftIcon;
	exports.ImageFilterVintageIcon = ImageFilterVintageIcon;
	exports.ImageFilterIcon = ImageFilterIcon;
	exports.ImageMultipleIcon = ImageMultipleIcon;
	exports.ImageOffIcon = ImageOffIcon;
	exports.ImageOutlineIcon = ImageOutlineIcon;
	exports.ImagePlusIcon = ImagePlusIcon;
	exports.ImageSearchOutlineIcon = ImageSearchOutlineIcon;
	exports.ImageSearchIcon = ImageSearchIcon;
	exports.ImageIcon = ImageIcon;
	exports.ImportIcon = ImportIcon;
	exports.InboxArrowDownIcon = InboxArrowDownIcon;
	exports.InboxArrowUpIcon = InboxArrowUpIcon;
	exports.InboxMultipleIcon = InboxMultipleIcon;
	exports.InboxIcon = InboxIcon;
	exports.IncognitoIcon = IncognitoIcon;
	exports.InfinityIcon = InfinityIcon;
	exports.InformationOutlineIcon = InformationOutlineIcon;
	exports.InformationVariantIcon = InformationVariantIcon;
	exports.InformationIcon = InformationIcon;
	exports.InstagramIcon = InstagramIcon;
	exports.InstapaperIcon = InstapaperIcon;
	exports.InternetExplorerIcon = InternetExplorerIcon;
	exports.InvertColorsIcon = InvertColorsIcon;
	exports.IslamIcon = IslamIcon;
	exports.ItunesIcon = ItunesIcon;
	exports.JeepneyIcon = JeepneyIcon;
	exports.JiraIcon = JiraIcon;
	exports.JqueryIcon = JqueryIcon;
	exports.JsfiddleIcon = JsfiddleIcon;
	exports.JsonIcon = JsonIcon;
	exports.JudaismIcon = JudaismIcon;
	exports.KarateIcon = KarateIcon;
	exports.KegIcon = KegIcon;
	exports.KettleIcon = KettleIcon;
	exports.KeyChangeIcon = KeyChangeIcon;
	exports.KeyMinusIcon = KeyMinusIcon;
	exports.KeyPlusIcon = KeyPlusIcon;
	exports.KeyRemoveIcon = KeyRemoveIcon;
	exports.KeyVariantIcon = KeyVariantIcon;
	exports.KeyIcon = KeyIcon;
	exports.KeyboardBackspaceIcon = KeyboardBackspaceIcon;
	exports.KeyboardCapsIcon = KeyboardCapsIcon;
	exports.KeyboardCloseIcon = KeyboardCloseIcon;
	exports.KeyboardOffIcon = KeyboardOffIcon;
	exports.KeyboardOutlineIcon = KeyboardOutlineIcon;
	exports.KeyboardReturnIcon = KeyboardReturnIcon;
	exports.KeyboardTabIcon = KeyboardTabIcon;
	exports.KeyboardVariantIcon = KeyboardVariantIcon;
	exports.KeyboardIcon = KeyboardIcon;
	exports.KickstarterIcon = KickstarterIcon;
	exports.KodiIcon = KodiIcon;
	exports.LabelOutlineIcon = LabelOutlineIcon;
	exports.LabelIcon = LabelIcon;
	exports.LadybugIcon = LadybugIcon;
	exports.LambdaIcon = LambdaIcon;
	exports.LampIcon = LampIcon;
	exports.LanConnectIcon = LanConnectIcon;
	exports.LanDisconnectIcon = LanDisconnectIcon;
	exports.LanPendingIcon = LanPendingIcon;
	exports.LanIcon = LanIcon;
	exports.LanguageCIcon = LanguageCIcon;
	exports.LanguageCppIcon = LanguageCppIcon;
	exports.LanguageCsharpIcon = LanguageCsharpIcon;
	exports.LanguageCss3Icon = LanguageCss3Icon;
	exports.LanguageGoIcon = LanguageGoIcon;
	exports.LanguageHtml5Icon = LanguageHtml5Icon;
	exports.LanguageJavascriptIcon = LanguageJavascriptIcon;
	exports.LanguageLuaIcon = LanguageLuaIcon;
	exports.LanguagePhpIcon = LanguagePhpIcon;
	exports.LanguagePythonTextIcon = LanguagePythonTextIcon;
	exports.LanguagePythonIcon = LanguagePythonIcon;
	exports.LanguageRIcon = LanguageRIcon;
	exports.LanguageSwiftIcon = LanguageSwiftIcon;
	exports.LanguageTypescriptIcon = LanguageTypescriptIcon;
	exports.LaptopChromebookIcon = LaptopChromebookIcon;
	exports.LaptopMacIcon = LaptopMacIcon;
	exports.LaptopOffIcon = LaptopOffIcon;
	exports.LaptopWindowsIcon = LaptopWindowsIcon;
	exports.LaptopIcon = LaptopIcon;
	exports.LastfmIcon = LastfmIcon;
	exports.LastpassIcon = LastpassIcon;
	exports.LaunchIcon = LaunchIcon;
	exports.LavaLampIcon = LavaLampIcon;
	exports.LayersOffIcon = LayersOffIcon;
	exports.LayersIcon = LayersIcon;
	exports.LeadPencilIcon = LeadPencilIcon;
	exports.LeafIcon = LeafIcon;
	exports.LedOffIcon = LedOffIcon;
	exports.LedOnIcon = LedOnIcon;
	exports.LedOutlineIcon = LedOutlineIcon;
	exports.LedStripIcon = LedStripIcon;
	exports.LedVariantOffIcon = LedVariantOffIcon;
	exports.LedVariantOnIcon = LedVariantOnIcon;
	exports.LedVariantOutlineIcon = LedVariantOutlineIcon;
	exports.LessThanOrEqualIcon = LessThanOrEqualIcon;
	exports.LessThanIcon = LessThanIcon;
	exports.LibraryBooksIcon = LibraryBooksIcon;
	exports.LibraryMusicIcon = LibraryMusicIcon;
	exports.LibraryPlusIcon = LibraryPlusIcon;
	exports.LibraryIcon = LibraryIcon;
	exports.LifebuoyIcon = LifebuoyIcon;
	exports.LightSwitchIcon = LightSwitchIcon;
	exports.LightbulbOnOutlineIcon = LightbulbOnOutlineIcon;
	exports.LightbulbOnIcon = LightbulbOnIcon;
	exports.LightbulbOutlineIcon = LightbulbOutlineIcon;
	exports.LightbulbIcon = LightbulbIcon;
	exports.LinkOffIcon = LinkOffIcon;
	exports.LinkVariantOffIcon = LinkVariantOffIcon;
	exports.LinkVariantIcon = LinkVariantIcon;
	exports.LinkIcon = LinkIcon;
	exports.LinkedinBoxIcon = LinkedinBoxIcon;
	exports.LinkedinIcon = LinkedinIcon;
	exports.LinuxMintIcon = LinuxMintIcon;
	exports.LinuxIcon = LinuxIcon;
	exports.LoadingIcon = LoadingIcon;
	exports.LockAlertIcon = LockAlertIcon;
	exports.LockClockIcon = LockClockIcon;
	exports.LockOpenOutlineIcon = LockOpenOutlineIcon;
	exports.LockOpenIcon = LockOpenIcon;
	exports.LockOutlineIcon = LockOutlineIcon;
	exports.LockPatternIcon = LockPatternIcon;
	exports.LockPlusIcon = LockPlusIcon;
	exports.LockQuestionIcon = LockQuestionIcon;
	exports.LockResetIcon = LockResetIcon;
	exports.LockSmartIcon = LockSmartIcon;
	exports.LockIcon = LockIcon;
	exports.LockerMultipleIcon = LockerMultipleIcon;
	exports.LockerIcon = LockerIcon;
	exports.LoginVariantIcon = LoginVariantIcon;
	exports.LoginIcon = LoginIcon;
	exports.LogoutVariantIcon = LogoutVariantIcon;
	exports.LogoutIcon = LogoutIcon;
	exports.LooksIcon = LooksIcon;
	exports.LoopIcon = LoopIcon;
	exports.LoupeIcon = LoupeIcon;
	exports.LumxIcon = LumxIcon;
	exports.MagnetOnIcon = MagnetOnIcon;
	exports.MagnetIcon = MagnetIcon;
	exports.MagnifyCloseIcon = MagnifyCloseIcon;
	exports.MagnifyMinusOutlineIcon = MagnifyMinusOutlineIcon;
	exports.MagnifyMinusIcon = MagnifyMinusIcon;
	exports.MagnifyPlusOutlineIcon = MagnifyPlusOutlineIcon;
	exports.MagnifyPlusIcon = MagnifyPlusIcon;
	exports.MagnifyIcon = MagnifyIcon;
	exports.MailRuIcon = MailRuIcon;
	exports.MailboxIcon = MailboxIcon;
	exports.MapMarkerCircleIcon = MapMarkerCircleIcon;
	exports.MapMarkerDistanceIcon = MapMarkerDistanceIcon;
	exports.MapMarkerMinusIcon = MapMarkerMinusIcon;
	exports.MapMarkerMultipleIcon = MapMarkerMultipleIcon;
	exports.MapMarkerOffIcon = MapMarkerOffIcon;
	exports.MapMarkerOutlineIcon = MapMarkerOutlineIcon;
	exports.MapMarkerPlusIcon = MapMarkerPlusIcon;
	exports.MapMarkerRadiusIcon = MapMarkerRadiusIcon;
	exports.MapMarkerIcon = MapMarkerIcon;
	exports.MapMinusIcon = MapMinusIcon;
	exports.MapOutlineIcon = MapOutlineIcon;
	exports.MapPlusIcon = MapPlusIcon;
	exports.MapSearchOutlineIcon = MapSearchOutlineIcon;
	exports.MapSearchIcon = MapSearchIcon;
	exports.MapIcon = MapIcon;
	exports.MarginIcon = MarginIcon;
	exports.MarkdownIcon = MarkdownIcon;
	exports.MarkerCheckIcon = MarkerCheckIcon;
	exports.MarkerIcon = MarkerIcon;
	exports.MaterialDesignIcon = MaterialDesignIcon;
	exports.MaterialUiIcon = MaterialUiIcon;
	exports.MathCompassIcon = MathCompassIcon;
	exports.MatrixIcon = MatrixIcon;
	exports.MaxcdnIcon = MaxcdnIcon;
	exports.MedalIcon = MedalIcon;
	exports.MedicalBagIcon = MedicalBagIcon;
	exports.MediumIcon = MediumIcon;
	exports.MemoryIcon = MemoryIcon;
	exports.MenuDownOutlineIcon = MenuDownOutlineIcon;
	exports.MenuDownIcon = MenuDownIcon;
	exports.MenuLeftIcon = MenuLeftIcon;
	exports.MenuRightIcon = MenuRightIcon;
	exports.MenuUpOutlineIcon = MenuUpOutlineIcon;
	exports.MenuUpIcon = MenuUpIcon;
	exports.MenuIcon = MenuIcon;
	exports.MessageAlertIcon = MessageAlertIcon;
	exports.MessageBulletedOffIcon = MessageBulletedOffIcon;
	exports.MessageBulletedIcon = MessageBulletedIcon;
	exports.MessageDrawIcon = MessageDrawIcon;
	exports.MessageImageIcon = MessageImageIcon;
	exports.MessageOutlineIcon = MessageOutlineIcon;
	exports.MessagePlusIcon = MessagePlusIcon;
	exports.MessageProcessingIcon = MessageProcessingIcon;
	exports.MessageReplyTextIcon = MessageReplyTextIcon;
	exports.MessageReplyIcon = MessageReplyIcon;
	exports.MessageSettingsVariantIcon = MessageSettingsVariantIcon;
	exports.MessageSettingsIcon = MessageSettingsIcon;
	exports.MessageTextOutlineIcon = MessageTextOutlineIcon;
	exports.MessageTextIcon = MessageTextIcon;
	exports.MessageVideoIcon = MessageVideoIcon;
	exports.MessageIcon = MessageIcon;
	exports.MeteorIcon = MeteorIcon;
	exports.MetronomeTickIcon = MetronomeTickIcon;
	exports.MetronomeIcon = MetronomeIcon;
	exports.MicroSdIcon = MicroSdIcon;
	exports.MicrophoneMinusIcon = MicrophoneMinusIcon;
	exports.MicrophoneOffIcon = MicrophoneOffIcon;
	exports.MicrophoneOutlineIcon = MicrophoneOutlineIcon;
	exports.MicrophonePlusIcon = MicrophonePlusIcon;
	exports.MicrophoneSettingsIcon = MicrophoneSettingsIcon;
	exports.MicrophoneVariantOffIcon = MicrophoneVariantOffIcon;
	exports.MicrophoneVariantIcon = MicrophoneVariantIcon;
	exports.MicrophoneIcon = MicrophoneIcon;
	exports.MicroscopeIcon = MicroscopeIcon;
	exports.MicrosoftDynamicsIcon = MicrosoftDynamicsIcon;
	exports.MicrosoftIcon = MicrosoftIcon;
	exports.MidiPortIcon = MidiPortIcon;
	exports.MidiIcon = MidiIcon;
	exports.MinecraftIcon = MinecraftIcon;
	exports.MinusBoxOutlineIcon = MinusBoxOutlineIcon;
	exports.MinusBoxIcon = MinusBoxIcon;
	exports.MinusCircleOutlineIcon = MinusCircleOutlineIcon;
	exports.MinusCircleIcon = MinusCircleIcon;
	exports.MinusNetworkIcon = MinusNetworkIcon;
	exports.MinusIcon = MinusIcon;
	exports.MixcloudIcon = MixcloudIcon;
	exports.MixedRealityIcon = MixedRealityIcon;
	exports.MixerIcon = MixerIcon;
	exports.MonitorCellphoneStarIcon = MonitorCellphoneStarIcon;
	exports.MonitorCellphoneIcon = MonitorCellphoneIcon;
	exports.MonitorMultipleIcon = MonitorMultipleIcon;
	exports.MonitorIcon = MonitorIcon;
	exports.MoreIcon = MoreIcon;
	exports.MotorbikeIcon = MotorbikeIcon;
	exports.MouseBluetoothIcon = MouseBluetoothIcon;
	exports.MouseOffIcon = MouseOffIcon;
	exports.MouseVariantOffIcon = MouseVariantOffIcon;
	exports.MouseVariantIcon = MouseVariantIcon;
	exports.MouseIcon = MouseIcon;
	exports.MoveResizeVariantIcon = MoveResizeVariantIcon;
	exports.MoveResizeIcon = MoveResizeIcon;
	exports.MovieRollIcon = MovieRollIcon;
	exports.MovieIcon = MovieIcon;
	exports.MuffinIcon = MuffinIcon;
	exports.MultiplicationBoxIcon = MultiplicationBoxIcon;
	exports.MultiplicationIcon = MultiplicationIcon;
	exports.MushroomOutlineIcon = MushroomOutlineIcon;
	exports.MushroomIcon = MushroomIcon;
	exports.MusicBoxOutlineIcon = MusicBoxOutlineIcon;
	exports.MusicBoxIcon = MusicBoxIcon;
	exports.MusicCircleIcon = MusicCircleIcon;
	exports.MusicNoteBluetoothOffIcon = MusicNoteBluetoothOffIcon;
	exports.MusicNoteBluetoothIcon = MusicNoteBluetoothIcon;
	exports.MusicNoteEighthIcon = MusicNoteEighthIcon;
	exports.MusicNoteHalfIcon = MusicNoteHalfIcon;
	exports.MusicNoteOffIcon = MusicNoteOffIcon;
	exports.MusicNoteQuarterIcon = MusicNoteQuarterIcon;
	exports.MusicNoteSixteenthIcon = MusicNoteSixteenthIcon;
	exports.MusicNoteWholeIcon = MusicNoteWholeIcon;
	exports.MusicNoteIcon = MusicNoteIcon;
	exports.MusicOffIcon = MusicOffIcon;
	exports.MusicIcon = MusicIcon;
	exports.NasIcon = NasIcon;
	exports.NativescriptIcon = NativescriptIcon;
	exports.NaturePeopleIcon = NaturePeopleIcon;
	exports.NatureIcon = NatureIcon;
	exports.NavigationIcon = NavigationIcon;
	exports.NearMeIcon = NearMeIcon;
	exports.NeedleIcon = NeedleIcon;
	exports.NetflixIcon = NetflixIcon;
	exports.NetworkStrength1AlertIcon = NetworkStrength1AlertIcon;
	exports.NetworkStrength1Icon = NetworkStrength1Icon;
	exports.NetworkStrength2AlertIcon = NetworkStrength2AlertIcon;
	exports.NetworkStrength2Icon = NetworkStrength2Icon;
	exports.NetworkStrength3AlertIcon = NetworkStrength3AlertIcon;
	exports.NetworkStrength3Icon = NetworkStrength3Icon;
	exports.NetworkStrength4AlertIcon = NetworkStrength4AlertIcon;
	exports.NetworkStrength4Icon = NetworkStrength4Icon;
	exports.NetworkStrengthOffOutlineIcon = NetworkStrengthOffOutlineIcon;
	exports.NetworkStrengthOffIcon = NetworkStrengthOffIcon;
	exports.NetworkStrengthOutlineIcon = NetworkStrengthOutlineIcon;
	exports.NetworkIcon = NetworkIcon;
	exports.NewBoxIcon = NewBoxIcon;
	exports.NewspaperIcon = NewspaperIcon;
	exports.NfcTapIcon = NfcTapIcon;
	exports.NfcVariantIcon = NfcVariantIcon;
	exports.NfcIcon = NfcIcon;
	exports.NinjaIcon = NinjaIcon;
	exports.NintendoSwitchIcon = NintendoSwitchIcon;
	exports.NodejsIcon = NodejsIcon;
	exports.NotEqualVariantIcon = NotEqualVariantIcon;
	exports.NotEqualIcon = NotEqualIcon;
	exports.NoteMultipleOutlineIcon = NoteMultipleOutlineIcon;
	exports.NoteMultipleIcon = NoteMultipleIcon;
	exports.NoteOutlineIcon = NoteOutlineIcon;
	exports.NotePlusOutlineIcon = NotePlusOutlineIcon;
	exports.NotePlusIcon = NotePlusIcon;
	exports.NoteTextIcon = NoteTextIcon;
	exports.NoteIcon = NoteIcon;
	exports.NotebookIcon = NotebookIcon;
	exports.NotificationClearAllIcon = NotificationClearAllIcon;
	exports.NpmVariantOutlineIcon = NpmVariantOutlineIcon;
	exports.NpmVariantIcon = NpmVariantIcon;
	exports.NpmIcon = NpmIcon;
	exports.NukeIcon = NukeIcon;
	exports.NullIcon = NullIcon;
	exports.Numeric0BoxMultipleOutlineIcon = Numeric0BoxMultipleOutlineIcon;
	exports.Numeric0BoxOutlineIcon = Numeric0BoxOutlineIcon;
	exports.Numeric0BoxIcon = Numeric0BoxIcon;
	exports.Numeric1BoxMultipleOutlineIcon = Numeric1BoxMultipleOutlineIcon;
	exports.Numeric1BoxOutlineIcon = Numeric1BoxOutlineIcon;
	exports.Numeric1BoxIcon = Numeric1BoxIcon;
	exports.Numeric2BoxMultipleOutlineIcon = Numeric2BoxMultipleOutlineIcon;
	exports.Numeric2BoxOutlineIcon = Numeric2BoxOutlineIcon;
	exports.Numeric2BoxIcon = Numeric2BoxIcon;
	exports.Numeric3BoxMultipleOutlineIcon = Numeric3BoxMultipleOutlineIcon;
	exports.Numeric3BoxOutlineIcon = Numeric3BoxOutlineIcon;
	exports.Numeric3BoxIcon = Numeric3BoxIcon;
	exports.Numeric4BoxMultipleOutlineIcon = Numeric4BoxMultipleOutlineIcon;
	exports.Numeric4BoxOutlineIcon = Numeric4BoxOutlineIcon;
	exports.Numeric4BoxIcon = Numeric4BoxIcon;
	exports.Numeric5BoxMultipleOutlineIcon = Numeric5BoxMultipleOutlineIcon;
	exports.Numeric5BoxOutlineIcon = Numeric5BoxOutlineIcon;
	exports.Numeric5BoxIcon = Numeric5BoxIcon;
	exports.Numeric6BoxMultipleOutlineIcon = Numeric6BoxMultipleOutlineIcon;
	exports.Numeric6BoxOutlineIcon = Numeric6BoxOutlineIcon;
	exports.Numeric6BoxIcon = Numeric6BoxIcon;
	exports.Numeric7BoxMultipleOutlineIcon = Numeric7BoxMultipleOutlineIcon;
	exports.Numeric7BoxOutlineIcon = Numeric7BoxOutlineIcon;
	exports.Numeric7BoxIcon = Numeric7BoxIcon;
	exports.Numeric8BoxMultipleOutlineIcon = Numeric8BoxMultipleOutlineIcon;
	exports.Numeric8BoxOutlineIcon = Numeric8BoxOutlineIcon;
	exports.Numeric8BoxIcon = Numeric8BoxIcon;
	exports.Numeric9BoxMultipleOutlineIcon = Numeric9BoxMultipleOutlineIcon;
	exports.Numeric9BoxOutlineIcon = Numeric9BoxOutlineIcon;
	exports.Numeric9BoxIcon = Numeric9BoxIcon;
	exports.Numeric9PlusBoxMultipleOutlineIcon = Numeric9PlusBoxMultipleOutlineIcon;
	exports.Numeric9PlusBoxOutlineIcon = Numeric9PlusBoxOutlineIcon;
	exports.Numeric9PlusBoxIcon = Numeric9PlusBoxIcon;
	exports.NumericIcon = NumericIcon;
	exports.NutIcon = NutIcon;
	exports.NutritionIcon = NutritionIcon;
	exports.OarIcon = OarIcon;
	exports.OctagonOutlineIcon = OctagonOutlineIcon;
	exports.OctagonIcon = OctagonIcon;
	exports.OctagramOutlineIcon = OctagramOutlineIcon;
	exports.OctagramIcon = OctagramIcon;
	exports.OdnoklassnikiIcon = OdnoklassnikiIcon;
	exports.OfficeBuildingIcon = OfficeBuildingIcon;
	exports.OfficeIcon = OfficeIcon;
	exports.OilTemperatureIcon = OilTemperatureIcon;
	exports.OilIcon = OilIcon;
	exports.OmegaIcon = OmegaIcon;
	exports.OnedriveIcon = OnedriveIcon;
	exports.OnenoteIcon = OnenoteIcon;
	exports.OnepasswordIcon = OnepasswordIcon;
	exports.OpacityIcon = OpacityIcon;
	exports.OpenInAppIcon = OpenInAppIcon;
	exports.OpenInNewIcon = OpenInNewIcon;
	exports.OpenidIcon = OpenidIcon;
	exports.OperaIcon = OperaIcon;
	exports.OrbitIcon = OrbitIcon;
	exports.OrnamentVariantIcon = OrnamentVariantIcon;
	exports.OrnamentIcon = OrnamentIcon;
	exports.OwlIcon = OwlIcon;
	exports.PackageDownIcon = PackageDownIcon;
	exports.PackageUpIcon = PackageUpIcon;
	exports.PackageVariantClosedIcon = PackageVariantClosedIcon;
	exports.PackageVariantIcon = PackageVariantIcon;
	exports.PackageIcon = PackageIcon;
	exports.PageFirstIcon = PageFirstIcon;
	exports.PageLastIcon = PageLastIcon;
	exports.PageLayoutBodyIcon = PageLayoutBodyIcon;
	exports.PageLayoutFooterIcon = PageLayoutFooterIcon;
	exports.PageLayoutHeaderIcon = PageLayoutHeaderIcon;
	exports.PageLayoutSidebarLeftIcon = PageLayoutSidebarLeftIcon;
	exports.PageLayoutSidebarRightIcon = PageLayoutSidebarRightIcon;
	exports.PaletteAdvancedIcon = PaletteAdvancedIcon;
	exports.PaletteSwatchIcon = PaletteSwatchIcon;
	exports.PaletteIcon = PaletteIcon;
	exports.PandaIcon = PandaIcon;
	exports.PandoraIcon = PandoraIcon;
	exports.PanoramaFisheyeIcon = PanoramaFisheyeIcon;
	exports.PanoramaHorizontalIcon = PanoramaHorizontalIcon;
	exports.PanoramaVerticalIcon = PanoramaVerticalIcon;
	exports.PanoramaWideAngleIcon = PanoramaWideAngleIcon;
	exports.PanoramaIcon = PanoramaIcon;
	exports.PaperCutVerticalIcon = PaperCutVerticalIcon;
	exports.PaperclipIcon = PaperclipIcon;
	exports.ParkingIcon = ParkingIcon;
	exports.PassportIcon = PassportIcon;
	exports.PatreonIcon = PatreonIcon;
	exports.PauseCircleOutlineIcon = PauseCircleOutlineIcon;
	exports.PauseCircleIcon = PauseCircleIcon;
	exports.PauseOctagonOutlineIcon = PauseOctagonOutlineIcon;
	exports.PauseOctagonIcon = PauseOctagonIcon;
	exports.PauseIcon = PauseIcon;
	exports.PawOffIcon = PawOffIcon;
	exports.PawIcon = PawIcon;
	exports.PaypalIcon = PaypalIcon;
	exports.PeaceIcon = PeaceIcon;
	exports.PenIcon = PenIcon;
	exports.PencilBoxOutlineIcon = PencilBoxOutlineIcon;
	exports.PencilBoxIcon = PencilBoxIcon;
	exports.PencilCircleOutlineIcon = PencilCircleOutlineIcon;
	exports.PencilCircleIcon = PencilCircleIcon;
	exports.PencilLockIcon = PencilLockIcon;
	exports.PencilOffIcon = PencilOffIcon;
	exports.PencilIcon = PencilIcon;
	exports.PentagonOutlineIcon = PentagonOutlineIcon;
	exports.PentagonIcon = PentagonIcon;
	exports.PercentIcon = PercentIcon;
	exports.PeriodicTableCo2Icon = PeriodicTableCo2Icon;
	exports.PeriodicTableIcon = PeriodicTableIcon;
	exports.PeriscopeIcon = PeriscopeIcon;
	exports.PharmacyIcon = PharmacyIcon;
	exports.PhoneBluetoothIcon = PhoneBluetoothIcon;
	exports.PhoneClassicIcon = PhoneClassicIcon;
	exports.PhoneForwardIcon = PhoneForwardIcon;
	exports.PhoneHangupIcon = PhoneHangupIcon;
	exports.PhoneInTalkIcon = PhoneInTalkIcon;
	exports.PhoneIncomingIcon = PhoneIncomingIcon;
	exports.PhoneLockedIcon = PhoneLockedIcon;
	exports.PhoneLogIcon = PhoneLogIcon;
	exports.PhoneMinusIcon = PhoneMinusIcon;
	exports.PhoneMissedIcon = PhoneMissedIcon;
	exports.PhoneOutgoingIcon = PhoneOutgoingIcon;
	exports.PhonePausedIcon = PhonePausedIcon;
	exports.PhonePlusIcon = PhonePlusIcon;
	exports.PhoneReturnIcon = PhoneReturnIcon;
	exports.PhoneRotateLandscapeIcon = PhoneRotateLandscapeIcon;
	exports.PhoneRotatePortraitIcon = PhoneRotatePortraitIcon;
	exports.PhoneSettingsIcon = PhoneSettingsIcon;
	exports.PhoneVoipIcon = PhoneVoipIcon;
	exports.PhoneIcon = PhoneIcon;
	exports.PiBoxIcon = PiBoxIcon;
	exports.PiIcon = PiIcon;
	exports.PianoIcon = PianoIcon;
	exports.PickaxeIcon = PickaxeIcon;
	exports.PierCraneIcon = PierCraneIcon;
	exports.PierIcon = PierIcon;
	exports.PigIcon = PigIcon;
	exports.PillIcon = PillIcon;
	exports.PillarIcon = PillarIcon;
	exports.PinOffOutlineIcon = PinOffOutlineIcon;
	exports.PinOffIcon = PinOffIcon;
	exports.PinOutlineIcon = PinOutlineIcon;
	exports.PinIcon = PinIcon;
	exports.PineTreeBoxIcon = PineTreeBoxIcon;
	exports.PineTreeIcon = PineTreeIcon;
	exports.PinterestBoxIcon = PinterestBoxIcon;
	exports.PinterestIcon = PinterestIcon;
	exports.PipeDisconnectedIcon = PipeDisconnectedIcon;
	exports.PipeLeakIcon = PipeLeakIcon;
	exports.PipeIcon = PipeIcon;
	exports.PistolIcon = PistolIcon;
	exports.PistonIcon = PistonIcon;
	exports.PizzaIcon = PizzaIcon;
	exports.PlaneShieldIcon = PlaneShieldIcon;
	exports.PlayBoxOutlineIcon = PlayBoxOutlineIcon;
	exports.PlayCircleOutlineIcon = PlayCircleOutlineIcon;
	exports.PlayCircleIcon = PlayCircleIcon;
	exports.PlayNetworkIcon = PlayNetworkIcon;
	exports.PlayPauseIcon = PlayPauseIcon;
	exports.PlayProtectedContentIcon = PlayProtectedContentIcon;
	exports.PlaySpeedIcon = PlaySpeedIcon;
	exports.PlayIcon = PlayIcon;
	exports.PlaylistCheckIcon = PlaylistCheckIcon;
	exports.PlaylistEditIcon = PlaylistEditIcon;
	exports.PlaylistMinusIcon = PlaylistMinusIcon;
	exports.PlaylistPlayIcon = PlaylistPlayIcon;
	exports.PlaylistPlusIcon = PlaylistPlusIcon;
	exports.PlaylistRemoveIcon = PlaylistRemoveIcon;
	exports.PlaystationIcon = PlaystationIcon;
	exports.PlexIcon = PlexIcon;
	exports.PlusBoxOutlineIcon = PlusBoxOutlineIcon;
	exports.PlusBoxIcon = PlusBoxIcon;
	exports.PlusCircleMultipleOutlineIcon = PlusCircleMultipleOutlineIcon;
	exports.PlusCircleOutlineIcon = PlusCircleOutlineIcon;
	exports.PlusCircleIcon = PlusCircleIcon;
	exports.PlusMinusBoxIcon = PlusMinusBoxIcon;
	exports.PlusMinusIcon = PlusMinusIcon;
	exports.PlusNetworkIcon = PlusNetworkIcon;
	exports.PlusOneIcon = PlusOneIcon;
	exports.PlusOutlineIcon = PlusOutlineIcon;
	exports.PlusIcon = PlusIcon;
	exports.PocketIcon = PocketIcon;
	exports.PodcastIcon = PodcastIcon;
	exports.PokeballIcon = PokeballIcon;
	exports.PokerChipIcon = PokerChipIcon;
	exports.PolaroidIcon = PolaroidIcon;
	exports.PollBoxIcon = PollBoxIcon;
	exports.PollIcon = PollIcon;
	exports.PolymerIcon = PolymerIcon;
	exports.PoolIcon = PoolIcon;
	exports.PopcornIcon = PopcornIcon;
	exports.PotMixIcon = PotMixIcon;
	exports.PotIcon = PotIcon;
	exports.PoundBoxIcon = PoundBoxIcon;
	exports.PoundIcon = PoundIcon;
	exports.PowerCycleIcon = PowerCycleIcon;
	exports.PowerOffIcon = PowerOffIcon;
	exports.PowerOnIcon = PowerOnIcon;
	exports.PowerPlugOffIcon = PowerPlugOffIcon;
	exports.PowerPlugIcon = PowerPlugIcon;
	exports.PowerSettingsIcon = PowerSettingsIcon;
	exports.PowerSleepIcon = PowerSleepIcon;
	exports.PowerSocketAuIcon = PowerSocketAuIcon;
	exports.PowerSocketEuIcon = PowerSocketEuIcon;
	exports.PowerSocketUkIcon = PowerSocketUkIcon;
	exports.PowerSocketUsIcon = PowerSocketUsIcon;
	exports.PowerSocketIcon = PowerSocketIcon;
	exports.PowerStandbyIcon = PowerStandbyIcon;
	exports.PowerIcon = PowerIcon;
	exports.PrescriptionIcon = PrescriptionIcon;
	exports.PresentationPlayIcon = PresentationPlayIcon;
	exports.PresentationIcon = PresentationIcon;
	exports.Printer3dIcon = Printer3dIcon;
	exports.PrinterAlertIcon = PrinterAlertIcon;
	exports.PrinterSettingsIcon = PrinterSettingsIcon;
	exports.PrinterIcon = PrinterIcon;
	exports.PriorityHighIcon = PriorityHighIcon;
	exports.PriorityLowIcon = PriorityLowIcon;
	exports.ProfessionalHexagonIcon = ProfessionalHexagonIcon;
	exports.ProgressCheckIcon = ProgressCheckIcon;
	exports.ProgressClockIcon = ProgressClockIcon;
	exports.ProgressDownloadIcon = ProgressDownloadIcon;
	exports.ProgressUploadIcon = ProgressUploadIcon;
	exports.ProjectorScreenIcon = ProjectorScreenIcon;
	exports.ProjectorIcon = ProjectorIcon;
	exports.PublishIcon = PublishIcon;
	exports.PulseIcon = PulseIcon;
	exports.PuzzleIcon = PuzzleIcon;
	exports.QiIcon = QiIcon;
	exports.QqchatIcon = QqchatIcon;
	exports.QrcodeEditIcon = QrcodeEditIcon;
	exports.QrcodeScanIcon = QrcodeScanIcon;
	exports.QrcodeIcon = QrcodeIcon;
	exports.QuadcopterIcon = QuadcopterIcon;
	exports.QualityHighIcon = QualityHighIcon;
	exports.QuicktimeIcon = QuicktimeIcon;
	exports.RabbitIcon = RabbitIcon;
	exports.RadarIcon = RadarIcon;
	exports.RadiatorIcon = RadiatorIcon;
	exports.RadioHandheldIcon = RadioHandheldIcon;
	exports.RadioTowerIcon = RadioTowerIcon;
	exports.RadioIcon = RadioIcon;
	exports.RadioactiveIcon = RadioactiveIcon;
	exports.RadioboxBlankIcon = RadioboxBlankIcon;
	exports.RadioboxMarkedIcon = RadioboxMarkedIcon;
	exports.RaspberrypiIcon = RaspberrypiIcon;
	exports.RayEndArrowIcon = RayEndArrowIcon;
	exports.RayEndIcon = RayEndIcon;
	exports.RayStartArrowIcon = RayStartArrowIcon;
	exports.RayStartEndIcon = RayStartEndIcon;
	exports.RayStartIcon = RayStartIcon;
	exports.RayVertexIcon = RayVertexIcon;
	exports.ReactIcon = ReactIcon;
	exports.ReadIcon = ReadIcon;
	exports.ReceiptIcon = ReceiptIcon;
	exports.RecordPlayerIcon = RecordPlayerIcon;
	exports.RecordRecIcon = RecordRecIcon;
	exports.RecordIcon = RecordIcon;
	exports.RecycleIcon = RecycleIcon;
	exports.RedditIcon = RedditIcon;
	exports.RedoVariantIcon = RedoVariantIcon;
	exports.RedoIcon = RedoIcon;
	exports.RefreshIcon = RefreshIcon;
	exports.RegexIcon = RegexIcon;
	exports.RelativeScaleIcon = RelativeScaleIcon;
	exports.ReloadIcon = ReloadIcon;
	exports.ReminderIcon = ReminderIcon;
	exports.RemoteDesktopIcon = RemoteDesktopIcon;
	exports.RemoteIcon = RemoteIcon;
	exports.RenameBoxIcon = RenameBoxIcon;
	exports.ReorderHorizontalIcon = ReorderHorizontalIcon;
	exports.ReorderVerticalIcon = ReorderVerticalIcon;
	exports.RepeatOffIcon = RepeatOffIcon;
	exports.RepeatOnceIcon = RepeatOnceIcon;
	exports.RepeatIcon = RepeatIcon;
	exports.ReplayIcon = ReplayIcon;
	exports.ReplyAllIcon = ReplyAllIcon;
	exports.ReplyIcon = ReplyIcon;
	exports.ReproductionIcon = ReproductionIcon;
	exports.ResizeBottomRightIcon = ResizeBottomRightIcon;
	exports.ResponsiveIcon = ResponsiveIcon;
	exports.RestartIcon = RestartIcon;
	exports.RestoreClockIcon = RestoreClockIcon;
	exports.RestoreIcon = RestoreIcon;
	exports.RewindOutlineIcon = RewindOutlineIcon;
	exports.RewindIcon = RewindIcon;
	exports.RhombusOutlineIcon = RhombusOutlineIcon;
	exports.RhombusIcon = RhombusIcon;
	exports.RibbonIcon = RibbonIcon;
	exports.RiceIcon = RiceIcon;
	exports.RingIcon = RingIcon;
	exports.RoadVariantIcon = RoadVariantIcon;
	exports.RoadIcon = RoadIcon;
	exports.RobotVacuumVariantIcon = RobotVacuumVariantIcon;
	exports.RobotVacuumIcon = RobotVacuumIcon;
	exports.RobotIcon = RobotIcon;
	exports.RocketIcon = RocketIcon;
	exports.RoomServiceIcon = RoomServiceIcon;
	exports.Rotate3dIcon = Rotate3dIcon;
	exports.RotateLeftVariantIcon = RotateLeftVariantIcon;
	exports.RotateLeftIcon = RotateLeftIcon;
	exports.RotateRightVariantIcon = RotateRightVariantIcon;
	exports.RotateRightIcon = RotateRightIcon;
	exports.RoundedCornerIcon = RoundedCornerIcon;
	exports.RouterWirelessIcon = RouterWirelessIcon;
	exports.RoutesIcon = RoutesIcon;
	exports.RowingIcon = RowingIcon;
	exports.RssBoxIcon = RssBoxIcon;
	exports.RssIcon = RssIcon;
	exports.RulerIcon = RulerIcon;
	exports.RunFastIcon = RunFastIcon;
	exports.RunIcon = RunIcon;
	exports.SaleIcon = SaleIcon;
	exports.SalesforceIcon = SalesforceIcon;
	exports.SassIcon = SassIcon;
	exports.SatelliteUplinkIcon = SatelliteUplinkIcon;
	exports.SatelliteVariantIcon = SatelliteVariantIcon;
	exports.SatelliteIcon = SatelliteIcon;
	exports.SausageIcon = SausageIcon;
	exports.SaxophoneIcon = SaxophoneIcon;
	exports.ScaleBalanceIcon = ScaleBalanceIcon;
	exports.ScaleBathroomIcon = ScaleBathroomIcon;
	exports.ScaleIcon = ScaleIcon;
	exports.ScannerOffIcon = ScannerOffIcon;
	exports.ScannerIcon = ScannerIcon;
	exports.SchoolIcon = SchoolIcon;
	exports.ScreenRotationLockIcon = ScreenRotationLockIcon;
	exports.ScreenRotationIcon = ScreenRotationIcon;
	exports.ScrewdriverIcon = ScrewdriverIcon;
	exports.ScriptIcon = ScriptIcon;
	exports.SdIcon = SdIcon;
	exports.SealIcon = SealIcon;
	exports.SearchWebIcon = SearchWebIcon;
	exports.SeatFlatAngledIcon = SeatFlatAngledIcon;
	exports.SeatFlatIcon = SeatFlatIcon;
	exports.SeatIndividualSuiteIcon = SeatIndividualSuiteIcon;
	exports.SeatLegroomExtraIcon = SeatLegroomExtraIcon;
	exports.SeatLegroomNormalIcon = SeatLegroomNormalIcon;
	exports.SeatLegroomReducedIcon = SeatLegroomReducedIcon;
	exports.SeatReclineExtraIcon = SeatReclineExtraIcon;
	exports.SeatReclineNormalIcon = SeatReclineNormalIcon;
	exports.SecurityAccountIcon = SecurityAccountIcon;
	exports.SecurityCloseIcon = SecurityCloseIcon;
	exports.SecurityHomeIcon = SecurityHomeIcon;
	exports.SecurityLockIcon = SecurityLockIcon;
	exports.SecurityNetworkIcon = SecurityNetworkIcon;
	exports.SecurityOffIcon = SecurityOffIcon;
	exports.SecurityIcon = SecurityIcon;
	exports.SelectAllIcon = SelectAllIcon;
	exports.SelectInverseIcon = SelectInverseIcon;
	exports.SelectOffIcon = SelectOffIcon;
	exports.SelectIcon = SelectIcon;
	exports.SelectionOffIcon = SelectionOffIcon;
	exports.SelectionIcon = SelectionIcon;
	exports.SendSecureIcon = SendSecureIcon;
	exports.SendIcon = SendIcon;
	exports.SerialPortIcon = SerialPortIcon;
	exports.ServerMinusIcon = ServerMinusIcon;
	exports.ServerNetworkOffIcon = ServerNetworkOffIcon;
	exports.ServerNetworkIcon = ServerNetworkIcon;
	exports.ServerOffIcon = ServerOffIcon;
	exports.ServerPlusIcon = ServerPlusIcon;
	exports.ServerRemoveIcon = ServerRemoveIcon;
	exports.ServerSecurityIcon = ServerSecurityIcon;
	exports.ServerIcon = ServerIcon;
	exports.SetAllIcon = SetAllIcon;
	exports.SetCenterRightIcon = SetCenterRightIcon;
	exports.SetCenterIcon = SetCenterIcon;
	exports.SetLeftCenterIcon = SetLeftCenterIcon;
	exports.SetLeftRightIcon = SetLeftRightIcon;
	exports.SetLeftIcon = SetLeftIcon;
	exports.SetNoneIcon = SetNoneIcon;
	exports.SetRightIcon = SetRightIcon;
	exports.SetTopBoxIcon = SetTopBoxIcon;
	exports.SettingsBoxIcon = SettingsBoxIcon;
	exports.SettingsOutlineIcon = SettingsOutlineIcon;
	exports.SettingsIcon = SettingsIcon;
	exports.ShapeCirclePlusIcon = ShapeCirclePlusIcon;
	exports.ShapeOutlineIcon = ShapeOutlineIcon;
	exports.ShapePlusIcon = ShapePlusIcon;
	exports.ShapePolygonPlusIcon = ShapePolygonPlusIcon;
	exports.ShapeRectanglePlusIcon = ShapeRectanglePlusIcon;
	exports.ShapeSquarePlusIcon = ShapeSquarePlusIcon;
	exports.ShapeIcon = ShapeIcon;
	exports.ShareOutlineIcon = ShareOutlineIcon;
	exports.ShareVariantIcon = ShareVariantIcon;
	exports.ShareIcon = ShareIcon;
	exports.ShieldHalfFullIcon = ShieldHalfFullIcon;
	exports.ShieldOutlineIcon = ShieldOutlineIcon;
	exports.ShieldIcon = ShieldIcon;
	exports.ShipWheelIcon = ShipWheelIcon;
	exports.ShoppingMusicIcon = ShoppingMusicIcon;
	exports.ShoppingIcon = ShoppingIcon;
	exports.ShovelOffIcon = ShovelOffIcon;
	exports.ShovelIcon = ShovelIcon;
	exports.ShowerHeadIcon = ShowerHeadIcon;
	exports.ShowerIcon = ShowerIcon;
	exports.ShredderIcon = ShredderIcon;
	exports.ShuffleDisabledIcon = ShuffleDisabledIcon;
	exports.ShuffleVariantIcon = ShuffleVariantIcon;
	exports.ShuffleIcon = ShuffleIcon;
	exports.SigmaLowerIcon = SigmaLowerIcon;
	exports.SigmaIcon = SigmaIcon;
	exports.SignCautionIcon = SignCautionIcon;
	exports.SignDirectionIcon = SignDirectionIcon;
	exports.SignTextIcon = SignTextIcon;
	exports.Signal2gIcon = Signal2gIcon;
	exports.Signal3gIcon = Signal3gIcon;
	exports.Signal4gIcon = Signal4gIcon;
	exports.SignalCellular1Icon = SignalCellular1Icon;
	exports.SignalCellular2Icon = SignalCellular2Icon;
	exports.SignalCellular3Icon = SignalCellular3Icon;
	exports.SignalCellularOutlineIcon = SignalCellularOutlineIcon;
	exports.SignalHspaPlusIcon = SignalHspaPlusIcon;
	exports.SignalHspaIcon = SignalHspaIcon;
	exports.SignalOffIcon = SignalOffIcon;
	exports.SignalVariantIcon = SignalVariantIcon;
	exports.SignalIcon = SignalIcon;
	exports.SilverwareForkIcon = SilverwareForkIcon;
	exports.SilverwareSpoonIcon = SilverwareSpoonIcon;
	exports.SilverwareVariantIcon = SilverwareVariantIcon;
	exports.SilverwareIcon = SilverwareIcon;
	exports.SimAlertIcon = SimAlertIcon;
	exports.SimOffIcon = SimOffIcon;
	exports.SimIcon = SimIcon;
	exports.SitemapIcon = SitemapIcon;
	exports.SkipBackwardIcon = SkipBackwardIcon;
	exports.SkipForwardIcon = SkipForwardIcon;
	exports.SkipNextCircleOutlineIcon = SkipNextCircleOutlineIcon;
	exports.SkipNextCircleIcon = SkipNextCircleIcon;
	exports.SkipNextIcon = SkipNextIcon;
	exports.SkipPreviousCircleOutlineIcon = SkipPreviousCircleOutlineIcon;
	exports.SkipPreviousCircleIcon = SkipPreviousCircleIcon;
	exports.SkipPreviousIcon = SkipPreviousIcon;
	exports.SkullIcon = SkullIcon;
	exports.SkypeBusinessIcon = SkypeBusinessIcon;
	exports.SkypeIcon = SkypeIcon;
	exports.SlackIcon = SlackIcon;
	exports.SlackwareIcon = SlackwareIcon;
	exports.SleepOffIcon = SleepOffIcon;
	exports.SleepIcon = SleepIcon;
	exports.SmokeDetectorIcon = SmokeDetectorIcon;
	exports.SmokingOffIcon = SmokingOffIcon;
	exports.SmokingIcon = SmokingIcon;
	exports.SnapchatIcon = SnapchatIcon;
	exports.SnowflakeIcon = SnowflakeIcon;
	exports.SnowmanIcon = SnowmanIcon;
	exports.SoccerFieldIcon = SoccerFieldIcon;
	exports.SoccerIcon = SoccerIcon;
	exports.SofaIcon = SofaIcon;
	exports.SolidIcon = SolidIcon;
	exports.SortAlphabeticalIcon = SortAlphabeticalIcon;
	exports.SortAscendingIcon = SortAscendingIcon;
	exports.SortDescendingIcon = SortDescendingIcon;
	exports.SortNumericIcon = SortNumericIcon;
	exports.SortVariantIcon = SortVariantIcon;
	exports.SortIcon = SortIcon;
	exports.SoundcloudIcon = SoundcloudIcon;
	exports.SourceBranchIcon = SourceBranchIcon;
	exports.SourceCommitEndLocalIcon = SourceCommitEndLocalIcon;
	exports.SourceCommitEndIcon = SourceCommitEndIcon;
	exports.SourceCommitLocalIcon = SourceCommitLocalIcon;
	exports.SourceCommitNextLocalIcon = SourceCommitNextLocalIcon;
	exports.SourceCommitStartNextLocalIcon = SourceCommitStartNextLocalIcon;
	exports.SourceCommitStartIcon = SourceCommitStartIcon;
	exports.SourceCommitIcon = SourceCommitIcon;
	exports.SourceForkIcon = SourceForkIcon;
	exports.SourceMergeIcon = SourceMergeIcon;
	exports.SourcePullIcon = SourcePullIcon;
	exports.SoySauceIcon = SoySauceIcon;
	exports.SpeakerBluetoothIcon = SpeakerBluetoothIcon;
	exports.SpeakerOffIcon = SpeakerOffIcon;
	exports.SpeakerWirelessIcon = SpeakerWirelessIcon;
	exports.SpeakerIcon = SpeakerIcon;
	exports.SpeedometerIcon = SpeedometerIcon;
	exports.SpellcheckIcon = SpellcheckIcon;
	exports.SpotifyIcon = SpotifyIcon;
	exports.SpotlightBeamIcon = SpotlightBeamIcon;
	exports.SpotlightIcon = SpotlightIcon;
	exports.SprayIcon = SprayIcon;
	exports.SquareEditOutlineIcon = SquareEditOutlineIcon;
	exports.SquareIncCashIcon = SquareIncCashIcon;
	exports.SquareIncIcon = SquareIncIcon;
	exports.SquareOutlineIcon = SquareOutlineIcon;
	exports.SquareRootBoxIcon = SquareRootBoxIcon;
	exports.SquareRootIcon = SquareRootIcon;
	exports.SquareIcon = SquareIcon;
	exports.SshIcon = SshIcon;
	exports.StackExchangeIcon = StackExchangeIcon;
	exports.StackOverflowIcon = StackOverflowIcon;
	exports.StadiumIcon = StadiumIcon;
	exports.StairsIcon = StairsIcon;
	exports.StandardDefinitionIcon = StandardDefinitionIcon;
	exports.StarCircleOutlineIcon = StarCircleOutlineIcon;
	exports.StarCircleIcon = StarCircleIcon;
	exports.StarFaceIcon = StarFaceIcon;
	exports.StarHalfIcon = StarHalfIcon;
	exports.StarOffIcon = StarOffIcon;
	exports.StarOutlineIcon = StarOutlineIcon;
	exports.StarIcon = StarIcon;
	exports.SteamBoxIcon = SteamBoxIcon;
	exports.SteamIcon = SteamIcon;
	exports.SteeringOffIcon = SteeringOffIcon;
	exports.SteeringIcon = SteeringIcon;
	exports.StepBackward2Icon = StepBackward2Icon;
	exports.StepBackwardIcon = StepBackwardIcon;
	exports.StepForward2Icon = StepForward2Icon;
	exports.StepForwardIcon = StepForwardIcon;
	exports.StethoscopeIcon = StethoscopeIcon;
	exports.StickerEmojiIcon = StickerEmojiIcon;
	exports.StickerIcon = StickerIcon;
	exports.StockingIcon = StockingIcon;
	exports.StopCircleOutlineIcon = StopCircleOutlineIcon;
	exports.StopCircleIcon = StopCircleIcon;
	exports.StopIcon = StopIcon;
	exports.Store24HourIcon = Store24HourIcon;
	exports.StoreIcon = StoreIcon;
	exports.StoveIcon = StoveIcon;
	exports.SubdirectoryArrowLeftIcon = SubdirectoryArrowLeftIcon;
	exports.SubdirectoryArrowRightIcon = SubdirectoryArrowRightIcon;
	exports.SubwayVariantIcon = SubwayVariantIcon;
	exports.SubwayIcon = SubwayIcon;
	exports.SummitIcon = SummitIcon;
	exports.SunglassesIcon = SunglassesIcon;
	exports.SurroundSound20Icon = SurroundSound20Icon;
	exports.SurroundSound31Icon = SurroundSound31Icon;
	exports.SurroundSound51Icon = SurroundSound51Icon;
	exports.SurroundSound71Icon = SurroundSound71Icon;
	exports.SurroundSoundIcon = SurroundSoundIcon;
	exports.SvgIcon = SvgIcon;
	exports.SwapHorizontalVariantIcon = SwapHorizontalVariantIcon;
	exports.SwapHorizontalIcon = SwapHorizontalIcon;
	exports.SwapVerticalVariantIcon = SwapVerticalVariantIcon;
	exports.SwapVerticalIcon = SwapVerticalIcon;
	exports.SwimIcon = SwimIcon;
	exports.SwitchIcon = SwitchIcon;
	exports.SwordCrossIcon = SwordCrossIcon;
	exports.SwordIcon = SwordIcon;
	exports.SyncAlertIcon = SyncAlertIcon;
	exports.SyncOffIcon = SyncOffIcon;
	exports.SyncIcon = SyncIcon;
	exports.TabPlusIcon = TabPlusIcon;
	exports.TabUnselectedIcon = TabUnselectedIcon;
	exports.TabIcon = TabIcon;
	exports.TableColumnPlusAfterIcon = TableColumnPlusAfterIcon;
	exports.TableColumnPlusBeforeIcon = TableColumnPlusBeforeIcon;
	exports.TableColumnRemoveIcon = TableColumnRemoveIcon;
	exports.TableColumnWidthIcon = TableColumnWidthIcon;
	exports.TableColumnIcon = TableColumnIcon;
	exports.TableEditIcon = TableEditIcon;
	exports.TableLargeIcon = TableLargeIcon;
	exports.TableMergeCellsIcon = TableMergeCellsIcon;
	exports.TableOfContentsIcon = TableOfContentsIcon;
	exports.TableRowHeightIcon = TableRowHeightIcon;
	exports.TableRowPlusAfterIcon = TableRowPlusAfterIcon;
	exports.TableRowPlusBeforeIcon = TableRowPlusBeforeIcon;
	exports.TableRowRemoveIcon = TableRowRemoveIcon;
	exports.TableRowIcon = TableRowIcon;
	exports.TableSearchIcon = TableSearchIcon;
	exports.TableSettingsIcon = TableSettingsIcon;
	exports.TableIcon = TableIcon;
	exports.TabletAndroidIcon = TabletAndroidIcon;
	exports.TabletCellphoneIcon = TabletCellphoneIcon;
	exports.TabletIpadIcon = TabletIpadIcon;
	exports.TabletIcon = TabletIcon;
	exports.TacoIcon = TacoIcon;
	exports.TagFacesIcon = TagFacesIcon;
	exports.TagHeartIcon = TagHeartIcon;
	exports.TagMinusIcon = TagMinusIcon;
	exports.TagMultipleIcon = TagMultipleIcon;
	exports.TagOutlineIcon = TagOutlineIcon;
	exports.TagPlusIcon = TagPlusIcon;
	exports.TagRemoveIcon = TagRemoveIcon;
	exports.TagTextOutlineIcon = TagTextOutlineIcon;
	exports.TagIcon = TagIcon;
	exports.TargetIcon = TargetIcon;
	exports.TaxiIcon = TaxiIcon;
	exports.TeachIcon = TeachIcon;
	exports.TeamviewerIcon = TeamviewerIcon;
	exports.TelegramIcon = TelegramIcon;
	exports.TelevisionBoxIcon = TelevisionBoxIcon;
	exports.TelevisionClassicOffIcon = TelevisionClassicOffIcon;
	exports.TelevisionClassicIcon = TelevisionClassicIcon;
	exports.TelevisionGuideIcon = TelevisionGuideIcon;
	exports.TelevisionOffIcon = TelevisionOffIcon;
	exports.TelevisionIcon = TelevisionIcon;
	exports.TemperatureCelsiusIcon = TemperatureCelsiusIcon;
	exports.TemperatureFahrenheitIcon = TemperatureFahrenheitIcon;
	exports.TemperatureKelvinIcon = TemperatureKelvinIcon;
	exports.TennisIcon = TennisIcon;
	exports.TentIcon = TentIcon;
	exports.TerrainIcon = TerrainIcon;
	exports.TestTubeEmptyIcon = TestTubeEmptyIcon;
	exports.TestTubeOffIcon = TestTubeOffIcon;
	exports.TestTubeIcon = TestTubeIcon;
	exports.TextShadowIcon = TextShadowIcon;
	exports.TextShortIcon = TextShortIcon;
	exports.TextSubjectIcon = TextSubjectIcon;
	exports.TextToSpeechOffIcon = TextToSpeechOffIcon;
	exports.TextToSpeechIcon = TextToSpeechIcon;
	exports.TextIcon = TextIcon;
	exports.TextboxPasswordIcon = TextboxPasswordIcon;
	exports.TextboxIcon = TextboxIcon;
	exports.TextureIcon = TextureIcon;
	exports.TheaterIcon = TheaterIcon;
	exports.ThemeLightDarkIcon = ThemeLightDarkIcon;
	exports.ThermometerLinesIcon = ThermometerLinesIcon;
	exports.ThermometerIcon = ThermometerIcon;
	exports.ThermostatBoxIcon = ThermostatBoxIcon;
	exports.ThermostatIcon = ThermostatIcon;
	exports.ThoughtBubbleOutlineIcon = ThoughtBubbleOutlineIcon;
	exports.ThoughtBubbleIcon = ThoughtBubbleIcon;
	exports.ThumbDownOutlineIcon = ThumbDownOutlineIcon;
	exports.ThumbDownIcon = ThumbDownIcon;
	exports.ThumbUpOutlineIcon = ThumbUpOutlineIcon;
	exports.ThumbUpIcon = ThumbUpIcon;
	exports.ThumbsUpDownIcon = ThumbsUpDownIcon;
	exports.TicketAccountIcon = TicketAccountIcon;
	exports.TicketConfirmationIcon = TicketConfirmationIcon;
	exports.TicketOutlineIcon = TicketOutlineIcon;
	exports.TicketPercentIcon = TicketPercentIcon;
	exports.TicketIcon = TicketIcon;
	exports.TieIcon = TieIcon;
	exports.TildeIcon = TildeIcon;
	exports.TimelapseIcon = TimelapseIcon;
	exports.Timer10Icon = Timer10Icon;
	exports.Timer3Icon = Timer3Icon;
	exports.TimerOffIcon = TimerOffIcon;
	exports.TimerSandEmptyIcon = TimerSandEmptyIcon;
	exports.TimerSandFullIcon = TimerSandFullIcon;
	exports.TimerSandIcon = TimerSandIcon;
	exports.TimerIcon = TimerIcon;
	exports.TimetableIcon = TimetableIcon;
	exports.ToggleSwitchOffIcon = ToggleSwitchOffIcon;
	exports.ToggleSwitchIcon = ToggleSwitchIcon;
	exports.ToiletIcon = ToiletIcon;
	exports.ToolboxOutlineIcon = ToolboxOutlineIcon;
	exports.ToolboxIcon = ToolboxIcon;
	exports.TooltipEditIcon = TooltipEditIcon;
	exports.TooltipImageIcon = TooltipImageIcon;
	exports.TooltipOutlinePlusIcon = TooltipOutlinePlusIcon;
	exports.TooltipOutlineIcon = TooltipOutlineIcon;
	exports.TooltipTextIcon = TooltipTextIcon;
	exports.TooltipIcon = TooltipIcon;
	exports.ToothOutlineIcon = ToothOutlineIcon;
	exports.ToothIcon = ToothIcon;
	exports.TorIcon = TorIcon;
	exports.TournamentIcon = TournamentIcon;
	exports.TowerBeachIcon = TowerBeachIcon;
	exports.TowerFireIcon = TowerFireIcon;
	exports.TowingIcon = TowingIcon;
	exports.TrackLightIcon = TrackLightIcon;
	exports.TrackpadLockIcon = TrackpadLockIcon;
	exports.TrackpadIcon = TrackpadIcon;
	exports.TractorIcon = TractorIcon;
	exports.TrafficLightIcon = TrafficLightIcon;
	exports.TrainVariantIcon = TrainVariantIcon;
	exports.TrainIcon = TrainIcon;
	exports.TramIcon = TramIcon;
	exports.TranscribeCloseIcon = TranscribeCloseIcon;
	exports.TranscribeIcon = TranscribeIcon;
	exports.TransferIcon = TransferIcon;
	exports.TransitTransferIcon = TransitTransferIcon;
	exports.TransitionMaskedIcon = TransitionMaskedIcon;
	exports.TransitionIcon = TransitionIcon;
	exports.TranslateIcon = TranslateIcon;
	exports.TreasureChestIcon = TreasureChestIcon;
	exports.TreeIcon = TreeIcon;
	exports.TrelloIcon = TrelloIcon;
	exports.TrendingDownIcon = TrendingDownIcon;
	exports.TrendingNeutralIcon = TrendingNeutralIcon;
	exports.TrendingUpIcon = TrendingUpIcon;
	exports.TriangleOutlineIcon = TriangleOutlineIcon;
	exports.TriangleIcon = TriangleIcon;
	exports.TrophyAwardIcon = TrophyAwardIcon;
	exports.TrophyOutlineIcon = TrophyOutlineIcon;
	exports.TrophyVariantOutlineIcon = TrophyVariantOutlineIcon;
	exports.TrophyVariantIcon = TrophyVariantIcon;
	exports.TrophyIcon = TrophyIcon;
	exports.TruckDeliveryIcon = TruckDeliveryIcon;
	exports.TruckFastIcon = TruckFastIcon;
	exports.TruckTrailerIcon = TruckTrailerIcon;
	exports.TruckIcon = TruckIcon;
	exports.TshirtCrewIcon = TshirtCrewIcon;
	exports.TshirtVIcon = TshirtVIcon;
	exports.TumbleDryerIcon = TumbleDryerIcon;
	exports.TumblrBoxIcon = TumblrBoxIcon;
	exports.TumblrReblogIcon = TumblrReblogIcon;
	exports.TumblrIcon = TumblrIcon;
	exports.TuneVerticalIcon = TuneVerticalIcon;
	exports.TuneIcon = TuneIcon;
	exports.TwitchIcon = TwitchIcon;
	exports.TwitterBoxIcon = TwitterBoxIcon;
	exports.TwitterCircleIcon = TwitterCircleIcon;
	exports.TwitterRetweetIcon = TwitterRetweetIcon;
	exports.TwitterIcon = TwitterIcon;
	exports.TwoFactorAuthenticationIcon = TwoFactorAuthenticationIcon;
	exports.UberIcon = UberIcon;
	exports.UbuntuIcon = UbuntuIcon;
	exports.UltraHighDefinitionIcon = UltraHighDefinitionIcon;
	exports.UmbracoIcon = UmbracoIcon;
	exports.UmbrellaClosedIcon = UmbrellaClosedIcon;
	exports.UmbrellaOutlineIcon = UmbrellaOutlineIcon;
	exports.UmbrellaIcon = UmbrellaIcon;
	exports.UndoVariantIcon = UndoVariantIcon;
	exports.UndoIcon = UndoIcon;
	exports.UnfoldLessHorizontalIcon = UnfoldLessHorizontalIcon;
	exports.UnfoldLessVerticalIcon = UnfoldLessVerticalIcon;
	exports.UnfoldMoreHorizontalIcon = UnfoldMoreHorizontalIcon;
	exports.UnfoldMoreVerticalIcon = UnfoldMoreVerticalIcon;
	exports.UngroupIcon = UngroupIcon;
	exports.UnityIcon = UnityIcon;
	exports.UnrealIcon = UnrealIcon;
	exports.UntappdIcon = UntappdIcon;
	exports.UpdateIcon = UpdateIcon;
	exports.UploadMultipleIcon = UploadMultipleIcon;
	exports.UploadNetworkIcon = UploadNetworkIcon;
	exports.UploadIcon = UploadIcon;
	exports.UsbIcon = UsbIcon;
	exports.VanPassengerIcon = VanPassengerIcon;
	exports.VanUtilityIcon = VanUtilityIcon;
	exports.VanishIcon = VanishIcon;
	exports.VectorArrangeAboveIcon = VectorArrangeAboveIcon;
	exports.VectorArrangeBelowIcon = VectorArrangeBelowIcon;
	exports.VectorCircleVariantIcon = VectorCircleVariantIcon;
	exports.VectorCircleIcon = VectorCircleIcon;
	exports.VectorCombineIcon = VectorCombineIcon;
	exports.VectorCurveIcon = VectorCurveIcon;
	exports.VectorDifferenceAbIcon = VectorDifferenceAbIcon;
	exports.VectorDifferenceBaIcon = VectorDifferenceBaIcon;
	exports.VectorDifferenceIcon = VectorDifferenceIcon;
	exports.VectorEllipseIcon = VectorEllipseIcon;
	exports.VectorIntersectionIcon = VectorIntersectionIcon;
	exports.VectorLineIcon = VectorLineIcon;
	exports.VectorPointIcon = VectorPointIcon;
	exports.VectorPolygonIcon = VectorPolygonIcon;
	exports.VectorPolylineIcon = VectorPolylineIcon;
	exports.VectorRadiusIcon = VectorRadiusIcon;
	exports.VectorRectangleIcon = VectorRectangleIcon;
	exports.VectorSelectionIcon = VectorSelectionIcon;
	exports.VectorSquareIcon = VectorSquareIcon;
	exports.VectorTriangleIcon = VectorTriangleIcon;
	exports.VectorUnionIcon = VectorUnionIcon;
	exports.VenmoIcon = VenmoIcon;
	exports.VerifiedIcon = VerifiedIcon;
	exports.VibrateIcon = VibrateIcon;
	exports.Video3dIcon = Video3dIcon;
	exports.Video4kBoxIcon = Video4kBoxIcon;
	exports.VideoAccountIcon = VideoAccountIcon;
	exports.VideoImageIcon = VideoImageIcon;
	exports.VideoInputAntennaIcon = VideoInputAntennaIcon;
	exports.VideoInputComponentIcon = VideoInputComponentIcon;
	exports.VideoInputHdmiIcon = VideoInputHdmiIcon;
	exports.VideoInputSvideoIcon = VideoInputSvideoIcon;
	exports.VideoMinusIcon = VideoMinusIcon;
	exports.VideoOffIcon = VideoOffIcon;
	exports.VideoPlusIcon = VideoPlusIcon;
	exports.VideoStabilizationIcon = VideoStabilizationIcon;
	exports.VideoSwitchIcon = VideoSwitchIcon;
	exports.VideoIcon = VideoIcon;
	exports.ViewAgendaIcon = ViewAgendaIcon;
	exports.ViewArrayIcon = ViewArrayIcon;
	exports.ViewCarouselIcon = ViewCarouselIcon;
	exports.ViewColumnIcon = ViewColumnIcon;
	exports.ViewDashboardVariantIcon = ViewDashboardVariantIcon;
	exports.ViewDashboardIcon = ViewDashboardIcon;
	exports.ViewDayIcon = ViewDayIcon;
	exports.ViewGridIcon = ViewGridIcon;
	exports.ViewHeadlineIcon = ViewHeadlineIcon;
	exports.ViewListIcon = ViewListIcon;
	exports.ViewModuleIcon = ViewModuleIcon;
	exports.ViewParallelIcon = ViewParallelIcon;
	exports.ViewQuiltIcon = ViewQuiltIcon;
	exports.ViewSequentialIcon = ViewSequentialIcon;
	exports.ViewStreamIcon = ViewStreamIcon;
	exports.ViewWeekIcon = ViewWeekIcon;
	exports.VimeoIcon = VimeoIcon;
	exports.ViolinIcon = ViolinIcon;
	exports.VirtualRealityIcon = VirtualRealityIcon;
	exports.VisualstudioIcon = VisualstudioIcon;
	exports.VkBoxIcon = VkBoxIcon;
	exports.VkCircleIcon = VkCircleIcon;
	exports.VkIcon = VkIcon;
	exports.VlcIcon = VlcIcon;
	exports.VoiceIcon = VoiceIcon;
	exports.VoicemailIcon = VoicemailIcon;
	exports.VolleyballIcon = VolleyballIcon;
	exports.VolumeHighIcon = VolumeHighIcon;
	exports.VolumeLowIcon = VolumeLowIcon;
	exports.VolumeMediumIcon = VolumeMediumIcon;
	exports.VolumeMinusIcon = VolumeMinusIcon;
	exports.VolumeMuteIcon = VolumeMuteIcon;
	exports.VolumeOffIcon = VolumeOffIcon;
	exports.VolumePlusIcon = VolumePlusIcon;
	exports.VpnIcon = VpnIcon;
	exports.VuejsIcon = VuejsIcon;
	exports.WalkIcon = WalkIcon;
	exports.WallSconceFlatIcon = WallSconceFlatIcon;
	exports.WallSconceVariantIcon = WallSconceVariantIcon;
	exports.WallSconceIcon = WallSconceIcon;
	exports.WallIcon = WallIcon;
	exports.WalletGiftcardIcon = WalletGiftcardIcon;
	exports.WalletMembershipIcon = WalletMembershipIcon;
	exports.WalletTravelIcon = WalletTravelIcon;
	exports.WalletIcon = WalletIcon;
	exports.WanIcon = WanIcon;
	exports.WashingMachineIcon = WashingMachineIcon;
	exports.WatchExportVariantIcon = WatchExportVariantIcon;
	exports.WatchExportIcon = WatchExportIcon;
	exports.WatchImportVariantIcon = WatchImportVariantIcon;
	exports.WatchImportIcon = WatchImportIcon;
	exports.WatchVariantIcon = WatchVariantIcon;
	exports.WatchVibrateIcon = WatchVibrateIcon;
	exports.WatchIcon = WatchIcon;
	exports.WaterOffIcon = WaterOffIcon;
	exports.WaterPercentIcon = WaterPercentIcon;
	exports.WaterPumpIcon = WaterPumpIcon;
	exports.WaterIcon = WaterIcon;
	exports.WatermarkIcon = WatermarkIcon;
	exports.WavesIcon = WavesIcon;
	exports.WeatherCloudyIcon = WeatherCloudyIcon;
	exports.WeatherFogIcon = WeatherFogIcon;
	exports.WeatherHailIcon = WeatherHailIcon;
	exports.WeatherHurricaneIcon = WeatherHurricaneIcon;
	exports.WeatherLightningRainyIcon = WeatherLightningRainyIcon;
	exports.WeatherLightningIcon = WeatherLightningIcon;
	exports.WeatherNightIcon = WeatherNightIcon;
	exports.WeatherPartlycloudyIcon = WeatherPartlycloudyIcon;
	exports.WeatherPouringIcon = WeatherPouringIcon;
	exports.WeatherRainyIcon = WeatherRainyIcon;
	exports.WeatherSnowyRainyIcon = WeatherSnowyRainyIcon;
	exports.WeatherSnowyIcon = WeatherSnowyIcon;
	exports.WeatherSunnyIcon = WeatherSunnyIcon;
	exports.WeatherSunsetDownIcon = WeatherSunsetDownIcon;
	exports.WeatherSunsetUpIcon = WeatherSunsetUpIcon;
	exports.WeatherSunsetIcon = WeatherSunsetIcon;
	exports.WeatherWindyVariantIcon = WeatherWindyVariantIcon;
	exports.WeatherWindyIcon = WeatherWindyIcon;
	exports.WebIcon = WebIcon;
	exports.WebcamIcon = WebcamIcon;
	exports.WebhookIcon = WebhookIcon;
	exports.WebpackIcon = WebpackIcon;
	exports.WechatIcon = WechatIcon;
	exports.WeightKilogramIcon = WeightKilogramIcon;
	exports.WeightPoundIcon = WeightPoundIcon;
	exports.WeightIcon = WeightIcon;
	exports.WhatsappIcon = WhatsappIcon;
	exports.WheelchairAccessibilityIcon = WheelchairAccessibilityIcon;
	exports.WhistleIcon = WhistleIcon;
	exports.WhiteBalanceAutoIcon = WhiteBalanceAutoIcon;
	exports.WhiteBalanceIncandescentIcon = WhiteBalanceIncandescentIcon;
	exports.WhiteBalanceIridescentIcon = WhiteBalanceIridescentIcon;
	exports.WhiteBalanceSunnyIcon = WhiteBalanceSunnyIcon;
	exports.WidgetsIcon = WidgetsIcon;
	exports.WifiOffIcon = WifiOffIcon;
	exports.WifiStrength1AlertIcon = WifiStrength1AlertIcon;
	exports.WifiStrength1LockIcon = WifiStrength1LockIcon;
	exports.WifiStrength1Icon = WifiStrength1Icon;
	exports.WifiStrength2AlertIcon = WifiStrength2AlertIcon;
	exports.WifiStrength2LockIcon = WifiStrength2LockIcon;
	exports.WifiStrength2Icon = WifiStrength2Icon;
	exports.WifiStrength3AlertIcon = WifiStrength3AlertIcon;
	exports.WifiStrength3LockIcon = WifiStrength3LockIcon;
	exports.WifiStrength3Icon = WifiStrength3Icon;
	exports.WifiStrength4AlertIcon = WifiStrength4AlertIcon;
	exports.WifiStrength4LockIcon = WifiStrength4LockIcon;
	exports.WifiStrength4Icon = WifiStrength4Icon;
	exports.WifiStrengthAlertOutlineIcon = WifiStrengthAlertOutlineIcon;
	exports.WifiStrengthLockOutlineIcon = WifiStrengthLockOutlineIcon;
	exports.WifiStrengthOffOutlineIcon = WifiStrengthOffOutlineIcon;
	exports.WifiStrengthOffIcon = WifiStrengthOffIcon;
	exports.WifiStrengthOutlineIcon = WifiStrengthOutlineIcon;
	exports.WifiIcon = WifiIcon;
	exports.WiiIcon = WiiIcon;
	exports.WiiuIcon = WiiuIcon;
	exports.WikipediaIcon = WikipediaIcon;
	exports.WindowCloseIcon = WindowCloseIcon;
	exports.WindowClosedIcon = WindowClosedIcon;
	exports.WindowMaximizeIcon = WindowMaximizeIcon;
	exports.WindowMinimizeIcon = WindowMinimizeIcon;
	exports.WindowOpenIcon = WindowOpenIcon;
	exports.WindowRestoreIcon = WindowRestoreIcon;
	exports.WindowsIcon = WindowsIcon;
	exports.WordpressIcon = WordpressIcon;
	exports.WorkerIcon = WorkerIcon;
	exports.WrapIcon = WrapIcon;
	exports.WrenchIcon = WrenchIcon;
	exports.WunderlistIcon = WunderlistIcon;
	exports.XamarinOutlineIcon = XamarinOutlineIcon;
	exports.XamarinIcon = XamarinIcon;
	exports.XamlIcon = XamlIcon;
	exports.XboxControllerBatteryAlertIcon = XboxControllerBatteryAlertIcon;
	exports.XboxControllerBatteryEmptyIcon = XboxControllerBatteryEmptyIcon;
	exports.XboxControllerBatteryFullIcon = XboxControllerBatteryFullIcon;
	exports.XboxControllerBatteryLowIcon = XboxControllerBatteryLowIcon;
	exports.XboxControllerBatteryMediumIcon = XboxControllerBatteryMediumIcon;
	exports.XboxControllerBatteryUnknownIcon = XboxControllerBatteryUnknownIcon;
	exports.XboxControllerOffIcon = XboxControllerOffIcon;
	exports.XboxControllerIcon = XboxControllerIcon;
	exports.XboxIcon = XboxIcon;
	exports.XdaIcon = XdaIcon;
	exports.XingBoxIcon = XingBoxIcon;
	exports.XingCircleIcon = XingCircleIcon;
	exports.XingIcon = XingIcon;
	exports.XmlIcon = XmlIcon;
	exports.XmppIcon = XmppIcon;
	exports.YammerIcon = YammerIcon;
	exports.YeastIcon = YeastIcon;
	exports.YelpIcon = YelpIcon;
	exports.YinYangIcon = YinYangIcon;
	exports.YoutubeCreatorStudioIcon = YoutubeCreatorStudioIcon;
	exports.YoutubeGamingIcon = YoutubeGamingIcon;
	exports.YoutubeTvIcon = YoutubeTvIcon;
	exports.YoutubeIcon = YoutubeIcon;
	exports.ZipBoxIcon = ZipBoxIcon;
	exports.UserBoxIcon = AccountBoxIcon;
	exports.IdentificationCardIcon = AccountCardDetailsIcon;
	exports.UserCardDetailsIcon = AccountCardDetailsIcon;
	exports.UserCheckIcon = AccountCheckIcon;
	exports.UserCircleIcon = AccountCircleIcon;
	exports.UserConvertIcon = AccountConvertIcon;
	exports.UserEditIcon = AccountEditIcon;
	exports.UserGroupIcon = AccountGroupIcon;
	exports.UserHeartIcon = AccountHeartIcon;
	exports.UserKeyIcon = AccountKeyIcon;
	exports.UserAddressIcon = AccountLocationIcon;
	exports.AccountAddressIcon = AccountLocationIcon;
	exports.UserLocationIcon = AccountLocationIcon;
	exports.UserMinusIcon = AccountMinusIcon;
	exports.UserMultipleCheckIcon = AccountMultipleCheckIcon;
	exports.UserMultipleMinusIcon = AccountMultipleMinusIcon;
	exports.UserMultipleOutlineIcon = AccountMultipleOutlineIcon;
	exports.PeopleOutlineIcon = AccountMultipleOutlineIcon;
	exports.GroupAddOutlineIcon = AccountMultiplePlusOutlineIcon;
	exports.UserMultiplePlusOutlineIcon = AccountMultiplePlusOutlineIcon;
	exports.UserMultiplePlusIcon = AccountMultiplePlusIcon;
	exports.GroupAddIcon = AccountMultiplePlusIcon;
	exports.PeopleIcon = AccountMultipleIcon;
	exports.UserMultipleIcon = AccountMultipleIcon;
	exports.UserNetworkIcon = AccountNetworkIcon;
	exports.UserOffIcon = AccountOffIcon;
	exports.UserOutlineIcon = AccountOutlineIcon;
	exports.PermIdentityIcon = AccountOutlineIcon;
	exports.PersonOutlineIcon = AccountOutlineIcon;
	exports.PersonAddOutlineIcon = AccountPlusOutlineIcon;
	exports.RegisterOutlineIcon = AccountPlusOutlineIcon;
	exports.UserPlusOutlineIcon = AccountPlusOutlineIcon;
	exports.RegisterIcon = AccountPlusIcon;
	exports.UserPlusIcon = AccountPlusIcon;
	exports.PersonAddIcon = AccountPlusIcon;
	exports.UserRemoveIcon = AccountRemoveIcon;
	exports.UserSearchOutlineIcon = AccountSearchOutlineIcon;
	exports.UserSearchIcon = AccountSearchIcon;
	exports.UserSettingsVariantIcon = AccountSettingsVariantIcon;
	exports.UserSettingsIcon = AccountSettingsIcon;
	exports.UserStarIcon = AccountStarIcon;
	exports.UserSwitchIcon = AccountSwitchIcon;
	exports.PersonIcon = AccountIcon;
	exports.UserIcon = AccountIcon;
	exports.AcUnitIcon = AirConditionerIcon;
	exports.HotAirBalloonIcon = AirballoonIcon;
	exports.AeroplaneLandingIcon = AirplaneLandingIcon;
	exports.FlightLandIcon = AirplaneLandingIcon;
	exports.AeroplaneOffIcon = AirplaneOffIcon;
	exports.AirplanemodeInactiveIcon = AirplaneOffIcon;
	exports.AeroplaneTakeoffIcon = AirplaneTakeoffIcon;
	exports.FlightTakeoffIcon = AirplaneTakeoffIcon;
	exports.AeroplaneIcon = AirplaneIcon;
	exports.AirplanemodeActiveIcon = AirplaneIcon;
	exports.FlightIcon = AirplaneIcon;
	exports.LocalAirportIcon = AirplaneIcon;
	exports.AlarmOnIcon = AlarmCheckIcon;
	exports.AddAlarmIcon = AlarmPlusIcon;
	exports.AccessAlarmsIcon = AlarmIcon;
	exports.VinylIcon = AlbumIcon;
	exports.WarningBoxIcon = AlertBoxIcon;
	exports.WarningCircleOutlineIcon = AlertCircleOutlineIcon;
	exports.ErrorOutlineIcon = AlertCircleOutlineIcon;
	exports.WarningCircleIcon = AlertCircleIcon;
	exports.ErrorIcon = AlertCircleIcon;
	exports.NewReleasesIcon = AlertDecagramIcon;
	exports.WarningDecagramIcon = AlertDecagramIcon;
	exports.WarningOctagonIcon = AlertOctagonIcon;
	exports.ReportIcon = AlertOctagonIcon;
	exports.WarningOctagramIcon = AlertOctagramIcon;
	exports.WarningOutlineIcon = AlertOutlineIcon;
	exports.WarningIcon = AlertIcon;
	exports.ReportProblemIcon = AlertIcon;
	exports.AmazonClouddriveIcon = AmazonDriveIcon;
	exports.AdbIcon = AndroidDebugBridgeIcon;
	exports.MathCompassVariantIcon = AndroidStudioIcon;
	exports.AutoAwesomeMotionIcon = AnimationIcon;
	exports.AppleMobilemeIcon = AppleIcloudIcon;
	exports.WebAssetIcon = ApplicationIcon;
	exports.DecagramCheckIcon = ApprovalIcon;
	exports.ApproveIcon = ApprovalIcon;
	exports.ArrowCompressAllIcon = ArrowCollapseAllIcon;
	exports.ArrowCompressDownIcon = ArrowCollapseDownIcon;
	exports.ArrowCompressLeftIcon = ArrowCollapseLeftIcon;
	exports.ArrowCompressRightIcon = ArrowCollapseRightIcon;
	exports.ArrowCompressUpIcon = ArrowCollapseUpIcon;
	exports.ArrowCompressIcon = ArrowCollapseIcon;
	exports.ArrowDropDownCircleIcon = ArrowDownDropCircleIcon;
	exports.ArrowDownwardIcon = ArrowDownIcon;
	exports.ArrowBackIcon = ArrowLeftIcon;
	exports.ArrowForwardIcon = ArrowRightIcon;
	exports.ArrowUpwardIcon = ArrowUpIcon;
	exports.AlternateEmailIcon = AtIcon;
	exports.PaperclipHorizontalIcon = AttachmentIcon;
	exports.MagicIcon = AutoFixIcon;
	exports.WandIcon = AutoFixIcon;
	exports.AutoFixHighIcon = AutoFixIcon;
	exports.ChildFriendlyIcon = BabyBuggyIcon;
	exports.HamburgerMenuBackIcon = BackburgerIcon;
	exports.SettingsBackupRestoreIcon = BackupRestoreIcon;
	exports.ShuttlecockIcon = BadmintonIcon;
	exports.AccountBalanceIcon = BankIcon;
	exports.BarcodeScannerIcon = BarcodeScanIcon;
	exports.GrainIcon = BarleyIcon;
	exports.ShoppingBasketIcon = BasketIcon;
	exports.YoutubeSportsIcon = BasketballIcon;
	exports.BatteryWarningIcon = BatteryAlertIcon;
	exports.BatteryChargingWirelessWarningIcon = BatteryChargingWirelessAlertIcon;
	exports.BatteryChargingWirelessEmptyIcon = BatteryChargingWirelessOutlineIcon;
	exports.BatteryChargingWireless0Icon = BatteryChargingWirelessOutlineIcon;
	exports.BatteryChargingWirelessFullIcon = BatteryChargingWirelessIcon;
	exports.BatteryChargingWireless100Icon = BatteryChargingWirelessIcon;
	exports.BatteryChargingFullIcon = BatteryChargingIcon;
	exports.Battery0Icon = BatteryOutlineIcon;
	exports.BatteryEmptyIcon = BatteryOutlineIcon;
	exports.BatterySaverIcon = BatteryPlusIcon;
	exports.BatteryFullIcon = BatteryIcon;
	exports.BatteryStdIcon = BatteryIcon;
	exports.Battery100Icon = BatteryIcon;
	exports.ParasolIcon = BeachIcon;
	exports.NotificationsOffIcon = BellOffIcon;
	exports.NotificationsNoneIcon = BellOutlineIcon;
	exports.AddAlertIcon = BellPlusIcon;
	exports.NotificationsActiveIcon = BellRingIcon;
	exports.NotificationsPausedIcon = BellSleepIcon;
	exports.NotificationsIcon = BellIcon;
	exports.BicycleIcon = BikeIcon;
	exports.CyclingIcon = BikeIcon;
	exports.DirectionsBikeIcon = BikeIcon;
	exports.BluetoothSearchingIcon = BluetoothAudioIcon;
	exports.BluetoothConnectedIcon = BluetoothConnectIcon;
	exports.BluetoothDisabledIcon = BluetoothOffIcon;
	exports.SettingsBluetoothIcon = BluetoothSettingsIcon;
	exports.BlurCircularIcon = BlurRadialIcon;
	exports.BlurOnIcon = BlurIcon;
	exports.AutoStoriesIcon = BookOpenPageVariantIcon;
	exports.ImportContactsIcon = BookOpenVariantIcon;
	exports.ChromeReaderModeIcon = BookOpenIcon;
	exports.ClassIcon = BookVariantIcon;
	exports.BookmarkBorderIcon = BookmarkOutlineIcon;
	exports.TurnedInNotIcon = BookmarkOutlineIcon;
	exports.TurnedInIcon = BookmarkIcon;
	exports.BorderColourIcon = BorderColorIcon;
	exports.BorderClearIcon = BorderNoneIcon;
	exports.BorderOuterIcon = BorderOutsideIcon;
	exports.WorkIcon = BriefcaseIcon;
	exports.BrightnessLowIcon = Brightness5Icon;
	exports.BrightnessMediumIcon = Brightness6Icon;
	exports.BrightnessHighIcon = Brightness7Icon;
	exports.PaintbrushIcon = BrushIcon;
	exports.BugReportIcon = BugIcon;
	exports.AnnouncementIcon = BullhornIcon;
	exports.MegaphoneIcon = BullhornIcon;
	exports.TargetArrowIcon = BullseyeArrowIcon;
	exports.DepartureBoardIcon = BusClockIcon;
	exports.DirectionsBusIcon = BusIcon;
	exports.EventAvailableIcon = CalendarCheckIcon;
	exports.CalendarTaskIcon = CalendarCheckIcon;
	exports.EventClockIcon = CalendarClockIcon;
	exports.EventTimeIcon = CalendarClockIcon;
	exports.CalendarTimeIcon = CalendarClockIcon;
	exports.EventEditIcon = CalendarEditIcon;
	exports.EventMultipleCheckIcon = CalendarMultipleCheckIcon;
	exports.EventMultipleIcon = CalendarMultipleIcon;
	exports.EventPlusIcon = CalendarPlusIcon;
	exports.CalendarRsvpIcon = CalendarQuestionIcon;
	exports.EventQuestionIcon = CalendarQuestionIcon;
	exports.DateRangeIcon = CalendarRangeIcon;
	exports.CalendarWeekIcon = CalendarRangeIcon;
	exports.EventRangeIcon = CalendarRangeIcon;
	exports.EventBusyIcon = CalendarRemoveIcon;
	exports.EventNoteIcon = CalendarTextIcon;
	exports.CalendarDayIcon = CalendarTodayIcon;
	exports.EventIcon = CalendarIcon;
	exports.InsertInvitationIcon = CalendarIcon;
	exports.MergeTypeIcon = CallMergeIcon;
	exports.CameraUserIcon = CameraAccountIcon;
	exports.BurstModeIcon = CameraBurstIcon;
	exports.CameraMeteringCentreIcon = CameraMeteringCenterIcon;
	exports.SwitchCameraIcon = CameraSwitchIcon;
	exports.PhotographyIcon = CameraIcon;
	exports.CameraAltIcon = CameraIcon;
	exports.LocalSeeIcon = CameraIcon;
	exports.PhotoCameraIcon = CameraIcon;
	exports.ProhibitedIcon = CancelIcon;
	exports.BanIcon = CancelIcon;
	exports.DoNotDisturbAltIcon = CancelIcon;
	exports.LocalCarWashIcon = CarWashIcon;
	exports.DirectionsCarIcon = CarIcon;
	exports.DriveEtaIcon = CarIcon;
	exports.TimeToLeaveIcon = CarIcon;
	exports.SuitClubsIcon = CardsClubIcon;
	exports.SuitDiamondsIcon = CardsDiamondIcon;
	exports.SuitHeartsIcon = CardsHeartIcon;
	exports.SuitSpadesIcon = CardsSpadeIcon;
	exports.TrolleyOffIcon = CartOffIcon;
	exports.RemoveShoppingCartIcon = CartOffIcon;
	exports.TrolleyOutlineIcon = CartOutlineIcon;
	exports.TrolleyPlusIcon = CartPlusIcon;
	exports.AddShoppingCartIcon = CartPlusIcon;
	exports.TrolleyIcon = CartIcon;
	exports.LocalGroceryStoreIcon = CartIcon;
	exports.ShoppingCartIcon = CartIcon;
	exports.LocalAtmIcon = CashUsdIcon;
	exports.ClosedCircuitTelevisionIcon = CctvIcon;
	exports.SecurityCameraIcon = CctvIcon;
	exports.MobilePhoneAndroidIcon = CellphoneAndroidIcon;
	exports.SmartphoneAndroidIcon = CellphoneAndroidIcon;
	exports.MobilePhoneBasicIcon = CellphoneBasicIcon;
	exports.MobilePhoneDockIcon = CellphoneDockIcon;
	exports.SmartphoneDockIcon = CellphoneDockIcon;
	exports.PhonelinkEraseIcon = CellphoneEraseIcon;
	exports.MobilePhoneEraseIcon = CellphoneEraseIcon;
	exports.SmartphoneEraseIcon = CellphoneEraseIcon;
	exports.MobilePhoneIphoneIcon = CellphoneIphoneIcon;
	exports.SmartphoneIphoneIcon = CellphoneIphoneIcon;
	exports.MobilePhoneLinkOffIcon = CellphoneLinkOffIcon;
	exports.SmartphoneLinkOffIcon = CellphoneLinkOffIcon;
	exports.PhonelinkOffIcon = CellphoneLinkOffIcon;
	exports.MobilePhoneLinkIcon = CellphoneLinkIcon;
	exports.SmartphoneLinkIcon = CellphoneLinkIcon;
	exports.DevicesIcon = CellphoneLinkIcon;
	exports.PhonelinkLockIcon = CellphoneLockIcon;
	exports.MobilePhoneLockIcon = CellphoneLockIcon;
	exports.SmartphoneLockIcon = CellphoneLockIcon;
	exports.MobilePhoneMessageIcon = CellphoneMessageIcon;
	exports.SmartphoneMessageIcon = CellphoneMessageIcon;
	exports.MobilePhoneOffIcon = CellphoneOffIcon;
	exports.SmartphoneOffIcon = CellphoneOffIcon;
	exports.MobileOffIcon = CellphoneOffIcon;
	exports.PhonelinkSetupIcon = CellphoneSettingsVariantIcon;
	exports.MobilePhoneSettingsVariantIcon = CellphoneSettingsVariantIcon;
	exports.SmartphoneSettingsVariantIcon = CellphoneSettingsVariantIcon;
	exports.MobilePhoneSettingsIcon = CellphoneSettingsIcon;
	exports.SmartphoneSettingsIcon = CellphoneSettingsIcon;
	exports.SettingsCellIcon = CellphoneSettingsIcon;
	exports.PhonelinkRingIcon = CellphoneSoundIcon;
	exports.MobilePhoneSoundIcon = CellphoneSoundIcon;
	exports.SmartphoneSoundIcon = CellphoneSoundIcon;
	exports.MobilePhoneTextIcon = CellphoneTextIcon;
	exports.SmartphoneTextIcon = CellphoneTextIcon;
	exports.MobilePhoneWirelessIcon = CellphoneWirelessIcon;
	exports.SmartphoneWirelessIcon = CellphoneWirelessIcon;
	exports.MobilePhoneIcon = CellphoneIcon;
	exports.SmartphoneIcon = CellphoneIcon;
	exports.StayCurrentPortraitIcon = CellphoneIcon;
	exports.StayPrimaryPortraitIcon = CellphoneIcon;
	exports.BubbleChartIcon = ChartBubbleIcon;
	exports.ChartDoughnutVariantIcon = ChartDonutVariantIcon;
	exports.ChartDoughnutIcon = ChartDonutIcon;
	exports.DataUsageIcon = ChartDonutIcon;
	exports.ShowChartIcon = ChartLineVariantIcon;
	exports.TickAllIcon = CheckAllIcon;
	exports.DoneAllIcon = CheckAllIcon;
	exports.TickCircleOutlineIcon = CheckCircleOutlineIcon;
	exports.TickCircleIcon = CheckCircleIcon;
	exports.DoneOutlineIcon = CheckOutlineIcon;
	exports.TickOutlineIcon = CheckOutlineIcon;
	exports.TickIcon = CheckIcon;
	exports.DoneIcon = CheckIcon;
	exports.CheckBoxOutlineBlankIcon = CheckboxBlankOutlineIcon;
	exports.CheckBoxIcon = CheckboxMarkedIcon;
	exports.ChessHorseIcon = ChessKnightIcon;
	exports.ChessCastleIcon = ChessRookIcon;
	exports.ExpandMoreIcon = ChevronDownIcon;
	exports.KeyboardArrowDownIcon = ChevronDownIcon;
	exports.KeyboardArrowLeftIcon = ChevronLeftIcon;
	exports.NavigateBeforeIcon = ChevronLeftIcon;
	exports.KeyboardArrowRightIcon = ChevronRightIcon;
	exports.NavigateNextIcon = ChevronRightIcon;
	exports.ExpandLessIcon = ChevronUpIcon;
	exports.KeyboardArrowUpIcon = ChevronUpIcon;
	exports.ChilliHotIcon = ChiliHotIcon;
	exports.ChilliMediumIcon = ChiliMediumIcon;
	exports.ChilliMildIcon = ChiliMildIcon;
	exports.LensIcon = CircleIcon;
	exports.LocationCityIcon = CityIcon;
	exports.ClipboardUserIcon = ClipboardAccountIcon;
	exports.AssignmentIndIcon = ClipboardAccountIcon;
	exports.ClipboardWarningIcon = ClipboardAlertIcon;
	exports.AssignmentLateIcon = ClipboardAlertIcon;
	exports.AssignmentReturnedIcon = ClipboardArrowDownIcon;
	exports.AssignmentReturnIcon = ClipboardArrowLeftIcon;
	exports.AssignmentTurnedInIcon = ClipboardCheckIcon;
	exports.AssignmentIcon = ClipboardTextIcon;
	exports.ClockWarningIcon = ClockAlertOutlineIcon;
	exports.AccessTimeIcon = ClockOutlineIcon;
	exports.QueryBuilderIcon = ClockOutlineIcon;
	exports.ScheduleIcon = ClockOutlineIcon;
	exports.WatchLaterIcon = ClockIcon;
	exports.HighlightOffIcon = CloseCircleOutlineIcon;
	exports.RemoveCircleIcon = CloseCircleIcon;
	exports.ClearIcon = CloseIcon;
	exports.CcIcon = ClosedCaptionIcon;
	exports.CloudJsonIcon = CloudBracesIcon;
	exports.CloudDoneIcon = CloudCheckIcon;
	exports.CloudQueueIcon = CloudOutlineIcon;
	exports.CloudXmlIcon = CloudTagsIcon;
	exports.BackupIcon = CloudUploadIcon;
	exports.WbCloudyIcon = CloudIcon;
	exports.LuckIcon = CloverIcon;
	exports.TeaOutlineIcon = CoffeeOutlineIcon;
	exports.CupOutlineIcon = CoffeeOutlineIcon;
	exports.TeaIcon = CoffeeIcon;
	exports.FreeBreakfastIcon = CoffeeIcon;
	exports.LocalCafeIcon = CoffeeIcon;
	exports.ManufacturingIcon = CogsIcon;
	exports.TollIcon = CoinsIcon;
	exports.AutoAwesomeMosaicIcon = CollageIcon;
	exports.ColourHelperIcon = ColorHelperIcon;
	exports.CommentUserOutlineIcon = CommentAccountOutlineIcon;
	exports.CommentUserIcon = CommentAccountIcon;
	exports.CommentWarningOutlineIcon = CommentAlertOutlineIcon;
	exports.CommentWarningIcon = CommentAlertIcon;
	exports.ExploreIcon = CompassIcon;
	exports.TerminalLineIcon = ConsoleLineIcon;
	exports.TerminalNetworkIcon = ConsoleNetworkIcon;
	exports.TerminalIcon = ConsoleIcon;
	exports.ScissorsIcon = ContentCutIcon;
	exports.ClipIcon = ContentCutIcon;
	exports.AutoAwesomeIcon = CreationIcon;
	exports.PaymentSettingsIcon = CreditCardSettingsIcon;
	exports.PaymentIcon = CreditCardIcon;
	exports.Crop54Icon = CropLandscapeIcon;
	exports.GpsFixedIcon = CrosshairsGpsIcon;
	exports.MyLocationIcon = CrosshairsGpsIcon;
	exports.GpsNotFixedIcon = CrosshairsIcon;
	exports.LocationSearchingIcon = CrosshairsIcon;
	exports.LocalDrinkIcon = CupWaterIcon;
	exports.TakaIcon = CurrencyBdtIcon;
	exports.BangladeshiTakaIcon = CurrencyBdtIcon;
	exports.FrancIcon = CurrencyChfIcon;
	exports.YuanIcon = CurrencyCnyIcon;
	exports.RenminbiIcon = CurrencyCnyIcon;
	exports.XiIcon = CurrencyEthIcon;
	exports.EuroIcon = CurrencyEurIcon;
	exports.EuroSymbolIcon = CurrencyEurIcon;
	exports.SterlingIcon = CurrencyGbpIcon;
	exports.RupeeIcon = CurrencyInrIcon;
	exports.YenIcon = CurrencyJpyIcon;
	exports.WonIcon = CurrencyKrwIcon;
	exports.KazakhstaniTengeIcon = CurrencyKztIcon;
	exports.NairaIcon = CurrencyNgnIcon;
	exports.RubleIcon = CurrencyRubIcon;
	exports.CurrencyScarabIcon = CurrencySignIcon;
	exports.LiraIcon = CurrencyTryIcon;
	exports.MoneyOffIcon = CurrencyUsdOffIcon;
	exports.AttachMoneyIcon = CurrencyUsdIcon;
	exports.AlternatingCurrentIcon = CurrentAcIcon;
	exports.DirectCurrentIcon = CurrentDcIcon;
	exports.TrashCircleIcon = DeleteCircleIcon;
	exports.BinCircleIcon = DeleteCircleIcon;
	exports.TrashEmptyIcon = DeleteEmptyIcon;
	exports.BinEmptyIcon = DeleteEmptyIcon;
	exports.TrashRestoreIcon = DeleteRestoreIcon;
	exports.BinRestoreIcon = DeleteRestoreIcon;
	exports.RestoreFromTrashIcon = DeleteRestoreIcon;
	exports.TrashVariantIcon = DeleteVariantIcon;
	exports.BinVariantIcon = DeleteVariantIcon;
	exports.TrashIcon = DeleteIcon;
	exports.BinIcon = DeleteIcon;
	exports.ChangeHistoryIcon = DeltaIcon;
	exports.ComputerClassicIcon = DesktopClassicIcon;
	exports.KeypadIcon = DialpadIcon;
	exports.Die1Icon = Dice1Icon;
	exports.Die2Icon = Dice2Icon;
	exports.Die3Icon = Dice3Icon;
	exports.Die4Icon = Dice4Icon;
	exports.Die5Icon = Dice5Icon;
	exports.Die6Icon = Dice6Icon;
	exports.DieD10Icon = DiceD10Icon;
	exports.DieD20Icon = DiceD20Icon;
	exports.DieD4Icon = DiceD4Icon;
	exports.DieD6Icon = DiceD6Icon;
	exports.DieD8Icon = DiceD8Icon;
	exports.DiskWarningIcon = DiskAlertIcon;
	exports.DiscFullIcon = DiskAlertIcon;
	exports.DiscPlayerIcon = DiskPlayerIcon;
	exports.HelixIcon = DnaIcon;
	exports.NoEntryIcon = DoNotDisturbIcon;
	exports.BuildingIcon = DomainIcon;
	exports.CompanyIcon = DomainIcon;
	exports.BusinessIcon = DomainIcon;
	exports.EllipsisHorizontalCircleIcon = DotsHorizontalCircleIcon;
	exports.MoreCircleIcon = DotsHorizontalCircleIcon;
	exports.EllipsisHorizontalIcon = DotsHorizontalIcon;
	exports.MoreHorizIcon = DotsHorizontalIcon;
	exports.EllipsisVerticalCircleIcon = DotsVerticalCircleIcon;
	exports.EllipsisVerticalIcon = DotsVerticalIcon;
	exports.MoreVertIcon = DotsVerticalIcon;
	exports.GetAppIcon = DownloadIcon;
	exports.WeightsIcon = DumbbellIcon;
	exports.GlobeIcon = EarthIcon;
	exports.PublicIcon = EarthIcon;
	exports.EmailWarningIcon = EmailAlertIcon;
	exports.EnvelopeAlertIcon = EmailAlertIcon;
	exports.EnvelopeWarningIcon = EmailAlertIcon;
	exports.EnvelopeOpenOutlineIcon = EmailOpenOutlineIcon;
	exports.DraftsIcon = EmailOpenIcon;
	exports.EnvelopeOpenIcon = EmailOpenIcon;
	exports.MailOutlineIcon = EmailOutlineIcon;
	exports.EnvelopeOutlineIcon = EmailOutlineIcon;
	exports.EnvelopeSecureIcon = EmailSecureIcon;
	exports.EnvelopeVariantIcon = EmailVariantIcon;
	exports.LocalPostOfficeIcon = EmailIcon;
	exports.MailIcon = EmailIcon;
	exports.MarkunreadIcon = EmailIcon;
	exports.EnvelopeIcon = EmailIcon;
	exports.SmileyCoolIcon = EmoticonCoolIcon;
	exports.SmileyDeadIcon = EmoticonDeadIcon;
	exports.SmileyDevilIcon = EmoticonDevilIcon;
	exports.SmileyExcitedIcon = EmoticonExcitedIcon;
	exports.SmileyHappyIcon = EmoticonHappyIcon;
	exports.SmileyNeutralIcon = EmoticonNeutralIcon;
	exports.SmileyPoopIcon = EmoticonPoopIcon;
	exports.SmileySadIcon = EmoticonSadIcon;
	exports.SmileyTongueIcon = EmoticonTongueIcon;
	exports.SmileyIcon = EmoticonIcon;
	exports.InsertEmoticonIcon = EmoticonIcon;
	exports.MoodIcon = EmoticonIcon;
	exports.SentimentVerySatisfiedIcon = EmoticonIcon;
	exports.HideOutlineIcon = EyeOffOutlineIcon;
	exports.VisibilityOffOutlineIcon = EyeOffOutlineIcon;
	exports.HideIcon = EyeOffIcon;
	exports.VisibilityOffIcon = EyeOffIcon;
	exports.ShowOutlineIcon = EyeOutlineIcon;
	exports.VisibilityOutlineIcon = EyeOutlineIcon;
	exports.ShowIcon = EyeIcon;
	exports.VisibilityIcon = EyeIcon;
	exports.RemoveRedEyeIcon = EyeIcon;
	exports.ColorizeIcon = EyedropperVariantIcon;
	exports.ColouriseIcon = EyedropperVariantIcon;
	exports.IndustrialIcon = FactoryIcon;
	exports.CargoShipIcon = FerryIcon;
	exports.BoatIcon = FerryIcon;
	exports.ShipIcon = FerryIcon;
	exports.DirectionsBoatIcon = FerryIcon;
	exports.DirectionsFerryIcon = FerryIcon;
	exports.FileUserIcon = FileAccountIcon;
	exports.FileReportIcon = FileChartIcon;
	exports.FileCsvIcon = FileDelimitedIcon;
	exports.PrintPreviewIcon = FileFindIcon;
	exports.FindInPageIcon = FileFindIcon;
	exports.NoteAddIcon = FilePlusIcon;
	exports.RestorePageIcon = FileRestoreIcon;
	exports.SubtasksIcon = FileTreeIcon;
	exports.FileRevertIcon = FileUndoIcon;
	exports.FileDiscardIcon = FileUndoIcon;
	exports.InsertDriveFileIcon = FileIcon;
	exports.DraftIcon = FileIcon;
	exports.CameraRollIcon = FilmIcon;
	exports.LocalMoviesIcon = FilmstripIcon;
	exports.TheatersIcon = FilmstripIcon;
	exports.FilterListIcon = FilterVariantIcon;
	exports.ChartFinanceIcon = FinanceIcon;
	exports.FireEngineIcon = FireTruckIcon;
	exports.WhatshotIcon = FireIcon;
	exports.AssistantPhotoIcon = FlagIcon;
	exports.AmpIcon = FlashCircleIcon;
	exports.OfflineBoltIcon = FlashCircleIcon;
	exports.LightningBoltCircleIcon = FlashCircleIcon;
	exports.LighningBoltOutlineIcon = FlashOutlineIcon;
	exports.LightningBoltIcon = FlashIcon;
	exports.FlashOnIcon = FlashIcon;
	exports.ElectricityIcon = FlashIcon;
	exports.TorchOffIcon = FlashlightOffIcon;
	exports.TorchIcon = FlashlightIcon;
	exports.LocalFloristIcon = FlowerIcon;
	exports.FolderUserIcon = FolderAccountIcon;
	exports.FolderSharedIcon = FolderAccountIcon;
	exports.FolderMydriveIcon = FolderGoogleDriveIcon;
	exports.PermMediaIcon = FolderMultipleImageIcon;
	exports.CreateNewFolderIcon = FolderPlusIcon;
	exports.FolderSpecialIcon = FolderStarIcon;
	exports.FormatAlignCentreIcon = FormatAlignCenterIcon;
	exports.FormatColourFillIcon = FormatColorFillIcon;
	exports.FormatColourTextIcon = FormatColorTextIcon;
	exports.FormatFloatCentreIcon = FormatFloatCenterIcon;
	exports.FormatHorizontalAlignCentreIcon = FormatHorizontalAlignCenterIcon;
	exports.FormatListNumberedIcon = FormatListNumbersIcon;
	exports.Rotate90DegreesCcwIcon = FormatRotate90Icon;
	exports.StrikethroughSIcon = FormatStrikethroughVariantIcon;
	exports.FormatUnderlinedIcon = FormatUnderlineIcon;
	exports.FormatVerticalAlignCentreIcon = FormatVerticalAlignCenterIcon;
	exports.MessageGroupIcon = ForumIcon;
	exports.QuestionAnswerIcon = ForumIcon;
	exports.RefrigeratorFilledBottomIcon = FridgeFilledBottomIcon;
	exports.RefrigeratorFilledTopIcon = FridgeFilledTopIcon;
	exports.RefrigeratorFilledIcon = FridgeFilledIcon;
	exports.KitchenIcon = FridgeIcon;
	exports.RefrigeratorIcon = FridgeIcon;
	exports.GamesIcon = GamepadIcon;
	exports.GarageWarningIcon = GarageAlertIcon;
	exports.GasPumpIcon = GasStationIcon;
	exports.PetrolPumpIcon = GasStationIcon;
	exports.PetrolStationIcon = GasStationIcon;
	exports.LocalGasStationIcon = GasStationIcon;
	exports.LogicGateAndIcon = GateAndIcon;
	exports.LogicGateNandIcon = GateNandIcon;
	exports.LogicGateNorIcon = GateNorIcon;
	exports.LogicGateNotIcon = GateNotIcon;
	exports.LogicGateOrIcon = GateOrIcon;
	exports.LogicGateXnorIcon = GateXnorIcon;
	exports.LogicGateXorIcon = GateXorIcon;
	exports.SwapDrivingAppsWheelIcon = GaugeIcon;
	exports.CourtHammerIcon = GavelIcon;
	exports.InteractionDoubleTapIcon = GestureDoubleTapIcon;
	exports.HandDoubleTapIcon = GestureDoubleTapIcon;
	exports.InteractionTapIcon = GestureTapIcon;
	exports.HandTapIcon = GestureTapIcon;
	exports.DonateIcon = GiftIcon;
	exports.PresentIcon = GiftIcon;
	exports.LocalBarIcon = GlassCocktailIcon;
	exports.CocktailIcon = GlassCocktailIcon;
	exports.MartiniIcon = GlassCocktailIcon;
	exports.GolfCourseIcon = GolfIcon;
	exports.CableCarIcon = GondolaIcon;
	exports.ChromecastIcon = GoogleChromeIcon;
	exports.AttachDriveIcon = GoogleDriveIcon;
	exports.GTranslateIcon = GoogleTranslateIcon;
	exports.WalletProductIcon = GoogleWalletIcon;
	exports.GridOnIcon = GridIcon;
	exports.HeadsetMicIcon = HeadsetIcon;
	exports.FavoriteBorderIcon = HeartOutlineIcon;
	exports.FavouriteBorderIcon = HeartOutlineIcon;
	exports.FavoriteOutlineIcon = HeartOutlineIcon;
	exports.FavouriteOutlineIcon = HeartOutlineIcon;
	exports.FavoriteIcon = HeartIcon;
	exports.FavouriteIcon = HeartIcon;
	exports.HelpOutlineIcon = HelpCircleOutlineIcon;
	exports.QuestionMarkCircleIcon = HelpCircleIcon;
	exports.QuestionMarkIcon = HelpIcon;
	exports.HdBoxIcon = HighDefinitionBoxIcon;
	exports.HdIcon = HighDefinitionIcon;
	exports.AutobahnIcon = HighwayIcon;
	exports.MotorwayIcon = HighwayIcon;
	exports.RecentIcon = HistoryIcon;
	exports.LatestIcon = HistoryIcon;
	exports.ClockArrowIcon = HistoryIcon;
	exports.CounterclockwiseIcon = HistoryIcon;
	exports.HomeUserIcon = HomeAccountIcon;
	exports.HomeWarningIcon = HomeAlertIcon;
	exports.HouseCircleIcon = HomeCircleIcon;
	exports.FamilyIcon = HomeHeartIcon;
	exports.HouseMapMarkerIcon = HomeMapMarkerIcon;
	exports.HouseModernIcon = HomeModernIcon;
	exports.HouseOutlineIcon = HomeOutlineIcon;
	exports.HouseVariantIcon = HomeVariantIcon;
	exports.HouseIcon = HomeIcon;
	exports.LocalHospitalIcon = HospitalIcon;
	exports.BedIcon = HotelIcon;
	exports.LocalHotelIcon = HotelIcon;
	exports.WomanIcon = HumanFemaleIcon;
	exports.WcIcon = HumanMaleFemaleIcon;
	exports.ManWomanIcon = HumanMaleFemaleIcon;
	exports.ManIcon = HumanMaleIcon;
	exports.PregnantWomanIcon = HumanPregnantIcon;
	exports.AccessibilityIcon = HumanIcon;
	exports.PhotoAlbumIcon = ImageAlbumIcon;
	exports.BrokenImageIcon = ImageBrokenVariantIcon;
	exports.FilterBAndWIcon = ImageFilterBlackWhiteIcon;
	exports.ImageFilterCentreFocusWeakIcon = ImageFilterCenterFocusWeakIcon;
	exports.ImageFilterCentreFocusIcon = ImageFilterCenterFocusIcon;
	exports.MountainIcon = ImageFilterHdrIcon;
	exports.LandscapeIcon = ImageFilterHdrIcon;
	exports.ImageMultipleOutlineIcon = ImageFilterIcon;
	exports.CollectionsIcon = ImageMultipleIcon;
	exports.PhotoLibraryIcon = ImageMultipleIcon;
	exports.InsertPhotoIcon = ImageIcon;
	exports.MoveToInboxIcon = InboxArrowDownIcon;
	exports.InfoOutlineIcon = InformationOutlineIcon;
	exports.AboutOutlineIcon = InformationOutlineIcon;
	exports.AboutIcon = InformationIcon;
	exports.InvertColoursIcon = InvertColorsIcon;
	exports.JewishIcon = JudaismIcon;
	exports.MartialArtsIcon = KarateIcon;
	exports.VpnKeyIcon = KeyIcon;
	exports.KeyboardCapslockIcon = KeyboardCapsIcon;
	exports.KeyboardHideIcon = KeyboardCloseIcon;
	exports.BugfoodIcon = LadybugIcon;
	exports.LadybirdIcon = LadybugIcon;
	exports.ComputerIcon = LaptopIcon;
	exports.LayersClearIcon = LayersOffIcon;
	exports.AddToPhotosIcon = LibraryPlusIcon;
	exports.LibraryAddIcon = LibraryPlusIcon;
	exports.QueueIcon = LibraryPlusIcon;
	exports.LocalLibraryIcon = LibraryIcon;
	exports.LifePreserverIcon = LifebuoyIcon;
	exports.SupportIcon = LifebuoyIcon;
	exports.InsertLinkIcon = LinkIcon;
	exports.TuxIcon = LinuxIcon;
	exports.LockWarningIcon = LockAlertIcon;
	exports.EnhancedEncryptionIcon = LockPlusIcon;
	exports.ForgotPasswordIcon = LockQuestionIcon;
	exports.PasswordResetIcon = LockResetIcon;
	exports.HttpsIcon = LockIcon;
	exports.RainbowIcon = LooksIcon;
	exports.ZoomOutOutlineIcon = MagnifyMinusOutlineIcon;
	exports.ZoomOutIcon = MagnifyMinusIcon;
	exports.ZoomInOutlineIcon = MagnifyPlusOutlineIcon;
	exports.ZoomInIcon = MagnifyPlusIcon;
	exports.SearchIcon = MagnifyIcon;
	exports.MarkunreadMailboxIcon = MailboxIcon;
	exports.ExploreNearbyIcon = MapMarkerCircleIcon;
	exports.LocationOffIcon = MapMarkerOffIcon;
	exports.AddLocationIcon = MapMarkerPlusIcon;
	exports.LocationIcon = MapMarkerIcon;
	exports.AddressMarkerIcon = MapMarkerIcon;
	exports.LocationOnIcon = MapMarkerIcon;
	exports.PlaceIcon = MapMarkerIcon;
	exports.RoomIcon = MapMarkerIcon;
	exports.BeenhereIcon = MarkerCheckIcon;
	exports.HighlighterIcon = MarkerIcon;
	exports.FirstAidKitIcon = MedicalBagIcon;
	exports.ArrowDropDownIcon = MenuDownIcon;
	exports.ArrowDropUpIcon = MenuUpIcon;
	exports.HamburgerMenuIcon = MenuIcon;
	exports.FeedbackIcon = MessageAlertIcon;
	exports.MessageWarningIcon = MessageAlertIcon;
	exports.SmsFailedIcon = MessageAlertIcon;
	exports.SpeakerNotesOffIcon = MessageBulletedOffIcon;
	exports.SpeakerNotesIcon = MessageBulletedIcon;
	exports.RateReviewIcon = MessageDrawIcon;
	exports.MmsIcon = MessageImageIcon;
	exports.ChatBubbleOutlineIcon = MessageOutlineIcon;
	exports.SmsIcon = MessageProcessingIcon;
	exports.TextsmsIcon = MessageProcessingIcon;
	exports.InsertCommentIcon = MessageReplyTextIcon;
	exports.ModeCommentIcon = MessageReplyIcon;
	exports.ChatIcon = MessageTextIcon;
	exports.VoiceChatIcon = MessageVideoIcon;
	exports.ChatBubbleIcon = MessageIcon;
	exports.MicOffIcon = MicrophoneOffIcon;
	exports.MicNoneIcon = MicrophoneOutlineIcon;
	exports.SettingsVoiceIcon = MicrophoneSettingsIcon;
	exports.KeyboardVoiceIcon = MicrophoneIcon;
	exports.CheckboxIndeterminateOutlineIcon = MinusBoxOutlineIcon;
	exports.IndeterminateCheckBoxIcon = MinusBoxIcon;
	exports.RemoveCircleOutlineIcon = MinusCircleOutlineIcon;
	exports.DoNotDisturbOnIcon = MinusCircleIcon;
	exports.RemoveIcon = MinusIcon;
	exports.ImportantDevicesIcon = MonitorCellphoneStarIcon;
	exports.DesktopWindowsIcon = MonitorIcon;
	exports.MotorcycleIcon = MotorbikeIcon;
	exports.FilmReelIcon = MovieRollIcon;
	exports.SlateIcon = MovieIcon;
	exports.ClapperboardIcon = MovieIcon;
	exports.MovieCreationIcon = MovieIcon;
	exports.NetworkAttachedStorageIcon = NasIcon;
	exports.ArrowCompassIcon = NavigationIcon;
	exports.SyringeIcon = NeedleIcon;
	exports.NetworkStrength1WarningIcon = NetworkStrength1AlertIcon;
	exports.NetworkStrength2WarningIcon = NetworkStrength2AlertIcon;
	exports.NetworkStrength3WarningIcon = NetworkStrength3AlertIcon;
	exports.NetworkStrength4WarningIcon = NetworkStrength4AlertIcon;
	exports.NetworkStrength0Icon = NetworkStrengthOutlineIcon;
	exports.FiberNewIcon = NewBoxIcon;
	exports.Filter1Icon = Numeric1BoxMultipleOutlineIcon;
	exports.LooksOneIcon = Numeric1BoxIcon;
	exports.Filter2Icon = Numeric2BoxMultipleOutlineIcon;
	exports.LooksTwoIcon = Numeric2BoxIcon;
	exports.Filter3Icon = Numeric3BoxMultipleOutlineIcon;
	exports.Looks3Icon = Numeric3BoxIcon;
	exports.Filter4Icon = Numeric4BoxMultipleOutlineIcon;
	exports.Looks4Icon = Numeric4BoxIcon;
	exports.Filter5Icon = Numeric5BoxMultipleOutlineIcon;
	exports.Looks5Icon = Numeric5BoxIcon;
	exports.Filter6Icon = Numeric6BoxMultipleOutlineIcon;
	exports.Looks6Icon = Numeric6BoxIcon;
	exports.Filter7Icon = Numeric7BoxMultipleOutlineIcon;
	exports.Filter8Icon = Numeric8BoxMultipleOutlineIcon;
	exports.Filter9Icon = Numeric9BoxMultipleOutlineIcon;
	exports.Filter9PlusIcon = Numeric9PlusBoxMultipleOutlineIcon;
	exports.OkRuIcon = OdnoklassnikiIcon;
	exports.OpenInBrowserIcon = OpenInAppIcon;
	exports.ExternalLinkIcon = OpenInNewIcon;
	exports.UnarchiveIcon = PackageUpIcon;
	exports.FirstPageIcon = PageFirstIcon;
	exports.LastPageIcon = PageLastIcon;
	exports.StyleIcon = PaletteSwatchIcon;
	exports.ColorLensIcon = PaletteIcon;
	exports.ColourLensIcon = PaletteIcon;
	exports.AttachmentVerticalIcon = PaperclipIcon;
	exports.AttachFileIcon = PaperclipIcon;
	exports.CarParkIcon = ParkingIcon;
	exports.LocalParkingIcon = ParkingIcon;
	exports.PauseCircleFilledIcon = PauseCircleIcon;
	exports.PetsIcon = PawIcon;
	exports.EditIcon = PencilIcon;
	exports.CreateIcon = PencilIcon;
	exports.ModeEditIcon = PencilIcon;
	exports.ChemistIcon = PharmacyIcon;
	exports.LocalPharmacyIcon = PharmacyIcon;
	exports.PhoneBluetoothSpeakerIcon = PhoneBluetoothIcon;
	exports.TelephoneBluetoothIcon = PhoneBluetoothIcon;
	exports.PhoneForwardedIcon = PhoneForwardIcon;
	exports.TelephoneForwardIcon = PhoneForwardIcon;
	exports.CallEndIcon = PhoneHangupIcon;
	exports.TelephoneHangupIcon = PhoneHangupIcon;
	exports.TelephoneInTalkIcon = PhoneInTalkIcon;
	exports.TelephoneIncomingIcon = PhoneIncomingIcon;
	exports.TelephoneLockedIcon = PhoneLockedIcon;
	exports.AddCallIcon = PhonePlusIcon;
	exports.SettingsPhoneIcon = PhoneSettingsIcon;
	exports.CallIcon = PhoneIcon;
	exports.LocalPhoneIcon = PhoneIcon;
	exports.TelephoneIcon = PhoneIcon;
	exports.MedicineIcon = PillIcon;
	exports.CapsuleIcon = PillIcon;
	exports.HistoricIcon = PillarIcon;
	exports.ColumnIcon = PillarIcon;
	exports.KeepOffOutlineIcon = PinOffOutlineIcon;
	exports.KeepOffIcon = PinOffIcon;
	exports.KeepOutlineIcon = PinOutlineIcon;
	exports.KeepIcon = PinIcon;
	exports.GunIcon = PistolIcon;
	exports.PizzeriaIcon = PizzaIcon;
	exports.LocalPizzaIcon = PizzaIcon;
	exports.AeroplaneShieldIcon = PlaneShieldIcon;
	exports.AirplaneShieldIcon = PlaneShieldIcon;
	exports.SlideshowIcon = PlayBoxOutlineIcon;
	exports.PlayCircleFilledIcon = PlayCircleIcon;
	exports.MediaNetworkIcon = PlayNetworkIcon;
	exports.PlayArrowIcon = PlayIcon;
	exports.SubscriptionsIcon = PlaylistCheckIcon;
	exports.PlaylistAddCheckIcon = PlaylistCheckIcon;
	exports.PlaylistAddIcon = PlaylistPlusIcon;
	exports.AddBoxIcon = PlusBoxIcon;
	exports.ControlPointDuplicateIcon = PlusCircleMultipleOutlineIcon;
	exports.AddCircleOutlineIcon = PlusCircleOutlineIcon;
	exports.ControlPointIcon = PlusCircleOutlineIcon;
	exports.AddCircleIcon = PlusCircleIcon;
	exports.AddIcon = PlusIcon;
	exports.AssessmentIcon = PollBoxIcon;
	exports.InsertChartIcon = PollBoxIcon;
	exports.BarChartIcon = PollIcon;
	exports.HashtagBoxIcon = PoundBoxIcon;
	exports.HashtagIcon = PoundIcon;
	exports.SettingsPowerIcon = PowerSettingsIcon;
	exports.PlugSocketAuIcon = PowerSocketAuIcon;
	exports.PowerSocketTypeIIcon = PowerSocketAuIcon;
	exports.PowerSocketCnIcon = PowerSocketAuIcon;
	exports.PowerSocketArIcon = PowerSocketAuIcon;
	exports.PowerSocketNzIcon = PowerSocketAuIcon;
	exports.PowerSocketPgIcon = PowerSocketAuIcon;
	exports.PlugSocketEuIcon = PowerSocketEuIcon;
	exports.PlugSocketUkIcon = PowerSocketUkIcon;
	exports.PowerSocketTypeGIcon = PowerSocketUkIcon;
	exports.PowerSocketIeIcon = PowerSocketUkIcon;
	exports.PowerSocketHkIcon = PowerSocketUkIcon;
	exports.PowerSocketMyIcon = PowerSocketUkIcon;
	exports.PowerSocketCyIcon = PowerSocketUkIcon;
	exports.PowerSocketMtIcon = PowerSocketUkIcon;
	exports.PowerSocketSgIcon = PowerSocketUkIcon;
	exports.PlugSocketUsIcon = PowerSocketUsIcon;
	exports.PowerSocketJpIcon = PowerSocketUsIcon;
	exports.PowerSocketCaIcon = PowerSocketUsIcon;
	exports.PowerSocketMxIcon = PowerSocketUsIcon;
	exports.PowerSocketTypeBIcon = PowerSocketUsIcon;
	exports.PlugSocketIcon = PowerSocketIcon;
	exports.PowerSettingsNewIcon = PowerIcon;
	exports.ShutdownIcon = PowerIcon;
	exports.PrinterWarningIcon = PrinterAlertIcon;
	exports.LocalPrintshopIcon = PrinterIcon;
	exports.LowPriorityIcon = PriorityLowIcon;
	exports.ExtensionIcon = PuzzleIcon;
	exports.HighQualityIcon = QualityHighIcon;
	exports.BunnyIcon = RabbitIcon;
	exports.TrackChangesIcon = RadarIcon;
	exports.RadioButtonUncheckedIcon = RadioboxBlankIcon;
	exports.RadioButtonCheckedIcon = RadioboxMarkedIcon;
	exports.FiberManualRecordIcon = RecordIcon;
	exports.ImageAspectRatioIcon = RelativeScaleIcon;
	exports.SettingsRemoteIcon = RemoteIcon;
	exports.RepeatOneIcon = RepeatOnceIcon;
	exports.FastRewindIcon = RewindIcon;
	exports.DiamondOutlineIcon = RhombusOutlineIcon;
	exports.NeatoIcon = RobotVacuumVariantIcon;
	exports.RoombaIcon = RobotVacuumIcon;
	exports.ArrowRotateLeftIcon = RotateLeftIcon;
	exports.ArrowRotateRightIcon = RotateRightIcon;
	exports.SignRoutesIcon = RoutesIcon;
	exports.RssFeedIcon = RssIcon;
	exports.DirectionsRunIcon = RunIcon;
	exports.DiscountIcon = SaleIcon;
	exports.GraduationCapIcon = SchoolIcon;
	exports.ScreenLockRotationIcon = ScreenRotationLockIcon;
	exports.SdCardIcon = SdIcon;
	exports.SdStorageIcon = SdIcon;
	exports.AirlineSeatFlatAngledIcon = SeatFlatAngledIcon;
	exports.AirlineSeatFlatIcon = SeatFlatIcon;
	exports.AirlineSeatIndividualSuiteIcon = SeatIndividualSuiteIcon;
	exports.AirlineSeatLegroomExtraIcon = SeatLegroomExtraIcon;
	exports.AirlineSeatLegroomNormalIcon = SeatLegroomNormalIcon;
	exports.AirlineSeatLegroomReducedIcon = SeatLegroomReducedIcon;
	exports.AirlineSeatReclineExtraIcon = SeatReclineExtraIcon;
	exports.AirlineSeatReclineNormalIcon = SeatReclineNormalIcon;
	exports.SetCentreRightIcon = SetCenterRightIcon;
	exports.SetCentreIcon = SetCenterIcon;
	exports.SetLeftCentreIcon = SetLeftCenterIcon;
	exports.GearBoxIcon = SettingsBoxIcon;
	exports.CogBoxIcon = SettingsBoxIcon;
	exports.SettingsApplicationsIcon = SettingsBoxIcon;
	exports.CogOutlineIcon = SettingsOutlineIcon;
	exports.GearOutlineIcon = SettingsOutlineIcon;
	exports.CogIcon = SettingsIcon;
	exports.GearIcon = SettingsIcon;
	exports.ThemeIcon = ShapeOutlineIcon;
	exports.CategoryIcon = ShapeIcon;
	exports.VoyagerIcon = ShipWheelIcon;
	exports.LocalMallIcon = ShoppingIcon;
	exports.SummationIcon = SigmaIcon;
	exports.SignalCellular0Icon = SignalCellularOutlineIcon;
	exports.LocalDiningIcon = SilverwareIcon;
	exports.RestaurantMenuIcon = SilverwareIcon;
	exports.LocalRestaurantIcon = SilverwareIcon;
	exports.SimWarningIcon = SimAlertIcon;
	exports.SimCardAlertIcon = SimAlertIcon;
	exports.SignalCellularNoSimIcon = SimOffIcon;
	exports.SimCardIcon = SimIcon;
	exports.WorkflowIcon = SitemapIcon;
	exports.FlowchartIcon = SitemapIcon;
	exports.TitleBackwardIcon = SkipBackwardIcon;
	exports.PreviousTitleIcon = SkipBackwardIcon;
	exports.TitleForwardIcon = SkipForwardIcon;
	exports.NextTitleIcon = SkipForwardIcon;
	exports.NestProtectIcon = SmokeDetectorIcon;
	exports.NoSmokingIcon = SmokingOffIcon;
	exports.CigaretteOffIcon = SmokingOffIcon;
	exports.SmokeFreeIcon = SmokingOffIcon;
	exports.CigaretteIcon = SmokingIcon;
	exports.SmokingAreaIcon = SmokingIcon;
	exports.SmokingRoomsIcon = SmokingIcon;
	exports.FootballPitchIcon = SoccerFieldIcon;
	exports.CouchIcon = SofaIcon;
	exports.SortByAlphaIcon = SortAlphabeticalIcon;
	exports.PaintIcon = SprayIcon;
	exports.AerosolIcon = SprayIcon;
	exports.ArenaIcon = StadiumIcon;
	exports.FeatureHighlightIcon = StarCircleOutlineIcon;
	exports.StarsIcon = StarCircleIcon;
	exports.StarBorderIcon = StarOutlineIcon;
	exports.GradeIcon = StarIcon;
	exports.StarRateIcon = StarIcon;
	exports.SearchHandsFreeOffIcon = SteeringOffIcon;
	exports.SearchHandsFreeIcon = SteeringIcon;
	exports.FrameBackwardIcon = StepBackward2Icon;
	exports.FrameForwardIcon = StepForward2Icon;
	exports.LocalConvenienceStoreIcon = Store24HourIcon;
	exports.Shop24HourIcon = Store24HourIcon;
	exports.ShopIcon = StoreIcon;
	exports.StoreMallDirectoryIcon = StoreIcon;
	exports.CookerIcon = StoveIcon;
	exports.OvenIcon = StoveIcon;
	exports.MetroVariantIcon = SubwayVariantIcon;
	exports.TubeVariantIcon = SubwayVariantIcon;
	exports.UndergroundVariantIcon = SubwayVariantIcon;
	exports.DirectionsSubwayIcon = SubwayVariantIcon;
	exports.DirectionsTransitIcon = SubwayVariantIcon;
	exports.MetroIcon = SubwayIcon;
	exports.TubeIcon = SubwayIcon;
	exports.UndergroundIcon = SubwayIcon;
	exports.PeakIcon = SummitIcon;
	exports.StereoIcon = SurroundSound20Icon;
	exports.SwapCallsIcon = SwapVerticalVariantIcon;
	exports.ImportExportIcon = SwapVerticalIcon;
	exports.SyncWarningIcon = SyncAlertIcon;
	exports.SyncProblemIcon = SyncAlertIcon;
	exports.SyncDisabledIcon = SyncOffIcon;
	exports.TocIcon = TableOfContentsIcon;
	exports.MobileDevicesIcon = TabletCellphoneIcon;
	exports.TabletMacIcon = TabletIpadIcon;
	exports.LoyaltyIcon = TagHeartIcon;
	exports.LocalOfferIcon = TagIcon;
	exports.LocalTaxiIcon = TaxiIcon;
	exports.TeacherIcon = TeachIcon;
	exports.TeachingIcon = TeachIcon;
	exports.TvBoxIcon = TelevisionBoxIcon;
	exports.TvGuideIcon = TelevisionBoxIcon;
	exports.TvClassicOffIcon = TelevisionClassicOffIcon;
	exports.TvClassicIcon = TelevisionClassicIcon;
	exports.TvOffIcon = TelevisionOffIcon;
	exports.TvIcon = TelevisionIcon;
	exports.TemperatureCentigradeIcon = TemperatureCelsiusIcon;
	exports.CampingIcon = TentIcon;
	exports.CinemaIcon = TheaterIcon;
	exports.TheatreIcon = TheaterIcon;
	exports.SunMoonStarsIcon = ThemeLightDarkIcon;
	exports.NestIcon = ThermostatIcon;
	exports.ComicThoughtBubbleOutlineIcon = ThoughtBubbleOutlineIcon;
	exports.ComicBubbleIcon = ThoughtBubbleIcon;
	exports.DislikeOutlineIcon = ThumbDownOutlineIcon;
	exports.ThumbsDownOutlineIcon = ThumbDownOutlineIcon;
	exports.DislikeIcon = ThumbDownIcon;
	exports.ThumbsDownIcon = ThumbDownIcon;
	exports.LikeOutlineIcon = ThumbUpOutlineIcon;
	exports.ThumbsUpOutlineIcon = ThumbUpOutlineIcon;
	exports.LikeIcon = ThumbUpIcon;
	exports.ThumbsUpIcon = ThumbUpIcon;
	exports.LikeDislikeIcon = ThumbsUpDownIcon;
	exports.TicketUserIcon = TicketAccountIcon;
	exports.ConfirmationNumberIcon = TicketConfirmationIcon;
	exports.CouponIcon = TicketPercentIcon;
	exports.VoucherIcon = TicketPercentIcon;
	exports.LocalActivityIcon = TicketIcon;
	exports.LocalPlayIcon = TicketIcon;
	exports.LocalAttractionIcon = TicketIcon;
	exports.StopwatchOffIcon = TimerOffIcon;
	exports.HourglassEmptyIcon = TimerSandEmptyIcon;
	exports.HourglassFullIcon = TimerSandFullIcon;
	exports.HourglassIcon = TimerSandIcon;
	exports.StopwatchIcon = TimerIcon;
	exports.BracketIcon = TournamentIcon;
	exports.AutoTowingIcon = TowingIcon;
	exports.DirectionsRailwayIcon = TrainIcon;
	exports.TransferWithinAStationIcon = TransitTransferIcon;
	exports.MaskedTransitionsIcon = TransitionMaskedIcon;
	exports.MotionIcon = TransitionIcon;
	exports.LanguageIcon = TranslateIcon;
	exports.TrendingFlatIcon = TrendingNeutralIcon;
	exports.AchievementAwardIcon = TrophyAwardIcon;
	exports.AchievementOutlineIcon = TrophyOutlineIcon;
	exports.AchievementVariantOutlineIcon = TrophyVariantOutlineIcon;
	exports.AchievementVariantIcon = TrophyVariantIcon;
	exports.AchievementIcon = TrophyIcon;
	exports.LorryDeliveryIcon = TruckDeliveryIcon;
	exports.LorryFastIcon = TruckFastIcon;
	exports.LorryIcon = TruckIcon;
	exports.LocalShippingIcon = TruckIcon;
	exports.EqualiserVerticalIcon = TuneVerticalIcon;
	exports.InstantMixIcon = TuneVerticalIcon;
	exports.MixerSettingsIcon = TuneIcon;
	exports.EqualiserIcon = TuneIcon;
	exports.UhdIcon = UltraHighDefinitionIcon;
	exports.UnrealEngineIcon = UnrealIcon;
	exports.ClockwiseIcon = UpdateIcon;
	exports.FileUploadIcon = UploadIcon;
	exports.VanCandyIcon = VanUtilityIcon;
	exports.BezierIcon = VectorCurveIcon;
	exports.ShieldCheckIcon = VerifiedIcon;
	exports.VerifiedUserIcon = VerifiedIcon;
	exports.VibrationIcon = VibrateIcon;
	exports.VideoUserIcon = VideoAccountIcon;
	exports.SettingsInputAntennaIcon = VideoInputAntennaIcon;
	exports.VideoInputCompositeIcon = VideoInputComponentIcon;
	exports.SettingsInputComponentIcon = VideoInputComponentIcon;
	exports.SettingsInputCompositeIcon = VideoInputComponentIcon;
	exports.VideoInputYpbprIcon = VideoInputComponentIcon;
	exports.RcaIcon = VideoInputComponentIcon;
	exports.SettingsInputHdmiIcon = VideoInputHdmiIcon;
	exports.SettingsInputSvideoIcon = VideoInputSvideoIcon;
	exports.VideocamOffIcon = VideoOffIcon;
	exports.VideoCallIcon = VideoPlusIcon;
	exports.VideoStabilisationIcon = VideoStabilizationIcon;
	exports.SwitchVideoIcon = VideoSwitchIcon;
	exports.VideocamIcon = VideoIcon;
	exports.VrIcon = VirtualRealityIcon;
	exports.VkontakteBoxIcon = VkBoxIcon;
	exports.VkontakteCircleIcon = VkCircleIcon;
	exports.VkontakteIcon = VkIcon;
	exports.RecordVoiceOverIcon = VoiceIcon;
	exports.AudioIcon = VolumeHighIcon;
	exports.SpeakerphoneIcon = VolumeHighIcon;
	exports.MuteIcon = VolumeOffIcon;
	exports.AudioOffIcon = VolumeOffIcon;
	exports.SpeakerphoneOffIcon = VolumeOffIcon;
	exports.DirectionsWalkIcon = WalkIcon;
	exports.CardGiftcardIcon = WalletGiftcardIcon;
	exports.RedeemIcon = WalletGiftcardIcon;
	exports.CardMembershipIcon = WalletMembershipIcon;
	exports.CardTravelIcon = WalletTravelIcon;
	exports.AccountBalanceWalletIcon = WalletIcon;
	exports.LaundretteIcon = WashingMachineIcon;
	exports.LocalLaundryServiceIcon = WashingMachineIcon;
	exports.FormatColorResetIcon = WaterOffIcon;
	exports.HumidityIcon = WaterPercentIcon;
	exports.BrandingWatermarkIcon = WatermarkIcon;
	exports.MoonAndStarsIcon = WeatherNightIcon;
	exports.NightSkyIcon = WeatherNightIcon;
	exports.AccessibleIcon = WheelchairAccessibilityIcon;
	exports.WbAutoIcon = WhiteBalanceAutoIcon;
	exports.WbIncandescentIcon = WhiteBalanceIncandescentIcon;
	exports.WbIridescentIcon = WhiteBalanceIridescentIcon;
	exports.WbSunnyIcon = WhiteBalanceSunnyIcon;
	exports.WifiStrength1WarningIcon = WifiStrength1AlertIcon;
	exports.WifiStrength2WarningIcon = WifiStrength2AlertIcon;
	exports.WifiStrength3WarningIcon = WifiStrength3AlertIcon;
	exports.WifiStrength4WarningIcon = WifiStrength4AlertIcon;
	exports.WifiStrengthWarningOutlineIcon = WifiStrengthAlertOutlineIcon;
	exports.WifiStrength0AlertIcon = WifiStrengthAlertOutlineIcon;
	exports.WifiStrength0WarningIcon = WifiStrengthAlertOutlineIcon;
	exports.WifiStrength0LockIcon = WifiStrengthLockOutlineIcon;
	exports.WifiStrength0Icon = WifiStrengthOutlineIcon;
	exports.BuildIcon = WrenchIcon;
	exports.MicrosoftXamarinOutlineIcon = XamarinOutlineIcon;
	exports.MicrosoftXamarinIcon = XamarinIcon;
	exports.XboxControllerBatteryWarningIcon = XboxControllerBatteryAlertIcon;
	exports.VideoYoutubeIcon = YoutubeIcon;
	exports.YoutubePlayIcon = YoutubeIcon;


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(114)))

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(199)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _classCallCheck = _interopDefault(__webpack_require__(8));
	var _createClass = _interopDefault(__webpack_require__(9));
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(14));
	var _getPrototypeOf = _interopDefault(__webpack_require__(12));
	var _inherits = _interopDefault(__webpack_require__(13));
	var _typeof = _interopDefault(__webpack_require__(47));
	var _objectWithoutProperties = _interopDefault(__webpack_require__(6));
	var _extends = _interopDefault(__webpack_require__(5));
	var React = _interopDefault(__webpack_require__(1));
	var PropTypes = _interopDefault(__webpack_require__(3));
	var warning = _interopDefault(__webpack_require__(11));
	
	function defineProperty(object, property, attr) {
	  return Object.defineProperty(object, property, attr);
	} // Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	
	
	var passiveOption = function () {
	  var cache = null;
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, defineProperty({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (err) {//
	    }
	
	    cache = supportsPassiveOption;
	    return supportsPassiveOption;
	  }();
	}();
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	
	function mergeDefaultEventOptions(options) {
	  return _extends({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  // eslint-disable-next-line prefer-spread
	  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	}
	
	function off(target, eventName, callback, options) {
	  // eslint-disable-next-line prefer-spread
	  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	}
	
	function forEachListener(props, iteratee) {
	  var children = props.children,
	      target = props.target,
	      eventProps = _objectWithoutProperties(props, ["children", "target"]);
	
	  Object.keys(eventProps).forEach(function (name) {
	    if (name.substring(0, 2) !== 'on') {
	      return;
	    }
	
	    var prop = eventProps[name];
	
	    var type = _typeof(prop);
	
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) {
	      return;
	    }
	
	    var capture = name.substr(-7).toLowerCase() === 'capture';
	    var eventName = name.substring(2).toLowerCase();
	    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;
	
	    if (isObject) {
	      iteratee(eventName, prop.handler, prop.options);
	    } else {
	      iteratee(eventName, prop, mergeDefaultEventOptions({
	        capture: capture
	      }));
	    }
	  });
	}
	
	function withOptions(handler, options) {
	   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(EventListener, _React$PureComponent);
	
	  function EventListener() {
	    _classCallCheck(this, EventListener);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(EventListener).apply(this, arguments));
	  }
	
	  _createClass(EventListener, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      this.applyListeners(off, prevProps);
	      this.applyListeners(on);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: "applyListeners",
	    value: function applyListeners(onOrOff) {
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
	      var target = props.target;
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	
	  return EventListener;
	}(React.PureComponent);
	
	EventListener.propTypes =  false ? {
	  /**
	   * You can provide a single child too.
	   */
	  children: PropTypes.node,
	
	  /**
	   * The DOM target to listen to.
	   */
	  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
	} : {};
	
	exports.withOptions = withOptions;
	exports.default = EventListener;


/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(585);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(433);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(566);
	
	var _HelmetConstants = __webpack_require__(278);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 278:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(85);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(278);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animateScroll = undefined;
	exports.updateHistory = updateHistory;
	
	var _requestanimationframeTimer = __webpack_require__(208);
	
	var animateScroll = exports.animateScroll = function () {
	  var timeoutId = void 0;
	  var resolvePrevious = void 0;
	
	  return function animateScroll(id, targetId, animate) {
	    var targetElement = document.getElementById(targetId);
	
	    function getScrollTop() {
	      // like jQuery -> $('html, body').scrollTop
	      return targetElement ? targetElement.scrollTop : document.documentElement.scrollTop || document.body.scrollTop;
	    }
	
	    function setScrollTop(position) {
	      if (targetElement) {
	        targetElement.scrollTop = position;
	      } else {
	        document.documentElement.scrollTop = document.body.scrollTop = position;
	      }
	    }
	
	    return new Promise(function (resolve, reject) {
	      var element = id ? document.getElementById(id) : document.body;
	
	      if (!element) {
	        return reject(new Error('Cannot find element: #' + id));
	      }
	
	      function getOffsetTop() {
	        var parentOffsetTop = targetElement ? targetElement.getBoundingClientRect().top : 0;
	        return element.getBoundingClientRect().top - parentOffsetTop + getScrollTop();
	      }
	
	      var offset = animate.offset,
	          duration = animate.duration,
	          easing = animate.easing;
	
	      var start = getScrollTop();
	      var to = getOffsetTop(element) + offset;
	      var change = to - start;
	
	      function animateFn() {
	        var elapsedTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	        var increment = 20;
	        var elapsed = elapsedTime + increment;
	        var position = easing(null, elapsed, start, change, duration);
	        setScrollTop(position);
	        if (elapsed < duration) {
	          timeoutId = (0, _requestanimationframeTimer.setTimeout)(function () {
	            animateFn(elapsed);
	          }, increment);
	        } else {
	          timeoutId = undefined;
	          return resolve(id);
	        }
	      }
	
	      if (timeoutId) {
	        (0, _requestanimationframeTimer.clearTimeout)(timeoutId);
	        resolvePrevious();
	      }
	      resolvePrevious = resolve;
	      animateFn();
	    });
	  };
	}();
	
	function updateHistory(id) {
	  id = '#' + id;
	  if (history.pushState) {
	    history.pushState(null, null, id);
	  } else {
	    location.hash = id;
	  }
	}

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(201);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scrollchor = function (_React$Component) {
	  _inherits(Scrollchor, _React$Component);
	
	  function Scrollchor(props) {
	    _classCallCheck(this, Scrollchor);
	
	    var _this = _possibleConstructorReturn(this, (Scrollchor.__proto__ || Object.getPrototypeOf(Scrollchor)).call(this, props));
	
	    _this._handleClick = function (event) {
	      _this.state.beforeAnimate(event);
	      event && event.preventDefault();
	      (0, _helpers.animateScroll)(_this.state.to, _this.state.target, _this.state.animate).then(function (id) {
	        if (id) {
	          _this.state.disableHistory || (0, _helpers.updateHistory)(id);
	          _this.state.afterAnimate(event);
	        }
	      });
	    };
	
	    _this.state = Scrollchor._stateHelper(props);
	    _this.simulateClick = _this._handleClick;
	    return _this;
	  }
	
	  _createClass(Scrollchor, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this.setState(Scrollchor._stateHelper(props));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          to = _props.to,
	          target = _props.target,
	          animate = _props.animate,
	          beforeAnimate = _props.beforeAnimate,
	          afterAnimate = _props.afterAnimate,
	          disableHistory = _props.disableHistory,
	          props = _objectWithoutProperties(_props, ['to', 'target', 'animate', 'beforeAnimate', 'afterAnimate', 'disableHistory']); // eslint-disable-line no-unused-vars
	
	      return !this.props.children ? null : _react2.default.createElement('a', _extends({}, props, { href: '#' + this.state.to, onClick: this._handleClick }));
	    }
	  }], [{
	    key: '_normalizeId',
	    value: function _normalizeId(id) {
	      return id && id.replace(/^#/, '') || '';
	    }
	  }, {
	    key: '_stateHelper',
	    value: function _stateHelper(props) {
	      var _ref = props.animate || {},
	          _ref$offset = _ref.offset,
	          offset = _ref$offset === undefined ? 0 : _ref$offset,
	          _ref$duration = _ref.duration,
	          duration = _ref$duration === undefined ? 400 : _ref$duration,
	          _ref$easing = _ref.easing,
	          easing = _ref$easing === undefined ? easeOutQuad : _ref$easing;
	
	      return {
	        to: Scrollchor._normalizeId(props.to),
	        target: Scrollchor._normalizeId(props.target),
	        animate: { offset: offset, duration: duration, easing: easing },
	        beforeAnimate: props.beforeAnimate || function () {},
	        afterAnimate: props.afterAnimate || function () {},
	        disableHistory: props.disableHistory
	      };
	    }
	  }, {
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(props) {
	      return Scrollchor._stateHelper(props);
	    }
	  }]);
	
	  return Scrollchor;
	}(_react2.default.Component);
	
	// Default easing function
	// jQuery easing 'swing'
	
	
	Scrollchor.propTypes = {
	  to: _propTypes2.default.string.isRequired,
	  target: _propTypes2.default.string,
	  animate: _propTypes2.default.shape({
	    offset: _propTypes2.default.number,
	    duration: _propTypes2.default.number,
	    easing: _propTypes2.default.func
	  }),
	  beforeAnimate: _propTypes2.default.func,
	  afterAnimate: _propTypes2.default.func,
	  disableHistory: _propTypes2.default.bool,
	  children: _propTypes2.default.node
	};
	exports.default = Scrollchor;
	function easeOutQuad(x, t, b, c, d) {
	  return -c * (t /= d) * (t - 2) + b;
	}
	
	// Setup for React version 16.3.x and beyond
	var reSemver = /^v?((\d+)\.(\d+)\.(\d+))(?:-([\dA-Za-z\-]+(?:\.[\dA-Za-z\-]+)*))?(?:\+([\dA-Za-z\-]+(?:\.[\dA-Za-z\-]+)*))?$/; // eslint-disable-line no-useless-escape
	
	var _reSemver$exec = reSemver.exec(_react2.default.version),
	    _reSemver$exec2 = _slicedToArray(_reSemver$exec, 4),
	    major = _reSemver$exec2[2],
	    minor = _reSemver$exec2[3];
	
	major >= 16 && minor >= 3 && delete Scrollchor.prototype.componentWillReceiveProps;

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(449));
	var shallowEqual = _interopDefault(__webpack_require__(645));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(20);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactLifecyclesCompat = __webpack_require__(86);
	
	var _PropTypes = __webpack_require__(204);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state = { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 *
	 * ## Timing
	 *
	 * Timing is often the trickiest part of animation, mistakes can result in slight delays
	 * that are hard to pin down. A common example is when you want to add an exit transition,
	 * you should set the desired final styles when the state is `'exiting'`. That's when the
	 * transition to those styles will start and, if you matched the `timeout` prop with the
	 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
	 *
	 * > **Note**: For simpler transitions the `Transition` component might be enough, but
	 * > take into account that it's platform-agnostic, while the `CSSTransition` component
	 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * > in order to make more complex transitions more predictable. For example, even though
	 * > classes `example-enter` and `example-enter-active` are applied immediately one after
	 * > another, you can still transition from one to the other because of the forced reflow
	 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
	 * > for more info). Take this into account when choosing between `Transition` and
	 * > `CSSTransition`.
	 *
	 * ## Example
	 *
	 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
	 *
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null // allows for nested Transitions
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return { status: EXITED };
	    }
	    return null;
	  };
	
	  // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	
	  //   return { nextStatus }
	  // }
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	    this.updateStatus(false, nextStatus);
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var nextStatus = arguments[1];
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	
	  // Name the function so it is clearer in the documentation
	} : {};function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = (0, _reactLifecyclesCompat.polyfill)(Transition);

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLifecyclesCompat = __webpack_require__(86);
	
	var _ChildMapping = __webpack_require__(203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes = {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes2.default.any,
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes2.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes2.default.func
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	
	  /**
	   * The `<TransitionGroup>` component manages a set of `<Transition>` components
	   * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
	   * state machine for managing the mounting and unmounting of components over
	   * time.
	   *
	   * Consider the example below using the `Fade` CSS transition from before.
	   * As items are removed or added to the TodoList the `in` prop is toggled
	   * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
	   * component in a `<TransitionGroup>`, not just css.
	   *
	   * ## Example
	   *
	   * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual `<Transition>`
	   * components. This means you can mix and match animations across different
	   * list items.
	   */
	};
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var handleExited = _this.handleExited.bind(_this);
	
	    // Initial children should all be entering, dependent on appear
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: { isMounting: !this.appeared }
	    };
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    this.setState(function (state) {
	      var children = _extends({}, state.children);
	
	      delete children[child.key];
	      return { children: children };
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        childFactory = _props.childFactory,
	        props = _objectWithoutProperties(_props, ['component', 'childFactory']);
	
	    var children = values(this.state.children).map(childFactory);
	
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes2.default.object.isRequired
	};
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	module.exports = exports['default'];

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = Object.create(null);
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	
	    if (!(0, _react.isValidElement)(child)) return;
	
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;
	
	    // item is new (entering)
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, { in: false });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	
	  return children;
	}

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterDone: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitDone: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(209).default;

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _raf = __webpack_require__(200);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var MODE_TIMEOUT = 0;
	var MODE_INTERVAL = 1;
	var fnStacks = new Map();
	var runArray = new Set();
	var rafStarted = false;
	var startId = 0;
	
	function getTimeStamp() {
	  return new Date().getTime();
	}
	
	function executeFn(value) {
	  var fn = value.fn,
	      args = value.args;
	
	  fn.apply(undefined, _toConsumableArray(args));
	}
	
	function runFunction() {
	  if (runArray.size === 0) return;
	  runArray.forEach(executeFn);
	  runArray.clear();
	}
	
	var checkTick = function checkTick(currentTimeTick) {
	  return function (value, id) {
	    var nextTick = value.nextTick,
	        ms = value.ms,
	        mode = value.mode;
	
	    if (currentTimeTick - nextTick >= 0) {
	      runArray.add(value);
	      if (mode === MODE_TIMEOUT) {
	        fnStacks.delete(id);
	      } else {
	        fnStacks.set(id, Object.assign({}, value, {
	          nextTick: nextTick + ms
	        }));
	      }
	    }
	  };
	};
	
	function loop() {
	  var currentTimeTick = getTimeStamp();
	  fnStacks.forEach(checkTick(currentTimeTick));
	  runFunction();
	  if (fnStacks.size === 0) {
	    rafStarted = false;
	    return;
	  }
	  (0, _raf2.default)(loop);
	}
	
	function addId(_ref) {
	  var fn = _ref.fn,
	      _ref$ms = _ref.ms,
	      ms = _ref$ms === undefined ? 0 : _ref$ms,
	      args = _ref.args,
	      mode = _ref.mode;
	
	  if (!fn) return null;
	  var currentId = startId;
	  fnStacks.set(currentId, {
	    fn: fn,
	    ms: ms,
	    nextTick: getTimeStamp() + ms,
	    args: args,
	    mode: mode
	  });
	  if (!rafStarted) {
	    rafStarted = true;
	    (0, _raf2.default)(loop);
	  }
	  startId += 1;
	  return currentId;
	}
	
	function removeId(id) {
	  if (fnStacks.has(id)) {
	    fnStacks.delete(id);
	  }
	  if (fnStacks.size === 0) {
	    rafStarted = false;
	  }
	}
	
	exports.default = {
	  setTimeout: function setTimeout(fn) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    return addId({ fn: fn, ms: ms, args: args, mode: MODE_TIMEOUT });
	  },
	  clearTimeout: removeId,
	  setInterval: function setInterval(fn) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	      args[_key2 - 2] = arguments[_key2];
	    }
	
	    var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    return addId({ fn: fn, ms: ms, args: args, mode: MODE_INTERVAL });
	  },
	  clearInterval: removeId
	};

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(16);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(7);
	
	var _TextLink = __webpack_require__(89);
	
	var _TextLink2 = _interopRequireDefault(_TextLink);
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _mdiReact = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Textbox = (0, _styledComponents2.default)(_rebass.Box).withConfig({
	  displayName: 'footer__Textbox',
	  componentId: 'r54yyk-0'
	})(['font-family:', ';font-size:', ';font-weight:700;color:white;'], _theme.fonts.primary, _theme.fontSizes[4] + 'px');
	var TextSeparator = (0, _styledComponents2.default)(_rebass.Divider).withConfig({
	  displayName: 'footer__TextSeparator',
	  componentId: 'r54yyk-1'
	})(['width:30px;height:4px;background-color:', ';border-bottom:none;border-radius:15px;'], _theme.colors.secondary);
	var TextDetails = (0, _styledComponents2.default)(_rebass.Text).withConfig({
	  displayName: 'footer__TextDetails',
	  componentId: 'r54yyk-2'
	})(['list-style:none;text-align:left;font-weight:500;margin-top:10px;margin-bottom:10px;color:#7f97ad;font-family:', ';font-size:', ';'], _theme.fonts.secondary, _theme.fontSizes[1] + 'px');
	var Links = (0, _styledComponents2.default)(_gatsbyLink2.default).withConfig({
	  displayName: 'footer__Links',
	  componentId: 'r54yyk-3'
	})(['color:#7f97ad;font-family:', ';font-weight:500;font-size:', ';text-decoration:none;margin-top:10px;margin-bottom:10px;&:hover{color:', ';}'], _theme.fonts.secondary, _theme.fontSizes[1] + 'px', _theme.colors.secondary);
	var Links2 = _styledComponents2.default.a.withConfig({
	  displayName: 'footer__Links2',
	  componentId: 'r54yyk-4'
	})(['color:#7f97ad;font-family:', ';font-weight:500;font-size:', ';text-decoration:none;margin-top:10px;margin-bottom:10px;&:hover{color:', ';}'], _theme.fonts.secondary, _theme.fontSizes[1] + 'px', _theme.colors.secondary);
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    var t = this.props.t;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        id: 'contact',
	        style: {
	          color: '#7f97ad',
	          background: _theme.colors.primary
	        }
	      },
	      _react2.default.createElement(
	        _rebass.Flex,
	        { flexWrap: 'wrap', flexDirection: 'row', px: [1, 2, 5, 5], py: 5 },
	        _react2.default.createElement(
	          Textbox,
	          { width: [1, 1, 1 / 2, 1 / 4], pr: 4 },
	          _react2.default.createElement('img', { src: '/img/transparent.svg', style: { height: '46px' } }),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { display: 'inline', mt: 3 },
	            _react2.default.createElement(_mdiReact.HomeIcon, { style: { minWidth: '20px' }, className: 'IconBox' }),
	            _react2.default.createElement(
	              TextDetails,
	              null,
	              '1/6242-A Street No. 3 East Rohtash Nagar Shahdara Delhi 110032'
	            )
	          ),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { display: 'inline' },
	            _react2.default.createElement(_mdiReact.PhoneIcon, { className: 'IconBox' }),
	            _react2.default.createElement(
	              TextDetails,
	              null,
	              '+91 9911887728'
	            )
	          ),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { display: 'inline' },
	            _react2.default.createElement(_mdiReact.PhoneIcon, { className: 'IconBox' }),
	            _react2.default.createElement(
	              TextDetails,
	              null,
	              '+91 9654121126'
	            )
	          ),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { display: 'inline' },
	            _react2.default.createElement(_mdiReact.PhoneIcon, { className: 'IconBox' }),
	            _react2.default.createElement(
	              TextDetails,
	              null,
	              '+91 9899274720'
	            )
	          ),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { display: 'inline' },
	            _react2.default.createElement(_mdiReact.EmailIcon, { className: 'IconBox' }),
	            _react2.default.createElement(
	              Links2,
	              { href: 'mailto:jshubham0094@gmail.com' },
	              'jshubham0094@gmail.com'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          Textbox,
	          { width: [1, 1, 1 / 2, 1 / 4], pl: [0, 0, 3, 4] },
	          'LINKS',
	          _react2.default.createElement(TextSeparator, null),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { display: 'inline' },
	            _react2.default.createElement(_mdiReact.ChevronRightIcon, { className: 'IconBox' }),
	            _react2.default.createElement(
	              Links,
	              { to: '/#home' },
	              'Home'
	            ),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { display: 'inline' },
	            _react2.default.createElement(_mdiReact.ChevronRightIcon, { className: 'IconBox' }),
	            _react2.default.createElement(
	              Links,
	              { to: '/services' },
	              'Our Services'
	            ),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { display: 'inline' },
	            _react2.default.createElement(_mdiReact.ChevronRightIcon, { className: 'IconBox' }),
	            _react2.default.createElement(
	              Links,
	              { to: '/about' },
	              'About us'
	            ),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { display: 'inline' },
	            _react2.default.createElement(_mdiReact.ChevronRightIcon, { className: 'IconBox' }),
	            _react2.default.createElement(
	              Links,
	              { to: '/articles' },
	              'Articles'
	            ),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { display: 'inline' },
	            _react2.default.createElement(_mdiReact.ChevronRightIcon, { className: 'IconBox' }),
	            _react2.default.createElement(
	              Links,
	              { to: '/values' },
	              'Our Values'
	            ),
	            _react2.default.createElement('br', null)
	          ),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { display: 'inline' },
	            _react2.default.createElement(_mdiReact.ChevronRightIcon, { className: 'IconBox' }),
	            _react2.default.createElement(
	              Links,
	              { to: '#contactus' },
	              'Contact Us'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          Textbox,
	          { width: [1, 1, 1 / 2, 1 / 4] },
	          'SUPPORT',
	          _react2.default.createElement(TextSeparator, null),
	          _react2.default.createElement(
	            Links,
	            { to: '/team' },
	            'Our Team'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            Links,
	            { to: '/request' },
	            'Submit a Request'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            Links,
	            { to: '/#' },
	            'Visit Knowledge Base'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            Links,
	            { to: '/#' },
	            'Support System'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            Links,
	            { to: '/#' },
	            'Refund Policy'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _rebass.Flex,
	            null,
	            _react2.default.createElement(
	              Links,
	              { to: '/#' },
	              'Professional Services'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          Textbox,
	          { width: [1, 1, 1 / 2, 1 / 4] },
	          'TWITTER FEED',
	          _react2.default.createElement(TextSeparator, null),
	          _react2.default.createElement(
	            _rebass.Flex,
	            null,
	            _react2.default.createElement(
	              TextDetails,
	              null,
	              'JAIN S N & Co. is a leading firm of Chartered Accountants established in 2012.'
	            )
	          ),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { display: 'inline' },
	            _react2.default.createElement(_mdiReact.WebIcon, {
	              style: {
	                color: '#198cfa',
	                height: '18px',
	                width: '18px',
	                marginRight: '10px',
	                marginTop: '10px'
	              }
	            }),
	            _react2.default.createElement(
	              Links2,
	              { href: 'https://taxbyjain.com/' },
	              'www.taxbyjain.com'
	            )
	          ),
	          _react2.default.createElement(_rebass.Divider, { color: _theme.colors.secondary }),
	          _react2.default.createElement(
	            TextDetails,
	            null,
	            'Firm acts as a One-Stop Advisor offering expertise and hands-on support.'
	          ),
	          _react2.default.createElement(
	            _rebass.Flex,
	            { display: 'inline' },
	            _react2.default.createElement(_mdiReact.TwitterIcon, {
	              style: {
	                color: '#198cfa',
	                height: '18px',
	                width: '18px',
	                marginRight: '10px',
	                marginTop: '10px'
	              }
	            }),
	            _react2.default.createElement(
	              Links2,
	              { href: 'https://twitter.com/shubhamjain', target: '_blank' },
	              '@ Shubham Jain'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _rebass.Flex,
	        {
	          bg: '#00152a',
	          color: 'greyDark',
	          px: [1, 2, 5, 5],
	          py: 3,
	          flexDirection: ['column', 'row']
	        },
	        _react2.default.createElement(
	          _rebass.Flex,
	          { width: [1, 1, 1 / 2, 1 / 2] },
	          _react2.default.createElement(
	            TextDetails,
	            null,
	            ' \xA9 2018 All Rights Reserved'
	          )
	        ),
	        _react2.default.createElement(
	          _rebass.Flex,
	          {
	            width: [1, 1, 1 / 2, 1 / 2],
	            justifyContent: ['flex-start', 'flex-end'],
	            display: 'inline'
	          },
	          _react2.default.createElement(
	            TextDetails,
	            null,
	            'Folow us: '
	          ),
	          _react2.default.createElement(_mdiReact.FacebookBoxIcon, { className: 'IconBox2' }),
	          _react2.default.createElement(_mdiReact.TwitterBoxIcon, { className: 'IconBox2' }),
	          _react2.default.createElement(_mdiReact.LinkedinBoxIcon, { className: 'IconBox2' }),
	          _react2.default.createElement(_mdiReact.GooglePlusBoxIcon, { className: 'IconBox2' }),
	          _react2.default.createElement(_mdiReact.RssBoxIcon, { className: 'IconBox2' })
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Navbar = __webpack_require__(165);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _rebass = __webpack_require__(16);
	
	var _theme = __webpack_require__(7);
	
	var _TextLink = __webpack_require__(89);
	
	var _TextLink2 = _interopRequireDefault(_TextLink);
	
	var _mdiReact = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var siteTitle = _ref.siteTitle,
	      fullDesign = _ref.fullDesign;
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        background: 'none',
	        position: fullDesign ? 'absolute' : 'fixed',
	        top: 0,
	        left: 0,
	        width: '100%',
	        zIndex: fullDesign ? '200' : '10'
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '0 auto'
	        }
	      },
	      fullDesign && _react2.default.createElement(
	        _rebass.Flex,
	        {
	          alignItems: 'center',
	          justifyContent: 'space-between',
	          flexDirection: ['column', 'column', 'row', 'row'],
	          bg: _theme.colors.primary,
	          pb: 5,
	          px: 5
	        },
	        _react2.default.createElement(
	          _rebass.Flex,
	          {
	            color: _theme.colors.secondary,
	            width: [1,,, 1 / 4],
	            display: 'inline',
	            alignItems: 'center',
	            justifyContent: ['center'],
	            mt: 3
	          },
	          _react2.default.createElement(_mdiReact.EmailIcon, { style: { height: '18px', width: '18px' } }),
	          _react2.default.createElement(
	            _TextLink2.default,
	            null,
	            'jshubham0094@gmail.com'
	          )
	        ),
	        _react2.default.createElement(
	          _rebass.Flex,
	          {
	            color: _theme.colors.secondary,
	            width: [1,,, 1 / 2],
	            display: 'inline'
	            // alignItems="center"
	            , justifyContent: 'center',
	            mt: 3
	          },
	          _react2.default.createElement(_mdiReact.NavigationIcon, {
	            style: {
	              transform: 'rotate(70deg)',
	              height: '18px',
	              width: '18px',
	              minWidth: '18px'
	            }
	          }),
	          _react2.default.createElement(
	            _TextLink2.default,
	            null,
	            '1/6242-A Street No. 3 East Rohtash Nagar Shahdara Delhi 110032'
	          )
	        ),
	        _react2.default.createElement(
	          _rebass.Flex,
	          {
	            color: _theme.colors.secondary,
	            width: [1,,, 1 / 6],
	            justifyContent: ['center'],
	            flexDirection: 'row',
	            display: 'inline',
	            alignItems: 'center',
	            mt: 3
	          },
	          _react2.default.createElement(_mdiReact.FacebookIcon, {
	            style: {
	              height: '18px',
	              width: '18px',
	              cursor: 'pointer',
	              marginRight: '5px'
	            }
	          }),
	          _react2.default.createElement(_mdiReact.TwitterIcon, {
	            style: {
	              height: '18px',
	              width: '18px',
	              cursor: 'pointer',
	              marginRight: '5px'
	            }
	          }),
	          _react2.default.createElement(_mdiReact.LinkedinIcon, {
	            style: {
	              height: '18px',
	              width: '18px',
	              cursor: 'pointer',
	              marginRight: '5px'
	            }
	          }),
	          _react2.default.createElement(_mdiReact.GooglePlusIcon, {
	            style: {
	              height: '21px',
	              width: '20px',
	              cursor: 'pointer',
	              marginRight: '5px'
	            }
	          }),
	          _react2.default.createElement(_mdiReact.RssIcon, {
	            style: {
	              height: '18px',
	              width: '18px',
	              cursor: 'pointer',
	              marginRight: '5px'
	            }
	          })
	        )
	      ),
	      _react2.default.createElement(_Navbar2.default, { fullDesign: fullDesign })
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styles = __webpack_require__(48);
	
	var _Drawer = __webpack_require__(133);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _Button = __webpack_require__(125);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _rebass = __webpack_require__(16);
	
	var _MenuIcon = __webpack_require__(197);
	
	var _MenuIcon2 = _interopRequireDefault(_MenuIcon);
	
	var _NavLink = __webpack_require__(73);
	
	var _NavLink2 = _interopRequireDefault(_NavLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  list: {
	    width: 250
	  },
	  fullList: {
	    width: 'auto'
	  },
	  button: {
	    padding: 0,
	    minWidth: '50px'
	  }
	};
	
	var NavDrawer = function (_React$Component) {
	  _inherits(NavDrawer, _React$Component);
	
	  function NavDrawer() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NavDrawer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      right: false
	    }, _this.toggleDrawer = function (side, open) {
	      return function () {
	        var _this$setState;
	
	        _this.setState((_this$setState = {}, _this$setState[side] = open, _this$setState));
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  NavDrawer.prototype.render = function render() {
	    var classes = this.props.classes;
	
	
	    var sideList = _react2.default.createElement(
	      'div',
	      { className: classes.list },
	      _react2.default.createElement(
	        _rebass.Flex,
	        { flexDirection: 'column', mt: 3, ml: 2 },
	        _react2.default.createElement(
	          _rebass.Box,
	          { p: 2 },
	          _react2.default.createElement(_NavLink2.default, { to: '#', children: 'Home' })
	        ),
	        _react2.default.createElement(
	          _rebass.Box,
	          { p: 2 },
	          _react2.default.createElement(_NavLink2.default, { to: '#about', children: 'About' })
	        ),
	        _react2.default.createElement(
	          _rebass.Box,
	          { p: 2 },
	          _react2.default.createElement(_NavLink2.default, { to: '#team', children: 'Team' })
	        ),
	        _react2.default.createElement(
	          _rebass.Box,
	          { p: 2 },
	          _react2.default.createElement(_NavLink2.default, { to: '#values', children: 'Values' })
	        ),
	        _react2.default.createElement(
	          _rebass.Box,
	          { p: 2 },
	          _react2.default.createElement(_NavLink2.default, { to: '#services', children: 'Services' })
	        ),
	        _react2.default.createElement(
	          _rebass.Box,
	          { p: 2 },
	          _react2.default.createElement(_NavLink2.default, { to: '#articles', children: 'Articles' })
	        ),
	        _react2.default.createElement(
	          _rebass.Box,
	          { p: 2 },
	          _react2.default.createElement(_NavLink2.default, { to: '#contact', children: 'Contact' })
	        )
	      )
	    );
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _Button2.default,
	        { onClick: this.toggleDrawer('right', true), className: classes.button },
	        _react2.default.createElement(_MenuIcon2.default, { color: '#000' })
	      ),
	      _react2.default.createElement(
	        _Drawer2.default,
	        { anchor: 'right', open: this.state.right, onClose: this.toggleDrawer('right', false) },
	        _react2.default.createElement(
	          'div',
	          {
	            tabIndex: 0,
	            role: 'button',
	            onClick: this.toggleDrawer('right', false),
	            onKeyDown: this.toggleDrawer('right', false)
	          },
	          sideList
	        )
	      )
	    );
	  };
	
	  return NavDrawer;
	}(_react2.default.Component);
	
	NavDrawer.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _styles.withStyles)(styles)(NavDrawer);
	module.exports = exports['default'];

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactScrollchor = __webpack_require__(116);
	
	var _reactScrollchor2 = _interopRequireDefault(_reactScrollchor);
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _theme = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScrollLink = (0, _styledComponents2.default)(_reactScrollchor2.default).withConfig({
	  displayName: 'NavLink__ScrollLink',
	  componentId: 'sc-1uxf5fe-0'
	})(['font-family:', ';font-weight:700;font-size:', ';transition:all 0.3s linear;color:#a5acb4;text-decoration:none;padding:0.5rem;margin:0 10px;&:hover{color:', ';}'], _theme.fonts.primary, _theme.fontSizes[2] + 'px', _theme.colors.primary);
	
	var PageLink = (0, _styledComponents2.default)(_gatsbyLink2.default).withConfig({
	  displayName: 'NavLink__PageLink',
	  componentId: 'sc-1uxf5fe-1'
	})(['font-family:', ';font-weight:700;font-size:', ';transition:all 0.3s linear;color:#a5acb4;text-decoration:none;padding:0.5rem;margin:0 10px;&:hover{color:', ';}'], _theme.fonts.primary, _theme.fontSizes[2] + 'px', _theme.colors.primary);
	
	var NavLink = function NavLink(props) {
	  return _react2.default.createElement(
	    'span',
	    null,
	    typeof window !== 'undefined' && window.location.pathname === '/' ? _react2.default.createElement(ScrollLink, {
	      to: props.to,
	      children: props.children,
	      animate: { offset: -60 }
	    }) : _react2.default.createElement(PageLink, {
	      to: '/' + props.to,
	      children: props.children
	    })
	  );
	};
	
	exports.default = NavLink;
	module.exports = exports['default'];

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__(16);
	
	var _NavLink = __webpack_require__(73);
	
	var _NavLink2 = _interopRequireDefault(_NavLink);
	
	var _NavDrawer = __webpack_require__(164);
	
	var _NavDrawer2 = _interopRequireDefault(_NavDrawer);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OnlySmallScreenBox = (0, _styledComponents2.default)(_rebass.Box).withConfig({
	  displayName: 'Navbar__OnlySmallScreenBox',
	  componentId: 'sc-1dco9f9-0'
	})(['display:none;@media (max-width:48em){display:block;}']);
	var OnlyLargeScreenBox = (0, _styledComponents2.default)(_rebass.Box).withConfig({
	  displayName: 'Navbar__OnlyLargeScreenBox',
	  componentId: 'sc-1dco9f9-1'
	})(['@media (max-width:48em){display:none;}']);
	var CustomBox = (0, _styledComponents2.default)(_rebass.Box).withConfig({
	  displayName: 'Navbar__CustomBox',
	  componentId: 'sc-1dco9f9-2'
	})(['border-radius:12px;@media (max-width:48em){border-radius:0;}']);
	var SpanBox = (0, _styledComponents2.default)('span').withConfig({
	  displayName: 'Navbar__SpanBox',
	  componentId: 'sc-1dco9f9-3'
	})(['color:', ';font-weight:600;font-size:30px;font-family:', ';@media (max-width:1110px){display:none;}@media (max-width:766px){display:inline;font-size:25px;}'], _theme.colors.primary, _theme.fonts.secondary);
	
	var Navbar = function (_Component) {
	  _inherits(Navbar, _Component);
	
	  function Navbar() {
	    _classCallCheck(this, Navbar);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Navbar.prototype.render = function render() {
	    return _react2.default.createElement(
	      CustomBox,
	      {
	        mt: this.props.fullDesign ? '-40px' : '0',
	        bg: 'white',
	        mx: this.props.fullDesign ? [0, 0, 4, 5] : '0',
	        py: 2,
	        style: {
	          borderRadius: this.props.fullDesign ? '12px' : 0,
	          boxShadow: this.props.fullDesign ? 'none' : '0 0.2rem 0.5rem rgba(0,0,0,.2)'
	        }
	      },
	      _react2.default.createElement(
	        _rebass.Flex,
	        {
	          flexDirection: 'row',
	          justifyContent: 'space-between',
	          px: [3],
	          alignItems: 'center',
	          ml: 2,
	          my: 1
	        },
	        _react2.default.createElement(
	          _rebass.Flex,
	          { alignItems: 'center', flexDirection: 'row' },
	          _react2.default.createElement('img', { src: '/img/logo.jpg', style: { height: '46px' } }),
	          _react2.default.createElement(
	            SpanBox,
	            null,
	            ' JAIN S N & CO.'
	          )
	        ),
	        _react2.default.createElement(
	          _rebass.Flex,
	          {
	            alignItems: 'center',
	            justifyContent: 'flex-end',
	            mt: '6',
	            mr: 2,
	            display: 'inline'
	          },
	          _react2.default.createElement(
	            OnlyLargeScreenBox,
	            null,
	            _react2.default.createElement(_NavLink2.default, { to: '#', children: 'Home' }),
	            _react2.default.createElement(_NavLink2.default, { to: '#about', children: 'About' }),
	            _react2.default.createElement(_NavLink2.default, { to: '#team', children: 'Team' }),
	            _react2.default.createElement(_NavLink2.default, { to: '#values', children: 'Values' }),
	            _react2.default.createElement(_NavLink2.default, { to: '#services', children: 'Services' }),
	            _react2.default.createElement(_NavLink2.default, { to: '#articles', children: 'Articles' }),
	            _react2.default.createElement(_NavLink2.default, { to: '#contact', children: 'Contact' })
	          ),
	          _react2.default.createElement(
	            OnlySmallScreenBox,
	            null,
	            _react2.default.createElement(_NavDrawer2.default, null)
	          )
	        )
	      )
	    );
	  };
	
	  return Navbar;
	}(_react.Component);
	
	exports.default = Navbar;
	module.exports = exports['default'];

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextLink = _styledComponents2.default.a.withConfig({
	  displayName: 'TextLink',
	  componentId: 'tz7q7u-0'
	})(['text-decoration:none;cursor:pointer;color:white;font-weight:', ';font-family:', ';font-size:', ';margin-left:8px;text-align:center;'], _theme.fontWeights.regular, _theme.fonts.secondary, _theme.fontSizes[0] + 'px');
	
	exports.default = TextLink;
	module.exports = exports['default'];

/***/ }),

/***/ 450:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(565);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _rebass = __webpack_require__(16);
	
	var _header = __webpack_require__(161);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(325);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _theme = __webpack_require__(7);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	__webpack_require__(450);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { style: { width: '100%' } },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'JAIN S N & CO.',
	      meta: [{ name: 'description', content: 'Sample' }, { name: 'keywords', content: 'sample, something' }],
	      link: [{ rel: "icon", type: "image/png", href: "/favicon.ico", sizes: "32x32" }]
	    }),
	    _react2.default.createElement(
	      _rebass.Provider,
	      { theme: _theme2.default },
	      _react2.default.createElement(_header2.default, null),
	      _react2.default.createElement(
	        'div',
	        null,
	        children()
	      ),
	      _react2.default.createElement(_footer2.default, null)
	    )
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-8217650181ea7a8a1911.js